function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("hcjUE", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$75cbcd79cc398126$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("bnL6w");
    var $jD5no;
    var $i8pyY;
    var $hmRfM;
    var $9dbF6;
    var $9NiTW;
    var $l8ruj;
    const $75cbcd79cc398126$var$JiraBusinessFormApp = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-form-submit-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "business"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8pyY")).FormSubmissionContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hmRfM")).FormSubmissionRoot), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "core"
        }))));
    var $75cbcd79cc398126$export$2e2bcd8739ae039 = $75cbcd79cc398126$var$JiraBusinessFormApp;
});
parcelRegister("i8pyY", function(module, exports) {
    $parcel$export(module.exports, "FormSubmissionContextProvider", ()=>$c118b8c67dae9e54$export$762da44d062c3e8b);
    var $5uXOq = parcelRequire("5uXOq");
    var $aXhsp;
    var $AeWM3;
    var $7nKe3;
    var $cm8b5;
    var $2vSU6;
    var $iXVV6;
    var $aVFIE;
    var $l2N2a;
    var $iEEXl;
    var $7wwVP;
    var $6czoq;
    var $g2iZ7;
    var $kyf8b;
    var $0557y;
    const $c118b8c67dae9e54$var$FormAccessWrapper = ({ children: children })=>{
        const [initialLoading, setInitialLoading] = (0, $5uXOq.useState)(true);
        const { data: project, loading: projectLoading } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const [{ data: data, loading: loading, error: error }] = (0, (0, parcelRequire("kyf8b")).useFormSubmissionStore)();
        (0, $5uXOq.useEffect)(()=>{
            if (loading) setInitialLoading(false);
        }, [
            loading
        ]);
        const isOpenForm = data?.accessLevel === (0, (0, parcelRequire("7wwVP")).FormAccessLevelTypes).OPEN;
        const projectId = String(data?.projectId);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId,
                isOpenForm: isOpenForm,
                projectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            }), [
            projectId,
            isOpenForm
        ]);
        if (initialLoading || projectLoading || loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton), null);
        if (error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !(0, (0, parcelRequire("0557y")).isFormNotFoundError)(error) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("iEEXl")).VIEW_FORM_SUBMISSION_EXPERIENCE),
            error: error
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).FormUnavailableView), null));
        if ((!project || !project.permissions.viewIssues || !project.permissions.createIssues) && isOpenForm) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: projectId,
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessFormSubmissionContext",
            attributes: analyticsAttributes
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nKe3")).default), null, children);
    };
    const $c118b8c67dae9e54$export$762da44d062c3e8b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("iEEXl")).VIEW_FORM_SUBMISSION_EXPERIENCE),
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: (0, (0, parcelRequire("aXhsp")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g2iZ7")).FormSubmissionPreloader), null), (0, ($parcel$interopDefault($5uXOq))).createElement($c118b8c67dae9e54$var$FormAccessWrapper, null, children)));
});
parcelRegister("aXhsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d88f4e626c9babc0$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $h4ppL;
    var $JPsIz;
    var $lC4FX;
    var $cuKXc = parcelRequire("cuKXc");
    var $dJl1T;
    var $jQUy5;
    var $l0T7c;
    var $9g713;
    const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
    const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
    const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
    const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
    const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
    const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, (0, parcelRequire("ivfDv")).IntrospectionFragmentMatcher)({
        introspectionQueryResultData: ($parcel$interopDefault((0, parcelRequire("l0T7c"))))
    });
    const $d88f4e626c9babc0$var$errorLink = (0, (0, parcelRequire("h4ppL")).onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        (0, (0, parcelRequire("9g713")).reportErrors)({
            graphQLErrors: graphQLErrors,
            operation: operation
        });
        const errorAnalytics = (0, (0, parcelRequire("9g713")).getErrorAnalyticsContext)(operation.getContext());
        if (errorAnalytics !== undefined) return;
        if (graphQLErrors) {
            if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                    message: JSON.stringify(message),
                    path: JSON.stringify(path),
                    locations: JSON.stringify(locations)
                }));
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
                message: JSON.stringify(graphQLErrors)
            });
        }
        if (networkError) {
            const occuredNetworkErrorsBefore = (0, ($parcel$interopDefault($9XE6b)))(operation.getContext(), [
                $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
            ], 0);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
            operation.setContext({
                [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
            });
        }
    });
    const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, (0, parcelRequire("lC4FX")).RetryLink)({
        delay: {
            initial: 300,
            max: 120000,
            jitter: true
        },
        attempts: (count, operation, networkError)=>{
            const retry = count < 5 && networkError && !networkError.statusCode;
            if (!retry) (0, (0, parcelRequire("9g713")).reportErrors)({
                networkError: networkError,
                operation: operation
            });
            return retry;
        }
    });
    class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, (0, parcelRequire("clSzL")).ApolloLink) {
        constructor(){
            super();
            this.inFlightRequestControllers = {};
        }
        request(operation, forward) {
            const context = operation.getContext();
            if (!context.cancelable) return forward(operation);
            const key = JSON.stringify([
                operation.operationName,
                operation.query
            ]);
            this.inFlightRequestControllers[key]?.abort();
            const abortController = new AbortController();
            operation.setContext({
                ...context,
                fetchOptions: {
                    signal: abortController.signal
                }
            });
            this.inFlightRequestControllers[key] = abortController;
            const cleanup = ()=>{
                if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
            };
            return new (0, (0, parcelRequire("clSzL")).Observable)((observer)=>{
                const subscription = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: (error)=>{
                        observer.error(error);
                        cleanup();
                    },
                    complete: observer.complete.bind(observer)
                });
                return ()=>{
                    subscription?.unsubscribe();
                    cleanup();
                };
            });
        }
    }
    const $d88f4e626c9babc0$var$cache = new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
        cacheRedirects: {
            Query: {
                ...(0, $cuKXc.fragmentCacheRedirect)()
            }
        },
        fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
        dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
    }).restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
    const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, (0, parcelRequire("e3a3O")).ApolloClient)({
            name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
            ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
            addTypename: true,
            link: (0, (0, parcelRequire("clSzL")).ApolloLink).from([
                $d88f4e626c9babc0$var$retryLinkWithFama,
                $d88f4e626c9babc0$var$errorLink,
                (0, (0, parcelRequire("jQUy5")).UFOLoggerLink),
                (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
                ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                    new $d88f4e626c9babc0$var$CancelableRequestLink()
                ] : [],
                new (0, (0, parcelRequire("JPsIz")).HttpLink)({
                    uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                    credentials: 'same-origin',
                    abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
                })
            ].filter(Boolean)),
            cache: $d88f4e626c9babc0$var$cache,
            connectToDevTools: false
        });
    var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
        clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("cuKXc", function(module, exports) {
    $parcel$export(module.exports, "fragmentCacheRedirect", ()=>$918cb5692ff82562$export$5133c88128301697);
    $parcel$export(module.exports, "fragmentLinkState", ()=>$918cb5692ff82562$export$3f9ecfb4d42ab23d);
    var $jojW6;
    var $9HlP2 = parcelRequire("9HlP2");
    var $ivfDv;
    function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
        if (dataIdFromObject === void 0) dataIdFromObject = (0, (0, parcelRequire("ivfDv")).defaultDataIdFromObject);
        return {
            getFragment: function(_, _a) {
                var id = _a.id, __typename = _a.__typename;
                return (0, (0, parcelRequire("jojW6")).toIdValue)(dataIdFromObject({
                    __typename: __typename,
                    id: id
                }));
            }
        };
    }
    function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
        return (0, $9HlP2.withClientState)({
            cache: apolloCache,
            resolvers: {
                Query: {
                    getFragment: function(_, _a, _b) {
                        var __typename = _a.__typename, id = _a.id;
                        var cache = _b.cache;
                        var fragmentId = cache.config.dataIdFromObject({
                            __typename: __typename,
                            id: id
                        });
                        return cache.data.data[fragmentId];
                    }
                }
            }
        });
    }
});
parcelRegister("9HlP2", function(module, exports) {
    $parcel$export(module.exports, "withClientState", ()=>$70f90ea50d538958$export$a13f755900e15d9e);
    var $clSzL;
    var $jojW6;
    var $jWd7i;
    var $b2p88 = parcelRequire("b2p88");
    var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $70f90ea50d538958$var$graphql = (0, parcelRequire("jWd7i")).graphql;
    var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
        if (clientStateConfig === void 0) clientStateConfig = {
            resolvers: {},
            defaults: {}
        };
        var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
        if (cache && defaults) cache.writeData({
            data: defaults
        });
        return new (function(_super) {
            $70f90ea50d538958$var$__extends(StateLink, _super);
            function StateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StateLink.prototype.writeDefaults = function() {
                if (cache && defaults) cache.writeData({
                    data: defaults
                });
            };
            StateLink.prototype.request = function(operation, forward) {
                if (forward === void 0) forward = function() {
                    return (0, (0, parcelRequire("clSzL")).Observable).of({
                        data: {}
                    });
                };
                if (typeDefs) {
                    var directives_1 = 'directive @client on FIELD';
                    var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                    operation.setContext(function(_a) {
                        var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                        return {
                            schemas: schemas.concat([
                                {
                                    definition: definition_1,
                                    directives: directives_1
                                }
                            ])
                        };
                    });
                }
                var isClient = (0, (0, parcelRequire("jojW6")).hasDirectives)([
                    'client'
                ], operation.query);
                if (!isClient) return forward(operation);
                var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
                var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
                var query = operation.query;
                var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, (0, parcelRequire("jojW6")).getMainDefinition)(query) || {}).operation) || 'Query';
                var resolver = function(fieldName, rootValue, args, context, info) {
                    if (rootValue === void 0) rootValue = {};
                    var resultKey = info.resultKey;
                    var aliasedNode = rootValue[resultKey];
                    var preAliasingNode = rootValue[fieldName];
                    var aliasNeeded = resultKey !== fieldName;
                    if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                    var resolverMap = resolvers[rootValue.__typename || type];
                    if (resolverMap) {
                        var resolve = resolverMap[fieldName];
                        if (resolve) return resolve(rootValue, args, context, info);
                    }
                    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
                };
                if (server) operation.query = server;
                var obs = server && forward ? forward(operation) : (0, (0, parcelRequire("clSzL")).Observable).of({
                    data: {}
                });
                return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                    var complete = false;
                    var handlingNext = false;
                    obs.subscribe({
                        next: function(_a) {
                            var data = _a.data, errors = _a.errors;
                            var observerErrorHandler = observer.error.bind(observer);
                            var context = operation.getContext();
                            handlingNext = true;
                            $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                                fragmentMatcher: fragmentMatcher
                            }).then(function(nextData) {
                                observer.next({
                                    data: nextData,
                                    errors: errors
                                });
                                if (complete) observer.complete();
                                handlingNext = false;
                            }).catch(observerErrorHandler);
                        },
                        error: observer.error.bind(observer),
                        complete: function() {
                            if (!handlingNext) observer.complete();
                            complete = true;
                        }
                    });
                });
            };
            return StateLink;
        }((0, (0, parcelRequire("clSzL")).ApolloLink)))();
    };
});
parcelRegister("jWd7i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $jojW6;
    var $jDjTr;
    function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
    function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function(selection) {
                            return (0, parcelRequire("3VFsf")).__awaiter(_this, void 0, void 0, function() {
                                var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                                return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return [
                                                2
                                            ];
                                            if (!(0, parcelRequire("jojW6")).isField(selection)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                            ];
                                        case 1:
                                            fieldResult = _a.sent();
                                            resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                                            if (fieldResult !== undefined) {
                                                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                                else (0, parcelRequire("jDjTr")).merge(result[resultFieldKey], fieldResult);
                                            }
                                            return [
                                                2
                                            ];
                                        case 2:
                                            if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                                            else {
                                                fragment = fragmentMap[selection.name.value];
                                                if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                            }
                                            typeCondition = fragment.typeCondition.name.value;
                                            if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                            ];
                                        case 3:
                                            fragmentResult = _a.sent();
                                            (0, parcelRequire("jDjTr")).merge(result, fragmentResult);
                                            _a.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4,
                            Promise.all(selectionSet.selections.map(execute))
                        ];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) return [
                            2,
                            execContext.resultMapper(result, rootValue)
                        ];
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
                            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
                            field: field
                        };
                        return [
                            4,
                            resolver(fieldName, rootValue, args, contextValue, info)
                        ];
                    case 1:
                        result = _a.sent();
                        if (!field.selectionSet) return [
                            2,
                            result
                        ];
                        if (result == null) return [
                            2,
                            result
                        ];
                        if (Array.isArray(result)) return [
                            2,
                            $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                        ];
                        return [
                            2,
                            $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
            return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
        }));
    }
});
parcelRegister("jDjTr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jojW6;
    function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (variableValues === void 0) variableValues = {};
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e4b11739b667b187$var$graphql;
    function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function(selection) {
            if (variables && !(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return;
            if ((0, parcelRequire("jojW6")).isField(selection)) {
                var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
                var resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                if (fieldResult !== undefined) {
                    if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                    else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
                }
            } else {
                var fragment = void 0;
                if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new Error("No fragment named " + selection.name.value);
                }
                var typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                    var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                    $e4b11739b667b187$var$merge(result, fragmentResult);
                }
            }
        });
        if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
        return result;
    }
    function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
        var info = {
            isLeaf: !field.selectionSet,
            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
            field: field
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);
        if (!field.selectionSet) return result;
        if (result == null) return result;
        if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
    }
    function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
        return result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
            return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
        });
    }
    var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
    function $e4b11739b667b187$var$merge(dest, src) {
        if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
            var srcVal = src[key];
            if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
            else $e4b11739b667b187$var$merge(dest[key], srcVal);
        });
    }
    module.exports.merge = $e4b11739b667b187$var$merge;
});
parcelRegister("b2p88", function(module, exports) {
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$80935fed9657b3c7$export$8eae69e876ee321e);
    $parcel$export(module.exports, "normalizeTypeDefs", ()=>$80935fed9657b3c7$export$467f9c465e4ace4e);
    var $1c8Um;
    var $jojW6;
    var $80935fed9657b3c7$var$connectionRemoveConfig = {
        test: function(directive) {
            return directive.name.value === 'client';
        },
        remove: true
    };
    var $80935fed9657b3c7$var$removed = new Map();
    function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
        var cached = $80935fed9657b3c7$var$removed.get(query);
        if (cached) return cached;
        (0, (0, parcelRequire("jojW6")).checkDocument)(query);
        var docClone = (0, (0, parcelRequire("jojW6")).removeDirectivesFromDocument)([
            $80935fed9657b3c7$var$connectionRemoveConfig
        ], query);
        $80935fed9657b3c7$var$removed.set(query, docClone);
        return docClone;
    }
    function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
        var defs = Array.isArray(typeDefs) ? typeDefs : [
            typeDefs
        ];
        return defs.map(function(typeDef) {
            return typeof typeDef === 'string' ? typeDef : (0, (0, parcelRequire("1c8Um")).print)(typeDef);
        }).map(function(str) {
            return str.trim();
        }).join('\n');
    }
});
parcelRegister("jQUy5", function(module, exports) {
    $parcel$export(module.exports, "UFOLoggerLink", ()=>$35ed2b5c814d0caf$export$fb326ed954631f3f);
    var $clSzL;
    var $knQnR;
    const $35ed2b5c814d0caf$export$fb326ed954631f3f = new (0, (0, parcelRequire("clSzL")).ApolloLink)((operation, forward)=>{
        const networkStart = performance.now();
        return forward(operation).map((response)=>{
            const networkComplete = performance.now();
            const operationName = operation.operationName ?? 'unnamed';
            (0, (0, parcelRequire("knQnR")).addSpanToAll)('graphql', operationName, [
                {
                    name: 'network'
                }
            ], networkStart, networkComplete);
            return response;
        });
    });
});
parcelRegister("l0T7c", function(module, exports) {
    module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");
});
parcelRegister("9g713", function(module, exports) {
    $parcel$export(module.exports, "getErrorAnalyticsContext", ()=>$a87e716199660ede$export$bd030713895ed5e2);
    $parcel$export(module.exports, "reportErrors", ()=>$a87e716199660ede$export$a78ebe1911f50d41);
    var $9XE6b = parcelRequire("9XE6b");
    var $e3a3O;
    var $jcw0u;
    const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
    const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
            ...context,
            [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
        });
    const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
        const errorAnalytics = (0, ($parcel$interopDefault($9XE6b)))(context, [
            $a87e716199660ede$export$15d632fe38832073
        ], undefined);
        if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
            id: errorAnalytics.id,
            packageName: errorAnalytics.packageName,
            teamName: errorAnalytics.teamName,
            attributes: errorAnalytics.attributes,
            sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
        };
        return undefined;
    };
    const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
        if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
        const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
        const hasNetworkError = networkError !== undefined;
        if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
        const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
        const error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
            graphQLErrors: graphQLErrors ? [
                ...graphQLErrors
            ] : undefined,
            networkError: networkError
        });
        const attributesWithOperationName = {
            ...attributes,
            operationName: operation.operationName,
            hasGraphQLError: hasGraphQLError,
            hasNetworkError: hasNetworkError
        };
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: attributesWithOperationName,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
    };
});
parcelRegister("AeWM3", function(module, exports) {
    $parcel$export(module.exports, "resetCache", ()=>$63ae5caf575c2d55$export$6e5dca841bdf93e3);
    $parcel$export(module.exports, "getClient", ()=>$63ae5caf575c2d55$export$6bb76d6eba7e258c);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>$63ae5caf575c2d55$export$8e363dbef886ff17);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $bvsgq;
    var $9OXo1;
    const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
    const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
        delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    };
    const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
                [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
            }), {});
    const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
        let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
        if (!client) {
            client = clientCreator(baseUrl, xsrfToken);
            $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
        }
        return client;
    };
    class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
        getClient(baseUrl, xsrfToken) {
            return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
        }
        render() {
            const { children: children } = this.props;
            if (!(0, ($parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
                const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
                    client: client
                }, children);
            });
        }
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("7nKe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b120e66bf4d03608$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $12jwF;
    var $54qG5;
    var $5YBrl;
    var $1Zr0i;
    var $daQYX;
    var $cm8b5;
    var $gxGcZ;
    var $iXVV6;
    var $aVFIE;
    var $l2N2a;
    var $koeKL;
    var $lVJAU;
    var $k7McJ;
    var $8OqLl;
    const $b120e66bf4d03608$var$ProjectContextProvider = ({ children: children })=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = project?.id;
        const projectKey = project?.key;
        const projectType = project?.type;
        const isTeamManaged = Boolean(project?.isSimplified);
        const jqlContext = projectKey ? `project = '${projectKey}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId,
                isTeamManaged: isTeamManaged,
                projectType: projectType
            }), [
            projectId,
            isTeamManaged,
            projectType
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>project?.permissions?.viewIssues ? {
                name: project.name,
                id: String(project.id)
            } : null, [
            project
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectId ? [
                projectId
            ] : undefined, [
            projectId
        ]);
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        if (project?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton), null);
        else if (project == null || entityData == null || error) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE),
            error: error
        }));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectAri
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: String(project?.id),
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: String(project?.id)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        }), content);
    };
    var $b120e66bf4d03608$export$2e2bcd8739ae039 = $b120e66bf4d03608$var$ProjectContextProvider;
});
parcelRegister("12jwF", function(module, exports) {
    $parcel$export(module.exports, "AriProvider", ()=>$d9a27a44a6301e03$export$c806f8ac05dc61fa);
    $parcel$export(module.exports, "useEntityAri", ()=>$d9a27a44a6301e03$export$badcacdc306567b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d9a27a44a6301e03$var$AriContext = (0, $5uXOq.createContext)('');
    const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
            value: ari
        }, children);
    const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);
});
parcelRegister("54qG5", function(module, exports) {
    $parcel$export(module.exports, "BusinessEntityProvider", ()=>$a71d927d8f07dfcc$export$c800e064c3c327ef);
    $parcel$export(module.exports, "useBusinessEntity", ()=>$a71d927d8f07dfcc$export$ff2574b00bc1c100);
    var $5uXOq = parcelRequire("5uXOq");
    const $a71d927d8f07dfcc$var$BusinessEntityContext = (0, $5uXOq.createContext)(null);
    const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
            value: data
        }, children);
    const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
        const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
        return {
            data: entity
        };
    };
});
parcelRegister("5YBrl", function(module, exports) {
    $parcel$export(module.exports, "JqlProvider", ()=>$81e54c5b62a4ab4d$export$fdc879e2ba0da048);
    $parcel$export(module.exports, "useJqlContext", ()=>$81e54c5b62a4ab4d$export$f32e2f688fc08561);
    var $5uXOq = parcelRequire("5uXOq");
    const $81e54c5b62a4ab4d$var$JqlContext = (0, $5uXOq.createContext)('');
    const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
            value: jqlContext
        }, children);
    const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);
});
parcelRegister("1Zr0i", function(module, exports) {
    $parcel$export(module.exports, "RealtimeProvider", ()=>$6a65786548fb921c$export$64d242981d970821);
    $parcel$export(module.exports, "useRealtimeContext", ()=>$6a65786548fb921c$export$f39c07717ad8c35b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6a65786548fb921c$var$RealtimeContext = (0, $5uXOq.createContext)([]);
    const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
        const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
            ids
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
            value: projectsIds
        }, children);
    };
    const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);
});
parcelRegister("daQYX", function(module, exports) {
    $parcel$export(module.exports, "ProjectHookProvider", ()=>$cf7f84dff81db95f$export$f1938a4916a14d9f);
    $parcel$export(module.exports, "useProject", ()=>$cf7f84dff81db95f$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    const $cf7f84dff81db95f$var$Context = (0, $5uXOq.createContext)(null);
    const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
            value: project
        }, children);
    const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
        const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
        if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
        return project;
    };
});
parcelRegister("gxGcZ", function(module, exports) {
    $parcel$export(module.exports, "FiltersProvider", ()=>$5ac2d1f4676106ae$export$905df3588d1d8c75);
    $parcel$export(module.exports, "useAssigneesFilterQuery", ()=>$5ac2d1f4676106ae$export$f39bce8705b01ff5);
    $parcel$export(module.exports, "useProjectFilter", ()=>$5ac2d1f4676106ae$export$b71768ffb8163578);
    $parcel$export(module.exports, "useAllowedFieldTypes", ()=>$5ac2d1f4676106ae$export$9dc8a291956c2fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
        assigneeQuery: '',
        projectFilter: {
            totalCount: 0,
            options: []
        }
    };
    const $5ac2d1f4676106ae$var$FiltersContext = (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
    const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
            const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
            const projectFilter = {
                totalCount: projects.length,
                options: projects.map((project)=>({
                        label: project.name,
                        value: String(project.id),
                        avatar: project.avatarUrl,
                        square: true
                    }))
            };
            return {
                assigneeQuery: assigneeQuery,
                projectFilter: projectFilter
            };
        }, [
            projects
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
            value: value
        }, children);
    };
    const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
    const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
    const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
        const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
        return (0, $5uXOq.useMemo)(()=>{
            const result = new Set(inputAllowedFieldTypes ?? (0, (0, parcelRequire("gzkAf")).BUSINESS_FIELD_TYPES));
            if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, (0, parcelRequire("5fc53")).PROJECT_TYPE));
            return result;
        }, [
            filtersContext,
            inputAllowedFieldTypes
        ]);
    };
});
parcelRegister("gzkAf", function(module, exports) {
    $parcel$export(module.exports, "POPUP_WIDTH", ()=>$92b04c6ea9a59b67$export$b6d617db656efcca);
    $parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", ()=>$92b04c6ea9a59b67$export$dd535f74d98d8b3);
    $parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", ()=>$92b04c6ea9a59b67$export$dba112976ea61483);
    $parcel$export(module.exports, "GAP_BETWEEN_OPTION", ()=>$92b04c6ea9a59b67$export$fe1082abeeda69ed);
    $parcel$export(module.exports, "OPTION_SPAN_PADDING", ()=>$92b04c6ea9a59b67$export$17ed91292eb6c163);
    $parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", ()=>$92b04c6ea9a59b67$export$fb22dccd99438559);
    $parcel$export(module.exports, "POPUP_OFFSET_TOP", ()=>$92b04c6ea9a59b67$export$15839778e99d81e7);
    $parcel$export(module.exports, "OPTION_MAX_WIDTH", ()=>$92b04c6ea9a59b67$export$39aa3a14ebf850c7);
    $parcel$export(module.exports, "DATE_RANGE_TYPE", ()=>$92b04c6ea9a59b67$export$1178808c606e043b);
    $parcel$export(module.exports, "BUSINESS_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$c269ba5d631cb115);
    $parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$232814e45256d5dc);
    $parcel$export(module.exports, "IMPLEMENTED_TYPES", ()=>$92b04c6ea9a59b67$export$9615a3d79408a88a);
    $parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$a21166a4b76932b5);
    $parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", ()=>$92b04c6ea9a59b67$export$1989c7236a398e8a);
    var $gwIPs;
    var $5fc53;
    const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
    const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
    const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
    const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, (0, parcelRequire("gwIPs")).gridSize) / 2;
    const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $92b04c6ea9a59b67$export$fb22dccd99438559 = 14;
    const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
    const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
    const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
    const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
    const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        (0, (0, parcelRequire("5fc53")).CREATED),
        $92b04c6ea9a59b67$export$1178808c606e043b,
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
    ];
    const $92b04c6ea9a59b67$export$232814e45256d5dc = [
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
        (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)
    ];
    const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
        ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
        ...$92b04c6ea9a59b67$export$232814e45256d5dc
    ]);
    const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)
    ]);
    const $92b04c6ea9a59b67$export$90ca377eb0b24ff1 = {
        assignee: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        component: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        created: (0, (0, parcelRequire("5fc53")).CREATED),
        issuetype: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        labels: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        priority: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        project: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        reporter: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        status: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        updated: (0, (0, parcelRequire("5fc53")).UPDATED)
    };
    const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3.5;
    const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
    const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
    const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("k7McJ", function(module, exports) {
    $parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", ()=>$47951bf9c4bef1f5$export$cb40bbf7ea51db63);
    const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
        experience: 'fetch-project',
        packageName: 'jiraBusinessEntityProjectProvider',
        teamName: 'wanjel'
    };
});
parcelRegister("8OqLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5cc2e237e9a9763$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $a5cc2e237e9a9763$var$NotFoundComponent = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("imwWS")), {
        moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
    });
    const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "not-found-component",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
    var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;
});
parcelRegister("imwWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("azGse")
    ]).then(()=>parcelRequire('4zX1V'));
});
parcelRegister("iEEXl", function(module, exports) {
    $parcel$export(module.exports, "URL_PARAMS", ()=>$8497b4ce450fc8b0$export$bcc0c92e1564488c);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$8497b4ce450fc8b0$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "VIEW_FORM_DIRECTORY_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$3a0a03305bcf855e);
    $parcel$export(module.exports, "DELETE_FORM_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$7da90561e94f981);
    $parcel$export(module.exports, "VIEW_FORM_SUBMISSION_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$cdf9f6e9e7d621b6);
    $parcel$export(module.exports, "SUBMIT_FORM_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$537c9533c0b9bc1);
    $parcel$export(module.exports, "VIEW_FORM_CREATE_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$ca4e778581db201e);
    $parcel$export(module.exports, "CREATE_FORM_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$a18ce17ea7fe6b60);
    $parcel$export(module.exports, "VIEW_FORM_UPDATE_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$3a8f4f9a630a8c30);
    $parcel$export(module.exports, "UPDATE_FORM_EXPERIENCE", ()=>$8497b4ce450fc8b0$export$b60e0f4f7fb57d79);
    $parcel$export(module.exports, "FORM_VALIDATION_ERROR", ()=>$8497b4ce450fc8b0$export$85998b62672f570a);
    $parcel$export(module.exports, "BUSINESS_PREFIX", ()=>$8497b4ce450fc8b0$export$b8ed4f67ef69db43);
    $parcel$export(module.exports, "SOFTWARE_TMP_PREFIX", ()=>$8497b4ce450fc8b0$export$b1dbf4e7f8828780);
    $parcel$export(module.exports, "SOFTWARE_CMP_PREFIX", ()=>$8497b4ce450fc8b0$export$90c8d3e12aee976a);
    $parcel$export(module.exports, "BUSINESS_FEEDBACK_GROUP_ID", ()=>$8497b4ce450fc8b0$export$8d12d5bc867b3584);
    $parcel$export(module.exports, "SOFTWARE_FEEDBACK_GROUP_ID", ()=>$8497b4ce450fc8b0$export$446ca3d108d6e8b0);
    const $8497b4ce450fc8b0$export$61b0d4a63fb97a47 = 250;
    const $8497b4ce450fc8b0$export$bcc0c92e1564488c = {
        FROM: 'from',
        DIRECTORY: 'directory'
    };
    const $8497b4ce450fc8b0$export$b8b9d90f9e5bd72b = 'jiraBusinessForm';
    const $8497b4ce450fc8b0$export$3a0a03305bcf855e = {
        experience: 'viewFormDirectory',
        experienceId: 'viewDirectory',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$7da90561e94f981 = {
        experience: 'deleteForm',
        experienceId: 'deleteForm',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$cdf9f6e9e7d621b6 = {
        experience: 'formSubmission',
        experienceId: 'main',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$537c9533c0b9bc1 = {
        experience: 'CreateJiraBusinessIssueForm',
        experienceId: 'mutation',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$ca4e778581db201e = {
        experience: 'formCreation',
        experienceId: 'main',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$a18ce17ea7fe6b60 = {
        experience: 'CreateJiraBusinessForm',
        experienceId: 'mutation',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$3a8f4f9a630a8c30 = {
        experience: 'formUpdate',
        experienceId: 'main',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$b60e0f4f7fb57d79 = {
        experience: 'UpdateJiraBusinessForm',
        experienceId: 'mutation',
        packageName: 'jiraBusinessForm',
        teamName: 'jira-werewolves'
    };
    const $8497b4ce450fc8b0$export$85998b62672f570a = {
        ATTACHMENT_ERROR: 'ATTACHMENT_VALIDATION_ERROR'
    };
    const $8497b4ce450fc8b0$export$b8ed4f67ef69db43 = '/jira/core';
    const $8497b4ce450fc8b0$export$b1dbf4e7f8828780 = '/jira/software';
    const $8497b4ce450fc8b0$export$90c8d3e12aee976a = '/jira/software/c';
    const $8497b4ce450fc8b0$export$8d12d5bc867b3584 = 'jbus-feedback-form';
    const $8497b4ce450fc8b0$export$446ca3d108d6e8b0 = 'jirasoftware-feedback-form';
});
parcelRegister("7wwVP", function(module, exports) {
    $parcel$export(module.exports, "FormAccessLevelTypes", ()=>$731dd5b579eaba8f$export$dbc34c94c457377);
    $parcel$export(module.exports, "AVAILABLE_FIELD_TYPE", ()=>$731dd5b579eaba8f$export$c019a43cced7fc);
    $parcel$export(module.exports, "FORM_FIELD_TYPE", ()=>$731dd5b579eaba8f$export$29a2902f3ad575d1);
    $parcel$export(module.exports, "DROPPABLE_SIDEBAR_AREA_TYPE", ()=>$731dd5b579eaba8f$export$9b69337637a4596e);
    const $731dd5b579eaba8f$export$dbc34c94c457377 = {
        LIMITED: 'limited',
        OPEN: 'open'
    };
    const $731dd5b579eaba8f$export$c019a43cced7fc = Symbol('AVAILABLE_FIELD_TYPE');
    const $731dd5b579eaba8f$export$29a2902f3ad575d1 = Symbol('FORM_FIELD_TYPE');
    const $731dd5b579eaba8f$export$9b69337637a4596e = Symbol('DROPPABLE_SIDEBAR_AREA_TYPE');
});
parcelRegister("6czoq", function(module, exports) {
    $parcel$export(module.exports, "SuccessView", ()=>$5f0f2a833fc793a6$export$be5117c66bf44cb9);
    $parcel$export(module.exports, "NoPermissionView", ()=>$5f0f2a833fc793a6$export$be11ccfe1ded6d81);
    $parcel$export(module.exports, "FormUnavailableView", ()=>$5f0f2a833fc793a6$export$5759d094146e3811);
    $parcel$export(module.exports, "NoProjectAccessView", ()=>$5f0f2a833fc793a6$export$8c53a54f2f70bf31);
    $parcel$export(module.exports, "IssueTypeNotAssociatedView", ()=>$5f0f2a833fc793a6$export$5d16b0bd7e8f5692);
    $parcel$export(module.exports, "IssueTypeDeletedView", ()=>$5f0f2a833fc793a6$export$8e65211163568af8);
    $parcel$export(module.exports, "FormContainsUnsupportedRequiredFieldsView", ()=>$5f0f2a833fc793a6$export$1c25efc053ce2b31);
    $parcel$export(module.exports, "FormMissingSupportedRequiredFieldsView", ()=>$5f0f2a833fc793a6$export$e6e19199dff5fc90);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4EETE;
    var $2oKQq;
    var $cZ1Pf;
    var $8xbuS;
    var $ZuPvl;
    var $41j30;
    var $8Q4sF;
    var $c8ARX;
    var $c2E1P;
    var $iVgQf;
    var $ousew;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $lwMsT;
    var $l2N2a;
    var $khNIP;
    const $5f0f2a833fc793a6$var$contactAdminUrl = '/jira/contact-administrator';
    const $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage = (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
            href: $5f0f2a833fc793a6$var$contactAdminUrl
        }, chunks);
    const $5f0f2a833fc793a6$var$WAC_LINK = 'https://www.atlassian.com/software/jira?utm_source=in-product-banner&utm_medium=inapp&utm_campaign=P:jira-work-management%7CO:cloudpmm-jwm%7CF:discovery%7CE:cloud%7CX:expand%7C';
    const $5f0f2a833fc793a6$export$be5117c66bf44cb9 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { shouldHidePoweredBy: shouldHidePoweredBy, onResetClick: onResetClick, analyticAttributes: analyticAttributes } = props;
        const onSubmitAnotherResponse = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'submitAnotherResponseForForm', {
                ...analyticAttributes
            });
            onResetClick();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormSuccessView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$SuccessWrapper, {
            shouldHidePoweredBy: shouldHidePoweredBy
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$Heading, null, formatMessage((0, (0, parcelRequire("khNIP")).messages).successSubmissionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "p"
        }, formatMessage((0, (0, parcelRequire("khNIP")).messages).successSubmissionContentExperiment)), (0, ($parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$SubmitAnotherButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4EETE")).default), {
            appearance: "primary",
            onClick: onSubmitAnotherResponse
        }, formatMessage((0, (0, parcelRequire("khNIP")).messages).formSubmitAnotherForm))), !shouldHidePoweredBy && (0, ($parcel$interopDefault($5uXOq))).createElement($5f0f2a833fc793a6$var$PromoFooter, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            message: formatMessage((0, (0, parcelRequire("khNIP")).messages).formSuccessFooterSpork, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xbuS")).JiraIcon), {
                        size: "small",
                        appearance: "brand"
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: $5f0f2a833fc793a6$var$WAC_LINK,
                        target: "_blank",
                        onClick: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'poweredByJwm');
                        }
                    }, children))
            }
        }))));
    };
    const $5f0f2a833fc793a6$export$be11ccfe1ded6d81 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormNoPermissionView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).noPermissionHeading),
            headingLevel: 1,
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("khNIP")).messages).noPermissionContent,
                values: {
                    createPermissionName: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                        as: "strong"
                    }, formatMessage((0, (0, parcelRequire("khNIP")).messages).createPermissionName)),
                    linkToContactAdmin: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
                        onClick: (event, analyticsEvent)=>{
                            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'contactAdministrator');
                        },
                        href: "/secure/ContactAdministrators!default.jspa"
                    }, formatMessage((0, (0, parcelRequire("khNIP")).messages).noPermissionLinkToContactAdmin))
                }
            }),
            maxImageWidth: 100,
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c2E1P")).default))
        }));
    };
    const $5f0f2a833fc793a6$export$5759d094146e3811 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormUnavailableView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableHeading),
            headingLevel: 1,
            description: formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableContent),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c8ARX")).default))
        }));
    };
    const $5f0f2a833fc793a6$export$8c53a54f2f70bf31 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormUnavailableView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableWithoutProjectAccessTitle),
            headingLevel: 1,
            description: formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableWithoutProjectAccessDescription),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c8ARX")).default))
        }));
    };
    const $5f0f2a833fc793a6$export$5d16b0bd7e8f5692 = ({ issueTypeName: issueTypeName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("l2N2a")).useProject)().data;
        const isAdmin = project && project.permissions.administerProject;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormUnavailableIssueTypeRemovedView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableHeading),
            headingLevel: 1,
            description: isAdmin ? formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableIssueTypeNotAssociatedContentForAdmins, {
                issueTypeName: issueTypeName
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("khNIP")).messages).formUnavailableIssueTypeNotAssociatedContent,
                values: {
                    link: $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage
                }
            }),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c8ARX")).default))
        }));
    };
    const $5f0f2a833fc793a6$export$8e65211163568af8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("l2N2a")).useProject)().data;
        const isAdmin = project && project.permissions.administerProject;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormUnavailableIssueTypeDeletedView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableHeading),
            headingLevel: 1,
            description: isAdmin ? formatMessage((0, (0, parcelRequire("khNIP")).messages).formUnavailableIssueTypeDeletedContentForAdmins) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("khNIP")).messages).formUnavailableIssueTypeDeletedContent,
                values: {
                    link: $5f0f2a833fc793a6$var$ContactYourAdminLinkMessage
                }
            }),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c8ARX")).default))
        }));
    };
    const $5f0f2a833fc793a6$export$1c25efc053ce2b31 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("l2N2a")).useProject)().data;
        const canCreateOrModifyForm = project && project.permissions.administerProject;
        const projectKey = project?.key;
        const isTeamManaged = project?.isSimplified;
        const fieldLayoutSchemesUrlCMP = '/secure/admin/ViewFieldLayoutSchemes.jspa';
        const fieldLayoutSchemesUrlTMP = `/jira/core/projects/${projectKey}/settings/issuetypes`;
        const fieldLayoutSchemesUrl = isTeamManaged ? fieldLayoutSchemesUrlTMP : fieldLayoutSchemesUrlCMP;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormContainsUnsupportedRequiredFieldsView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).unsupportedRequiredFieldsHeading),
            headingLevel: 1,
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("khNIP")).messages).unsupportedRequiredFieldsDescription,
                values: {
                    canCreateOrModifyForm: canCreateOrModifyForm,
                    link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
                            onClick: (event, analyticsEvent)=>{
                                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingUnsupportedRequiredFieldsCta', {
                                    isAdmin: canCreateOrModifyForm
                                });
                            },
                            href: canCreateOrModifyForm ? fieldLayoutSchemesUrl : $5f0f2a833fc793a6$var$contactAdminUrl
                        }, chunks)
                }
            }),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c8ARX")).default))
        }));
    };
    const $5f0f2a833fc793a6$export$e6e19199dff5fc90 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const project = (0, (0, parcelRequire("l2N2a")).useProject)().data;
        const canCreateOrModifyForm = project && project.permissions.administerProject;
        const adminUrl = typeof window !== 'undefined' ? `${window.location.href}/builder` : '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormMissingSupportedRequiredFieldsView",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            header: formatMessage((0, (0, parcelRequire("khNIP")).messages).supportedRequiredFieldsMissingHeading),
            headingLevel: 1,
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("khNIP")).messages).supportedRequiredFieldsDescription,
                values: {
                    canCreateOrModifyForm: canCreateOrModifyForm,
                    link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41j30")).default), {
                            onClick: (event, analyticsEvent)=>{
                                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'formMissingSupportedRequiredFieldsCta', {
                                    isAdmin: canCreateOrModifyForm
                                });
                            },
                            href: canCreateOrModifyForm ? adminUrl : $5f0f2a833fc793a6$var$contactAdminUrl
                        }, chunks)
                }
            }),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("c8ARX")).default))
        }));
    };
    const $5f0f2a833fc793a6$var$illustrationHeight = 4;
    const $5f0f2a833fc793a6$var$Heading = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "large",
            as: "h1"
        }, children);
    const $5f0f2a833fc793a6$var$WrapperStyleBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _1uak12bs _ydafzu5n _cfu11ule _l5lo12bs",
                __cmplp.className
            ])
        });
    });
    const $5f0f2a833fc793a6$var$SuccessWrapper = (0, $5uXOq.forwardRef)(({ as: C = $5f0f2a833fc793a6$var$WrapperStyleBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s816qb _1kt976ek",
                __cmplp.shouldHidePoweredBy ? "_n3tdf6fq" : "_n3tdidpf",
                __cmplp.className
            ])
        });
    });
    const $5f0f2a833fc793a6$var$PromoFooter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _x3dowsm2 _19pkxy5q _otyrpxbi _ca0q1ejb _syaz1thw",
                __cmplp.className
            ])
        });
    });
    const $5f0f2a833fc793a6$var$SubmitAnotherButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qpxbi _18s8qc1h",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("41j30", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c2f3c33a6194375$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8oe80;
    var $hDzhb;
    function $7c2f3c33a6194375$var$Link(props) {
        const { children: children, ...rest } = props;
        delete rest.createAnalyticsEvent;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), rest, children);
    }
    var $7c2f3c33a6194375$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('link', {
        onClick: 'clicked'
    })($7c2f3c33a6194375$var$Link);
});
parcelRegister("8Q4sF", function(module, exports) {
    $parcel$export(module.exports, "FormattedI18nMessage", ()=>$7c8c20575fbc9bfc$export$200d7bd7633253ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $gHDlh;
    var $9Byym;
    const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
        const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
        const messageParts = (0, $5uXOq.useMemo)(()=>{
            const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, (0, parcelRequire("9Byym")).getTags)(componentsMapping);
            try {
                const parts = [];
                let token = '';
                let TagComponent;
                let closeTagLookup;
                for(let i = 0; i < message.length; i += 1){
                    const letter = message[i];
                    token += letter;
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter)) {
                        const firstTagFound = (0, (0, parcelRequire("9Byym")).findTag)(token, {
                            tags: openTags
                        });
                        if (firstTagFound !== null && firstTagFound !== undefined) {
                            if (TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                            const text = token.replace(firstTagFound, '');
                            parts.push(text);
                            const tagInfo = tags[firstTagFound];
                            TagComponent = tagInfo.component;
                            closeTagLookup = tagInfo.close;
                            token = '';
                        }
                    }
                    if (closeTagLookup !== null && closeTagLookup !== undefined && (0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: [
                            closeTagLookup
                        ]
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                        const text = token.replace(closeTagLookup, '');
                        parts.push((0, ($parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                        TagComponent = undefined;
                        token = '';
                        closeTagLookup = undefined;
                    }
                    if ((0, (0, parcelRequire("9Byym")).isCloseTagDelimiter)(letter) && (0, (0, parcelRequire("9Byym")).isAnyTag)(token, {
                        tags: closeTags
                    })) {
                        if (!TagComponent) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                    }
                }
                if (TagComponent || closeTagLookup) throw new (0, (0, parcelRequire("gHDlh")).MalformedMessageError)();
                if (token.length > 0) parts.push(token);
                return parts;
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("gHDlh")).MalformedMessageError)) {
                    (0, (0, parcelRequire("gHDlh")).logMalformedMessageError)({
                        message: message,
                        packageName: packageName
                    });
                    return [
                        (0, (0, parcelRequire("gHDlh")).getMalformedMessage)({
                            message: message,
                            closeTags: closeTags,
                            openTags: openTags
                        })
                    ];
                }
                throw e;
            }
        }, [
            message,
            packageName,
            componentsMapping
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: index
            }, item)));
    };
});
parcelRegister("gHDlh", function(module, exports) {
    $parcel$export(module.exports, "getMalformedMessage", ()=>$ecff24857c176a60$export$f085cf20ec1f69ab);
    $parcel$export(module.exports, "logMalformedMessageError", ()=>$ecff24857c176a60$export$954c3e6aad1c9429);
    $parcel$export(module.exports, "MalformedMessageError", ()=>$ecff24857c176a60$export$40d900e818b9630e);
    var $dJl1T;
    var $jcw0u;
    const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
            ...openTags,
            ...closeTags
        ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
    const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
        if (packageName !== null && packageName !== undefined) {
            const errorMessage = `Malformed message: ${message}`;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    packageName: packageName,
                    id: (0, $5514815b06163219$export$f3390a0e172fee41)
                },
                attributes: {
                    message: errorMessage
                }
            });
            const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, errorMessage);
        }
    };
    class $ecff24857c176a60$export$40d900e818b9630e extends Error {
        constructor(){
            super('Malformed i18n message');
        }
    }
});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';
parcelRegister("9Byym", function(module, exports) {
    $parcel$export(module.exports, "getTags", ()=>$84498158f946a67b$export$af63d7414243dad3);
    $parcel$export(module.exports, "isAnyTag", ()=>$84498158f946a67b$export$38ffa64fc639355f);
    $parcel$export(module.exports, "findTag", ()=>$84498158f946a67b$export$dfca0f74034f8657);
    $parcel$export(module.exports, "isCloseTagDelimiter", ()=>$84498158f946a67b$export$d5170904651e91b1);
    const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce((acc, [key, value])=>{
            const open = `{${key}Start}`;
            const close = `{${key}End}`;
            acc.tags[open] = {
                close: close,
                component: value
            };
            acc.openTags.push(open);
            acc.closeTags.push(close);
            return acc;
        }, {
            tags: {},
            openTags: [],
            closeTags: []
        });
    const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
    const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
    const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);
});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';
parcelRegister("c8ARX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fefc6da4073af21$export$2e2bcd8739ae039);
    var $dCLgq;
    var $at4lO = parcelRequire("at4lO");
    const $2fefc6da4073af21$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($at4lO)),
        srcDark: ($parcel$interopDefault($at4lO))
    });
    var $2fefc6da4073af21$export$2e2bcd8739ae039 = $2fefc6da4073af21$var$Illustration;
    const $2fefc6da4073af21$export$a179c88182cb9d56 = [
        0,
        0,
        236,
        211
    ];
});
parcelRegister("at4lO", function(module, exports) {
    module.exports = new URL("loading-file-error.402df2c9.svg", import.meta.url).toString();
});
parcelRegister("c2E1P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c12b9bc47dd929a8$export$2e2bcd8739ae039);
    var $dCLgq;
    var $9IVIt = parcelRequire("9IVIt");
    var $d60hN = parcelRequire("d60hN");
    const $c12b9bc47dd929a8$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($d60hN)),
        srcDark: ($parcel$interopDefault($9IVIt))
    });
    var $c12b9bc47dd929a8$export$2e2bcd8739ae039 = $c12b9bc47dd929a8$var$Illustration;
    const $c12b9bc47dd929a8$export$a179c88182cb9d56 = [
        0,
        0,
        169,
        222
    ];
});
parcelRegister("9IVIt", function(module, exports) {
    module.exports = new URL("lock-red-darkmode.35f0d66e.svg", import.meta.url).toString();
});
parcelRegister("d60hN", function(module, exports) {
    module.exports = new URL("lock-red.0ce332f2.svg", import.meta.url).toString();
});
parcelRegister("khNIP", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df85728e69598bad$export$defe85febe8b728c);
    var $7VHMR;
    const $df85728e69598bad$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successSubmissionHeading: {
            "id": "business-form.common.empty-views.success-submission-heading",
            "defaultMessage": "We're on it!"
        },
        successSubmissionContentExperiment: {
            "id": "business-form.common.empty-views.success-submission-content-experiment",
            "defaultMessage": "Thanks for your submission."
        },
        noPermissionHeading: {
            "id": "business-form.common.empty-views.no-permission-heading",
            "defaultMessage": "You don't have access to this form"
        },
        noPermissionContent: {
            "id": "business-form.common.empty-views.no-permission-content",
            "defaultMessage": "You do not have permission to submit forms to this project. Please request for the {createPermissionName} permission by {linkToContactAdmin}"
        },
        noPermissionLinkToContactAdmin: {
            "id": "business-form.common.empty-views.no-permission-link-to-contact-admin",
            "defaultMessage": " contacting this project's administrator."
        },
        createPermissionName: {
            "id": "business-form.common.empty-views.create-permission-name",
            "defaultMessage": "\u201CCreate Issue\u201D"
        },
        formUnavailableHeading: {
            "id": "business-form.common.empty-views.form-unavailable-heading",
            "defaultMessage": "Form is unavailable"
        },
        formUnavailableContent: {
            "id": "business-form.common.empty-views.form-unavailable-content",
            "defaultMessage": "This form is no longer active. Try contacting the owner of the form if you think this is a mistake."
        },
        formUnavailableIssueTypeDeletedContentOld: {
            "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-old",
            "defaultMessage": "The issue type associated with this form was removed from your business project. {linkStart}Contact your admin{linkEnd} to delete the form and create a new one.  "
        },
        formUnavailableIssueTypeDeletedContent: {
            "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content",
            "defaultMessage": "The issue type associated with this form was removed from your business project. <link>Contact your admin</link> to delete the form and create a new one.  "
        },
        formUnavailableIssueTypeDeletedContentForAdmins: {
            "id": "business-form.common.empty-views.form-unavailable-issue-type-deleted-content-for-admins",
            "defaultMessage": "The issue type associated with this form was removed from your business project. Delete this form and create a new one with the issue types that are available."
        },
        formUnavailableIssueTypeNotAssociatedContentOld: {
            "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-old",
            "defaultMessage": "The issue type being used for this form is not valid. {linkStart}Contact your admin{linkEnd} to check if this issue type is linked to the issue type scheme for this business project."
        },
        formUnavailableIssueTypeNotAssociatedContent: {
            "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content",
            "defaultMessage": "The issue type being used for this form is not valid. <link>Contact your admin</link> to check if this issue type is linked to the issue type scheme for this business project."
        },
        formUnavailableIssueTypeNotAssociatedContentForAdmins: {
            "id": "business-form.common.empty-views.form-unavailable-issue-type-not-associated-content-for-admins",
            "defaultMessage": "The issue type {issueTypeName} being used for this form is not valid. Check if this issue type is linked to the issue type scheme for this business project."
        },
        formSuccessFooterSpork: {
            "id": "business-form.common.empty-views.form-success-footer-spork",
            "defaultMessage": "Powered by {linkStart}Jira{linkEnd}"
        },
        formSubmitAnotherForm: {
            "id": "business-form.common.empty-views.form-submit-another-form",
            "defaultMessage": "Submit another form"
        },
        unsupportedRequiredFieldsHeading: {
            "id": "business-form.common.empty-views.unsupported-required-fields-heading",
            "defaultMessage": "Unsupported required fields"
        },
        unsupportedRequiredFieldsDescription: {
            "id": "business-form.common.empty-views.unsupported-required-fields-description",
            "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Update the field configuration</link> to make these fields optional, and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request changes to the field configuration}\n        }."
        },
        supportedRequiredFieldsMissingHeading: {
            "id": "business-form.common.empty-views.supported-required-fields-missing-heading",
            "defaultMessage": "Missing required fields"
        },
        supportedRequiredFieldsDescription: {
            "id": "business-form.common.empty-views.supported-required-fields-description",
            "defaultMessage": "{canCreateOrModifyForm, select,\n            true {This form is missing information that is required. <link>Complete all the required fields in the form</link> and try again}\n            other {This form is missing information that is required by the admin. <link>Contact the admin</link> to request any changes to required fields}\n        }."
        },
        formUnavailableWithoutProjectAccessTitle: {
            "id": "business-form.common.empty-views.form-unavailable-without-project-access-title",
            "defaultMessage": "You can't view this form without access to this Jira project"
        },
        formUnavailableWithoutProjectAccessDescription: {
            "id": "business-form.common.empty-views.form-unavailable-without-project-access-description",
            "defaultMessage": "Try contacting the owner of this form if you think this is a mistake."
        }
    });
});
parcelRegister("g2iZ7", function(module, exports) {
    $parcel$export(module.exports, "FormSubmissionPreloader", ()=>$818cc29cb1c3ec2d$export$bacf31e62dc24134);
    $parcel$export(module.exports, "useFormSubmission", ()=>$818cc29cb1c3ec2d$export$6a196f0d30f494f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $l2N2a;
    var $doZTA;
    var $gak61;
    var $EU5WQ;
    var $5FLxe;
    var $kyf8b;
    var $8feUl;
    const $818cc29cb1c3ec2d$export$bacf31e62dc24134 = ()=>{
        const [{ match: { params: { formId: formId } } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const result = (0, (0, parcelRequire("5FLxe")).useGetFormWithFieldDataByFormId)(String(formId));
        const [state, { updateStore: updateStore }] = (0, (0, parcelRequire("kyf8b")).useFormSubmissionStore)();
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(result, state)) updateStore(result);
        }, [
            updateStore,
            result,
            state
        ]);
        return null;
    };
    const $818cc29cb1c3ec2d$export$6a196f0d30f494f8 = ()=>{
        const [{ data: formWithFieldData, loading: getFormLoading, error: getFormError }] = (0, (0, parcelRequire("kyf8b")).useFormSubmissionStore)();
        const { data: fieldMetaData, loading: fieldMetaDataLoading, error: fieldMetaDataError } = (0, (0, parcelRequire("EU5WQ")).useFieldMeta)(formWithFieldData?.projectId, formWithFieldData?.issueType?.id, String(formWithFieldData?.formId));
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const projectType = (0, (0, parcelRequire("gak61")).useProjectType)();
        const loading = getFormLoading || fieldMetaDataLoading;
        return {
            data: loading ? undefined : {
                fieldMetaData: fieldMetaData,
                formWithFieldData: formWithFieldData,
                formSubmissionValidationData: (0, (0, parcelRequire("8feUl")).getFormValidationData)({
                    formData: formWithFieldData,
                    fieldMetaData: fieldMetaData,
                    projectType: projectType ?? project?.type
                })
            },
            formId: String(formWithFieldData?.formId),
            loading: loading,
            error: getFormError || fieldMetaDataError
        };
    };
});
parcelRegister("gak61", function(module, exports) {
    $parcel$export(module.exports, "useProjectType", ()=>$07561ff55b22087f$export$6de29d851c914935);
    var $2vSU6;
    var $65Ltd;
    var $4R6GH;
    var $lODMY;
    const $07561ff55b22087f$var$SOFTWARE_ROUTES_GROUPS = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE)
    ];
    const $07561ff55b22087f$export$a1210dbe3ee59218 = (state)=>$07561ff55b22087f$var$SOFTWARE_ROUTES_GROUPS.includes(state.route.group ?? '');
    const $07561ff55b22087f$export$54f478d5af594f53 = (0, (0, parcelRequire("lODMY")).createRouterSelector)($07561ff55b22087f$export$a1210dbe3ee59218);
    const $07561ff55b22087f$export$6de29d851c914935 = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw_forms_rollout')) return undefined;
        const isSoftwareProject = $07561ff55b22087f$export$54f478d5af594f53();
        return isSoftwareProject ? (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) : (0, (0, parcelRequire("2vSU6")).CORE_PROJECT);
    };
});
parcelRegister("EU5WQ", function(module, exports) {
    $parcel$export(module.exports, "useFieldMeta", ()=>$bba4aa13d32bd987$export$c6fef47cfdcb6be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $gN11a;
    var $7f4tk;
    var $45NOA;
    const $bba4aa13d32bd987$var$fetchMeta = async (formId)=>{
        const response = await (0, (0, parcelRequire("7f4tk")).default)(`/rest/api/2/issue/createmeta/businessform?formId=${formId}&expand=projects.issuetypes.fields`);
        return response;
    };
    const $bba4aa13d32bd987$var$memoizedFetchMeta = (0, (0, parcelRequire("8QpSo")).default)($bba4aa13d32bd987$var$fetchMeta);
    const $bba4aa13d32bd987$export$c6fef47cfdcb6be7 = (projectId, issueTypeId, formId)=>{
        const [state, setState] = (0, $5uXOq.useState)({
            loading: true
        });
        (0, $5uXOq.useEffect)(()=>{
            if (projectId === undefined || projectId === null || issueTypeId === undefined || issueTypeId === null || formId === undefined || formId === null) {
                setState({
                    loading: false
                });
                return;
            }
            (async ()=>{
                setState({
                    loading: true
                });
                (0, (0, parcelRequire("gN11a")).markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
                try {
                    const response = await $bba4aa13d32bd987$var$memoizedFetchMeta(formId);
                    let data;
                    if (response.projects[0]?.issuetypes[0]?.fields) data = (0, (0, parcelRequire("45NOA")).transformFieldsMeta)((0, (0, parcelRequire("45NOA")).filterFieldsMeta)(response.projects[0].issuetypes[0].fields));
                    setState({
                        data: data,
                        loading: false,
                        error: undefined
                    });
                } catch (e) {
                    setState({
                        loading: false,
                        error: e.message
                    });
                } finally{
                    (0, (0, parcelRequire("gN11a")).markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                }
            })();
        }, [
            formId,
            issueTypeId,
            projectId
        ]);
        return state;
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("45NOA", function(module, exports) {
    $parcel$export(module.exports, "filterFieldsMeta", ()=>$e161d853a36b3724$export$6a17577fedf4efeb);
    $parcel$export(module.exports, "transformFieldsMeta", ()=>$e161d853a36b3724$export$613acfe083d57f99);
    var $dPSWJ = parcelRequire("dPSWJ");
    var $5fc53;
    const $e161d853a36b3724$export$6a17577fedf4efeb = (fieldMeta)=>{
        const { issuetype: issuetype, project: project, reporter: reporter, ...otherFieldMeta } = fieldMeta;
        return otherFieldMeta;
    };
    const $e161d853a36b3724$export$5647ab885112c565 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $e161d853a36b3724$var$isCascadingField = (fieldMeta)=>fieldMeta.schema?.custom === $e161d853a36b3724$export$5647ab885112c565;
    const $e161d853a36b3724$var$transformCascadingFieldChildValue = ({ id: id, value: value })=>({
            id: id,
            value: value,
            __typename: 'JiraCascadingOptions'
        });
    const $e161d853a36b3724$export$8e0c8a960f1af96 = ({ id: id, value: value, children: children = [] })=>({
            parentOptionValue: {
                id: id,
                value: value,
                __typename: 'JiraOption'
            },
            childOptionValues: children.map($e161d853a36b3724$var$transformCascadingFieldChildValue)
        });
    const $e161d853a36b3724$var$GROUP_PICKER_API_ENDPOINT = '/rest/api/3/groups/picker?query=';
    const $e161d853a36b3724$var$isGroupField = (fieldMeta)=>fieldMeta.schema?.custom === (0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE) || fieldMeta.schema?.custom === (0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE);
    const $e161d853a36b3724$var$transformGroupField = (fieldMeta)=>({
            ...fieldMeta,
            autoCompleteUrl: $e161d853a36b3724$var$GROUP_PICKER_API_ENDPOINT
        });
    const $e161d853a36b3724$export$613acfe083d57f99 = (fieldsMeta)=>(0, ($parcel$interopDefault($dPSWJ)))(fieldsMeta, (field)=>{
            if ($e161d853a36b3724$var$isGroupField(field)) return $e161d853a36b3724$var$transformGroupField(field);
            if (!$e161d853a36b3724$var$isCascadingField(field)) return field;
            const { allowedValues: allowedValues = [], ...rest } = field;
            return {
                allowedValues: allowedValues.map($e161d853a36b3724$export$8e0c8a960f1af96),
                ...rest
            };
        });
});
parcelRegister("dPSWJ", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $hDnyx = parcelRequire("hDnyx");
    var $bxDef = parcelRequire("bxDef");
    function $a12aa8fd8ab9a7da$var$mapValues(object, iteratee) {
        var result = {};
        iteratee = $bxDef(iteratee, 3);
        $hDnyx(object, function(value, key, object) {
            $1m3dq(result, key, iteratee(value, key, object));
        });
        return result;
    }
    module.exports = $a12aa8fd8ab9a7da$var$mapValues;
});
parcelRegister("5FLxe", function(module, exports) {
    $parcel$export(module.exports, "useFormById", ()=>$fb77ed67ab7c7c60$export$ac7a76dbf4149182);
    $parcel$export(module.exports, "useGetFormWithFieldDataByFormId", ()=>$fb77ed67ab7c7c60$export$7c42f44d9574ee82);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $gN11a;
    var $jcw0u;
    var $4R6GH;
    var $8zOmE;
    var $lwMsT;
    var $8qFWq;
    var $0557y;
    const $fb77ed67ab7c7c60$export$ac7a76dbf4149182 = (formId)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [fetch, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("8qFWq")).JIRA_BUSINESS_FORM_BY_ID));
        (0, $5uXOq.useEffect)(()=>{
            if (formId != null) {
                (0, (0, parcelRequire("gN11a")).markViewMetric)('form', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
                const QUERY_NAME = 'JiraBusinessFormById';
                fetch({
                    variables: {
                        formId: formId,
                        isConditionalFieldsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_forms_conditional_field_logic_gate_')
                    },
                    onError: (apolloError)=>{
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: QUERY_NAME,
                                packageName: 'jiraBusinessForm',
                                teamName: 'jira-werewolves'
                            },
                            error: apolloError,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        (0, (0, parcelRequire("gN11a")).markViewMetric)('form', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                    },
                    onCompleted: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
                        (0, (0, parcelRequire("gN11a")).markViewMetric)('form', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
                    }
                });
            }
        }, [
            createAnalyticsEvent,
            fetch,
            formId
        ]);
        const form = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("0557y")).transformJiraBusinessForm)({
                data: data
            }), [
            data
        ]);
        return {
            form: form,
            loading: loading,
            error: error
        };
    };
    const $fb77ed67ab7c7c60$export$7c42f44d9574ee82 = (formId)=>{
        const QUERY_NAME = 'JiraBusinessFormWithFieldDataByFormId';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
        }, []);
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("5tTFS")).useQuery)((0, (0, parcelRequire("8qFWq")).JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID), {
            fetchPolicy: 'no-cache',
            variables: {
                formId: formId,
                isConditionalFieldsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_forms_conditional_field_logic_gate_')
            },
            onError: (apolloError)=>{
                const analyticsError = apolloError;
                const skipSentry = (0, (0, parcelRequire("0557y")).isFormNotFoundError)(analyticsError);
                if (skipSentry) analyticsError.skipSentry = true;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: QUERY_NAME,
                        packageName: 'jiraBusinessForm',
                        teamName: 'jira-werewolves'
                    },
                    error: analyticsError,
                    sendToPrivacyUnsafeSplunk: true
                });
                (0, (0, parcelRequire("gN11a")).markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            },
            onCompleted: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${QUERY_NAME} succeeded`);
                (0, (0, parcelRequire("gN11a")).markViewMetric)('form-submit', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            }
        });
        return {
            data: (0, (0, parcelRequire("0557y")).transformFormDataWithFieldData)({
                data: data
            }),
            loading: loading,
            error: error
        };
    };
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("8qFWq", function(module, exports) {
    $parcel$export(module.exports, "JIRA_BUSINESS_FORM_BY_ID", ()=>$a583d3b87ccf6299$export$46b3396662c77cec);
    $parcel$export(module.exports, "JIRA_BUSINESS_FORM_WITH_FIELD_DATA_BY_FORM_ID", ()=>$a583d3b87ccf6299$export$30c35ae67d1502b);
    var $5cllN;
    var $cRgoL;
    const $a583d3b87ccf6299$export$46b3396662c77cec = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessFormById($formId: ID!, $isConditionalFieldsEnabled: Boolean!) {
    jiraBusinessForm(formId: $formId) {
      ...FormBuilderConfigurationFragment
    }
  }

  ${(0, (0, parcelRequire("cRgoL")).FORM_BUILDER_CONFIGURATION_FRAGMENT)}
`;
    const $a583d3b87ccf6299$export$30c35ae67d1502b = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessFormWithFieldDataByFormId(
		$formId: ID!,
		$isConditionalFieldsEnabled: Boolean!
	) {
    jiraBusinessForm(formId: $formId) {
      formId
      projectId
      issueType {
        name
        issueTypeId
      }
      title
      description
      bannerColor
      enabled
      accessLevel
      fields {
        fieldId
        alias
        description
        isRequired
				parentCondition @include(if: $isConditionalFieldsEnabled) {
					...FieldParentConditionFragment
				}
        field {
          name
          type
          ... on GenericIssueField {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraIssueFieldConfiguration {
            fieldConfig {
              isRequired
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
            }
          }
        }
      }
    }
  }

	${(0, (0, parcelRequire("cRgoL")).FIELD_PARENT_CONDITION_FRAGMENT)}
`;
});
parcelRegister("cRgoL", function(module, exports) {
    $parcel$export(module.exports, "FORM_BUILDER_CONFIGURATION_FRAGMENT", ()=>$e4d2e67206dcc3bb$export$41f21ae1bbcf5d4c);
    $parcel$export(module.exports, "FORM_CONFIGURATION_FOR_DIRECTORY", ()=>$e4d2e67206dcc3bb$export$e89d36bee87f0323);
    $parcel$export(module.exports, "MUTATION_ERROR_FRAGMENT", ()=>$e4d2e67206dcc3bb$export$25fa4c03959b6e86);
    $parcel$export(module.exports, "FIELD_PARENT_CONDITION_FRAGMENT", ()=>$e4d2e67206dcc3bb$export$4e44bfa60653a6f1);
    var $5cllN;
    const $e4d2e67206dcc3bb$export$41f21ae1bbcf5d4c = (0, (0, parcelRequire("5cllN")).default)`
 fragment FormBuilderConfigurationFragment on JiraBusinessFormConfiguration {
    id
    formId
    projectId
    title
    description
    bannerColor
    enabled
    isSubmittableByAllLoggedInUsers
    accessLevel
    fields {
      id
      fieldId
      alias
      description
      isRequired
      field @include(if: $isConditionalFieldsEnabled) {
        __typename
        id
		... on JiraSingleSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraMultipleSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraRadioSelectField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraCheckboxesField {
			fieldOptions {
				edges {
					node {
						id
						optionId
						value
					}
				}
			}
		}
		... on JiraPriorityField {
			priorities {
				edges {
					node {
						id
						priorityId
						name
					}
				}
			}
		}
      }
    }
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
 }
`;
    const $e4d2e67206dcc3bb$export$e89d36bee87f0323 = (0, (0, parcelRequire("5cllN")).default)`
  fragment FormConfigurationFragmentForDirectory on JiraBusinessFormConfiguration {
    id
    formId
    title
    description
    bannerColor
    enabled
    updated
    accessLevel
    issueType {
      issueTypeId
      name
      avatarId
      avatar {
        medium
      }
    }
    updateAuthor {
      name
      accountId
    }
    errors
  }
`;
    const $e4d2e67206dcc3bb$export$25fa4c03959b6e86 = (0, (0, parcelRequire("5cllN")).default)`
  fragment MutationErrorFragment on MutationError {
    message
    extensions {
      statusCode
      errorType
    }
  }
`;
    const $e4d2e67206dcc3bb$export$4e44bfa60653a6f1 = (0, (0, parcelRequire("5cllN")).default)`
	fragment FieldParentConditionFragment on JiraFormFieldCondition {
		__typename
		id
		... on JiraFormSelectCondition {
			fieldOptionIds
			operator
		}
		parentField {
			id
			fieldId
			field {
				__typename
				id
			}
		}
	}
`;
});
parcelRegister("0557y", function(module, exports) {
    $parcel$export(module.exports, "transformJiraBusinessForm", ()=>$b6818a16bbb72cb8$export$c07aa36a491f7398);
    $parcel$export(module.exports, "transformFormDataWithFieldData", ()=>$b6818a16bbb72cb8$export$9488a647bac5a6d6);
    $parcel$export(module.exports, "isFormNotFoundError", ()=>$b6818a16bbb72cb8$export$1227e121b71c2a43);
    var $4R6GH;
    var $7wwVP;
    var $f7GQf;
    const $b6818a16bbb72cb8$export$4dee7f5ded2c202d = (field)=>(0, (0, parcelRequire("f7GQf")).IGNORE_FIELD_IDS).includes(field.fieldId) === false;
    const $b6818a16bbb72cb8$export$47e6f860e5c51292 = (field)=>(0, (0, parcelRequire("f7GQf")).IGNORE_FIELD_IDS).includes(field.fieldId) === false;
    const $b6818a16bbb72cb8$export$c07aa36a491f7398 = ({ data: data })=>{
        if (!data || !data.jiraBusinessForm) return undefined;
        const { jiraBusinessForm: jiraBusinessForm } = data;
        const form = {
            id: jiraBusinessForm.id,
            formId: jiraBusinessForm.formId,
            projectId: jiraBusinessForm.projectId,
            title: jiraBusinessForm.title,
            description: jiraBusinessForm.description ?? undefined,
            bannerColor: jiraBusinessForm.bannerColor ?? undefined,
            enabled: jiraBusinessForm.enabled,
            isSubmittableByAllLoggedInUsers: jiraBusinessForm.isSubmittableByAllLoggedInUsers,
            issueType: jiraBusinessForm.issueType ? {
                id: jiraBusinessForm.issueType.issueTypeId ?? '',
                name: jiraBusinessForm.issueType.name ?? '',
                avatarId: jiraBusinessForm.issueType.avatarId ?? null,
                avatarUrl: jiraBusinessForm.issueType.avatar?.medium ?? null,
                isDefault: false,
                subtask: jiraBusinessForm.issueType.type === 'SUB_TASK',
                hierarchyLevel: jiraBusinessForm.issueType.hierarchy?.level ?? 0
            } : null,
            fields: jiraBusinessForm.fields?.filter(Boolean).map((f)=>({
                    id: f.id,
                    fieldId: f.fieldId,
                    alias: f.alias ?? undefined,
                    isRequiredByForm: !!f.isRequired,
                    description: f.description ?? undefined,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jira_forms_conditional_field_logic_gate_') && {
                        field: f.field
                    }
                })).filter($b6818a16bbb72cb8$export$4dee7f5ded2c202d) ?? null,
            accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, (0, parcelRequire("7wwVP")).FormAccessLevelTypes).LIMITED
        };
        return form;
    };
    const $b6818a16bbb72cb8$export$9488a647bac5a6d6 = ({ data: data })=>{
        if (!data || !data.jiraBusinessForm) return undefined;
        const { jiraBusinessForm: jiraBusinessForm } = data;
        return {
            formId: jiraBusinessForm.formId,
            projectId: jiraBusinessForm.projectId,
            issueType: jiraBusinessForm.issueType ? {
                name: jiraBusinessForm.issueType.name || '',
                id: jiraBusinessForm.issueType.issueTypeId ?? ''
            } : null,
            title: jiraBusinessForm.title,
            description: jiraBusinessForm.description ?? undefined,
            bannerColor: jiraBusinessForm.bannerColor ?? undefined,
            enabled: jiraBusinessForm.enabled,
            fields: jiraBusinessForm.fields?.filter(Boolean).filter((f)=>'fieldConfig' in f.field).map((f)=>{
                const fieldIsRequiredByIssueConfig = Boolean(f.field.fieldConfig.isRequired);
                const fieldIsRequiredByFormConfig = !!f.isRequired;
                return {
                    fieldId: f.fieldId,
                    alias: f.alias,
                    name: f.field.name,
                    isRequired: fieldIsRequiredByIssueConfig,
                    isRequiredByForm: fieldIsRequiredByFormConfig,
                    description: f.description ?? undefined,
                    type: f.field.type,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jira_forms_conditional_field_logic_gate_') && {
                        parentCondition: f.parentCondition
                    }
                };
            }).filter($b6818a16bbb72cb8$export$47e6f860e5c51292) ?? [],
            accessLevel: jiraBusinessForm.accessLevel ? jiraBusinessForm.accessLevel : (0, (0, parcelRequire("7wwVP")).FormAccessLevelTypes).LIMITED
        };
    };
    const $b6818a16bbb72cb8$export$1227e121b71c2a43 = (error)=>error.graphQLErrors?.[0]?.extensions?.errorType === (0, (0, parcelRequire("f7GQf")).FORM_NOT_FOUND_ERROR);
});
parcelRegister("f7GQf", function(module, exports) {
    $parcel$export(module.exports, "IGNORE_FIELD_IDS", ()=>$5c143e6311b821dd$export$18705e0cb6bd7398);
    $parcel$export(module.exports, "FORM_NOT_FOUND_ERROR", ()=>$5c143e6311b821dd$export$a5614f895fe1c5d2);
    var $5fc53;
    const $5c143e6311b821dd$export$18705e0cb6bd7398 = [
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)
    ];
    const $5c143e6311b821dd$export$a5614f895fe1c5d2 = 'FORM_NOT_FOUND';
});
parcelRegister("kyf8b", function(module, exports) {
    $parcel$export(module.exports, "useFormSubmissionStore", ()=>$885876e47cc26c5a$export$bd364acc55858de);
    var $3sQ5x;
    var $iXqE5;
    const $885876e47cc26c5a$var$actions = {
        updateStore: (newData)=>({ setState: setState })=>{
                setState(newData);
            }
    };
    const $885876e47cc26c5a$var$FormSubmissionStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            data: undefined,
            loading: false,
            error: undefined
        },
        actions: $885876e47cc26c5a$var$actions,
        name: 'JWMFormSubmission'
    });
    const $885876e47cc26c5a$export$bd364acc55858de = (0, (0, parcelRequire("3sQ5x")).createHook)($885876e47cc26c5a$var$FormSubmissionStore);
});
parcelRegister("8feUl", function(module, exports) {
    $parcel$export(module.exports, "getFormValidationData", ()=>$c8efa796b9edd3e8$export$1b92201c43ea8a87);
    var $fOgCm;
    const $c8efa796b9edd3e8$export$1b92201c43ea8a87 = ({ formData: formData, fieldMetaData: fieldMetaData, projectType: projectType })=>{
        if (!formData || !fieldMetaData) return null;
        const formRequiredFields = formData.fields.filter((f)=>f.isRequired && !!fieldMetaData[f.fieldId]);
        const requiredFieldIds = Object.keys(fieldMetaData).filter((fieldId)=>fieldMetaData[fieldId].required);
        const formContainsAllRequiredFields = formRequiredFields.length === requiredFieldIds.length;
        const isAllRequiredFieldsSupported = requiredFieldIds.every((f)=>{
            const fieldType = fieldMetaData[f].schema?.custom || fieldMetaData[f].schema?.system;
            if (!fieldType) return false;
            return (0, (0, parcelRequire("fOgCm")).isFieldTypeSupported)(fieldType, projectType);
        });
        const fieldsRequiredByForm = formData.fields.filter((f)=>f.isRequiredByForm && !!fieldMetaData[f.fieldId]);
        const hasProjectScopedRequiredFields = fieldsRequiredByForm.some(({ type: fieldType })=>{
            if (!fieldType) return false;
            return (0, (0, parcelRequire("fOgCm")).isProjectScopedFieldType)(fieldType);
        });
        return {
            isFormSubmissionValid: formContainsAllRequiredFields && isAllRequiredFieldsSupported,
            hasMissingSupportedRequiredFields: !formContainsAllRequiredFields && isAllRequiredFieldsSupported,
            hasUnsupportedRequiredFields: !isAllRequiredFieldsSupported,
            hasProjectScopedRequiredFields: hasProjectScopedRequiredFields
        };
    };
});
parcelRegister("fOgCm", function(module, exports) {
    $parcel$export(module.exports, "isFieldTypeSupported", ()=>$cef62a43f25c3fdf$export$b47920a5dd99844f);
    $parcel$export(module.exports, "getFieldTypeConfig", ()=>$cef62a43f25c3fdf$export$5be962d414ad6e6c);
    $parcel$export(module.exports, "FORM_LABEL", ()=>$cef62a43f25c3fdf$export$364c27f38e7541f8);
    $parcel$export(module.exports, "getFormLabelPrefix", ()=>$cef62a43f25c3fdf$export$1cad3815d15ba80d);
    $parcel$export(module.exports, "getUniqueFormLabel", ()=>$cef62a43f25c3fdf$export$b0616c054785bb44);
    $parcel$export(module.exports, "isProjectScopedFieldType", ()=>$cef62a43f25c3fdf$export$b6ad606b1df91ef5);
    $parcel$export(module.exports, "isFieldImproperForForm", ()=>$cef62a43f25c3fdf$export$567d10980a8f2859);
    var $2vSU6;
    var $5fc53;
    var $btedi;
    var $22Wo8;
    var $1Zt9x;
    var $1C9NJ;
    var $97VNg;
    var $aR835;
    var $9Hxrl;
    var $bunMY;
    var $bxMnv;
    var $iNY3w;
    var $jbGY4;
    var $awO6U;
    var $3ZQGw;
    var $kTnsH;
    var $g8kqC;
    var $iHSUu;
    var $3owst;
    var $dzSVK;
    var $2prZd;
    var $eRVlU;
    var $cK31e;
    var $9HQd3;
    var $7lpSO;
    var $chk7J;
    var $j85Ze;
    var $9TyvL;
    var $j2R7K;
    var $kfv7e;
    var $9uVge;
    var $4I0dG;
    var $eFzGt;
    var $5VWF9;
    var $1avQ5;
    const $cef62a43f25c3fdf$var$PROJECT_SCOPED_FIELD_TYPE_CONFIGS = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: (0, (0, parcelRequire("2prZd")).ParentFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: (0, (0, parcelRequire("chk7J")).SprintFieldTypeConfig)
    };
    const $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS = {
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: (0, (0, parcelRequire("1avQ5")).MultiVersionsFieldTypeConfig)((0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)),
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: (0, (0, parcelRequire("22Wo8")).AssigneeFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: (0, (0, parcelRequire("1Zt9x")).AttachmentFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: (0, (0, parcelRequire("1C9NJ")).CascadingSelectFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: (0, (0, parcelRequire("97VNg")).CategoryFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: (0, (0, parcelRequire("aR835")).ComponentsFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: (0, (0, parcelRequire("bunMY")).DateTimeCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: (0, (0, parcelRequire("9Hxrl")).DateCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: (0, (0, parcelRequire("bxMnv")).DescriptionFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: (0, (0, parcelRequire("iNY3w")).DueDateFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: (0, (0, parcelRequire("1avQ5")).MultiVersionsFieldTypeConfig)((0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)),
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: (0, (0, parcelRequire("jbGY4")).GroupCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: (0, (0, parcelRequire("awO6U")).LabelsCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: (0, (0, parcelRequire("3ZQGw")).LabelsFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: (0, (0, parcelRequire("kTnsH")).MultiCheckboxesCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: (0, (0, parcelRequire("g8kqC")).MultiGroupCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: (0, (0, parcelRequire("iHSUu")).MultiSelectCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: (0, (0, parcelRequire("3owst")).MultiUserCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: (0, (0, parcelRequire("1avQ5")).MultiVersionsFieldTypeConfig)((0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)),
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: (0, (0, parcelRequire("dzSVK")).NumberCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: (0, (0, parcelRequire("2prZd")).ParentFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: (0, (0, parcelRequire("eRVlU")).PeopleCustomFieldType),
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: (0, (0, parcelRequire("cK31e")).PriorityFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: (0, (0, parcelRequire("9HQd3")).RadioButtonsCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: (0, (0, parcelRequire("7lpSO")).SelectCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE)]: (0, (0, parcelRequire("btedi")).AffectedServicesCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: (0, (0, parcelRequire("j85Ze")).StoryPointEstimateCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: (0, (0, parcelRequire("9TyvL")).SummaryFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: (0, (0, parcelRequire("kfv7e")).TeamsPlatformCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)]: (0, (0, parcelRequire("j2R7K")).TeamCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: (0, (0, parcelRequire("9uVge")).TextAreaCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: (0, (0, parcelRequire("4I0dG")).TextCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: (0, (0, parcelRequire("eFzGt")).UrlCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: (0, (0, parcelRequire("5VWF9")).UserCustomFieldTypeConfig),
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: (0, (0, parcelRequire("1avQ5")).VersionFieldTypeConfig)
    };
    const $cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS = {
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: (0, (0, parcelRequire("chk7J")).SprintFieldTypeConfig)
    };
    const $cef62a43f25c3fdf$var$FIELD_TYPE_CONFIGS = {
        ...$cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS,
        ...$cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS
    };
    function $cef62a43f25c3fdf$export$b47920a5dd99844f(type, projectType) {
        if (projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)) return type in $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS || type in $cef62a43f25c3fdf$var$SOFTWARE_FIELD_TYPE_CONFIGS;
        return type in $cef62a43f25c3fdf$var$BASE_FIELD_TYPE_CONFIGS;
    }
    function $cef62a43f25c3fdf$export$5be962d414ad6e6c(fieldType, projectType) {
        return $cef62a43f25c3fdf$export$b47920a5dd99844f(fieldType, projectType) ? $cef62a43f25c3fdf$var$FIELD_TYPE_CONFIGS[fieldType] : undefined;
    }
    const $cef62a43f25c3fdf$export$364c27f38e7541f8 = 'business-form';
    const $cef62a43f25c3fdf$export$1cad3815d15ba80d = (projectType)=>{
        if (projectType != null && projectType === 'business') return 'business-form';
        return 'form';
    };
    const $cef62a43f25c3fdf$export$b0616c054785bb44 = (formLabelPrefix, formId)=>`${formLabelPrefix}-${formId}`;
    const $cef62a43f25c3fdf$export$b6ad606b1df91ef5 = (type)=>type in $cef62a43f25c3fdf$var$PROJECT_SCOPED_FIELD_TYPE_CONFIGS;
    const $cef62a43f25c3fdf$var$improperFieldIdsForForm = new Set([
        'created',
        'issuelinks',
        'issuetype',
        'project',
        'resolution',
        'security',
        'subtasks',
        'timeoriginalestimate',
        'updated',
        'updated',
        'votes',
        'watches'
    ]);
    const $cef62a43f25c3fdf$var$improperFieldTypesForForm = new Set([
        (0, (0, parcelRequire("5fc53")).EPIC_TYPE),
        (0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE),
        (0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE)
    ]);
    const $cef62a43f25c3fdf$export$567d10980a8f2859 = ({ fieldId: fieldId, fieldName: fieldName, fieldType: fieldType })=>{
        if ($cef62a43f25c3fdf$var$improperFieldIdsForForm.has(fieldId) || $cef62a43f25c3fdf$var$improperFieldTypesForForm.has(fieldType)) return true;
        if (fieldName === 'Flagged' && fieldType === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) return true;
        return false;
    };
});
parcelRegister("btedi", function(module, exports) {
    $parcel$export(module.exports, "AffectedServicesCustomFieldTypeConfig", ()=>$b16b96f20af09d65$export$b379a34008ba5f5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $beKPf;
    var $5fc53;
    var $9gHYS;
    var $2Kya6;
    var $kShoa;
    const $b16b96f20af09d65$var$AffectedServicesCustomFieldComponent = (props)=>{
        const autoCompleteUrl = props.autoCompleteUrl?.split('?')[0];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Kya6")).default), {
            ...props,
            autoCompleteUrl: autoCompleteUrl
        });
    };
    const $b16b96f20af09d65$export$b379a34008ba5f5a = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("beKPf"))))),
        type: (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE),
        Component: $b16b96f20af09d65$var$AffectedServicesCustomFieldComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).multiSelectFieldWriter)
    };
});
parcelRegister("beKPf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $82e5531e93c95313$var$_react = $82e5531e93c95313$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $82e5531e93c95313$var$_UNSAFE_baseNew = $82e5531e93c95313$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $82e5531e93c95313$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $82e5531e93c95313$var$ComponentIcon = (props)=>$82e5531e93c95313$var$_react.default.createElement($82e5531e93c95313$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.75 5.25H2c-.69 0-1.25.56-1.25 1.25V12c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V6.5c0-.69-.56-1.25-1.25-1.25h-.75m-10.5 0v-2.5h3.5v2.5m-3.5 0h3.5m0 0h3.5m0 0v-2.5h3.5v2.5m-3.5 0h3.5"/>`
        }, props));
    $82e5531e93c95313$var$ComponentIcon.displayName = 'ComponentIcon';
    var $82e5531e93c95313$var$_default = module.exports.default = $82e5531e93c95313$var$ComponentIcon;
});
parcelRegister("9gHYS", function(module, exports) {
    $parcel$export(module.exports, "TextFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$6fa85fe91d7baf70);
    $parcel$export(module.exports, "DescriptionFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$b2a65447738df397);
    $parcel$export(module.exports, "AttachmentFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$b3e78b2794b60a3c);
    $parcel$export(module.exports, "AssigneeFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$628ddd885c3ef19a);
    $parcel$export(module.exports, "DropdownFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$6767d78d6b24ff93);
    $parcel$export(module.exports, "DateFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$94d5efb8e5cd7e54);
    $parcel$export(module.exports, "DateTimeFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$8ba7f20c1eb81d37);
    $parcel$export(module.exports, "NotSupportedFieldPlaceholder", ()=>$91f0bd5d2e8ed9a6$export$4b127f667f36c30b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    var $bLDEj;
    var $cSXhT;
    var $6UxUy;
    var $30Rxs;
    var $bZ5LF;
    var $3srSR;
    var $fm763;
    var $ZuPvl;
    var $99gde;
    var $ousew;
    var $koVbs;
    var $25C5e;
    const $91f0bd5d2e8ed9a6$export$6fa85fe91d7baf70 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$TextFieldWrapper, null, formatMessage((0, (0, parcelRequire("25C5e")).default).fieldPlaceholder));
    };
    const $91f0bd5d2e8ed9a6$export$b2a65447738df397 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$DescriptionWrapper, null, formatMessage((0, (0, parcelRequire("25C5e")).default).fieldPlaceholder));
    };
    const $91f0bd5d2e8ed9a6$export$b3e78b2794b60a3c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$AttachmentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("30Rxs"))))), {
            label: "upload"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("25C5e")).default).attachmentFieldPlaceholder))));
    };
    const $91f0bd5d2e8ed9a6$export$628ddd885c3ef19a = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$TextFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bZ5LF"))))), {
            label: "avatar"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("25C5e")).default).assigneeFieldPlaceholder)))));
    };
    const $91f0bd5d2e8ed9a6$export$6767d78d6b24ff93 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("25C5e")).default).dropdownFieldPlaceholder))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cSXhT"))))), {
            label: "openDropdown"
        }));
    };
    const $91f0bd5d2e8ed9a6$export$94d5efb8e5cd7e54 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $91f0bd5d2e8ed9a6$var$fieldHeight,
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("25C5e")).default).dateFieldPlaceholder))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bLDEj"))))), {
            label: "calendar"
        }));
    };
    const $91f0bd5d2e8ed9a6$export$8ba7f20c1eb81d37 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$SplitHalfFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            alignBlock: "center",
            xcss: $91f0bd5d2e8ed9a6$var$fieldHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("25C5e")).default).dateFieldPlaceholder))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            alignBlock: "center",
            xcss: $91f0bd5d2e8ed9a6$var$fieldHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, formatMessage((0, (0, parcelRequire("25C5e")).default).timeFieldPlaceholder))));
    };
    const $91f0bd5d2e8ed9a6$export$4b127f667f36c30b = ({ isRequired: isRequired, onRemoveFieldClick: onRemoveFieldClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$NotSupportedFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6UxUy"))))), {
            label: "error"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtlest"
        }, isRequired ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("25C5e")).default).notSupportedRequiredFieldPlaceholder,
            values: {
                contactAdmin: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: "/secure/ContactAdministrators!default.jspa"
                }, formatMessage((0, (0, parcelRequire("25C5e")).default).contactAdmin))
            }
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("25C5e")).default).notSupportedOptionalFieldPlaceholder,
            values: {
                clickHere: (0, ($parcel$interopDefault($5uXOq))).createElement($91f0bd5d2e8ed9a6$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                    appearance: "link",
                    onClick: onRemoveFieldClick
                }, formatMessage((0, (0, parcelRequire("25C5e")).default).clickHere)))
            }
        }))));
    };
    const $91f0bd5d2e8ed9a6$var$fieldHeight = (0, (0, parcelRequire("99gde")).xcss)({
        height: '2.25rem'
    });
    const $91f0bd5d2e8ed9a6$var$FieldBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1y44 _11q76rqw _1yt4h8dc _189et94y _1dqonqa1 _1h6dkidp _syaz15i6 _vwz414no",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$IconBeforeBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _10nju2gc",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _10nju2gc",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$TextFieldWrapper = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i14no",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$DescriptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i8vuz",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$AttachmentWrapper = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBaseWithIconBefore, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i14no _11q7glyw _1dqogq9o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$WithIconAfterFieldWrapper = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1oc61wug",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$SplitHalfFieldWrapper = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$FieldBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _12apkb7n",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$NotSupportedFieldWrapper = (0, $5uXOq.forwardRef)(({ as: C = $91f0bd5d2e8ed9a6$var$IconBeforeBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15i6 _1bsb1osq _vwz4gktf _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $91f0bd5d2e8ed9a6$var$ButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_i1wwidpf _8ax3idpf _ake1idpf _1gqwidpf _1rra1kw7 _t74oqslr",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bLDEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8912d6fb9cca436d$var$_react = $8912d6fb9cca436d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $8912d6fb9cca436d$var$_calendar = $8912d6fb9cca436d$var$_interopRequireDefault((parcelRequire("lL8mO")));
    function $8912d6fb9cca436d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8912d6fb9cca436d$var$CalendarIcon = (props)=>$8912d6fb9cca436d$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $8912d6fb9cca436d$var$_calendar.default
        }));
    $8912d6fb9cca436d$var$CalendarIcon.displayName = 'CalendarIcon';
    var $8912d6fb9cca436d$var$_default = module.exports.default = $8912d6fb9cca436d$var$CalendarIcon;
});
parcelRegister("lL8mO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd747a425ea05ec4$var$_react = $fd747a425ea05ec4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fd747a425ea05ec4$var$_UNSAFE_baseNew = $fd747a425ea05ec4$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fd747a425ea05ec4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd747a425ea05ec4$var$CalendarIcon = (props)=>$fd747a425ea05ec4$var$_react.default.createElement($fd747a425ea05ec4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $fd747a425ea05ec4$var$CalendarIcon.displayName = 'CalendarIcon';
    var $fd747a425ea05ec4$var$_default = module.exports.default = $fd747a425ea05ec4$var$CalendarIcon;
});
parcelRegister("30Rxs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $231ae6d2c30e830c$var$_react = $231ae6d2c30e830c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $231ae6d2c30e830c$var$_cloudArrowUp = $231ae6d2c30e830c$var$_interopRequireDefault((parcelRequire("kNwf0")));
    function $231ae6d2c30e830c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $231ae6d2c30e830c$var$UploadIcon = (props)=>$231ae6d2c30e830c$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
        }, props, {
            newIcon: $231ae6d2c30e830c$var$_cloudArrowUp.default
        }));
    $231ae6d2c30e830c$var$UploadIcon.displayName = 'UploadIcon';
    var $231ae6d2c30e830c$var$_default = module.exports.default = $231ae6d2c30e830c$var$UploadIcon;
});
parcelRegister("kNwf0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f24164a0675939cb$var$_react = $f24164a0675939cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f24164a0675939cb$var$_UNSAFE_baseNew = $f24164a0675939cb$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $f24164a0675939cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f24164a0675939cb$var$CloudArrowUpIcon = (props)=>$f24164a0675939cb$var$_react.default.createElement($f24164a0675939cb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m4.429 3.18.217.718.358-.108.129-.35zm6.25.81-.723.2.151.55h.572zM8 8.75l.53-.53a.75.75 0 0 0-1.06 0zm2.405-5.754.723-.2zM2.5 6.5v-.482H1V6.5zm1.408-2.378.738-.224-.434-1.435-.738.223zm1.225-.683.157-.427-1.408-.517-.157.427zm4.549-.244.274.995 1.446-.398-.274-.995zm.997 1.546h1.191v-1.5h-1.19zM13.5 6.37v.13H15v-.13zm-7.97 5.91 3-3-1.06-1.06-3 3zm1.94-3 3 3 1.06-1.061-3-3zm-.22-.031V16h1.5V9.25zM13.5 6.5A1.5 1.5 0 0 1 12 8v1.5a3 3 0 0 0 3-3zm-6.044-5a2.31 2.31 0 0 1 2.226 1.695l1.446-.398A3.81 3.81 0 0 0 7.456 0zM5.29 3.012A2.31 2.31 0 0 1 7.456 1.5V0a3.81 3.81 0 0 0-3.574 2.495zm6.58 1.729c.9 0 1.63.73 1.63 1.63H15a3.13 3.13 0 0 0-3.13-3.13zM2.5 6.018a1.98 1.98 0 0 1 1.408-1.896l-.434-1.436A3.48 3.48 0 0 0 1 6.018zM4 8a1.5 1.5 0 0 1-1.5-1.5H1a3 3 0 0 0 3 3z"/>`
        }, props));
    $f24164a0675939cb$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
    var $f24164a0675939cb$var$_default = module.exports.default = $f24164a0675939cb$var$CloudArrowUpIcon;
});
parcelRegister("25C5e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714c727dd5fe3e71$export$2e2bcd8739ae039);
    var $7VHMR;
    var $714c727dd5fe3e71$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fieldPlaceholder: {
            "id": "business-form.common.field-placeholders.field-placeholder",
            "defaultMessage": "Answer will be written here"
        },
        attachmentFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.attachment-field-placeholder",
            "defaultMessage": "Attachments will be uploaded here"
        },
        assigneeFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.assignee-field-placeholder",
            "defaultMessage": "Unassigned"
        },
        dropdownFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.dropdown-field-placeholder",
            "defaultMessage": "Answer will be selected from dropdown"
        },
        dateFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.date-field-placeholder",
            "defaultMessage": "Date will be entered here"
        },
        timeFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.time-field-placeholder",
            "defaultMessage": "Time will be entered here"
        },
        notSupportedRequiredFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.not-supported-required-field-placeholder",
            "defaultMessage": "This required field is unsupported, {contactAdmin} to make this field optional"
        },
        contactAdmin: {
            "id": "business-form.common.field-placeholders.contact-admin",
            "defaultMessage": "contact admin"
        },
        notSupportedOptionalFieldPlaceholder: {
            "id": "business-form.common.field-placeholders.not-supported-optional-field-placeholder",
            "defaultMessage": "This field is unsupported, {clickHere} to remove this field. "
        },
        clickHere: {
            "id": "business-form.common.field-placeholders.click-here",
            "defaultMessage": "click here"
        }
    });
});
parcelRegister("2Kya6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55a4d6a889fba550$export$2e2bcd8739ae039);
    var $hpV4g;
    var $ii6hB;
    var $aZJYe;
    var $6iZh4;
    const $55a4d6a889fba550$var$AffectedServicesField = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aZJYe")).transformDefaultAffectedServices),
        validator: (0, (0, parcelRequire("6iZh4")).validateRequired)
    })((0, (0, parcelRequire("ii6hB")).AffectedServicesField));
    var $55a4d6a889fba550$export$2e2bcd8739ae039 = $55a4d6a889fba550$var$AffectedServicesField;
});
parcelRegister("hpV4g", function(module, exports) {
    $parcel$export(module.exports, "withFormField", ()=>$b3f935405140180d$export$17bf6386ac4a43ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $knKRw;
    var $6Ll2T;
    var $99gde;
    var $39xOx;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $5pZ9g;
    var $7Emtg;
    var $6cMZg;
    var $gifeQ;
    var $bPtOr;
    var $fl3Yy;
    var $1MgIu;
    var $3IJWP;
    var $59xJP;
    var $mTNgq;
    var $5eGnF;
    var $9svjh;
    var $2eeg1;
    var $dCm1o;
    var $aBZin;
    var $45JN1;
    var $iblgc;
    var $86fzT;
    const $b3f935405140180d$export$17bf6386ac4a43ba = (options)=>(Component)=>(ownProps)=>{
                const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
                const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
                const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
                const description = (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) ? (0, (0, parcelRequire("1MgIu")).extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
                const hasSentTransformDefaultValueError = (0, $5uXOq.useRef)(false);
                let transformedDefaultValue;
                try {
                    if (defaultValueDontTransform) transformedDefaultValue = defaultValue;
                    else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
                } catch (error) {
                    if (hasSentTransformDefaultValueError.current === false) {
                        hasSentTransformDefaultValueError.current = true;
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'defaultValueTransformation',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            attributes: {
                                fieldType: fieldType
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                }
                (0, $5uXOq.useLayoutEffect)(()=>{
                    onLayoutDone && onLayoutDone();
                }, [
                    onLayoutDone
                ]);
                const shouldSetWidth = (0, (0, parcelRequire("co1wz")).ff)('gic-smart-fields-jira-labs_8uwvr') || (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
                const renderComponent = (fieldProps, error)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                        ...ownPropsRest,
                        fieldId: fieldId,
                        fieldName: fieldName,
                        isRequired: isRequired,
                        fieldProps: fieldProps,
                        width: shouldSetWidth ? '100%' : undefined,
                        isMini: isMini,
                        description: description,
                        defaultValue: defaultValue,
                        error: error,
                        key: componentKey,
                        ariaLabelledBy: `${fieldId}-field-label`
                    });
                const renderFieldMessage = (0, $5uXOq.useCallback)((error)=>{
                    if (shouldRenderFieldMessage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
                        fieldId: fieldId,
                        description: description,
                        error: error,
                        fieldName: fieldName,
                        fieldHelpTextUrl: fieldHelpTextUrl,
                        onLinkClickEvent: onLinkClickEvent,
                        isMini: isMini
                    });
                    return null;
                }, [
                    description,
                    fieldHelpTextUrl,
                    fieldId,
                    fieldName,
                    isMini,
                    onLinkClickEvent,
                    shouldRenderFieldMessage
                ]);
                const extension = (0, $5uXOq.useMemo)(()=>{
                    if (typeof fieldType === 'string' && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, (0, parcelRequire("6cMZg")).getExtension)(fieldType, forge?.modules);
                    return null;
                }, [
                    fieldType,
                    forge?.modules,
                    forge?.hasFinishedLoading
                ]);
                (0, $5uXOq.useEffect)(()=>{
                    const shouldReportFailure = typeof fieldType === 'string' && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                    if (shouldReportFailure) (0, (0, parcelRequire("7Emtg")).reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
                }, [
                    fieldType,
                    extension,
                    forge?.modules,
                    forge?.filteredOutModules,
                    forge?.hasFinishedLoading
                ]);
                const renderFieldContent = (fieldProps, error)=>{
                    if (((0, (0, parcelRequire("co1wz")).ff)('gic-smart-fields-jira-labs_8uwvr') || (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) && isCollapsed) return null;
                    const fieldPropsWithPublish = {
                        ...fieldProps,
                        onChange: (value, ...rest)=>{
                            fieldProps.onChange(value, ...rest);
                            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                                fieldId: fieldId,
                                fieldName: fieldName,
                                fieldType: fieldType,
                                value: (0, (0, parcelRequire("aBZin")).getValueFromEventOrValue)(value)
                            });
                        }
                    };
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5pZ9g")).ForgeField), {
                        fieldId: fieldId,
                        fieldName: fieldName,
                        fieldType: fieldType,
                        fieldProps: fieldPropsWithPublish,
                        error: error,
                        selectedProject: forge?.selectedProject,
                        selectedIssueType: forge?.selectedIssueType,
                        extension: extension,
                        renderFieldMessage: renderFieldMessage,
                        renderDefaultComponent: renderComponent
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                        renderComponent(fieldPropsWithPublish, error),
                        renderFieldMessage(error)
                    ]) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
                };
                const renderFieldLabel = (0, $5uXOq.useCallback)(()=>{
                    if (((0, (0, parcelRequire("co1wz")).ff)('gic-smart-fields-jira-labs_8uwvr') || (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) && isCollapsed) return '';
                    if (shouldHideLabel) return '';
                    if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType)) {
                        const { environment: environment } = (0, (0, parcelRequire("1MgIu")).extractEnvFromFieldDescription)(descriptionRaw);
                        return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                            environmentType: environment
                        }));
                    }
                    return fieldName;
                }, [
                    fieldName,
                    fieldType,
                    shouldHideLabel,
                    descriptionRaw,
                    isCollapsed
                ]);
                if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iblgc")).FieldSkeleton), null);
                if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && !extension) return null;
                const renderField = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
                    id: `${fieldId}-field`,
                    label: renderFieldLabel(),
                    elementAfterLabel: areUiModificationsBusy ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("59xJP")).FieldBusyIndicator), {
                        fieldId: fieldId
                    }) : undefined,
                    isRequired: isRequired,
                    name: fieldId,
                    defaultValue: transformedDefaultValue,
                    key: (0, (0, parcelRequire("86fzT")).generateKeyForRequiredFromUIM)({
                        fieldId: fieldId,
                        isRequiredFromUIM: isRequiredFromUIM === true
                    }),
                    validate: (value, _formState, { dirty: dirty })=>{
                        try {
                            const { type: type } = ownPropsRest;
                            if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && isRequired) return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                            return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        } catch (error) {
                            (0, (0, parcelRequire("jcw0u")).default)({
                                meta: {
                                    id: 'fieldValidationIssue',
                                    packageName: 'jiraIssueCreateCommons',
                                    teamName: 'gryffindor'
                                },
                                error: error,
                                sendToPrivacyUnsafeSplunk: true
                            });
                            return undefined;
                        }
                    }
                }, ({ fieldProps: fieldProps, error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassOutput), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                        id: "issueAdjustmentsFieldValueDecorator",
                        packageName: "jiraIssueCreateModal",
                        fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps, error)),
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: (err)=>({
                                errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(err),
                                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                                fieldId: fieldId,
                                fieldType: fieldType
                            })
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2eeg1")).FieldValueDecoratorAsync), {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        fieldProps: fieldProps
                    }, (interceptedFieldProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error))))));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
                    id: "withFormField",
                    packageName: "jiraIssueCreateModal",
                    fallback: "unmount",
                    sendToPrivacyUnsafeSplunk: true
                }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && fieldId === 'assignee' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                    xcss: $b3f935405140180d$var$fieldStyles
                }, " ", renderField, " ") : renderField);
            };
    const $b3f935405140180d$var$ForgeLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81il0 _1e0c116y _4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $b3f935405140180d$var$fieldStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'relative'
    });
});
parcelRegister("knKRw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$110243b5cd2eb92d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $bkJDg;
    var $1FTEF;
    var $lOr6E;
    var $7VnW8;
    var $8knNZ;
    var $6cAn5 = parcelRequire("6cAn5");
    function $110243b5cd2eb92d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $110243b5cd2eb92d$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $110243b5cd2eb92d$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $110243b5cd2eb92d$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $110243b5cd2eb92d$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $110243b5cd2eb92d$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $110243b5cd2eb92d$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $110243b5cd2eb92d$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $110243b5cd2eb92d$var$usePreviousRef(props);
        const isDefaultValueChanged = !$110243b5cd2eb92d$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $110243b5cd2eb92d$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $110243b5cd2eb92d$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($110243b5cd2eb92d$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $110243b5cd2eb92d$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8knNZ")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("1FTEF", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$b38f467b8b7721b2$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $b38f467b8b7721b2$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("lOr6E", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$75a5255a3d60692c$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$75a5255a3d60692c$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$75a5255a3d60692c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $75a5255a3d60692c$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $75a5255a3d60692c$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $75a5255a3d60692c$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("7VnW8", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$bc5fcc4d894aeca1$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$bc5fcc4d894aeca1$export$ed247974535929c7);
    var $f8Sb3;
    function $bc5fcc4d894aeca1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bc5fcc4d894aeca1$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $bc5fcc4d894aeca1$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $bc5fcc4d894aeca1$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles
        }, children);
    };
    var $bc5fcc4d894aeca1$export$2e2bcd8739ae039 = $bc5fcc4d894aeca1$export$b04be29aa201d4f5;
});
parcelRegister("8knNZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3fe143ced70112a$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d3fe143ced70112a$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d3fe143ced70112a$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d3fe143ced70112a$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("5pZ9g", function(module, exports) {
    $parcel$export(module.exports, "ForgeField", ()=>$297a009f70430225$export$34a15d6027142c62);
    var $5uXOq = parcelRequire("5uXOq");
    var $1rTGO;
    var $2RhPB;
    var $7Aezm;
    var $g5X3G;
    var $gifeQ;
    var $ELVDL;
    var $j5sSv;
    var $7fjFA;
    var $6cMZg;
    const $297a009f70430225$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
        const { onChange: onChange, value: value } = fieldProps;
        const extensionPayload = (0, $5uXOq.useMemo)(()=>{
            if (value === undefined) return {
                fieldValue: null
            };
            return {
                fieldValue: (0, (0, parcelRequire("6cMZg")).transformValueToExtensionData)(value, extension)
            };
        }, [
            extension,
            value
        ]);
        const extensionData = (0, $5uXOq.useMemo)(()=>{
            const defaultExtensionData = {
                fieldId: fieldId,
                fieldType: (0, (0, parcelRequire("gifeQ")).isForgeLegacyFieldType)(fieldType) ? (0, (0, parcelRequire("gifeQ")).getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
                fieldName: fieldName,
                renderContext: 'issue-create'
            };
            if (!selectedProject || !selectedIssueType) return defaultExtensionData;
            const issueTypeId = (0, (0, parcelRequire("g5X3G")).toIssueTypeId)(selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
            return {
                ...defaultExtensionData,
                project: {
                    id: (0, (0, parcelRequire("g5X3G")).toProjectId)(selectedProject.value),
                    key: (0, (0, parcelRequire("g5X3G")).toProjectKey)(selectedProject.projectKey),
                    type: selectedProject.projectType
                },
                issue: {
                    type: selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                    typeId: issueTypeId
                }
            };
        }, [
            selectedProject,
            selectedIssueType,
            fieldId,
            fieldName,
            fieldType
        ]);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                renderContext: 'issue-create',
                fieldType: extension?.properties.type,
                module: extension?.type,
                ...extension ? (0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension) : {}
            }), [
            extension
        ]);
        if (!extension) return null;
        const renderDefaultView = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderDefaultComponent(fieldProps, error), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
                attributes: {
                    ...analyticsAttributes,
                    renderMode: 'default'
                }
            }));
        if (!extension.properties.edit) return renderDefaultView();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ELVDL")).EditMode), {
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            analyticsAttributes: analyticsAttributes,
            onChange: onChange
        });
    };
    const $297a009f70430225$export$34a15d6027142c62 = (props)=>{
        const { renderFieldMessage: renderFieldMessage, ...rest } = props;
        const { fieldId: fieldId, extension: extension, error: error } = rest;
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                renderContext: 'issue-create',
                ...extension && (0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension)
            }), [
            extension
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Aezm")).EditAnalyticsWrapper), {
            attributes: analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j5sSv")).FieldContainer), {
            width: "100%",
            paddingBottom: 6
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($297a009f70430225$export$4f0175d9150f8767, rest), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7fjFA")).ForgeFieldMessage), {
            error: error,
            fieldId: fieldId,
            renderFieldMessage: renderFieldMessage
        })));
    };
});
parcelRegister("7Aezm", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$f6c5a5a43a090916$export$c794eb4124961145);
    $parcel$export(module.exports, "EditAnalyticsWrapper", ()=>$f6c5a5a43a090916$export$947ae3996b2bc000);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    const $f6c5a5a43a090916$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $f6c5a5a43a090916$export$947ae3996b2bc000 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
            ...props
        });
});
parcelRegister("gifeQ", function(module, exports) {
    $parcel$export(module.exports, "isForgeCustomField", ()=>$89f92c26c7f930da$export$78cf1b56a8dede1f);
    $parcel$export(module.exports, "isForgeLegacyFieldType", ()=>$89f92c26c7f930da$export$3fb46a1fa454ffea);
    $parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", ()=>$89f92c26c7f930da$export$2b6a9cc67d548886);
    $parcel$export(module.exports, "focusFormButton", ()=>$89f92c26c7f930da$export$f1a0ef98758e7a8a);
    var $k2DRb;
    const $89f92c26c7f930da$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, (0, parcelRequire("k2DRb")).LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, (0, parcelRequire("k2DRb")).FORGE_FIELD_TYPE_PREFIX)));
    const $89f92c26c7f930da$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, (0, parcelRequire("k2DRb")).LEGACY_FORGE_FIELD_TYPE_PREFIX));
    const $89f92c26c7f930da$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, (0, parcelRequire("k2DRb")).PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
    const $89f92c26c7f930da$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$89f92c26c7f930da$export$78cf1b56a8dede1f(field.fieldType));
    const $89f92c26c7f930da$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
        const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
        if (button != null) button.focus();
    };
});
parcelRegister("ELVDL", function(module, exports) {
    $parcel$export(module.exports, "EditMode", ()=>$ed405e89d26d258c$export$5304145354a3bee9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $2RhPB;
    var $4JpPl;
    var $7Aezm;
    var $9wJ66;
    var $frltc;
    var $koVbs;
    var $6cMZg;
    var $gb8Pv;
    const $ed405e89d26d258c$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
        const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
            onChange((0, (0, parcelRequire("6cMZg")).transformValue)(newValue, extension));
            (0, (0, parcelRequire("4JpPl")).fireTrackEditedEvent)('issue-create', analyticsAttributes);
        }, [
            extension,
            analyticsAttributes,
            onChange
        ]);
        const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
        if (isModalMode) {
            const translatedError = {
                message: intl.formatMessage((0, (0, parcelRequire("gb8Pv")).default).modalModeErrorTitle),
                errorMessage: intl.formatMessage((0, (0, parcelRequire("gb8Pv")).default).modalModeErrorDescription)
            };
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
                ...analyticsAttributes,
                extension: JSON.stringify(extension)
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frltc")).ErrorPanel), {
                error: translatedError
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wJ66")).AsyncCustomFieldInlineEdit), {
            extension: extension,
            extensionData: extensionData,
            analyticsAttributes: analyticsAttributes,
            extensionPayload: extensionPayload,
            onSubmit: onEditConfirm,
            onModalRender: onModalRender
        });
    };
    const $ed405e89d26d258c$export$5304145354a3bee9 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Aezm")).EditAnalyticsWrapper), {
            attributes: (0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(props.extension)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed405e89d26d258c$export$ba588b5cce278e96, props));
});
parcelRegister("4JpPl", function(module, exports) {
    $parcel$export(module.exports, "fireTrackEditedEvent", ()=>$d80ee50440a72c0c$export$1798d320c6527c08);
    $parcel$export(module.exports, "fireUiCanceledEvent", ()=>$d80ee50440a72c0c$export$fc09afa3d0d5294c);
    $parcel$export(module.exports, "fireOperationalEditFailedEvent", ()=>$d80ee50440a72c0c$export$762dee9e981de3e1);
    $parcel$export(module.exports, "fireUiTriggerClickEvent", ()=>$d80ee50440a72c0c$export$cfefb608fbbf02c9);
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$d80ee50440a72c0c$export$add44f896fb31ba3);
    var $k2DRb;
    var $8uOa6;
    var $9BrHy;
    var $8kVg1;
    var $hBuqR;
    const $d80ee50440a72c0c$var$moduleEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION),
        entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)
    });
    const $d80ee50440a72c0c$var$triggerEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
        entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)
    });
    const $d80ee50440a72c0c$export$1798d320c6527c08 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).EDITED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $d80ee50440a72c0c$export$fc09afa3d0d5294c = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).CANCELED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $d80ee50440a72c0c$export$762dee9e981de3e1 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).EDIT_FAILED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $d80ee50440a72c0c$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
        (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
            startTime: performance.now()
        });
        return (0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).CLICKED, {
            id: $d80ee50440a72c0c$var$triggerEventId,
            source: source,
            attributes: attributes
        });
    };
    const $d80ee50440a72c0c$export$add44f896fb31ba3 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
});
parcelRegister("9wJ66", function(module, exports) {
    $parcel$export(module.exports, "AsyncCustomFieldInlineEdit", ()=>$05c72791f20b76f4$export$ca6c6772b322056d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2G8Ll;
    var $3oVvh;
    const $05c72791f20b76f4$var$isIssueViewProps = (props)=>props.extensionData.renderContext === 'issue-view';
    const $05c72791f20b76f4$var$isIssueCreateOrTransitionProps = (props)=>props.extensionData.renderContext === 'issue-create' || props.extensionData.renderContext === 'issue-transition';
    const $05c72791f20b76f4$export$980ea0297ad3a4c8 = (props)=>{
        if ($05c72791f20b76f4$var$isIssueViewProps(props)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3oVvh")).LazyCustomFieldInlineEditIssueView), props);
        if ($05c72791f20b76f4$var$isIssueCreateOrTransitionProps(props)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2G8Ll")).LazyCustomFieldInlineEditForm), props);
        return null;
    };
    const $05c72791f20b76f4$export$ca6c6772b322056d = $05c72791f20b76f4$export$980ea0297ad3a4c8;
});
parcelRegister("2G8Ll", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldInlineEditForm", ()=>$3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $6ikhl;
    var $4JpPl;
    var $k2DRb;
    var $afKG3;
    var $3mOWa;
    var $lfTZh;
    var $bLCKr;
    var $69dub;
    var $3OHUI;
    const $3e8d63ebec6f951f$var$skeletonConfig = [
        {
            width: 100
        }
    ];
    const $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
        const requestsCount = (0, $5uXOq.useRef)(0);
        const [, { setFieldState: setFieldState }] = (0, (0, parcelRequire("6ikhl")).useInlineField)(restProps.extensionData.fieldId);
        const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
        const loadingComponent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bLCKr")).Skeleton), {
                skeletonConfig: $3e8d63ebec6f951f$var$skeletonConfig
            }), []);
        const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
            const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
                fieldId: extensionData.fieldId,
                fieldType: extensionData.fieldType,
                fieldName: extensionData.fieldName,
                renderContext: extensionData.renderContext
            };
            return {
                ...preparedExtensionData,
                type: extension.type,
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                isInline: true
            };
        }, [
            extension,
            extensionData
        ]);
        const extraProps = (0, $5uXOq.useMemo)(()=>({
                loadingComponent: loadingComponent,
                module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                extensionData: extensionDataValue,
                extensionPayload: extensionPayload,
                contextToken: (0, (0, parcelRequire("k2DRb")).CONTEXT_TOKEN_TYPE_JIRA)
            }), [
            extensionDataValue,
            extensionPayload,
            loadingComponent
        ]);
        const createRetryFunction = (0, $5uXOq.useCallback)((fieldValue)=>async ()=>{
                try {
                    setFieldState({
                        fieldId: extensionData.fieldId,
                        status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                    });
                    requestsCount.current += 1;
                    const submitValue = await Promise.resolve(fieldValue);
                    onSubmit(submitValue);
                    requestsCount.current -= 1;
                    if (requestsCount.current === 0) setFieldState({
                        fieldId: extensionData.fieldId,
                        status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                    });
                } catch (error) {
                    setFieldState({
                        fieldId: extensionData.fieldId,
                        status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                    });
                    (0, (0, parcelRequire("4JpPl")).fireOperationalEditFailedEvent)(extensionData.renderContext, {
                        error: error,
                        isInline: true
                    });
                }
                return undefined;
            }, [
            onSubmit,
            extensionData,
            setFieldState
        ]);
        const submit = (0, $5uXOq.useCallback)(async ({ data: fieldValue })=>{
            const retryFunction = createRetryFunction(fieldValue);
            setFieldState({
                fieldId: extensionData.fieldId,
                retryFunction: retryFunction
            });
            await retryFunction();
            return undefined;
        }, [
            createRetryFunction,
            extensionData.fieldId,
            setFieldState
        ]);
        const bridge = (0, $5uXOq.useMemo)(()=>({
                submit: submit
            }), [
            submit
        ]);
        if ((0, (0, parcelRequire("3mOWa")).isNativeUiExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) || (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT))) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-edit",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditExtension), {
            ...restProps,
            ...extraProps,
            onModalRender: onModalRender,
            onSubmit: onSubmit,
            bridge: bridge
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-inline-edit",
            fallback: loadingComponent
        }, (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("afKG3")).LazyIframe), {
            ...restProps,
            ...extraProps,
            bridge: bridge,
            isResizable: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditRenderer), {
            ...restProps,
            ...extraProps,
            onModalRender: onModalRender,
            onSubmit: onSubmit,
            bridge: bridge
        })));
    };
});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';
parcelRegister("6ikhl", function(module, exports) {
    $parcel$export(module.exports, "useInlineFields", ()=>$d56dd4f138add558$export$71d5b5acb7d7f5ce);
    $parcel$export(module.exports, "useInlineField", ()=>$d56dd4f138add558$export$14c9655e9d9e873c);
    $parcel$export(module.exports, "useInlineFieldsActions", ()=>$d56dd4f138add558$export$cdb4b503c6154b35);
    var $3sQ5x;
    var $iXqE5;
    var $5rCpD;
    const $d56dd4f138add558$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'forge.inline-fields-state',
        initialState: {},
        actions: (0, parcelRequire("5rCpD")).default
    });
    const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store);
    const $d56dd4f138add558$export$14c9655e9d9e873c = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: (state, fieldId)=>state[fieldId]
    });
    const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, (0, parcelRequire("3sQ5x")).createHook)($d56dd4f138add558$var$store, {
        selector: null
    });
});
parcelRegister("5rCpD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02373df28193ad93$export$2e2bcd8739ae039);
    var $hPhpd;
    const $02373df28193ad93$var$actions = {
        setFieldState: (0, parcelRequire("hPhpd")).setFieldState,
        resetState: (0, parcelRequire("hPhpd")).resetState,
        dispatchRetryFunction: (0, parcelRequire("hPhpd")).dispatchRetryFunction,
        dispatchFormSubmits: (0, parcelRequire("hPhpd")).dispatchFormSubmits
    };
    var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;
});
parcelRegister("hPhpd", function(module, exports) {
    $parcel$export(module.exports, "setFieldState", ()=>$9eca433be421af07$export$80fd62d9217dd703);
    $parcel$export(module.exports, "resetState", ()=>$9eca433be421af07$export$8e84bad0b35de9e8);
    $parcel$export(module.exports, "dispatchRetryFunction", ()=>$9eca433be421af07$export$27c59f06a7c1fe26);
    $parcel$export(module.exports, "dispatchFormSubmits", ()=>$9eca433be421af07$export$42fd5e650971333b);
    var $9J85a;
    const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const stateObject = {
                status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
                formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
                retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
            };
            setState({
                ...getState(),
                [data.fieldId]: stateObject
            });
        };
    const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
            const stateToOverride = {};
            Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
                stateToOverride[fieldId] = {
                    status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
                };
            });
            setState(stateToOverride);
        };
    const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
            const currentState = getState();
            const fieldData = currentState[fieldId];
            const retryFunction = fieldData?.retryFunction;
            retryFunction && retryFunction();
        };
    const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
            const currentState = getState();
            Object.keys(currentState).forEach((fieldId)=>{
                if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                    const formRef = currentState[fieldId]?.formRef;
                    (0, (0, parcelRequire("9J85a")).dispatchFormSubmitAndBlurElements)(formRef);
                }
            });
        };
});
parcelRegister("9J85a", function(module, exports) {
    $parcel$export(module.exports, "submitForgeFormField", ()=>$b1c36799aab2b39a$export$7e50fee868362aa2);
    $parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", ()=>$b1c36799aab2b39a$export$4d639a8e0790daf2);
    $parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", ()=>$b1c36799aab2b39a$export$ee23412a8bea9333);
    const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
        formRef?.current?.requestSubmit();
    };
    const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
        $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
        if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
            if ('blur' in element && typeof element.blur === 'function') element?.blur();
        });
    };
    const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);
});
parcelRegister("afKG3", function(module, exports) {
    $parcel$export(module.exports, "LazyIframe", ()=>$8deafd95f39f73a9$export$808646051d5a3908);
    $parcel$export(module.exports, "LazyModalIframe", ()=>$8deafd95f39f73a9$export$f35ac420e260eb7);
    var $1rTGO;
    var $1jUsD;
    const $8deafd95f39f73a9$var$getModule = ()=>(parcelRequire("i2O8t"));
    const $8deafd95f39f73a9$export$808646051d5a3908 = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>$8deafd95f39f73a9$var$getModule().then((module)=>module.IframeRenderer), {
        ssr: false
    }));
    const $8deafd95f39f73a9$export$f35ac420e260eb7 = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, (0, parcelRequire("1jUsD")).lazy)(()=>$8deafd95f39f73a9$var$getModule().then((module)=>module.ModalIframeRenderer), {}));
});
parcelRegister("i2O8t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1SRXI")
    ]).then(()=>parcelRequire('96A2p'));
});
parcelRegister("bLCKr", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$e1da1ba1fdde315e$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "SkeletonLayout", ()=>$e1da1ba1fdde315e$export$af3ba02ef74c9bdf);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $6Ll2T;
    var $99gde;
    const $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 = [];
    const $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e1da1ba1fdde315e$var$ForgeSkeleton, {
                "data-testId": `forgeskeleton-${index}`,
                key: index,
                width: width
            })));
    const $e1da1ba1fdde315e$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
        if (!layout) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            testId: "forge-ui-async.common.ui.skeleton.box",
            xcss: $e1da1ba1fdde315e$var$layoutStyles
        }, children);
    };
    const $e1da1ba1fdde315e$var$shimmer = null;
    const $e1da1ba1fdde315e$var$ForgeSkeleton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1y04s53": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}%`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
                __cmplp.className
            ])
        });
    });
    const $e1da1ba1fdde315e$var$layoutStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingTop: 'space.200',
        paddingLeft: 'space.300',
        paddingRight: 'space.300'
    });
});
parcelRegister("69dub", function(module, exports) {
    $parcel$export(module.exports, "StopSubmitPropagation", ()=>$1d6031a605ad4b71$export$238f56c0891e9254);
    var $5uXOq = parcelRequire("5uXOq");
    const $1d6031a605ad4b71$export$e6dfd72ab29f8598 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
            onSubmit: props.onSubmit
        }, props.children);
    const $1d6031a605ad4b71$export$238f56c0891e9254 = ({ children: children })=>{
        const handleSubmit = (e)=>{
            e.stopPropagation();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1d6031a605ad4b71$export$e6dfd72ab29f8598, {
            onSubmit: handleSubmit
        }, children);
    };
});
parcelRegister("3OHUI", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldInlineEditRenderer", ()=>$e47c1fd0d3acd296$export$eef5130ba28e0f4e);
    $parcel$export(module.exports, "LazyCustomFieldInlineEditExtension", ()=>$e47c1fd0d3acd296$export$299b8ce8659dec8c);
    var $1rTGO;
    var $8kVg1;
    var $hBuqR;
    var $1jUsD;
    const $e47c1fd0d3acd296$var$getModule = ()=>(0, (0, parcelRequire("8kVg1")).measureInitialPageLoadAsyncResourcesTiming)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("lf16s")));
    const $e47c1fd0d3acd296$var$getForgeExtensionModule = ()=>(0, (0, parcelRequire("8kVg1")).measureInitialPageLoadAsyncResourcesTiming)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("7kdGo")));
    const $e47c1fd0d3acd296$export$eef5130ba28e0f4e = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>$e47c1fd0d3acd296$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
        ssr: false
    }));
    const $e47c1fd0d3acd296$export$299b8ce8659dec8c = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>$e47c1fd0d3acd296$var$getForgeExtensionModule().then((module)=>module.CustomFieldInlineEdit), {
        ssr: false
    }));
});
parcelRegister("lf16s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2AjeU")
    ]).then(()=>parcelRequire('lDRdH'));
});
parcelRegister("7kdGo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2QVAD")
    ]).then(()=>parcelRequire('456zR'));
});
parcelRegister("3oVvh", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldInlineEditIssueView", ()=>$46e0705763f3c3d0$export$9929b4973c13a82f);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $k2DRb;
    var $afKG3;
    var $3mOWa;
    var $lfTZh;
    var $bLCKr;
    var $69dub;
    var $7IjIj;
    var $3OHUI;
    const $46e0705763f3c3d0$var$skeletonConfig = [
        {
            width: 100
        }
    ];
    const $46e0705763f3c3d0$export$9929b4973c13a82f = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onRender: onRender, ...restProps })=>{
        const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const loadingComponent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bLCKr")).Skeleton), {
                skeletonConfig: $46e0705763f3c3d0$var$skeletonConfig
            }), []);
        const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
            const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
                fieldType: extensionData.fieldType,
                fieldId: extensionData.fieldId,
                fieldName: extensionData.fieldName,
                renderContext: extensionData.renderContext
            };
            return {
                ...preparedExtensionData,
                type: extension.type,
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                isInline: true
            };
        }, [
            extension.type,
            extensionData
        ]);
        const extraProps = (0, $5uXOq.useMemo)(()=>({
                loadingComponent: loadingComponent,
                module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                extensionData: extensionDataValue,
                extensionPayload: extensionPayload,
                contextToken: (0, (0, parcelRequire("k2DRb")).CONTEXT_TOKEN_TYPE_JIRA)
            }), [
            extensionDataValue,
            extensionPayload,
            loadingComponent
        ]);
        const submit = (0, $5uXOq.useCallback)(({ data: fieldValue })=>(0, (0, parcelRequire("7IjIj")).onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), [
            showFlag
        ]);
        const close = onCancel;
        const bridge = (0, $5uXOq.useMemo)(()=>({
                submit: submit,
                close: close
            }), [
            submit,
            close
        ]);
        if ((0, (0, parcelRequire("3mOWa")).isNativeUiExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) || (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT))) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-edit",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditExtension), {
            ...restProps,
            ...extraProps,
            onCancel: onCancel,
            onLoad: onRender,
            onRender: onRender,
            bridge: bridge
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-edit",
            fallback: null
        }, (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("afKG3")).LazyIframe), {
            ...restProps,
            ...extraProps,
            onLoad: onRender,
            bridge: bridge,
            isResizable: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditRenderer), {
            ...restProps,
            ...extraProps,
            onRender: onRender,
            onCancel: onCancel,
            bridge: bridge
        })));
    };
});
parcelRegister("7IjIj", function(module, exports) {
    $parcel$export(module.exports, "onCustomFieldSubmit", ()=>$7482280c9b50d561$export$fc8c2ed652969e74);
    var $jJZqs;
    var $dGSK4;
    const $7482280c9b50d561$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
            if (response == null) return;
            if ('error' in response) {
                if (response.error) throw response.error;
            } else onConfirm(response.data);
        }).catch((error)=>{
            showFlag((0, (0, parcelRequire("dGSK4")).default)(error));
            if ((0, (0, parcelRequire("jJZqs")).isValidationError)(error)) throw error;
            throw Error(`Unable to save custom field, error: ${error.message}`);
        });
});
parcelRegister("dGSK4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b60f776846cd27f9$export$2e2bcd8739ae039);
    var $jJZqs;
    var $eRDnE;
    var $ctOgQ;
    var $b60f776846cd27f9$export$2e2bcd8739ae039 = (error)=>(0, (0, parcelRequire("jJZqs")).isValidationError)(error) ? (0, (0, parcelRequire("ctOgQ")).default)(error.errors) : (0, (0, parcelRequire("eRDnE")).default)();
});
parcelRegister("eRDnE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41e1a5ac6c28ff9a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $41e1a5ac6c28ff9a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
            "defaultMessage": "We were unable to edit this custom field. Please try again."
        }
    });
    var $41e1a5ac6c28ff9a$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $41e1a5ac6c28ff9a$var$messages.title,
            isAutoDismiss: false
        });
});
parcelRegister("ctOgQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59eef974107568f4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $59eef974107568f4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
            "defaultMessage": "Validation error"
        }
    });
    var $59eef974107568f4$export$2e2bcd8739ae039 = (errors)=>({
            type: 'error',
            title: $59eef974107568f4$var$messages.title,
            description: errors.map(({ error: error })=>error).join(', '),
            isAutoDismiss: false
        });
});
parcelRegister("frltc", function(module, exports) {
    $parcel$export(module.exports, "ErrorPanel", ()=>$a7cc7ee0610715db$export$9f3dc18e1adf5d8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gT07g;
    var $eg03U;
    var $113Tq;
    var $koVbs;
    var $lUtFZ;
    const $a7cc7ee0610715db$var$Loader = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$LoaderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
            size: "large"
        }));
    const $a7cc7ee0610715db$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
        const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
        const reinitializeApp = (0, $5uXOq.useCallback)(async (e)=>{
            setIsLoading(true);
            try {
                e.stopPropagation();
                if (onRetry) await onRetry();
            } catch  {} finally{
                setIsLoading(false);
            }
        }, [
            onRetry
        ]);
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$Loader, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ContentWrapper, {
            onClick: onClickStopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gT07g")).default), {
            appearance: "error",
            title: message,
            actions: onRetry ? [
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eg03U")).default), {
                    onClick: reinitializeApp,
                    key: "refresh"
                }, intl.formatMessage((0, (0, parcelRequire("lUtFZ")).default).refreshApp))
            ] : []
        }, errorMessage && (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorMessageWrapper, null, errorMessage), errorDetails && (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorDetailsWrapper, null, errorDetails)));
    };
    const $a7cc7ee0610715db$var$ContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _k7zyidpf",
                __cmplp.className
            ])
        });
    });
    const $a7cc7ee0610715db$var$LoaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $a7cc7ee0610715db$var$ErrorMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721jtm",
                __cmplp.className
            ])
        });
    });
    const $a7cc7ee0610715db$var$ErrorDetailsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721jtm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eg03U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f25624550e6319cf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    const $f25624550e6319cf$var$SectionMessageAction = (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
        return onClick || href ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            testId: testId,
            appearance: "link",
            spacing: "none",
            onClick: onClick,
            href: href,
            component: href ? linkComponent : undefined
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
    $f25624550e6319cf$var$SectionMessageAction.displayName = 'SectionMessageAction';
    var $f25624550e6319cf$export$2e2bcd8739ae039 = $f25624550e6319cf$var$SectionMessageAction;
});
parcelRegister("lUtFZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c0d2ab7d73abc3f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0c0d2ab7d73abc3f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        refreshApp: {
            "id": "forge-ui-renderers.common.error-panel.refresh-app",
            "defaultMessage": "Refresh app"
        }
    });
});
parcelRegister("6cMZg", function(module, exports) {
    $parcel$export(module.exports, "transformValue", ()=>$856789955d192c4b$export$98c150630afe5417);
    $parcel$export(module.exports, "transformValueToExtensionData", ()=>$856789955d192c4b$export$b82f09291a00d8c1);
    $parcel$export(module.exports, "getExtension", ()=>$856789955d192c4b$export$78d71f9ed5534abe);
    var $2QTbq;
    var $gifeQ;
    var $2pEv1;
    const $856789955d192c4b$export$98c150630afe5417 = (value, extension)=>{
        const { properties: { type: type, collection: collection } } = extension;
        switch(type){
            case 'string':
                if (collection === 'list' && Array.isArray(value)) return (0, (0, parcelRequire("2QTbq")).mapDataToLabelOptions)(value);
                return value;
            case 'object':
                return JSON.stringify(value);
            case 'user':
                if (value != null) return $856789955d192c4b$export$26760e7b66ccf1e1(value);
                return value;
            default:
                return value;
        }
    };
    const $856789955d192c4b$export$b82f09291a00d8c1 = (value, extension)=>{
        const type = extension?.properties?.type;
        const collection = extension?.properties?.collection;
        switch(type){
            case 'string':
                if (collection === 'list') return (0, (0, parcelRequire("2QTbq")).mapLabelOptionsToData)(value);
                return value;
            case 'object':
                return (0, (0, parcelRequire("2pEv1")).transformJSONStringToObject)(value);
            case 'user':
                if (value === null) return value;
                return $856789955d192c4b$export$e4490ea0dfe4173f(value);
            default:
                return value;
        }
    };
    const $856789955d192c4b$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, (0, parcelRequire("gifeQ")).isForgeLegacyFieldType)(fieldType) ? field.id === (0, (0, parcelRequire("gifeQ")).getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const $856789955d192c4b$export$e4490ea0dfe4173f = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                accountId: option.id
            }));
        return {
            accountId: userOption.id
        };
    };
    const $856789955d192c4b$export$3e406786572c35b0 = (userData)=>({
            id: userData.accountId || '',
            name: userData.name || '',
            avatarUrl: userData.picture || ''
        });
    const $856789955d192c4b$export$26760e7b66ccf1e1 = (defaultValue)=>{
        if (Array.isArray(defaultValue)) return defaultValue.map($856789955d192c4b$export$3e406786572c35b0);
        return $856789955d192c4b$export$3e406786572c35b0(defaultValue);
    };
});
parcelRegister("2QTbq", function(module, exports) {
    $parcel$export(module.exports, "mapDataToLabelOptions", ()=>$392cb309afc1042a$export$cd8e373d5b1325b1);
    $parcel$export(module.exports, "mapLabelOptionsToData", ()=>$392cb309afc1042a$export$1bf703d99c7bcef6);
    $parcel$export(module.exports, "mapLabelsResponseToLabelOptions", ()=>$392cb309afc1042a$export$37f55c1f665c1221);
    const $392cb309afc1042a$export$cd8e373d5b1325b1 = (data)=>{
        if (!data) return [];
        return data.map((value)=>({
                value: value,
                label: value
            }));
    };
    const $392cb309afc1042a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
    const $392cb309afc1042a$export$37f55c1f665c1221 = (response)=>{
        const { suggestions: suggestions } = response;
        if (!suggestions) return [];
        return suggestions.map(({ label: label })=>({
                label: label,
                value: label
            }));
    };
});
parcelRegister("2pEv1", function(module, exports) {
    $parcel$export(module.exports, "transformJSONStringToObject", ()=>$ff7dce57394b1eb3$export$2de59005e10fd82);
    var $agVdz = parcelRequire("agVdz");
    const $ff7dce57394b1eb3$export$2de59005e10fd82 = (value)=>{
        try {
            if ((0, ($parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
        } catch (e) {
            return value;
        }
        return value;
    };
});
parcelRegister("gb8Pv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c94c49b5b89ee482$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c94c49b5b89ee482$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalModeErrorTitle: {
            "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
            "defaultMessage": "We couldn't show this extension"
        },
        modalModeErrorDescription: {
            "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
            "defaultMessage": "Contact the app vendor to update the app."
        }
    });
});
parcelRegister("j5sSv", function(module, exports) {
    $parcel$export(module.exports, "FieldContainer", ()=>$41b83e50a34e2ca1$export$b5c4b0e7cd7f148b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1r250ak": (0, (0, parcelRequire("lD23V")).default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
                "--_1glwpqj": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.marginTop ?? 0}px`),
                "--_1i3s0vn": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.paddingBottom ?? 0}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbuo76 _19pknek2 _n3td11zn",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7fjFA", function(module, exports) {
    $parcel$export(module.exports, "ForgeFieldMessage", ()=>$111a3dd21aa999b8$export$1df6b326181f4cdf);
    var $5uXOq = parcelRequire("5uXOq");
    var $c4CWe;
    var $113Tq;
    var $6ikhl;
    var $koVbs;
    var $jcuk9;
    var $3EMIO;
    var $hbsKr;
    const $111a3dd21aa999b8$export$1df6b326181f4cdf = (props)=>{
        const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
        const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
        const [fieldState] = (0, (0, parcelRequire("6ikhl")).useInlineField)(fieldId);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const renderErrorMessage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).ErrorMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hbsKr")).MessagePartsSeparationWrapper), null, formatMessage((0, (0, parcelRequire("3EMIO")).default).forgeFieldErrorTextLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcuk9")).ForgeFieldDispatchButton), {
                fieldId: fieldId
            }));
        const renderSuccessMessage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).ValidMessage), null, formatMessage((0, (0, parcelRequire("3EMIO")).default).forgeFieldSuccessTextLabel));
        const renderHelperMessage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hbsKr")).MessagePartsSeparationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: "small"
            })), formatMessage((0, (0, parcelRequire("3EMIO")).default).forgeFieldPendingTextLabel));
        const renderDefaultErrorMessage = ()=>{
            if (renderFieldMessage !== undefined && renderFieldMessage !== null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderFieldMessage(error));
            return null;
        };
        if (error !== undefined) return renderDefaultErrorMessage();
        if (failedErrorMessageAppeared.current) {
            if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
                case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                    return renderErrorMessage();
                case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                    return renderSuccessMessage();
                case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
                case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                    return renderHelperMessage();
                default:
                    return renderDefaultErrorMessage();
            }
            return null;
        }
        if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
            failedErrorMessageAppeared.current = true;
            return renderErrorMessage();
        }
        return renderDefaultErrorMessage();
    };
});
parcelRegister("c4CWe", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$37aaa14c21610882$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$37aaa14c21610882$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$37aaa14c21610882$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$37aaa14c21610882$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2ISpW;
    var $4ljkj;
    var $1FTEF;
    function $37aaa14c21610882$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $37aaa14c21610882$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $37aaa14c21610882$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $37aaa14c21610882$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $37aaa14c21610882$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $37aaa14c21610882$var$iconWrapperStyles
        }, children);
    };
    const $37aaa14c21610882$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2ISpW"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("4ljkj"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $37aaa14c21610882$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $37aaa14c21610882$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($37aaa14c21610882$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $37aaa14c21610882$var$messageStyles,
                $37aaa14c21610882$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$IconWrapper, null, icon), content);
    };
    const $37aaa14c21610882$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $37aaa14c21610882$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $37aaa14c21610882$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $37aaa14c21610882$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $37aaa14c21610882$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($37aaa14c21610882$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("2ISpW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1fb9e6fe23750f95$var$_react = $1fb9e6fe23750f95$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1fb9e6fe23750f95$var$_error = $1fb9e6fe23750f95$var$_interopRequireDefault((parcelRequire("4b40Y")));
    var $1fb9e6fe23750f95$var$_error2 = $1fb9e6fe23750f95$var$_interopRequireDefault((parcelRequire("6UxUy")));
    function $1fb9e6fe23750f95$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1fb9e6fe23750f95$var$ErrorIcon = (props)=>$1fb9e6fe23750f95$var$_react.default.createElement($1fb9e6fe23750f95$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $1fb9e6fe23750f95$var$_error2.default
        }, props));
    $1fb9e6fe23750f95$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $1fb9e6fe23750f95$var$_default = module.exports.default = $1fb9e6fe23750f95$var$ErrorIcon;
});
parcelRegister("4b40Y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30ab4dbd64ae5aed$var$_react = $30ab4dbd64ae5aed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30ab4dbd64ae5aed$var$_UNSAFE_baseNew = $30ab4dbd64ae5aed$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $30ab4dbd64ae5aed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30ab4dbd64ae5aed$var$ErrorIcon = (props)=>$30ab4dbd64ae5aed$var$_react.default.createElement($30ab4dbd64ae5aed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $30ab4dbd64ae5aed$var$ErrorIcon.displayName = 'ErrorIcon';
    var $30ab4dbd64ae5aed$var$_default = module.exports.default = $30ab4dbd64ae5aed$var$ErrorIcon;
});
parcelRegister("4ljkj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32981d764c8c8a36$var$_react = $32981d764c8c8a36$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32981d764c8c8a36$var$_success = $32981d764c8c8a36$var$_interopRequireDefault((parcelRequire("5x8hX")));
    var $32981d764c8c8a36$var$_success2 = $32981d764c8c8a36$var$_interopRequireDefault((parcelRequire("jyRWF")));
    function $32981d764c8c8a36$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32981d764c8c8a36$var$SuccessIcon = (props)=>$32981d764c8c8a36$var$_react.default.createElement($32981d764c8c8a36$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $32981d764c8c8a36$var$_success2.default
        }, props));
    $32981d764c8c8a36$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $32981d764c8c8a36$var$_default = module.exports.default = $32981d764c8c8a36$var$SuccessIcon;
});
parcelRegister("5x8hX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $407676ca7dbef70c$var$_react = $407676ca7dbef70c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $407676ca7dbef70c$var$_UNSAFE_baseNew = $407676ca7dbef70c$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $407676ca7dbef70c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $407676ca7dbef70c$var$SuccessIcon = (props)=>$407676ca7dbef70c$var$_react.default.createElement($407676ca7dbef70c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $407676ca7dbef70c$var$SuccessIcon.displayName = 'SuccessIcon';
    var $407676ca7dbef70c$var$_default = module.exports.default = $407676ca7dbef70c$var$SuccessIcon;
});
parcelRegister("jyRWF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e3db09ac6ef9c7a0$var$_react = $e3db09ac6ef9c7a0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $e3db09ac6ef9c7a0$var$_success = $e3db09ac6ef9c7a0$var$_interopRequireDefault((parcelRequire("c10Ip")));
    function $e3db09ac6ef9c7a0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e3db09ac6ef9c7a0$var$EditorSuccessIcon = (props)=>$e3db09ac6ef9c7a0$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $e3db09ac6ef9c7a0$var$_success.default
        }));
    $e3db09ac6ef9c7a0$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $e3db09ac6ef9c7a0$var$_default = module.exports.default = $e3db09ac6ef9c7a0$var$EditorSuccessIcon;
});
parcelRegister("c10Ip", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8bf62213531adf65$var$_react = $8bf62213531adf65$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8bf62213531adf65$var$_UNSAFE_baseNew = $8bf62213531adf65$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $8bf62213531adf65$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8bf62213531adf65$var$SuccessIcon = (props)=>$8bf62213531adf65$var$_react.default.createElement($8bf62213531adf65$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $8bf62213531adf65$var$SuccessIcon.displayName = 'SuccessIcon';
    var $8bf62213531adf65$var$_default = module.exports.default = $8bf62213531adf65$var$SuccessIcon;
});
parcelRegister("jcuk9", function(module, exports) {
    $parcel$export(module.exports, "ForgeFieldDispatchButton", ()=>$354a8a5375650812$export$59e3aafda495153);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $6ikhl;
    const $354a8a5375650812$export$59e3aafda495153 = (props)=>{
        const { fieldId: fieldId } = props;
        const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, (0, parcelRequire("6ikhl")).useInlineField)(fieldId);
        const onClickHandler = async ()=>{
            if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
        };
        const renderRetryButton = ()=>{
            if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                spacing: "none",
                appearance: "link",
                onClick: onClickHandler
            }, "Try again?");
            return null;
        };
        return renderRetryButton();
    };
});
parcelRegister("3EMIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$477739caf5b64c43$export$2e2bcd8739ae039);
    var $7VHMR;
    var $477739caf5b64c43$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forgeFieldErrorTextLabel: {
            "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
            "defaultMessage": "We couldn't save the value of this custom field."
        },
        forgeFieldSuccessTextLabel: {
            "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
            "defaultMessage": "Custom field value saved."
        },
        forgeFieldPendingTextLabel: {
            "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
            "defaultMessage": "Saving custom field value."
        }
    });
});
parcelRegister("hbsKr", function(module, exports) {
    $parcel$export(module.exports, "MessagePartsSeparationWrapper", ()=>$80adf2e407a23636$export$16fadfc3d05f6fc0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $80adf2e407a23636$export$16fadfc3d05f6fc0 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f31b66",
                __cmplp.className
            ])
        });
    });
});
const $5363dcf42759d41f$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $5363dcf42759d41f$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $5363dcf42759d41f$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $5363dcf42759d41f$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $5363dcf42759d41f$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $5363dcf42759d41f$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $5363dcf42759d41f$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
const $5363dcf42759d41f$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $5363dcf42759d41f$export$ebb48b08205007c5 = 'ISSUE_TYPE';
parcelRegister("7Emtg", function(module, exports) {
    $parcel$export(module.exports, "reportForgeFailure", ()=>$6c61c34a1b63244f$export$e95b9e5003024a9c);
    var $4JpPl;
    var $gifeQ;
    const $6c61c34a1b63244f$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
        const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, (0, parcelRequire("gifeQ")).isForgeLegacyFieldType)(fieldType) ? field.id === (0, (0, parcelRequire("gifeQ")).getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
        const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
        if (isEmptyForgeData || isExtensionFilteredOut) return;
        (0, (0, parcelRequire("4JpPl")).fireOperationalFailedEvent)('issue-create', {
            error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
            renderContext: 'issue-create'
        });
    };
});
parcelRegister("1MgIu", function(module, exports) {
    $parcel$export(module.exports, "extractEnvFromFieldDescription", ()=>$91f4ce51875a932d$export$dfa36573f3bd00af);
    const $91f4ce51875a932d$var$DEV_PREFIX = '(DEVELOPMENT) ';
    const $91f4ce51875a932d$var$STG_PREFIX = '(STAGING) ';
    const $91f4ce51875a932d$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
        if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$DEV_PREFIX)) return {
            environment: 'DEVELOPMENT',
            description: descriptionWithEnv.replace($91f4ce51875a932d$var$DEV_PREFIX, '')
        };
        if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$STG_PREFIX)) return {
            environment: 'STAGING',
            description: descriptionWithEnv.replace($91f4ce51875a932d$var$STG_PREFIX, '')
        };
        return {
            environment: 'PRODUCTION',
            description: descriptionWithEnv ?? ''
        };
    };
});
parcelRegister("3IJWP", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundaryBypassProvider", ()=>$9680a0b11955a508$export$a5feb4d632b53009);
    $parcel$export(module.exports, "ErrorBoundaryBypassInput", ()=>$9680a0b11955a508$export$36798a6d5688c318);
    $parcel$export(module.exports, "ErrorBoundaryBypassOutput", ()=>$9680a0b11955a508$export$775be62266860b86);
    var $5uXOq = parcelRequire("5uXOq");
    const $9680a0b11955a508$var$ErrorBoundaryBypassApiContext = (0, $5uXOq.createContext)(null);
    const $9680a0b11955a508$var$ErrorBoundaryBypassErrorContext = (0, $5uXOq.createContext)(null);
    const $9680a0b11955a508$export$a5feb4d632b53009 = ({ children: children })=>{
        const [bypassedError, setBypassedError] = (0, $5uXOq.useState)(null);
        const api = (0, $5uXOq.useMemo)(()=>({
                swallowError: (error)=>{
                    setBypassedError(error);
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9680a0b11955a508$var$ErrorBoundaryBypassErrorContext.Provider, {
            value: bypassedError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9680a0b11955a508$var$ErrorBoundaryBypassApiContext.Provider, {
            value: api
        }, children));
    };
    class $9680a0b11955a508$export$36798a6d5688c318 extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        componentDidCatch(error) {
            if (this.context !== null) this.context.swallowError(error);
        }
        static{
            this.contextType = $9680a0b11955a508$var$ErrorBoundaryBypassApiContext;
        }
        render() {
            if (this.state.hasError) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                hasError: false
            };
        }
    }
    const $9680a0b11955a508$export$775be62266860b86 = ()=>{
        const bypassedError = (0, $5uXOq.useContext)($9680a0b11955a508$var$ErrorBoundaryBypassErrorContext);
        if (bypassedError !== null) throw bypassedError;
        return null;
    };
});
parcelRegister("59xJP", function(module, exports) {
    $parcel$export(module.exports, "FieldBusyIndicator", ()=>$b68c1576a43006f5$export$cf3e115209fc94cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $113Tq;
    var $loZC0;
    var $l0sjw;
    var $4ZSFc;
    const $b68c1576a43006f5$export$cf3e115209fc94cb = (0, $5uXOq.memo)(({ fieldId: fieldId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const loadingMessage = formatMessage((0, (0, parcelRequire("4ZSFc")).default).fieldLevelIndicatorTooltipContent);
        const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
        const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            tag: "span",
            content: loadingMessage,
            testId: tooltipId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b68c1576a43006f5$export$4e31364808fb7483, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l0sjw")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            testId: indicatorId,
            size: "small"
        }))));
    });
    $b68c1576a43006f5$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
    const $b68c1576a43006f5$export$4e31364808fb7483 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u012x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l0sjw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f5b4df3c1787ede$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4PIH3;
    var $kbxWk;
    function $3f5b4df3c1787ede$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
        const parentProfilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kbxWk")).ProfilerContext));
        const ignoredRLLProfilerContext = (0, $5uXOq.useMemo)(()=>({
                ...parentProfilerContext,
                placeholderFallBackMounted () {},
                placeholderFallBackUnmounted () {}
            }), [
            parentProfilerContext
        ]);
        const kids = children != null ? children : null;
        if (!ignore) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, kids);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4PIH3")).default), {
            ignore: ignore
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kbxWk")).ProfilerContext).Provider, {
            value: ignoredRLLProfilerContext
        }, kids));
    }
});
parcelRegister("4PIH3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c99ba6d9ee197e42$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2cBsB;
    function $c99ba6d9ee197e42$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("2cBsB")).default));
        const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
            if (!parentContext) return null;
            return {
                ...parentContext,
                hold (...args) {
                    if (!ignore) return parentContext.hold(...args);
                }
            };
        }, [
            parentContext,
            ignore
        ]);
        const kids = children != null ? children : null;
        if (!ignoredInteractionContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, kids);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2cBsB")).default).Provider, {
            value: ignoredInteractionContext
        }, kids);
    }
});
parcelRegister("4ZSFc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974b96d64cf7f740$export$2e2bcd8739ae039);
    var $7VHMR;
    var $974b96d64cf7f740$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fieldLevelIndicatorTooltipContent: {
            "id": "issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content",
            "defaultMessage": "Loading UI modifications..."
        }
    });
});
parcelRegister("mTNgq", function(module, exports) {
    $parcel$export(module.exports, "IssueAdjustmentsErrorHandler", ()=>$f3c77fc718edb938$export$68b86a282e98ff70);
    var $5uXOq = parcelRequire("5uXOq");
    var $asu2W;
    const $f3c77fc718edb938$export$68b86a282e98ff70 = ()=>{
        const { setError: setError, resetError: resetError } = (0, (0, parcelRequire("asu2W")).useIssueAdjustmentsActions)();
        (0, $5uXOq.useEffect)(()=>{
            setError({
                errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
            });
            return ()=>resetError();
        }, [
            setError,
            resetError
        ]);
        return null;
    };
});
parcelRegister("asu2W", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$ef99e75ec2f2694e$export$6f57813fe9f31bf9);
    $parcel$export(module.exports, "useAdjustedField", ()=>$ef99e75ec2f2694e$export$df4b0714e8177e0e);
    $parcel$export(module.exports, "useAnalyticsData", ()=>$ef99e75ec2f2694e$export$45885672916a1436);
    $parcel$export(module.exports, "useIssueAdjustmentsActions", ()=>$ef99e75ec2f2694e$export$cb9a014ec14556d8);
    $parcel$export(module.exports, "useAdjustedScreenTabs", ()=>$ef99e75ec2f2694e$export$677b3e34bd14c681);
    var $3sQ5x;
    var $iXqE5;
    var $7rVee;
    var $9gKFJ;
    var $dsc5J;
    var $lWjzW;
    var $3Pzhj;
    var $f81nP;
    var $l97Ge;
    var $2MPbo;
    var $jZ1BZ;
    var $gwqYE;
    var $ifTQq;
    var $hk40m;
    var $bAAVc;
    var $5pnmQ;
    var $4qdFk;
    const $ef99e75ec2f2694e$var$name = 'issue-adjustments';
    const $ef99e75ec2f2694e$export$d4c72bab9d6cc13a = {
        formData: null,
        screenTabs: null,
        appliedChanges: null,
        error: null,
        analyticsData: {},
        registeredFieldsDeprecated: {},
        registeredFields: {},
        triggerFieldInitializationKey: 0,
        numberOfSupportedFields: 0,
        internalFormMetadata: {},
        viewType: null,
        experienceDataIsLoading: false,
        lastProcessedChange: null,
        fieldsInitialization: {
            startTime: null,
            timeoutId: undefined,
            status: 'notStarted'
        },
        appliedChangesHistory: {},
        appsErrors: {},
        notification: null
    };
    const { triggerFieldInitializationKey: $ef99e75ec2f2694e$var$triggerFieldInitializationKey, viewType: $ef99e75ec2f2694e$var$scopedViewType, numberOfSupportedFields: $ef99e75ec2f2694e$var$numberOfSupportedFields, ...$ef99e75ec2f2694e$var$stateForResetAllFields } = $ef99e75ec2f2694e$export$d4c72bab9d6cc13a;
    const $ef99e75ec2f2694e$export$e324594224ef24da = {
        triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
                });
            },
        processChange: (0, parcelRequire("gwqYE")).processChange,
        setFieldValue: (0, parcelRequire("hk40m")).setFieldValue,
        initializeField: (0, parcelRequire("f81nP")).initializeField,
        initializeFields: (0, parcelRequire("f81nP")).initializeFields,
        startFieldsInitialisationTimeout: (0, parcelRequire("3Pzhj")).startFieldsInitialisationTimeout,
        successFieldsInitalisation: (0, parcelRequire("3Pzhj")).successFieldsInitalisation,
        registerFields: (0, parcelRequire("ifTQq")).registerFields,
        unregisterFields: (0, parcelRequire("ifTQq")).unregisterFields,
        updateFields: (0, parcelRequire("5pnmQ")).updateFields,
        clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
                const previousState = getState().appliedChanges || {};
                if (previousState[fieldId]) {
                    const { value: value, ...otherFieldChanges } = previousState[fieldId];
                    setState({
                        appliedChanges: {
                            ...previousState,
                            [fieldId]: otherFieldChanges
                        }
                    });
                }
            },
        resetAllFields: ()=>({ setState: setState, getState: getState })=>{
                clearTimeout(getState().fieldsInitialization.timeoutId);
                setState($ef99e75ec2f2694e$var$stateForResetAllFields);
            },
        setError: (0, parcelRequire("lWjzW")).setError,
        resetError: (0, parcelRequire("lWjzW")).resetError,
        setAnalyticsData: (analyticsData)=>({ setState: setState, getState: getState })=>{
                const previousState = getState().analyticsData ?? {};
                setState({
                    analyticsData: {
                        ...previousState,
                        ...analyticsData
                    }
                });
            },
        setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
                setState({
                    numberOfSupportedFields: numberOfAllSupportedFields
                });
            },
        setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
                setState({
                    experienceDataIsLoading: experienceDataIsLoading
                });
            },
        setAppErrors: (0, parcelRequire("7rVee")).setAppErrors,
        resetAppErrors: (0, parcelRequire("7rVee")).resetAppErrors,
        addAppsErrors: (0, parcelRequire("7rVee")).addAppsErrors,
        initializeNoScreenTab: (0, parcelRequire("l97Ge")).initializeNoScreenTab,
        initializeScreenTabs: (0, parcelRequire("2MPbo")).initializeScreenTabs,
        updateScreenTabs: (0, parcelRequire("4qdFk")).updateScreenTabs,
        updateActiveScreenTab: (0, parcelRequire("bAAVc")).updateActiveScreenTab,
        detectAppliedChangesConflicts: (0, parcelRequire("dsc5J")).detectAppliedChangesConflicts,
        collectScreenTabsAppliedChangesHistory: (0, parcelRequire("9gKFJ")).collectScreenTabsAppliedChangesHistory,
        collectFieldsAppliedChangesHistory: (0, parcelRequire("9gKFJ")).collectFieldsAppliedChangesHistory,
        setNotification: (0, parcelRequire("jZ1BZ")).setNotification,
        resetNotification: (0, parcelRequire("jZ1BZ")).resetNotification
    };
    const $ef99e75ec2f2694e$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $ef99e75ec2f2694e$var$name,
        initialState: $ef99e75ec2f2694e$export$d4c72bab9d6cc13a,
        actions: $ef99e75ec2f2694e$export$e324594224ef24da
    });
    const $ef99e75ec2f2694e$export$37792a602e748c08 = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9);
    const $ef99e75ec2f2694e$var$stableEmptyFieldFromIframe = {};
    const $ef99e75ec2f2694e$export$df4b0714e8177e0e = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9, {
        selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $ef99e75ec2f2694e$var$stableEmptyFieldFromIframe
    });
    const $ef99e75ec2f2694e$export$45885672916a1436 = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9, {
        selector: (state)=>state.analyticsData
    });
    const $ef99e75ec2f2694e$export$cb9a014ec14556d8 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9);
    const $ef99e75ec2f2694e$export$677b3e34bd14c681 = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9, {
        selector: (state)=>state.screenTabs
    });
});
parcelRegister("7rVee", function(module, exports) {
    $parcel$export(module.exports, "setAppErrors", ()=>$51d57126fd93ecb2$export$7054e2f8e68cf0dd);
    $parcel$export(module.exports, "addAppsErrors", ()=>$51d57126fd93ecb2$export$903d525e420c7d00);
    $parcel$export(module.exports, "resetAppErrors", ()=>$51d57126fd93ecb2$export$24c821207687a907);
    const $51d57126fd93ecb2$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appsErrors ?? {};
            setState({
                appsErrors: {
                    ...previousState,
                    [appId]: errors
                }
            });
        };
    const $51d57126fd93ecb2$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appsErrors ?? {};
            const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
                acc[appId] = [
                    ...acc[appId] ?? [],
                    ...appErrors
                ];
                return acc;
            }, {
                ...previousState
            });
            setState({
                appsErrors: appsErrors
            });
        };
    const $51d57126fd93ecb2$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appsErrors ?? {};
            setState({
                appsErrors: {
                    ...previousState,
                    [appId]: null
                }
            });
        };
});
parcelRegister("9gKFJ", function(module, exports) {
    $parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", ()=>$161ca2ef8e97884e$export$1d2b7abeeea36239);
    $parcel$export(module.exports, "collectFieldsAppliedChangesHistory", ()=>$161ca2ef8e97884e$export$7d0f534e5b16dcc9);
    var $hsiqV;
    const $161ca2ef8e97884e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
        const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
        const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
        return {
            ...currentAppliedChangesHistory,
            [changeId]: {
                apps: {
                    ...appliedChangesHistoryChangeId.apps,
                    [appId]: {
                        ...appliedChangesHistoryChangeIdApp,
                        ...newSingleAppChange
                    }
                },
                createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
            }
        };
    };
    const $161ca2ef8e97884e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
            const { appliedChangesHistory: appliedChangesHistory } = getState();
            if (!screenTabs.length) return;
            const newAppliedChangesHistory = $161ca2ef8e97884e$var$prepareAppliedChangesHistoryForSingleChange({
                currentAppliedChangesHistory: appliedChangesHistory,
                appId: appId,
                changeId: changeId,
                newSingleAppChange: {
                    tabs: {
                        type: (0, $ee1cb4d07e178dd8$export$f674b7a3bbd94b5)
                    }
                }
            });
            setState({
                appliedChangesHistory: newAppliedChangesHistory
            });
        };
    const $161ca2ef8e97884e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
            const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
            const singleAppChange = (0, (0, parcelRequire("hsiqV")).normalizeFieldsAppliedChangesForHistory)({
                fieldsChanges: fieldsChanges,
                internalFormMetadata: internalFormMetadata
            });
            const newAppliedChangesHistory = $161ca2ef8e97884e$var$prepareAppliedChangesHistoryForSingleChange({
                currentAppliedChangesHistory: appliedChangesHistory,
                appId: appId,
                changeId: changeId,
                newSingleAppChange: singleAppChange
            });
            setState({
                appliedChangesHistory: newAppliedChangesHistory
            });
        };
});
const $ee1cb4d07e178dd8$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $ee1cb4d07e178dd8$export$4a9f236a0db33834 = 'FIELD';
parcelRegister("hsiqV", function(module, exports) {
    $parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", ()=>$331671ca0401ed2b$export$8a23b3e9a1749620);
    var $4R6GH;
    const $331671ca0401ed2b$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
        return Object.keys(fieldChanges).reduce((acc, property)=>{
            const normalizedKey = `${fieldId}|${property}`;
            acc[normalizedKey] = {
                fieldId: fieldId,
                fieldType: fieldMetadata.fieldType,
                property: property,
                type: (0, $ee1cb4d07e178dd8$export$4a9f236a0db33834)
            };
            return acc;
        }, {});
    };
    const $331671ca0401ed2b$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
        return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
            const fieldMetadata = internalFormMetadata[fieldId];
            if ((0, (0, parcelRequire("4R6GH")).fg)('uim-check-for-undefined-field-metadata-in-history')) {
                if (!fieldMetadata) return acc;
            }
            const normalizedFieldHistory = $331671ca0401ed2b$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
            Object.assign(acc, normalizedFieldHistory);
            return acc;
        }, {});
    };
});
parcelRegister("dsc5J", function(module, exports) {
    $parcel$export(module.exports, "detectAppliedChangesConflicts", ()=>$3f81091b441597d8$export$90d94f20d157e756);
    var $dNpDc;
    var $7rVee;
    var $jZ1BZ;
    var $dDdm6;
    const $3f81091b441597d8$var$HISTORY_LOG_TTL = 60000;
    const $3f81091b441597d8$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
            return Date.now() - history.createdAt <= $3f81091b441597d8$var$HISTORY_LOG_TTL || existingChangeId === changeId;
        }));
    const $3f81091b441597d8$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
            const { appliedChangesHistory: appliedChangesHistory } = getState();
            const tidyAppliedChangesHistory = $3f81091b441597d8$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
            setState({
                appliedChangesHistory: tidyAppliedChangesHistory
            });
            const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
            const newChanges = appliedChangesHistoryChangeId?.apps[appId];
            if (!appliedChangesHistoryChangeId || !newChanges || Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
            const lifecycleHook = changeId === (0, $ff955bdb062d4e8f$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
            const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, (0, parcelRequire("dDdm6")).collectConflicts)({
                appliedChangesHistory: appliedChangesHistoryChangeId.apps,
                newChanges: newChanges,
                appIdOfNewChanges: appId,
                lifecycleHook: lifecycleHook
            });
            if (conflicts.length) {
                (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'appliedChangesHistory conflicted', viewType, {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap)
                });
                dispatch((0, (0, parcelRequire("7rVee")).addAppsErrors)({
                    errors: appErrorsMap
                }));
                dispatch((0, (0, parcelRequire("jZ1BZ")).setNotification)({
                    type: 'MULTIPLE_APPS_CONFLICTS'
                }));
            }
        };
});
parcelRegister("dNpDc", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalyticsWithoutContext", ()=>$d40341520e6b6a2e$export$92f0a000de1dacb3);
    $parcel$export(module.exports, "fireOperationalAnalyticsWithContext", ()=>$d40341520e6b6a2e$export$5ac7b3728975936c);
    var $8zOmE;
    var $g9E9n;
    const $d40341520e6b6a2e$export$92f0a000de1dacb3 = (actionSubject, action, viewType, attributes = {})=>(0, (0, parcelRequire("g9E9n")).getAnalyticsWebClient)().getInstance().sendOperationalEvent({
            action: action,
            actionSubject: `jiraUiModifications.${actionSubject}`,
            source: viewType,
            attributes: {
                ...attributes,
                viewType: viewType
            }
        });
    const $d40341520e6b6a2e$export$5ac7b3728975936c = (event, id, viewType, attributes = {})=>{
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, `jiraUiModifications.${id}`, {
            ...attributes,
            viewType: viewType
        });
    };
});
const $ff955bdb062d4e8f$export$415cc1afa6445f90 = 'onInitChangeId';
const $ff955bdb062d4e8f$export$811b7f067a43b422 = 'jira:uiModifications';
parcelRegister("jZ1BZ", function(module, exports) {
    $parcel$export(module.exports, "setNotification", ()=>$a8d175f1be522910$export$b9c5e783593ff01d);
    $parcel$export(module.exports, "resetNotification", ()=>$a8d175f1be522910$export$caafa3945f199bc7);
    const $a8d175f1be522910$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
            setState({
                notification: {
                    type: notificationProperties.type
                }
            });
        };
    const $a8d175f1be522910$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
            setState({
                notification: null
            });
        };
});
parcelRegister("dDdm6", function(module, exports) {
    $parcel$export(module.exports, "collectConflicts", ()=>$60b8259bed273e2d$export$a06103ec99e4e394);
    var $fr1K2 = parcelRequire("fr1K2");
    var $7wDhr;
    const $60b8259bed273e2d$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
    const $60b8259bed273e2d$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
        const appErrors = conflicts.map((change)=>{
            if (change.type === (0, $ee1cb4d07e178dd8$export$f674b7a3bbd94b5)) return {
                type: (0, $36f69991a898da6d$export$2a3fdceaae2188d5),
                cause: (0, $36f69991a898da6d$export$877da1000325f8b5),
                lifecycleHook: lifecycleHook,
                message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$60b8259bed273e2d$var$MESSAGE_SUFFIX}`
            };
            const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
            const method = (0, (0, parcelRequire("7wDhr")).mapFieldPropertyToApiMethod)(property);
            return {
                type: (0, $36f69991a898da6d$export$2a3fdceaae2188d5),
                cause: (0, $36f69991a898da6d$export$e4ac32edd5da2ee7),
                fieldId: fieldId,
                fieldType: fieldType,
                method: method,
                lifecycleHook: lifecycleHook,
                message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$60b8259bed273e2d$var$MESSAGE_SUFFIX}`
            };
        });
        return appErrors;
    };
    const $60b8259bed273e2d$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
        return Object.entries((0, ($parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
            const previousChangesKeys = Object.keys(previousChanges);
            const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                    ...change,
                    lifecycleHook: lifecycleHook,
                    appIds: [
                        appId,
                        appIdOfNewChanges
                    ]
                }));
            acc.conflicts.push(...conflicts);
            const appErrors = $60b8259bed273e2d$var$mapToAppErrors({
                conflicts: conflicts,
                lifecycleHook: lifecycleHook
            });
            if (appErrors.length > 0) {
                acc.appErrorsMap[appId] = appErrors;
                acc.appErrorsMap[appIdOfNewChanges] = [
                    ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                    ...appErrors
                ];
            }
            return acc;
        }, {
            appErrorsMap: {},
            conflicts: []
        });
    };
});
const $36f69991a898da6d$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $36f69991a898da6d$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $36f69991a898da6d$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $36f69991a898da6d$export$e4ac32edd5da2ee7 = 'FIELD';
const $36f69991a898da6d$export$877da1000325f8b5 = 'SCREENTABS';
parcelRegister("7wDhr", function(module, exports) {
    $parcel$export(module.exports, "mapFieldPropertyToApiMethod", ()=>$7cabc464949619ac$export$e1cc7da28a1c4bb7);
    const $7cabc464949619ac$var$SET_NAME_METHOD = 'setName';
    const $7cabc464949619ac$var$SET_DESCRIPTION_METHOD = 'setDescription';
    const $7cabc464949619ac$var$SET_VISIBLE_METHOD = 'setVisible';
    const $7cabc464949619ac$var$SET_READ_ONLY_METHOD = 'setReadOnly';
    const $7cabc464949619ac$var$SET_VALUE_METHOD = 'setValue';
    const $7cabc464949619ac$var$SET_REQUIRED_METHOD = 'setRequired';
    const $7cabc464949619ac$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
    const $7cabc464949619ac$export$8325709d137b2606 = {
        fieldName: $7cabc464949619ac$var$SET_NAME_METHOD,
        description: $7cabc464949619ac$var$SET_DESCRIPTION_METHOD,
        isVisible: $7cabc464949619ac$var$SET_VISIBLE_METHOD,
        isReadOnly: $7cabc464949619ac$var$SET_READ_ONLY_METHOD,
        value: $7cabc464949619ac$var$SET_VALUE_METHOD,
        isRequired: $7cabc464949619ac$var$SET_REQUIRED_METHOD,
        optionsVisibility: $7cabc464949619ac$var$SET_OPTIONS_VISIBILITY_METHOD
    };
    const $7cabc464949619ac$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
        const method = $7cabc464949619ac$export$8325709d137b2606[fieldProperty];
        if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
        return method;
    };
});
parcelRegister("lWjzW", function(module, exports) {
    $parcel$export(module.exports, "setError", ()=>$3b252ac3f49ca2f5$export$b8d0bb2aa0adefe5);
    $parcel$export(module.exports, "resetError", ()=>$3b252ac3f49ca2f5$export$7e5930c6217b1d4e);
    const $3b252ac3f49ca2f5$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
            setState({
                error: {
                    errorCode: errorProperties.errorCode,
                    fieldName: errorProperties.fieldName
                }
            });
        };
    const $3b252ac3f49ca2f5$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
            setState({
                error: null
            });
        };
});
parcelRegister("3Pzhj", function(module, exports) {
    $parcel$export(module.exports, "startFieldsInitialisationTimeout", ()=>$db69240367e29f46$export$2c0f020b89dfa30b);
    $parcel$export(module.exports, "successFieldsInitalisation", ()=>$db69240367e29f46$export$cf768a695e83eefa);
    var $4R6GH;
    var $dNpDc;
    var $bLLxY;
    var $lWjzW;
    const $db69240367e29f46$var$getTimeout = ()=>50000;
    const $db69240367e29f46$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
    const $db69240367e29f46$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
    const $db69240367e29f46$export$2c0f020b89dfa30b = ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { fieldsInitialization: fieldsInitialization } = getState();
            if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
                const timeoutId = setTimeout(()=>dispatch($db69240367e29f46$export$8ce83a9201590a5e()), $db69240367e29f46$var$getTimeout());
                setState({
                    fieldsInitialization: {
                        startTime: performance.now(),
                        timeoutId: timeoutId,
                        status: 'inProgress'
                    }
                });
            }
        };
    const $db69240367e29f46$export$8ce83a9201590a5e = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
            const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
            const { startTime: startTime, status: status } = fieldsInitialization;
            if ($db69240367e29f46$var$isFieldInitialisationComplete(status) || ((0, (0, parcelRequire("4R6GH")).fg)('forge_ui_modifications_for_screen_tabs') ? (0, (0, parcelRequire("bLLxY")).selectReadyPublicDataForOnInit)(getState(), {
                viewType: viewType
            }) !== null : (0, (0, parcelRequire("bLLxY")).selectReadyFieldsOld)(getState(), undefined) !== null)) return;
            dispatch((0, (0, parcelRequire("lWjzW")).setError)({
                errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
            }));
            (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization timedOut', viewType, {
                previousStatus: status,
                configuredTimeout: $db69240367e29f46$var$getTimeout(),
                fieldsInitializationTime: $db69240367e29f46$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields
            });
            setState({
                fieldsInitialization: {
                    ...fieldsInitialization,
                    status: 'timedOut'
                }
            });
        };
    const $db69240367e29f46$export$cf768a695e83eefa = ()=>({ getState: getState, setState: setState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
            const { status: status } = getState().fieldsInitialization;
            if ($db69240367e29f46$var$isFieldInitialisationComplete(status)) return;
            const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
            const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
            clearTimeout(timeoutId);
            (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization success', viewType, {
                previousStatus: status,
                fieldsInitializationTime: $db69240367e29f46$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields
            });
            setState({
                fieldsInitialization: {
                    ...fieldsInitialization,
                    status: 'success'
                }
            });
        };
});
parcelRegister("bLLxY", function(module, exports) {
    $parcel$export(module.exports, "selectReadyFieldsOld", ()=>$f325d3a34d0ad276$export$8f4fb114be4d807);
    $parcel$export(module.exports, "selectReadyPublicDataForOnInit", ()=>$f325d3a34d0ad276$export$4cadeedb8c3f31f7);
    var $6dDSs;
    var $d9r6K;
    const $f325d3a34d0ad276$export$8f4fb114be4d807 = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, experienceDataIsLoading)=>{
        if (formData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return formData;
        return null;
    });
    const $f325d3a34d0ad276$export$4cadeedb8c3f31f7 = (0, (0, parcelRequire("6dDSs")).createSelector)((_, props)=>props.viewType, (state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
        if (formData !== null && !(0, (0, parcelRequire("d9r6K")).isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
            formData: formData,
            screenTabsData: []
        };
        if (formData !== null && screenTabsData !== null && (0, (0, parcelRequire("d9r6K")).isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
            formData: formData,
            screenTabsData: screenTabsData
        };
        return null;
    });
});
parcelRegister("d9r6K", function(module, exports) {
    $parcel$export(module.exports, "getSupportedFieldConfiguration", ()=>$f28ca877f892a554$export$8fc8d6775f1842b8);
    $parcel$export(module.exports, "isFieldTypeSupported", ()=>$f28ca877f892a554$export$b47920a5dd99844f);
    $parcel$export(module.exports, "getConsentMessage", ()=>$f28ca877f892a554$export$20eabd2b3ada6bf3);
    $parcel$export(module.exports, "isProjectTypeSupported", ()=>$f28ca877f892a554$export$cd7c26587dda4120);
    $parcel$export(module.exports, "getAnalytics", ()=>$f28ca877f892a554$export$b0297573c90085aa);
    $parcel$export(module.exports, "isTriggerPointSupported", ()=>$f28ca877f892a554$export$ef45e4471aa21b27);
    $parcel$export(module.exports, "isScreenTabsSupportEnabled", ()=>$f28ca877f892a554$export$71e5898a2b967ce3);
    var $9myvH;
    var $7vOTV;
    const $f28ca877f892a554$var$isKeyOf = (key, object)=>object[key] !== undefined;
    const $f28ca877f892a554$var$getConfigurationByViewType = ({ viewType: viewType })=>{
        const viewConfiguration = (0, (0, parcelRequire("7vOTV")).getViewConfiguration)(viewType);
        if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
        return viewConfiguration;
    };
    function $f28ca877f892a554$export$8fc8d6775f1842b8(viewType, fieldType) {
        const fieldsConfiguration = $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedFieldsConfiguration();
        if (!$f28ca877f892a554$var$isKeyOf(fieldType, fieldsConfiguration)) {
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: new Error('Unsupported field type.'),
                id: 'getSupportedFieldConfiguration',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
            return undefined;
        }
        return fieldsConfiguration[fieldType];
    }
    const $f28ca877f892a554$export$e4330d77fd93d1de = (viewType)=>$f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedFieldTypes();
    const $f28ca877f892a554$export$72171ea4e785fc66 = (viewType)=>$f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedProjectTypes();
    function $f28ca877f892a554$export$b47920a5dd99844f(viewType, fieldType) {
        return fieldType !== undefined && $f28ca877f892a554$export$e4330d77fd93d1de(viewType).includes(fieldType);
    }
    function $f28ca877f892a554$export$20eabd2b3ada6bf3(viewType) {
        return $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getConsentMessage();
    }
    function $f28ca877f892a554$export$cd7c26587dda4120(project, viewType) {
        return $f28ca877f892a554$export$72171ea4e785fc66(viewType).includes(project.type);
    }
    function $f28ca877f892a554$export$b0297573c90085aa(viewType) {
        return $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getAnalytics();
    }
    function $f28ca877f892a554$export$c0728caa743a409e(viewType) {
        return $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedTriggerPointsConfiguration();
    }
    const $f28ca877f892a554$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $f28ca877f892a554$export$c0728caa743a409e(viewType).has(triggerPoint);
    const $f28ca877f892a554$export$71e5898a2b967ce3 = (viewType)=>$f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).isScreenTabsSupportEnabled();
});
parcelRegister("9myvH", function(module, exports) {
    $parcel$export(module.exports, "fireIAErrorAnalytics", ()=>$10357a302bd65fc5$export$319cadf5a1a1b6a7);
    var $jcw0u;
    var $bPtOr;
    const $10357a302bd65fc5$export$319cadf5a1a1b6a7 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        const packageName = `${viewType}jiraUiModifications`;
        (0, (0, parcelRequire("jcw0u")).default)({
            event: event,
            meta: {
                id: id,
                packageName: packageName,
                teamName: 'unbox'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorType: errorType,
                ...attributes
            }
        });
    };
    const $10357a302bd65fc5$export$7ca48916618a8ab2 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        const packageName = 'jiraUiModifications';
        (0, (0, parcelRequire("jcw0u")).default)({
            event: event,
            meta: {
                id: id,
                teamName: 'unbox',
                packageName: packageName
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorType: errorType,
                ...attributes,
                viewType: viewType
            }
        });
    };
});
parcelRegister("7vOTV", function(module, exports) {
    $parcel$export(module.exports, "getViewConfiguration", ()=>$bbfcfa56d4cc54c6$export$176b6e68da08ffa2);
    $parcel$export(module.exports, "useLoadViewConfiguration", ()=>$bbfcfa56d4cc54c6$export$f0022a21ccd1f6be);
    var $5uXOq = parcelRequire("5uXOq");
    const $bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS = new Map();
    const $bbfcfa56d4cc54c6$export$cda1ad403b37fe70 = (viewType, configuration)=>{
        if (!$bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.has(viewType)) $bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
    };
    const $bbfcfa56d4cc54c6$export$176b6e68da08ffa2 = (viewType)=>$bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.get(viewType);
    const $bbfcfa56d4cc54c6$export$e8091eff40c4f16e = ()=>{
        $bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.clear();
    };
    const $bbfcfa56d4cc54c6$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
        (0, $5uXOq.useState)(()=>{
            $bbfcfa56d4cc54c6$export$cda1ad403b37fe70(viewType, new configurationClass());
        });
    };
});
parcelRegister("f81nP", function(module, exports) {
    $parcel$export(module.exports, "initializeField", ()=>$15384141fbdc5039$export$6b51e123e61a9615);
    $parcel$export(module.exports, "initializeFields", ()=>$15384141fbdc5039$export$4a6b4707110b0552);
    var $ePDG3;
    const $15384141fbdc5039$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
            const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, (0, parcelRequire("ePDG3")).mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            setState({
                formData: {
                    ...formData,
                    [field.fieldId]: {
                        fieldId: field.fieldId,
                        fieldName: field.fieldName,
                        description: field.description,
                        isVisible: field.isVisible,
                        fieldType: field.fieldType,
                        isReadOnly: field.isReadOnly,
                        isRequired: field.isRequired,
                        value: publicValue,
                        optionsVisibility: undefined
                    }
                },
                internalFormMetadata: {
                    ...internalFormMetadata,
                    [field.fieldId]: fieldMetadata
                }
            });
        };
    const $15384141fbdc5039$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
            const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
                const fieldMetadata = {
                    allowedValues: field.allowedValues,
                    isReadOnlyBySystem: field.isReadOnly,
                    isRequiredBySystem: field.isRequired,
                    fieldRenderer: metadata?.fieldRenderer,
                    fieldType: field.fieldType
                };
                const publicValue = (0, (0, parcelRequire("ePDG3")).mapFieldValueFromInternalToPublic)({
                    fieldMetadata: fieldMetadata,
                    internalFieldValue: field.value,
                    fieldType: field.fieldType,
                    viewType: viewType
                });
                acc.formData[field.fieldId] = {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                };
                acc.internalFormMetadata[field.fieldId] = fieldMetadata;
                return acc;
            }, {
                internalFormMetadata: {},
                formData: {}
            });
            setState({
                formData: formData,
                internalFormMetadata: internalFormMetadata,
                numberOfSupportedFields: fields.length
            });
        };
});
parcelRegister("ePDG3", function(module, exports) {
    $parcel$export(module.exports, "mapFieldValueFromInternalToPublic", ()=>$c6f6fbfe7e0233e1$export$50806045b617d116);
    var $9myvH;
    var $d9r6K;
    const $c6f6fbfe7e0233e1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
        if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
        let value = internalFieldValue;
        try {
            const valueTransformer = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
            if (valueTransformer) value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
        } catch (error) {
            value = null;
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: error,
                id: 'internalToPublicValueTransformer',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
        }
        return value;
    };
});
parcelRegister("l97Ge", function(module, exports) {
    $parcel$export(module.exports, "initializeNoScreenTab", ()=>$d2f40011899724e0$export$93459ad9bfd6c380);
    const $d2f40011899724e0$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
            setState({
                screenTabs: []
            });
        };
});
parcelRegister("2MPbo", function(module, exports) {
    $parcel$export(module.exports, "initializeScreenTabs", ()=>$02ea37ca59c50e7a$export$7f7be235f64f029b);
    const $02ea37ca59c50e7a$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
            const { screenTabs: internalScreenTabs } = getState();
            const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
            setState({
                screenTabs: tabs.map(({ id: id }, index)=>({
                        id: id,
                        isVisible: true,
                        isActive: index === selected || index === previouslySelected
                    }))
            });
        };
});
parcelRegister("gwqYE", function(module, exports) {
    $parcel$export(module.exports, "processChange", ()=>$ce014541a04fdd22$export$352dfcce04d66748);
    var $3ZT8o = parcelRequire("3ZT8o");
    var $4R6GH;
    var $d9r6K;
    var $bhqjS;
    const $ce014541a04fdd22$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType, fieldType: fieldType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
            const emitChangeOn = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
            if (emitChangeOn !== eventType) return;
            const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
            const nextFormData = (0, (0, parcelRequire("bhqjS")).calculateNextFormValue)({
                internalFormMetadata: internalFormMetadata,
                formData: formData,
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: fieldValue,
                viewType: viewType
            });
            if (nextFormData === null) return;
            setTimeout(()=>{
                const changeId = (0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps') ? (0, ($parcel$interopDefault($3ZT8o)))() : undefined;
                setState({
                    lastProcessedChange: {
                        fieldId: fieldId,
                        changeId: changeId
                    },
                    formData: nextFormData
                });
            }, 0);
        };
});
parcelRegister("3ZT8o", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $2e91d6202798e8a1$var$idCounter = 0;
    function $2e91d6202798e8a1$var$uniqueId(prefix) {
        var id = ++$2e91d6202798e8a1$var$idCounter;
        return $jJVtR(prefix) + id;
    }
    module.exports = $2e91d6202798e8a1$var$uniqueId;
});
parcelRegister("bhqjS", function(module, exports) {
    $parcel$export(module.exports, "calculateNextFormValue", ()=>$df2387a66dda51fa$export$25441a03bb8f1cb0);
    var $ajpes = parcelRequire("ajpes");
    var $dNpDc;
    var $ePDG3;
    const $df2387a66dda51fa$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
        if (formData === null) return null;
        let newPublicValue;
        try {
            newPublicValue = (0, (0, parcelRequire("ePDG3")).mapFieldValueFromInternalToPublic)({
                fieldMetadata: internalFormMetadata[fieldId],
                internalFieldValue: fieldValue,
                fieldType: fieldType,
                viewType: viewType
            });
        } catch (e) {
            (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('internalToPublicValueTransformer', 'fieldMetadataUndefined', viewType, {
                fieldType: fieldType
            });
            return null;
        }
        const currentPublicValue = formData[fieldId]?.value;
        if ((0, ($parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
        return {
            ...formData,
            [fieldId]: {
                ...formData[fieldId],
                value: newPublicValue
            }
        };
    };
});
parcelRegister("ifTQq", function(module, exports) {
    $parcel$export(module.exports, "registerFields", ()=>$490b4304c5c98fd8$export$d4eb181b231cf88d);
    $parcel$export(module.exports, "unregisterFields", ()=>$490b4304c5c98fd8$export$1ca69a85bb7273de);
    var $fr1K2 = parcelRequire("fr1K2");
    var $kGsr8 = parcelRequire("kGsr8");
    var $4R6GH;
    const $490b4304c5c98fd8$var$registerFieldsFFOn = ({ getState: getState, setState: setState, changeId: changeId, appId: appId, fieldsToBeRegistered: fieldsToBeRegistered })=>{
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, ($parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
    const $490b4304c5c98fd8$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
            if (!Array.isArray(fieldsToBeRegistered)) return;
            if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) $490b4304c5c98fd8$var$registerFieldsFFOn({
                getState: getState,
                setState: setState,
                changeId: changeId,
                appId: appId,
                fieldsToBeRegistered: fieldsToBeRegistered
            });
            else {
                const alreadyRegisteredFields = getState().registeredFieldsDeprecated;
                setState({
                    registeredFieldsDeprecated: {
                        ...alreadyRegisteredFields,
                        [changeId]: fieldsToBeRegistered
                    }
                });
            }
        };
    const $490b4304c5c98fd8$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) {
                const { registeredFields: registeredFields } = getState();
                const registeredAppFields = registeredFields[appId] ?? {};
                const nextRegisteredAppFields = (0, ($parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
                setState({
                    registeredFields: {
                        ...registeredFields,
                        [appId]: nextRegisteredAppFields
                    }
                });
            } else setState({
                registeredFieldsDeprecated: (0, ($parcel$interopDefault($fr1K2)))(getState().registeredFieldsDeprecated, changeId)
            });
        };
});
parcelRegister("hk40m", function(module, exports) {
    $parcel$export(module.exports, "setFieldValue", ()=>$958b56c0b5134e36$export$6556d46d2662453c);
    var $bhqjS;
    const $958b56c0b5134e36$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
            const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
            if (!internalFormMetadata[fieldId]) return;
            const nextFormData = (0, (0, parcelRequire("bhqjS")).calculateNextFormValue)({
                internalFormMetadata: internalFormMetadata,
                formData: formData,
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: fieldValue,
                viewType: viewType
            });
            if (nextFormData === null) return;
            setState({
                formData: nextFormData
            });
        };
});
parcelRegister("bAAVc", function(module, exports) {
    $parcel$export(module.exports, "updateActiveScreenTab", ()=>$f1d096c94b789717$export$21363496760d39cd);
    const $f1d096c94b789717$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
            const { screenTabs: screenTabs } = getState();
            if (screenTabs) setState({
                screenTabs: screenTabs.map((tab, index)=>({
                        ...tab,
                        isActive: index === selected
                    }))
            });
        };
});
parcelRegister("5pnmQ", function(module, exports) {
    $parcel$export(module.exports, "updateFields", ()=>$3fb6e39de728db49$export$cceae62fd4d1ef0a);
    var $gccSB = parcelRequire("gccSB");
    var $4R6GH;
    var $dNpDc;
    var $93Yir;
    var $hni9B;
    var $1u7E9;
    var $kVUQH;
    var $gMXSj;
    var $9gKFJ;
    var $fB4oc;
    const $3fb6e39de728db49$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId, intl: intl })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) {
                await dispatch($3fb6e39de728db49$export$7a87c0c70cfb2bfe({
                    changeId: changeId,
                    fieldsChanges: fieldsChanges,
                    lookupDataFromApi: lookupDataFromApi,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    appId: appId,
                    intl: intl
                }));
                return;
            }
            const appliedChanges = getState().appliedChanges || {};
            const formData = getState().formData || {};
            const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, registeredFieldsDeprecated: registeredFieldsDeprecated } = getState();
            const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
                const fieldData = formData[fieldId];
                const internalMetadata = internalFormMetadata[fieldId];
                const fieldIsRegistered = (0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps') ? (0, (0, parcelRequire("hni9B")).fieldWasRegistered)(registeredFields, changeId, fieldId, appId) : (0, (0, parcelRequire("hni9B")).fieldWasRegisteredDeprecated)(registeredFieldsDeprecated, changeId, fieldId);
                if (!fieldIsRegistered || !fieldData) {
                    console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                    (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId
                    });
                    return acc;
                }
                const lookupData = {
                    [(0, $e774cb836eab763c$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                    [(0, $e774cb836eab763c$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $e774cb836eab763c$export$3a106242c8f57ac2]
                };
                const supportedFieldChanges = await (0, (0, parcelRequire("fB4oc")).transformFieldChangesToInternalShape)({
                    fieldType: fieldData.fieldType,
                    fieldId: fieldId,
                    fieldFromIframe: fieldsChanges?.[fieldId],
                    lookupData: lookupData,
                    viewType: viewType,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    intl: intl
                });
                if (supportedFieldChanges.isValid === false) {
                    (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                    return acc;
                }
                const publicShapeChanges = (0, (0, parcelRequire("gMXSj")).transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
                const transformedFieldChanges = (0, (0, parcelRequire("1u7E9")).mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
                const combinedChangesToApply = {
                    ...appliedChanges[fieldId],
                    ...transformedFieldChanges
                };
                if (!(0, ($parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                    (await acc).changesToApply[fieldId] = combinedChangesToApply;
                    (await acc).incomingFormData[fieldId] = {
                        ...formData[fieldId],
                        ...publicShapeChanges
                    };
                }
                return acc;
            }, Promise.resolve({
                changesToApply: {
                    ...appliedChanges
                },
                incomingFormData: {
                    ...formData
                },
                errorsByField: {}
            }));
            if (!(0, ($parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, (0, parcelRequire("93Yir")).UiModificationsFieldsValidationError)('Transformation failed', {
                errors: (0, (0, parcelRequire("kVUQH")).prepareErrorsArray)(errorsByField)
            });
            setState({
                appliedChanges: changesToApply,
                formData: incomingFormData
            });
        };
    const $3fb6e39de728db49$export$7a87c0c70cfb2bfe = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId, intl: intl })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
            const appliedChanges = getState().appliedChanges ?? {};
            const formData = getState().formData ?? {};
            const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
            const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
                const fieldData = formData[fieldId];
                const internalMetadata = internalFormMetadata[fieldId];
                const fieldIsRegistered = (0, (0, parcelRequire("hni9B")).fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
                if (!fieldIsRegistered || !fieldData) {
                    console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                    (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId
                    });
                    return acc;
                }
                const lookupData = {
                    [(0, $e774cb836eab763c$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                    [(0, $e774cb836eab763c$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $e774cb836eab763c$export$3a106242c8f57ac2]
                };
                const supportedFieldChanges = await (0, (0, parcelRequire("fB4oc")).transformFieldChangesToInternalShape)({
                    fieldType: fieldData.fieldType,
                    fieldId: fieldId,
                    fieldFromIframe: fieldsChanges?.[fieldId],
                    lookupData: lookupData,
                    viewType: viewType,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    intl: intl
                });
                if (supportedFieldChanges.isValid === false) {
                    (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                    return acc;
                }
                const publicShapeChanges = (0, (0, parcelRequire("gMXSj")).transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
                const transformedFieldChanges = (0, (0, parcelRequire("1u7E9")).mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
                const combinedChangesToApply = {
                    ...appliedChanges[fieldId],
                    ...transformedFieldChanges
                };
                if (!(0, ($parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                    (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                    (await acc).changesToApply[fieldId] = combinedChangesToApply;
                    (await acc).incomingFormData[fieldId] = {
                        ...formData[fieldId],
                        ...publicShapeChanges
                    };
                }
                return acc;
            }, Promise.resolve({
                changesToApply: {
                    ...appliedChanges
                },
                incomingFormData: {
                    ...formData
                },
                newAppliedChangesPublic: {},
                errorsByField: {}
            }));
            if (!(0, ($parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, (0, parcelRequire("93Yir")).UiModificationsFieldsValidationError)('Transformation failed', {
                errors: (0, (0, parcelRequire("kVUQH")).prepareErrorsArray)(errorsByField)
            });
            setState({
                appliedChanges: changesToApply,
                formData: incomingFormData
            });
            dispatch((0, (0, parcelRequire("9gKFJ")).collectFieldsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                fieldsChanges: newAppliedChangesPublic
            }));
        };
});
const $e774cb836eab763c$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $e774cb836eab763c$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $e774cb836eab763c$export$f5d5f6bb902f1027 = '-1';
const $e774cb836eab763c$export$106087dcfd4fb129 = 100;
parcelRegister("93Yir", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsFieldsValidationError", ()=>$5b6f63ca0e228ddb$export$9e8b5e552e255163);
    var $gUcnt;
    class $5b6f63ca0e228ddb$export$9e8b5e552e255163 extends (0, (0, parcelRequire("gUcnt")).UiModificationsValidationError) {
        constructor(message, attributes, cause){
            super(message, attributes, 'fields', cause);
        }
    }
});
parcelRegister("gUcnt", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsValidationError", ()=>$8e0bfdee7bf98a33$export$6e8165c81a6a65df);
    class $8e0bfdee7bf98a33$export$6e8165c81a6a65df extends Error {
        constructor(message, attributes, validationErrorType, cause){
            super(message, cause);
            this.attributes = attributes;
            this.validationErrorType = validationErrorType;
        }
    }
});
parcelRegister("hni9B", function(module, exports) {
    $parcel$export(module.exports, "fieldWasRegisteredDeprecated", ()=>$cfee9dff1dd1041b$export$fce3a63433d10493);
    $parcel$export(module.exports, "fieldWasRegistered", ()=>$cfee9dff1dd1041b$export$fbe9157c12cb4e7b);
    const $cfee9dff1dd1041b$export$fce3a63433d10493 = (registeredFields, changeId, fieldId)=>registeredFields[changeId]?.includes(fieldId);
    const $cfee9dff1dd1041b$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);
});
parcelRegister("1u7E9", function(module, exports) {
    $parcel$export(module.exports, "mapFieldPropertyNamesToInternal", ()=>$e9fe99ede0bfc5ac$export$460820f27643954e);
    var $d9r6K;
    const $e9fe99ede0bfc5ac$export$460820f27643954e = (properties, viewType, fieldType)=>{
        const fieldConfiguration = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType);
        const propertyMapping = fieldConfiguration?.propertyMapping;
        if (!propertyMapping) return properties;
        return Object.keys(properties).reduce((acc, propertyName)=>{
            const propertyMappingValue = propertyMapping[propertyName];
            acc[propertyMappingValue ?? propertyName] = properties[propertyName];
            return acc;
        }, {});
    };
});
parcelRegister("kVUQH", function(module, exports) {
    $parcel$export(module.exports, "prepareErrorsArray", ()=>$55355faba3ba8aca$export$e1fce51bc5be90b7);
    const $55355faba3ba8aca$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();
});
parcelRegister("gMXSj", function(module, exports) {
    $parcel$export(module.exports, "transformFieldToIframe", ()=>$ff2054f6419ee419$export$aa453854f74fab);
    var $9myvH;
    var $d9r6K;
    const $ff2054f6419ee419$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
        const fieldConfiguration = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType);
        const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
        const publicShapeField = {
            ...fieldChanges
        };
        if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
            publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
        } catch (err) {
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: err,
                id: 'internalToPublicValueTransformer',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
        }
        if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
            const lookupSource = fieldConfiguration?.lookupSource;
            const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
            publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
        } catch (err) {
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: err,
                id: 'internalToPublicOptionsVisibilityTransformer',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
        }
        return publicShapeField;
    };
});
parcelRegister("fB4oc", function(module, exports) {
    $parcel$export(module.exports, "transformFieldChangesToInternalShape", ()=>$e45f458eeb3547af$export$d14f85c01e334a1);
    var $gccSB = parcelRequire("gccSB");
    var $4R6GH;
    var $iyelu;
    var $d9r6K;
    var $7wDhr;
    var $6rgBv;
    var $ipjHo;
    const $e45f458eeb3547af$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, viewContext: viewContext, environment: environment, intl: intl })=>{
        const fieldConfiguration = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType);
        const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
        const fieldValidators = fieldConfiguration?.publicShapeValidators;
        if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
            ...(0, (0, parcelRequire("6rgBv")).VALID_RESULT),
            data: {}
        };
        const validatorsArray = Object.keys(fieldValidators);
        const lookupSource = fieldConfiguration?.lookupSource;
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
            if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, (0, parcelRequire("6rgBv")).VALID_RESULT;
            const propertyValue = fieldFromIframe[propertyName];
            const transformer = fieldTransformers[propertyName];
            const fieldContext = {
                fieldId: fieldId
            };
            try {
                const data = transformer ? await transformer(propertyValue, lookupValues, {
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    fieldContext: fieldContext,
                    intl: (0, (0, parcelRequire("4R6GH")).fg)('getautomaticuseroption_refactoring_for_jsm') ? intl : undefined
                }) : propertyValue;
                return {
                    isValid: true,
                    data: {
                        [propertyName]: data
                    }
                };
            } catch (err) {
                if (err instanceof (0, (0, parcelRequire("iyelu")).FieldValueLookupError)) {
                    const faultyValue = err.message || propertyValue;
                    return {
                        isValid: false,
                        error: {
                            fieldId: fieldId,
                            fieldType: fieldType,
                            type: (0, $36f69991a898da6d$export$d1996cb46a690190),
                            method: (0, (0, parcelRequire("7wDhr")).mapFieldPropertyToApiMethod)(propertyName),
                            message: `Invalid IDs provided: ${faultyValue}`
                        }
                    };
                }
                throw err;
            }
        }));
        const invalidTransformationResults = (0, (0, parcelRequire("ipjHo")).filterInvalidResults)(fieldTransformationResults);
        if (!(0, ($parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
            isValid: false,
            errors: invalidTransformationResults.map((result)=>result.error)
        };
        return (0, (0, parcelRequire("ipjHo")).mapValidResultsToFieldInternalShape)(fieldTransformationResults);
    };
});
parcelRegister("iyelu", function(module, exports) {
    $parcel$export(module.exports, "FieldValueLookupError", ()=>$7d9a5d144067113e$export$73c2f0689b6c4a5a);
    class $7d9a5d144067113e$export$73c2f0689b6c4a5a extends Error {
    }
});
parcelRegister("6rgBv", function(module, exports) {
    $parcel$export(module.exports, "VALID_RESULT", ()=>$b7fbd017e17733fd$export$ee79e3ab53b8db79);
    const $b7fbd017e17733fd$export$ee79e3ab53b8db79 = {
        isValid: true
    };
});
parcelRegister("ipjHo", function(module, exports) {
    $parcel$export(module.exports, "mapValidResultsToFieldInternalShape", ()=>$9b00f9608a01c0fc$export$a60dd8f1b025f23d);
    $parcel$export(module.exports, "filterInvalidResults", ()=>$9b00f9608a01c0fc$export$ddd005554aecd409);
    const $9b00f9608a01c0fc$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
            if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
                ...acc.data,
                ...result.data
            };
            return acc;
        }, {
            isValid: true,
            data: {}
        });
    const $9b00f9608a01c0fc$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
            if (result.isValid === false) acc.push(result);
            return acc;
        }, []);
});
parcelRegister("4qdFk", function(module, exports) {
    $parcel$export(module.exports, "updateScreenTabs", ()=>$6f863ceddcde4420$export$131c67fd312b8a11);
    var $4R6GH;
    var $hkYX3;
    var $ldH1m;
    var $iQI6L;
    var $9gKFJ;
    const $6f863ceddcde4420$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { screenTabs: internalScreenTabs } = getState();
            if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
            if (internalScreenTabs && (0, (0, parcelRequire("hkYX3")).screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
                const newScreenTabs = (0, (0, parcelRequire("hkYX3")).screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
                setState({
                    screenTabs: newScreenTabs
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) dispatch((0, (0, parcelRequire("9gKFJ")).collectScreenTabsAppliedChangesHistory)({
                    appId: appId,
                    changeId: changeId,
                    screenTabs: newScreenTabs
                }));
            } else throw new (0, (0, parcelRequire("ldH1m")).UiModificationsScreenTabsValidationError)('Transformation failed', {
                errors: (0, (0, parcelRequire("hkYX3")).getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, (0, parcelRequire("iQI6L")).toScreenTabsValidationError))
            });
        };
});
parcelRegister("hkYX3", function(module, exports) {
    $parcel$export(module.exports, "screenTabsPublicToInternalTransformer", ()=>$dc3e5a7f628b7026$export$9ca9b35e7b6a8bbc);
    $parcel$export(module.exports, "screenTabsPublicToInternalValidator", ()=>$dc3e5a7f628b7026$export$e7a91e7e430e691a);
    $parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", ()=>$dc3e5a7f628b7026$export$62d63af83dac7315);
    const $dc3e5a7f628b7026$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
    const $dc3e5a7f628b7026$var$isValidScreenTabId = (internalScreenTabs, id)=>$dc3e5a7f628b7026$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
    const $dc3e5a7f628b7026$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
    const $dc3e5a7f628b7026$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
    const $dc3e5a7f628b7026$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$dc3e5a7f628b7026$var$isValidScreenTabId(internalScreenTabs, id) && $dc3e5a7f628b7026$var$isValidScreenTabIsVisible(isVisible) && $dc3e5a7f628b7026$var$isValidScreenTabIsActive(isActive);
    const $dc3e5a7f628b7026$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
        if ($dc3e5a7f628b7026$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
        return acc;
    };
    const $dc3e5a7f628b7026$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
        if ($dc3e5a7f628b7026$var$isValidScreenTabIsActive(isActive) && isActive && $dc3e5a7f628b7026$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
        return acc;
    };
    const $dc3e5a7f628b7026$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
        let numberOfActiveScreenTabs = 0;
        const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
        const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
            const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
            if (!screenTabFromApp) return screenTabInternal;
            numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
            return {
                id: screenTabInternal.id,
                isVisible: screenTabFromApp.isVisible ?? true,
                isActive: screenTabFromApp.isActive
            };
        });
        if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
        return screenTabsInternalUpdated;
    };
    const $dc3e5a7f628b7026$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
        if (!Array.isArray(screenTabsFromApp)) return false;
        const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$dc3e5a7f628b7026$var$isValidScreenTabData(internalScreenTabs, data));
        const numberOfActiveScreenTabs = screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfActiveScreenTabs, 0);
        const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfHiddenActiveScreenTabs, 0);
        return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
    };
    const $dc3e5a7f628b7026$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
        if (!internalScreenTabs) return [
            'There are no screen tabs in the current view.'
        ];
        if (!Array.isArray(screenTabsFromApp)) return [
            'Your app must return screen tabs as an array.'
        ];
        const errors = [];
        if (screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
        if (screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
        return errors;
    };
});
parcelRegister("ldH1m", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsScreenTabsValidationError", ()=>$0cba70b8975758a2$export$faf1f1824ee0a136);
    var $gUcnt;
    class $0cba70b8975758a2$export$faf1f1824ee0a136 extends (0, (0, parcelRequire("gUcnt")).UiModificationsValidationError) {
        constructor(message, attributes, cause){
            super(message, attributes, 'screenTabs', cause);
        }
    }
});
parcelRegister("iQI6L", function(module, exports) {
    $parcel$export(module.exports, "toScreenTabsValidationError", ()=>$e7f1397478a6ee9f$export$b2675440ade984fb);
    const $e7f1397478a6ee9f$export$b2675440ade984fb = (message)=>({
            message: message,
            type: (0, $36f69991a898da6d$export$fd26696d109785a0)
        });
});
parcelRegister("5eGnF", function(module, exports) {
    $parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", ()=>$700db8c378cd19d9$export$876003a5b887f37e);
    const $700db8c378cd19d9$export$876003a5b887f37e = {
        MODAL_OPENED: 'MODAL_OPENED',
        MODAL_CLOSED: 'MODAL_CLOSED',
        MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
        MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
        MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
        MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
        MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
        CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
        CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
        ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
        PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
        ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
        RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
        USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
        STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
        CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
        CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
        FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
    };
});
parcelRegister("9svjh", function(module, exports) {
    $parcel$export(module.exports, "useGICLifeCycleEvents", ()=>$d9b2e43e4699b192$export$e3ff72f196296fcc);
    var $1mrD8;
    const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, (0, parcelRequire("1mrD8")).PubSubHub)();
    const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
            ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
        });
});
parcelRegister("1mrD8", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
    class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
const $380826ec5efdda82$export$e615b7e9b8fb4715 = 'GIC';
parcelRegister("2eeg1", function(module, exports) {
    $parcel$export(module.exports, "FieldValueDecoratorAsync", ()=>$58ac5136636efa9f$export$24545fc29fe55980);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCJ2;
    var $d9r6K;
    var $62s0B;
    const $58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
        const adjustmentsAreEnabled = (0, (0, parcelRequire("laCJ2")).useAdjustmentsEnabled)();
        const undecoratedResult = children(fieldProps);
        if ((0, (0, parcelRequire("d9r6K")).isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62s0B")).EnabledFieldValueDecorator), {
            fieldProps: fieldProps,
            fieldId: fieldId,
            fieldType: fieldType
        }, children);
        return undecoratedResult;
    };
    const $58ac5136636efa9f$export$24545fc29fe55980 = (0, $5uXOq.memo)($58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo);
});
parcelRegister("laCJ2", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$f7dbb0638e5239f0$export$6f57813fe9f31bf9);
    $parcel$export(module.exports, "useAdjustmentsEnabled", ()=>$f7dbb0638e5239f0$export$358ad850b2f6d6fe);
    $parcel$export(module.exports, "useAdjustmentsContextActions", ()=>$f7dbb0638e5239f0$export$4f2729981f4b81d2);
    $parcel$export(module.exports, "UiModificationContextContainer", ()=>$f7dbb0638e5239f0$export$5eb9c167b683d125);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    const $f7dbb0638e5239f0$var$initialState = {
        shouldUiModificationsLoad: 'unknown',
        hasFinishedLoading: false,
        adjustmentsAreEnabled: false,
        uiModificationsConsentStatusDeprecated: (0, $2aeb8c12bc7d07a0$export$39d15f3568f5a72c),
        uiModificationsConsentStatus: {}
    };
    const $f7dbb0638e5239f0$export$e324594224ef24da = {
        resetAdjustmentContext: ()=>({ setState: setState })=>{
                setState($f7dbb0638e5239f0$var$initialState);
            },
        setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
                setState({
                    shouldUiModificationsLoad: status
                });
            },
        setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
                setState({
                    hasFinishedLoading: hasFinishedLoading
                });
            },
        setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
                setState({
                    adjustmentsAreEnabled: enabled
                });
            },
        setUIModificationsConsentStatusDeprecated: (enabled)=>({ setState: setState })=>{
                setState({
                    uiModificationsConsentStatusDeprecated: enabled
                });
            },
        setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
                const currentConsentState = getState().uiModificationsConsentStatus;
                setState({
                    uiModificationsConsentStatus: {
                        ...currentConsentState,
                        [appId]: status
                    }
                });
            }
    };
    const $f7dbb0638e5239f0$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-adjustments-context',
        initialState: $f7dbb0638e5239f0$var$initialState,
        actions: $f7dbb0638e5239f0$export$e324594224ef24da
    });
    const $f7dbb0638e5239f0$export$a12f82a132dee079 = (0, (0, parcelRequire("3sQ5x")).createHook)($f7dbb0638e5239f0$export$6f57813fe9f31bf9);
    const $f7dbb0638e5239f0$export$358ad850b2f6d6fe = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f7dbb0638e5239f0$export$6f57813fe9f31bf9, {
        selector: (state)=>state.adjustmentsAreEnabled
    });
    const $f7dbb0638e5239f0$export$4f2729981f4b81d2 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f7dbb0638e5239f0$export$6f57813fe9f31bf9);
    const $f7dbb0638e5239f0$export$5eb9c167b683d125 = (0, (0, parcelRequire("gg7kZ")).createContainer)($f7dbb0638e5239f0$export$6f57813fe9f31bf9, {
        displayName: 'UiModificationContextContainer'
    });
});
const $2aeb8c12bc7d07a0$export$39d15f3568f5a72c = 'unknown';
const $2aeb8c12bc7d07a0$export$d67d63332ce3ce38 = 'required';
const $2aeb8c12bc7d07a0$export$45ca911896c5084f = 'consented';
parcelRegister("62s0B", function(module, exports) {
    $parcel$export(module.exports, "EnabledFieldValueDecorator", ()=>$f47b896eac91b738$export$9d96bb1f53295b76);
    var $asu2W;
    var $9QJ7Z;
    const $f47b896eac91b738$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldType: fieldType, fieldProps: fieldProps })=>{
        const { onBlur: onBlur, onChange: onChange } = fieldProps;
        const { getFieldValue: getFieldValue } = (0, (0, parcelRequire("9QJ7Z")).useFormApi)();
        const { processChange: processChange } = (0, (0, parcelRequire("asu2W")).useIssueAdjustmentsActions)();
        const processChangeByType = (eventType)=>{
            processChange({
                fieldId: fieldId,
                fieldValue: getFieldValue(fieldId),
                eventType: eventType,
                fieldType: fieldType
            });
        };
        const interceptedFieldProps = {
            ...fieldProps,
            onChange: (modifiedValue)=>{
                onChange(modifiedValue);
                processChangeByType('change');
            },
            onBlur: ()=>{
                onBlur();
                processChangeByType('blur');
            }
        };
        return children(interceptedFieldProps);
    };
});
parcelRegister("9QJ7Z", function(module, exports) {
    $parcel$export(module.exports, "FormApiProvider", ()=>$33387961dd1f98b9$export$1e7be89a21d0c0ae);
    $parcel$export(module.exports, "useFormApi", ()=>$33387961dd1f98b9$export$4607062597b2b4df);
    var $5uXOq = parcelRequire("5uXOq");
    const $33387961dd1f98b9$var$Context = (0, $5uXOq.createContext)(null);
    const $33387961dd1f98b9$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
        const setFieldValueRef = (0, $5uXOq.useRef)(setFieldValue);
        setFieldValueRef.current = setFieldValue;
        const getFormStateRef = (0, $5uXOq.useRef)(getFormState);
        getFormStateRef.current = getFormState;
        const value = (0, $5uXOq.useMemo)(()=>({
                setFieldValue: (...args)=>setFieldValueRef.current(...args),
                getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId]
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($33387961dd1f98b9$var$Context.Provider, {
            value: value
        }, children);
    };
    const $33387961dd1f98b9$export$4607062597b2b4df = ()=>{
        const context = (0, $5uXOq.useContext)($33387961dd1f98b9$var$Context);
        if (context === null) throw new Error('Missing FormApiProvider');
        return context;
    };
});
parcelRegister("aBZin", function(module, exports) {
    $parcel$export(module.exports, "getValueFromEventOrValue", ()=>$56aa95be299fa4e4$export$a59801673b41acfd);
    function $56aa95be299fa4e4$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $56aa95be299fa4e4$export$a59801673b41acfd(eventOrValue) {
        if ($56aa95be299fa4e4$var$isEvent(eventOrValue)) {
            const { currentTarget: currentTarget } = eventOrValue;
            if (currentTarget.type === 'checkbox') {
                if (currentTarget.checked) return currentTarget.value || true;
                return currentTarget.value ? undefined : false;
            }
            if (currentTarget) return currentTarget.value;
        }
        return eventOrValue;
    }
});
parcelRegister("45JN1", function(module, exports) {
    $parcel$export(module.exports, "FieldMessage", ()=>$f046862319512079$export$eb5013679a5d3f69);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $kOFhM;
    var $c4CWe;
    var $jRBku;
    var $f9FHW;
    var $loZC0;
    var $h17zy;
    var $4R6GH;
    var $aWse0;
    var $6a30R;
    var $4IoOR;
    var $aQb3V;
    const $f046862319512079$var$FieldHelpLink = (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl })=>{
        const learnMoreMessage = (0, (0, parcelRequire("aQb3V")).getLearnMoreMessage)(fieldHelpTextUrl ?? '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRBku")).default), {
            href: fieldHelpTextUrl,
            target: "_blank"
        }, formatMessage(learnMoreMessage));
    });
    const $f046862319512079$var$FieldMessageBehaviour = (props)=>{
        const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const maxHeight = 22;
        const emojiProvider = (0, (0, parcelRequire("h17zy")).useEmojiProvider)();
        const adfDocument = (0, $5uXOq.useMemo)(()=>{
            if (error) return null;
            if ((0, (0, parcelRequire("4R6GH")).fg)('replace_anchor_with_link')) return (0, (0, parcelRequire("4IoOR")).convertWikiToAdf)(description);
            let fieldDescription = description;
            if (fieldHelpTextUrl) {
                if (fieldDescription) fieldDescription = `${fieldDescription} ${(0, (0, parcelRequire("aQb3V")).getHelpText)(fieldHelpTextUrl, formatMessage)}`;
                else fieldDescription = (0, (0, parcelRequire("aQb3V")).getHelpText)(fieldHelpTextUrl, formatMessage);
            }
            return (0, (0, parcelRequire("4IoOR")).convertWikiToAdf)(fieldDescription);
        }, [
            description,
            error,
            fieldHelpTextUrl,
            formatMessage
        ]);
        if (error !== undefined && error !== false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).ErrorMessage), null, (0, (0, parcelRequire("aQb3V")).getErrorMessage)(error, fieldName, formatMessage, formatNumber));
        if (!adfDocument && !fieldHelpTextUrl) return null;
        const getRenderer = (isTruncated = false)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9FHW")).default), {
                document: adfDocument,
                schema: (0, (0, parcelRequire("kOFhM")).defaultSchema),
                dataProviders: emojiProvider,
                disableHeadingIDs: true,
                featureFlags: {
                    codeBidiWarnings: true,
                    'code-bidi-warnings': true,
                    'renderer-tti-tracking': (0, (0, parcelRequire("4R6GH")).fg)('renderer_tti_tracking_jira'),
                    'allow-windowed-code-block': true
                },
                maxHeight: isTruncated ? maxHeight : undefined,
                truncated: isTruncated,
                fadeOutHeight: isTruncated ? 0 : undefined,
                eventHandlers: {
                    smartCard: {
                        onClick: (0, (0, parcelRequire("6a30R")).onLinkClick)
                    },
                    link: {
                        onClick: onLinkClickEvent || (0, (0, parcelRequire("6a30R")).onLinkClick)
                    }
                },
                smartLinks: (0, (0, parcelRequire("6a30R")).smartLinksDefault)
            });
        const getRenderedDescription = (truncatedRenderer = false)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4CWe")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$Description, {
                "data-testid": "issue-create-commons.common.ui.field-message.description",
                isMini: isMini,
                ...fieldId && {
                    id: `${fieldId}-field-message`
                }
            }, adfDocument && getRenderer(truncatedRenderer), fieldHelpTextUrl && (0, (0, parcelRequire("4R6GH")).fg)('replace_anchor_with_link') && (0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldHelpLink, {
                fieldHelpTextUrl: fieldHelpTextUrl
            })));
        if (isMini) {
            if (adfDocument?.content[0]?.type === 'paragraph') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$TooltipContentContainer, null, getRenderer()),
                position: "bottom"
            }, getRenderedDescription(true));
            return null;
        }
        return getRenderedDescription();
    };
    const $f046862319512079$export$eb5013679a5d3f69 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldMessageBehaviour, {
            key: `field-message-${props.fieldId}`,
            ...props
        });
    const $f046862319512079$var$TooltipContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_woio15cr _1f1h16g6 _13odidpf _9j7z1moj",
                __cmplp.className
            ])
        });
    });
    const $f046862319512079$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isMini: isMini, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_162p546": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isMini && {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                })
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_woio1wmz _1f1hqk37 _13od1b66 _1pz31ynx",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kOFhM", function(module, exports) {
    $parcel$export(module.exports, "defaultSchemaConfig", ()=>$f27880a8173018db$export$e4e3ac1fa64862db);
    $parcel$export(module.exports, "getSchemaBasedOnStage", ()=>$f27880a8173018db$export$fd147e7d448dea03);
    $parcel$export(module.exports, "defaultSchema", ()=>$f27880a8173018db$export$1db618b7b2275ea1);
    var $8QpSo;
    var $aXBFx;
    var $7kC9H;
    var $47jug;
    var $gZoER;
    var $2FIVU;
    var $bFtEE;
    var $9UDEr;
    var $kBho7;
    const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
        const defaultSchemaConfig = {
            nodes: [
                'doc',
                'paragraph',
                'text',
                'bulletList',
                'orderedList',
                'listItem',
                'heading',
                'blockquote',
                'codeBlock',
                'panel',
                'rule',
                'image',
                'caption',
                'mention',
                'media',
                'mediaGroup',
                'mediaSingle',
                'mediaInline',
                'confluenceUnsupportedBlock',
                'confluenceUnsupportedInline',
                'confluenceJiraIssue',
                'expand',
                'nestedExpand',
                'extension',
                'inlineExtension',
                'bodiedExtension',
                'hardBreak',
                'emoji',
                'table',
                'tableCell',
                'tableHeader',
                'tableRow',
                'decisionList',
                'decisionItem',
                'taskList',
                'taskItem',
                'unknownBlock',
                'date',
                'status',
                'placeholder',
                'layoutSection',
                'layoutColumn',
                'inlineCard',
                'blockCard',
                'embedCard',
                'unsupportedBlock',
                'unsupportedInline'
            ],
            marks: [
                'link',
                'em',
                'strong',
                'strike',
                'subsup',
                'underline',
                'code',
                'textColor',
                'backgroundColor',
                'confluenceInlineComment',
                'breakout',
                'alignment',
                'indentation',
                'annotation',
                'dataConsumer',
                'border',
                'unsupportedMark',
                'unsupportedNodeAttribute',
                'typeAheadQuery',
                'fragment'
            ]
        };
        return defaultSchemaConfig;
    };
    const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
    const $f27880a8173018db$export$fd147e7d448dea03 = (0, (0, parcelRequire("8QpSo")).default)((stage = 'final')=>{
        const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
        if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
            layoutSection: (0, (0, parcelRequire("gZoER")).layoutSectionWithSingleColumn),
            multiBodiedExtension: (0, (0, parcelRequire("47jug")).multiBodiedExtension),
            extensionFrame: (0, (0, parcelRequire("47jug")).extensionFrame),
            expand: (0, (0, parcelRequire("7kC9H")).expandWithNestedExpand),
            blockquote: (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia),
            listItem: (0, (0, parcelRequire("2FIVU")).listItemWithDecisionStage0),
            panel: (0, (0, parcelRequire("bFtEE")).panelWithBlockquoteStage0)(true),
            table: (0, (0, parcelRequire("9UDEr")).tableWithNestedTable),
            tableRow: (0, (0, parcelRequire("9UDEr")).tableRowWithNestedTable),
            tableCell: (0, (0, parcelRequire("9UDEr")).tableCellWithNestedTable),
            tableHeader: (0, (0, parcelRequire("9UDEr")).tableHeaderWithNestedTable)
        };
        return (0, (0, parcelRequire("kBho7")).createSchema)(defaultSchemaConfig);
    });
    const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();
});
parcelRegister("aXBFx", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$7faca2534e4894a0$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", ()=>$7faca2534e4894a0$export$c4d50234112df933);
    $parcel$export(module.exports, "blockquoteWithList", ()=>$7faca2534e4894a0$export$9b4686c4b9672643);
    var $gthjq;
    const $7faca2534e4894a0$var$nodeSpecOptions = {
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    };
    const $7faca2534e4894a0$export$67dc04e652a298ca = (0, (0, parcelRequire("gthjq")).blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
    const $7faca2534e4894a0$export$c4d50234112df933 = (0, (0, parcelRequire("gthjq")).blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
    const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, (0, parcelRequire("gthjq")).blockquoteWithoutNestedCodeblockOrMedia)({
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    });
});
parcelRegister("gthjq", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$bfdcc8a4590754dc$export$c4c2f833baaebdb8);
    $parcel$export(module.exports, "blockquote", ()=>$bfdcc8a4590754dc$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockquoteLegacy", ()=>$bfdcc8a4590754dc$export$199922e5af8e9a6);
    $parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", ()=>$bfdcc8a4590754dc$export$a91509d1c739c16f);
    $parcel$export(module.exports, "bodiedExtension", ()=>$bfdcc8a4590754dc$export$27903d543b563e39);
    $parcel$export(module.exports, "bulletList", ()=>$bfdcc8a4590754dc$export$a140c94e5ea26bee);
    $parcel$export(module.exports, "caption", ()=>$bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
    $parcel$export(module.exports, "codeBlock", ()=>$bfdcc8a4590754dc$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>$bfdcc8a4590754dc$export$daf889beb5092f95);
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>$bfdcc8a4590754dc$export$e6e4878f43c27cab);
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>$bfdcc8a4590754dc$export$3e6d667072febc87);
    $parcel$export(module.exports, "date", ()=>$bfdcc8a4590754dc$export$324d90190a8b822a);
    $parcel$export(module.exports, "decisionItem", ()=>$bfdcc8a4590754dc$export$6959e16eeff859b4);
    $parcel$export(module.exports, "decisionList", ()=>$bfdcc8a4590754dc$export$62d45a65fb43d95e);
    $parcel$export(module.exports, "doc", ()=>$bfdcc8a4590754dc$export$2a111da947c407d2);
    $parcel$export(module.exports, "embedCard", ()=>$bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
    $parcel$export(module.exports, "emoji", ()=>$bfdcc8a4590754dc$export$a19185d1233fc4b2);
    $parcel$export(module.exports, "expand", ()=>$bfdcc8a4590754dc$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expandWithoutNestedExpand", ()=>$bfdcc8a4590754dc$export$63c0f3992661097b);
    $parcel$export(module.exports, "extension", ()=>$bfdcc8a4590754dc$export$1b45514b112dd749);
    $parcel$export(module.exports, "extensionFrameStage0", ()=>$bfdcc8a4590754dc$export$b555be60c7703afb);
    $parcel$export(module.exports, "hardBreak", ()=>$bfdcc8a4590754dc$export$371da9dd35aba193);
    $parcel$export(module.exports, "heading", ()=>$bfdcc8a4590754dc$export$46e4a324ac90507f);
    $parcel$export(module.exports, "image", ()=>$bfdcc8a4590754dc$export$5c452ff88e35e47d);
    $parcel$export(module.exports, "inlineCard", ()=>$bfdcc8a4590754dc$export$cbf8224b64e0d942);
    $parcel$export(module.exports, "inlineExtensionWithMarks", ()=>$bfdcc8a4590754dc$export$b3b1e36c2105006d);
    $parcel$export(module.exports, "layoutColumn", ()=>$bfdcc8a4590754dc$export$ab76e7c03cd6f650);
    $parcel$export(module.exports, "layoutSection", ()=>$bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSectionFull", ()=>$bfdcc8a4590754dc$export$cdae19acb0a520fd);
    $parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", ()=>$bfdcc8a4590754dc$export$206007566ca0aca5);
    $parcel$export(module.exports, "listItem", ()=>$bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "listItemWithNestedDecisionStage0", ()=>$bfdcc8a4590754dc$export$df876f0305235056);
    $parcel$export(module.exports, "media", ()=>$bfdcc8a4590754dc$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "mediaGroup", ()=>$bfdcc8a4590754dc$export$2855e964765eac9);
    $parcel$export(module.exports, "mediaInline", ()=>$bfdcc8a4590754dc$export$38bab695e3f720f1);
    $parcel$export(module.exports, "mediaSingle", ()=>$bfdcc8a4590754dc$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingleCaption", ()=>$bfdcc8a4590754dc$export$8d067f22dc2d1254);
    $parcel$export(module.exports, "mediaSingleFull", ()=>$bfdcc8a4590754dc$export$7e767666f2ce108a);
    $parcel$export(module.exports, "mediaSingleWidthType", ()=>$bfdcc8a4590754dc$export$4bd9a38995f6bf50);
    $parcel$export(module.exports, "mention", ()=>$bfdcc8a4590754dc$export$db83999c14438df4);
    $parcel$export(module.exports, "multiBodiedExtensionStage0", ()=>$bfdcc8a4590754dc$export$750e45819f66d9d0);
    $parcel$export(module.exports, "nestedExpand", ()=>$bfdcc8a4590754dc$export$63cadbf5f4296627);
    $parcel$export(module.exports, "orderedList", ()=>$bfdcc8a4590754dc$export$a5dc81035676e7a);
    $parcel$export(module.exports, "panel", ()=>$bfdcc8a4590754dc$export$21f42ab9b6679f44);
    $parcel$export(module.exports, "panelWithNestedBlockquoteStage0", ()=>$bfdcc8a4590754dc$export$a1cf9918ad22c7e9);
    $parcel$export(module.exports, "paragraph", ()=>$bfdcc8a4590754dc$export$9c206ddddb32a9b);
    $parcel$export(module.exports, "placeholder", ()=>$bfdcc8a4590754dc$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "rule", ()=>$bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
    $parcel$export(module.exports, "status", ()=>$bfdcc8a4590754dc$export$471f7ae5c4103ae1);
    $parcel$export(module.exports, "table", ()=>$bfdcc8a4590754dc$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>$bfdcc8a4590754dc$export$ce086a560a1d05f5);
    $parcel$export(module.exports, "tableCell", ()=>$bfdcc8a4590754dc$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>$bfdcc8a4590754dc$export$abf39ca178940ff3);
    $parcel$export(module.exports, "tableHeader", ()=>$bfdcc8a4590754dc$export$48884d2a5190dc73);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>$bfdcc8a4590754dc$export$2a5a518232fa1a97);
    $parcel$export(module.exports, "tableRow", ()=>$bfdcc8a4590754dc$export$ce666bf02318c957);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>$bfdcc8a4590754dc$export$7d657479499397);
    $parcel$export(module.exports, "taskItem", ()=>$bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
    $parcel$export(module.exports, "taskList", ()=>$bfdcc8a4590754dc$export$375b6afcc5f4d291);
    $parcel$export(module.exports, "text", ()=>$bfdcc8a4590754dc$export$6f093cfa640b7166);
    $parcel$export(module.exports, "unsupportedBlock", ()=>$bfdcc8a4590754dc$export$44b79b0979d0f0f7);
    $parcel$export(module.exports, "unsupportedInline", ()=>$bfdcc8a4590754dc$export$310ebe0d80122e9b);
    var $f0ccE;
    const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            url: {
                default: null
            },
            datasource: {
                default: null
            },
            width: {
                default: null
            },
            layout: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        defining: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        defining: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'listItem+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: false
    });
    const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
        marks: '_',
        selectable: false,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(text | unsupportedInline)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            language: {
                default: null
            },
            uniqueId: {
                default: null
            }
        },
        code: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$62a75647a293fbec = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            language: {
                default: null
            },
            uniqueId: {
                default: null
            }
        },
        code: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        atom: true,
        attrs: {
            issueKey: {
                default: ''
            },
            macroId: {
                default: null
            },
            schemaVersion: {
                default: null
            },
            server: {
                default: null
            },
            serverId: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            cxhtml: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        atom: true,
        attrs: {
            cxhtml: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            timestamp: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            timestamp: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: '_',
        attrs: {
            localId: {
                default: ''
            },
            state: {
                default: 'DECIDED'
            }
        },
        defining: true
    });
    const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(decisionItem | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            localId: {
                default: ''
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(block | layoutSection | blockRootOnly)+',
        marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
    });
    const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            url: {
                default: ''
            },
            layout: {
                default: 'center'
            },
            width: {
                default: 100
            },
            originalHeight: {
                default: null
            },
            originalWidth: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            shortName: {
                default: ''
            },
            id: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            shortName: {
                default: ''
            },
            id: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$111717af0897b759 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        attrs: {},
        selectable: false,
        definingAsContext: false,
        definingForContent: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: '\n'
            }
        },
        selectable: false,
        linebreakReplacement: true
    });
    const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            src: {
                default: ''
            },
            alt: {
                default: ''
            },
            title: {
                default: null
            }
        },
        draggable: true
    });
    const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            url: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            url: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(block | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
        attrs: {
            width: {
                default: undefined
            }
        },
        selectable: false,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true
    });
    const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){2,3}',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true
    });
    const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            columnRuleStyle: {
                default: null
            }
        },
        isolating: true
    });
    const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$df876f0305235056 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        attrs: {
            type: {
                default: 'file'
            },
            id: {
                default: ''
            },
            alt: {
                default: ''
            },
            collection: {
                default: ''
            },
            height: {
                default: null
            },
            occurrenceKey: {
                default: null
            },
            width: {
                default: null
            },
            __contextId: {
                default: null
            },
            __displayType: {
                default: null
            },
            __external: {
                default: false
            },
            __fileMimeType: {
                default: null
            },
            __fileName: {
                default: null
            },
            __fileSize: {
                default: null
            },
            __mediaTraceId: {
                default: null
            },
            url: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(media | unsupportedBlock)+',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {},
        selectable: false
    });
    const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            type: {
                default: 'file'
            },
            url: {
                default: null
            },
            id: {
                default: ''
            },
            alt: {
                default: ''
            },
            collection: {
                default: ''
            },
            occurrenceKey: {
                default: null
            },
            width: {
                default: null
            },
            height: {
                default: null
            },
            __fileName: {
                default: null
            },
            __fileSize: {
                default: null
            },
            __fileMimeType: {
                default: null
            },
            __displayType: {
                default: null
            },
            __contextId: {
                default: null
            },
            __mediaTraceId: {
                default: null
            },
            __external: {
                default: false
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            layout: {
                default: 'center'
            },
            width: {
                default: null
            }
        },
        selectable: true,
        content: 'media|unsupportedBlock+|media unsupportedBlock+',
        marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
    });
    const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: false,
        attrs: {
            layout: {
                default: 'center'
            },
            width: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: false,
        attrs: {
            width: {
                default: null
            },
            layout: {
                default: 'center'
            },
            widthType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media unsupportedBlock+',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: true,
        attrs: {
            width: {
                default: null
            },
            layout: {
                default: 'center'
            },
            widthType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            id: {
                default: ''
            },
            localId: {
                default: null
            },
            text: {
                default: ''
            },
            accessLevel: {
                default: ''
            },
            userType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            id: {
                default: ''
            },
            localId: {
                default: null
            },
            text: {
                default: ''
            },
            accessLevel: {
                default: ''
            },
            userType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'extensionFrame+',
        marks: 'unsupportedNodeAttribute unsupportedMark',
        group: 'blockRootOnly',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        definingAsContext: true
    });
    const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'listItem+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            order: {
                default: 1
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            panelType: {
                default: 'info'
            },
            panelIcon: {
                default: null
            },
            panelIconId: {
                default: null
            },
            panelIconText: {
                default: null
            },
            panelColor: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a1cf9918ad22c7e9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            panelType: {
                default: 'info'
            },
            panelIcon: {
                default: null
            },
            panelIconId: {
                default: null
            },
            panelIconText: {
                default: null
            },
            panelColor: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: '',
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block'
    });
    const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            },
            color: {
                default: ''
            },
            localId: {
                default: ''
            },
            style: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            },
            color: {
                default: ''
            },
            localId: {
                default: ''
            },
            style: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'tableRow+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            displayMode: {
                default: null
            },
            isNumberColumnEnabled: {
                default: false
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: ''
            },
            width: {
                default: null
            },
            __autoSize: {
                default: false
            }
        },
        selectable: true,
        isolating: true,
        tableRole: 'table'
    });
    const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'tableRow+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            displayMode: {
                default: null
            },
            isNumberColumnEnabled: {
                default: false
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: ''
            },
            width: {
                default: null
            },
            __autoSize: {
                default: false
            }
        },
        selectable: true,
        isolating: true,
        tableRole: 'table'
    });
    const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'cell'
    });
    const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'cell'
    });
    const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'header_cell'
    });
    const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'header_cell'
    });
    const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(tableCell | tableHeader)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        tableRole: 'row'
    });
    const $bfdcc8a4590754dc$export$7d657479499397 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(tableCell | tableHeader)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        tableRole: 'row'
    });
    const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: '_',
        attrs: {
            localId: {
                default: ''
            },
            state: {
                default: 'TODO'
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            localId: {
                default: ''
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            originalValue: {
                default: {}
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            originalValue: {
                default: {}
            }
        },
        selectable: true
    });
});
parcelRegister("f0ccE", function(module, exports) {
    $parcel$export(module.exports, "createPMNodeSpecFactory", ()=>$aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
    $parcel$export(module.exports, "createPMMarkSpecFactory", ()=>$aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
    const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
            return {
                ...nodeSpec,
                ...parseDOM && {
                    parseDOM: parseDOM
                },
                ...toDOM && {
                    toDOM: toDOM
                },
                ...toDebugString && {
                    toDebugString: toDebugString
                }
            };
        };
    const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
            return {
                ...markSpec,
                ...parseDOM && {
                    parseDOM: parseDOM
                },
                ...toDOM && {
                    toDOM: toDOM
                },
                ...toDebugString && {
                    toDebugString: toDebugString
                }
            };
        };
});
parcelRegister("7kC9H", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>$5567ff8f3f52f7a8$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expandWithNestedExpand", ()=>$5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
    $parcel$export(module.exports, "toJSON", ()=>$5567ff8f3f52f7a8$export$54fd2c36b5cc6731);
    var $gthjq;
    function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
        const dom = domNode;
        return {
            title: dom.getAttribute('data-title'),
            __expanded: true
        };
    }
    const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
        parseDOM: [
            {
                context: 'table//',
                tag: 'div[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                context: 'expand//',
                tag: '[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'expand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, (0, parcelRequire("gthjq")).expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
    const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, (0, parcelRequire("gthjq")).expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
    const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
});
parcelRegister("47jug", function(module, exports) {
    $parcel$export(module.exports, "extensionFrame", ()=>$2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>$2ff6ee9baaedd4b6$export$c3c04d555a8b9013);
    var $CWpyq;
    var $gthjq;
    const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, (0, parcelRequire("gthjq")).extensionFrameStage0)({
        parseDOM: [
            {
                context: 'extensionFrame//',
                tag: 'div[data-extension-frame]',
                skip: true
            },
            {
                tag: 'div[data-extension-frame]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-extension-frame': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, (0, parcelRequire("gthjq")).multiBodiedExtensionStage0)({
        parseDOM: [
            {
                context: 'multiBodiedExtension//',
                tag: '[data-node-type="multi-bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="multi-bodied-extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'multi-bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("CWpyq", function(module, exports) {
    $parcel$export(module.exports, "getExtensionAttrs", ()=>$0750dbf71b86cced$export$1765e2758fc47004);
    const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
        return !!name && [
            'default',
            'wide',
            'full-width'
        ].includes(name);
    };
    const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
        const extensionType = dom.getAttribute('data-extension-type');
        const extensionKey = dom.getAttribute('data-extension-key');
        if (!extensionType || !extensionKey) return false;
        const attrs = {
            extensionType: extensionType,
            extensionKey: extensionKey,
            text: dom.getAttribute('data-text') || undefined,
            parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
            localId: dom.getAttribute('data-local-id') || undefined
        };
        if (!isInline) {
            const rawLayout = dom.getAttribute('data-layout');
            attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
        }
        return attrs;
    };
});
parcelRegister("gZoER", function(module, exports) {
    $parcel$export(module.exports, "layoutSection", ()=>$c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSectionWithSingleColumn", ()=>$c5e57867b1f8b9c7$export$4f9d8f623ff17117);
    var $gthjq;
    const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, (0, parcelRequire("gthjq")).layoutSection)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-layout-section': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, (0, parcelRequire("gthjq")).layoutSectionFull)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-layout-section': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, (0, parcelRequire("gthjq")).layoutSectionWithSingleColumnStage0)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]',
                getAttrs: (dom)=>{
                    const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                    return columnRuleStyle ? {
                        columnRuleStyle: columnRuleStyle
                    } : {};
                }
            }
        ],
        toDOM (node) {
            const { columnRuleStyle: columnRuleStyle } = node.attrs;
            const attrs = {
                'data-layout-section': 'true',
                'data-column-rule-style': columnRuleStyle || undefined
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("2FIVU", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$1f2243de0d109562$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "listItemWithTask", ()=>$1f2243de0d109562$export$58dca2f0678302a4);
    $parcel$export(module.exports, "listItemWithDecisionStage0", ()=>$1f2243de0d109562$export$b2cd54d5ce935ddb);
    var $gthjq;
    const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, (0, parcelRequire("gthjq")).listItem)({
        parseDOM: [
            {
                tag: 'li'
            }
        ],
        toDOM () {
            return [
                'li',
                0
            ];
        }
    });
    const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
    const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, (0, parcelRequire("gthjq")).listItemWithNestedDecisionStage0)({
        parseDOM: [
            {
                tag: 'li'
            }
        ],
        toDOM () {
            return [
                'li',
                0
            ];
        }
    });
});
parcelRegister("bFtEE", function(module, exports) {
    $parcel$export(module.exports, "PanelType", ()=>$87ea86de426496d8$export$969277cf61e5a7aa);
    $parcel$export(module.exports, "extendedPanel", ()=>$87ea86de426496d8$export$ce20b13564211141);
    $parcel$export(module.exports, "panelWithBlockquoteStage0", ()=>$87ea86de426496d8$export$1f8c55a804c909c7);
    var $gthjq;
    let $87ea86de426496d8$export$969277cf61e5a7aa = function(PanelType) {
        PanelType["INFO"] = "info";
        PanelType["NOTE"] = "note";
        PanelType["TIP"] = "tip";
        PanelType["WARNING"] = "warning";
        PanelType["ERROR"] = "error";
        PanelType["SUCCESS"] = "success";
        PanelType["CUSTOM"] = "custom";
        return PanelType;
    }({});
    const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
        const attrs = {
            'data-panel-type': nodeAttrs.panelType,
            'data-panel-icon': nodeAttrs.panelIcon,
            'data-panel-icon-id': nodeAttrs.panelIconId,
            'data-panel-icon-text': nodeAttrs.panelIconText,
            'data-panel-color': nodeAttrs.panelColor
        };
        return attrs;
    };
    const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
        let parseDOMAttrs = {
            panelType: dom.getAttribute('data-panel-type')
        };
        if (allowCustomPanel) parseDOMAttrs = {
            ...parseDOMAttrs,
            panelIcon: dom.getAttribute('data-panel-icon'),
            panelIconId: dom.getAttribute('data-panel-icon-id'),
            panelIconText: dom.getAttribute('data-panel-icon-text'),
            panelColor: dom.getAttribute('data-panel-color')
        };
        else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
        return parseDOMAttrs;
    };
    const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>{
        const panelNodeSpec = (0, (0, parcelRequire("gthjq")).panel)({
            parseDOM: [
                {
                    tag: 'div[data-panel-type]',
                    getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
                }
            ],
            toDOM (node) {
                const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
                const contentAttrs = {
                    'data-panel-content': 'true'
                };
                return [
                    'div',
                    attrs,
                    [
                        'div',
                        contentAttrs,
                        0
                    ]
                ];
            }
        });
        return panelNodeSpec;
    };
    const $87ea86de426496d8$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
        const panelNodeSpec = (0, (0, parcelRequire("gthjq")).panelWithNestedBlockquoteStage0)({
            parseDOM: [
                {
                    tag: 'div[data-panel-type]',
                    getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
                }
            ],
            toDOM (node) {
                const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
                const contentAttrs = {
                    'data-panel-content': 'true'
                };
                return [
                    'div',
                    attrs,
                    [
                        'div',
                        contentAttrs,
                        0
                    ]
                ];
            }
        });
        return panelNodeSpec;
    };
});
parcelRegister("9UDEr", function(module, exports) {
    $parcel$export(module.exports, "tablePrefixSelector", ()=>$737819f27951a815$export$9cfceb893b24742a);
    $parcel$export(module.exports, "tableCellSelector", ()=>$737819f27951a815$export$69cb4c3f80383763);
    $parcel$export(module.exports, "tableHeaderSelector", ()=>$737819f27951a815$export$7b07d37d879c957f);
    $parcel$export(module.exports, "tableCellContentWrapperSelector", ()=>$737819f27951a815$export$8dd42a84cd52da07);
    $parcel$export(module.exports, "tableCellContentDomSelector", ()=>$737819f27951a815$export$5e26a5c19f0865d8);
    $parcel$export(module.exports, "getCellAttrs", ()=>$737819f27951a815$export$43977bde391e007);
    $parcel$export(module.exports, "getCellDomAttrs", ()=>$737819f27951a815$export$363c8dda799bfe9c);
    $parcel$export(module.exports, "tableBackgroundColorNames", ()=>$737819f27951a815$export$8cc2833b5b349a1e);
    $parcel$export(module.exports, "tableBackgroundColorPalette", ()=>$737819f27951a815$export$219b7f492ad209f8);
    $parcel$export(module.exports, "tableBackgroundBorderColor", ()=>$737819f27951a815$export$95e9c925fbf01d1c);
    $parcel$export(module.exports, "table", ()=>$737819f27951a815$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableWithCustomWidth", ()=>$737819f27951a815$export$90e634fbace1f0c4);
    $parcel$export(module.exports, "tableStage0", ()=>$737819f27951a815$export$3862de5c8c9098cf);
    $parcel$export(module.exports, "tableToJSON", ()=>$737819f27951a815$export$1f92a2f429e06fa8);
    $parcel$export(module.exports, "tableRow", ()=>$737819f27951a815$export$ce666bf02318c957);
    $parcel$export(module.exports, "tableCell", ()=>$737819f27951a815$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "toJSONTableCell", ()=>$737819f27951a815$export$2ac34c099660f1a8);
    $parcel$export(module.exports, "tableHeader", ()=>$737819f27951a815$export$48884d2a5190dc73);
    $parcel$export(module.exports, "toJSONTableHeader", ()=>$737819f27951a815$export$2af48797a1010bb1);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>$737819f27951a815$export$ce086a560a1d05f5);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>$737819f27951a815$export$7d657479499397);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>$737819f27951a815$export$abf39ca178940ff3);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>$737819f27951a815$export$2a5a518232fa1a97);
    var $daes7;
    var $51H8P;
    var $9IGaJ;
    var $87j2U;
    var $gthjq;
    const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
    const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
    const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
    const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
    const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
    const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, (0, parcelRequire("51H8P")).N20).toLocaleLowerCase();
    const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
        const widthAttr = dom.getAttribute('data-colwidth');
        const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
        const colspan = Number(dom.getAttribute('colspan') || 1);
        let { backgroundColor: backgroundColor } = dom.style;
        const dataCellBackground = dom.getAttribute('data-cell-background');
        const dataCellBackgroundHexCode = dataCellBackground && (0, (0, parcelRequire("51H8P")).isHex)(dataCellBackground) ? dataCellBackground : undefined;
        if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
        else if (backgroundColor && (0, (0, parcelRequire("51H8P")).isRgb)(backgroundColor)) {
            const result = (0, (0, parcelRequire("51H8P")).rgbToHex)(backgroundColor);
            if (result !== null) backgroundColor = result;
        }
        const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
        return {
            colspan: colspan,
            rowspan: Number(dom.getAttribute('rowspan') || 1),
            colwidth: width && width.length === colspan ? width : null,
            background: backgroundHexCode
        };
    };
    let $737819f27951a815$var$testGlobalTheme;
    const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
        $737819f27951a815$var$testGlobalTheme = theme;
    };
    const $737819f27951a815$var$getGlobalTheme = ()=>{
        if ($737819f27951a815$var$testGlobalTheme) return {
            colorMode: $737819f27951a815$var$testGlobalTheme
        };
        const element = document.documentElement;
        const colorMode = element.getAttribute('data-color-mode') || '';
        return {
            colorMode: colorMode
        };
    };
    const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
    const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
        const attrs = {};
        const nodeType = node.type.name;
        if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
        if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
        if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
        if (node.attrs.background) {
            const { background: background } = node.attrs;
            const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
            if (ignored) attrs.style = '';
            else {
                const color = (0, (0, parcelRequire("51H8P")).isRgb)(background) && (0, (0, parcelRequire("51H8P")).rgbToHex)(background) ? (0, (0, parcelRequire("51H8P")).rgbToHex)(background) : background;
                const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorBackgroundPaletteRawValue)(color);
                if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
                else if ($737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
                else if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') attrs.style = `background-color: ${(0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(color)};`;
                else attrs.style = `background-color: ${background};`;
                if (color) attrs['data-cell-background'] = color;
                attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
            }
        }
        if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
        else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
        return attrs;
    };
    const $737819f27951a815$export$219b7f492ad209f8 = new Map();
    const $737819f27951a815$export$95e9c925fbf01d1c = (0, (0, parcelRequire("51H8P")).hexToRgba)((0, (0, parcelRequire("51H8P")).N800), 0.12) || (0, (0, parcelRequire("51H8P")).N0);
    const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
    [
        [
            (0, (0, parcelRequire("51H8P")).N0),
            'White'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B50),
            'Light blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T50),
            'Light teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G50),
            'Light green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y50),
            'Light yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R50),
            'Light red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P50),
            'Light purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N20),
            'Light gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B75),
            'Blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T75),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G75),
            'Green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y75),
            'Yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R75),
            'Red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P75),
            'Purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N60),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B100),
            'Dark blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T100),
            'Dark teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G200),
            'Dark green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y200),
            'Dark yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R100),
            'Dark red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P100),
            'Dark purple'
        ]
    ].forEach(([colorValue, colorName])=>{
        $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
        $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    });
    const $737819f27951a815$var$tableNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    };
    const $737819f27951a815$var$createTableSpec = ()=>(0, (0, parcelRequire("gthjq")).table)($737819f27951a815$var$tableNodeSpecOptions);
    const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
    const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
    const $737819f27951a815$var$tableRowNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'tr'
            }
        ],
        toDOM () {
            return [
                'tr',
                0
            ];
        }
    };
    const $737819f27951a815$export$ce666bf02318c957 = (0, (0, parcelRequire("gthjq")).tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
    const $737819f27951a815$var$cellAttrs = {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    };
    const $737819f27951a815$var$tableCellNodeSpecOptions = {
        parseDOM: [
            {
                tag: '.ak-renderer-table-number-column',
                ignore: true
            },
            {
                tag: 'td',
                getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
            }
        ],
        toDOM: (node)=>[
                'td',
                $737819f27951a815$export$363c8dda799bfe9c(node),
                0
            ]
    };
    const $737819f27951a815$export$e1e720e5f4603e6a = (0, (0, parcelRequire("gthjq")).tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
    const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
    const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'th',
                getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                        background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                    })
            }
        ],
        toDOM: (node)=>[
                'th',
                $737819f27951a815$export$363c8dda799bfe9c(node),
                0
            ]
    };
    const $737819f27951a815$export$48884d2a5190dc73 = (0, (0, parcelRequire("gthjq")).tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
    const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
    const $737819f27951a815$export$ce086a560a1d05f5 = (0, (0, parcelRequire("gthjq")).tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
    const $737819f27951a815$export$7d657479499397 = (0, (0, parcelRequire("gthjq")).tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
    const $737819f27951a815$export$abf39ca178940ff3 = (0, (0, parcelRequire("gthjq")).tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
    const $737819f27951a815$export$2a5a518232fa1a97 = (0, (0, parcelRequire("gthjq")).tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);
});
parcelRegister("daes7", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorBorderPaletteColor", ()=>$99576b847e5fbb17$export$bad3c41dd33cb4bc);
    $parcel$export(module.exports, "hexToEditorTextPaletteColor", ()=>$99576b847e5fbb17$export$9c2f408d391feb93);
    $parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", ()=>$99576b847e5fbb17$export$8b58ff1b36bb75e0);
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", ()=>$99576b847e5fbb17$export$a270511a0e7fd61a);
    function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
        return $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
    }
    const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
        '#091E4224': 'var(--ds-border, #091E4224)',
        '#758195': 'var(--ds-border-bold, #758195)',
        '#172B4D': 'var(--ds-text, #172B4D)'
    };
    function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
        return $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()];
    }
    const $99576b847e5fbb17$export$57fa5089caad992 = {
        '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
        '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
        '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
        '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
        '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
        '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
        '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
        '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
        '#006644': 'var(--ds-text-accent-green, #006644)',
        '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
        '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
        '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
        '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
        '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
        '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
        '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
        '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
        '#403294': 'var(--ds-text-accent-purple, #403294)',
        '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
        '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
        '#172B4D': 'var(--ds-text, #172B4D)'
    };
    function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
        return $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()];
    }
    const $99576b847e5fbb17$export$12a518ff137dd389 = {
        '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
        '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
        '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
        '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
        '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
        '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
    };
    function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
        const tokenData = $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.getValue(hexColor) : undefined;
    }
    const $99576b847e5fbb17$export$2462741d70e6a62f = {
        '#DEEBFF': {
            getValue: ()=>'#DEEBFF',
            token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
        },
        '#B3D4FF': {
            getValue: ()=>'#B3D4FF',
            token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
        },
        '#4C9AFF': {
            getValue: ()=>'#4C9AFF',
            token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
        },
        '#E6FCFF': {
            getValue: ()=>'#E6FCFF',
            token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
        },
        '#B3F5FF': {
            getValue: ()=>'#B3F5FF',
            token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
        },
        '#79E2F2': {
            getValue: ()=>'#79E2F2',
            token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
        },
        '#E3FCEF': {
            getValue: ()=>'#E3FCEF',
            token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
        },
        '#ABF5D1': {
            getValue: ()=>'#ABF5D1',
            token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
        },
        '#57D9A3': {
            getValue: ()=>'#57D9A3',
            token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
        },
        '#FFFAE6': {
            getValue: ()=>'#FFFAE6',
            token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
        },
        '#FFF0B3': {
            getValue: ()=>'#FFF0B3',
            token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
        },
        '#FFC400': {
            getValue: ()=>'#FFC400',
            token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
        },
        '#FFEBE6': {
            getValue: ()=>'#FFEBE6',
            token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
        },
        '#FFBDAD': {
            getValue: ()=>'#FFBDAD',
            token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
        },
        '#FF8F73': {
            getValue: ()=>'#FF8F73',
            token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
        },
        '#EAE6FF': {
            getValue: ()=>'#EAE6FF',
            token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
        },
        '#C0B6F2': {
            getValue: ()=>'#C0B6F2',
            token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
        },
        '#998DD9': {
            getValue: ()=>'#998DD9',
            token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
        },
        '#FFFFFF': {
            getValue: ()=>'#FFFFFF',
            token: 'var(--ds-surface, #FFFFFF)'
        },
        '#F4F5F7': {
            getValue: ()=>'#F4F5F7',
            token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
        },
        '#B3BAC5': {
            getValue: ()=>'#B3BAC5',
            token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
        }
    };
});
parcelRegister("51H8P", function(module, exports) {
    $parcel$export(module.exports, "R50", ()=>$3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
    $parcel$export(module.exports, "R75", ()=>$3a8e82bcbd673dd1$export$b34b069eff244586);
    $parcel$export(module.exports, "R100", ()=>$3a8e82bcbd673dd1$export$be802dd0d8b57f35);
    $parcel$export(module.exports, "R300", ()=>$3a8e82bcbd673dd1$export$4a7404f376229999);
    $parcel$export(module.exports, "R400", ()=>$3a8e82bcbd673dd1$export$2010d0fb4295b346);
    $parcel$export(module.exports, "R500", ()=>$3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
    $parcel$export(module.exports, "Y50", ()=>$3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
    $parcel$export(module.exports, "Y75", ()=>$3a8e82bcbd673dd1$export$41060a744ab0b7ae);
    $parcel$export(module.exports, "Y200", ()=>$3a8e82bcbd673dd1$export$5aae31392d72caaa);
    $parcel$export(module.exports, "Y400", ()=>$3a8e82bcbd673dd1$export$59619663aa6500fb);
    $parcel$export(module.exports, "G50", ()=>$3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
    $parcel$export(module.exports, "G75", ()=>$3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
    $parcel$export(module.exports, "G200", ()=>$3a8e82bcbd673dd1$export$747d86715d4175de);
    $parcel$export(module.exports, "G300", ()=>$3a8e82bcbd673dd1$export$940e1f69e873f202);
    $parcel$export(module.exports, "G400", ()=>$3a8e82bcbd673dd1$export$a49394138f7b8e85);
    $parcel$export(module.exports, "G500", ()=>$3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
    $parcel$export(module.exports, "B50", ()=>$3a8e82bcbd673dd1$export$226de0355ed012f8);
    $parcel$export(module.exports, "B75", ()=>$3a8e82bcbd673dd1$export$8c13c2ee36917869);
    $parcel$export(module.exports, "B100", ()=>$3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
    $parcel$export(module.exports, "B400", ()=>$3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
    $parcel$export(module.exports, "B500", ()=>$3a8e82bcbd673dd1$export$a6ee3d71bc067634);
    $parcel$export(module.exports, "L200", ()=>$3a8e82bcbd673dd1$export$f72948ef771f6f15);
    $parcel$export(module.exports, "N0", ()=>$3a8e82bcbd673dd1$export$29a4f05edc054374);
    $parcel$export(module.exports, "N20", ()=>$3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
    $parcel$export(module.exports, "N30", ()=>$3a8e82bcbd673dd1$export$3e51e8f1440314ba);
    $parcel$export(module.exports, "N40", ()=>$3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
    $parcel$export(module.exports, "N50", ()=>$3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
    $parcel$export(module.exports, "N60", ()=>$3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
    $parcel$export(module.exports, "N80", ()=>$3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
    $parcel$export(module.exports, "N200", ()=>$3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
    $parcel$export(module.exports, "N300", ()=>$3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
    $parcel$export(module.exports, "Neutral300", ()=>$3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
    $parcel$export(module.exports, "N300A", ()=>$3a8e82bcbd673dd1$export$13609db0e6812ab8);
    $parcel$export(module.exports, "N500", ()=>$3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
    $parcel$export(module.exports, "N600", ()=>$3a8e82bcbd673dd1$export$7090862dc3038a9f);
    $parcel$export(module.exports, "N800", ()=>$3a8e82bcbd673dd1$export$7d61b15e0da132af);
    $parcel$export(module.exports, "N1000", ()=>$3a8e82bcbd673dd1$export$f78789c8b01753cd);
    $parcel$export(module.exports, "M200", ()=>$3a8e82bcbd673dd1$export$a19f0c33186f7767);
    $parcel$export(module.exports, "O200", ()=>$3a8e82bcbd673dd1$export$51716a84e62e022c);
    $parcel$export(module.exports, "P50", ()=>$3a8e82bcbd673dd1$export$363e4475840015bb);
    $parcel$export(module.exports, "P75", ()=>$3a8e82bcbd673dd1$export$4b0a4417ed59760f);
    $parcel$export(module.exports, "P100", ()=>$3a8e82bcbd673dd1$export$6011520a64d9a187);
    $parcel$export(module.exports, "P200", ()=>$3a8e82bcbd673dd1$export$a7175d4e9206bc80);
    $parcel$export(module.exports, "P300", ()=>$3a8e82bcbd673dd1$export$b48405b95304b5a1);
    $parcel$export(module.exports, "P500", ()=>$3a8e82bcbd673dd1$export$147899de772240ec);
    $parcel$export(module.exports, "T50", ()=>$3a8e82bcbd673dd1$export$2cf711fe14c66f06);
    $parcel$export(module.exports, "T75", ()=>$3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
    $parcel$export(module.exports, "T100", ()=>$3a8e82bcbd673dd1$export$776c9c497ef08533);
    $parcel$export(module.exports, "T200", ()=>$3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
    $parcel$export(module.exports, "T300", ()=>$3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
    $parcel$export(module.exports, "T500", ()=>$3a8e82bcbd673dd1$export$6036577f95c3877e);
    $parcel$export(module.exports, "normalizeHexColor", ()=>$3a8e82bcbd673dd1$export$b61655071712e690);
    $parcel$export(module.exports, "isHex", ()=>$3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
    $parcel$export(module.exports, "isRgb", ()=>$3a8e82bcbd673dd1$export$e698776ec826343);
    $parcel$export(module.exports, "rgbToHex", ()=>$3a8e82bcbd673dd1$export$34d09c4a771c46ef);
    $parcel$export(module.exports, "hexToRgb", ()=>$3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
    $parcel$export(module.exports, "hexToRgba", ()=>$3a8e82bcbd673dd1$export$9665a07d9187b414);
    var $3nnJa = parcelRequire("3nnJa");
    const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
    const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
    const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
    const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
    const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
    const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
    const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
    const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
    const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
    const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
    const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
    const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
    const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
    const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
    const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
    const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
    const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
    const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
    const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
    const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
    const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
    const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
    const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
    const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
    const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
    const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
    const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
    const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
    const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
    const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
    const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
    const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
    const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
    const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
    const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
    const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
    const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
    const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
    const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
    const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
    const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
    const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
    const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
    const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
    const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
    const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
    const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
    const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
    const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
    const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
    const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
    const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
    const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
    const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
    function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
        if (!color) return null;
        color = color.trim().toLowerCase();
        if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) {
            if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
        } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
        else {
            if (color === 'default') return null;
            else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
            else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
            else return null;
        }
        if (color === defaultColor) return null;
        return color;
    }
    function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
        if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
        let colorBits = color.substring(1).split('');
        if (colorBits.length === 3) colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2]
        ];
        const rgb = Number(`0x${colorBits.join('')}`);
        return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
    }
    function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
        const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
        if (!color) return null;
        const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
        return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
    }
    function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
        const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
        if (matches && matches.length >= 3) {
            const [red, green, blue] = matches.map(Number);
            return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
        }
        return null;
    }
    function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
        return /rgba?\(/.test(color);
    }
    function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
        return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
    }
});
parcelRegister("3nnJa", function(module, exports) {
    module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");
});
parcelRegister("9IGaJ", function(module, exports) {
    $parcel$export(module.exports, "generateUuid", ()=>$7138efa2a0163ee8$export$1c3aefb711c3a4cc);
    $parcel$export(module.exports, "uuid", ()=>$7138efa2a0163ee8$export$31b40729666a4ae0);
    const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
    let $7138efa2a0163ee8$var$staticValue = false;
    const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
        setStatic (value) {
            $7138efa2a0163ee8$var$staticValue = value;
        },
        generate () {
            return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
        }
    };
});
parcelRegister("87j2U", function(module, exports) {
    $parcel$export(module.exports, "getDarkModeLCHColor", ()=>$5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
    const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
        const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
    const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
    const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
        const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
        lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
        return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
    };
    const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
        const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
        if (rgb === null) return 0;
        const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
        return lch.l;
    };
    const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
        const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
        const newLightness = Math.abs(100 - lightness);
        return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
    };
});
parcelRegister("kBho7", function(module, exports) {
    $parcel$export(module.exports, "createSchema", ()=>$eff4c0443be4d23b$export$5f4ce795563f4211);
    var $kCV8T;
    var $aeGrH;
    var $88i6h;
    var $8jJss;
    var $14Vqw;
    var $zceQE;
    var $lcXoV;
    var $71k4W;
    var $cUwVZ;
    var $l3Tmi;
    var $29Vii;
    var $fK6mK;
    var $8XeG6;
    var $aUhe2;
    var $hhtT8;
    var $4NwJJ;
    var $c9aa1;
    var $dtyqo;
    var $8EAPB;
    var $jxVez;
    var $lVmBd;
    var $21PS7;
    var $aXBFx;
    var $5AxYU;
    var $kjhhp;
    var $5JeV5;
    var $8vlrc;
    var $6bbHe;
    var $5y0tR;
    var $bd7A9;
    var $b2VmY;
    var $Khvpb;
    var $8gSD8;
    var $xjCuM;
    var $kshOv;
    var $7DoMR;
    var $7kC9H;
    var $bFtEE;
    var $hhN5g;
    var $47jug;
    var $jnMM2;
    var $lRTZM;
    var $7lRBh;
    var $cCBEe;
    var $5BOuQ;
    var $4EbxI;
    var $gZoER;
    var $2FIVU;
    var $7agO8;
    var $92lix;
    var $7Xgp3;
    var $bIGZ7;
    var $g7Cky;
    var $dx5eC;
    var $dwptW;
    var $abme3;
    var $dgJoa;
    var $M4hHz;
    var $18bvk;
    var $9UDEr;
    var $iThOL;
    var $43mJF;
    var $3DR6L;
    var $9X587;
    var $d1d6m;
    var $6kr5W;
    function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
        if (!config) return {};
        const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
            if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
            return items;
        }, {});
        return Object.keys(customSpecs).reduce((items, name)=>{
            if (items[name]) return items;
            items[name] = customSpecs[name];
            return items;
        }, items);
    }
    function $eff4c0443be4d23b$var$groupDeclaration(name) {
        return {
            name: `__${name}GroupDeclaration`,
            spec: {
                group: name
            }
        };
    }
    const $eff4c0443be4d23b$var$markGroupDeclarations = [
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
    ];
    const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
    const $eff4c0443be4d23b$var$nodesInOrder = [
        {
            name: 'doc',
            spec: (0, (0, parcelRequire("xjCuM")).doc)
        },
        {
            name: 'paragraph',
            spec: (0, (0, parcelRequire("abme3")).paragraph)
        },
        {
            name: 'text',
            spec: (0, (0, parcelRequire("3DR6L")).text)
        },
        {
            name: 'bulletList',
            spec: (0, (0, parcelRequire("kjhhp")).bulletList)
        },
        {
            name: 'orderedList',
            spec: (0, (0, parcelRequire("dwptW")).orderedListWithOrder)
        },
        {
            name: 'listItem',
            spec: (0, (0, parcelRequire("2FIVU")).listItemWithTask)
        },
        {
            name: 'heading',
            spec: (0, (0, parcelRequire("lRTZM")).heading)
        },
        {
            name: 'blockquote',
            spec: (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia)
        },
        {
            name: 'codeBlock',
            spec: (0, (0, parcelRequire("8vlrc")).codeBlock)
        },
        {
            name: 'panel',
            spec: (0, (0, parcelRequire("bFtEE")).extendedPanel)(true)
        },
        {
            name: 'rule',
            spec: (0, (0, parcelRequire("M4hHz")).rule)
        },
        {
            name: 'image',
            spec: (0, (0, parcelRequire("7lRBh")).image)
        },
        {
            name: 'mention',
            spec: (0, (0, parcelRequire("g7Cky")).mention)
        },
        {
            name: 'caption',
            spec: (0, (0, parcelRequire("5JeV5")).caption)
        },
        {
            name: 'media',
            spec: (0, (0, parcelRequire("7agO8")).media)
        },
        {
            name: 'mediaGroup',
            spec: (0, (0, parcelRequire("92lix")).mediaGroup)
        },
        {
            name: 'mediaSingle',
            spec: (0, (0, parcelRequire("bIGZ7")).mediaSingleFull)
        },
        {
            name: 'mediaInline',
            spec: (0, (0, parcelRequire("7Xgp3")).mediaInline)
        },
        {
            name: 'placeholder',
            spec: (0, (0, parcelRequire("dgJoa")).placeholder)
        },
        {
            name: 'layoutSection',
            spec: (0, (0, parcelRequire("gZoER")).layoutSection)
        },
        {
            name: 'layoutColumn',
            spec: (0, (0, parcelRequire("4EbxI")).layoutColumn)
        },
        {
            name: 'hardBreak',
            spec: (0, (0, parcelRequire("jnMM2")).hardBreak)
        },
        {
            name: 'emoji',
            spec: (0, (0, parcelRequire("7DoMR")).emoji)
        },
        {
            name: 'table',
            spec: (0, (0, parcelRequire("9UDEr")).table)
        },
        {
            name: 'tableCell',
            spec: (0, (0, parcelRequire("9UDEr")).tableCell)
        },
        {
            name: 'tableRow',
            spec: (0, (0, parcelRequire("9UDEr")).tableRow)
        },
        {
            name: 'tableHeader',
            spec: (0, (0, parcelRequire("9UDEr")).tableHeader)
        },
        {
            name: 'confluenceJiraIssue',
            spec: (0, (0, parcelRequire("6bbHe")).confluenceJiraIssue)
        },
        {
            name: 'confluenceUnsupportedInline',
            spec: (0, (0, parcelRequire("bd7A9")).confluenceUnsupportedInline)
        },
        {
            name: 'confluenceUnsupportedBlock',
            spec: (0, (0, parcelRequire("5y0tR")).confluenceUnsupportedBlock)
        },
        {
            name: 'decisionList',
            spec: (0, (0, parcelRequire("8gSD8")).decisionList)
        },
        {
            name: 'decisionItem',
            spec: (0, (0, parcelRequire("Khvpb")).decisionItem)
        },
        {
            name: 'taskList',
            spec: (0, (0, parcelRequire("43mJF")).taskList)
        },
        {
            name: 'taskItem',
            spec: (0, (0, parcelRequire("iThOL")).taskItem)
        },
        {
            name: 'date',
            spec: (0, (0, parcelRequire("b2VmY")).date)
        },
        {
            name: 'status',
            spec: (0, (0, parcelRequire("18bvk")).status)
        },
        {
            name: 'expand',
            spec: (0, (0, parcelRequire("7kC9H")).expandWithNestedExpand)
        },
        {
            name: 'nestedExpand',
            spec: (0, (0, parcelRequire("dx5eC")).nestedExpand)
        },
        {
            name: 'extension',
            spec: (0, (0, parcelRequire("hhN5g")).extension)
        },
        {
            name: 'inlineExtension',
            spec: (0, (0, parcelRequire("5BOuQ")).inlineExtension)
        },
        {
            name: 'bodiedExtension',
            spec: (0, (0, parcelRequire("5AxYU")).bodiedExtension)
        },
        {
            name: 'multiBodiedExtension',
            spec: (0, (0, parcelRequire("47jug")).multiBodiedExtension)
        },
        {
            name: 'extensionFrame',
            spec: (0, (0, parcelRequire("47jug")).extensionFrame)
        },
        {
            name: 'inlineCard',
            spec: (0, (0, parcelRequire("cCBEe")).inlineCard)
        },
        {
            name: 'blockCard',
            spec: (0, (0, parcelRequire("21PS7")).blockCard)
        },
        {
            name: 'embedCard',
            spec: (0, (0, parcelRequire("kshOv")).embedCard)
        },
        {
            name: 'unknownBlock',
            spec: (0, (0, parcelRequire("9X587")).default)
        },
        {
            name: 'unsupportedBlock',
            spec: (0, (0, parcelRequire("d1d6m")).unsupportedBlock)
        },
        {
            name: 'unsupportedInline',
            spec: (0, (0, parcelRequire("6kr5W")).unsupportedInline)
        }
    ];
    const $eff4c0443be4d23b$var$marksInOrder = [
        {
            name: 'link',
            spec: (0, (0, parcelRequire("8XeG6")).link)
        },
        {
            name: 'em',
            spec: (0, (0, parcelRequire("l3Tmi")).em)
        },
        {
            name: 'strong',
            spec: (0, (0, parcelRequire("hhtT8")).strong)
        },
        {
            name: 'textColor',
            spec: (0, (0, parcelRequire("c9aa1")).textColor)
        },
        {
            name: 'backgroundColor',
            spec: (0, (0, parcelRequire("8jJss")).backgroundColor)
        },
        {
            name: 'strike',
            spec: (0, (0, parcelRequire("aUhe2")).strike)
        },
        {
            name: 'subsup',
            spec: (0, (0, parcelRequire("4NwJJ")).subsup)
        },
        {
            name: 'underline',
            spec: (0, (0, parcelRequire("8EAPB")).underline)
        },
        {
            name: 'code',
            spec: (0, (0, parcelRequire("lcXoV")).code)
        },
        {
            name: 'typeAheadQuery',
            spec: (0, (0, parcelRequire("dtyqo")).typeAheadQuery)
        },
        {
            name: 'alignment',
            spec: (0, (0, parcelRequire("aeGrH")).alignment)
        },
        {
            name: 'annotation',
            spec: (0, (0, parcelRequire("88i6h")).annotation)
        },
        {
            name: 'confluenceInlineComment',
            spec: (0, (0, parcelRequire("71k4W")).confluenceInlineComment)
        },
        ...$eff4c0443be4d23b$var$markGroupDeclarations,
        {
            name: 'breakout',
            spec: (0, (0, parcelRequire("zceQE")).breakout)
        },
        {
            name: 'dataConsumer',
            spec: (0, (0, parcelRequire("cUwVZ")).dataConsumer)
        },
        {
            name: 'fragment',
            spec: (0, (0, parcelRequire("29Vii")).fragment)
        },
        {
            name: 'indentation',
            spec: (0, (0, parcelRequire("fK6mK")).indentation)
        },
        {
            name: 'border',
            spec: (0, (0, parcelRequire("14Vqw")).border)
        },
        {
            name: 'unsupportedMark',
            spec: (0, (0, parcelRequire("jxVez")).unsupportedMark)
        },
        {
            name: 'unsupportedNodeAttribute',
            spec: (0, (0, parcelRequire("lVmBd")).unsupportedNodeAttribute)
        }
    ];
    function $eff4c0443be4d23b$export$2d0c32a809131488() {
        const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
            acc[name] = spec;
            return acc;
        }, {});
        const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
            acc[name] = spec;
            return acc;
        }, {});
        return {
            nodes: nodes,
            marks: marks
        };
    }
    function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
        const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
        const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
        const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
        let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
        const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
        nodes = $eff4c0443be4d23b$export$daf54fed04c8fb77(nodes, marks);
        return new (0, (0, parcelRequire("kCV8T")).Schema)({
            nodes: nodes,
            marks: marks
        });
    }
    function $eff4c0443be4d23b$export$daf54fed04c8fb77(nodes, supportedMarks) {
        const nodeNames = Object.keys(nodes);
        nodeNames.forEach((nodeKey)=>{
            const nodeSpec = {
                ...nodes[nodeKey]
            };
            if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
            if (nodeSpec.content) nodeSpec.content = $eff4c0443be4d23b$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
            nodes[nodeKey] = nodeSpec;
        });
        return nodes;
    }
    function $eff4c0443be4d23b$export$9cb535b0ed27c9c(nodes, rawContent) {
        const content = rawContent.replace(/\W/g, ' ');
        const contentKeys = content.split(' ');
        const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$eff4c0443be4d23b$var$isContentSupported(nodes, contentKey));
        return unsupportedContentKeys.reduce((newContent, nodeName)=>$eff4c0443be4d23b$var$sanitizedContent(newContent, nodeName), rawContent);
    }
    function $eff4c0443be4d23b$var$sanitizedContent(content, invalidContent) {
        if (!invalidContent.length) return content || '';
        if (!content || !content.match(/\w/)) return '';
        const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
        return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
    }
    function $eff4c0443be4d23b$var$isContentSupported(nodes, contentKey) {
        const nodeKeys = Object.keys(nodes);
        if (nodeKeys.indexOf(contentKey) > -1) return true;
        for(const supportedKey in nodes){
            const nodeSpec = nodes[supportedKey];
            if (nodeSpec && nodeSpec.group === contentKey) return true;
        }
        return false;
    }
    const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;
});
parcelRegister("kCV8T", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$f043ae92c0a873f0$export$ffb0004e005737fa);
    $parcel$export(module.exports, "Mark", ()=>$f043ae92c0a873f0$export$c9d15bcfc6d42044);
    $parcel$export(module.exports, "ReplaceError", ()=>$f043ae92c0a873f0$export$6de0e778727af3f2);
    $parcel$export(module.exports, "Slice", ()=>$f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
    $parcel$export(module.exports, "ResolvedPos", ()=>$f043ae92c0a873f0$export$b2a42f82e59e4b19);
    $parcel$export(module.exports, "NodeRange", ()=>$f043ae92c0a873f0$export$7bc461ceb770fb16);
    $parcel$export(module.exports, "Node", ()=>$f043ae92c0a873f0$export$85c928794f8d04d4);
    $parcel$export(module.exports, "MarkType", ()=>$f043ae92c0a873f0$export$b6a78689043c6521);
    $parcel$export(module.exports, "Schema", ()=>$f043ae92c0a873f0$export$19342e026b58ebb7);
    $parcel$export(module.exports, "DOMParser", ()=>$f043ae92c0a873f0$export$1059c6e7d2ce5669);
    $parcel$export(module.exports, "DOMSerializer", ()=>$f043ae92c0a873f0$export$3476b78f8f5a8b72);
    var $dHeNB;
    function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
        for(let i = 0;; i++){
            if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
            let childA = a.child(i), childB = b.child(i);
            if (childA == childB) {
                pos += childA.nodeSize;
                continue;
            }
            if (!childA.sameMarkup(childB)) return pos;
            if (childA.isText && childA.text != childB.text) {
                for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
                return pos;
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
                if (inner != null) return inner;
            }
            pos += childA.nodeSize;
        }
    }
    function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
        for(let iA = a.childCount, iB = b.childCount;;){
            if (iA == 0 || iB == 0) return iA == iB ? null : {
                a: posA,
                b: posB
            };
            let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
            if (childA == childB) {
                posA -= size;
                posB -= size;
                continue;
            }
            if (!childA.sameMarkup(childB)) return {
                a: posA,
                b: posB
            };
            if (childA.isText && childA.text != childB.text) {
                let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
                while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                    same++;
                    posA--;
                    posB--;
                }
                return {
                    a: posA,
                    b: posB
                };
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
                if (inner) return inner;
            }
            posA -= size;
            posB -= size;
        }
    }
    class $f043ae92c0a873f0$export$ffb0004e005737fa {
        constructor(content, size){
            this.content = content;
            this.size = size || 0;
            if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
        }
        nodesBetween(from, to, f, nodeStart = 0, parent) {
            for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                    let start = pos + 1;
                    child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
                }
                pos = end;
            }
        }
        descendants(f) {
            this.nodesBetween(0, this.size, f);
        }
        textBetween(from, to, blockSeparator, leafText) {
            let text = "", first = true;
            this.nodesBetween(from, to, (node, pos)=>{
                let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
                if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                    if (first) first = false;
                    else text += blockSeparator;
                }
                text += nodeText;
            }, 0);
            return text;
        }
        append(other) {
            if (!other.size) return this;
            if (!this.size) return other;
            let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
            if (last.isText && last.sameMarkup(first)) {
                content[content.length - 1] = last.withText(last.text + first.text);
                i = 1;
            }
            for(; i < other.content.length; i++)content.push(other.content[i]);
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
        }
        cut(from, to = this.size) {
            if (from == 0 && to == this.size) return this;
            let result = [], size = 0;
            if (to > from) for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from) {
                    if (pos < from || end > to) {
                        if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                        else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                    }
                    result.push(child);
                    size += child.nodeSize;
                }
                pos = end;
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
        }
        cutByIndex(from, to) {
            if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (from == 0 && to == this.content.length) return this;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
        }
        replaceChild(index, node) {
            let current = this.content[index];
            if (current == node) return this;
            let copy = this.content.slice();
            let size = this.size + node.nodeSize - current.nodeSize;
            copy[index] = node;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
        }
        addToStart(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                node
            ].concat(this.content), this.size + node.nodeSize);
        }
        addToEnd(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
        }
        eq(other) {
            if (this.content.length != other.content.length) return false;
            for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
            return true;
        }
        get firstChild() {
            return this.content.length ? this.content[0] : null;
        }
        get lastChild() {
            return this.content.length ? this.content[this.content.length - 1] : null;
        }
        get childCount() {
            return this.content.length;
        }
        child(index) {
            let found = this.content[index];
            if (!found) throw new RangeError("Index " + index + " out of range for " + this);
            return found;
        }
        maybeChild(index) {
            return this.content[index] || null;
        }
        forEach(f) {
            for(let i = 0, p = 0; i < this.content.length; i++){
                let child = this.content[i];
                f(child, p, i);
                p += child.nodeSize;
            }
        }
        findDiffStart(other, pos = 0) {
            return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
        }
        findDiffEnd(other, pos = this.size, otherPos = other.size) {
            return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
        }
        findIndex(pos, round = -1) {
            if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
            if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
            if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
            for(let i = 0, curPos = 0;; i++){
                let cur = this.child(i), end = curPos + cur.nodeSize;
                if (end >= pos) {
                    if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                    return $f043ae92c0a873f0$var$retIndex(i, curPos);
                }
                curPos = end;
            }
        }
        toString() {
            return "<" + this.toStringInner() + ">";
        }
        toStringInner() {
            return this.content.join(", ");
        }
        toJSON() {
            return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
        }
        static fromJSON(schema, value) {
            if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
        }
        static fromArray(array) {
            if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            let joined, size = 0;
            for(let i = 0; i < array.length; i++){
                let node = array[i];
                size += node.nodeSize;
                if (i && node.isText && array[i - 1].sameMarkup(node)) {
                    if (!joined) joined = array.slice(0, i);
                    joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
                } else if (joined) joined.push(node);
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
        }
        static from(nodes) {
            if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
            if (Array.isArray(nodes)) return this.fromArray(nodes);
            if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                nodes
            ], nodes.nodeSize);
            throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
        }
    }
    $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
    const $f043ae92c0a873f0$var$found = {
        index: 0,
        offset: 0
    };
    function $f043ae92c0a873f0$var$retIndex(index, offset) {
        $f043ae92c0a873f0$var$found.index = index;
        $f043ae92c0a873f0$var$found.offset = offset;
        return $f043ae92c0a873f0$var$found;
    }
    function $f043ae92c0a873f0$var$compareDeep(a, b) {
        if (a === b) return true;
        if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
        let array = Array.isArray(a);
        if (Array.isArray(b) != array) return false;
        if (array) {
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
        } else {
            for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
            for(let p in b)if (!(p in a)) return false;
        }
        return true;
    }
    class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
        constructor(type, attrs){
            this.type = type;
            this.attrs = attrs;
        }
        addToSet(set) {
            let copy, placed = false;
            for(let i = 0; i < set.length; i++){
                let other = set[i];
                if (this.eq(other)) return set;
                if (this.type.excludes(other.type)) {
                    if (!copy) copy = set.slice(0, i);
                } else if (other.type.excludes(this.type)) return set;
                else {
                    if (!placed && other.type.rank > this.type.rank) {
                        if (!copy) copy = set.slice(0, i);
                        copy.push(this);
                        placed = true;
                    }
                    if (copy) copy.push(other);
                }
            }
            if (!copy) copy = set.slice();
            if (!placed) copy.push(this);
            return copy;
        }
        removeFromSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
            return false;
        }
        eq(other) {
            return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
            let type = schema.marks[json.type];
            if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
            let mark = type.create(json.attrs);
            type.checkAttrs(mark.attrs);
            return mark;
        }
        static sameSet(a, b) {
            if (a == b) return true;
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
            return true;
        }
        static setFrom(marks) {
            if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
                marks
            ];
            let copy = marks.slice();
            copy.sort((a, b)=>a.type.rank - b.type.rank);
            return copy;
        }
    }
    $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
    class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
    }
    class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
        constructor(content, openStart, openEnd){
            this.content = content;
            this.openStart = openStart;
            this.openEnd = openEnd;
        }
        get size() {
            return this.content.size - this.openStart - this.openEnd;
        }
        insertAt(pos, fragment) {
            let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
            return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
        }
        removeBetween(from, to) {
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
        }
        eq(other) {
            return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
        }
        toString() {
            return this.content + "(" + this.openStart + "," + this.openEnd + ")";
        }
        toJSON() {
            if (!this.content.size) return null;
            let json = {
                content: this.content.toJSON()
            };
            if (this.openStart > 0) json.openStart = this.openStart;
            if (this.openEnd > 0) json.openEnd = this.openEnd;
            return json;
        }
        static fromJSON(schema, json) {
            if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
            if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
        }
        static maxOpen(fragment, openIsolating = true) {
            let openStart = 0, openEnd = 0;
            for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
            for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
        }
    }
    $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
    function $f043ae92c0a873f0$var$removeRange(content, from, to) {
        let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
        let { index: indexTo, offset: offsetTo } = content.findIndex(to);
        if (offset == from || child.isText) {
            if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
            return content.cut(0, from).append(content.cut(to));
        }
        if (index != indexTo) throw new RangeError("Removing non-flat range");
        return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
    }
    function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
        let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
        if (offset == dist || child.isText) {
            if (parent && !parent.canReplace(index, index, insert)) return null;
            return content.cut(0, dist).append(insert).append(content.cut(dist));
        }
        let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
        return inner && content.replaceChild(index, child.copy(inner));
    }
    function $f043ae92c0a873f0$var$replace($from, $to, slice) {
        if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
        if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
        return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
    }
    function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
        let index = $from.index(depth), node = $from.node(depth);
        if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
            let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
            return node.copy(node.content.replaceChild(index, inner));
        } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
        else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
            let parent = $from.parent, content = parent.content;
            return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
        } else {
            let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
            return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
        }
    }
    function $f043ae92c0a873f0$var$checkJoin(main, sub) {
        if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
    }
    function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
        let node = $before.node(depth);
        $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
        return node;
    }
    function $f043ae92c0a873f0$var$addNode(child, target) {
        let last = target.length - 1;
        if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
        else target.push(child);
    }
    function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
        let node = ($end || $start).node(depth);
        let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
        if ($start) {
            startIndex = $start.index(depth);
            if ($start.depth > depth) startIndex++;
            else if ($start.textOffset) {
                $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
                startIndex++;
            }
        }
        for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
        if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
    }
    function $f043ae92c0a873f0$var$close(node, content) {
        node.type.checkContent(content);
        return node.copy(content);
    }
    function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
        let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
        let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
            $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
        } else {
            if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
            $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
            if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if ($from.depth > depth) {
            let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
        let extra = $along.depth - slice.openStart, parent = $along.node(extra);
        let node = parent.copy(slice.content);
        for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
        return {
            start: node.resolveNoCache(slice.openStart + extra),
            end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
        };
    }
    class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
        constructor(pos, path, parentOffset){
            this.pos = pos;
            this.path = path;
            this.parentOffset = parentOffset;
            this.depth = path.length / 3 - 1;
        }
        resolveDepth(val) {
            if (val == null) return this.depth;
            if (val < 0) return this.depth + val;
            return val;
        }
        get parent() {
            return this.node(this.depth);
        }
        get doc() {
            return this.node(0);
        }
        node(depth) {
            return this.path[this.resolveDepth(depth) * 3];
        }
        index(depth) {
            return this.path[this.resolveDepth(depth) * 3 + 1];
        }
        indexAfter(depth) {
            depth = this.resolveDepth(depth);
            return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
        }
        start(depth) {
            depth = this.resolveDepth(depth);
            return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        }
        end(depth) {
            depth = this.resolveDepth(depth);
            return this.start(depth) + this.node(depth).content.size;
        }
        before(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position before the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
        }
        after(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position after the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
        }
        get textOffset() {
            return this.pos - this.path[this.path.length - 1];
        }
        get nodeAfter() {
            let parent = this.parent, index = this.index(this.depth);
            if (index == parent.childCount) return null;
            let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
            return dOff ? parent.child(index).cut(dOff) : child;
        }
        get nodeBefore() {
            let index = this.index(this.depth);
            let dOff = this.pos - this.path[this.path.length - 1];
            if (dOff) return this.parent.child(index).cut(0, dOff);
            return index == 0 ? null : this.parent.child(index - 1);
        }
        posAtIndex(index, depth) {
            depth = this.resolveDepth(depth);
            let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
            for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
            return pos;
        }
        marks() {
            let parent = this.parent, index = this.index();
            if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (this.textOffset) return parent.child(index).marks;
            let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
            if (!main) {
                let tmp = main;
                main = other;
                other = tmp;
            }
            let marks = main.marks;
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        marksAcross($end) {
            let after = this.parent.maybeChild(this.index());
            if (!after || !after.isInline) return null;
            let marks = after.marks, next = $end.parent.maybeChild($end.index());
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        sharedDepth(pos) {
            for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
            return 0;
        }
        blockRange(other = this, pred) {
            if (other.pos < this.pos) return other.blockRange(this);
            for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
            return null;
        }
        sameParent(other) {
            return this.pos - this.parentOffset == other.pos - other.parentOffset;
        }
        max(other) {
            return other.pos > this.pos ? other : this;
        }
        min(other) {
            return other.pos < this.pos ? other : this;
        }
        toString() {
            let str = "";
            for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
            return str + ":" + this.parentOffset;
        }
        static resolve(doc, pos) {
            if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
            let path = [];
            let start = 0, parentOffset = pos;
            for(let node = doc;;){
                let { index: index, offset: offset } = node.content.findIndex(parentOffset);
                let rem = parentOffset - offset;
                path.push(node, index, start + offset);
                if (!rem) break;
                node = node.child(index);
                if (node.isText) break;
                parentOffset = rem - 1;
                start += offset + 1;
            }
            return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
        }
        static resolveCached(doc, pos) {
            let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
            if (cache) for(let i = 0; i < cache.elts.length; i++){
                let elt = cache.elts[i];
                if (elt.pos == pos) return elt;
            }
            else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
            let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
            cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
            return result;
        }
    }
    class $f043ae92c0a873f0$var$ResolveCache {
        constructor(){
            this.elts = [];
            this.i = 0;
        }
    }
    const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
    class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
        constructor($from, $to, depth){
            this.$from = $from;
            this.$to = $to;
            this.depth = depth;
        }
        get start() {
            return this.$from.before(this.depth + 1);
        }
        get end() {
            return this.$to.after(this.depth + 1);
        }
        get parent() {
            return this.$from.node(this.depth);
        }
        get startIndex() {
            return this.$from.index(this.depth);
        }
        get endIndex() {
            return this.$to.indexAfter(this.depth);
        }
    }
    const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
    class $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        }
        get nodeSize() {
            return this.isLeaf ? 1 : 2 + this.content.size;
        }
        get childCount() {
            return this.content.childCount;
        }
        child(index) {
            return this.content.child(index);
        }
        maybeChild(index) {
            return this.content.maybeChild(index);
        }
        forEach(f) {
            this.content.forEach(f);
        }
        nodesBetween(from, to, f, startPos = 0) {
            this.content.nodesBetween(from, to, f, startPos, this);
        }
        descendants(f) {
            this.nodesBetween(0, this.content.size, f);
        }
        get textContent() {
            return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
        }
        textBetween(from, to, blockSeparator, leafText) {
            return this.content.textBetween(from, to, blockSeparator, leafText);
        }
        get firstChild() {
            return this.content.firstChild;
        }
        get lastChild() {
            return this.content.lastChild;
        }
        eq(other) {
            return this == other || this.sameMarkup(other) && this.content.eq(other.content);
        }
        sameMarkup(other) {
            return this.hasMarkup(other.type, other.attrs, other.marks);
        }
        hasMarkup(type, attrs, marks) {
            return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
        }
        copy(content = null) {
            if (content == this.content) return this;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
        }
        cut(from, to = this.content.size) {
            if (from == 0 && to == this.content.size) return this;
            return this.copy(this.content.cut(from, to));
        }
        slice(from, to = this.content.size, includeParents = false) {
            if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let $from = this.resolve(from), $to = this.resolve(to);
            let depth = includeParents ? 0 : $from.sharedDepth(to);
            let start = $from.start(depth), node = $from.node(depth);
            let content = node.content.cut($from.pos - start, $to.pos - start);
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
        }
        replace(from, to, slice) {
            return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
        }
        nodeAt(pos) {
            for(let node = this;;){
                let { index: index, offset: offset } = node.content.findIndex(pos);
                node = node.maybeChild(index);
                if (!node) return null;
                if (offset == pos || node.isText) return node;
                pos -= offset + 1;
            }
        }
        childAfter(pos) {
            let { index: index, offset: offset } = this.content.findIndex(pos);
            return {
                node: this.content.maybeChild(index),
                index: index,
                offset: offset
            };
        }
        childBefore(pos) {
            if (pos == 0) return {
                node: null,
                index: 0,
                offset: 0
            };
            let { index: index, offset: offset } = this.content.findIndex(pos);
            if (offset < pos) return {
                node: this.content.child(index),
                index: index,
                offset: offset
            };
            let node = this.content.child(index - 1);
            return {
                node: node,
                index: index - 1,
                offset: offset - node.nodeSize
            };
        }
        resolve(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
        }
        resolveNoCache(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
        }
        rangeHasMark(from, to, type) {
            let found = false;
            if (to > from) this.nodesBetween(from, to, (node)=>{
                if (type.isInSet(node.marks)) found = true;
                return !found;
            });
            return found;
        }
        get isBlock() {
            return this.type.isBlock;
        }
        get isTextblock() {
            return this.type.isTextblock;
        }
        get inlineContent() {
            return this.type.inlineContent;
        }
        get isInline() {
            return this.type.isInline;
        }
        get isText() {
            return this.type.isText;
        }
        get isLeaf() {
            return this.type.isLeaf;
        }
        get isAtom() {
            return this.type.isAtom;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            let name = this.type.name;
            if (this.content.size) name += "(" + this.content.toStringInner() + ")";
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
        }
        contentMatchAt(index) {
            let match = this.type.contentMatch.matchFragment(this.content, 0, index);
            if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
            return match;
        }
        canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
            let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
            let two = one && one.matchFragment(this.content, to);
            if (!two || !two.validEnd) return false;
            for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
            return true;
        }
        canReplaceWith(from, to, type, marks) {
            if (marks && !this.type.allowsMarks(marks)) return false;
            let start = this.contentMatchAt(from).matchType(type);
            let end = start && start.matchFragment(this.content, to);
            return end ? end.validEnd : false;
        }
        canAppend(other) {
            if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
            else return this.type.compatibleContent(other.type);
        }
        check() {
            this.type.checkContent(this.content);
            this.type.checkAttrs(this.attrs);
            let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for(let i = 0; i < this.marks.length; i++){
                let mark = this.marks[i];
                mark.type.checkAttrs(mark.attrs);
                copy = mark.addToSet(copy);
            }
            if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
            this.content.forEach((node)=>node.check());
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            if (this.content.size) obj.content = this.content.toJSON();
            if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Node.fromJSON");
            let marks = undefined;
            if (json.marks) {
                if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
                marks = json.marks.map(schema.markFromJSON);
            }
            if (json.type == "text") {
                if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
                return schema.text(json.text, marks);
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
            let node = schema.nodeType(json.type).create(json.attrs, content, marks);
            node.type.checkAttrs(node.attrs);
            return node;
        }
    }
    $f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
    class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks){
            super(type, attrs, null, marks);
            if (!content) throw new RangeError("Empty text nodes are not allowed");
            this.text = content;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
        }
        get textContent() {
            return this.text;
        }
        textBetween(from, to) {
            return this.text.slice(from, to);
        }
        get nodeSize() {
            return this.text.length;
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
        }
        withText(text) {
            if (text == this.text) return this;
            return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
        }
        cut(from = 0, to = this.text.length) {
            if (from == 0 && to == this.text.length) return this;
            return this.withText(this.text.slice(from, to));
        }
        eq(other) {
            return this.sameMarkup(other) && this.text == other.text;
        }
        toJSON() {
            let base = super.toJSON();
            base.text = this.text;
            return base;
        }
    }
    function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
        for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
        return str;
    }
    class $f043ae92c0a873f0$export$364ed450558d7ec4 {
        constructor(validEnd){
            this.validEnd = validEnd;
            this.next = [];
            this.wrapCache = [];
        }
        static parse(string, nodeTypes) {
            let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
            if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (stream.next) stream.err("Unexpected trailing text");
            let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
            $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
            return match;
        }
        matchType(type) {
            for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
            return null;
        }
        matchFragment(frag, start = 0, end = frag.childCount) {
            let cur = this;
            for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
            return cur;
        }
        get inlineContent() {
            return this.next.length != 0 && this.next[0].type.isInline;
        }
        get defaultType() {
            for(let i = 0; i < this.next.length; i++){
                let { type: type } = this.next[i];
                if (!(type.isText || type.hasRequiredAttrs())) return type;
            }
            return null;
        }
        compatible(other) {
            for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
            return false;
        }
        fillBefore(after, toEnd = false, startIndex = 0) {
            let seen = [
                this
            ];
            function search(match, types) {
                let finished = match.matchFragment(after, startIndex);
                if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                        seen.push(next);
                        let found = search(next, types.concat(type));
                        if (found) return found;
                    }
                }
                return null;
            }
            return search(this, []);
        }
        findWrapping(target) {
            for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
            let computed = this.computeWrapping(target);
            this.wrapCache.push(target, computed);
            return computed;
        }
        computeWrapping(target) {
            let seen = Object.create(null), active = [
                {
                    match: this,
                    type: null,
                    via: null
                }
            ];
            while(active.length){
                let current = active.shift(), match = current.match;
                if (match.matchType(target)) {
                    let result = [];
                    for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                    return result.reverse();
                }
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                        active.push({
                            match: type.contentMatch,
                            type: type,
                            via: current
                        });
                        seen[type.name] = true;
                    }
                }
            }
            return null;
        }
        get edgeCount() {
            return this.next.length;
        }
        edge(n) {
            if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
            return this.next[n];
        }
        toString() {
            let seen = [];
            function scan(m) {
                seen.push(m);
                for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
            }
            scan(this);
            return seen.map((m, i)=>{
                let out = i + (m.validEnd ? "*" : " ") + " ";
                for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
                return out;
            }).join("\n");
        }
    }
    $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
    class $f043ae92c0a873f0$var$TokenStream {
        constructor(string, nodeTypes){
            this.string = string;
            this.nodeTypes = nodeTypes;
            this.inline = null;
            this.pos = 0;
            this.tokens = string.split(/\s*(?=\b|\W|$)/);
            if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
            if (this.tokens[0] == "") this.tokens.shift();
        }
        get next() {
            return this.tokens[this.pos];
        }
        eat(tok) {
            return this.next == tok && (this.pos++ || true);
        }
        err(str) {
            throw new SyntaxError(str + " (in content expression '" + this.string + "')");
        }
    }
    function $f043ae92c0a873f0$var$parseExpr(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
        while (stream.eat("|"))
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSeq(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
        while (stream.next && stream.next != ")" && stream.next != "|")
        return exprs.length == 1 ? exprs[0] : {
            type: "seq",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
        let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
        for(;;){
            if (stream.eat("+")) expr = {
                type: "plus",
                expr: expr
            };
            else if (stream.eat("*")) expr = {
                type: "star",
                expr: expr
            };
            else if (stream.eat("?")) expr = {
                type: "opt",
                expr: expr
            };
            else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
            else break;
        }
        return expr;
    }
    function $f043ae92c0a873f0$var$parseNum(stream) {
        if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
        let result = Number(stream.next);
        stream.pos++;
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
        let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
        if (stream.eat(",")) {
            if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
            else max = -1;
        }
        if (!stream.eat("}")) stream.err("Unclosed braced range");
        return {
            type: "range",
            min: min,
            max: max,
            expr: expr
        };
    }
    function $f043ae92c0a873f0$var$resolveName(stream, name) {
        let types = stream.nodeTypes, type = types[name];
        if (type) return [
            type
        ];
        let result = [];
        for(let typeName in types){
            let type = types[typeName];
            if (type.groups.indexOf(name) > -1) result.push(type);
        }
        if (result.length == 0) stream.err("No node type or group '" + name + "' found");
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprAtom(stream) {
        if (stream.eat("(")) {
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (!stream.eat(")")) stream.err("Missing closing paren");
            return expr;
        } else if (!/\W/.test(stream.next)) {
            let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
                if (stream.inline == null) stream.inline = type.isInline;
                else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
                return {
                    type: "name",
                    value: type
                };
            });
            stream.pos++;
            return exprs.length == 1 ? exprs[0] : {
                type: "choice",
                exprs: exprs
            };
        } else stream.err("Unexpected token '" + stream.next + "'");
    }
    function $f043ae92c0a873f0$var$nfa(expr) {
        let nfa = [
            []
        ];
        connect(compile(expr, 0), node());
        return nfa;
        function node() {
            return nfa.push([]) - 1;
        }
        function edge(from, to, term) {
            let edge = {
                term: term,
                to: to
            };
            nfa[from].push(edge);
            return edge;
        }
        function connect(edges, to) {
            edges.forEach((edge)=>edge.to = to);
        }
        function compile(expr, from) {
            if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
            else if (expr.type == "seq") for(let i = 0;; i++){
                let next = compile(expr.exprs[i], from);
                if (i == expr.exprs.length - 1) return next;
                connect(next, from = node());
            }
            else if (expr.type == "star") {
                let loop = node();
                edge(from, loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "plus") {
                let loop = node();
                connect(compile(expr.expr, from), loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "opt") return [
                edge(from)
            ].concat(compile(expr.expr, from));
            else if (expr.type == "range") {
                let cur = from;
                for(let i = 0; i < expr.min; i++){
                    let next = node();
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                if (expr.max == -1) connect(compile(expr.expr, cur), cur);
                else for(let i = expr.min; i < expr.max; i++){
                    let next = node();
                    edge(cur, next);
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                return [
                    edge(cur)
                ];
            } else if (expr.type == "name") return [
                edge(from, undefined, expr.value)
            ];
            else throw new Error("Unknown expr type");
        }
    }
    function $f043ae92c0a873f0$var$cmp(a, b) {
        return b - a;
    }
    function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
        let result = [];
        scan(node);
        return result.sort($f043ae92c0a873f0$var$cmp);
        function scan(node) {
            let edges = nfa[node];
            if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
            result.push(node);
            for(let i = 0; i < edges.length; i++){
                let { term: term, to: to } = edges[i];
                if (!term && result.indexOf(to) == -1) scan(to);
            }
        }
    }
    function $f043ae92c0a873f0$var$dfa(nfa) {
        let labeled = Object.create(null);
        return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
        function explore(states) {
            let out = [];
            states.forEach((node)=>{
                nfa[node].forEach(({ term: term, to: to })=>{
                    if (!term) return;
                    let set;
                    for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                    $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                        if (!set) out.push([
                            term,
                            set = []
                        ]);
                        if (set.indexOf(node) == -1) set.push(node);
                    });
                });
            });
            let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
            for(let i = 0; i < out.length; i++){
                let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
                state.next.push({
                    type: out[i][0],
                    next: labeled[states.join(",")] || explore(states)
                });
            }
            return state;
        }
    }
    function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
        for(let i = 0, work = [
            match
        ]; i < work.length; i++){
            let state = work[i], dead = !state.validEnd, nodes = [];
            for(let j = 0; j < state.next.length; j++){
                let { type: type, next: next } = state.next[j];
                nodes.push(type.name);
                if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
                if (work.indexOf(next) == -1) work.push(next);
            }
            if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
        }
    }
    function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
        let defaults = Object.create(null);
        for(let attrName in attrs){
            let attr = attrs[attrName];
            if (!attr.hasDefault) return null;
            defaults[attrName] = attr.default;
        }
        return defaults;
    }
    function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
        let built = Object.create(null);
        for(let name in attrs){
            let given = value && value[name];
            if (given === undefined) {
                let attr = attrs[name];
                if (attr.hasDefault) given = attr.default;
                else throw new RangeError("No value supplied for attribute " + name);
            }
            built[name] = given;
        }
        return built;
    }
    function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
        for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
        for(let name in attrs){
            let attr = attrs[name];
            if (attr.validate) attr.validate(values[name]);
        }
    }
    function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
        let result = Object.create(null);
        if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
        return result;
    }
    class $f043ae92c0a873f0$export$f06e977173f1857c {
        constructor(name, schema, spec){
            this.name = name;
            this.schema = schema;
            this.spec = spec;
            this.markSet = null;
            this.groups = spec.group ? spec.group.split(" ") : [];
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.contentMatch = null;
            this.inlineContent = null;
            this.isBlock = !(spec.inline || name == "text");
            this.isText = name == "text";
        }
        get isInline() {
            return !this.isBlock;
        }
        get isTextblock() {
            return this.isBlock && this.inlineContent;
        }
        get isLeaf() {
            return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        }
        get isAtom() {
            return this.isLeaf || !!this.spec.atom;
        }
        get whitespace() {
            return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
        }
        hasRequiredAttrs() {
            for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
            return false;
        }
        compatibleContent(other) {
            return this == other || this.contentMatch.compatible(other.contentMatch);
        }
        computeAttrs(attrs) {
            if (!attrs && this.defaultAttrs) return this.defaultAttrs;
            else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
        }
        create(attrs = null, content, marks) {
            if (this.isText) throw new Error("NodeType.create can't construct text nodes");
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createChecked(attrs = null, content, marks) {
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            this.checkContent(content);
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createAndFill(attrs = null, content, marks) {
            attrs = this.computeAttrs(attrs);
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            if (content.size) {
                let before = this.contentMatch.fillBefore(content);
                if (!before) return null;
                content = before.append(content);
            }
            let matched = this.contentMatch.matchFragment(content);
            let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
            if (!after) return null;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        validContent(content) {
            let result = this.contentMatch.matchFragment(content);
            if (!result || !result.validEnd) return false;
            for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
            return true;
        }
        checkContent(content) {
            if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
        }
        allowsMarkType(markType) {
            return this.markSet == null || this.markSet.indexOf(markType) > -1;
        }
        allowsMarks(marks) {
            if (this.markSet == null) return true;
            for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
            return true;
        }
        allowedMarks(marks) {
            if (this.markSet == null) return marks;
            let copy;
            for(let i = 0; i < marks.length; i++){
                if (!this.allowsMarkType(marks[i].type)) {
                    if (!copy) copy = marks.slice(0, i);
                } else if (copy) copy.push(marks[i]);
            }
            return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        }
        static compile(nodes, schema) {
            let result = Object.create(null);
            nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
            let topType = schema.spec.topNode || "doc";
            if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
            if (!result.text) throw new RangeError("Every schema needs a 'text' type");
            for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
            return result;
        }
    }
    function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
        let types = type.split("|");
        return (value)=>{
            let name = value === null ? "null" : typeof value;
            if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
        };
    }
    class $f043ae92c0a873f0$var$Attribute {
        constructor(typeName, attrName, options){
            this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
            this.default = options.default;
            this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
        }
        get isRequired() {
            return !this.hasDefault;
        }
    }
    class $f043ae92c0a873f0$export$b6a78689043c6521 {
        constructor(name, rank, schema, spec){
            this.name = name;
            this.rank = rank;
            this.schema = schema;
            this.spec = spec;
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.excluded = null;
            let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
        }
        create(attrs = null) {
            if (!attrs && this.instance) return this.instance;
            return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
        }
        static compile(marks, schema) {
            let result = Object.create(null), rank = 0;
            marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
            return result;
        }
        removeFromSet(set) {
            for(var i = 0; i < set.length; i++)if (set[i].type == this) {
                set = set.slice(0, i).concat(set.slice(i + 1));
                i--;
            }
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
        }
        excludes(other) {
            return this.excluded.indexOf(other) > -1;
        }
    }
    class $f043ae92c0a873f0$export$19342e026b58ebb7 {
        constructor(spec){
            this.linebreakReplacement = null;
            this.cached = Object.create(null);
            let instanceSpec = this.spec = {};
            for(let prop in spec)instanceSpec[prop] = spec[prop];
            instanceSpec.nodes = (0, (0, parcelRequire("dHeNB")).default).from(spec.nodes), instanceSpec.marks = (0, (0, parcelRequire("dHeNB")).default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
            this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
            let contentExprCache = Object.create(null);
            for(let prop in this.nodes){
                if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
                let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
                type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
                type.inlineContent = type.contentMatch.inlineContent;
                if (type.spec.linebreakReplacement) {
                    if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                    if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                    this.linebreakReplacement = type;
                }
                type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
            }
            for(let prop in this.marks){
                let type = this.marks[prop], excl = type.spec.excludes;
                type.excluded = excl == null ? [
                    type
                ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
            }
            this.nodeFromJSON = this.nodeFromJSON.bind(this);
            this.markFromJSON = this.markFromJSON.bind(this);
            this.topNodeType = this.nodes[this.spec.topNode || "doc"];
            this.cached.wrappings = Object.create(null);
        }
        node(type, attrs = null, content, marks) {
            if (typeof type == "string") type = this.nodeType(type);
            else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
            else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
            return type.createChecked(attrs, content, marks);
        }
        text(text, marks) {
            let type = this.nodes.text;
            return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        mark(type, attrs) {
            if (typeof type == "string") type = this.marks[type];
            return type.create(attrs);
        }
        nodeFromJSON(json) {
            return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
        }
        markFromJSON(json) {
            return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
        }
        nodeType(name) {
            let found = this.nodes[name];
            if (!found) throw new RangeError("Unknown node type: " + name);
            return found;
        }
    }
    function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
        let found = [];
        for(let i = 0; i < marks.length; i++){
            let name = marks[i], mark = schema.marks[name], ok = mark;
            if (mark) found.push(mark);
            else for(let prop in schema.marks){
                let mark = schema.marks[prop];
                if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
            }
            if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
        }
        return found;
    }
    function $f043ae92c0a873f0$var$isTagRule(rule) {
        return rule.tag != null;
    }
    function $f043ae92c0a873f0$var$isStyleRule(rule) {
        return rule.style != null;
    }
    class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
        constructor(schema, rules){
            this.schema = schema;
            this.rules = rules;
            this.tags = [];
            this.styles = [];
            let matchedStyles = this.matchedStyles = [];
            rules.forEach((rule)=>{
                if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
                else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                    let prop = /[^=]*/.exec(rule.style)[0];
                    if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                    this.styles.push(rule);
                }
            });
            this.normalizeLists = !this.tags.some((r)=>{
                if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
                let node = schema.nodes[r.node];
                return node.contentMatch.matchType(node);
            });
        }
        parse(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return context.finish();
        }
        parseSlice(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
        }
        matchTag(dom, context, after) {
            for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
                let rule = this.tags[i];
                if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                    if (rule.getAttrs) {
                        let result = rule.getAttrs(dom);
                        if (result === false) continue;
                        rule.attrs = result || undefined;
                    }
                    return rule;
                }
            }
        }
        matchStyle(prop, value, context, after) {
            for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
                let rule = this.styles[i], style = rule.style;
                if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
                if (rule.getAttrs) {
                    let result = rule.getAttrs(value);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
        static schemaRules(schema) {
            let result = [];
            function insert(rule) {
                let priority = rule.priority == null ? 50 : rule.priority, i = 0;
                for(; i < result.length; i++){
                    let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                    if (nextPriority < priority) break;
                }
                result.splice(i, 0, rule);
            }
            for(let name in schema.marks){
                let rules = schema.marks[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
                });
            }
            for(let name in schema.nodes){
                let rules = schema.nodes[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
                });
            }
            return result;
        }
        static fromSchema(schema) {
            return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
        }
    }
    const $f043ae92c0a873f0$var$blockTags = {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        canvas: true,
        dd: true,
        div: true,
        dl: true,
        fieldset: true,
        figcaption: true,
        figure: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        li: true,
        noscript: true,
        ol: true,
        output: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        tfoot: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$ignoreTags = {
        head: true,
        noscript: true,
        object: true,
        script: true,
        style: true,
        title: true
    };
    const $f043ae92c0a873f0$var$listTags = {
        ol: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
    function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
        if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
        return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
    }
    class $f043ae92c0a873f0$var$NodeContext {
        constructor(type, attrs, marks, solid, match, options){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.solid = solid;
            this.options = options;
            this.content = [];
            this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
        }
        findWrapping(node) {
            if (!this.match) {
                if (!this.type) return [];
                let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
                if (fill) this.match = this.type.contentMatch.matchFragment(fill);
                else {
                    let start = this.type.contentMatch, wrap;
                    if (wrap = start.findWrapping(node.type)) {
                        this.match = start;
                        return wrap;
                    } else return null;
                }
            }
            return this.match.findWrapping(node.type);
        }
        finish(openEnd) {
            if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                let last = this.content[this.content.length - 1], m;
                if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                    let text = last;
                    if (last.text.length == m[0].length) this.content.pop();
                    else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
                }
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
            if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
            return this.type ? this.type.create(this.attrs, content, this.marks) : content;
        }
        inlineContext(node) {
            if (this.type) return this.type.inlineContent;
            if (this.content.length) return this.content[0].isInline;
            return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
        }
    }
    class $f043ae92c0a873f0$var$ParseContext {
        constructor(parser, options, isOpen){
            this.parser = parser;
            this.options = options;
            this.isOpen = isOpen;
            this.open = 0;
            let topNode = options.topNode, topContext;
            let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
            if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
            else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            this.nodes = [
                topContext
            ];
            this.find = options.findPositions;
            this.needsBlock = false;
        }
        get top() {
            return this.nodes[this.open];
        }
        addDOM(dom, marks) {
            if (dom.nodeType == 3) this.addTextNode(dom, marks);
            else if (dom.nodeType == 1) this.addElement(dom, marks);
        }
        addTextNode(dom, marks) {
            let value = dom.nodeValue;
            let top = this.top;
            if (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
                if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                    value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                    if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                        let nodeBefore = top.content[top.content.length - 1];
                        let domNodeBefore = dom.previousSibling;
                        if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                    }
                } else if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
                else value = value.replace(/\r\n?/g, "\n");
                if (value) this.insertNode(this.parser.schema.text(value), marks);
                this.findInText(dom);
            } else this.findInside(dom);
        }
        addElement(dom, marks, matchAfter) {
            let name = dom.nodeName.toLowerCase(), ruleID;
            if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
            let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
            if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
                this.findInside(dom);
                this.ignoreFallback(dom, marks);
            } else if (!rule || rule.skip || rule.closeParent) {
                if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
                else if (rule && rule.skip.nodeType) dom = rule.skip;
                let sync, top = this.top, oldNeedsBlock = this.needsBlock;
                if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                    if (top.content.length && top.content[0].isInline && this.open) {
                        this.open--;
                        top = this.top;
                    }
                    sync = true;
                    if (!top.type) this.needsBlock = true;
                } else if (!dom.firstChild) {
                    this.leafFallback(dom, marks);
                    return;
                }
                let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
                if (innerMarks) this.addAll(dom, innerMarks);
                if (sync) this.sync(top);
                this.needsBlock = oldNeedsBlock;
            } else {
                let innerMarks = this.readStyles(dom, marks);
                if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
            }
        }
        leafFallback(dom, marks) {
            if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
        }
        ignoreFallback(dom, marks) {
            if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
        }
        readStyles(dom, marks) {
            let styles = dom.style;
            if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
                let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
                if (value) for(let after = undefined;;){
                    let rule = this.parser.matchStyle(name, value, this, after);
                    if (!rule) break;
                    if (rule.ignore) return null;
                    if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                    else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                    if (rule.consuming === false) after = rule;
                    else break;
                }
            }
            return marks;
        }
        addElementByRule(dom, rule, marks, continueAfter) {
            let sync, nodeType;
            if (rule.node) {
                nodeType = this.parser.schema.nodes[rule.node];
                if (!nodeType.isLeaf) {
                    let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                    if (inner) {
                        sync = true;
                        marks = inner;
                    }
                } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
            } else {
                let markType = this.parser.schema.marks[rule.mark];
                marks = marks.concat(markType.create(rule.attrs));
            }
            let startIn = this.top;
            if (nodeType && nodeType.isLeaf) this.findInside(dom);
            else if (continueAfter) this.addElement(dom, marks, continueAfter);
            else if (rule.getContent) {
                this.findInside(dom);
                rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
            } else {
                let contentDOM = dom;
                if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
                else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
                else if (rule.contentElement) contentDOM = rule.contentElement;
                this.findAround(dom, contentDOM, true);
                this.addAll(contentDOM, marks);
            }
            if (sync && this.sync(startIn)) this.open--;
        }
        addAll(parent, marks, startIndex, endIndex) {
            let index = startIndex || 0;
            for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
                this.findAtPoint(parent, index);
                this.addDOM(dom, marks);
            }
            this.findAtPoint(parent, index);
        }
        findPlace(node, marks) {
            let route, sync;
            for(let depth = this.open; depth >= 0; depth--){
                let cx = this.nodes[depth];
                let found = cx.findWrapping(node);
                if (found && (!route || route.length > found.length)) {
                    route = found;
                    sync = cx;
                    if (!found.length) break;
                }
                if (cx.solid) break;
            }
            if (!route) return null;
            this.sync(sync);
            for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
            return marks;
        }
        insertNode(node, marks) {
            if (node.isInline && this.needsBlock && !this.top.type) {
                let block = this.textblockFromContext();
                if (block) marks = this.enterInner(block, null, marks);
            }
            let innerMarks = this.findPlace(node, marks);
            if (innerMarks) {
                this.closeExtra();
                let top = this.top;
                if (top.match) top.match = top.match.matchType(node.type);
                let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
                for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
                top.content.push(node.mark(nodeMarks));
                return true;
            }
            return false;
        }
        enter(type, attrs, marks, preserveWS) {
            let innerMarks = this.findPlace(type.create(attrs), marks);
            if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
            return innerMarks;
        }
        enterInner(type, attrs, marks, solid = false, preserveWS) {
            this.closeExtra();
            let top = this.top;
            top.match = top.match && top.match.matchType(type);
            let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
            if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
            let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            marks = marks.filter((m)=>{
                if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                    applyMarks = m.addToSet(applyMarks);
                    return false;
                }
                return true;
            });
            this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
            this.open++;
            return marks;
        }
        closeExtra(openEnd = false) {
            let i = this.nodes.length - 1;
            if (i > this.open) {
                for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
                this.nodes.length = this.open + 1;
            }
        }
        finish() {
            this.open = 0;
            this.closeExtra(this.isOpen);
            return this.nodes[0].finish(this.isOpen || this.options.topOpen);
        }
        sync(to) {
            for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
                this.open = i;
                return true;
            }
            return false;
        }
        get currentPos() {
            this.closeExtra();
            let pos = 0;
            for(let i = this.open; i >= 0; i--){
                let content = this.nodes[i].content;
                for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
                if (i) pos++;
            }
            return pos;
        }
        findAtPoint(parent, offset) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
            }
        }
        findInside(parent) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
            }
        }
        findAround(parent, content, before) {
            if (parent != content && this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                    let pos = content.compareDocumentPosition(this.find[i].node);
                    if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
                }
            }
        }
        findInText(textNode) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
            }
        }
        matchesContext(context) {
            if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
            let parts = context.split("/");
            let option = this.options.context;
            let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
            let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
            let match = (i, depth)=>{
                for(; i >= 0; i--){
                    let part = parts[i];
                    if (part == "") {
                        if (i == parts.length - 1 || i == 0) continue;
                        for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                        return false;
                    } else {
                        let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                        if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                        depth--;
                    }
                }
                return true;
            };
            return match(parts.length - 1, this.open);
        }
        textblockFromContext() {
            let $context = this.options.context;
            if ($context) for(let d = $context.depth; d >= 0; d--){
                let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
                if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
            }
            for(let name in this.parser.schema.nodes){
                let type = this.parser.schema.nodes[name];
                if (type.isTextblock && type.defaultAttrs) return type;
            }
        }
    }
    function $f043ae92c0a873f0$var$normalizeList(dom) {
        for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
            let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
            if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
                prevItem.appendChild(child);
                child = prevItem;
            } else if (name == "li") prevItem = child;
            else if (name) prevItem = null;
        }
    }
    function $f043ae92c0a873f0$var$matches(dom, selector) {
        return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
    }
    function $f043ae92c0a873f0$var$copy(obj) {
        let copy = {};
        for(let prop in obj)copy[prop] = obj[prop];
        return copy;
    }
    function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
        let nodes = nodeType.schema.nodes;
        for(let name in nodes){
            let parent = nodes[name];
            if (!parent.allowsMarkType(markType)) continue;
            let seen = [], scan = (match)=>{
                seen.push(match);
                for(let i = 0; i < match.edgeCount; i++){
                    let { type: type, next: next } = match.edge(i);
                    if (type == nodeType) return true;
                    if (seen.indexOf(next) < 0 && scan(next)) return true;
                }
            };
            if (scan(parent.contentMatch)) return true;
        }
    }
    class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
        constructor(nodes, marks){
            this.nodes = nodes;
            this.marks = marks;
        }
        serializeFragment(fragment, options = {}, target) {
            if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
            let top = target, active = [];
            fragment.forEach((node)=>{
                if (active.length || node.marks.length) {
                    let keep = 0, rendered = 0;
                    while(keep < active.length && rendered < node.marks.length){
                        let next = node.marks[rendered];
                        if (!this.marks[next.type.name]) {
                            rendered++;
                            continue;
                        }
                        if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                        keep++;
                        rendered++;
                    }
                    while(keep < active.length)top = active.pop()[1];
                    while(rendered < node.marks.length){
                        let add = node.marks[rendered++];
                        let markDOM = this.serializeMark(add, node.isInline, options);
                        if (markDOM) {
                            active.push([
                                add,
                                top
                            ]);
                            top.appendChild(markDOM.dom);
                            top = markDOM.contentDOM || markDOM.dom;
                        }
                    }
                }
                top.appendChild(this.serializeNodeInner(node, options));
            });
            return target;
        }
        serializeNodeInner(node, options) {
            let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
            if (contentDOM) {
                if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
                this.serializeFragment(node.content, options, contentDOM);
            }
            return dom;
        }
        serializeNode(node, options = {}) {
            let dom = this.serializeNodeInner(node, options);
            for(let i = node.marks.length - 1; i >= 0; i--){
                let wrap = this.serializeMark(node.marks[i], node.isInline, options);
                if (wrap) {
                    (wrap.contentDOM || wrap.dom).appendChild(dom);
                    dom = wrap.dom;
                }
            }
            return dom;
        }
        serializeMark(mark, inline, options = {}) {
            let toDOM = this.marks[mark.type.name];
            return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
        }
        static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
            return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
        }
        static fromSchema(schema) {
            return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
        }
        static nodesFromSchema(schema) {
            let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
            if (!result.text) result.text = (node)=>node.text;
            return result;
        }
        static marksFromSchema(schema) {
            return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
        }
    }
    function $f043ae92c0a873f0$var$gatherToDOM(obj) {
        let result = {};
        for(let name in obj){
            let toDOM = obj[name].spec.toDOM;
            if (toDOM) result[name] = toDOM;
        }
        return result;
    }
    function $f043ae92c0a873f0$var$doc(options) {
        return options.document || window.document;
    }
    const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
    function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
        let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
        if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
        return value;
    }
    function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
        let result = null;
        function scan(value) {
            if (value && typeof value == "object") {
                if (Array.isArray(value)) {
                    if (typeof value[0] == "string") {
                        if (!result) result = [];
                        result.push(value);
                    } else for(let i = 0; i < value.length; i++)scan(value[i]);
                } else for(let prop in value)scan(value[prop]);
            }
        }
        scan(attrs);
        return result;
    }
    function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], suspicious;
        if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
        if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
        let space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
});
parcelRegister("dHeNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
    function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
        this.content = content;
    }
    $9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
        constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
        find: function(key) {
            for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
            return -1;
        },
        get: function(key) {
            var found = this.find(key);
            return found == -1 ? undefined : this.content[found + 1];
        },
        update: function(key, value, newKey) {
            var self = newKey && newKey != key ? this.remove(newKey) : this;
            var found = self.find(key), content = self.content.slice();
            if (found == -1) content.push(newKey || key, value);
            else {
                content[found + 1] = value;
                if (newKey) content[found] = newKey;
            }
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        remove: function(key) {
            var found = this.find(key);
            if (found == -1) return this;
            var content = this.content.slice();
            content.splice(found, 2);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addToStart: function(key, value) {
            return new $9f8ac547b0b2e1f8$var$OrderedMap([
                key,
                value
            ].concat(this.remove(key).content));
        },
        addToEnd: function(key, value) {
            var content = this.remove(key).content.slice();
            content.push(key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addBefore: function(place, key, value) {
            var without = this.remove(key), content = without.content.slice();
            var found = without.find(place);
            content.splice(found == -1 ? content.length : found, 0, key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        forEach: function(f) {
            for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
        },
        prepend: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
        },
        append: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
        },
        subtract: function(map) {
            var result = this;
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
            return result;
        },
        toObject: function() {
            var result = {};
            this.forEach(function(key, value) {
                result[key] = value;
            });
            return result;
        },
        get size () {
            return this.content.length >> 1;
        }
    };
    $9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
        if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
        var content = [];
        if (value) for(var prop in value)content.push(prop, value[prop]);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    };
    var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;
});
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';
parcelRegister("aeGrH", function(module, exports) {
    $parcel$export(module.exports, "alignmentPositionMap", ()=>$773c2309706a915e$export$be9cf49015769bbd);
    $parcel$export(module.exports, "alignment", ()=>$773c2309706a915e$export$8e53000a4ec837);
    var $2fTAU;
    const $773c2309706a915e$export$be9cf49015769bbd = {
        end: 'right',
        right: 'end',
        center: 'center'
    };
    const $773c2309706a915e$export$8e53000a4ec837 = (0, (0, parcelRequire("2fTAU")).alignment)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-block-mark',
                getAttrs: (dom)=>{
                    const align = dom.getAttribute('data-align');
                    return align ? {
                        align: align
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            return [
                'div',
                {
                    class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                    'data-align': mark.attrs.align
                },
                0
            ];
        }
    });
});
parcelRegister("2fTAU", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>$1a481b607696d815$export$8e53000a4ec837);
    $parcel$export(module.exports, "annotation", ()=>$1a481b607696d815$export$8512c9afa7b24c3b);
    $parcel$export(module.exports, "backgroundColor", ()=>$1a481b607696d815$export$8c5a050822fd698c);
    $parcel$export(module.exports, "border", ()=>$1a481b607696d815$export$1edee58a52776cd9);
    $parcel$export(module.exports, "breakout", ()=>$1a481b607696d815$export$89015c65f1c75e3f);
    $parcel$export(module.exports, "code", ()=>$1a481b607696d815$export$6565f9f03506010b);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$1a481b607696d815$export$f3b72f8fc4684ecd);
    $parcel$export(module.exports, "dataConsumer", ()=>$1a481b607696d815$export$3024f02c495408d6);
    $parcel$export(module.exports, "em", ()=>$1a481b607696d815$export$c63c6f932822f543);
    $parcel$export(module.exports, "fragment", ()=>$1a481b607696d815$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "indentation", ()=>$1a481b607696d815$export$480c699bd4ec0d86);
    $parcel$export(module.exports, "link", ()=>$1a481b607696d815$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "strike", ()=>$1a481b607696d815$export$4899a95d70ec5056);
    $parcel$export(module.exports, "strong", ()=>$1a481b607696d815$export$59ae2c325a998f89);
    $parcel$export(module.exports, "subsup", ()=>$1a481b607696d815$export$b3401ee80eb31041);
    $parcel$export(module.exports, "textColor", ()=>$1a481b607696d815$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "typeAheadQuery", ()=>$1a481b607696d815$export$20af3dabbb5538df);
    $parcel$export(module.exports, "underline", ()=>$1a481b607696d815$export$425327af25286e5e);
    $parcel$export(module.exports, "unsupportedMark", ()=>$1a481b607696d815$export$30d78d5eb6719bb8);
    $parcel$export(module.exports, "unsupportedNodeAttribute", ()=>$1a481b607696d815$export$a316dc07ff5182a2);
    var $f0ccE;
    const $1a481b607696d815$export$8e53000a4ec837 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            align: {}
        },
        excludes: 'alignment indentation',
        group: 'alignment'
    });
    const $1a481b607696d815$export$8512c9afa7b24c3b = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            id: {
                default: ''
            },
            annotationType: {
                default: 'inlineComment'
            }
        },
        inclusive: true,
        excludes: '',
        group: 'annotation'
    });
    const $1a481b607696d815$export$8c5a050822fd698c = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            color: {}
        },
        inclusive: true,
        excludes: 'color',
        group: 'color'
    });
    const $1a481b607696d815$export$1edee58a52776cd9 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            size: {},
            color: {}
        },
        inclusive: false
    });
    const $1a481b607696d815$export$89015c65f1c75e3f = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            mode: {
                default: 'wide'
            },
            width: {
                default: null
            }
        },
        inclusive: false,
        spanning: false
    });
    const $1a481b607696d815$export$6565f9f03506010b = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        excludes: 'fontStyle link searchQuery color'
    });
    const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            reference: {
                default: ''
            }
        },
        inclusive: false,
        excludes: ''
    });
    const $1a481b607696d815$export$3024f02c495408d6 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            sources: {
                default: []
            }
        }
    });
    const $1a481b607696d815$export$c63c6f932822f543 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$f00aeb236b6f05af = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            localId: {
                default: ''
            },
            name: {
                default: null
            }
        },
        inclusive: false,
        excludes: ''
    });
    const $1a481b607696d815$export$480c699bd4ec0d86 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            level: {}
        },
        excludes: 'indentation alignment',
        group: 'indentation'
    });
    const $1a481b607696d815$export$9c30223ca0a664fb = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            href: {},
            __confluenceMetadata: {
                default: null
            }
        },
        inclusive: false,
        excludes: 'link',
        group: 'link'
    });
    const $1a481b607696d815$export$4899a95d70ec5056 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$59ae2c325a998f89 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$b3401ee80eb31041 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            type: {
                default: 'sub'
            }
        },
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$32f78bffcd82ff28 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            color: {}
        },
        inclusive: true,
        group: 'color'
    });
    const $1a481b607696d815$export$20af3dabbb5538df = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            trigger: {
                default: ''
            }
        },
        inclusive: true,
        group: 'searchQuery'
    });
    const $1a481b607696d815$export$425327af25286e5e = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            originalValue: {}
        },
        excludes: ''
    });
    const $1a481b607696d815$export$a316dc07ff5182a2 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            unsupported: {},
            type: {}
        }
    });
});
parcelRegister("88i6h", function(module, exports) {
    $parcel$export(module.exports, "AnnotationTypes", ()=>$5ebd1c6c912098fc$export$94aa2fc69ad33d19);
    $parcel$export(module.exports, "AnnotationMarkStates", ()=>$5ebd1c6c912098fc$export$4bab14797673da9f);
    $parcel$export(module.exports, "buildDataAttributes", ()=>$5ebd1c6c912098fc$export$93a98caa8bc6cb07);
    $parcel$export(module.exports, "annotation", ()=>$5ebd1c6c912098fc$export$8512c9afa7b24c3b);
    var $2fTAU;
    let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = function(AnnotationTypes) {
        AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
        return AnnotationTypes;
    }({});
    let $5ebd1c6c912098fc$export$4bab14797673da9f = function(AnnotationMarkStates) {
        AnnotationMarkStates["RESOLVED"] = "resolved";
        AnnotationMarkStates["ACTIVE"] = "active";
        return AnnotationMarkStates;
    }({});
    function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
        const data = {
            'data-mark-type': 'annotation',
            'data-mark-annotation-type': annotationType,
            'data-id': id
        };
        if (state) return {
            ...data,
            'data-mark-annotation-state': state
        };
        return data;
    }
    const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, (0, parcelRequire("2fTAU")).annotation)({
        parseDOM: [
            {
                tag: 'span[data-mark-type="annotation"]',
                mark: 'annotation',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const attrs = {
                        id: dom.getAttribute('data-id'),
                        annotationType: dom.getAttribute('data-mark-annotation-type')
                    };
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'class': 'fabric-editor-annotation',
                    ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                        id: node.attrs.id,
                        annotationType: node.attrs.annotationType
                    })
                },
                0
            ];
        }
    });
});
parcelRegister("8jJss", function(module, exports) {
    $parcel$export(module.exports, "backgroundColor", ()=>$60e35c16db44f137$export$8c5a050822fd698c);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    var $c9aa1;
    var $87j2U;
    const $60e35c16db44f137$var$colorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).Neutral300),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T200),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).L200),
            'Lime'
        ],
        [
            (0, (0, parcelRequire("51H8P")).O200),
            'Orange'
        ],
        [
            (0, (0, parcelRequire("51H8P")).M200),
            'Magenta'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P200),
            'Purple'
        ]
    ];
    const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
    $60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
    const $60e35c16db44f137$export$8c5a050822fd698c = (0, (0, parcelRequire("2fTAU")).backgroundColor)({
        parseDOM: [
            {
                style: 'background-color',
                getAttrs: (maybeValue)=>{
                    const value = maybeValue;
                    let hexColor;
                    if (value.match(/^rgb/i)) hexColor = (0, (0, parcelRequire("51H8P")).rgbToHex)(value);
                    else if (value[0] === '#') hexColor = value.toLowerCase();
                    return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            },
            {
                tag: '.fabric-background-color-mark',
                getAttrs: (maybeElement)=>{
                    if (!(maybeElement instanceof HTMLElement)) return false;
                    const hexColor = maybeElement.dataset.backgroundCustomColor;
                    return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            let paletteColorValue;
            const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
            if (tokenColor) paletteColorValue = tokenColor;
            else if ((0, (0, parcelRequire("c9aa1")).getGlobalTheme)().colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(mark.attrs.color);
            else paletteColorValue = mark.attrs.color;
            return [
                'span',
                {
                    class: 'fabric-background-color-mark',
                    style: `--custom-palette-color: ${paletteColorValue}`,
                    ['data-background-custom-color']: mark.attrs.color
                }
            ];
        }
    });
});
parcelRegister("c9aa1", function(module, exports) {
    $parcel$export(module.exports, "colorPalette", ()=>$8d7e34fd69d04bb8$export$569885e57444f84a);
    $parcel$export(module.exports, "getGlobalTheme", ()=>$8d7e34fd69d04bb8$export$813ecdf77207a053);
    $parcel$export(module.exports, "textColor", ()=>$8d7e34fd69d04bb8$export$32f78bffcd82ff28);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    var $87j2U;
    const $8d7e34fd69d04bb8$var$colorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).B500),
            'Dark blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T500),
            'Dark teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G500),
            'Dark green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y400),
            'Orange'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R500),
            'Dark red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P500),
            'Dark purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N80),
            'Light gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B100),
            'Blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T300),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G300),
            'Green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y200),
            'Yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R300),
            'Red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P300),
            'Purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N0),
            'White'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B75),
            'Light blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T75),
            'Light teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G75),
            'Light green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y75),
            'Light yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R75),
            'Light red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P50),
            'Light purple'
        ]
    ];
    const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
    const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
    $8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
    let $8d7e34fd69d04bb8$var$testGlobalTheme;
    const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
        $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
    };
    const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
        if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
            colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
        };
        const element = document.documentElement;
        const colorMode = element.getAttribute('data-color-mode') || '';
        return {
            colorMode: colorMode
        };
    };
    const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, (0, parcelRequire("2fTAU")).textColor)({
        parseDOM: [
            {
                style: 'color',
                getAttrs: (maybeValue)=>{
                    const value = maybeValue;
                    let hexColor;
                    if (value.match(/^rgb/i)) hexColor = (0, (0, parcelRequire("51H8P")).rgbToHex)(value);
                    else if (value[0] === '#') hexColor = value.toLowerCase();
                    return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            },
            {
                tag: '.fabric-text-color-mark',
                getAttrs: (maybeElement)=>{
                    if (!(maybeElement instanceof HTMLElement)) return false;
                    const hexColor = maybeElement.dataset.textCustomColor;
                    return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            let paletteColorValue;
            const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorTextPaletteColor)(mark.attrs.color);
            if (tokenColor) paletteColorValue = tokenColor;
            else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(mark.attrs.color);
            else paletteColorValue = mark.attrs.color;
            return [
                'span',
                {
                    class: 'fabric-text-color-mark',
                    style: `--custom-palette-color: ${paletteColorValue}`,
                    ['data-text-custom-color']: mark.attrs.color
                }
            ];
        }
    });
});
parcelRegister("14Vqw", function(module, exports) {
    $parcel$export(module.exports, "borderColorPalette", ()=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7);
    $parcel$export(module.exports, "border", ()=>$0c92b5eb9dbe9377$export$1edee58a52776cd9);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).N300A),
            'Subtle gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N600),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N1000),
            'Bold gray'
        ]
    ];
    const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
    $0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
    const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, (0, parcelRequire("2fTAU")).border)({
        parseDOM: [
            {
                tag: '[data-mark-type="border"]',
                getAttrs: (domNode)=>{
                    var _dom$getAttribute, _dom$getAttribute2;
                    const dom = domNode;
                    const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                    const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                    return {
                        size: size > 3 ? 3 : size < 1 ? false : size,
                        color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                    };
                }
            }
        ],
        toDOM (mark, isInline) {
            const wrapperStyle = isInline ? 'span' : 'div';
            const paletteColorValue = (0, (0, parcelRequire("daes7")).hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'border',
                    'data-color': mark.attrs.color,
                    'data-size': mark.attrs.size,
                    style: `--custom-palette-color: ${paletteColorValue}`
                }
            ];
        }
    });
});
parcelRegister("zceQE", function(module, exports) {
    $parcel$export(module.exports, "breakout", ()=>$069cc34ec2ef025e$export$89015c65f1c75e3f);
    var $2fTAU;
    const $069cc34ec2ef025e$var$allowedTypes = [
        'wide',
        'full-width'
    ];
    const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, (0, parcelRequire("2fTAU")).breakout)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-breakout-mark',
                getAttrs (dom) {
                    const mode = dom.getAttribute('data-mode');
                    const width = dom.getAttribute('data-width');
                    return {
                        mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                        width: width ? parseInt(width) : null
                    };
                }
            }
        ],
        toDOM (mark) {
            var _mark$attrs;
            return [
                'div',
                {
                    class: 'fabric-editor-breakout-mark',
                    'data-mode': mark.attrs.mode,
                    'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
                },
                0
            ];
        }
    });
});
parcelRegister("lcXoV", function(module, exports) {
    $parcel$export(module.exports, "code", ()=>$f708cbc93f02b120$export$6565f9f03506010b);
    var $2fTAU;
    const $f708cbc93f02b120$export$6565f9f03506010b = (0, (0, parcelRequire("2fTAU")).code)({
        parseDOM: [
            {
                tag: 'span.code',
                preserveWhitespace: true
            },
            {
                tag: 'code',
                preserveWhitespace: true
            },
            {
                tag: 'tt',
                preserveWhitespace: true
            },
            {
                tag: 'span',
                preserveWhitespace: true,
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    if (dom.style.whiteSpace === 'pre') return {};
                    if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                    return false;
                }
            }
        ],
        toDOM () {
            return [
                'span',
                {
                    class: 'code',
                    spellcheck: 'false'
                }
            ];
        }
    });
});
parcelRegister("71k4W", function(module, exports) {
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$51c833981031ae17$export$f3b72f8fc4684ecd);
    var $2fTAU;
    const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, (0, parcelRequire("2fTAU")).confluenceInlineComment)({
        parseDOM: [
            {
                tag: 'span[data-mark-type="confluenceInlineComment"]'
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'data-mark-type': 'confluenceInlineComment',
                    'data-reference': node.attrs.reference
                }
            ];
        }
    });
});
parcelRegister("cUwVZ", function(module, exports) {
    $parcel$export(module.exports, "dataConsumer", ()=>$966443126bdc8969$export$3024f02c495408d6);
    $parcel$export(module.exports, "toJSON", ()=>$966443126bdc8969$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $6VXbJ;
    const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
        const sources = (0, (0, parcelRequire("6VXbJ")).isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
        try {
            return sources ? {
                sources: JSON.parse(sources)
            } : false;
        } catch  {
            return false;
        }
    };
    const $966443126bdc8969$export$3024f02c495408d6 = (0, (0, parcelRequire("2fTAU")).dataConsumer)({
        parseDOM: [
            {
                tag: '[data-mark-type="dataConsumer"]',
                getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
            }
        ],
        toDOM (mark, inline) {
            const wrapperStyle = inline ? 'span' : 'div';
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'dataConsumer',
                    'data-sources': JSON.stringify(mark.attrs.sources)
                }
            ];
        }
    });
    const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
        return {
            type: mark.type.name,
            attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
                return {
                    ...acc,
                    [key]: mark.attrs[key]
                };
            }, {})
        };
    };
});
parcelRegister("6VXbJ", function(module, exports) {
    $parcel$export(module.exports, "isDOMElement", ()=>$50c5fa8010b73128$export$c296e2d4365c37a5);
    const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
});
parcelRegister("l3Tmi", function(module, exports) {
    $parcel$export(module.exports, "em", ()=>$f554d1dac524ac83$export$c63c6f932822f543);
    var $2fTAU;
    const $f554d1dac524ac83$var$emDOM = [
        'em'
    ];
    const $f554d1dac524ac83$export$c63c6f932822f543 = (0, (0, parcelRequire("2fTAU")).em)({
        parseDOM: [
            {
                tag: 'i'
            },
            {
                tag: 'em'
            },
            {
                style: 'font-style=italic'
            }
        ],
        toDOM () {
            return $f554d1dac524ac83$var$emDOM;
        }
    });
});
parcelRegister("29Vii", function(module, exports) {
    $parcel$export(module.exports, "fragment", ()=>$1928dd6d160b68a9$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "toJSON", ()=>$1928dd6d160b68a9$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $6VXbJ;
    const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
        var _maybeValue$getAttrib;
        if (!(0, (0, parcelRequire("6VXbJ")).isDOMElement)(maybeValue)) return false;
        const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
        const localId = maybeValue.getAttribute('data-localId');
        if (!localId) return false;
        return {
            localId: localId,
            name: name
        };
    };
    const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, (0, parcelRequire("2fTAU")).fragment)({
        parseDOM: [
            {
                tag: '[data-mark-type="fragment"]',
                getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
            }
        ],
        toDOM (mark, inline) {
            const wrapperStyle = inline ? 'span' : 'div';
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'fragment',
                    'data-name': mark.attrs.name,
                    'data-localId': mark.attrs.localId
                }
            ];
        }
    });
    const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
        return {
            type: mark.type.name,
            attrs: {
                localId: mark.attrs.localId,
                ...mark.attrs.name ? {
                    name: mark.attrs.name
                } : {}
            }
        };
    };
});
parcelRegister("fK6mK", function(module, exports) {
    $parcel$export(module.exports, "indentation", ()=>$b760170dcfe13435$export$480c699bd4ec0d86);
    var $2fTAU;
    const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, (0, parcelRequire("2fTAU")).indentation)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-indentation-mark',
                getAttrs (dom) {
                    const level = +(dom.getAttribute('data-level') || '0');
                    return {
                        level: level > 6 ? 6 : level < 1 ? false : level
                    };
                }
            }
        ],
        toDOM (mark) {
            return [
                'div',
                {
                    class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                    'data-level': mark.attrs.level
                },
                0
            ];
        }
    });
});
parcelRegister("8XeG6", function(module, exports) {
    $parcel$export(module.exports, "link", ()=>$684f383282dda449$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "toJSON", ()=>$684f383282dda449$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $iZOJ9;
    const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
            const dom = domNode;
            const href = dom.getAttribute(attribute) || '';
            const attrs = {
                __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
            };
            if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(href)) return false;
            if ((0, (0, parcelRequire("iZOJ9")).isRootRelative)(href)) {
                attrs.href = href;
                return attrs;
            }
            attrs.href = (0, (0, parcelRequire("iZOJ9")).normalizeUrl)(href);
            return attrs;
        };
    const $684f383282dda449$export$9c30223ca0a664fb = (0, (0, parcelRequire("2fTAU")).link)({
        parseDOM: [
            {
                tag: '[data-block-link]',
                getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
                contentElement: (node)=>{
                    const clone = node.cloneNode(true);
                    clone.removeAttribute('data-block-link');
                    clone.setAttribute('data-skip-paste', 'true');
                    const wrapper = document.createElement('div');
                    wrapper.appendChild(clone);
                    return wrapper;
                }
            },
            {
                tag: 'a[href]',
                getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
            }
        ],
        toDOM (node, isInline) {
            const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
                if (key === '__confluenceMetadata') {
                    if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
                } else if (key === 'href') attrs[key] = (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
                else attrs[key] = node.attrs[key];
                return attrs;
            }, {});
            if (isInline) return [
                'a',
                attrs
            ];
            return [
                'a',
                {
                    ...attrs,
                    ['data-block-link']: 'true',
                    class: 'blockLink'
                },
                0
            ];
        }
    });
    const $684f383282dda449$var$OPTIONAL_ATTRS = [
        'title',
        'id',
        'collection',
        'occurrenceKey',
        '__confluenceMetadata'
    ];
    const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
            type: mark.type.name,
            attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
                if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
                return attrs;
            }, {})
        });
});
parcelRegister("iZOJ9", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$dd4545da25e52dce$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "linkify", ()=>$dd4545da25e52dce$export$8ccbde94d5c7f8e7);
    $parcel$export(module.exports, "linkifyMatch", ()=>$dd4545da25e52dce$export$6f7d7761b97f967);
    $parcel$export(module.exports, "getLinkMatch", ()=>$dd4545da25e52dce$export$ce9ae45aed3e4ec);
    $parcel$export(module.exports, "normalizeUrl", ()=>$dd4545da25e52dce$export$6535eb414fa2c8b6);
    $parcel$export(module.exports, "isRootRelative", ()=>$dd4545da25e52dce$export$23579274a7a24f7b);
    var $i6xkD = parcelRequire("i6xkD");
    const $dd4545da25e52dce$var$whitelistedURLPatterns = [
        /^https?:\/\//im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\//im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:/im,
        /^facetime:/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^sourcetree:\/\//im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^#/im
    ];
    const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        if (urlTrimmed.length === 0) return true;
        return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, ($parcel$interopDefault($i6xkD)))();
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
    const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
        validate: /[^\s]+/
    };
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
    const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
    const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
        if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
        const matches = [];
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
        if (!str) return null;
        let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
        if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
        return match && match[0];
    }
    function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
        const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
        return match && match.url || '';
    }
    function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
        return url.startsWith('/') || url === '#top' || url === '#';
    }
});
parcelRegister("i6xkD", function(module, exports) {
    'use strict';
    function $d2e2a485107d561a$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $d2e2a485107d561a$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $d2e2a485107d561a$var$isString(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object String]';
    }
    function $d2e2a485107d561a$var$isObject(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
    }
    function $d2e2a485107d561a$var$isRegExp(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
    }
    function $d2e2a485107d561a$var$isFunction(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
    }
    function $d2e2a485107d561a$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $d2e2a485107d561a$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $d2e2a485107d561a$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $d2e2a485107d561a$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $d2e2a485107d561a$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $d2e2a485107d561a$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $d2e2a485107d561a$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $d2e2a485107d561a$var$compile(self) {
        var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($d2e2a485107d561a$var$isObject(val)) {
                if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
                else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($d2e2a485107d561a$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $d2e2a485107d561a$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($d2e2a485107d561a$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
        $d2e2a485107d561a$var$resetScanCache(self);
    }
    function $d2e2a485107d561a$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $d2e2a485107d561a$var$createMatch(self, shift) {
        var match = new $d2e2a485107d561a$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $d2e2a485107d561a$var$compile(this);
    }
    $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $d2e2a485107d561a$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $d2e2a485107d561a$var$LinkifyIt;
});
parcelRegister("9mKTr", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,3}[a-zA-Z0-9%/]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("b9ep3", function(module, exports) {
    module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
});
parcelRegister("23ErL", function(module, exports) {
    module.exports = /[\0-\x1F\x7F-\x9F]/;
});
parcelRegister("oRY4m", function(module, exports) {
    module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
});
parcelRegister("9bBmm", function(module, exports) {
    module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
});
parcelRegister("aUhe2", function(module, exports) {
    $parcel$export(module.exports, "strike", ()=>$7f0c7ef7d4ef76e7$export$4899a95d70ec5056);
    var $2fTAU;
    const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, (0, parcelRequire("2fTAU")).strike)({
        parseDOM: [
            {
                tag: 'strike'
            },
            {
                tag: 's'
            },
            {
                tag: 'del'
            },
            {
                style: 'text-decoration',
                getAttrs: (value)=>value === 'line-through' && null
            }
        ],
        toDOM () {
            return [
                's'
            ];
        }
    });
});
parcelRegister("hhtT8", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$c94b3560d4129743$export$59ae2c325a998f89);
    var $2fTAU;
    const $c94b3560d4129743$var$strongDOM = [
        'strong'
    ];
    const $c94b3560d4129743$export$59ae2c325a998f89 = (0, (0, parcelRequire("2fTAU")).strong)({
        parseDOM: [
            {
                tag: 'strong'
            },
            {
                tag: 'b',
                getAttrs (node) {
                    const element = node;
                    return element.style.fontWeight !== 'normal' && null;
                }
            },
            {
                tag: 'span',
                getAttrs (node) {
                    const element = node;
                    const { fontWeight: fontWeight } = element.style;
                    return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
                }
            }
        ],
        toDOM () {
            return $c94b3560d4129743$var$strongDOM;
        }
    });
});
parcelRegister("4NwJJ", function(module, exports) {
    $parcel$export(module.exports, "subsup", ()=>$37e521d9accf6615$export$b3401ee80eb31041);
    var $2fTAU;
    function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
        if (node === 'sub') return {
            type: 'sub'
        };
        if (node === 'super') return {
            type: 'sup'
        };
        return false;
    }
    const $37e521d9accf6615$export$b3401ee80eb31041 = (0, (0, parcelRequire("2fTAU")).subsup)({
        parseDOM: [
            {
                tag: 'sub',
                attrs: {
                    type: 'sub'
                }
            },
            {
                tag: 'sup',
                attrs: {
                    type: 'sup'
                }
            },
            {
                style: 'vertical-align=super',
                getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
            },
            {
                style: 'vertical-align=sub',
                getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
            }
        ],
        toDOM (mark) {
            return [
                mark.attrs.type
            ];
        }
    });
});
parcelRegister("dtyqo", function(module, exports) {
    $parcel$export(module.exports, "typeAheadQuery", ()=>$9cf8afcff83743a0$export$20af3dabbb5538df);
    var $2fTAU;
    var $51H8P;
    const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, (0, parcelRequire("2fTAU")).typeAheadQuery)({
        parseDOM: [
            {
                tag: 'span[data-type-ahead-query]'
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'data-type-ahead-query': 'true',
                    'data-trigger': node.attrs.trigger,
                    style: `color: ${(0, (0, parcelRequire("51H8P")).B400)}`
                }
            ];
        }
    });
});
parcelRegister("8EAPB", function(module, exports) {
    $parcel$export(module.exports, "underline", ()=>$64cea1116bb0e8f8$export$425327af25286e5e);
    var $2fTAU;
    const $64cea1116bb0e8f8$export$425327af25286e5e = (0, (0, parcelRequire("2fTAU")).underline)({
        parseDOM: [
            {
                tag: 'u'
            },
            {
                style: 'text-decoration',
                getAttrs: (value)=>value === 'underline' && null
            }
        ],
        toDOM () {
            return [
                'u'
            ];
        }
    });
});
parcelRegister("jxVez", function(module, exports) {
    $parcel$export(module.exports, "unsupportedMark", ()=>$e3ad7edb6364f3b2$export$30d78d5eb6719bb8);
    var $2fTAU;
    const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, (0, parcelRequire("2fTAU")).unsupportedMark)({
        toDOM () {
            return [
                'span'
            ];
        }
    });
});
parcelRegister("lVmBd", function(module, exports) {
    $parcel$export(module.exports, "unsupportedNodeAttribute", ()=>$ff60739479aa7be3$export$a316dc07ff5182a2);
    var $2fTAU;
    const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, (0, parcelRequire("2fTAU")).unsupportedNodeAttribute)({
        toDOM () {
            return [
                'span'
            ];
        }
    });
});
parcelRegister("21PS7", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$17a3e9738ed289c7$export$c4c2f833baaebdb8);
    var $gthjq;
    const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
        const anchor = dom;
        const data = anchor.getAttribute('data-card-data');
        const datasource = anchor.getAttribute('data-datasource');
        return {
            data: data ? JSON.parse(data) : undefined,
            layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
            width: Number(dom.getAttribute('data-width')) || undefined,
            datasource: datasource ? JSON.parse(datasource) : undefined
        };
    };
    const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, (0, parcelRequire("gthjq")).blockCard)({
        parseDOM: [
            {
                tag: 'a[data-block-card]',
                priority: 100,
                getAttrs: (dom)=>{
                    const anchor = dom;
                    return {
                        url: anchor.getAttribute('href') || undefined,
                        ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                    };
                }
            },
            {
                tag: 'div[data-block-card]',
                getAttrs: (dom)=>{
                    const anchor = dom;
                    return {
                        url: anchor.getAttribute('data-card-url') || undefined,
                        ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                    };
                }
            }
        ],
        toDOM (node) {
            var _node$attrs;
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                href: url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`
            };
            return [
                'a',
                attrs,
                (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
            ];
        }
    });
});
parcelRegister("5AxYU", function(module, exports) {
    $parcel$export(module.exports, "bodiedExtension", ()=>$411aac89e34c8741$export$27903d543b563e39);
    var $CWpyq;
    var $gthjq;
    const $411aac89e34c8741$export$27903d543b563e39 = (0, (0, parcelRequire("gthjq")).bodiedExtension)({
        parseDOM: [
            {
                context: 'bodiedExtension//',
                tag: '[data-node-type="bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="bodied-extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("kjhhp", function(module, exports) {
    $parcel$export(module.exports, "bulletListSelector", ()=>$ec92fc66e86ee824$export$5f25a39efab3b58b);
    $parcel$export(module.exports, "bulletList", ()=>$ec92fc66e86ee824$export$a140c94e5ea26bee);
    var $gthjq;
    const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
    const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, (0, parcelRequire("gthjq")).bulletList)({
        parseDOM: [
            {
                tag: 'ul'
            }
        ],
        toDOM () {
            const attrs = {
                class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
            };
            return [
                'ul',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("5JeV5", function(module, exports) {
    $parcel$export(module.exports, "caption", ()=>$42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);
    var $gthjq;
    const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, (0, parcelRequire("gthjq")).caption)({
        parseDOM: [
            {
                tag: 'figcaption[data-caption]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-caption': 'true'
            };
            return [
                'figcaption',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("8vlrc", function(module, exports) {
    $parcel$export(module.exports, "codeBlock", ()=>$6311d90c8f0b12c7$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "toJSON", ()=>$6311d90c8f0b12c7$export$54fd2c36b5cc6731);
    var $kCV8T;
    var $gthjq;
    const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
        return dom.getAttribute('data-language') || undefined;
    };
    const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
        if (dom && dom.classList.contains('codehilite')) return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
        return;
    };
    const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
        const firstChild = dom.firstElementChild;
        if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
    };
    const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
        const languageRegex = /(?:^|\s)language-([^\s]+)/;
        const result = languageRegex.exec(className);
        if (result && result[1]) return result[1];
        return;
    };
    const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
        const parent = dom && dom.parentElement;
        if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
        return dom;
    };
    function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
        let code = '';
        node.childNodes.forEach((child)=>{
            if (child.nodeType === Node.TEXT_NODE) code += child.nodeValue;
            else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
                const tagName = child.tagName.toLowerCase();
                if (tagName === 'div' || tagName === 'p') {
                    if (child.previousElementSibling !== null) code += '\n';
                }
                if (tagName === 'br') code += '\n';
                else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
            }
        });
        return code;
    }
    const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, (0, parcelRequire("gthjq")).codeBlock)({
        parseDOM: [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    let dom = domNode;
                    const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                    dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                    return {
                        language: language
                    };
                }
            },
            {
                tag: 'div[style]',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                    return false;
                },
                getContent: (domNode, schema)=>{
                    const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                    return code ? (0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text(code)) : (0, (0, parcelRequire("kCV8T")).Fragment).empty;
                }
            },
            {
                tag: 'table[style]',
                preserveWhitespace: 'full',
                getAttrs: (dom)=>{
                    if (dom.querySelector('td[class*="blob-code"]')) return {};
                    return false;
                }
            },
            {
                tag: 'div.code-block',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                    if (lineNumber.length > 0) lineNumber.forEach((line)=>line.remove());
                    return {};
                }
            }
        ],
        toDOM (node) {
            return [
                'pre',
                [
                    'code',
                    {
                        'data-language': node.attrs.language
                    },
                    0
                ]
            ];
        }
    });
    const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((memo, key)=>{
                if (key === 'uniqueId') return memo;
                if (key === 'language' && node.attrs.language === null) return memo;
                memo[key] = node.attrs[key];
                return memo;
            }, {})
        });
});
parcelRegister("6bbHe", function(module, exports) {
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>$47fcd7cf328a46ad$export$daf889beb5092f95);
    var $gthjq;
    const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
    const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, (0, parcelRequire("gthjq")).confluenceJiraIssue)({
        parseDOM: [
            {
                tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        issueKey: dom.textContent,
                        macroId: dom.dataset && dom.dataset.macroId,
                        schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                        server: dom.dataset && dom.dataset.server,
                        serverId: dom.dataset && dom.dataset.serverId
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': $47fcd7cf328a46ad$var$name,
                'data-macro-id': node.attrs.macroId,
                'data-schema-version': node.attrs.schemaVersion,
                'data-server': node.attrs.server,
                'data-server-id': node.attrs.serverId,
                'data-jira-issue': node.attrs.issueKey
            };
            return [
                'span',
                attrs,
                node.attrs.issueKey
            ];
        }
    });
});
parcelRegister("5y0tR", function(module, exports) {
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>$40a0802970c8dfd0$export$e6e4878f43c27cab);
    var $gthjq;
    const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
    const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, (0, parcelRequire("gthjq")).confluenceUnsupportedBlock)({
        toDOM (node) {
            const attrs = {
                'data-node-type': $40a0802970c8dfd0$var$name,
                'data-confluence-unsupported': 'block',
                'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
                getAttrs (dom) {
                    return {
                        cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                    };
                }
            }
        ]
    });
});
parcelRegister("bd7A9", function(module, exports) {
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>$8296ca40a4ed2ee7$export$3e6d667072febc87);
    var $gthjq;
    const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
    const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, (0, parcelRequire("gthjq")).confluenceUnsupportedInline)({
        toDOM (node) {
            const attrs = {
                'data-node-type': $8296ca40a4ed2ee7$var$name,
                'data-confluence-unsupported': 'inline',
                'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
                getAttrs (dom) {
                    return {
                        cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                    };
                }
            }
        ]
    });
});
parcelRegister("b2VmY", function(module, exports) {
    $parcel$export(module.exports, "date", ()=>$80ac620012a63cc1$export$324d90190a8b822a);
    var $gthjq;
    const $80ac620012a63cc1$export$324d90190a8b822a = (0, (0, parcelRequire("gthjq")).date)({
        parseDOM: [
            {
                tag: 'span[data-node-type="date"]',
                getAttrs: (dom)=>({
                        timestamp: dom.getAttribute('data-timestamp')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'date',
                'data-timestamp': node.attrs.timestamp
            };
            return [
                'span',
                attrs
            ];
        }
    });
});
parcelRegister("Khvpb", function(module, exports) {
    $parcel$export(module.exports, "decisionItem", ()=>$08b1e03a19cbdc24$export$6959e16eeff859b4);
    var $9IGaJ;
    var $gthjq;
    const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, (0, parcelRequire("gthjq")).decisionItem)({
        parseDOM: [
            {
                tag: 'li[data-decision-local-id]',
                priority: 100,
                getAttrs: (dom)=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        state: dom.getAttribute('data-decision-state')
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state
            };
            return [
                'li',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("8gSD8", function(module, exports) {
    $parcel$export(module.exports, "decisionListSelector", ()=>$605a31c9af2a8977$export$a5393ce68c2ff601);
    $parcel$export(module.exports, "decisionList", ()=>$605a31c9af2a8977$export$62d45a65fb43d95e);
    var $9IGaJ;
    var $gthjq;
    const $605a31c9af2a8977$var$name = 'decisionList';
    const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
    const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, (0, parcelRequire("gthjq")).decisionList)({
        parseDOM: [
            {
                tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
                priority: 100,
                getAttrs: ()=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const attrs = {
                'data-node-type': $605a31c9af2a8977$var$name,
                'data-decision-list-local-id': localId || 'local-decision-list',
                style: 'list-style: none; padding-left: 0'
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("xjCuM", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$06424d48e92613a9$export$2a111da947c407d2);
    var $gthjq;
    const $06424d48e92613a9$export$2a111da947c407d2 = (0, (0, parcelRequire("gthjq")).doc)({});
});
parcelRegister("kshOv", function(module, exports) {
    $parcel$export(module.exports, "embedCard", ()=>$ee443d93678dbe0b$export$be4283d9a1cb1ff6);
    var $gthjq;
    const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, (0, parcelRequire("gthjq")).embedCard)({
        parseDOM: [
            {
                tag: 'div[data-embed-card]',
                getAttrs: (dom)=>({
                        url: dom.getAttribute('data-card-url'),
                        layout: dom.getAttribute('data-layout') || 'center',
                        width: Number(dom.getAttribute('data-width')) || null,
                        originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                        originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                    })
            }
        ],
        toDOM (node) {
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight
            };
            return [
                'div',
                attrs
            ];
        }
    });
});
parcelRegister("7DoMR", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$58ef6723e99e5604$export$a19185d1233fc4b2);
    var $4pzsz;
    var $gthjq;
    const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, (0, parcelRequire("gthjq")).emoji)({
        parseDOM: [
            {
                tag: 'div.ak-editor-panel__icon span',
                ignore: true
            },
            {
                tag: 'span[data-emoji-short-name]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                        id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                        text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                    };
                }
            },
            {
                tag: 'img[data-emoticon-name]',
                getAttrs: (dom)=>(0, (0, parcelRequire("4pzsz")).acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
            },
            {
                tag: 'img[data-hipchat-emoticon]',
                getAttrs: (dom)=>(0, (0, parcelRequire("4pzsz")).acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
            },
            {
                tag: 'img.emoji[data-emoji-short-name]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                        id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                        text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                    };
                }
            }
        ],
        toDOM (node) {
            const { shortName: shortName, id: id, text: text } = node.attrs;
            const attrs = {
                'data-emoji-short-name': shortName,
                'data-emoji-id': id,
                'data-emoji-text': text,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("4pzsz", function(module, exports) {
    $parcel$export(module.exports, "acNameToEmoji", ()=>$336500cbd1ca0f10$export$f61e93bda2a8b420);
    $parcel$export(module.exports, "acShortcutToEmoji", ()=>$336500cbd1ca0f10$export$441f8b58f5790a68);
    $parcel$export(module.exports, "getEmojiAcName", ()=>$336500cbd1ca0f10$export$880a2465992fbbe);
    const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
    const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
    const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
    const $336500cbd1ca0f10$var$acNameToEmojiMap = {
        smile: [
            '1f642',
            ':slight_smile:',
            '\uD83D\uDE42'
        ],
        sad: [
            '1f641',
            ':slight_frown:',
            '\uD83D\uDE41'
        ],
        cheeky: [
            '1f61b',
            ':stuck_out_tongue:',
            '\uD83D\uDE1B'
        ],
        laugh: [
            '1f600',
            ':grinning:',
            '\uD83D\uDE00'
        ],
        wink: [
            '1f609',
            ':wink:',
            '\uD83D\uDE09'
        ],
        information: [
            '2139',
            ':information_source:',
            '\u2139'
        ],
        tick: [
            '2705',
            ':white_check_mark:',
            '\u2705'
        ],
        cross: [
            '274c',
            ':x:',
            '\u274C'
        ],
        warning: [
            '26a0',
            ':warning:',
            '\u26A0'
        ],
        plus: [
            '2795',
            ':heavy_plus_sign:',
            '\u2795'
        ],
        minus: [
            '2796',
            ':heavy_minus_sign:',
            '\u2796'
        ],
        question: [
            '2753',
            ':question:',
            '\u003F'
        ],
        'thumbs-up': [
            '1f44d',
            ':thumbsup:',
            '\uD83D\uDC4D'
        ],
        'thumbs-down': [
            '1f44e',
            ':thumbsdown:',
            '\uD83D\uDC4E'
        ],
        'light-on': [
            '1f4a1',
            ':bulb:',
            '\uD83D\uDCA1'
        ],
        'yellow-star': [
            '2b50',
            ':star:',
            '\uD83D\uDC9B'
        ],
        'light-off': [
            '1f6ab',
            ':no_entry_sign:',
            '\uD83D\uDEAB'
        ],
        'red-star': [
            '2764',
            ':heart:',
            '\u2764\uFE0F'
        ],
        'green-star': [
            '1f49a',
            ':green_heart:',
            '\uD83D\uDC9A'
        ],
        'blue-star': [
            '1f499',
            ':blue_heart:',
            '\uD83D\uDC99'
        ],
        heart: [
            '2764',
            ':heart:',
            '\u2764\uFE0F'
        ],
        'broken-heart': [
            '1f494',
            ':broken_heart:',
            '\uD83D\uDC94'
        ]
    };
    function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
        const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
        return emojiData ? {
            id: emojiData[0],
            shortName: emojiData[1],
            text: emojiData[2]
        } : {
            id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
            shortName: `:${acName}:`,
            text: ''
        };
    }
    function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
        const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
        return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
    }
    function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
        return {
            id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
            shortName: `:${hipchatEmoticonShortName}:`,
            text: ''
        };
    }
    function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
        return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
    }
    function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
        if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
            const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
            if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
        }
        return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
    }
});
parcelRegister("hhN5g", function(module, exports) {
    $parcel$export(module.exports, "extension", ()=>$c95a1940f4fa6aee$export$1b45514b112dd749);
    var $CWpyq;
    var $gthjq;
    const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, (0, parcelRequire("gthjq")).extension)({
        parseDOM: [
            {
                tag: '[data-node-type="extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs
            ];
        }
    });
});
parcelRegister("jnMM2", function(module, exports) {
    $parcel$export(module.exports, "hardBreak", ()=>$e1c5ffc4cc369fdc$export$371da9dd35aba193);
    var $gthjq;
    const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, (0, parcelRequire("gthjq")).hardBreak)({
        parseDOM: [
            {
                tag: 'br'
            }
        ],
        toDOM () {
            return [
                'br'
            ];
        }
    });
});
parcelRegister("lRTZM", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$feb9fbb7aabe0cc7$export$46e4a324ac90507f);
    var $gthjq;
    const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
            var _heading$attrs, _heading$attrs$localI;
            return {
                level: level,
                localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
            };
        };
    const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, (0, parcelRequire("gthjq")).heading)({
        parseDOM: [
            {
                tag: 'h1',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
            },
            {
                tag: 'h2',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
            },
            {
                tag: 'h3',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
            },
            {
                tag: 'h4',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
            },
            {
                tag: 'h5',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
            },
            {
                tag: 'h6',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
            }
        ],
        toDOM (node) {
            const { level: level, localId: localId } = node.attrs;
            const name = 'h' + level;
            const attrs = localId !== undefined && localId !== null ? [
                {
                    'data-local-id': localId
                }
            ] : [];
            return [
                name,
                ...attrs,
                0
            ];
        }
    });
});
parcelRegister("7lRBh", function(module, exports) {
    $parcel$export(module.exports, "image", ()=>$55a4127c569d3934$export$5c452ff88e35e47d);
    var $gthjq;
    const $55a4127c569d3934$export$5c452ff88e35e47d = (0, (0, parcelRequire("gthjq")).image)({
        parseDOM: [
            {
                tag: 'img[src^="data:image/"]',
                ignore: true
            },
            {
                tag: 'img[src]',
                getAttrs (domNode) {
                    const dom = domNode;
                    return {
                        src: dom.getAttribute('src'),
                        alt: dom.getAttribute('alt'),
                        title: dom.getAttribute('title')
                    };
                }
            }
        ],
        toDOM (node) {
            return [
                'img',
                node.attrs
            ];
        }
    });
});
parcelRegister("cCBEe", function(module, exports) {
    $parcel$export(module.exports, "inlineCard", ()=>$93063cb7956d3766$export$cbf8224b64e0d942);
    var $gthjq;
    const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, (0, parcelRequire("gthjq")).inlineCard)({
        parseDOM: [
            {
                tag: 'a[data-inline-card], span[data-inline-card]',
                priority: 100,
                getAttrs: (dom)=>{
                    const anchor = dom;
                    const data = anchor.getAttribute('data-card-data');
                    return {
                        url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                        data: data ? JSON.parse(data) : null
                    };
                }
            },
            {
                tag: 'div[data-inline-card]',
                getAttrs: (dom)=>{
                    const anchor = dom;
                    const data = anchor.getAttribute('data-card-data');
                    return {
                        url: anchor.getAttribute('data-card-url'),
                        data: data ? JSON.parse(data) : null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
            };
            if (node.attrs.url) return [
                'a',
                attrs,
                node.attrs.url
            ];
            else return [
                'a',
                attrs
            ];
        }
    });
});
parcelRegister("5BOuQ", function(module, exports) {
    $parcel$export(module.exports, "inlineExtension", ()=>$4157940155363fee$export$16b353b2649bd8d9);
    var $CWpyq;
    var $gthjq;
    const $4157940155363fee$export$16b353b2649bd8d9 = (0, (0, parcelRequire("gthjq")).inlineExtensionWithMarks)({
        parseDOM: [
            {
                tag: 'span[data-extension-type]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode, true)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-local-id:': node.attrs.localId,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs
            ];
        }
    });
});
parcelRegister("4EbxI", function(module, exports) {
    $parcel$export(module.exports, "layoutColumn", ()=>$3623d9fd8951cfd2$export$ab76e7c03cd6f650);
    var $gthjq;
    const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, (0, parcelRequire("gthjq")).layoutColumn)({
        parseDOM: [
            {
                context: 'layoutColumn//',
                tag: 'div[data-layout-column]',
                skip: true
            },
            {
                tag: 'div[data-layout-column]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        width: Number(dom.getAttribute('data-column-width')) || undefined
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-layout-column': 'true'
            };
            const { width: width } = node.attrs;
            if (width) {
                attrs['style'] = `flex-basis: ${width}%`;
                attrs['data-column-width'] = `${width}`;
            }
            const contentAttrs = {
                'data-layout-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
});
parcelRegister("7agO8", function(module, exports) {
    $parcel$export(module.exports, "createMediaSpec", ()=>$5376813d9b4ea07d$export$35bdbf5bc8caa677);
    $parcel$export(module.exports, "copyPrivateAttributes", ()=>$5376813d9b4ea07d$export$111130fa8968d741);
    $parcel$export(module.exports, "media", ()=>$5376813d9b4ea07d$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "toJSON", ()=>$5376813d9b4ea07d$export$54fd2c36b5cc6731);
    var $51H8P;
    var $gthjq;
    const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, (0, parcelRequire("gthjq")).media)({}).attrs;
    const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
        const domNodeType = inline ? 'span' : 'div';
        const nodeName = inline ? 'mediaInline' : 'media';
        const parseDOM = [
            {
                tag: `${domNodeType}[data-node-type="${nodeName}"]`,
                getAttrs: (dom)=>{
                    const attrs = {};
                    if (attributes) Object.keys(attributes).forEach((k)=>{
                        const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                        const value = dom.getAttribute(`data-${key}`) || '';
                        if (value) attrs[k] = value;
                    });
                    if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                    const width = Number(attrs.width);
                    if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                    const height = Number(attrs.height);
                    if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                    return attrs;
                }
            },
            {
                tag: 'img[src^="data:image"]',
                ignore: true
            }
        ];
        const toDOM = (node)=>{
            const attrs = {
                'data-id': node.attrs.id,
                'data-node-type': `${nodeName}`,
                'data-type': node.attrs.type,
                'data-collection': node.attrs.collection,
                'data-occurrence-key': node.attrs.occurrenceKey,
                'data-width': node.attrs.width,
                'data-height': node.attrs.height,
                'data-url': node.attrs.url,
                'data-alt': node.attrs.alt,
                title: 'Attachment',
                style: `display: inline-block; border-radius: 3px; background: ${(0, (0, parcelRequire("51H8P")).N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
            };
            $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
            return [
                `${domNodeType}`,
                attrs
            ];
        };
        if (inline) return (0, (0, parcelRequire("gthjq")).mediaInline)({
            parseDOM: parseDOM,
            toDOM: toDOM
        });
        return (0, (0, parcelRequire("gthjq")).media)({
            parseDOM: [
                ...parseDOM,
                {
                    tag: 'img:not(.smart-link-icon)',
                    getAttrs: (dom)=>{
                        return {
                            type: 'external',
                            url: dom.getAttribute('src') || '',
                            alt: dom.getAttribute('alt') || ''
                        };
                    }
                }
            ],
            toDOM: toDOM
        });
    };
    const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
    const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
    const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
        if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const $5376813d9b4ea07d$var$optionalAttributes = [
        'occurrenceKey',
        'width',
        'height',
        'url',
        'alt'
    ];
    const $5376813d9b4ea07d$var$externalOnlyAttributes = [
        'type',
        'url',
        'width',
        'height',
        'alt'
    ];
    const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
                if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
                if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
                if ([
                    'width',
                    'height'
                ].indexOf(key) !== -1) {
                    obj[key] = Number(node.attrs[key]);
                    return obj;
                }
                obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
});
parcelRegister("92lix", function(module, exports) {
    $parcel$export(module.exports, "mediaGroup", ()=>$6944d24b2c8b0dd9$export$2855e964765eac9);
    var $gthjq;
    const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, (0, parcelRequire("gthjq")).mediaGroup)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaGroup"]'
            },
            {
                tag: 'div[class="MediaGroup"]'
            }
        ],
        toDOM () {
            return [
                'div',
                {
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    });
});
parcelRegister("7Xgp3", function(module, exports) {
    $parcel$export(module.exports, "mediaInline", ()=>$5caac46433adf3f0$export$38bab695e3f720f1);
    var $7agO8;
    var $gthjq;
    const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, (0, parcelRequire("7agO8")).createMediaSpec)((0, (0, parcelRequire("gthjq")).mediaInline)({}).attrs, true);
});
parcelRegister("bIGZ7", function(module, exports) {
    $parcel$export(module.exports, "mediaSingleSpec", ()=>$888525ada96954d1$export$5a1e124099b60c6b);
    $parcel$export(module.exports, "mediaSingle", ()=>$888525ada96954d1$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingleWithCaption", ()=>$888525ada96954d1$export$d35e6c006d4abdfb);
    $parcel$export(module.exports, "mediaSingleWithWidthType", ()=>$888525ada96954d1$export$9c58e19811ce4cf5);
    $parcel$export(module.exports, "mediaSingleFull", ()=>$888525ada96954d1$export$7e767666f2ce108a);
    $parcel$export(module.exports, "toJSON", ()=>$888525ada96954d1$export$54fd2c36b5cc6731);
    var $ITAJ1;
    var $6VXbJ;
    var $gthjq;
    const $888525ada96954d1$export$bb3fe706be61f640 = {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        }
    };
    const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
        const getAttrs = (dom)=>{
            if (!(0, (0, parcelRequire("6VXbJ")).isDOMElement)(dom)) return {
                layout: 'center'
            };
            const layout = dom.getAttribute('data-layout') || 'center';
            const width = Number(dom.getAttribute('data-width')) || null;
            const widthType = dom.getAttribute('data-width-type');
            if (withExtendedWidthTypes) return {
                layout: layout,
                width: width,
                widthType: widthType
            };
            else if (widthType === (0, (0, parcelRequire("ITAJ1")).WidthType).PIXEL) return {
                layout: layout
            };
            else return {
                layout: layout,
                width: width
            };
        };
        const getAttrsFromNode = (node)=>{
            const { layout: layout, width: width } = node.attrs;
            const attrs = {
                'data-node-type': 'mediaSingle',
                'data-layout': layout,
                'data-width': ''
            };
            if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
            if (withExtendedWidthTypes && node.attrs.widthType) {
                const { widthType: widthType } = node.attrs;
                return {
                    ...attrs,
                    'data-width-type': widthType || (0, (0, parcelRequire("ITAJ1")).WidthType).PERCENTAGE
                };
            }
            return attrs;
        };
        if (withExtendedWidthTypes && withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleFull)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        if (withExtendedWidthTypes && !withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleWidthType)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        if (!withExtendedWidthTypes && withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleCaption)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        return (0, (0, parcelRequire("gthjq")).mediaSingle)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
    };
    const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: false,
        withExtendedWidthTypes: false
    });
    const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: true,
        withExtendedWidthTypes: false
    });
    const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: false,
        withExtendedWidthTypes: true
    });
    const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: true,
        withExtendedWidthTypes: true
    });
    const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if (node.attrs[key] !== null) obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
});
parcelRegister("ITAJ1", function(module, exports) {
    $parcel$export(module.exports, "WidthType", ()=>$086f3b754fef02e1$export$4d41558722ac7eed);
    let $086f3b754fef02e1$export$4d41558722ac7eed = function(WidthType) {
        WidthType["PIXEL"] = "pixel";
        WidthType["PERCENTAGE"] = "percentage";
        return WidthType;
    }({});
});
parcelRegister("g7Cky", function(module, exports) {
    $parcel$export(module.exports, "mention", ()=>$bbcb0873d657d42d$export$db83999c14438df4);
    $parcel$export(module.exports, "toJSON", ()=>$bbcb0873d657d42d$export$54fd2c36b5cc6731);
    var $9IGaJ;
    var $gthjq;
    let $bbcb0873d657d42d$export$abebb208988c258 = function(USER_TYPES) {
        USER_TYPES["DEFAULT"] = "DEFAULT";
        USER_TYPES["SPECIAL"] = "SPECIAL";
        USER_TYPES["APP"] = "APP";
        return USER_TYPES;
    }({});
    const $bbcb0873d657d42d$export$db83999c14438df4 = (0, (0, parcelRequire("gthjq")).mention)({
        parseDOM: [
            {
                tag: 'span[data-mention-id]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const attrs = {
                        id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                        text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                        accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    };
                    const userType = dom.getAttribute('data-user-type');
                    if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
            const attrs = {
                'data-mention-id': id,
                'data-access-level': accessLevel,
                contenteditable: 'false'
            };
            if (localId) attrs['data-local-id'] = localId;
            if (userType) attrs['data-user-type'] = userType;
            return [
                'span',
                attrs,
                text
            ];
        }
    });
    const $bbcb0873d657d42d$var$isOptional = (key)=>{
        return [
            'userType',
            'localId'
        ].indexOf(key) > -1;
    };
    const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
});
parcelRegister("dx5eC", function(module, exports) {
    $parcel$export(module.exports, "nestedExpand", ()=>$9da26af350402964$export$63cadbf5f4296627);
    var $gthjq;
    function $9da26af350402964$var$getExpandAttrs(domNode) {
        const dom = domNode;
        return {
            title: dom.getAttribute('data-title'),
            __expanded: true
        };
    }
    const $9da26af350402964$export$63cadbf5f4296627 = (0, (0, parcelRequire("gthjq")).nestedExpand)({
        parseDOM: [
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="nestedExpand"]',
                getAttrs: $9da26af350402964$var$getExpandAttrs
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="nestedExpand"]',
                getAttrs: $9da26af350402964$var$getExpandAttrs
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'nestedExpand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("dwptW", function(module, exports) {
    $parcel$export(module.exports, "orderedListSelector", ()=>$9d8207b1e6c47527$export$4e7125c7ff595be5);
    $parcel$export(module.exports, "orderedList", ()=>$9d8207b1e6c47527$export$a5dc81035676e7a);
    $parcel$export(module.exports, "orderedListWithOrder", ()=>$9d8207b1e6c47527$export$b9ab759e8298198f);
    var $gthjq;
    const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
    const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, (0, parcelRequire("gthjq")).orderedList)({
        parseDOM: [
            {
                tag: 'ol'
            }
        ],
        toDOM () {
            const attrs = {
                class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
    const $9d8207b1e6c47527$var$resolveStart = (start)=>{
        const num = Number(start);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, (0, parcelRequire("gthjq")).orderedList)({
        parseDOM: [
            {
                tag: 'ol',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const startDOMAttr = dom.getAttribute('start');
                    if (startDOMAttr) {
                        const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                        if (typeof start === 'number') return {
                            order: start
                        };
                    }
                    return null;
                }
            }
        ],
        toDOM (node) {
            var _node$attrs;
            const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
            const attrs = {
                start: typeof start === 'number' ? String(start) : undefined,
                class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("abme3", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$769c2c0b195d79f6$export$9c206ddddb32a9b);
    var $gthjq;
    const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, (0, parcelRequire("gthjq")).paragraph)({
        parseDOM: [
            {
                tag: 'p',
                getAttrs: (domNode)=>{
                    var _paragraph$attrs, _paragraph$attrs$loca;
                    const dom = domNode;
                    const attrs = {
                        localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                    };
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const name = 'p';
            const attrs = localId !== undefined && localId !== null ? [
                {
                    'data-local-id': localId
                }
            ] : [];
            return [
                name,
                ...attrs,
                0
            ];
        }
    });
});
parcelRegister("dgJoa", function(module, exports) {
    $parcel$export(module.exports, "placeholder", ()=>$9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);
    var $gthjq;
    const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, (0, parcelRequire("gthjq")).placeholder)({
        parseDOM: [
            {
                tag: 'span[data-placeholder]',
                getAttrs: (dom)=>({
                        text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                    })
            }
        ],
        toDOM (node) {
            const { text: text } = node.attrs;
            const attrs = {
                'data-placeholder': text,
                contenteditable: 'true'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("M4hHz", function(module, exports) {
    $parcel$export(module.exports, "rule", ()=>$0907ce9fea0294ca$export$fbeb3a3956e8a3c7);
    var $gthjq;
    const $0907ce9fea0294ca$var$hrDOM = [
        'hr'
    ];
    const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, (0, parcelRequire("gthjq")).rule)({
        parseDOM: [
            {
                tag: 'hr'
            }
        ],
        toDOM () {
            return $0907ce9fea0294ca$var$hrDOM;
        }
    });
});
parcelRegister("18bvk", function(module, exports) {
    $parcel$export(module.exports, "status", ()=>$0d2f764e7fea7c00$export$471f7ae5c4103ae1);
    var $9IGaJ;
    var $gthjq;
    const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, (0, parcelRequire("gthjq")).status)({
        parseDOM: [
            {
                tag: 'span[data-node-type="status"]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        text: dom.textContent.replace(/\n/, '').trim(),
                        color: dom.getAttribute('data-color'),
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        style: dom.getAttribute('data-style')
                    };
                }
            }
        ],
        toDOM (node) {
            const { text: text, color: color, localId: localId, style: style } = node.attrs;
            const attrs = {
                'data-node-type': 'status',
                'data-color': color,
                'data-local-id': localId,
                'data-style': style,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("iThOL", function(module, exports) {
    $parcel$export(module.exports, "taskItem", ()=>$dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);
    var $9IGaJ;
    var $gthjq;
    const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, (0, parcelRequire("gthjq")).taskItem)({
        parseDOM: [
            {
                tag: 'div[data-task-local-id]',
                priority: 100,
                getAttrs: (dom)=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        state: dom.getAttribute('data-task-state') || 'TODO'
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-task-local-id': localId || 'local-task',
                'data-task-state': state || 'TODO'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("43mJF", function(module, exports) {
    $parcel$export(module.exports, "taskListSelector", ()=>$2f3914100d01687b$export$c0ec71adb7a18fb2);
    $parcel$export(module.exports, "taskList", ()=>$2f3914100d01687b$export$375b6afcc5f4d291);
    var $9IGaJ;
    var $gthjq;
    const $2f3914100d01687b$var$name = 'actionList';
    const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
    const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, (0, parcelRequire("gthjq")).taskList)({
        parseDOM: [
            {
                tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
                priority: 100,
                getAttrs: ()=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const attrs = {
                'data-node-type': $2f3914100d01687b$var$name,
                'data-task-list-local-id': localId || 'local-task-list',
                style: 'list-style: none; padding-left: 0'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("3DR6L", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$2a6e35cab1a01b8e$export$6f093cfa640b7166);
    var $gthjq;
    const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, (0, parcelRequire("gthjq")).text)({
        toDebugString: ()=>'text_node'
    });
});
parcelRegister("9X587", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01deabc8204e5493$export$2e2bcd8739ae039);
    const $01deabc8204e5493$var$name = 'unknownBlock';
    var $01deabc8204e5493$export$2e2bcd8739ae039 = {
        group: 'block',
        content: 'inline+',
        marks: '_',
        toDOM () {
            return [
                'div',
                {
                    'data-node-type': $01deabc8204e5493$var$name
                },
                0
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
            }
        ]
    };
});
parcelRegister("d1d6m", function(module, exports) {
    $parcel$export(module.exports, "unsupportedBlock", ()=>$97a5880db351ce36$export$44b79b0979d0f0f7);
    var $gthjq;
    const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, (0, parcelRequire("gthjq")).unsupportedBlock)({
        parseDOM: [
            {
                tag: '[data-node-type="unsupportedBlock"]',
                getAttrs: (dom)=>({
                        originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'unsupportedBlock',
                'data-original-value': JSON.stringify(node.attrs.originalValue)
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        }
    });
});
parcelRegister("6kr5W", function(module, exports) {
    $parcel$export(module.exports, "unsupportedInline", ()=>$49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);
    var $gthjq;
    const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, (0, parcelRequire("gthjq")).unsupportedInline)({
        parseDOM: [
            {
                tag: '[data-node-type="unsupportedInline"]',
                getAttrs: (dom)=>({
                        originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'unsupportedInline',
                'data-original-value': JSON.stringify(node.attrs.originalValue)
            };
            return [
                'span',
                attrs,
                'Unsupported content'
            ];
        }
    });
});
parcelRegister("f9FHW", function(module, exports) {
    $parcel$export(module.exports, "defaultNodeComponents", ()=>$64812a5fe031a1a1$export$ee31295d51950741);
    $parcel$export(module.exports, "default", ()=>$64812a5fe031a1a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $kOFhM;
    var $2osam;
    var $d67ah;
    var $i5Kxj = parcelRequire("i5Kxj");
    var $6MTWT;
    var $kaGUJ;
    var $iITB0;
    var $caFD8;
    var $afkuR;
    var $979lV;
    var $cZe8H;
    var $9axZJ;
    var $lXM3l;
    var $dMwYp;
    var $4cJrc;
    var $2oS3b;
    var $dk7tY;
    var $70yok;
    var $20EGj = parcelRequire("20EGj");
    var $hjG0m = parcelRequire("hjG0m");
    var $bXrHm = parcelRequire("bXrHm");
    var $daO0f;
    var $9EkeZ;
    var $jEKj7;
    var $2L3dU;
    var $6SKbt;
    var $4la1F;
    var $drjNK;
    var $fPbxE;
    var $4R9F2;
    var $35dtk;
    var $cVlbF;
    var $8foRb;
    var $5u5gV;
    var $daqZ0;
    var $3UkaZ;
    var $iWoJB;
    var $8QpSo;
    var $lTPvl;
    var $kDE4W;
    var $aE1nS;
    var $2gO4q;
    function $64812a5fe031a1a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $64812a5fe031a1a1$export$47b2879ca9bbf67a = 2000;
    const $64812a5fe031a1a1$export$1b622068be977101 = 3000;
    const $64812a5fe031a1a1$var$packageName = "platform-pkg";
    const $64812a5fe031a1a1$var$packageVersion = "0.0.0-use.local";
    const $64812a5fe031a1a1$var$setAsQueryContainerStyles = {
        name: "isqlwl",
        styles: "container-name:ak-renderer-wrapper;container-type:inline-size;contain:layout style inline-size"
    };
    const $64812a5fe031a1a1$export$ee31295d51950741 = (0, (0, parcelRequire("aE1nS")).nodeToReact);
    class $64812a5fe031a1a1$export$5161b00bb85c4267 extends (0, $5uXOq.PureComponent) {
        constructor(props){
            super(props);
            this.renderedMeasurementDistortedDurationMonitor = (0, (0, parcelRequire("lXM3l")).getDistortedDurationMonitor)();
            this.createRendererContext = (0, (0, parcelRequire("8QpSo")).default)((featureFlags, isTopLevelRenderer)=>{
                const normalizedFeatureFlags = (0, (0, parcelRequire("dk7tY")).normalizeFeatureFlags)(featureFlags);
                return {
                    featureFlags: normalizedFeatureFlags,
                    isTopLevelRenderer: isTopLevelRenderer === undefined
                };
            });
            this.fireAnalyticsEvent = (event)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) {
                    const channel = (0, $20EGj.FabricChannel).editor;
                    createAnalyticsEvent(event).fire(channel);
                }
            };
            this.getSchema = (0, (0, parcelRequire("8QpSo")).default)((schema, adfStage)=>{
                if (schema) return schema;
                return (0, (0, parcelRequire("kOFhM")).getSchemaBasedOnStage)(adfStage);
            });
            this.onMouseDownEditView = ()=>{
                const windowSelection = window.getSelection();
                this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
            };
            this.handleMouseTripleClickInTables = (event)=>{
                if ((0, (0, parcelRequire("dMwYp")).browser).ios || (0, (0, parcelRequire("dMwYp")).browser).android) return;
                const badBrowser = (0, (0, parcelRequire("dMwYp")).browser).chrome || (0, (0, parcelRequire("dMwYp")).browser).safari;
                const tripleClick = event.detail >= 3;
                if (!(badBrowser && tripleClick)) return;
                const selection = window.getSelection();
                if (!selection) return;
                const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
                const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
                if (!rangeSelection) return;
                const target = event.target;
                const tableCell = target.closest('td,th');
                const clickedInCell = Boolean(tableCell);
                if (!clickedInCell) return;
                const anchorInCell = tableCell.contains(anchorNode);
                const focusInCell = tableCell.contains(focusNode);
                const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
                if (!selectionStartsOrEndsOutsideClickedCell) return;
                const elementToSelect = anchorInCell ? anchorNode.parentElement?.closest('div,p') : focusInCell ? focusNode.parentElement?.closest('div,p') : tableCell;
                if (elementToSelect) selection.selectAllChildren(elementToSelect);
            };
            this.providerFactory = props.dataProviders || new (0, (0, parcelRequire("2osam")).default)();
            this.serializer = new (0, (0, parcelRequire("daO0f")).default)(this.deriveSerializerProps(props));
            this.editorRef = props.innerRef || (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.id = (0, ($parcel$interopDefault($bXrHm)))();
            (0, (0, parcelRequire("979lV")).startMeasure)(`Renderer Render Time: ${this.id}`);
        }
        anchorLinkAnalytics() {
            const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
            const { disableHeadingIDs: disableHeadingIDs } = this.props;
            if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
                const anchorLinkElement = document.getElementById(hash);
                if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).VIEWED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANCHOR_LINK,
                    attributes: {
                        platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("4la1F")).MODE).RENDERER
                    },
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).UI
                });
            }
        }
        componentDidMount() {
            this.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).STARTED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB
                },
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).UI
            });
            this.rafID = requestAnimationFrame(()=>{
                (0, (0, parcelRequire("979lV")).stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                    const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, (0, parcelRequire("9axZJ")).shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, (0, parcelRequire("cZe8H")).getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $64812a5fe031a1a1$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $64812a5fe031a1a1$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("6SKbt")).ACTION).RENDERED,
                        actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                            duration: duration,
                            distortedDuration: this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, (0, parcelRequire("4cJrc")).getResponseEndTime)(),
                            nodes: (0, (0, parcelRequire("2gO4q")).countNodes)(this.props.document),
                            severity: severity
                        },
                        eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL
                    });
                    this.renderedMeasurementDistortedDurationMonitor.cleanup();
                    delete this.renderedMeasurementDistortedDurationMonitor;
                });
                this.anchorLinkAnalytics();
            });
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            const nextMedia = nextProps.media || {};
            const media = this.props.media || {};
            if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, (0, parcelRequire("daO0f")).default)(this.deriveSerializerProps(nextProps));
        }
        deriveSerializerProps(props) {
            const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
            const { annotationProvider: annotationProvider } = props;
            const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
            const { featureFlags: featureFlags } = this.createRendererContext(props.featureFlags, props.isTopLevelRenderer);
            return {
                startPos: props.startPos,
                providers: this.providerFactory,
                eventHandlers: props.eventHandlers,
                extensionHandlers: props.extensionHandlers,
                portal: props.portal,
                objectContext: {
                    adDoc: props.document,
                    schema: props.schema,
                    ...props.rendererContext
                },
                appearance: props.appearance,
                disableHeadingIDs: props.disableHeadingIDs,
                disableActions: props.disableActions,
                allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
                allowColumnSorting: props.allowColumnSorting,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                shouldOpenMediaViewer: props.shouldOpenMediaViewer,
                allowAltTextOnImages: props.allowAltTextOnImages,
                stickyHeaders: stickyHeaders,
                allowMediaLinking: props.media && props.media.allowLinking,
                surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
                media: props.media,
                emojiResourceConfig: props.emojiResourceConfig,
                smartLinks: props.smartLinks,
                allowCopyToClipboard: props.allowCopyToClipboard,
                allowWrapCodeBlock: props.allowWrapCodeBlock,
                allowCustomPanels: props.allowCustomPanels,
                allowAnnotations: props.allowAnnotations,
                allowSelectAllTrap: props.allowSelectAllTrap,
                allowPlaceholderText: props.allowPlaceholderText,
                nodeComponents: props.nodeComponents,
                allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
                isInsideOfInlineExtension: props.isInsideOfInlineExtension,
                textHighlighter: props.UNSTABLE_textHighlighter,
                allowTableAlignment: props.UNSTABLE_allowTableAlignment,
                allowTableResizing: props.UNSTABLE_allowTableResizing
            };
        }
        render() {
            const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media } = this.props;
            const rendererContext = this.createRendererContext(this.props.featureFlags, this.props.isTopLevelRenderer);
            const allowNestedHeaderLinks = (0, (0, parcelRequire("5u5gV")).isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
            const handleWrapperOnClick = (event)=>{
                const targetElement = event.target;
                this.handleMouseTripleClickInTables(event);
                if (!this.props.eventHandlers?.onUnhandledClick) return;
                if (!(targetElement instanceof window.Element)) return;
                const rendererWrapper = event.currentTarget;
                const isInteractiveElementInTree = (0, (0, parcelRequire("daqZ0")).findInTree)(targetElement, rendererWrapper, (0, (0, parcelRequire("3UkaZ")).isInteractiveElement));
                if (isInteractiveElementInTree) return;
                const windowSelection = window.getSelection();
                const selection = windowSelection !== null ? windowSelection.toString() : undefined;
                const hasSelection = selection && selection.length !== 0;
                const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
                const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
                if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
            };
            try {
                const schema = this.getSchema(this.props.schema, this.props.adfStage);
                const { result: result, stat: stat, pmDoc: pmDoc } = (0, (0, parcelRequire("9EkeZ")).renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance, this.props.includeNodesCountInStats);
                if (onComplete) onComplete(stat);
                const rendererOutput = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iWoJB")).RendererContextProvider), {
                    value: rendererContext
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cVlbF")).ActiveHeaderIdProvider), {
                    value: (0, (0, parcelRequire("5u5gV")).getActiveHeadingId)(allowHeadingAnchorLinks)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("drjNK")).default).Provider, {
                    value: {
                        fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                    }
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fPbxE")).Provider), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("d67ah")).ProviderFactoryProvider), {
                    value: this.providerFactory
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$var$RendererWrapper, {
                    allowAnnotations: allowAnnotations,
                    appearance: appearance,
                    allowNestedHeaderLinks: allowNestedHeaderLinks,
                    allowColumnSorting: allowColumnSorting,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    allowCustomPanels: allowCustomPanels,
                    allowPlaceholderText: allowPlaceholderText,
                    useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                    addTelepointer: this.props.addTelepointer,
                    innerRef: this.editorRef,
                    onClick: handleWrapperOnClick,
                    onMouseDown: this.onMouseDownEditView,
                    ssr: media?.ssr,
                    isInsideOfInlineExtension: this.props.isInsideOfInlineExtension,
                    isTopLevelRenderer: rendererContext.isTopLevelRenderer
                }, enableSsrInlineScripts ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4R9F2")).BreakoutSSRInlineScript), null) : null, (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$var$RendererActionsInternalUpdater, {
                    doc: pmDoc,
                    schema: schema,
                    onAnalyticsEvent: this.fireAnalyticsEvent
                }, result)))))));
                let rendererResult = truncated ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2L3dU")).TruncatedWrapper), {
                    height: maxHeight,
                    fadeHeight: fadeOutHeight
                }, rendererOutput) : rendererOutput;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, rendererResult);
            } catch (e) {
                if (onError) onError(e);
                return (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$var$RendererWrapper, {
                    allowAnnotations: allowAnnotations,
                    appearance: appearance,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    allowPlaceholderText: allowPlaceholderText,
                    allowColumnSorting: allowColumnSorting,
                    allowNestedHeaderLinks: allowNestedHeaderLinks,
                    useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                    addTelepointer: this.props.addTelepointer,
                    onClick: handleWrapperOnClick,
                    isTopLevelRenderer: rendererContext.isTopLevelRenderer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iITB0")).default), null));
            }
        }
        componentWillUnmount() {
            const { dataProviders: dataProviders } = this.props;
            if (this.rafID) window.cancelAnimationFrame(this.rafID);
            if (!dataProviders) this.providerFactory.destroy();
        }
    }
    function $64812a5fe031a1a1$export$88530751e3977073(props) {
        const { startPos: startPos } = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("8foRb")).AnnotationsPositionContext));
        const { isTopLevelRenderer: isTopLevelRenderer } = (0, (0, parcelRequire("iWoJB")).useRendererContext)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$export$5161b00bb85c4267, {
            ...props,
            startPos: startPos,
            isTopLevelRenderer: isTopLevelRenderer
        }));
    }
    const $64812a5fe031a1a1$export$af81ffb59b6ef0dd = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $hjG0m.FabricEditorAnalyticsContext), {
            data: {
                appearance: (0, (0, parcelRequire("cZe8H")).getAnalyticsAppearance)(props.appearance),
                packageName: $64812a5fe031a1a1$var$packageName,
                packageVersion: $64812a5fe031a1a1$var$packageVersion,
                componentName: 'renderer',
                editorSessionId: (0, ($parcel$interopDefault($bXrHm)))()
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("afkuR")).WithCreateAnalyticsEvent), {
            render: (createAnalyticsEvent)=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lTPvl")).ErrorBoundary), {
                    component: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                    rethrowError: true,
                    fallbackComponent: null,
                    createAnalyticsEvent: createAnalyticsEvent
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kaGUJ")).IntlErrorBoundary), null, (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$export$88530751e3977073, {
                    ...props,
                    createAnalyticsEvent: createAnalyticsEvent
                })));
            }
        })));
    const $64812a5fe031a1a1$var$RendererWrapper = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
        const createTelepointer = ()=>{
            const telepointer = document.createElement('span');
            telepointer.textContent = '\u200b';
            telepointer.id = (0, (0, parcelRequire("jEKj7")).TELEPOINTER_ID);
            return telepointer;
        };
        const initialUpdate = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
                const renderer = innerRef.current.querySelector('.ak-renderer-document');
                if (initialUpdate.current) {
                    const lastChild = renderer.lastChild;
                    lastChild && lastChild.appendChild(createTelepointer());
                }
                const mutateTelepointer = (mutations)=>{
                    mutations.forEach((mutation)=>{
                        if (initialUpdate.current) {
                            const oldTelepointer = renderer.querySelector(`#${(0, (0, parcelRequire("jEKj7")).TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            const lastChild = renderer.lastChild;
                            lastChild && lastChild.appendChild(createTelepointer());
                            initialUpdate.current = false;
                        }
                        if (mutation.type === 'characterData') {
                            const parentNode = mutation.target.parentElement;
                            if (parentNode) {
                                const oldTelepointer = renderer.querySelector(`#${(0, (0, parcelRequire("jEKj7")).TELEPOINTER_ID)}`);
                                if (oldTelepointer) oldTelepointer.remove();
                                parentNode.appendChild(createTelepointer());
                            }
                        }
                    });
                };
                const observer = new MutationObserver(mutateTelepointer);
                observer.observe(innerRef.current, {
                    characterData: true,
                    attributes: false,
                    childList: true,
                    subtree: true
                });
                return ()=>observer.disconnect();
            }
        }, [
            innerRef,
            addTelepointer
        ]);
        const renderer = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("caFD8")).WidthProvider), {
            className: `ak-renderer-wrapper is-${appearance}`,
            "data-appearance": appearance,
            shouldCheckExistingValue: isInsideOfInlineExtension
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6MTWT")).BaseTheme), {
            baseFontSize: appearance && appearance !== 'comment' ? (0, (0, parcelRequire("70yok")).akEditorFullPageDefaultFontSize) : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kDE4W")).EditorMediaClientProvider), {
            ssr: ssr
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            onClick: onClick,
            onMouseDown: onMouseDown,
            css: (0, (0, parcelRequire("jEKj7")).rendererStyles)({
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: !!allowColumnSorting,
                useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
                allowAnnotations: props.allowAnnotations,
                allowTableResizing: allowTableResizing
            })
        }, children))));
        return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && isTopLevelRenderer && (0, (0, parcelRequire("2oS3b")).fg)('platform-fix-table-ssr-resizing') ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $64812a5fe031a1a1$var$setAsQueryContainerStyles
        }, renderer) : renderer;
    });
    const $64812a5fe031a1a1$var$RootRendererContext = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    function $64812a5fe031a1a1$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
        const rootRendererContextValue = (0, ($parcel$interopDefault($5uXOq))).useContext($64812a5fe031a1a1$var$RootRendererContext);
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const rendererRef = (0, $5uXOq.useRef)(null);
        let _doc;
        if ((0, $i5Kxj.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) _doc = rootRendererContextValue.doc;
        else _doc = doc;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
            else actions._privateUnregisterRenderer();
            return ()=>actions._privateUnregisterRenderer();
        }, [
            actions,
            schema,
            _doc,
            onAnalyticsEvent
        ]);
        if ((0, $i5Kxj.editorExperiment)('comment_on_bodied_extensions', true)) return (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$var$RootRendererContext.Provider, {
            value: {
                doc: _doc
            }
        }, children);
        return children;
    }
    const $64812a5fe031a1a1$var$RendererWithAnnotationSelection = (props)=>{
        const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
        const localRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const innerRef = props.innerRef || localRef;
        if (!allowAnnotations) return (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$export$af81ffb59b6ef0dd, {
            innerRef: innerRef,
            ...props
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("35dtk")).RendererActionsContext), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8foRb")).AnnotationsWrapper), {
            rendererRef: innerRef,
            adfDocument: adfDocument,
            annotationProvider: props.annotationProvider,
            isNestedRender: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($64812a5fe031a1a1$export$af81ffb59b6ef0dd, {
            innerRef: innerRef,
            ...props,
            featureFlags: props.featureFlags
        })));
    };
    var $64812a5fe031a1a1$export$2e2bcd8739ae039 = $64812a5fe031a1a1$var$RendererWithAnnotationSelection;
});
parcelRegister("2osam", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7299633502638e7$export$2e2bcd8739ae039);
    function $c7299633502638e7$var$isUndefined(x) {
        return x === undefined;
    }
    class $c7299633502638e7$export$2e2bcd8739ae039 {
        static create(providers) {
            const providerFactory = new $c7299633502638e7$export$2e2bcd8739ae039();
            const keys = Object.keys(providers);
            keys.forEach((name)=>{
                providerFactory.setProvider(name, providers[name]);
            });
            return providerFactory;
        }
        destroy() {
            this.providers.clear();
            this.subscribers.clear();
        }
        isEmpty() {
            return !this.providers.size && !this.subscribers.size;
        }
        setProvider(name, provider) {
            if (this.providers.get(name) === provider) return;
            if (!$c7299633502638e7$var$isUndefined(provider)) this.providers.set(name, provider);
            else this.providers.delete(name);
            this.notifyUpdated(name, provider);
        }
        removeProvider(name) {
            this.providers.delete(name);
            this.notifyUpdated(name);
        }
        subscribe(name, handler) {
            const handlers = this.subscribers.get(name) || [];
            handlers.push(handler);
            this.subscribers.set(name, handlers);
            const provider = this.providers.get(name);
            if (provider) handler(name, provider);
            return provider;
        }
        unsubscribe(name, handler) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            const index = handlers.indexOf(handler);
            if (index !== -1) handlers.splice(index, 1);
            if (handlers.length === 0) this.subscribers.delete(name);
            else this.subscribers.set(name, handlers);
        }
        unsubscribeAll(name) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            this.subscribers.delete(name);
        }
        hasProvider(name) {
            return this.providers.has(name);
        }
        notifyUpdated(name, provider) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            handlers.forEach((handler)=>{
                handler(name, provider);
            });
        }
        constructor(){
            this.providers = new Map();
            this.subscribers = new Map();
        }
    }
});
parcelRegister("d67ah", function(module, exports) {
    $parcel$export(module.exports, "ProviderFactoryProvider", ()=>$422eb3b5d4c82d00$export$617c134b25cc4265);
    $parcel$export(module.exports, "useProvider", ()=>$422eb3b5d4c82d00$export$693cdb10cec23617);
    var $5uXOq = parcelRequire("5uXOq");
    var $2osam;
    const $422eb3b5d4c82d00$var$ProviderFactoryContext = (0, ($parcel$interopDefault($5uXOq))).createContext(new (0, (0, parcelRequire("2osam")).default)());
    const $422eb3b5d4c82d00$export$617c134b25cc4265 = $422eb3b5d4c82d00$var$ProviderFactoryContext.Provider;
    const $422eb3b5d4c82d00$export$a3af4b6980aa23b5 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($422eb3b5d4c82d00$var$ProviderFactoryContext);
    const $422eb3b5d4c82d00$export$693cdb10cec23617 = (name)=>{
        const [provider, setProvider] = (0, ($parcel$interopDefault($5uXOq))).useState();
        const providerFactory = $422eb3b5d4c82d00$export$a3af4b6980aa23b5();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const providerHandler = (_, provider)=>{
                setProvider(provider);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        }, [
            name,
            providerFactory
        ]);
        return provider;
    };
});
parcelRegister("i5Kxj", function(module, exports) {
    $parcel$export(module.exports, "editorExperiment", ()=>$55aeb50a5412bb5f$export$9b7cf3b74f250027);
    var $2H0Fr;
    var $34PHa = parcelRequire("34PHa");
    var $krH0B = parcelRequire("krH0B");
    function $55aeb50a5412bb5f$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
        exposure: false
    }) {
        const experimentConfig = (0, $34PHa.editorExperimentsConfig)[experimentName];
        if ((0, $krH0B._overrides)[experimentName] !== undefined) return (0, $krH0B._overrides)[experimentName] === expectedExperimentValue;
        if (!(0, $krH0B._product)) return experimentConfig.defaultValue === expectedExperimentValue;
        const experimentKey = experimentConfig.productKeys?.[0, $krH0B._product];
        if (!experimentKey) return (0, $34PHa.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
        const experimentValue = (0, (0, parcelRequire("2H0Fr")).default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
            typeGuard: experimentConfig.typeGuard,
            fireExperimentExposure: options.exposure
        });
        return expectedExperimentValue === experimentValue;
    }
});
parcelRegister("34PHa", function(module, exports) {
    $parcel$export(module.exports, "editorExperimentsConfig", ()=>$c5f9c58255547897$export$6cbb856f286b07ef);
    var $5bUQm = parcelRequire("5bUQm");
    const $c5f9c58255547897$export$6cbb856f286b07ef = {
        'example-boolean': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package_boolean'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'example-multivariate': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package_multivariate'
            },
            param: 'variant',
            typeGuard: (0, $5bUQm.oneOf)([
                'one',
                'two',
                'three'
            ]),
            defaultValue: 'one'
        },
        'test-new-experiments-package': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package',
                jira: 'jira_editor_experiment_test_new_package'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'basic-text-transformations': {
            productKeys: {
                confluence: 'platform_editor_basic_text_transformations'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'dnd-input-performance-optimisation': {
            productKeys: {
                confluence: 'platform_editor_dnd_input_performance_optimisation'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'element-level-templates': {
            productKeys: {
                confluence: 'platform_editor_element_level_templates'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'add-media-from-url': {
            productKeys: {
                confluence: 'platform_editor_add_media_from_url'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'nested-dnd': {
            productKeys: {
                confluence: 'platform_editor_element_drag_and_drop_nested'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'table-nested-dnd': {
            productKeys: {
                confluence: 'platform_editor_elements_dnd_nested_table'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'insert-menu-in-right-rail': {
            productKeys: {
                confluence: 'platform_editor_insert_menu_in_right_rail'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        support_table_in_comment: {
            productKeys: {
                confluence: 'platform_editor_support_table_in_comment_exp'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_exp_lazy_node_views: {
            productKeys: {
                confluence: 'platform_editor_exp_lazy_node_views'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_ai_button_block_elements: {
            productKeys: {
                confluence: 'platform_editor_ai_ai_button_block_elements'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_renderer_table_sticky_scrollbar: {
            productKeys: {
                confluence: 'platform_renderer_table_sticky_scrollbar'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'nest-media-and-codeblock-in-quote': {
            productKeys: {
                confluence: 'platform_editor_nest_media_and_codeblock_in_quotes'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'nested-expand-in-expand': {
            productKeys: {
                confluence: 'platform_editor_nest_nested_expand_in_expand'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_command_palette_post_ga: {
            productKeys: {
                confluence: 'platform_editor_ai_command_palette_post_ga'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_editor_table_use_shared_state_hook: {
            productKeys: {
                confluence: 'platform_editor_table_use_shared_state_hook'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_multi_prompts': {
            productKeys: {
                confluence: 'editor_ai_-_multi_prompts'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_additional_editor_prompts: {
            productKeys: {
                confluence: 'platform_editor_ai_additional_editor_prompts'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        comment_on_bodied_extensions: {
            productKeys: {
                confluence: 'platform_editor_comment_on_bodied_extensions'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'optimised-apply-dnd': {
            productKeys: {
                confluence: 'platform_editor_element_dnd_apply_optimisation'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_1p_placeholder_hints: {
            productKeys: {
                confluence: 'platform_editor_ai_1p_placeholder_hints'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'example-placeholders',
                'tip-placeholders'
            ]),
            defaultValue: 'control'
        },
        advanced_layouts: {
            productKeys: {
                confluence: 'platform_editor_advanced_layouts'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_live_pages_ai_definitions: {
            productKeys: {
                confluence: 'platform_editor_live_pages_ai_definitions'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        support_table_in_comment_jira: {
            productKeys: {
                jira: 'platform_editor_support_table_in_comment_jira'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        comment_on_inline_node_spotlight: {
            productKeys: {
                confluence: 'platform_editor_comment_on_inline_node_spotlight'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_proactive_ai_model_variations': {
            productKeys: {
                confluence: 'editor_ai_-_proactive_ai_model_variations'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'skip_grammar'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_refine_response_button: {
            productKeys: {
                confluence: 'platform_editor_ai_refine_response_button'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_proactive_ai_spelling_and_grammar': {
            productKeys: {
                confluence: 'editor_ai_-_proactive_ai_spelling_and_grammar'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'default-off',
                'default-on'
            ]),
            defaultValue: 'control'
        },
        'platform_editor_ai-prompts-placeholder': {
            productKeys: {
                confluence: 'platform_editor_ai-prompts-placeholder'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        'editor_ai_-_gpt4_experiment': {
            productKeys: {
                confluence: 'editor_ai_-_gpt4_experiment'
            },
            param: 'cohort',
            typeGuard: (0, $5bUQm.oneOf)([
                'control',
                'einstein'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_facepile: {
            productKeys: {
                confluence: 'platform_editor_ai_facepile'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        'nested-tables-in-tables': {
            productKeys: {
                confluence: 'platform_editor_nested_tables'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_change_tone_floating_toolbar: {
            productKeys: {
                confluence: 'platform_editor_ai_change_tone_floating_toolbar'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_response_history: {
            productKeys: {
                confluence: 'platform_editor_ai_response_history'
            },
            param: 'isEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        },
        issue_view_action_items: {
            productKeys: {
                jira: 'issue_view_action_items'
            },
            param: 'isActionItemsEnabled',
            typeGuard: (0, $5bUQm.isBoolean),
            defaultValue: false
        }
    };
});
parcelRegister("5bUQm", function(module, exports) {
    $parcel$export(module.exports, "isBoolean", ()=>$4a4b6621adb3d86e$export$f9ce7b637dfbe238);
    $parcel$export(module.exports, "oneOf", ()=>$4a4b6621adb3d86e$export$a9a18ae5ba42aeab);
    function $4a4b6621adb3d86e$export$f9ce7b637dfbe238(value) {
        return typeof value === 'boolean';
    }
    function $4a4b6621adb3d86e$export$a9a18ae5ba42aeab(values) {
        function typeGuard(value) {
            return values.includes(value);
        }
        if ($4a4b6621adb3d86e$var$IS_TESTING_ENV) typeGuard.values = values;
        return typeGuard;
    }
    const $4a4b6621adb3d86e$var$IS_TESTING_ENV = false;
});
parcelRegister("krH0B", function(module, exports) {
    $parcel$export(module.exports, "_overrides", ()=>$4f4081684a0795fc$export$e5d73bf4f8e2ae96);
    $parcel$export(module.exports, "_product", ()=>$4f4081684a0795fc$export$cf7305fc65acbf0d);
    $parcel$export(module.exports, "setupEditorExperiments", ()=>$4f4081684a0795fc$export$1c2b6dbf79eb3560);
    var $34PHa = parcelRequire("34PHa");
    let $4f4081684a0795fc$export$e5d73bf4f8e2ae96 = {};
    let $4f4081684a0795fc$export$cf7305fc65acbf0d;
    function $4f4081684a0795fc$export$1c2b6dbf79eb3560(product, overrides) {
        if (overrides) {
            overrides = Object.entries(overrides).reduce((acc, [key, value])=>{
                const config = (0, $34PHa.editorExperimentsConfig)[key];
                if (config) acc = {
                    ...acc,
                    [key]: config.typeGuard(value) ? value : config.defaultValue
                };
                return acc;
            }, {});
            $4f4081684a0795fc$export$e5d73bf4f8e2ae96 = overrides;
        }
        $4f4081684a0795fc$export$cf7305fc65acbf0d = product;
    }
});
parcelRegister("6MTWT", function(module, exports) {
    $parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", ()=>$c532ba172cddf43f$export$b5ccf4d25d2c5af1);
    $parcel$export(module.exports, "BaseTheme", ()=>$c532ba172cddf43f$export$a1a213d350ca51ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0wej;
    var $70yok;
    var $caFD8;
    function $c532ba172cddf43f$export$b5ccf4d25d2c5af1(breakpoint) {
        switch(breakpoint){
            case 'M':
            case 'L':
                return 760;
            default:
                return 680;
        }
    }
    function $c532ba172cddf43f$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
        const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
                baseFontSize: baseFontSize || 14,
                layoutMaxWidth: (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth)
            }), [
            baseFontSize
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0wej")).a), {
            theme: memoizedTheme
        }, children);
    }
    function $c532ba172cddf43f$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caFD8")).WidthConsumer), null, ({ breakpoint: breakpoint })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c532ba172cddf43f$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)));
    }
});
parcelRegister("70yok", function(module, exports) {
    $parcel$export(module.exports, "akEditorFullPageDefaultFontSize", ()=>$1694baef1b316db3$export$fe6b0b821a0e9067);
    $parcel$export(module.exports, "akEditorCodeFontFamily", ()=>$1694baef1b316db3$export$9a7c520c39e1f0aa);
    $parcel$export(module.exports, "akEditorSubtleAccent", ()=>$1694baef1b316db3$export$1d762aef048d30f9);
    $parcel$export(module.exports, "akEditorBlockquoteBorderColor", ()=>$1694baef1b316db3$export$a7a75e50ae62d0a8);
    $parcel$export(module.exports, "akEditorDeleteBackground", ()=>$1694baef1b316db3$export$ef95eb6ef0fd0a4a);
    $parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", ()=>$1694baef1b316db3$export$8f7d2d784079e274);
    $parcel$export(module.exports, "akEditorDeleteBorder", ()=>$1694baef1b316db3$export$3c108a6bc41bb5f2);
    $parcel$export(module.exports, "akEditorDeleteIconColor", ()=>$1694baef1b316db3$export$bf3aaa2106c119fd);
    $parcel$export(module.exports, "akEditorCustomIconSize", ()=>$1694baef1b316db3$export$d2715266dd4a1fd1);
    $parcel$export(module.exports, "akEditorSelectedBorderColor", ()=>$1694baef1b316db3$export$cf524c1b49838a49);
    $parcel$export(module.exports, "akEditorSelectedBorderSize", ()=>$1694baef1b316db3$export$8dac549e32469ac4);
    $parcel$export(module.exports, "akEditorSelectedBorder", ()=>$1694baef1b316db3$export$6e1e1996c4e8cc51);
    $parcel$export(module.exports, "akEditorSelectedBoxShadow", ()=>$1694baef1b316db3$export$b6a59ac3a19b6343);
    $parcel$export(module.exports, "akEditorSelectedBorderBoldSize", ()=>$1694baef1b316db3$export$befaaae517e3d864);
    $parcel$export(module.exports, "akEditorUnitZIndex", ()=>$1694baef1b316db3$export$f35cc48f3398ab79);
    $parcel$export(module.exports, "akEditorShadowZIndex", ()=>$1694baef1b316db3$export$b46cda584c619451);
    $parcel$export(module.exports, "akEditorStickyHeaderZIndex", ()=>$1694baef1b316db3$export$6bed85de54b5de42);
    $parcel$export(module.exports, "akEditorSmallZIndex", ()=>$1694baef1b316db3$export$321ddd2f049dd12);
    $parcel$export(module.exports, "akEditorGridLineZIndex", ()=>$1694baef1b316db3$export$daeac9b8422ac3c2);
    $parcel$export(module.exports, "akEditorMenuZIndex", ()=>$1694baef1b316db3$export$501d46e11ed5bf73);
    $parcel$export(module.exports, "akEditorFloatingPanelZIndex", ()=>$1694baef1b316db3$export$6817b4b6a5ef78f1);
    $parcel$export(module.exports, "akEditorFloatingDialogZIndex", ()=>$1694baef1b316db3$export$93768eb72dec48ce);
    $parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", ()=>$1694baef1b316db3$export$c0aec4e0896849a0);
    $parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", ()=>$1694baef1b316db3$export$5886f057e4f21fe4);
    $parcel$export(module.exports, "akEditorTableToolbarSize", ()=>$1694baef1b316db3$export$6e85faa46d537a3f);
    $parcel$export(module.exports, "akEditorTableBorder", ()=>$1694baef1b316db3$export$36ba77fba4a62d5f);
    $parcel$export(module.exports, "akEditorTableToolbar", ()=>$1694baef1b316db3$export$640eef769748f78f);
    $parcel$export(module.exports, "akEditorTableHeaderCellBackground", ()=>$1694baef1b316db3$export$4c6f61fb4b9ae93);
    $parcel$export(module.exports, "akEditorTableBorderSelected", ()=>$1694baef1b316db3$export$f7bbcec54ff5bc47);
    $parcel$export(module.exports, "akEditorFullPageMaxWidth", ()=>$1694baef1b316db3$export$fad19f16d3f953a3);
    $parcel$export(module.exports, "akEditorDefaultLayoutWidth", ()=>$1694baef1b316db3$export$9db045950eedb49f);
    $parcel$export(module.exports, "akEditorWideLayoutWidth", ()=>$1694baef1b316db3$export$74c442132af16a);
    $parcel$export(module.exports, "akEditorFullWidthLayoutWidth", ()=>$1694baef1b316db3$export$f580e3d28d0986de);
    $parcel$export(module.exports, "akEditorTableNumberColumnWidth", ()=>$1694baef1b316db3$export$37df10057d36a0e5);
    $parcel$export(module.exports, "akEditorBreakoutPadding", ()=>$1694baef1b316db3$export$437293c5e9fc2703);
    $parcel$export(module.exports, "akEditorGutterPadding", ()=>$1694baef1b316db3$export$6e0f4d52efd3d2d);
    $parcel$export(module.exports, "akEditorGutterPaddingDynamic", ()=>$1694baef1b316db3$export$f222e0c7a2dc5324);
    $parcel$export(module.exports, "akEditorMobileBreakoutPoint", ()=>$1694baef1b316db3$export$efe8561bbd3f74d2);
    $parcel$export(module.exports, "akEditorTableCellMinWidth", ()=>$1694baef1b316db3$export$e4d39a9e8607c1d3);
    $parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", ()=>$1694baef1b316db3$export$43946f2400ab6f1f);
    $parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", ()=>$1694baef1b316db3$export$558438ae7fd4b8ce);
    $parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", ()=>$1694baef1b316db3$export$6beb98d32d4ca149);
    $parcel$export(module.exports, "akEditorSwoopCubicBezier", ()=>$1694baef1b316db3$export$3b24948cd5dbb087);
    $parcel$export(module.exports, "gridMediumMaxWidth", ()=>$1694baef1b316db3$export$5edb4f38c3eacb1a);
    $parcel$export(module.exports, "breakoutWideScaleRatio", ()=>$1694baef1b316db3$export$e60820063058ed59);
    $parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", ()=>$1694baef1b316db3$export$60da500206e2ceec);
    $parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", ()=>$1694baef1b316db3$export$c0e6648ae1bb2fac);
    $parcel$export(module.exports, "akRichMediaResizeZIndex", ()=>$1694baef1b316db3$export$fb15fade89f67217);
    $parcel$export(module.exports, "akLayoutGutterOffset", ()=>$1694baef1b316db3$export$847030921e9d5a40);
    $parcel$export(module.exports, "akEditorLineHeight", ()=>$1694baef1b316db3$export$40eb41ab799f0329);
    $parcel$export(module.exports, "akEditorToolbarKeylineHeight", ()=>$1694baef1b316db3$export$d29cb2c31fcbb7c5);
    $parcel$export(module.exports, "akEditorContextPanelWidth", ()=>$1694baef1b316db3$export$688a6dc01e760755);
    $parcel$export(module.exports, "akEditorTableCellBlanketSelected", ()=>$1694baef1b316db3$export$e736f2caf3b39eb3);
    $parcel$export(module.exports, "akEditorTableCellBlanketDeleted", ()=>$1694baef1b316db3$export$de3cef07cda55645);
    $parcel$export(module.exports, "akEditorWrappedNodeZIndex", ()=>$1694baef1b316db3$export$e88f6c898960b391);
    $parcel$export(module.exports, "layoutBreakpointWidth", ()=>$1694baef1b316db3$export$e5c605f2b2a12b00);
    $parcel$export(module.exports, "blockNodesVerticalMargin", ()=>$1694baef1b316db3$export$1d0d506416d457f1);
    $parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", ()=>$1694baef1b316db3$export$e683ef42725d1713);
    $parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", ()=>$1694baef1b316db3$export$226c784ba04bd04b);
    $parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", ()=>$1694baef1b316db3$export$214ff00e5618d86c);
    $parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", ()=>$1694baef1b316db3$export$d7726a000ae2d7c);
    $parcel$export(module.exports, "akEditorSelectedNodeClassName", ()=>$1694baef1b316db3$export$a02a3f1515c2e21a);
    $parcel$export(module.exports, "editorFontSize", ()=>$1694baef1b316db3$export$58a725ff69bda73a);
    $parcel$export(module.exports, "relativeFontSizeToBase16", ()=>$1694baef1b316db3$export$59733a9f61449b25);
    $parcel$export(module.exports, "akEditorMobileMaxWidth", ()=>$1694baef1b316db3$export$9369fd010fa0ddd6);
    $parcel$export(module.exports, "avatarColors", ()=>$1694baef1b316db3$export$312e1e71424c4aa1);
    var $2oS3b;
    const $1694baef1b316db3$export$fe6b0b821a0e9067 = 16;
    const $1694baef1b316db3$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $1694baef1b316db3$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
    const $1694baef1b316db3$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
    const $1694baef1b316db3$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    const $1694baef1b316db3$export$f0e953d95429ca1 = '12px';
    const $1694baef1b316db3$export$a309dbdeca0adb1a = '2px 4px';
    const $1694baef1b316db3$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
    const $1694baef1b316db3$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)';
    const $1694baef1b316db3$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
    const $1694baef1b316db3$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
    const $1694baef1b316db3$export$d2715266dd4a1fd1 = 20;
    const $1694baef1b316db3$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
    const $1694baef1b316db3$export$8dac549e32469ac4 = 1;
    const $1694baef1b316db3$export$6e1e1996c4e8cc51 = `${$1694baef1b316db3$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
    const $1694baef1b316db3$export$b6a59ac3a19b6343 = `0 0 0 ${$1694baef1b316db3$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
    const $1694baef1b316db3$export$befaaae517e3d864 = 2;
    const $1694baef1b316db3$export$4a007c22e25e31f6 = 0.3;
    const $1694baef1b316db3$export$f35cc48f3398ab79 = 1;
    const $1694baef1b316db3$export$b46cda584c619451 = 2;
    const $1694baef1b316db3$export$6bed85de54b5de42 = 11;
    const $1694baef1b316db3$export$321ddd2f049dd12 = $1694baef1b316db3$export$6bed85de54b5de42 + 1;
    const $1694baef1b316db3$export$daeac9b8422ac3c2 = 2;
    const $1694baef1b316db3$export$501d46e11ed5bf73 = 500;
    const $1694baef1b316db3$export$6817b4b6a5ef78f1 = 400;
    const $1694baef1b316db3$export$93768eb72dec48ce = $1694baef1b316db3$export$501d46e11ed5bf73 + 10;
    const $1694baef1b316db3$export$c0aec4e0896849a0 = $1694baef1b316db3$export$93768eb72dec48ce - 5;
    const $1694baef1b316db3$export$5886f057e4f21fe4 = $1694baef1b316db3$export$6817b4b6a5ef78f1 + 5;
    const $1694baef1b316db3$export$6e85faa46d537a3f = 11;
    const $1694baef1b316db3$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
    const $1694baef1b316db3$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    const $1694baef1b316db3$export$4c6f61fb4b9ae93 = '#F1F2F4';
    const $1694baef1b316db3$export$95e9a0285b97474d = '#2C333A';
    const $1694baef1b316db3$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
    const $1694baef1b316db3$export$76b5e653883e5290 = '3px';
    const $1694baef1b316db3$export$6d85fe8177a50c0c = 0.5;
    const $1694baef1b316db3$export$fad19f16d3f953a3 = 680;
    const $1694baef1b316db3$export$9db045950eedb49f = 760;
    const $1694baef1b316db3$export$74c442132af16a = 960;
    const $1694baef1b316db3$export$f580e3d28d0986de = 1800;
    const $1694baef1b316db3$export$9d5488b5afad62bf = 1792;
    const $1694baef1b316db3$export$37df10057d36a0e5 = 42;
    const $1694baef1b316db3$export$437293c5e9fc2703 = 96;
    const $1694baef1b316db3$export$6e0f4d52efd3d2d = 32;
    const $1694baef1b316db3$export$f222e0c7a2dc5324 = ()=>(0, (0, parcelRequire("2oS3b")).fg)('platform_editor_core_increase_full_page_guttering') ? 52 : 32;
    const $1694baef1b316db3$export$efe8561bbd3f74d2 = 720;
    const $1694baef1b316db3$export$e4d39a9e8607c1d3 = 48;
    const $1694baef1b316db3$export$43946f2400ab6f1f = 128;
    const $1694baef1b316db3$export$558438ae7fd4b8ce = 12;
    const $1694baef1b316db3$export$6beb98d32d4ca149 = 4;
    const $1694baef1b316db3$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
    const $1694baef1b316db3$export$5edb4f38c3eacb1a = 1024;
    const $1694baef1b316db3$export$e60820063058ed59 = 1.33;
    const $1694baef1b316db3$export$60da500206e2ceec = 905;
    const $1694baef1b316db3$export$c0e6648ae1bb2fac = 1011;
    const $1694baef1b316db3$export$fb15fade89f67217 = $1694baef1b316db3$export$f35cc48f3398ab79 * 99;
    const $1694baef1b316db3$export$847030921e9d5a40 = 12;
    const $1694baef1b316db3$export$40eb41ab799f0329 = 1.714;
    const $1694baef1b316db3$export$e271312fc7124aec = '1px';
    const $1694baef1b316db3$export$d29cb2c31fcbb7c5 = 2;
    const $1694baef1b316db3$export$688a6dc01e760755 = 320;
    const $1694baef1b316db3$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
    const $1694baef1b316db3$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
    const $1694baef1b316db3$export$e88f6c898960b391 = $1694baef1b316db3$export$f35cc48f3398ab79 * 2;
    const $1694baef1b316db3$export$e5c605f2b2a12b00 = {
        SMALL: 550,
        MEDIUM: 760
    };
    const $1694baef1b316db3$export$1d0d506416d457f1 = '0.75rem';
    const $1694baef1b316db3$export$e683ef42725d1713 = 680;
    const $1694baef1b316db3$export$226c784ba04bd04b = 480;
    const $1694baef1b316db3$export$214ff00e5618d86c = 20;
    const $1694baef1b316db3$export$c82675fa56f2eefd = '56px';
    const $1694baef1b316db3$var$DEFAULT_FONT_SIZE = 14;
    const $1694baef1b316db3$export$d7726a000ae2d7c = ()=>"var(--ds-space-500, 40px)";
    const $1694baef1b316db3$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
    const $1694baef1b316db3$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $1694baef1b316db3$var$DEFAULT_FONT_SIZE;
    const $1694baef1b316db3$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$1694baef1b316db3$export$58a725ff69bda73a({
                theme: theme
            }) * multiplier;
    const $1694baef1b316db3$export$59733a9f61449b25 = (px)=>{
        if (typeof px === 'string') px = parseInt(px);
        if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
        return `${px / 16}rem`;
    };
    const $1694baef1b316db3$export$96b72b7f243fa693 = {
        laptopHiDPI: {
            width: 1440,
            height: 900
        },
        laptopMDPI: {
            width: 1280,
            height: 800
        },
        tabletL: {
            width: 1024,
            height: 1366
        },
        tabletS: {
            width: 768,
            height: 1024
        },
        mobileM: {
            width: 414,
            height: 736
        },
        mobileS: {
            width: 375,
            height: 667
        },
        mobileXS: {
            width: 320,
            height: 568
        }
    };
    const $1694baef1b316db3$export$9369fd010fa0ddd6 = 0;
    const $1694baef1b316db3$export$846a716e9e69a8df = [
        [
            'White',
            '#000000'
        ],
        [
            'Light blue',
            '#0C294F'
        ],
        [
            'Light teal',
            '#0C343B'
        ],
        [
            'Light green',
            '#052E21'
        ],
        [
            'Light yellow',
            '#484123'
        ],
        [
            'Light red',
            '#441C13'
        ],
        [
            'Light purple',
            '#282249'
        ],
        [
            'Light gray',
            '#202328'
        ],
        [
            'Blue',
            '#0B3165'
        ],
        [
            'Teal',
            '#044853'
        ],
        [
            'Green',
            '#053927'
        ],
        [
            'Yellow',
            '#6F5C25'
        ],
        [
            'Red',
            '#582013'
        ],
        [
            'Purple',
            '#3E327B'
        ],
        [
            'Gray',
            '#475262'
        ],
        [
            'Dark blue',
            '#003884'
        ],
        [
            'Dark teal',
            '#055866'
        ],
        [
            'Dark green',
            '#044932'
        ],
        [
            'Dark yellow',
            '#82641C'
        ],
        [
            'Dark red',
            '#6B2A19'
        ],
        [
            'Dark purple',
            '#4D38B2'
        ]
    ].map(([colorName, colorValue])=>$1694baef1b316db3$export$5f2dade43b841301(colorName, colorValue)).join('\n');
    function $1694baef1b316db3$export$5f2dade43b841301(colorName, colorValue) {
        return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
    }
    const $1694baef1b316db3$export$312e1e71424c4aa1 = [
        "var(--ds-icon-accent-red, #C9372C)",
        "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
        "var(--ds-icon-accent-magenta, #CD519D)",
        "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
        "var(--ds-icon-accent-orange, #E56910)",
        "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
        "var(--ds-icon-accent-green, #22A06B)",
        "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
        "var(--ds-icon-accent-blue, #1D7AFC)",
        "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
        "var(--ds-icon-accent-teal, #2898BD)",
        "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
        "var(--ds-icon-accent-lime, #6A9A23)",
        "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
        "var(--ds-icon-accent-purple, #8270DB)",
        "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
        "var(--ds-icon-accent-gray, #758195)",
        "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        "var(--ds-icon-accent-yellow, #B38600)",
        "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
        "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
    ];
    const $1694baef1b316db3$export$42608c013398a830 = [
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
        }
    ];
});
parcelRegister("caFD8", function(module, exports) {
    $parcel$export(module.exports, "getBreakpoint", ()=>$444eb12a729163d8$export$1eb095b00b926404);
    $parcel$export(module.exports, "createWidthContext", ()=>$444eb12a729163d8$export$31a4966bffb9ac98);
    $parcel$export(module.exports, "WidthContext", ()=>$444eb12a729163d8$export$27e39f636459b9f);
    $parcel$export(module.exports, "WidthConsumer", ()=>$444eb12a729163d8$export$5d8538aa831b6ebb);
    $parcel$export(module.exports, "WidthProvider", ()=>$444eb12a729163d8$export$7921e18173e8c666);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8QpSo;
    var $7nRxN;
    var $bR08v;
    var $lbKJX;
    function $444eb12a729163d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $444eb12a729163d8$var$styles = {
        name: "pw7jst",
        styles: "position:relative;width:100%"
    };
    const $444eb12a729163d8$var$SCROLLBAR_WIDTH = 30;
    function $444eb12a729163d8$export$1eb095b00b926404(width = 0) {
        const MAX_S = 1266;
        const MAX_M = 2146;
        if (width >= MAX_S && width < MAX_M) return 'M';
        else if (width >= MAX_M) return 'L';
        return 'S';
    }
    function $444eb12a729163d8$export$31a4966bffb9ac98(width = 0) {
        return {
            width: width,
            breakpoint: $444eb12a729163d8$export$1eb095b00b926404(width)
        };
    }
    const $444eb12a729163d8$export$27e39f636459b9f = (0, ($parcel$interopDefault($5uXOq))).createContext($444eb12a729163d8$export$31a4966bffb9ac98());
    const { Provider: $444eb12a729163d8$var$Provider, Consumer: $444eb12a729163d8$export$5d8538aa831b6ebb } = $444eb12a729163d8$export$27e39f636459b9f;
    const $444eb12a729163d8$export$df154c49e93b2ac2 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return (0, (0, parcelRequire("lbKJX")).isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
    });
    const $444eb12a729163d8$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
        const existingContextValue = (0, $5uXOq.useContext)($444eb12a729163d8$export$27e39f636459b9f);
        const [width, setWidth] = (0, $5uXOq.useState)($444eb12a729163d8$export$df154c49e93b2ac2);
        const widthRef = (0, $5uXOq.useRef)(width);
        const isMountedRef = (0, $5uXOq.useRef)(true);
        const providerValue = (0, $5uXOq.useMemo)(()=>$444eb12a729163d8$export$31a4966bffb9ac98(width), [
            width
        ]);
        const updateWidth = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("7nRxN")).default)((nextWidth)=>{
                const currentWidth = widthRef.current || 0;
                if (Math.abs(currentWidth - nextWidth) < $444eb12a729163d8$var$SCROLLBAR_WIDTH) return;
                if (!isMountedRef.current) return;
                setWidth(nextWidth);
            });
        }, []);
        const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
        (0, ($parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
            isMountedRef.current = true;
            return ()=>{
                isMountedRef.current = false;
            };
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $444eb12a729163d8$var$styles,
            className: className
        }, !skipWidthDetection && (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bR08v")).WidthObserver), {
            setWidth: updateWidth,
            offscreen: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($444eb12a729163d8$var$Provider, {
            value: providerValue
        }, children)), skipWidthDetection && children);
    };
});
parcelRegister("lbKJX", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$1fe425fd6e3302d0$export$48d7c418edadb60c);
    var $6cAn5 = parcelRequire("6cAn5");
    function $1fe425fd6e3302d0$export$48d7c418edadb60c() {
        try {
            return Boolean(typeof document === 'undefined' || typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("kaGUJ", function(module, exports) {
    $parcel$export(module.exports, "IntlErrorBoundary", ()=>$d39dbed39c793ed9$export$7df0749115d18d19);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $d39dbed39c793ed9$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
    const $d39dbed39c793ed9$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
    class $d39dbed39c793ed9$export$7df0749115d18d19 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch(error, errorInfo) {
            if ($d39dbed39c793ed9$var$isMissingIntlProviderInAncestryError(error)) this.setState({
                missingIntlProviderInAncestry: true
            });
            else throw error;
        }
        render() {
            if (this.state.missingIntlProviderInAncestry) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                locale: "en"
            }, this.props.children);
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                missingIntlProviderInAncestry: false
            };
        }
    }
});
parcelRegister("iITB0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5276a69342aceb3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $70yok;
    var $k5aAz;
    var $loZC0;
    var $6SKbt;
    var $kXMr5;
    var $484Vr;
    var $3GOhg;
    const $5276a69342aceb3c$var$blockNodeStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        background: "var(--ds-background-disabled, #091E4208)",
        border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        cursor: 'default',
        display: 'flex',
        fontSize: (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14),
        margin: `${"var(--ds-space-100, 8px)"} 0`,
        minHeight: '24px',
        padding: "var(--ds-space-150, 12px)",
        textAlign: 'center',
        verticalAlign: 'text-bottom',
        minWidth: '120px',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $5276a69342aceb3c$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const message = (0, (0, parcelRequire("3GOhg")).getUnsupportedContent)((0, (0, parcelRequire("kXMr5")).unsupportedContentMessages).unsupportedBlockContent, (0, (0, parcelRequire("kXMr5")).unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
        const tooltipContent = intl.formatMessage((0, (0, parcelRequire("kXMr5")).unsupportedContentMessages).unsupportedContentTooltip);
        const { current: style } = (0, $5uXOq.useRef)({
            padding: '4px'
        });
        const originalNodeType = node?.attrs.originalValue.type;
        const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, (0, parcelRequire("484Vr")).trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
            dispatchAnalyticsEvent,
            originalNodeType
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $5276a69342aceb3c$var$blockNodeStyle,
            className: "unsupported"
        }, message, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("loZC0")).default), {
            content: tooltipContent,
            hideTooltipOnClick: false,
            position: "bottom",
            onShow: tooltipOnShowHandler,
            strategy: "absolute"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: style
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("k5aAz"))))), {
            label: "?",
            size: "small"
        })))));
    };
    var $5276a69342aceb3c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5276a69342aceb3c$var$UnsupportedBlockNode);
});
parcelRegister("6SKbt", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$d8fa7d64be421dcc$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "ACTION", ()=>$d8fa7d64be421dcc$export$9523889e0a5da4ba);
    $parcel$export(module.exports, "INPUT_METHOD", ()=>$d8fa7d64be421dcc$export$85f107b1fcc9d96f);
    $parcel$export(module.exports, "INSERT_MEDIA_VIA", ()=>$d8fa7d64be421dcc$export$9b31fa32ae3f8051);
    $parcel$export(module.exports, "TRIGGER_METHOD", ()=>$d8fa7d64be421dcc$export$81a8b7dba1aa8f75);
    $parcel$export(module.exports, "ACTION_SUBJECT", ()=>$d8fa7d64be421dcc$export$7525482b5931e326);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$d8fa7d64be421dcc$export$9957974f8b4d8f74);
    $parcel$export(module.exports, "CONTENT_COMPONENT", ()=>$d8fa7d64be421dcc$export$9f0b2adf3cfd71b7);
    var $d8fa7d64be421dcc$export$76a2e4c433c23bb9;
    (function(EVENT_TYPE) {
        EVENT_TYPE["OPERATIONAL"] = "operational";
        EVENT_TYPE["SCREEN"] = "screen";
        EVENT_TYPE["TRACK"] = "track";
        EVENT_TYPE["UI"] = "ui";
    })($d8fa7d64be421dcc$export$76a2e4c433c23bb9 || ($d8fa7d64be421dcc$export$76a2e4c433c23bb9 = {}));
    var $d8fa7d64be421dcc$export$9523889e0a5da4ba;
    (function(ACTION) {
        ACTION["ACTIVATED"] = "activated";
        ACTION["ADDED"] = "added";
        ACTION["BROWSER_FREEZE"] = "browserFreeze";
        ACTION["CANCELLED"] = "cancelled";
        ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
        ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
        ACTION["CHANGED_ICON"] = "changedIcon";
        ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
        ACTION["CHANGED_LAYOUT"] = "changedLayout";
        ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
        ACTION["CHANGED_TYPE"] = "changedType";
        ACTION["CHANGED_URL"] = "changedUrl";
        ACTION["CLEARED"] = "cleared";
        ACTION["CLICKED"] = "clicked";
        ACTION["CLOSED"] = "closed";
        ACTION["COMMITTED"] = "committed";
        ACTION["CONNECTED_NODES"] = "connectedNodes";
        ACTION["CONVERTED"] = "converted";
        ACTION["COPIED"] = "copied";
        ACTION["CUT"] = "cut";
        ACTION["DEACTIVATED"] = "deactivated";
        ACTION["DECREMENTED"] = "decremented";
        ACTION["DELETED"] = "deleted";
        ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
        ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
        ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
        ACTION["DISMISSED"] = "dismissed";
        ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
        ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
        ACTION["DOUBLE_CLICKED"] = "doubleClicked";
        ACTION["DRAGGED"] = "dragged";
        ACTION["EDITED"] = "edited";
        ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
        ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
        ACTION["EDITOR_MOUNTED"] = "mounted";
        ACTION["EDITOR_TTI"] = "tti";
        ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
        ACTION["RE_RENDERED"] = "reRendered";
        ACTION["ENTERED"] = "entered";
        ACTION["ERRORED"] = "errored";
        ACTION["EXPOSED"] = "exposed";
        ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
        ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
        ACTION["FIND_PERFORMED"] = "findPerformed";
        ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
        ACTION["FORMATTED"] = "formatted";
        ACTION["HELP_OPENED"] = "helpOpened";
        ACTION["HIGHLIGHTED"] = "highlighted";
        ACTION["INCREMENTED"] = "incremented";
        ACTION["INDENTED"] = "indented";
        ACTION["INITIALISED"] = "initialised";
        ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
        ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
        ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
        ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
        ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
        ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
        ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
        ACTION["INSERTED"] = "inserted";
        ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
        ACTION["INVOKED"] = "invoked";
        ACTION["GOT_CONNECTIONS"] = "gotConnections";
        ACTION["LANGUAGE_SELECTED"] = "languageSelected";
        ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
        ACTION["MATCHED"] = "matched";
        ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
        ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
        ACTION["OPENED"] = "opened";
        ACTION["OUTDENTED"] = "outdented";
        ACTION["PASTED"] = "pasted";
        ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
        ACTION["PASTED_TIMED"] = "pastedTimed";
        ACTION["PRESSED"] = "pressed";
        ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
        ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
        ACTION["REPLACED_ALL"] = "replacedAll";
        ACTION["REPLACED_ONE"] = "replacedOne";
        ACTION["RESOLVED"] = "resolved";
        ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
        ACTION["SELECTED"] = "selected";
        ACTION["SHOWN"] = "shown";
        ACTION["SLOW_INPUT"] = "slowInput";
        ACTION["STARTED"] = "started";
        ACTION["STOPPED"] = "stopped";
        ACTION["SUBSTITUTED"] = "autoSubstituted";
        ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
        ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
        ACTION["SYNCHRONY_ERROR"] = "synchronyError";
        ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
        ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
        ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
        ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
        ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
        ACTION["TOGGLE_EXPAND"] = "toggleExpand";
        ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
        ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
        ACTION["TYPING_FINISHED"] = "typingFinished";
        ACTION["TYPING_STARTED"] = "typingStarted";
        ACTION["UNLINK"] = "unlinked";
        ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
        ACTION["UPDATED"] = "updated";
        ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
        ACTION["UPDATED_SOURCE"] = "updatedSource";
        ACTION["UPDATED_TARGET"] = "updatedTarget";
        ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
        ACTION["VIEWED"] = "viewed";
        ACTION["VISITED"] = "visited";
        ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
        ACTION["RENDERED"] = "rendered";
        ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
        ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
        ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
        ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
        ACTION["REMOVE_ICON"] = "removedIcon";
        ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
        ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
        ACTION["RENDERER_TTI"] = "tti";
        ACTION["CRASHED"] = "unhandledErrorCaughtV2";
        ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
        ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
        ACTION["SORT_COLUMN"] = "sortedColumn";
        ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
        ACTION["STEPS_TRACKED"] = "stepsTracked";
        ACTION["STEPS_FILTERED"] = "stepsFiltered";
        ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
        ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
        ACTION["RECORD_VIDEO"] = "recordVideo";
        ACTION["INSERT_VIDEO"] = "insertVideo";
        ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
        ACTION["ADD_CHILD"] = "addChild";
        ACTION["CHANGE_ACTIVE"] = "changeActive";
        ACTION["REMOVE_CHILD"] = "removeChild";
        ACTION["UPDATE_PARAMETERS"] = "updateParameters";
        ACTION["GET_CHILDERN"] = "getChildern";
        ACTION["MOVED"] = "moved";
        ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
        ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
        ACTION["UPLOAD_FAILED"] = "uploadFailed";
        ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    })($d8fa7d64be421dcc$export$9523889e0a5da4ba || ($d8fa7d64be421dcc$export$9523889e0a5da4ba = {}));
    var $d8fa7d64be421dcc$export$85f107b1fcc9d96f;
    (function(INPUT_METHOD) {
        INPUT_METHOD["ASCII"] = "ascii";
        INPUT_METHOD["AUTO"] = "auto";
        INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
        INPUT_METHOD["BUTTON"] = "button";
        INPUT_METHOD["BLUR"] = "blur";
        INPUT_METHOD["CARD"] = "card";
        INPUT_METHOD["CLIPBOARD"] = "clipboard";
        INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
        INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
        INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
        INPUT_METHOD["DRAG"] = "drag";
        INPUT_METHOD["EXTERNAL"] = "external";
        INPUT_METHOD["EXTENSION_API"] = "extensionApi";
        INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
        INPUT_METHOD["FORMATTING"] = "autoformatting";
        INPUT_METHOD["INSERT_MENU"] = "insertMenu";
        INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
        INPUT_METHOD["KEYBOARD"] = "keyboard";
        INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
        INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
        INPUT_METHOD["MANUAL"] = "manual";
        INPUT_METHOD["PICKER"] = "picker";
        INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
        INPUT_METHOD["PREFILL"] = "prefill";
        INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
        INPUT_METHOD["SHORTCUT"] = "shortcut";
        INPUT_METHOD["TOOLBAR"] = "toolbar";
        INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
        INPUT_METHOD["DATASOURCE"] = "datasource_config";
        INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
        INPUT_METHOD["MOUSE"] = "mouse";
        INPUT_METHOD["BROWSER"] = "browser";
        INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    })($d8fa7d64be421dcc$export$85f107b1fcc9d96f || ($d8fa7d64be421dcc$export$85f107b1fcc9d96f = {}));
    var $d8fa7d64be421dcc$export$9b31fa32ae3f8051;
    (function(INSERT_MEDIA_VIA) {
        INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
        INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
        INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    })($d8fa7d64be421dcc$export$9b31fa32ae3f8051 || ($d8fa7d64be421dcc$export$9b31fa32ae3f8051 = {}));
    var $d8fa7d64be421dcc$export$81a8b7dba1aa8f75;
    (function(TRIGGER_METHOD) {
        TRIGGER_METHOD["BUTTON"] = "button";
        TRIGGER_METHOD["KEYBOARD"] = "keyboard";
        TRIGGER_METHOD["SHORTCUT"] = "shortcut";
        TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    })($d8fa7d64be421dcc$export$81a8b7dba1aa8f75 || ($d8fa7d64be421dcc$export$81a8b7dba1aa8f75 = {}));
    var $d8fa7d64be421dcc$export$7525482b5931e326;
    (function(ACTION_SUBJECT) {
        ACTION_SUBJECT["COLLAB"] = "collab";
        ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
        ACTION_SUBJECT["BUTTON"] = "button";
        ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
        ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
        ACTION_SUBJECT["DATE"] = "date";
        ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
        ACTION_SUBJECT["DOCUMENT"] = "document";
        ACTION_SUBJECT["EDITOR"] = "editor";
        ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
        ACTION_SUBJECT["EMBEDS"] = "embeds";
        ACTION_SUBJECT["EXPAND"] = "expand";
        ACTION_SUBJECT["EXTENSION"] = "extension";
        ACTION_SUBJECT["FEATURE"] = "feature";
        ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
        ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
        ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
        ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
        ACTION_SUBJECT["HELP"] = "help";
        ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
        ACTION_SUBJECT["LAYOUT"] = "layout";
        ACTION_SUBJECT["LIST"] = "list";
        ACTION_SUBJECT["MEDIA"] = "media";
        ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT["MENTION"] = "mention";
        ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
        ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT["PANEL"] = "panel";
        ACTION_SUBJECT["PICKER"] = "picker";
        ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
        ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
        ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
        ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
        ACTION_SUBJECT["SELECTION"] = "selection";
        ACTION_SUBJECT["SMART_LINK"] = "smartLink";
        ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
        ACTION_SUBJECT["TABLE"] = "table";
        ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
        ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
        ACTION_SUBJECT["TEXT"] = "text";
        ACTION_SUBJECT["TOOLBAR"] = "toolbar";
        ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
        ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
        ACTION_SUBJECT["ANNOTATION"] = "annotation";
        ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
        ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
        ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
        ACTION_SUBJECT["RENDERER"] = "renderer";
        ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
        ACTION_SUBJECT["LINK"] = "link";
        ACTION_SUBJECT["TOOLTIP"] = "tooltip";
        ACTION_SUBJECT["LOOM"] = "loom";
        ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
        ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
        ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
        ACTION_SUBJECT["DRAG"] = "drag";
        ACTION_SUBJECT["ELEMENT"] = "element";
        ACTION_SUBJECT["CONTEXT_MENU"] = "contextMenu";
        ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
        ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
        ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
        ACTION_SUBJECT["DECORATION"] = "decoration";
    })($d8fa7d64be421dcc$export$7525482b5931e326 || ($d8fa7d64be421dcc$export$7525482b5931e326 = {}));
    var $d8fa7d64be421dcc$export$9957974f8b4d8f74;
    (function(ACTION_SUBJECT_ID) {
        ACTION_SUBJECT_ID["ACTION"] = "action";
        ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
        ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
        ACTION_SUBJECT_ID["ALL"] = "all";
        ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
        ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
        ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
        ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["BORDER"] = "border";
        ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
        ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
        ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
        ACTION_SUBJECT_ID["CANCEL"] = "cancel";
        ACTION_SUBJECT_ID["CAPTION"] = "caption";
        ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
        ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
        ACTION_SUBJECT_ID["CELL"] = "cell";
        ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
        ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
        ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
        ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
        ACTION_SUBJECT_ID["DATE"] = "date";
        ACTION_SUBJECT_ID["DATE_DAY"] = "day";
        ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
        ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
        ACTION_SUBJECT_ID["DECISION"] = "decision";
        ACTION_SUBJECT_ID["DIVIDER"] = "divider";
        ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
        ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
        ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
        ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
        ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
        ACTION_SUBJECT_ID["EMOJI"] = "emoji";
        ACTION_SUBJECT_ID["EXPAND"] = "expand";
        ACTION_SUBJECT_ID["EXTENSION"] = "extension";
        ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
        ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
        ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
        ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
        ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
        ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
        ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
        ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
        ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
        ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
        ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
        ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
        ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
        ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
        ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
        ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
        ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
        ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
        ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
        ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
        ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
        ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
        ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
        ACTION_SUBJECT_ID["LAYOUT"] = "layout";
        ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
        ACTION_SUBJECT_ID["LINK"] = "link";
        ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
        ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
        ACTION_SUBJECT_ID["MEDIA"] = "media";
        ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
        ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
        ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
        ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
        ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT_ID["MENTION"] = "mention";
        ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
        ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT_ID["NODE"] = "node";
        ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
        ACTION_SUBJECT_ID["PANEL"] = "panel";
        ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
        ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
        ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
        ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
        ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
        ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
        ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
        ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
        ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
        ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
        ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
        ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
        ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
        ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
        ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
        ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
        ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
        ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
        ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
        ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
        ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
        ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
        ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
        ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
        ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
        ACTION_SUBJECT_ID["PUNC"] = "punctuation";
        ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
        ACTION_SUBJECT_ID["RANGE"] = "range";
        ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
        ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
        ACTION_SUBJECT_ID["RESIZED"] = "resized";
        ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
        ACTION_SUBJECT_ID["SAVE"] = "save";
        ACTION_SUBJECT_ID["SECTION"] = "section";
        ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
        ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
        ACTION_SUBJECT_ID["STATUS"] = "status";
        ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
        ACTION_SUBJECT_ID["TABLE"] = "table";
        ACTION_SUBJECT_ID["TEXT"] = "text";
        ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
        ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
        ACTION_SUBJECT_ID["UNLINK"] = "unlink";
        ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
        ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
        ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
        ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
        ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
        ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
        ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
        ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
        ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
        ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    })($d8fa7d64be421dcc$export$9957974f8b4d8f74 || ($d8fa7d64be421dcc$export$9957974f8b4d8f74 = {}));
    var $d8fa7d64be421dcc$export$75ef928acd21e35b;
    (function(FLOATING_CONTROLS_TITLE) {
        FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
        FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
        FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
        FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
        FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
        FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
        FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    })($d8fa7d64be421dcc$export$75ef928acd21e35b || ($d8fa7d64be421dcc$export$75ef928acd21e35b = {}));
    var $d8fa7d64be421dcc$export$9f0b2adf3cfd71b7;
    (function(CONTENT_COMPONENT) {
        CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
        CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
        CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
        CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    })($d8fa7d64be421dcc$export$9f0b2adf3cfd71b7 || ($d8fa7d64be421dcc$export$9f0b2adf3cfd71b7 = {}));
});
parcelRegister("kXMr5", function(module, exports) {
    $parcel$export(module.exports, "unsupportedContentMessages", ()=>$fdbe3c0cc11d4837$export$32ec96484dd3ba39);
    var $7VHMR;
    const $fdbe3c0cc11d4837$export$32ec96484dd3ba39 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unsupportedInlineContent: {
            id: 'fabric.editor.unsupportedInlineContent',
            defaultMessage: 'Unsupported content',
            description: 'Unsupported content'
        },
        unsupportedBlockContent: {
            id: 'fabric.editor.unsupportedBlockContent',
            defaultMessage: 'This editor does not support displaying this content',
            description: 'This editor does not support displaying this content'
        },
        unsupportedContentTooltip: {
            id: 'fabric.editor.unsupportedContentTooltip',
            defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
            description: 'Content is not available in this editor, this will be preserved when you edit and save'
        }
    });
});
parcelRegister("484Vr", function(module, exports) {
    $parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", ()=>$9e99a33df40f710b$export$d343369b8f25914);
    $parcel$export(module.exports, "fireUnsupportedEvent", ()=>$9e99a33df40f710b$export$e1051b410945e4d4);
    $parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", ()=>$9e99a33df40f710b$export$3a34598135e7219b);
    var $6SKbt;
    const $9e99a33df40f710b$var$whitelistedAttributes = [
        'align',
        'annotationType',
        'extensionKey',
        'extensionType',
        'layout',
        'type',
        'localId',
        'mode',
        'language',
        'timestamp',
        'state',
        'originalWidth',
        'originalHeight',
        'height',
        'width',
        'shortName',
        'level',
        'userType',
        'order',
        'panelType',
        'color',
        'style',
        'isNumberColumnEnabled',
        'colspan',
        'rowspan',
        'colwidth',
        'background'
    ];
    function $9e99a33df40f710b$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
        const { name: name } = node.type;
        return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
    }
    const $9e99a33df40f710b$var$sanitizeMarks = (marks = [])=>{
        let sanitizedMarks = [];
        marks.forEach((mark)=>{
            if (mark.attrs) {
                const attrs = $9e99a33df40f710b$var$sanitizeAttributes(mark.attrs);
                sanitizedMarks.push({
                    ...mark,
                    attrs: attrs
                });
            } else sanitizedMarks.push({
                ...mark
            });
        });
        return sanitizedMarks;
    };
    const $9e99a33df40f710b$var$sanitizeAttributes = (attrs = {})=>{
        let sanitizedAttrs = Object.assign({}, attrs);
        Object.keys(attrs).filter((key)=>!$9e99a33df40f710b$var$whitelistedAttributes.includes(key)).forEach((key)=>{
            sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
        });
        return sanitizedAttrs;
    };
    const $9e99a33df40f710b$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
        dispatchAnalyticsEvent({
            action: action,
            actionSubjectId: unsupportedContentType,
            actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).TOOLTIP,
            eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).UI,
            attributes: {
                unsupportedNodeType: originalNodeType
            }
        });
    };
    const $9e99a33df40f710b$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
        const { type: nodeType, marks: nodeMarks } = node;
        const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
        const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
        const parentType = ancestorHierarchy.split(' ').pop() || '';
        if (nodeMarks.length) nodeMarks.forEach((mark)=>{
            if (mark.type === unsupportedMark) {
                const { originalValue: originalValue } = mark.attrs || {};
                const { type: type } = originalValue || {};
                const unsupportedNode = {
                    type: type || '',
                    ancestry: ancestorHierarchy,
                    parentType: parentType,
                    marks: [],
                    attrs: originalValue.attrs || {}
                };
                $9e99a33df40f710b$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
            } else if (mark.type === unsupportedNodeAttribute) {
                const { unsupported: unsupported } = mark.attrs || {};
                const unsupportedNodeAttribute = {
                    type: nodeType.name || '',
                    ancestry: ancestorHierarchy,
                    parentType: parentType,
                    marks: [],
                    attrs: unsupported || {}
                };
                $9e99a33df40f710b$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
            }
        });
        if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
            const { originalValue: originalValue } = node.attrs || {};
            const { marks: marks } = originalValue || [];
            const { attrs: attrs } = originalValue || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: marks || [],
                attrs: attrs || {}
            };
            const actionSubjectId = nodeType === unsupportedInline ? (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
            $9e99a33df40f710b$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
        } else node.content.forEach((childNode)=>$9e99a33df40f710b$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $9e99a33df40f710b$var$concatAncestorHierarchy(node, ancestorHierarchy)));
    };
    const $9e99a33df40f710b$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
        const sanitizedAttrs = $9e99a33df40f710b$var$sanitizeAttributes(unsupportedNode.attrs);
        const sanitizedMarks = $9e99a33df40f710b$var$sanitizeMarks(unsupportedNode.marks);
        const sanitizedUnsupportedNode = {
            type: unsupportedNode.type,
            ancestry: unsupportedNode.ancestry,
            parentType: unsupportedNode.parentType,
            attrs: sanitizedAttrs,
            marks: sanitizedMarks
        };
        const payload = {
            action: (0, (0, parcelRequire("6SKbt")).ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
            actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: actionSubjectId,
            attributes: {
                unsupportedNode: sanitizedUnsupportedNode,
                ...!!errorCode && {
                    errorCode: errorCode
                }
            },
            eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
        };
        dispatchAnalyticsEvent(payload);
    };
    const $9e99a33df40f710b$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
        $9e99a33df40f710b$var$trackUnsupportedContentTooltipActionFor((0, (0, parcelRequire("6SKbt")).ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
    };
});
parcelRegister("3GOhg", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedContent", ()=>$177a07bc35d5daa7$export$d4ded51d0f0bd2df);
    function $177a07bc35d5daa7$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
        let defaultLocale = 'en';
        let canTranslateToLocale = true;
        let locale = intl ? intl.locale : defaultLocale;
        let finalMessage = message.defaultMessage;
        if (node && locale.startsWith(defaultLocale)) {
            const { originalValue: originalValue } = node.attrs;
            if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
                finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
                canTranslateToLocale = false;
            } else if (originalValue.type) {
                finalMessage = `${prefix} ${originalValue.type}`;
                canTranslateToLocale = false;
            }
        }
        if (intl && canTranslateToLocale) return intl.formatMessage(message);
        return finalMessage;
    }
});
parcelRegister("afkuR", function(module, exports) {
    $parcel$export(module.exports, "WithCreateAnalyticsEvent", ()=>$2c4e05357878b80e$export$9ac3d19711324187);
    var $5uXOq = parcelRequire("5uXOq");
    var $7GEKO;
    const $2c4e05357878b80e$export$9ac3d19711324187 = (0, (0, parcelRequire("7GEKO")).default)()(class WithCreateAnalyticsEvent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return render(createAnalyticsEvent);
        }
    });
});
parcelRegister("979lV", function(module, exports) {
    $parcel$export(module.exports, "startMeasure", ()=>$fa8180dd9427a627$export$b62aa2130c86b59b);
    $parcel$export(module.exports, "stopMeasure", ()=>$fa8180dd9427a627$export$37c25be427bec097);
    $parcel$export(module.exports, "clearMeasure", ()=>$fa8180dd9427a627$export$6f766653554dac02);
    var $4DIM0;
    const $fa8180dd9427a627$var$measureMap = new Map();
    function $fa8180dd9427a627$export$b62aa2130c86b59b(measureName) {
        if (!(0, (0, parcelRequire("4DIM0")).isPerformanceAPIAvailable)()) return;
        performance.mark(`${measureName}::start`);
        $fa8180dd9427a627$var$measureMap.set(measureName, performance.now());
    }
    function $fa8180dd9427a627$export$37c25be427bec097(measureName, onMeasureComplete) {
        if (!(0, (0, parcelRequire("4DIM0")).isPerformanceAPIAvailable)()) return;
        performance.mark(`${measureName}::end`);
        const start = onMeasureComplete ? $fa8180dd9427a627$var$measureMap.get(measureName) : undefined;
        try {
            performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
        } catch (error) {} finally{
            if (onMeasureComplete) {
                const entry = performance.getEntriesByName(measureName).pop();
                if (entry) onMeasureComplete(entry.duration, entry.startTime);
                else if (start) onMeasureComplete(performance.now() - start, start);
            }
            $fa8180dd9427a627$export$6f766653554dac02(measureName);
        }
    }
    function $fa8180dd9427a627$export$6f766653554dac02(measureName) {
        if (!(0, (0, parcelRequire("4DIM0")).isPerformanceAPIAvailable)()) return;
        $fa8180dd9427a627$var$measureMap.delete(measureName);
        performance.clearMarks(`${measureName}::start`);
        performance.clearMarks(`${measureName}::end`);
        performance.clearMeasures(measureName);
    }
});
parcelRegister("4DIM0", function(module, exports) {
    $parcel$export(module.exports, "isPerformanceAPIAvailable", ()=>$93158323a3ba64ad$export$b5717a625dd4a3eb);
    $parcel$export(module.exports, "isPerformanceObserverAvailable", ()=>$93158323a3ba64ad$export$48995af1e77d8643);
    let $93158323a3ba64ad$var$hasRequiredPerformanceAPIs;
    function $93158323a3ba64ad$export$b5717a625dd4a3eb() {
        if ($93158323a3ba64ad$var$hasRequiredPerformanceAPIs === undefined) $93158323a3ba64ad$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType',
            'now'
        ].every((api)=>!!performance[api]);
        return $93158323a3ba64ad$var$hasRequiredPerformanceAPIs;
    }
    function $93158323a3ba64ad$export$48995af1e77d8643() {
        return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
    }
    function $93158323a3ba64ad$export$4370ec0f52022f66() {
        return $93158323a3ba64ad$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
    }
});
parcelRegister("cZe8H", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAppearance", ()=>$b3d08d4375485316$export$be87849653b93e6b);
    $parcel$export(module.exports, "getAnalyticsEditorAppearance", ()=>$b3d08d4375485316$export$31ae53e002edded0);
    $parcel$export(module.exports, "getAnalyticsEventSeverity", ()=>$b3d08d4375485316$export$f8edd689e8b20f3a);
    $parcel$export(module.exports, "analyticsEventKey", ()=>$b3d08d4375485316$export$288273ee3e3b6132);
    var $dVthH = parcelRequire("dVthH");
    const $b3d08d4375485316$export$be87849653b93e6b = (appearance)=>{
        switch(appearance){
            case 'full-page':
                return (0, $dVthH.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
            case 'full-width':
                return (0, $dVthH.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
            case 'comment':
                return (0, $dVthH.EDITOR_APPEARANCE_CONTEXT).COMMENT;
            case 'chromeless':
                return (0, $dVthH.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
            case 'mobile':
                return (0, $dVthH.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        }
    };
    const $b3d08d4375485316$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$b3d08d4375485316$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
    const $b3d08d4375485316$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
        if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
        if (duration > degradedThreshold) return "blocking";
        return "normal";
    };
    var $b3d08d4375485316$export$6a6bef12562cd865;
    (function(SEVERITY) {
        SEVERITY["NORMAL"] = "normal";
        SEVERITY["DEGRADED"] = "degraded";
        SEVERITY["BLOCKING"] = "blocking";
    })($b3d08d4375485316$export$6a6bef12562cd865 || ($b3d08d4375485316$export$6a6bef12562cd865 = {}));
    const $b3d08d4375485316$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
});
parcelRegister("9axZJ", function(module, exports) {
    $parcel$export(module.exports, "shouldForceTracking", ()=>$0ca240479f567f82$export$5b59d3e9e22dbdc6);
    const $0ca240479f567f82$export$5b59d3e9e22dbdc6 = ()=>{
        try {
            const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
            return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
        } catch (err) {
            console.warn(err);
            return false;
        }
    };
});
parcelRegister("lXM3l", function(module, exports) {
    $parcel$export(module.exports, "getDistortedDurationMonitor", ()=>$40b71c2fe9d98b62$export$70f7d127254a90c);
    $parcel$export(module.exports, "measureRender", ()=>$40b71c2fe9d98b62$export$267ed650a5d21ae6);
    var $4DIM0;
    const $40b71c2fe9d98b62$export$70f7d127254a90c = ()=>{
        if (typeof document === 'undefined') return {
            distortedDuration: false,
            cleanup () {}
        };
        let distortedDuration = document.visibilityState !== 'visible';
        function handleVisibilityChange() {
            if (document.visibilityState !== 'visible') distortedDuration = true;
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return {
            distortedDuration: distortedDuration,
            cleanup () {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            }
        };
    };
    function $40b71c2fe9d98b62$export$267ed650a5d21ae6(measureName, onMeasureComplete) {
        if (!(0, (0, parcelRequire("4DIM0")).isPerformanceAPIAvailable)()) return;
        const startMark = `[START]: ${measureName}`;
        const endMark = `[END]: ${measureName}`;
        const startTime = performance.now();
        performance.mark(startMark);
        let distortedDurationMonitor = $40b71c2fe9d98b62$export$70f7d127254a90c();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                performance.mark(endMark);
                distortedDurationMonitor.cleanup();
                const duration = performance.now() - startTime;
                try {
                    performance.measure(measureName, startMark, endMark);
                    const entry = performance.getEntriesByName(measureName).pop();
                    if (!entry) onMeasureComplete({
                        duration: duration,
                        startTime: startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                    else onMeasureComplete({
                        duration: entry.duration,
                        startTime: entry.startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                } catch (e) {
                    onMeasureComplete({
                        duration: duration,
                        startTime: startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                }
                performance.clearMeasures(measureName);
                performance.clearMarks(startMark);
                performance.clearMarks(endMark);
            });
        });
    }
});
parcelRegister("dMwYp", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$486989396f2adb1f$export$3f2684e5d7cb1006);
    const $486989396f2adb1f$export$3f2684e5d7cb1006 = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $486989396f2adb1f$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
        $486989396f2adb1f$export$3f2684e5d7cb1006.windows = navigator.userAgentData?.platform === 'Windows' || /Windows|Win\d+/i.test(navigator.userAgent);
        let ie = $486989396f2adb1f$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $486989396f2adb1f$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $486989396f2adb1f$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $486989396f2adb1f$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        $486989396f2adb1f$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $486989396f2adb1f$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $486989396f2adb1f$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
        $486989396f2adb1f$export$3f2684e5d7cb1006.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $486989396f2adb1f$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $486989396f2adb1f$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $486989396f2adb1f$export$3f2684e5d7cb1006.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        $486989396f2adb1f$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $486989396f2adb1f$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
});
parcelRegister("4cJrc", function(module, exports) {
    $parcel$export(module.exports, "getResponseEndTime", ()=>$643b8717e5c68480$export$92d097a1155bbe27);
    var $4DIM0;
    function $643b8717e5c68480$export$92d097a1155bbe27() {
        if (!(0, (0, parcelRequire("4DIM0")).isPerformanceAPIAvailable)()) return;
        const nav = performance.getEntriesByType('navigation')[0];
        if (nav) return nav.responseEnd;
        return;
    }
});
parcelRegister("dk7tY", function(module, exports) {
    $parcel$export(module.exports, "normalizeFeatureFlags", ()=>$2c155cfbc7d4333b$export$f1485fc4974593c0);
    $parcel$export(module.exports, "getEnabledFeatureFlagKeys", ()=>$2c155cfbc7d4333b$export$6d018dd0f6cbebcb);
    var $e4eHl = parcelRequire("e4eHl");
    var $3T6Xo = parcelRequire("3T6Xo");
    const $2c155cfbc7d4333b$var$EMPTY = {};
    function $2c155cfbc7d4333b$var$isObjectFlagKey(key, value, objectFlagKeys) {
        return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
    }
    function $2c155cfbc7d4333b$var$isValidJSONObject(value) {
        try {
            let result = JSON.parse(value);
            if (typeof result === 'object' && result !== null) return true;
            return false;
        } catch (err) {
            return false;
        }
    }
    function $2c155cfbc7d4333b$export$f1485fc4974593c0(rawFeatureFlags, options) {
        if (!rawFeatureFlags) return $2c155cfbc7d4333b$var$EMPTY;
        return Object.entries(rawFeatureFlags).filter((e)=>{
            if (typeof e[1] === 'boolean') return true;
            if ($2c155cfbc7d4333b$var$isObjectFlagKey((0, ($parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $2c155cfbc7d4333b$var$isValidJSONObject(e[1])) return true;
            return false;
        }).filter(([key])=>(0, ($parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
                (0, ($parcel$interopDefault($e4eHl)))(key),
                value
            ]).reduce((flags, [key, value])=>{
            if ($2c155cfbc7d4333b$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
            if (typeof value === 'boolean') flags[key] = value;
            return flags;
        }, {});
    }
    function $2c155cfbc7d4333b$export$6d018dd0f6cbebcb(featureFlags) {
        return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
    }
});
parcelRegister("daO0f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c91701a889037dcb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kCV8T;
    var $i5Kxj = parcelRequire("i5Kxj");
    var $5u5gV;
    parcelRequire("aE1nS");
    var $02ldW;
    var $aE1nS;
    var $ltS6U;
    var $5qH0P;
    var $jXk0r;
    var $fxgxP;
    var $eM70S;
    var $daqZ0;
    var $5r0mK = parcelRequire("5r0mK");
    var $e0Fey;
    var $31jF8;
    var $9w2jc;
    var $aYRbA;
    function $c91701a889037dcb$var$mergeMarks(marksAndNodes) {
        return marksAndNodes.reduce((acc, markOrNode)=>{
            const prev = acc.length && acc[acc.length - 1] || null;
            if (markOrNode.type instanceof (0, (0, parcelRequire("kCV8T")).MarkType) && prev && prev.type instanceof (0, (0, parcelRequire("kCV8T")).MarkType) && Array.isArray(prev.content) && (0, (0, parcelRequire("fxgxP")).isSameMark)(prev, markOrNode)) prev.content = $c91701a889037dcb$var$mergeMarks(prev.content.concat(markOrNode.content));
            else acc.push(markOrNode);
            return acc;
        }, []);
    }
    class $c91701a889037dcb$export$2e2bcd8739ae039 {
        constructor(init){
            this.headingIds = [];
            this.expandHeadingIds = [];
            this.allowCopyToClipboard = false;
            this.allowWrapCodeBlock = false;
            this.allowPlaceholderText = true;
            this.allowCustomPanels = false;
            this.surroundTextNodesWithTextWrapper = false;
            this.allowAnnotations = false;
            this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
                const pos = this.startPos;
                const currentPath = parentInfo && parentInfo.path || [];
                const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
                const nodeKey = `${node.type.name}__${this.startPos}`;
                const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, (0, parcelRequire("aE1nS")).toReact)(node, {
                    allowSelectAllTrap: this.allowSelectAllTrap,
                    allowWindowedCodeBlock: this.allowWindowedCodeBlock
                }, this.nodeComponents), nodeKey, {
                    parentIsIncompleteTask: parentIsIncompleteTask,
                    path: [
                        ...currentPath,
                        node
                    ],
                    pos: this.startPos
                });
                this.startPos = pos + node.nodeSize;
                const marks = node.marks ? [
                    ...node.marks
                ] : [];
                const isMedia = node.type.name === 'media';
                const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
                const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
                return marks.reduceRight((content, mark)=>{
                    if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                    return this.renderMark((0, (0, parcelRequire("jXk0r")).toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
                }, serializedContent);
            };
            this.withMediaMarkProps = (node, mark, defaultProps)=>{
                if (mark.type.name === 'link' && node.type.name === 'media') return {
                    ...defaultProps,
                    isMediaLink: true
                };
                if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                    ...defaultProps,
                    isMediaInline: true
                };
                return defaultProps;
            };
            this.getUnsupportedContentProps = (node)=>{
                return {
                    node: node,
                    dispatchAnalyticsEvent: this.fireAnalyticsEvent
                };
            };
            this.getAnnotationMarkProps = (mark, marksParentPath)=>{
                const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                    if ((0, (0, parcelRequire("5qH0P")).isAnnotationMark)(parent)) return [
                        ...acc,
                        parent.attrs.id
                    ];
                    return acc;
                }, []);
                return {
                    id: mark.attrs.id,
                    annotationType: mark.attrs.annotationType,
                    annotationParentIds: annotationParentIds,
                    allowAnnotations: this.allowAnnotations,
                    dataAttributes: {
                        'data-renderer-mark': true
                    }
                };
            };
            this.getMarkProps = (mark, marksParentPath, node)=>{
                if ((0, (0, parcelRequire("5qH0P")).isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
                const { key: key, ...otherAttrs } = mark.attrs;
                const extraProps = {
                    isInline: node?.isInline
                };
                const markSpecificProps = (0, (0, parcelRequire("31jF8")).isCodeMark)(mark) ? {
                    codeBidiWarningTooltipEnabled: false
                } : {};
                const props = {
                    eventHandlers: this.eventHandlers,
                    fireAnalyticsEvent: this.fireAnalyticsEvent,
                    markKey: key,
                    ...otherAttrs,
                    ...extraProps,
                    ...markSpecificProps,
                    dataAttributes: {
                        'data-renderer-mark': true
                    }
                };
                return props;
            };
            if ((0, $i5Kxj.editorExperiment)('comment_on_bodied_extensions', true)) {
                this.initStartPos = init.startPos || 1;
                this.startPos = init.startPos || 1;
            } else {
                this.initStartPos = 1;
                this.startPos = 1;
            }
            this.providers = init.providers;
            this.eventHandlers = init.eventHandlers;
            this.extensionHandlers = init.extensionHandlers;
            this.portal = init.portal;
            this.rendererContext = init.objectContext;
            this.appearance = init.appearance;
            this.disableHeadingIDs = init.disableHeadingIDs;
            this.disableActions = init.disableActions;
            this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
            this.allowCopyToClipboard = init.allowCopyToClipboard;
            this.allowWrapCodeBlock = init.allowWrapCodeBlock;
            this.allowPlaceholderText = init.allowPlaceholderText;
            this.allowCustomPanels = init.allowCustomPanels;
            this.allowColumnSorting = init.allowColumnSorting;
            this.fireAnalyticsEvent = init.fireAnalyticsEvent;
            this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
            this.allowAltTextOnImages = init.allowAltTextOnImages;
            this.stickyHeaders = init.stickyHeaders;
            this.allowMediaLinking = init.allowMediaLinking;
            this.allowAnnotations = Boolean(init.allowAnnotations);
            this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
            this.media = init.media;
            this.emojiResourceConfig = init.emojiResourceConfig;
            this.smartLinks = init.smartLinks;
            this.allowSelectAllTrap = init.allowSelectAllTrap;
            this.nodeComponents = init.nodeComponents;
            this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
            this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
            this.textHighlighter = init.textHighlighter;
            this.allowTableAlignment = init.allowTableAlignment;
            this.allowTableResizing = init.allowTableResizing;
        }
        resetState() {
            this.headingIds = [];
            this.expandHeadingIds = [];
            this.startPos = this.initStartPos;
        }
        getNodeProps(node, parentInfo) {
            const path = parentInfo ? parentInfo.path : undefined;
            switch(node.type.name){
                case 'date':
                    return this.getDateProps(node, parentInfo, path);
                case 'hardBreak':
                    return this.getHardBreakProps(node, path);
                case 'heading':
                    return this.getHeadingProps(node, path);
                case 'media':
                    return this.getMediaProps(node, path);
                case 'emoji':
                    return this.getEmojiProps(node);
                case 'mediaGroup':
                    return this.getMediaGroupProps(node);
                case 'mediaInline':
                    return this.getMediaInlineProps(node);
                case 'mediaSingle':
                    return this.getMediaSingleProps(node, path);
                case 'table':
                    return this.getTableProps(node, path);
                case 'tableHeader':
                case 'tableRow':
                    return this.getTableChildrenProps(node);
                case 'taskItem':
                    return this.getTaskItemProps(node, path);
                case 'embedCard':
                    return this.getEmbedCardProps(node, path);
                case 'blockCard':
                    return this.getBlockCardProps(node, path);
                case 'expand':
                    return this.getExpandProps(node, path);
                case 'unsupportedBlock':
                case 'unsupportedInline':
                    return this.getUnsupportedContentProps(node);
                case 'codeBlock':
                    return this.getCodeBlockProps(node);
                case 'panel':
                    return this.getPanelProps(node);
                default:
                    return this.getProps(node, path);
            }
        }
        serializeFragment(fragment, props = {}, target = this.allowSelectAllTrap ? (0, (0, parcelRequire("02ldW")).DocWithSelectAllTrap) : (0, (0, parcelRequire("02ldW")).default), key = 'root-0', parentInfo) {
            if (key === 'root-0') this.resetState();
            return this.renderNode(target, props, key, $c91701a889037dcb$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
                if ((0, (0, parcelRequire("aE1nS")).isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                    index: index,
                    parentInfo: parentInfo
                });
                return this.serializeFragmentChild(node, {
                    index: index,
                    parentInfo: parentInfo
                });
            }));
        }
        serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
            const currentPath = parentInfo && parentInfo.path || [];
            const nodePosition = parentInfo && parentInfo.pos || 1;
            return $c91701a889037dcb$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
                return this.serializeMark({
                    mark: mark,
                    parentNode: {
                        path: currentPath,
                        pos: nodePosition
                    },
                    parentMark: {
                        path: [
                            mark
                        ]
                    }
                });
            });
        }
        serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
            if (!(0, (0, parcelRequire("aE1nS")).isTextNode)(mark)) {
                const serializeContent = (childMark, index)=>this.serializeMark({
                        mark: childMark,
                        parentNode: parentNode,
                        parentMark: {
                            path: [
                                ...parentMark.path,
                                childMark
                            ]
                        }
                    });
                const content = (mark.content || []).map(serializeContent);
                const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
                return this.renderMark((0, (0, parcelRequire("jXk0r")).toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
            }
            const startPos = this.startPos;
            const endPos = startPos + mark.nodeSize;
            this.startPos = endPos;
            const textKey = `text-wrapper_${this.startPos}`;
            if (this.surroundTextNodesWithTextWrapper) {
                const parentDepth = Math.max(parentNode.path.length - 1, 0);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ltS6U")).default), {
                    key: textKey,
                    startPos: startPos + parentDepth,
                    endPos: endPos + parentDepth,
                    textHighlighter: this.textHighlighter,
                    marks: mark.marks
                }, mark.text);
            }
            const segments = (0, (0, parcelRequire("9w2jc")).segmentText)(mark.text, this.textHighlighter);
            return (0, (0, parcelRequire("aYRbA")).renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
        }
        renderNode(NodeComponent, props, key, content) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement(NodeComponent, {
                key: key,
                ...props
            }, content);
        }
        renderMark(MarkComponent, props, key, content) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement(MarkComponent, {
                key: key,
                ...props
            }, content);
        }
        getTableChildrenProps(node) {
            return {
                ...this.getProps(node),
                allowColumnSorting: this.allowColumnSorting
            };
        }
        getTableProps(node, path = []) {
            const stickyHeaders = !(0, (0, parcelRequire("e0Fey")).insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
            const isInsideOfBlockNode = (0, (0, parcelRequire("e0Fey")).insideBlockNode)(path, node.type.schema);
            const isInsideMultiBodiedExtension = (0, (0, parcelRequire("e0Fey")).insideMultiBodiedExtension)(path, node.type.schema);
            return {
                ...this.getProps(node),
                allowColumnSorting: this.allowColumnSorting,
                columnWidths: (0, (0, parcelRequire("eM70S")).calcTableColumnWidths)(node),
                tableNode: node,
                stickyHeaders: stickyHeaders,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
                allowTableAlignment: this.allowTableAlignment,
                allowTableResizing: this.allowTableResizing
            };
        }
        getDateProps(node, parentInfo, path = []) {
            return {
                timestamp: node.attrs && node.attrs.timestamp,
                parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
                dataAttributes: {
                    'data-renderer-start-pos': this.startPos + path.length
                }
            };
        }
        getMediaSingleProps(node, path = []) {
            const { marks: { link: link } } = node.type.schema;
            const isInsideOfBlockNode = (0, (0, parcelRequire("e0Fey")).insideBlockNode)(path, node.type.schema);
            const isLinkMark = (mark)=>mark.type === link;
            const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
            return {
                ...this.getProps(node, path),
                isInsideOfBlockNode: isInsideOfBlockNode,
                childHasLink: childHasLink,
                allowCaptions: this.media && this.media.allowCaptions,
                featureFlags: this.media && this.media.featureFlags
            };
        }
        getMediaProps(node, path = []) {
            const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
            const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
            const isAnnotationMark = (mark)=>mark.type === annotation;
            const isLinkMark = (mark)=>mark.type === link;
            const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
            return {
                ...this.getProps(node, path),
                marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
                isLinkMark: isLinkMark,
                isBorderMark: isBorderMark,
                isAnnotationMark: isAnnotationMark,
                allowAltTextOnImages: this.allowAltTextOnImages,
                featureFlags: this.media && this.media.featureFlags,
                shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                ssr: this.media?.ssr,
                allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
            };
        }
        getEmojiProps(node) {
            return {
                ...this.getProps(node),
                resourceConfig: this.emojiResourceConfig
            };
        }
        getEmbedCardProps(node, path = []) {
            const isInsideOfBlockNode = (0, (0, parcelRequire("e0Fey")).insideBlockNode)(path, node.type.schema);
            return {
                ...this.getProps(node),
                isInsideOfBlockNode: isInsideOfBlockNode
            };
        }
        getBlockCardProps(node, path = []) {
            return {
                ...this.getProps(node),
                isNodeNested: path.length > 0
            };
        }
        getMediaGroupProps(node) {
            return {
                ...this.getProps(node),
                shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                allowAltTextOnImages: this.allowAltTextOnImages,
                featureFlags: this.media && this.media.featureFlags,
                enableDownloadButton: this.media?.enableDownloadButton,
                ssr: this.media?.ssr
            };
        }
        getMediaInlineProps(node) {
            return {
                ...this.getProps(node),
                ssr: this.media?.ssr
            };
        }
        getTaskItemProps(node, path = []) {
            return {
                ...this.getProps(node, path),
                disabled: this.disableActions
            };
        }
        getHardBreakProps(node, path = []) {
            let forceNewLine = false;
            const parentNode = path.length > 0 ? path[path.length - 1] : null;
            if (parentNode && parentNode.lastChild === node) forceNewLine = true;
            return {
                ...this.getProps(node),
                forceNewLine: forceNewLine
            };
        }
        getCodeBlockProps(node) {
            const codeBidiWarningTooltipEnabled = false;
            return {
                ...this.getProps(node),
                text: node.textContent,
                codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
            };
        }
        getPanelProps(node) {
            return {
                ...this.getProps(node),
                allowCustomPanels: this.allowCustomPanels
            };
        }
        getProps(node, path = []) {
            const startPos = this.startPos + path.length;
            return {
                text: node.text,
                providers: this.providers,
                eventHandlers: this.eventHandlers,
                extensionHandlers: this.extensionHandlers,
                portal: this.portal,
                rendererContext: this.rendererContext,
                serializer: this,
                content: node.content ? node.content.toJSON() : undefined,
                allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
                allowCopyToClipboard: this.allowCopyToClipboard,
                allowWrapCodeBlock: this.allowWrapCodeBlock,
                allowPlaceholderText: this.allowPlaceholderText,
                rendererAppearance: this.appearance,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                nodeType: node.type.name,
                marks: node.marks,
                smartLinks: this.smartLinks,
                isInsideOfInlineExtension: this.isInsideOfInlineExtension,
                dataAttributes: {
                    'data-renderer-start-pos': startPos
                },
                startPos: startPos,
                path: path,
                ...node.attrs
            };
        }
        headingAnchorSupported(path = []) {
            const isImmediateParent = (path, nodeName)=>{
                return path.length > 0 && path[path.length - 1].type.name === nodeName;
            };
            return (0, (0, parcelRequire("5u5gV")).isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
        }
        getHeadingProps(node, path = []) {
            return {
                ...this.getProps(node, path),
                content: node.content ? node.content.toJSON() : undefined,
                headingId: this.getHeadingId(node, this.headingIds),
                showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
            };
        }
        getExpandProps(node, path = []) {
            if (!(0, (0, parcelRequire("5u5gV")).isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
            const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
            return {
                ...this.getProps(node),
                nestedHeaderIds: nestedHeaderIds
            };
        }
        getHeadingId(node, headingIds) {
            if (this.disableHeadingIDs || !node.content.size) return;
            const nodeContent = node.content.toJSON().reduce((acc, node)=>acc.concat((0, (0, parcelRequire("daqZ0")).getText)(node) || ''), '').trim().replace(/\s/g, '-');
            if (!nodeContent) return;
            return this.getUniqueHeadingId(nodeContent, headingIds);
        }
        getUniqueHeadingId(baseId, headingIds, counter = 0) {
            if (counter === 0 && headingIds.indexOf(baseId) === -1) {
                headingIds.push(baseId);
                return baseId;
            } else if (counter !== 0) {
                const headingId = `${baseId}.${counter}`;
                if (headingIds.indexOf(headingId) === -1) {
                    headingIds.push(headingId);
                    return headingId;
                }
            }
            return this.getUniqueHeadingId(baseId, headingIds, ++counter);
        }
        static getChildNodes(fragment) {
            const children = [];
            fragment.forEach((node)=>{
                children.push(node);
            });
            return (0, (0, parcelRequire("aE1nS")).mergeTextNodes)(children);
        }
        static getMarks(node) {
            if (!node.marks || node.marks.length === 0) return [];
            return (0, (0, parcelRequire("fxgxP")).getMarksByOrder)(node.marks);
        }
        static buildMarkStructure(content) {
            return $c91701a889037dcb$var$mergeMarks(content.map((node)=>{
                const nodeMarks = this.getMarks(node);
                if (nodeMarks.length === 0) return node;
                return nodeMarks.reverse().reduce((acc, mark)=>{
                    const { eq: eq } = mark;
                    return {
                        ...mark,
                        eq: eq,
                        content: [
                            acc
                        ]
                    };
                }, node);
            }));
        }
        static fromSchema(_, init) {
            return new $c91701a889037dcb$export$2e2bcd8739ae039(init);
        }
    }
});
parcelRegister("5u5gV", function(module, exports) {
    $parcel$export(module.exports, "isNestedHeaderLinksEnabled", ()=>$e2a7ae190beb77db$export$7aa7587d1ce9583c);
    $parcel$export(module.exports, "getActiveHeadingId", ()=>$e2a7ae190beb77db$export$acb253d79d72af92);
    function $e2a7ae190beb77db$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
        if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
        const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
        return !!allowNestedHeaderLinks;
    }
    function $e2a7ae190beb77db$export$acb253d79d72af92(allowHeadingAnchorLinks) {
        if (!$e2a7ae190beb77db$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
        return allowHeadingAnchorLinks.activeHeadingId;
    }
});
parcelRegister("aE1nS", function(module, exports) {
    $parcel$export(module.exports, "InlineCard", ()=>$2e55f3987d1ce6c4$export$aff6291803939b05);
    $parcel$export(module.exports, "nodeToReact", ()=>$2e55f3987d1ce6c4$export$3931063f6a5f290e);
    $parcel$export(module.exports, "toReact", ()=>$2e55f3987d1ce6c4$export$d4334b129116aad7);
    $parcel$export(module.exports, "mergeTextNodes", ()=>$2e55f3987d1ce6c4$export$8045509d14b5046f);
    $parcel$export(module.exports, "isTextWrapper", ()=>$2e55f3987d1ce6c4$export$d4ebd3557ee7fac1);
    $parcel$export(module.exports, "isTextNode", ()=>$2e55f3987d1ce6c4$export$ccbedd67ef6e9417);
    $parcel$export(module.exports, "Doc", ()=>(parcelRequire("02ldW")).default);
    $parcel$export(module.exports, "DocWithSelectAllTrap", ()=>(parcelRequire("02ldW")).DocWithSelectAllTrap);
    var $4qBtX = parcelRequire("4qBtX");
    var $bic03;
    var $dCYTa;
    var $f3cky;
    var $1Sdr8;
    var $j4Mf9;
    var $02ldW;
    var $lklLu;
    var $ddxNm;
    var $cTi0Q;
    var $cdB0A;
    var $gj6hB;
    var $ev9Gv;
    var $8aCWn;
    var $5fqw2;
    var $5bFfj;
    var $7yLSH;
    var $eV0Dv;
    var $fWiVV;
    var $fhoQm;
    var $ffD5B;
    var $kXb3o;
    var $8xfhx;
    var $iITB0;
    var $cKk13;
    const $2e55f3987d1ce6c4$export$a22ee8f907eecb5f = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6YsFx")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$6c415d1fdae3dfdb = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("2IuQA")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$771a55a10b0a40ae = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("h4k7O")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$27c4189b8be1bf93 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8UEog")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$b458dfa720128865 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8eZjH")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$b6f73a2b0b0de599 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("k1bqP")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$6341f9a885713487 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("9JrDW")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$96e9906d6d93a972 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("kVmCz")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$56cc48506ff790a = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("bv7Z4")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$2ddb90ad54e5f587 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("jBXoV")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$6789d7ecdc77631b = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("dFvTp")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$aff6291803939b05 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("4kY1v")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$d18ccd25c0d2c6b0 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("bCdOW")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$7fc53215244aec38 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("1Ragz")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$d7858be3df00d59 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("84b6y")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$462ea7c2a1c4cb1f = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("jt6ij")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$888d74bc001c3a5d = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("h14um")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$e891316fea657d90 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("3aRy8")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$49bd1dfb0ad29c40 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("48J9u")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2e55f3987d1ce6c4$export$3931063f6a5f290e = {
        blockquote: (0, (0, parcelRequire("bic03")).default),
        bulletList: (0, (0, parcelRequire("j4Mf9")).default),
        blockCard: $2e55f3987d1ce6c4$export$d18ccd25c0d2c6b0,
        caption: (0, (0, parcelRequire("5fqw2")).default),
        date: $2e55f3987d1ce6c4$export$6341f9a885713487,
        decisionItem: $2e55f3987d1ce6c4$export$b6f73a2b0b0de599,
        decisionList: $2e55f3987d1ce6c4$export$b458dfa720128865,
        doc: (0, (0, parcelRequire("02ldW")).default),
        emoji: $2e55f3987d1ce6c4$export$56cc48506ff790a,
        extension: (0, (0, parcelRequire("lklLu")).default),
        bodiedExtension: (0, (0, parcelRequire("dCYTa")).default),
        multiBodiedExtension: (0, (0, parcelRequire("f3cky")).default),
        extensionFrame: (0, (0, parcelRequire("1Sdr8")).default),
        hardBreak: (0, (0, parcelRequire("ddxNm")).default),
        heading: (0, (0, parcelRequire("cTi0Q")).default),
        inlineCard: $2e55f3987d1ce6c4$export$aff6291803939b05,
        inlineExtension: (0, (0, parcelRequire("cdB0A")).default),
        layoutSection: (0, (0, parcelRequire("gj6hB")).default),
        layoutColumn: (0, (0, parcelRequire("ev9Gv")).default),
        listItem: (0, (0, parcelRequire("8aCWn")).default),
        media: $2e55f3987d1ce6c4$export$7fc53215244aec38,
        mediaGroup: $2e55f3987d1ce6c4$export$d7858be3df00d59,
        mediaInline: $2e55f3987d1ce6c4$export$462ea7c2a1c4cb1f,
        mediaSingle: $2e55f3987d1ce6c4$export$888d74bc001c3a5d,
        mention: $2e55f3987d1ce6c4$export$e891316fea657d90,
        orderedList: (0, (0, parcelRequire("5bFfj")).default),
        panel: $2e55f3987d1ce6c4$export$2ddb90ad54e5f587,
        paragraph: (0, (0, parcelRequire("7yLSH")).default),
        placeholder: (0, (0, parcelRequire("eV0Dv")).default),
        rule: (0, (0, parcelRequire("fWiVV")).default),
        status: $2e55f3987d1ce6c4$export$96e9906d6d93a972,
        taskItem: $2e55f3987d1ce6c4$export$27c4189b8be1bf93,
        taskList: $2e55f3987d1ce6c4$export$771a55a10b0a40ae,
        table: (0, (0, parcelRequire("fhoQm")).default),
        tableCell: (0, (0, parcelRequire("ffD5B")).TableCell),
        tableHeader: (0, (0, parcelRequire("ffD5B")).TableHeader),
        tableRow: (0, (0, parcelRequire("kXb3o")).default),
        unknownBlock: (0, (0, parcelRequire("8xfhx")).default),
        unsupportedBlock: (0, (0, parcelRequire("iITB0")).default),
        unsupportedInline: (0, (0, parcelRequire("cKk13")).default),
        expand: $2e55f3987d1ce6c4$export$49bd1dfb0ad29c40,
        nestedExpand: $2e55f3987d1ce6c4$export$49bd1dfb0ad29c40,
        embedCard: $2e55f3987d1ce6c4$export$6789d7ecdc77631b
    };
    const $2e55f3987d1ce6c4$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
        if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, (0, parcelRequire("02ldW")).DocWithSelectAllTrap;
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return $2e55f3987d1ce6c4$export$a22ee8f907eecb5f;
            return $2e55f3987d1ce6c4$export$6c415d1fdae3dfdb;
        }
        const nodes = {
            ...$2e55f3987d1ce6c4$export$3931063f6a5f290e,
            ...nodeComponents
        };
        return nodes[node.type.name];
    };
    const $2e55f3987d1ce6c4$export$8045509d14b5046f = (nodes)=>{
        return nodes.reduce((acc, current)=>{
            if (!$2e55f3987d1ce6c4$export$1879817ac5c922b7(current.type.name)) {
                acc.push(current);
                return acc;
            }
            if (acc.length > 0 && $2e55f3987d1ce6c4$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
                const textWrapper = acc[acc.length - 1];
                textWrapper.content.push(current);
                textWrapper.nodeSize += current.nodeSize;
            } else acc.push({
                type: {
                    name: 'textWrapper'
                },
                content: [
                    current
                ],
                nodeSize: current.nodeSize
            });
            return acc;
        }, []);
    };
    const $2e55f3987d1ce6c4$export$1879817ac5c922b7 = (type)=>{
        return type === 'text';
    };
    const $2e55f3987d1ce6c4$export$d4ebd3557ee7fac1 = (node)=>{
        return node.type.name === 'textWrapper';
    };
    function $2e55f3987d1ce6c4$export$ccbedd67ef6e9417(node) {
        return node.type.name === 'text';
    }
    const $2e55f3987d1ce6c4$var$whitespaceRegex = /^\s*$/;
    const $2e55f3987d1ce6c4$export$dd0c7365db1f79a5 = (doc)=>{
        if (doc.childCount !== 1) return false;
        const parentNodes = [];
        doc.forEach((child)=>parentNodes.push(child));
        const node = parentNodes[0];
        return node.type.name === 'paragraph' && $2e55f3987d1ce6c4$var$isEmojiBlock(node.content);
    };
    const $2e55f3987d1ce6c4$var$isEmojiBlock = (pnode)=>{
        const content = [];
        if (pnode.childCount > 7) return false;
        pnode.forEach((child)=>content.push(child));
        let emojiCount = 0;
        for(let i = 0; i < content.length; ++i){
            const node = content[i];
            switch(node.type.name){
                case 'text':
                    if (node.text && !node.text.match($2e55f3987d1ce6c4$var$whitespaceRegex)) return false;
                    continue;
                case 'emoji':
                    if (++emojiCount > 3) return false;
                    continue;
                default:
                    return false;
            }
        }
        return emojiCount > 0;
    };
});
parcelRegister("bic03", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce37c540016817a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $ce37c540016817a2$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("blockquote", null, props.children);
    }
});
parcelRegister("dCYTa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a4a6d067db07176$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $lklLu;
    var $lTPvl;
    var $f045t;
    var $bAXaR;
    var $6SKbt;
    var $8foRb;
    const $0a4a6d067db07176$var$BodiedExtension = (props)=>{
        const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const removeOverflow = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lTPvl")).ErrorBoundary), {
            component: (0, (0, parcelRequire("bAXaR")).ACTION_SUBJECT).RENDERER,
            componentId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).EXTENSION_BODIED,
            createAnalyticsEvent: createAnalyticsEvent,
            additionalInfo: `${extensionType}: ${extensionKey} `
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8foRb")).AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f045t")).default), {
            ...props,
            type: "bodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, (0, parcelRequire("lklLu")).renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                }, removeOverflow);
            } catch (e) {}
            return (0, (0, parcelRequire("lklLu")).renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        })));
    };
    var $0a4a6d067db07176$export$2e2bcd8739ae039 = $0a4a6d067db07176$var$BodiedExtension;
});
parcelRegister("lklLu", function(module, exports) {
    $parcel$export(module.exports, "renderExtension", ()=>$e46d27da350e36d9$export$b7482bdc8aff85e4);
    $parcel$export(module.exports, "default", ()=>$e46d27da350e36d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f045t;
    var $cpToy;
    var $caFD8;
    var $9N9gL;
    var $6zogC;
    const $e46d27da350e36d9$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow)=>{
        const overflowContainerClass = !removeOverflow ? (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
        const { isTopLevel: isTopLevel = true } = options || {};
        const centerAlignClass = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) ? (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caFD8")).WidthConsumer), null, ({ width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: options.handleRef,
                className: `${(0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    width: isTopLevel ? (0, (0, parcelRequire("9N9gL")).calcBreakoutWidth)(layout, width) : '100%'
                },
                "data-layout": layout
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: overflowContainerClass
            }, content)));
    };
    const $e46d27da350e36d9$var$Extension = (props)=>{
        const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f045t")).default), {
            ...props,
            type: "extension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return $e46d27da350e36d9$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                });
            } catch (e) {}
            return $e46d27da350e36d9$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        });
    };
    var $e46d27da350e36d9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cpToy")).default)($e46d27da350e36d9$var$Extension, {
        overflowSelector: `.${(0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    });
});
parcelRegister("f045t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fc04c8974242f38$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $3BiVC;
    var $b1fdP;
    var $3C39f;
    const $1fc04c8974242f38$var$inlineExtensionStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
        margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
        '& .rich-media-item': {
            maxWidth: '100%'
        }
    });
    function $1fc04c8974242f38$export$2e2bcd8739ae039(props) {
        const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
        const isMounted = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        const localGetNodeRenderer = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>(0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("3BiVC")).getNodeRenderer)), []);
        const [extensionProvider, setExtensionProvider] = (0, ($parcel$interopDefault($5uXOq))).useState(null);
        const handleProvider = (0, ($parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
            providerPromise && providerPromise.then((provider)=>{
                if (isMounted.current) setExtensionProvider(provider);
            });
        }, []);
        const renderExtensionNode = (0, ($parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
            const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const node = {
                type: type,
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: content || text,
                localId: localId,
                fragmentLocalId: fragmentLocalId
            };
            let result = null;
            try {
                if (extensionHandlers && extensionHandlers[extensionType]) {
                    const render = (0, (0, parcelRequire("3C39f")).getExtensionRenderer)(extensionHandlers[extensionType]);
                    result = render(node, rendererContext.adDoc);
                }
                if (!result && extensionProvider) {
                    const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                    if (node.type === 'multiBodiedExtension') result = (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node,
                        actions: actions
                    });
                    else if (node.type === 'inlineExtension') result = (0, (0, parcelRequire("f8Sb3")).jsx)($1fc04c8974242f38$var$InlineNodeRendererWrapper, null, (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node
                    });
                }
            } catch (e) {}
            return children({
                result: result
            });
        }, [
            actions,
            children,
            content,
            extensionHandlers,
            extensionKey,
            extensionType,
            localGetNodeRenderer,
            localId,
            marks,
            parameters,
            rendererContext?.adDoc,
            text,
            type
        ]);
        const setupAndRenderExtensionNode = (0, ($parcel$interopDefault($5uXOq))).useCallback((providers)=>{
            if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
            return renderExtensionNode(extensionProvider);
        }, [
            extensionProvider,
            handleProvider,
            renderExtensionNode
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, []);
        if (!props.providers) return setupAndRenderExtensionNode({});
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b1fdP")).WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: props.providers,
            renderNode: setupAndRenderExtensionNode
        });
    }
    const $1fc04c8974242f38$var$InlineNodeRendererWrapper = ({ children: children })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: "inline-extension-renderer",
            css: $1fc04c8974242f38$var$inlineExtensionStyle
        }, children));
    };
});
parcelRegister("3BiVC", function(module, exports) {
    $parcel$export(module.exports, "getExtensionModuleNode", ()=>$cdf93c56a75dd4f8$export$82dd45c2db936caf);
    $parcel$export(module.exports, "getExtensionModuleNodePrivateProps", ()=>$cdf93c56a75dd4f8$export$426f8efd8690d8aa);
    $parcel$export(module.exports, "getNodeRenderer", ()=>$cdf93c56a75dd4f8$export$67a7d49db68d30a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $4UqzJ;
    async function $cdf93c56a75dd4f8$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
        const [extKey, nodeKey] = (0, (0, parcelRequire("4UqzJ")).getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const manifest = await extensionProvider.getExtension(extensionType, extKey);
        if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
        if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
        const node = manifest.modules.nodes[nodeKey];
        if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
        return node;
    }
    async function $cdf93c56a75dd4f8$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
        const moduleNode = await $cdf93c56a75dd4f8$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
        return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
            acc[key] = moduleNode[key];
            return acc;
        }, {});
    }
    function $cdf93c56a75dd4f8$var$ExtensionLoading(props) {
        if (props.error || props.timedOut) {
            console.error('Error rendering extension', props.error);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "Error loading the extension!");
        } else return null;
    }
    function $cdf93c56a75dd4f8$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>{
                return $cdf93c56a75dd4f8$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, (0, parcelRequire("4UqzJ")).resolveImport)(node.render()));
            },
            loading: $cdf93c56a75dd4f8$var$ExtensionLoading
        });
    }
});
parcelRegister("4UqzJ", function(module, exports) {
    $parcel$export(module.exports, "getExtensionKeyAndNodeKey", ()=>$43f941f9a3a6aed0$export$8a49818572e1d105);
    $parcel$export(module.exports, "buildAction", ()=>$43f941f9a3a6aed0$export$bb33bcdd9a10a608);
    $parcel$export(module.exports, "resolveImport", ()=>$43f941f9a3a6aed0$export$d69c9b451c47653b);
    const $43f941f9a3a6aed0$export$a7d04c836550045a = 'com.atlassian.ecosystem';
    const $43f941f9a3a6aed0$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
        if (extensionType === $43f941f9a3a6aed0$export$a7d04c836550045a) return [
            extensionKey,
            'default'
        ];
        const [extKey, nodeKey = 'default'] = extensionKey.split(':');
        return [
            extKey,
            nodeKey
        ];
    };
    const $43f941f9a3a6aed0$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
        if (!nodeKey || nodeKey === 'default') return extensionKey;
        return `${extensionKey}:${nodeKey}`;
    };
    function $43f941f9a3a6aed0$export$bb33bcdd9a10a608(action, manifest) {
        if (typeof action === 'function') return action;
        if (action.type === 'node' && manifest.modules.nodes) return $43f941f9a3a6aed0$export$33863d887d6f4bfd(action, manifest);
    }
    const $43f941f9a3a6aed0$export$d69c9b451c47653b = async (importPromise)=>{
        const importedModule = await importPromise;
        return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
    };
    function $43f941f9a3a6aed0$export$33863d887d6f4bfd(action, manifest) {
        if (!manifest.modules.nodes) return;
        const node = manifest.modules.nodes[action.key];
        const extensionKey = $43f941f9a3a6aed0$export$5f3eb042babacbbd(manifest.key, action.key);
        const extension = {
            type: node.type,
            attrs: {
                extensionType: manifest.type,
                extensionKey: extensionKey,
                parameters: action.parameters
            }
        };
        if (node.type === 'bodiedExtension') return {
            ...extension,
            content: [
                {
                    type: 'paragraph',
                    content: []
                }
            ]
        };
        else if (node.type === 'multiBodiedExtension') return {
            ...extension,
            content: [
                {
                    type: 'extensionFrame',
                    content: [
                        {
                            type: 'paragraph',
                            content: []
                        }
                    ]
                }
            ]
        };
        return extension;
    }
});
parcelRegister("b1fdP", function(module, exports) {
    $parcel$export(module.exports, "WithProviders", ()=>$5ff641ec3e879276$export$d498ee8be33e096f);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oS3b;
    class $5ff641ec3e879276$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
        static{
            this.displayName = 'WithProviders';
        }
        constructor(props){
            super(props);
            this.mounted = false;
            this.handleProviderIfMounted = (name, provider)=>{
                if (!this.mounted) return;
                this.handleProvider(name, provider);
            };
            this.handleProvider = (name, provider)=>{
                this.setState(({ providers: providers })=>{
                    return {
                        providers: {
                            ...providers,
                            [name]: provider
                        }
                    };
                });
            };
            this.mounted = false;
            const providers = {};
            this.props.providers.forEach((name)=>{
                if ((0, (0, parcelRequire("2oS3b")).fg)('platform_editor_react18_phase2_v2')) {
                    const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
                    providers[name] = providerPromise;
                } else providers[name] = undefined;
            });
            this.state = {
                providers: providers
            };
        }
        componentDidMount() {
            this.mounted = true;
        }
        UNSAFE_componentWillMount() {
            if (!(0, (0, parcelRequire("2oS3b")).fg)('platform_editor_react18_phase2_v2')) {
                const { providers: providers, providerFactory: providerFactory } = this.props;
                providers.forEach((name)=>{
                    providerFactory.subscribe(name, this.handleProvider);
                });
            }
        }
        componentWillUnmount() {
            const { providers: providers, providerFactory: providerFactory } = this.props;
            providers.forEach((name)=>{
                providerFactory.unsubscribe(name, this.handleProvider);
            });
        }
        render() {
            const { state: state, props: props } = this;
            const { renderNode: renderNode } = props;
            return renderNode(state.providers);
        }
    }
});
parcelRegister("3C39f", function(module, exports) {
    $parcel$export(module.exports, "getExtensionRenderer", ()=>$900eaf8ffc623225$export$9214452ef07eda7);
    function $900eaf8ffc623225$export$9214452ef07eda7(extensionHandler) {
        if (typeof extensionHandler === 'object') return extensionHandler.render;
        else return extensionHandler;
    }
});
parcelRegister("cpToy", function(module, exports) {
    $parcel$export(module.exports, "shadowClassNames", ()=>$2eea03fc930c6a6c$export$4735dd2b0fa88aa5);
    $parcel$export(module.exports, "default", ()=>$2eea03fc930c6a6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bRJM5;
    const $2eea03fc930c6a6c$export$4735dd2b0fa88aa5 = {
        RIGHT_SHADOW: 'right-shadow',
        LEFT_SHADOW: 'left-shadow'
    };
    function $2eea03fc930c6a6c$export$2e2bcd8739ae039(Component, options) {
        return class OverflowShadow extends (0, ($parcel$interopDefault($5uXOq))).Component {
            componentWillUnmount() {
                if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
                if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
                this.updateShadows();
            }
            componentDidUpdate() {
                if (!options.useShadowObserver) this.updateShadows();
            }
            initShadowObserver() {
                if (this.shadowObserver || !this.overflowContainer) return;
                this.shadowObserver = new (0, (0, parcelRequire("bRJM5")).ShadowObserver)({
                    scrollContainer: this.overflowContainer,
                    onUpdateShadows: (shadowStates)=>{
                        this.setState((prevState)=>{
                            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                            if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                                showLeftShadow: showLeftShadow,
                                showRightShadow: showRightShadow
                            };
                            return null;
                        });
                    }
                });
            }
            render() {
                const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
                let classNames = [
                    showRightShadow && $2eea03fc930c6a6c$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                    showLeftShadow && $2eea03fc930c6a6c$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                    options.useShadowObserver && (0, (0, parcelRequire("bRJM5")).shadowObserverClassNames).SHADOW_CONTAINER
                ].filter(Boolean).join(' ');
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    handleRef: this.handleContainer,
                    shadowClassNames: classNames,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args);
                this.overflowContainerWidth = 0;
                this.state = {
                    showLeftShadow: false,
                    showRightShadow: false
                };
                this.handleScroll = (event)=>{
                    if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                    this.updateShadows();
                };
                this.updateShadows = ()=>{
                    if (options.useShadowObserver) return;
                    this.setState((prevState)=>{
                        if (!this.overflowContainer) return;
                        const diff = this.calcOverflowDiff();
                        const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                        const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                };
                this.showLeftShadow = (overflowContainer)=>{
                    return !!overflowContainer && overflowContainer.scrollLeft > 0;
                };
                this.calcOverflowDiff = ()=>{
                    if (!this.overflowContainer) return 0;
                    this.diff = this.calcScrollableWidth();
                    return this.diff - this.overflowContainer.offsetWidth;
                };
                this.calcScrollableWidth = ()=>{
                    if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                    if (!this.scrollable) return 0;
                    let width = 0;
                    for(let i = 0; i < this.scrollable.length; i++){
                        const scrollableElement = this.scrollable[i];
                        width += scrollableElement.scrollWidth;
                    }
                    return width;
                };
                this.handleContainer = (container)=>{
                    if (!container || this.container) return;
                    this.container = container;
                    this.overflowContainer = container.querySelector(options.overflowSelector);
                    if (!this.overflowContainer) this.overflowContainer = container;
                    if (options.useShadowObserver) {
                        this.initShadowObserver();
                        return;
                    }
                    this.updateShadows();
                    this.overflowContainer.addEventListener('scroll', this.handleScroll);
                };
            }
        };
    }
});
parcelRegister("bRJM5", function(module, exports) {
    $parcel$export(module.exports, "shadowObserverClassNames", ()=>$c1b13ca1b397a019$export$1cbe0bb16052178d);
    $parcel$export(module.exports, "ShadowObserver", ()=>$c1b13ca1b397a019$export$51a5b28e4fb2dba2);
    var $c1b13ca1b397a019$export$ebeea2fe2e93862e;
    (function(ShadowKeys) {
        ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
        ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    })($c1b13ca1b397a019$export$ebeea2fe2e93862e || ($c1b13ca1b397a019$export$ebeea2fe2e93862e = {}));
    const $c1b13ca1b397a019$export$1cbe0bb16052178d = {
        SENTINEL_LEFT: 'sentinel-left',
        SENTINEL_RIGHT: 'sentinel-right',
        SHADOW_CONTAINER: 'with-shadow-observer'
    };
    const $c1b13ca1b397a019$var$requestIdleCallback = (fn)=>{
        return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
    };
    const $c1b13ca1b397a019$var$cancelIdleCallback = (id)=>{
        return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
    };
    class $c1b13ca1b397a019$export$51a5b28e4fb2dba2 {
        constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
            this.sentinels = {};
            this.shadowStates = {
                ["showLeftShadow"]: false,
                ["showRightShadow"]: false
            };
            this.init = ()=>{
                if (!this.scrollContainer || this.intersectionObserver) return;
                this.sentinels.right = document.createElement('div');
                this.sentinels.right.classList.add($c1b13ca1b397a019$export$1cbe0bb16052178d.SENTINEL_RIGHT);
                this.scrollContainer.appendChild(this.sentinels.right);
                this.sentinels.left = document.createElement('div');
                this.sentinels.left.classList.add($c1b13ca1b397a019$export$1cbe0bb16052178d.SENTINEL_LEFT);
                this.scrollContainer.prepend(this.sentinels.left);
                this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                    entries.forEach(this.onIntersect);
                }, {
                    root: this.scrollContainer,
                    rootMargin: '1px'
                });
                this.intersectionObserver.observe(this.sentinels.left);
                this.intersectionObserver.observe(this.sentinels.right);
            };
            this.onIntersect = (entry)=>{
                this.requestCallbackId = $c1b13ca1b397a019$var$requestIdleCallback(()=>{
                    if (entry.target.classList.contains($c1b13ca1b397a019$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                    if (entry.target.classList.contains($c1b13ca1b397a019$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                    this.onUpdateShadows(this.shadowStates);
                });
            };
            this.scrollContainer = scrollContainer;
            this.onUpdateShadows = onUpdateShadows;
            this.init();
        }
        dispose() {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = undefined;
                this.requestCallbackId && $c1b13ca1b397a019$var$cancelIdleCallback(this.requestCallbackId);
            }
        }
    }
});
parcelRegister("9N9gL", function(module, exports) {
    $parcel$export(module.exports, "breakoutConsts", ()=>$fc8564cd32ff5fc7$export$ead1fecec2ecf57c);
    $parcel$export(module.exports, "absoluteBreakoutWidth", ()=>$fc8564cd32ff5fc7$export$b34ea040d1533a3);
    $parcel$export(module.exports, "calcWideWidth", ()=>$fc8564cd32ff5fc7$export$86325001fe8f3adc);
    $parcel$export(module.exports, "calcBreakoutWidth", ()=>$fc8564cd32ff5fc7$export$5f4502874a28dfce);
    $parcel$export(module.exports, "calcBreakoutWithCustomWidth", ()=>$fc8564cd32ff5fc7$export$ccc0a02edddeed39);
    $parcel$export(module.exports, "calculateBreakoutStyles", ()=>$fc8564cd32ff5fc7$export$c377853ecdd53e5b);
    $parcel$export(module.exports, "calcBreakoutWidthPx", ()=>$fc8564cd32ff5fc7$export$586300c53bd298dd);
    $parcel$export(module.exports, "getNextBreakoutMode", ()=>$fc8564cd32ff5fc7$export$7eb758567e6644fd);
    $parcel$export(module.exports, "getTitle", ()=>$fc8564cd32ff5fc7$export$70d1bf7729efff40);
    var $70yok;
    var $hnzQ2;
    var $6MTWT;
    var $caFD8;
    var $jIV3M;
    const $fc8564cd32ff5fc7$export$ead1fecec2ecf57c = {
        padding: (0, (0, parcelRequire("70yok")).akEditorBreakoutPadding),
        defaultLayoutWidth: (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth),
        wideScaleRatio: (0, (0, parcelRequire("70yok")).breakoutWideScaleRatio),
        fullWidthLayoutWidth: (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth),
        wideLayoutWidth: (0, (0, parcelRequire("70yok")).akEditorWideLayoutWidth),
        mapBreakpointToLayoutMaxWidth: (0, parcelRequire("6MTWT")).mapBreakpointToLayoutMaxWidth,
        getBreakpoint: (0, parcelRequire("caFD8")).getBreakpoint,
        calcBreakoutWidth: (layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    let wideWidth = $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
        calcLineLength: ()=>$fc8564cd32ff5fc7$export$ead1fecec2ecf57c.defaultLayoutWidth,
        calcWideWidth: (containerWidth = $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.padding);
            const layoutMaxWidth = $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($fc8564cd32ff5fc7$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
    };
    const $fc8564cd32ff5fc7$export$b34ea040d1533a3 = (layout, containerWidth)=>{
        const breakoutWidth = $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
        if (breakoutWidth.endsWith('%')) switch(layout){
            case 'full-width':
                return 0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth;
            case 'wide':
                return 0, (0, parcelRequire("70yok")).akEditorWideLayoutWidth;
            default:
                return $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($fc8564cd32ff5fc7$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        }
        return parseInt(breakoutWidth, 10);
    };
    const $fc8564cd32ff5fc7$export$86325001fe8f3adc = $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.calcWideWidth;
    const $fc8564cd32ff5fc7$export$5f4502874a28dfce = $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.calcBreakoutWidth;
    const $fc8564cd32ff5fc7$export$ccc0a02edddeed39 = (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $fc8564cd32ff5fc7$export$ead1fecec2ecf57c.padding;
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $fc8564cd32ff5fc7$export$5f4502874a28dfce(mode, editorContainerWidth);
    };
    function $fc8564cd32ff5fc7$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
        const breakoutWidth = $fc8564cd32ff5fc7$export$5f4502874a28dfce(mode, widthStateWidth);
        const breakoutWidthPx = (0, (0, parcelRequire("jIV3M")).parsePx)(breakoutWidth);
        if (!widthStateLineLength) return {
            type: 'line-length-unknown',
            width: breakoutWidth,
            minWidth: breakoutWidthPx,
            display: 'flex',
            justifyContent: 'center',
            transform: 'none',
            transition: `min-width 0.5s ${0, (0, parcelRequire("70yok")).akEditorSwoopCubicBezier}`
        };
        return {
            type: 'line-length-known',
            width: breakoutWidth,
            minWidth: breakoutWidthPx,
            transition: `min-width 0.5s ${0, (0, parcelRequire("70yok")).akEditorSwoopCubicBezier}`,
            transform: `translateX(-50%)`,
            marginLeft: `50%`
        };
    }
    function $fc8564cd32ff5fc7$export$586300c53bd298dd(mode, widthStateWidth, padding) {
        return (0, (0, parcelRequire("jIV3M")).parsePx)($fc8564cd32ff5fc7$export$5f4502874a28dfce(mode, widthStateWidth, padding));
    }
    const $fc8564cd32ff5fc7$export$7eb758567e6644fd = (currentMode)=>{
        if (currentMode === 'full-width') return 'center';
        else if (currentMode === 'wide') return 'full-width';
        return 'wide';
    };
    const $fc8564cd32ff5fc7$export$70d1bf7729efff40 = (layout)=>{
        switch(layout){
            case 'full-width':
                return (0, (0, parcelRequire("hnzQ2")).default).layoutFixedWidth;
            case 'wide':
                return (0, (0, parcelRequire("hnzQ2")).default).layoutFullWidth;
            default:
                return (0, (0, parcelRequire("hnzQ2")).default).layoutWide;
        }
    };
});
parcelRegister("hnzQ2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f023d473bec978e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4Aqlm;
    var $dC25E;
    var $g3XwM;
    var $7Z0Bw;
    var $pX2sZ;
    var $cAc9K;
    var $jGbSY;
    var $1lZME;
    var $bnPu7;
    var $a9uw8;
    var $lIcDG;
    var $jgzIF;
    var $4iJWu;
    var $5LgyQ;
    var $hMIh8;
    var $k6IO8;
    var $i6QGE;
    var $4GrnC;
    var $eUfMV;
    var $eyTh3;
    var $dKTBr;
    var $kvDhH;
    var $7Gd7P;
    var $glbxM;
    var $gOena;
    var $5ROCI;
    var $tsdau;
    var $dtPLE;
    var $2bKBY;
    var $5f023d473bec978e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        layoutFixedWidth: {
            id: 'fabric.editor.layoutFixedWidth',
            defaultMessage: 'Back to center',
            description: 'Display your element (image, table, extension, etc) as standard width'
        },
        layoutWide: {
            id: 'fabric.editor.layoutWide',
            defaultMessage: 'Go wide',
            description: 'Display your element (image, table, extension, etc) wider than normal'
        },
        layoutFullWidth: {
            id: 'fabric.editor.layoutFullWidth',
            defaultMessage: 'Go full width',
            description: 'Display your element (image, table, extension, etc) as full width'
        },
        alignImageRight: {
            id: 'fabric.editor.alignImageRight',
            defaultMessage: 'Align right',
            description: 'Aligns image to the right'
        },
        alignImageCenter: {
            id: 'fabric.editor.alignImageCenter',
            defaultMessage: 'Align center',
            description: 'Aligns image to the center'
        },
        alignImageLeft: {
            id: 'fabric.editor.alignImageLeft',
            defaultMessage: 'Align left',
            description: 'Aligns image to the left'
        },
        remove: {
            id: 'fabric.editor.remove',
            defaultMessage: 'Remove',
            description: 'Delete the element (image, panel, table, etc.) from your document'
        },
        removeEmoji: {
            id: 'fabric.editor.removeEmoji',
            defaultMessage: 'Remove emoji',
            description: 'Remove the emoji panel icon from custom panel'
        },
        visit: {
            id: 'fabric.editor.visit',
            defaultMessage: 'Open link in a new window',
            description: 'Open the link in a new window'
        },
        inviteToEditButtonTitle: {
            id: 'fabric.editor.editMode.inviteToEditButton.title',
            defaultMessage: 'Invite to edit',
            description: 'Invite another user to edit the current document'
        },
        saveButton: {
            id: 'fabric.editor.saveButton',
            defaultMessage: 'Save',
            description: 'Submit and save a comment or document'
        },
        cancelButton: {
            id: 'fabric.editor.cancelButton',
            defaultMessage: 'Cancel',
            description: 'Discard the current comment or document'
        },
        taskList: {
            id: 'fabric.editor.tooltip.taskList',
            defaultMessage: 'an action item',
            description: 'an action item in the Editor'
        },
        bulletList: {
            id: 'fabric.editor.tooltip.bulletList',
            defaultMessage: 'a list',
            description: 'a list item in the Editor'
        },
        nestedExpand: {
            id: 'fabric.editor.tooltip.nestedExpand',
            defaultMessage: 'a nested expand',
            description: 'expand node which is nested'
        },
        decisionList: {
            id: 'fabric.editor.tooltip.decisionList',
            defaultMessage: 'a decision list',
            description: 'a list of decisions'
        },
        defaultBlockNode: {
            id: 'fabric.editor.tooltip.defaultBlockNode',
            defaultMessage: 'a block node',
            description: 'a block node element'
        },
        panel: {
            id: 'fabric.editor.tooltip.blockPanel',
            defaultMessage: 'a panel',
            description: 'Panel node in the Editor'
        },
        blockquote: {
            id: 'fabric.editor.blockquote',
            defaultMessage: 'a quote',
            description: 'a quote node'
        },
        timeUpdated: {
            id: 'fabric.editor.time.updated',
            defaultMessage: 'Updated',
            description: 'Time last updated'
        },
        timeViewed: {
            id: 'fabric.editor.time.viewed',
            defaultMessage: 'Viewed',
            description: 'Time last viewed'
        },
        timeAgo: {
            id: 'fabric.editor.time.ago',
            defaultMessage: 'ago',
            description: 'Some time ago'
        },
        copyToClipboard: {
            id: 'fabric.editor.copyToClipboard',
            defaultMessage: 'Copy',
            description: 'Copy the whole content of the element to your clipboard'
        },
        copiedToClipboard: {
            id: 'fabric.editor.copiedToClipboard',
            defaultMessage: 'Copied!',
            description: 'Copied the whole content of the element to clipboard'
        }
    });
});
parcelRegister("4Aqlm", function(module, exports) {
    $parcel$export(module.exports, "alignmentMessages", ()=>$0d56943d78032909$export$5229ffea355cfdf6);
    var $7VHMR;
    const $0d56943d78032909$export$5229ffea355cfdf6 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        alignment: {
            id: 'fabric.editor.alignment',
            defaultMessage: 'Text alignment',
            description: 'Opens drop down menu of options to configure text alignment'
        },
        alignLeft: {
            id: 'fabric.editor.alignLeft',
            defaultMessage: 'Align left',
            description: 'label stating that text is aligned left'
        },
        alignCenter: {
            id: 'fabric.editor.alignCenter',
            defaultMessage: 'Align center',
            description: 'label stating that text is aligned center'
        },
        alignRight: {
            id: 'fabric.editor.alignRight',
            defaultMessage: 'Align right',
            description: 'label stating that text is aligned right'
        }
    });
});
parcelRegister("dC25E", function(module, exports) {
    $parcel$export(module.exports, "annotationMessages", ()=>$9bb8097c3ee9a5db$export$ff612ca71703201d);
    var $7VHMR;
    const $9bb8097c3ee9a5db$export$ff612ca71703201d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createComment: {
            id: 'fabric.editor.createComment',
            defaultMessage: 'Comment',
            description: 'Create/add an inline comment based on the users selection'
        },
        createCommentInvalid: {
            id: 'fabric.editor.createCommentInvalid',
            defaultMessage: 'You can only comment on text and headings',
            description: 'Error message to communicate to the user they can only do the current action in certain contexts'
        },
        createCommentDisabled: {
            id: 'fabric.editor.createCommentDisabled',
            defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
            description: 'Error message to communicate to the user they can only do the current action in certain contexts'
        },
        toolbar: {
            id: 'fabric.editor.annotationToolbar',
            defaultMessage: 'Annotation toolbar',
            description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
        },
        createCommentOnInlineNodeSpotlightBody: {
            id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
            defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
            description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
        },
        createCommentOnInlineNodeSpotlightAction: {
            id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
            defaultMessage: 'Got it',
            description: 'The content of the action button that closes the spotlight'
        }
    });
});
parcelRegister("g3XwM", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b4700b8e551aec64$export$defe85febe8b728c);
    var $7VHMR;
    const $b4700b8e551aec64$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        normal: {
            id: 'fabric.editor.normal',
            defaultMessage: 'Normal text',
            description: 'This is the default text style'
        },
        heading1: {
            id: 'fabric.editor.heading1',
            defaultMessage: 'Heading 1',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading1Description: {
            id: 'fabric.editor.heading1Description',
            defaultMessage: 'Use this for a top level heading',
            description: 'Description of the main heading, heading 1'
        },
        heading2: {
            id: 'fabric.editor.heading2',
            defaultMessage: 'Heading 2',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading2Description: {
            id: 'fabric.editor.heading2Description',
            defaultMessage: 'Use this for key sections',
            description: 'Description of a subtitle heading or secondary heading'
        },
        heading3: {
            id: 'fabric.editor.heading3',
            defaultMessage: 'Heading 3',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading3Description: {
            id: 'fabric.editor.heading3Description',
            defaultMessage: 'Use this for sub sections and group headings',
            description: ''
        },
        heading4: {
            id: 'fabric.editor.heading4',
            defaultMessage: 'Heading 4',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading4Description: {
            id: 'fabric.editor.heading4Description',
            defaultMessage: 'Use this for deep headings',
            description: ''
        },
        heading5: {
            id: 'fabric.editor.heading5',
            defaultMessage: 'Heading 5',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading5Description: {
            id: 'fabric.editor.heading5Description',
            defaultMessage: 'Use this for grouping list items',
            description: ''
        },
        heading6: {
            id: 'fabric.editor.heading6',
            defaultMessage: 'Heading 6',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading6Description: {
            id: 'fabric.editor.heading6Description',
            defaultMessage: 'Use this for low level headings',
            description: ''
        },
        blockquote: {
            id: 'fabric.editor.blockquote2',
            defaultMessage: 'Quote',
            description: 'Quote some text'
        },
        blockquoteDescription: {
            id: 'fabric.editor.blockquote.description',
            defaultMessage: 'Insert a quote or citation',
            description: 'Quote some text'
        },
        codeblock: {
            id: 'fabric.editor.codeblock',
            defaultMessage: 'Code snippet',
            description: 'Insert a snippet/segment of code (code block)'
        },
        codeblockDescription: {
            id: 'fabric.editor.codeblock.description',
            defaultMessage: 'Display code with syntax highlighting',
            description: 'Insert a snippet/segment of code (code block)'
        },
        infoPanel: {
            id: 'fabric.editor.infoPanel',
            defaultMessage: 'Info panel',
            description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
        },
        infoPanelDescription: {
            id: 'fabric.editor.infoPanel.description',
            defaultMessage: 'Highlight information in a colored panel',
            description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
        },
        notePanel: {
            id: 'fabric.editor.notePanel',
            defaultMessage: 'Note panel',
            description: 'Visually distinguishes your text by adding a note panel'
        },
        notePanelDescription: {
            id: 'fabric.editor.notePanel.description',
            defaultMessage: 'Add a note in a colored panel',
            description: 'Visually distinguishes your text by adding a note panel'
        },
        successPanel: {
            id: 'fabric.editor.successPanel',
            defaultMessage: 'Success panel',
            description: 'Visually distinguishes your text by adding a success panel'
        },
        successPanelDescription: {
            id: 'fabric.editor.successPanel.description',
            defaultMessage: 'Add tips in a colored panel',
            description: 'Visually distinguishes your text by adding a success panel'
        },
        warningPanel: {
            id: 'fabric.editor.warningPanel',
            defaultMessage: 'Warning panel',
            description: 'Visually distinguishes your text by adding a warning panel'
        },
        warningPanelDescription: {
            id: 'fabric.editor.warningPanel.description',
            defaultMessage: 'Add a note of caution in a colored panel',
            description: 'Visually distinguishes your text by adding a warning panel'
        },
        errorPanel: {
            id: 'fabric.editor.errorPanel',
            defaultMessage: 'Error panel',
            description: 'Visually distinguishes your text by adding a error panel'
        },
        errorPanelDescription: {
            id: 'fabric.editor.errorPanel.description',
            defaultMessage: 'Call out errors in a colored panel',
            description: 'Visually distinguishes your text by adding a error panel'
        },
        customPanel: {
            id: 'fabric.editor.customPanel',
            defaultMessage: 'Custom panel',
            description: 'Visually distinguishes your panel by adding a emoji icon and background color'
        },
        customPanelDescription: {
            id: 'fabric.editor.customPanel.description',
            defaultMessage: 'Add a note with an emoji and colored background',
            description: 'Visually distinguishes your panel by adding a emoji icon and background color '
        },
        panel: {
            id: 'fabric.editor.panel',
            defaultMessage: 'Panel',
            description: 'Visually distinguishes your text by adding a panel'
        },
        other: {
            id: 'fabric.editor.other',
            defaultMessage: 'Others...',
            description: 'Other text formatting'
        }
    });
});
parcelRegister("7Z0Bw", function(module, exports) {
    $parcel$export(module.exports, "codeBidiWarningMessages", ()=>$c6a78fae34ec3d9a$export$42bb270d1224182);
    var $7VHMR;
    const $c6a78fae34ec3d9a$export$42bb270d1224182 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'fabric.editor.codeBidiWarningLabel',
            defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
            description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
        }
    });
});
parcelRegister("pX2sZ", function(module, exports) {
    $parcel$export(module.exports, "linkMessages", ()=>$e6faf1c8e553c720$export$4ce3884394d6d9);
    var $7VHMR;
    const $e6faf1c8e553c720$export$4ce3884394d6d9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openLink: {
            id: 'fabric.editor.openLink',
            defaultMessage: 'Open link in a new tab',
            description: 'Opens the link in a new tab'
        }
    });
});
parcelRegister("cAc9K", function(module, exports) {
    $parcel$export(module.exports, "linkToolbarMessages", ()=>$a0be3cb6b7d43a2a$export$2d7676d841c8ae9);
    var $7VHMR;
    const $a0be3cb6b7d43a2a$export$2d7676d841c8ae9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addLink: {
            id: 'fabric.editor.mediaAddLink',
            defaultMessage: 'Add link',
            description: 'Add link'
        },
        unableToOpenLink: {
            id: 'fabric.editor.unableToOpenLink',
            defaultMessage: 'Unable to open this link',
            description: 'Unable to open this link'
        },
        unlink: {
            id: 'fabric.editor.unlink',
            defaultMessage: 'Unlink',
            description: 'Removes the hyperlink but keeps your text.'
        },
        editDatasourceStandalone: {
            id: 'fabric.editor.editDatasourceStandalone',
            defaultMessage: 'Edit',
            description: 'A standalone edit button to edit the datasource via a config modal'
        },
        editDatasourceStandaloneTooltip: {
            id: 'fabric.editor.editDatasourceStandaloneTooltip',
            defaultMessage: 'Edit search query',
            description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
        },
        editLink: {
            id: 'fabric.editor.editLink',
            defaultMessage: 'Edit link',
            description: 'Edit the link, update display text'
        },
        placeholder: {
            id: 'fabric.editor.hyperlinkToolbarPlaceholder',
            defaultMessage: 'Paste or search for link',
            description: 'Paste or search for link'
        },
        linkPlaceholder: {
            id: 'fabric.editor.linkPlaceholder',
            defaultMessage: 'Paste link',
            description: 'Create a new link by pasting a URL.'
        },
        linkAddress: {
            id: 'fabric.editor.linkAddress',
            defaultMessage: 'Link address',
            description: 'Insert the address of the link'
        },
        invalidLink: {
            id: 'fabric.editor.invalidLink',
            defaultMessage: 'Please enter a valid link.',
            description: 'Please enter a valid link.'
        },
        emptyLink: {
            id: 'fabric.editor.emptyLink',
            defaultMessage: 'Please enter a link.',
            description: 'Please enter a link.'
        },
        settingsLink: {
            id: 'fabric.editor.settingsLinks',
            defaultMessage: 'Go to Link Preferences',
            description: 'Go to Link Preferences'
        },
        editDatasource: {
            id: 'fabric.editor.edit.datasource',
            defaultMessage: 'Edit search query',
            description: 'Datasource toolbar edit button'
        },
        searchInput: {
            id: 'fabric.editor.edit.searchInput',
            defaultMessage: 'Add a link',
            description: 'Label for the search media input'
        }
    });
});
parcelRegister("jGbSY", function(module, exports) {
    $parcel$export(module.exports, "codeBlockButtonMessages", ()=>$286388266fccf9da$export$74e304339778e94d);
    var $7VHMR;
    const $286388266fccf9da$export$74e304339778e94d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyCodeToClipboard: {
            id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
            defaultMessage: 'Copy as text',
            description: 'Copy the content of the code block as text to your clipboard'
        },
        copiedCodeToClipboard: {
            id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
            defaultMessage: 'Copied!',
            description: 'Copied the content of the code block as text to clipboard'
        },
        wrapCode: {
            id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
            defaultMessage: 'Turn on wrap',
            description: 'Wrap the content of the code block'
        },
        unwrapCode: {
            id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
            defaultMessage: 'Turn off wrap',
            description: 'Wrap the content of the code block'
        },
        selectLanguage: {
            id: 'fabric.editor.selectLanguage',
            defaultMessage: 'Select language',
            description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
        }
    });
});
parcelRegister("1lZME", function(module, exports) {
    $parcel$export(module.exports, "toolbarInsertBlockMessages", ()=>$6bf2d26bf5846d3b$export$70c8a7203d95247);
    var $7VHMR;
    const $6bf2d26bf5846d3b$export$70c8a7203d95247 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        action: {
            id: 'fabric.editor.action',
            defaultMessage: 'Action item',
            description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
        },
        actionDescription: {
            id: 'fabric.editor.action.description',
            defaultMessage: 'Create and assign action items',
            description: ''
        },
        closeInsertRightRail: {
            id: 'fabric.editor.insertRightRail.close',
            defaultMessage: 'Close',
            description: 'Close button label'
        },
        link: {
            id: 'fabric.editor.link',
            defaultMessage: 'Link',
            description: 'Insert a hyperlink'
        },
        linkDescription: {
            id: 'fabric.editor.link.description',
            defaultMessage: 'Insert a link',
            description: 'Insert a hyperlink'
        },
        mediaFiles: {
            id: 'fabric.editor.mediaFiles',
            defaultMessage: 'Image, video, or file',
            description: 'Insert one or more files, videos or images'
        },
        addMediaFiles: {
            id: 'fabric.editor.addMediaFiles',
            defaultMessage: 'Add image, video, or file',
            description: 'Insert one or more files, videos or images'
        },
        insertRightRailTitle: {
            id: 'fabric.editor.insertRightRail.title',
            defaultMessage: 'Insert',
            description: 'Insert a node into the document'
        },
        mediaFilesDescription: {
            id: 'fabric.editor.mediaFiles.description',
            defaultMessage: 'Add images and other files to your page',
            description: 'Insert one or more files or images'
        },
        image: {
            id: 'fabric.editor.image',
            defaultMessage: 'Image',
            description: 'Insert an image.'
        },
        mention: {
            id: 'fabric.editor.mention',
            defaultMessage: 'Mention',
            description: 'Reference another person in your document'
        },
        mentionDescription: {
            id: 'fabric.editor.mention.description',
            defaultMessage: 'Mention someone to send them a notification',
            description: 'Reference another person in your document'
        },
        emoji: {
            id: 'fabric.editor.emoji',
            defaultMessage: 'Emoji',
            description: 'Insert an emoticon or smiley :-)'
        },
        emojiDescription: {
            id: 'fabric.editor.emoji.description',
            defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
            description: 'Insert an emoticon or smiley :-)'
        },
        table: {
            id: 'fabric.editor.table',
            defaultMessage: 'Table',
            description: 'Inserts a table in the document'
        },
        tableDescription: {
            id: 'fabric.editor.table.description',
            defaultMessage: 'Insert a table',
            description: 'Inserts a table in the document'
        },
        tableSelector: {
            id: 'fabric.editor.tableSelector',
            defaultMessage: 'Table size',
            description: 'Opens a table selector that lets you insert a table of custom size'
        },
        tableSelectorDescription: {
            id: 'fabric.editor.tableSelector.description',
            defaultMessage: 'Add a table using popup to select a custom size',
            description: 'Opens a table selector that lets you insert a table of a custom size'
        },
        tableSizeSelectorButton: {
            id: 'fabric.editor.tableSizeSelectorButton',
            defaultMessage: '{numberOfColumns} by {numberOfRows}',
            description: 'Creates a table of custom size'
        },
        tableSizeSelectorPopup: {
            id: 'fabric.editor.tableSizeSelectorPopup',
            defaultMessage: 'Table size selector',
            description: 'Table selector popup to create table of custom size'
        },
        expand: {
            id: 'fabric.editor.expand',
            defaultMessage: 'Expand',
            description: 'Inserts an expand in the document'
        },
        expandDescription: {
            id: 'fabric.editor.expand.description',
            defaultMessage: 'Insert an expand',
            description: 'Inserts an expand in the document'
        },
        decision: {
            id: 'fabric.editor.decision',
            defaultMessage: 'Decision',
            description: "Capture a decision you\u2019ve made"
        },
        decisionDescription: {
            id: 'fabric.editor.decision.description',
            defaultMessage: "Capture decisions so they\u2019re easy to track",
            description: "Capture a decision you\u2019ve made"
        },
        feedbackDialog: {
            id: 'fabric.editor.feedbackDialog',
            defaultMessage: 'Give feedback',
            description: 'Open the feedback dialog from editor'
        },
        feedbackDialogDescription: {
            id: 'fabric.editor.feedbackDialog.description',
            defaultMessage: 'Tell us about your experience using the new editor',
            description: 'Description for feedback option under quick insert dropdown'
        },
        horizontalRule: {
            id: 'fabric.editor.horizontalRule',
            defaultMessage: 'Divider',
            description: 'A horizontal rule or divider'
        },
        horizontalRuleDescription: {
            id: 'fabric.editor.horizontalRule.description',
            defaultMessage: 'Separate content with a horizontal line',
            description: 'A horizontal rule or divider'
        },
        date: {
            id: 'fabric.editor.date',
            defaultMessage: 'Date',
            description: 'Opens a date picker that lets you select a date'
        },
        dateDescription: {
            id: 'fabric.editor.date.description',
            defaultMessage: 'Add a date using a calendar',
            description: 'Opens a date picker that lets you select a date'
        },
        placeholderText: {
            id: 'fabric.editor.placeholderText',
            defaultMessage: 'Placeholder text',
            description: 'Inserts a text placeholder into the page'
        },
        placeholderTextDescription: {
            id: 'fabric.editor.placeholderText.description',
            defaultMessage: 'Insert a text placeholder into the page',
            description: 'Inserts a text placeholder into the page'
        },
        columns: {
            id: 'fabric.editor.columns',
            defaultMessage: 'Layouts',
            description: 'Create a multi column section or layout'
        },
        columnsDescription: {
            id: 'fabric.editor.columns.description',
            defaultMessage: 'Structure your page using sections',
            description: 'Create a multi column section or layout'
        },
        status: {
            id: 'fabric.editor.status',
            defaultMessage: 'Status',
            description: 'Inserts an item representing the status of an activity to task.'
        },
        statusDescription: {
            id: 'fabric.editor.status.description',
            defaultMessage: 'Add a custom status label',
            description: 'Inserts an item representing the status of an activity to task.'
        },
        viewMore: {
            id: 'fabric.editor.viewMore',
            defaultMessage: 'View more',
            description: ''
        },
        insertMenu: {
            id: 'fabric.editor.insertMenu',
            defaultMessage: 'Insert elements',
            description: 'Opens a menu of additional items that can be inserted into your document.'
        },
        help: {
            id: 'fabric.editor.help',
            defaultMessage: 'Help',
            description: 'Opens up the help dialog'
        },
        helpDescription: {
            id: 'fabric.editor.help.description',
            defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
            description: 'Browse all the keyboard shortcuts and markdown options'
        },
        recordVideo: {
            id: 'fabric.editor.recordVideo',
            defaultMessage: 'Record a Loom video',
            description: 'Record a Loom video'
        },
        addLoomVideo: {
            id: 'fabric.editor.addLoomVideo',
            defaultMessage: 'Record a Loom video',
            description: 'Record a Loom video'
        },
        addLoomVideoComment: {
            id: 'fabric.editor.addLoomVideoComment',
            defaultMessage: 'Record a Loom video comment',
            description: 'Record a Loom video comment'
        },
        recordVideoDescription: {
            id: 'fabric.editor.recordVideo.description',
            defaultMessage: 'Record and share your screen and thoughts',
            description: 'Record and share your screen and thoughts'
        },
        recordLoomShortTitle: {
            id: 'fabric.editor.recordLoomShortTitle',
            defaultMessage: 'Record',
            description: 'Record'
        },
        turnInto: {
            id: 'fabric.editor.turnInto',
            defaultMessage: 'Turn into',
            description: 'Turn selected texts into another element containing those texts'
        }
    });
});
parcelRegister("bnPu7", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$80ed282981502999$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $80ed282981502999$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        wrapLeft: {
            id: 'fabric.editor.wrapLeft',
            defaultMessage: 'Wrap left',
            description: 'Aligns your image to the left and wraps text around it.'
        },
        wrapRight: {
            id: 'fabric.editor.wrapRight',
            defaultMessage: 'Wrap right',
            description: 'Aligns your image to the right and wraps text around it.'
        },
        changeToMediaSingle: {
            id: 'fabric.editor.media_change_mediasingle',
            defaultMessage: 'Original size',
            description: 'In the context of a media inline image, it allows the user to convert it to media single'
        },
        changeToMediaInlineImage: {
            id: 'fabric.editor.media_change_mediainline_default',
            defaultMessage: 'Inline',
            description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
        },
        changeToMediaInlineImageCaptionWarning: {
            id: 'fabric.editor.media_change_mediainline_caption_warn',
            defaultMessage: 'Inline (caption will be removed)',
            description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
        }
    });
});
parcelRegister("a9uw8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7056f9614010e78b$export$defe85febe8b728c);
    var $7VHMR;
    const $7056f9614010e78b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        url: {
            id: 'fabric.editor.url',
            defaultMessage: 'Display URL',
            description: 'Convert the card to become a regular text-based hyperlink.'
        },
        block: {
            id: 'fabric.editor.displayBlock',
            defaultMessage: 'Display card',
            description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
        },
        inline: {
            id: 'fabric.editor.displayInline',
            defaultMessage: 'Display inline',
            description: 'Display link with the title only.'
        },
        embed: {
            id: 'fabric.editor.displayEmbed',
            defaultMessage: 'Display embed',
            description: 'Display link as an embedded object'
        },
        link: {
            id: 'fabric.editor.displayLink',
            defaultMessage: 'Display as text',
            description: 'Convert the card to become a regular text-based hyperlink.'
        },
        card: {
            id: 'fabric.editor.cardFloatingControls',
            defaultMessage: 'Card options',
            description: 'Options to change card type'
        },
        blockCardUnavailable: {
            id: 'fabric.editor.blockCardUnavailable',
            defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
            description: 'Warning message to show the user that this node cannot change its view'
        },
        displayOptionUnavailableInParentNode: {
            id: 'fabric.editor.displayOptionUnavailableInParentNode',
            defaultMessage: "This display option isn't available inside {node}",
            description: 'Warning message to show the user that this node option is not available inside a parent node type'
        },
        urlTitle: {
            id: 'fabric.editor.urlTitle',
            defaultMessage: 'URL',
            description: 'Title for option to convert the card to become a regular text-based hyperlink.'
        },
        blockTitle: {
            id: 'fabric.editor.blockTitle',
            defaultMessage: 'Card',
            description: 'Title for option to display link in the card view.'
        },
        inlineTitle: {
            id: 'fabric.editor.inlineTitle',
            defaultMessage: 'Inline',
            description: 'Title for option to display link in the inline view.'
        },
        embedTitle: {
            id: 'fabric.editor.embedTitle',
            defaultMessage: 'Embed',
            description: 'Title for option to display link as an embedded object.'
        },
        urlDescription: {
            id: 'fabric.editor.urlDescription',
            defaultMessage: 'Display link as URL',
            description: 'Description for option to convert the card to become a regular text-based hyperlink.'
        },
        blockDescription: {
            id: 'fabric.editor.blockDescription',
            defaultMessage: 'Display more information about a link, including a summary and actions',
            description: 'Description for option to display link in the card view.'
        },
        inlineDescription: {
            id: 'fabric.editor.inlineDescription',
            defaultMessage: 'Display link as inline text',
            description: 'Description for option to display link in the inline view.'
        },
        embedDescription: {
            id: 'fabric.editor.ecombedDescription',
            defaultMessage: 'Display an interactive preview of a link',
            description: 'Description for option to display link as an embedded object.'
        },
        editDropdownExpandIconLabel: {
            id: 'fabric.editor.editDropdownExpandIconLabel',
            defaultMessage: 'Expand dropdown menu',
            description: 'Text of an icon to expand the dropdown'
        },
        editDropdownTriggerTitle: {
            id: 'fabric.editor.editDropdownTriggerTitle',
            defaultMessage: 'Edit',
            description: 'Text of a button to trigger opening an edit dropdown'
        },
        editDropdownEditLinkTitle: {
            id: 'fabric.editor.editDropdownEditLinkTitle',
            defaultMessage: 'Edit link',
            description: 'Edit dropdown edit link button text'
        },
        editDropdownEditDatasourceTitle: {
            id: 'fabric.editor.editDropdownEditDatasourceTitle',
            defaultMessage: 'Edit search query',
            description: 'Edit dropdown edit datasource button text'
        },
        datasourceTitle: {
            id: 'fabric.editor.datasourceTitle',
            defaultMessage: 'Edit search query',
            description: 'Tooltip of button to edit a card into a datasource'
        },
        datasourceAppearanceTitle: {
            id: 'fabric.editor.datasourceAppearanceTitle',
            defaultMessage: 'List',
            description: 'Tooltip of button to change to datasource appearance'
        },
        datasourceJiraIssue: {
            id: 'fabric.editor.datasource.jiraIssue',
            defaultMessage: 'Jira Issues',
            description: 'Insert a jira datasource table'
        },
        datasourceJiraIssueDescription: {
            id: 'fabric.editor.datasource.jiraIssue.description',
            defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
            description: 'Insert a jira datasource table'
        },
        datasourceAssetsObjectsGeneralAvailability: {
            id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
            defaultMessage: 'Assets',
            description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
        },
        datasourceAssetsObjectsDescription: {
            id: 'fabric.editor.datasource.assetsObjects.description',
            defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
            description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
        },
        inlineOverlay: {
            id: 'fabric.editor.inlineOverlay',
            defaultMessage: 'Configure',
            description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
        },
        inlineConfigureLink: {
            id: 'fabric.editor.inlineConfigureLink',
            defaultMessage: 'Configure link',
            description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
        },
        inlineGoToLink: {
            id: 'fabric.editor.inlineGoToLink',
            defaultMessage: 'Go to link',
            description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
        },
        datasourceConfluenceSearch: {
            id: 'fabric.editor.datasource.confluenceSearch',
            defaultMessage: 'Insert Confluence list',
            description: 'Title shown for Confluence Search datasource on QuickInsert options'
        },
        datasourceConfluenceSearchDescription: {
            id: 'fabric.editor.datasource.confluenceSearch.description',
            defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
            description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
        }
    });
});
parcelRegister("lIcDG", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ac32542784238da5$export$defe85febe8b728c);
    var $7VHMR;
    const $ac32542784238da5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toolbarLabel: {
            id: 'fabric.editor.toolbarLabel',
            defaultMessage: 'Editor',
            description: 'Label for the ARIA region landmark'
        },
        pageActionsLabel: {
            id: 'fabric.editor.pageActionsLabel',
            defaultMessage: 'Page actions',
            description: 'Label for the ARIA region landmark'
        },
        editableContentLabel: {
            id: 'fabric.editor.editableContentLabel',
            defaultMessage: 'Editable content',
            description: 'Label for the ARIA region landmark'
        }
    });
});
parcelRegister("jgzIF", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$34fdfd94df91d716$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $34fdfd94df91d716$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        underline: {
            id: 'fabric.editor.underline',
            defaultMessage: 'Underline',
            description: 'Whether the text selection has underlined text'
        },
        strike: {
            id: 'fabric.editor.strike',
            defaultMessage: 'Strikethrough',
            description: 'Whether the text selection has crossed out text'
        },
        code: {
            id: 'fabric.editor.code',
            defaultMessage: 'Code',
            description: 'Whether the text selection has monospaced/code font'
        },
        codeOn: {
            id: 'fabric.editor.code.on',
            defaultMessage: '{textFormattingOff}, Code On',
            description: 'Reports that code formatting has been turned on'
        },
        subscript: {
            id: 'fabric.editor.subscript',
            defaultMessage: 'Subscript',
            description: 'Whether the text selection is written below the line in a slightly smaller size'
        },
        subscriptOffSuperscriptOn: {
            id: 'fabric.editor.subscript.off.superscript.on',
            defaultMessage: 'Subscript Off, Superscript On',
            description: 'Reports text formatting in case when subscript off and superscript on'
        },
        superscript: {
            id: 'fabric.editor.superscript',
            defaultMessage: 'Superscript',
            description: 'Whether the text selection is written above the line in a slightly smaller size'
        },
        superscriptOffSubscriptOn: {
            id: 'fabric.editor.superscript.off.subscript.on',
            defaultMessage: 'Superscript Off, Subscript On',
            description: 'Describe text formatting in case when Superscript Off and Subscript on'
        },
        clearFormatting: {
            id: 'fabric.editor.clearFormatting',
            defaultMessage: 'Clear formatting',
            description: 'Remove all rich text formatting from the selected text'
        },
        moreFormatting: {
            id: 'fabric.editor.moreFormatting',
            defaultMessage: 'More formatting',
            description: 'Clicking this will show a menu with additional formatting options'
        },
        textFormatting: {
            id: 'fabric.editor.textFormatting',
            defaultMessage: 'Text formatting',
            description: 'Aria label for the wrapper of text format buttons'
        },
        bold: {
            id: 'fabric.editor.bold',
            defaultMessage: 'Bold',
            description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
        },
        italic: {
            id: 'fabric.editor.italic',
            defaultMessage: 'Italic',
            description: 'This refers to italics or emphasized formatting.'
        },
        on: {
            id: 'fabric.editor.on',
            defaultMessage: '{formattingType} On',
            description: 'Reports that text formatting has been turned on'
        },
        off: {
            id: 'fabric.editor.off',
            defaultMessage: '{formattingType} Off',
            description: 'Reports that text formatting has been turned off'
        },
        textStyles: {
            id: 'fabric.editor.textStyles',
            defaultMessage: '{blockTypeName} Text styles',
            description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
        },
        textStylesTooltip: {
            id: 'fabric.editor.textStylesTooltip',
            defaultMessage: 'Text styles',
            description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
        },
        textFormattingOff: {
            id: 'fabric.editor.text.formatting.off',
            defaultMessage: 'Text formatting Off',
            description: 'Reports that text formatting has been turned off'
        },
        navigateToEditorToolbar: {
            id: 'fabric.editor.navigate.toolbar.editor',
            defaultMessage: 'Navigate to editor toolbar',
            description: 'Navigate to the main editor toolbar.'
        },
        navigateToFloatingToolbar: {
            id: 'fabric.editor.navigate.toolbar.floating',
            defaultMessage: 'Navigate to floating toolbar',
            description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
        }
    });
});
parcelRegister("4iJWu", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4f7a6d323beb190f$export$defe85febe8b728c);
    var $7VHMR;
    const $4f7a6d323beb190f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tableOptions: {
            id: 'fabric.editor.tableOptions',
            defaultMessage: 'Table options',
            description: 'Opens a menu with additional table options'
        },
        tableSizeIncreaseScreenReaderInformation: {
            id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
            defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
            description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
        },
        tableSizeDecreaseScreenReaderInformation: {
            id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
            defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
            description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
        },
        headerRow: {
            id: 'fabric.editor.headerRow',
            defaultMessage: 'Header row',
            description: 'Marks the first table row as a header row'
        },
        headerColumn: {
            id: 'fabric.editor.headerColumn',
            defaultMessage: 'Header column',
            description: 'Marks the first table column as a header row'
        },
        numberedColumn: {
            id: 'fabric.editor.numberedColumn',
            defaultMessage: 'Numbered column',
            description: 'Adds an auto-numbering column to your table'
        },
        collapseTable: {
            id: 'fabric.editor.collapseTable',
            defaultMessage: 'Collapse table',
            description: 'Wraps table in an expand'
        },
        resizeTable: {
            id: 'fabric.editor.tables.resizeTable',
            defaultMessage: 'Resize table',
            description: 'Tooltip displayed on custom table width resize hande'
        },
        insertColumn: {
            id: 'fabric.editor.insertColumn',
            defaultMessage: 'Insert column right',
            description: 'Inserts a new column to the right of selected column.'
        },
        addColumnLeft: {
            id: 'fabric.editor.addColumnLeft',
            defaultMessage: 'Add column left',
            description: 'Adds a new column to the left of selected column.'
        },
        addColumnRight: {
            id: 'fabric.editor.addColumnRight',
            defaultMessage: 'Add column right',
            description: 'Adds a new column to the right of selected column.'
        },
        insertColumnDrag: {
            id: 'fabric.editor.insertColumnDrag',
            defaultMessage: 'Insert column',
            description: 'Inserts a new column to the right of selected column.'
        },
        removeColumns: {
            id: 'fabric.editor.removeColumns',
            defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
            description: 'Deletes a table column.'
        },
        insertRow: {
            id: 'fabric.editor.insertRow',
            defaultMessage: 'Insert row below',
            description: 'Inserts a new row below the selected row.'
        },
        addRowAbove: {
            id: 'fabric.editor.addRowAbove',
            defaultMessage: 'Add row above',
            description: 'Adds a new row above the selected row.'
        },
        addRowBelow: {
            id: 'fabric.editor.addRowBelow',
            defaultMessage: 'Add row below',
            description: 'Adds a new row below the selected row.'
        },
        moveColumnLeft: {
            id: 'fabric.editor.moveColumnLeft',
            defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
            description: 'Moves a column or columns to the left.'
        },
        moveColumnRight: {
            id: 'fabric.editor.moveColumnRight',
            defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
            description: 'Moves a column or columns to the right.'
        },
        moveRowUp: {
            id: 'fabric.editor.moveRowUp',
            defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
            description: 'Moves a row or selected rows up.'
        },
        moveRowDown: {
            id: 'fabric.editor.moveDownDown',
            defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
            description: 'Moves a row or selected rows down.'
        },
        insertRowDrag: {
            id: 'fabric.editor.insertRowDrag',
            defaultMessage: 'Insert row',
            description: 'Inserts a new row below the selected row.'
        },
        removeRows: {
            id: 'fabric.editor.removeRows',
            defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
            description: 'Deletes a table row.'
        },
        rowNumbers: {
            id: 'fabrid.editor.rowNumbers',
            defaultMessage: 'Row numbers',
            desciption: 'Adds a number to each row except header row'
        },
        rowsAreInserted: {
            id: 'fabric.editor.rowsAreInserted',
            defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
            description: 'Assistive message following the insertion of row(s)'
        },
        rowsAreRemoved: {
            id: 'fabric.editor.rowsAreRemoved',
            defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
            description: 'Assistive message following the removal of row(s)'
        },
        rowSelected: {
            id: 'fabric.editor.rowSelected',
            defaultMessage: 'Row {index} of {total} selected',
            description: 'Assistive message following the selection of a row'
        },
        rowMovedUp: {
            id: 'fabric.editor.rowMovedUp',
            defaultMessage: 'Row moved up to {index} of {total}',
            description: 'Assistive message following the upward movement of a row'
        },
        rowMovedDown: {
            id: 'fabric.editor.rowMovedDown',
            defaultMessage: 'Row moved down to {index} of {total}',
            description: 'Assistive message following the downward movement of a row'
        },
        columnsAreInserted: {
            id: 'fabric.editor.columnsAreInserted',
            defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
            description: 'Assistive message following the insertion of column(s)'
        },
        columnsAreRemoved: {
            id: 'fabric.editor.columnsAreRemoved',
            defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
            description: 'Assistive message following the removal of column(s)'
        },
        columnSelected: {
            id: 'fabric.editor.columnSelected',
            defaultMessage: 'Column {index} of {total} selected',
            description: 'Assistive message following the selection of a column'
        },
        columnMovedLeft: {
            id: 'fabric.editor.columnMovedLeft',
            defaultMessage: 'Column moved left to {index} of {total}',
            description: 'Assistive message following the left movement of a column'
        },
        columnMovedRight: {
            id: 'fabric.editor.columnMovedRight',
            defaultMessage: 'Column moved right to {index} of {total}',
            description: 'Assistive message following the right movement of a column'
        },
        cellOptions: {
            id: 'fabric.editor.cellOptions',
            defaultMessage: 'Cell options',
            description: 'Opens a menu with options for the current table cell.'
        },
        confirmDeleteLinkedModalOKButton: {
            id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
            defaultMessage: 'Delete',
            description: 'Action button label for confirm modal when deleting a table linked to an extension.'
        },
        confirmDeleteLinkedModalMessage: {
            id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
            defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
            description: 'Message for confirm modal when deleting a table linked to an extension.'
        },
        confirmDeleteLinkedModalMessagePrefix: {
            id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
            defaultMessage: 'Deleting',
            description: 'prefix for confirmation dialog text'
        },
        confirmModalCheckboxLabel: {
            id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
            defaultMessage: 'Also delete connected elements',
            description: 'checkbox label text'
        },
        deleteElementTitle: {
            id: 'fabric.editor.extension.deleteElementTitle',
            defaultMessage: 'Delete element',
            description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
        },
        unnamedSource: {
            id: 'fabric.editor.extension.sourceNoTitledName',
            defaultMessage: 'this element',
            description: 'The current element without preset name been selected'
        },
        adjustColumns: {
            id: 'fabric.editor.tables.adjustColumn',
            defaultMessage: 'Adjust column',
            description: 'Tooltip displayed on table column resize handle'
        },
        cornerControl: {
            id: 'fabric.editor.cornerControl',
            defaultMessage: 'Highlight table',
            description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
        },
        cellBackground: {
            id: 'fabric.editor.cellBackground',
            defaultMessage: 'Cell background',
            description: 'Change the background color of a table cell.'
        },
        backgroundColor: {
            id: 'fabric.editor.backgroundColor',
            defaultMessage: 'Background color',
            description: 'Change the background color of a table cell.'
        },
        mergeCells: {
            id: 'fabric.editor.mergeCells',
            defaultMessage: 'Merge cells',
            description: 'Merge tables cells together.'
        },
        splitCell: {
            id: 'fabric.editor.splitCell',
            defaultMessage: 'Split cell',
            description: 'Split a merged table cell.'
        },
        clearCells: {
            id: 'fabric.editor.clearCells',
            defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
            description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
        },
        sortColumnASC: {
            id: 'fabric.editor.sortColumnASC',
            defaultMessage: "Sort column A \u2192 Z",
            description: 'Sort column in ascending order'
        },
        sortColumnDESC: {
            id: 'fabric.editor.sortColumnDESC',
            defaultMessage: "Sort column Z \u2192 A",
            description: 'Sort column in descending order'
        },
        sortColumnIncreasing: {
            id: 'fabric.editor.sortColumnIncreasing',
            defaultMessage: 'Sort increasing',
            description: 'Sort column in ascending order'
        },
        sortColumnDecreasing: {
            id: 'fabric.editor.sortColumnDecreasing',
            defaultMessage: 'Sort decreasing',
            description: 'Sort column in descending order'
        },
        canNotSortTable: {
            id: 'fabric.editor.canNotSortTable',
            defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
            description: `Split your cells to enable this feature`
        },
        distributeColumns: {
            id: 'fabric.editor.distributeColumns',
            defaultMessage: `Distribute columns`,
            description: `Distribute widths between selected columns`
        },
        lockColumnWidths: {
            id: 'fabric.editor.lockColumns',
            defaultMessage: 'Fixed column widths',
            description: 'Toggle button to enable fixed column widths'
        },
        rowControl: {
            id: 'fabric.editor.rowControl',
            defaultMessage: 'Highlight row',
            description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
        },
        rowDragHandle: {
            id: 'fabric.editor.rowDragHandle',
            defaultMessage: 'Row options',
            description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
        },
        columnDragHandle: {
            id: 'fabric.editor.columnDragHandle',
            defaultMessage: 'Column options',
            description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
        },
        fullWidthLabel: {
            id: 'fabric.editor.tableFullWidthLabel',
            defaultMessage: 'Full-width',
            description: 'Trigger table width to full-width mode'
        },
        startedColumnResize: {
            id: 'fabric.editor.tables.startedColumnResize',
            defaultMessage: 'Started column resize',
            description: 'Screen Reader announces when the user engages the column resizer'
        },
        focusedOtherResize: {
            id: 'fabric.editor.tables.otherResize',
            defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
            description: 'Screen Reader announces when the user switches to the left or right column resizer'
        },
        changedColumnWidth: {
            id: 'fabric.editor.tables.columnWidth',
            defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
            description: 'Screen Reader announces when the user modifies the column width'
        },
        columnResizeStop: {
            id: 'fabric.editor.tables.resizeStop',
            defaultMessage: 'Stopped resize',
            description: 'Screen Reader announces when the user discontinues the resizing operation'
        },
        columnResizeOverflow: {
            id: 'fabric.editor.tables.columnResizeOverflow',
            defaultMessage: 'You can only resize this column while the table has a scroll bar.',
            description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
        },
        columnResizeLast: {
            id: 'fabric.editor.tables.columnResizeLast',
            defaultMessage: 'You can only resize this column to the left.',
            description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
        },
        tableAlignmentOptions: {
            id: 'fabric.editor.tableAlignmentOptions',
            defaultMessage: 'Alignment options',
            description: 'Opens a menu with additional table alignment options'
        },
        alignTableCenter: {
            id: 'fabric.editor.alignTableCenter',
            defaultMessage: 'Align center',
            description: 'Aligns table to the center'
        },
        alignTableLeft: {
            id: 'fabric.editor.alignTableLeft',
            defaultMessage: 'Align left',
            description: 'Aligns table to the left'
        }
    });
});
parcelRegister("5LgyQ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ded515abaacc14a1$export$defe85febe8b728c);
    var $7VHMR;
    const $ded515abaacc14a1$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unorderedList: {
            id: 'fabric.editor.unorderedList',
            defaultMessage: 'Bullet list',
            description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
        },
        unorderedListDescription: {
            id: 'fabric.editor.unorderedList.description',
            defaultMessage: 'Create an unordered list',
            description: ''
        },
        orderedList: {
            id: 'fabric.editor.orderedList',
            defaultMessage: 'Numbered list',
            description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
        },
        orderedListDescription: {
            id: 'fabric.editor.orderedList.description',
            defaultMessage: 'Create an ordered list',
            description: ''
        },
        lists: {
            id: 'fabric.editor.lists',
            defaultMessage: 'Lists',
            description: 'Menu shows ordered/bullet list and unordered/numbered lists'
        },
        listsFormat: {
            id: 'fabric.editor.listsFormat',
            defaultMessage: 'List formatting',
            description: 'Aria label for the wrapper of list buttons'
        }
    });
});
parcelRegister("hMIh8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$cbf0d922f3968687$export$defe85febe8b728c);
    var $7VHMR;
    const $cbf0d922f3968687$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        undo: {
            id: 'fabric.editor.undo',
            defaultMessage: 'Undo',
            description: 'Undo the previously performed action.'
        },
        redo: {
            id: 'fabric.editor.redo',
            defaultMessage: 'Redo',
            description: 'Redo the previously undone action.'
        }
    });
});
parcelRegister("k6IO8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4de03882ebe41d74$export$defe85febe8b728c);
    var $7VHMR;
    const $4de03882ebe41d74$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.editor.statusPlaceholder',
            defaultMessage: 'Set a status',
            description: 'Placeholder description for an empty (new) status item in the editor'
        },
        editText: {
            id: 'fabric.editor.editStatusText',
            defaultMessage: 'Edit Status',
            description: 'Title for the input that changes the status text'
        },
        editColor: {
            id: 'fabric.editor.editStatusColor',
            defaultMessage: 'Edit Status Color',
            description: 'Title for the color picker that changes the status color'
        }
    });
});
parcelRegister("i6QGE", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d860fdeff20c78a5$export$defe85febe8b728c);
    var $7VHMR;
    const $d860fdeff20c78a5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editText: {
            id: 'fabric.editor.editDateText',
            defaultMessage: 'Edit Date',
            description: 'Title for the input that changes the date'
        },
        invalidDateError: {
            id: 'fabric.editor.invalidDateError',
            defaultMessage: 'Enter a valid date',
            description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
        },
        onKeyUpDownText: {
            id: 'fabric.editor.upDown',
            defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
            description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
        }
    });
});
parcelRegister("4GrnC", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$0db9f8d488396552$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $0db9f8d488396552$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        singleColumn: {
            id: 'fabric.editor.single',
            defaultMessage: 'Single column layout',
            description: 'Layout with one single column'
        },
        twoColumns: {
            id: 'fabric.editor.twoColumns',
            defaultMessage: 'Two columns layout',
            description: 'Layout with two columns of equal width'
        },
        threeColumns: {
            id: 'fabric.editor.threeColumns',
            defaultMessage: 'Three columns layout',
            description: 'Layout with three columns of equal width'
        },
        fourColumns: {
            id: 'fabric.editor.fourColumns',
            defaultMessage: 'Four columns layout',
            description: 'Layout with four columns of equal width'
        },
        fiveColumns: {
            id: 'fabric.editor.fiveColumns',
            defaultMessage: 'Five columns layout',
            description: 'Layout with five columns of equal width'
        },
        rightSidebar: {
            id: 'fabric.editor.rightSidebar',
            defaultMessage: 'Right sidebar layout',
            description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
        },
        leftSidebar: {
            id: 'fabric.editor.leftSidebar',
            defaultMessage: 'Left sidebar layout',
            description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
        },
        threeColumnsWithSidebars: {
            id: 'fabric.editor.threeColumnsWithSidebars',
            defaultMessage: 'Three columns with sidebars layout',
            description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
        },
        floatingToolbarRadioGroupAriaLabel: {
            id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
            defaultMessage: 'Layout options',
            description: "a floating toolbar radiogroup's aria label"
        },
        layoutPlaceholder: {
            id: 'fabric.editor.layout.placeholder',
            defaultMessage: 'Add content',
            description: 'Add placeholder text for empty layout'
        },
        columnOption: {
            id: 'fabric.editor.layout.columnOption',
            defaultMessage: '{count, plural, one {-column} other {{count}-columns}}',
            description: 'column option text for layout'
        }
    });
});
parcelRegister("eUfMV", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1e57218f7e7fb61b$export$defe85febe8b728c);
    var $7VHMR;
    const $1e57218f7e7fb61b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        indent: {
            id: 'fabric.editor.indent',
            defaultMessage: 'Indent',
            description: 'Indent a list item, paragraph or heading'
        },
        outdent: {
            id: 'fabric.editor.outdent',
            defaultMessage: 'Outdent',
            description: 'Outdent a list item, paragraph or heading'
        }
    });
});
parcelRegister("eyTh3", function(module, exports) {
    $parcel$export(module.exports, "avatarGroupMessages", ()=>$15ba62e9fb97a1fa$export$8a0e7c3f8f5b8868);
    var $7VHMR;
    const $15ba62e9fb97a1fa$export$8a0e7c3f8f5b8868 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editors: {
            id: 'fabric.editor.editors',
            defaultMessage: 'Editors',
            description: 'classifying the people that are currently editing the document'
        }
    });
});
parcelRegister("dKTBr", function(module, exports) {
    $parcel$export(module.exports, "findReplaceMessages", ()=>$e4486eadbec51b5f$export$b46a930e1a386b2e);
    var $7VHMR;
    const $e4486eadbec51b5f$export$b46a930e1a386b2e = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        find: {
            id: 'fabric.editor.find',
            defaultMessage: 'Find',
            description: 'The word or phrase to search for on the document'
        },
        matchCase: {
            id: 'fabric.editor.matchCase',
            defaultMessage: 'Match case',
            description: 'Toggle whether should also match case when searching for text'
        },
        findNext: {
            id: 'fabric.editor.findNext',
            defaultMessage: 'Find next',
            description: 'Locate the next occurrence of the word or phrase that was searched for'
        },
        findPrevious: {
            id: 'fabric.editor.findPrevious',
            defaultMessage: 'Find previous',
            description: 'Locate the previous occurrence of the word or phrase that was searched for'
        },
        closeFindReplaceDialog: {
            id: 'fabric.editor.closeFindReplaceDialog',
            defaultMessage: 'Close',
            description: 'Cancel search and close the "Find and Replace" dialog'
        },
        noResultsFound: {
            id: 'fabric.editor.noResultsFound',
            defaultMessage: 'No results',
            description: 'No matches were found for the word or phrase that was searched for'
        },
        resultsCount: {
            id: 'fabric.editor.resultsCount',
            description: 'Text for selected search match position and total results count',
            defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
        },
        findReplaceToolbarButton: {
            id: 'fabric.editor.findReplaceToolbarButton',
            defaultMessage: 'Find and replace',
            description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
        },
        replaceWith: {
            id: 'fabric.editor.replaceWith',
            defaultMessage: 'Replace with',
            description: 'The value that will replace the word or phrase that was searched for'
        },
        replace: {
            id: 'fabric.editor.replace',
            defaultMessage: 'Replace',
            description: 'Replace only the currently selected instance of the word or phrase'
        },
        replaceAll: {
            id: 'fabric.editor.replaceAll',
            defaultMessage: 'Replace all',
            description: 'Replace all instances of the word or phrase throughout the entire document'
        },
        replaceSuccess: {
            id: 'fabric.editor.replaceSuccess',
            defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
            description: 'Text when replacement succesfully done'
        }
    });
});
parcelRegister("kvDhH", function(module, exports) {
    $parcel$export(module.exports, "textColorMessages", ()=>$5c5c913fed889ad3$export$effb4ee8b6f74abe);
    var $7VHMR;
    const $5c5c913fed889ad3$export$effb4ee8b6f74abe = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        textColor: {
            id: 'fabric.editor.textColor',
            defaultMessage: '{selectedColorName} Text color',
            description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
        },
        textColorTooltip: {
            id: 'fabric.editor.textColorTooltip',
            defaultMessage: 'Text color',
            description: 'Toolip of menu that provides access to various colors of text.'
        }
    });
});
parcelRegister("7Gd7P", function(module, exports) {
    $parcel$export(module.exports, "tasksAndDecisionsMessages", ()=>$591eefa2d843fbed$export$273d864e9e6d0b1f);
    var $7VHMR;
    const $591eefa2d843fbed$export$273d864e9e6d0b1f = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        taskPlaceholder: {
            id: 'fabric.editor.taskPlaceholder',
            defaultMessage: "Type your action, use '@' to assign to someone.",
            description: 'Placeholder description for an empty action/task in the editor'
        },
        decisionPlaceholder: {
            id: 'fabric.editor.decisionPlaceholder',
            defaultMessage: "Add a decision\u2026",
            description: 'Placeholder description for an empty decision in the editor'
        },
        editAccessTitle: {
            id: 'fabric.editor.editAccessTitle',
            defaultMessage: 'You need edit access',
            description: 'Title in the popup when we click on action item checkbox without edit permission'
        },
        requestToEditDescription: {
            id: 'fabric.editor.requestToEditDescription',
            defaultMessage: 'When you request access, the page owner will receive a notification.',
            description: 'Description in the popup when we click on action item checkbox without edit permission'
        },
        requestToEdit: {
            id: 'fabric.editor.requestToEdit',
            defaultMessage: 'Request to edit',
            description: 'Button in the popup when we click on action item checkbox without edit permission'
        },
        dismiss: {
            id: 'fabric.editor.requestToEditDismiss',
            defaultMessage: 'Dismiss',
            description: 'Button in the popup when we click on dismiss without edit permission'
        }
    });
});
parcelRegister("glbxM", function(module, exports) {
    $parcel$export(module.exports, "placeholderTextMessages", ()=>$9ea130d29c96d980$export$ee8ab8a034b5a8bd);
    var $7VHMR;
    const $9ea130d29c96d980$export$ee8ab8a034b5a8bd = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholderTextPlaceholder: {
            id: 'fabric.editor.placeholderTextPlaceholder',
            defaultMessage: 'Add placeholder text',
            description: ''
        }
    });
});
parcelRegister("gOena", function(module, exports) {
    $parcel$export(module.exports, "pasteOptionsToolbarMessages", ()=>$0faec06e4bab78f5$export$703e803e9cb0cea4);
    var $7VHMR;
    const $0faec06e4bab78f5$export$703e803e9cb0cea4 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pasteOptions: {
            id: 'fabric.editor.pasteOptions',
            defaultMessage: 'Paste options',
            description: 'Opens a menu with additional paste options'
        },
        plainText: {
            id: 'fabric.editor.plainText',
            defaultMessage: 'Use plain text',
            description: 'Converts pasted text into plain text'
        },
        markdown: {
            id: 'fabric.editor.useMarkdown',
            defaultMessage: 'Use Markdown',
            description: 'Converts pasted text into Markdown'
        },
        richText: {
            id: 'fabric.editor.richText',
            defaultMessage: 'Use rich text',
            description: 'Converts pasted text into Rich text'
        }
    });
});
parcelRegister("5ROCI", function(module, exports) {
    $parcel$export(module.exports, "panelMessages", ()=>$8abe00f89cc8f2a1$export$7bb18eb6f9170174);
    var $7VHMR;
    const $8abe00f89cc8f2a1$export$7bb18eb6f9170174 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        info: {
            id: 'fabric.editor.info',
            defaultMessage: 'Info',
            description: 'Panels provide a way to highlight text. The info panel has a blue background.'
        },
        note: {
            id: 'fabric.editor.note',
            defaultMessage: 'Note',
            description: 'Panels provide a way to highlight text. The note panel has a purple background.'
        },
        success: {
            id: 'fabric.editor.success',
            defaultMessage: 'Success',
            description: 'Panels provide a way to highlight text. The success panel has a green background.'
        },
        warning: {
            id: 'fabric.editor.warning',
            defaultMessage: 'Warning',
            description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
        },
        error: {
            id: 'fabric.editor.error',
            defaultMessage: 'Error',
            description: 'Panels provide a way to highlight text. The error panel has a red background.'
        },
        emoji: {
            id: 'fabric.editor.panel.emoji',
            defaultMessage: 'Add emoji',
            description: 'Select the panel icon'
        },
        backgroundColor: {
            id: 'fabric.editor.panel.backgroundColor',
            defaultMessage: 'Background color',
            description: 'Select the panel background color.'
        },
        panelsGroup: {
            id: 'fabric.editor.panel.panelsGroup',
            defaultMessage: 'Panel Types',
            description: 'aria-label for group of panels the floating toolbar'
        }
    });
});
parcelRegister("tsdau", function(module, exports) {
    $parcel$export(module.exports, "mentionMessages", ()=>$20652424ee2f9d73$export$33aafd5ccbbbd00a);
    var $7VHMR;
    const $20652424ee2f9d73$export$33aafd5ccbbbd00a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteItemTitle: {
            id: 'fabric.editor.inviteItem.title',
            defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
            description: 'Title of the invite teammate item in typeahead plugin'
        },
        mentionsAddLabel: {
            id: 'fabric.editor.mentionsAddLabel',
            defaultMessage: 'add-icon',
            description: 'icon label to describe adding a new mention'
        },
        mentionsIconLabel: {
            id: 'fabric.editor.mentionsIconLabel',
            defaultMessage: 'Mention',
            description: 'icon label to describe the mention icon'
        },
        mentionsNodeLabel: {
            id: 'fabric.editor.mentionNode.label',
            defaultMessage: 'Tagged user',
            description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
        }
    });
});
parcelRegister("dtPLE", function(module, exports) {
    $parcel$export(module.exports, "helpDialogMessages", ()=>$a46d01c595e7608c$export$83c85447c71428ba);
    var $7VHMR;
    const $a46d01c595e7608c$export$83c85447c71428ba = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editorHelp: {
            id: 'fabric.editor.editorHelp',
            defaultMessage: 'Editor help',
            description: 'Title of editor help dialog.'
        },
        helpDialogTips: {
            id: 'fabric.editor.helpDialogTips',
            defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
            description: 'Hint about how to open a dialog quickly using a shortcut.'
        },
        keyboardShortcuts: {
            id: 'fabric.editor.keyboardShortcuts',
            defaultMessage: 'Keyboard shortcuts',
            description: ''
        },
        markdown: {
            id: 'fabric.editor.markdown',
            defaultMessage: 'Markdown',
            description: 'It is a name of popular markup language.'
        },
        pastePlainText: {
            id: 'fabric.editor.pastePlainText',
            defaultMessage: 'Paste plain text',
            description: ''
        },
        CheckUncheckActionItem: {
            id: 'fabric.editor.checkUncheckActionItem',
            defaultMessage: 'Toggle action item',
            description: 'For Check/Uncheck Action item use shortcut'
        },
        InsertTableColumn: {
            id: 'fabric.editor.insertTableColumn',
            defaultMessage: 'Insert table column',
            description: 'For insert table column'
        },
        InsertTableRow: {
            id: 'fabric.editor.insertTableRow',
            defaultMessage: 'Insert table row',
            description: 'For insert table row'
        },
        altText: {
            id: 'fabric.editor.altText',
            defaultMessage: 'Alt text',
            description: 'Alternative text for image.'
        },
        selectTableRow: {
            id: 'fabric.editor.selectTableRow',
            defaultMessage: 'Select table row',
            description: 'Hint for selecting a table row using a shortcut'
        },
        selectTableColumn: {
            id: 'fabric.editor.selectTableColumn',
            defaultMessage: 'Select table column',
            description: 'Hint for selecting a table column using a shortcut'
        },
        selectColumnResize: {
            id: 'fabric.editor.selectColumnResize',
            defaultMessage: 'Select column resize',
            description: 'Hint for selecting a column resize a shortcut'
        },
        increaseSize: {
            id: 'fabric.editor.increaseSize',
            defaultMessage: 'Increase table or media size',
            description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
        },
        decreaseSize: {
            id: 'fabric.editor.decreaseSize',
            defaultMessage: 'Decrease table or media size',
            description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
        },
        openCellOptions: {
            id: 'fabric.editor.openCellOptions',
            defaultMessage: 'Open cell options',
            description: 'Keyboard shortcut to open cell options.'
        },
        focusTableResizeHandle: {
            id: 'fabric.editor.focusTableResizeHandle',
            defaultMessage: 'Focus table resize handle',
            description: 'Focus table resize handle'
        },
        closeHelpDialog: {
            id: 'fabric.editor.closeHelpDialog',
            defaultMessage: 'Close help dialog',
            description: ''
        },
        quickInsert: {
            id: 'fabric.editor.quickInsert',
            defaultMessage: 'Quick insert',
            description: 'Name of a feature, which let you insert items quickly.'
        },
        highlightColor: {
            id: 'fabric.editor.highlightColor',
            defaultMessage: 'Toggle highlight color palette',
            description: 'Keyboard shortcut to toggle highlight color palette.'
        }
    });
});
parcelRegister("2bKBY", function(module, exports) {
    $parcel$export(module.exports, "mediaInsertMessages", ()=>$1f990a5b3e363af7$export$7eb9dc59242bbc45);
    var $7VHMR;
    const $1f990a5b3e363af7$export$7eb9dc59242bbc45 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadPreview: {
            id: 'fabric.editor.media.insert.loadPreview',
            defaultMessage: 'Load preview',
            description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
        },
        insert: {
            id: 'fabric.editor.media.insert.insert',
            defaultMessage: 'Insert',
            description: 'Text on the modal action button that inserts the linked media file into the editor document'
        },
        pasteLinkToUpload: {
            id: 'fabric.editor.media.insert.pasteLinkToUpload',
            defaultMessage: 'Paste link to upload',
            description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
        },
        cancel: {
            id: 'fabric.editor.media.insert.cancel',
            defaultMessage: 'Cancel',
            description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
        },
        fromUrlErrorMessage: {
            id: 'fabric.editor.media.insert.fromUrlErrorMessage',
            defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
            description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
        },
        fromUrlWarning: {
            id: 'fabric.editor.media.insert.fromUrlWarning',
            defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
            description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
        },
        localFileNetworkErrorMessage: {
            id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
            defaultMessage: 'File upload error. Check file path or network.',
            description: 'Error message displayed when a network error occurs during file upload'
        },
        localFileErrorMessage: {
            id: 'fabric.editor.media.insert.localFileErrorMessage',
            defaultMessage: "This file couldn\u2019t be uploaded.",
            description: 'Generic catch-all error message displayed when file upload fails'
        },
        mediaAlt: {
            id: 'fabric.editor.media.insert.mediaAlt',
            defaultMessage: 'Preview for uploaded image or video file',
            description: 'Alt text describing a preview of an image uploaded.'
        },
        upload: {
            id: 'fabric.editor.media.insert.upload',
            defaultMessage: 'Upload',
            description: 'Text on a button that opens a file picker dialog to upload a media file'
        },
        linkTabTitle: {
            id: 'fabric.editor.media.insert.linkTabTitle',
            defaultMessage: 'Link',
            description: 'Title of the navigation tab that allows users to insert media from a URL or link'
        },
        fileTabTitle: {
            id: 'fabric.editor.media.insert.fileTabTitle',
            defaultMessage: 'File',
            description: 'Title of the navigation tab that allows users to upload local media files'
        },
        mediaPickerPopupAriaLabel: {
            id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
            defaultMessage: 'Media picker',
            description: 'Accessibility label for the media picker popup'
        },
        invalidUrlErrorMessage: {
            id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
            defaultMessage: 'Invalid link',
            description: 'Error message displayed when a user tries to insert media from an invalid URL'
        }
    });
});
parcelRegister("jIV3M", function(module, exports) {
    $parcel$export(module.exports, "walkUpTreeUntil", ()=>$7a4cb7e2b7143cd5$export$df14aaf7a527ab0c);
    $parcel$export(module.exports, "unwrap", ()=>$7a4cb7e2b7143cd5$export$debb760848ca95a);
    $parcel$export(module.exports, "removeNestedEmptyEls", ()=>$7a4cb7e2b7143cd5$export$5b66dc78851adb5e);
    $parcel$export(module.exports, "containsClassName", ()=>$7a4cb7e2b7143cd5$export$c8913a477cc44663);
    $parcel$export(module.exports, "closest", ()=>$7a4cb7e2b7143cd5$export$ff7f7c97cdce86e);
    $parcel$export(module.exports, "closestElement", ()=>$7a4cb7e2b7143cd5$export$d508bcfb7f019487);
    $parcel$export(module.exports, "parsePx", ()=>$7a4cb7e2b7143cd5$export$b0eef8cd00b29d5c);
    $parcel$export(module.exports, "maphElem", ()=>$7a4cb7e2b7143cd5$export$5b6ab01a6efa50e2);
    function $7a4cb7e2b7143cd5$export$df14aaf7a527ab0c(element, shouldStop) {
        let rootElement = element;
        while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
        return rootElement;
    }
    function $7a4cb7e2b7143cd5$export$debb760848ca95a(parent, wrapped) {
        const docsFragment = document.createDocumentFragment();
        Array.from(wrapped.children).forEach((child)=>{
            docsFragment.appendChild(child);
        });
        parent.replaceChild(docsFragment, wrapped);
    }
    function $7a4cb7e2b7143cd5$export$5b66dc78851adb5e(el) {
        while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
            const parentEl = el.parentElement;
            parentEl.removeChild(el);
            el = parentEl;
        }
    }
    const $7a4cb7e2b7143cd5$export$c8913a477cc44663 = (node, className)=>{
        if (!node) return false;
        if (node.classList && node.classList.contains) return node.classList.contains(className);
        if (!node.className) return false;
        const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
        return classNames.split(' ').indexOf(className) !== -1;
    };
    function $7a4cb7e2b7143cd5$export$ff7f7c97cdce86e(node, s) {
        if (!node) return null;
        let el = node;
        if (!document.documentElement || !document.documentElement.contains(el)) return null;
        if (el.closest) return el.closest(s);
        do {
            const matchfn = el.matches ? el.matches : el.msMatchesSelector;
            if (matchfn && matchfn.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        }while (el !== null && el.nodeType === 1)
        return null;
    }
    function $7a4cb7e2b7143cd5$export$d508bcfb7f019487(node, s) {
        return $7a4cb7e2b7143cd5$export$ff7f7c97cdce86e(node, s);
    }
    function $7a4cb7e2b7143cd5$export$b0eef8cd00b29d5c(pxStr) {
        if (!pxStr.endsWith('px')) return undefined;
        const maybeNumber = parseInt(pxStr, 10);
        return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
    }
    function $7a4cb7e2b7143cd5$export$b2d5d4f1aeebddf1(elem, callback) {
        const array = [];
        for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
        return array;
    }
    function $7a4cb7e2b7143cd5$export$5b6ab01a6efa50e2(elem, callback) {
        return $7a4cb7e2b7143cd5$export$b2d5d4f1aeebddf1(elem, callback);
    }
});
parcelRegister("6zogC", function(module, exports) {
    $parcel$export(module.exports, "RendererCssClassName", ()=>$fcf43aba79b88879$export$91f3bbbf974496e2);
    const $fcf43aba79b88879$var$clPrefix = 'ak-renderer-';
    const $fcf43aba79b88879$export$91f3bbbf974496e2 = {
        DOCUMENT: `${$fcf43aba79b88879$var$clPrefix}document`,
        EXTENSION: `${$fcf43aba79b88879$var$clPrefix}extension`,
        EXTENSION_CENTER_ALIGN: `${$fcf43aba79b88879$var$clPrefix}extension-center-align`,
        EXTENSION_OVERFLOW_CONTAINER: `${$fcf43aba79b88879$var$clPrefix}extension-overflow-container`,
        NUMBER_COLUMN: `${$fcf43aba79b88879$var$clPrefix}table-number-column`,
        SORTABLE_COLUMN_WRAPPER: `${$fcf43aba79b88879$var$clPrefix}tableHeader-sortable-column__wrapper`,
        SORTABLE_COLUMN: `${$fcf43aba79b88879$var$clPrefix}tableHeader-sortable-column`,
        SORTABLE_COLUMN_ICON_WRAPPER: `${$fcf43aba79b88879$var$clPrefix}tableHeader-sorting-icon__wrapper`,
        SORTABLE_COLUMN_NO_ORDER: `${$fcf43aba79b88879$var$clPrefix}tableHeader-sorting-icon__no-order`
    };
});
parcelRegister("lTPvl", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$8a014c88c45f1ad9$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $6SKbt;
    var $20EGj = parcelRequire("20EGj");
    var $6nkIt;
    var $4la1F;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $8a014c88c45f1ad9$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        fireAnalyticsEvent(event) {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $20EGj.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        }
        hasFallback() {
            return typeof this.props.fallbackComponent !== 'undefined';
        }
        shouldRecover() {
            return this.hasFallback() && this.state.errorCaptured;
        }
        componentDidCatch(error, errorInfo) {
            const additionalInfo = this.props.additionalInfo ?? '';
            this.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).CRASHED,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`,
                    componentStack: errorInfo?.componentStack || undefined,
                    errorRethrown: Boolean(this.props.rethrowError)
                }
            });
            (0, (0, parcelRequire("6nkIt")).logException)(error, {
                location: 'renderer'
            });
            const pattern = /Failed to execute.*on 'Node'.*/;
            const matchesPattern = pattern.test(error.message);
            if (matchesPattern) {
                this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).CAUGHT_DOM_ERROR,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                        errorMessage: `${additionalInfo}${error?.message}`
                    }
                });
                this.setState(()=>({
                        domError: true
                    }));
            }
            if (this.hasFallback()) this.setState({
                errorCaptured: true
            }, ()=>{
                if (this.props.rethrowError) throw error;
            });
        }
        render() {
            if (this.state.domError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: (0, ($parcel$interopDefault($7Jxgt)))()
            }, this.props.children);
            if (this.shouldRecover()) return this.props.fallbackComponent;
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                errorCaptured: false,
                domError: false
            };
        }
    }
});
parcelRegister("6nkIt", function(module, exports) {
    $parcel$export(module.exports, "logException", ()=>$e933c239a0a7d706$export$f86b2a1a2ce291b3);
    var $awSO7;
    const $e933c239a0a7d706$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
    const $e933c239a0a7d706$var$packageName = 'editor-common';
    const $e933c239a0a7d706$var$packageVersion = "0.0.0-use.local";
    const $e933c239a0a7d706$var$sanitiseSentryEvents = (data, _hint)=>{
        if (data.request) delete data.request.url;
        return data;
    };
    const $e933c239a0a7d706$export$f86b2a1a2ce291b3 = async (error, tags)=>{
        try {
            const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("VSnc9"));
            const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("lcj9W"));
            const sentryOptions = {
                dsn: (0, (0, parcelRequire("awSO7")).isFedRamp)() ? undefined : $e933c239a0a7d706$var$SENTRY_DSN,
                release: `${$e933c239a0a7d706$var$packageName}@${$e933c239a0a7d706$var$packageVersion}`,
                environment: undefined ?? 'unknown',
                ignoreErrors: [
                    /^network error/i,
                    /^network failure/i,
                    'TypeError: Failed to fetch',
                    'ResizeObserver loop limit exceeded',
                    /ResizeObserver loop completed with undelivered notifications/
                ],
                autoSessionTracking: false,
                integrations: (_integrations)=>[
                        ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                        new ExtraErrorData()
                    ],
                beforeSend: $e933c239a0a7d706$var$sanitiseSentryEvents
            };
            const client = new BrowserClient(sentryOptions);
            const hub = getCurrentHub();
            hub.bindClient(client);
            hub.withScope((scope)=>{
                scope.setTags({
                    'jira-bundler': window.BUNDLER_VERSION,
                    'jira-variant': window.BUILD_VARIANT,
                    'jira-release': window.BUILD_KEY,
                    'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                    ...tags
                });
                scope.clearBreadcrumbs();
                hub.captureException(error);
            });
            return client.close();
        } catch (_error) {}
    };
});
parcelRegister("awSO7", function(module, exports) {
    $parcel$export(module.exports, "isFedRamp", ()=>$f470ce04fa52958b$export$64d6499adf9b2e51);
    const $f470ce04fa52958b$var$FEDRAMP_MODERATE = 'fedramp-moderate';
    function $f470ce04fa52958b$export$64d6499adf9b2e51() {
        const global = globalThis;
        const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (env) return env === $f470ce04fa52958b$var$FEDRAMP_MODERATE;
        const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
        return matches ? matches.length > 0 : false;
    }
});
parcelRegister("VSnc9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fbG7h").then(()=>parcelRequire('b7J9p'));
});
parcelRegister("lcj9W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jDBFK").then(()=>parcelRequire('gdtZw'));
});
parcelRegister("4la1F", function(module, exports) {
    $parcel$export(module.exports, "PLATFORM", ()=>$a0af690a76761d75$export$88c4881e092abcaf);
    $parcel$export(module.exports, "MODE", ()=>$a0af690a76761d75$export$e48589d9e4824227);
    var $a0af690a76761d75$export$88c4881e092abcaf;
    (function(PLATFORM) {
        PLATFORM["NATIVE"] = "mobileNative";
        PLATFORM["HYBRID"] = "mobileHybrid";
        PLATFORM["WEB"] = "web";
    })($a0af690a76761d75$export$88c4881e092abcaf || ($a0af690a76761d75$export$88c4881e092abcaf = {}));
    var $a0af690a76761d75$export$e48589d9e4824227;
    (function(MODE) {
        MODE["RENDERER"] = "renderer";
        MODE["EDITOR"] = "editor";
    })($a0af690a76761d75$export$e48589d9e4824227 || ($a0af690a76761d75$export$e48589d9e4824227 = {}));
    var $a0af690a76761d75$var$RESOLVE_METHOD;
    (function(RESOLVE_METHOD) {
        RESOLVE_METHOD["COMPONENT"] = "component";
        RESOLVE_METHOD["CONSUMER"] = "consumer";
        RESOLVE_METHOD["ORPHANED"] = "orphaned";
    })($a0af690a76761d75$var$RESOLVE_METHOD || ($a0af690a76761d75$var$RESOLVE_METHOD = {}));
});
parcelRegister("bAXaR", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$089c70c3f0f7ee65$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "ACTION", ()=>$089c70c3f0f7ee65$export$9523889e0a5da4ba);
    $parcel$export(module.exports, "ACTION_SUBJECT", ()=>$089c70c3f0f7ee65$export$7525482b5931e326);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$089c70c3f0f7ee65$export$9957974f8b4d8f74);
    var $089c70c3f0f7ee65$export$76a2e4c433c23bb9;
    (function(EVENT_TYPE) {
        EVENT_TYPE["OPERATIONAL"] = "operational";
        EVENT_TYPE["SCREEN"] = "screen";
        EVENT_TYPE["TRACK"] = "track";
        EVENT_TYPE["UI"] = "ui";
    })($089c70c3f0f7ee65$export$76a2e4c433c23bb9 || ($089c70c3f0f7ee65$export$76a2e4c433c23bb9 = {}));
    var $089c70c3f0f7ee65$export$9523889e0a5da4ba;
    (function(ACTION) {
        ACTION["STARTED"] = "started";
        ACTION["RENDERED"] = "rendered";
        ACTION["RENDERER_TTI"] = "tti";
        ACTION["CRASHED"] = "unhandledErrorCaught";
        ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
        ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
        ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
        ACTION["CLICKED"] = "clicked";
        ACTION["VIEWED"] = "viewed";
        ACTION["VISITED"] = "visited";
        ACTION["SORT_COLUMN"] = "sortedColumn";
        ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
        ACTION["TOGGLE_EXPAND"] = "toggleExpand";
        ACTION["INSERTED"] = "inserted";
        ACTION["OPENED"] = "opened";
        ACTION["CLOSED"] = "closed";
        ACTION["DELETED"] = "deleted";
        ACTION["EDITED"] = "edited";
        ACTION["RESOLVED"] = "resolved";
        ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
        ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    })($089c70c3f0f7ee65$export$9523889e0a5da4ba || ($089c70c3f0f7ee65$export$9523889e0a5da4ba = {}));
    var $089c70c3f0f7ee65$export$7525482b5931e326;
    (function(ACTION_SUBJECT) {
        ACTION_SUBJECT["RENDERER"] = "renderer";
        ACTION_SUBJECT["BUTTON"] = "button";
        ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
        ACTION_SUBJECT["TABLE"] = "table";
        ACTION_SUBJECT["EXPAND"] = "expand";
        ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT["LINK"] = "link";
        ACTION_SUBJECT["ANNOTATION"] = "annotation";
        ACTION_SUBJECT["MEDIA"] = "media";
    })($089c70c3f0f7ee65$export$7525482b5931e326 || ($089c70c3f0f7ee65$export$7525482b5931e326 = {}));
    var $089c70c3f0f7ee65$export$9957974f8b4d8f74;
    (function(ACTION_SUBJECT_ID) {
        ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
        ACTION_SUBJECT_ID["LINK"] = "link";
        ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
        ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
        ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    })($089c70c3f0f7ee65$export$9957974f8b4d8f74 || ($089c70c3f0f7ee65$export$9957974f8b4d8f74 = {}));
});
parcelRegister("8foRb", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsPositionContext", ()=>$f4e83c249ff71783$export$8c8c3e12db6c0591);
    $parcel$export(module.exports, "AnnotationsWrapper", ()=>$f4e83c249ff71783$export$cef0157dd42cbb3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $eOk0h;
    var $d6S9D;
    var $clIqK;
    var $dmpPy;
    var $7WRSM;
    var $lwMsT;
    var $gtdQQ;
    var $820Yv;
    var $6c6bW;
    var $jaTuH;
    const $f4e83c249ff71783$var$LoadAnnotations = (0, ($parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
        (0, (0, parcelRequire("dmpPy")).useLoadAnnotations)({
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        });
        return null;
    });
    const $f4e83c249ff71783$export$8c8c3e12db6c0591 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        startPos: 1
    });
    const $f4e83c249ff71783$export$cef0157dd42cbb3f = (props)=>{
        const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
        const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
        const inlineCommentAnnotationsState = (0, (0, parcelRequire("7WRSM")).useAnnotationStateByTypeEvent)({
            type: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT,
            updateSubscriber: updateSubscriber || null
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("clIqK")).ProvidersContext).Provider, {
            value: annotationProvider
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("clIqK")).InlineCommentsStateContext).Provider, {
            value: inlineCommentAnnotationsState
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gtdQQ")).AnnotationRangeProvider), {
            allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("820Yv")).AnnotationHoverContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d6S9D")).AnnotationsContextWrapper), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f4e83c249ff71783$var$LoadAnnotations, {
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eOk0h")).AnnotationView), {
            isNestedRender: isNestedRender,
            createAnalyticsEvent: createAnalyticsEvent
        }), children)))));
    };
});
parcelRegister("eOk0h", function(module, exports) {
    $parcel$export(module.exports, "AnnotationView", ()=>$e1641edb3d04ebb1$export$41cd4a02859c2806);
    var $5uXOq = parcelRequire("5uXOq");
    var $clIqK;
    var $7WRSM;
    var $35dtk;
    const $e1641edb3d04ebb1$export$41cd4a02859c2806 = (props)=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("clIqK")).ProvidersContext));
        const actionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const inlineCommentProvider = providers && providers.inlineComment;
        const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
        const viewComponentProps = (0, (0, parcelRequire("7WRSM")).useAnnotationClickEvent)({
            updateSubscriber: updateSubscriber,
            createAnalyticsEvent: props.createAnalyticsEvent,
            isNestedRender: props.isNestedRender
        });
        const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
        const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
            actionContext
        ]);
        const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
            actionContext
        ]);
        if (ViewComponent && viewComponentProps) {
            const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ViewComponent, {
                annotations: annotations,
                clickElementTarget: clickElementTarget,
                deleteAnnotation: deleteAnnotation,
                getInlineNodeTypes: getInlineNodeTypes
            });
        }
        return null;
    };
});
parcelRegister("clIqK", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsDraftContext", ()=>$5317075acad88c27$export$365d1799d81a236d);
    $parcel$export(module.exports, "ProvidersContext", ()=>$5317075acad88c27$export$6a26b015ac619737);
    $parcel$export(module.exports, "InlineCommentsStateContext", ()=>$5317075acad88c27$export$aafe46a36ef535ba);
    $parcel$export(module.exports, "AnnotationsDraftContextWrapper", ()=>$5317075acad88c27$export$153126608e00390);
    var $5uXOq = parcelRequire("5uXOq");
    const $5317075acad88c27$export$365d1799d81a236d = (0, $5uXOq.createContext)(null);
    const $5317075acad88c27$export$6a26b015ac619737 = (0, $5uXOq.createContext)(null);
    const $5317075acad88c27$export$aafe46a36ef535ba = (0, $5uXOq.createContext)({});
    class $5317075acad88c27$export$153126608e00390 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children } = this.props;
            const { position: position } = this.state;
            const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
            const clearAnnotationDraft = this.clearAnnotationDraft;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($5317075acad88c27$export$365d1799d81a236d.Provider, {
                value: position
            }, children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }));
        }
        constructor(...args){
            super(...args);
            this.state = {
                position: null
            };
            this.applyAnnotationDraftAt = (nextPosition)=>{
                const { setDraftRange: setDraftRange } = this.props;
                setDraftRange();
                this.setState({
                    position: nextPosition
                });
            };
            this.clearAnnotationDraft = ()=>{
                const { clearDraftRange: clearDraftRange } = this.props;
                clearDraftRange();
                this.setState({
                    position: null
                });
            };
        }
    }
});
parcelRegister("7WRSM", function(module, exports) {
    $parcel$export(module.exports, "useAnnotationStateByTypeEvent", ()=>$816aedbe40d9f64e$export$95f9f9045e92d283);
    $parcel$export(module.exports, "useHasFocusEvent", ()=>$816aedbe40d9f64e$export$48f5d7f6702be07c);
    $parcel$export(module.exports, "useAnnotationClickEvent", ()=>$816aedbe40d9f64e$export$26cf539704e444c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $hj0ZZ;
    var $2H0Fr;
    var $88i6h;
    var $6SKbt;
    var $20EGj = parcelRequire("20EGj");
    const $816aedbe40d9f64e$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
        const [states, setStates] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber) return;
            const cb = (payload)=>{
                if (!payload) return;
                const nextStates = Object.values(payload).reduce((acc, curr)=>{
                    if (curr.id && curr.annotationType === type) {
                        const isEmpty = curr.state === null || curr.state === undefined;
                        return {
                            ...acc,
                            [curr.id]: !isEmpty ? curr.state : states[curr.id]
                        };
                    }
                    return acc;
                }, {});
                setStates({
                    ...states,
                    ...nextStates
                });
            };
            updateSubscriber.on((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }, [
            states,
            type,
            updateSubscriber
        ]);
        return states;
    };
    const $816aedbe40d9f64e$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
        const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("2H0Fr")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber) return;
            const cb = (payload)=>{
                setHasFocus(payload && payload.annotationId === id);
            };
            const removeFocus = ()=>{
                setHasFocus(false);
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            updateSubscriber.on((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            };
        }, [
            id,
            updateSubscriber,
            isInlineCommentsKbAccessible
        ]);
        return hasFocus;
    };
    const $816aedbe40d9f64e$export$26cf539704e444c1 = (props)=>{
        const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
        const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("2H0Fr")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber || isNestedRender) return;
            const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
                const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                        id: id,
                        type: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
                    }));
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).VIEWED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: annotationsByType.length || 0,
                        targetNodeType: eventTargetType,
                        method: viewMethod
                    }
                }).fire((0, $20EGj.FabricChannel).editor);
                setAnnotationClickEvent({
                    annotations: annotationsByType,
                    clickElementTarget: eventTarget
                });
            };
            const deselectCb = ()=>{
                setAnnotationClickEvent({
                    annotations: [],
                    clickElementTarget: undefined
                });
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            updateSubscriber.on((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }, [
            updateSubscriber,
            createAnalyticsEvent,
            isInlineCommentsKbAccessible,
            isNestedRender
        ]);
        return annotationClickEvent;
    };
});
parcelRegister("hj0ZZ", function(module, exports) {
    $parcel$export(module.exports, "AnnotationUpdateEvent", ()=>$9a73b36ee9af271e$export$c1c4b33b4e7b1c70);
    var $6Oghe = parcelRequire("6Oghe");
    var $9a73b36ee9af271e$export$c1c4b33b4e7b1c70;
    (function(AnnotationUpdateEvent) {
        AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
        AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
        AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
        AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
        AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    })($9a73b36ee9af271e$export$c1c4b33b4e7b1c70 || ($9a73b36ee9af271e$export$c1c4b33b4e7b1c70 = {}));
    class $9a73b36ee9af271e$export$7cc60aa9ef845515 {
        emit(event, params) {
            if (typeof params === 'undefined') return this.emitter.emit(event);
            return this.emitter.emit(event, params);
        }
        on(event, listener) {
            return this.emitter.on(event, listener);
        }
        off(event, listener) {
            return this.emitter.removeListener(event, listener);
        }
        listeners(event) {
            return this.emitter.listeners(event);
        }
        constructor(){
            this.emitter = new (0, ($parcel$interopDefault($6Oghe)))();
        }
    }
});
parcelRegister("6Oghe", function(module, exports) {
    'use strict';
    var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
    var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var $4f5409da028b4771$var$ReflectOwnKeys;
    if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
    else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function $4f5409da028b4771$var$EventEmitter() {
        $4f5409da028b4771$var$EventEmitter.init.call(this);
    }
    module.exports = $4f5409da028b4771$var$EventEmitter;
    module.exports.once = $4f5409da028b4771$var$once;
    $4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
    $4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
    $4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
    $4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
    var $4f5409da028b4771$var$defaultMaxListeners = 10;
    function $4f5409da028b4771$var$checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return $4f5409da028b4771$var$defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            $4f5409da028b4771$var$defaultMaxListeners = arg;
        }
    });
    $4f5409da028b4771$var$EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function $4f5409da028b4771$var$_getMaxListeners(that) {
        if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $4f5409da028b4771$var$_getMaxListeners(this);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) throw er;
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err;
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
            for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        $4f5409da028b4771$var$checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            m = $4f5409da028b4771$var$_getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $4f5409da028b4771$var$ProcessEmitWarning(w);
            }
        }
        return target;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, false);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
    $4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, true);
    };
    function $4f5409da028b4771$var$onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        $4f5409da028b4771$var$checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else $4f5409da028b4771$var$spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
    $4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
    }
    $4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, true);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, false);
    };
    $4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
    function $4f5409da028b4771$var$listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
    };
    function $4f5409da028b4771$var$arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function $4f5409da028b4771$var$spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function $4f5409da028b4771$var$unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function $4f5409da028b4771$var$once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') emitter.addEventListener(name, function wrapListener(arg) {
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
});
parcelRegister("35dtk", function(module, exports) {
    $parcel$export(module.exports, "RendererContext", ()=>$c04c0995a3bbaca9$export$1e9ea4edb6d1bfe6);
    $parcel$export(module.exports, "RendererActionsContext", ()=>$c04c0995a3bbaca9$export$66feffbad722f9d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $eTz5O;
    const $c04c0995a3bbaca9$export$1e9ea4edb6d1bfe6 = (0, ($parcel$interopDefault($5uXOq))).createContext(new (0, (0, parcelRequire("eTz5O")).default)());
    function $c04c0995a3bbaca9$export$66feffbad722f9d4({ children: children, context: context }) {
        const actions = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("eTz5O")).default)(true), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c04c0995a3bbaca9$export$1e9ea4edb6d1bfe6.Provider, {
            value: context || actions
        }, (0, ($parcel$interopDefault($5uXOq))).Children.only(children));
    }
    const $c04c0995a3bbaca9$export$d5fcf151601331bc = $c04c0995a3bbaca9$export$1e9ea4edb6d1bfe6.Consumer;
});
parcelRegister("eTz5O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96a7e018f56ec456$export$2e2bcd8739ae039);
    var $jLwE5;
    var $4UKgY;
    var $88i6h;
    var $gZGBX;
    var $eS2Dn;
    var $jDqXW;
    var $6SKbt;
    var $8UzU4;
    var $dAQq9;
    var $2oS3b;
    class $96a7e018f56ec456$export$2e2bcd8739ae039 {
        constructor(initFromContext = false){
            this.initFromContext = false;
            this.initFromContext = initFromContext;
            this.transformer = new (0, (0, parcelRequire("jLwE5")).JSONTransformer)();
        }
        _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
            if (!this.initFromContext) return;
            else if (!this.ref) this.ref = ref;
            else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
            this.doc = doc;
            this.schema = schema;
            this.onAnalyticsEvent = onAnalyticsEvent;
        }
        _privateUnregisterRenderer() {
            this.doc = undefined;
            this.ref = undefined;
            this.schema = undefined;
        }
        _privateValidatePositionsForAnnotation(from, to) {
            if (!this.doc || !this.schema) return false;
            if ((0, (0, parcelRequire("2oS3b")).fg)('forbid_comments_on_empty_newlines')) {
                const currentSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(this.doc, from, to);
                if ((0, (0, parcelRequire("4UKgY")).isEmptyTextSelection)(currentSelection, this.schema)) return false;
            }
            return (0, (0, parcelRequire("4UKgY")).canApplyAnnotationOnRange)({
                from: from,
                to: to
            }, this.doc, this.schema);
        }
        deleteAnnotation(annotationId, annotationType) {
            if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
            const mark = this.schema.marks.annotation.create({
                id: annotationId,
                annotationType: annotationType
            });
            let from;
            let to;
            let nodePos;
            let step;
            this.doc.descendants((node, pos)=>{
                const found = mark.isInSet(node.marks);
                if (found && node.type.name === 'media') nodePos = pos;
                if (found && !from) {
                    from = pos;
                    to = pos + node.nodeSize;
                } else if (found && from) to = pos + node.nodeSize;
                return true;
            });
            if (nodePos !== undefined) step = new (0, (0, parcelRequire("eS2Dn")).RemoveNodeMarkStep)(nodePos, mark);
            else {
                if (from === undefined || to === undefined) return false;
                step = new (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep)(from, to, mark);
            }
            const { doc: doc, failed: failed } = step.apply(this.doc);
            if (this.onAnalyticsEvent) {
                const payload = {
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).DELETED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    attributes: {
                        inlineNodeNames: step instanceof (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep) ? (0, (0, parcelRequire("dAQq9")).getRendererRangeInlineNodeNames)({
                            pos: {
                                from: from,
                                to: to
                            },
                            actions: this
                        }) : undefined
                    }
                };
                this.onAnalyticsEvent(payload);
            }
            if (!failed && doc) return {
                step: step,
                doc: this.transformer.encode(doc)
            };
            return false;
        }
        annotate(range, annotationId, annotationType) {
            if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
            const pos = (0, (0, parcelRequire("jDqXW")).getPosFromRange)(range);
            if (!pos) return false;
            const { from: from, to: to } = pos;
            const validPositions = this._privateValidatePositionsForAnnotation(from, to);
            if (!validPositions) return false;
            return this.applyAnnotation(pos, {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            });
        }
        isValidAnnotationRange(range) {
            if (!range) return false;
            if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (this.isRendererWithinRange(range)) return false;
            }
            const pos = (0, (0, parcelRequire("jDqXW")).getPosFromRange)(range);
            if (!pos || !this.doc) return false;
            return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
        }
        isRangeAnnotatable(range) {
            try {
                if (!range) return false;
                const { startContainer: startContainer, endContainer: endContainer } = range;
                if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
                return this.isValidAnnotationRange(range);
            } catch  {
                return false;
            }
        }
        isRendererWithinRange(range) {
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
            return false;
        }
        isValidAnnotationPosition(pos) {
            if (!pos || !this.doc) return false;
            return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
        }
        getPositionFromRange(range) {
            if (!this.doc || !this.schema || !range) return false;
            return (0, (0, parcelRequire("jDqXW")).getPosFromRange)(range);
        }
        getAnnotationMarks() {
            const { schema: schema, doc: doc } = this;
            if (!schema || !doc) return [];
            const { marks: { annotation: annotationMarkType } } = schema;
            if (!annotationMarkType) return [];
            const marks = [];
            doc.descendants((node)=>{
                const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
                if (!annotationsMark || !annotationsMark.length) return true;
                marks.push(...annotationsMark);
                return false;
            });
            const uniqueMarks = new Map();
            marks.forEach((m)=>{
                uniqueMarks.set(m.attrs.id, m);
            });
            return Array.from(uniqueMarks.values());
        }
        getAnnotationsByPosition(range) {
            if (!this.doc || !this.schema) return [];
            const pos = (0, (0, parcelRequire("jDqXW")).getPosFromRange)(range);
            if (!pos || !this.doc) return [];
            return (0, (0, parcelRequire("4UKgY")).getAnnotationIdsFromRange)(pos, this.doc, this.schema);
        }
        applyAnnotation(pos, annotation) {
            if (!this.doc || !pos || !this.schema) return false;
            const { from: from, to: to } = pos;
            const { annotationId: annotationId, annotationType: annotationType } = annotation;
            let step;
            let targetNodeType;
            const beforeNodePos = from;
            const possibleNode = this.doc.nodeAt(beforeNodePos);
            if (possibleNode?.type.name === 'media') {
                targetNodeType = 'media';
                step = new (0, (0, parcelRequire("eS2Dn")).AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                    id: annotationId,
                    type: annotationType
                }));
            } else {
                const resolvedNode = this.doc.resolve(from).node();
                targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
                step = (0, (0, parcelRequire("jDqXW")).createAnnotationStep)(from, to, {
                    annotationId: annotationId,
                    annotationType: annotationType,
                    schema: this.schema
                });
            }
            const { doc: doc, failed: failed } = step.apply(this.doc);
            if (failed || !doc) return false;
            const originalSelection = doc.textBetween(from, to);
            const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, (0, parcelRequire("8UzU4")).getIndexMatch)(this.doc, this.schema, originalSelection, from);
            return {
                step: step,
                doc: this.transformer.encode(doc),
                inlineNodeTypes: (0, (0, parcelRequire("dAQq9")).getRendererRangeInlineNodeNames)({
                    actions: this,
                    pos: {
                        from: from,
                        to: to
                    }
                }),
                originalSelection: originalSelection,
                numMatches: numMatches,
                matchIndex: matchIndex,
                pos: blockNodePos,
                targetNodeType: targetNodeType
            };
        }
        generateAnnotationIndexMatch(pos) {
            if (!this.doc || !pos || !this.schema) return false;
            const { from: from, to: to } = pos;
            const originalSelection = this.doc.textBetween(from, to);
            const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, (0, parcelRequire("8UzU4")).getIndexMatch)(this.doc, this.schema, originalSelection, from);
            return {
                originalSelection: originalSelection,
                numMatches: numMatches,
                matchIndex: matchIndex,
                pos: blockNodePos
            };
        }
        getInlineNodeTypes(annotationId) {
            if (!this.doc || !this.schema) return [];
            return (0, (0, parcelRequire("4UKgY")).getAnnotationInlineNodeTypes)({
                doc: this.doc,
                schema: this.schema
            }, annotationId);
        }
    }
});
parcelRegister("jLwE5", function(module, exports) {
    $parcel$export(module.exports, "SchemaStage", ()=>$17378af9f6eb90cc$export$933e6445c497ffd5);
    $parcel$export(module.exports, "JSONTransformer", ()=>$17378af9f6eb90cc$export$98cb1d9308d0944d);
    var $ajpes = parcelRequire("ajpes");
    var $8vlrc;
    var $cUwVZ;
    var $7kC9H;
    var $29Vii;
    var $8XeG6;
    var $bIGZ7;
    var $7agO8;
    var $g7Cky;
    var $9UDEr;
    var $kOFhM;
    var $9Dy9u;
    var $cqw4j;
    var $17378af9f6eb90cc$export$933e6445c497ffd5;
    (function(SchemaStage) {
        SchemaStage["FINAL"] = "final";
        SchemaStage["STAGE_0"] = "stage0";
    })($17378af9f6eb90cc$export$933e6445c497ffd5 || ($17378af9f6eb90cc$export$933e6445c497ffd5 = {}));
    const $17378af9f6eb90cc$var$isType = (type)=>(node)=>node.type.name === type;
    const $17378af9f6eb90cc$var$isCodeBlock = $17378af9f6eb90cc$var$isType('codeBlock');
    const $17378af9f6eb90cc$var$isMediaNode = $17378af9f6eb90cc$var$isType('media');
    const $17378af9f6eb90cc$var$isMediaInline = $17378af9f6eb90cc$var$isType('mediaInline');
    const $17378af9f6eb90cc$var$isMediaSingleNode = $17378af9f6eb90cc$var$isType('mediaSingle');
    const $17378af9f6eb90cc$var$isMentionNode = $17378af9f6eb90cc$var$isType('mention');
    const $17378af9f6eb90cc$var$isParagraph = $17378af9f6eb90cc$var$isType('paragraph');
    const $17378af9f6eb90cc$var$isHeading = $17378af9f6eb90cc$var$isType('heading');
    const $17378af9f6eb90cc$var$isTable = $17378af9f6eb90cc$var$isType('table');
    const $17378af9f6eb90cc$var$isTableCell = $17378af9f6eb90cc$var$isType('tableCell');
    const $17378af9f6eb90cc$var$isTableHeader = $17378af9f6eb90cc$var$isType('tableHeader');
    const $17378af9f6eb90cc$var$isLinkMark = $17378af9f6eb90cc$var$isType('link');
    const $17378af9f6eb90cc$var$isUnsupportedMark = $17378af9f6eb90cc$var$isType('unsupportedMark');
    const $17378af9f6eb90cc$var$isUnsupportedNodeAttributeMark = $17378af9f6eb90cc$var$isType('unsupportedNodeAttribute');
    const $17378af9f6eb90cc$var$isExpand = $17378af9f6eb90cc$var$isType('expand');
    const $17378af9f6eb90cc$var$isNestedExpand = $17378af9f6eb90cc$var$isType('nestedExpand');
    const $17378af9f6eb90cc$var$isUnsupportedNode = (node)=>$17378af9f6eb90cc$var$isType('unsupportedBlock')(node) || $17378af9f6eb90cc$var$isType('unsupportedInline')(node);
    const $17378af9f6eb90cc$var$isDataConsumer = $17378af9f6eb90cc$var$isType('dataConsumer');
    const $17378af9f6eb90cc$var$isFragmentMark = $17378af9f6eb90cc$var$isType('fragment');
    const $17378af9f6eb90cc$var$isHardBreak = $17378af9f6eb90cc$var$isType('hardBreak');
    const $17378af9f6eb90cc$var$filterNull = (subject)=>{
        let output = {
            ...subject
        };
        for(const key in output){
            const current = output[key];
            if (current === null) {
                const { [key]: unusedKey, ...filteredObj } = output;
                output = filteredObj;
            } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $17378af9f6eb90cc$var$filterNull(current);
        }
        return output;
    };
    const $17378af9f6eb90cc$var$createDocFromContent = (content)=>{
        return {
            version: 1,
            type: 'doc',
            content: content || []
        };
    };
    const $17378af9f6eb90cc$var$emptyDoc = $17378af9f6eb90cc$var$createDocFromContent([
        {
            type: 'paragraph',
            content: []
        }
    ]);
    const $17378af9f6eb90cc$var$toJSON = (node, mentionMap)=>{
        const obj = {
            type: node.type.name
        };
        if ($17378af9f6eb90cc$var$isUnsupportedNode(node)) return node.attrs.originalValue;
        else if ($17378af9f6eb90cc$var$isMediaNode(node)) obj.attrs = (0, (0, parcelRequire("7agO8")).toJSON)(node).attrs;
        else if ($17378af9f6eb90cc$var$isMediaSingleNode(node)) obj.attrs = (0, (0, parcelRequire("bIGZ7")).toJSON)(node).attrs;
        else if ($17378af9f6eb90cc$var$isMediaInline(node)) obj.attrs = (0, (0, parcelRequire("7agO8")).toJSON)(node).attrs;
        else if ($17378af9f6eb90cc$var$isMentionNode(node)) obj.attrs = (0, (0, parcelRequire("g7Cky")).toJSON)(node).attrs;
        else if ($17378af9f6eb90cc$var$isCodeBlock(node)) obj.attrs = (0, (0, parcelRequire("8vlrc")).toJSON)(node).attrs;
        else if ($17378af9f6eb90cc$var$isTable(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).tableToJSON)(node).attrs;
        else if ($17378af9f6eb90cc$var$isTableCell(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).toJSONTableCell)(node).attrs;
        else if ($17378af9f6eb90cc$var$isTableHeader(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).toJSONTableHeader)(node).attrs;
        else if ($17378af9f6eb90cc$var$isExpand(node) || $17378af9f6eb90cc$var$isNestedExpand(node)) obj.attrs = (0, (0, parcelRequire("7kC9H")).toJSON)(node).attrs;
        else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
        if (obj.attrs) obj.attrs = $17378af9f6eb90cc$var$filterNull(obj.attrs);
        if ($17378af9f6eb90cc$var$isMentionNode(node) && mentionMap) {
            const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
            const text = obj.attrs?.text ?? '';
            obj.attrs = {
                ...obj.attrs,
                text: !!text ? text : name
            };
        }
        if ($17378af9f6eb90cc$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
        if ($17378af9f6eb90cc$var$isHardBreak(node)) delete obj.attrs;
        if (node.isText) obj.text = node.textContent;
        else node.content.forEach((child)=>{
            obj.content = obj.content || [];
            obj.content.push($17378af9f6eb90cc$var$toJSON(child, mentionMap));
        });
        if ($17378af9f6eb90cc$var$isParagraph(node) || $17378af9f6eb90cc$var$isHeading(node)) obj.content = obj.content || [];
        if (node.marks.length) {
            const parsedMarks = node.marks.map((mark)=>{
                if ($17378af9f6eb90cc$var$isUnsupportedMark(mark)) return $17378af9f6eb90cc$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
                else if ($17378af9f6eb90cc$var$isUnsupportedNodeAttributeMark(mark)) return null;
                else if ($17378af9f6eb90cc$var$isLinkMark(mark)) return (0, (0, parcelRequire("8XeG6")).toJSON)(mark);
                else if ($17378af9f6eb90cc$var$isDataConsumer(mark)) {
                    const serialised = (0, (0, parcelRequire("cUwVZ")).toJSON)(mark);
                    return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
                } else if ($17378af9f6eb90cc$var$isFragmentMark(mark)) {
                    const fragmentMark = (0, (0, parcelRequire("29Vii")).toJSON)(mark);
                    if (!fragmentMark.attrs.localId) return null;
                    return fragmentMark;
                } else return mark.toJSON();
            }).filter((maybeMark)=>maybeMark !== null);
            obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
            const nodeAttributeMark = node.marks.find($17378af9f6eb90cc$var$isUnsupportedNodeAttributeMark);
            if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
                ...$17378af9f6eb90cc$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
            };
        }
        return obj;
    };
    const $17378af9f6eb90cc$var$canOverrideMark = (mark, existingMarks)=>{
        if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, (0, parcelRequire("9Dy9u")).markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
        return false;
    };
    const $17378af9f6eb90cc$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
        const nodeAttributes = node.type.spec.attrs;
        const attributes = {
            ...mark.attrs.unsupported,
            ...obj.attrs
        };
        for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
            const attribute = nodeAttributes ? nodeAttributes[key] : null;
            if (attribute) {
                if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                    ...attributes,
                    [key]: mark.attrs.unsupported[key]
                };
            }
        }
        return attributes;
    };
    class $17378af9f6eb90cc$export$98cb1d9308d0944d {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), mentionMap){
            this.schema = schema;
            this.mentionMap = mentionMap;
        }
        encode(node) {
            const content = [];
            node.content.forEach((child)=>{
                content.push((0, (0, parcelRequire("cqw4j")).sanitizeNode)($17378af9f6eb90cc$var$toJSON(child, this.mentionMap)));
            });
            if (!content || (0, ($parcel$interopDefault($ajpes)))(content, $17378af9f6eb90cc$var$emptyDoc.content)) return $17378af9f6eb90cc$var$createDocFromContent([]);
            return $17378af9f6eb90cc$var$createDocFromContent(content);
        }
        internalParse(content, schema) {
            const doc = schema.nodeFromJSON(content);
            doc.check();
            return doc;
        }
        parse(content, stage) {
            if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
            const schema = !!stage ? (0, (0, parcelRequire("kOFhM")).getSchemaBasedOnStage)(stage) : this.schema;
            if (!content.content || content.content.length === 0) return this.internalParse($17378af9f6eb90cc$var$emptyDoc, schema);
            return this.internalParse(content, schema);
        }
        encodeNode(node) {
            return (0, (0, parcelRequire("cqw4j")).sanitizeNode)($17378af9f6eb90cc$var$toJSON(node, this.mentionMap));
        }
    }
});
parcelRegister("9Dy9u", function(module, exports) {
    $parcel$export(module.exports, "markOverrideRuleFor", ()=>$2fd0b1fb0616ebf6$export$28e4e3c024cce988);
    const $2fd0b1fb0616ebf6$var$defaultAllowOverrideBehaviour = {
        canOverrideUnsupportedMark: ()=>{
            return true;
        }
    };
    const $2fd0b1fb0616ebf6$var$defaultDoNotAllowOverrideBehaviour = {
        canOverrideUnsupportedMark: ()=>{
            return false;
        }
    };
    const $2fd0b1fb0616ebf6$export$28e4e3c024cce988 = (type)=>{
        switch(type){
            case 'link':
            case 'em':
            case 'strong':
            case 'strike':
            case 'subsup':
            case 'underline':
            case 'code':
            case 'textColor':
            case 'backgroundColor':
            case 'confluenceInlineComment':
            case 'breakout':
            case 'alignment':
            case 'indentation':
            case 'border':
                return $2fd0b1fb0616ebf6$var$defaultAllowOverrideBehaviour;
            default:
                return $2fd0b1fb0616ebf6$var$defaultDoNotAllowOverrideBehaviour;
        }
    };
});
parcelRegister("cqw4j", function(module, exports) {
    $parcel$export(module.exports, "sanitizeNode", ()=>$6ac6cbf57f8f66ee$export$48b382180baf8e88);
    var $2O1uP;
    var $ayoEj;
    var $2oS3b;
    var $3dJwv;
    const $6ac6cbf57f8f66ee$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
    function $6ac6cbf57f8f66ee$export$48b382180baf8e88(json) {
        const sanitizedJSON = (0, (0, parcelRequire("ayoEj")).traverse)(json, {
            text: (node)=>{
                if (!node || !Array.isArray(node.marks)) return node;
                return {
                    ...node,
                    marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
                };
            },
            status: (node)=>{
                if (node.attrs && !!node.attrs.text) return (0, (0, parcelRequire("3dJwv")).removeNonAnnotationMarks)(node);
                return false;
            },
            caption: (node)=>{
                if (node.content) return node;
                return false;
            },
            tableCell: (node)=>{
                if ($6ac6cbf57f8f66ee$var$hasNestedTable(node) && (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_use_nested_table_pm_nodes')) return (0, (0, parcelRequire("2O1uP")).transformNestedTableNodeOutgoingDocument)(node);
            },
            tableHeader: (node)=>{
                if ($6ac6cbf57f8f66ee$var$hasNestedTable(node) && (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_use_nested_table_pm_nodes')) return (0, (0, parcelRequire("2O1uP")).transformNestedTableNodeOutgoingDocument)(node);
            },
            emoji: (0, (0, parcelRequire("3dJwv")).removeNonAnnotationMarks),
            mention: (0, (0, parcelRequire("3dJwv")).removeNonAnnotationMarks),
            date: (0, (0, parcelRequire("3dJwv")).removeNonAnnotationMarks),
            hardBreak: (0, (0, parcelRequire("3dJwv")).removeMarks),
            inlineCard: (0, (0, parcelRequire("3dJwv")).removeNonAnnotationMarks)
        });
        return sanitizedJSON;
    }
});
parcelRegister("2O1uP", function(module, exports) {
    $parcel$export(module.exports, "transformNestedTablesIncomingDocument", ()=>$e3b46785d08fdb13$export$18544d0b5f43e4a1);
    $parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", ()=>$e3b46785d08fdb13$export$8a334a7d9fe120ec);
    var $ayoEj;
    var $TzK9U;
    const $e3b46785d08fdb13$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.nesting', $e3b46785d08fdb13$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
    const $e3b46785d08fdb13$var$isNestedTableExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $e3b46785d08fdb13$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $e3b46785d08fdb13$var$NESTED_TABLE_EXTENSION_KEY;
    const $e3b46785d08fdb13$var$transformNestedTableExtension = (nestedTableExtension)=>{
        if (!nestedTableExtension.attrs?.parameters?.macroParams?.nestedContent) return false;
        try {
            return JSON.parse(nestedTableExtension.attrs?.parameters?.macroParams?.nestedContent.value);
        } catch (e) {
            throw new Error('Failed to parse nested table content');
        }
    };
    const $e3b46785d08fdb13$export$18544d0b5f43e4a1 = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("ayoEj")).traverse)(adf, {
            extension: (node)=>{
                if ($e3b46785d08fdb13$var$isNestedTableExtension(node)) {
                    isTransformed = true;
                    return $e3b46785d08fdb13$var$transformNestedTableExtension(node);
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
    const $e3b46785d08fdb13$export$8a334a7d9fe120ec = (tableCellNode)=>({
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                if (childNode?.type === 'table') return (0, (0, parcelRequire("TzK9U")).extension)({
                    extensionType: $e3b46785d08fdb13$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $e3b46785d08fdb13$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        macroParams: {
                            nestedContent: {
                                value: JSON.stringify(childNode)
                            }
                        }
                    }
                });
                return childNode;
            })
        });
});
parcelRegister("ayoEj", function(module, exports) {
    $parcel$export(module.exports, "traverse", ()=>$c329bf1cb5938bfc$export$df3f009e3d155b20);
    function $c329bf1cb5938bfc$export$735cfea22ce30f58(_visitors) {
        return true;
    }
    function $c329bf1cb5938bfc$export$df3f009e3d155b20(adf, visitors) {
        if (!$c329bf1cb5938bfc$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
        return $c329bf1cb5938bfc$var$traverseNode(adf, {
            node: undefined
        }, visitors, 0, 0);
    }
    function $c329bf1cb5938bfc$var$traverseNode(adfNode, parent, visitors, index, depth) {
        const visitor = visitors[adfNode.type] || visitors['any'];
        let newNode = {
            ...adfNode
        };
        if (visitor) {
            const processedNode = visitor({
                ...newNode
            }, parent, index, depth);
            if (processedNode === false) return false;
            newNode = processedNode || adfNode;
        }
        if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
            if (!node) return acc;
            const processedNode = $c329bf1cb5938bfc$var$traverseNode(node, {
                node: newNode,
                parent: parent
            }, visitors, idx, depth + 1);
            if (processedNode !== false) acc.push(processedNode);
            return acc;
        }, []);
        return newNode;
    }
});
parcelRegister("TzK9U", function(module, exports) {
    $parcel$export(module.exports, "extension", ()=>$c9441e2af6cf409b$export$1b45514b112dd749);
    const $c9441e2af6cf409b$export$1b45514b112dd749 = (attrs)=>({
            type: 'extension',
            attrs: attrs
        });
});
parcelRegister("3dJwv", function(module, exports) {
    $parcel$export(module.exports, "removeMarks", ()=>$e20b1dab7a055b2a$export$9bf001d8ef76e497);
    $parcel$export(module.exports, "removeNonAnnotationMarks", ()=>$e20b1dab7a055b2a$export$8cae9126fc577085);
    function $e20b1dab7a055b2a$export$9bf001d8ef76e497(node) {
        let newNode = {
            ...node
        };
        delete newNode.marks;
        return newNode;
    }
    function $e20b1dab7a055b2a$export$8cae9126fc577085(node) {
        let newNode = {
            ...node
        };
        if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
        return newNode;
    }
});
parcelRegister("4UKgY", function(module, exports) {
    $parcel$export(module.exports, "canApplyAnnotationOnRange", ()=>$5685536febbcda41$export$77ddf8216f9eb904);
    $parcel$export(module.exports, "getAnnotationIdsFromRange", ()=>$5685536febbcda41$export$badbcc229c848aec);
    $parcel$export(module.exports, "hasAnnotationMark", ()=>$5685536febbcda41$export$5fe1412b20386053);
    $parcel$export(module.exports, "containsAnyAnnotations", ()=>$5685536febbcda41$export$1976770b876b2728);
    $parcel$export(module.exports, "getRangeInlineNodeNames", ()=>$5685536febbcda41$export$35054451202ed5d9);
    $parcel$export(module.exports, "getAnnotationInlineNodeTypes", ()=>$5685536febbcda41$export$8261bc1f662f3f6e);
    $parcel$export(module.exports, "getAnnotationMarksForPos", ()=>$5685536febbcda41$export$bb1945a828f2864b);
    $parcel$export(module.exports, "isEmptyTextSelection", ()=>$5685536febbcda41$export$2efbc6d84ea0fbec);
    var $88i6h;
    var $2oS3b;
    const $5685536febbcda41$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
        const { from: from, to: to } = rangeSelection;
        if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
        let foundInvalid = false;
        doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
            if (schema.nodes.hardBreak === node.type) return false;
            if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                    foundInvalid = true;
                    return false;
                }
            } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
            return true;
        });
        return !foundInvalid;
    };
    const $5685536febbcda41$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
        const { from: from, to: to } = rangeSelection;
        let annotations = new Set();
        doc.nodesBetween(from, to, (node)=>{
            if (!node.marks) return true;
            node.marks.forEach((mark)=>{
                if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
            });
            return true;
        });
        return Array.from(annotations);
    };
    function $5685536febbcda41$export$5fe1412b20386053(node, state) {
        const { schema: { marks: { annotation: annotationMark } } } = state;
        return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
    }
    function $5685536febbcda41$export$1976770b876b2728(slice, state) {
        if (!slice.content.size) return false;
        let hasAnnotation = false;
        slice.content.forEach((node)=>{
            hasAnnotation = hasAnnotation || $5685536febbcda41$export$5fe1412b20386053(node, state);
            if (hasAnnotation) return true;
            node.descendants((node)=>{
                if ($5685536febbcda41$export$5fe1412b20386053(node, state)) {
                    hasAnnotation = true;
                    return false;
                }
                return true;
            });
        });
        return hasAnnotation;
    }
    function $5685536febbcda41$export$35054451202ed5d9({ doc: doc, pos: pos }) {
        if (!(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        let nodeNames = new Set();
        try {
            doc.nodesBetween(pos.from, pos.to, (node)=>{
                if (node.isInline) nodeNames.add(node.type.name);
            });
            const sortedNames = [
                ...nodeNames
            ].sort();
            return sortedNames;
        } catch  {
            return undefined;
        }
    }
    function $5685536febbcda41$export$8261bc1f662f3f6e(state, annotationId) {
        if (!(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        const mark = state.schema.marks.annotation.create({
            id: annotationId,
            annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
        });
        const inlineNodeNames = new Set();
        state.doc.descendants((node, pos)=>{
            if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
            return true;
        });
        return [
            ...inlineNodeNames
        ].sort();
    }
    function $5685536febbcda41$export$bb1945a828f2864b(pos) {
        if (!(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
        const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
        return annotationMarks;
    }
    function $5685536febbcda41$export$2efbc6d84ea0fbec(selection, schema) {
        const { text: text, paragraph: paragraph } = schema.nodes;
        let hasContent = false;
        selection.content().content.descendants((node)=>{
            if (node.type === paragraph && !node.content.size) return false;
            if (node.type !== text || !node.textContent) hasContent = true;
            return !hasContent;
        });
        return !hasContent;
    }
});
parcelRegister("gZGBX", function(module, exports) {
    $parcel$export(module.exports, "Selection", ()=>$c5f36586ce432e9f$export$52baac22726c72bf);
    $parcel$export(module.exports, "SelectionRange", ()=>$c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
    $parcel$export(module.exports, "TextSelection", ()=>$c5f36586ce432e9f$export$c2b25f346d19bcbb);
    $parcel$export(module.exports, "AllSelection", ()=>$c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    $parcel$export(module.exports, "NodeSelection", ()=>$c5f36586ce432e9f$export$e2940151ac854c0b);
    $parcel$export(module.exports, "Transaction", ()=>$c5f36586ce432e9f$export$febc5573c75cefb0);
    $parcel$export(module.exports, "EditorState", ()=>$c5f36586ce432e9f$export$afa855cbfaff27f2);
    $parcel$export(module.exports, "Plugin", ()=>$c5f36586ce432e9f$export$901cf72dabf2112a);
    $parcel$export(module.exports, "PluginKey", ()=>$c5f36586ce432e9f$export$1692d8b0e89cecc3);
    var $kCV8T;
    var $eS2Dn;
    const $c5f36586ce432e9f$var$classesById = Object.create(null);
    class $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head, ranges){
            this.$anchor = $anchor;
            this.$head = $head;
            this.ranges = ranges || [
                new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
            ];
        }
        get anchor() {
            return this.$anchor.pos;
        }
        get head() {
            return this.$head.pos;
        }
        get from() {
            return this.$from.pos;
        }
        get to() {
            return this.$to.pos;
        }
        get $from() {
            return this.ranges[0].$from;
        }
        get $to() {
            return this.ranges[0].$to;
        }
        get empty() {
            let ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
            return true;
        }
        content() {
            return this.$from.doc.slice(this.from, this.to, true);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let lastNode = content.content.lastChild, lastParent = null;
            for(let i = 0; i < content.openEnd; i++){
                lastParent = lastNode;
                lastNode = lastNode.lastChild;
            }
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, (0, parcelRequire("kCV8T")).Slice).empty : content);
                if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
            }
        }
        replaceWith(tr, node) {
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                let from = mapping.map($from.pos), to = mapping.map($to.pos);
                if (i) tr.deleteRange(from, to);
                else {
                    tr.replaceRangeWith(from, to, node);
                    $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
                }
            }
        }
        static findFrom($pos, dir, textOnly = false) {
            let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
            if (inner) return inner;
            for(let depth = $pos.depth - 1; depth >= 0; depth--){
                let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
                if (found) return found;
            }
            return null;
        }
        static near($pos, bias = 1) {
            return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
        }
        static atStart(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static atEnd(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static fromJSON(doc, json) {
            if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
            let cls = $c5f36586ce432e9f$var$classesById[json.type];
            if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
            return cls.fromJSON(doc, json);
        }
        static jsonID(id, selectionClass) {
            if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
            $c5f36586ce432e9f$var$classesById[id] = selectionClass;
            selectionClass.prototype.jsonID = id;
            return selectionClass;
        }
        getBookmark() {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
    class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
        constructor($from, $to){
            this.$from = $from;
            this.$to = $to;
        }
    }
    let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
    function $c5f36586ce432e9f$var$checkTextSelection($pos) {
        if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
            $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
            console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
        }
    }
    class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head = $anchor){
            $c5f36586ce432e9f$var$checkTextSelection($anchor);
            $c5f36586ce432e9f$var$checkTextSelection($head);
            super($anchor, $head);
        }
        get $cursor() {
            return this.$anchor.pos == this.$head.pos ? this.$head : null;
        }
        map(doc, mapping) {
            let $head = doc.resolve(mapping.map(this.head));
            if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
            let $anchor = doc.resolve(mapping.map(this.anchor));
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            super.replace(tr, content);
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                let marks = this.$from.marksAcross(this.$to);
                if (marks) tr.ensureMarks(marks);
            }
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
        }
        toJSON() {
            return {
                type: "text",
                anchor: this.anchor,
                head: this.head
            };
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
        }
        static create(doc, anchor, head = anchor) {
            let $anchor = doc.resolve(anchor);
            return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
        }
        static between($anchor, $head, bias) {
            let dPos = $anchor.pos - $head.pos;
            if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
            if (!$head.parent.inlineContent) {
                let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
                if (found) $head = found.$head;
                else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
            }
            if (!$anchor.parent.inlineContent) {
                if (dPos == 0) $anchor = $head;
                else {
                    $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                    if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
                }
            }
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
    class $c5f36586ce432e9f$var$TextBookmark {
        constructor(anchor, head){
            this.anchor = anchor;
            this.head = head;
        }
        map(mapping) {
            return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
        }
        resolve(doc) {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
        }
    }
    class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($pos){
            let node = $pos.nodeAfter;
            let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
            super($pos, $end);
            this.node = node;
        }
        map(doc, mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            let $pos = doc.resolve(pos);
            if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
            return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        }
        content() {
            return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(this.node), 0, 0);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
        }
        toJSON() {
            return {
                type: "node",
                anchor: this.anchor
            };
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
        }
        static create(doc, from) {
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
        }
        static isSelectable(node) {
            return !node.isText && node.type.spec.selectable !== false;
        }
    }
    $c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
    class $c5f36586ce432e9f$var$NodeBookmark {
        constructor(anchor){
            this.anchor = anchor;
        }
        map(mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
        }
        resolve(doc) {
            let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
            if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
            return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        }
    }
    class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor(doc){
            super(doc.resolve(0), doc.resolve(doc.content.size));
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                tr.delete(0, tr.doc.content.size);
                let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
                if (!sel.eq(tr.selection)) tr.setSelection(sel);
            } else super.replace(tr, content);
        }
        toJSON() {
            return {
                type: "all"
            };
        }
        static fromJSON(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        map(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
        }
        getBookmark() {
            return $c5f36586ce432e9f$var$AllBookmark;
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    const $c5f36586ce432e9f$var$AllBookmark = {
        map () {
            return this;
        },
        resolve (doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
    };
    function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
        if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
        for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
            let child = node.child(i);
            if (!child.isAtom) {
                let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
                if (inner) return inner;
            } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
            pos += child.nodeSize * dir;
        }
        return null;
    }
    function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
        let last = tr.steps.length - 1;
        if (last < startLen) return;
        let step = tr.steps[last];
        if (!(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep))) return;
        let map = tr.mapping.maps[last], end;
        map.forEach((_from, _to, _newFrom, newTo)=>{
            if (end == null) end = newTo;
        });
        tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
    }
    const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
    class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, (0, parcelRequire("eS2Dn")).Transform) {
        constructor(state){
            super(state.doc);
            this.curSelectionFor = 0;
            this.updated = 0;
            this.meta = Object.create(null);
            this.time = Date.now();
            this.curSelection = state.selection;
            this.storedMarks = state.storedMarks;
        }
        get selection() {
            if (this.curSelectionFor < this.steps.length) {
                this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
                this.curSelectionFor = this.steps.length;
            }
            return this.curSelection;
        }
        setSelection(selection) {
            if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
            this.curSelection = selection;
            this.curSelectionFor = this.steps.length;
            this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
            return this;
        }
        get selectionSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
        }
        setStoredMarks(marks) {
            this.storedMarks = marks;
            this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
            return this;
        }
        ensureMarks(marks) {
            if (!(0, (0, parcelRequire("kCV8T")).Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
            return this;
        }
        addStoredMark(mark) {
            return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
        }
        removeStoredMark(mark) {
            return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
        }
        get storedMarksSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
        }
        addStep(step, doc) {
            super.addStep(step, doc);
            this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
        }
        setTime(time) {
            this.time = time;
            return this;
        }
        replaceSelection(slice) {
            this.selection.replace(this, slice);
            return this;
        }
        replaceSelectionWith(node, inheritMarks = true) {
            let selection = this.selection;
            if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, (0, parcelRequire("kCV8T")).Mark).none));
            selection.replaceWith(this, node);
            return this;
        }
        deleteSelection() {
            this.selection.replace(this);
            return this;
        }
        insertText(text, from, to) {
            let schema = this.doc.type.schema;
            if (from == null) {
                if (!text) return this.deleteSelection();
                return this.replaceSelectionWith(schema.text(text), true);
            } else {
                if (to == null) to = from;
                to = to == null ? from : to;
                if (!text) return this.deleteRange(from, to);
                let marks = this.storedMarks;
                if (!marks) {
                    let $from = this.doc.resolve(from);
                    marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
                }
                this.replaceRangeWith(from, to, schema.text(text, marks));
                if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
                return this;
            }
        }
        setMeta(key, value) {
            this.meta[typeof key == "string" ? key : key.key] = value;
            return this;
        }
        getMeta(key) {
            return this.meta[typeof key == "string" ? key : key.key];
        }
        get isGeneric() {
            for(let _ in this.meta)return false;
            return true;
        }
        scrollIntoView() {
            this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
            return this;
        }
        get scrolledIntoView() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
        }
    }
    function $c5f36586ce432e9f$var$bind(f, self) {
        return !self || !f ? f : f.bind(self);
    }
    class $c5f36586ce432e9f$var$FieldDesc {
        constructor(name, desc, self){
            this.name = name;
            this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
            this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
        }
    }
    const $c5f36586ce432e9f$var$baseFields = [
        new $c5f36586ce432e9f$var$FieldDesc("doc", {
            init (config) {
                return config.doc || config.schema.topNodeType.createAndFill();
            },
            apply (tr) {
                return tr.doc;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("selection", {
            init (config, instance) {
                return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
            },
            apply (tr) {
                return tr.selection;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
            init (config) {
                return config.storedMarks || null;
            },
            apply (tr, _marks, _old, state) {
                return state.selection.$cursor ? tr.storedMarks : null;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
            init () {
                return 0;
            },
            apply (tr, prev) {
                return tr.scrolledIntoView ? prev + 1 : prev;
            }
        })
    ];
    class $c5f36586ce432e9f$var$Configuration {
        constructor(schema, plugins){
            this.schema = schema;
            this.plugins = [];
            this.pluginsByKey = Object.create(null);
            this.fields = $c5f36586ce432e9f$var$baseFields.slice();
            if (plugins) plugins.forEach((plugin)=>{
                if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
                this.plugins.push(plugin);
                this.pluginsByKey[plugin.key] = plugin;
                if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
            });
        }
    }
    class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
        constructor(config){
            this.config = config;
        }
        get schema() {
            return this.config.schema;
        }
        get plugins() {
            return this.config.plugins;
        }
        apply(tr) {
            return this.applyTransaction(tr).state;
        }
        filterTransaction(tr, ignore = -1) {
            for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
            }
            return true;
        }
        applyTransaction(rootTr) {
            if (!this.filterTransaction(rootTr)) return {
                state: this,
                transactions: []
            };
            let trs = [
                rootTr
            ], newState = this.applyInner(rootTr), seen = null;
            for(;;){
                let haveNew = false;
                for(let i = 0; i < this.config.plugins.length; i++){
                    let plugin = this.config.plugins[i];
                    if (plugin.spec.appendTransaction) {
                        let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                        let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                        if (tr && newState.filterTransaction(tr, i)) {
                            tr.setMeta("appendedTransaction", rootTr);
                            if (!seen) {
                                seen = [];
                                for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                    state: newState,
                                    n: trs.length
                                } : {
                                    state: this,
                                    n: 0
                                });
                            }
                            trs.push(tr);
                            newState = newState.applyInner(tr);
                            haveNew = true;
                        }
                        if (seen) seen[i] = {
                            state: newState,
                            n: trs.length
                        };
                    }
                }
                if (!haveNew) return {
                    state: newState,
                    transactions: trs
                };
            }
        }
        applyInner(tr) {
            if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
            let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
            for(let i = 0; i < fields.length; i++){
                let field = fields[i];
                newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
            }
            return newInstance;
        }
        get tr() {
            return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
        }
        static create(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
            return instance;
        }
        reconfigure(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
            let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < fields.length; i++){
                let name = fields[i].name;
                instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
            }
            return instance;
        }
        toJSON(pluginFields) {
            let result = {
                doc: this.doc.toJSON(),
                selection: this.selection.toJSON()
            };
            if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
            if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
                if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
                let plugin = pluginFields[prop], state = plugin.spec.state;
                if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
            }
            return result;
        }
        static fromJSON(config, json, pluginFields) {
            if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
            if (!config.schema) throw new RangeError("Required config field 'schema' missing");
            let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            $config.fields.forEach((field)=>{
                if (field.name == "doc") instance.doc = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(config.schema, json.doc);
                else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
                else if (field.name == "storedMarks") {
                    if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
                } else {
                    if (pluginFields) for(let prop in pluginFields){
                        let plugin = pluginFields[prop], state = plugin.spec.state;
                        if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                            instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                            return;
                        }
                    }
                    instance[field.name] = field.init(config, instance);
                }
            });
            return instance;
        }
    }
    function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
        for(let prop in obj){
            let val = obj[prop];
            if (val instanceof Function) val = val.bind(self);
            else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
            target[prop] = val;
        }
        return target;
    }
    class $c5f36586ce432e9f$export$901cf72dabf2112a {
        constructor(spec){
            this.spec = spec;
            this.props = {};
            if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
            this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
        }
        getState(state) {
            return state[this.key];
        }
    }
    const $c5f36586ce432e9f$var$keys = Object.create(null);
    function $c5f36586ce432e9f$var$createKey(name) {
        if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
        $c5f36586ce432e9f$var$keys[name] = 0;
        return name + "$";
    }
    class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
        constructor(name = "key"){
            this.key = $c5f36586ce432e9f$var$createKey(name);
        }
        get(state) {
            return state.config.pluginsByKey[this.key];
        }
        getState(state) {
            return state[this.key];
        }
    }
});
parcelRegister("eS2Dn", function(module, exports) {
    $parcel$export(module.exports, "StepMap", ()=>$ad3826e817ebec37$export$c53d01c3ab9721b3);
    $parcel$export(module.exports, "Mapping", ()=>$ad3826e817ebec37$export$f5f785078011b62);
    $parcel$export(module.exports, "Step", ()=>$ad3826e817ebec37$export$fd55ce593607084a);
    $parcel$export(module.exports, "StepResult", ()=>$ad3826e817ebec37$export$8ebf1578a4199c09);
    $parcel$export(module.exports, "AddMarkStep", ()=>$ad3826e817ebec37$export$d24ba56b0e3464a9);
    $parcel$export(module.exports, "RemoveMarkStep", ()=>$ad3826e817ebec37$export$94150db1311f67a9);
    $parcel$export(module.exports, "AddNodeMarkStep", ()=>$ad3826e817ebec37$export$adefd16c402fee4e);
    $parcel$export(module.exports, "RemoveNodeMarkStep", ()=>$ad3826e817ebec37$export$fdf7d1dc10724da2);
    $parcel$export(module.exports, "ReplaceStep", ()=>$ad3826e817ebec37$export$5c860b2e74034756);
    $parcel$export(module.exports, "ReplaceAroundStep", ()=>$ad3826e817ebec37$export$444ba800d6024a98);
    $parcel$export(module.exports, "liftTarget", ()=>$ad3826e817ebec37$export$f1508b72cc76a09e);
    $parcel$export(module.exports, "findWrapping", ()=>$ad3826e817ebec37$export$118cb9a83e81ba37);
    $parcel$export(module.exports, "canSplit", ()=>$ad3826e817ebec37$export$5aaf008897aef029);
    $parcel$export(module.exports, "canJoin", ()=>$ad3826e817ebec37$export$f15f89fd9d8cc98a);
    $parcel$export(module.exports, "joinPoint", ()=>$ad3826e817ebec37$export$41b1d4cb5ceb3147);
    $parcel$export(module.exports, "insertPoint", ()=>$ad3826e817ebec37$export$64cb316d02de1dd1);
    $parcel$export(module.exports, "dropPoint", ()=>$ad3826e817ebec37$export$2819d598d048fc9c);
    $parcel$export(module.exports, "replaceStep", ()=>$ad3826e817ebec37$export$ed6ac67359824afd);
    $parcel$export(module.exports, "AttrStep", ()=>$ad3826e817ebec37$export$626399c38172f669);
    $parcel$export(module.exports, "DocAttrStep", ()=>$ad3826e817ebec37$export$f50707b396300ac9);
    $parcel$export(module.exports, "Transform", ()=>$ad3826e817ebec37$export$563a914cafbdc389);
    var $kCV8T;
    const $ad3826e817ebec37$var$lower16 = 0xffff;
    const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
    function $ad3826e817ebec37$var$makeRecover(index, offset) {
        return index + offset * $ad3826e817ebec37$var$factor16;
    }
    function $ad3826e817ebec37$var$recoverIndex(value) {
        return value & $ad3826e817ebec37$var$lower16;
    }
    function $ad3826e817ebec37$var$recoverOffset(value) {
        return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
    }
    const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
    class $ad3826e817ebec37$export$c77c9be41668e9b4 {
        constructor(pos, delInfo, recover){
            this.pos = pos;
            this.delInfo = delInfo;
            this.recover = recover;
        }
        get deleted() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
        }
        get deletedBefore() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAfter() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAcross() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
        }
    }
    class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
        constructor(ranges, inverted = false){
            this.ranges = ranges;
            this.inverted = inverted;
            if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        recover(value) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
            if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
            return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        map(pos, assoc = 1) {
            return this._map(pos, assoc, true);
        }
        _map(pos, assoc, simple) {
            let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
                if (pos <= end) {
                    let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                    let result = start + diff + (side < 0 ? 0 : newSize);
                    if (simple) return result;
                    let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                    let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                    if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                    return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
                }
                diff += newSize - oldSize;
            }
            return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
        }
        touches(pos, recover) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
                if (pos <= end && i == index * 3) return true;
                diff += this.ranges[i + newIndex] - oldSize;
            }
            return false;
        }
        forEach(f) {
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
                f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
                diff += newSize - oldSize;
            }
        }
        invert() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
        }
        toString() {
            return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
        }
        static offset(n) {
            return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
                0,
                -n,
                0
            ] : [
                0,
                0,
                n
            ]);
        }
    }
    $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
    class $ad3826e817ebec37$export$f5f785078011b62 {
        constructor(maps = [], mirror, from = 0, to = maps.length){
            this.maps = maps;
            this.mirror = mirror;
            this.from = from;
            this.to = to;
        }
        slice(from = 0, to = this.maps.length) {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
        }
        copy() {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
        }
        appendMap(map, mirrors) {
            this.to = this.maps.push(map);
            if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
        }
        appendMapping(mapping) {
            for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
            }
        }
        getMirror(n) {
            if (this.mirror) {
                for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
            }
        }
        setMirror(n, m) {
            if (!this.mirror) this.mirror = [];
            this.mirror.push(n, m);
        }
        appendMappingInverted(mapping) {
            for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
            }
        }
        invert() {
            let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
            inverse.appendMappingInverted(this);
            return inverse;
        }
        map(pos, assoc = 1) {
            if (this.mirror) return this._map(pos, assoc, true);
            for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
            return pos;
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        _map(pos, assoc, simple) {
            let delInfo = 0;
            for(let i = this.from; i < this.to; i++){
                let map = this.maps[i], result = map.mapResult(pos, assoc);
                if (result.recover != null) {
                    let corr = this.getMirror(i);
                    if (corr != null && corr > i && corr < this.to) {
                        i = corr;
                        pos = this.maps[corr].recover(result.recover);
                        continue;
                    }
                }
                delInfo |= result.delInfo;
                pos = result.pos;
            }
            return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
        }
    }
    const $ad3826e817ebec37$var$stepsByID = Object.create(null);
    class $ad3826e817ebec37$export$fd55ce593607084a {
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        merge(other) {
            return null;
        }
        static fromJSON(schema, json) {
            if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
            let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
            if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
            return type.fromJSON(schema, json);
        }
        static jsonID(id, stepClass) {
            if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
            $ad3826e817ebec37$var$stepsByID[id] = stepClass;
            stepClass.prototype.jsonID = id;
            return stepClass;
        }
    }
    class $ad3826e817ebec37$export$8ebf1578a4199c09 {
        constructor(doc, failed){
            this.doc = doc;
            this.failed = failed;
        }
        static ok(doc) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
        }
        static fail(message) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
        }
        static fromReplace(doc, from, to, slice) {
            try {
                return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("kCV8T")).ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
                throw e;
            }
        }
    }
    function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
        let mapped = [];
        for(let i = 0; i < fragment.childCount; i++){
            let child = fragment.child(i);
            if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
            if (child.isInline) child = f(child, parent, i);
            mapped.push(child);
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(mapped);
    }
    class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
            let parent = $from.node($from.sharedDepth(this.to));
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
                if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
                return node.mark(this.mark.addToSet(node.marks));
            }, parent), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "addMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
    class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to);
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
                return node.mark(this.mark.removeFromSet(node.marks));
            }, doc), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "removeMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
    class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (node) {
                let newSet = this.mark.addToSet(node.marks);
                if (newSet.length == node.marks.length) {
                    for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                    return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
                }
            }
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "addNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
    class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node || !this.mark.isInSet(node.marks)) return this;
            return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "removeNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
    class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, slice, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.slice = slice;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.to - this.from,
                this.slice.size
            ]);
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deletedAcross && to.deletedAcross) return null;
            return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
        }
        merge(other) {
            if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
            if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
            } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
            } else return null;
        }
        toJSON() {
            let json = {
                stepType: "replace",
                from: this.from,
                to: this.to
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
            return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
    class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, gapFrom, gapTo, slice, insert, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.gapFrom = gapFrom;
            this.gapTo = gapTo;
            this.slice = slice;
            this.insert = insert;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
            let gap = doc.slice(this.gapFrom, this.gapTo);
            if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
            let inserted = this.slice.insertAt(this.insert, gap.content);
            if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.gapFrom - this.from,
                this.insert,
                this.gapTo,
                this.to - this.gapTo,
                this.slice.size - this.insert
            ]);
        }
        invert(doc) {
            let gap = this.gapTo - this.gapFrom;
            return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
            let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
            if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
            return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
        }
        toJSON() {
            let json = {
                stepType: "replaceAround",
                from: this.from,
                to: this.to,
                gapFrom: this.gapFrom,
                gapTo: this.gapTo,
                insert: this.insert
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
            return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
    function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
        let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
        while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
            depth--;
            dist--;
        }
        if (dist > 0) {
            let next = $from.node(depth).maybeChild($from.indexAfter(depth));
            while(dist > 0){
                if (!next || next.isLeaf) return true;
                next = next.firstChild;
                dist--;
            }
        }
        return false;
    }
    function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
        let removed = [], added = [];
        let removing, adding;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.isInline) return;
            let marks = node.marks;
            if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
                let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
                let newSet = mark.addToSet(marks);
                for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                    if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                    else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
                }
                if (adding && adding.to == start) adding.to = end;
                else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
            }
        });
        removed.forEach((s)=>tr.step(s));
        added.forEach((s)=>tr.step(s));
    }
    function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
        let matched = [], step = 0;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isInline) return;
            step++;
            let toRemove = null;
            if (mark instanceof (0, (0, parcelRequire("kCV8T")).MarkType)) {
                let set = node.marks, found;
                while(found = mark.isInSet(set)){
                    (toRemove || (toRemove = [])).push(found);
                    set = found.removeFromSet(set);
                }
            } else if (mark) {
                if (mark.isInSet(node.marks)) toRemove = [
                    mark
                ];
            } else toRemove = node.marks;
            if (toRemove && toRemove.length) {
                let end = Math.min(pos + node.nodeSize, to);
                for(let i = 0; i < toRemove.length; i++){
                    let style = toRemove[i], found;
                    for(let j = 0; j < matched.length; j++){
                        let m = matched[j];
                        if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                    }
                    if (found) {
                        found.to = end;
                        found.step = step;
                    } else matched.push({
                        style: style,
                        from: Math.max(pos, from),
                        to: end,
                        step: step
                    });
                }
            }
        });
        matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
    }
    function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
        let node = tr.doc.nodeAt(pos);
        let replSteps = [], cur = pos + 1;
        for(let i = 0; i < node.childCount; i++){
            let child = node.child(i), end = cur + child.nodeSize;
            let allowed = match.matchType(child.type);
            if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, (0, parcelRequire("kCV8T")).Slice).empty));
            else {
                match = allowed;
                for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
                if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                    let m, newline = /\r?\n|\r/g, slice;
                    while(m = newline.exec(child.text)){
                        if (!slice) slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                        replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                    }
                }
            }
            cur = end;
        }
        if (!match.validEnd) {
            let fill = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            tr.replace(cur, cur, new (0, (0, parcelRequire("kCV8T")).Slice)(fill, 0, 0));
        }
        for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
    }
    function $ad3826e817ebec37$var$canCut(node, start, end) {
        return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
    }
    function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
        let parent = range.parent;
        let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
        for(let depth = range.depth;; --depth){
            let node = range.$from.node(depth);
            let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
            if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
            if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
        }
        return null;
    }
    function $ad3826e817ebec37$var$lift(tr, range, target) {
        let { $from: $from, $to: $to, depth: depth } = range;
        let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
        let start = gapStart, end = gapEnd;
        let before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openStart = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
            splitting = true;
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(d).copy(before));
            openStart++;
        } else start--;
        let after = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openEnd = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
            splitting = true;
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from($to.node(d).copy(after));
            openEnd++;
        } else end++;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
    }
    function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
        let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
        let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
        if (!inner) return null;
        return around.map($ad3826e817ebec37$var$withAttrs).concat({
            type: nodeType,
            attrs: attrs
        }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
    }
    function $ad3826e817ebec37$var$withAttrs(type) {
        return {
            type: type,
            attrs: null
        };
    }
    function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let around = parent.contentMatchAt(startIndex).findWrapping(type);
        if (!around) return null;
        let outer = around.length ? around[0] : type;
        return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
    }
    function $ad3826e817ebec37$var$findWrappingInside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let inner = parent.child(startIndex);
        let inside = type.contentMatch.findWrapping(inner.type);
        if (!inside) return null;
        let lastType = inside.length ? inside[inside.length - 1] : type;
        let innerMatch = lastType.contentMatch;
        for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
        if (!innerMatch || !innerMatch.validEnd) return null;
        return inside;
    }
    function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
        let content = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let i = wrappers.length - 1; i >= 0; i--){
            if (content.size) {
                let match = wrappers[i].type.contentMatch.matchFragment(content);
                if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
            }
            content = (0, (0, parcelRequire("kCV8T")).Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
        }
        let start = range.start, end = range.end;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, (0, parcelRequire("kCV8T")).Slice)(content, 0, 0), wrappers.length, true));
    }
    function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
        if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
        let mapFrom = tr.steps.length;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
            if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
                let convertNewlines = null;
                if (type.schema.linebreakReplacement) {
                    let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                    if (pre && !supportLinebreak) convertNewlines = false;
                    else if (!pre && supportLinebreak) convertNewlines = true;
                }
                if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
                $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
                let mapping = tr.mapping.slice(mapFrom);
                let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
                tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
                if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
                return false;
            }
        });
    }
    function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.isText) {
                let m, newline = /\r?\n|\r/g;
                while(m = newline.exec(child.text)){
                    let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                    tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
                }
            }
        });
    }
    function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.type == child.type.schema.linebreakReplacement) {
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
                tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
            }
        });
    }
    function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, type);
    }
    function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
        let node = tr.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at given position");
        if (!type) type = node.type;
        let newNode = type.create(attrs, null, marks || node.marks);
        if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
        if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(newNode), 0, 0), 1, true));
    }
    function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
        let $pos = doc.resolve(pos), base = $pos.depth - depth;
        let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
        if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
        for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
            let node = $pos.node(d), index = $pos.index(d);
            if (node.type.spec.isolating) return false;
            let rest = node.content.cutByIndex(index, node.childCount);
            let overrideChild = typesAfter && typesAfter[i + 1];
            if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
            let after = typesAfter && typesAfter[i] || node;
            if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
        }
        let index = $pos.indexAfter(base);
        let baseType = typesAfter && typesAfter[0];
        return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
    }
    function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
        let $pos = tr.doc.resolve(pos), before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, after = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($pos.node(d).copy(before));
            let typeAfter = typesAfter && typesAfter[i];
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
        }
        tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), depth, depth), true));
    }
    function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
    }
    function $ad3826e817ebec37$var$joinable(a, b) {
        return !!(a && b && !a.isLeaf && a.canAppend(b));
    }
    function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
        let $pos = doc.resolve(pos);
        for(let d = $pos.depth;; d--){
            let before, after, index = $pos.index(d);
            if (d == $pos.depth) {
                before = $pos.nodeBefore;
                after = $pos.nodeAfter;
            } else if (dir > 0) {
                before = $pos.node(d + 1);
                index++;
                after = $pos.node(d).maybeChild(index);
            } else {
                before = $pos.node(d).maybeChild(index - 1);
                after = $pos.node(d + 1);
            }
            if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
            if (d == 0) break;
            pos = dir < 0 ? $pos.before(d) : $pos.after(d);
        }
    }
    function $ad3826e817ebec37$var$join(tr, pos, depth) {
        let step = new $ad3826e817ebec37$export$5c860b2e74034756(pos - depth, pos + depth, (0, (0, parcelRequire("kCV8T")).Slice).empty, true);
        tr.step(step);
    }
    function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
        let $pos = doc.resolve(pos);
        if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
        if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.index(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
            if (index > 0) return null;
        }
        if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.indexAfter(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
            if (index < $pos.node(d).childCount) return null;
        }
        return null;
    }
    function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
        let $pos = doc.resolve(pos);
        if (!slice.content.size) return pos;
        let content = slice.content;
        for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
        for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
            let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
            let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
            let parent = $pos.node(d), fits = false;
            if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
            else {
                let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
                fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
            }
            if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
        return null;
    }
    function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
        if (from == to && !slice.size) return null;
        let $from = doc.resolve(from), $to = doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
        return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
    }
    function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
        return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
    }
    class $ad3826e817ebec37$var$Fitter {
        constructor($from, $to, unplaced){
            this.$from = $from;
            this.$to = $to;
            this.unplaced = unplaced;
            this.frontier = [];
            this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
            for(let i = 0; i <= $from.depth; i++){
                let node = $from.node(i);
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt($from.indexAfter(i))
                });
            }
            for(let i = $from.depth; i > 0; i--)this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(i).copy(this.placed));
        }
        get depth() {
            return this.frontier.length - 1;
        }
        fit() {
            while(this.unplaced.size){
                let fit = this.findFittable();
                if (fit) this.placeNodes(fit);
                else this.openMore() || this.dropNode();
            }
            let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
            let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
            if (!$to) return null;
            let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
            while(openStart && openEnd && content.childCount == 1){
                content = content.firstChild.content;
                openStart--;
                openEnd--;
            }
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart, openEnd);
            if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
            if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
            return null;
        }
        findFittable() {
            let startDepth = this.unplaced.openStart;
            for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
                let node = cur.firstChild;
                if (cur.childCount > 1) openEnd = 0;
                if (node.type.spec.isolating && openEnd <= d) {
                    startDepth = d;
                    break;
                }
                cur = node.content;
            }
            for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
                let fragment, parent = null;
                if (sliceDepth) {
                    parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                    fragment = parent.content;
                } else fragment = this.unplaced.content;
                let first = fragment.firstChild;
                for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                    let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                    if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        inject: inject
                    };
                    else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        wrap: wrap
                    };
                    if (parent && match.matchType(parent.type)) break;
                }
            }
        }
        openMore() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (!inner.childCount || inner.firstChild.isLeaf) return false;
            this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
            return true;
        }
        dropNode() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (inner.childCount <= 1 && openStart > 0) {
                let openAtEnd = content.size - openStart <= openStart + inner.size;
                this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
            } else this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
        }
        placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
            while(this.depth > frontierDepth)this.closeFrontierNode();
            if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
            let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
            let openStart = slice.openStart - sliceDepth;
            let taken = 0, add = [];
            let { match: match, type: type } = this.frontier[frontierDepth];
            if (inject) {
                for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
                match = match.matchFragment(inject);
            }
            let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
            while(taken < fragment.childCount){
                let next = fragment.child(taken), matches = match.matchType(next.type);
                if (!matches) break;
                taken++;
                if (taken > 1 || openStart == 0 || next.content.size) {
                    match = matches;
                    add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
                }
            }
            let toEnd = taken == fragment.childCount;
            if (!toEnd) openEndCount = -1;
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, (0, parcelRequire("kCV8T")).Fragment).from(add));
            this.frontier[frontierDepth].match = match;
            if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
            for(let i = 0, cur = fragment; i < openEndCount; i++){
                let node = cur.lastChild;
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt(node.childCount)
                });
                cur = node.content;
            }
            this.unplaced = !toEnd ? new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
        }
        mustMoveInline() {
            if (!this.$to.parent.isTextblock) return -1;
            let top = this.frontier[this.depth], level;
            if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
            let { depth: depth } = this.$to, after = this.$to.after(depth);
            while(depth > 1 && after == this.$to.end(--depth))++after;
            return after;
        }
        findCloseLevel($to) {
            scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
                let { match: match, type: type } = this.frontier[i];
                let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
                let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
                if (!fit) continue;
                for(let d = i - 1; d >= 0; d--){
                    let { match: match, type: type } = this.frontier[d];
                    let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                    if (!matches || matches.childCount) continue scan;
                }
                return {
                    depth: i,
                    fit: fit,
                    move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
                };
            }
        }
        close($to) {
            let close = this.findCloseLevel($to);
            if (!close) return null;
            while(this.depth > close.depth)this.closeFrontierNode();
            if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
            $to = close.move;
            for(let d = close.depth + 1; d <= $to.depth; d++){
                let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
                this.openFrontierNode(node.type, node.attrs, add);
            }
            return $to;
        }
        openFrontierNode(type, attrs = null, content) {
            let top = this.frontier[this.depth];
            top.match = top.match.matchType(type);
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrs, content)));
            this.frontier.push({
                type: type,
                match: type.contentMatch
            });
        }
        closeFrontierNode() {
            let open = this.frontier.pop();
            let add = open.match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
        }
    }
    function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
        if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
        return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
    }
    function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
        if (depth == 0) return fragment.append(content);
        return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
    }
    function $ad3826e817ebec37$var$contentAt(fragment, depth) {
        for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
        return fragment;
    }
    function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
        if (openStart <= 0) return node;
        let frag = node.content;
        if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
        if (openStart > 0) {
            frag = node.type.contentMatch.fillBefore(frag).append(frag);
            if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return node.copy(frag);
    }
    function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
        let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
        if (index == node.childCount && !type.compatibleContent(node.type)) return null;
        let fit = match.fillBefore(node.content, true, index);
        return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
    }
    function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
        for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
        return false;
    }
    function $ad3826e817ebec37$var$definesContent(type) {
        return type.spec.defining || type.spec.definingForContent;
    }
    function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
        if (!slice.size) return tr.deleteRange(from, to);
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
        let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
        if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
        let preferredTarget = -($from.depth + 1);
        targetDepths.unshift(preferredTarget);
        for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
            let spec = $from.node(d).type.spec;
            if (spec.defining || spec.definingAsContext || spec.isolating) break;
            if (targetDepths.indexOf(d) > -1) preferredTarget = d;
            else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
        }
        let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
        let leftNodes = [], preferredDepth = slice.openStart;
        for(let content = slice.content, i = 0;; i++){
            let node = content.firstChild;
            leftNodes.push(node);
            if (i == slice.openStart) break;
            content = node.content;
        }
        for(let d = preferredDepth - 1; d >= 0; d--){
            let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
            if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
            else if (def || !leftNode.type.isTextblock) break;
        }
        for(let j = slice.openStart; j >= 0; j--){
            let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
            let insert = leftNodes[openDepth];
            if (!insert) continue;
            for(let i = 0; i < targetDepths.length; i++){
                let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
                if (targetDepth < 0) {
                    expand = false;
                    targetDepth = -targetDepth;
                }
                let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
                if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
            }
        }
        let startSteps = tr.steps.length;
        for(let i = targetDepths.length - 1; i >= 0; i--){
            tr.replace(from, to, slice);
            if (tr.steps.length > startSteps) break;
            let depth = targetDepths[i];
            if (depth < 0) continue;
            from = $from.before(depth);
            to = $to.after(depth);
        }
    }
    function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
        if (depth < oldOpen) {
            let first = fragment.firstChild;
            fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
        }
        if (depth > newOpen) {
            let match = parent.contentMatchAt(0);
            let start = match.fillBefore(fragment).append(fragment);
            fragment = start.append(match.matchFragment(start).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return fragment;
    }
    function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
        if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
            let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
            if (point != null) from = to = point;
        }
        tr.replaceRange(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(node), 0, 0));
    }
    function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
        for(let i = 0; i < covered.length; i++){
            let depth = covered[i], last = i == covered.length - 1;
            if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
            if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
        }
        for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
            if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
        }
        tr.delete(from, to);
    }
    function $ad3826e817ebec37$var$coveredDepths($from, $to) {
        let result = [], minDepth = Math.min($from.depth, $to.depth);
        for(let d = minDepth; d >= 0; d--){
            let start = $from.start(d);
            if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
            if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
        }
        return result;
    }
    class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, attr, value){
            super();
            this.pos = pos;
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
            let attrs = Object.create(null);
            for(let name in node.attrs)attrs[name] = node.attrs[name];
            attrs[this.attr] = this.value;
            let updated = node.type.create(attrs, null, node.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
        }
        toJSON() {
            return {
                stepType: "attr",
                pos: this.pos,
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
            return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
    class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(attr, value){
            super();
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let attrs = Object.create(null);
            for(let name in doc.attrs)attrs[name] = doc.attrs[name];
            attrs[this.attr] = this.value;
            let updated = doc.type.create(attrs, doc.content, doc.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
        }
        map(mapping) {
            return this;
        }
        toJSON() {
            return {
                stepType: "docAttr",
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
            return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
    let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
        let err = Error.call(this, message);
        err.__proto__ = TransformError.prototype;
        return err;
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
    class $ad3826e817ebec37$export$563a914cafbdc389 {
        constructor(doc){
            this.doc = doc;
            this.steps = [];
            this.docs = [];
            this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
        }
        get before() {
            return this.docs.length ? this.docs[0] : this.doc;
        }
        step(step) {
            let result = this.maybeStep(step);
            if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
            return this;
        }
        maybeStep(step) {
            let result = step.apply(this.doc);
            if (!result.failed) this.addStep(step, result.doc);
            return result;
        }
        get docChanged() {
            return this.steps.length > 0;
        }
        addStep(step, doc) {
            this.docs.push(this.doc);
            this.steps.push(step);
            this.mapping.appendMap(step.getMap());
            this.doc = doc;
        }
        replace(from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
            if (step) this.step(step);
            return this;
        }
        replaceWith(from, to, content) {
            return this.replace(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(content), 0, 0));
        }
        delete(from, to) {
            return this.replace(from, to, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
        insert(pos, content) {
            return this.replaceWith(pos, pos, content);
        }
        replaceRange(from, to, slice) {
            $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
            return this;
        }
        replaceRangeWith(from, to, node) {
            $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
            return this;
        }
        deleteRange(from, to) {
            $ad3826e817ebec37$var$deleteRange(this, from, to);
            return this;
        }
        lift(range, target) {
            $ad3826e817ebec37$var$lift(this, range, target);
            return this;
        }
        join(pos, depth = 1) {
            $ad3826e817ebec37$var$join(this, pos, depth);
            return this;
        }
        wrap(range, wrappers) {
            $ad3826e817ebec37$var$wrap(this, range, wrappers);
            return this;
        }
        setBlockType(from, to = from, type, attrs = null) {
            $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
            return this;
        }
        setNodeMarkup(pos, type, attrs = null, marks) {
            $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
            return this;
        }
        setNodeAttribute(pos, attr, value) {
            this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
            return this;
        }
        setDocAttribute(attr, value) {
            this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
            return this;
        }
        addNodeMark(pos, mark) {
            this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
            return this;
        }
        removeNodeMark(pos, mark) {
            if (!(mark instanceof (0, (0, parcelRequire("kCV8T")).Mark))) {
                let node = this.doc.nodeAt(pos);
                if (!node) throw new RangeError("No node at position " + pos);
                mark = mark.isInSet(node.marks);
                if (!mark) return this;
            }
            this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
            return this;
        }
        split(pos, depth = 1, typesAfter) {
            $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
            return this;
        }
        addMark(from, to, mark) {
            $ad3826e817ebec37$var$addMark(this, from, to, mark);
            return this;
        }
        removeMark(from, to, mark) {
            $ad3826e817ebec37$var$removeMark(this, from, to, mark);
            return this;
        }
        clearIncompatible(pos, parentType, match) {
            $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
            return this;
        }
    }
});
parcelRegister("jDqXW", function(module, exports) {
    $parcel$export(module.exports, "isRoot", ()=>$156bd5a891736fc3$export$e3140dc7d0c35e48);
    $parcel$export(module.exports, "getPosFromRange", ()=>$156bd5a891736fc3$export$243cdddc5b21d8c1);
    $parcel$export(module.exports, "createAnnotationStep", ()=>$156bd5a891736fc3$export$74899f7e5acb5cd3);
    var $2oS3b;
    var $eS2Dn;
    function $156bd5a891736fc3$var$getStartPos(element) {
        return parseInt(element.dataset.rendererStartPos || '-1', 10);
    }
    const $156bd5a891736fc3$var$getNodeType = (element)=>element.dataset.nodeType;
    function $156bd5a891736fc3$var$isPositionPointer(element) {
        return $156bd5a891736fc3$var$getStartPos(element) > -1;
    }
    function $156bd5a891736fc3$var$findParent(element) {
        const { parentElement: parentElement } = element;
        if (!parentElement || $156bd5a891736fc3$export$e3140dc7d0c35e48(parentElement)) return null;
        if ($156bd5a891736fc3$var$isPositionPointer(parentElement)) return parentElement;
        return $156bd5a891736fc3$var$findParent(parentElement);
    }
    function $156bd5a891736fc3$var$findMediaParent(element) {
        const { parentElement: parentElement } = element;
        if (!parentElement || $156bd5a891736fc3$export$e3140dc7d0c35e48(parentElement)) return null;
        if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
        return $156bd5a891736fc3$var$findMediaParent(parentElement);
    }
    function $156bd5a891736fc3$var$findParentBeforePointer(element) {
        const { parentElement: parentElement } = element;
        if ($156bd5a891736fc3$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
        if ($156bd5a891736fc3$var$isPositionPointer(parentElement)) return element;
        return $156bd5a891736fc3$var$findParentBeforePointer(parentElement);
    }
    function $156bd5a891736fc3$var$isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    }
    function $156bd5a891736fc3$var$isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    }
    function $156bd5a891736fc3$var$isHighlightTextNode(node) {
        return !!node?.dataset?.highlighted;
    }
    function $156bd5a891736fc3$var$isNodeInlineMark(node) {
        return $156bd5a891736fc3$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    }
    function $156bd5a891736fc3$var$isElementInlineMark(element) {
        return !!element && Boolean(element.dataset.rendererMark);
    }
    function $156bd5a891736fc3$var$isNodeInlineTextMark(node) {
        if (node === null) return false;
        const isInlineMark = $156bd5a891736fc3$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
        if (!isInlineMark) return false;
        if ($156bd5a891736fc3$var$hasInlineNodeDescendant(node)) return false;
        return true;
    }
    function $156bd5a891736fc3$var$hasInlineNodeDescendant(node) {
        if ($156bd5a891736fc3$var$isElementNode(node)) {
            if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.dataset.annotationInlineNode === 'true') return true;
            } else {
                if (node.dataset.inlineCard === 'true') return true;
            }
            return Array.from(node.childNodes).some($156bd5a891736fc3$var$hasInlineNodeDescendant);
        }
        return false;
    }
    function $156bd5a891736fc3$var$resolveNodePos(node) {
        let resolvedPos = 0;
        let prev = node.previousSibling;
        while(prev){
            if (prev && ($156bd5a891736fc3$var$isTextNode(prev) || $156bd5a891736fc3$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
            else if (prev) {
                if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
                    if ($156bd5a891736fc3$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                    else resolvedPos += 1;
                } else if ($156bd5a891736fc3$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            }
            prev = prev.previousSibling;
        }
        return resolvedPos;
    }
    function $156bd5a891736fc3$export$e3140dc7d0c35e48(element) {
        return !!element && element.classList.contains('ak-renderer-document');
    }
    function $156bd5a891736fc3$export$5db587db55468da7(node, offset, findEnd = false) {
        if (!node) return false;
        if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
            const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
            const potentialParent = (0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
            if (startPosAncestor?.hasAttribute(potentialParent)) {
                if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
                else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
            }
        }
        if (node instanceof HTMLElement && $156bd5a891736fc3$var$isPositionPointer(node)) {
            if (findEnd) {
                let count = $156bd5a891736fc3$var$getStartPos(node);
                const children = node.childNodes;
                for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
                return count;
            }
            return $156bd5a891736fc3$var$getStartPos(node) + offset;
        }
        const parent = $156bd5a891736fc3$var$findParent(node);
        if (!parent) return false;
        let resolvedPos = $156bd5a891736fc3$var$getStartPos(parent);
        let current = node;
        if (current.parentElement && current.parentElement !== parent) {
            const preParentPointer = $156bd5a891736fc3$var$findParentBeforePointer(current.parentElement);
            if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (!($156bd5a891736fc3$var$isNodeInlineTextMark(preParentPointer) || $156bd5a891736fc3$var$isHighlightTextNode(preParentPointer))) {
                    current = current.parentElement;
                    offset = 0;
                }
            } else if (!($156bd5a891736fc3$var$isElementInlineMark(preParentPointer) || $156bd5a891736fc3$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
            resolvedPos += $156bd5a891736fc3$var$resolveNodePos(current);
            while(current && current.parentElement !== parent){
                current = current.parentNode;
                if (current) {
                    const nodePos = $156bd5a891736fc3$var$resolveNodePos(current);
                    resolvedPos += nodePos;
                }
            }
        } else resolvedPos += $156bd5a891736fc3$var$resolveNodePos(current);
        return resolvedPos + offset;
    }
    function $156bd5a891736fc3$export$243cdddc5b21d8c1(range) {
        const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
        const possibleMediaOrMediaSingleElement = $156bd5a891736fc3$var$findParent(startContainer);
        const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && /media|mediaSingle/.test($156bd5a891736fc3$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
        if (isMediaOrMediaSingle) {
            let pos;
            const mediaSingleElement = $156bd5a891736fc3$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $156bd5a891736fc3$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $156bd5a891736fc3$var$getStartPos(mediaSingleElement);
            if (pos !== undefined) return {
                from: pos,
                to: pos
            };
        }
        const from = $156bd5a891736fc3$export$5db587db55468da7(startContainer, startOffset);
        const findEnd = true;
        const to = $156bd5a891736fc3$export$5db587db55468da7(endContainer, endOffset, findEnd);
        if (from === false || to === false) return false;
        return {
            from: from,
            to: to
        };
    }
    function $156bd5a891736fc3$export$74899f7e5acb5cd3(from, to, opts) {
        return new (0, (0, parcelRequire("eS2Dn")).AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
            id: opts.annotationId,
            annotationType: opts.annotationType
        }));
    }
});
parcelRegister("8UzU4", function(module, exports) {
    $parcel$export(module.exports, "getIndexMatch", ()=>$964c4488955af803$export$fb7dab895a0d310e);
    function $964c4488955af803$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
        let textContent = '';
        let matchIndex = 0;
        let numMatches = 0;
        let blockNodePos;
        doc.descendants((node, pos)=>{
            const nodeType = node.type;
            const { media: media } = schema.nodes;
            if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) return true;
            const nodeStart = pos;
            const nodeEnd = nodeStart + node.nodeSize;
            if (startIndex >= nodeStart && startIndex <= nodeEnd) {
                if (nodeType === media) blockNodePos = pos;
                textContent += doc.textBetween(nodeStart, startIndex - 1);
                matchIndex = $964c4488955af803$export$3c2359e76fc742da(textContent, selectedText);
                textContent += doc.textBetween(startIndex, nodeEnd);
            } else textContent += node.textContent;
            return true;
        });
        numMatches = $964c4488955af803$export$3c2359e76fc742da(textContent, selectedText);
        return {
            numMatches: numMatches,
            matchIndex: matchIndex,
            textContent: textContent,
            blockNodePos: blockNodePos
        };
    }
    function $964c4488955af803$export$3c2359e76fc742da(searchString, query) {
        if (searchString === '' || query === '') return 0;
        const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
        return (searchString.match(reg) || []).length;
    }
});
parcelRegister("dAQq9", function(module, exports) {
    $parcel$export(module.exports, "getRendererRangeInlineNodeNames", ()=>$c662296fc8a687d3$export$b0ea72d31617ccea);
    var $4UKgY;
    var $2oS3b;
    function $c662296fc8a687d3$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
        if (!(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        const { doc: doc } = actions;
        if (!pos || !doc) return undefined;
        const inlineNodeNames = (0, (0, parcelRequire("4UKgY")).getRangeInlineNodeNames)({
            doc: doc,
            pos: pos
        });
        return inlineNodeNames;
    }
});
parcelRegister("d6S9D", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsContextWrapper", ()=>$88992de38a8651cb$export$787af8a111ff3c03);
    var $5uXOq = parcelRequire("5uXOq");
    var $clIqK;
    var $1OQAq;
    var $8xPn0;
    var $gtdQQ;
    const $88992de38a8651cb$export$787af8a111ff3c03 = (props)=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("clIqK")).ProvidersContext));
        const { range: range, type: type } = (0, (0, parcelRequire("gtdQQ")).useAnnotationRangeState)();
        const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, (0, parcelRequire("gtdQQ")).useAnnotationRangeDispatch)();
        const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
        const inlineCommentProvider = providers && providers.inlineComment;
        const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
        const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
        const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
            setDraftRange(range, type);
        }, [
            range,
            setDraftRange,
            type
        ]);
        const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
            clearDraftRange(type);
        }, [
            type,
            clearDraftRange
        ]);
        const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children, !!hoverComponent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1OQAq")).RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                component: hoverComponent,
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }), !!selectionComponent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xPn0")).SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                selectionComponent: selectionComponent,
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }));
        }, [
            hoverComponent,
            selectionComponent,
            children,
            rendererRef,
            createAnalyticsEvent
        ]);
        if (!selectionComponent && !hoverComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("clIqK")).AnnotationsDraftContextWrapper), {
            setDraftRange: setRangeForDraft,
            clearDraftRange: clearRangeForDraft
        }, render);
    };
});
parcelRegister("1OQAq", function(module, exports) {
    $parcel$export(module.exports, "RangeValidator", ()=>$475f6228afe6dc1e$export$6d8376a902cb8aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $l9Uzn;
    var $35dtk;
    var $gtdQQ;
    var $820Yv;
    const $475f6228afe6dc1e$export$6d8376a902cb8aa7 = (props)=>{
        const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const { clearHoverRange: clearHoverRange } = (0, (0, parcelRequire("gtdQQ")).useAnnotationRangeDispatch)();
        const { range: range, type: type } = (0, (0, parcelRequire("gtdQQ")).useAnnotationRangeState)();
        const { isWithinRange: isWithinRange } = (0, (0, parcelRequire("820Yv")).useAnnotationHoverContext)();
        if (!range || type !== 'hover') return null;
        const documentPosition = actions.getPositionFromRange(range);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l9Uzn")).Mounter), {
            isWithinRange: isWithinRange,
            range: range,
            wrapperDOM: rendererRef,
            component: component,
            onClose: clearHoverRange,
            documentPosition: documentPosition,
            isAnnotationAllowed: true,
            applyAnnotation: actions.applyAnnotation.bind(actions),
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
            clearAnnotationDraft: clearAnnotationDraft,
            createAnalyticsEvent: createAnalyticsEvent
        });
    };
});
parcelRegister("l9Uzn", function(module, exports) {
    $parcel$export(module.exports, "Mounter", ()=>$a8add59c202211b3$export$2109cd350bcf6eda);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $ka8BB;
    var $20EGj = parcelRequire("20EGj");
    var $6SKbt;
    var $35dtk;
    const $a8add59c202211b3$export$2109cd350bcf6eda = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
        const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
            if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
            const annotation = {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
            }).fire((0, $20EGj.FabricChannel).editor);
            return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
        }, [
            isAnnotationAllowed,
            documentPosition,
            applyAnnotation,
            draftDocumentPosition,
            createAnalyticsEvent
        ]);
        const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
            if (!documentPosition || !generateIndexMatch) return false;
            const result = generateIndexMatch(documentPosition);
            if (!result) return false;
            return result;
        }, [
            documentPosition,
            generateIndexMatch
        ]);
        const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
            if (!documentPosition || !isAnnotationAllowed) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {},
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
                }).fire((0, $20EGj.FabricChannel).editor);
                return false;
            }
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt(documentPosition);
            if (createAnalyticsEvent) {
                const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
                createAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).OPENED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: uniqueAnnotationsInRange.length
                    }
                }).fire((0, $20EGj.FabricChannel).editor);
            }
            window.requestAnimationFrame(()=>{
                if (options.keepNativeSelection) (0, (0, parcelRequire("ka8BB")).updateWindowSelectionAroundDraft)(documentPosition);
                else {
                    const sel = window.getSelection();
                    if (sel) sel.removeAllRanges();
                }
            });
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
            const annotation = {
                annotationId: options.annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            documentPosition,
            isAnnotationAllowed,
            applyAnnotationDraftAt,
            createAnalyticsEvent,
            applyAnnotation,
            draftDocumentPosition,
            actions,
            range
        ]);
        const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
            clearAnnotationDraft();
            setDraftDocumentPosition(null);
            const sel = window.getSelection();
            if (sel) sel.removeAllRanges();
        }, [
            clearAnnotationDraft
        ]);
        const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).CLOSED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                attributes: {}
            }).fire((0, $20EGj.FabricChannel).editor);
            removeDraftModeCallback();
            onCloseProps();
        }, [
            onCloseProps,
            removeDraftModeCallback,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            range: range,
            isWithinRange: isWithinRange,
            wrapperDOM: wrapperDOM.current,
            isAnnotationAllowed: isAnnotationAllowed,
            onClose: onCloseCallback,
            onCreate: onCreateCallback,
            getAnnotationIndexMatch: createIndexCallback,
            applyDraftMode: applyDraftModeCallback,
            removeDraftMode: removeDraftModeCallback
        });
    });
});
parcelRegister("ka8BB", function(module, exports) {
    $parcel$export(module.exports, "dataAttributes", ()=>$9ea66eac7ba41c75$export$15d6ddc168d35719);
    $parcel$export(module.exports, "updateWindowSelectionAroundDraft", ()=>$9ea66eac7ba41c75$export$e14699d956e87e73);
    const $9ea66eac7ba41c75$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
        return {
            ['data-annotation-draft-mark']: true,
            ['data-draft-start-at']: from,
            ['data-draft-end-at']: to
        };
    };
    const $9ea66eac7ba41c75$var$buildDataAttributesQuery = (pos)=>{
        const a = $9ea66eac7ba41c75$export$15d6ddc168d35719(pos);
        return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
    };
    const $9ea66eac7ba41c75$export$e14699d956e87e73 = (pos)=>{
        const sel = window.getSelection();
        if (!sel) return false;
        const draftNodes = document.querySelectorAll($9ea66eac7ba41c75$var$buildDataAttributesQuery(pos));
        if (!draftNodes || draftNodes.length === 0) return false;
        sel.removeAllRanges();
        const range = document.createRange();
        range.setStart(draftNodes[0], 0);
        range.setEndAfter(draftNodes[draftNodes.length - 1]);
        sel.addRange(range);
        return true;
    };
});
parcelRegister("gtdQQ", function(module, exports) {
    $parcel$export(module.exports, "AnnotationRangeProvider", ()=>$cc1c42013317a481$export$30384a6aedd19fee);
    $parcel$export(module.exports, "useAnnotationRangeState", ()=>$cc1c42013317a481$export$e07ee6d6cc95d9a0);
    $parcel$export(module.exports, "useAnnotationRangeDispatch", ()=>$cc1c42013317a481$export$708fc397e2b6f08d);
    var $5uXOq = parcelRequire("5uXOq");
    function $cc1c42013317a481$var$reducer(state, action) {
        switch(action.type){
            case 'clear':
                if (!!state.range || !!state.type) return {
                    range: null,
                    draftRange: null,
                    type: null
                };
                return state;
            case 'clearSelection':
                if (state.type === 'selection') return {
                    ...state,
                    range: null,
                    type: null
                };
                return state;
            case 'clearDraftSelection':
                if (state.type === 'selection') return {
                    ...state,
                    draftRange: null
                };
                return state;
            case 'clearDraftHover':
                if (state.type === 'hover') return {
                    ...state,
                    draftRange: null
                };
                return state;
            case 'clearHover':
                if (state.type === 'hover') return {
                    range: null,
                    draftRange: null,
                    type: null
                };
                return state;
            case 'setSelection':
                if (state.range !== action.range || state.type !== 'selection') return {
                    ...state,
                    range: action.range,
                    type: 'selection'
                };
                return state;
            case 'setHover':
                if (state.range !== action.range || state.type !== 'hover') return {
                    ...state,
                    range: action.range,
                    type: 'hover'
                };
                return state;
            case 'setDraftSelection':
                if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                    range: null,
                    draftRange: action.draftRange,
                    type: null
                };
                return state;
            case 'setDraftHover':
                if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                    ...state,
                    draftRange: action.draftRange
                };
                return state;
        }
    }
    const $cc1c42013317a481$var$AnnotationRangeStateContext = (0, $5uXOq.createContext)({
        range: null,
        draftRange: null,
        type: null
    });
    const $cc1c42013317a481$var$AnnotationRangeDispatchContext = (0, $5uXOq.createContext)({
        clearRange: ()=>{},
        clearSelectionRange: ()=>{},
        clearDraftRange: ()=>{},
        clearHoverRange: ()=>{},
        setRange: ()=>{},
        setDraftRange: ()=>{}
    });
    const $cc1c42013317a481$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
        const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $5uXOq.useReducer)($cc1c42013317a481$var$reducer, {
            range: null,
            draftRange: null,
            type: null
        });
        const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clear'
            }), []);
        const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clearSelection'
            }), []);
        const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
            if (type === 'hover') {
                dispatch({
                    type: 'clearDraftHover'
                });
                return;
            }
            dispatch({
                type: 'clearDraftSelection'
            });
        }, []);
        const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clearHover'
            }), []);
        const setRange = (0, $5uXOq.useCallback)((range)=>dispatch({
                type: 'setSelection',
                range: range
            }), []);
        const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
            if (type === 'hover') {
                dispatch({
                    type: 'setDraftHover',
                    draftRange: range
                });
                return;
            }
            dispatch({
                type: 'setDraftSelection',
                draftRange: range
            });
        }, []);
        const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
            const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
            if (!mediaNode) return;
            const range = document.createRange();
            range.setStartBefore(mediaNode);
            range.setEndAfter(mediaNode);
            dispatch({
                type: 'setHover',
                range: range
            });
        }, []);
        const stateData = (0, $5uXOq.useMemo)(()=>({
                range: range,
                draftRange: draftRange,
                type: type
            }), [
            range,
            draftRange,
            type
        ]);
        const dispatchData = (0, $5uXOq.useMemo)(()=>({
                clearRange: clearRange,
                clearSelectionRange: clearSelectionRange,
                clearDraftRange: clearDraftRange,
                clearHoverRange: clearHoverRange,
                setRange: setRange,
                setDraftRange: setDraftRange,
                setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
            }), [
            allowCommentsOnMedia,
            clearRange,
            clearSelectionRange,
            clearDraftRange,
            clearHoverRange,
            setRange,
            setDraftRange,
            setHoverTarget
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cc1c42013317a481$var$AnnotationRangeStateContext.Provider, {
            value: stateData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cc1c42013317a481$var$AnnotationRangeDispatchContext.Provider, {
            value: dispatchData
        }, children));
    };
    const $cc1c42013317a481$export$e07ee6d6cc95d9a0 = ()=>{
        return (0, $5uXOq.useContext)($cc1c42013317a481$var$AnnotationRangeStateContext);
    };
    const $cc1c42013317a481$export$708fc397e2b6f08d = ()=>{
        return (0, $5uXOq.useContext)($cc1c42013317a481$var$AnnotationRangeDispatchContext);
    };
});
parcelRegister("820Yv", function(module, exports) {
    $parcel$export(module.exports, "AnnotationHoverContext", ()=>$028b80a31ba239d6$export$b3db0feb20552fc3);
    $parcel$export(module.exports, "useAnnotationHoverContext", ()=>$028b80a31ba239d6$export$a02bfcbbbf920306);
    $parcel$export(module.exports, "useAnnotationHoverDispatch", ()=>$028b80a31ba239d6$export$c288883964405c82);
    var $5uXOq = parcelRequire("5uXOq");
    const $028b80a31ba239d6$var$AnnotationHoverStateContext = (0, $5uXOq.createContext)({
        isWithinRange: false
    });
    const $028b80a31ba239d6$var$AnnotationHoverDispatchContext = (0, $5uXOq.createContext)({
        cancelTimeout: ()=>{},
        initiateTimeout: ()=>{},
        setIsWithinRange: ()=>{}
    });
    const $028b80a31ba239d6$export$b3db0feb20552fc3 = ({ children: children })=>{
        const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
        const timeoutHandler = (0, $5uXOq.useRef)();
        const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
            if (timeoutHandler) clearTimeout(timeoutHandler.current);
        }, [
            timeoutHandler
        ]);
        const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
            if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
                setIsWithinRange(false);
            }, 500);
        }, [
            isWithinRange
        ]);
        const stateData = (0, $5uXOq.useMemo)(()=>({
                isWithinRange: isWithinRange
            }), [
            isWithinRange
        ]);
        const dispatchData = (0, $5uXOq.useMemo)(()=>({
                cancelTimeout: cancelTimeout,
                initiateTimeout: initiateTimeout,
                setIsWithinRange: setIsWithinRange
            }), [
            cancelTimeout,
            initiateTimeout,
            setIsWithinRange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($028b80a31ba239d6$var$AnnotationHoverStateContext.Provider, {
            value: stateData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($028b80a31ba239d6$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData
        }, children));
    };
    const $028b80a31ba239d6$export$a02bfcbbbf920306 = ()=>{
        return (0, $5uXOq.useContext)($028b80a31ba239d6$var$AnnotationHoverStateContext);
    };
    const $028b80a31ba239d6$export$c288883964405c82 = ()=>{
        return (0, $5uXOq.useContext)($028b80a31ba239d6$var$AnnotationHoverDispatchContext);
    };
});
parcelRegister("8xPn0", function(module, exports) {
    $parcel$export(module.exports, "SelectionRangeValidator", ()=>$b7f5dbb00ebca7d9$export$74435b85e23b84d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $1bVVw;
    var $aaeg2;
    var $35dtk;
    const $b7f5dbb00ebca7d9$export$74435b85e23b84d9 = (props)=>{
        const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const [range, draftRange, clearRange] = (0, (0, parcelRequire("1bVVw")).useUserSelectionRange)({
            rendererRef: rendererRef
        });
        if (!range && !draftRange) return null;
        const documentPosition = actions.getPositionFromRange(range);
        let isAnnotationAllowedOnRange = false;
        try {
            isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
        } catch  {
            isAnnotationAllowedOnRange = false;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aaeg2")).SelectionInlineCommentMounter), {
            range: range,
            draftRange: draftRange,
            wrapperDOM: rendererRef,
            component: selectionComponent,
            onClose: clearRange,
            documentPosition: documentPosition,
            isAnnotationAllowed: isAnnotationAllowedOnRange,
            applyAnnotation: actions.applyAnnotation.bind(actions),
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
            clearAnnotationDraft: clearAnnotationDraft,
            createAnalyticsEvent: createAnalyticsEvent
        });
    };
});
parcelRegister("1bVVw", function(module, exports) {
    $parcel$export(module.exports, "useUserSelectionRange", ()=>$bea35be4032b76be$export$47201332e612f5a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oS3b;
    var $gtdQQ;
    var $c3ALw;
    var $jDqXW;
    const $bea35be4032b76be$export$47201332e612f5a4 = (props)=>{
        const { rendererRef: { current: rendererDOM } } = props;
        const selectionTimeoutRef = (0, $5uXOq.useRef)();
        const { clearRange: clearRange, setRange: setRange } = (0, (0, parcelRequire("gtdQQ")).useAnnotationRangeDispatch)();
        const { range: range, draftRange: draftRange, type: type } = (0, (0, parcelRequire("gtdQQ")).useAnnotationRangeState)();
        (0, $5uXOq.useEffect)(()=>{
            if (!document || !rendererDOM) return;
            const onSelectionChange = (event)=>{
                if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
                selectionTimeoutRef.current = setTimeout(()=>{
                    const sel = document.getSelection();
                    if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                    const _range = sel.getRangeAt(0);
                    if (rendererDOM && (0, (0, parcelRequire("c3ALw")).isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                        if ((0, (0, parcelRequire("2oS3b")).fg)('platform_editor_allow_annotation_triple_click')) {
                            const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                            const parentNode = startContainer.parentNode;
                            const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                            if (isTripleClick && (0, (0, parcelRequire("jDqXW")).isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P') {
                                const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                                _range.setEnd(lastChild, lastChild.length || 0);
                            }
                        }
                        setRange(_range.cloneRange());
                    }
                }, 250);
            };
            document.addEventListener('selectionchange', onSelectionChange);
            return ()=>{
                document.removeEventListener('selectionchange', onSelectionChange);
                clearRange();
            };
        }, [
            rendererDOM,
            setRange,
            clearRange
        ]);
        return [
            type === 'selection' ? range : null,
            draftRange,
            clearRange
        ];
    };
});
parcelRegister("c3ALw", function(module, exports) {
    $parcel$export(module.exports, "isRangeInsideOfRendererContainer", ()=>$ac0a8694eb2f51b4$export$90ee8f2d9317f430);
    const $ac0a8694eb2f51b4$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
        const sourceRange = document.createRange();
        sourceRange.selectNode(rendererDOM);
        const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
        const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
        const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
        return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
    };
});
parcelRegister("aaeg2", function(module, exports) {
    $parcel$export(module.exports, "SelectionInlineCommentMounter", ()=>$dccd273898f7e581$export$ca7741472ed8ba00);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $2oS3b;
    var $ka8BB;
    var $20EGj = parcelRequire("20EGj");
    var $6SKbt;
    var $dAQq9;
    var $35dtk;
    const $dccd273898f7e581$export$ca7741472ed8ba00 = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
        const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('annotations_defensive_node_name_calculations')) {
                if (!actions.isRangeAnnotatable(range)) return undefined;
                return (0, (0, parcelRequire("dAQq9")).getRendererRangeInlineNodeNames)({
                    pos: documentPosition,
                    actions: actions
                });
            } else {
                if (!(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
                if (actions.isValidAnnotationRange(range)) return (0, (0, parcelRequire("dAQq9")).getRendererRangeInlineNodeNames)({
                    pos: documentPosition,
                    actions: actions
                });
                else return undefined;
            }
        }, [
            documentPosition,
            actions,
            range
        ]);
        const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation) return false;
            const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
            if (!isCreateAllowedOnPosition) return false;
            const annotation = {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
            }).fire((0, $20EGj.FabricChannel).editor);
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            actions,
            documentPosition,
            applyAnnotation,
            draftDocumentPosition,
            createAnalyticsEvent,
            inlineNodeTypes
        ]);
        const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
            if (!documentPosition || !generateIndexMatch) return false;
            const result = generateIndexMatch(documentPosition);
            if (!result) return false;
            return result;
        }, [
            documentPosition,
            generateIndexMatch
        ]);
        const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
            if (!documentPosition || !isAnnotationAllowed) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {
                        inlineNodeNames: inlineNodeTypes
                    },
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
                }).fire((0, $20EGj.FabricChannel).editor);
                return false;
            }
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt(documentPosition);
            if (createAnalyticsEvent) {
                const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
                createAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).OPENED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: uniqueAnnotationsInRange.length,
                        inlineNodeNames: inlineNodeTypes
                    }
                }).fire((0, $20EGj.FabricChannel).editor);
            }
            window.requestAnimationFrame(()=>{
                if (options.keepNativeSelection) (0, (0, parcelRequire("ka8BB")).updateWindowSelectionAroundDraft)(documentPosition);
                else {
                    const sel = window.getSelection();
                    if (sel) sel.removeAllRanges();
                }
            });
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
            const annotation = {
                annotationId: options.annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            documentPosition,
            isAnnotationAllowed,
            applyAnnotationDraftAt,
            createAnalyticsEvent,
            applyAnnotation,
            draftDocumentPosition,
            actions,
            range,
            inlineNodeTypes
        ]);
        const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
            clearAnnotationDraft();
            setDraftDocumentPosition(null);
            const sel = window.getSelection();
            if (sel) sel.removeAllRanges();
        }, [
            clearAnnotationDraft
        ]);
        const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).CLOSED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $20EGj.FabricChannel).editor);
            removeDraftModeCallback();
            onCloseProps();
        }, [
            onCloseProps,
            removeDraftModeCallback,
            createAnalyticsEvent,
            inlineNodeTypes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            range: range,
            draftRange: draftRange,
            wrapperDOM: wrapperDOM.current,
            isAnnotationAllowed: isAnnotationAllowed,
            onClose: onCloseCallback,
            onCreate: onCreateCallback,
            getAnnotationIndexMatch: createIndexCallback,
            applyDraftMode: applyDraftModeCallback,
            removeDraftMode: removeDraftModeCallback,
            inlineNodeTypes: inlineNodeTypes
        });
    });
});
parcelRegister("dmpPy", function(module, exports) {
    $parcel$export(module.exports, "useLoadAnnotations", ()=>$f259a273ed030be7$export$39f7c1a861a0d41c);
    var $5uXOq = parcelRequire("5uXOq");
    var $hj0ZZ;
    var $clIqK;
    var $35dtk;
    const $f259a273ed030be7$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("35dtk")).RendererContext));
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("clIqK")).ProvidersContext));
        (0, $5uXOq.useEffect)(()=>{
            if (!providers) return;
            const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
            const annotations = actions.getAnnotationMarks();
            if (!annotations.length) {
                onLoadComplete && onLoadComplete({
                    numberOfUnresolvedInlineComments: 0
                });
                return;
            }
            const ids = annotations.map((mark)=>mark.attrs.id);
            const cb = (data)=>{
                if (!updateSubscriberInlineComment) return;
                const payload = data.reduce((acc, value)=>({
                        ...acc,
                        [value.id]: value
                    }), {});
                updateSubscriberInlineComment.emit((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
                onLoadComplete && onLoadComplete({
                    numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
                });
            };
            inlineCommentGetState(ids, isNestedRender).then(cb);
        }, [
            actions,
            providers,
            adfDocument,
            isNestedRender,
            onLoadComplete
        ]);
    };
});
parcelRegister("6c6bW", function(module, exports) {
    $parcel$export(module.exports, "TextWithAnnotationDraft", ()=>$86fae105fc4c70bc$export$69a4e0ac39aaf9b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fhZID;
    var $clIqK;
    var $g4UrI;
    var $5JQCF;
    var $ka8BB;
    var $084mA;
    var $9w2jc;
    var $aYRbA;
    const $86fae105fc4c70bc$var$markStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", (0, (0, parcelRequire("084mA")).AnnotationSharedCSSByState)().common, (0, (0, parcelRequire("084mA")).AnnotationSharedCSSByState)().focus);
    const $86fae105fc4c70bc$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("mark", {
            "data-renderer-mark": true,
            ...(0, (0, parcelRequire("ka8BB")).dataAttributes)(draftPosition),
            css: $86fae105fc4c70bc$var$markStyles
        }, children);
    };
    const $86fae105fc4c70bc$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
        if (annotationPosition === (0, (0, parcelRequire("fhZID")).InsertDraftPosition).START) return 0;
        if (annotationPosition === (0, (0, parcelRequire("fhZID")).InsertDraftPosition).END) return fragmentCount - 1;
        if (annotationPosition === (0, (0, parcelRequire("fhZID")).InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
        return -1;
    };
    const $86fae105fc4c70bc$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
        const annotateIndex = $86fae105fc4c70bc$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
        return texts.map((value, index)=>{
            const segments = (0, (0, parcelRequire("9w2jc")).segmentText)(value, textHighlighter);
            if (annotateIndex === index) return (0, (0, parcelRequire("f8Sb3")).jsx)($86fae105fc4c70bc$export$8062d68eccdfa39c, {
                key: index,
                draftPosition: draftPosition
            }, (0, (0, parcelRequire("aYRbA")).renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, (0, parcelRequire("aYRbA")).renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
        });
    };
    const $86fae105fc4c70bc$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
        const textPosition = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                start: startPos,
                end: endPos
            }), [
            endPos,
            startPos
        ]);
        const nextDraftPosition = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("clIqK")).AnnotationsDraftContext));
        const shouldApplyAnnotationAt = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!nextDraftPosition) return false;
            return (0, (0, parcelRequire("5JQCF")).calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
        }, [
            nextDraftPosition,
            textPosition
        ]);
        const textString = (0, (0, parcelRequire("g4UrI")).findTextString)(children);
        if (!textString) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children);
        if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
            const segments = (0, (0, parcelRequire("9w2jc")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("aYRbA")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        if (shouldApplyAnnotationAt === (0, (0, parcelRequire("fhZID")).InsertDraftPosition).AROUND_TEXT) {
            const segments = (0, (0, parcelRequire("9w2jc")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)($86fae105fc4c70bc$export$8062d68eccdfa39c, {
                key: 0,
                draftPosition: nextDraftPosition
            }, (0, (0, parcelRequire("aYRbA")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        const offsets = (0, (0, parcelRequire("g4UrI")).calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
        const texts = (0, (0, parcelRequire("g4UrI")).splitText)(textString, offsets);
        if (!texts) {
            const segments = (0, (0, parcelRequire("9w2jc")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("aYRbA")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        const components = $86fae105fc4c70bc$export$b756d37afc321d72({
            texts: texts,
            shouldApplyAnnotationAt: shouldApplyAnnotationAt,
            draftPosition: nextDraftPosition,
            textHighlighter: textHighlighter,
            marks: marks
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, components);
    };
});
parcelRegister("fhZID", function(module, exports) {
    $parcel$export(module.exports, "InsertDraftPosition", ()=>$d5bcb084126546e9$export$c1bd4813440b4505);
    var $d5bcb084126546e9$export$c1bd4813440b4505;
    (function(InsertDraftPosition) {
        InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
        InsertDraftPosition["START"] = "START";
        InsertDraftPosition["END"] = "END";
        InsertDraftPosition["INSIDE"] = "INSIDE";
    })($d5bcb084126546e9$export$c1bd4813440b4505 || ($d5bcb084126546e9$export$c1bd4813440b4505 = {}));
});
parcelRegister("g4UrI", function(module, exports) {
    $parcel$export(module.exports, "findTextString", ()=>$48a27075a57967b9$export$a9795c84b22a1f06);
    $parcel$export(module.exports, "splitText", ()=>$48a27075a57967b9$export$2878cc467c8be8fe);
    $parcel$export(module.exports, "calcTextSplitOffset", ()=>$48a27075a57967b9$export$1059bfc467f4f55d);
    var $5uXOq = parcelRequire("5uXOq");
    const $48a27075a57967b9$export$a9795c84b22a1f06 = (reactNode)=>{
        let result = null;
        const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
        for (const childNode of children){
            if (result) break;
            else if (typeof childNode === 'string') result = childNode;
            else if ($48a27075a57967b9$var$isReactElement(childNode) && childNode.props.children) result = $48a27075a57967b9$export$a9795c84b22a1f06(childNode.props.children);
        }
        return result;
    };
    function $48a27075a57967b9$var$isReactElement(child) {
        return !!child.type;
    }
    const $48a27075a57967b9$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
        if (endOffset > text.length || endOffset - startOffset <= 0) return null;
        return [
            text.slice(0, startOffset),
            text.slice(startOffset, endOffset),
            text.slice(endOffset)
        ].filter(Boolean);
    };
    const $48a27075a57967b9$export$1059bfc467f4f55d = (position, textPosition, text)=>{
        const { start: start, end: end } = textPosition;
        const startOffset = Math.max(position.from - start, 0);
        const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
        return {
            startOffset: startOffset,
            endOffset: endOffset
        };
    };
});
parcelRegister("5JQCF", function(module, exports) {
    $parcel$export(module.exports, "calcInsertDraftPositionOnText", ()=>$c1921e910237bfd7$export$b1baddbd5f289877);
    var $fhZID;
    const $c1921e910237bfd7$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
        const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
        if (isRangePositionAroundText) return (0, (0, parcelRequire("fhZID")).InsertDraftPosition).AROUND_TEXT;
        const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
        if (isRangePositionInsideText) return (0, (0, parcelRequire("fhZID")).InsertDraftPosition).INSIDE;
        const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
        if (isRangePositionStartingAtText) return (0, (0, parcelRequire("fhZID")).InsertDraftPosition).END;
        const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
        if (isRangePositionEndingAtText) return (0, (0, parcelRequire("fhZID")).InsertDraftPosition).START;
        return false;
    };
});
parcelRegister("084mA", function(module, exports) {
    $parcel$export(module.exports, "AnnotationSharedClassNames", ()=>$acd7c00ea250564e$export$b0aeb22a160e5b4c);
    $parcel$export(module.exports, "BlockAnnotationSharedClassNames", ()=>$acd7c00ea250564e$export$ac15f3ad21fefeac);
    $parcel$export(module.exports, "AnnotationSharedCSSByState", ()=>$acd7c00ea250564e$export$261ebe180da42726);
    $parcel$export(module.exports, "annotationSharedStyles", ()=>$acd7c00ea250564e$export$5f72fe1d39f8129b);
    var $f8Sb3;
    var $2oS3b;
    function $acd7c00ea250564e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $acd7c00ea250564e$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
    const $acd7c00ea250564e$export$b0aeb22a160e5b4c = {
        focus: `${$acd7c00ea250564e$export$6d0ce11e3a04da25}-focus`,
        blur: `${$acd7c00ea250564e$export$6d0ce11e3a04da25}-blur`,
        draft: `${$acd7c00ea250564e$export$6d0ce11e3a04da25}-draft`
    };
    const $acd7c00ea250564e$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
    const $acd7c00ea250564e$export$ac15f3ad21fefeac = {
        focus: `${$acd7c00ea250564e$export$3600479d19dfa7a9}-focus`,
        blur: `${$acd7c00ea250564e$export$3600479d19dfa7a9}-blur`,
        draft: `${$acd7c00ea250564e$export$3600479d19dfa7a9}-draft`
    };
    var $acd7c00ea250564e$var$_ref = {
        name: "kh65d",
        styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
    };
    var $acd7c00ea250564e$var$_ref2 = {
        name: "buc4yh",
        styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
    };
    const $acd7c00ea250564e$export$261ebe180da42726 = ()=>{
        if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) return {
            common: {
                borderBottom: '2px solid transparent',
                cursor: 'pointer',
                padding: '1px 0 2px',
                '&:has(.card), &:has([data-inline-card])': (0, (0, parcelRequire("2oS3b")).fg)('annotations_align_editor_and_renderer_styles') ? {
                    padding: '5px 0 3px 0'
                } : {
                    paddingTop: '4px',
                    border: 'none',
                    boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
                },
                '&:has(.date-lozenger-container)': {
                    paddingTop: '2px'
                }
            },
            focus: $acd7c00ea250564e$var$_ref2,
            blur: $acd7c00ea250564e$var$_ref
        };
        else return {
            focus: (0, (0, parcelRequire("f8Sb3")).css)({
                background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
                borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                cursor: 'pointer'
            }),
            blur: (0, (0, parcelRequire("f8Sb3")).css)({
                background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
                borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
                cursor: 'pointer'
            })
        };
    };
    const $acd7c00ea250564e$export$5f72fe1d39f8129b = ()=>(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.blur, ",.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.focus, ",.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.draft, "{", $acd7c00ea250564e$export$261ebe180da42726().common, ";}.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.focus, "{", $acd7c00ea250564e$export$261ebe180da42726().focus, ";}.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.draft, "{", $acd7c00ea250564e$export$261ebe180da42726().focus, ";cursor:initial;}.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.blur, "{", $acd7c00ea250564e$export$261ebe180da42726().blur, ";}}") : (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.focus, "{", $acd7c00ea250564e$export$261ebe180da42726().focus, ";}.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.draft, "{", $acd7c00ea250564e$export$261ebe180da42726().focus, ";cursor:initial;}.", $acd7c00ea250564e$export$b0aeb22a160e5b4c.blur, "{", $acd7c00ea250564e$export$261ebe180da42726().blur, ";}}");
});
parcelRegister("9w2jc", function(module, exports) {
    $parcel$export(module.exports, "segmentText", ()=>$c579e094c31b171a$export$93301b6f1ff0b0c3);
    function $c579e094c31b171a$export$93301b6f1ff0b0c3(text, highlighter) {
        if (!highlighter || !text) return [
            {
                type: 'plain',
                text: text ?? ''
            }
        ];
        const segments = [];
        let pos = 0;
        try {
            const markTextSegmentMatches = text.matchAll(highlighter.pattern);
            for (const markTextMatch of markTextSegmentMatches){
                if (markTextMatch.index !== 0) segments.push({
                    type: 'plain',
                    text: text.substring(pos, markTextMatch.index)
                });
                segments.push({
                    type: 'match',
                    text: markTextMatch[0],
                    groups: markTextMatch.groups && Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
                });
                pos = markTextMatch.index + markTextMatch[0].length;
            }
            if (pos < text.length) segments.push({
                type: 'plain',
                text: text.substring(pos)
            });
            return segments;
        } catch (_e) {}
        return [
            {
                type: 'plain',
                text: text
            }
        ];
    }
});
parcelRegister("aYRbA", function(module, exports) {
    $parcel$export(module.exports, "renderTextSegments", ()=>$a43ecebbb836b49b$export$8a20fd0614851c5f);
    var $5uXOq = parcelRequire("5uXOq");
    function $a43ecebbb836b49b$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
        const Component = textHighlighter?.component;
        const marks = new Set(marksList.map((m)=>m.type.name));
        function renderSegment(segment, idx = 0) {
            if (segment.type === 'plain' || !Component) return segment.text;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-highlighted": true,
                "data-vc": "highlighted-text"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                key: `${segment.text}_${startPos}_${idx}`,
                startPos: startPos + idx
            }, segment.text));
        }
        if (segments.length === 1) return renderSegment(segments[0]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
            key: `text-wrapper_${startPos}`
        }, segments.map(renderSegment));
    }
});
parcelRegister("jaTuH", function(module, exports) {
    $parcel$export(module.exports, "MarkElement", ()=>$c5508f820b9c4885$export$f3069f755c1eba0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $jBvYD;
    var $7WRSM;
    var $fTG8Q;
    var $dhxrl;
    var $clIqK;
    var $hj0ZZ;
    const $c5508f820b9c4885$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
        const updateSubscriber = (0, (0, parcelRequire("dhxrl")).useInlineCommentSubscriberContext)();
        const states = (0, $5uXOq.useContext)((0, (0, parcelRequire("clIqK")).InlineCommentsStateContext));
        const hasFocus = (0, (0, parcelRequire("7WRSM")).useHasFocusEvent)({
            id: id,
            updateSubscriber: updateSubscriber
        });
        const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
            dataAttributes
        ]);
        const onClick = (0, $5uXOq.useCallback)((props)=>{
            if (!updateSubscriber) return;
            if (useBlockLevel) return;
            const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
            updateSubscriber.emit((0, (0, parcelRequire("hj0ZZ")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: annotationIds,
                eventTarget: eventTarget
            });
        }, [
            updateSubscriber,
            useBlockLevel
        ]);
        const activeParentIds = (0, (0, parcelRequire("fTG8Q")).useInlineCommentsFilter)({
            annotationIds: annotationParentIds,
            filter: {
                state: (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jBvYD")).MarkComponent), {
            id: id,
            dataAttributes: dataAttributesMemorized,
            annotationParentIds: activeParentIds,
            onClick: onClick,
            hasFocus: hasFocus,
            state: states[id],
            useBlockLevel: useBlockLevel
        }, children);
    };
});
parcelRegister("jBvYD", function(module, exports) {
    $parcel$export(module.exports, "MarkComponent", ()=>$19d55dc99d3a0db4$export$4f5a51511304fdd0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2H0Fr;
    var $084mA;
    var $88i6h;
    var $2oS3b;
    var $koVbs;
    var $gAy7Q;
    const $19d55dc99d3a0db4$var$markStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE, "']{", (0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? (0, (0, parcelRequire("084mA")).AnnotationSharedCSSByState)().common : '', " ", (0, (0, parcelRequire("084mA")).AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, (0, parcelRequire("084mA")).AnnotationSharedCSSByState)().focus, ";}}");
    const $19d55dc99d3a0db4$var$isMobile = ()=>{
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    const $19d55dc99d3a0db4$var$accessibilityStyles = (startMarker, endMarker)=>(0, (0, parcelRequire("f8Sb3")).css)({
            '&::before, &::after': {
                clipPath: 'inset(100%)',
                clip: 'rect(1px, 1px, 1px, 1px)',
                height: '1px',
                overflow: 'hidden',
                position: 'absolute',
                whiteSpace: 'nowrap',
                width: '1px'
            },
            '&::before': {
                content: `' [${startMarker}] '`
            },
            '&::after': {
                content: `' [${endMarker}] '`
            }
        });
    const $19d55dc99d3a0db4$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, onClick: onClick, useBlockLevel: useBlockLevel })=>{
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("2H0Fr")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const annotationIds = (0, $5uXOq.useMemo)(()=>[
                ...new Set([
                    ...annotationParentIds,
                    id
                ])
            ], [
            id,
            annotationParentIds
        ]);
        const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
            if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
            if (event.defaultPrevented || state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE) return;
            if ((0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                    if (event.target.closest('[data-mention-id]')) ;
                    else {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            } else event.preventDefault();
            onClick({
                eventTarget: event.target,
                annotationIds: annotationIds
            });
        }, [
            annotationIds,
            onClick,
            state
        ]);
        const onMarkEnter = (evt)=>{
            const focusedElementTag = document.activeElement?.tagName;
            if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
        };
        const overriddenData = !state ? dataAttributes : {
            ...dataAttributes,
            'data-mark-annotation-state': state,
            'data-has-focus': hasFocus
        };
        const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $19d55dc99d3a0db4$var$isMobile() ? {} : {
            role: 'button',
            tabIndex: 0,
            onKeyDown: onMarkEnter,
            'aria-expanded': hasFocus
        } : {};
        const accessibility = state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE ? {
            'aria-disabled': true
        } : {
            'aria-details': annotationIds.join(', '),
            ...desktopAccessibilityAttributes
        };
        const getAccessibilityStyles = ()=>{
            if ($19d55dc99d3a0db4$var$isMobile()) return {};
            if (isInlineCommentsKbAccessible && state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).RESOLVED) {
                const startMarker = intl.formatMessage((0, (0, parcelRequire("gAy7Q")).inlineCommentMessages).contentRendererInlineCommentMarkerStart);
                const endMarker = intl.formatMessage((0, (0, parcelRequire("gAy7Q")).inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
                return $19d55dc99d3a0db4$var$accessibilityStyles(startMarker, endMarker);
            } else return {};
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)(useBlockLevel ? 'div' : 'mark', {
            id: id,
            [(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
            ...accessibility,
            ...overriddenData,
            ...!useBlockLevel && {
                css: [
                    $19d55dc99d3a0db4$var$markStyles,
                    getAccessibilityStyles()
                ]
            }
        }, children);
    };
});
parcelRegister("gAy7Q", function(module, exports) {
    $parcel$export(module.exports, "headingAnchorLinkMessages", ()=>$dbd66939c6a91887$export$74bada844422036d);
    $parcel$export(module.exports, "tableCellMessages", ()=>$dbd66939c6a91887$export$c79ebc36348824d1);
    $parcel$export(module.exports, "inlineCommentMessages", ()=>$dbd66939c6a91887$export$9f52c375a6ef34fc);
    var $7VHMR;
    const $dbd66939c6a91887$export$74bada844422036d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyHeadingLinkToClipboard: {
            id: 'fabric.editor.headingLink.copyAnchorLink',
            defaultMessage: 'Copy link to heading',
            description: 'Copy heading link to clipboard'
        },
        copiedHeadingLinkToClipboard: {
            id: 'fabric.editor.headingLink.copied',
            defaultMessage: 'Copied!',
            description: 'Copied heading link to clipboard'
        },
        failedToCopyHeadingLink: {
            id: 'fabric.editor.headingLink.failedToCopy',
            defaultMessage: 'Copy failed',
            description: 'failed to copy heading link to clipboard'
        },
        copyAriaLabel: {
            id: 'fabric.editor.headingLink.copyAriaLabel',
            defaultMessage: 'Copy',
            description: 'copy aria label for link icon'
        }
    });
    const $dbd66939c6a91887$export$c79ebc36348824d1 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noneSortingLabel: {
            id: 'fabric.editor.headingLink.noneSortingLabel',
            defaultMessage: 'none',
            description: 'this table column is not sorted'
        },
        ascSortingLabel: {
            id: 'fabric.editor.headingLink.ascSortingLabel',
            defaultMessage: 'ascending',
            description: 'this table column is sorted in ascending order'
        },
        descSortingLabel: {
            id: 'fabric.editor.headingLink.descSortingLabel',
            defaultMessage: 'descending',
            description: 'this table column is sorted in descending order'
        }
    });
    const $dbd66939c6a91887$export$9f52c375a6ef34fc = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        contentRendererInlineCommentMarkerStart: {
            id: 'fabric.editor.inlineComment.marker.start',
            defaultMessage: 'inline comment start',
            description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
        },
        contentRendererInlineCommentMarkerEnd: {
            id: 'fabric.editor.inlineComment.marker.end',
            defaultMessage: 'inline comment end',
            description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
        }
    });
});
parcelRegister("fTG8Q", function(module, exports) {
    $parcel$export(module.exports, "useInlineCommentsFilter", ()=>$4d4ba6971034dab7$export$8e7d47f9e38ad4f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $clIqK;
    const $4d4ba6971034dab7$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
        const states = (0, $5uXOq.useContext)((0, (0, parcelRequire("clIqK")).InlineCommentsStateContext));
        return (0, $5uXOq.useMemo)(()=>{
            return annotationIds.reduce((acc, id)=>{
                if (states && states[id] === stateFilter) return [
                    ...acc,
                    id
                ];
                return acc;
            }, []);
        }, [
            annotationIds,
            states,
            stateFilter
        ]);
    };
});
parcelRegister("dhxrl", function(module, exports) {
    $parcel$export(module.exports, "useInlineCommentSubscriberContext", ()=>$1d2a2bf77f26ea14$export$b46737175cffd396);
    var $5uXOq = parcelRequire("5uXOq");
    var $clIqK;
    const $1d2a2bf77f26ea14$export$b46737175cffd396 = ()=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("clIqK")).ProvidersContext));
        if (!providers) return null;
        const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
        return updateSubscriber || null;
    };
});
parcelRegister("f3cky", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c1c4f9e72d08fdd$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $lklLu;
    var $f045t;
    var $5WUHq;
    var $caFD8;
    var $6zogC;
    var $9N9gL;
    const $7c1c4f9e72d08fdd$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
        const actions = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            return {
                changeActive (index) {
                    return updateActiveChild(index);
                },
                addChild () {
                    return false;
                },
                getChildrenCount () {
                    return children ? children?.length : 0;
                },
                removeChild (index) {
                    return false;
                },
                updateParameters (parameters) {
                    return false;
                },
                getChildren () {
                    return [];
                }
            };
        }, [
            updateActiveChild,
            children
        ]);
        return actions;
    };
    const $7c1c4f9e72d08fdd$var$navigationCssExtended = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("5WUHq")).sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
    const $7c1c4f9e72d08fdd$var$MultiBodiedExtension = (props)=>{
        const { children: children, layout: layout = 'default', path: path = [] } = props;
        const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
        const removeOverflow = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
        const overflowContainerClass = !removeOverflow ? (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
        const updateActiveChild = (0, ($parcel$interopDefault($5uXOq))).useCallback((index)=>{
            if (typeof index !== 'number') {
                setActiveChildIndex(0);
                return false;
            }
            setActiveChildIndex(index);
            return true;
        }, [
            setActiveChildIndex
        ]);
        const actions = $7c1c4f9e72d08fdd$var$useMultiBodiedExtensionActions({
            updateActiveChild: updateActiveChild,
            children: children
        });
        const containerCssExtended = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("5WUHq")).sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $72ba03e317f3d228$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, (0, parcelRequire("5WUHq")).sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
        const isTopLevel = path.length < 1;
        const centerAlignClass = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) ? (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
        function renderMbeContent(width) {
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: `${(0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
                style: {
                    width: isTopLevel ? (0, (0, parcelRequire("9N9gL")).calcBreakoutWidth)(layout, width) : '100%'
                },
                "data-layout": layout
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
                className: "multiBodiedExtension-navigation",
                css: $7c1c4f9e72d08fdd$var$navigationCssExtended,
                "data-testid": "multiBodiedExtension-navigation"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f045t")).default), {
                ...props,
                actions: actions,
                type: "multiBodiedExtension"
            }, ({ result: result })=>{
                try {
                    if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, (0, parcelRequire("lklLu")).renderExtension)(result, layout, {
                        isTopLevel: path.length < 1
                    });
                } catch (e) {}
                return (0, (0, parcelRequire("lklLu")).renderExtension)(children, layout, {
                    isTopLevel: path.length < 1
                });
            })), (0, (0, parcelRequire("f8Sb3")).jsx)("article", {
                "data-testid": "multiBodiedExtension--frames",
                className: `multiBodiedExtension--frames`
            }, children));
        }
        return (0, (0, parcelRequire("f8Sb3")).jsx)("section", {
            className: "multiBodiedExtension--container",
            css: containerCssExtended,
            "data-testid": "multiBodiedExtension--container",
            "data-active-child-index": activeChildIndex,
            "data-layout": layout
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("caFD8")).WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
    };
    var $7c1c4f9e72d08fdd$export$2e2bcd8739ae039 = $7c1c4f9e72d08fdd$var$MultiBodiedExtension;
});
parcelRegister("5WUHq", function(module, exports) {
    $parcel$export(module.exports, "removeMarginsAndBorder", ()=>$6670505f7504ed5a$export$8df0393dc2d5d656);
    $parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", ()=>$6670505f7504ed5a$export$9c7196ca47f67390);
    var $f8Sb3;
    function $6670505f7504ed5a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6670505f7504ed5a$var$mbeExtensionContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        background: 'transparent !important',
        'padding:': {
            left: `${"var(--ds-space-100, 8px)"} !important`,
            right: `${"var(--ds-space-100, 8px)"} !important`
        },
        paddingBottom: "var(--ds-space-100, 8px)",
        '&.remove-padding': {
            paddingBottom: 0
        },
        position: 'relative',
        verticalAlign: 'middle',
        cursor: 'pointer',
        '.multiBodiedExtension-handler-result': {
            marginLeft: "var(--ds-space-100, 8px)"
        },
        ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
            display: 'none',
            background: "var(--ds-surface, white)"
        },
        '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
            "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
                marginTop: 0
            }
        }
    });
    const $6670505f7504ed5a$var$mbeNavigation = {
        name: "2ubief",
        styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
    };
    const $6670505f7504ed5a$var$extensionFrameContent = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} !important`,
        display: 'block',
        minHeight: '100px',
        background: "var(--ds-surface, white)",
        borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
        borderBottomRightRadius: "var(--ds-border-radius, 3px)",
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        cursor: 'initial',
        '.pm-table-with-controls': {
            marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
            paddingRight: `${"var(--ds-space-150, 12px)"} !important`
        },
        '.bodiedExtensionView-content-wrap': {
            marginTop: `${"var(--ds-space-150, 12px)"} !important`
        },
        '.extensionView-content-wrap': {
            marginTop: `${"var(--ds-space-100, 8px)"} !important`
        }
    });
    const $6670505f7504ed5a$export$8df0393dc2d5d656 = {
        name: "c620zi",
        styles: "margin-left:0;margin-right:0;border:none"
    };
    const $6670505f7504ed5a$export$9c7196ca47f67390 = {
        mbeExtensionContainer: $6670505f7504ed5a$var$mbeExtensionContainer,
        mbeNavigation: $6670505f7504ed5a$var$mbeNavigation,
        extensionFrameContent: $6670505f7504ed5a$var$extensionFrameContent
    };
});
parcelRegister("1Sdr8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cf3b51a33a820fc$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $5cf3b51a33a820fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5cf3b51a33a820fc$var$containerCSS = {
        name: "ecvjkq",
        styles: "min-height:100px"
    };
    const $5cf3b51a33a820fc$var$ExtensionFrame = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $5cf3b51a33a820fc$var$containerCSS,
            "data-extension-frame": "true",
            style: {
                flexBasis: `100%`
            }
        }, props.children);
    };
    var $5cf3b51a33a820fc$export$2e2bcd8739ae039 = $5cf3b51a33a820fc$var$ExtensionFrame;
});
parcelRegister("j4Mf9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b5d2da5d3b12f97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kjhhp;
    var $59laf;
    function $7b5d2da5d3b12f97$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("ul", {
            className: (0, (0, parcelRequire("kjhhp")).bulletListSelector).substr(1),
            "data-indent-level": props.path ? (0, (0, parcelRequire("59laf")).getListIndentLevel)(props.path) : 1
        }, props.children);
    }
});
parcelRegister("59laf", function(module, exports) {
    $parcel$export(module.exports, "getListIndentLevel", ()=>$de9ab52220b94f32$export$75aa84e85754623e);
    function $de9ab52220b94f32$export$75aa84e85754623e(path) {
        let count = 1;
        path.forEach((node)=>{
            if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
        });
        return count;
    }
});
parcelRegister("02ldW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ce33275d87f05aa$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "DocWithSelectAllTrap", ()=>$8ce33275d87f05aa$export$41121a410ca2f650);
    var $5uXOq = parcelRequire("5uXOq");
    var $6zogC;
    var $7Xbkq;
    function $8ce33275d87f05aa$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT
        }, props.children);
    }
    function $8ce33275d87f05aa$export$41121a410ca2f650(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: (0, (0, parcelRequire("7Xbkq")).useSelectAllTrap)(),
            className: (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT
        }, props.children);
    }
});
parcelRegister("7Xbkq", function(module, exports) {
    $parcel$export(module.exports, "useSelectAllTrap", ()=>$0a43d636c9d5999f$export$98871b245ee25215);
    var $6SKbt;
    var $5uXOq = parcelRequire("5uXOq");
    var $drjNK;
    var $i67U6;
    var $2oS3b;
    const $0a43d636c9d5999f$export$98871b245ee25215 = ()=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("drjNK")).default));
        const ref = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const clicked = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const caught = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
        const onKeyDown = (0, ($parcel$interopDefault($5uXOq))).useCallback((e)=>{
            const el = ref.current;
            if (!el) return;
            const modKey = mac ? e.metaKey : e.ctrlKey;
            if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
            const elementSelection = (0, (0, parcelRequire("i67U6")).ElementSelection).fromWindow();
            const isInput = (0, (0, parcelRequire("2oS3b")).fg)('platform-datasources-enable-two-way-sync') ? e.target?.matches?.('input') : false;
            if (elementSelection.eq(caught.current) || isInput) {
                fireAnalyticsEvent({
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).SELECT_ALL_ESCAPED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER
                });
                return;
            }
            if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
                fireAnalyticsEvent({
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).SELECT_ALL_CAUGHT,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER
                });
                e.preventDefault();
                caught.current = elementSelection.select(el);
            }
        }, [
            mac,
            ref,
            fireAnalyticsEvent,
            clicked,
            caught
        ]);
        const onClick = (0, ($parcel$interopDefault($5uXOq))).useCallback((e)=>{
            clicked.current = ref.current?.contains(e.target) ?? false;
        }, [
            ref,
            clicked
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            window.addEventListener('keydown', onKeyDown);
            window.addEventListener('click', onClick);
            return ()=>{
                window.removeEventListener('keydown', onKeyDown);
                window.removeEventListener('click', onClick);
            };
        }, [
            onKeyDown,
            onClick
        ]);
        return ref;
    };
});
parcelRegister("drjNK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd70417b0c5f97b5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $dd70417b0c5f97b5$var$AnalyticsContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        fireAnalyticsEvent: (_event)=>null
    });
    var $dd70417b0c5f97b5$export$2e2bcd8739ae039 = $dd70417b0c5f97b5$var$AnalyticsContext;
});
parcelRegister("i67U6", function(module, exports) {
    $parcel$export(module.exports, "ElementSelection", ()=>$23960228028bab47$export$6e6724d89f27411);
    class $23960228028bab47$export$6e6724d89f27411 {
        constructor(selection){
            this.type = selection ? selection.type : 'None';
            if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
        }
        eq(selection) {
            if (!selection) return false;
            if (this.range && selection.range) {
                const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
                const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
                return startMatches && endMatches;
            }
            return this.type === 'None' && selection.type === 'None';
        }
        inside(el) {
            return el.contains(this.range?.commonAncestorContainer ?? null);
        }
        select(el) {
            const range = document.createRange();
            range.selectNodeContents(el);
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
            return $23960228028bab47$export$6e6724d89f27411.fromWindow();
        }
        static fromWindow(win = window) {
            return new $23960228028bab47$export$6e6724d89f27411(win.getSelection());
        }
    }
});
parcelRegister("ddxNm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$433e78ec430db034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $433e78ec430db034$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
        if (forceNewLine) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("br", null);
    };
    var $433e78ec430db034$export$2e2bcd8739ae039 = $433e78ec430db034$var$HardBreak;
});
parcelRegister("cTi0Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$761c05a2defd485f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8L7RC;
    var $6SKbt;
    var $drjNK;
    var $flTv6;
    const $761c05a2defd485f$var$getCurrentUrlWithHash = (hash = '')=>{
        const url = new URL(window.location.href);
        url.search = '';
        url.hash = encodeURIComponent(hash);
        return url.href;
    };
    function $761c05a2defd485f$var$hasRightAlignmentMark(marks) {
        if (!marks || !marks.length) return false;
        return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
    }
    function $761c05a2defd485f$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drjNK")).default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8L7RC")).default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("6SKbt")).ACTION).CLICKED,
                        actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).UI
                    });
                    return (0, (0, parcelRequire("flTv6")).copyTextToClipboard)($761c05a2defd485f$var$getCurrentUrlWithHash(headingId));
                }
            }));
    }
    function $761c05a2defd485f$var$Heading(props) {
        const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
        const HX = `h${props.level}`;
        const showAnchorLink = !!props.showAnchorLink;
        const isRightAligned = $761c05a2defd485f$var$hasRightAlignmentMark(marks);
        const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
        const headingIdToUse = invisible ? undefined : headingId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(HX, {
            id: headingIdToUse,
            ...dataAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showAnchorLink && headingId && isRightAligned && (0, ($parcel$interopDefault($5uXOq))).createElement($761c05a2defd485f$var$WrappedHeadingAnchor, {
            level: props.level,
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            headingId: headingId
        }), props.children, showAnchorLink && headingId && !isRightAligned && (0, ($parcel$interopDefault($5uXOq))).createElement($761c05a2defd485f$var$WrappedHeadingAnchor, {
            level: props.level,
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            headingId: headingId
        })));
    }
    var $761c05a2defd485f$export$2e2bcd8739ae039 = $761c05a2defd485f$var$Heading;
});
parcelRegister("8L7RC", function(module, exports) {
    $parcel$export(module.exports, "HeadingAnchorWrapperClassName", ()=>$d2a19bfc02fae344$export$3c9cedc52604835d);
    $parcel$export(module.exports, "default", ()=>$d2a19bfc02fae344$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5nOGd;
    var $loZC0;
    var $8RXs9;
    var $gAy7Q;
    const $d2a19bfc02fae344$export$3c9cedc52604835d = 'heading-anchor-wrapper';
    const $d2a19bfc02fae344$var$CopyAnchorWrapperWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...rest,
            className: $d2a19bfc02fae344$export$3c9cedc52604835d,
            ref: ref
        }, children));
    });
    const $d2a19bfc02fae344$var$copyAnchorButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline',
        outline: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: `var(--ds-icon, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`,
        cursor: 'pointer',
        right: 0
    });
    class $d2a19bfc02fae344$var$HeadingAnchor extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        componentDidMount() {
            this.resetMessage();
        }
        render() {
            const { tooltipMessage: tooltipMessage } = this.state;
            if (tooltipMessage) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("loZC0")).default), {
                tag: $d2a19bfc02fae344$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage
            }, this.renderAnchorButton());
            return this.renderAnchorButton();
        }
        constructor(...args){
            super(...args);
            this.state = {
                tooltipMessage: '',
                isClicked: false
            };
            this.setTooltipState = (message, isClicked = false)=>{
                this.setState({
                    tooltipMessage: this.props.intl.formatMessage(message),
                    isClicked: isClicked
                });
            };
            this.getCopyAriaLabel = ()=>{
                const { copyAriaLabel: copyAriaLabel } = (0, (0, parcelRequire("gAy7Q")).headingAnchorLinkMessages);
                return this.props.intl.formatMessage(copyAriaLabel);
            };
            this.copyToClipboard = async (event)=>{
                const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, (0, parcelRequire("gAy7Q")).headingAnchorLinkMessages);
                event.stopPropagation();
                try {
                    await this.props.onCopyText();
                    this.setTooltipState(copiedHeadingLinkToClipboard, true);
                } catch (e) {
                    this.setTooltipState(failedToCopyHeadingLink);
                }
            };
            this.resetMessage = ()=>{
                this.setTooltipState((0, (0, parcelRequire("gAy7Q")).headingAnchorLinkMessages).copyHeadingLinkToClipboard);
            };
            this.renderAnchorButton = ()=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
                    css: $d2a19bfc02fae344$var$copyAnchorButtonStyles,
                    onMouseLeave: this.resetMessage,
                    onClick: this.copyToClipboard,
                    "aria-label": this.state.tooltipMessage,
                    type: "button"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5nOGd"))))), {
                    label: this.getCopyAriaLabel(),
                    size: this.props.level > 3 ? 'small' : 'medium',
                    primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                }));
            };
        }
    }
    var $d2a19bfc02fae344$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d2a19bfc02fae344$var$HeadingAnchor);
});
parcelRegister("5nOGd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb669b27c378597$var$_react = $3eb669b27c378597$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $3eb669b27c378597$var$_link = $3eb669b27c378597$var$_interopRequireDefault((parcelRequire("lF2mK")));
    function $3eb669b27c378597$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb669b27c378597$var$LinkIcon = (props)=>$3eb669b27c378597$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $3eb669b27c378597$var$_link.default
        }));
    $3eb669b27c378597$var$LinkIcon.displayName = 'LinkIcon';
    var $3eb669b27c378597$var$_default = module.exports.default = $3eb669b27c378597$var$LinkIcon;
});
parcelRegister("lF2mK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fc4f431cbf5e81e8$var$_react = $fc4f431cbf5e81e8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fc4f431cbf5e81e8$var$_UNSAFE_baseNew = $fc4f431cbf5e81e8$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fc4f431cbf5e81e8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fc4f431cbf5e81e8$var$LinkIcon = (props)=>$fc4f431cbf5e81e8$var$_react.default.createElement($fc4f431cbf5e81e8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $fc4f431cbf5e81e8$var$LinkIcon.displayName = 'LinkIcon';
    var $fc4f431cbf5e81e8$var$_default = module.exports.default = $fc4f431cbf5e81e8$var$LinkIcon;
});
parcelRegister("flTv6", function(module, exports) {
    $parcel$export(module.exports, "copyTextToClipboard", ()=>$3ba0af9041b8960a$export$f980440e1ab4537d);
    const $3ba0af9041b8960a$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
            const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
            if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
            else reject('Clipboard API is not supported');
        });
});
parcelRegister("cdB0A", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62d83e88588436bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f045t;
    const $62d83e88588436bc$var$InlineExtension = (props)=>{
        const { text: text } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f045t")).default), {
            ...props,
            type: "inlineExtension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, result);
            } catch (e) {}
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text || 'inlineExtension');
        });
    };
    var $62d83e88588436bc$export$2e2bcd8739ae039 = $62d83e88588436bc$var$InlineExtension;
});
parcelRegister("gj6hB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b06db31b8c923e2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oS3b;
    var $i5Kxj = parcelRequire("i5Kxj");
    function $5b06db31b8c923e2$export$2e2bcd8739ae039(props) {
        const isAdvancedLayoutsPreRelease2 = (0, $i5Kxj.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_advanced_layouts_pre_release_2');
        return isAdvancedLayoutsPreRelease2 ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "layout-section-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length
        }, props.children)) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-section": true
        }, props.children);
    }
});
parcelRegister("ev9Gv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54642fe5c4fb151d$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $5aHmo;
    var $caFD8;
    const $54642fe5c4fb151d$var$layoutColumnClearMarginTopStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("5aHmo")).clearNextSiblingMarginTopStyle), (0, (0, parcelRequire("5aHmo")).clearNextSiblingBlockMarkMarginTopStyle));
    function $54642fe5c4fb151d$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-layout-column": true,
            "data-column-width": props.width,
            style: {
                flexBasis: `${props.width}%`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("caFD8")).WidthProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $54642fe5c4fb151d$var$layoutColumnClearMarginTopStyles
        }), props.children));
    }
});
parcelRegister("5aHmo", function(module, exports) {
    $parcel$export(module.exports, "clearNextSiblingMarginTopStyle", ()=>$6afed134a0007284$export$b15ec88fc1f2e843);
    $parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", ()=>$6afed134a0007284$export$eb3aaa9338936d44);
    var $f8Sb3;
    function $6afed134a0007284$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6afed134a0007284$export$b15ec88fc1f2e843 = {
        name: "1f3w791",
        styles: "& + *{margin-top:0 !important;}"
    };
    const $6afed134a0007284$var$textElements = [
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ];
    const $6afed134a0007284$var$nextSiblingBlockMarkContentSelectors = $6afed134a0007284$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
    const $6afed134a0007284$export$eb3aaa9338936d44 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`${$6afed134a0007284$var$nextSiblingBlockMarkContentSelectors}`]: {
            marginTop: '0 !important'
        }
    });
});
parcelRegister("8aCWn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ebb8239bf8a8773$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $9ebb8239bf8a8773$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, props.children);
    }
});
parcelRegister("5fqw2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$011798829148a172$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPvAM;
    const $011798829148a172$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPvAM")).default), {
            hasContent: true,
            dataAttributes: dataAttributes
        }, children);
    };
    var $011798829148a172$export$2e2bcd8739ae039 = $011798829148a172$var$RenderCaption;
});
parcelRegister("gPvAM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$270fedaf10b18166$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $2B6VH;
    function $270fedaf10b18166$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $270fedaf10b18166$var$captionWrapperStyle = {
        name: "1f0iwez",
        styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
    };
    const $270fedaf10b18166$var$placeholderStyle = (0, (0, parcelRequire("99gde")).xcss)({
        color: 'color.text.subtlest',
        position: 'absolute',
        top: 'space.0',
        width: '100%'
    });
    class $270fedaf10b18166$export$f7feb87190a94c76 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
            const showPlaceholder = !selected && !hasContent;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-media-caption": true,
                "data-testid": "media-caption",
                ...dataAttributes,
                css: $270fedaf10b18166$var$captionWrapperStyle
            }, showPlaceholder ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $270fedaf10b18166$var$placeholderStyle
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), null, formatMessage((0, (0, parcelRequire("2B6VH")).messages).placeholder))) : null, children);
        }
    }
    var $270fedaf10b18166$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($270fedaf10b18166$export$f7feb87190a94c76);
});
parcelRegister("2B6VH", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$59f966aab6edc266$export$defe85febe8b728c);
    var $7VHMR;
    const $59f966aab6edc266$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.editor.captionPlaceholder',
            defaultMessage: 'Add a caption',
            description: 'Placeholder description for an empty (new) caption in the editor'
        }
    });
});
parcelRegister("5bFfj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e5d4be853859c34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dwptW;
    var $6NIy9;
    var $gQuDo;
    var $59laf;
    function $5e5d4be853859c34$export$2e2bcd8739ae039(props) {
        let extraProps = {};
        const itemCounterDigitsSize = (0, (0, parcelRequire("gQuDo")).getItemCounterDigitsSize)({
            order: props.order,
            itemsCount: props?.content?.length
        });
        if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, (0, parcelRequire("6NIy9")).getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
        if (props.order !== undefined) extraProps.start = (0, (0, parcelRequire("gQuDo")).resolveOrder)(props.order);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("ol", {
            className: (0, (0, parcelRequire("dwptW")).orderedListSelector).substr(1),
            "data-indent-level": props.path ? (0, (0, parcelRequire("59laf")).getListIndentLevel)(props.path) : 1,
            start: props.start,
            ...extraProps
        }, props.children);
    }
});
parcelRegister("6NIy9", function(module, exports) {
    $parcel$export(module.exports, "listItemCounterPadding", ()=>$a14ec9b6ac25fac1$export$bafd6beec0797f87);
    $parcel$export(module.exports, "getOrderedListInlineStyles", ()=>$a14ec9b6ac25fac1$export$6d31fdb1d74cee3e);
    $parcel$export(module.exports, "listsSharedStyles", ()=>$a14ec9b6ac25fac1$export$ea95db02cc29c78f);
    var $f8Sb3;
    var $kjhhp;
    var $dwptW;
    var $dMwYp;
    const $a14ec9b6ac25fac1$export$bafd6beec0797f87 = 24;
    var $a14ec9b6ac25fac1$var$CSS_VAR_NAMES;
    (function(CSS_VAR_NAMES) {
        CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    })($a14ec9b6ac25fac1$var$CSS_VAR_NAMES || ($a14ec9b6ac25fac1$var$CSS_VAR_NAMES = {}));
    const $a14ec9b6ac25fac1$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
        let paddingLeft = `2.385ch`;
        if (itemCounterDigitsSize >= 3) {
            const fixedBasePx = 2;
            paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
        }
        return paddingLeft;
    };
    const $a14ec9b6ac25fac1$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
    function $a14ec9b6ac25fac1$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
        const style = {
            ["--ed--list--item-counter--padding"]: $a14ec9b6ac25fac1$var$getItemCounterLeftPadding(itemCounterDigitsSize)
        };
        if (styleFormat === 'string') return $a14ec9b6ac25fac1$var$stringifyStyle(style);
        return style;
    }
    const $a14ec9b6ac25fac1$export$ea95db02cc29c78f = (0, (0, parcelRequire("f8Sb3")).css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $a14ec9b6ac25fac1$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, (0, parcelRequire("dMwYp")).browser).gecko ? 'display: inline-block;' : '', ";}}", (0, (0, parcelRequire("dwptW")).orderedListSelector), ",", (0, (0, parcelRequire("kjhhp")).bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");
});
parcelRegister("gQuDo", function(module, exports) {
    $parcel$export(module.exports, "resolveOrder", ()=>$4d14d32ffbed1d2d$export$d445360e2a3c026b);
    $parcel$export(module.exports, "getOrderFromOrderedListNode", ()=>$4d14d32ffbed1d2d$export$cbefb5b89ef0719f);
    $parcel$export(module.exports, "getItemCounterDigitsSize", ()=>$4d14d32ffbed1d2d$export$320582fc14ba1e0f);
    $parcel$export(module.exports, "isListNode", ()=>$4d14d32ffbed1d2d$export$a7d7d2b9ba4d4dbb);
    $parcel$export(module.exports, "isParagraphNode", ()=>$4d14d32ffbed1d2d$export$35f600abfe6f0127);
    $parcel$export(module.exports, "isListItemNode", ()=>$4d14d32ffbed1d2d$export$2ddb0a75547407f6);
    $parcel$export(module.exports, "isBulletList", ()=>$4d14d32ffbed1d2d$export$35b2f400604e700);
    const $4d14d32ffbed1d2d$export$8ef94ae42a3729bd = 1;
    const $4d14d32ffbed1d2d$export$d445360e2a3c026b = (order)=>{
        const num = Number(order);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $4d14d32ffbed1d2d$export$cbefb5b89ef0719f = (orderedListNode)=>{
        const order = orderedListNode?.attrs?.order;
        return $4d14d32ffbed1d2d$export$d445360e2a3c026b(order) ?? $4d14d32ffbed1d2d$export$8ef94ae42a3729bd;
    };
    const $4d14d32ffbed1d2d$export$320582fc14ba1e0f = (options)=>{
        const order = $4d14d32ffbed1d2d$export$d445360e2a3c026b(options.order) ?? $4d14d32ffbed1d2d$export$8ef94ae42a3729bd;
        const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
        const largestCounter = order + (itemsCount - 1);
        return String(largestCounter)?.split('.')?.[0]?.length;
    };
    function $4d14d32ffbed1d2d$export$a7d7d2b9ba4d4dbb(node) {
        return Boolean(node && node.type && [
            'orderedList',
            'bulletList'
        ].includes(node.type.name));
    }
    function $4d14d32ffbed1d2d$export$35f600abfe6f0127(node) {
        return Boolean(node && node.type && 'paragraph' === node.type.name);
    }
    function $4d14d32ffbed1d2d$export$2ddb0a75547407f6(node) {
        return Boolean(node && node.type && 'listItem' === node.type.name);
    }
    function $4d14d32ffbed1d2d$export$35b2f400604e700(node) {
        return Boolean(node && node.type && 'bulletList' === node.type.name);
    }
});
parcelRegister("7yLSH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42c7e057fe36397c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kRMVw;
    function $42c7e057fe36397c$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("p", dataAttributes, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kRMVw")).default), null, children)));
    }
});
parcelRegister("kRMVw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8320dd07f2cdef2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b8320dd07f2cdef2$export$2e2bcd8739ae039(props) {
        const { children: children } = props;
        const childCount = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).length;
        if (!childCount) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, "\xa0");
        return children;
    }
});
parcelRegister("eV0Dv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b3be53863b9ba4c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $4b3be53863b9ba4c$export$2e2bcd8739ae039(props) {
        if (props.allowPlaceholderText) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-placeholder": `${props.text}`
        }, props.text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null);
    }
});
parcelRegister("fWiVV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82eabc73762e4a11$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $82eabc73762e4a11$export$2e2bcd8739ae039() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("hr", {
            role: "presentation"
        });
    }
});
parcelRegister("fhoQm", function(module, exports) {
    $parcel$export(module.exports, "isTableResizingEnabled", ()=>$716874cccc5584e3$export$eec82c0a93aa66d9);
    $parcel$export(module.exports, "isStickyScrollbarEnabled", ()=>$716874cccc5584e3$export$bdb2dadcb04aad50);
    $parcel$export(module.exports, "default", ()=>$716874cccc5584e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $qXiNF;
    var $cpToy;
    var $caFD8;
    var $2oS3b;
    var $j7Z83;
    var $eM70S;
    var $d9hj8;
    var $ahRv6;
    var $70yok;
    var $fEe07;
    var $i5Kxj = parcelRequire("i5Kxj");
    var $jEKj7;
    var $ffD5B;
    var $fPbxE;
    var $kXFys;
    var $aVAOE;
    var $2Pc8k;
    var $8MO2r;
    const $716874cccc5584e3$export$eec82c0a93aa66d9 = (appearance)=>(0, (0, parcelRequire("2Pc8k")).isFullWidthOrFullPageAppearance)(appearance) || (0, (0, parcelRequire("2Pc8k")).isCommentAppearance)(appearance) && (0, $i5Kxj.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        });
    const $716874cccc5584e3$export$bdb2dadcb04aad50 = (appearance)=>(0, (0, parcelRequire("2Pc8k")).isFullWidthOrFullPageAppearance)(appearance) && (0, $i5Kxj.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
            exposure: true
        });
    const $716874cccc5584e3$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
        if (!tableOrderStatus || tableOrderStatus.order === (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER) return children;
        const { order: order, columnIndex: columnIndex } = tableOrderStatus;
        const compareNodesInOrder = (0, (0, parcelRequire("d9hj8")).createCompareNodes)({
            getInlineCardTextFromStore (attrs) {
                const { url: url } = attrs;
                if (!url) return null;
                return smartCardStorage.get(url) || null;
            }
        }, order);
        const tableArray = (0, (0, parcelRequire("eM70S")).convertProsemirrorTableNodeToArrayOfRows)(tableNode);
        const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
                rowNodes: rowNodes,
                rowReact: children[index]
            }));
        const headerRow = tableArrayWithChildren.shift();
        const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        return sortedTable.map((elem)=>elem.rowReact);
    };
    const $716874cccc5584e3$var$hasRowspan = (row)=>{
        let hasRowspan = false;
        row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
        return hasRowspan;
    };
    const $716874cccc5584e3$var$getRefTop = (refElement)=>{
        return Math.round(refElement.getBoundingClientRect().top);
    };
    const $716874cccc5584e3$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
    const $716874cccc5584e3$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
    const $716874cccc5584e3$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
        return (0, ($parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
            if (index === 0) return (0, ($parcel$interopDefault($5uXOq))).cloneElement((0, ($parcel$interopDefault($5uXOq))).Children.only(row), {
                tableOrderStatus: tableOrderStatus,
                onSorting: onSorting
            });
            return row;
        });
    };
    const $716874cccc5584e3$var$isHeaderRowEnabled = (rows)=>{
        if (!rows.length) return false;
        const { children: children } = rows[0].props;
        if (!children.length) return false;
        if (children.length === 1) return children[0].type === (0, (0, parcelRequire("ffD5B")).TableHeader);
        return children.every((node)=>node.type === (0, (0, parcelRequire("ffD5B")).TableHeader));
    };
    const $716874cccc5584e3$var$tableCanBeSticky = (node, children)=>{
        return $716874cccc5584e3$var$isHeaderRowEnabled(children) && node && node.firstChild && !$716874cccc5584e3$var$hasRowspan(node.firstChild);
    };
    class $716874cccc5584e3$export$f2c3aea42b2a048f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.resizeObserver = new ResizeObserver(this.applyResizerChange);
            if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
            if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
            if (this.props.stickyHeaders) {
                this.overflowParent = (0, (0, parcelRequire("kXFys")).OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
                this.overflowParent.addEventListener('scroll', this.onScroll);
            }
            if (this.wrapperRef.current && $716874cccc5584e3$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, (0, parcelRequire("8MO2r")).TableStickyScrollbar)(this.wrapperRef.current);
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, (0, parcelRequire("kXFys")).OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            else if (!this.props.stickyHeaders && this.overflowParent) {
                this.overflowParent.removeEventListener('scroll', this.onScroll);
                this.overflowParent = null;
            }
            if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
            if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        }
        get pinTop() {
            if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
            return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, (0, parcelRequire("qXiNF")).tableMarginTop) - (0, (0, parcelRequire("kXFys")).tableStickyPadding);
        }
        get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
            return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
        }
        get stickyTop() {
            switch(this.state.stickyMode){
                case 'pin-bottom':
                    return this.pinTop;
                case 'stick':
                    const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                    if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                        const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                        return offsetTop + overflowParentOffsetTop;
                    } else return offsetTop;
                default:
                    return undefined;
            }
        }
        render() {
            const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing } = this.props;
            const { stickyMode: stickyMode } = this.state;
            const lineLengthFixedWidth = (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth);
            let left;
            let updatedLayout;
            const isRenderWidthValid = !!renderWidth && renderWidth > 0;
            const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, (0, parcelRequire("jEKj7")).FullPagePadding}px * 2` : `100cqw`;
            const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
                if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                    isRenderWidthValid ? Math.min((0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth), renderWidth) : (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth),
                    `min(${(0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
                ];
                else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                    const tableContainerWidth = (0, (0, parcelRequire("fEe07")).getTableContainerWidth)(tableNode);
                    return [
                        isRenderWidthValid ? renderWidth : tableContainerWidth,
                        renderWidthCSS
                    ];
                } else {
                    const tableContainerWidth = (0, (0, parcelRequire("fEe07")).getTableContainerWidth)(tableNode);
                    return [
                        isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                        `min(${tableContainerWidth}px, ${renderWidthCSS})`
                    ];
                }
            };
            const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
            const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
            const fullWidthLineLength = isRenderWidthValid ? Math.min((0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth), renderWidth) : (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth);
            const fullWidthLineLengthCSS = `min(${(0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
            const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
            const isCommentAppearanceAndTableAlignmentEnabled = (0, (0, parcelRequire("2Pc8k")).isCommentAppearance)(rendererAppearance) && allowTableAlignment;
            const lineLength = (0, (0, parcelRequire("2Pc8k")).isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
            const lineLengthCSS = (0, (0, parcelRequire("2Pc8k")).isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
            const fixTableSSRResizing = (0, (0, parcelRequire("2oS3b")).fg)('platform-fix-table-ssr-resizing');
            const tableWidthNew = fixTableSSRResizing ? (0, (0, parcelRequire("fEe07")).getTableContainerWidth)(tableNode) : tableWidth;
            const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && isTableAlignStart && ((0, (0, parcelRequire("2Pc8k")).isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, (0, parcelRequire("2Pc8k")).isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
            let leftCSS;
            if (shouldCalculateLeftForAlignment) {
                left = (tableWidth - lineLength) / 2;
                leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
            }
            if (fixTableSSRResizing) {
                if (!shouldCalculateLeftForAlignment && (0, (0, parcelRequire("2Pc8k")).isFullPageAppearance)(rendererAppearance)) leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
            } else if (!shouldCalculateLeftForAlignment && (0, (0, parcelRequire("2Pc8k")).isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
            const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
            const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
            if (isFullWidth) updatedLayout = 'full-width';
            else if (tableNode?.attrs.width) updatedLayout = 'custom';
            else updatedLayout = layout;
            let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
            if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
            if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
            if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
            let style;
            if (fixTableSSRResizing) style = {
                width: finalTableContainerWidth,
                left: leftCSS ? `calc(${leftCSS})` : undefined,
                marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
            };
            else style = {
                width: finalTableContainerWidth,
                left: left,
                marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                style: style
            }, $716874cccc5584e3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                "data-testid": "sticky-scrollbar-sentinel-top"
            }), stickyHeaders && $716874cccc5584e3$var$tableCanBeSticky(tableNode, children) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXFys")).StickyTable), {
                isNumberColumnEnabled: isNumberColumnEnabled,
                tableWidth: tableWidth,
                layout: layout,
                renderWidth: renderWidth,
                handleRef: this.props.handleRef,
                shadowClassNames: this.props.shadowClassNames,
                top: this.stickyTop,
                mode: stickyMode,
                innerRef: this.stickyWrapperRef,
                wrapperWidth: this.state.wrapperWidth,
                columnWidths: columnWidths,
                rowHeight: this.state.headerRowHeight,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                allowTableResizing: allowTableResizing
            }, [
                children && children[0]
            ]), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_NODE_WRAPPER,
                ref: this.wrapperRef,
                onScroll: this.props.stickyHeaders && this.onWrapperScrolled
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVAOE")).Table), {
                innerRef: this.tableRef,
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }, this.grabFirstRowRef(children))), $716874cccc5584e3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                ref: this.stickyScrollbarRef,
                style: {
                    height: "var(--ds-space-250, 20px)",
                    display: fixTableSSRResizing ? 'none' : 'block',
                    width: '100%'
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: this.tableRef.current?.clientWidth,
                    height: '100%'
                }
            })), $716874cccc5584e3$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                "data-testid": "sticky-scrollbar-sentinel-bottom"
            })));
        }
        constructor(...args){
            super(...args);
            this.state = {
                stickyMode: 'none',
                wrapperWidth: 0,
                headerRowHeight: 0
            };
            this.tableRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.stickyHeaderRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.stickyScrollbarRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.stickyWrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.wrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.overflowParent = null;
            this.resizeObserver = null;
            this.applyResizerChange = (entries)=>{
                let wrapperWidth = this.state.wrapperWidth;
                let headerRowHeight = this.state.headerRowHeight;
                for (const entry of entries){
                    if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                    else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
                }
                if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                    wrapperWidth: wrapperWidth,
                    headerRowHeight: headerRowHeight
                });
            };
            this.componentWillUnmount = ()=>{
                if (this.overflowParent) this.overflowParent.removeEventListener('scroll', this.onScroll);
                if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
                if (this.resizeObserver) this.resizeObserver.disconnect();
                if (this.stickyScrollbar) this.stickyScrollbar.dispose();
            };
            this.getScrollTop = ()=>{
                const { stickyHeaders: stickyHeaders } = this.props;
                const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
                return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
            };
            this.updateSticky = ()=>{
                const tableElem = this.tableRef.current;
                const refElem = this.stickyHeaderRef.current;
                if (!tableElem || !refElem) return;
                const scrollTop = this.getScrollTop() + (0, (0, parcelRequire("kXFys")).tableStickyPadding);
                const tableTop = $716874cccc5584e3$var$getRefTop(tableElem);
                const tableBottom = tableTop + tableElem.clientHeight;
                const shouldSticky = $716874cccc5584e3$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
                const shouldPin = $716874cccc5584e3$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
                let stickyMode = 'none';
                if (shouldPin) stickyMode = 'pin-bottom';
                else if (shouldSticky) stickyMode = 'stick';
                if (this.state.stickyMode !== stickyMode) this.setState({
                    stickyMode: stickyMode
                });
                this.nextFrame = undefined;
            };
            this.onScroll = ()=>{
                if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
            };
            this.onWrapperScrolled = ()=>{
                if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
                this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
                if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            };
            this.grabFirstRowRef = (children)=>{
                return (0, ($parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                    if (idx === 0 && (0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        innerRef: this.stickyHeaderRef
                    });
                    return child;
                });
            };
        }
    }
    class $716874cccc5584e3$export$91e0997fd3f75d56 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children } = this.props;
            if (!children) return null;
            let childrenArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
            const orderedChildren = (0, (0, parcelRequire("j7Z83")).compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($716874cccc5584e3$export$f2c3aea42b2a048f, this.props, orderedChildren);
        }
        constructor(...args){
            super(...args);
            this.state = {
                tableOrderStatus: undefined
            };
            this.addSortableColumn = (childrenArray)=>{
                const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
                const { tableOrderStatus: tableOrderStatus } = this.state;
                if (allowColumnSorting && $716874cccc5584e3$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, (0, parcelRequire("eM70S")).hasMergedCell)(tableNode)) return $716874cccc5584e3$var$addSortableColumn($716874cccc5584e3$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
                return childrenArray;
            };
            this.changeSortOrder = (columnIndex, sortOrder)=>{
                this.setState({
                    tableOrderStatus: {
                        columnIndex: columnIndex,
                        order: sortOrder
                    }
                });
            };
            this.addNumberColumnIndexes = (rows)=>{
                const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
                const headerRowEnabled = $716874cccc5584e3$var$isHeaderRowEnabled(rows);
                return (0, ($parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                    return (0, ($parcel$interopDefault($5uXOq))).cloneElement((0, ($parcel$interopDefault($5uXOq))).Children.only(row), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                    });
                });
            };
        }
    }
    const $716874cccc5584e3$var$TableWithShadows = (0, (0, parcelRequire("cpToy")).default)($716874cccc5584e3$export$91e0997fd3f75d56, {
        overflowSelector: `.${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
        useShadowObserver: true
    });
    const $716874cccc5584e3$var$TableWithWidth = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caFD8")).WidthConsumer), null, ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, (0, parcelRequire("jEKj7")).FullPagePadding) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) return (0, ($parcel$interopDefault($5uXOq))).createElement($716874cccc5584e3$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($716874cccc5584e3$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        });
    };
    var $716874cccc5584e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("fPbxE")).withSmartCardStorage)($716874cccc5584e3$var$TableWithWidth);
});
parcelRegister("qXiNF", function(module, exports) {
    $parcel$export(module.exports, "tableMarginTop", ()=>$7d06cf01528fff71$export$808015ab1dd6897a);
    $parcel$export(module.exports, "tableMarginTopWithControl", ()=>$7d06cf01528fff71$export$910bf0d22c3d10f2);
    $parcel$export(module.exports, "tableMarginSides", ()=>$7d06cf01528fff71$export$a43e30915fab3ccf);
    $parcel$export(module.exports, "tableCellMinWidth", ()=>$7d06cf01528fff71$export$531f77930bf508de);
    $parcel$export(module.exports, "tableNewColumnMinWidth", ()=>$7d06cf01528fff71$export$c60fae4049791eae);
    $parcel$export(module.exports, "tableCellBorderWidth", ()=>$7d06cf01528fff71$export$72aad729077aa0fb);
    $parcel$export(module.exports, "tableCellPadding", ()=>$7d06cf01528fff71$export$e56b8ca552b280f6);
    $parcel$export(module.exports, "TableSharedCssClassName", ()=>$7d06cf01528fff71$export$c096bca5477eb7ad);
    $parcel$export(module.exports, "tableSharedStyle", ()=>$7d06cf01528fff71$export$c2bf8eea75aa9302);
    $parcel$export(module.exports, "calcTableWidth", ()=>$7d06cf01528fff71$export$d7ece4d8beb06815);
    var $f8Sb3;
    var $9UDEr;
    var $70yok;
    var $iw1aw;
    var $i5Kxj = parcelRequire("i5Kxj");
    var $dMwYp;
    var $ap4cA;
    var $kH3pD;
    function $7d06cf01528fff71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7d06cf01528fff71$export$808015ab1dd6897a = 24;
    const $7d06cf01528fff71$export$afe1899c3eea9823 = 16;
    const $7d06cf01528fff71$export$910bf0d22c3d10f2 = 14;
    const $7d06cf01528fff71$export$a43e30915fab3ccf = 8;
    const $7d06cf01528fff71$export$531f77930bf508de = 48;
    const $7d06cf01528fff71$export$c60fae4049791eae = 140;
    const $7d06cf01528fff71$export$72aad729077aa0fb = 1;
    const $7d06cf01528fff71$export$e56b8ca552b280f6 = 8;
    const $7d06cf01528fff71$export$bba39e724bc39451 = 6;
    const $7d06cf01528fff71$export$c096bca5477eb7ad = {
        TABLE_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-container`,
        TABLE_NODE_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-wrapper`,
        TABLE_LEFT_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-left-shadow`,
        TABLE_RIGHT_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-right-shadow`,
        TABLE_STICKY_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-shadow`,
        TABLE_STICKY_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-wrapper`,
        TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-container`,
        TABLE_STICKY_SENTINEL_TOP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-sentinel-top`,
        TABLE_STICKY_SENTINEL_BOTTOM: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-sentinel-bottom`,
        TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
        TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
        TABLE_SHADOW_SENTINEL_LEFT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-shadow-sentinel-left`,
        TABLE_SHADOW_SENTINEL_RIGHT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-shadow-sentinel-right`,
        TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, (0, parcelRequire("9UDEr")).tableCellContentDomSelector),
        TABLE_CELL_WRAPPER: (0, (0, parcelRequire("9UDEr")).tableCellSelector),
        TABLE_HEADER_CELL_WRAPPER: (0, (0, parcelRequire("9UDEr")).tableHeaderSelector),
        TABLE_ROW_CONTROLS_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls-wrapper`,
        TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-controls-decoration`,
        TABLE_RESIZER_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-resizer-container`
    };
    var $7d06cf01528fff71$var$_ref = {
        name: "qubt66",
        styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
    };
    var $7d06cf01528fff71$var$_ref2 = {
        name: "1fct7qz",
        styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
    };
    const $7d06cf01528fff71$var$firstNodeWithNotMarginTop = ()=>(0, $i5Kxj.editorExperiment)('nested-dnd', true) ? $7d06cf01528fff71$var$_ref2 : $7d06cf01528fff71$var$_ref;
    const $7d06cf01528fff71$export$c2bf8eea75aa9302 = ()=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("kH3pD")).tableCellBackgroundStyleOverride)(), " .", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $7d06cf01528fff71$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $7d06cf01528fff71$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}th,td{min-width:", $7d06cf01528fff71$export$531f77930bf508de, "px;font-weight:normal;vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:", (0, $i5Kxj.editorExperiment)('table-nested-dnd', true) ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-100, 8px)", ";", (0, (0, parcelRequire("dMwYp")).browser).gecko || (0, (0, parcelRequire("dMwYp")).browser).ie || (0, (0, parcelRequire("dMwYp")).browser).mac && (0, (0, parcelRequire("dMwYp")).browser).chrome ? 'background-clip: padding-box;' : '', " ", $7d06cf01528fff71$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, (0, parcelRequire("70yok")).akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, (0, parcelRequire("70yok")).akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, (0, parcelRequire("iw1aw")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, (0, parcelRequire("iw1aw")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
    const $7d06cf01528fff71$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
        switch(layout){
            case 'full-width':
                return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, (0, parcelRequire("70yok")).akEditorBreakoutPadding) : 0), (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth)) : (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth);
            case 'wide':
                if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, (0, parcelRequire("70yok")).akEditorBreakoutPadding) : 0), (0, (0, parcelRequire("70yok")).akEditorWideLayoutWidth));
                return 0, (0, parcelRequire("70yok")).akEditorWideLayoutWidth;
            default:
                return 'inherit';
        }
    };
});
parcelRegister("iw1aw", function(module, exports) {
    $parcel$export(module.exports, "overflowShadow", ()=>$6b825933cc538acc$export$c5c1e4f4640336fb);
    var $f8Sb3;
    const $6b825933cc538acc$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
        const width = "var(--ds-space-100, 8px)";
        const leftCoverWidthResolved = leftCoverWidth || width;
        const rightCoverWidthResolved = rightCoverWidth || width;
        return (0, (0, parcelRequire("f8Sb3")).css)();
    };
});
parcelRegister("ap4cA", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockSharedCssClassName", ()=>$70504cc6fb202047$export$42659c26f026f6ea);
    $parcel$export(module.exports, "codeBlockSharedStyles", ()=>$70504cc6fb202047$export$a4fbe21dc6fae881);
    $parcel$export(module.exports, "codeBlockInListSafariFix", ()=>$70504cc6fb202047$export$3aa5ee2f4c156533);
    var $f8Sb3;
    var $70yok;
    var $iw1aw;
    const $70504cc6fb202047$export$42659c26f026f6ea = {
        CODEBLOCK_CONTAINER: 'code-block',
        CODEBLOCK_START: 'code-block--start',
        CODEBLOCK_END: 'code-block--end',
        CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
        CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
        CODEBLOCK_CONTENT: 'code-content',
        DS_CODEBLOCK: '[data-ds--code--code-block]',
        CODEBLOCK_CONTENT_WRAPPER_FG: 'code-block-content-wrapper--fg',
        CODEBLOCK_CONTENT_FG: 'code-content--fg',
        CODEBLOCK_CONTENT_FG_WRAPPED: 'code-content--fg-wrapped',
        CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped',
        CODEBLOCK_LINE_NUMBER_GUTTER_FG: 'line-number-gutter--fg'
    };
    const $70504cc6fb202047$export$a4fbe21dc6fae881 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG_WRAPPED, ">.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, ">.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), " 0 0 0;font-family:", (0, (0, parcelRequire("70yok")).akEditorCodeFontFamily), ";min-width:", (0, (0, parcelRequire("70yok")).akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, (0, parcelRequire("iw1aw")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER_FG, "{position:relative;}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{flex-shrink:0;text-align:right;background-color:var(--ds-background-neutral, #091E420F);padding:var(--ds-space-100, 8px);position:relative;span{display:block;line-height:0;font-size:0;::before{display:inline-block;content:counter(line);counter-increment:line;color:var(--ds-text-subtlest, #626F86);font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER_FG, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:0px var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);white-space:pre;font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTENT_FG, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $70504cc6fb202047$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
    const $70504cc6fb202047$export$3aa5ee2f4c156533 = (0, (0, parcelRequire("f8Sb3")).css)("::before{content:' ';line-height:", (0, (0, parcelRequire("70yok")).akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, (0, parcelRequire("70yok")).akEditorLineHeight), "em!important;}");
});
parcelRegister("kH3pD", function(module, exports) {
    $parcel$export(module.exports, "tableCellBackgroundStyleOverride", ()=>$a641163fe2fa6b6b$export$677e93f0f5f9623a);
    var $f8Sb3;
    var $9UDEr;
    var $dRNhL;
    const $a641163fe2fa6b6b$var$mapBackgroundColors = ()=>{
        let cssString = '';
        (0, (0, parcelRequire("9UDEr")).tableBackgroundColorNames).forEach((value, key)=>{
            const paletteColorValue = (0, (0, parcelRequire("dRNhL")).hexToEditorBackgroundPaletteColor)(value);
            if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
        });
        return cssString;
    };
    const $a641163fe2fa6b6b$export$677e93f0f5f9623a = ()=>(0, (0, parcelRequire("f8Sb3")).css)($a641163fe2fa6b6b$var$mapBackgroundColors());
});
parcelRegister("dRNhL", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", ()=>$24225218c9038e15$export$5f6a44a42a4b38c2);
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", ()=>$24225218c9038e15$export$a270511a0e7fd61a);
    var $5w2JH;
    function $24225218c9038e15$export$5f6a44a42a4b38c2(hexColor) {
        const tokenData = $24225218c9038e15$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.token : undefined;
    }
    function $24225218c9038e15$export$a270511a0e7fd61a(hexColor) {
        const tokenData = $24225218c9038e15$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.getValue(hexColor) : undefined;
    }
    const $24225218c9038e15$export$2462741d70e6a62f = {
        ['#DEEBFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.blue.subtlest', fallback),
            token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
        },
        ['#B3D4FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.blue.subtler', fallback),
            token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
        },
        ['#4C9AFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.blue.subtle', fallback),
            token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
        },
        ['#E6FCFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.teal.subtlest', fallback),
            token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
        },
        ['#B3F5FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.teal.subtler', fallback),
            token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
        },
        ['#79E2F2']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.teal.subtle', fallback),
            token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
        },
        ['#E3FCEF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.green.subtlest', fallback),
            token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
        },
        ['#ABF5D1']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.green.subtler', fallback),
            token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
        },
        ['#57D9A3']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.green.subtle', fallback),
            token: "var(--ds-background-accent-green-subtle, #57D9A3)"
        },
        ['#FFFAE6']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.yellow.subtlest', fallback),
            token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
        },
        ['#FFF0B3']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.yellow.subtler', fallback),
            token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
        },
        ['#FFC400']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.orange.subtle', fallback),
            token: "var(--ds-background-accent-orange-subtle, #FFC400)"
        },
        ['#FFEBE6']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.red.subtlest', fallback),
            token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
        },
        ['#FFBDAD']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.red.subtler', fallback),
            token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
        },
        ['#FF8F73']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.red.subtle', fallback),
            token: "var(--ds-background-accent-red-subtle, #FF8F73)"
        },
        ['#EAE6FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.purple.subtlest', fallback),
            token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
        },
        ['#C0B6F2']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.purple.subtler', fallback),
            token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
        },
        ['#998DD9']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.purple.subtle', fallback),
            token: "var(--ds-background-accent-purple-subtle, #998DD9)"
        },
        ['#FFFFFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('elevation.surface', fallback),
            token: "var(--ds-surface, #FFFFFF)"
        },
        ['#F4F5F7']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.gray.subtlest', fallback),
            token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
        },
        ['#B3BAC5']: {
            getValue: (fallback)=>(0, (0, parcelRequire("5w2JH")).default)('color.background.accent.gray.subtle', fallback),
            token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
        }
    };
});
parcelRegister("j7Z83", function(module, exports) {
    $parcel$export(module.exports, "compose", ()=>$6117e4c7084f30ff$export$f672e0b6f7222cd7);
    function $6117e4c7084f30ff$export$f672e0b6f7222cd7(func, ...funcs) {
        const allFuncs = [
            func,
            ...funcs
        ];
        return function composed(raw) {
            return allFuncs.reduceRight((memo, func)=>func(memo), raw);
        };
    }
});
parcelRegister("eM70S", function(module, exports) {
    $parcel$export(module.exports, "calcTableColumnWidths", ()=>$9459a7ae4a216eb7$export$98951d3cdcfd364b);
    $parcel$export(module.exports, "hasMergedCell", ()=>$9459a7ae4a216eb7$export$f9d610bfbb78949b);
    $parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", ()=>$9459a7ae4a216eb7$export$69fbfaf01f2fd534);
    $parcel$export(module.exports, "isPositionNearTableRow", ()=>$9459a7ae4a216eb7$export$889a8e446452be16);
    function $9459a7ae4a216eb7$export$98951d3cdcfd364b(node) {
        let tableColumnWidths = [];
        const firstRow = node.firstChild;
        if (firstRow) firstRow.forEach((colNode)=>{
            let colwidth = colNode.attrs.colwidth || [
                0
            ];
            if (colwidth) tableColumnWidths = [
                ...tableColumnWidths,
                ...colwidth
            ];
        });
        return tableColumnWidths;
    }
    function $9459a7ae4a216eb7$export$f9d610bfbb78949b(tableNode) {
        let hasSpan = false;
        tableNode.descendants((node)=>{
            if (node.type.name === 'tableRow') return true;
            const { colspan: colspan, rowspan: rowspan } = node.attrs;
            if (colspan > 1 || rowspan > 1) hasSpan = true;
            return false;
        });
        return hasSpan;
    }
    function $9459a7ae4a216eb7$export$69fbfaf01f2fd534(tableNode) {
        const result = [];
        tableNode.forEach((rowNode)=>{
            if (rowNode.type.name === 'tableRow') {
                const row = [];
                rowNode.forEach((n)=>row.push(n));
                result.push(row);
            }
        });
        return result;
    }
    function $9459a7ae4a216eb7$export$889a8e446452be16(pos, schema, direction) {
        if (!schema.nodes.tableRow) return false;
        let doc = pos.doc;
        let resolved = pos;
        const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
        while(resolved.depth > 0){
            const siblingType = resolved[sibling]?.type;
            if (siblingType === schema.nodes.tableRow) return true;
            resolved = doc.resolve(resolved[direction]());
        }
        return false;
    }
});
parcelRegister("d9hj8", function(module, exports) {
    $parcel$export(module.exports, "createCompareNodes", ()=>$4318649a05c470ba$export$49215374a8bec29c);
    var $ahRv6;
    var $4318649a05c470ba$export$e2e108cbe2e4f865;
    (function(ContentType) {
        ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
        ContentType[ContentType["TEXT"] = 5] = "TEXT";
        ContentType[ContentType["MENTION"] = 10] = "MENTION";
        ContentType[ContentType["DATE"] = 15] = "DATE";
        ContentType[ContentType["STATUS"] = 20] = "STATUS";
        ContentType[ContentType["LINK"] = 25] = "LINK";
    })($4318649a05c470ba$export$e2e108cbe2e4f865 || ($4318649a05c470ba$export$e2e108cbe2e4f865 = {}));
    function $4318649a05c470ba$var$getLinkMark(node) {
        const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
        return linkMark || null;
    }
    function $4318649a05c470ba$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
        if (!stringNumber.trim().length) return null;
        const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
        if (Number.isNaN(maybeANumber)) return null;
        return maybeANumber;
    }
    function $4318649a05c470ba$export$8ebf986086b1866f() {
        const locale = window.navigator.language;
        const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
        const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
        const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
        const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
        const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
        return (text)=>{
            if (!text.trim().length) return null;
            const result = text.split(numericPattern);
            const tokens = result.reduce((acc, stringNumber)=>{
                if (!stringNumber?.length) return acc;
                const maybeANumber = $4318649a05c470ba$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
                if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
                else acc.push(stringNumber);
                return acc;
            }, []);
            if (tokens.length === 1) return tokens[0];
            return tokens.join('');
        };
    }
    function $4318649a05c470ba$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
        const linkMark = $4318649a05c470ba$var$getLinkMark(textNode);
        if (linkMark) {
            const value = textNode.text || '';
            return {
                type: 25,
                value: value
            };
        }
        const text = textNode.text || '';
        const normalizedText = normalizeTextParser(text);
        if (typeof normalizedText === 'number') return {
            type: 0,
            value: normalizedText
        };
        return {
            type: 5,
            value: normalizedText ?? text
        };
    }
    function $4318649a05c470ba$var$getMetaFromNode(node, options, normalizeTextParser) {
        if (!node) return null;
        const firstChild = node.firstChild;
        if (!firstChild) return null;
        switch(firstChild.type.name){
            case 'heading':
            case 'paragraph':
                return $4318649a05c470ba$var$getMetaFromNode(firstChild, options, normalizeTextParser);
            case 'inlineCard':
                {
                    const attrs = firstChild.attrs;
                    const maybeTitle = options.getInlineCardTextFromStore(attrs);
                    if (maybeTitle) return {
                        type: 25,
                        value: maybeTitle
                    };
                    const url = attrs.url;
                    return {
                        type: 25,
                        value: url ? url : ''
                    };
                }
            case 'text':
                return $4318649a05c470ba$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
            case 'status':
                {
                    const text = firstChild.attrs.text;
                    return {
                        type: 20,
                        value: text
                    };
                }
            case 'date':
                {
                    const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                    return {
                        type: 15,
                        value: timestamp
                    };
                }
            case 'mention':
                {
                    const text = firstChild.attrs.text || '';
                    return {
                        type: 10,
                        value: text.toLowerCase()
                    };
                }
            default:
                return null;
        }
    }
    function $4318649a05c470ba$var$compareValue(valueA, valueB) {
        if (valueA === valueB) return 0;
        if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
            caseFirst: 'upper',
            numeric: true
        });
        return valueA > valueB ? 1 : -1;
    }
    const $4318649a05c470ba$export$49215374a8bec29c = (options, order = (0, (0, parcelRequire("ahRv6")).SortOrder).ASC)=>{
        const normalizeTextParser = $4318649a05c470ba$export$8ebf986086b1866f();
        return (nodeA, nodeB)=>{
            const metaNodeA = $4318649a05c470ba$var$getMetaFromNode(nodeA, options, normalizeTextParser);
            const metaNodeB = $4318649a05c470ba$var$getMetaFromNode(nodeB, options, normalizeTextParser);
            if (metaNodeA === null || metaNodeB === null) return $4318649a05c470ba$var$compareMetaFromNode(metaNodeA, metaNodeB);
            return (order === (0, (0, parcelRequire("ahRv6")).SortOrder).DESC ? -1 : 1) * $4318649a05c470ba$var$compareMetaFromNode(metaNodeA, metaNodeB);
        };
    };
    function $4318649a05c470ba$var$compareMetaFromNode(metaNodeA, metaNodeB) {
        if (metaNodeA === metaNodeB) return 0;
        if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
        if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
        return $4318649a05c470ba$var$compareValue(metaNodeA.value, metaNodeB.value);
    }
});
parcelRegister("ahRv6", function(module, exports) {
    $parcel$export(module.exports, "SortOrder", ()=>$61eae1e6e65479d5$export$7ae723045d45777a);
    var $hj0ZZ;
    var $1ZfEV;
    var $61eae1e6e65479d5$export$7ae723045d45777a;
    (function(SortOrder) {
        SortOrder["ASC"] = "asc";
        SortOrder["DESC"] = "desc";
        SortOrder["NO_ORDER"] = "no_order";
    })($61eae1e6e65479d5$export$7ae723045d45777a || ($61eae1e6e65479d5$export$7ae723045d45777a = {}));
});
parcelRegister("1ZfEV", function(module, exports) {
    $parcel$export(module.exports, "ToolbarSize", ()=>$0e342ea0b9562750$export$ed55211407a9423);
    $parcel$export(module.exports, "ToolbarWidths", ()=>$0e342ea0b9562750$export$423b5e8c92d477b9);
    $parcel$export(module.exports, "ToolbarWidthsNext", ()=>$0e342ea0b9562750$export$3f050002d3df641b);
    $parcel$export(module.exports, "ToolbarWidthsFullPage", ()=>$0e342ea0b9562750$export$63ca43752be70b90);
    $parcel$export(module.exports, "ToolbarWidthsFullPageNext", ()=>$0e342ea0b9562750$export$501a79d885598191);
    var $0e342ea0b9562750$export$ed55211407a9423;
    (function(ToolbarSize) {
        ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
        ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
        ToolbarSize[ToolbarSize["L"] = 4] = "L";
        ToolbarSize[ToolbarSize["M"] = 3] = "M";
        ToolbarSize[ToolbarSize["S"] = 2] = "S";
        ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    })($0e342ea0b9562750$export$ed55211407a9423 || ($0e342ea0b9562750$export$ed55211407a9423 = {}));
    var $0e342ea0b9562750$export$423b5e8c92d477b9;
    (function(ToolbarWidths) {
        ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
        ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
        ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
        ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
        ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    })($0e342ea0b9562750$export$423b5e8c92d477b9 || ($0e342ea0b9562750$export$423b5e8c92d477b9 = {}));
    var $0e342ea0b9562750$export$3f050002d3df641b;
    (function(ToolbarWidthsNext) {
        ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
        ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
        ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
        ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
        ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    })($0e342ea0b9562750$export$3f050002d3df641b || ($0e342ea0b9562750$export$3f050002d3df641b = {}));
    var $0e342ea0b9562750$export$63ca43752be70b90;
    (function(ToolbarWidthsFullPage) {
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    })($0e342ea0b9562750$export$63ca43752be70b90 || ($0e342ea0b9562750$export$63ca43752be70b90 = {}));
    var $0e342ea0b9562750$export$501a79d885598191;
    (function(ToolbarWidthsFullPageNext) {
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    })($0e342ea0b9562750$export$501a79d885598191 || ($0e342ea0b9562750$export$501a79d885598191 = {}));
});
parcelRegister("fEe07", function(module, exports) {
    $parcel$export(module.exports, "layoutToWidth", ()=>$192f96dc0b75e230$export$9b77d38feba5446);
    $parcel$export(module.exports, "getParentNodeWidth", ()=>$192f96dc0b75e230$export$d76cc081ce1449a8);
    $parcel$export(module.exports, "getTableContainerWidth", ()=>$192f96dc0b75e230$export$3930799be057b305);
    var $5r0mK = parcelRequire("5r0mK");
    var $70yok;
    var $6DTSl;
    var $hDd3R;
    var $9N9gL;
    const $192f96dc0b75e230$var$GRID_SIZE = 8;
    const $192f96dc0b75e230$export$9b77d38feba5446 = {
        default: (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth),
        wide: (0, (0, parcelRequire("70yok")).akEditorWideLayoutWidth),
        'full-width': (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth)
    };
    const $192f96dc0b75e230$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
        if (!pos) return;
        const node = $192f96dc0b75e230$var$getNestedParentNode(pos, state);
        if (!node) return;
        let layout = node.attrs.layout || 'default';
        const { schema: schema } = state;
        const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
        if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
        let parentWidth = $192f96dc0b75e230$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
        const contextPanelPluginKey = {
            key: 'contextPanelPluginKey$',
            getState: (state)=>{
                return state['contextPanelPluginKey$'];
            }
        };
        if (node.type === schema.nodes.layoutSection) {
            parentWidth += (0, (0, parcelRequire("70yok")).akLayoutGutterOffset) * 2;
            if (containerWidth.width > (0, (0, parcelRequire("70yok")).gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, (0, parcelRequire("hDd3R")).LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
        }
        switch(node.type){
            case schema.nodes.layoutSection:
                parentWidth -= (0, (0, parcelRequire("hDd3R")).LAYOUT_COLUMN_PADDING) * 2;
                break;
            case schema.nodes.bodiedExtension:
                parentWidth -= (0, (0, parcelRequire("6DTSl")).BODIED_EXT_PADDING) * 2;
                break;
            case schema.nodes.extensionFrame:
                parentWidth -= (0, (0, parcelRequire("6DTSl")).BODIED_EXT_PADDING) * 2;
                break;
            case schema.nodes.expand:
                parentWidth -= $192f96dc0b75e230$var$GRID_SIZE * 2;
                parentWidth += $192f96dc0b75e230$var$GRID_SIZE * 3;
                parentWidth -= $192f96dc0b75e230$var$GRID_SIZE;
                parentWidth -= $192f96dc0b75e230$var$GRID_SIZE * 4 - $192f96dc0b75e230$var$GRID_SIZE / 2;
                break;
        }
        parentWidth -= 2;
        return parentWidth;
    };
    const $192f96dc0b75e230$var$getNestedParentNode = (tablePos, state)=>{
        if (tablePos === undefined) return null;
        const $pos = state.doc.resolve(tablePos);
        const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.extensionFrame,
            state.schema.nodes.layoutSection,
            state.schema.nodes.expand
        ]);
        return parent ? parent.node : null;
    };
    const $192f96dc0b75e230$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
        return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth)) : (0, (0, parcelRequire("9N9gL")).absoluteBreakoutWidth)(layout, containerWidth.width);
    };
    const $192f96dc0b75e230$export$3930799be057b305 = (node)=>{
        if (node?.attrs.width) return node.attrs.width;
        return $192f96dc0b75e230$export$9b77d38feba5446[node?.attrs.layout] || (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth);
    };
    const $192f96dc0b75e230$export$9724081a0d43786a = (node, offset)=>{
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        if (isNumberColumnEnabled && offset > 0) return $192f96dc0b75e230$export$3930799be057b305(node) - offset;
        return $192f96dc0b75e230$export$3930799be057b305(node);
    };
});
parcelRegister("5r0mK", function(module, exports) {
    $parcel$export(module.exports, "removeParentNodeOfType", ()=>$3f4fc20879d21ebe$export$5dd18664fe8bcbde);
    $parcel$export(module.exports, "findParentNodeOfType", ()=>$3f4fc20879d21ebe$export$1a3a74094b9968e);
    $parcel$export(module.exports, "replaceParentNodeOfType", ()=>$3f4fc20879d21ebe$export$b72cc612b642c071);
    $parcel$export(module.exports, "removeSelectedNode", ()=>$3f4fc20879d21ebe$export$7d6e4e6663186878);
    $parcel$export(module.exports, "isNodeSelection", ()=>$3f4fc20879d21ebe$export$a8c1d2c13abf8822);
    $parcel$export(module.exports, "replaceSelectedNode", ()=>$3f4fc20879d21ebe$export$39874bca494f9ba3);
    $parcel$export(module.exports, "setTextSelection", ()=>$3f4fc20879d21ebe$export$1df6d14df6b0b758);
    $parcel$export(module.exports, "safeInsert", ()=>$3f4fc20879d21ebe$export$5fe92db78385e37c);
    $parcel$export(module.exports, "canInsert", ()=>$3f4fc20879d21ebe$export$b4d1262a40ad21d4);
    $parcel$export(module.exports, "removeNodeBefore", ()=>$3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
    $parcel$export(module.exports, "findPositionOfNodeBefore", ()=>$3f4fc20879d21ebe$export$f8088819b1e2c2dc);
    $parcel$export(module.exports, "findParentNode", ()=>$3f4fc20879d21ebe$export$dc159056ffdb4c76);
    $parcel$export(module.exports, "findParentNodeClosestToPos", ()=>$3f4fc20879d21ebe$export$fe09644e3bc6166b);
    $parcel$export(module.exports, "findDomRefAtPos", ()=>$3f4fc20879d21ebe$export$666ce65defe9ad6e);
    $parcel$export(module.exports, "hasParentNode", ()=>$3f4fc20879d21ebe$export$178ecaf80f45fdb6);
    $parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", ()=>$3f4fc20879d21ebe$export$8bf0d019bde85d18);
    $parcel$export(module.exports, "hasParentNodeOfType", ()=>$3f4fc20879d21ebe$export$14f438bb7227ce63);
    $parcel$export(module.exports, "findParentDomRefOfType", ()=>$3f4fc20879d21ebe$export$faeafc1151740116);
    $parcel$export(module.exports, "findSelectedNodeOfType", ()=>$3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
    $parcel$export(module.exports, "flatten", ()=>$3f4fc20879d21ebe$export$bffa455ba8c619a6);
    $parcel$export(module.exports, "findChildren", ()=>$3f4fc20879d21ebe$export$f94ca194e830789c);
    $parcel$export(module.exports, "findChildrenByType", ()=>$3f4fc20879d21ebe$export$96bb9476c7c69f39);
    $parcel$export(module.exports, "contains", ()=>$3f4fc20879d21ebe$export$2344b14b097df817);
    var $gZGBX;
    var $kCV8T;
    var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
            return tr;
        };
    var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
            if (!Array.isArray(nodeType)) nodeType = [
                nodeType
            ];
            for(let i = 0, count = nodeType.length; i < count; i++){
                const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
                if (parent) {
                    const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                    if (newTr !== tr) return newTr;
                }
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const from = tr.selection.$from.pos;
            const to = tr.selection.$to.pos;
            return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
        }
        return tr;
    };
    var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
                const { $from: $from, $to: $to } = tr.selection;
                if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, (0, parcelRequire("kCV8T")).Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve($from.pos))));
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
            const nextSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(position), dir, true);
            if (nextSelection) return tr.setSelection(nextSelection);
            return tr;
        };
    var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.type && node.type.spec.selectable);
    var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
    var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
        if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve(pos)));
        return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
    };
    var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
            const hasPosition = typeof position === "number";
            const { $from: $from } = tr.selection;
            const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
            const { parent: parent } = $insertPos;
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
                const oldTr = tr;
                tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
                if (oldTr !== tr) return tr;
            }
            if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
                const oldTr = tr;
                tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
                if (oldTr !== tr) {
                    const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? $insertPos.before($insertPos.depth) : $insertPos.pos;
                    return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
                }
            }
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
                tr.insert($insertPos.pos, content);
                const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
            for(let i = $insertPos.depth; i > 0; i--){
                const pos = $insertPos.after(i);
                const $pos = tr.doc.resolve(pos);
                if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                    tr.insert(pos, content);
                    return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
                }
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
            return tr;
        };
    var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
            if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
                const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
                if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, parent.pos)));
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
        const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
        if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
        return tr;
    };
    var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
        return selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection);
    };
    var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
        return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
    };
    var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
        return Object.assign(Object.create(tr), tr).setTime(Date.now());
    };
    var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
            const node = tr.doc.nodeAt(position);
            const $pos = tr.doc.resolve(position);
            if (!node) return tr;
            if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
                tr = tr.replaceWith(position, position + node.nodeSize, content);
                const start = tr.selection.$from.pos - 1;
                tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
                tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
                return $3f4fc20879d21ebe$var$cloneTr(tr);
            }
            return tr;
        };
    var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
        const node = $pos.node($pos.depth);
        return node && node.type.validContent(content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) ? content : (0, (0, parcelRequire("kCV8T")).Fragment).from(content));
    };
    var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
            const node = tr.doc.nodeAt(position);
            if (!node) return tr;
            return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
        };
    var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
        const index = $pos.index();
        if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment)) return $pos.parent.canReplace(index, index, content);
        else if (content instanceof (0, (0, parcelRequire("kCV8T")).Node)) return $pos.parent.canReplaceWith(index, index, content.type);
        return false;
    };
    var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
        return !node || node.type.name === "paragraph" && node.nodeSize === 2;
    };
    var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
            if (validateSameParent && !$from.sameParent($to)) {
                let depth = Math.min($from.depth, $to.depth);
                while(depth >= 0){
                    const fromNode = $from.node(depth);
                    const toNode = $to.node(depth);
                    if (toNode === fromNode) {
                        if (predicate(fromNode)) return {
                            pos: depth > 0 ? $from.before(depth) : 0,
                            start: $from.start(depth),
                            depth: depth,
                            node: fromNode
                        };
                    }
                    depth = depth - 1;
                }
                return;
            }
            return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
        };
    var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    };
    var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
            const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
            if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
        };
    var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
            return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        };
    var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
            return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
        };
    var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
    };
    var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
            return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
        };
    var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
            return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
        };
    var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
                const { node: node, $from: $from } = selection;
                if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                    node: node,
                    start: $from.start(),
                    pos: $from.pos,
                    depth: $from.depth
                };
            }
        };
    var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
        const { nodeBefore: nodeBefore } = selection.$from;
        const maybeSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(selection.$from, -1);
        if (maybeSelection && nodeBefore) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
            if (parent) return parent.pos;
            return maybeSelection.$from.pos;
        }
    };
    var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
        const dom = domAtPos(position);
        const node = dom.node.childNodes[dom.offset];
        if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
        if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
        return node;
    };
    var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
        if (!node) throw new Error('Invalid "node" parameter');
        const result = [];
        node.descendants((child, pos)=>{
            result.push({
                node: child,
                pos: pos
            });
            if (!descend) return false;
        });
        return result;
    };
    var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
        if (!node) throw new Error('Invalid "node" parameter');
        else if (!predicate) throw new Error('Invalid "predicate" parameter');
        return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
    };
    var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
    };
    var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
    };
    var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
    };
    var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
    };
    var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
    };
    var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
    };
    var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
        return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
    };
});
parcelRegister("6DTSl", function(module, exports) {
    $parcel$export(module.exports, "BODIED_EXT_PADDING", ()=>$0207b6df05e849c8$export$5ac5087fe1217160);
    $parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", ()=>$0207b6df05e849c8$export$91624ec52c59c24c);
    const $0207b6df05e849c8$export$f5ecdce4c60ff98b = 8;
    const $0207b6df05e849c8$export$5ac5087fe1217160 = $0207b6df05e849c8$export$f5ecdce4c60ff98b * 2;
    const $0207b6df05e849c8$export$91624ec52c59c24c = 12;
});
parcelRegister("hDd3R", function(module, exports) {
    $parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", ()=>$cec520cb65f57c68$export$cd04f19842abff0);
    $parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", ()=>$cec520cb65f57c68$export$a1bb91aa2d5fcce8);
    const $cec520cb65f57c68$export$cd04f19842abff0 = 8;
    const $cec520cb65f57c68$export$a1bb91aa2d5fcce8 = $cec520cb65f57c68$export$cd04f19842abff0 * 1.5;
});
parcelRegister("jEKj7", function(module, exports) {
    $parcel$export(module.exports, "FullPagePadding", ()=>$3e1c69a6b9939fcb$export$12fd658e5eef0d79);
    $parcel$export(module.exports, "TELEPOINTER_ID", ()=>$3e1c69a6b9939fcb$export$74b525449cc7cbd1);
    $parcel$export(module.exports, "rendererStyles", ()=>$3e1c69a6b9939fcb$export$1c4377249312209);
    var $f8Sb3;
    var $2oS3b;
    var $bUQGL;
    var $1y4EV;
    var $3kjDV;
    var $67vPJ;
    var $3uv4U;
    var $2aBrY;
    var $lpCDe;
    var $ap4cA;
    var $dhb4X;
    var $36ut0;
    var $9BDXQ;
    var $lX5Os;
    var $kVAtA;
    var $6NIy9;
    var $adne7;
    var $iITpp;
    var $eOPA3;
    var $9L6VL;
    var $9b2NM;
    var $qXiNF;
    var $jLRN5;
    var $7vLId;
    var $kD3Ei;
    var $cpToy;
    var $bRJM5;
    var $dMwYp;
    var $70yok;
    var $6zogC;
    var $8L7RC;
    var $d69lr;
    var $fhoQm;
    var $i5Kxj = parcelRequire("i5Kxj");
    const $3e1c69a6b9939fcb$export$12fd658e5eef0d79 = 32;
    const $3e1c69a6b9939fcb$var$tableShadowWidth = 32;
    const $3e1c69a6b9939fcb$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
    const $3e1c69a6b9939fcb$var$telepointerStyles = (colorMode)=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("#", $3e1c69a6b9939fcb$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:700;width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
    };
    const $3e1c69a6b9939fcb$var$getLineHeight = (fontCode)=>(0, (0, parcelRequire("1y4EV")).headingSizes)[fontCode].lineHeight / (0, (0, parcelRequire("1y4EV")).headingSizes)[fontCode].size;
    const $3e1c69a6b9939fcb$var$headingSizes = {
        h1: {
            lineHeight: $3e1c69a6b9939fcb$var$getLineHeight('h700')
        },
        h2: {
            lineHeight: $3e1c69a6b9939fcb$var$getLineHeight('h600')
        },
        h3: {
            lineHeight: $3e1c69a6b9939fcb$var$getLineHeight('h500')
        },
        h4: {
            lineHeight: $3e1c69a6b9939fcb$var$getLineHeight('h400')
        },
        h5: {
            lineHeight: $3e1c69a6b9939fcb$var$getLineHeight('h300')
        },
        h6: {
            lineHeight: $3e1c69a6b9939fcb$var$getLineHeight('h100')
        }
    };
    const $3e1c69a6b9939fcb$var$headingAnchorStyle = (headingTag)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName), "{position:absolute;height:", $3e1c69a6b9939fcb$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
    const $3e1c69a6b9939fcb$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
        if (!allowNestedHeaderLinks) return '';
        return (0, (0, parcelRequire("f8Sb3")).css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
    };
    const $3e1c69a6b9939fcb$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
        if (!allowColumnSorting) return '';
        let headingsCss = '';
        if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, (0, parcelRequire("8L7RC")).HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $i5Kxj.editorExperiment)('table-nested-dnd', true) ? `${0, (0, parcelRequire("qXiNF")).tableCellPadding}px ${"var(--ds-space-250, 20px)"}` : `${0, (0, parcelRequire("qXiNF")).tableCellPadding}px`, ";border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$72ba03e317f3d228$export$e62e8919cca44969})`, ";}}}.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23), "{opacity:1;}}}}");
    };
    const $3e1c69a6b9939fcb$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
        if (appearance !== 'full-page') return '';
        return (0, (0, parcelRequire("f8Sb3")).css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $3e1c69a6b9939fcb$export$12fd658e5eef0d79 : 0, "px;");
    };
    const $3e1c69a6b9939fcb$var$fullWidthStyles = ({ appearance: appearance })=>{
        if (appearance !== 'full-width') return '';
        return (0, (0, parcelRequire("f8Sb3")).css)("max-width:", (0, (0, parcelRequire("70yok")).akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark,.ak-renderer-extension{width:100%!important;}", (0, (0, parcelRequire("fhoQm")).isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
    };
    const $3e1c69a6b9939fcb$var$breakoutWidthStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("*:not([data-mark-type='fragment']) .", (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
    };
    const $3e1c69a6b9939fcb$var$getShadowOverrides = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("&.", (0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, (0, parcelRequire("cpToy")).shadowClassNames).LEFT_SHADOW, "::before{width:", $3e1c69a6b9939fcb$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
    };
    function $3e1c69a6b9939fcb$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
        if (!(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes')) return '';
        if ((0, (0, parcelRequire("2oS3b")).fg)('annotations_align_editor_and_renderer_styles')) return (0, (0, parcelRequire("f8Sb3")).css)({
            '& [data-annotation-draft-mark][data-annotation-inline-node]': {
                borderBottom: '2px solid transparent',
                cursor: 'pointer',
                padding: '1px 0 2px',
                background: `var(--ds-background-accent-yellow-subtler, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
                borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $72ba03e317f3d228$export$c6930421db9fa514)})`,
                boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}`})`
            },
            '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
                padding: '5px 0 3px 0'
            },
            '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        });
        return (0, (0, parcelRequire("f8Sb3")).css)({
            "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
                background: `var(--ds-background-accent-yellow-subtler, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
                borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $72ba03e317f3d228$export$c6930421db9fa514)})`}`,
                boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}`})`,
                cursor: 'pointer',
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
            }
        });
    }
    const $3e1c69a6b9939fcb$var$tableRowHeight = 44;
    const $3e1c69a6b9939fcb$var$stickyScrollbarStyles = `
	position: relative;
	flex-direction: column;

	> .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
	  width: 100%;
	  display: block;
	  visibility: hidden;
	  overflow-x: auto;
	  position: sticky;
	  bottom: ${"var(--ds-space-0, 0px)"};
	  z-index: 1;
	}

	> .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
	> .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   position: absolute;
	   width: 100%;
	   height: 1px;
	   margin-top: -1px;
	   // need this to avoid sentinel being focused via keyboard
	   // this still allows it to be detected by intersection observer
	   visibility: hidden;
	 }
	 > .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   top: ${$3e1c69a6b9939fcb$var$tableRowHeight * 3}px;
	 }
	 > .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
	   bottom:  ${"var(--ds-space-250, 20px)"}; // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
	 }
  `;
    const $3e1c69a6b9939fcb$var$isAdvancedLayoutsPreRelease2 = ()=>(0, $i5Kxj.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_advanced_layouts_pre_release_2');
    const $3e1c69a6b9939fcb$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
            const { colorMode: colorMode, typography: typography } = (0, (0, parcelRequire("3kjDV")).default)();
            const themeProps = {
                theme: theme
            };
            const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, appearance: appearance } = wrapperProps;
            return (0, (0, parcelRequire("f8Sb3")).css)("font-size:", (0, (0, parcelRequire("70yok")).editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`, ";.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $3e1c69a6b9939fcb$var$fullPageStyles(wrapperProps, themeProps), " ", $3e1c69a6b9939fcb$var$fullWidthStyles(wrapperProps), " .", (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT, "{", (0, (0, parcelRequire("67vPJ")).mediaInlineImageStyles), ";}& h1{", $3e1c69a6b9939fcb$var$headingAnchorStyle('h1'), ";}& h2{", $3e1c69a6b9939fcb$var$headingAnchorStyle('h2'), ";}& h3{", $3e1c69a6b9939fcb$var$headingAnchorStyle('h3'), ";}& h4{", $3e1c69a6b9939fcb$var$headingAnchorStyle('h4'), ";}& h5{", $3e1c69a6b9939fcb$var$headingAnchorStyle('h5'), ";}& h6{", $3e1c69a6b9939fcb$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$72ba03e317f3d228$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$72ba03e317f3d228$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$f563ee71e9ee74cd})`, ";}", $3e1c69a6b9939fcb$var$telepointerStyles(colorMode), " ", (0, (0, parcelRequire("kD3Ei")).whitespaceSharedStyles), ";", (0, (0, parcelRequire("lpCDe")).blockquoteSharedStyles), ";", (0, (0, parcelRequire("lX5Os")).headingsSharedStyles)(typography), ";", (0, (0, parcelRequire("eOPA3")).ruleSharedStyles)(), ";", (0, (0, parcelRequire("iITpp")).paragraphSharedStyles)(typography), ";", (0, (0, parcelRequire("6NIy9")).listsSharedStyles), ";", (0, (0, parcelRequire("kVAtA")).indentationSharedStyles), ";", (0, (0, parcelRequire("2aBrY")).blockMarksSharedStyles), ";", (0, (0, parcelRequire("dhb4X")).codeMarkSharedStyles)(), ";", (0, (0, parcelRequire("9L6VL")).shadowSharedStyle), ";", (0, (0, parcelRequire("9BDXQ")).dateSharedStyle), ";", (0, (0, parcelRequire("7vLId")).textColorStyles), ";", (0, (0, parcelRequire("3uv4U")).backgroundColorStyles)(), ";", (0, (0, parcelRequire("jLRN5")).tasksAndDecisionsStyles), ";", (0, (0, parcelRequire("9b2NM")).smartCardSharedStyles), " ", $3e1c69a6b9939fcb$var$getAnnotationStyles(wrapperProps), " & .UnknownBlock{font-family:", (0, (0, parcelRequire("bUQGL")).fontFamily)(), ";font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)((0, (0, parcelRequire("bUQGL")).fontSize)()), ";font-weight:400;white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$72ba03e317f3d228$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$72ba03e317f3d228$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$72ba03e317f3d228$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, (0, parcelRequire("adne7")).richMediaClassName), ".rich-media-wrapped+.", (0, (0, parcelRequire("adne7")).richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, (0, parcelRequire("adne7")).richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, (0, parcelRequire("adne7")).richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, (0, parcelRequire("adne7")).richMediaClassName), ".image-align-start,.", (0, (0, parcelRequire("adne7")).richMediaClassName), ".image-center,.", (0, (0, parcelRequire("adne7")).richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $3e1c69a6b9939fcb$var$alignedHeadingAnchorStyle(wrapperProps), (0, (0, parcelRequire("adne7")).mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT, ">{", $3e1c69a6b9939fcb$var$breakoutWidthStyle(), " * .", (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT, "{.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION, "{margin-top:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), ";}.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, (0, parcelRequire("bRJM5")).shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, (0, parcelRequire("qXiNF")).tableSharedStyle)(), " .", (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT, " .", (0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, (0, parcelRequire("cpToy")).shadowClassNames).LEFT_SHADOW, "::before{top:", (0, (0, parcelRequire("qXiNF")).tableMarginTop) - 1, "px;height:calc(100% - ", (0, (0, parcelRequire("qXiNF")).tableMarginTop), "px);z-index:", (0, (0, parcelRequire("70yok")).akEditorStickyHeaderZIndex), ";}", $3e1c69a6b9939fcb$var$getShadowOverrides(), " ", (0, (0, parcelRequire("fhoQm")).isStickyScrollbarEnabled)(appearance) ? $3e1c69a6b9939fcb$var$stickyScrollbarStyles : '', " & .", (0, (0, parcelRequire("bRJM5")).shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, (0, parcelRequire("bRJM5")).shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, (0, parcelRequire("qXiNF")).tableMarginTop), "px);}table{height:1px;", $3e1c69a6b9939fcb$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}table tr:first-of-type{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, (0, parcelRequire("6zogC")).RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, (0, parcelRequire("70yok")).akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ";width:", (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$f563ee71e9ee74cd})`, ";font-size:", (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)((0, (0, parcelRequire("bUQGL")).fontSize)()), ";}.fixed .", (0, (0, parcelRequire("6zogC")).RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, (0, parcelRequire("70yok")).akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, (0, parcelRequire("70yok")).akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("70yok")).akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $3e1c69a6b9939fcb$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, (0, parcelRequire("d69lr")).getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", $3e1c69a6b9939fcb$var$isAdvancedLayoutsPreRelease2() ? (0, (0, parcelRequire("36ut0")).columnLayoutResponsiveSharedStyle) : (0, (0, parcelRequire("36ut0")).columnLayoutSharedStyle), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:", $3e1c69a6b9939fcb$var$isAdvancedLayoutsPreRelease2() ? 0 : "var(--ds-space-400, 32px)", ";}@media screen and (max-width: ", (0, (0, parcelRequire("70yok")).gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, (0, parcelRequire("9b2NM")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, (0, parcelRequire("dMwYp")).browser).safari ? (0, (0, parcelRequire("ap4cA")).codeBlockInListSafariFix) : '', ";}");
        };
    const $3e1c69a6b9939fcb$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
        if (codeBlockRenderAsBlock) return '';
        return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
    };
});
parcelRegister("67vPJ", function(module, exports) {
    $parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", ()=>$85b640660d4d2f3a$export$dd2e16f83ae6aa78);
    $parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", ()=>$85b640660d4d2f3a$export$7ab34e219ce6eef);
    $parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", ()=>$85b640660d4d2f3a$export$263a8a844c370a89);
    $parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", ()=>$85b640660d4d2f3a$export$b0d1f1e1fb3c4b46);
    $parcel$export(module.exports, "mediaInlineImageStyles", ()=>$85b640660d4d2f3a$export$dee15762144889b7);
    $parcel$export(module.exports, "wrapperStyle", ()=>$85b640660d4d2f3a$export$c4d4f06a25de97f);
    $parcel$export(module.exports, "selectedStyle", ()=>$85b640660d4d2f3a$export$a7abb1b3dc25813f);
    $parcel$export(module.exports, "interactiveStyle", ()=>$85b640660d4d2f3a$export$ac950970e139031e);
    $parcel$export(module.exports, "borderStyle", ()=>$85b640660d4d2f3a$export$4d0a7f76ad443516);
    var $f8Sb3;
    var $8OwkQ;
    function $85b640660d4d2f3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $85b640660d4d2f3a$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
    const $85b640660d4d2f3a$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
    const $85b640660d4d2f3a$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
    const $85b640660d4d2f3a$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
    const $85b640660d4d2f3a$var$inlineImageHeight = (height, margin = 0)=>(0, (0, parcelRequire("f8Sb3")).css)(">.mediaInlineView-content-wrap>.", $85b640660d4d2f3a$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $85b640660d4d2f3a$export$dd2e16f83ae6aa78, ",>.", $85b640660d4d2f3a$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $85b640660d4d2f3a$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
    const $85b640660d4d2f3a$export$dee15762144889b7 = (0, (0, parcelRequire("f8Sb3")).css)(".", $85b640660d4d2f3a$export$dd2e16f83ae6aa78, "{height:", (0, (0, parcelRequire("8OwkQ")).referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $85b640660d4d2f3a$var$inlineImageHeight((0, (0, parcelRequire("8OwkQ")).referenceHeights)['h1'], -3), ";}h2{", $85b640660d4d2f3a$var$inlineImageHeight((0, (0, parcelRequire("8OwkQ")).referenceHeights)['h2'], -3), ";}h3{", $85b640660d4d2f3a$var$inlineImageHeight((0, (0, parcelRequire("8OwkQ")).referenceHeights)['h3'], -2), ";}h4{", $85b640660d4d2f3a$var$inlineImageHeight((0, (0, parcelRequire("8OwkQ")).referenceHeights)['h4'], -2), ";}h5{", $85b640660d4d2f3a$var$inlineImageHeight((0, (0, parcelRequire("8OwkQ")).referenceHeights)['h5'], -2), ";}h6{", $85b640660d4d2f3a$var$inlineImageHeight((0, (0, parcelRequire("8OwkQ")).referenceHeights)['h6'], -2), ";}");
    const $85b640660d4d2f3a$export$c4d4f06a25de97f = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
        overflow: 'hidden',
        borderRadius: `${"var(--ds-border-radius, 3px)"}`,
        aspectRatio: `var(${$85b640660d4d2f3a$export$7ab34e219ce6eef}, ${(0, (0, parcelRequire("8OwkQ")).DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
        maxWidth: '100%'
    });
    const $85b640660d4d2f3a$export$a7abb1b3dc25813f = (0, (0, parcelRequire("f8Sb3")).css)({
        cursor: 'pointer',
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
        outline: 'none'
    });
    const $85b640660d4d2f3a$export$ac950970e139031e = {
        name: "e0dnmk",
        styles: "cursor:pointer"
    };
    const $85b640660d4d2f3a$export$4d0a7f76ad443516 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(${$85b640660d4d2f3a$export$b0d1f1e1fb3c4b46})`,
        borderStyle: 'solid',
        borderRadius: `calc(var(${$85b640660d4d2f3a$export$263a8a844c370a89}, ${(0, (0, parcelRequire("8OwkQ")).DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
        borderWidth: `calc(var(${$85b640660d4d2f3a$export$263a8a844c370a89}, ${(0, (0, parcelRequire("8OwkQ")).DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
        boxSizing: `border-box`
    });
});
parcelRegister("8OwkQ", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", ()=>$4aee4d779062e808$export$d722b7527b1834a8);
    $parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", ()=>$4aee4d779062e808$export$da894f7669b4e67c);
    $parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", ()=>$4aee4d779062e808$export$286cf28b87ad4b4f);
    $parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", ()=>$4aee4d779062e808$export$64fe09732fb8680);
    $parcel$export(module.exports, "referenceHeights", ()=>$4aee4d779062e808$export$c1317a9224e4d798);
    const $4aee4d779062e808$export$d722b7527b1834a8 = 250;
    const $4aee4d779062e808$export$da894f7669b4e67c = 200;
    const $4aee4d779062e808$export$286cf28b87ad4b4f = $4aee4d779062e808$export$d722b7527b1834a8 / $4aee4d779062e808$export$da894f7669b4e67c;
    const $4aee4d779062e808$export$64fe09732fb8680 = 0;
    const $4aee4d779062e808$export$c1317a9224e4d798 = {
        p: 22,
        h1: 36,
        h2: 31,
        h3: 25,
        h4: 23,
        h5: 20,
        h6: 18
    };
});
parcelRegister("3uv4U", function(module, exports) {
    $parcel$export(module.exports, "backgroundColorStyles", ()=>$93afd5e0179d6487$export$e4cca17cf56e99d);
    function $93afd5e0179d6487$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $93afd5e0179d6487$var$_ref = {
        name: "7ixjog",
        styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
    };
    const $93afd5e0179d6487$export$e4cca17cf56e99d = ()=>{
        return $93afd5e0179d6487$var$_ref;
    };
});
parcelRegister("2aBrY", function(module, exports) {
    $parcel$export(module.exports, "blockMarksSharedStyles", ()=>$75dca9fbd1ff6b87$export$33edc553df878c50);
    function $75dca9fbd1ff6b87$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $75dca9fbd1ff6b87$export$33edc553df878c50 = {
        name: "1p01ut3",
        styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
    };
});
parcelRegister("lpCDe", function(module, exports) {
    $parcel$export(module.exports, "blockquoteSharedStyles", ()=>$8b2774dcd04ce923$export$1b5f3b43e6c4a8ee);
    var $f8Sb3;
    var $70yok;
    const $8b2774dcd04ce923$export$1b5f3b43e6c4a8ee = (0, (0, parcelRequire("f8Sb3")).css)({
        '& blockquote': {
            boxSizing: 'border-box',
            color: 'inherit',
            width: '100%',
            display: 'inline-block',
            paddingLeft: "var(--ds-space-200, 16px)",
            borderLeft: `2px solid ${`var(--ds-border, ${(0, (0, parcelRequire("70yok")).akEditorBlockquoteBorderColor)})`}`,
            margin: `${(0, (0, parcelRequire("70yok")).blockNodesVerticalMargin)} 0 0 0`,
            marginRight: 0,
            "[dir='rtl'] &": {
                paddingLeft: 0,
                paddingRight: "var(--ds-space-200, 16px)"
            },
            '&:first-child': {
                marginTop: 0
            },
            '&::before': {
                content: "''"
            },
            '&::after': {
                content: 'none'
            },
            '& p': {
                display: 'block'
            },
            '& table, & table:last-child': {
                display: 'inline-table'
            },
            '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
                display: 'block'
            }
        }
    });
});
parcelRegister("dhb4X", function(module, exports) {
    $parcel$export(module.exports, "codeMarkSharedStyles", ()=>$247e5546301b637d$export$ea799c18f699972b);
    var $f8Sb3;
    var $1VQAj;
    const $247e5546301b637d$export$ea799c18f699972b = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '.code': {
                '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
                ...(0, (0, parcelRequire("1VQAj")).getCodeStyles)()
            }
        });
    };
});
parcelRegister("1VQAj", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$1f3f8b295e4f1970$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$1f3f8b295e4f1970$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$1f3f8b295e4f1970$export$57a2d4b573afd64a);
    var $9jPr7;
    var $dW8Ue;
    const $1f3f8b295e4f1970$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $1f3f8b295e4f1970$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("9jPr7")).SPACING),
            marginRight: (0, (0, parcelRequire("9jPr7")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $1f3f8b295e4f1970$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $1f3f8b295e4f1970$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("9jPr7")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $1f3f8b295e4f1970$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("9jPr7")).SPACING}px 0` : (0, (0, parcelRequire("9jPr7")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("9jPr7")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme),
                ...$1f3f8b295e4f1970$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $1f3f8b295e4f1970$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("9jPr7")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("9jPr7")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $1f3f8b295e4f1970$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("dW8Ue")).getBaseTheme)();
        const baseStyles = $1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $1f3f8b295e4f1970$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("dW8Ue")).getBaseTheme)(),
            ...(0, (0, parcelRequire("dW8Ue")).getColorPalette)(),
            lineNumberWidth: maxLines ? $1f3f8b295e4f1970$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("9jPr7", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$16851b1001a2abd2$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$16851b1001a2abd2$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$16851b1001a2abd2$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$16851b1001a2abd2$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$16851b1001a2abd2$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$16851b1001a2abd2$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$16851b1001a2abd2$export$1758fda69688282e);
    var $bUQGL;
    const $16851b1001a2abd2$export$431ac46d758d98c8 = 12;
    const $16851b1001a2abd2$export$8e3c04032121c606 = '20px';
    const $16851b1001a2abd2$export$c8b5dc30e9f2b86e = '4px';
    const $16851b1001a2abd2$export$82ea42e772d49e5b = (0, (0, parcelRequire("bUQGL")).gridSize)();
    const $16851b1001a2abd2$export$eeeea0ff98e06fff = $16851b1001a2abd2$export$82ea42e772d49e5b * 2;
    const $16851b1001a2abd2$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $16851b1001a2abd2$export$1758fda69688282e = '--ds--code--bg-color';
    const $16851b1001a2abd2$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("dW8Ue", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$c352b5d6d7e52441$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$c352b5d6d7e52441$export$fe2a6478976e8b17);
    var $8QpSo;
    var $5w2JH;
    const $c352b5d6d7e52441$var$T800 = '#067384';
    const $c352b5d6d7e52441$var$Y1100 = '#7A5D1A';
    const $c352b5d6d7e52441$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("5w2JH")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`
        });
    const $c352b5d6d7e52441$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$72ba03e317f3d228$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$72ba03e317f3d228$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`
        };
    });
    const $c352b5d6d7e52441$var$getTheme = ()=>({
            ...$c352b5d6d7e52441$export$4464aa303b3e4fda(),
            ...$c352b5d6d7e52441$export$fe2a6478976e8b17()
        });
    var $c352b5d6d7e52441$export$2e2bcd8739ae039 = $c352b5d6d7e52441$var$getTheme;
});
parcelRegister("36ut0", function(module, exports) {
    $parcel$export(module.exports, "columnLayoutSharedStyle", ()=>$3c9e31d599c6ac65$export$6891a39948814a80);
    $parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", ()=>$3c9e31d599c6ac65$export$3afcac98e7ca927d);
    var $f8Sb3;
    var $70yok;
    const $3c9e31d599c6ac65$export$6891a39948814a80 = (0, (0, parcelRequire("f8Sb3")).css)({
        '[data-layout-section]': {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            '& > *': {
                flex: 1,
                minWidth: 0
            },
            '& > .unsupportedBlockView-content-wrap': {
                minWidth: 'initial'
            },
            [`@media screen and (max-width: ${0, (0, parcelRequire("70yok")).gridMediumMaxWidth}px)`]: {
                flexDirection: 'column'
            }
        }
    });
    const $3c9e31d599c6ac65$export$3afcac98e7ca927d = (0, (0, parcelRequire("f8Sb3")).css)({
        '[data-layout-section]': {
            display: 'flex',
            flexDirection: 'row',
            gap: "var(--ds-space-100, 8px)",
            '& > *': {
                flex: 1,
                minWidth: 0
            },
            '& > .unsupportedBlockView-content-wrap': {
                minWidth: 'initial'
            }
        },
        '.layout-section-container': {
            containerType: 'inline-size',
            containerName: 'layout-area',
            '[data-layout-section]': {
                [`@container layout-area (max-width:${(0, (0, parcelRequire("70yok")).layoutBreakpointWidth).MEDIUM - 1}px)`]: {
                    flexDirection: 'column'
                }
            }
        }
    });
});
parcelRegister("9BDXQ", function(module, exports) {
    $parcel$export(module.exports, "DateSharedCssClassName", ()=>$36d6b9da30e7b61f$export$99cdf122d0bb9f95);
    $parcel$export(module.exports, "dateSharedStyle", ()=>$36d6b9da30e7b61f$export$86f86bd772084bf4);
    var $f8Sb3;
    const $36d6b9da30e7b61f$export$99cdf122d0bb9f95 = {
        DATE_WRAPPER: `date-lozenger-container`,
        DATE_CONTAINER: 'dateView-content-wrap'
    };
    const $36d6b9da30e7b61f$export$86f86bd772084bf4 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`.${$36d6b9da30e7b61f$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
            whiteSpace: 'unset'
        }
    });
});
parcelRegister("lX5Os", function(module, exports) {
    $parcel$export(module.exports, "headingsSharedStyles", ()=>$a3797924328d6815$export$9272613b68afed4b);
    var $f8Sb3;
    var $2oS3b;
    var $2Si48;
    const $a3797924328d6815$var$headingWithAlignmentStyles = ()=>(0, (0, parcelRequire("2oS3b")).fg)('platform_editor_heading_margin_fix') ? {
            '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
                '> h1:first-child': {
                    marginTop: '1.667em'
                },
                ' > h2:first-child': {
                    marginTop: '1.8em'
                },
                '> h3:first-child': {
                    marginTop: '2em'
                },
                '> h4:first-child': {
                    marginTop: '1.357em'
                },
                '> h5:first-child': {
                    marginTop: '1.667em'
                },
                '> h6:first-child': {
                    marginTop: '1.455em'
                }
            },
            '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
                '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                    marginTop: '0'
                }
            }
        } : {};
    const $a3797924328d6815$export$9272613b68afed4b = (typographyTheme)=>{
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform_editor_typography_ugc')) return (0, (0, parcelRequire("f8Sb3")).css)({
            '& h1': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.heading.h1', typographyTheme),
                marginBottom: 0,
                marginTop: '1.45833em',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("2Si48")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                },
                '&::before': {}
            },
            '& h2': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.heading.h2', typographyTheme),
                marginTop: '1.4em',
                marginBottom: 0,
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("2Si48")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h3': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.heading.h3', typographyTheme),
                marginTop: '1.31249em',
                marginBottom: 0,
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("2Si48")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h4': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.heading.h4', typographyTheme),
                marginTop: '1.25em',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("2Si48")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h5': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.heading.h5', typographyTheme),
                marginTop: '1.45833em',
                textTransform: 'none',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("2Si48")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h6': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.heading.h6', typographyTheme),
                marginTop: '1.59091em',
                textTransform: 'none',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("2Si48")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            ...$a3797924328d6815$var$headingWithAlignmentStyles()
        });
        else return (0, (0, parcelRequire("f8Sb3")).css)({
            '& h1': {
                fontSize: `${24 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 28 / 24,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                letterSpacing: `-0.01em`,
                marginBottom: 0,
                marginTop: '1.667em'
            },
            '& h2': {
                fontSize: `${20 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 1.2,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                letterSpacing: `-0.008em`,
                marginTop: '1.8em',
                marginBottom: 0
            },
            '& h3': {
                fontSize: `${16 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 1.25,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                letterSpacing: `-0.006em`,
                marginTop: '2em',
                marginBottom: 0
            },
            '& h4': {
                fontSize: `${1}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 14,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                letterSpacing: `-0.003em`,
                marginTop: '1.357em'
            },
            '& h5': {
                fontSize: `${12 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 12,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                marginTop: '1.667em',
                textTransform: 'none'
            },
            '& h6': {
                fontSize: `${11 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 11,
                color: "var(--ds-text-subtlest, #626F86)",
                fontWeight: "var(--ds-font-weight-bold, 700)",
                marginTop: '1.455em',
                textTransform: 'none'
            },
            ...$a3797924328d6815$var$headingWithAlignmentStyles()
        });
    };
});
parcelRegister("2Si48", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03be794bf4bcfa0c$export$2e2bcd8739ae039);
    var $9i4P5;
    function $03be794bf4bcfa0c$var$editorUGCToken(path, typographyTheme) {
        let token;
        switch(typographyTheme){
            case 'typography-modernized':
                token = (0, (0, parcelRequire("9i4P5")).editorUGCTokensModernized)[path];
                break;
            case 'typography-refreshed':
                token = (0, (0, parcelRequire("9i4P5")).editorUGCTokensRefreshed)[path];
                break;
            default:
                token = (0, (0, parcelRequire("9i4P5")).editorUGCTokens)[path];
                break;
        }
        return token;
    }
    var $03be794bf4bcfa0c$export$2e2bcd8739ae039 = $03be794bf4bcfa0c$var$editorUGCToken;
});
parcelRegister("9i4P5", function(module, exports) {
    $parcel$export(module.exports, "editorUGCTokens", ()=>$488c5df5f5bbd361$export$4a3637dc6e2ae29e);
    $parcel$export(module.exports, "editorUGCTokensModernized", ()=>$488c5df5f5bbd361$export$95588e746468319e);
    $parcel$export(module.exports, "editorUGCTokensRefreshed", ()=>$488c5df5f5bbd361$export$63adc0ebe3278d31);
    const $488c5df5f5bbd361$export$4a3637dc6e2ae29e = {
        'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
    const $488c5df5f5bbd361$export$95588e746468319e = {
        'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
    const $488c5df5f5bbd361$export$63adc0ebe3278d31 = {
        'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600 1em/1.14286 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600 0.857143em/1.33333  "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 "Inter Variable", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
});
parcelRegister("kVAtA", function(module, exports) {
    $parcel$export(module.exports, "indentationSharedStyles", ()=>$087a8438af6acee7$export$6856b92f564d3de8);
    function $087a8438af6acee7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $087a8438af6acee7$export$6856b92f564d3de8 = {
        name: "1bgz9nd",
        styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
    };
});
parcelRegister("adne7", function(module, exports) {
    $parcel$export(module.exports, "richMediaClassName", ()=>$819d087b0a6d5bb1$export$cfe6da7d522d87bb);
    $parcel$export(module.exports, "mediaSingleSharedStyle", ()=>$819d087b0a6d5bb1$export$d031611b96ba4cf0);
    $parcel$export(module.exports, "mediaSingleSharedStyleNew", ()=>$819d087b0a6d5bb1$export$b51dea84d928a378);
    var $f8Sb3;
    var $70yok;
    const $819d087b0a6d5bb1$export$cfe6da7d522d87bb = 'rich-media-item';
    const $819d087b0a6d5bb1$var$wrappedMediaBreakoutPoint = 410;
    const $819d087b0a6d5bb1$export$d031611b96ba4cf0 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`li .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}`]: {
            margin: 0
        },
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        '&.ua-firefox': {
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        [`table .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        [`.${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left`]: {
            clear: 'both'
        },
        [`.${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right, .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left, .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left, .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        [`@media all and (max-width: ${$819d087b0a6d5bb1$var$wrappedMediaBreakoutPoint}px)`]: {
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        }
    });
    const $819d087b0a6d5bb1$export$b51dea84d928a378 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`li .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}`]: {
            margin: 0
        },
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        '&.ua-firefox': {
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            zIndex: (0, (0, parcelRequire("70yok")).akEditorWrappedNodeZIndex)
        },
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        [`table .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        [`.${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left`]: {
            clear: 'both'
        },
        [`.${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right, .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left, .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-left, .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right + .${$819d087b0a6d5bb1$export$cfe6da7d522d87bb}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        [`@media all and (max-width: ${$819d087b0a6d5bb1$var$wrappedMediaBreakoutPoint}px)`]: {
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        }
    });
});
parcelRegister("iITpp", function(module, exports) {
    $parcel$export(module.exports, "paragraphSharedStyles", ()=>$94510f1cbf7beed2$export$2f49074d75b0e29f);
    var $f8Sb3;
    var $70yok;
    var $2oS3b;
    var $2Si48;
    const $94510f1cbf7beed2$export$2f49074d75b0e29f = (typographyTheme)=>{
        return (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_typography_ugc') ? (0, (0, parcelRequire("f8Sb3")).css)({
            '& p': {
                font: (0, (0, parcelRequire("2Si48")).default)('editor.font.body', typographyTheme),
                marginTop: (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin),
                marginBottom: 0
            }
        }) : (0, (0, parcelRequire("f8Sb3")).css)({
            '& p': {
                fontSize: '1em',
                lineHeight: (0, (0, parcelRequire("70yok")).akEditorLineHeight),
                fontWeight: 'normal',
                marginTop: (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin),
                marginBottom: 0,
                letterSpacing: '-0.005em'
            }
        });
    };
});
parcelRegister("eOPA3", function(module, exports) {
    $parcel$export(module.exports, "ruleSharedStyles", ()=>$8ec270d1c971ed01$export$329434b3a2da905e);
    var $f8Sb3;
    var $70yok;
    const $8ec270d1c971ed01$export$329434b3a2da905e = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& hr': {
                border: 'none',
                backgroundColor: "var(--ds-border, #091E4224)",
                margin: `${(0, (0, parcelRequire("70yok")).akEditorLineHeight)}em 0`,
                height: '2px',
                borderRadius: '1px'
            }
        });
});
parcelRegister("9L6VL", function(module, exports) {
    $parcel$export(module.exports, "shadowSharedStyle", ()=>$99a9af145d7e358b$export$985ce3da3286f9ed);
    var $f8Sb3;
    var $70yok;
    var $cpToy;
    var $bRJM5;
    const $99a9af145d7e358b$var$shadowWidth = 8;
    const $99a9af145d7e358b$export$985ce3da3286f9ed = (0, (0, parcelRequire("f8Sb3")).css)({
        [`& .${(0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW}::before, .${(0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW}::after, .${(0, (0, parcelRequire("cpToy")).shadowClassNames).LEFT_SHADOW}::before, .${(0, (0, parcelRequire("cpToy")).shadowClassNames).LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: (0, (0, parcelRequire("70yok")).akEditorShadowZIndex),
            width: `${$99a9af145d7e358b$var$shadowWidth}px`,
            content: "''",
            height: 'calc(100%)'
        },
        [`& .${(0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW}, .${(0, (0, parcelRequire("cpToy")).shadowClassNames).LEFT_SHADOW}`]: {
            position: 'relative'
        },
        [`& .${(0, (0, parcelRequire("cpToy")).shadowClassNames).LEFT_SHADOW}::before`]: {
            background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
            top: '0px',
            left: 0,
            display: 'block'
        },
        [`& .${(0, (0, parcelRequire("cpToy")).shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
            right: '0px',
            top: '0px',
            display: 'block'
        },
        [`& .${(0, (0, parcelRequire("bRJM5")).shadowObserverClassNames).SENTINEL_LEFT}`]: {
            height: '100%',
            width: '0px',
            minWidth: '0px'
        },
        [`& .${(0, (0, parcelRequire("bRJM5")).shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: '100%',
            width: '0px',
            minWidth: '0px'
        }
    });
});
parcelRegister("9b2NM", function(module, exports) {
    $parcel$export(module.exports, "SmartCardSharedCssClassName", ()=>$6e1d352d5b18c5e3$export$4ccd31bf665a88f6);
    $parcel$export(module.exports, "smartCardSharedStyles", ()=>$6e1d352d5b18c5e3$export$83e107f0a431e184);
    var $70yok;
    const $6e1d352d5b18c5e3$export$4ccd31bf665a88f6 = {
        INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
        BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
        EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
        DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
        LOADER_WRAPPER: 'loader-wrapper'
    };
    const $6e1d352d5b18c5e3$export$83e107f0a431e184 = `
  .${$6e1d352d5b18c5e3$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, (0, parcelRequire("70yok")).blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
});
parcelRegister("jLRN5", function(module, exports) {
    $parcel$export(module.exports, "TaskDecisionSharedCssClassName", ()=>$1f2a1d3860bdaaf8$export$a7172b75d403a0e4);
    $parcel$export(module.exports, "tasksAndDecisionsStyles", ()=>$1f2a1d3860bdaaf8$export$df437277fbc8b4f5);
    var $f8Sb3;
    var $70yok;
    const $1f2a1d3860bdaaf8$export$a7172b75d403a0e4 = {
        DECISION_CONTAINER: 'decisionItemView-content-wrap',
        TASK_CONTAINER: 'taskItemView-content-wrap',
        TASK_ITEM: 'task-item'
    };
    const $1f2a1d3860bdaaf8$export$df437277fbc8b4f5 = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.taskItemView-content-wrap,.", $1f2a1d3860bdaaf8$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, (0, parcelRequire("70yok")).akEditorTableCellMinWidth), "px;}.", $1f2a1d3860bdaaf8$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $1f2a1d3860bdaaf8$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, (0, parcelRequire("70yok")).akEditorLineHeight), "em;}}.", $1f2a1d3860bdaaf8$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, (0, parcelRequire("70yok")).akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, (0, parcelRequire("70yok")).akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, (0, parcelRequire("70yok")).akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");
});
parcelRegister("7vLId", function(module, exports) {
    $parcel$export(module.exports, "textColorStyles", ()=>$9adbd7f7e69db0ff$export$a518ea5d00002b38);
    function $9adbd7f7e69db0ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9adbd7f7e69db0ff$export$a518ea5d00002b38 = {
        name: "1nlqh0j",
        styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
    };
});
parcelRegister("kD3Ei", function(module, exports) {
    $parcel$export(module.exports, "whitespaceSharedStyles", ()=>$35793e5ed83bf2e6$export$c9ce3bfa46d7acba);
    function $35793e5ed83bf2e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $35793e5ed83bf2e6$export$c9ce3bfa46d7acba = {
        name: "1s8ykn2",
        styles: "word-wrap:break-word;white-space:pre-wrap"
    };
});
parcelRegister("d69lr", function(module, exports) {
    $parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", ()=>$270a1ffa7f18cee5$export$3f1ff491ca7c4c4a);
    $parcel$export(module.exports, "default", ()=>$270a1ffa7f18cee5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $70yok;
    var $ap4cA;
    var $5LTNu;
    var $6zogC;
    const $270a1ffa7f18cee5$var$lightWeightCodeBlockStyles = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
    const $270a1ffa7f18cee5$export$afbde0e7339bed51 = {
        CONTAINER: 'light-weight-code-block'
    };
    const $270a1ffa7f18cee5$export$3f1ff491ca7c4c4a = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("6zogC")).RendererCssClassName).DOCUMENT, ">.", $270a1ffa7f18cee5$export$afbde0e7339bed51.CONTAINER, " .", (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, (0, parcelRequire("70yok")).blockNodesVerticalMargin), ";}");
    };
    const $270a1ffa7f18cee5$var$LightWeightCodeBlock = (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
        const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
            text
        ]);
        const { renderBidiWarnings: renderBidiWarnings } = (0, (0, parcelRequire("5LTNu")).useBidiWarnings)({
            enableWarningTooltip: codeBidiWarningTooltipEnabled
        });
        const classNames = [
            $270a1ffa7f18cee5$export$afbde0e7339bed51.CONTAINER,
            className
        ].join(' ');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: classNames,
            ref: ref,
            css: [
                (0, (0, parcelRequire("ap4cA")).codeBlockSharedStyles)(),
                $270a1ffa7f18cee5$var$lightWeightCodeBlockStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
        }, textRows.map((_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                key: index
            }))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("ap4cA")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("code", null, renderBidiWarnings(text))))));
    });
    var $270a1ffa7f18cee5$export$2e2bcd8739ae039 = $270a1ffa7f18cee5$var$LightWeightCodeBlock;
});
parcelRegister("5LTNu", function(module, exports) {
    $parcel$export(module.exports, "useBidiWarnings", ()=>$7ba15e2a0e6b5d56$export$9fb9fe546a188c7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $47G8n;
    var $7Z0Bw;
    var $dE7lx;
    const $7ba15e2a0e6b5d56$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const warningLabel = intl.formatMessage((0, (0, parcelRequire("7Z0Bw")).codeBidiWarningMessages).label);
        const renderBidiWarnings = (text)=>{
            return (0, (0, parcelRequire("dE7lx")).default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47G8n")).default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: warningLabel,
                    tooltipEnabled: enableWarningTooltip
                }));
        };
        return {
            renderBidiWarnings: renderBidiWarnings,
            warningLabel: warningLabel
        };
    };
});
parcelRegister("47G8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8606b73bc0e8d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $barbM;
    function $6c8606b73bc0e8d9$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            tag: $6c8606b73bc0e8d9$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $6c8606b73bc0e8d9$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("barbM", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$c9e1f2aa239b72a9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $AHUyh;
    const $c9e1f2aa239b72a9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $c9e1f2aa239b72a9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $c9e1f2aa239b72a9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("dE7lx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511185a3065642e8$export$2e2bcd8739ae039);
    const $511185a3065642e8$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $511185a3065642e8$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($511185a3065642e8$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
const $5fdc00ecb445215c$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
parcelRegister("ffD5B", function(module, exports) {
    $parcel$export(module.exports, "TableHeader", ()=>$81bf611908402e0a$export$f850895b287ef28e);
    $parcel$export(module.exports, "TableCell", ()=>$81bf611908402e0a$export$1e4baea7053fc0e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $9UDEr;
    var $hmJa1;
    var $ahRv6;
    var $dRNhL;
    var $8zPVe;
    var $4la1F;
    var $6SKbt;
    var $6zogC;
    var $koVbs;
    var $gAy7Q;
    const $81bf611908402e0a$var$IgnoreSorting = [
        'LABEL',
        'INPUT'
    ];
    const $81bf611908402e0a$var$nextStatusOrder = (currentSortOrder)=>{
        switch(currentSortOrder){
            case (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER:
                return (0, (0, parcelRequire("ahRv6")).SortOrder).ASC;
            case (0, (0, parcelRequire("ahRv6")).SortOrder).ASC:
                return (0, (0, parcelRequire("ahRv6")).SortOrder).DESC;
            case (0, (0, parcelRequire("ahRv6")).SortOrder).DESC:
                return (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER;
        }
        return (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER;
    };
    const $81bf611908402e0a$var$getSortOrderLabel = (intl, currentSortOrder)=>{
        const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, (0, parcelRequire("gAy7Q")).tableCellMessages);
        switch(currentSortOrder){
            case (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER:
                return intl.formatMessage(noneSortingLabel);
            case (0, (0, parcelRequire("ahRv6")).SortOrder).ASC:
                return intl.formatMessage(ascSortingLabel);
            case (0, (0, parcelRequire("ahRv6")).SortOrder).DESC:
                return intl.formatMessage(descSortingLabel);
            default:
                return intl.formatMessage(noneSortingLabel);
        }
    };
    const $81bf611908402e0a$var$getDataAttributes = (colwidth, background)=>{
        const attrs = {};
        if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
        if (background) attrs['data-cell-background'] = background;
        return attrs;
    };
    const $81bf611908402e0a$var$cssVariablePattern = /^var\(--.*\)$/;
    const $81bf611908402e0a$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
        const style = {};
        if (background && !background.includes('--ds-background-neutral')) {
            const tokenColor = (0, (0, parcelRequire("dRNhL")).hexToEditorBackgroundPaletteRawValue)(background);
            if (tokenColor) style.backgroundColor = tokenColor;
            else if ($81bf611908402e0a$var$cssVariablePattern.test(background)) style.backgroundColor = background;
            else if (colorMode === 'dark') style.backgroundColor = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(background);
            else style.backgroundColor = background;
        }
        if (colGroupWidth) {
            style.width = colGroupWidth;
            style.minWidth = colGroupWidth;
        }
        if (offsetTop !== undefined) style.top = offsetTop;
        return style;
    };
    const $81bf611908402e0a$var$getWithCellProps = (WrapperComponent)=>{
        return function WithCellProps(props) {
            const { colorMode: colorMode } = (0, (0, parcelRequire("hmJa1")).default)();
            const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
            const colorName = background ? (0, (0, parcelRequire("9UDEr")).tableBackgroundColorPalette).get(background) : '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
                rowSpan: rowspan,
                colSpan: colspan,
                style: $81bf611908402e0a$var$getStyle({
                    background: background,
                    colGroupWidth: colGroupWidth,
                    offsetTop: offsetTop,
                    colorMode: colorMode
                }),
                colorname: colorName,
                onClick: onClick,
                className: className,
                ...$81bf611908402e0a$var$getDataAttributes(colwidth, background),
                "aria-sort": ariaSort
            }, children);
        };
    };
    const $81bf611908402e0a$var$TH = $81bf611908402e0a$var$getWithCellProps('th');
    const $81bf611908402e0a$export$cfca40ca5c56a38e = (WrapperComponent)=>{
        return function THWithSortableColumn(props) {
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
            const sortOrderedClassName = sortOrdered === (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER ? (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
            if (!allowColumnSorting || !isHeaderRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, props);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
                ...props,
                className: (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
                ariaSort: $81bf611908402e0a$var$getSortOrderLabel(intl, sortOrdered)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN
            }, children, (0, ($parcel$interopDefault($5uXOq))).createElement("figure", {
                className: `${(0, (0, parcelRequire("6zogC")).RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zPVe")).default), {
                isSortingAllowed: !!onSorting,
                sortOrdered: sortOrdered,
                onClick: sort,
                onKeyDown: onKeyPress
            }))));
            function onKeyPress(event) {
                const keys = [
                    ' ',
                    'Enter',
                    'Spacebar'
                ];
                const { tagName: tagName } = event.target;
                if (keys.includes(event.key) && !$81bf611908402e0a$var$IgnoreSorting.includes(tagName)) {
                    event.preventDefault();
                    sort();
                }
            }
            function sort() {
                const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
                if (onSorting && columnIndex != null) {
                    const sortOrder = $81bf611908402e0a$var$nextStatusOrder(sortOrdered);
                    onSorting(columnIndex, sortOrder);
                    fireAnalyticsEvent && fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("6SKbt")).ACTION).SORT_COLUMN,
                        actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).TABLE,
                        attributes: {
                            platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                            mode: (0, (0, parcelRequire("4la1F")).MODE).RENDERER,
                            columnIndex: columnIndex,
                            sortOrder: sortOrder
                        },
                        eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
                    });
                } else fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).SORT_COLUMN_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("4la1F")).MODE).RENDERER
                    },
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK
                });
            }
        };
    };
    const $81bf611908402e0a$export$f850895b287ef28e = $81bf611908402e0a$export$cfca40ca5c56a38e($81bf611908402e0a$var$TH);
    const $81bf611908402e0a$var$TD = $81bf611908402e0a$var$getWithCellProps('td');
    const $81bf611908402e0a$export$1e4baea7053fc0e3 = $81bf611908402e0a$var$TD;
});
parcelRegister("8zPVe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ce6a8a71de1a816$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8RXs9;
    var $2oS3b;
    var $loZC0;
    var $ahRv6;
    var $3O7rk;
    function $8ce6a8a71de1a816$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ce6a8a71de1a816$var$annotationRangeFixStyle = {
        name: "oldbq4",
        styles: "user-select:none"
    };
    var $8ce6a8a71de1a816$export$c3618f310f725028;
    (function(StatusClassNames) {
        StatusClassNames["ASC"] = "sorting-icon-svg__asc";
        StatusClassNames["DESC"] = "sorting-icon-svg__desc";
        StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
        StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    })($8ce6a8a71de1a816$export$c3618f310f725028 || ($8ce6a8a71de1a816$export$c3618f310f725028 = {}));
    const $8ce6a8a71de1a816$var$buttonStyles = (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
    const $8ce6a8a71de1a816$var$iconWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
    const $8ce6a8a71de1a816$var$iconStyles = {
        name: "1uj2pwb",
        styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
    };
    const $8ce6a8a71de1a816$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
        const activated = sortOrdered !== (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER;
        const activeStatusClass = `${(0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
        if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
        switch(sortOrdered){
            case (0, (0, parcelRequire("ahRv6")).SortOrder).ASC:
                return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
            case (0, (0, parcelRequire("ahRv6")).SortOrder).DESC:
                return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
            default:
                return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
        }
    };
    const $8ce6a8a71de1a816$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
        const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, (0, parcelRequire("3O7rk")).sortingIconMessages);
        if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
        switch(sortOrdered){
            case (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER:
                return intl.formatMessage(noOrderLabel);
            case (0, (0, parcelRequire("ahRv6")).SortOrder).ASC:
                return intl.formatMessage(ascOrderLabel);
            case (0, (0, parcelRequire("ahRv6")).SortOrder).DESC:
                return intl.formatMessage(descOrderLabel);
        }
        return '';
    };
    const $8ce6a8a71de1a816$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
        const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, (0, parcelRequire("3O7rk")).sortingAriaLabelMessages);
        if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
        switch(sortOrdered){
            case (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER:
                return intl.formatMessage(noOrderLabel);
            case (0, (0, parcelRequire("ahRv6")).SortOrder).ASC:
                return intl.formatMessage(ascOrderLabel);
            case (0, (0, parcelRequire("ahRv6")).SortOrder).DESC:
                return intl.formatMessage(descOrderLabel);
        }
        return intl.formatMessage(defaultLabel);
    };
    const $8ce6a8a71de1a816$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
        const buttonClassName = `${(0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $5fdc00ecb445215c$export$bd4f24d8b1e86b23}__not-allowed `}`;
        const content = $8ce6a8a71de1a816$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
        const ariaLabel = $8ce6a8a71de1a816$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
        const handleClick = ()=>{
            if (isSortingAllowed) onClick();
        };
        const handleKeyDown = (event)=>{
            if (isSortingAllowed) onKeyDown(event);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("loZC0")).default), {
            delay: 0,
            content: content,
            position: "top"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $8ce6a8a71de1a816$var$buttonStyles,
            className: buttonClassName,
            role: "button",
            tabIndex: isSortingAllowed ? 0 : -1,
            "aria-label": ariaLabel,
            "aria-disabled": !isSortingAllowed,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $8ce6a8a71de1a816$var$iconWrapperStyles,
            className: $8ce6a8a71de1a816$var$getIconClassName(isSortingAllowed, sortOrdered)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $8ce6a8a71de1a816$var$iconStyles,
                (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_allow_annotation_triple_click') && $8ce6a8a71de1a816$var$annotationRangeFixStyle
            ]
        }))));
    };
    var $8ce6a8a71de1a816$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($8ce6a8a71de1a816$var$SortingIcon);
});
parcelRegister("3O7rk", function(module, exports) {
    $parcel$export(module.exports, "sortingIconMessages", ()=>$bbf57858bbf296e8$export$458c50917513cd1a);
    $parcel$export(module.exports, "sortingAriaLabelMessages", ()=>$bbf57858bbf296e8$export$f142573f51a67577);
    var $7VHMR;
    const $bbf57858bbf296e8$export$458c50917513cd1a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOrderLabel: {
            id: 'fabric.editor.headingLink.noOrderLabel',
            defaultMessage: 'Sort column A to Z',
            description: 'Sort the column in ascending order'
        },
        ascOrderLabel: {
            id: 'fabric.editor.headingLink.ascOrderLabel',
            defaultMessage: 'Sort column Z to A',
            description: 'Sort the column in descending order'
        },
        descOrderLabel: {
            id: 'fabric.editor.headingLink.descOrderLabel',
            defaultMessage: 'Clear sorting',
            description: 'clear the sorting from this column'
        },
        invalidLabel: {
            id: 'fabric.editor.headingLink.invalidLabel',
            defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
            description: 'this sort is invalid for merged cells'
        }
    });
    const $bbf57858bbf296e8$export$f142573f51a67577 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.no',
            defaultMessage: 'No sort applied to the column',
            description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
        },
        ascOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.asc',
            defaultMessage: 'Ascending sort applied',
            description: 'Aria-label for Sort column button when ascending sorting was applied'
        },
        descOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.desc',
            defaultMessage: 'Descending sort applied',
            description: 'Aria-label for Sort column button when descending sorting was applied'
        },
        invalidLabel: {
            id: 'fabric.editor.tableHeader.sorting.invalid',
            defaultMessage: `You can't sort a table with merged cells`,
            description: 'Aria-label for Sort column button when sorting is not possible'
        },
        defaultLabel: {
            id: 'fabric.editor.tableHeader.sorting.default',
            defaultMessage: 'Sort the column',
            description: 'Default aria-label for Sort column button'
        }
    });
});
parcelRegister("fPbxE", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$6bafb41b415e0132$export$2881499e37b75b9a);
    $parcel$export(module.exports, "withSmartCardStorage", ()=>$6bafb41b415e0132$export$65e2d5a272a382b0);
    var $5uXOq = parcelRequire("5uXOq");
    const $6bafb41b415e0132$export$841858b892ce1f4c = (0, ($parcel$interopDefault($5uXOq))).createContext(new Map());
    const $6bafb41b415e0132$export$2881499e37b75b9a = function({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6bafb41b415e0132$export$841858b892ce1f4c.Provider, {
            value: new Map()
        }, children);
    };
    const $6bafb41b415e0132$export$65e2d5a272a382b0 = (WrappedComponent)=>{
        return class extends (0, ($parcel$interopDefault($5uXOq))).Component {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement($6bafb41b415e0132$export$841858b892ce1f4c.Consumer, null, (storage)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    }));
            }
        };
    };
});
parcelRegister("kXFys", function(module, exports) {
    $parcel$export(module.exports, "tableStickyPadding", ()=>$4f3b179378bb6d7f$export$3de6413b528017ca);
    $parcel$export(module.exports, "StickyTable", ()=>$4f3b179378bb6d7f$export$fd9654fc359d55a3);
    $parcel$export(module.exports, "OverflowParent", ()=>$4f3b179378bb6d7f$export$e97bc6692974bd0b);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $qXiNF;
    var $70yok;
    var $aVAOE;
    var $ha2BZ;
    function $4f3b179378bb6d7f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4f3b179378bb6d7f$export$3de6413b528017ca = 8;
    const $4f3b179378bb6d7f$var$modeSpecficStyles = {
        none: {
            name: "eivff4",
            styles: "display:none"
        },
        stick: {
            name: "duudsh",
            styles: "position:fixed"
        },
        'pin-bottom': {
            name: "a4hmbt",
            styles: "position:absolute"
        }
    };
    const $4f3b179378bb6d7f$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
        let stickyHeaderZIndex;
        if (allowTableResizing) stickyHeaderZIndex = 13;
        else stickyHeaderZIndex = (0, (0, parcelRequire("70yok")).akEditorStickyHeaderZIndex);
        return (0, (0, parcelRequire("f8Sb3")).css)(typeof top === 'number' && `top: ${top}px;`, {
            width: `${width}px`,
            zIndex: stickyHeaderZIndex,
            [`& .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
                marginTop: 0,
                marginBottom: 0,
                tr: {
                    background: "var(--ds-surface, white)"
                }
            },
            borderTop: `${$4f3b179378bb6d7f$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
            background: "var(--ds-surface-overlay, white)",
            boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)})`}`,
            "div[data-expanded='false'] &": {
                display: 'none'
            },
            [`& .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
                top: '0px',
                height: '100%'
            },
            "&.fixed-table-div-custom-table-resizing[mode='stick']": {
                zIndex: stickyHeaderZIndex
            }
        });
    };
    const $4f3b179378bb6d7f$var$FixedTableDiv = (props)=>{
        const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
        const fixedTableCss = [
            $4f3b179378bb6d7f$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
            $4f3b179378bb6d7f$var$modeSpecficStyles?.[mode]
        ];
        const attrs = {
            mode: mode
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...attrs,
            "data-testid": "sticky-table-fixed",
            className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
            css: fixedTableCss
        }, props.children);
    };
    const $4f3b179378bb6d7f$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
        let styles;
        if (allowTableResizing) styles = (0, (0, parcelRequire("f8Sb3")).css)({
            top: mode === 'pin-bottom' ? top : undefined,
            position: 'absolute'
        });
        else styles = (0, (0, parcelRequire("f8Sb3")).css)({
            left: left && left < 0 ? left : undefined,
            top: mode === 'pin-bottom' ? top : undefined,
            position: 'relative'
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($4f3b179378bb6d7f$var$FixedTableDiv, {
            top: mode === 'stick' ? top : undefined,
            mode: rowHeight > 300 ? 'none' : mode,
            wrapperWidth: wrapperWidth,
            allowTableResizing: allowTableResizing
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: `${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
            "data-layout": layout,
            style: {
                width: tableWidth
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            className: `${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
            style: {
                overflow: 'hidden'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aVAOE")).Table), {
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance
        }, (0, (0, parcelRequire("ha2BZ")).recursivelyInjectProps)(children, {
            invisible: true
        })))))));
    };
    function $4f3b179378bb6d7f$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
        let parent = table;
        if (!parent) return null;
        while(parent = parent.parentElement){
            const style = window.getComputedStyle(parent);
            if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
            if (!!defaultScrollRootId && parent.id === defaultScrollRootId) return parent;
        }
        return null;
    }
    class $4f3b179378bb6d7f$export$e97bc6692974bd0b {
        constructor(ref){
            this.ref = ref;
            this.ref = ref;
        }
        static fromElement(el, defaultScrollRootId) {
            return new $4f3b179378bb6d7f$export$e97bc6692974bd0b($4f3b179378bb6d7f$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
        }
        get isElement() {
            return this.ref instanceof HTMLElement;
        }
        get id() {
            if (this.ref instanceof HTMLElement) return this.ref.id;
            return '';
        }
        get top() {
            if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
            return 0;
        }
        addEventListener(type, cb, ...args) {
            this.ref.addEventListener(type, cb, ...args);
        }
        removeEventListener(type, cb, ...args) {
            this.ref.removeEventListener(type, cb, ...args);
        }
    }
});
parcelRegister("aVAOE", function(module, exports) {
    $parcel$export(module.exports, "Table", ()=>$d8eecb7ce62446fa$export$54ec01a60f47d33d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1phjZ;
    var $fEe07;
    var $70yok;
    const $d8eecb7ce62446fa$export$54ec01a60f47d33d = (0, ($parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing })=>{
        let tableWidth = tableNode ? (0, (0, parcelRequire("fEe07")).getTableContainerWidth)(tableNode) : (0, (0, parcelRequire("70yok")).akEditorDefaultLayoutWidth);
        if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
        if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
        const tableLayout = tableNode?.attrs.layout;
        const tableDisplayMode = tableNode?.attrs.displayMode;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("table", {
            "data-testid": "renderer-table",
            "data-number-column": isNumberColumnEnabled,
            "data-table-width": tableWidth,
            "data-layout": tableLayout,
            "data-table-display-mode": tableDisplayMode,
            ref: innerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1phjZ")).Colgroup), {
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, children));
    });
});
parcelRegister("1phjZ", function(module, exports) {
    $parcel$export(module.exports, "Colgroup", ()=>$9dfe566bdecdf577$export$89efc2d0ceeaa030);
    var $5uXOq = parcelRequire("5uXOq");
    var $qXiNF;
    var $70yok;
    var $i5Kxj = parcelRequire("i5Kxj");
    var $fEe07;
    var $2oS3b;
    var $43exb;
    var $iWoJB;
    const $9dfe566bdecdf577$var$MAX_SCALING_PERCENT = 0.3;
    const $9dfe566bdecdf577$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
    const $9dfe566bdecdf577$var$isTableColumnResized = (columnWidths)=>{
        const filteredWidths = columnWidths.filter((width)=>width !== 0);
        return !!filteredWidths.length;
    };
    const $9dfe566bdecdf577$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
        if (columnWidth === 0) return columnWidth;
        if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, (0, parcelRequire("qXiNF")).tableCellMinWidth));
        return Math.max(columnWidth - (0, (0, parcelRequire("qXiNF")).tableCellBorderWidth), zeroWidthColumnsCount ? (0, (0, parcelRequire("70yok")).akEditorTableLegacyCellMinWidth) : (0, (0, parcelRequire("qXiNF")).tableCellMinWidth));
    };
    const $9dfe566bdecdf577$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
        const noNumColumnScalePercent = renderWidth / tableWidth;
        const numColumnScalePercent = (renderWidth - (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth)) / (tableWidth - (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth));
        const diffPercent = 1 - noNumColumnScalePercent;
        return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
    };
    const $9dfe566bdecdf577$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
    const $9dfe566bdecdf577$var$renderScaleDownColgroup = (props)=>{
        let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
        if (!columnWidths) return [];
        const tableColumnResized = $9dfe566bdecdf577$var$isTableColumnResized(columnWidths);
        const noOfColumns = columnWidths.length;
        let targetWidths;
        const isRendererNested = isTopLevelRenderer === false && (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_nested_table_in_nested_parent_fix');
        const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, (0, parcelRequire("fEe07")).getTableContainerWidth)(tableNode);
        if (allowTableResizing && !isInsideOfBlockNode && !isinsideMultiBodiedExtension && !tableColumnResized) {
            const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
            const defaultColumnWidth = tableWidth / noOfColumns;
            targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
        } else if (!tableColumnResized) return null;
        const sumOfColumns = $9dfe566bdecdf577$var$colWidthSum(columnWidths);
        const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
        const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
        if (forceScaleForNumColumn) {
            const scalePercentage = +((tableContainerWidth - (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth)) / tableContainerWidth);
            const targetMaxWidth = tableContainerWidth - (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth);
            let totalWidthAfterScale = 0;
            const newScaledTargetWidths = columnWidths.map((width)=>{
                const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
                const newWidth = Math.floor(patchedWidth * scalePercentage);
                totalWidthAfterScale += newWidth;
                return newWidth;
            });
            const diff = targetMaxWidth - totalWidthAfterScale;
            targetWidths = newScaledTargetWidths;
            if (diff > 0 || diff < 0 && Math.abs(diff) < (0, (0, parcelRequire("qXiNF")).tableCellMinWidth)) {
                let updated = false;
                targetWidths = targetWidths.map((width)=>{
                    if (!updated && width + diff > (0, (0, parcelRequire("qXiNF")).tableCellMinWidth)) {
                        updated = true;
                        width += diff;
                    }
                    return width;
                });
            }
        }
        targetWidths = targetWidths || columnWidths;
        const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
        let tableWidth = isNumberColumnEnabled ? (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth) : 0;
        let minTableWidth = tableWidth;
        let zeroWidthColumnsCount = 0;
        targetWidths.forEach((width)=>{
            if (width) tableWidth += Math.ceil(width);
            else zeroWidthColumnsCount += 1;
            minTableWidth += Math.ceil(width) || (0, (0, parcelRequire("70yok")).akEditorTableLegacyCellMinWidth);
        });
        let cellMinWidth = 0;
        let scaleDownPercent = 0;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
        const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $9dfe566bdecdf577$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $9dfe566bdecdf577$var$MAX_SCALING_PERCENT;
        if (zeroWidthColumnsCount > 0) {
            if (minTableWidth > maxTableWidth) {
                const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
                cellMinWidth = minWidth < (0, (0, parcelRequire("70yok")).akEditorTableLegacyCellMinWidth) ? (0, (0, parcelRequire("70yok")).akEditorTableLegacyCellMinWidth) : minWidth;
            }
        } else if (renderWidth < tableWidth && !isTableWidthFixed) {
            const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
            scaleDownPercent = $9dfe566bdecdf577$var$calcScalePercent({
                renderWidth: renderWidth,
                tableWidth: tableWidth,
                maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
                isNumberColumnEnabled: isNumberColumnEnabled
            });
        }
        return targetWidths.map((colWidth)=>{
            const width = $9dfe566bdecdf577$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
            const style = width ? {
                width: `${width}px`
            } : {};
            return style;
        });
    };
    const $9dfe566bdecdf577$export$89efc2d0ceeaa030 = (props)=>{
        const { isTopLevelRenderer: isTopLevelRenderer } = (0, (0, parcelRequire("iWoJB")).useRendererContext)();
        let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
        const flags = (0, (0, parcelRequire("43exb")).useFeatureFlags)();
        if (!columnWidths) return null;
        const colStyles = $9dfe566bdecdf577$var$renderScaleDownColgroup({
            ...props,
            isTopLevelRenderer: isTopLevelRenderer,
            isTableScalingEnabled: !!(flags && 'tablePreserveWidth' in flags && flags.tablePreserveWidth) || props.rendererAppearance === 'comment' && (0, $i5Kxj.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            }) || props.rendererAppearance === 'comment' && (0, $i5Kxj.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
        });
        if (!colStyles) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("colgroup", null, isNumberColumnEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement("col", {
            style: {
                width: (0, (0, parcelRequire("70yok")).akEditorTableNumberColumnWidth)
            },
            "data-test-id": 'num'
        }), colStyles.map((style, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement("col", {
                key: idx,
                style: style
            })));
    };
});
parcelRegister("43exb", function(module, exports) {
    $parcel$export(module.exports, "useFeatureFlags", ()=>$387064046ba5bbc9$export$90335b3ff08f335);
    var $iWoJB;
    const $387064046ba5bbc9$export$90335b3ff08f335 = ()=>(0, (0, parcelRequire("iWoJB")).useRendererContext)()?.featureFlags;
});
parcelRegister("iWoJB", function(module, exports) {
    $parcel$export(module.exports, "useRendererContext", ()=>$fc2adb3ff7cc463d$export$a906432540ed7ed8);
    $parcel$export(module.exports, "RendererContextProvider", ()=>$fc2adb3ff7cc463d$export$ca5df47902194781);
    var $5uXOq = parcelRequire("5uXOq");
    const $fc2adb3ff7cc463d$var$RendererContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    const $fc2adb3ff7cc463d$export$a906432540ed7ed8 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($fc2adb3ff7cc463d$var$RendererContext);
    const $fc2adb3ff7cc463d$export$ca5df47902194781 = $fc2adb3ff7cc463d$var$RendererContext.Provider;
});
parcelRegister("ha2BZ", function(module, exports) {
    $parcel$export(module.exports, "recursivelyInjectProps", ()=>$86382b988810d853$export$40e12ce8e0a76b0c);
    var $5uXOq = parcelRequire("5uXOq");
    function $86382b988810d853$export$40e12ce8e0a76b0c(children, propsToInject) {
        return (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
            if (!(0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
            if (child.props.children) child = (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                children: $86382b988810d853$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
            });
            return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
        });
    }
});
parcelRegister("2Pc8k", function(module, exports) {
    $parcel$export(module.exports, "isFullWidthAppearance", ()=>$e9433779c47a735d$export$c0112b8340d4924b);
    $parcel$export(module.exports, "isFullPageAppearance", ()=>$e9433779c47a735d$export$a64737a81cde10b4);
    $parcel$export(module.exports, "isCommentAppearance", ()=>$e9433779c47a735d$export$f77d2ff45b2c53ed);
    $parcel$export(module.exports, "isFullWidthOrFullPageAppearance", ()=>$e9433779c47a735d$export$33331a99fac775a1);
    const $e9433779c47a735d$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
    const $e9433779c47a735d$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
    const $e9433779c47a735d$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
    const $e9433779c47a735d$export$33331a99fac775a1 = (appearance)=>$e9433779c47a735d$export$a64737a81cde10b4(appearance) || $e9433779c47a735d$export$c0112b8340d4924b(appearance);
});
parcelRegister("8MO2r", function(module, exports) {
    $parcel$export(module.exports, "TableStickyScrollbar", ()=>$787052377e7c8741$export$8c072780619cfc83);
    var $qXiNF;
    class $787052377e7c8741$export$8c072780619cfc83 {
        constructor(wrapper){
            this.sentinels = {};
            this.handleScroll = (event)=>{
                if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
                this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
            };
            this.wrapper = wrapper;
            this.init();
        }
        dispose() {
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
            this.deleteIntersectionObserver();
        }
        scrollLeft(left) {
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
        }
        init() {
            if (!this.wrapper) return;
            this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
                passive: true
            });
            this.createIntersectionObserver();
        }
        createIntersectionObserver() {
            this.rendererScrollableElement = window.document;
            if (!this.rendererScrollableElement || !this.wrapper) return;
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                if (!this.stickyScrollbarContainerElement) return;
                entries.forEach((entry)=>{
                    const target = entry.target;
                    if (target.classList.contains((0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                    if (target.classList.contains((0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
                });
            }, {
                root: this.rendererScrollableElement
            });
            this.sentinels.bottom = this.wrapper?.parentElement?.getElementsByClassName((0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
            this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, (0, parcelRequire("qXiNF")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
            [
                this.sentinels.bottom,
                this.sentinels.top
            ].forEach((el)=>this.intersectionObserver.observe(el));
        }
        deleteIntersectionObserver() {
            if (this.intersectionObserver) {
                if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
                this.intersectionObserver.disconnect();
            }
        }
        sentinelBottomCallback(entry) {
            const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
            this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
            this.toggle();
        }
        sentinelTopCallback(entry) {
            const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
            this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
            this.toggle();
        }
        toggle() {
            if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
            else this.hide();
        }
        hide() {
            if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
        }
        show() {
            if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
        }
    }
});
parcelRegister("kXb3o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1022cd36d5e7637d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $j7Z83;
    var $ahRv6;
    var $6zogC;
    class $1022cd36d5e7637d$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, innerRef: innerRef } = this.props;
            const childrenArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                ref: innerRef
            }, this.props.isNumberColumnEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                className: (0, (0, parcelRequire("6zogC")).RendererCssClassName).NUMBER_COLUMN
            }, this.props.index), (0, (0, parcelRequire("j7Z83")).compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
        }
        constructor(...args){
            super(...args);
            this.state = {
                colGroupWidths: []
            };
            this.addSortableColumn = (childrenArray)=>{
                const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
                if (allowColumnSorting) {
                    const isHeaderRow = !rowIndex;
                    childrenArray = childrenArray.map((child, index)=>{
                        if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) {
                            const { tableOrderStatus: tableOrderStatus } = this.props;
                            let sortOrdered = (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER;
                            if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, (0, parcelRequire("ahRv6")).SortOrder).NO_ORDER;
                            return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                                columnIndex: index,
                                onSorting: this.props.onSorting,
                                sortOrdered: sortOrdered,
                                isHeaderRow: isHeaderRow
                            });
                        }
                    });
                }
                return childrenArray;
            };
            this.addColGroupWidth = (childrenArray)=>{
                if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                    if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        colGroupWidth: this.state.colGroupWidths[index]
                    });
                });
                return childrenArray;
            };
        }
    }
});
parcelRegister("8xfhx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8a7a7d84298cc67$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $c8a7a7d84298cc67$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "UnknownBlock"
        }, props.children);
    }
});
parcelRegister("cKk13", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$508e02ab814333ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $70yok;
    var $k5aAz;
    var $loZC0;
    var $6SKbt;
    var $kXMr5;
    var $484Vr;
    var $3GOhg;
    const $508e02ab814333ed$var$inlineNodeStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        alignItems: 'center',
        background: "var(--ds-background-disabled, #091E4208)",
        border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        cursor: 'default',
        display: 'inline-flex',
        fontSize: (0, (0, parcelRequire("70yok")).relativeFontSizeToBase16)(14),
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        minHeight: '24px',
        padding: `0 ${"var(--ds-space-100, 8px)"}`,
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
    });
    const $508e02ab814333ed$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const message = (0, (0, parcelRequire("3GOhg")).getUnsupportedContent)((0, (0, parcelRequire("kXMr5")).unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
        const tooltipContent = intl.formatMessage((0, (0, parcelRequire("kXMr5")).unsupportedContentMessages).unsupportedContentTooltip);
        const { current: style } = (0, $5uXOq.useRef)({
            padding: '4px'
        });
        const originalNodeType = node?.attrs.originalValue.type;
        const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, (0, parcelRequire("484Vr")).trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
            dispatchAnalyticsEvent,
            originalNodeType
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $508e02ab814333ed$var$inlineNodeStyle
        }, message, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("loZC0")).default), {
            content: tooltipContent,
            hideTooltipOnClick: false,
            position: "bottom",
            onShow: tooltipOnShowHandler,
            strategy: "absolute"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: style
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("k5aAz"))))), {
            label: "?",
            size: "small"
        }))));
    };
    var $508e02ab814333ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($508e02ab814333ed$var$UnsupportedInlineNode);
});
parcelRegister("6YsFx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Xnrz").then(()=>parcelRequire('h9eZs'));
});
parcelRegister("2IuQA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iroR9").then(()=>parcelRequire('7sKVT'));
});
parcelRegister("h4k7O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bWnGg").then(()=>parcelRequire('9RjJM'));
});
parcelRegister("8UEog", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("6PFVQ")
    ]).then(()=>parcelRequire('fYPFw'));
});
parcelRegister("8eZjH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kItRj").then(()=>parcelRequire('2l3Ic'));
});
parcelRegister("k1bqP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jA4o5").then(()=>parcelRequire('hTr4L'));
});
parcelRegister("9JrDW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ilipr").then(()=>parcelRequire('Adwu5'));
});
parcelRegister("kVmCz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5V5qT")
    ]).then(()=>parcelRequire('eMpCd'));
});
parcelRegister("bv7Z4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("cgCbS")
    ]).then(()=>parcelRequire('dTW2c'));
});
parcelRegister("jBXoV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2ClsJ")
    ]).then(()=>parcelRequire('csy4W'));
});
parcelRegister("dFvTp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("hHqDR")
    ]).then(()=>parcelRequire('7G5uP'));
});
parcelRegister("4kY1v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4LXZH")
    ]).then(()=>parcelRequire('7MSHt'));
});
parcelRegister("bCdOW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9rZPZ")
    ]).then(()=>parcelRequire('cCzkL'));
});
parcelRegister("1Ragz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9ROpP")
    ]).then(()=>parcelRequire('4fg2k'));
});
parcelRegister("84b6y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jcNXO")
    ]).then(()=>parcelRequire('8sF7n'));
});
parcelRegister("jt6ij", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4BW1H")
    ]).then(()=>parcelRequire('cQG7G'));
});
parcelRegister("h14um", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kW2ju").then(()=>parcelRequire('drZL1'));
});
parcelRegister("3aRy8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("bVQDU")
    ]).then(()=>parcelRequire('gs2rs'));
});
parcelRegister("48J9u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kcrVO")
    ]).then(()=>parcelRequire('1NlsB'));
});
parcelRegister("ltS6U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f7dc29dfbca1a35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6c6bW;
    const $1f7dc29dfbca1a35$var$TextWrapper = (props)=>{
        const { startPos: startPos, endPos: endPos } = props;
        const { children: children } = props;
        if (!children) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6c6bW")).TextWithAnnotationDraft), {
            startPos: startPos,
            endPos: endPos,
            textHighlighter: props.textHighlighter,
            marks: props.marks
        }, children);
    };
    var $1f7dc29dfbca1a35$export$2e2bcd8739ae039 = $1f7dc29dfbca1a35$var$TextWrapper;
});
parcelRegister("5qH0P", function(module, exports) {
    $parcel$export(module.exports, "isAnnotationMark", ()=>$c96743ed79f969a1$export$855795c145f03402);
    $parcel$export(module.exports, "default", ()=>$c96743ed79f969a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $jaTuH;
    const $c96743ed79f969a1$export$855795c145f03402 = (mark)=>{
        return mark && mark.type && mark.type.name === 'annotation';
    };
    const $c96743ed79f969a1$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
        const data = {
            ...dataAttributes,
            ...(0, (0, parcelRequire("88i6h")).buildDataAttributes)({
                id: id,
                annotationType: annotationType
            })
        };
        if (allowAnnotations) return isMediaInline ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: id
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jaTuH")).MarkElement), {
            id: id,
            dataAttributes: data,
            annotationParentIds: annotationParentIds,
            annotationType: annotationType,
            useBlockLevel: useBlockLevel
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: id,
            ...data
        }, children);
    };
    var $c96743ed79f969a1$export$2e2bcd8739ae039 = $c96743ed79f969a1$var$AnnotationComponent;
});
parcelRegister("jXk0r", function(module, exports) {
    $parcel$export(module.exports, "toReact", ()=>$6c632027413d43a0$export$d4334b129116aad7);
    var $31jF8;
    var $46QKN;
    var $dBa7n;
    var $l3Btm;
    var $9jIsx;
    var $ag6sP;
    var $j6ESF;
    var $kDIMM;
    var $iV0Ik;
    var $jfdf8;
    var $eWnSX;
    var $iqj4v;
    var $e6uLQ;
    var $g8egj;
    var $hFru6;
    var $ciRQw;
    var $5qH0P;
    var $cnXKU;
    var $aNTft;
    const $6c632027413d43a0$export$c00d967a0f56fdb7 = {
        code: (0, (0, parcelRequire("31jF8")).default),
        em: (0, (0, parcelRequire("46QKN")).default),
        link: (0, (0, parcelRequire("dBa7n")).default),
        strike: (0, (0, parcelRequire("l3Btm")).default),
        strong: (0, (0, parcelRequire("9jIsx")).default),
        subsup: (0, (0, parcelRequire("ag6sP")).default),
        textColor: (0, (0, parcelRequire("j6ESF")).default),
        backgroundColor: (0, (0, parcelRequire("kDIMM")).default),
        underline: (0, (0, parcelRequire("iV0Ik")).default),
        annotation: (0, (0, parcelRequire("5qH0P")).default),
        border: (0, (0, parcelRequire("cnXKU")).default),
        confluenceInlineComment: (0, (0, parcelRequire("aNTft")).default),
        breakout: (0, (0, parcelRequire("jfdf8")).default),
        alignment: (0, (0, parcelRequire("eWnSX")).default),
        indentation: (0, (0, parcelRequire("iqj4v")).default),
        unsupportedMark: (0, (0, parcelRequire("e6uLQ")).default),
        unsupportedNodeAttribute: (0, (0, parcelRequire("g8egj")).default),
        dataConsumer: (0, (0, parcelRequire("hFru6")).default),
        fragment: (0, (0, parcelRequire("ciRQw")).default)
    };
    const $6c632027413d43a0$export$d4334b129116aad7 = (mark)=>{
        return $6c632027413d43a0$export$c00d967a0f56fdb7[mark.type.name];
    };
});
parcelRegister("31jF8", function(module, exports) {
    $parcel$export(module.exports, "isCodeMark", ()=>$50bb03617a992814$export$86390c02c110ec2f);
    $parcel$export(module.exports, "default", ()=>$50bb03617a992814$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $aJya3;
    var $7Z0Bw;
    const $50bb03617a992814$export$86390c02c110ec2f = (mark)=>{
        return mark && mark.type && mark.type.name === 'code';
    };
    function $50bb03617a992814$export$7cea6ffa7022e85f(props) {
        const codeBidiWarningLabel = props.intl.formatMessage((0, (0, parcelRequire("7Z0Bw")).codeBidiWarningMessages).label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aJya3")).default), {
            className: "code",
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
            ...props.dataAttributes
        }, props.children);
    }
    var $50bb03617a992814$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($50bb03617a992814$export$7cea6ffa7022e85f);
});
parcelRegister("aJya3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$280cfc9bda8e0c22$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $47G8n;
    var $dE7lx;
    var $9jPr7;
    var $1VQAj;
    const $280cfc9bda8e0c22$var$styles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(${(0, (0, parcelRequire("9jPr7")).VAR_CODE_BG_COLOR)}, ${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        font: "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        lineHeight: 'inherit',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    });
    const $280cfc9bda8e0c22$var$Code = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
        const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
        const decoratedChildren = codeBidiWarnings ? (0, (0, parcelRequire("f8Sb3")).jsx)($280cfc9bda8e0c22$var$RenderCodeChildrenWithBidiWarnings, {
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        }, children) : children;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("code", {
            ref: ref,
            "data-testid": testId,
            css: $280cfc9bda8e0c22$var$styles,
            ...otherProps
        }, decoratedChildren));
    }));
    function $280cfc9bda8e0c22$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
        const replacedChildren = (0, ($parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
            if (typeof childNode === 'string') {
                const decorated = (0, (0, parcelRequire("dE7lx")).default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("47G8n")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            if ($280cfc9bda8e0c22$var$isReactElement(childNode) && childNode.props.children) {
                const newChildNode = (0, ($parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                    children: (0, (0, parcelRequire("f8Sb3")).jsx)($280cfc9bda8e0c22$var$RenderCodeChildrenWithBidiWarnings, {
                        codeBidiWarningLabel: codeBidiWarningLabel,
                        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                    }, childNode.props.children)
                });
                return newChildNode;
            }
            return childNode;
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, replacedChildren);
    }
    function $280cfc9bda8e0c22$var$isReactElement(child) {
        return !!child.type;
    }
    $280cfc9bda8e0c22$var$Code.displayName = 'Code';
    var $280cfc9bda8e0c22$export$2e2bcd8739ae039 = $280cfc9bda8e0c22$var$Code;
});
parcelRegister("46QKN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b8bd9d20df603c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $7b8bd9d20df603c8$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("em", props.dataAttributes, props.children);
    }
});
parcelRegister("dBa7n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac93aff1745cb3ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $daqZ0;
    var $4la1F;
    var $6SKbt;
    var $bwcfh;
    var $iJDK4;
    const $ac93aff1745cb3ba$var$anchorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-link, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '&:hover': {
            color: `var(--ds-link, ${(0, $72ba03e317f3d228$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $72ba03e317f3d228$export$a6ee3d71bc067634)})`
        }
    });
    function $ac93aff1745cb3ba$export$2e2bcd8739ae039(props) {
        const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
        const anchorProps = {
            href: href,
            target: target,
            title: href
        };
        if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
        const handler = (0, (0, parcelRequire("daqZ0")).getEventHandler)(eventHandlers, 'link');
        if (isMediaLink) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, props.children);
        const analyticsData = {
            attributes: {
                location: 'renderer'
            },
            location: 'renderer'
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iJDK4")).default), {
            data: analyticsData
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bwcfh")).default), {
            css: $ac93aff1745cb3ba$var$anchorStyles,
            onClick: (e)=>{
                if (fireAnalyticsEvent) fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).VISITED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).LINK,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).TRACK,
                    attributes: {
                        platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("4la1F")).MODE).RENDERER
                    }
                });
                if (handler) handler(e, href);
            },
            ...anchorProps,
            ...dataAttributes
        }, props.children));
    }
});
parcelRegister("daqZ0", function(module, exports) {
    $parcel$export(module.exports, "ADFEncoder", ()=>$6ae38a01dc8c01ba$export$bcf771b83128eae7);
    $parcel$export(module.exports, "getText", ()=>$6ae38a01dc8c01ba$export$c72d34660a162238);
    $parcel$export(module.exports, "getEventHandler", ()=>$6ae38a01dc8c01ba$export$eee20638634729b3);
    $parcel$export(module.exports, "findInTree", ()=>$6ae38a01dc8c01ba$export$38b61ebf4950cd39);
    var $kOFhM;
    var $jLwE5;
    function $6ae38a01dc8c01ba$var$createEncoder(parser, encoder) {
        return (value)=>encoder.encode(parser.parse(value));
    }
    class $6ae38a01dc8c01ba$export$bcf771b83128eae7 {
        constructor(createTransformerWithSchema){
            const transformer = createTransformerWithSchema((0, (0, parcelRequire("kOFhM")).defaultSchema));
            this.encode = $6ae38a01dc8c01ba$var$createEncoder(transformer, new (0, (0, parcelRequire("jLwE5")).JSONTransformer)());
        }
    }
    const $6ae38a01dc8c01ba$export$c72d34660a162238 = (node)=>{
        return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
    };
    const $6ae38a01dc8c01ba$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
        return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
    };
    function $6ae38a01dc8c01ba$export$38b61ebf4950cd39(element, topElement, evaluate) {
        if (element === topElement) return false;
        if (evaluate(element)) return true;
        if (!element.parentElement) return false;
        return $6ae38a01dc8c01ba$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
    }
});
parcelRegister("bwcfh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c0501e51a3aeb63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dvXtt;
    var $4XPSZ;
    var $4AZ8t;
    var $2bBpZ;
    var $1J5tM;
    const $7c0501e51a3aeb63$var$PACKAGE_DATA = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        componentName: 'linkUrl'
    };
    const $7c0501e51a3aeb63$var$Link = (0, (0, parcelRequire("4XPSZ")).withLinkClickedEvent)('a');
    const $7c0501e51a3aeb63$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', ...props })=>{
        const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, (0, parcelRequire("1J5tM")).useLinkWarningModal)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4AZ8t")).LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c0501e51a3aeb63$var$Link, {
            "data-testid": testId,
            href: href,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2bBpZ")).default), linkWarningModalProps));
    };
    var $7c0501e51a3aeb63$export$2e2bcd8739ae039 = (0, (0, parcelRequire("dvXtt")).default)($7c0501e51a3aeb63$var$PACKAGE_DATA)($7c0501e51a3aeb63$var$LinkUrl);
});
parcelRegister("4XPSZ", function(module, exports) {
    $parcel$export(module.exports, "fireLinkClickedEvent", ()=>$42e0672e5b4e2667$export$7987de3055fbdcb0);
    $parcel$export(module.exports, "withLinkClickedEvent", ()=>$42e0672e5b4e2667$export$263352d59c0c5966);
    var $5uXOq = parcelRequire("5uXOq");
    var $7uSTi;
    var $21hik;
    var $2E3bm;
    const $42e0672e5b4e2667$export$cfb45d54e1604f6c = new Map([
        [
            undefined,
            'none'
        ],
        [
            0,
            'left'
        ],
        [
            1,
            'middle'
        ],
        [
            2,
            'right'
        ]
    ]);
    const $42e0672e5b4e2667$export$74743eda5dda3ccf = (e)=>{
        return [
            'alt',
            'ctrl',
            'meta',
            'shift'
        ].filter((key)=>e[`${key}Key`] === true);
    };
    const $42e0672e5b4e2667$var$isContentEditable = (el)=>{
        return el instanceof HTMLElement && el.isContentEditable;
    };
    function $42e0672e5b4e2667$export$d2a83e3b34be812b(e, clickType) {
        const { mac: mac, safari: safari } = (0, (0, parcelRequire("7uSTi")).browser)();
        if ($42e0672e5b4e2667$var$isContentEditable(e.currentTarget) && [
            'left',
            'middle'
        ].includes(clickType)) return 'contentEditable';
        switch(clickType){
            case 'left':
            case 'keyboard':
                {
                    if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                    if (e.shiftKey) {
                        if (safari) return 'alt';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.ctrlKey) {
                        if (mac) return 'clickThrough';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.altKey) return 'alt';
                    const target = e.currentTarget.getAttribute('target');
                    if (target === '_blank') return 'clickThroughNewTabOrWindow';
                    return 'clickThrough';
                }
            case 'middle':
                return 'clickThroughNewTabOrWindow';
            case 'right':
                return 'contextMenu';
        }
        return 'unknown';
    }
    const $42e0672e5b4e2667$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
            action: 'clicked',
            actionSubject: 'link',
            eventType: 'ui',
            attributes: {
                clickType: clickType,
                clickOutcome: clickOutcome,
                keysHeld: keysHeld,
                defaultPrevented: defaultPrevented
            }
        });
    const $42e0672e5b4e2667$export$7fedc699766c16de = (event)=>{
        const isKeyboard = event.nativeEvent.detail === 0;
        const clickType = isKeyboard ? 'keyboard' : $42e0672e5b4e2667$export$cfb45d54e1604f6c.get(event.button);
        if (!clickType) return;
        const clickOutcome = $42e0672e5b4e2667$export$d2a83e3b34be812b(event, clickType);
        const keysHeld = $42e0672e5b4e2667$export$74743eda5dda3ccf(event);
        const defaultPrevented = event.defaultPrevented;
        return $42e0672e5b4e2667$var$linkClickedEvent({
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        });
    };
    const $42e0672e5b4e2667$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
            const payload = $42e0672e5b4e2667$export$7fedc699766c16de(event);
            if (payload) createAnalyticsEvent({
                ...payload,
                ...overrides,
                attributes: {
                    ...payload.attributes,
                    ...overrides?.attributes
                }
            }).fire((0, (0, parcelRequire("2E3bm")).ANALYTICS_CHANNEL));
        };
    const $42e0672e5b4e2667$var$getDisplayName = (WrappedComponent)=>{
        if (typeof WrappedComponent === 'string') return WrappedComponent;
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    };
    function $42e0672e5b4e2667$export$263352d59c0c5966(WrappedComponent) {
        const Component = (props)=>{
            const onClick = (0, (0, parcelRequire("21hik")).useLinkClicked)(props.onClick);
            const onMouseDown = (0, (0, parcelRequire("21hik")).useMouseDownEvent)(props.onMouseDown);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                onClick: onClick,
                onMouseDown: onMouseDown
            });
        };
        Component.displayName = `withLinkClickedEvent(${$42e0672e5b4e2667$var$getDisplayName(WrappedComponent)})`;
        return Component;
    }
});
parcelRegister("7uSTi", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$42f7f3d569f86126$export$3f2684e5d7cb1006);
    const $42f7f3d569f86126$var$result = {
        mac: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $42f7f3d569f86126$var$result.mac = /Mac/.test(navigator.platform);
        let ie = $42f7f3d569f86126$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $42f7f3d569f86126$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $42f7f3d569f86126$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $42f7f3d569f86126$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $42f7f3d569f86126$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $42f7f3d569f86126$var$result.android = /Android \d/.test(navigator.userAgent);
        $42f7f3d569f86126$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $42f7f3d569f86126$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $42f7f3d569f86126$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $42f7f3d569f86126$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $42f7f3d569f86126$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
    function $42f7f3d569f86126$export$3f2684e5d7cb1006() {
        return $42f7f3d569f86126$var$result;
    }
});
parcelRegister("21hik", function(module, exports) {
    $parcel$export(module.exports, "useLinkClicked", ()=>$3c2aa815c301c38a$export$5993d3ca6c85f774);
    $parcel$export(module.exports, "useMouseDownEvent", ()=>$3c2aa815c301c38a$export$df67f318ded0283c);
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $4XPSZ;
    var $3c2aa815c301c38a$export$81a5b494baf0f17c;
    (function(ClickButton) {
        ClickButton[ClickButton["Left"] = 0] = "Left";
        ClickButton[ClickButton["Middle"] = 1] = "Middle";
        ClickButton[ClickButton["Right"] = 2] = "Right";
    })($3c2aa815c301c38a$export$81a5b494baf0f17c || ($3c2aa815c301c38a$export$81a5b494baf0f17c = {}));
    const $3c2aa815c301c38a$export$5993d3ca6c85f774 = (handler, predicate)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((...args)=>{
            const [event] = args;
            handler?.apply(null, args);
            if (!predicate || predicate?.(event)) (0, (0, parcelRequire("4XPSZ")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            handler,
            predicate,
            createAnalyticsEvent
        ]);
    };
    const $3c2aa815c301c38a$var$isNotLeftClick = (event)=>event.button !== 0;
    const $3c2aa815c301c38a$export$df67f318ded0283c = (onMouseDown)=>{
        return $3c2aa815c301c38a$export$5993d3ca6c85f774(onMouseDown, $3c2aa815c301c38a$var$isNotLeftClick);
    };
});
parcelRegister("2E3bm", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$5979d3fbca32eee0$export$85183a312807388d);
    $parcel$export(module.exports, "context", ()=>$5979d3fbca32eee0$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "TrackQuickActionType", ()=>$5979d3fbca32eee0$export$72af824fa910c33e);
    $parcel$export(module.exports, "TrackQuickActionFailureReason", ()=>$5979d3fbca32eee0$export$c89e475f7f7174c2);
    $parcel$export(module.exports, "SmartLinkEvents", ()=>$5979d3fbca32eee0$export$b91e0203b928470c);
    $parcel$export(module.exports, "resolvedEvent", ()=>$5979d3fbca32eee0$export$e2e1bab8375c3115);
    $parcel$export(module.exports, "unresolvedEvent", ()=>$5979d3fbca32eee0$export$331b399cdebbb8d4);
    $parcel$export(module.exports, "invokeSucceededEvent", ()=>$5979d3fbca32eee0$export$237caeb1002642ba);
    $parcel$export(module.exports, "invokeFailedEvent", ()=>$5979d3fbca32eee0$export$ac488bf3e4c7f93);
    $parcel$export(module.exports, "connectSucceededEvent", ()=>$5979d3fbca32eee0$export$5f549b8ba38f19b1);
    $parcel$export(module.exports, "connectFailedEvent", ()=>$5979d3fbca32eee0$export$fdfcba182edbb89a);
    $parcel$export(module.exports, "trackAppAccountConnected", ()=>$5979d3fbca32eee0$export$27d8deca51e9575c);
    $parcel$export(module.exports, "trackAppAccountAuthStarted", ()=>$5979d3fbca32eee0$export$48e92e116e00d94c);
    $parcel$export(module.exports, "trackSmartLinkQuickActionStarted", ()=>$5979d3fbca32eee0$export$1c2a74fe02a8031b);
    $parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", ()=>$5979d3fbca32eee0$export$afbd6446c1c03a3e);
    $parcel$export(module.exports, "trackSmartLinkQuickActionFailed", ()=>$5979d3fbca32eee0$export$2706827739a8c50);
    $parcel$export(module.exports, "trackHoverCardResolutionStarted", ()=>$5979d3fbca32eee0$export$daa964b113be9527);
    $parcel$export(module.exports, "uiAuthEvent", ()=>$5979d3fbca32eee0$export$5318734335f1d8b8);
    $parcel$export(module.exports, "uiAuthAlternateAccountEvent", ()=>$5979d3fbca32eee0$export$14f2ce8523ccb652);
    $parcel$export(module.exports, "uiCardClickedEvent", ()=>$5979d3fbca32eee0$export$8b5d1f55370347a1);
    $parcel$export(module.exports, "uiIframeDwelledEvent", ()=>$5979d3fbca32eee0$export$6b045396616c2e9f);
    $parcel$export(module.exports, "uiIframeFocusedEvent", ()=>$5979d3fbca32eee0$export$93fa3246cf9e3b52);
    $parcel$export(module.exports, "uiActionClickedEvent", ()=>$5979d3fbca32eee0$export$e00b9d79d3367530);
    $parcel$export(module.exports, "uiClosedAuthEvent", ()=>$5979d3fbca32eee0$export$fe5b1f066ca3365d);
    $parcel$export(module.exports, "screenAuthPopupEvent", ()=>$5979d3fbca32eee0$export$69bb595db263d8ef);
    $parcel$export(module.exports, "uiRenderSuccessEvent", ()=>$5979d3fbca32eee0$export$bd308326cf1076aa);
    $parcel$export(module.exports, "uiRenderFailedEvent", ()=>$5979d3fbca32eee0$export$1543b6391f48a5e2);
    $parcel$export(module.exports, "uiHoverCardViewedEvent", ()=>$5979d3fbca32eee0$export$e80a2f97cccab3b1);
    $parcel$export(module.exports, "uiHoverCardDismissedEvent", ()=>$5979d3fbca32eee0$export$3d10c6f90bc461d3);
    $parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", ()=>$5979d3fbca32eee0$export$ad3275d7dff50d21);
    $parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", ()=>$5979d3fbca32eee0$export$925348ae8d2e0bf3);
    $parcel$export(module.exports, "chunkloadFailedEvent", ()=>$5979d3fbca32eee0$export$2b6bbed3753f06f9);
    $parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", ()=>$5979d3fbca32eee0$export$94c3643533642ab);
    $parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", ()=>$5979d3fbca32eee0$export$18dfe458db0b743d);
    $parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", ()=>$5979d3fbca32eee0$export$9a352e2e15b3de89);
    $parcel$export(module.exports, "uiServerActionClicked", ()=>$5979d3fbca32eee0$export$a66dc699502b5d28);
    var $ek9kg;
    var $4gJ7g;
    const $5979d3fbca32eee0$export$85183a312807388d = 'media';
    const $5979d3fbca32eee0$export$a078c61943f9dbbe = {
        componentName: 'smart-cards',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    var $5979d3fbca32eee0$export$72af824fa910c33e;
    (function(TrackQuickActionType) {
        TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    })($5979d3fbca32eee0$export$72af824fa910c33e || ($5979d3fbca32eee0$export$72af824fa910c33e = {}));
    var $5979d3fbca32eee0$export$c89e475f7f7174c2;
    (function(TrackQuickActionFailureReason) {
        TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
        TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
        TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    })($5979d3fbca32eee0$export$c89e475f7f7174c2 || ($5979d3fbca32eee0$export$c89e475f7f7174c2 = {}));
    const $5979d3fbca32eee0$export$bbd674aacb40a160 = {
        [(0, (0, parcelRequire("ek9kg")).SmartLinkActionType).FollowEntityAction]: 'Follow',
        [(0, (0, parcelRequire("ek9kg")).SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
        [(0, (0, parcelRequire("ek9kg")).SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
    };
    const $5979d3fbca32eee0$export$baf70a532f8c6fa6 = {
        [(0, (0, parcelRequire("ek9kg")).SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
        [(0, (0, parcelRequire("ek9kg")).SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
    };
    const $5979d3fbca32eee0$var$uiActionSubjectIds = {
        DownloadAction: 'downloadDocument',
        PreviewAction: 'invokePreviewScreen',
        ViewAction: 'shortcutGoToLink',
        StatusAction: 'issueStatusUpdate'
    };
    class $5979d3fbca32eee0$export$b91e0203b928470c {
        insertSmartLink(url, type, createAnalyticsEvent) {
            $5979d3fbca32eee0$export$2a123f7ee48a122c({
                action: 'inserted',
                actionSubject: 'smartLink',
                eventType: 'track',
                attributes: {
                    type: type
                },
                nonPrivacySafeAttributes: {
                    domainName: url
                }
            }, createAnalyticsEvent);
        }
    }
    const $5979d3fbca32eee0$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
        if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($5979d3fbca32eee0$export$85183a312807388d);
    };
    const $5979d3fbca32eee0$export$e2e1bab8375c3115 = (props)=>({
            action: 'resolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...props,
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe
            }
        });
    const $5979d3fbca32eee0$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
            action: 'unresolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                id: id,
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                ...definitionId ? {
                    definitionId: definitionId
                } : {},
                ...extensionKey ? {
                    extensionKey: extensionKey
                } : {},
                ...resourceType ? {
                    resourceType: resourceType
                } : {},
                ...destinationSubproduct ? {
                    destinationSubproduct: destinationSubproduct
                } : {},
                ...destinationProduct ? {
                    destinationProduct: destinationProduct
                } : {},
                ...location ? {
                    location: location
                } : {},
                reason: status,
                error: error ? {
                    message: error?.message,
                    kind: error?.kind,
                    type: error?.type
                } : undefined
            }
        });
    const $5979d3fbca32eee0$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("4gJ7g")).getMeasure)(id, 'resolved') : undefined;
        return {
            action: 'resolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                extensionKey: extensionKey,
                duration: measure?.duration
            }
        };
    };
    const $5979d3fbca32eee0$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("4gJ7g")).getMeasure)(id, 'errored') : undefined;
        return {
            action: 'unresolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                duration: measure?.duration,
                reason: reason
            }
        };
    };
    const $5979d3fbca32eee0$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connectSucceeded',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
            action: 'connectFailed',
            actionSubject: 'smartLink',
            actionSubjectId: reason,
            eventType: 'operational',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                reason: reason,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connected',
            actionSubject: 'applicationAccount',
            eventType: 'track',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
            action: 'authStarted',
            actionSubject: 'applicationAccount',
            eventType: 'track',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'started',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $5979d3fbca32eee0$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $5979d3fbca32eee0$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'success',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $5979d3fbca32eee0$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $5979d3fbca32eee0$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
            action: 'failed',
            actionSubject: 'smartLinkQuickAction',
            eventType: 'track',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                ...attributes,
                smartLinkActionType: $5979d3fbca32eee0$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
            }
        });
    const $5979d3fbca32eee0$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
            action: 'resolved',
            actionSubject: 'hoverCard',
            eventType: 'track',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                ...attributes,
                display: display
            }
        });
    const $5979d3fbca32eee0$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connectAccount',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $5979d3fbca32eee0$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'tryAnotherAccount',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $5979d3fbca32eee0$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                isModifierKeyPressed: isModifierKeyPressed,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $5979d3fbca32eee0$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
            action: 'dwelled',
            actionSubject: 'smartLinkIframe',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                dwellTime: dwellTime,
                dwellPercentVisible: dwellPercentVisible
            }
        });
    const $5979d3fbca32eee0$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
            action: 'focused',
            actionSubject: 'smartLinkIframe',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $5979d3fbca32eee0$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $5979d3fbca32eee0$var$uiActionSubjectIds[actionType],
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                display: display,
                actionType: actionType,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'closed',
            actionSubject: 'consentModal',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $5979d3fbca32eee0$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'consentModal',
            eventType: 'screen',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
            action: 'renderSuccess',
            actionSubject: 'smartLink',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display,
                canBeDatasource: canBeDatasource
            }
        });
    const $5979d3fbca32eee0$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'smartLink',
            action: 'renderFailed',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'viewed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $5979d3fbca32eee0$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'dismissed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                hoverTime: hoverTime,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $5979d3fbca32eee0$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'shortcutGoToLink',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod
            }
        });
    const $5979d3fbca32eee0$export$925348ae8d2e0bf3 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe
            }
        });
    const $5979d3fbca32eee0$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'chunkLoadFailed',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $5979d3fbca32eee0$export$94c3643533642ab = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusLozenge',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe
            }
        });
    const $5979d3fbca32eee0$export$18dfe458db0b743d = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusListItem',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe
            }
        });
    const $5979d3fbca32eee0$export$9a352e2e15b3de89 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusOpenPreview',
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe
            }
        });
    const $5979d3fbca32eee0$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $5979d3fbca32eee0$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
            eventType: 'ui',
            attributes: {
                ...$5979d3fbca32eee0$export$a078c61943f9dbbe
            }
        });
});
parcelRegister("ek9kg", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkActionType", ()=>$445392b9289d7225$export$6324b7946ad663e9);
    $parcel$export(module.exports, "InvokeError", ()=>$445392b9289d7225$export$d4d72202bff63658);
    var $445392b9289d7225$export$6324b7946ad663e9;
    (function(SmartLinkActionType) {
        SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
        SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
        SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
        SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    })($445392b9289d7225$export$6324b7946ad663e9 || ($445392b9289d7225$export$6324b7946ad663e9 = {}));
    class $445392b9289d7225$export$d4d72202bff63658 extends Error {
        constructor(message, errorCode){
            super(message);
            this.errorCode = errorCode;
        }
    }
});
parcelRegister("4gJ7g", function(module, exports) {
    $parcel$export(module.exports, "clearMarks", ()=>$a3953c0a508abdc0$export$1a717feb4df1a945);
    $parcel$export(module.exports, "clearMeasures", ()=>$a3953c0a508abdc0$export$de42547d395c8271);
    $parcel$export(module.exports, "getMeasure", ()=>$a3953c0a508abdc0$export$d6e97a903ae9a3aa);
    $parcel$export(module.exports, "mark", ()=>$a3953c0a508abdc0$export$bf7f2fce5c1cf636);
    $parcel$export(module.exports, "create", ()=>$a3953c0a508abdc0$export$185802fd694ee1f5);
    const $a3953c0a508abdc0$var$isPerformanceAPIAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType'
        ].every((api)=>!!performance[api]);
    };
    const $a3953c0a508abdc0$var$hasPerformanceAPIAvailable = $a3953c0a508abdc0$var$isPerformanceAPIAvailable();
    const $a3953c0a508abdc0$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
    const $a3953c0a508abdc0$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
    const $a3953c0a508abdc0$export$1a717feb4df1a945 = (id)=>{
        if ($a3953c0a508abdc0$var$hasPerformanceAPIAvailable) {
            const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
            marks.forEach((mark)=>performance.clearMarks(mark.name));
        }
    };
    const $a3953c0a508abdc0$export$de42547d395c8271 = (id)=>{
        if ($a3953c0a508abdc0$var$hasPerformanceAPIAvailable) {
            const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
            measures.forEach((measure)=>performance.clearMeasures(measure.name));
        }
    };
    const $a3953c0a508abdc0$var$getMark = (id, status)=>{
        if ($a3953c0a508abdc0$var$hasPerformanceAPIAvailable) {
            const name = $a3953c0a508abdc0$export$fcff3185c7ce7f2b(id, status);
            const marks = performance.getEntriesByName(name);
            if (marks.length > 0) return marks[0];
            return undefined;
        }
    };
    const $a3953c0a508abdc0$export$d6e97a903ae9a3aa = (id, status)=>{
        if ($a3953c0a508abdc0$var$hasPerformanceAPIAvailable) {
            const name = $a3953c0a508abdc0$export$984df7f61dd7928f(id, status);
            const measures = performance.getEntriesByName(name);
            if (measures.length > 0) return measures[0];
            return undefined;
        }
    };
    const $a3953c0a508abdc0$export$bf7f2fce5c1cf636 = (id, status)=>{
        if ($a3953c0a508abdc0$var$hasPerformanceAPIAvailable) {
            const name = $a3953c0a508abdc0$export$fcff3185c7ce7f2b(id, status);
            performance.mark(name);
        }
    };
    const $a3953c0a508abdc0$export$185802fd694ee1f5 = (id, status)=>{
        if ($a3953c0a508abdc0$var$hasPerformanceAPIAvailable) {
            const name = $a3953c0a508abdc0$export$984df7f61dd7928f(id, status);
            const measure = $a3953c0a508abdc0$export$d6e97a903ae9a3aa(id, status);
            if (!measure) {
                const startMark = $a3953c0a508abdc0$var$getMark(id, 'pending');
                const endMark = $a3953c0a508abdc0$var$getMark(id, status);
                if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
            }
        }
    };
});
parcelRegister("4AZ8t", function(module, exports) {
    $parcel$export(module.exports, "LinkAnalyticsContext", ()=>$1c51808c6cbddefd$export$9458cdec663b9ff1);
    var $5uXOq = parcelRequire("5uXOq");
    var $iJDK4;
    const $1c51808c6cbddefd$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
        const displayCategory = display === 'url' ? 'link' : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iJDK4")).default), {
            data: {
                source: source,
                attributes: {
                    displayCategory: displayCategory,
                    display: display,
                    id: id
                }
            }
        }, children);
    };
});
parcelRegister("2bBpZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a0877b6d984e1b0$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $8RXs9;
    var $i5FdW;
    var $2APCZ;
    var $bTmOP;
    var $2Yyer;
    var $4qSaV;
    var $i9cxd;
    var $2TrWf;
    var $4uJJm;
    var $eMzWj;
    var $frj8f;
    const $3a0877b6d984e1b0$var$WarningModal = (props)=>{
        const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4uJJm")).default), null, isOpen && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bTmOP")).default), {
            onClose: onClose,
            testId: "link-with-safety-warning"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i9cxd")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2TrWf")).default), {
            appearance: "warning"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("eMzWj")).messages).check_this_link))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2Yyer")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("frj8f")).breakWordsCss)
        }, url && unsafeLinkText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("eMzWj")).messages).link_safety_warning_message,
            values: {
                unsafeLinkText: unsafeLinkText,
                a: ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("a", {
                        href: url,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, url)
            }
        }))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4qSaV")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "subtle",
            onClick: onClose
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("eMzWj")).messages).go_back)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "warning",
            onClick: onContinue,
            autoFocus: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("eMzWj")).messages).continue)))));
        return intl ? content : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, content);
    };
    var $3a0877b6d984e1b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($3a0877b6d984e1b0$var$WarningModal, {
        enforceContext: false
    });
});
parcelRegister("eMzWj", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$52e8cd07a6eb6dee$export$defe85febe8b728c);
    var $7VHMR;
    const $52e8cd07a6eb6dee$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actions: {
            id: 'fabric.linking.actions',
            defaultMessage: 'Actions',
            description: ''
        },
        add_account: {
            id: 'fabric.linking.add_account',
            defaultMessage: 'Add account',
            description: 'Allows to add a new account'
        },
        ai_summarize: {
            id: 'fabric.linking.ai_summarize',
            defaultMessage: 'Summarize',
            description: 'Action to summarize link resource content with AI'
        },
        ai_summarized: {
            id: 'fabric.linking.ai_summarized',
            defaultMessage: 'Summarized by Atlassian Intelligence',
            description: 'Shown with the content summarised by AI.'
        },
        ai_summarized_abbreviation: {
            id: 'fabric.linking.ai_summarized_abbreviation',
            defaultMessage: 'Summarized by AI',
            description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
        },
        ai_summarized_info: {
            id: 'fabric.linking.ai_summarized_info',
            defaultMessage: 'Information quality may vary. <a>Learn more</a>',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarized_info_short: {
            id: 'fabric.linking.ai_summarized_info_short',
            defaultMessage: 'Content quality may vary',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarizing: {
            id: 'fabric.linking.ai_summarizing',
            defaultMessage: 'Atlassian Intelligence is working...',
            description: 'Shown when AI summary is summarising the link resource content.'
        },
        ai_summary_error_generic: {
            id: 'fabric.linking.ai_summary_error_generic',
            defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
            description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
        },
        ai_summary_error_acceptable_use_violation: {
            id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
            defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
            description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
        },
        ai_summary_error_hipaa_content_detected: {
            id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
            defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
            description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
        },
        ai_summary_error_exceeding_context_length_error: {
            id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
            defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
            description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
        },
        assigned_to: {
            id: 'fabric.linking.assigned_to',
            defaultMessage: 'Assigned to {context}',
            description: 'Indicates the person or entity that the resource is assigned to.'
        },
        automation_action_title: {
            id: 'fabric.linking.automation-action.title',
            defaultMessage: 'View automation rules...',
            description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
        },
        automation_action_icon_label: {
            id: 'fabric.linking.automation-action.icon.label',
            defaultMessage: 'Automation icon',
            description: 'The label for the automation icon inside of the button opening the automation menu.'
        },
        automation_action_tooltip: {
            id: 'fabric.linking.automation-action.tooltip',
            defaultMessage: 'Select an automation rule to run',
            description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
        },
        automation_action_confluence_page_modal_title: {
            id: 'fabric.linking.automation-action.confluence.page.modal.title',
            defaultMessage: 'Page automations',
            description: 'The title of the automation modal when the SmartLink is a Confluence page'
        },
        automation_action_confluence_page_modal_description: {
            id: 'fabric.linking.automation-action.confluence.page.modal.description',
            defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
            description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
        },
        cancel: {
            id: 'fabric.linking.cancel',
            defaultMessage: 'Cancel',
            description: 'cancel'
        },
        beta: {
            id: 'fabric.linking.beta',
            defaultMessage: 'Beta',
            description: 'Indicates a beta phase of the feature.'
        },
        cannot_connect: {
            id: 'fabric.linking.cannot_connect',
            defaultMessage: "Can't connect, try again",
            description: 'Error for when a provided link is not found.'
        },
        cannot_find_link: {
            id: 'fabric.linking.cannot_find_link',
            defaultMessage: "Can't find link",
            description: 'Error for when a provided link is not found.'
        },
        click_to_join: {
            id: 'fabric.linking.click_to_join',
            defaultMessage: 'Join {context}',
            description: 'Allows the user join the product or service immediately'
        },
        click_to_join_description: {
            id: 'fabric.linking.click_to_join_description',
            defaultMessage: "You've been approved, so you can join {context} right away.",
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        close: {
            id: 'fabric.linking.close',
            defaultMessage: 'Close',
            description: ''
        },
        check_this_link: {
            id: 'fabric.linking.check_this_link',
            defaultMessage: 'Check this link',
            description: 'Link safety warning modal header'
        },
        connect_to: {
            id: 'fabric.linking.connect_to',
            defaultMessage: 'Connect to {name}',
            description: 'Allows the user to connect with different types of external services'
        },
        connect_account_description: {
            id: 'fabric.linking.connect_account_description',
            defaultMessage: "We'll open a new page to help you connect your {name} account",
            description: 'Explains what will happen when the users connects to a new account'
        },
        connect_link_account: {
            id: 'fabric.linking.connect_link_account',
            defaultMessage: 'Connect to preview',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
        },
        connect_link_account_card: {
            id: 'fabric.linking.connect_link_account_card_view',
            defaultMessage: 'Connect',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_link_account_card_name: {
            id: 'fabric.linking.connect_link_account_card_view_name',
            defaultMessage: 'Connect your {context} account',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
        },
        connect_link_account_card_description: {
            id: 'fabric.linking.connect_link_account_card_view_description',
            defaultMessage: 'To show a preview of this link, connect your {context} account.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
        },
        connect_unauthorised_account_action: {
            id: 'fabric.linking.connect_unauthorised_account_action',
            defaultMessage: 'Connect to {context}',
            description: 'Shown on a button to connect user external account to their Atlassian account.'
        },
        connect_unauthorised_account_description: {
            id: 'fabric.linking.connect_unauthorised_account_description',
            defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_unauthorised_account_description_no_provider: {
            id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
            defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
        },
        continue: {
            id: 'fabric.linking.continue',
            defaultMessage: 'Continue',
            description: 'continue'
        },
        copy_url_to_clipboard: {
            id: 'fabric.linking.copy_url_to_clipboard',
            defaultMessage: 'Copy link',
            description: ''
        },
        copied_url_to_clipboard: {
            id: 'fabric.linking.copied_url_to_clipboard',
            defaultMessage: 'Copied!',
            description: 'Url has been copied to the clipboard'
        },
        could_not_load_link: {
            id: 'fabric.linking.couldnt_load_link',
            defaultMessage: "We couldn't load this link for an unknown reason.",
            description: 'Error case for card view - link could not be loaded.'
        },
        created_by: {
            id: 'fabric.linking.created_by',
            defaultMessage: 'Created by {context}',
            description: 'Indicates the person or entity that created the resource.'
        },
        created_on_relative: {
            id: 'fabric.linking.create_on_relative',
            defaultMessage: 'Created {context}',
            description: 'Indicated when entity was created (relative form)'
        },
        created_on_absolute: {
            id: 'fabric.linking.create_on_absolute',
            defaultMessage: 'Created on {context}',
            description: 'Indicated when entity was created (absolute form)'
        },
        delete: {
            id: 'fabric.linking.delete',
            defaultMessage: 'Delete',
            description: 'Allow a user to delete a link'
        },
        download: {
            id: 'fabric.linking.download',
            defaultMessage: 'Download',
            description: ''
        },
        download_description: {
            id: 'fabric.linking.download_description',
            defaultMessage: 'Download this file into your local storage',
            description: 'Description on what Download does'
        },
        download_file: {
            id: 'fabric.linking.download_file',
            defaultMessage: 'Download file',
            description: 'Allow a user to download a file'
        },
        ai_summary_action: {
            id: 'fabric.linking.ai_summary_action',
            defaultMessage: 'Summarize with AI',
            description: 'Allow a user to summarize a link'
        },
        ai_summary_action_description: {
            id: 'fabric.linking.ai_summary_action_description',
            defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
            description: 'Description of what the summarize link with AI action does'
        },
        copy_summary_action: {
            id: 'fabric.linking.copy_summary_action',
            defaultMessage: 'Copy summary',
            description: 'Allow a user to copy a generated summary'
        },
        copy_summary_action_description: {
            id: 'fabric.linking.copy_summary_action_description',
            defaultMessage: 'Copy summary',
            description: 'Description of what the copy summary AI action does'
        },
        copied_summary_action_description: {
            id: 'fabric.linking.copied_summary_action_description',
            defaultMessage: 'Copied summary to clipboard',
            description: 'Confirmation to the user that the summry has been copied'
        },
        edit: {
            id: 'fabric.linking.edit',
            defaultMessage: 'Edit',
            description: 'Allow a user to edit a link'
        },
        follow: {
            id: 'fabric.linking.follow',
            defaultMessage: 'Follow',
            description: 'Click to follow a project.'
        },
        follow_project_description: {
            id: 'fabric.linking.follow_project_description',
            defaultMessage: 'Follow to get notifications on this project',
            description: 'Description on what Follow does'
        },
        follow_project: {
            id: 'fabric.linking.follow_project',
            defaultMessage: 'Follow project',
            description: 'Click to follow a project.'
        },
        follow_project_error: {
            id: 'fabric.linking.follow_project_error',
            defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas project'
        },
        follow_goal_description: {
            id: 'fabric.linking.follow_goal_description',
            defaultMessage: 'Follow this goal to get notifications on updates',
            description: 'Description on what Follow does'
        },
        follow_goal: {
            id: 'fabric.linking.follow_goal',
            defaultMessage: 'Follow goal',
            description: 'Click to follow a project.'
        },
        follow_goal_error: {
            id: 'fabric.linking.follow_goal_error',
            defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas goal'
        },
        go_back: {
            id: 'fabric.linking.go_back',
            defaultMessage: 'Go back',
            description: 'go back'
        },
        invalid_permissions: {
            id: 'fabric.linking.invalid_permissions',
            defaultMessage: 'Restricted content',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        invalid_permissions_description: {
            id: 'fabric.linking.invalid_permissions_description',
            defaultMessage: "You'll need to request access or try a different account to view this preview.",
            description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
        },
        join_to_view: {
            id: 'fabric.linking.join_to_view',
            defaultMessage: 'Join {context} to view this issue',
            description: 'Allows the user join the product or service immediately'
        },
        learn_more_about_smart_links: {
            id: 'fabric.linking.learn_more_about_smart_links',
            defaultMessage: 'Learn more about Smart Links.',
            description: 'An anchor link to redirect user to a page about Smart Links.'
        },
        learn_more_about_connecting_account: {
            id: 'fabric.linking.learn_more_about_connecting_account',
            defaultMessage: 'Learn more about connecting your account to Atlassian products.',
            description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
        },
        loading: {
            id: 'fabric.linking.loading',
            defaultMessage: 'Loading...',
            description: 'Indicates an element on a page is loading.'
        },
        modified_by: {
            id: 'fabric.linking.updated_by',
            defaultMessage: 'Modified by {context}',
            description: 'Indicates the person or entity that modified the resource.'
        },
        modified_on_relative: {
            id: 'fabric.linking.modified_on_relative',
            defaultMessage: 'Updated {context}',
            description: 'Indicated when entity was modified (relative form)'
        },
        modified_on_absolute: {
            id: 'fabric.linking.modified_on_absolute',
            defaultMessage: 'Updated on {context}',
            description: 'Indicated when entity was modified (absolute form)'
        },
        more_actions: {
            id: 'fabric.linking.more_actions',
            defaultMessage: 'More actions',
            description: 'Allows the users to see more link actions'
        },
        open_issue_in_jira: {
            id: 'fabric.linking.open_issue_in_jira',
            defaultMessage: 'Open issue in Jira',
            description: 'Click to open link in Jira'
        },
        open_link_in_a_new_tab: {
            id: 'fabric.linking.open_link_in_a_new_tab',
            defaultMessage: 'Open link in a new tab',
            description: 'Click to open link in a new tab'
        },
        owned_by: {
            id: 'fabric.linking.owned_by',
            defaultMessage: 'Owned by {context}',
            description: 'Indicates the person or entity that owns or maintains the resource.'
        },
        preview_description: {
            id: 'fabric.linking.preview_description',
            defaultMessage: 'Open a full screen preview of this link',
            description: 'Description on what Preview does'
        },
        preview_improved: {
            id: 'fabric.linking.preview_improved',
            defaultMessage: 'Open preview',
            description: 'Click to view a richer view of your content, without needing to navigate to it.'
        },
        preview_close: {
            id: 'fabric.linking.preview_close',
            defaultMessage: 'Close preview',
            description: 'Click to close embed preview modal.'
        },
        preview_max_size: {
            id: 'fabric.linking.preview_max_size',
            defaultMessage: 'View full screen',
            description: 'Click to increase embed preview modal size to a maximum viewing size.'
        },
        preview_min_size: {
            id: 'fabric.linking.preview_min_size',
            defaultMessage: 'Close full screen',
            description: 'Click to decrease embed preview modal size to a minimum viewing size.'
        },
        priority_blocker: {
            id: 'fabric.linking.priority_blocker',
            defaultMessage: 'Blocker',
            description: 'Indicated priority as blocker'
        },
        priority_critical: {
            id: 'fabric.linking.priority_critical',
            defaultMessage: 'Critical',
            description: 'Indicated priority as critical'
        },
        priority_high: {
            id: 'fabric.linking.priority_high',
            defaultMessage: 'High',
            description: 'Indicated priority as high'
        },
        priority_highest: {
            id: 'fabric.linking.priority_highest',
            defaultMessage: 'Highest',
            description: 'Indicated priority as highest'
        },
        priority_low: {
            id: 'fabric.linking.priority_low',
            defaultMessage: 'Low',
            description: 'Indicated priority as low'
        },
        priority_lowest: {
            id: 'fabric.linking.priority_lowest',
            defaultMessage: 'Lowest',
            description: 'Indicated priority as lowest'
        },
        priority_major: {
            id: 'fabric.linking.priority_major',
            defaultMessage: 'Major',
            description: 'Indicated priority as major'
        },
        priority_medium: {
            id: 'fabric.linking.priority_medium',
            defaultMessage: 'Medium',
            description: 'Indicated priority as medium'
        },
        priority_minor: {
            id: 'fabric.linking.priority_minor',
            defaultMessage: 'Minor',
            description: 'Indicated priority as minor'
        },
        priority_trivial: {
            id: 'fabric.linking.priority_trivial',
            defaultMessage: 'Trivial',
            description: 'Indicated priority as trivial'
        },
        priority_undefined: {
            id: 'fabric.linking.priority_undefined',
            defaultMessage: 'Undefined',
            description: 'Indicated priority as unknown'
        },
        forbidden_access: {
            id: 'fabric.linking.forbidden_access',
            defaultMessage: 'Your access is forbidden',
            description: 'Shown when a user does not have access to a resource behind the link.'
        },
        pending_request: {
            id: 'fabric.linking.pending_request',
            defaultMessage: 'Your access request is pending',
            description: 'Shown when a user has requested an access but status is pending.'
        },
        read_time: {
            id: 'fabric.linking.read_time',
            defaultMessage: '{context} min read',
            description: 'Estimated time to read this resource'
        },
        restricted_link: {
            id: 'fabric.linking.restricted_link',
            defaultMessage: 'Restricted link, try another account',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        request_access_to_view: {
            id: 'fabric.linking.request_access_to_view',
            defaultMessage: 'Request access to {context} to view this issue',
            description: 'Allows the user to request access to a product or service'
        },
        request_denied: {
            id: 'fabric.linking.request_denied',
            defaultMessage: 'Your access request was denied',
            description: 'The user had request access but the request was denied by a product or service'
        },
        retry: {
            id: 'fabric.linking.retry',
            defaultMessage: 'Retry',
            description: 'Allows user to perform an action again'
        },
        save: {
            id: 'fabric.linking.save',
            defaultMessage: 'Save',
            description: 'Just the "save" word'
        },
        sent_on_relative: {
            id: 'fabric.linking.sent_on_relative',
            defaultMessage: 'Sent {context}',
            description: 'Indicated when entity was sent (relative form)'
        },
        sent_on_absolute: {
            id: 'fabric.linking.sent_on_absolute',
            defaultMessage: 'Sent on {context}',
            description: 'Indicated when entity was sent (absolute form)'
        },
        status_change_load_error: {
            id: 'fabric.linking.status_change_load_error',
            defaultMessage: "We couldn\u2019t load the statuses and transitions",
            description: 'Informs the user that the loading of status transitions failed'
        },
        status_change_permission_error: {
            id: 'fabric.linking.status_change_permission_error',
            defaultMessage: "You don\u2019t have permission to transition this issue. ",
            description: 'Informs the user that they do not have enough permissions to update a status'
        },
        status_change_update_error: {
            id: 'fabric.linking.status_change_update_error',
            defaultMessage: "We couldn\u2019t update the status",
            description: "Occurs when a user tries to update an issue's status but fails to do so"
        },
        try_again: {
            id: 'fabric.linking.try_again',
            defaultMessage: 'Try again',
            description: 'Allow the user to try an action again'
        },
        try_another_account: {
            id: 'fabric.linking.try_another_account',
            defaultMessage: 'Try another account',
            description: 'Allows the user to try an action again with a different account'
        },
        link_safety_warning_message: {
            id: 'fabric.linking.link_safety_warning_message',
            defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
            description: 'Link safety check warning message'
        },
        unauthorised_account_description: {
            id: 'fabric.linking.unauthorised_account_description',
            defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_description_no_provider: {
            id: 'fabric.linking.unauthorised_account_description_no_provider',
            defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_name: {
            id: 'fabric.linking.unauthorised_account_name',
            defaultMessage: "We can't display private pages from {context}",
            description: 'Shown when a user does not have access to a link.'
        },
        unauthorised_account_name_no_provider: {
            id: 'fabric.linking.unauthorised_account_name_no_provider',
            defaultMessage: "We can't display private pages",
            description: 'Shown when a user does not have access to a link.'
        },
        unassigned: {
            id: 'fabric.linking.unassigned',
            defaultMessage: 'Unassigned',
            description: 'Shown as a tooltip text for a default unassigned fallback avatar'
        },
        unfollow: {
            id: 'fabric.linking.unfollow',
            defaultMessage: 'Unfollow',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_description: {
            id: 'fabric.linking.unfollow_project_description',
            defaultMessage: 'Unfollow to stop receiving project notifications',
            description: 'Description on what Unfollow does'
        },
        unfollow_project: {
            id: 'fabric.linking.unfollow_project',
            defaultMessage: 'Unfollow project',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_error: {
            id: 'fabric.linking.unfollow_project_error',
            defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
        },
        unfollow_goal_description: {
            id: 'fabric.linking.unfollow_goal_description',
            defaultMessage: 'Unfollow to stop receiving notifications for this goal',
            description: 'Description on what Unfollow does'
        },
        unfollow_goal: {
            id: 'fabric.linking.unfollow_goal',
            defaultMessage: 'Unfollow goal',
            description: 'Click to unfollow a project.'
        },
        unfollow_goal_error: {
            id: 'fabric.linking.unfollow_goal_error',
            defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
        },
        unlink_account: {
            id: 'fabric.linking.unlink_account',
            defaultMessage: 'Unlink Account',
            description: 'Allows to remove a connected account from the user'
        },
        view: {
            id: 'fabric.linking.view',
            defaultMessage: 'View',
            description: 'Go through to a piece of content to view it in its original context.'
        },
        viewIn: {
            id: 'fabric.linking.srclink',
            defaultMessage: 'View in',
            description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
        },
        viewOriginal: {
            id: 'fabric.linking.srclinkunknown',
            defaultMessage: 'View Original',
            description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
        },
        default_no_access_title: {
            id: 'fabric.linking.no_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they dont have access to certain content'
        },
        direct_access_title: {
            id: 'fabric.linking.direct_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access_description: {
            id: 'fabric.linking.direct_access_description',
            defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access: {
            id: 'fabric.linking.direct_access',
            defaultMessage: 'Join now',
            description: 'Allows the user join the product or service immediately'
        },
        request_access_description: {
            id: 'fabric.linking.request_access_description',
            defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
            description: 'Informs the user to request access to a product by talking to the website administrator'
        },
        request_access: {
            id: 'fabric.linking.request_access',
            defaultMessage: 'Request access',
            description: 'Allows the user to request access to a product or service'
        },
        request_access_pending_title: {
            id: 'fabric.linking.request_access_pending_title',
            defaultMessage: 'Access to {product} is pending',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_access_pending_description: {
            id: 'fabric.linking.request_access_pending_description',
            defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
            description: 'Informs the user that their request to view this content is pending website administrator approval'
        },
        request_access_pending: {
            id: 'fabric.linking.request_access_pending',
            defaultMessage: 'Pending approval',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_denied_description: {
            id: 'fabric.linking.request_denied_description',
            defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
            description: 'Informs the user that their request to view this content was denied'
        },
        access_exists_description: {
            id: 'fabric.linking.access_exists_description',
            defaultMessage: 'Request access to view this content from {hostname}.',
            description: 'Informs the user to contact the website administrator to request access to a product'
        },
        not_found_description: {
            id: 'fabric.linking.not_found_description',
            defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
            description: 'Error case for when a provided item is not found within the list of items'
        },
        not_found_title: {
            id: 'fabric.linking.not_found_title',
            defaultMessage: "We can't show you this {product} page",
            description: 'Error case for when a provided link is not found'
        },
        forbidden_title: {
            id: 'fabric.linking.forbidden_title',
            defaultMessage: "You don't have access to this content",
            description: 'Informs the user that they do not have access to the linked content.'
        },
        forbidden_description: {
            id: 'fabric.linking.forbidden_description',
            defaultMessage: 'Contact your admin to request access to {hostname}.',
            description: 'Informs the user that they must contact the site administrator for access.'
        },
        related_work_items_not_found: {
            id: 'fabric.linking.related_work_items_not_found',
            defaultMessage: 'This link is not mentioned anywhere else.',
            description: 'Informs the user that there are no related resources for a given url'
        },
        last_mentioned_in: {
            id: 'fabric.linking.last_mentioned_in',
            defaultMessage: 'Last mentioned in',
            description: 'Informs the user about where the resource was last mentioned in'
        },
        related: {
            id: 'fabric.linking.related',
            defaultMessage: 'Related',
            description: 'Informs the user about related resources'
        },
        generic_error_message: {
            id: 'fabric.linking.generic_error_message',
            defaultMessage: 'An error occurred',
            description: 'A generic error message to the user'
        },
        related_links_modal_title: {
            id: 'fabric.linking.related_links_modal_title',
            defaultMessage: 'Recent links',
            description: 'Shown as the title for the related links modal'
        },
        related_links_view_related_urls: {
            id: 'fabric.linking.related_links_view_related_urls.nonfinal',
            defaultMessage: 'View recent links...',
            description: 'Action to view related links to the given resource'
        },
        related_links_found_in: {
            id: 'fabric.linking.related_links_found_in',
            defaultMessage: 'Found In',
            description: 'Informs the user of the resources are found in the given url'
        },
        related_links_not_found: {
            id: 'fabric.linking.related_links_not_found',
            defaultMessage: "We didn't find any links to show here.",
            description: 'Informs the user that there are no related resources for the given url'
        },
        related_links_includes_links_to: {
            id: 'fabric.linking.related_links_includes_links_to',
            defaultMessage: 'Includes Links To',
            description: 'Informs the user of the resources the url links to'
        },
        related_links_modal_error_header: {
            id: 'fabric.linking.related_links_modal_error_header',
            defaultMessage: 'Something went wrong',
            description: 'Title for related links error'
        },
        related_links_modal_error_message: {
            id: 'fabric.linking.related_links_modal_error_message',
            defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
            description: 'Informs the user that there was a problem loading related links'
        },
        related_links_modal_unavailable_header: {
            id: 'fabric.linking.related_links_modal_unavailable_header',
            defaultMessage: 'No recent links',
            description: 'Title for related links being unavailable'
        },
        related_links_modal_unavailable_message: {
            id: 'fabric.linking.related_links_modal_unavailable_message',
            defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
            description: 'Informs the user that related links were not found but may be available in the future'
        }
    });
});
parcelRegister("frj8f", function(module, exports) {
    $parcel$export(module.exports, "breakWordsCss", ()=>$bd5f477e395be154$export$e4dda5b86d39ace5);
    function $bd5f477e395be154$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bd5f477e395be154$export$e4dda5b86d39ace5 = {
        name: "1ujvzzx",
        styles: "white-space:pre-line;word-break:break-all"
    };
});
parcelRegister("1J5tM", function(module, exports) {
    $parcel$export(module.exports, "useLinkWarningModal", ()=>$95ac944d91b216bf$export$32b76c003683c2ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $fSxw1;
    var $2E3bm;
    const $95ac944d91b216bf$var$toUrl = (url, base)=>{
        try {
            return new URL(url, base);
        } catch  {
            return undefined;
        }
    };
    const $95ac944d91b216bf$export$32b76c003683c2ec = ()=>{
        const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
        const [url, setUrl] = (0, $5uXOq.useState)(null);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const sendWarningModalViewedEvent = ()=>{
            createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'linkSafetyWarningModal',
                eventType: 'screen',
                name: 'linkSafetyWarningModal'
            }).fire((0, (0, parcelRequire("2E3bm")).ANALYTICS_CHANNEL));
        };
        const sendContinueClickedEvent = ()=>{
            createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'linkSafetyWarningModalContinue',
                eventType: 'ui',
                screen: 'linkSafetyWarningModal'
            }).fire((0, (0, parcelRequire("2E3bm")).ANALYTICS_CHANNEL));
        };
        const isLinkSafe = (event, href)=>{
            if (!href) return true;
            const anchor = event.currentTarget;
            const linkText = anchor.innerText;
            const normalisedUrlFromLinkText = (0, (0, parcelRequire("fSxw1")).normalizeUrl)(linkText);
            if (!normalisedUrlFromLinkText) return true;
            const anchorLinkRegex = new RegExp(/^#/im);
            const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
            const isAnchorLink = anchorLinkRegex.test(href);
            if (isAnchorLink || isLinkTextAnchorLink) return true;
            const relativeLinkRegex = new RegExp(/^\//im);
            const isRelativeHrefLink = relativeLinkRegex.test(href);
            if (isRelativeHrefLink) return true;
            const hrefUrl = $95ac944d91b216bf$var$toUrl(href, window.location.origin);
            const linkTextUrl = $95ac944d91b216bf$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
            if (!hrefUrl || !linkTextUrl) return true;
            const httpProtocols = [
                'http:',
                'https:'
            ];
            let areProtocolsEquivalent;
            if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
                const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
                areProtocolsEquivalent = noUserNameAndPassword;
            } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
            const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
            if (!areEquivalentLinks) return false;
            return true;
        };
        const showSafetyWarningModal = (event, href)=>{
            event.preventDefault();
            const anchor = event.currentTarget;
            const linkText = anchor.innerText;
            setUnsafeLinkText(linkText);
            href && setUrl(href);
            setIsOpen(true);
            sendWarningModalViewedEvent();
        };
        const onClose = ()=>{
            setIsOpen(false);
            setUnsafeLinkText(null);
            setUrl(null);
        };
        const onContinue = ()=>{
            onClose();
            sendContinueClickedEvent();
            url && window.open(url, '_blank', 'noopener noreferrer');
        };
        return {
            isLinkSafe: isLinkSafe,
            isOpen: isOpen,
            onClose: onClose,
            onContinue: onContinue,
            showSafetyWarningModal: showSafetyWarningModal,
            unsafeLinkText: unsafeLinkText,
            url: url
        };
    };
});
parcelRegister("fSxw1", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$dcaa1c26a26f119d$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "normalizeUrl", ()=>$dcaa1c26a26f119d$export$6535eb414fa2c8b6);
    var $e2gHg = parcelRequire("e2gHg");
    const $dcaa1c26a26f119d$var$linkify = (0, ($parcel$interopDefault($e2gHg)))();
    $dcaa1c26a26f119d$var$linkify.add('sourcetree:', 'http:');
    $dcaa1c26a26f119d$var$linkify.add('jamfselfservice:', 'http:');
    $dcaa1c26a26f119d$var$linkify.add('notes:', 'http:');
    const $dcaa1c26a26f119d$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $dcaa1c26a26f119d$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $dcaa1c26a26f119d$var$tlds.push($dcaa1c26a26f119d$var$tlds2Char);
    $dcaa1c26a26f119d$var$linkify.tlds($dcaa1c26a26f119d$var$tlds, false);
    const $dcaa1c26a26f119d$var$whitelistedURLPatterns = [
        /^https?:\/\/[^\s]*$/im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\/[^\s]*$/im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:[^\s]*$/im,
        /^facetime:[^\s]*$/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^foo:/im,
        /^#/im
    ];
    const $dcaa1c26a26f119d$var$normaliseLinkHref = (url)=>{
        const match = $dcaa1c26a26f119d$var$getLinkMatch(url);
        return match && match.url || null;
    };
    const $dcaa1c26a26f119d$var$getLinkMatch = (str)=>{
        if (!str) return null;
        let match = $dcaa1c26a26f119d$var$linkifyMatch(str);
        if (!match.length) match = $dcaa1c26a26f119d$var$linkify.match(str);
        return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
    };
    const $dcaa1c26a26f119d$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $dcaa1c26a26f119d$var$linkifyMatch = (text)=>{
        const matches = [];
        if (!$dcaa1c26a26f119d$var$LINK_REGEXP.test(text)) return matches;
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($dcaa1c26a26f119d$var$LINK_REGEXP) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($dcaa1c26a26f119d$var$LINK_REGEXP);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    const $dcaa1c26a26f119d$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        return $dcaa1c26a26f119d$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    function $dcaa1c26a26f119d$export$6535eb414fa2c8b6(url) {
        if (!url) return '';
        const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
        if ($dcaa1c26a26f119d$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
        return $dcaa1c26a26f119d$var$normaliseLinkHref(urlWithoutNewlines);
    }
});
parcelRegister("e2gHg", function(module, exports) {
    'use strict';
    function $a37e3434b26d3f31$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $a37e3434b26d3f31$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $a37e3434b26d3f31$var$isString(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
    }
    function $a37e3434b26d3f31$var$isObject(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
    }
    function $a37e3434b26d3f31$var$isRegExp(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
    }
    function $a37e3434b26d3f31$var$isFunction(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
    }
    function $a37e3434b26d3f31$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $a37e3434b26d3f31$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $a37e3434b26d3f31$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $a37e3434b26d3f31$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $a37e3434b26d3f31$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $a37e3434b26d3f31$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $a37e3434b26d3f31$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $a37e3434b26d3f31$var$compile(self) {
        var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($a37e3434b26d3f31$var$isObject(val)) {
                if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
                else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($a37e3434b26d3f31$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $a37e3434b26d3f31$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($a37e3434b26d3f31$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
        $a37e3434b26d3f31$var$resetScanCache(self);
    }
    function $a37e3434b26d3f31$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $a37e3434b26d3f31$var$createMatch(self, shift) {
        var match = new $a37e3434b26d3f31$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $a37e3434b26d3f31$var$compile(this);
    }
    $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($a37e3434b26d3f31$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($a37e3434b26d3f31$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $a37e3434b26d3f31$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $a37e3434b26d3f31$var$compile(this);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $a37e3434b26d3f31$var$LinkifyIt;
});
parcelRegister("d5qnw", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + ';(?!' + re.src_ZCc + ').|' + '\\!+(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("l3Btm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060dd7ef935b7102$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $060dd7ef935b7102$export$2e2bcd8739ae039(props) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            style: {
                textDecoration: 'line-through'
            }
        }, props.children));
    }
});
parcelRegister("9jIsx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$566247665082f7d1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $566247665082f7d1$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("strong", props.dataAttributes, props.children);
    }
});
parcelRegister("ag6sP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44727defc94f0438$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $44727defc94f0438$var$isSub = (type)=>{
        return type === 'sub';
    };
    function $44727defc94f0438$export$2e2bcd8739ae039(props) {
        if ($44727defc94f0438$var$isSub(props.type)) return (0, ($parcel$interopDefault($5uXOq))).createElement("sub", props.dataAttributes, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("sup", props.dataAttributes, props.children);
    }
});
parcelRegister("j6ESF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$556919a0b38f09fe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $56Mai;
    var $hmJa1;
    function $556919a0b38f09fe$export$2e2bcd8739ae039(props) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hmJa1")).default)();
        let paletteColorValue;
        const tokenColor = (0, (0, parcelRequire("56Mai")).hexToEditorTextPaletteColor)(props.color);
        if (tokenColor) paletteColorValue = (0, (0, parcelRequire("56Mai")).hexToEditorTextPaletteColor)(props.color) || props.color;
        else if (colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(props.color);
        else paletteColorValue = props.color;
        const style = (0, $5uXOq.useMemo)(()=>({
                ['--custom-palette-color']: paletteColorValue
            }), [
            paletteColorValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            "data-text-custom-color": props.color,
            className: "fabric-text-color-mark",
            style: style
        }, props.children);
    }
});
parcelRegister("56Mai", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorTextPaletteColor", ()=>$812b2834ff33b9c7$export$9c2f408d391feb93);
    function $812b2834ff33b9c7$export$9c2f408d391feb93(hexColor) {
        return $812b2834ff33b9c7$export$57fa5089caad992[hexColor.toUpperCase()];
    }
    const $812b2834ff33b9c7$export$57fa5089caad992 = {
        ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
        ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
        ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
        ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
        ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
        ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
        ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
        ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
        ['#006644']: "var(--ds-text-accent-green, #006644)",
        ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
        ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
        ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
        ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
        ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
        ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
        ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
        ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
        ['#403294']: "var(--ds-text-accent-purple, #403294)",
        ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
        ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
        ['#172B4D']: "var(--ds-text, #172B4D)"
    };
});
parcelRegister("kDIMM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$594569a32115a41f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $2cipp;
    var $hmJa1;
    function $594569a32115a41f$export$2e2bcd8739ae039(props) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hmJa1")).default)();
        let paletteColorValue;
        const tokenColor = (0, (0, parcelRequire("2cipp")).hexToEditorTextBackgroundPaletteColor)(props.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if (colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(props.color);
        else paletteColorValue = props.color;
        const style = (0, $5uXOq.useMemo)(()=>({
                ['--custom-palette-color']: paletteColorValue
            }), [
            paletteColorValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            "data-background-custom-color": props.color,
            className: "fabric-background-color-mark",
            style: style
        }, props.children);
    }
});
parcelRegister("2cipp", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", ()=>$b48f146263c7954d$export$8b58ff1b36bb75e0);
    const $b48f146263c7954d$export$12a518ff137dd389 = {
        ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    };
    function $b48f146263c7954d$export$8b58ff1b36bb75e0(hexColor) {
        return $b48f146263c7954d$export$12a518ff137dd389[hexColor.toUpperCase()];
    }
});
parcelRegister("iV0Ik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dac393d2c1a8c2f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $1dac393d2c1a8c2f$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("u", props.dataAttributes, props.children);
    }
});
parcelRegister("jfdf8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14ab2ccc033c5224$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $caFD8;
    var $9N9gL;
    var $70yok;
    var $2oS3b;
    const $14ab2ccc033c5224$var$wrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${(0, (0, parcelRequire("70yok")).blockNodesVerticalMargin)} 0`,
        marginLeft: '50%',
        transform: 'translateX(-50%)'
    });
    function $14ab2ccc033c5224$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("caFD8")).WidthConsumer), null, ({ width: width })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $14ab2ccc033c5224$var$wrapperStyles,
                "data-mode": props.mode,
                style: {
                    width: (0, (0, parcelRequire("2oS3b")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? (0, (0, parcelRequire("9N9gL")).calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : (0, (0, parcelRequire("9N9gL")).calcBreakoutWidth)(props.mode, width)
                },
                className: "fabric-editor-breakout-mark fabric-editor-block-mark"
            }, props.children));
    }
});
parcelRegister("eWnSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff82170d9b1a9044$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $aeGrH;
    const $ff82170d9b1a9044$var$MarkWrapper = (props)=>{
        const styles = props['data-align'] ? (0, (0, parcelRequire("f8Sb3")).css)("text-align:", (0, (0, parcelRequire("aeGrH")).alignmentPositionMap)[props['data-align']], ";") : '';
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles,
            ...props
        }, props.children));
    };
    function $ff82170d9b1a9044$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($ff82170d9b1a9044$var$MarkWrapper, {
            className: "fabric-editor-block-mark fabric-editor-alignment",
            "data-align": props.align
        }, props.children);
    }
});
parcelRegister("iqj4v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$468ad46285614793$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $468ad46285614793$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "fabric-editor-block-mark fabric-editor-indentation-mark",
            "data-level": props.level
        }, props.children);
    }
});
parcelRegister("e6uLQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$130e4fde885e8290$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $130e4fde885e8290$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
    }
});
parcelRegister("g8egj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05866d6706587f20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $05866d6706587f20$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
    }
});
parcelRegister("hFru6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bad7ea6a24c1b48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $6bad7ea6a24c1b48$export$2e2bcd8739ae039(props) {
        const WrapperElement = props.isInline ? 'span' : 'div';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
            "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
            "data-mark-type": "dataConsumer",
            ...props.dataAttributes
        }, props.children);
    }
});
parcelRegister("ciRQw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a48a6634a30b4400$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $a48a6634a30b4400$export$2e2bcd8739ae039(props) {
        const WrapperElement = props.isInline ? 'span' : 'div';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
            "data-localId": props.localId,
            "data-name": props.name,
            "data-mark-type": "fragment",
            ...props.dataAttributes
        }, props.children);
    }
});
parcelRegister("cnXKU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff283dbbe65b21f3$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ff283dbbe65b21f3$export$2e2bcd8739ae039(props) {
        const borderColor = props.color ?? '';
        const borderSize = props.size ?? 0;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-color": borderColor,
            "data-size": borderSize,
            "data-mark-type": "border"
        }, props.children);
    }
});
parcelRegister("aNTft", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb75c8cc431f47de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $fb75c8cc431f47de$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { reference: reference, children: children } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": reference
            }, children);
        }
    }
});
parcelRegister("fxgxP", function(module, exports) {
    $parcel$export(module.exports, "getMarksByOrder", ()=>$8d06b00056a4837e$export$99a33ed044c278ae);
    $parcel$export(module.exports, "isSameMark", ()=>$8d06b00056a4837e$export$b1304404bdc42b7a);
    $parcel$export(module.exports, "getValidDocument", ()=>$8d06b00056a4837e$export$fb80336a7e408cb3);
    $parcel$export(module.exports, "getValidNode", ()=>$8d06b00056a4837e$export$81b20b6c83a56bd);
    var $9IGaJ;
    var $kc0v7;
    var $iZOJ9;
    var $bFtEE;
    var $kOFhM;
    var $2oS3b;
    const $8d06b00056a4837e$export$3b94ef2190b2d585 = {
        FINAL: 'final',
        STAGE_0: 'stage0'
    };
    const $8d06b00056a4837e$export$62d5811a2955c1d8 = [
        'fragment',
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'confluenceInlineComment',
        'annotation',
        'dataConsumer'
    ];
    const $8d06b00056a4837e$export$30f8aa4cc1f8c1cb = (type)=>{
        return type === 'sub' || type === 'sup';
    };
    const $8d06b00056a4837e$export$99a33ed044c278ae = (marks)=>{
        return [
            ...marks
        ].sort((a, b)=>$8d06b00056a4837e$export$62d5811a2955c1d8.indexOf(a.type.name) - $8d06b00056a4837e$export$62d5811a2955c1d8.indexOf(b.type.name));
    };
    const $8d06b00056a4837e$export$b1304404bdc42b7a = (mark, otherMark)=>{
        if (!mark || !otherMark) return false;
        return mark.eq(otherMark);
    };
    const $8d06b00056a4837e$export$fb80336a7e408cb3 = (doc, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const node = $8d06b00056a4837e$export$81b20b6c83a56bd(doc, schema, adfStage);
        if (node.type === 'doc') {
            node.content = $8d06b00056a4837e$var$wrapInlineNodes(node.content);
            return node;
        }
        return null;
    };
    const $8d06b00056a4837e$var$wrapInlineNodes = (nodes = [])=>{
        return nodes.map((node)=>(0, (0, parcelRequire("kc0v7")).inlineNodes).has(node.type) ? {
                type: 'paragraph',
                content: [
                    node
                ]
            } : node);
    };
    const $8d06b00056a4837e$export$fafd4f799ee68da0 = (content, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        return content.map((node)=>$8d06b00056a4837e$export$81b20b6c83a56bd(node, schema, adfStage));
    };
    const $8d06b00056a4837e$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
    const $8d06b00056a4837e$var$RELATIVE_LINK = /^\//;
    const $8d06b00056a4837e$var$ANCHOR_LINK = /^#/;
    const $8d06b00056a4837e$var$flattenUnknownBlockTree = (node, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const output = [];
        let isPrevLeafNode = false;
        for(let i = 0; i < node.content.length; i++){
            const childNode = node.content[i];
            const isLeafNode = !(childNode.content && childNode.content.length);
            if (i > 0) {
                if (isPrevLeafNode) output.push({
                    type: 'text',
                    text: ' '
                });
                else output.push({
                    type: 'hardBreak'
                });
            }
            if (isLeafNode) output.push($8d06b00056a4837e$export$81b20b6c83a56bd(childNode, schema, adfStage));
            else output.push(...$8d06b00056a4837e$var$flattenUnknownBlockTree(childNode, schema, adfStage));
            isPrevLeafNode = isLeafNode;
        }
        return output;
    };
    const $8d06b00056a4837e$export$b9908ef75cad1e0e = (node)=>{
        const { attrs: attrs = {}, content: content, text: text, type: type } = node;
        if (!content || !content.length) {
            const unknownInlineNode = {
                type: 'text',
                text: text || attrs.text || `[${type}]`
            };
            const { textUrl: textUrl } = attrs;
            if (textUrl && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(textUrl)) unknownInlineNode.marks = [
                {
                    type: 'link',
                    attrs: {
                        href: textUrl
                    }
                }
            ];
            return unknownInlineNode;
        }
        return {
            type: 'unknownBlock',
            content: $8d06b00056a4837e$var$flattenUnknownBlockTree(node)
        };
    };
    const $8d06b00056a4837e$var$getValidMarks = (marks, adfStage = 'final')=>{
        if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
            const validMark = $8d06b00056a4837e$export$87c6d4a6ebb7d9e9(mark, adfStage);
            if (validMark) acc.push(validMark);
            return acc;
        }, []);
        return marks;
    };
    const $8d06b00056a4837e$export$81b20b6c83a56bd = (originalNode, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
        let { content: content } = originalNode;
        const node = {
            attrs: attrs,
            marks: marks,
            text: text,
            type: type
        };
        if (content) node.content = content = $8d06b00056a4837e$export$fafd4f799ee68da0(content, schema, adfStage);
        if (!schema.nodes[type]) return $8d06b00056a4837e$export$b9908ef75cad1e0e(node);
        if (type) switch(type){
            case 'doc':
                {
                    const { version: version } = originalNode;
                    if (version && content && content.length) return {
                        type: type,
                        content: content
                    };
                    break;
                }
            case 'codeBlock':
                if (content) content = content.reduce((acc, val)=>{
                    if (val.type === 'text') acc.push({
                        type: val.type,
                        text: val.text
                    });
                    return acc;
                }, []);
                if (attrs && attrs.language) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: marks
                };
                return {
                    type: type,
                    content: content,
                    marks: marks
                };
            case 'date':
                if (attrs && attrs.timestamp) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'status':
                if (attrs && attrs.text && attrs.color) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'emoji':
                if (attrs && attrs.shortName) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'inlineExtension':
            case 'extension':
                if (attrs && attrs.extensionType && attrs.extensionKey) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'inlineCard':
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'blockCard':
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'embedCard':
                if (attrs && (attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'bodiedExtension':
                if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'multiBodiedExtension':
                if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'extensionFrame':
                if (content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'hardBreak':
                return {
                    type: type
                };
            case 'caption':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'mediaInline':
                {
                    let mediaId = '';
                    let mediaCollection = [];
                    if (attrs) {
                        const { id: id, collection: collection } = attrs;
                        mediaId = id;
                        mediaCollection = collection;
                    }
                    if (mediaId && mediaCollection) return {
                        type: type,
                        attrs: attrs,
                        marks: marks
                    };
                    break;
                }
            case 'media':
                {
                    let mediaId = '';
                    let mediaType = '';
                    let mediaCollection = [];
                    let mediaUrl = '';
                    if (attrs) {
                        const { id: id, collection: collection, type: type, url: url } = attrs;
                        mediaId = id;
                        mediaType = type;
                        mediaCollection = collection;
                        mediaUrl = url;
                    }
                    if (mediaType === 'external' && !!mediaUrl) {
                        const mediaAttrs = {
                            type: mediaType,
                            url: mediaUrl,
                            width: attrs.width,
                            height: attrs.height
                        };
                        if (attrs.alt) mediaAttrs.alt = attrs.alt;
                        const getMarks = $8d06b00056a4837e$var$getValidMarks(marks, adfStage);
                        return getMarks ? {
                            type: type,
                            attrs: mediaAttrs,
                            marks: getMarks
                        } : {
                            type: type,
                            attrs: mediaAttrs
                        };
                    } else if (mediaId && mediaType) {
                        const mediaAttrs = {
                            type: mediaType,
                            id: mediaId,
                            collection: mediaCollection
                        };
                        if (attrs.width) mediaAttrs.width = attrs.width;
                        if (attrs.height) mediaAttrs.height = attrs.height;
                        if (attrs.alt) mediaAttrs.alt = attrs.alt;
                        const getMarks = $8d06b00056a4837e$var$getValidMarks(marks, adfStage);
                        return getMarks ? {
                            type: type,
                            attrs: mediaAttrs,
                            marks: getMarks
                        } : {
                            type: type,
                            attrs: mediaAttrs
                        };
                    }
                    break;
                }
            case 'mediaGroup':
                if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                    type: type,
                    content: content
                };
                break;
            case 'mediaSingle':
                {
                    const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                    const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                    if (containsJustMedia || containsMediaAndCaption) return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: $8d06b00056a4837e$var$getValidMarks(marks, adfStage)
                    };
                    break;
                }
            case 'mention':
                {
                    let mentionText = '';
                    let mentionId;
                    let mentionAccess;
                    if (attrs) {
                        const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                        mentionText = text || displayName;
                        mentionId = id;
                        mentionAccess = accessLevel;
                    }
                    if (!mentionText) mentionText = text || '@unknown';
                    if (mentionText && mentionId) {
                        const mentionNode = {
                            type: type,
                            attrs: {
                                id: mentionId,
                                text: mentionText,
                                accessLevel: ''
                            },
                            ...(0, (0, parcelRequire("2oS3b")).fg)('editor_inline_comments_on_inline_nodes') ? {
                                marks: marks
                            } : {}
                        };
                        if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                        return mentionNode;
                    }
                    break;
                }
            case 'paragraph':
                if (adfStage === 'stage0') {
                    let paragraphNode = {
                        type: type,
                        content: content || []
                    };
                    if (attrs && attrs.localId) paragraphNode.attrs = {
                        localId: attrs.localId
                    };
                    if (marks) paragraphNode.marks = [
                        ...marks
                    ];
                    return paragraphNode;
                }
                return marks ? {
                    type: type,
                    content: content || [],
                    marks: marks
                } : {
                    type: type,
                    content: content || []
                };
            case 'rule':
                return {
                    type: type
                };
            case 'text':
                {
                    let { marks: marks } = node;
                    if (text) return marks ? {
                        type: type,
                        text: text,
                        marks: $8d06b00056a4837e$var$getValidMarks(marks, adfStage)
                    } : {
                        type: type,
                        text: text
                    };
                    break;
                }
            case 'heading':
                if (attrs) {
                    const { level: level } = attrs;
                    const between = (x, a, b)=>x >= a && x <= b;
                    if (level && between(level, 1, 6)) {
                        if (adfStage === 'stage0') {
                            let headingNode = {
                                type: type,
                                content: content,
                                attrs: {
                                    level: level
                                }
                            };
                            if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                            if (marks) headingNode.marks = [
                                ...marks
                            ];
                            return headingNode;
                        }
                        return marks ? {
                            type: type,
                            content: content,
                            marks: marks,
                            attrs: {
                                level: level
                            }
                        } : {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                    }
                }
                break;
            case 'bulletList':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'orderedList':
                if (content) return {
                    type: type,
                    content: content,
                    attrs: {
                        order: attrs && attrs.order
                    }
                };
                break;
            case 'listItem':
                if (content) return {
                    type: type,
                    content: $8d06b00056a4837e$var$wrapInlineNodes(content)
                };
                break;
            case 'blockquote':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'panel':
                if (attrs && content) {
                    const { panelType: panelType } = attrs;
                    if (Object.values((0, (0, parcelRequire("bFtEE")).PanelType)).includes(panelType)) return {
                        type: type,
                        attrs: attrs,
                        content: content
                    };
                }
                break;
            case 'layoutSection':
                if (content) return {
                    type: type,
                    marks: marks,
                    content: content
                };
                break;
            case 'layoutColumn':
                if (attrs && content) {
                    if (attrs.width > 0 && attrs.width <= 100) return {
                        type: type,
                        content: content,
                        attrs: attrs
                    };
                }
                break;
            case 'decisionList':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)()
                    }
                };
            case 'decisionItem':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                        state: attrs && attrs.state || 'DECIDED'
                    }
                };
            case 'taskList':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)()
                    }
                };
            case 'taskItem':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                        state: attrs && attrs.state || 'TODO'
                    }
                };
            case 'table':
                if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                    if (adfStage === 'stage0') return {
                        type: type,
                        content: content,
                        attrs: {
                            ...attrs,
                            localId: attrs?.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                            width: attrs?.width || null
                        }
                    };
                    return {
                        type: type,
                        content: content,
                        attrs: attrs
                    };
                }
                break;
            case 'tableRow':
                if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                    type: type,
                    content: content
                };
                break;
            case 'tableCell':
            case 'tableHeader':
                if (content) {
                    const cellAttrs = {};
                    if (attrs) {
                        if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                        if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                        if (attrs.background) cellAttrs.background = attrs.background;
                        if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                    }
                    return {
                        type: type,
                        content: $8d06b00056a4837e$var$wrapInlineNodes(content),
                        attrs: attrs ? cellAttrs : undefined
                    };
                }
                break;
            case 'image':
                if (attrs && attrs.src) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'placeholder':
                if (attrs && typeof attrs.text !== 'undefined') return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'expand':
            case 'nestedExpand':
                return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: marks
                };
        }
        return $8d06b00056a4837e$export$b9908ef75cad1e0e(node);
    };
    const $8d06b00056a4837e$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
        const { attrs: attrs, type: type } = mark;
        if (type) switch(type){
            case 'code':
                return {
                    type: type
                };
            case 'em':
                return {
                    type: type
                };
            case 'link':
                if (attrs) {
                    const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                    let linkHref = href || url;
                    if (linkHref && linkHref.indexOf(':') === -1 && !$8d06b00056a4837e$var$RELATIVE_LINK.test(linkHref) && !$8d06b00056a4837e$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                    const linkAttrs = {
                        href: linkHref
                    };
                    if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                    if (linkHref && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(linkHref)) return {
                        type: type,
                        attrs: linkAttrs
                    };
                }
                break;
            case 'strike':
                return {
                    type: type
                };
            case 'strong':
                return {
                    type: type
                };
            case 'subsup':
                if (attrs && attrs['type']) {
                    const subSupType = attrs['type'];
                    if ($8d06b00056a4837e$export$30f8aa4cc1f8c1cb(subSupType)) return {
                        type: type,
                        attrs: {
                            type: subSupType
                        }
                    };
                }
                break;
            case 'textColor':
                if (attrs && $8d06b00056a4837e$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'underline':
                return {
                    type: type
                };
            case 'annotation':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'border':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'backgroundColor':
                if (attrs && $8d06b00056a4837e$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                    type: type,
                    attrs: attrs
                };
                break;
        }
        if (adfStage === 'stage0') switch(type){
            case 'confluenceInlineComment':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'dataConsumer':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'fragment':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'border':
                return {
                    type: type,
                    attrs: attrs
                };
        }
        return null;
    };
});
parcelRegister("kc0v7", function(module, exports) {
    $parcel$export(module.exports, "inlineNodes", ()=>$eb355120b38723aa$export$b1f729c6af6f2a6e);
    var $ctVrM;
    const $eb355120b38723aa$var$typedNodes = (0, parcelRequire("ctVrM"));
    const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));
});
parcelRegister("ctVrM", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>(parcelRequire("7kC9H")).expand);
    $parcel$export(module.exports, "expandWithNestedExpand", ()=>(parcelRequire("7kC9H")).expandWithNestedExpand);
    $parcel$export(module.exports, "expandToJSON", ()=>(parcelRequire("7kC9H")).toJSON);
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>(parcelRequire("6bbHe")).confluenceJiraIssue);
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>(parcelRequire("5y0tR")).confluenceUnsupportedBlock);
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>(parcelRequire("bd7A9")).confluenceUnsupportedInline);
    $parcel$export(module.exports, "doc", ()=>(parcelRequire("xjCuM")).doc);
    $parcel$export(module.exports, "blockquote", ()=>(parcelRequire("aXBFx")).blockquote);
    $parcel$export(module.exports, "blockquoteWithList", ()=>(parcelRequire("aXBFx")).blockquoteWithList);
    $parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", ()=>(parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
    $parcel$export(module.exports, "bulletList", ()=>(parcelRequire("kjhhp")).bulletList);
    $parcel$export(module.exports, "bulletListSelector", ()=>(parcelRequire("kjhhp")).bulletListSelector);
    $parcel$export(module.exports, "codeBlock", ()=>(parcelRequire("8vlrc")).codeBlock);
    $parcel$export(module.exports, "codeBlockToJSON", ()=>(parcelRequire("8vlrc")).toJSON);
    $parcel$export(module.exports, "hardBreak", ()=>(parcelRequire("jnMM2")).hardBreak);
    $parcel$export(module.exports, "heading", ()=>(parcelRequire("lRTZM")).heading);
    $parcel$export(module.exports, "rule", ()=>(parcelRequire("M4hHz")).rule);
    $parcel$export(module.exports, "orderedList", ()=>(parcelRequire("dwptW")).orderedList);
    $parcel$export(module.exports, "orderedListSelector", ()=>(parcelRequire("dwptW")).orderedListSelector);
    $parcel$export(module.exports, "orderedListWithOrder", ()=>(parcelRequire("dwptW")).orderedListWithOrder);
    $parcel$export(module.exports, "paragraph", ()=>(parcelRequire("abme3")).paragraph);
    $parcel$export(module.exports, "emoji", ()=>(parcelRequire("7DoMR")).emoji);
    $parcel$export(module.exports, "image", ()=>(parcelRequire("7lRBh")).image);
    $parcel$export(module.exports, "mention", ()=>(parcelRequire("g7Cky")).mention);
    $parcel$export(module.exports, "mentionToJSON", ()=>(parcelRequire("g7Cky")).toJSON);
    $parcel$export(module.exports, "listItem", ()=>(parcelRequire("2FIVU")).listItem);
    $parcel$export(module.exports, "listItemWithTask", ()=>(parcelRequire("2FIVU")).listItemWithTask);
    $parcel$export(module.exports, "listItemWithDecisionStage0", ()=>(parcelRequire("2FIVU")).listItemWithDecisionStage0);
    $parcel$export(module.exports, "extendedPanel", ()=>(parcelRequire("bFtEE")).extendedPanel);
    $parcel$export(module.exports, "PanelType", ()=>(parcelRequire("bFtEE")).PanelType);
    $parcel$export(module.exports, "panelWithBlockquoteStage0", ()=>(parcelRequire("bFtEE")).panelWithBlockquoteStage0);
    $parcel$export(module.exports, "text", ()=>(parcelRequire("3DR6L")).text);
    $parcel$export(module.exports, "unknownBlock", ()=>(parcelRequire("9X587")).default);
    $parcel$export(module.exports, "caption", ()=>(parcelRequire("5JeV5")).caption);
    $parcel$export(module.exports, "media", ()=>(parcelRequire("7agO8")).media);
    $parcel$export(module.exports, "copyPrivateMediaAttributes", ()=>(parcelRequire("7agO8")).copyPrivateAttributes);
    $parcel$export(module.exports, "mediaToJSON", ()=>(parcelRequire("7agO8")).toJSON);
    $parcel$export(module.exports, "mediaGroup", ()=>(parcelRequire("92lix")).mediaGroup);
    $parcel$export(module.exports, "mediaInline", ()=>(parcelRequire("7Xgp3")).mediaInline);
    $parcel$export(module.exports, "mediaSingle", ()=>(parcelRequire("bIGZ7")).mediaSingle);
    $parcel$export(module.exports, "mediaSingleSpec", ()=>(parcelRequire("bIGZ7")).mediaSingleSpec);
    $parcel$export(module.exports, "mediaSingleWithCaption", ()=>(parcelRequire("bIGZ7")).mediaSingleWithCaption);
    $parcel$export(module.exports, "mediaSingleWithWidthType", ()=>(parcelRequire("bIGZ7")).mediaSingleWithWidthType);
    $parcel$export(module.exports, "mediaSingleFull", ()=>(parcelRequire("bIGZ7")).mediaSingleFull);
    $parcel$export(module.exports, "mediaSingleToJSON", ()=>(parcelRequire("bIGZ7")).toJSON);
    $parcel$export(module.exports, "table", ()=>(parcelRequire("9UDEr")).table);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>(parcelRequire("9UDEr")).tableWithNestedTable);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>(parcelRequire("9UDEr")).tableRowWithNestedTable);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>(parcelRequire("9UDEr")).tableCellWithNestedTable);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>(parcelRequire("9UDEr")).tableHeaderWithNestedTable);
    $parcel$export(module.exports, "tableStage0", ()=>(parcelRequire("9UDEr")).tableStage0);
    $parcel$export(module.exports, "tableWithCustomWidth", ()=>(parcelRequire("9UDEr")).tableWithCustomWidth);
    $parcel$export(module.exports, "tableToJSON", ()=>(parcelRequire("9UDEr")).tableToJSON);
    $parcel$export(module.exports, "tableCell", ()=>(parcelRequire("9UDEr")).tableCell);
    $parcel$export(module.exports, "toJSONTableCell", ()=>(parcelRequire("9UDEr")).toJSONTableCell);
    $parcel$export(module.exports, "tableHeader", ()=>(parcelRequire("9UDEr")).tableHeader);
    $parcel$export(module.exports, "toJSONTableHeader", ()=>(parcelRequire("9UDEr")).toJSONTableHeader);
    $parcel$export(module.exports, "tableRow", ()=>(parcelRequire("9UDEr")).tableRow);
    $parcel$export(module.exports, "tableBackgroundColorPalette", ()=>(parcelRequire("9UDEr")).tableBackgroundColorPalette);
    $parcel$export(module.exports, "tableBackgroundBorderColor", ()=>(parcelRequire("9UDEr")).tableBackgroundBorderColor);
    $parcel$export(module.exports, "tableBackgroundColorNames", ()=>(parcelRequire("9UDEr")).tableBackgroundColorNames);
    $parcel$export(module.exports, "getCellAttrs", ()=>(parcelRequire("9UDEr")).getCellAttrs);
    $parcel$export(module.exports, "getCellDomAttrs", ()=>(parcelRequire("9UDEr")).getCellDomAttrs);
    $parcel$export(module.exports, "tablePrefixSelector", ()=>(parcelRequire("9UDEr")).tablePrefixSelector);
    $parcel$export(module.exports, "tableCellSelector", ()=>(parcelRequire("9UDEr")).tableCellSelector);
    $parcel$export(module.exports, "tableHeaderSelector", ()=>(parcelRequire("9UDEr")).tableHeaderSelector);
    $parcel$export(module.exports, "tableCellContentWrapperSelector", ()=>(parcelRequire("9UDEr")).tableCellContentWrapperSelector);
    $parcel$export(module.exports, "tableCellContentDomSelector", ()=>(parcelRequire("9UDEr")).tableCellContentDomSelector);
    $parcel$export(module.exports, "decisionList", ()=>(parcelRequire("8gSD8")).decisionList);
    $parcel$export(module.exports, "decisionListSelector", ()=>(parcelRequire("8gSD8")).decisionListSelector);
    $parcel$export(module.exports, "decisionItem", ()=>(parcelRequire("Khvpb")).decisionItem);
    $parcel$export(module.exports, "taskList", ()=>(parcelRequire("43mJF")).taskList);
    $parcel$export(module.exports, "taskListSelector", ()=>(parcelRequire("43mJF")).taskListSelector);
    $parcel$export(module.exports, "taskItem", ()=>(parcelRequire("iThOL")).taskItem);
    $parcel$export(module.exports, "date", ()=>(parcelRequire("b2VmY")).date);
    $parcel$export(module.exports, "placeholder", ()=>(parcelRequire("dgJoa")).placeholder);
    $parcel$export(module.exports, "layoutSection", ()=>(parcelRequire("gZoER")).layoutSection);
    $parcel$export(module.exports, "layoutSectionWithSingleColumn", ()=>(parcelRequire("gZoER")).layoutSectionWithSingleColumn);
    $parcel$export(module.exports, "layoutColumn", ()=>(parcelRequire("4EbxI")).layoutColumn);
    $parcel$export(module.exports, "inlineCard", ()=>(parcelRequire("cCBEe")).inlineCard);
    $parcel$export(module.exports, "blockCard", ()=>(parcelRequire("21PS7")).blockCard);
    $parcel$export(module.exports, "unsupportedBlock", ()=>(parcelRequire("d1d6m")).unsupportedBlock);
    $parcel$export(module.exports, "unsupportedInline", ()=>(parcelRequire("6kr5W")).unsupportedInline);
    $parcel$export(module.exports, "status", ()=>(parcelRequire("18bvk")).status);
    $parcel$export(module.exports, "nestedExpand", ()=>(parcelRequire("dx5eC")).nestedExpand);
    $parcel$export(module.exports, "embedCard", ()=>(parcelRequire("kshOv")).embedCard);
    $parcel$export(module.exports, "extension", ()=>(parcelRequire("hhN5g")).extension);
    $parcel$export(module.exports, "inlineExtension", ()=>(parcelRequire("5BOuQ")).inlineExtension);
    $parcel$export(module.exports, "bodiedExtension", ()=>(parcelRequire("5AxYU")).bodiedExtension);
    $parcel$export(module.exports, "extensionFrame", ()=>(parcelRequire("47jug")).extensionFrame);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>(parcelRequire("47jug")).multiBodiedExtension);
    var $7kC9H;
    var $6bbHe;
    var $5y0tR;
    var $bd7A9;
    var $xjCuM;
    var $aXBFx;
    var $kjhhp;
    var $8vlrc;
    var $jnMM2;
    var $lRTZM;
    var $M4hHz;
    var $dwptW;
    var $abme3;
    var $7DoMR;
    var $7lRBh;
    var $g7Cky;
    var $2FIVU;
    var $bFtEE;
    var $3DR6L;
    var $9X587;
    var $5JeV5;
    var $7agO8;
    var $92lix;
    var $7Xgp3;
    var $bIGZ7;
    var $9UDEr;
    var $8gSD8;
    var $Khvpb;
    var $43mJF;
    var $iThOL;
    var $b2VmY;
    var $dgJoa;
    var $gZoER;
    var $4EbxI;
    var $cCBEe;
    var $21PS7;
    var $d1d6m;
    var $6kr5W;
    var $18bvk;
    var $dx5eC;
    var $kshOv;
    var $hhN5g;
    var $5BOuQ;
    var $5AxYU;
    var $47jug;
});
parcelRegister("e0Fey", function(module, exports) {
    $parcel$export(module.exports, "insideBreakoutLayout", ()=>$57c7446d386e2d6a$export$d7bc71cca336a3b);
    $parcel$export(module.exports, "insideBlockNode", ()=>$57c7446d386e2d6a$export$42ddc573eb5a7b43);
    $parcel$export(module.exports, "insideMultiBodiedExtension", ()=>$57c7446d386e2d6a$export$9f1e9347b0411934);
    const $57c7446d386e2d6a$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
    const $57c7446d386e2d6a$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
    const $57c7446d386e2d6a$export$d7bc71cca336a3b = (path)=>path.some((item)=>$57c7446d386e2d6a$var$isLayoutNode(item) && $57c7446d386e2d6a$var$hasBreakOutMark(item));
    const $57c7446d386e2d6a$export$42ddc573eb5a7b43 = (path, schema)=>{
        const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
        const blockNodeNames = [
            expand,
            nestedExpand,
            layoutColumn
        ].filter((node)=>Boolean(node)).map((node)=>node.name);
        return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
    };
    const $57c7446d386e2d6a$export$9f1e9347b0411934 = (path, schema)=>{
        const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
        return path.some((n)=>n.type === multiBodiedExtension);
    };
});
parcelRegister("9EkeZ", function(module, exports) {
    $parcel$export(module.exports, "renderDocument", ()=>$3b31717acd99a939$export$59a54f98b9753d5c);
    var $8QpSo;
    var $kOFhM;
    var $fxgxP;
    var $484Vr;
    var $krgVw;
    var $6SKbt;
    var $4la1F;
    var $3bwMs;
    var $hQzt3;
    var $2O1uP;
    var $2gO4q;
    var $2oS3b;
    const $3b31717acd99a939$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
    const $3b31717acd99a939$var$withStopwatch = (cb)=>{
        const startTime = $3b31717acd99a939$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
        const output = cb();
        const endTime = $3b31717acd99a939$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
        const time = endTime - startTime;
        return {
            output: output,
            time: time
        };
    };
    const $3b31717acd99a939$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent)=>{
        let result;
        if (useSpecBasedValidator) {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("hQzt3")).transformMediaLinkMarks)(doc);
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).MEDIA_LINK_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL
            });
            result = (0, (0, parcelRequire("krgVw")).validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
        } else result = (0, (0, parcelRequire("fxgxP")).getValidDocument)(doc, schema, adfStage);
        if (!result) return result;
        if (result.type === 'doc' && useSpecBasedValidator) {
            if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
                type: 'paragraph',
                content: []
            });
            if (!result.version) result.version = 1;
        }
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform_editor_use_nested_table_pm_nodes')) try {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("2O1uP")).transformNestedTablesIncomingDocument)(result);
            if (isTransformed) {
                dispatchAnalyticsEvent?.({
                    action: (0, (0, parcelRequire("6SKbt")).ACTION).NESTED_TABLE_TRANSFORMED,
                    actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                    eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL
                });
                result = transformedAdf;
            }
        } catch (e) {
            dispatchAnalyticsEvent?.({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                    errorStack: 'Failed to transform one or more nested tables in the document'
                }
            });
        }
        return result;
    };
    const $3b31717acd99a939$var$memoValidation = (0, (0, parcelRequire("8QpSo")).default)($3b31717acd99a939$var$_validation, (newArgs, lastArgs)=>{
        const [newDoc, newSchema, newADFStage, newUseSpecValidator] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator] = lastArgs;
        const result = $3b31717acd99a939$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator;
        return result;
    });
    const $3b31717acd99a939$var$areDocsEqual = (docA, docB)=>{
        if (docA === docB) return true;
        if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
        if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
        return JSON.stringify(docA) === JSON.stringify(docB);
    };
    const $3b31717acd99a939$var$_serializeFragment = (serializer, doc)=>{
        return serializer.serializeFragment(doc.content);
    };
    const $3b31717acd99a939$var$memoSerializeFragment = (0, (0, parcelRequire("8QpSo")).default)($3b31717acd99a939$var$_serializeFragment, (newArgs, lastArgs)=>{
        const [newSerializer, newDoc] = newArgs;
        const [oldSerializer, oldDoc] = lastArgs;
        return newSerializer === oldSerializer && $3b31717acd99a939$var$areDocsEqual(newDoc, oldDoc);
    });
    const $3b31717acd99a939$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
        const pmNode = schema.nodeFromJSON(doc);
        try {
            pmNode.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                    errorStack: err instanceof Error ? err.message : String(err)
                },
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL
            });
        }
        return pmNode;
    };
    const $3b31717acd99a939$var$memoCreateNodeAndCheck = (0, (0, parcelRequire("8QpSo")).default)($3b31717acd99a939$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
        const [newSchema, newDoc] = newArgs;
        const [oldSchema, oldDoc] = lastArgs;
        return newSchema === oldSchema && $3b31717acd99a939$var$areDocsEqual(newDoc, oldDoc);
    });
    const $3b31717acd99a939$export$59a54f98b9753d5c = (doc, serializer, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats)=>{
        const stat = {
            sanitizeTime: 0
        };
        const { output: validDoc, time: sanitizeTime } = $3b31717acd99a939$var$withStopwatch(()=>{
            return $3b31717acd99a939$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent);
        });
        stat.sanitizeTime = sanitizeTime;
        if (!validDoc) return {
            stat: stat,
            result: null
        };
        const { output: node, time: buildTreeTime } = $3b31717acd99a939$var$withStopwatch(()=>{
            return $3b31717acd99a939$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
        });
        stat.buildTreeTime = buildTreeTime;
        const { output: result, time: serializeTime } = $3b31717acd99a939$var$withStopwatch(()=>{
            return $3b31717acd99a939$var$memoSerializeFragment(serializer, node);
        });
        stat.serializeTime = serializeTime;
        if (dispatchAnalyticsEvent && useSpecBasedValidator) {
            (0, (0, parcelRequire("484Vr")).findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
            if (unsupportedContentLevelsTracking?.enabled) {
                const documentData = {
                    doc: validDoc,
                    appearance: appearance,
                    rendererId: rendererId
                };
                (0, (0, parcelRequire("3bwMs")).trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
            }
        }
        if (includeNodesCountInStats) stat.nodesCount = (0, (0, parcelRequire("2gO4q")).countNodes)(doc);
        return {
            result: result,
            stat: stat,
            pmDoc: node
        };
    };
});
parcelRegister("krgVw", function(module, exports) {
    $parcel$export(module.exports, "validateADFEntity", ()=>$620c307cbb35a15f$export$884cfad20dece33e);
    var $4qIMY;
    var $6SKbt;
    var $484Vr;
    const $620c307cbb35a15f$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
    const $620c307cbb35a15f$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
        return (entity, error, options)=>{
            return $620c307cbb35a15f$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
        };
    };
    const $620c307cbb35a15f$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
        if (entity && entity.type === $620c307cbb35a15f$export$8e7fd962b4d3895d) return entity;
        if (options.isMark) return $620c307cbb35a15f$export$87b732fa69cdf16e(error.meta, 'mark');
        if (options.isNodeAttribute) {
            const entityType = entity && entity.type ? entity.type : undefined;
            return {
                type: $620c307cbb35a15f$export$8e7fd962b4d3895d,
                attrs: {
                    type: {
                        nodeType: entityType
                    },
                    unsupported: error.meta
                }
            };
        }
        if (entity && marks.indexOf(entity.type) > -1) return;
        if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
            type: 'paragraph',
            content: []
        };
        if (error.code === 'INVALID_CONTENT_LENGTH') {
            if (error.meta && options.allowUnsupportedBlock && entity.content) return $620c307cbb35a15f$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
            else if (dispatchAnalyticsEvent) $620c307cbb35a15f$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
        }
        if (options.allowUnsupportedBlock) return $620c307cbb35a15f$export$87b732fa69cdf16e(entity);
        if (options.allowUnsupportedInline) return $620c307cbb35a15f$export$87b732fa69cdf16e(entity, 'inline');
        if (dispatchAnalyticsEvent) $620c307cbb35a15f$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
        return entity;
    };
    function $620c307cbb35a15f$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
        const meta = error.meta;
        if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
            return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $620c307cbb35a15f$export$87b732fa69cdf16e(child) : validate(child, $620c307cbb35a15f$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
        });
        if (meta.type === 'minimum') {
            if (entity.content.length === 0) return $620c307cbb35a15f$export$87b732fa69cdf16e(entity);
            entity.content = entity.content.filter((x)=>!!x).map((child)=>{
                return child.type !== 'unsupportedBlock' ? $620c307cbb35a15f$export$87b732fa69cdf16e(child) : child;
            });
        }
        return entity;
    }
    function $620c307cbb35a15f$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
        if (!dispatchAnalyticsEvent) return;
        (0, (0, parcelRequire("484Vr")).fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
            type: entity.type || '',
            ancestry: entity.ancestorHierarchy || '',
            parentType: entity.parentType || '',
            marks: entity.marks || [],
            attrs: entity.attrs || {}
        }, error.code);
    }
    const $620c307cbb35a15f$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
        const nodes = Object.keys(schema.nodes);
        const marks = Object.keys(schema.marks);
        const validate = (0, (0, parcelRequire("4qIMY")).validator)(nodes, marks, {
            allowPrivateAttributes: true
        });
        const emptyDoc = {
            type: 'doc',
            content: []
        };
        const { entity: entity = emptyDoc } = validate(node, $620c307cbb35a15f$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
        return entity;
    };
    function $620c307cbb35a15f$export$87b732fa69cdf16e(originalValue, type = 'block') {
        let unsupportedNodeType;
        switch(type){
            case 'inline':
                unsupportedNodeType = 'unsupportedInline';
                break;
            case 'mark':
                unsupportedNodeType = 'unsupportedMark';
                break;
            default:
                unsupportedNodeType = 'unsupportedBlock';
        }
        return {
            type: unsupportedNodeType,
            attrs: {
                originalValue: originalValue
            }
        };
    }
});
parcelRegister("4qIMY", function(module, exports) {
    $parcel$export(module.exports, "validator", ()=>$0e02563a3c892ae7$export$956325f45c5d174a);
    var $lgREk;
    var $asoRy;
    var $fr2tu;
    function $0e02563a3c892ae7$var$mapMarksItems(spec, fn = (x)=>x) {
        if (spec.props && spec.props.marks) {
            const { items: items, ...rest } = spec.props.marks;
            return {
                ...spec,
                props: {
                    ...spec.props,
                    marks: {
                        ...rest,
                        items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                            fn(items)
                        ] : [
                            []
                        ]
                    }
                }
            };
        } else return spec;
    }
    const $0e02563a3c892ae7$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
            const result = predicate(key, obj[key], obj);
            acc[result ? 0 : 1].push(key);
            return acc;
        }, [
            [],
            []
        ]);
    function $0e02563a3c892ae7$var$createSpec(nodes, marks) {
        return Object.keys((0, parcelRequire("lgREk"))).reduce((newSpecs, k)=>{
            const spec = {
                ...(0, parcelRequire("lgREk"))[k]
            };
            if (spec.props) {
                spec.props = {
                    ...spec.props
                };
                if (spec.props.content) {
                    if ((0, (0, parcelRequire("asoRy")).isString)(spec.props.content)) spec.props.content = (0, parcelRequire("lgREk"))[spec.props.content];
                    if (Array.isArray(spec.props.content)) spec.props.content = {
                        type: 'array',
                        items: (spec.props.content || []).map((arr)=>arr.items)
                    };
                    else spec.props.content = {
                        ...spec.props.content
                    };
                    spec.props.content.items = spec.props.content.items.map((item)=>(0, (0, parcelRequire("asoRy")).isString)(item) ? Array.isArray((0, parcelRequire("lgREk"))[item]) ? (0, parcelRequire("lgREk"))[item] : [
                            item
                        ] : item).map((item)=>item.map((subItem)=>Array.isArray((0, parcelRequire("lgREk"))[subItem]) ? (0, parcelRequire("lgREk"))[subItem] : (0, (0, parcelRequire("asoRy")).isString)(subItem) ? subItem : [
                                'text',
                                subItem
                            ]).filter((subItem)=>{
                            if (nodes) {
                                if (Array.isArray(subItem)) {
                                    const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                    if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                    return isMainNodeSupported;
                                }
                                return nodes.indexOf(subItem) > -1;
                            }
                            return true;
                        }).map((subItem)=>Array.isArray(subItem) && marks ? [
                                subItem[0],
                                $0e02563a3c892ae7$var$mapMarksItems(subItem[1])
                            ] : subItem));
                }
            }
            newSpecs[k] = spec;
            return newSpecs;
        }, {});
    }
    function $0e02563a3c892ae7$var$getOptionsForType(type, list) {
        if (!list) return {};
        for(let i = 0, len = list.length; i < len; i++){
            const spec = list[i];
            let name = spec;
            let options = {};
            if (Array.isArray(spec)) [name, options] = spec;
            if (name === type) return options;
        }
        return false;
    }
    const $0e02563a3c892ae7$var$isValidatorSpecAttrs = (spec)=>{
        return !!spec.props;
    };
    function $0e02563a3c892ae7$export$66c739158ef99a42(spec, value) {
        if (!(0, (0, parcelRequire("asoRy")).isDefined)(value)) return !!spec.optional;
        if ($0e02563a3c892ae7$var$isValidatorSpecAttrs(spec)) {
            const [_, invalidKeys] = $0e02563a3c892ae7$var$partitionObject(spec.props, (key, subSpec)=>$0e02563a3c892ae7$export$66c739158ef99a42(subSpec, value[key]));
            return invalidKeys.length === 0;
        }
        if (!(0, (0, parcelRequire("asoRy")).isDefined)(spec.type)) return !!spec.optional;
        switch(spec.type){
            case 'boolean':
                return (0, (0, parcelRequire("asoRy")).isBoolean)(value);
            case 'number':
                return (0, (0, parcelRequire("asoRy")).isNumber)(value) && ((0, (0, parcelRequire("asoRy")).isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, (0, parcelRequire("asoRy")).isDefined)(spec.maximum) ? spec.maximum >= value : true);
            case 'integer':
                return (0, (0, parcelRequire("asoRy")).isInteger)(value) && ((0, (0, parcelRequire("asoRy")).isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, (0, parcelRequire("asoRy")).isDefined)(spec.maximum) ? spec.maximum >= value : true);
            case 'string':
                const validatorFnPassed = (rule)=>typeof value === 'string' && (0, (0, parcelRequire("asoRy")).isDefined)((0, (0, parcelRequire("fr2tu")).validatorFnMap)[rule]) && (0, (0, parcelRequire("fr2tu")).validatorFnMap)[rule](value);
                return (0, (0, parcelRequire("asoRy")).isString)(value) && ((0, (0, parcelRequire("asoRy")).isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, (0, parcelRequire("asoRy")).isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
            case 'object':
                return (0, (0, parcelRequire("asoRy")).isPlainObject)(value);
            case 'array':
                if (Array.isArray(value)) {
                    const isTuple = !!spec.isTupleLike;
                    const { minItems: minItems, maxItems: maxItems } = spec;
                    if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                    if (isTuple) {
                        const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                        return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$0e02563a3c892ae7$export$66c739158ef99a42(spec.items[i], value[i]));
                    } else return value.every((valueItem)=>spec.items.some((itemSpec)=>$0e02563a3c892ae7$export$66c739158ef99a42(itemSpec, valueItem)));
                }
                return false;
            case 'enum':
                return (0, (0, parcelRequire("asoRy")).isString)(value) && spec.values.indexOf(value) > -1;
        }
    }
    const $0e02563a3c892ae7$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
    const $0e02563a3c892ae7$var$getUnsupportedOptions = (spec)=>{
        if (spec && spec.props && spec.props.content) {
            const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
            return {
                allowUnsupportedBlock: allowUnsupportedBlock,
                allowUnsupportedInline: allowUnsupportedInline
            };
        }
        return {};
    };
    const $0e02563a3c892ae7$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
        const message = $0e02563a3c892ae7$var$errorMessageFor(child.type, 'invalid content');
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message
        }, $0e02563a3c892ae7$var$getUnsupportedOptions(parentSpec));
    };
    const $0e02563a3c892ae7$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
        const message = errorMessage || $0e02563a3c892ae7$var$errorMessageFor(mark.type, 'unsupported mark');
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            ...mark
        }, {
            code: errorCode,
            message: message,
            meta: mark
        }, {
            allowUnsupportedBlock: false,
            allowUnsupportedInline: false,
            isMark: true
        });
    };
    const $0e02563a3c892ae7$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            type: entity.type
        }, {
            code: errorCode,
            message: message,
            meta: invalidAttributes
        }, {
            allowUnsupportedBlock: false,
            allowUnsupportedInline: false,
            isMark: false,
            isNodeAttribute: true
        });
    };
    function $0e02563a3c892ae7$export$956325f45c5d174a(nodes, marks, options) {
        const validatorSpecs = $0e02563a3c892ae7$var$createSpec(nodes, marks);
        const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
        const validate = (entity, errorCallback, allowed, parentSpec)=>{
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        };
        const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
            const { type: type } = entity;
            let newEntity = {
                ...entity
            };
            const err = (code, msg, meta)=>{
                const message = $0e02563a3c892ae7$var$errorMessageFor(type, msg);
                if (errorCallback) return {
                    valid: false,
                    entity: errorCallback(newEntity, {
                        code: code,
                        message: message,
                        meta: meta
                    }, $0e02563a3c892ae7$var$getUnsupportedOptions(parentSpec))
                };
                else throw new Error(message);
            };
            if (type) {
                const typeOptions = $0e02563a3c892ae7$var$getOptionsForType(type, allowed);
                if (typeOptions === false) return isMark ? {
                    valid: false
                } : err('INVALID_TYPE', 'type not allowed here');
                const spec = validatorSpecs[type];
                if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
                const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
                if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
            } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
            return {
                valid: true,
                entity: newEntity
            };
        };
        return validate;
        function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
            let validationResult;
            if (validator.props && validator.props.marks) {
                const marksSet = allowedMarksFor(validator);
                const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
                validationResult = {
                    valid: true,
                    entity: newEntity,
                    marksValidationOutput: marksValidationResult
                };
            } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
            return validationResult;
        }
        function validatorFor(spec, typeOptions) {
            return {
                ...spec,
                ...typeOptions,
                ...spec.props ? {
                    props: {
                        ...spec.props,
                        ...typeOptions['props'] || {}
                    }
                } : {}
            };
        }
        function marksAfterValidation(entity, errorCallback, marksSet, validator) {
            return entity.marks ? entity.marks.map((mark)=>{
                const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
                if (mode === 'strict' && isAKnownMark) {
                    const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                    const finalMark = finalResult.entity;
                    if (finalMark) return {
                        valid: true,
                        originalMark: mark,
                        newMark: finalMark
                    };
                    else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                        valid: false,
                        originalMark: mark,
                        errorCode: finalResult.marksValidationOutput[0].errorCode,
                        message: finalResult.marksValidationOutput[0].message
                    };
                    else return {
                        valid: false,
                        originalMark: mark,
                        errorCode: 'INVALID_TYPE'
                    };
                } else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_CONTENT'
                };
            }) : [];
        }
        function allowedMarksFor(validator) {
            const { items: items } = validator.props.marks;
            const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
            return marksSet;
        }
        function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
            const errorCode = 'REDUNDANT_MARKS';
            const currentMarks = prevEntity.marks || [];
            const newMarks = currentMarks.map((mark)=>{
                const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
                if (isUnsupportedNodeAttributeMark) return mark;
                return $0e02563a3c892ae7$var$unsupportedMarkContent(errorCode, mark, errorCallback);
            });
            if (newMarks.length) {
                newEntity.marks = newMarks;
                return {
                    valid: true,
                    entity: newEntity
                };
            } else return err('REDUNDANT_MARKS', 'redundant marks', {
                marks: Object.keys(currentMarks)
            });
        }
        function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.required) {
                if (!validatorSpec.required.every((prop)=>(0, (0, parcelRequire("asoRy")).isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
            }
            return result;
        }
        function textPropertyValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.props.text) {
                if ((0, (0, parcelRequire("asoRy")).isDefined)(prevEntity.text) && !$0e02563a3c892ae7$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
            }
            return result;
        }
        function contentLengthValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.props.content && prevEntity.content) {
                const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
                const length = prevEntity.content.length;
                if ((0, (0, parcelRequire("asoRy")).isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                    length: length,
                    requiredLength: minItems,
                    type: 'minimum'
                });
                else if ((0, (0, parcelRequire("asoRy")).isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                    length: length,
                    requiredLength: maxItems,
                    type: 'maximum'
                });
            }
            return result;
        }
        function invalidAttributesFor(validatorSpec, prevEntity) {
            let invalidAttrs = [];
            let validatorAttrs = {};
            if (validatorSpec.props && validatorSpec.props.attrs) {
                const attrOptions = (0, (0, parcelRequire("asoRy")).makeArray)(validatorSpec.props.attrs);
                for(let i = 0, length = attrOptions.length; i < length; ++i){
                    const attrOption = attrOptions[i];
                    if (attrOption && attrOption.props) [, invalidAttrs] = $0e02563a3c892ae7$var$partitionObject(attrOption.props, (key, spec)=>{
                        const valueToValidate = prevEntity.attrs[key];
                        return $0e02563a3c892ae7$export$66c739158ef99a42(spec, valueToValidate);
                    });
                    validatorAttrs = attrOption;
                    if (!invalidAttrs.length) break;
                }
            }
            return {
                invalidAttrs: invalidAttrs,
                validatorAttrs: validatorAttrs
            };
        }
        function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
            const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
            if (prevEntity.attrs) {
                if (!validatorSpecAllowsAttributes) {
                    if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                    const attrs = Object.keys(prevEntity.attrs);
                    return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
                }
                const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
                if (hasUnsupportedAttrs) {
                    if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                    return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
                }
            }
            return {
                valid: true,
                entity: prevEntity
            };
        }
        function validateAttributes(validatorSpec, prevEntity, attributes) {
            const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
            const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
            const validatorAttrs = invalidAttributesResult.validatorAttrs;
            const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
            const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
            const hasRedundantAttrs = redundantAttrs.length > 0;
            const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
            return {
                hasUnsupportedAttrs: hasUnsupportedAttrs,
                invalidAttrs: invalidAttrs,
                redundantAttrs: redundantAttrs
            };
        }
        function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
            const attr = invalidAttrs.concat(redundantAttrs);
            let result = {
                valid: true,
                entity: prevEntity
            };
            const message = $0e02563a3c892ae7$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
            const errorCode = 'UNSUPPORTED_ATTRIBUTES';
            newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
            result = {
                valid: true,
                entity: newEntity
            };
            return result;
        }
        function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
            let errorCode = 'INVALID_ATTRIBUTES';
            let message = $0e02563a3c892ae7$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
            const hasRedundantAttrs = redundantAttrs.length;
            const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
            if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
                errorCode = 'REDUNDANT_ATTRIBUTES';
                message = $0e02563a3c892ae7$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
            }
            const markValidationResult = {
                valid: true,
                originalMark: prevEntity,
                errorCode: errorCode,
                message: message
            };
            return {
                valid: false,
                marksValidationOutput: [
                    markValidationResult
                ]
            };
        }
        function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
            const message = $0e02563a3c892ae7$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
            const errorCode = 'REDUNDANT_ATTRIBUTES';
            const markValidationResult = {
                valid: true,
                originalMark: prevEntity,
                errorCode: errorCode,
                message: message
            };
            return {
                valid: false,
                marksValidationOutput: [
                    markValidationResult
                ]
            };
        }
        function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
            let invalidValues = {};
            for(let invalidAttr in invalidAttrs){
                invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
                if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
            }
            const unsupportedNodeAttributeValues = $0e02563a3c892ae7$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
            const finalEntity = {
                ...newEntity
            };
            if (finalEntity.marks) {
                if (!unsupportedNodeAttributeValues) return finalEntity.marks;
                const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
                if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
                else finalEntity.marks.push(unsupportedNodeAttributeValues);
                return finalEntity.marks;
            } else return [
                unsupportedNodeAttributeValues
            ];
        }
        function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            const [requiredProps, redundantProps] = $0e02563a3c892ae7$var$partitionObject(prevEntity, (k)=>(0, (0, parcelRequire("asoRy")).isDefined)(validatorSpec.props[k]));
            if (redundantProps.length) {
                if (mode === 'loose') {
                    newEntity = {
                        type: type
                    };
                    requiredProps.reduce((acc, p)=>(0, (0, parcelRequire("asoRy")).copy)(prevEntity, acc, p), newEntity);
                } else {
                    if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                        props: redundantProps
                    });
                }
            }
            return result;
        }
        function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
            let specBasedValidationResult = {
                hasValidated: false
            };
            const validatorSpec = validatorFor(spec, typeOptions);
            if (!validatorSpec) return specBasedValidationResult;
            const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
            if (!requiredPropertyValidatonResult.valid) return {
                hasValidated: true,
                result: requiredPropertyValidatonResult
            };
            if (!validatorSpec.props) {
                const props = Object.keys(prevEntity);
                if (props.length > 1) return {
                    hasValidated: true,
                    result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                        props: props
                    })
                };
                return specBasedValidationResult;
            }
            const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
            if (!textPropertyValidationResult.valid) return {
                hasValidated: true,
                result: textPropertyValidationResult
            };
            const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
            if (!contentLengthValidationResult.valid) return {
                hasValidated: true,
                result: contentLengthValidationResult
            };
            const [, missingProps] = $0e02563a3c892ae7$var$partitionObject(validatorSpec.props, (k, v)=>{
                const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
                return isOptional || (0, (0, parcelRequire("asoRy")).isDefined)(prevEntity[k]);
            });
            if (missingProps.length) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'required prop missing', {
                    props: missingProps
                })
            };
            const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
            if (!attributesValidationResult.valid) return {
                hasValidated: true,
                result: attributesValidationResult
            };
            if (isMark && attributesValidationResult.valid) return {
                hasValidated: true,
                result: attributesValidationResult
            };
            const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
            if (!extraPropsValidationResult.valid) return {
                hasValidated: true,
                result: extraPropsValidationResult
            };
            if (validatorSpec.props.content) {
                const contentValidatorSpec = validatorSpec.props.content;
                if (prevEntity.content) {
                    const validateChildNode = (child, index)=>{
                        if (child === undefined) return child;
                        const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                            let marksAreValid = true;
                            if (childEntity && childEntity.marks && marksValidationOutput) {
                                const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                                const finalMarks = marksValidationOutput.map((mr)=>{
                                    if (mr.valid) return mr.newMark;
                                    else {
                                        if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $0e02563a3c892ae7$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                        return;
                                    }
                                }).filter(Boolean);
                                if (finalMarks.length) childEntity.marks = finalMarks;
                                else {
                                    delete childEntity.marks;
                                    marksAreValid = false;
                                }
                            }
                            return {
                                valid: marksAreValid,
                                entity: childEntity
                            };
                        };
                        const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                        if (hasMultipleCombinationOfContentAllowed) {
                            const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, (0, parcelRequire("asoRy")).makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                            const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                            return entity;
                        }
                        const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some((spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                        if (allowedSpecsForEntity.length) {
                            if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                            const maybeArray = (0, (0, parcelRequire("asoRy")).makeArray)(allowedSpecsForEntity[0]);
                            const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                            if (allowedSpecsForChild.length === 0) return $0e02563a3c892ae7$var$invalidChildContent(child, errorCallback, validatorSpec);
                            let firstError;
                            let firstChild;
                            for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                                const allowedValueForCurrentSpec = [
                                    allowedSpecsForChild[i]
                                ];
                                const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                                if (valid) {
                                    const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                    const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                    const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                    if (marksAreValid && !unsupportedMarks.length) return entity;
                                    else firstChild = firstChild || newChildEntity;
                                } else firstChild = firstChild || newChildEntity;
                            } catch (error) {
                                firstError = firstError || error;
                            }
                            if (!errorCallback) throw firstError;
                            else return firstChild;
                        } else return $0e02563a3c892ae7$var$invalidChildContent(child, errorCallback, validatorSpec);
                    };
                    newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
                } else if (!contentValidatorSpec.optional) return {
                    hasValidated: true,
                    result: err('MISSING_PROPERTIES', 'missing `content` prop')
                };
            }
            if (prevEntity.marks) return {
                hasValidated: true,
                result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
            };
            return specBasedValidationResult;
        }
    }
});
parcelRegister("lgREk", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>(parcelRequire("5fjVx")).alignment);
    $parcel$export(module.exports, "annotation", ()=>(parcelRequire("5fjVx")).annotation);
    $parcel$export(module.exports, "backgroundColor", ()=>(parcelRequire("5fjVx")).backgroundColor);
    $parcel$export(module.exports, "blockCard", ()=>(parcelRequire("5fjVx")).blockCard);
    $parcel$export(module.exports, "block_content", ()=>(parcelRequire("5fjVx")).block_content);
    $parcel$export(module.exports, "blockquote", ()=>(parcelRequire("5fjVx")).blockquote);
    $parcel$export(module.exports, "bodiedExtension", ()=>(parcelRequire("5fjVx")).bodiedExtension);
    $parcel$export(module.exports, "bodiedExtension_with_marks", ()=>(parcelRequire("5fjVx")).bodiedExtension_with_marks);
    $parcel$export(module.exports, "border", ()=>(parcelRequire("5fjVx")).border);
    $parcel$export(module.exports, "breakout", ()=>(parcelRequire("5fjVx")).breakout);
    $parcel$export(module.exports, "bulletList", ()=>(parcelRequire("5fjVx")).bulletList);
    $parcel$export(module.exports, "caption", ()=>(parcelRequire("5fjVx")).caption);
    $parcel$export(module.exports, "code", ()=>(parcelRequire("5fjVx")).code);
    $parcel$export(module.exports, "codeBlock", ()=>(parcelRequire("5fjVx")).codeBlock);
    $parcel$export(module.exports, "codeBlock_with_marks", ()=>(parcelRequire("5fjVx")).codeBlock_with_marks);
    $parcel$export(module.exports, "codeBlock_with_no_marks", ()=>(parcelRequire("5fjVx")).codeBlock_with_no_marks);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>(parcelRequire("5fjVx")).confluenceInlineComment);
    $parcel$export(module.exports, "dataConsumer", ()=>(parcelRequire("5fjVx")).dataConsumer);
    $parcel$export(module.exports, "date", ()=>(parcelRequire("5fjVx")).date);
    $parcel$export(module.exports, "decisionItem", ()=>(parcelRequire("5fjVx")).decisionItem);
    $parcel$export(module.exports, "decisionList", ()=>(parcelRequire("5fjVx")).decisionList);
    $parcel$export(module.exports, "doc", ()=>(parcelRequire("5fjVx")).doc);
    $parcel$export(module.exports, "em", ()=>(parcelRequire("5fjVx")).em);
    $parcel$export(module.exports, "embedCard", ()=>(parcelRequire("5fjVx")).embedCard);
    $parcel$export(module.exports, "emoji", ()=>(parcelRequire("5fjVx")).emoji);
    $parcel$export(module.exports, "expand", ()=>(parcelRequire("5fjVx")).expand);
    $parcel$export(module.exports, "expand_with_breakout_mark", ()=>(parcelRequire("5fjVx")).expand_with_breakout_mark);
    $parcel$export(module.exports, "expand_with_no_mark", ()=>(parcelRequire("5fjVx")).expand_with_no_mark);
    $parcel$export(module.exports, "extension", ()=>(parcelRequire("5fjVx")).extension);
    $parcel$export(module.exports, "extensionFrame", ()=>(parcelRequire("5fjVx")).extensionFrame);
    $parcel$export(module.exports, "extension_with_marks", ()=>(parcelRequire("5fjVx")).extension_with_marks);
    $parcel$export(module.exports, "fragment", ()=>(parcelRequire("5fjVx")).fragment);
    $parcel$export(module.exports, "hardBreak", ()=>(parcelRequire("5fjVx")).hardBreak);
    $parcel$export(module.exports, "heading", ()=>(parcelRequire("5fjVx")).heading);
    $parcel$export(module.exports, "heading_with_alignment", ()=>(parcelRequire("5fjVx")).heading_with_alignment);
    $parcel$export(module.exports, "heading_with_indentation", ()=>(parcelRequire("5fjVx")).heading_with_indentation);
    $parcel$export(module.exports, "heading_with_no_marks", ()=>(parcelRequire("5fjVx")).heading_with_no_marks);
    $parcel$export(module.exports, "indentation", ()=>(parcelRequire("5fjVx")).indentation);
    $parcel$export(module.exports, "inlineCard", ()=>(parcelRequire("5fjVx")).inlineCard);
    $parcel$export(module.exports, "inlineExtension", ()=>(parcelRequire("5fjVx")).inlineExtension);
    $parcel$export(module.exports, "inlineExtension_with_marks", ()=>(parcelRequire("5fjVx")).inlineExtension_with_marks);
    $parcel$export(module.exports, "inline_content", ()=>(parcelRequire("5fjVx")).inline_content);
    $parcel$export(module.exports, "layoutColumn", ()=>(parcelRequire("5fjVx")).layoutColumn);
    $parcel$export(module.exports, "layoutSection", ()=>(parcelRequire("5fjVx")).layoutSection);
    $parcel$export(module.exports, "layoutSection_full", ()=>(parcelRequire("5fjVx")).layoutSection_full);
    $parcel$export(module.exports, "layoutSection_with_single_column", ()=>(parcelRequire("5fjVx")).layoutSection_with_single_column);
    $parcel$export(module.exports, "link", ()=>(parcelRequire("5fjVx")).link);
    $parcel$export(module.exports, "listItem", ()=>(parcelRequire("5fjVx")).listItem);
    $parcel$export(module.exports, "media", ()=>(parcelRequire("5fjVx")).media);
    $parcel$export(module.exports, "mediaGroup", ()=>(parcelRequire("5fjVx")).mediaGroup);
    $parcel$export(module.exports, "mediaInline", ()=>(parcelRequire("5fjVx")).mediaInline);
    $parcel$export(module.exports, "mediaSingle", ()=>(parcelRequire("5fjVx")).mediaSingle);
    $parcel$export(module.exports, "mediaSingle_caption", ()=>(parcelRequire("5fjVx")).mediaSingle_caption);
    $parcel$export(module.exports, "mediaSingle_full", ()=>(parcelRequire("5fjVx")).mediaSingle_full);
    $parcel$export(module.exports, "mention", ()=>(parcelRequire("5fjVx")).mention);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>(parcelRequire("5fjVx")).multiBodiedExtension);
    $parcel$export(module.exports, "nestedExpand", ()=>(parcelRequire("5fjVx")).nestedExpand);
    $parcel$export(module.exports, "nestedExpand_content", ()=>(parcelRequire("5fjVx")).nestedExpand_content);
    $parcel$export(module.exports, "nestedExpand_with_no_marks", ()=>(parcelRequire("5fjVx")).nestedExpand_with_no_marks);
    $parcel$export(module.exports, "non_nestable_block_content", ()=>(parcelRequire("5fjVx")).non_nestable_block_content);
    $parcel$export(module.exports, "orderedList", ()=>(parcelRequire("5fjVx")).orderedList);
    $parcel$export(module.exports, "panel", ()=>(parcelRequire("5fjVx")).panel);
    $parcel$export(module.exports, "panel_with_nested_blockquote", ()=>(parcelRequire("5fjVx")).panel_with_nested_blockquote);
    $parcel$export(module.exports, "paragraph", ()=>(parcelRequire("5fjVx")).paragraph);
    $parcel$export(module.exports, "paragraph_with_alignment", ()=>(parcelRequire("5fjVx")).paragraph_with_alignment);
    $parcel$export(module.exports, "paragraph_with_indentation", ()=>(parcelRequire("5fjVx")).paragraph_with_indentation);
    $parcel$export(module.exports, "paragraph_with_no_marks", ()=>(parcelRequire("5fjVx")).paragraph_with_no_marks);
    $parcel$export(module.exports, "placeholder", ()=>(parcelRequire("5fjVx")).placeholder);
    $parcel$export(module.exports, "rule", ()=>(parcelRequire("5fjVx")).rule);
    $parcel$export(module.exports, "status", ()=>(parcelRequire("5fjVx")).status);
    $parcel$export(module.exports, "strike", ()=>(parcelRequire("5fjVx")).strike);
    $parcel$export(module.exports, "strong", ()=>(parcelRequire("5fjVx")).strong);
    $parcel$export(module.exports, "subsup", ()=>(parcelRequire("5fjVx")).subsup);
    $parcel$export(module.exports, "table", ()=>(parcelRequire("5fjVx")).table);
    $parcel$export(module.exports, "tableCell", ()=>(parcelRequire("5fjVx")).tableCell);
    $parcel$export(module.exports, "tableHeader", ()=>(parcelRequire("5fjVx")).tableHeader);
    $parcel$export(module.exports, "tableRow", ()=>(parcelRequire("5fjVx")).tableRow);
    $parcel$export(module.exports, "taskItem", ()=>(parcelRequire("5fjVx")).taskItem);
    $parcel$export(module.exports, "taskList", ()=>(parcelRequire("5fjVx")).taskList);
    $parcel$export(module.exports, "text", ()=>(parcelRequire("5fjVx")).text);
    $parcel$export(module.exports, "textColor", ()=>(parcelRequire("5fjVx")).textColor);
    $parcel$export(module.exports, "text_code_inline", ()=>(parcelRequire("5fjVx")).text_code_inline);
    $parcel$export(module.exports, "text_formatted", ()=>(parcelRequire("5fjVx")).text_formatted);
    $parcel$export(module.exports, "text_link_inline", ()=>(parcelRequire("5fjVx")).text_link_inline);
    $parcel$export(module.exports, "underline", ()=>(parcelRequire("5fjVx")).underline);
    var $5fjVx;
});
parcelRegister("5fjVx", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
    $parcel$export(module.exports, "text", ()=>$3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
    $parcel$export(module.exports, "codeBlock", ()=>$3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "codeBlock_with_marks", ()=>$3d1dcf8b9eccd1a7$export$e6744655acd74d98);
    $parcel$export(module.exports, "codeBlock_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$6e3671492ca8dabf);
    $parcel$export(module.exports, "mediaSingle", ()=>$3d1dcf8b9eccd1a7$export$969fe3781ca15058);
    $parcel$export(module.exports, "media", ()=>$3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "link", ()=>$3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "annotation", ()=>$3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
    $parcel$export(module.exports, "border", ()=>$3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
    $parcel$export(module.exports, "hardBreak", ()=>$3d1dcf8b9eccd1a7$export$371da9dd35aba193);
    $parcel$export(module.exports, "mention", ()=>$3d1dcf8b9eccd1a7$export$db83999c14438df4);
    $parcel$export(module.exports, "emoji", ()=>$3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
    $parcel$export(module.exports, "date", ()=>$3d1dcf8b9eccd1a7$export$324d90190a8b822a);
    $parcel$export(module.exports, "placeholder", ()=>$3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "inlineCard", ()=>$3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
    $parcel$export(module.exports, "status", ()=>$3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
    $parcel$export(module.exports, "text_formatted", ()=>$3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
    $parcel$export(module.exports, "text_code_inline", ()=>$3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
    $parcel$export(module.exports, "em", ()=>$3d1dcf8b9eccd1a7$export$c63c6f932822f543);
    $parcel$export(module.exports, "strong", ()=>$3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
    $parcel$export(module.exports, "strike", ()=>$3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
    $parcel$export(module.exports, "subsup", ()=>$3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
    $parcel$export(module.exports, "underline", ()=>$3d1dcf8b9eccd1a7$export$425327af25286e5e);
    $parcel$export(module.exports, "textColor", ()=>$3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "backgroundColor", ()=>$3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
    $parcel$export(module.exports, "code", ()=>$3d1dcf8b9eccd1a7$export$6565f9f03506010b);
    $parcel$export(module.exports, "caption", ()=>$3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
    $parcel$export(module.exports, "mediaSingle_caption", ()=>$3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
    $parcel$export(module.exports, "mediaSingle_full", ()=>$3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
    $parcel$export(module.exports, "text_link_inline", ()=>$3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
    $parcel$export(module.exports, "inlineExtension", ()=>$3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
    $parcel$export(module.exports, "inlineExtension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$e37f10815f36843d);
    $parcel$export(module.exports, "mediaInline", ()=>$3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
    $parcel$export(module.exports, "inline_content", ()=>$3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
    $parcel$export(module.exports, "paragraph", ()=>$3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
    $parcel$export(module.exports, "paragraph_with_alignment", ()=>$3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
    $parcel$export(module.exports, "paragraph_with_indentation", ()=>$3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
    $parcel$export(module.exports, "paragraph_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
    $parcel$export(module.exports, "taskItem", ()=>$3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
    $parcel$export(module.exports, "taskList", ()=>$3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
    $parcel$export(module.exports, "decisionItem", ()=>$3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
    $parcel$export(module.exports, "decisionList", ()=>$3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
    $parcel$export(module.exports, "bulletList", ()=>$3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
    $parcel$export(module.exports, "listItem", ()=>$3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "orderedList", ()=>$3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
    $parcel$export(module.exports, "mediaGroup", ()=>$3d1dcf8b9eccd1a7$export$2855e964765eac9);
    $parcel$export(module.exports, "blockquote", ()=>$3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
    $parcel$export(module.exports, "embedCard", ()=>$3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
    $parcel$export(module.exports, "extension", ()=>$3d1dcf8b9eccd1a7$export$1b45514b112dd749);
    $parcel$export(module.exports, "extension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$15be7c145cec614a);
    $parcel$export(module.exports, "heading", ()=>$3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
    $parcel$export(module.exports, "heading_with_indentation", ()=>$3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
    $parcel$export(module.exports, "heading_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
    $parcel$export(module.exports, "heading_with_alignment", ()=>$3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
    $parcel$export(module.exports, "rule", ()=>$3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
    $parcel$export(module.exports, "panel", ()=>$3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
    $parcel$export(module.exports, "panel_with_nested_blockquote", ()=>$3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3);
    $parcel$export(module.exports, "nestedExpand_content", ()=>$3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
    $parcel$export(module.exports, "nestedExpand_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
    $parcel$export(module.exports, "alignment", ()=>$3d1dcf8b9eccd1a7$export$8e53000a4ec837);
    $parcel$export(module.exports, "indentation", ()=>$3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
    $parcel$export(module.exports, "dataConsumer", ()=>$3d1dcf8b9eccd1a7$export$3024f02c495408d6);
    $parcel$export(module.exports, "fragment", ()=>$3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "tableCell", ()=>$3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "nestedExpand", ()=>$3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
    $parcel$export(module.exports, "tableHeader", ()=>$3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
    $parcel$export(module.exports, "tableRow", ()=>$3d1dcf8b9eccd1a7$export$ce666bf02318c957);
    $parcel$export(module.exports, "table", ()=>$3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "non_nestable_block_content", ()=>$3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
    $parcel$export(module.exports, "bodiedExtension", ()=>$3d1dcf8b9eccd1a7$export$27903d543b563e39);
    $parcel$export(module.exports, "bodiedExtension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
    $parcel$export(module.exports, "expand", ()=>$3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expand_with_no_mark", ()=>$3d1dcf8b9eccd1a7$export$1358dbfffec33cd4);
    $parcel$export(module.exports, "expand_with_breakout_mark", ()=>$3d1dcf8b9eccd1a7$export$c30e395ad81940c1);
    $parcel$export(module.exports, "block_content", ()=>$3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
    $parcel$export(module.exports, "layoutColumn", ()=>$3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
    $parcel$export(module.exports, "layoutSection", ()=>$3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSection_with_single_column", ()=>$3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
    $parcel$export(module.exports, "layoutSection_full", ()=>$3d1dcf8b9eccd1a7$export$941b63fbd931e449);
    $parcel$export(module.exports, "extensionFrame", ()=>$3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>$3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
    $parcel$export(module.exports, "breakout", ()=>$3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
    $parcel$export(module.exports, "doc", ()=>$3d1dcf8b9eccd1a7$export$2a111da947c407d2);
    const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'blockCard'
                ]
            },
            attrs: [
                {
                    props: {
                        url: {
                            type: 'string',
                            optional: true,
                            validatorFn: 'safeUrl'
                        },
                        datasource: {
                            props: {
                                id: {
                                    type: 'string'
                                },
                                parameters: {
                                    type: 'object'
                                },
                                views: {
                                    items: [
                                        {
                                            props: {
                                                properties: {
                                                    optional: true,
                                                    type: 'object'
                                                },
                                                type: {
                                                    type: 'string'
                                                }
                                            }
                                        }
                                    ],
                                    minItems: 1,
                                    type: 'array'
                                }
                            }
                        },
                        width: {
                            type: 'number',
                            optional: true
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ],
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        url: {
                            type: 'string',
                            validatorFn: 'safeUrl'
                        }
                    }
                },
                {
                    props: {
                        data: {
                            type: 'object'
                        }
                    }
                }
            ]
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'text'
                ]
            },
            text: {
                type: 'string',
                minLength: 1
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'codeBlock'
                ]
            },
            attrs: {
                props: {
                    language: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'text',
                        {
                            props: {
                                marks: {
                                    items: [],
                                    maxItems: 0,
                                    optional: true,
                                    type: 'array'
                                }
                            }
                        }
                    ]
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e6744655acd74d98 = [
        'codeBlock',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$6e3671492ca8dabf = [
        'codeBlock',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaSingle'
                ]
            },
            attrs: [
                {
                    props: {
                        width: {
                            type: 'number',
                            minimum: 0,
                            maximum: 100,
                            optional: true
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ]
                        },
                        widthType: {
                            type: 'enum',
                            values: [
                                'percentage'
                            ],
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        width: {
                            type: 'number',
                            minimum: 0
                        },
                        widthType: {
                            type: 'enum',
                            values: [
                                'pixel'
                            ]
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ]
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'media'
                ]
            },
            attrs: [
                {
                    props: {
                        type: {
                            type: 'enum',
                            values: [
                                'link',
                                'file'
                            ]
                        },
                        id: {
                            minLength: 1,
                            type: 'string'
                        },
                        alt: {
                            type: 'string',
                            optional: true
                        },
                        collection: {
                            type: 'string'
                        },
                        height: {
                            type: 'number',
                            optional: true
                        },
                        occurrenceKey: {
                            minLength: 1,
                            type: 'string',
                            optional: true
                        },
                        width: {
                            type: 'number',
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        type: {
                            type: 'enum',
                            values: [
                                'external'
                            ]
                        },
                        alt: {
                            type: 'string',
                            optional: true
                        },
                        height: {
                            type: 'number',
                            optional: true
                        },
                        width: {
                            type: 'number',
                            optional: true
                        },
                        url: {
                            type: 'string'
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'annotation',
                        'border'
                    ]
                ]
            }
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'link'
                ]
            },
            attrs: {
                props: {
                    href: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    title: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string',
                        optional: true
                    },
                    occurrenceKey: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'annotation'
                ]
            },
            attrs: {
                props: {
                    id: {
                        type: 'string'
                    },
                    annotationType: {
                        type: 'enum',
                        values: [
                            'inlineComment'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'border'
                ]
            },
            attrs: {
                props: {
                    size: {
                        type: 'number',
                        minimum: 1,
                        maximum: 3
                    },
                    color: {
                        pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'hardBreak'
                ]
            },
            attrs: {
                props: {
                    text: {
                        type: 'enum',
                        values: [
                            '\n'
                        ],
                        optional: true
                    }
                },
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mention'
                ]
            },
            attrs: {
                props: {
                    id: {
                        type: 'string'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    accessLevel: {
                        type: 'string',
                        optional: true
                    },
                    userType: {
                        type: 'enum',
                        values: [
                            'DEFAULT',
                            'SPECIAL',
                            'APP'
                        ],
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'emoji'
                ]
            },
            attrs: {
                props: {
                    shortName: {
                        type: 'string'
                    },
                    id: {
                        type: 'string',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'date'
                ]
            },
            attrs: {
                props: {
                    timestamp: {
                        minLength: 1,
                        type: 'string'
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'placeholder'
                ]
            },
            attrs: {
                props: {
                    text: {
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'inlineCard'
                ]
            },
            attrs: [
                {
                    props: {
                        url: {
                            type: 'string',
                            validatorFn: 'safeUrl'
                        }
                    }
                },
                {
                    props: {
                        data: {
                            type: 'object'
                        }
                    }
                }
            ],
            marks: {
                items: [
                    'annotation'
                ],
                optional: true,
                type: 'array'
            }
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'status'
                ]
            },
            attrs: {
                props: {
                    text: {
                        minLength: 1,
                        type: 'string'
                    },
                    color: {
                        type: 'enum',
                        values: [
                            'neutral',
                            'purple',
                            'blue',
                            'red',
                            'yellow',
                            'green'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    style: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'link',
                            'em',
                            'strong',
                            'strike',
                            'subsup',
                            'underline',
                            'textColor',
                            'annotation',
                            'backgroundColor',
                            null
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'code',
                            'link',
                            'annotation'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'em'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'strong'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'strike'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'subsup'
                ]
            },
            attrs: {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'sub',
                            'sup'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'underline'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'textColor'
                ]
            },
            attrs: {
                props: {
                    color: {
                        type: 'string',
                        pattern: '^#[0-9a-fA-F]{6}$'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'backgroundColor'
                ]
            },
            attrs: {
                props: {
                    color: {
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'confluenceInlineComment'
                ]
            },
            attrs: {
                props: {
                    reference: {
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'code'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'caption'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'hardBreak',
                        'mention',
                        'emoji',
                        'date',
                        'placeholder',
                        'inlineCard',
                        'status',
                        'text_formatted',
                        'text_code_inline'
                    ]
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    isTupleLike: true,
                    items: [
                        'media',
                        'caption'
                    ],
                    minItems: 1,
                    maxItems: 2,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'media'
                    ],
                    minItems: 1,
                    maxItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'media'
                    ],
                    minItems: 1,
                    maxItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'link'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'inlineExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
        'inlineExtension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaInline'
                ]
            },
            attrs: {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file',
                            'image'
                        ],
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    data: {
                        type: 'object',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'annotation',
                        'border'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
        'text_formatted',
        'text_code_inline',
        'date',
        'emoji',
        'hardBreak',
        'inlineCard',
        'mention',
        'placeholder',
        'status',
        'inlineExtension_with_marks',
        'mediaInline'
    ];
    const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'paragraph'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'alignment'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'indentation'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'taskItem'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    },
                    state: {
                        type: 'enum',
                        values: [
                            'TODO',
                            'DONE'
                        ]
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'taskList'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'taskItem',
                    [
                        'taskItem',
                        'taskList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'decisionItem'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    },
                    state: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'decisionList'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'decisionItem'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
        'listItem',
        {
            props: {
                content: {
                    type: 'array',
                    isTupleLike: true,
                    items: [
                        [
                            'paragraph_with_no_marks',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock_with_no_marks',
                            'decisionList'
                        ],
                        [
                            'paragraph_with_no_marks',
                            'bulletList',
                            'orderedList',
                            'taskList',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock_with_no_marks',
                            'decisionList'
                        ]
                    ],
                    minItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'bulletList'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'listItem',
                        'listItem_with_nested_decision'
                    ]
                ],
                minItems: 1
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'listItem'
                ]
            },
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'orderedList'
                ]
            },
            attrs: {
                props: {
                    order: {
                        type: 'number',
                        minimum: 0,
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'listItem',
                        'listItem_with_nested_decision'
                    ]
                ],
                minItems: 1
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaGroup'
                ]
            },
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'blockquote'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'orderedList',
                        'bulletList',
                        'codeBlock_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'embedCard'
                ]
            },
            attrs: {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    width: {
                        type: 'number',
                        maximum: 100,
                        minimum: 0,
                        optional: true
                    },
                    originalHeight: {
                        type: 'number',
                        optional: true
                    },
                    originalWidth: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'extension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
        'extension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'heading'
                ]
            },
            attrs: {
                props: {
                    level: {
                        type: 'number',
                        minimum: 1,
                        maximum: 6
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'indentation'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'alignment'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'rule'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'panel'
                ]
            },
            attrs: {
                props: {
                    panelType: {
                        type: 'enum',
                        values: [
                            'info',
                            'note',
                            'tip',
                            'warning',
                            'error',
                            'success',
                            'custom'
                        ]
                    },
                    panelIcon: {
                        type: 'string',
                        optional: true
                    },
                    panelIconId: {
                        type: 'string',
                        optional: true
                    },
                    panelIconText: {
                        type: 'string',
                        optional: true
                    },
                    panelColor: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'taskList',
                        'rule',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3 = [
        'panel',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        [
                            'paragraph_with_no_marks',
                            'heading_with_no_marks',
                            'bulletList',
                            'orderedList',
                            'blockCard',
                            'mediaGroup',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock_with_no_marks',
                            'taskList',
                            'rule',
                            'decisionList',
                            'blockquote'
                        ]
                    ],
                    minItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
        type: 'array',
        items: [
            [
                'paragraph_with_no_marks',
                'heading_with_no_marks',
                'mediaSingle_caption',
                'mediaSingle_full',
                'mediaGroup',
                'codeBlock_with_no_marks',
                'bulletList',
                'orderedList',
                'taskList',
                'decisionList',
                'rule',
                'panel',
                'blockquote'
            ]
        ],
        minItems: 1,
        allowUnsupportedBlock: true
    };
    const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
        'nestedExpand',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'alignment'
                ]
            },
            attrs: {
                props: {
                    align: {
                        type: 'enum',
                        values: [
                            'center',
                            'end'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'indentation'
                ]
            },
            attrs: {
                props: {
                    level: {
                        type: 'number',
                        minimum: 1,
                        maximum: 6
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'dataConsumer'
                ]
            },
            attrs: {
                props: {
                    sources: {
                        type: 'array',
                        items: [
                            {
                                type: 'string'
                            }
                        ],
                        minItems: 1
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'fragment'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        minLength: 1,
                        type: 'string'
                    },
                    name: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableCell'
                ]
            },
            attrs: {
                props: {
                    colspan: {
                        type: 'number',
                        optional: true
                    },
                    rowspan: {
                        type: 'number',
                        optional: true
                    },
                    colwidth: {
                        type: 'array',
                        items: [
                            {
                                type: 'number'
                            }
                        ],
                        optional: true
                    },
                    background: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'codeBlock_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup',
                        'decisionList',
                        'taskList',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'nestedExpand'
                ]
            },
            attrs: {
                props: {
                    title: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: 'nestedExpand_content'
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableHeader'
                ]
            },
            attrs: {
                props: {
                    colspan: {
                        type: 'number',
                        optional: true
                    },
                    rowspan: {
                        type: 'number',
                        optional: true
                    },
                    colwidth: {
                        type: 'array',
                        items: [
                            {
                                type: 'number'
                            }
                        ],
                        optional: true
                    },
                    background: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'codeBlock_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup',
                        'decisionList',
                        'taskList',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks',
                        'nestedExpand'
                    ]
                ],
                minItems: 1
            }
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableRow'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'tableCell',
                        'tableHeader'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'table'
                ]
            },
            attrs: {
                props: {
                    displayMode: {
                        type: 'enum',
                        values: [
                            'default',
                            'fixed'
                        ],
                        optional: true
                    },
                    isNumberColumnEnabled: {
                        type: 'boolean',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'align-end',
                            'align-start',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        minLength: 1,
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'tableRow'
                ],
                minItems: 1
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'fragment'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
        'paragraph_with_no_marks',
        'panel',
        'blockquote',
        'orderedList',
        'bulletList',
        'rule',
        'heading_with_no_marks',
        'codeBlock_with_no_marks',
        'mediaGroup',
        'mediaSingle_caption',
        'mediaSingle_full',
        'decisionList',
        'taskList',
        'table',
        'blockCard',
        'embedCard',
        'extension_with_marks'
    ];
    const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'bodiedExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'non_nestable_block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
        'bodiedExtension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'expand'
                ]
            },
            attrs: {
                props: {
                    title: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'codeBlock_with_no_marks',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'decisionList',
                        'taskList',
                        'table',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$1358dbfffec33cd4 = [
        'expand',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c30e395ad81940c1 = [
        'expand',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
        'blockCard',
        'paragraph_with_no_marks',
        'paragraph_with_alignment',
        'paragraph_with_indentation',
        'mediaSingle_caption',
        'mediaSingle_full',
        'codeBlock_with_no_marks',
        'taskList',
        'bulletList',
        'orderedList',
        'heading_with_no_marks',
        'heading_with_alignment',
        'heading_with_indentation',
        'mediaGroup',
        'decisionList',
        'rule',
        'panel',
        'panel_with_nested_blockquote',
        'blockquote',
        'extension_with_marks',
        'embedCard',
        'table',
        'expand_with_no_mark',
        'bodiedExtension_with_marks'
    ];
    const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutColumn'
                ]
            },
            attrs: {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ]
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
        'layoutSection',
        {
            props: {
                attrs: {
                    props: {
                        columnRuleStyle: {
                            type: 'enum',
                            values: [
                                'solid'
                            ],
                            optional: true
                        }
                    },
                    optional: true
                },
                content: {
                    type: 'array',
                    items: [
                        'layoutColumn'
                    ],
                    minItems: 1,
                    maxItems: 5,
                    allowUnsupportedBlock: true
                },
                type: {
                    type: 'enum',
                    values: [
                        'layoutSection'
                    ]
                },
                marks: {
                    items: [
                        'breakout'
                    ],
                    optional: true,
                    type: 'array'
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
        'layoutSection',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'layoutColumn'
                    ],
                    minItems: 2,
                    maxItems: 3,
                    allowUnsupportedBlock: true
                },
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                },
                type: {
                    type: 'enum',
                    values: [
                        'layoutSection'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'extensionFrame'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'codeBlock_with_no_marks',
                        'mediaGroup',
                        'mediaSingle_full',
                        'mediaSingle_caption',
                        'decisionList',
                        'taskList',
                        'table',
                        'extension_with_marks',
                        'bodiedExtension_with_marks',
                        'blockCard',
                        'embedCard'
                    ]
                ],
                minItems: 1
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'multiBodiedExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        type: 'string',
                        minLength: 1
                    },
                    extensionType: {
                        type: 'string',
                        minLength: 1
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'default',
                            'wide',
                            'full-width'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true,
                        minLength: 1
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'extensionFrame'
                ]
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
        'multiBodiedExtension'
    ];
    const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'breakout'
                ]
            },
            attrs: {
                props: {
                    mode: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width'
                        ]
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'doc'
                ]
            },
            version: {
                type: 'enum',
                values: [
                    1
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'blockCard',
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'paragraph_with_indentation',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks',
                        'taskList',
                        'bulletList',
                        'orderedList',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'mediaGroup',
                        'decisionList',
                        'rule',
                        'panel',
                        'panel_with_nested_blockquote',
                        'blockquote',
                        'extension_with_marks',
                        'embedCard',
                        'table',
                        'expand_with_no_mark',
                        'bodiedExtension_with_marks',
                        'codeBlock_with_marks',
                        'layoutSection_with_single_column',
                        'layoutSection_full',
                        'multiBodiedExtension',
                        'expand_with_breakout_mark'
                    ]
                ],
                allowUnsupportedBlock: true
            }
        }
    };
});
parcelRegister("asoRy", function(module, exports) {
    $parcel$export(module.exports, "isDefined", ()=>$13cb3ca4773dfa57$export$4e62c701997796c1);
    $parcel$export(module.exports, "isNumber", ()=>$13cb3ca4773dfa57$export$7e4aa119212bc614);
    $parcel$export(module.exports, "isInteger", ()=>$13cb3ca4773dfa57$export$a287f47fed4544b8);
    $parcel$export(module.exports, "isBoolean", ()=>$13cb3ca4773dfa57$export$f9ce7b637dfbe238);
    $parcel$export(module.exports, "isString", ()=>$13cb3ca4773dfa57$export$844ec244b1367d54);
    $parcel$export(module.exports, "isPlainObject", ()=>$13cb3ca4773dfa57$export$53b83ca8eaab0383);
    $parcel$export(module.exports, "copy", ()=>$13cb3ca4773dfa57$export$784d13d8ee351f07);
    $parcel$export(module.exports, "makeArray", ()=>$13cb3ca4773dfa57$export$7b85fd78dd236198);
    const $13cb3ca4773dfa57$export$4e62c701997796c1 = (x)=>x != null;
    const $13cb3ca4773dfa57$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
    const $13cb3ca4773dfa57$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
    const $13cb3ca4773dfa57$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
    const $13cb3ca4773dfa57$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
    const $13cb3ca4773dfa57$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
    const $13cb3ca4773dfa57$export$784d13d8ee351f07 = (source, dest, key)=>{
        dest[key] = source[key];
        return dest;
    };
    const $13cb3ca4773dfa57$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
            maybeArray
        ];
});
parcelRegister("fr2tu", function(module, exports) {
    $parcel$export(module.exports, "validatorFnMap", ()=>$33f6c40f57db705e$export$d1b377ca77ac267d);
    var $iZOJ9;
    const $33f6c40f57db705e$export$d1b377ca77ac267d = {
        safeUrl: (0, (0, parcelRequire("iZOJ9")).isSafeUrl)
    };
});
parcelRegister("3bwMs", function(module, exports) {
    $parcel$export(module.exports, "trackUnsupportedContentLevels", ()=>$bdd9513321e2e0d2$export$a43de96edd8d0a0);
    var $cZe8H;
    var $iOW5z;
    var $6SKbt;
    var $4la1F;
    let $bdd9513321e2e0d2$var$rendersMap = {};
    const $bdd9513321e2e0d2$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
        try {
            const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, (0, parcelRequire("iOW5z")).getUnsupportedContentLevelData)(item.doc, thresholds);
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    appearance: (0, (0, parcelRequire("cZe8H")).getAnalyticsAppearance)(item.appearance),
                    platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                    unsupportedContentLevelSeverity: severity,
                    unsupportedContentLevelPercentage: percentage,
                    unsupportedNodesCount: unsupportedNodes,
                    supportedNodesCount: supportedNodes,
                    unsupportedNodeTypeCount: unsupportedNodeTypeCount
                },
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL
            });
        } catch (err) {
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("6SKbt")).ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
                actionSubject: (0, (0, parcelRequire("6SKbt")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("4la1F")).PLATFORM).WEB,
                    error: err instanceof Error ? err.message : String(err)
                },
                eventType: (0, (0, parcelRequire("6SKbt")).EVENT_TYPE).OPERATIONAL
            });
        }
    };
    const $bdd9513321e2e0d2$var$schedule = (fn)=>{
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn);
        else setTimeout(fn, 0);
    };
    const $bdd9513321e2e0d2$var$DEFAULT_SAMPLING_RATE = 100;
    const $bdd9513321e2e0d2$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
        const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
        const appearance = item.appearance ?? 'unknown';
        if (!$bdd9513321e2e0d2$var$rendersMap[appearance]) $bdd9513321e2e0d2$var$rendersMap[appearance] = new Set();
        const didProcessRenderer = $bdd9513321e2e0d2$var$rendersMap[appearance].has(item.rendererId);
        if (didProcessRenderer) return;
        $bdd9513321e2e0d2$var$rendersMap[appearance].add(item.rendererId);
        const sampleRate = samplingRates && samplingRates[appearance] || $bdd9513321e2e0d2$var$DEFAULT_SAMPLING_RATE;
        if ($bdd9513321e2e0d2$var$rendersMap[appearance].size === 1) $bdd9513321e2e0d2$var$schedule(()=>$bdd9513321e2e0d2$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
        if ($bdd9513321e2e0d2$var$rendersMap[appearance].size % sampleRate === 0) $bdd9513321e2e0d2$var$rendersMap[appearance] = new Set();
    };
});
parcelRegister("iOW5z", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedContentLevelData", ()=>$d9cc09ec5879a72c$export$484b83e0462998d);
    var $ayoEj;
    var $d9cc09ec5879a72c$export$6632e71a22d31bf1;
    (function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    })($d9cc09ec5879a72c$export$6632e71a22d31bf1 || ($d9cc09ec5879a72c$export$6632e71a22d31bf1 = {}));
    const $d9cc09ec5879a72c$export$f9f8a29778652c3e = {
        DEGRADED: 10,
        BLOCKING: 25
    };
    const $d9cc09ec5879a72c$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
        return {
            degraded: customThresholds?.degraded || $d9cc09ec5879a72c$export$f9f8a29778652c3e.DEGRADED,
            blocking: customThresholds?.blocking || $d9cc09ec5879a72c$export$f9f8a29778652c3e.BLOCKING
        };
    };
    const $d9cc09ec5879a72c$var$countSupportedUnsupportedNodes = (validDocument)=>{
        let unsupportedNodes = 0;
        let supportedNodes = 0;
        const unsupportedNodeTypeCount = {};
        const unsupportedNodeTypes = [
            'unsupportedInline',
            'unsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceUnsupportedBlock'
        ];
        (0, (0, parcelRequire("ayoEj")).traverse)(validDocument, {
            any: (node)=>{
                if (unsupportedNodeTypes.includes(node.type)) {
                    const originalNode = node.attrs?.originalValue;
                    if (originalNode) (0, (0, parcelRequire("ayoEj")).traverse)(originalNode, {
                        any: (unsupportedNode, parent)=>{
                            unsupportedNodes++;
                            const parentType = parent.parent?.node?.type ?? 'unknown';
                            const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                            unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                        }
                    });
                    return false;
                } else supportedNodes++;
            }
        });
        return {
            unsupportedNodes: unsupportedNodes,
            supportedNodes: supportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        };
    };
    const $d9cc09ec5879a72c$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
        if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
        if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
        return "normal";
    };
    const $d9cc09ec5879a72c$export$484b83e0462998d = (validDocument, customThresholds)=>{
        const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $d9cc09ec5879a72c$var$countSupportedUnsupportedNodes(validDocument);
        const thresholds = $d9cc09ec5879a72c$var$buildUnsupportedContentLevelThresholds(customThresholds);
        const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
        const severity = $d9cc09ec5879a72c$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
        return {
            severity: severity,
            percentage: percentage,
            counts: {
                supportedNodes: supportedNodes,
                unsupportedNodes: unsupportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            }
        };
    };
});
parcelRegister("hQzt3", function(module, exports) {
    $parcel$export(module.exports, "transformMediaLinkMarks", ()=>$decc27377fc16df6$export$6528700f3fa2fe2a);
    var $ayoEj;
    const $decc27377fc16df6$export$6528700f3fa2fe2a = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("ayoEj")).traverse)(adf, {
            mediaSingle: (node)=>{
                if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
                let linkMark = null;
                node.marks.forEach((mark, i)=>{
                    if (mark.type === 'link') {
                        linkMark = mark;
                        node.marks?.splice(i, 1);
                        isTransformed = true;
                    }
                });
                if (node.marks.length === 0) delete node.marks;
                if (linkMark) {
                    const mediaNode = node.content[0];
                    if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                    else if (!mediaNode.marks) mediaNode.marks = [
                        linkMark
                    ];
                }
                return node;
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("2gO4q", function(module, exports) {
    $parcel$export(module.exports, "countNodes", ()=>$3cc5be4528494e73$export$1daf15cbaf649dad);
    var $UqDUu;
    function $3cc5be4528494e73$export$1daf15cbaf649dad(adfDocument) {
        return (0, (0, parcelRequire("UqDUu")).reduce)(adfDocument, (acc, node)=>{
            acc[node.type] = (acc[node.type] || 0) + 1;
            return acc;
        }, {});
    }
});
parcelRegister("UqDUu", function(module, exports) {
    $parcel$export(module.exports, "reduce", ()=>$ca8c7f6bd569ac29$export$533b26079ad0b4b);
    var $ayoEj;
    function $ca8c7f6bd569ac29$export$533b26079ad0b4b(adf, callback, initial) {
        let result = initial;
        (0, (0, parcelRequire("ayoEj")).traverse)(adf, {
            any: (node)=>{
                result = callback(result, node);
            }
        });
        return result;
    }
});
parcelRegister("2L3dU", function(module, exports) {
    $parcel$export(module.exports, "TruncatedWrapper", ()=>$d70c67254eb9b4a3$export$79ad592494094f07);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    const $d70c67254eb9b4a3$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>(0, (0, parcelRequire("f8Sb3")).css)({
            position: 'relative',
            overflowY: 'hidden',
            maxHeight: `${maxHeight}px`,
            '&::after': {
                content: "''",
                position: 'absolute',
                top: `${top}px`,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
            }
        });
    const $d70c67254eb9b4a3$var$FadeOut = (props)=>{
        const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
        const top = height - fadeHeight;
        const styles = $d70c67254eb9b4a3$var$fadeOutStyles(height, top, backgroundColor);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles
        }, children);
    };
    class $d70c67254eb9b4a3$export$79ad592494094f07 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
        }
        render() {
            const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)($d70c67254eb9b4a3$var$FadeOut, {
                height: height,
                fadeHeight: fadeHeight,
                backgroundColor: backgroundColor
            }, children);
        }
    }
});
parcelRegister("4R9F2", function(module, exports) {
    $parcel$export(module.exports, "BreakoutSSRInlineScript", ()=>$1596167be67310da$export$cfc1361be0de4203);
    var $5uXOq = parcelRequire("5uXOq");
    var $9N9gL;
    var $2oS3b;
    var $jEKj7;
    function $1596167be67310da$export$cfc1361be0de4203() {
        if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) return null;
        const id = Math.floor(Math.random() * 9999990001) + 9999;
        const context = $1596167be67310da$export$92859d13f30c883e(id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-breakout-script-id": id,
            dangerouslySetInnerHTML: {
                __html: context
            }
        });
    }
    function $1596167be67310da$export$92859d13f30c883e(id) {
        return `
  (function(window){
    ${$1596167be67310da$export$47813c4121c8b4b3};
    (${$1596167be67310da$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${Boolean((0, (0, parcelRequire("2oS3b")).fg)('platform-fix-table-ssr-resizing'))});
  })(window);
`;
    }
    const $1596167be67310da$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, (0, parcelRequire("9N9gL")).breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, (0, parcelRequire("9N9gL")).breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, (0, parcelRequire("9N9gL")).breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, (0, parcelRequire("9N9gL")).breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, (0, parcelRequire("9N9gL")).breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, (0, parcelRequire("9N9gL")).breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, (0, parcelRequire("jEKj7")).FullPagePadding).toString()};
`;
    function $1596167be67310da$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
        const MEDIA_NODE_TYPE = 'mediaSingle';
        const WIDE_LAYOUT_MODES = [
            'full-width',
            'wide',
            'custom'
        ];
        function findUp(element, condition) {
            if (!element) return;
            while(element.parentElement){
                if (condition(element)) return element.parentElement;
                element = element.parentElement;
            }
        }
        const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
        if (!renderer) return;
        const observer = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((item)=>{
                if (item.target.nodeType !== Node.ELEMENT_NODE) return;
                if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                    if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                    let width;
                    const node = maybeNode;
                    const mode = node.dataset.mode || node.dataset.layout || '';
                    if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                    if (!shouldFixTableResizing) {
                        if (node.classList.contains('pm-table-container') && mode === 'custom') {
                            const rendererWidth = renderer.offsetWidth;
                            const effectiveWidth = rendererWidth - breakoutConsts.padding;
                            width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                        } else width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                        if (node.style.width === width) return;
                        node.style.width = width;
                        if (node.classList.contains('pm-table-container') && !renderer.classList.contains('is-full-width')) {
                            const lineLength = breakoutConsts.calcLineLength();
                            const left = lineLength / 2 - parseInt(width) / 2;
                            if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                            else node.style.left = '';
                        }
                    }
                });
                else if (item.target.dataset.nodeType === MEDIA_NODE_TYPE) applyMediaBreakout(item.target);
            });
        });
        const applyMediaBreakout = (card)=>{
            if (card.style.width) return;
            const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
            if (tableParent) return;
            const mode = card.dataset.mode || card.dataset.layout || '';
            const width = card.dataset.width;
            const isPixelBasedResizing = card.dataset.widthType === 'pixel';
            if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
            else if (width && !isPixelBasedResizing) card.style.width = `${width}%`;
        };
        observer.observe(renderer, {
            childList: true,
            subtree: true
        });
        const disconnect = ()=>{
            observer.disconnect();
            window.removeEventListener('load', disconnect);
        };
        window.addEventListener('load', disconnect);
    }
    const $1596167be67310da$export$2a0b3eeee3f2ea40 = (0, (0, parcelRequire("9N9gL")).breakoutConsts).calcLineLength;
});
parcelRegister("cVlbF", function(module, exports) {
    $parcel$export(module.exports, "ActiveHeaderIdProvider", ()=>$9ed3d1f6371e2f8a$export$20439b49fdd0d26c);
    $parcel$export(module.exports, "ActiveHeaderIdConsumer", ()=>$9ed3d1f6371e2f8a$export$cddc3c6ebe2d2cec);
    var $5uXOq = parcelRequire("5uXOq");
    const { Provider: $9ed3d1f6371e2f8a$export$20439b49fdd0d26c, Consumer: $9ed3d1f6371e2f8a$var$Consumer } = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $9ed3d1f6371e2f8a$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
        const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9ed3d1f6371e2f8a$var$Consumer, null, (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        });
    };
});
parcelRegister("3UkaZ", function(module, exports) {
    $parcel$export(module.exports, "isInteractiveElement", ()=>$7255986a432661a9$export$3dee5e4542c672d9);
    function $7255986a432661a9$export$3dee5e4542c672d9(element) {
        if ('href' in element && element.href != null) return true;
        if (element.classList.contains((0, $233dabeecda04459$export$42c8d07e41ed1e74))) return true;
        if (element.classList.contains((0, $c8a15596c227c97f$export$7a6526d4be3b7eb3))) return true;
        return false;
    }
});
const $c8a15596c227c97f$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $c8a15596c227c97f$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
const $233dabeecda04459$export$42c8d07e41ed1e74 = 'media-viewer-popup';
parcelRegister("kDE4W", function(module, exports) {
    $parcel$export(module.exports, "EditorMediaClientProvider", ()=>$d10d6b2b9020f98e$export$77218b6ff680865f);
    var $5uXOq = parcelRequire("5uXOq");
    var $2KWq4;
    var $d67ah;
    const $d10d6b2b9020f98e$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
        const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
        const mediaProvider = (0, (0, parcelRequire("d67ah")).useProvider)('mediaProvider');
        const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
        const contextMediaClient = (0, $5uXOq.useContext)((0, (0, parcelRequire("2KWq4")).MediaClientContext));
        const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, (0, parcelRequire("2KWq4")).getMediaClient)(mediaClientConfig) : undefined, [
            mediaClientConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (ssr?.config) setMediaClientConfig(ssr.config);
            else if (mediaProvider) mediaProvider.then((provider)=>{
                setMediaClientConfig(provider.viewMediaClientConfig);
            });
        }, [
            mediaProvider,
            ssr
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KWq4")).MediaClientContext).Provider, {
            value: shouldSkipContext ? mediaClient : contextMediaClient
        }, children);
    };
});
parcelRegister("2KWq4", function(module, exports) {
    $parcel$export(module.exports, "MediaClientContext", ()=>$737961040dbcc3b2$export$ba5d7212f2b4619f);
    $parcel$export(module.exports, "getMediaClient", ()=>$737961040dbcc3b2$export$c9ecbc1b719fd417);
    $parcel$export(module.exports, "MediaClientProvider", ()=>$737961040dbcc3b2$export$5bff351c86f56d97);
    $parcel$export(module.exports, "useMediaClient", ()=>$737961040dbcc3b2$export$8b3e87ea56c3a345);
    var $5uXOq = parcelRequire("5uXOq");
    var $8iwy1;
    const $737961040dbcc3b2$export$ba5d7212f2b4619f = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $737961040dbcc3b2$export$f92e83e86b03c398 = new Map();
    const $737961040dbcc3b2$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
        if (!mediaClientConfig) return new (0, (0, parcelRequire("8iwy1")).MediaClient)({
            authProvider: ()=>Promise.resolve({
                    clientId: '',
                    token: '',
                    baseUrl: ''
                })
        });
        let mediaClient = $737961040dbcc3b2$export$f92e83e86b03c398.get(mediaClientConfig);
        if (!mediaClient) {
            mediaClient = new (0, (0, parcelRequire("8iwy1")).MediaClient)(mediaClientConfig);
            $737961040dbcc3b2$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
        }
        return mediaClient;
    };
    const $737961040dbcc3b2$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
        const mediaClient = (0, $5uXOq.useMemo)(()=>$737961040dbcc3b2$export$c9ecbc1b719fd417(clientConfig), [
            clientConfig
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($737961040dbcc3b2$export$ba5d7212f2b4619f.Provider, {
            value: mediaClient
        }, children);
    };
    const $737961040dbcc3b2$export$8b3e87ea56c3a345 = ()=>{
        const mediaClient = (0, ($parcel$interopDefault($5uXOq))).useContext($737961040dbcc3b2$export$ba5d7212f2b4619f);
        if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
        return mediaClient;
    };
});
parcelRegister("8iwy1", function(module, exports) {
    $parcel$export(module.exports, "MediaClient", ()=>$45d222c56af5ab33$export$fba8b4ca6d386aec);
    var $7n9mn = parcelRequire("7n9mn");
    parcelRequire("aPznU");
    var $1688S = parcelRequire("1688S");
    var $dwvRq;
    var $c68kn;
    var $bBU9J;
    parcelRequire("hJHW3");
    var $aO9Bk = parcelRequire("aO9Bk");
    class $45d222c56af5ab33$export$fba8b4ca6d386aec {
        constructor(mediaClientConfig, store = (0, $aO9Bk.mediaStore), mediaApi){
            this.mediaClientConfig = mediaClientConfig;
            this.store = store;
            this.mediaStore = mediaApi ?? new (0, (0, parcelRequire("dwvRq")).MediaStore)({
                authProvider: mediaClientConfig.authProvider,
                initialAuth: mediaClientConfig.initialAuth,
                chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $1688S.ChunkHashAlgorithm).Sha256 : (0, $1688S.ChunkHashAlgorithm).Sha1,
                authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
            });
            this.config = mediaClientConfig;
            this.file = new (0, (0, parcelRequire("c68kn")).FileFetcherImpl)(this.mediaStore, this.store);
            this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
            this.stargate = new (0, (0, parcelRequire("bBU9J")).StargateClient)(mediaClientConfig.stargateBaseUrl);
        }
        __DO_NOT_USE__getMediaStore() {
            return this.store;
        }
        getImage(id, params, controller, fetchMaxRes, traceContext) {
            return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
        }
        getImageUrl(id, params) {
            return this.mediaStore.getFileImageURL(id, params);
        }
        getImageUrlSync(id, params) {
            return this.mediaStore.getFileImageURLSync(id, params);
        }
        async getImageMetadata(id, params) {
            return (await this.mediaStore.getImageMetadata(id, params)).metadata;
        }
        async mobileUploadPromise() {
            if (this.mobileUpload) return this.mobileUpload;
            const module = await (parcelRequire("evHmy"));
            this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
            return this.mobileUpload;
        }
        async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
            await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
        }
        on(event, listener) {
            this.eventEmitter.on(event, listener);
        }
        off(event, listener) {
            this.eventEmitter.off(event, listener);
        }
        emit(event, payload) {
            return this.eventEmitter.emit(event, payload);
        }
    }
});
parcelRegister("aPznU", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>(parcelRequire("3Mv91")).mediaState);
    $parcel$export(module.exports, "isClientBasedAuth", ()=>(parcelRequire("27Pip")).isClientBasedAuth);
    $parcel$export(module.exports, "authToOwner", ()=>(parcelRequire("27Pip")).authToOwner);
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>(parcelRequire("1688S")).ChunkHashAlgorithm);
    var $3Mv91 = parcelRequire("3Mv91");
    var $27Pip = parcelRequire("27Pip");
    var $1688S = parcelRequire("1688S");
});
parcelRegister("3Mv91", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>$544b3275a94d45cb$export$8cef61637918b288);
    var $7n9mn = parcelRequire("7n9mn");
    var $iwKVT = parcelRequire("iwKVT");
    const $544b3275a94d45cb$export$8cef61637918b288 = {
        streams: new (0, $iwKVT.LRUMap)(1000),
        stateDeferreds: new Map(),
        eventEmitter: new (0, $7n9mn.EventEmitter2)()
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("27Pip", function(module, exports) {
    $parcel$export(module.exports, "isClientBasedAuth", ()=>$7652e571dc105ad9$export$6ba49fcac9c46e54);
    $parcel$export(module.exports, "authToOwner", ()=>$7652e571dc105ad9$export$17f6055767a8d96a);
    function $7652e571dc105ad9$export$6ba49fcac9c46e54(auth) {
        return !!auth.clientId;
    }
    function $7652e571dc105ad9$export$af1ab14f2246ef72(auth) {
        return !!auth.asapIssuer;
    }
    const $7652e571dc105ad9$export$17f6055767a8d96a = (auth)=>{
        if ($7652e571dc105ad9$export$af1ab14f2246ef72(auth)) return auth;
        const clientAuth = {
            id: auth.clientId,
            baseUrl: auth.baseUrl,
            token: auth.token
        };
        return clientAuth;
    };
});
parcelRegister("1688S", function(module, exports) {
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>$0a2ffc4b84ee2e7f$export$d3e73a50cc549c2e);
    var $0a2ffc4b84ee2e7f$export$d3e73a50cc549c2e;
    (function(ChunkHashAlgorithm) {
        ChunkHashAlgorithm["Sha1"] = "sha1";
        ChunkHashAlgorithm["Sha256"] = "sha256";
    })($0a2ffc4b84ee2e7f$export$d3e73a50cc549c2e || ($0a2ffc4b84ee2e7f$export$d3e73a50cc549c2e = {}));
});
parcelRegister("dwvRq", function(module, exports) {
    $parcel$export(module.exports, "MediaStore", ()=>$82b2517a2f3bcd9a$export$572b8a2a9fd7cbba);
    $parcel$export(module.exports, "getMediaEnvironment", ()=>$82b2517a2f3bcd9a$export$c8b741e18397852a);
    $parcel$export(module.exports, "getMediaRegion", ()=>$82b2517a2f3bcd9a$export$20f9315304dd6726);
    parcelRequire("aPznU");
    var $1688S = parcelRequire("1688S");
    var $27Pip = parcelRequire("27Pip");
    var $bF32U;
    var $3lPpF;
    var $gDM7B;
    var $fLQOa;
    var $i7tQA;
    var $g03z0;
    var $2oS3b;
    var $2UAFG;
    const $82b2517a2f3bcd9a$var$MEDIA_API_REGION = 'media-api-region';
    const $82b2517a2f3bcd9a$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
    const $82b2517a2f3bcd9a$var$extendImageParams = (params, fetchMaxRes = false)=>{
        return {
            ...params,
            'max-age': params?.['max-age'] ?? (0, (0, parcelRequire("bF32U")).FILE_CACHE_MAX_AGE),
            allowAnimated: params?.allowAnimated ?? true,
            mode: params?.mode ?? 'crop',
            ...fetchMaxRes ? {
                width: (0, (0, parcelRequire("bF32U")).MAX_RESOLUTION),
                height: (0, (0, parcelRequire("bF32U")).MAX_RESOLUTION)
            } : {}
        };
    };
    const $82b2517a2f3bcd9a$var$jsonHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const $82b2517a2f3bcd9a$var$cdnFeatureFlag = (endpoint)=>{
        let result = endpoint;
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform_media_cdn_delivery')) {
            if ((0, (0, parcelRequire("2UAFG")).isCommercial)()) result += '/cdn';
        }
        return result;
    };
    class $82b2517a2f3bcd9a$export$572b8a2a9fd7cbba {
        constructor(config){
            this.config = config;
            this.resolveAuth = (authContext)=>(0, (0, parcelRequire("g03z0")).resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
            this.resolveInitialAuth = ()=>(0, (0, parcelRequire("g03z0")).resolveInitialAuth)(this.config.initialAuth);
            this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $1688S.ChunkHashAlgorithm).Sha1;
        }
        async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/collection/{collectionName}'
            };
            const body = {
                actions: [
                    {
                        action: 'remove',
                        item: {
                            type: 'file',
                            id: id,
                            occurrenceKey: occurrenceKey
                        }
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/collection/${collectionName}`, options);
        }
        createUpload(createUpTo = 1, collectionName, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                params: {
                    createUpTo: createUpTo,
                    hashAlgorithm: this._chunkHashAlgorithm
                },
                headers: {
                    Accept: 'application/json'
                },
                traceContext: traceContext
            };
            return this.request(`/upload`, options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/chunk/{etag}'
            };
            const options = {
                ...metadata,
                params: {
                    uploadId: uploadId,
                    partNumber: partNumber
                },
                authContext: {
                    collectionName: collectionName
                },
                body: blob,
                traceContext: traceContext
            };
            await this.request(`/chunk/${etag}`, options);
        }
        createFileFromUpload(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $82b2517a2f3bcd9a$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/upload', options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        getRejectedResponseFromDescriptor(descriptor, limit) {
            return {
                fileId: descriptor.fileId,
                error: {
                    code: 'ExceedMaxFileSizeLimit',
                    title: 'The expected file size exceeded the maximum size limit.',
                    href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                    limit: limit,
                    size: descriptor.size
                }
            };
        }
        async touchFiles(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload/createWithFiles'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                headers: $82b2517a2f3bcd9a$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext,
                params: {
                    hashAlgorithm: this._chunkHashAlgorithm
                }
            };
            return this.request('/upload/createWithFiles', options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        getFile(fileId, params = {}, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${fileId}`, options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        async getFileImageURL(id, params) {
            const { collection: collectionName } = params || {};
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            return this.createFileImageURL(id, auth, params);
        }
        getFileImageURLSync(id, params) {
            const auth = this.resolveInitialAuth();
            return this.createFileImageURL(id, auth, params);
        }
        createFileImageURL(id, auth, params) {
            const options = {
                params: $82b2517a2f3bcd9a$var$extendImageParams(params),
                auth: auth
            };
            const imageEndpoint = $82b2517a2f3bcd9a$var$cdnFeatureFlag('image');
            return (0, (0, parcelRequire("i7tQA")).mapToMediaCdnUrl)((0, (0, parcelRequire("fLQOa")).createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
        }
        async getFileBinary(id, collectionName, abortController, maxAge = (0, (0, parcelRequire("bF32U")).FILE_CACHE_MAX_AGE)) {
            const headers = {};
            const binaryEndpoint = $82b2517a2f3bcd9a$var$cdnFeatureFlag('binary');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${binaryEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: headers,
                params: {
                    collection: collectionName,
                    'max-age': `${maxAge}`
                }
            };
            return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, (0, parcelRequire("fLQOa")).createMapResponseToBlob)(metadata));
        }
        async getFileBinaryURL(id, collectionName, maxAge = (0, (0, parcelRequire("bF32U")).FILE_CACHE_MAX_AGE)) {
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    dl: true,
                    collection: collectionName,
                    'max-age': maxAge
                },
                auth: auth
            };
            const binaryEndpoint = $82b2517a2f3bcd9a$var$cdnFeatureFlag('binary');
            return (0, (0, parcelRequire("i7tQA")).mapToMediaCdnUrl)((0, (0, parcelRequire("fLQOa")).createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
        }
        async getArtifactURL(artifacts, artifactName, collectionName) {
            const artifactUrl = (0, (0, parcelRequire("3lPpF")).getArtifactUrl)(artifacts, artifactName);
            if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    collection: collectionName,
                    'max-age': (0, (0, parcelRequire("bF32U")).FILE_CACHE_MAX_AGE)
                },
                auth: auth
            };
            return (0, (0, parcelRequire("fLQOa")).createUrl)((0, (0, parcelRequire("i7tQA")).mapToMediaCdnUrl)(artifactUrl, auth.token), options);
        }
        async getImage(id, params, controller, fetchMaxRes, traceContext) {
            const isWebpSupported = false;
            const headers = {};
            if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
            const imageEndpoint = $82b2517a2f3bcd9a$var$cdnFeatureFlag('image');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${imageEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: $82b2517a2f3bcd9a$var$extendImageParams(params, fetchMaxRes),
                headers: headers,
                traceContext: traceContext,
                addMediaClientParam: (0, (0, parcelRequire("2oS3b")).fg)('platform.media-card-performance-observer_a803k') && true
            };
            return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, (0, parcelRequire("fLQOa")).createMapResponseToBlob)(metadata));
        }
        async getItems(ids, collectionName, traceContext) {
            const descriptors = ids.map((id)=>({
                    type: 'file',
                    id: id,
                    collection: collectionName
                }));
            const metadata = {
                method: 'POST',
                endpoint: '/items'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $82b2517a2f3bcd9a$var$jsonHeaders,
                body: JSON.stringify({
                    descriptors: descriptors
                }),
                traceContext: traceContext
            };
            return this.request('/items', options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        async getImageMetadata(id, params, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}/image/metadata'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/image/metadata`, options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/upload/{uploadId}/chunks'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $82b2517a2f3bcd9a$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/upload/${uploadId}/chunks`, options);
        }
        copyFileWithToken(body, params, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/copy/withToken'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $82b2517a2f3bcd9a$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/copy/withToken', options).then((0, (0, parcelRequire("fLQOa")).createMapResponseToJson)(metadata));
        }
        async request(path, options = {
            method: 'GET',
            endpoint: undefined,
            authContext: {}
        }, controller, useMediaCdn) {
            const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
            const auth = await this.resolveAuth(authContext);
            const clientId = (0, $27Pip.isClientBasedAuth)(auth) ? auth.clientId : undefined;
            const extendedTraceContext = (0, (0, parcelRequire("fLQOa")).extendTraceContext)(traceContext);
            const extendedParams = addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params;
            let url = `${auth.baseUrl}${path}`;
            if (useMediaCdn) url = (0, (0, parcelRequire("i7tQA")).mapToMediaCdnUrl)(url, auth.token);
            const response = await (0, (0, parcelRequire("gDM7B")).request)(url, {
                method: method,
                endpoint: endpoint,
                auth: auth,
                params: extendedParams,
                headers: headers,
                body: body,
                clientOptions: clientOptions,
                traceContext: extendedTraceContext
            }, controller);
            $82b2517a2f3bcd9a$var$setKeyValueInSessionStorage($82b2517a2f3bcd9a$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
            $82b2517a2f3bcd9a$var$setKeyValueInSessionStorage($82b2517a2f3bcd9a$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
            return response;
        }
        async testUrl(url, options = {}) {
            const { traceContext: traceContext } = options;
            await (0, (0, parcelRequire("gDM7B")).request)(url, {
                method: 'HEAD',
                traceContext: (0, (0, parcelRequire("fLQOa")).extendTraceContext)(traceContext),
                clientOptions: {
                    retryOptions: {
                        maxAttempts: 1
                    }
                }
            });
        }
        get chunkHashAlgorithm() {
            return this._chunkHashAlgorithm;
        }
    }
    const $82b2517a2f3bcd9a$var$getValueFromSessionStorage = (key)=>{
        return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
    };
    const $82b2517a2f3bcd9a$var$setKeyValueInSessionStorage = (key, value)=>{
        if (!value || !(window && window.sessionStorage)) return;
        const currentValue = window.sessionStorage.getItem(key);
        if (currentValue !== value) window.sessionStorage.setItem(key, value);
    };
    const $82b2517a2f3bcd9a$export$c8b741e18397852a = ()=>{
        return $82b2517a2f3bcd9a$var$getValueFromSessionStorage($82b2517a2f3bcd9a$var$MEDIA_API_ENVIRONMENT);
    };
    const $82b2517a2f3bcd9a$export$20f9315304dd6726 = ()=>{
        return $82b2517a2f3bcd9a$var$getValueFromSessionStorage($82b2517a2f3bcd9a$var$MEDIA_API_REGION);
    };
});
parcelRegister("bF32U", function(module, exports) {
    $parcel$export(module.exports, "RECENTS_COLLECTION", ()=>$d73243dbf5130043$export$860a16125e30000b);
    $parcel$export(module.exports, "FILE_CACHE_MAX_AGE", ()=>$d73243dbf5130043$export$bd6e8fe09a90927b);
    $parcel$export(module.exports, "MAX_RESOLUTION", ()=>$d73243dbf5130043$export$6e70f30e392bc53f);
    $parcel$export(module.exports, "CHUNK_SIZE", ()=>$d73243dbf5130043$export$c1abb8bab1e615cd);
    $parcel$export(module.exports, "PROCESSING_BATCH_SIZE", ()=>$d73243dbf5130043$export$3d5157f0def70e54);
    $parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", ()=>$d73243dbf5130043$export$f14f521f3d306044);
    var $gie68;
    const $d73243dbf5130043$export$860a16125e30000b = 'recents';
    const $d73243dbf5130043$export$bd6e8fe09a90927b = 2592000;
    const $d73243dbf5130043$export$6e70f30e392bc53f = 4096;
    const $d73243dbf5130043$export$c1abb8bab1e615cd = 5 * (0, (0, parcelRequire("gie68")).DATA_UNIT).MB;
    const $d73243dbf5130043$export$3d5157f0def70e54 = 1000;
    const $d73243dbf5130043$export$f14f521f3d306044 = 2 * (0, (0, parcelRequire("gie68")).DATA_UNIT).TB;
});
parcelRegister("gie68", function(module, exports) {
    $parcel$export(module.exports, "isNotFoundMediaItemDetails", ()=>$65468bc1a96adf94$export$fd27d7abbc4a746d);
    $parcel$export(module.exports, "DATA_UNIT", ()=>$65468bc1a96adf94$export$76cfea4c354af843);
    const $65468bc1a96adf94$export$350ede7b7a6acf99 = (type)=>{
        const defaultPreviewableTypes = [
            'audio',
            'video',
            'image',
            'doc'
        ];
        return defaultPreviewableTypes.indexOf(type) > -1;
    };
    const $65468bc1a96adf94$export$fd27d7abbc4a746d = (itemDetails)=>{
        return 'type' in itemDetails && itemDetails.type === 'not-found';
    };
    var $65468bc1a96adf94$export$76cfea4c354af843;
    (function(DATA_UNIT) {
        DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
        DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
        DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    })($65468bc1a96adf94$export$76cfea4c354af843 || ($65468bc1a96adf94$export$76cfea4c354af843 = {}));
});
parcelRegister("3lPpF", function(module, exports) {
    $parcel$export(module.exports, "getArtifactUrl", ()=>$8a2812619cade055$export$1cc24defa44e7f84);
    var $2oS3b;
    var $2UAFG;
    const $8a2812619cade055$export$1cc24defa44e7f84 = (artifacts, prop)=>{
        if ((0, (0, parcelRequire("2UAFG")).isCommercial)() && (0, (0, parcelRequire("2oS3b")).fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
        return artifacts[prop]?.url;
    };
});
parcelRegister("2UAFG", function(module, exports) {
    $parcel$export(module.exports, "isCommercial", ()=>$0683f8c1a89e5cb3$export$df69ff6733e73e50);
    function $0683f8c1a89e5cb3$export$df69ff6733e73e50() {
        const global = globalThis;
        const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (perimeter) return perimeter === 'commercial';
        return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
    }
});
parcelRegister("gDM7B", function(module, exports) {
    $parcel$export(module.exports, "request", ()=>$a3670e0fe344402b$export$b5fe3f66a567bec0);
    var $bWJgu;
    var $fLQOa;
    async function $a3670e0fe344402b$export$b5fe3f66a567bec0(url, options = {}, controller) {
        const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
        const { retryOptions: retryOptions } = clientOptions;
        const metadata = {
            method: method,
            endpoint: endpoint,
            traceContext: traceContext
        };
        const doFetch = ()=>fetch((0, (0, parcelRequire("fLQOa")).createUrl)(url, {
                params: params
            }), {
                method: method,
                body: body,
                headers: (0, (0, parcelRequire("fLQOa")).extendHeaders)(headers, auth, traceContext),
                signal: controller && controller.signal
            }).then((0, (0, parcelRequire("fLQOa")).createProcessFetchResponse)(metadata));
        return (0, (0, parcelRequire("fLQOa")).fetchRetry)(doFetch, metadata, retryOptions);
    }
});
parcelRegister("bWJgu", function(module, exports) {
    $parcel$export(module.exports, "RequestError", ()=>$3a2558ed55c62b7c$export$43ee7d0e4f429743);
    $parcel$export(module.exports, "isRequestError", ()=>$3a2558ed55c62b7c$export$3717b1ffef4428ea);
    var $aLxtX;
    class $3a2558ed55c62b7c$export$43ee7d0e4f429743 extends (0, (0, parcelRequire("aLxtX")).BaseMediaClientError) {
        constructor(reason, metadata, innerError){
            super(reason);
            this.reason = reason;
            this.metadata = metadata;
            this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
            return {
                reason: reason,
                method: method,
                endpoint: endpoint,
                mediaRegion: mediaRegion,
                mediaEnv: mediaEnv,
                attempts: attempts,
                clientExhaustedRetries: clientExhaustedRetries,
                statusCode: statusCode,
                metadata: {
                    traceContext: traceContext
                },
                innerError: innerError
            };
        }
    }
    function $3a2558ed55c62b7c$export$3717b1ffef4428ea(err) {
        return err instanceof $3a2558ed55c62b7c$export$43ee7d0e4f429743;
    }
});
parcelRegister("aLxtX", function(module, exports) {
    $parcel$export(module.exports, "BaseMediaClientError", ()=>$b5a69afaf425080a$export$2b0aca14d61c3190);
    var $gSt3A;
    class $b5a69afaf425080a$export$2b0aca14d61c3190 extends Error {
        constructor(message){
            super(message);
            this.message = message;
            Object.setPrototypeOf(this, new.target.prototype);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
        }
    }
});
parcelRegister("gSt3A", function(module, exports) {
    $parcel$export(module.exports, "isMediaClientError", ()=>$35d1dc1c2e5a5229$export$2491e0bbdb59256e);
    $parcel$export(module.exports, "getMediaClientErrorReason", ()=>$35d1dc1c2e5a5229$export$c15d72765ee2baa4);
    function $35d1dc1c2e5a5229$export$2491e0bbdb59256e(error) {
        return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
    }
    function $35d1dc1c2e5a5229$export$c15d72765ee2baa4(err) {
        return $35d1dc1c2e5a5229$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
    }
});
parcelRegister("fLQOa", function(module, exports) {
    $parcel$export(module.exports, "isRateLimitedError", ()=>$6a3b4312499354c5$export$bc96a6a479480590);
    $parcel$export(module.exports, "extendTraceContext", ()=>$6a3b4312499354c5$export$ee24a95986dfd173);
    $parcel$export(module.exports, "createUrl", ()=>$6a3b4312499354c5$export$7138c24907de3954);
    $parcel$export(module.exports, "extendHeaders", ()=>$6a3b4312499354c5$export$18cfbabc415d771c);
    $parcel$export(module.exports, "createMapResponseToJson", ()=>$6a3b4312499354c5$export$e0519b126b73efa6);
    $parcel$export(module.exports, "createMapResponseToBlob", ()=>$6a3b4312499354c5$export$5cc7b0795397da86);
    $parcel$export(module.exports, "fetchRetry", ()=>$6a3b4312499354c5$export$782df2acbe10b22c);
    $parcel$export(module.exports, "createRequestErrorReason", ()=>$6a3b4312499354c5$export$6397609af718d008);
    $parcel$export(module.exports, "createProcessFetchResponse", ()=>$6a3b4312499354c5$export$6e2e477edb7d6032);
    parcelRequire("aPznU");
    var $27Pip = parcelRequire("27Pip");
    var $lh7hT;
    var $fD0Jz;
    var $bWJgu;
    function $6a3b4312499354c5$export$80c51ea1e89203dd(timeout) {
        return new Promise((resolve)=>setTimeout(resolve, timeout));
    }
    function $6a3b4312499354c5$export$de0b576cf7ce4a53(err) {
        return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
    }
    function $6a3b4312499354c5$export$ad8c5cf7dd4c3caf(err) {
        return err instanceof TypeError;
    }
    function $6a3b4312499354c5$export$bc96a6a479480590(error) {
        return !!error && (0, (0, parcelRequire("bWJgu")).isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
    }
    const $6a3b4312499354c5$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, (0, parcelRequire("lh7hT")).getRandomHex)(8)
        } : undefined;
    const $6a3b4312499354c5$export$922566b90d0535ce = {
        traceId: 'x-b3-traceid',
        spanId: 'x-b3-spanid',
        parentSpanId: 'x-b3-parentspanid',
        sampled: 'x-b3-sampled',
        flags: 'x-b3-flags'
    };
    const $6a3b4312499354c5$var$mapTraceIdToRequestHeaders = (traceContext)=>{
        return traceContext ? {
            [$6a3b4312499354c5$export$922566b90d0535ce.traceId]: traceContext.traceId,
            [$6a3b4312499354c5$export$922566b90d0535ce.spanId]: traceContext.spanId
        } : {};
    };
    function $6a3b4312499354c5$export$eaf4479116d2f925(auth) {
        if (!auth) return {};
        if ((0, $27Pip.isClientBasedAuth)(auth)) return {
            'X-Client-Id': auth.clientId,
            Authorization: `Bearer ${auth.token}`
        };
        return {
            'X-Issuer': auth.asapIssuer,
            Authorization: `Bearer ${auth.token}`
        };
    }
    function $6a3b4312499354c5$export$7138c24907de3954(url, { params: params, auth: auth }) {
        const parsedUrl = new URL(url, auth?.baseUrl);
        const authParams = auth && (0, (0, parcelRequire("fD0Jz")).mapAuthToQueryParameters)(auth) || {};
        const paramsToAppend = {
            ...params,
            ...authParams
        };
        Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
            parsedUrl.searchParams.append(...pair);
        });
        parsedUrl.searchParams.sort();
        return parsedUrl.toString();
    }
    function $6a3b4312499354c5$export$18cfbabc415d771c(headers, auth, traceContext) {
        if (!auth && !traceContext && !headers) return undefined;
        return {
            ...headers ?? {},
            ...$6a3b4312499354c5$export$eaf4479116d2f925(auth),
            ...$6a3b4312499354c5$var$mapTraceIdToRequestHeaders(traceContext)
        };
    }
    function $6a3b4312499354c5$export$e0519b126b73efa6(metadata) {
        return async (response)=>{
            try {
                return await response.json();
            } catch (err) {
                throw new (0, (0, parcelRequire("bWJgu")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$6a3b4312499354c5$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    function $6a3b4312499354c5$export$5cc7b0795397da86(metadata) {
        return async (response)=>{
            try {
                return await response.blob();
            } catch (err) {
                throw new (0, (0, parcelRequire("bWJgu")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$6a3b4312499354c5$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    const $6a3b4312499354c5$export$c65cfa70960d8fe5 = {
        startTimeoutInMs: 1000,
        maxAttempts: 5,
        factor: 2
    };
    function $6a3b4312499354c5$export$359f19ca51f9eba1(error, extraMetadata) {
        const { reason: reason, metadata: metadata, innerError: innerError } = error;
        return new (0, (0, parcelRequire("bWJgu")).RequestError)(reason, {
            ...metadata,
            ...extraMetadata
        }, innerError);
    }
    async function $6a3b4312499354c5$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
        const options = {
            ...$6a3b4312499354c5$export$c65cfa70960d8fe5,
            ...overwriteOptions
        };
        const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
        let attempts = 0;
        let timeoutInMs = startTimeoutInMs;
        let lastError;
        const waitAndBumpTimeout = async ()=>{
            await $6a3b4312499354c5$export$80c51ea1e89203dd(timeoutInMs);
            timeoutInMs *= factor;
            attempts += 1;
        };
        while(attempts < maxAttempts)try {
            return await functionToRetry();
        } catch (err) {
            lastError = err;
            if ($6a3b4312499354c5$export$de0b576cf7ce4a53(err)) throw new (0, (0, parcelRequire("bWJgu")).RequestError)('clientAbortedRequest', metadata, err);
            if (!$6a3b4312499354c5$export$ad8c5cf7dd4c3caf(err) && !(0, (0, parcelRequire("bWJgu")).isRequestError)(err) || (0, (0, parcelRequire("bWJgu")).isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
            await waitAndBumpTimeout();
        }
        if ((0, (0, parcelRequire("bWJgu")).isRequestError)(lastError)) throw $6a3b4312499354c5$export$359f19ca51f9eba1(lastError, {
            attempts: attempts,
            clientExhaustedRetries: true
        });
        throw new (0, (0, parcelRequire("bWJgu")).RequestError)('serverUnexpectedError', {
            ...metadata,
            attempts: attempts,
            clientExhaustedRetries: true
        }, lastError);
    }
    function $6a3b4312499354c5$export$6397609af718d008(statusCode) {
        switch(statusCode){
            case 400:
                return 'serverBadRequest';
            case 401:
                return 'serverUnauthorized';
            case 403:
                return 'serverForbidden';
            case 404:
                return 'serverNotFound';
            case 429:
                return 'serverRateLimited';
            case 500:
                return 'serverInternalError';
            case 502:
                return 'serverBadGateway';
            default:
                return 'serverUnexpectedError';
        }
    }
    function $6a3b4312499354c5$export$d171f49f6b4ddc33(metadata, response) {
        const { status: statusCode } = response;
        const reason = $6a3b4312499354c5$export$6397609af718d008(statusCode);
        return new (0, (0, parcelRequire("bWJgu")).RequestError)(reason, {
            ...metadata,
            ...$6a3b4312499354c5$export$ea175c0c5497224(response),
            statusCode: statusCode
        });
    }
    function $6a3b4312499354c5$export$6e2e477edb7d6032(metadata) {
        return (response)=>{
            if (response.ok || response.status < 400) return response;
            const requestError = $6a3b4312499354c5$export$d171f49f6b4ddc33(metadata, response);
            throw requestError;
        };
    }
    function $6a3b4312499354c5$export$ea175c0c5497224(response) {
        const { headers: headers } = response;
        const mediaRegion = headers.get('x-media-region') || 'unknown';
        const mediaEnv = headers.get('x-media-env') || 'unknown';
        return {
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv
        };
    }
});
parcelRegister("lh7hT", function(module, exports) {
    $parcel$export(module.exports, "isUndefined", ()=>$03b60e669ad8d063$export$fce6876652108ab);
    $parcel$export(module.exports, "omitBy", ()=>$03b60e669ad8d063$export$d7a617dda645b4e3);
    $parcel$export(module.exports, "getRandomHex", ()=>$03b60e669ad8d063$export$456b25e3a9b4a843);
    const $03b60e669ad8d063$export$fce6876652108ab = (value)=>value === undefined;
    const $03b60e669ad8d063$export$357523c63a2253b9 = (obj, keys = [])=>{
        if (obj === undefined) return {};
        return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
    };
    const $03b60e669ad8d063$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
    const $03b60e669ad8d063$export$61fc7d43ac8f84b0 = (func, wait)=>{
        let timeout;
        return (...args)=>{
            clearTimeout(timeout);
            timeout = setTimeout(()=>func(...args), wait);
        };
    };
    const $03b60e669ad8d063$export$de994efd351b291c = (srcObj)=>{
        return (obj)=>{
            let key;
            for(key in srcObj){
                if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
            }
            return true;
        };
    };
    function $03b60e669ad8d063$var$getRandomHexValues(byte) {
        return [
            ...Array(byte * 2)
        ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
    }
    function $03b60e669ad8d063$export$456b25e3a9b4a843(byte) {
        let randomHex;
        if (window?.crypto) try {
            randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
        } catch (e) {
            randomHex = $03b60e669ad8d063$var$getRandomHexValues(byte);
        }
        else randomHex = $03b60e669ad8d063$var$getRandomHexValues(byte);
        return randomHex;
    }
});
parcelRegister("fD0Jz", function(module, exports) {
    $parcel$export(module.exports, "mapAuthToQueryParameters", ()=>$e36118fe689257e8$export$6833b130611df767);
    parcelRequire("aPznU");
    var $27Pip = parcelRequire("27Pip");
    function $e36118fe689257e8$export$6833b130611df767(auth) {
        if ((0, $27Pip.isClientBasedAuth)(auth)) return {
            client: auth.clientId,
            token: auth.token
        };
        else return {
            issuer: auth.asapIssuer,
            token: auth.token
        };
    }
});
parcelRegister("i7tQA", function(module, exports) {
    $parcel$export(module.exports, "mapToMediaCdnUrl", ()=>$4951096a4195c23d$export$fb88a576cf28364d);
    var $2oS3b;
    var $2UAFG;
    const $4951096a4195c23d$export$8a9b6ab3569a543a = {
        'api.media.atlassian.com': 'media-cdn.atlassian.com',
        'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
    };
    const $4951096a4195c23d$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
    function $4951096a4195c23d$export$fb88a576cf28364d(url, token) {
        const tokenLength = token?.length ?? 0;
        if (!(0, (0, parcelRequire("2UAFG")).isCommercial)() || tokenLength > $4951096a4195c23d$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform_media_cdn_delivery') && (0, (0, parcelRequire("2oS3b")).fg)('platform_media_cdn_single_host')) try {
            const parsedUrl = new URL(url);
            const cdnHost = $4951096a4195c23d$export$8a9b6ab3569a543a[parsedUrl.host];
            if (!cdnHost) return url;
            parsedUrl.host = cdnHost;
            return parsedUrl.toString();
        } catch (error) {
            return url;
        }
        return url;
    }
});
parcelRegister("g03z0", function(module, exports) {
    $parcel$export(module.exports, "resolveAuth", ()=>$cdb7549fa25df176$export$4b4cec3dcdfce972);
    $parcel$export(module.exports, "resolveInitialAuth", ()=>$cdb7549fa25df176$export$5211e1371264aec3);
    var $jOK8Q;
    var $geCfo;
    const $cdb7549fa25df176$export$560085fe411c0660 = 10000;
    const $cdb7549fa25df176$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $cdb7549fa25df176$export$560085fe411c0660)=>{
        let auth;
        try {
            auth = await Promise.race([
                authProvider(authContext),
                (0, (0, parcelRequire("geCfo")).rejectTimeout)(authProviderTimeout, new (0, (0, parcelRequire("jOK8Q")).MediaStoreError)('authProviderTimedOut'))
            ]);
        } catch (err) {
            if (err instanceof (0, (0, parcelRequire("jOK8Q")).MediaStoreError)) throw err;
            throw new (0, (0, parcelRequire("jOK8Q")).MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
        }
        if (!auth) throw new (0, (0, parcelRequire("jOK8Q")).MediaStoreError)('emptyAuth');
        return auth;
    };
    const $cdb7549fa25df176$export$5211e1371264aec3 = (auth)=>{
        if (!auth) throw new (0, (0, parcelRequire("jOK8Q")).MediaStoreError)('missingInitialAuth');
        return auth;
    };
});
parcelRegister("jOK8Q", function(module, exports) {
    $parcel$export(module.exports, "MediaStoreError", ()=>$f4f1c93483f9f268$export$b78480bd311630bc);
    $parcel$export(module.exports, "isMediaStoreError", ()=>$f4f1c93483f9f268$export$8d2a9b675b2ce37a);
    var $aLxtX;
    class $f4f1c93483f9f268$export$b78480bd311630bc extends (0, (0, parcelRequire("aLxtX")).BaseMediaClientError) {
        constructor(reason, innerError){
            super(reason);
            this.reason = reason;
            this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, innerError: innerError } = this;
            return {
                reason: reason,
                innerError: innerError
            };
        }
    }
    function $f4f1c93483f9f268$export$8d2a9b675b2ce37a(err) {
        return err instanceof $f4f1c93483f9f268$export$b78480bd311630bc;
    }
});
parcelRegister("geCfo", function(module, exports) {
    $parcel$export(module.exports, "rejectTimeout", ()=>$c769b0324ea59074$export$cf2d2a1124beacb2);
    const $c769b0324ea59074$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
            setTimeout(resolve, timeout, resolveWith);
        });
    const $c769b0324ea59074$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
            setTimeout(reject, timeout, rejectWith);
        });
});
parcelRegister("c68kn", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherImpl", ()=>$8331cb168ae3917c$export$fe17eabf77aabacb);
    $parcel$export(module.exports, "FileFetcherError", ()=>(parcelRequire("1vCw3")).FileFetcherError);
    var $aZdZn = parcelRequire("aZdZn");
    var $cVFxd = parcelRequire("cVFxd");
    var $bXrHm = parcelRequire("bXrHm");
    parcelRequire("aPznU");
    var $27Pip = parcelRequire("27Pip");
    var $gIVqx;
    var $dwvRq;
    var $iaC52;
    var $gie68;
    var $1vCw3;
    var $kApqj;
    var $8DAQV;
    var $9bBDn;
    var $bF32U;
    var $6CZ6k = parcelRequire("6CZ6k");
    var $6VVZs;
    var $k9LMn;
    var $cvXAd;
    var $kJ7Lb;
    var $cZeYk;
    var $h2tIX;
    var $25T96;
    var $bW3Xt;
    var $1GOqZ;
    var $l7XOX;
    var $7v5TU;
    var $gevlu;
    parcelRequire("hJHW3");
    var $aO9Bk = parcelRequire("aO9Bk");
    class $8331cb168ae3917c$export$fe17eabf77aabacb {
        constructor(mediaApi, store = (0, $aO9Bk.mediaStore)){
            this.mediaApi = mediaApi;
            this.store = store;
            this.getErrorFileState = (error, id, occurrenceKey)=>{
                const { metadata: metadata, ...attributes } = error?.attributes ?? {};
                return typeof error === 'string' ? {
                    status: 'error',
                    id: id,
                    reason: error,
                    occurrenceKey: occurrenceKey,
                    message: error
                } : {
                    status: 'error',
                    id: id,
                    reason: error?.reason,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    },
                    occurrenceKey: occurrenceKey,
                    message: error?.message
                };
            };
            this.setFileState = (id, fileState)=>{
                this.store.setState((state)=>{
                    state.files[id] = fileState;
                });
            };
            this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
                const subject = (0, (0, parcelRequire("bW3Xt")).createMediaSubject)();
                const poll = new (0, (0, parcelRequire("7v5TU")).PollingFunction)();
                poll.onError = (error)=>subject.error(error);
                poll.execute(async ()=>{
                    const response = await this.dataloader.load({
                        id: id,
                        collectionName: collectionName
                    });
                    if ((0, (0, parcelRequire("gie68")).isNotFoundMediaItemDetails)(response)) throw new (0, (0, parcelRequire("1vCw3")).FileFetcherError)('emptyItems', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    if ((0, (0, parcelRequire("gevlu")).isEmptyFile)(response)) throw new (0, (0, parcelRequire("1vCw3")).FileFetcherError)('zeroVersionFile', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    const fileState = (0, (0, parcelRequire("iaC52")).mapMediaItemToFileState)(id, response);
                    subject.next(fileState);
                    switch(fileState.status){
                        case 'processing':
                            poll.next();
                            break;
                        case 'processed':
                            subject.complete();
                            break;
                    }
                });
                return subject;
            };
            this.getUploadingFileStateBase = (file, upfrontId)=>{
                if (typeof file.content === 'string') file.content = (0, (0, parcelRequire("kJ7Lb")).convertBase64ToBlob)(file.content);
                const { content: content, name: name = '' } = file;
                const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
                let preview;
                let size = 0;
                let mimeType = '';
                if (content instanceof Blob) {
                    size = content.size;
                    mimeType = content.type;
                    preview = {
                        value: content,
                        origin: 'local'
                    };
                }
                const mediaType = (0, (0, parcelRequire("k9LMn")).getMediaTypeFromUploadableFile)(file);
                return {
                    id: id,
                    occurrenceKey: occurrenceKey,
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: mimeType,
                    preview: preview
                };
            };
            this.dataloader = (0, (0, parcelRequire("6VVZs")).createFileDataloader)(mediaApi);
        }
        getFileState(id, options = {}) {
            const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
            if (!(0, ($parcel$interopDefault($6CZ6k)))(id)) {
                const subject = (0, (0, parcelRequire("bW3Xt")).createMediaSubject)();
                const err = new (0, (0, parcelRequire("1vCw3")).FileFetcherError)('invalidFileId', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const { metadata: metadata, ...attributes } = err?.attributes ?? {};
                const errorFileState = {
                    status: 'error',
                    id: id,
                    reason: err?.reason,
                    message: err?.message,
                    occurrenceKey: occurrenceKey,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    }
                };
                subject.error(err);
                this.setFileState(id, errorFileState);
                return (0, (0, parcelRequire("cZeYk")).fromObservable)(subject);
            }
            return (0, (0, parcelRequire("cZeYk")).fromObservable)((0, (0, parcelRequire("8DAQV")).getFileStreamsCache)().getOrInsert(id, ()=>{
                const subject = this.createDownloadFileStream(id, collectionName);
                subject.subscribe({
                    next: (fileState)=>{
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(id, errorFileState);
                    }
                });
                return subject;
            }));
        }
        getCurrentState(id, options) {
            return (0, (0, parcelRequire("h2tIX")).toPromise)(this.getFileState(id, options));
        }
        getArtifactURL(artifacts, artifactName, collectionName) {
            return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
        }
        getFileBinaryURL(id, collectionName, maxAge) {
            return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
        }
        touchFiles(descriptors, collection, traceContext) {
            return this.mediaApi.touchFiles({
                descriptors: descriptors
            }, {
                collection: collection
            }, traceContext).then(({ data: data })=>data);
        }
        generateUploadableFileUpfrontIds(collection, traceContext) {
            const id = (0, ($parcel$interopDefault($bXrHm)))();
            const occurrenceKey = (0, ($parcel$interopDefault($bXrHm)))();
            const touchFileDescriptor = {
                fileId: id,
                occurrenceKey: occurrenceKey,
                collection: collection
            };
            const deferredUploadId = this.touchFiles([
                touchFileDescriptor
            ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                deferredUploadId: deferredUploadId
            };
        }
        async uploadExternal(url, collection, traceContext) {
            const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
            const subject = (0, (0, parcelRequire("bW3Xt")).createMediaSubject)();
            const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
            const preview = new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) reject('Could not fetch the blob');
                resolve({
                    value: blob,
                    origin: 'remote'
                });
            });
            const name = url.split('/').pop() || '';
            const fileState = {
                status: 'processing',
                name: name,
                size: 0,
                mediaType: 'unknown',
                mimeType: '',
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            };
            subject.next(fileState);
            (0, (0, parcelRequire("8DAQV")).getFileStreamsCache)().set(id, subject);
            this.setFileState(id, fileState);
            return new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) return reject('Could not download remote file');
                const { type: type, size: size } = blob;
                const file = {
                    content: blob,
                    mimeType: type,
                    collection: collection,
                    name: name,
                    size: size
                };
                const mediaType = (0, (0, parcelRequire("1GOqZ")).getMediaTypeFromMimeType)(type);
                subject.next({
                    status: 'processing',
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: type,
                    id: id,
                    occurrenceKey: occurrenceKey,
                    preview: preview
                });
                this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                let dimensions;
                try {
                    dimensions = await (0, (0, parcelRequire("25T96")).getDimensionsFromBlob)(mediaType, blob);
                } catch (error) {
                    reject(error);
                    return;
                }
                resolve({
                    dimensions: dimensions,
                    mimeType: type,
                    uploadableFileUpfrontIds: uploadableFileUpfrontIds
                });
            });
        }
        upload(file, controller, uploadableFileUpfrontIds, traceContext) {
            const { collection: collection } = file;
            const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            const stateBase = this.getUploadingFileStateBase(file, upfrontId);
            const subject = (0, (0, parcelRequire("bW3Xt")).createMediaSubject)();
            (0, (0, parcelRequire("8DAQV")).getFileStreamsCache)().set(id, subject);
            const onProgress = (progress)=>{
                const fileState = {
                    status: 'uploading',
                    ...stateBase,
                    progress: progress
                };
                subject.next(fileState);
                this.setFileState(id, fileState);
            };
            let processingSubscription = new (0, $aZdZn.Subscription)();
            const onUploadFinish = (error)=>{
                if (error) {
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                    return subject.error(error);
                }
                processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                        ...stateBase,
                        ...remoteFileState,
                        ...(0, (0, parcelRequire("cvXAd")).overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                    }))).subscribe({
                    next: (fileState)=>{
                        subject.next(fileState);
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        subject.error(err);
                        this.setFileState(id, errorFileState);
                    },
                    complete: subject.complete
                });
            };
            const { cancel: cancel } = (0, (0, parcelRequire("kApqj")).uploadFile)(file, this.mediaApi, upfrontId, {
                onUploadFinish: onUploadFinish,
                onProgress: onProgress
            }, traceContext);
            controller?.setAbort(()=>{
                cancel();
                processingSubscription.unsubscribe();
            });
            setTimeout(onProgress, 0, 0);
            return (0, (0, parcelRequire("cZeYk")).fromObservable)(subject);
        }
        async downloadBinary(id, name = 'download', collectionName, traceContext) {
            const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
            (0, (0, parcelRequire("gIVqx")).downloadUrl)(url, {
                name: name
            });
            (0, (0, parcelRequire("9bBDn")).globalMediaEventEmitter).emit('media-viewed', {
                fileId: id,
                isUserCollection: collectionName === (0, (0, parcelRequire("bF32U")).RECENTS_COLLECTION),
                viewingLevel: 'download'
            });
            await this.mediaApi.testUrl(url, {
                traceContext: traceContext
            });
        }
        async copyFile(source, destination, options = {}, traceContext) {
            const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
            const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
            const { preview: preview, mimeType: mimeType } = options;
            const mediaStore = destination.mediaStore || new (0, (0, parcelRequire("dwvRq")).MediaStore)({
                authProvider: destinationAuthProvider
            });
            const owner = (0, $27Pip.authToOwner)(await authProvider({
                collectionName: sourceCollection
            }));
            const body = {
                sourceFile: {
                    id: id,
                    collection: sourceCollection,
                    owner: owner
                }
            };
            const params = {
                collection: destinationCollectionName,
                replaceFileId: replaceFileId,
                occurrenceKey: occurrenceKey
            };
            const cache = (0, (0, parcelRequire("8DAQV")).getFileStreamsCache)();
            let processingSubscription;
            try {
                const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
                const copiedFileWithMimeType = {
                    ...copiedFile,
                    ...mimeType ? {
                        mimeType: mimeType
                    } : undefined
                };
                const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
                const mediaType = copiedMimeType ? (0, (0, parcelRequire("1GOqZ")).getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
                const copiedFileState = (0, (0, parcelRequire("iaC52")).mapMediaFileToFileState)({
                    data: copiedFileWithMimeType
                });
                const fileCache = cache.get(copiedId);
                const subject = fileCache || (0, (0, parcelRequire("bW3Xt")).createMediaSubject)();
                const previewOverride = !(0, (0, parcelRequire("iaC52")).isErrorFileState)(copiedFileState) && !!preview ? {
                    preview: preview
                } : {};
                if (!(0, (0, parcelRequire("iaC52")).isFinalFileState)(copiedFileState) && copiedMimeType && await (0, (0, parcelRequire("l7XOX")).shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                    const fileState = {
                        ...copiedFileState,
                        ...(0, (0, parcelRequire("cvXAd")).overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                        ...previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                    processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                        next: (remoteFileState)=>{
                            const fileState = {
                                ...remoteFileState,
                                ...(0, (0, parcelRequire("cvXAd")).overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                                ...!(0, (0, parcelRequire("iaC52")).isErrorFileState)(remoteFileState) && previewOverride
                            };
                            this.setFileState(copiedId, fileState);
                            return subject.next(fileState);
                        },
                        error: (err)=>{
                            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                            this.setFileState(copiedId, errorFileState);
                            return subject.error(err);
                        },
                        complete: ()=>subject.complete()
                    });
                } else if (!(0, (0, parcelRequire("iaC52")).isProcessingFileState)(copiedFileState)) {
                    const fileState = {
                        ...copiedFileState,
                        ...!(0, (0, parcelRequire("iaC52")).isErrorFileState)(copiedFileState) && previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                }
                if (!cache.has(copiedId)) (0, (0, parcelRequire("8DAQV")).getFileStreamsCache)().set(copiedId, subject);
                return copiedFile;
            } catch (error) {
                if (processingSubscription) processingSubscription.unsubscribe();
                if (replaceFileId) {
                    const fileCache = cache.get(replaceFileId);
                    const replaceFileState = this.store.getState().files[replaceFileId];
                    if (fileCache) fileCache.error(error);
                    else cache.set(id, (0, (0, parcelRequire("bW3Xt")).createMediaSubject)(error));
                    const key = replaceFileState ? replaceFileId : id;
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(key, errorFileState);
                }
                throw error;
            }
        }
    }
});
parcelRegister("gIVqx", function(module, exports) {
    $parcel$export(module.exports, "downloadUrl", ()=>$b04b19f601d20117$export$8a96edb1c96563f4);
    const $b04b19f601d20117$export$8a96edb1c96563f4 = (url, options)=>{
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        if (options && options.name) link.download = options.name;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
});
parcelRegister("iaC52", function(module, exports) {
    $parcel$export(module.exports, "isUploadingFileState", ()=>$8bd3b5db73514898$export$70eb3481b487c668);
    $parcel$export(module.exports, "isProcessingFileState", ()=>$8bd3b5db73514898$export$5c30e6dd75278e66);
    $parcel$export(module.exports, "isProcessedFileState", ()=>$8bd3b5db73514898$export$1d17291aafa5f231);
    $parcel$export(module.exports, "isErrorFileState", ()=>$8bd3b5db73514898$export$f863e1e09c8a926);
    $parcel$export(module.exports, "isPreviewableFileState", ()=>$8bd3b5db73514898$export$92dd692b31e42e64);
    $parcel$export(module.exports, "isFinalFileState", ()=>$8bd3b5db73514898$export$270b3fc27120edd0);
    $parcel$export(module.exports, "isImageRepresentationReady", ()=>$8bd3b5db73514898$export$4e33ccde53b4f0bf);
    $parcel$export(module.exports, "mapMediaFileToFileState", ()=>$8bd3b5db73514898$export$ddfd67d20657322f);
    $parcel$export(module.exports, "mapMediaItemToFileState", ()=>$8bd3b5db73514898$export$ea3730792e8bebfb);
    const $8bd3b5db73514898$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
    const $8bd3b5db73514898$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
    const $8bd3b5db73514898$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
    const $8bd3b5db73514898$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
    const $8bd3b5db73514898$export$92dd692b31e42e64 = (fileState)=>!$8bd3b5db73514898$export$f863e1e09c8a926(fileState) && !!fileState.preview;
    const $8bd3b5db73514898$export$270b3fc27120edd0 = (fileState)=>[
            'processed',
            'failed-processing',
            'error'
        ].includes(fileState.status);
    const $8bd3b5db73514898$export$4e33ccde53b4f0bf = (fileState)=>{
        switch(fileState.status){
            case 'processing':
            case 'processed':
            case 'failed-processing':
                return !!(fileState.representations && fileState.representations.image);
            default:
                return false;
        }
    };
    const $8bd3b5db73514898$export$ddfd67d20657322f = (mediaFile)=>{
        const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
        const baseState = {
            id: id,
            name: name,
            size: size,
            mediaType: mediaType,
            mimeType: mimeType,
            artifacts: artifacts,
            representations: representations,
            createdAt: createdAt,
            metadataTraceContext: metadataTraceContext
        };
        switch(processingStatus){
            case 'pending':
            case undefined:
                return {
                    ...baseState,
                    status: 'processing'
                };
            case 'succeeded':
                return {
                    ...baseState,
                    status: 'processed'
                };
            case 'failed':
                return {
                    ...baseState,
                    status: 'failed-processing'
                };
        }
    };
    const $8bd3b5db73514898$export$ea3730792e8bebfb = (id, item)=>{
        return $8bd3b5db73514898$export$ddfd67d20657322f({
            data: {
                id: id,
                ...item
            }
        });
    };
});
parcelRegister("1vCw3", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherError", ()=>$a12b51af310dea3a$export$e3e60f0dab8641de);
    var $aLxtX;
    class $a12b51af310dea3a$export$e3e60f0dab8641de extends (0, (0, parcelRequire("aLxtX")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason);
            this.reason = reason;
            this.id = id;
            this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                ...traceContext && {
                    metadata: {
                        traceContext: traceContext
                    }
                }
            };
        }
    }
    function $a12b51af310dea3a$export$5c3435f75ce0ce70(err) {
        return err instanceof $a12b51af310dea3a$export$e3e60f0dab8641de;
    }
});
parcelRegister("kApqj", function(module, exports) {
    $parcel$export(module.exports, "uploadFile", ()=>$83428cff91f71b34$export$a5575dbeeffdad98);
    var $cg7pb;
    var $gI62y = parcelRequire("gI62y");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $eG1Ho;
    var $hgnLB;
    var $bF32U;
    var $5l0DE;
    const $83428cff91f71b34$var$hashingFunction = async (blob, hashAlgorithm)=>{
        const hasher = await (0, (0, parcelRequire("eG1Ho")).createHasher)(hashAlgorithm);
        return hasher.hash(blob);
    };
    const $83428cff91f71b34$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
            return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
        };
    const $83428cff91f71b34$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
        let offset = 0;
        return async (chunks)=>{
            await store.appendChunksToUpload(await deferredUploadId, {
                chunks: $83428cff91f71b34$var$hashedChunks(chunks),
                offset: offset
            }, collection, traceContext);
            offset += chunks.length;
        };
    };
    const $83428cff91f71b34$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
        const { collection: collection, name: name, mimeType: mimeType } = file;
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const body = file.size ? {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType,
            conditions: {
                size: file.size
            }
        } : {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType
        };
        return store.createFileFromUpload(body, {
            occurrenceKey: occurrenceKey,
            collection: collection,
            replaceFileId: id
        }, traceContext);
    };
    const $83428cff91f71b34$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
        const { content: content, collection: collection } = file;
        const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        let chunkSize = (0, (0, parcelRequire("bF32U")).CHUNK_SIZE);
        try {
            if (content instanceof Blob) chunkSize = (0, (0, parcelRequire("5l0DE")).calculateChunkSize)(content.size);
        } catch (err) {
            if (err instanceof Error && err.message === (0, (0, parcelRequire("5l0DE")).fileSizeError)) callbacks?.onUploadFinish(new (0, (0, parcelRequire("hgnLB")).UploaderError)(err.message, id, {
                collectionName: collection,
                occurrenceKey: occurrenceKey
            }));
            return {
                cancel: ()=>{
                    callbacks?.onUploadFinish('canceled');
                }
            };
        }
        const chunkinatorObservable = (0, (0, parcelRequire("cg7pb")).chunkinator)(content, {
            hashingFunction: (blob)=>$83428cff91f71b34$var$hashingFunction(blob, store.chunkHashAlgorithm),
            hashingConcurrency: 5,
            chunkSize: chunkSize,
            uploadingConcurrency: 3,
            uploadingFunction: $83428cff91f71b34$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
            processingBatchSize: (0, (0, parcelRequire("bF32U")).PROCESSING_BATCH_SIZE),
            processingFunction: $83428cff91f71b34$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
        }, {
            onProgress (progress) {
                if (callbacks) callbacks.onProgress(progress);
            }
        });
        const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
        const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($83428cff91f71b34$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
            error: (err)=>onUploadFinish(err),
            complete: ()=>onUploadFinish()
        });
        return {
            cancel: ()=>{
                subscription.unsubscribe();
                onUploadFinish('canceled');
            }
        };
    };
    const $83428cff91f71b34$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);
});
parcelRegister("cg7pb", function(module, exports) {
    $parcel$export(module.exports, "chunkinator", ()=>$d9f82d678e26ece3$export$9ab6bef3838698f8);
    var $j7Dz8 = parcelRequire("j7Dz8");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $9RLLl = parcelRequire("9RLLl");
    var $bXPjr = parcelRequire("bXPjr");
    var $9fphF;
    var $dcGXH;
    var $lJUFQ;
    var $6Ib19;
    var $9OPmB;
    var $gI62y = parcelRequire("gI62y");
    const $d9f82d678e26ece3$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, (0, parcelRequire("9OPmB")).fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
            const { chunkSize: chunkSize } = options;
            const { onProgress: onProgress } = callbacks;
            const totalChunks = Math.ceil(blob.size / chunkSize);
            const slicenatedBlobs = (0, (0, parcelRequire("9fphF")).slicenator)(blob, {
                size: chunkSize
            });
            const hashinatedBlobs = (0, (0, parcelRequire("dcGXH")).hashinator)(slicenatedBlobs, {
                concurrency: options.hashingConcurrency,
                hasher: options.hashingFunction
            });
            let uploadedChunks = 0;
            let uploadedBlobs = (0, (0, parcelRequire("lJUFQ")).uploadinator)(hashinatedBlobs, {
                concurrency: options.uploadingConcurrency,
                uploader: options.uploadingFunction
            });
            if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
                uploadedChunks += 1;
                onProgress(uploadedChunks / totalChunks);
            }));
            return (0, (0, parcelRequire("6Ib19")).processinator)(uploadedBlobs, {
                batchSize: options.processingBatchSize,
                processor: options.processingFunction
            }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
                return (0, $gI62y.from)(batchedChunks);
            }), (0, $9RLLl.bufferCount)(totalChunks));
        }));
    const $d9f82d678e26ece3$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
        return $d9f82d678e26ece3$export$88e80b3a0bb31f63(file, options, callbacks);
    };
});
parcelRegister("9fphF", function(module, exports) {
    $parcel$export(module.exports, "slicenator", ()=>$3d270ec225c75a0d$export$5b92d769f2f57509);
    var $eTa7E = parcelRequire("eTa7E");
    var $cVFxd = parcelRequire("cVFxd");
    const $3d270ec225c75a0d$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
        const totalChunks = Math.ceil(blob.size / chunkSize);
        return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
            return {
                partNumber: index + 1,
                blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
            };
        }));
    };
});
parcelRegister("dcGXH", function(module, exports) {
    $parcel$export(module.exports, "hashinator", ()=>$ba3ff888339f7564$export$d5f5a550a38ec367);
    var $9OPmB;
    const $ba3ff888339f7564$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                    blob: slicedBlob.blob,
                    hash: `${hash}-${slicedBlob.blob.size}`,
                    partNumber: slicedBlob.partNumber
                }));
    const $ba3ff888339f7564$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, (0, parcelRequire("9OPmB")).asyncMap)($ba3ff888339f7564$export$28a452a485721473(hasher), concurrency)(blobs$);
});
parcelRegister("9OPmB", function(module, exports) {
    $parcel$export(module.exports, "fetchBlob", ()=>$1223f4aa6562166e$export$14e9cfd4a872cc1e);
    $parcel$export(module.exports, "asyncMap", ()=>$1223f4aa6562166e$export$707ee4c4c95d39e3);
    var $kVLXA = parcelRequire("kVLXA");
    var $80gxR = parcelRequire("80gxR");
    async function $1223f4aa6562166e$export$14e9cfd4a872cc1e(file) {
        if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
        else return file;
    }
    const $1223f4aa6562166e$var$notify = (promise, observer, onReady)=>{
        const notifier = {
            notifyIfReady: ()=>false
        };
        promise.then((value)=>{
            notifier.notifyIfReady = ()=>{
                observer.next(value);
                observer.complete();
                return true;
            };
            onReady(notifier);
        }, (reason)=>{
            notifier.notifyIfReady = ()=>{
                observer.error(reason);
                return true;
            };
            onReady(notifier);
        });
        return notifier;
    };
    const $1223f4aa6562166e$var$mapper = (project)=>{
        const notifiers = new Array();
        const onReady = ()=>{
            const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
            if (notReadyIdx > 0) notifiers.splice(0, notReadyIdx);
        };
        return (value)=>new (0, $kVLXA.Observable)((sub)=>{
                notifiers.push($1223f4aa6562166e$var$notify(project(value), sub, onReady));
            });
    };
    const $1223f4aa6562166e$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($1223f4aa6562166e$var$mapper(project), concurrent);
});
parcelRegister("lJUFQ", function(module, exports) {
    $parcel$export(module.exports, "uploadinator", ()=>$245c6c860c73bc95$export$94ce0f3fcf999415);
    var $9OPmB;
    const $245c6c860c73bc95$export$94ce0f3fcf999415 = (blobs$, options)=>{
        const upload = (blob)=>{
            return options.uploader(blob).then(()=>blob);
        };
        return blobs$.pipe((0, (0, parcelRequire("9OPmB")).asyncMap)(upload, options.concurrency));
    };
});
parcelRegister("6Ib19", function(module, exports) {
    $parcel$export(module.exports, "processinator", ()=>$51075e67e4408fbb$export$2f21790600302ed);
    var $9RLLl = parcelRequire("9RLLl");
    var $ib0Rz = parcelRequire("ib0Rz");
    const $51075e67e4408fbb$export$2f21790600302ed = (blobs$, options)=>{
        const process = (blobs)=>{
            if (options.processor) return options.processor(blobs).then(()=>blobs);
            else return Promise.resolve(blobs);
        };
        return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
    };
});
parcelRegister("eG1Ho", function(module, exports) {
    $parcel$export(module.exports, "createHasher", ()=>$905db734d5a3dcaa$export$14b114effbc08b6b);
    parcelRequire("aPznU");
    var $1688S = parcelRequire("1688S");
    let $905db734d5a3dcaa$var$hasher = null;
    let $905db734d5a3dcaa$var$sha256Hasher = null;
    const $905db734d5a3dcaa$export$b7d263e6bc26b29a = ()=>$905db734d5a3dcaa$var$hasher = null;
    const $905db734d5a3dcaa$export$14b114effbc08b6b = async (algorithm)=>{
        const numWorkers = 3;
        if (algorithm === (0, $1688S.ChunkHashAlgorithm).Sha256) {
            if (!$905db734d5a3dcaa$var$sha256Hasher) {
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("eJcK9"));
                $905db734d5a3dcaa$var$sha256Hasher = new SimpleHasher();
            }
            return $905db734d5a3dcaa$var$sha256Hasher;
        } else if (!$905db734d5a3dcaa$var$hasher) try {
            const { WorkerHasher: WorkerHasher } = await (parcelRequire("lcU1a"));
            $905db734d5a3dcaa$var$hasher = new WorkerHasher(numWorkers);
        } catch (error) {
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("kSoTt"));
            $905db734d5a3dcaa$var$hasher = new SimpleHasher();
        }
        return $905db734d5a3dcaa$var$hasher;
    };
});
parcelRegister("eJcK9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cLAr4").then(()=>parcelRequire('jqzYv'));
});
parcelRegister("lcU1a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("dfMHU")
    ]).then(()=>parcelRequire('g9GFI'));
});
parcelRegister("kSoTt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8Hllm")
    ]).then(()=>parcelRequire('1MJh0'));
});
parcelRegister("hgnLB", function(module, exports) {
    $parcel$export(module.exports, "UploaderError", ()=>$6b92dfb8ece7c846$export$515240c3f059c807);
    var $aLxtX;
    class $6b92dfb8ece7c846$export$515240c3f059c807 extends (0, (0, parcelRequire("aLxtX")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason);
            this.reason = reason;
            this.id = id;
            this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            };
        }
    }
    function $6b92dfb8ece7c846$export$80ee180172bc336(err) {
        return err instanceof $6b92dfb8ece7c846$export$515240c3f059c807;
    }
});
parcelRegister("5l0DE", function(module, exports) {
    $parcel$export(module.exports, "fileSizeError", ()=>$aed56c9d0fe72b1c$export$b36239e4c33c2902);
    $parcel$export(module.exports, "calculateChunkSize", ()=>$aed56c9d0fe72b1c$export$71f452e02035c1e2);
    var $gie68;
    var $bF32U;
    const $aed56c9d0fe72b1c$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
    const $aed56c9d0fe72b1c$export$71f452e02035c1e2 = (fileSize)=>{
        if (fileSize > (0, (0, parcelRequire("bF32U")).MAX_UPLOAD_FILE_SIZE)) throw new Error($aed56c9d0fe72b1c$export$b36239e4c33c2902);
        if (fileSize <= 5 * (0, (0, parcelRequire("gie68")).DATA_UNIT).GB) return 5 * (0, (0, parcelRequire("gie68")).DATA_UNIT).MB;
        if (fileSize > 5 * (0, (0, parcelRequire("gie68")).DATA_UNIT).GB && fileSize <= 50 * (0, (0, parcelRequire("gie68")).DATA_UNIT).GB) return 50 * (0, (0, parcelRequire("gie68")).DATA_UNIT).MB;
        if (fileSize > 50 * (0, (0, parcelRequire("gie68")).DATA_UNIT).GB && fileSize <= 0.95 * (0, (0, parcelRequire("gie68")).DATA_UNIT).TB) return 100 * (0, (0, parcelRequire("gie68")).DATA_UNIT).MB;
        return 210 * (0, (0, parcelRequire("gie68")).DATA_UNIT).MB;
    };
});
parcelRegister("8DAQV", function(module, exports) {
    $parcel$export(module.exports, "getFileStreamsCache", ()=>$229da05ff15c4dd2$export$f2f061938c1e6810);
    class $229da05ff15c4dd2$export$4293896e79732236 {
        constructor(streams){
            this.streams = streams;
        }
        has(id) {
            return !!this.streams.find(id);
        }
        set(id, stream) {
            this.streams.set(id, stream);
        }
        get(id) {
            return this.streams.get(id);
        }
        getOrInsert(id, callback) {
            if (!this.has(id)) this.set(id, callback());
            return this.get(id);
        }
        removeAll() {
            this.streams.clear();
        }
        remove(id) {
            this.streams.delete(id);
        }
        get size() {
            return this.streams.size;
        }
    }
    let $229da05ff15c4dd2$var$streamCache;
    const $229da05ff15c4dd2$export$f2f061938c1e6810 = ()=>{
        if (!$229da05ff15c4dd2$var$streamCache) {
            const mediaState = (parcelRequire("3Mv91")).mediaState;
            $229da05ff15c4dd2$var$streamCache = new $229da05ff15c4dd2$export$4293896e79732236(mediaState.streams);
        }
        return $229da05ff15c4dd2$var$streamCache;
    };
});
parcelRegister("9bBDn", function(module, exports) {
    $parcel$export(module.exports, "globalMediaEventEmitter", ()=>$11c22725522d41ec$export$68d003d3105952ad);
    parcelRequire("aPznU");
    var $3Mv91 = parcelRequire("3Mv91");
    const $11c22725522d41ec$export$68d003d3105952ad = {
        on (event, listener) {
            if ((0, $3Mv91.mediaState).eventEmitter) (0, $3Mv91.mediaState).eventEmitter.on(event, listener);
        },
        off (event, listener) {
            if ((0, $3Mv91.mediaState).eventEmitter) (0, $3Mv91.mediaState).eventEmitter.off(event, listener);
        },
        emit (event, payload) {
            if ((0, $3Mv91.mediaState).eventEmitter) return (0, $3Mv91.mediaState).eventEmitter.emit(event, payload);
            return undefined;
        }
    };
});
parcelRegister("6CZ6k", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
    var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    var $4d35b0145f276bfe$var$_byteToHex = [];
    for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
    function $4d35b0145f276bfe$var$unparse(buf, offset) {
        var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
        return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
    }
    module.exports = function(uuid, version) {
        var parsedUuid;
        if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
        else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
        else return false;
        parsedUuid = parsedUuid.toLowerCase();
        if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
        if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
        else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
        switch(version){
            case 1:
            case 2:
                return true;
            case 3:
            case 4:
            case 5:
                return [
                    '8',
                    '9',
                    'a',
                    'b'
                ].indexOf(parsedUuid.charAt(19)) !== -1;
            default:
                throw new Error('Invalid version provided.');
        }
    };
    var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
        return uuid.charAt(14) | 0;
    };
});
parcelRegister("6VVZs", function(module, exports) {
    $parcel$export(module.exports, "createFileDataloader", ()=>$fbb5fbcffe407c05$export$ae188fee39529b82);
    var $hhZW9 = parcelRequire("hhZW9");
    var $lh7hT;
    const $fbb5fbcffe407c05$export$b79d95ee17a87a = 100;
    const $fbb5fbcffe407c05$var$isBatchLoadingErrorResult = (result)=>{
        return result.error instanceof Error;
    };
    const $fbb5fbcffe407c05$var$isResponseFileItem = (fileItem)=>{
        return 'details' in fileItem;
    };
    const $fbb5fbcffe407c05$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
    const $fbb5fbcffe407c05$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
        const itemsByKey = fileItems.reduce((prev, fileItem)=>{
            const { id: id, collection: collection } = fileItem;
            const key = $fbb5fbcffe407c05$var$makeCacheKey(id, collection);
            if ($fbb5fbcffe407c05$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
            else if ($fbb5fbcffe407c05$var$isResponseFileItem(fileItem)) prev[key] = {
                ...fileItem.details,
                metadataTraceContext: fileItem.metadataTraceContext
            };
            else prev[key] = {
                id: id,
                collection: collection,
                type: 'not-found',
                metadataTraceContext: fileItem.metadataTraceContext
            };
            return prev;
        }, {});
        return dataloaderKeys.map((dataloaderKey)=>{
            const { id: id, collectionName: collectionName } = dataloaderKey;
            const key = $fbb5fbcffe407c05$var$makeCacheKey(id, collectionName);
            return itemsByKey[key] || {
                id: id,
                type: 'not-found'
            };
        });
    };
    function $fbb5fbcffe407c05$export$4a53beb129e8c49a(mediaStore) {
        return async (keys)=>{
            const nonCollectionName = '__media-single-file-collection__';
            const fileIdsByCollection = keys.reduce((acc, key)=>{
                const collectionName = key.collectionName || nonCollectionName;
                const fileIds = acc[collectionName] || [];
                if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
                acc[collectionName] = fileIds;
                return acc;
            }, {});
            const items = [];
            await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
                const metadataTraceContext = {
                    traceId: (0, (0, parcelRequire("lh7hT")).getRandomHex)(8),
                    spanId: (0, (0, parcelRequire("lh7hT")).getRandomHex)(8)
                };
                const fileIds = fileIdsByCollection[collectionNameKey];
                const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
                try {
                    const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                    const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                            ...item,
                            metadataTraceContext: metadataTraceContext
                        }));
                    items.push(...itemsWithMetadataTraceContext);
                    const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                    const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                    fileIdsNotFound.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            type: 'not-found',
                            metadataTraceContext: metadataTraceContext
                        });
                    });
                } catch (error) {
                    fileIds.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            error: error
                        });
                    });
                }
            }));
            return $fbb5fbcffe407c05$export$71cd2e8f8162d47b(keys, items);
        };
    }
    function $fbb5fbcffe407c05$export$ae188fee39529b82(mediaStore) {
        return new (0, ($parcel$interopDefault($hhZW9)))($fbb5fbcffe407c05$export$4a53beb129e8c49a(mediaStore), {
            maxBatchSize: $fbb5fbcffe407c05$export$b79d95ee17a87a
        });
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("k9LMn", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromUploadableFile", ()=>$30bf08fcda823474$export$ac3214931ffd82af);
    var $1GOqZ;
    const $30bf08fcda823474$export$ac3214931ffd82af = (file)=>{
        if (file.content instanceof Blob) {
            const type = file.content.type;
            return (0, (0, parcelRequire("1GOqZ")).getMediaTypeFromMimeType)(type);
        } else return 'unknown';
    };
});
parcelRegister("1GOqZ", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromMimeType", ()=>$f524a49df4f26bb7$export$79e1dc0d1801e8ef);
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>(parcelRequire("b9Q2k")).isImageMimeTypeSupportedByBrowser);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>(parcelRequire("b9Q2k")).isVideoMimeTypeSupportedByBrowser);
    var $6gH40;
    var $b9Q2k;
    var $5jx5a;
    const $f524a49df4f26bb7$export$79e1dc0d1801e8ef = (mimeType)=>{
        if ((0, (0, parcelRequire("6gH40")).isArchive)(mimeType)) return 'archive';
        if ((0, (0, parcelRequire("b9Q2k")).isImageMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("5jx5a")).isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
        if ((0, (0, parcelRequire("b9Q2k")).isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("5jx5a")).isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
        if ((0, (0, parcelRequire("b9Q2k")).isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("5jx5a")).isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
        if ((0, (0, parcelRequire("b9Q2k")).isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("5jx5a")).isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
        return 'unknown';
    };
});
parcelRegister("6gH40", function(module, exports) {
    $parcel$export(module.exports, "isArchive", ()=>$8d0f56725be43fb9$export$f47f3fe506e20fe6);
    const $8d0f56725be43fb9$export$f47f3fe506e20fe6 = (mimeType)=>[
            'application/x-archive',
            'application/x-cpio',
            'application/x-shar',
            'application/x-iso9660-image',
            'application/x-sbx',
            'application/x-tar',
            'application/x-bzip2',
            'application/gzip',
            'application/x-gzip',
            'application/x-lzip',
            'application/x-lzma',
            'application/x-lzop',
            'application/x-snappy-framed',
            'application/x-xz',
            'application/x-compress',
            'application/zstd',
            'application/x-7z-compressed',
            'application/x-ace-compressed',
            'application/x-astrotite-afa',
            'application/x-alz-compressed',
            'application/vnd.android.package-archive',
            'application/x-freearc',
            'application/x-arj',
            'application/x-b1',
            'application/vnd.ms-cab-compressed',
            'application/x-cfs-compressed',
            'application/x-dar',
            'application/x-dgc-compressed',
            'application/x-apple-diskimage',
            'application/x-gca-compressed',
            'application/java-archive',
            'application/x-lzh',
            'application/x-lzx',
            'application/x-rar-compressed',
            'application/x-stuffit',
            'application/x-stuffitx',
            'application/x-gtar',
            'application/x-ms-wim',
            'application/x-xar',
            'application/zip',
            'application/x-zoo',
            'application/x-par2'
        ].indexOf(mimeType.toLowerCase()) > -1;
});
parcelRegister("b9Q2k", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>$f0ca48f1dccc63d5$export$c021f2623a75015f);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", ()=>$f0ca48f1dccc63d5$export$74325e3c843a9555);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", ()=>$f0ca48f1dccc63d5$export$ff36075ea755a717);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>$f0ca48f1dccc63d5$export$87bf945cf31ec2d9);
    $parcel$export(module.exports, "isMimeTypeSupportedByBrowser", ()=>$f0ca48f1dccc63d5$export$55ca6cdaf6093034);
    const $f0ca48f1dccc63d5$export$c021f2623a75015f = (mimeType)=>[
            'image/apng',
            'image/bmp',
            'image/gif',
            'image/x-icon',
            'image/jpeg',
            'image/png',
            'image/webp'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $f0ca48f1dccc63d5$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
    const $f0ca48f1dccc63d5$export$ff36075ea755a717 = (mimeType)=>[
            'audio/aac',
            'audio/flac',
            'audio/mp4',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/wav',
            'audio/x-wav'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $f0ca48f1dccc63d5$export$87bf945cf31ec2d9 = (mimeType)=>[
            'video/mp4',
            'video/quicktime'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $f0ca48f1dccc63d5$export$55ca6cdaf6093034 = (mimeType)=>$f0ca48f1dccc63d5$export$74325e3c843a9555(mimeType) || $f0ca48f1dccc63d5$export$c021f2623a75015f(mimeType) || $f0ca48f1dccc63d5$export$ff36075ea755a717(mimeType) || $f0ca48f1dccc63d5$export$87bf945cf31ec2d9(mimeType);
});
parcelRegister("5jx5a", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByServer", ()=>$4379879a5ac05776$export$e9a065a80f76311e);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", ()=>$4379879a5ac05776$export$86baad7a89d908e9);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", ()=>$4379879a5ac05776$export$8cba23825d020bbb);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", ()=>$4379879a5ac05776$export$9c2b4de5fdca2ce3);
    $parcel$export(module.exports, "isMimeTypeSupportedByServer", ()=>$4379879a5ac05776$export$548d9148a80556a3);
    const $4379879a5ac05776$export$e9a065a80f76311e = (mimeType)=>[
            'image/bmp',
            'image/x-windows-bmp',
            'application/dicom',
            'image/gif',
            'image/jpeg',
            'image/jpg',
            'image/jp_',
            'application/jpg',
            'application/x-jpg',
            'image/png',
            'application/png',
            'application/x-png',
            'application/vnd.adobe.photoshop',
            'image/vnd.adobe.photoshop',
            'image/photoshop',
            'image/x-photoshop',
            'image/psd',
            'application/photoshop',
            'application/psd',
            'zz-application/zz-winassoc-psd',
            'image/tiff',
            'image/x-tif',
            'image/x-tiff',
            'application/tif',
            'application/x-tif',
            'application/tiff',
            'application/x-tiff',
            'image/svg+xml',
            'image/heif',
            'image/heif-sequence',
            'image/heic',
            'image/heic-sequence'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $4379879a5ac05776$export$86baad7a89d908e9 = (mimeType)=>[
            'application/pdf',
            'application/x-pdf',
            'application/acrobat',
            'applications/vnd.pdf',
            'text/pdf',
            'text/x-pdf',
            'application/vnd.adobe.illustrator',
            'application/vnd.ms-office',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-word.document.macroenabled.12',
            'application/vnd.ms-word.template.macroenabled.12',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.ms-excel.sheet.macroenabled.12',
            'application/vnd.ms-excel.template.macroenabled.12',
            'application/vnd.ms-excel.addin.macroenabled.12',
            'application/vnd.ms-excel.sheet.macroenabled',
            'application/vnd.ms-excel.template.macroenabled',
            'application/vnd.ms-excel.addin.macroenabled',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12',
            'application/vnd.ms-powerpoint.template.macroenabled.12',
            'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
            'application/vnd.sun.xml.writer',
            'application/vnd.sun.xml.writer.template',
            'application/vnd.sun.xml.draw',
            'application/vnd.sun.xml.draw.template',
            'application/vnd.oasis.opendocument.graphics',
            'application/vnd.oasis.opendocument.presentation',
            'application/x-vnd.oasis.opendocument.presentation',
            'application/vnd.sun.xml.calc',
            'application/vnd.sun.xml.calc.template',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/x-vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.spreadsheet-template',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.text-template',
            'application/vnd.oasis.opendocument.text-master',
            'application/x-vnd.oasis.opendocument.text',
            'application/x-vnd.oasis.opendocument.text-template',
            'application/x-vnd.oasis.opendocument.text-master',
            'application/vnd.wordperfect',
            'text/csv',
            'text/x-diff',
            'text/x-perl',
            'text/x-python',
            'text/x-ruby',
            'text/rtf',
            'text/richtext',
            'text/plain',
            'application/txt',
            'application/rtf',
            'application/x-rtf',
            'application/postscript'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $4379879a5ac05776$export$8cba23825d020bbb = (mimeType)=>[
            'audio/aac',
            'audio/x-hx-aac-adts',
            'audio/vnd.dolby.dd-raw',
            'audio/aiff',
            'audio/x-aiff',
            'audio/x-monkeys-audio',
            'audio/x-ape',
            'audio/basic',
            'audio/flac',
            'audio/mp4',
            'audio/midi',
            'audio/x-matroska',
            'audio/x-mod',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/x-pn-realaudio',
            'audio/wav',
            'audio/x-wav',
            'audio/x-ms-wma'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $4379879a5ac05776$export$9c2b4de5fdca2ce3 = (mimeType)=>[
            'video/3gpp',
            'video/3gpp2',
            'video/x-ms-asf',
            'video/avi',
            'video/msvideo',
            'video/x-msvideo',
            'video/x-dv',
            'video/x-flv',
            'video/m2ts',
            'video/x-m4v',
            'video/x-matroska',
            'video/quicktime',
            'video/mp4',
            'video/mpeg',
            'video/ogg',
            'video/x-ogg',
            'video/webm',
            'video/x-ms-wmv'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $4379879a5ac05776$export$94e1479e01d2af53 = (mimeType)=>[
            'binary/octet-stream'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $4379879a5ac05776$export$548d9148a80556a3 = (mimeType)=>$4379879a5ac05776$export$e9a065a80f76311e(mimeType) || $4379879a5ac05776$export$86baad7a89d908e9(mimeType) || $4379879a5ac05776$export$8cba23825d020bbb(mimeType) || $4379879a5ac05776$export$9c2b4de5fdca2ce3(mimeType) || $4379879a5ac05776$export$94e1479e01d2af53(mimeType);
});
parcelRegister("cvXAd", function(module, exports) {
    $parcel$export(module.exports, "overrideMediaTypeIfUnknown", ()=>$834ffd9c4f4322ef$export$89097c0ec1e0dee1);
    var $iaC52;
    const $834ffd9c4f4322ef$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
        if (!(0, (0, parcelRequire("iaC52")).isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
            mediaType: mediaType
        };
        return {};
    };
});
parcelRegister("kJ7Lb", function(module, exports) {
    $parcel$export(module.exports, "convertBase64ToBlob", ()=>$184063cc2064ff7e$export$ed17558b11b88056);
    const $184063cc2064ff7e$export$ed17558b11b88056 = (base64)=>{
        const sliceSize = 512;
        const base64Data = base64.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {
            type: 'image/jpeg'
        });
    };
});
parcelRegister("cZeYk", function(module, exports) {
    $parcel$export(module.exports, "fromObservable", ()=>$1ec37c6a8efb5f7c$export$4b2432e2d8723823);
    var $bW3Xt;
    function $1ec37c6a8efb5f7c$export$4b2432e2d8723823(observable) {
        return {
            subscribe: (observer)=>{
                const subscription = observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
                return {
                    unsubscribe: ()=>{
                        subscription.unsubscribe();
                    }
                };
            }
        };
    }
    function $1ec37c6a8efb5f7c$export$8659d1f07d151381(item) {
        return $1ec37c6a8efb5f7c$export$4b2432e2d8723823((0, (0, parcelRequire("bW3Xt")).createMediaSubject)(item));
    }
});
parcelRegister("bW3Xt", function(module, exports) {
    $parcel$export(module.exports, "createMediaSubject", ()=>$bb9db15489ff4d09$export$bc76d51553fa5e35);
    var $dZ0DN = parcelRequire("dZ0DN");
    function $bb9db15489ff4d09$export$bc76d51553fa5e35(initialState) {
        const subject = new (0, $dZ0DN.ReplaySubject)(1);
        if (initialState instanceof Error) subject.error(initialState);
        else if (initialState) subject.next(initialState);
        return subject;
    }
});
parcelRegister("h2tIX", function(module, exports) {
    $parcel$export(module.exports, "toPromise", ()=>$6f6ae1fab45f617c$export$4dbaaf6c79705e6c);
    var $aZdZn = parcelRequire("aZdZn");
    const $6f6ae1fab45f617c$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
                next: (state)=>{
                    resolve(state);
                    subscription.unsubscribe();
                },
                error: (error)=>{
                    reject(error);
                    subscription.unsubscribe();
                }
            })));
});
parcelRegister("25T96", function(module, exports) {
    $parcel$export(module.exports, "getDimensionsFromBlob", ()=>$2c36617ae3f4c0cf$export$71797c284d89a3e1);
    var $ckDpQ;
    var $5PACv;
    const $2c36617ae3f4c0cf$export$71797c284d89a3e1 = async (mediaType, blob)=>{
        switch(mediaType){
            case 'image':
                {
                    const url = URL.createObjectURL(blob);
                    try {
                        return await (0, (0, parcelRequire("ckDpQ")).getImageDimensionsFromBlob)(url);
                    } finally{
                        URL.revokeObjectURL(url);
                    }
                }
            case 'video':
                return (0, (0, parcelRequire("5PACv")).getVideoDimensionsFromBlob)(blob);
            default:
                throw new Error(`Can't extract dimensions from ${mediaType}`);
        }
    };
});
parcelRegister("ckDpQ", function(module, exports) {
    $parcel$export(module.exports, "getImageDimensionsFromBlob", ()=>$494b6293cdf6566d$export$a1c3205f28a20414);
    const $494b6293cdf6566d$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
            const img = new Image();
            img.src = url;
            img.onload = ()=>resolve({
                    width: img.width,
                    height: img.height
                });
            img.onerror = reject;
        });
});
parcelRegister("5PACv", function(module, exports) {
    $parcel$export(module.exports, "getVideoDimensionsFromBlob", ()=>$18e77bc4fcbdafee$export$62aabd5ff85d0451);
    const $18e77bc4fcbdafee$export$62aabd5ff85d0451 = async (blob)=>{
        return new Promise((resolve, reject)=>{
            const url = URL.createObjectURL(blob);
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.src = url;
            video.muted = true;
            video.addEventListener('loadedmetadata', function timeupdateHandler() {
                video.removeEventListener('loadedmetadata', timeupdateHandler);
                resolve({
                    width: video.videoWidth,
                    height: video.videoHeight
                });
                URL.revokeObjectURL(url);
            });
            video.addEventListener('error', ()=>{
                reject(new Error('failed to load video'));
                URL.revokeObjectURL(url);
            });
        });
    };
});
parcelRegister("l7XOX", function(module, exports) {
    $parcel$export(module.exports, "shouldFetchRemoteFileStates", ()=>$5846afc2a35321b0$export$2ccdd6f9a9eba6a);
    var $b9Q2k;
    var $5jx5a;
    var $5PACv;
    async function $5846afc2a35321b0$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
        if ((mediaType === 'doc' || !(0, (0, parcelRequire("b9Q2k")).isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, (0, parcelRequire("5jx5a")).isMimeTypeSupportedByServer)(mimeType)) return true;
        if (mediaType === 'video' && !!preview) {
            const content = (await preview).value;
            if (!(content instanceof Blob)) return false;
            try {
                const { width: width, height: height } = await (0, (0, parcelRequire("5PACv")).getVideoDimensionsFromBlob)(content);
                return !width && !height;
            } catch (e) {
                return true;
            }
        }
        return false;
    }
});
parcelRegister("7v5TU", function(module, exports) {
    $parcel$export(module.exports, "PollingFunction", ()=>$956b6fb9f6567bbe$export$4c54d536f8e37dc2);
    var $2aF0Q;
    const $956b6fb9f6567bbe$export$9f15a162d6785fc9 = {
        poll_intervalMs: 3000,
        poll_maxAttempts: 30,
        poll_backoffFactor: 1.25,
        poll_maxIntervalMs: 200000
    };
    class $956b6fb9f6567bbe$export$4c54d536f8e37dc2 {
        constructor(options){
            this.poll_intervalMs = 0;
            this.attempt = 1;
            this.shouldIterate = true;
            this.timeoutId = 0;
            this.options = {
                ...$956b6fb9f6567bbe$export$9f15a162d6785fc9,
                ...options
            };
            this.poll_intervalMs = this.options.poll_intervalMs;
        }
        async execute(executor) {
            const { poll_maxAttempts: poll_maxAttempts } = this.options;
            if (poll_maxAttempts === 0) return this.fail(new (0, (0, parcelRequire("2aF0Q")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            try {
                this.shouldIterate = false;
                await executor();
                if (!this.shouldIterate) return;
                if (this.attempt >= poll_maxAttempts) return this.fail(new (0, (0, parcelRequire("2aF0Q")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
                this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
                this.attempt++;
                this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
            } catch (error) {
                this.fail(error);
            }
        }
        fail(error) {
            const { onError: onError } = this;
            this.cancel();
            onError && onError(error);
        }
        getIntervalMsForIteration(iteration) {
            let poll_intervalMs = this.options.poll_intervalMs;
            if (iteration === 1) return poll_intervalMs;
            for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
            return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
        }
        next() {
            this.shouldIterate = true;
        }
        cancel() {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
});
parcelRegister("2aF0Q", function(module, exports) {
    $parcel$export(module.exports, "PollingError", ()=>$7ddda47252d94cd5$export$c3748c310e92340a);
    $parcel$export(module.exports, "isPollingError", ()=>$7ddda47252d94cd5$export$541e3e52eea6fece);
    var $aLxtX;
    class $7ddda47252d94cd5$export$c3748c310e92340a extends (0, (0, parcelRequire("aLxtX")).BaseMediaClientError) {
        constructor(reason, attempts){
            super(reason);
            this.reason = reason;
            this.attempts = attempts;
        }
        get attributes() {
            const { reason: reason, attempts: attempts } = this;
            return {
                reason: reason,
                attempts: attempts
            };
        }
    }
    function $7ddda47252d94cd5$export$541e3e52eea6fece(err) {
        return err instanceof $7ddda47252d94cd5$export$c3748c310e92340a;
    }
});
parcelRegister("gevlu", function(module, exports) {
    $parcel$export(module.exports, "isEmptyFile", ()=>$a745fbef4482d046$export$728192ce8dd94659);
    const $a745fbef4482d046$export$d32fc52697b2ec92 = 43200000;
    function $a745fbef4482d046$export$728192ce8dd94659(fileDetails, now = Date.now()) {
        const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
        if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
            const msSinceFileCreation = now - createdAt;
            if (msSinceFileCreation > $a745fbef4482d046$export$d32fc52697b2ec92) return true;
        }
        return false;
    }
});
parcelRegister("hJHW3", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>(parcelRequire("aO9Bk")).mediaStore);
    var $aO9Bk = parcelRequire("aO9Bk");
});
parcelRegister("aO9Bk", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>$c77cc24083d87124$export$5785580dea19518d);
    var $bIv98;
    var $70n8Q;
    var $ee7sp;
    const $c77cc24083d87124$var$mediaStoreWithoutDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        }))));
    const $c77cc24083d87124$var$mediaStoreWithDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).devtools)((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        })))));
    const $c77cc24083d87124$export$5785580dea19518d = $c77cc24083d87124$var$mediaStoreWithoutDevtools;
    const $c77cc24083d87124$export$503459913a0dc356 = (initialStore)=>{
        return (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
                files: {},
                ...initialStore
            }))));
    };
});
parcelRegister("bIv98", function(module, exports) {
    $parcel$export(module.exports, "devtools", ()=>$887bf6c78f4461c3$export$6922d3b3a607469e);
    $parcel$export(module.exports, "subscribeWithSelector", ()=>$887bf6c78f4461c3$export$5c593627aef9f076);
    var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/middleware.mjs"
    });
    const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
            api.dispatch = (action)=>{
                set((state)=>reducer(state, action), false, action);
                return action;
            };
            api.dispatchFromDevtools = true;
            return {
                dispatch: (...a)=>api.dispatch(...a),
                ...initial
            };
        };
    const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
    const $887bf6c78f4461c3$var$trackedConnections = new Map();
    const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
        const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
        if (!api) return {};
        return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
                key,
                api2.getState()
            ]));
    };
    const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
        if (store === void 0) return {
            type: "untracked",
            connection: extensionConnector.connect(options)
        };
        const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
        if (existingConnection) return {
            type: "tracked",
            store: store,
            ...existingConnection
        };
        const newConnection = {
            connection: extensionConnector.connect(options),
            stores: {}
        };
        $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
        return {
            type: "tracked",
            store: store,
            ...newConnection
        };
    };
    const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
            const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
            let extensionConnector;
            try {
                extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
            } catch (e) {}
            if (!extensionConnector) {
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
                return fn(set, get, api);
            }
            const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
            let isRecording = true;
            api.setState = (state, replace, nameOrAction)=>{
                const r = set(state, replace);
                if (!isRecording) return r;
                const action = nameOrAction === void 0 ? {
                    type: anonymousActionType || "anonymous"
                } : typeof nameOrAction === "string" ? {
                    type: nameOrAction
                } : nameOrAction;
                if (store === void 0) {
                    connection == null || connection.send(action, get());
                    return r;
                }
                connection == null || connection.send({
                    ...action,
                    type: `${store}/${action.type}`
                }, {
                    ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                    [store]: api.getState()
                });
                return r;
            };
            const setStateFromDevtools = (...a)=>{
                const originalIsRecording = isRecording;
                isRecording = false;
                set(...a);
                isRecording = originalIsRecording;
            };
            const initialState = fn(api.setState, get, api);
            if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
            else {
                connectionInformation.stores[connectionInformation.store] = api;
                connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                        key,
                        key === connectionInformation.store ? initialState : store2.getState()
                    ])));
            }
            if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
                let didWarnAboutReservedActionType = false;
                const originalDispatch = api.dispatch;
                api.dispatch = (...a)=>{
                    if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                        console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                        didWarnAboutReservedActionType = true;
                    }
                    originalDispatch(...a);
                };
            }
            connection.subscribe((message)=>{
                var _a;
                switch(message.type){
                    case "ACTION":
                        if (typeof message.payload !== "string") {
                            console.error("[zustand devtools middleware] Unsupported action format");
                            return;
                        }
                        return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                            if (action.type === "__setState") {
                                if (store === void 0) {
                                    setStateFromDevtools(action.state);
                                    return;
                                }
                                if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                                const stateFromDevtools = action.state[store];
                                if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                                if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                                return;
                            }
                            if (!api.dispatchFromDevtools) return;
                            if (typeof api.dispatch !== "function") return;
                            api.dispatch(action);
                        });
                    case "DISPATCH":
                        switch(message.payload.type){
                            case "RESET":
                                setStateFromDevtools(initialState);
                                if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "COMMIT":
                                if (store === void 0) {
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "ROLLBACK":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        connection == null || connection.init(api.getState());
                                        return;
                                    }
                                    setStateFromDevtools(state[store]);
                                    connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                                });
                            case "JUMP_TO_STATE":
                            case "JUMP_TO_ACTION":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        return;
                                    }
                                    if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                                });
                            case "IMPORT_STATE":
                                {
                                    const { nextLiftedState: nextLiftedState } = message.payload;
                                    const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                    if (!lastComputedState) return;
                                    if (store === void 0) setStateFromDevtools(lastComputedState);
                                    else setStateFromDevtools(lastComputedState[store]);
                                    connection == null || connection.send(null, nextLiftedState);
                                    return;
                                }
                            case "PAUSE_RECORDING":
                                return isRecording = !isRecording;
                        }
                        return;
                }
            });
            return initialState;
        };
    const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
    const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
        let parsed;
        try {
            parsed = JSON.parse(stringified);
        } catch (e) {
            console.error("[zustand devtools middleware] Could not parse the received json", e);
        }
        if (parsed !== void 0) f(parsed);
    };
    const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
            const origSubscribe = api.subscribe;
            api.subscribe = (selector, optListener, options)=>{
                let listener = selector;
                if (optListener) {
                    const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                    let currentSlice = selector(api.getState());
                    listener = (state)=>{
                        const nextSlice = selector(state);
                        if (!equalityFn(currentSlice, nextSlice)) {
                            const previousSlice = currentSlice;
                            optListener(currentSlice = nextSlice, previousSlice);
                        }
                    };
                    if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
                }
                return origSubscribe(listener);
            };
            const initialState = fn(set, get, api);
            return initialState;
        };
    const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
    const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
    function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
        let storage;
        try {
            storage = getStorage();
        } catch (e) {
            return;
        }
        const persistStorage = {
            getItem: (name)=>{
                var _a;
                const parse = (str2)=>{
                    if (str2 === null) return null;
                    return JSON.parse(str2, options == null ? void 0 : options.reviver);
                };
                const str = (_a = storage.getItem(name)) != null ? _a : null;
                if (str instanceof Promise) return str.then(parse);
                return parse(str);
            },
            setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
            removeItem: (name)=>storage.removeItem(name)
        };
        return persistStorage;
    }
    const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
            try {
                const result = fn(input);
                if (result instanceof Promise) return result;
                return {
                    then (onFulfilled) {
                        return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                    },
                    catch (_onRejected) {
                        return this;
                    }
                };
            } catch (e) {
                return {
                    then (_onFulfilled) {
                        return this;
                    },
                    catch (onRejected) {
                        return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                    }
                };
            }
        };
    const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                getStorage: ()=>localStorage,
                serialize: JSON.stringify,
                deserialize: JSON.parse,
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage;
            try {
                storage = options.getStorage();
            } catch (e) {}
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                let errorInSync;
                const thenable = thenableSerialize({
                    state: state,
                    version: options.version
                }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                    errorInSync = e;
                });
                if (errorInSync) throw errorInSync;
                return thenable;
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            let stateFromStorage;
            const hydrate = ()=>{
                var _a;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>cb(get()));
                const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                    if (storageValue) return options.deserialize(storageValue);
                }).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.getStorage) storage = newOptions.getStorage();
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage = options.storage;
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                return storage.setItem(options.name, {
                    state: state,
                    version: options.version
                });
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            api.getInitialState = ()=>configResult;
            let stateFromStorage;
            const hydrate = ()=>{
                var _a, _b;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>{
                    var _a2;
                    return cb((_a2 = get()) != null ? _a2 : configResult);
                });
                const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    stateFromStorage = get();
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.storage) storage = newOptions.storage;
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            if (!options.skipHydration) hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
        if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
            return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
        }
        return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
    };
    const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;
});
parcelRegister("70n8Q", function(module, exports) {
    $parcel$export(module.exports, "immer", ()=>$519a7bf2c276fd5a$export$428de7ec69ac95c);
    var $86xFr;
    const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
            store.setState = (updater, replace, ...a)=>{
                const nextState = typeof updater === "function" ? (0, (0, parcelRequire("86xFr")).produce)(updater) : updater;
                return set(nextState, replace, ...a);
            };
            return initializer(store.setState, get, store);
        };
    const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;
});
parcelRegister("86xFr", function(module, exports) {
    $parcel$export(module.exports, "produce", ()=>fn);
    function n(n) {
        for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
        var i, o;
        throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
            return "'" + n + "'";
        }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }
    function r(n) {
        return !!n && !!n[Q];
    }
    function t(n) {
        var r;
        return !!n && (function(n) {
            if (!n || "object" != typeof n) return !1;
            var r = Object.getPrototypeOf(n);
            if (null === r) return !0;
            var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
            return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
        }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
    }
    function e(t) {
        return r(t) || n(23, t), t[Q].t;
    }
    function i(n, r, t) {
        void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
            t && "symbol" == typeof e || r(e, n[e], n);
        }) : n.forEach(function(t, e) {
            return r(e, t, n);
        });
    }
    function o(n) {
        var r = n[Q];
        return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
    }
    function u(n, r) {
        return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
    }
    function a(n, r) {
        return 2 === o(n) ? n.get(r) : n[r];
    }
    function f(n, r, t) {
        var e = o(n);
        2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
    }
    function c(n, r) {
        return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
    }
    function s(n) {
        return X && n instanceof Map;
    }
    function v(n) {
        return q && n instanceof Set;
    }
    function p(n) {
        return n.o || n.t;
    }
    function l(n) {
        if (Array.isArray(n)) return Array.prototype.slice.call(n);
        var r = rn(n);
        delete r[Q];
        for(var t = nn(r), e = 0; e < t.length; e++){
            var i = t[e], o = r[i];
            !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: n[i]
            });
        }
        return Object.create(Object.getPrototypeOf(n), r);
    }
    function d(n, e) {
        return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
            return d(r, !0);
        }, !0)), n;
    }
    function h() {
        n(2);
    }
    function y(n) {
        return null == n || "object" != typeof n || Object.isFrozen(n);
    }
    function b(r) {
        var t = tn[r];
        return t || n(18, r), t;
    }
    function m(n, r) {
        tn[n] || (tn[n] = r);
    }
    function _() {
        return U;
    }
    function j(n, r) {
        r && (b("Patches"), n.u = [], n.s = [], n.v = r);
    }
    function g(n) {
        O(n), n.p.forEach(S), n.p = null;
    }
    function O(n) {
        n === U && (U = n.l);
    }
    function w(n) {
        return U = {
            p: [],
            l: U,
            h: n,
            m: !0,
            _: 0
        };
    }
    function S(n) {
        var r = n[Q];
        0 === r.i || 1 === r.i ? r.j() : r.g = !0;
    }
    function P(r, e) {
        e._ = e.p.length;
        var i = e.p[0], o = void 0 !== r && r !== i;
        return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
    }
    function M(n, r, t) {
        if (y(r)) return r;
        var e = r[Q];
        if (!e) return i(r, function(i, o) {
            return A(n, e, r, i, o, t);
        }, !0), r;
        if (e.A !== n) return r;
        if (!e.P) return x(n, e.t, !0), e.t;
        if (!e.I) {
            e.I = !0, e.A._--;
            var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
            3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
                return A(n, e, o, r, i, t, a);
            }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
        }
        return e.o;
    }
    function A(e, i, o, a, c, s, v) {
        if (r(c)) {
            var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
            if (f(o, a, p), !r(p)) return;
            e.m = !1;
        } else v && o.add(c);
        if (t(c) && !y(c)) {
            if (!e.h.D && e._ < 1) return;
            M(e, c), i && i.A.l || x(e, c);
        }
    }
    function x(n, r, t) {
        void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
    }
    function z(n, r) {
        var t = n[Q];
        return (t ? p(t) : n)[r];
    }
    function I(n, r) {
        if (r in n) for(var t = Object.getPrototypeOf(n); t;){
            var e = Object.getOwnPropertyDescriptor(t, r);
            if (e) return e;
            t = Object.getPrototypeOf(t);
        }
    }
    function k(n) {
        n.P || (n.P = !0, n.l && k(n.l));
    }
    function E(n) {
        n.o || (n.o = l(n.t));
    }
    function N(n, r, t) {
        var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
            var t = Array.isArray(n), e = {
                i: t ? 1 : 0,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: null,
                o: null,
                j: null,
                C: !1
            }, i = e, o = en;
            t && (i = [
                e
            ], o = on);
            var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
            return e.k = f, e.j = a, f;
        }(r, t) : b("ES5").J(r, t);
        return (t ? t.A : _()).p.push(e), e;
    }
    function R(e) {
        return r(e) || n(22, e), function n(r) {
            if (!t(r)) return r;
            var e, u = r[Q], c = o(r);
            if (u) {
                if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
                u.I = !0, e = D(r, c), u.I = !1;
            } else e = D(r, c);
            return i(e, function(r, t) {
                u && a(u.t, r) === t || f(e, r, n(t));
            }), 3 === c ? new Set(e) : e;
        }(e);
    }
    function D(n, r) {
        switch(r){
            case 2:
                return new Map(n);
            case 3:
                return Array.from(n);
        }
        return l(n);
    }
    function F() {
        function t(n, r) {
            var t = s[n];
            return t ? t.enumerable = r : s[n] = t = {
                configurable: !0,
                enumerable: r,
                get: function() {
                    var r = this[Q];
                    return en.get(r, n);
                },
                set: function(r) {
                    var t = this[Q];
                    en.set(t, n, r);
                }
            }, t;
        }
        function e(n) {
            for(var r = n.length - 1; r >= 0; r--){
                var t = n[r][Q];
                if (!t.P) switch(t.i){
                    case 5:
                        a(t) && k(t);
                        break;
                    case 4:
                        o(t) && k(t);
                }
            }
        }
        function o(n) {
            for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
                var o = e[i];
                if (o !== Q) {
                    var a = r[o];
                    if (void 0 === a && !u(r, o)) return !0;
                    var f = t[o], s = f && f[Q];
                    if (s ? s.t !== a : !c(f, a)) return !0;
                }
            }
            var v = !!r[Q];
            return e.length !== nn(r).length + (v ? 0 : 1);
        }
        function a(n) {
            var r = n.k;
            if (r.length !== n.t.length) return !0;
            var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
            if (t && !t.get) return !0;
            for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
            return !1;
        }
        function f(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var s = {};
        m("ES5", {
            J: function(n, r) {
                var e = Array.isArray(n), i = function(n, r) {
                    if (n) {
                        for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                        return e;
                    }
                    var o = rn(r);
                    delete o[Q];
                    for(var u = nn(o), a = 0; a < u.length; a++){
                        var f = u[a];
                        o[f] = t(f, n || !!o[f].enumerable);
                    }
                    return Object.create(Object.getPrototypeOf(r), o);
                }(e, n), o = {
                    i: e ? 5 : 4,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    R: {},
                    l: r,
                    t: n,
                    k: i,
                    o: null,
                    g: !1,
                    C: !1
                };
                return Object.defineProperty(i, Q, {
                    value: o,
                    writable: !0
                }), i;
            },
            S: function(n, t, o) {
                o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                    if (r && "object" == typeof r) {
                        var t = r[Q];
                        if (t) {
                            var e = t.t, o = t.k, f = t.R, c = t.i;
                            if (4 === c) i(o, function(r) {
                                r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                            }), i(e, function(n) {
                                void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                            });
                            else if (5 === c) {
                                if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                                else for(var v = e.length; v < o.length; v++)f[v] = !0;
                                for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                            }
                        }
                    }
                }(n.p[0]), e(n.p));
            },
            K: function(n) {
                return 4 === n.i ? o(n) : a(n);
            }
        });
    }
    function T() {
        function e(n) {
            if (!t(n)) return n;
            if (Array.isArray(n)) return n.map(e);
            if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
                return [
                    n[0],
                    e(n[1])
                ];
            }));
            if (v(n)) return new Set(Array.from(n).map(e));
            var r = Object.create(Object.getPrototypeOf(n));
            for(var i in n)r[i] = e(n[i]);
            return u(n, L) && (r[L] = n[L]), r;
        }
        function f(n) {
            return r(n) ? e(n) : n;
        }
        var c = "add";
        m("Patches", {
            $: function(r, t) {
                return t.forEach(function(t) {
                    for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                        var v = o(f), p = i[s];
                        "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                    }
                    var l = o(f), d = e(t.value), h = i[i.length - 1];
                    switch(u){
                        case "replace":
                            switch(l){
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    n(16);
                                default:
                                    return f[h] = d;
                            }
                        case c:
                            switch(l){
                                case 1:
                                    return "-" === h ? f.push(d) : f.splice(h, 0, d);
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    return f.add(d);
                                default:
                                    return f[h] = d;
                            }
                        case "remove":
                            switch(l){
                                case 1:
                                    return f.splice(h, 1);
                                case 2:
                                    return f.delete(h);
                                case 3:
                                    return f.delete(t.value);
                                default:
                                    return delete f[h];
                            }
                        default:
                            n(17, u);
                    }
                }), r;
            },
            N: function(n, r, t, e) {
                switch(n.i){
                    case 0:
                    case 4:
                    case 2:
                        return function(n, r, t, e) {
                            var o = n.t, s = n.o;
                            i(n.R, function(n, i) {
                                var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                                if (v !== p || "replace" !== l) {
                                    var d = r.concat(n);
                                    t.push("remove" === l ? {
                                        op: l,
                                        path: d
                                    } : {
                                        op: l,
                                        path: d,
                                        value: p
                                    }), e.push(l === c ? {
                                        op: "remove",
                                        path: d
                                    } : "remove" === l ? {
                                        op: c,
                                        path: d,
                                        value: f(v)
                                    } : {
                                        op: "replace",
                                        path: d,
                                        value: f(v)
                                    });
                                }
                            });
                        }(n, r, t, e);
                    case 5:
                    case 1:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.R, u = n.o;
                            if (u.length < i.length) {
                                var a = [
                                    u,
                                    i
                                ];
                                i = a[0], u = a[1];
                                var s = [
                                    e,
                                    t
                                ];
                                t = s[0], e = s[1];
                            }
                            for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                                var p = r.concat([
                                    v
                                ]);
                                t.push({
                                    op: "replace",
                                    path: p,
                                    value: f(u[v])
                                }), e.push({
                                    op: "replace",
                                    path: p,
                                    value: f(i[v])
                                });
                            }
                            for(var l = i.length; l < u.length; l++){
                                var d = r.concat([
                                    l
                                ]);
                                t.push({
                                    op: c,
                                    path: d,
                                    value: f(u[l])
                                });
                            }
                            i.length < u.length && e.push({
                                op: "replace",
                                path: r.concat([
                                    "length"
                                ]),
                                value: i.length
                            });
                        }(n, r, t, e);
                    case 3:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.o, u = 0;
                            i.forEach(function(n) {
                                if (!o.has(n)) {
                                    var i = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: "remove",
                                        path: i,
                                        value: n
                                    }), e.unshift({
                                        op: c,
                                        path: i,
                                        value: n
                                    });
                                }
                                u++;
                            }), u = 0, o.forEach(function(n) {
                                if (!i.has(n)) {
                                    var o = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: c,
                                        path: o,
                                        value: n
                                    }), e.unshift({
                                        op: "remove",
                                        path: o,
                                        value: n
                                    });
                                }
                                u++;
                            });
                        }(n, r, t, e);
                }
            },
            M: function(n, r, t, e) {
                t.push({
                    op: "replace",
                    path: [],
                    value: r === H ? void 0 : r
                }), e.push({
                    op: "replace",
                    path: [],
                    value: n
                });
            }
        });
    }
    function C() {
        function r(n, r) {
            function t() {
                this.constructor = n;
            }
            a(n, r), n.prototype = (t.prototype = r.prototype, new t);
        }
        function e(n) {
            n.o || (n.R = new Map, n.o = new Map(n.t));
        }
        function o(n) {
            n.o || (n.o = new Set, n.t.forEach(function(r) {
                if (t(r)) {
                    var e = N(n.A.h, r, n);
                    n.p.set(r, e), n.o.add(e);
                } else n.o.add(r);
            }));
        }
        function u(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var a = function(n, r) {
            return (a = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(n, r) {
                n.__proto__ = r;
            } || function(n, r) {
                for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
            })(n, r);
        }, f = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 2,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    R: void 0,
                    t: n,
                    k: this,
                    C: !1,
                    g: !1
                }, this;
            }
            r(n, Map);
            var o = n.prototype;
            return Object.defineProperty(o, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), o.has = function(n) {
                return p(this[Q]).has(n);
            }, o.set = function(n, r) {
                var t = this[Q];
                return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
            }, o.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
            }, o.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                    n.R.set(r, !1);
                }), n.o.clear());
            }, o.forEach = function(n, r) {
                var t = this;
                p(this[Q]).forEach(function(e, i) {
                    n.call(r, t.get(i), i, t);
                });
            }, o.get = function(n) {
                var r = this[Q];
                u(r);
                var i = p(r).get(n);
                if (r.I || !t(i)) return i;
                if (i !== r.t.get(n)) return i;
                var o = N(r.A.h, i, r);
                return e(r), r.o.set(n, o), o;
            }, o.keys = function() {
                return p(this[Q]).keys();
            }, o.values = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.values();
                }, n.next = function() {
                    var n = t.next();
                    return n.done ? n : {
                        done: !1,
                        value: r.get(n.value)
                    };
                }, n;
            }, o.entries = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.entries();
                }, n.next = function() {
                    var n = t.next();
                    if (n.done) return n;
                    var e = r.get(n.value);
                    return {
                        done: !1,
                        value: [
                            n.value,
                            e
                        ]
                    };
                }, n;
            }, o[V] = function() {
                return this.entries();
            }, n;
        }(), c = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 3,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    t: n,
                    k: this,
                    p: new Map,
                    g: !1,
                    C: !1
                }, this;
            }
            r(n, Set);
            var t = n.prototype;
            return Object.defineProperty(t, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), t.has = function(n) {
                var r = this[Q];
                return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
            }, t.add = function(n) {
                var r = this[Q];
                return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
            }, t.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
            }, t.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (o(n), k(n), n.o.clear());
            }, t.values = function() {
                var n = this[Q];
                return u(n), o(n), n.o.values();
            }, t.entries = function() {
                var n = this[Q];
                return u(n), o(n), n.o.entries();
            }, t.keys = function() {
                return this.values();
            }, t[V] = function() {
                return this.values();
            }, t.forEach = function(n, r) {
                for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
            }, n;
        }();
        m("MapSet", {
            F: function(n, r) {
                return new f(n, r);
            },
            T: function(n, r) {
                return new c(n, r);
            }
        });
    }
    function J() {
        F(), C(), T();
    }
    function K(n) {
        return n;
    }
    function $(n) {
        return n;
    }
    var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
        0: "Illegal state",
        1: "Immer drafts cannot have computed properties",
        2: "This object has been frozen and should not be mutated",
        3: function(n) {
            return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
        },
        4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
        5: "Immer forbids circular references",
        6: "The first or second argument to `produce` must be a function",
        7: "The third argument to `produce` must be a function or undefined",
        8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
        9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
        10: "The given draft is already finalized",
        11: "Object.defineProperty() cannot be used on an Immer draft",
        12: "Object.setPrototypeOf() cannot be used on an Immer draft",
        13: "Immer only supports deleting array indices",
        14: "Immer only supports setting array indices and the 'length' property",
        15: function(n) {
            return "Cannot apply patch, path doesn't resolve: " + n;
        },
        16: 'Sets cannot have "replace" patches.',
        17: function(n) {
            return "Unsupported patch operation: " + n;
        },
        18: function(n) {
            return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
        },
        20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
        21: function(n) {
            return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
        },
        22: function(n) {
            return "'current' expects a draft, got: " + n;
        },
        23: function(n) {
            return "'original' expects a draft, got: " + n;
        },
        24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
    }, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
        return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
    } : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
        var r = {};
        return nn(n).forEach(function(t) {
            r[t] = Object.getOwnPropertyDescriptor(n, t);
        }), r;
    }, tn = {}, en = {
        get: function(n, r) {
            if (r === Q) return n;
            var e = p(n);
            if (!u(e, r)) return function(n, r, t) {
                var e, i = I(r, t);
                return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
            }(n, e, r);
            var i = e[r];
            return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
        },
        has: function(n, r) {
            return r in p(n);
        },
        ownKeys: function(n) {
            return Reflect.ownKeys(p(n));
        },
        set: function(n, r, t) {
            var e = I(p(n), r);
            if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
            if (!n.P) {
                var i = z(p(n), r), o = null == i ? void 0 : i[Q];
                if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
                if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
                E(n), k(n);
            }
            return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
        },
        deleteProperty: function(n, r) {
            return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
        },
        getOwnPropertyDescriptor: function(n, r) {
            var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
            return e ? {
                writable: !0,
                configurable: 1 !== n.i || "length" !== r,
                enumerable: e.enumerable,
                value: t[r]
            } : e;
        },
        defineProperty: function() {
            n(11);
        },
        getPrototypeOf: function(n) {
            return Object.getPrototypeOf(n.t);
        },
        setPrototypeOf: function() {
            n(12);
        }
    }, on = {};
    i(en, function(n, r) {
        on[n] = function() {
            return arguments[0] = arguments[0][0], r.apply(this, arguments);
        };
    }), on.deleteProperty = function(r, t) {
        return on.set.call(this, r, t, void 0);
    }, on.set = function(r, t, e) {
        return en.set.call(this, r[0], t, e, r[0]);
    };
    var un = function() {
        function e(r) {
            var e = this;
            this.O = B, this.D = !0, this.produce = function(r, i, o) {
                if ("function" == typeof r && "function" != typeof i) {
                    var u = i;
                    i = r;
                    var a = e;
                    return function(n) {
                        var r = this;
                        void 0 === n && (n = u);
                        for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                        return a.produce(n, function(n) {
                            var t;
                            return (t = i).call.apply(t, [
                                r,
                                n
                            ].concat(e));
                        });
                    };
                }
                var f;
                if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                    var c = w(e), s = N(e, r, void 0), v = !0;
                    try {
                        f = i(s), v = !1;
                    } finally{
                        v ? g(c) : O(c);
                    }
                    return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                        return j(c, o), P(n, c);
                    }, function(n) {
                        throw g(c), n;
                    }) : (j(c, o), P(f, c));
                }
                if (!r || "object" != typeof r) {
                    if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                        var p = [], l = [];
                        b("Patches").M(r, f, p, l), o(p, l);
                    }
                    return f;
                }
                n(21, r);
            }, this.produceWithPatches = function(n, r) {
                if ("function" == typeof n) return function(r) {
                    for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                    return e.produceWithPatches(r, function(r) {
                        return n.apply(void 0, [
                            r
                        ].concat(i));
                    });
                };
                var t, i, o = e.produce(n, r, function(n, r) {
                    t = n, i = r;
                });
                return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                    return [
                        n,
                        t,
                        i
                    ];
                }) : [
                    o,
                    t,
                    i
                ];
            }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
        }
        var i = e.prototype;
        return i.createDraft = function(e) {
            t(e) || n(8), r(e) && (e = R(e));
            var i = w(this), o = N(this, e, void 0);
            return o[Q].C = !0, O(i), o;
        }, i.finishDraft = function(r, t) {
            var e = r && r[Q];
            var i = e.A;
            return j(i, t), P(void 0, i);
        }, i.setAutoFreeze = function(n) {
            this.D = n;
        }, i.setUseProxies = function(r) {
            r && !B && n(20), this.O = r;
        }, i.applyPatches = function(n, t) {
            var e;
            for(e = t.length - 1; e >= 0; e--){
                var i = t[e];
                if (0 === i.path.length && "replace" === i.op) {
                    n = i.value;
                    break;
                }
            }
            e > -1 && (t = t.slice(e + 1));
            var o = b("Patches").$;
            return r(n) ? o(n, t) : this.produce(n, function(n) {
                return o(n, t);
            });
        }, e;
    }(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
    var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;
});
parcelRegister("ee7sp", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$a5b82856cfbd137f$export$f51a9068ac82ea43);
    var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/vanilla.mjs"
    });
    const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
        let state;
        const listeners = new Set();
        const setState = (partial, replace)=>{
            const nextState = typeof partial === "function" ? partial(state) : partial;
            if (!Object.is(nextState, state)) {
                const previousState = state;
                state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
                listeners.forEach((listener)=>listener(state, previousState));
            }
        };
        const getState = ()=>state;
        const getInitialState = ()=>initialState;
        const subscribe = (listener)=>{
            listeners.add(listener);
            return ()=>listeners.delete(listener);
        };
        const destroy = ()=>{
            if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
            listeners.clear();
        };
        const api = {
            setState: setState,
            getState: getState,
            getInitialState: getInitialState,
            subscribe: subscribe,
            destroy: destroy
        };
        const initialState = state = createState(setState, getState, api);
        return api;
    };
    const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
    var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
        return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
    };
});
parcelRegister("bBU9J", function(module, exports) {
    $parcel$export(module.exports, "StargateClient", ()=>$b0cc2e572d80e936$export$c66ca190f89caaac);
    class $b0cc2e572d80e936$export$c66ca190f89caaac {
        constructor(baseUrl){
            this.baseUrl = baseUrl || '/gateway/api';
        }
        async fetchToken(clientId) {
            return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
                credentials: 'include',
                headers: {
                    'x-client-id': clientId
                }
            })).json();
        }
        isTokenExpired(token) {
            const currentTimeInSeconds = new Date().getTime() / 1000;
            return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
        }
    }
});
parcelRegister("evHmy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("66G7r").then(()=>parcelRequire('1lpSp'));
});
parcelRegister("h17zy", function(module, exports) {
    $parcel$export(module.exports, "useEmojiProvider", ()=>$502e0815e90e6f7b$export$d80cf6b7758b1c7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $2osam;
    var $hXRXz;
    var $90yGq;
    var $koeKL;
    const $502e0815e90e6f7b$export$d80cf6b7758b1c7e = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const atlassianAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const emojiProvider = (0, $5uXOq.useMemo)(()=>{
            const dataProviders = new (0, (0, parcelRequire("2osam")).default)();
            dataProviders.setProvider('emojiProvider', (0, (0, parcelRequire("hXRXz")).getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
            return dataProviders;
        }, [
            cloudId,
            atlassianAccountId
        ]);
        return emojiProvider;
    };
});
parcelRegister("hXRXz", function(module, exports) {
    $parcel$export(module.exports, "getEmojiProvider", ()=>$8599af293a85f3b3$export$8210f5f78c0bcf27);
    $parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", ()=>$8599af293a85f3b3$export$f9c5a1e85ff0cb72);
    $parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", ()=>$8599af293a85f3b3$export$7cda0fc535c2710f);
    var $4n2on;
    var $9CGZY;
    const $8599af293a85f3b3$var$baseProviders = (serviceBaseUrl)=>[
            {
                url: `${serviceBaseUrl}/emoji/standard`
            },
            {
                url: `${serviceBaseUrl}/emoji/atlassian`
            }
        ];
    const $8599af293a85f3b3$export$8210f5f78c0bcf27 = ()=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_SERVICEID), (serviceBaseUrl)=>{
            const emojiResource = new (0, (0, parcelRequire("4n2on")).default)({
                providers: $8599af293a85f3b3$var$baseProviders(serviceBaseUrl)
            });
            return emojiResource.getEmojiProvider();
        });
    const $8599af293a85f3b3$export$f9c5a1e85ff0cb72 = (cloudId, accountId)=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
            const providers = cloudId ? [
                ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
                {
                    url: `${serviceBaseUrl}/emoji/${cloudId}/site`
                }
            ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
            const emojiResource = new (0, (0, parcelRequire("4n2on")).default)({
                providers: providers,
                allowUpload: true,
                currentUser: {
                    id: accountId
                }
            });
            return emojiResource.getEmojiProvider();
        });
    const $8599af293a85f3b3$export$7cda0fc535c2710f = (cloudId, accountId)=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
            const providers = cloudId ? [
                ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
                {
                    url: `${serviceBaseUrl}/emoji/${cloudId}/site`
                }
            ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
            const emojiResource = new (0, (0, parcelRequire("4n2on")).default)({
                providers: providers,
                allowUpload: false,
                currentUser: {
                    id: accountId
                }
            });
            return emojiResource.getEmojiProvider();
        });
});
parcelRegister("4n2on", function(module, exports) {
    $parcel$export(module.exports, "supportsUploadFeature", ()=>$4687db15348be69e$export$7b697b720032fd6f);
    $parcel$export(module.exports, "default", ()=>$4687db15348be69e$export$2e2bcd8739ae039);
    var $2Z5gN = parcelRequire("2Z5gN");
    var $8PD8v;
    var $gLnrw;
    var $ibnx0;
    var $6ijiY;
    var $8JfNZ;
    var $lpq8i;
    var $vcPXi;
    var $aJRhE;
    var $eNoEO;
    const $4687db15348be69e$export$7b697b720032fd6f = (emojiProvider)=>{
        const emojiUploadProvider = emojiProvider;
        return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
    };
    class $4687db15348be69e$export$b5efafc6dd611ec5 extends (0, $2Z5gN.AbstractResource) {
        constructor(config){
            super();
            this.activeLoaders = 0;
            this.initialLoaders = 0;
            this.retries = new Map();
            this.isInitialised = false;
            this.fetchOnDemand = false;
            this.getOptimisticImageURL = (emojiId)=>{
                if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
                return;
            };
            this.isRepositoryAvailable = (repository)=>{
                return !!repository;
            };
            this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
            this.emojiProviderConfig = config;
            this.recordConfig = config.recordConfig;
            this.currentUser = config.currentUser;
            if ((0, (0, parcelRequire("6ijiY")).default)('localStorage')) this.selectedTone = this.loadStoredTone();
            if (config.providers.length === 0) throw new Error('No providers specified');
            this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
            this.initialLoaders = this.emojiProviderConfig.providers.length;
            this.activeLoaders = this.emojiProviderConfig.providers.length;
            this.emojiResponses = [];
        }
        async getEmojiProvider(options = {
            fetchAtStart: !this.fetchOnDemand
        }) {
            if (options.fetchAtStart) try {
                await this.fetchEmojiProvider();
            } catch (error) {
                (0, (0, parcelRequire("gLnrw")).default)(error);
                return Promise.resolve(this);
            }
            return Promise.resolve(this);
        }
        async fetchIndividualProvider(provider, index) {
            const providerType = this.getProviderType(provider);
            try {
                (0, (0, parcelRequire("eNoEO")).sampledUfoEmojiResourceFetched)(providerType).start({
                    samplingRate: (0, (0, parcelRequire("8PD8v")).SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
                });
                (0, (0, parcelRequire("eNoEO")).sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                    type: providerType
                });
                const loader = new (0, (0, parcelRequire("lpq8i")).default)(provider);
                const emojiResponse = await loader.loadEmoji();
                (0, (0, parcelRequire("eNoEO")).sampledUfoEmojiResourceFetched)(providerType).success();
                this.emojiResponses[index] = emojiResponse;
                this.initEmojiRepository(this.emojiResponses);
                await this.initSiteEmojiResource(emojiResponse, provider);
                this.activeLoaders--;
                this.performRetries();
                this.refreshLastFilter();
            } catch (error) {
                this.activeLoaders--;
                this.notifyError(error);
                (0, (0, parcelRequire("eNoEO")).sampledUfoEmojiResourceFetched)(providerType).failure({
                    metadata: {
                        reason: error,
                        source: 'EmojiProvider',
                        providerUrl: provider.url
                    }
                });
                (0, (0, parcelRequire("gLnrw")).default)(`failed to fetch emoji provider for ${provider.url}`, error);
                throw new Error(`failed to fetch emoji from ${provider.url}`);
            }
        }
        async fetchEmojiProvider(force = false) {
            if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
                this.isInitialised = true;
                this.emojiResponses = [];
                await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
            }
            return Promise.resolve(this.emojiRepository);
        }
        onlyFetchOnDemand() {
            return this.fetchOnDemand;
        }
        async fetchByEmojiId(emojiId, optimistic) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
                const emoji = await this.findByEmojiId(emojiId);
                if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
            if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
                const provider = {
                    url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                    securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
                };
                const loader = new (0, (0, parcelRequire("lpq8i")).default)(provider);
                try {
                    const loadEmoji = await loader.loadEmoji();
                    if (!loadEmoji.emojis[0]) return;
                    if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                    return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
                } catch  {
                    const emoji = await this.findByEmojiId(emojiId);
                    if (!emoji) return;
                    return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
                }
            }
            const emoji = await this.findByEmojiId(emojiId);
            if (!emoji) return;
            return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        getProviderType(provider) {
            if (provider.url.includes('/site')) return (0, (0, parcelRequire("8JfNZ")).ProviderTypes).SITE;
            else if (provider.url.includes('/standard')) return (0, (0, parcelRequire("8JfNZ")).ProviderTypes).STANDARD;
            else if (provider.url.includes('/atlassian')) return (0, (0, parcelRequire("8JfNZ")).ProviderTypes).ATLASSIAN;
            return (0, (0, parcelRequire("8JfNZ")).ProviderTypes).UNKNOWN;
        }
        initEmojiRepository(emojiResponses) {
            let emojis = [];
            emojiResponses.forEach((emojiResponse)=>{
                emojis = emojis.concat(emojiResponse.emojis);
            });
            this.emojiRepository = new (0, (0, parcelRequire("vcPXi")).default)(emojis);
        }
        initSiteEmojiResource(emojiResponse, provider) {
            if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
                this.siteEmojiResource = new (0, (0, parcelRequire("aJRhE")).default)(provider, emojiResponse.mediaApiToken);
                const { emojis: emojis } = emojiResponse;
                if (emojis.length) {
                    const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                    if ((0, (0, parcelRequire("ibnx0")).isPromise)(done)) return done.then(()=>{
                        (0, (0, parcelRequire("gLnrw")).default)('Primed siteEmojiResource');
                    }).catch(()=>{
                        (0, (0, parcelRequire("gLnrw")).default)('Failed to prime siteEmojiResource');
                    });
                    else (0, (0, parcelRequire("gLnrw")).default)('Already primed siteEmojiResource');
                } else (0, (0, parcelRequire("gLnrw")).default)('No emoji to prime siteEmojiResource with');
            }
            return Promise.resolve();
        }
        performRetries() {
            const currentRetries = this.retries;
            this.retries = new Map();
            currentRetries.forEach((resolveReject, retry)=>{
                const result = retry();
                if ((0, (0, parcelRequire("ibnx0")).isPromise)(result)) result.then((response)=>{
                    resolveReject.resolve(response);
                }).catch((reason)=>{
                    resolveReject.reject(reason);
                });
                else resolveReject.resolve(result);
            });
        }
        loadStoredTone() {
            if (typeof window === 'undefined') return undefined;
            const storedToneString = window.localStorage.getItem((0, (0, parcelRequire("8PD8v")).selectedToneStorageKey));
            if (storedToneString) {
                const storedTone = parseInt(storedToneString, 10);
                return !isNaN(storedTone) ? storedTone : undefined;
            }
            return undefined;
        }
        refreshLastFilter() {
            if (typeof this.lastQuery !== 'undefined') {
                const { query: query, options: options } = this.lastQuery;
                this.filter(query, options);
            }
        }
        retryIfLoading(retry, defaultResponse) {
            if (!this.isLoaded()) return new Promise((resolve, reject)=>{
                this.retries.set(retry, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return Promise.resolve(defaultResponse);
        }
        notifyResult(result) {
            if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
        }
        async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
            if (this.isRepositoryAvailable(this.siteEmojiResource)) {
                const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
                return {
                    ...emoji,
                    representation: representation,
                    altRepresentation: altRepresentation
                };
            }
            return emoji;
        }
        loadMediaEmoji(emoji, useAlt) {
            if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, (0, parcelRequire("ibnx0")).isMediaEmoji)(emoji)) return emoji;
            return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
        }
        optimisticMediaRendering(emoji, useAlt) {
            if (!(0, (0, parcelRequire("ibnx0")).isMediaEmoji)(emoji)) return true;
            if (!this.isRepositoryAvailable(this.siteEmojiResource)) return false;
            const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
            if ((0, (0, parcelRequire("ibnx0")).isPromise)(optimistic)) return false;
            return optimistic;
        }
        filter(query, options) {
            (0, (0, parcelRequire("eNoEO")).ufoExperiences)['emoji-searched'].start();
            (0, (0, parcelRequire("eNoEO")).ufoExperiences)['emoji-searched'].addMetadata({
                queryLength: query?.length || 0
            });
            this.lastQuery = {
                query: query,
                options: options
            };
            if (this.isRepositoryAvailable(this.emojiRepository)) {
                const searchResults = this.emojiRepository.search(query, options);
                this.notifyResult(searchResults);
                (0, (0, parcelRequire("eNoEO")).ufoExperiences)['emoji-searched'].success({
                    metadata: {
                        emojisLength: searchResults.emojis.length,
                        source: options?.source || 'typeahead'
                    }
                });
            } else this.notifyNotReady();
        }
        findByShortName(shortName) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findByShortName(shortName);
            return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
        }
        findByEmojiId(emojiId) {
            const { id: id, shortName: shortName } = emojiId;
            if (this.isRepositoryAvailable(this.emojiRepository)) {
                if (id) {
                    const emoji = this.emojiRepository.findById(id);
                    if (emoji) return emoji;
                    if (this.isLoaded()) {
                        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                            if (!emoji) return this.findByShortName(shortName);
                            this.addUnknownEmoji(emoji);
                            return emoji;
                        });
                        return this.findByShortName(shortName);
                    }
                } else return this.findByShortName(shortName);
            }
            return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
        }
        findById(id) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
            return this.retryIfLoading(()=>this.findById(id), undefined);
        }
        findInCategory(categoryId) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
            return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
        }
        getAsciiMap() {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
            return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
        }
        getFrequentlyUsed(options) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
            return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
        }
        recordSelection(emoji) {
            const { recordConfig: recordConfig } = this;
            if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
            if (recordConfig) {
                const queryParams = {
                    emojiId: (0, (0, parcelRequire("ibnx0")).toEmojiId)(emoji)
                };
                const requestInit = {
                    method: 'POST'
                };
                return (0, $2Z5gN.utils).requestService(recordConfig, {
                    queryParams: queryParams,
                    requestInit: requestInit
                });
            }
            return Promise.resolve();
        }
        deleteSiteEmoji(emoji) {
            if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
                if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                    this.emojiRepository.delete(emoji);
                    return true;
                }
                return false;
            }).catch((err)=>{
                console.error('failed to delete site emoji', err);
                return false;
            });
            return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
        }
        getSelectedTone() {
            return this.selectedTone;
        }
        setSelectedTone(tone) {
            this.selectedTone = tone;
            if (typeof window === 'undefined') return;
            if ((0, (0, parcelRequire("6ijiY")).default)('localStorage')) try {
                window.localStorage.setItem((0, (0, parcelRequire("8PD8v")).selectedToneStorageKey), tone ? tone.toString() : '');
            } catch (e) {
                console.error('failed to store selected emoji skin tone', e);
            }
        }
        calculateDynamicCategories() {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
            return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
        }
        getCurrentUser() {
            return this.currentUser;
        }
        addUnknownEmoji(emoji) {
            if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
        }
    }
    class $4687db15348be69e$export$2e2bcd8739ae039 extends $4687db15348be69e$export$b5efafc6dd611ec5 {
        constructor(config){
            super(config);
            this.allowUpload = !!config.allowUpload;
        }
        isUploadSupported() {
            if (!this.allowUpload) return Promise.resolve(false);
            if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
            return this.retryIfLoading(()=>this.isUploadSupported(), false);
        }
        uploadCustomEmoji(upload, retry = false) {
            return this.isUploadSupported().then((supported)=>{
                if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
                return this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                    emoji.representation.imagePath = upload.dataURL;
                    this.addUnknownEmoji(emoji);
                    this.refreshLastFilter();
                    return emoji;
                });
            });
        }
        prepareForUpload() {
            if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
            return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
        }
    }
});
parcelRegister("8PD8v", function(module, exports) {
    $parcel$export(module.exports, "customCategory", ()=>$602fdf9a4c53bd7d$export$5e4e3d1c3e43156a);
    $parcel$export(module.exports, "frequentCategory", ()=>$602fdf9a4c53bd7d$export$78ccdc4be403c468);
    $parcel$export(module.exports, "searchCategory", ()=>$602fdf9a4c53bd7d$export$1b0258512be88334);
    $parcel$export(module.exports, "yourUploadsCategory", ()=>$602fdf9a4c53bd7d$export$42b510423367f354);
    $parcel$export(module.exports, "customTitle", ()=>$602fdf9a4c53bd7d$export$5d0f2d8ee50f86f5);
    $parcel$export(module.exports, "userCustomTitle", ()=>$602fdf9a4c53bd7d$export$1debc2f10cc69389);
    $parcel$export(module.exports, "dataURLPrefix", ()=>$602fdf9a4c53bd7d$export$8ac325bfd32359b0);
    $parcel$export(module.exports, "deleteEmojiLabel", ()=>$602fdf9a4c53bd7d$export$a330961542edfe6f);
    $parcel$export(module.exports, "MAX_ORDINAL", ()=>$602fdf9a4c53bd7d$export$1a817f1886276c6d);
    $parcel$export(module.exports, "defaultEmojiHeight", ()=>$602fdf9a4c53bd7d$export$3f99ac31dc0406db);
    $parcel$export(module.exports, "emojiPickerWidth", ()=>$602fdf9a4c53bd7d$export$d171dc12fee2b1da);
    $parcel$export(module.exports, "sizeGap", ()=>$602fdf9a4c53bd7d$export$c10ac8125a260041);
    $parcel$export(module.exports, "defaultEmojiPickerSize", ()=>$602fdf9a4c53bd7d$export$5248fb9e0cccc41f);
    $parcel$export(module.exports, "emojiPickerMinHeight", ()=>$602fdf9a4c53bd7d$export$94f75d625e7801d3);
    $parcel$export(module.exports, "emojiPickerHeight", ()=>$602fdf9a4c53bd7d$export$7ed599d166d65aea);
    $parcel$export(module.exports, "emojiPickerListHeight", ()=>$602fdf9a4c53bd7d$export$7722b8e9522021df);
    $parcel$export(module.exports, "emojiPickerHeightWithPreview", ()=>$602fdf9a4c53bd7d$export$e67f617938b111f1);
    $parcel$export(module.exports, "localStoragePrefix", ()=>$602fdf9a4c53bd7d$export$e394a0c530ae5631);
    $parcel$export(module.exports, "selectedToneStorageKey", ()=>$602fdf9a4c53bd7d$export$79ee4ef84c545f8f);
    $parcel$export(module.exports, "defaultCategories", ()=>$602fdf9a4c53bd7d$export$d7ab74456f1aa1ad);
    $parcel$export(module.exports, "KeyboardKeys", ()=>$602fdf9a4c53bd7d$export$70f9e5bc10d7eac);
    $parcel$export(module.exports, "KeyboardNavigationDirection", ()=>$602fdf9a4c53bd7d$export$1c4f2adc1f8e19d3);
    $parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", ()=>$602fdf9a4c53bd7d$export$99130b698ea188ae);
    $parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", ()=>$602fdf9a4c53bd7d$export$84b035f8d01101cc);
    $parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", ()=>$602fdf9a4c53bd7d$export$e27d4e477c0cd4ec);
    $parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", ()=>$602fdf9a4c53bd7d$export$97027974dc06eeee);
    $parcel$export(module.exports, "DEFAULT_TONE", ()=>$602fdf9a4c53bd7d$export$4f0ee90b28d6efc5);
    $parcel$export(module.exports, "EMOJI_LIST_COLUMNS", ()=>$602fdf9a4c53bd7d$export$2829f3ec323f8ec0);
    $parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", ()=>$602fdf9a4c53bd7d$export$ce3a0e7d2d7d6ba2);
    $parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", ()=>$602fdf9a4c53bd7d$export$858e8dc100a97278);
    $parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", ()=>$602fdf9a4c53bd7d$export$83aab2ae64548423);
    $parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", ()=>$602fdf9a4c53bd7d$export$66cabad5e268b05e);
    const $602fdf9a4c53bd7d$export$5e4e3d1c3e43156a = 'CUSTOM';
    const $602fdf9a4c53bd7d$export$78ccdc4be403c468 = 'FREQUENT';
    const $602fdf9a4c53bd7d$export$2c4b04c3aacdf1b3 = 'SITE';
    const $602fdf9a4c53bd7d$export$1b0258512be88334 = 'SEARCH';
    const $602fdf9a4c53bd7d$export$42b510423367f354 = 'USER_CUSTOM';
    const $602fdf9a4c53bd7d$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
    const $602fdf9a4c53bd7d$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
    const $602fdf9a4c53bd7d$export$8ac325bfd32359b0 = 'data:';
    const $602fdf9a4c53bd7d$export$a330961542edfe6f = 'delete-emoji';
    const $602fdf9a4c53bd7d$export$1a817f1886276c6d = 100000;
    const $602fdf9a4c53bd7d$export$3f99ac31dc0406db = 20;
    const $602fdf9a4c53bd7d$export$d171dc12fee2b1da = 350;
    const $602fdf9a4c53bd7d$export$c10ac8125a260041 = 80;
    const $602fdf9a4c53bd7d$export$5248fb9e0cccc41f = 'medium';
    const $602fdf9a4c53bd7d$export$94f75d625e7801d3 = 260;
    const $602fdf9a4c53bd7d$export$7ed599d166d65aea = 295;
    const $602fdf9a4c53bd7d$export$7722b8e9522021df = $602fdf9a4c53bd7d$export$7ed599d166d65aea - 58;
    const $602fdf9a4c53bd7d$export$e218e5cb105a0e22 = 54;
    const $602fdf9a4c53bd7d$export$e67f617938b111f1 = $602fdf9a4c53bd7d$export$7ed599d166d65aea + $602fdf9a4c53bd7d$export$e218e5cb105a0e22;
    const $602fdf9a4c53bd7d$export$e394a0c530ae5631 = 'fabric.emoji';
    const $602fdf9a4c53bd7d$export$79ee4ef84c545f8f = `${$602fdf9a4c53bd7d$export$e394a0c530ae5631}.selectedTone`;
    const $602fdf9a4c53bd7d$export$d7ab74456f1aa1ad = [
        'PEOPLE',
        'NATURE',
        'FOODS',
        'ACTIVITY',
        'PLACES',
        'OBJECTS',
        'SYMBOLS',
        'FLAGS'
    ];
    var $602fdf9a4c53bd7d$export$70f9e5bc10d7eac;
    (function(KeyboardKeys) {
        KeyboardKeys["ArrowLeft"] = "ArrowLeft";
        KeyboardKeys["ArrowRight"] = "ArrowRight";
        KeyboardKeys["ArrowUp"] = "ArrowUp";
        KeyboardKeys["ArrowDown"] = "ArrowDown";
        KeyboardKeys["PageUp"] = "PageUp";
        KeyboardKeys["PageDown"] = "PageDown";
        KeyboardKeys["Home"] = "Home";
        KeyboardKeys["End"] = "End";
        KeyboardKeys["Enter"] = "Enter";
        KeyboardKeys["Tab"] = "Tab";
        KeyboardKeys["Space"] = " ";
        KeyboardKeys["Backspace"] = "Backspace";
    })($602fdf9a4c53bd7d$export$70f9e5bc10d7eac || ($602fdf9a4c53bd7d$export$70f9e5bc10d7eac = {}));
    var $602fdf9a4c53bd7d$export$1c4f2adc1f8e19d3;
    (function(KeyboardNavigationDirection) {
        KeyboardNavigationDirection["Down"] = "Down";
        KeyboardNavigationDirection["Up"] = "Up";
        KeyboardNavigationDirection["Left"] = "Left";
        KeyboardNavigationDirection["Right"] = "Right";
    })($602fdf9a4c53bd7d$export$1c4f2adc1f8e19d3 || ($602fdf9a4c53bd7d$export$1c4f2adc1f8e19d3 = {}));
    const $602fdf9a4c53bd7d$export$99130b698ea188ae = [
        "ArrowRight",
        "ArrowLeft",
        "Home",
        "End"
    ];
    const $602fdf9a4c53bd7d$export$84b035f8d01101cc = [
        "Enter",
        "Backspace",
        " "
    ];
    const $602fdf9a4c53bd7d$export$e27d4e477c0cd4ec = [
        "Enter",
        "Tab",
        " "
    ];
    const $602fdf9a4c53bd7d$export$97027974dc06eeee = [
        "ArrowRight",
        "ArrowLeft",
        "Home",
        "End",
        "ArrowUp",
        "ArrowDown",
        "PageUp",
        "PageDown"
    ];
    const $602fdf9a4c53bd7d$export$4f0ee90b28d6efc5 = 0;
    const $602fdf9a4c53bd7d$export$9f7de4293d27f3aa = 50;
    const $602fdf9a4c53bd7d$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
    const $602fdf9a4c53bd7d$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
    const $602fdf9a4c53bd7d$export$2829f3ec323f8ec0 = 8;
    const $602fdf9a4c53bd7d$export$ce3a0e7d2d7d6ba2 = 5;
    const $602fdf9a4c53bd7d$export$858e8dc100a97278 = 150;
    const $602fdf9a4c53bd7d$export$83aab2ae64548423 = 20;
    const $602fdf9a4c53bd7d$export$66cabad5e268b05e = 100;
});
parcelRegister("gLnrw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7e9ebef0e347b98$export$2e2bcd8739ae039);
    let $e7e9ebef0e347b98$var$debugEnabled = false;
    let $e7e9ebef0e347b98$var$stacktracesEnabled = false;
    function $e7e9ebef0e347b98$export$748ada60eaf985cc(enable) {
        $e7e9ebef0e347b98$var$debugEnabled = enable;
    }
    function $e7e9ebef0e347b98$export$4f7017086af31c25(enable) {
        $e7e9ebef0e347b98$var$stacktracesEnabled = enable;
    }
    function $e7e9ebef0e347b98$export$2a858f450a2f66d() {
        if ($e7e9ebef0e347b98$var$stacktracesEnabled) console.log(new Error().stack);
    }
    function $e7e9ebef0e347b98$export$2e2bcd8739ae039(msg, ...args) {
        if ($e7e9ebef0e347b98$var$debugEnabled) console.log(msg, ...args);
    }
});
parcelRegister("ibnx0", function(module, exports) {
    $parcel$export(module.exports, "isSpriteServiceRepresentation", ()=>$d4da972269bc453a$export$1c52f72b88b558e8);
    $parcel$export(module.exports, "isSpriteRepresentation", ()=>$d4da972269bc453a$export$a194199d673d75de);
    $parcel$export(module.exports, "isImageRepresentation", ()=>$d4da972269bc453a$export$90b099a26fbd8b41);
    $parcel$export(module.exports, "isMediaRepresentation", ()=>$d4da972269bc453a$export$979133dc1df141c6);
    $parcel$export(module.exports, "isPromise", ()=>$d4da972269bc453a$export$4369c812aac99591);
    $parcel$export(module.exports, "isEmojiDescription", ()=>$d4da972269bc453a$export$378ed2c87d03531c);
    $parcel$export(module.exports, "isMediaEmoji", ()=>$d4da972269bc453a$export$a7e82c67204c73a1);
    $parcel$export(module.exports, "isLoadedMediaEmoji", ()=>$d4da972269bc453a$export$d25a80b2c86d7fdf);
    $parcel$export(module.exports, "isEmojiDescriptionWithVariations", ()=>$d4da972269bc453a$export$b0ed6d8df471f3cc);
    $parcel$export(module.exports, "isEmojiVariationDescription", ()=>$d4da972269bc453a$export$82a0350e1f6b5c0a);
    $parcel$export(module.exports, "isMessagesKey", ()=>$d4da972269bc453a$export$dddfba07c16c94d2);
    $parcel$export(module.exports, "toEmojiId", ()=>$d4da972269bc453a$export$8d7d3de6b5b305d1);
    $parcel$export(module.exports, "containsEmojiId", ()=>$d4da972269bc453a$export$39ed0ad389e58ef7);
    $parcel$export(module.exports, "convertImageToMediaRepresentation", ()=>$d4da972269bc453a$export$20a1bd1d33069ce7);
    $parcel$export(module.exports, "convertMediaToImageEmoji", ()=>$d4da972269bc453a$export$f1a89a11f425faaa);
    $parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", ()=>$d4da972269bc453a$export$a48c58c688a3131);
    $parcel$export(module.exports, "getCategoryId", ()=>$d4da972269bc453a$export$4bcbf61cb6832a8e);
    var $bV5kZ;
    var $8PD8v;
    const $d4da972269bc453a$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
    const $d4da972269bc453a$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
    const $d4da972269bc453a$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
    const $d4da972269bc453a$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
    const $d4da972269bc453a$export$4369c812aac99591 = (p)=>!!(p && p.then);
    const $d4da972269bc453a$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
    const $d4da972269bc453a$export$a7e82c67204c73a1 = (emoji)=>$d4da972269bc453a$export$979133dc1df141c6(emoji.representation);
    const $d4da972269bc453a$export$7720a4954d6f75f8 = (rep)=>$d4da972269bc453a$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, (0, parcelRequire("8PD8v")).dataURLPrefix)) === 0;
    const $d4da972269bc453a$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, (0, parcelRequire("8PD8v")).customCategory) && $d4da972269bc453a$export$7720a4954d6f75f8(emoji.representation);
    const $d4da972269bc453a$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
    const $d4da972269bc453a$export$82a0350e1f6b5c0a = (object)=>{
        return 'baseId' in object;
    };
    const $d4da972269bc453a$export$dddfba07c16c94d2 = (key)=>key in (0, (0, parcelRequire("bV5kZ")).messages);
    const $d4da972269bc453a$export$8d7d3de6b5b305d1 = (emoji)=>({
            shortName: emoji.shortName,
            id: emoji.id,
            fallback: emoji.fallback
        });
    const $d4da972269bc453a$export$2dbfa5a5d35af350 = (emoji)=>{
        if (!emoji) return undefined;
        return $d4da972269bc453a$export$8d7d3de6b5b305d1(emoji);
    };
    const $d4da972269bc453a$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
    const $d4da972269bc453a$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
        if (!emojiId) return false;
        for(let i = 0; i < emojis.length; i++){
            if ($d4da972269bc453a$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
        }
        return false;
    };
    const $d4da972269bc453a$export$20a1bd1d33069ce7 = (rep)=>({
            mediaPath: rep.imagePath,
            height: rep.height,
            width: rep.width
        });
    const $d4da972269bc453a$export$3197405d49d2e298 = (rep, newImagePath)=>({
            imagePath: newImagePath || rep.mediaPath,
            height: rep.height,
            width: rep.width
        });
    const $d4da972269bc453a$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
        const mediaRepresentation = emoji.representation;
        const mediaAltRepresentation = emoji.altRepresentation;
        const imgPath = !useAlt ? newImagePath : undefined;
        const altImgPath = useAlt ? newImagePath : undefined;
        if (!$d4da972269bc453a$export$979133dc1df141c6(mediaRepresentation) && !$d4da972269bc453a$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
        const representation = $d4da972269bc453a$export$979133dc1df141c6(mediaRepresentation) ? $d4da972269bc453a$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
        const altRepresentation = $d4da972269bc453a$export$979133dc1df141c6(mediaAltRepresentation) ? $d4da972269bc453a$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
        const baseEmoji = {
            ...emoji,
            representation: representation
        };
        return $d4da972269bc453a$export$a48c58c688a3131(baseEmoji, altRepresentation);
    };
    const $d4da972269bc453a$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
        if (!altRepresentation) return emoji;
        return {
            ...emoji,
            altRepresentation: altRepresentation
        };
    };
    const $d4da972269bc453a$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;
});
parcelRegister("bV5kZ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6d2f71f022acc358$export$defe85febe8b728c);
    var $7VHMR;
    const $6d2f71f022acc358$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteEmojiTooltip: {
            id: 'fabric.emoji.delete.tooltip',
            defaultMessage: 'Delete',
            description: 'Tooltip content for delete emoji when focus on deletable emoji'
        },
        deleteEmojiTooltipForScreenreader: {
            id: 'fabric.emoji.delete.screenreader.tooltip',
            defaultMessage: 'To delete {shortName} emoji, press Backspace',
            description: 'Tooltip content for delete emoji when focus on deletable emoji'
        },
        deleteEmojiTitle: {
            id: 'fabric.emoji.delete.title',
            defaultMessage: 'Remove emoji',
            description: 'Title for emoji removal dialog'
        },
        deleteEmojiDescription: {
            id: 'fabric.emoji.delete.description',
            defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
            description: 'Description for emoji removal dialog'
        },
        deleteEmojiLabel: {
            id: 'fabric.emoji.delete.label',
            defaultMessage: 'Remove',
            description: 'Button label to remove emoji'
        },
        addCustomEmojiLabel: {
            id: 'fabric.emoji.add.custom.emoji.label',
            defaultMessage: 'Add your own emoji',
            description: 'Button label to add custom emoji'
        },
        emojiPlaceholder: {
            id: 'fabric.emoji.placeholder',
            defaultMessage: 'e.g. hello',
            description: 'Placeholder for emoji that provides an example for emoji name'
        },
        emojiNameAriaLabel: {
            id: 'fabric.emoji.name.ariaLabel',
            defaultMessage: 'Enter a name for the new emoji',
            description: 'Explains to enter a name for a new emoji'
        },
        emojiChooseFileTitle: {
            id: 'fabric.emoji.choose.file.title',
            defaultMessage: 'Choose file',
            description: 'Choose custom emoji file'
        },
        emojiChooseFileScreenReaderDescription: {
            id: 'fabric.emoji.choose.file.screenReaderDescription',
            defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
            description: 'Message indicating the purpose of choosing the file and requirements for the file'
        },
        emojiSelectSkinToneButtonAriaLabelText: {
            id: 'fabric.emoji.select.skin.tone.ariaLabel',
            defaultMessage: 'Choose your skin tone, {selectedTone} selected',
            description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
        },
        emojiSelectSkinToneListAriaLabelText: {
            id: 'fabric.emoji.select.skin.list.ariaLabel',
            defaultMessage: 'Skin tone selector',
            description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
        },
        emojiImageRequirements: {
            id: 'fabric.emoji.image.requirements',
            defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
            description: 'Message for emoji image requirements and maximum file size'
        },
        emojiPreviewTitle: {
            id: 'fabric.emoji.preview.title',
            defaultMessage: 'Preview',
            description: 'Emoji preview title'
        },
        emojiPreview: {
            id: 'fabric.emoji.preview',
            defaultMessage: 'Your new emoji {emoji} looks great',
            description: 'Emoji preview'
        },
        addEmojiLabel: {
            id: 'fabric.emoji.add.label',
            defaultMessage: 'Add emoji',
            description: 'verb - Button label to add emoji'
        },
        retryLabel: {
            id: 'fabric.emoji.retry.label',
            defaultMessage: 'Retry',
            description: 'verb - Button label to retry upload'
        },
        cancelLabel: {
            id: 'fabric.emoji.cancel.label',
            defaultMessage: 'Cancel',
            description: 'verb - button label to cancel operation'
        },
        searchPlaceholder: {
            id: 'fabric.emoji.search.placeholder',
            defaultMessage: 'Search',
            description: 'Placeholder for search emoji field'
        },
        searchLabel: {
            id: 'fabric.emoji.search.label',
            defaultMessage: 'Emoji name',
            description: 'verb - button label to search'
        },
        searchResultsStatusSeeAll: {
            id: 'fabric.emoji.search.status',
            defaultMessage: 'Seeing all emojis',
            description: 'search results status when no search query for screenreader to read out'
        },
        categoriesSelectorLabel: {
            id: 'fabric.emoji.categories.label',
            defaultMessage: 'Choose an emoji category',
            description: 'Aria label for Emoji categories selector at the top of emoji picker'
        },
        categoriesSearchResults: {
            id: 'fabric.emoji.categories.search.results',
            defaultMessage: 'Search results',
            description: 'Emoji categories search results'
        },
        frequentCategory: {
            id: 'fabric.emoji.category.frequent',
            defaultMessage: 'Frequent',
            description: 'Emoji frequent category'
        },
        peopleCategory: {
            id: 'fabric.emoji.category.people',
            defaultMessage: 'People',
            description: 'Emoji frequent category'
        },
        natureCategory: {
            id: 'fabric.emoji.category.nature',
            defaultMessage: 'Nature',
            description: 'Emoji nature category'
        },
        foodsCategory: {
            id: 'fabric.emoji.category.foods',
            defaultMessage: 'Food & Drink',
            description: 'Emoji Foods category'
        },
        activityCategory: {
            id: 'fabric.emoji.category.activity',
            defaultMessage: 'Activity',
            description: 'Emoji activity category'
        },
        placesCategory: {
            id: 'fabric.emoji.category.places',
            defaultMessage: 'Travel & Places',
            description: 'Emoji Places category'
        },
        objectsCategory: {
            id: 'fabric.emoji.category.objects',
            defaultMessage: 'Objects',
            description: 'Emoji objects category'
        },
        symbolsCategory: {
            id: 'fabric.emoji.category.symbols',
            defaultMessage: 'Symbols',
            description: 'Emoji symbols category'
        },
        flagsCategory: {
            id: 'fabric.emoji.category.flags',
            defaultMessage: 'Flags',
            description: 'Emoji flags category'
        },
        productivityCategory: {
            id: 'fabric.emoji.category.productivity',
            defaultMessage: 'Productivity',
            description: 'Emoji productivity category'
        },
        userUploadsCustomCategory: {
            id: 'fabric.emoji.category.user.uploads',
            defaultMessage: 'Your uploads',
            description: 'User uploads in the custom category'
        },
        allUploadsCustomCategory: {
            id: 'fabric.emoji.category.all.uploads',
            defaultMessage: 'All uploads',
            description: 'All uploads in the custom category'
        },
        deleteEmojiFailed: {
            id: 'fabric.emoji.error.delete.failed',
            defaultMessage: 'Remove failed',
            description: 'Error message when custom emoji failed to be removed'
        },
        emojiInvalidImage: {
            id: 'fabric.emoji.error.invalid.image',
            defaultMessage: 'Selected image is invalid',
            description: 'Error message for invalid selected image'
        },
        emojiUploadFailed: {
            id: 'fabric.emoji.error.upload.failed',
            defaultMessage: 'Upload failed',
            description: 'Failed to upload emoji image'
        },
        emojiImageTooBig: {
            id: 'fabric.emoji.error.image.too.big',
            defaultMessage: 'Selected image is more than 1 MB',
            description: 'Error message for image too big, beyond the size limit'
        },
        emojiPickerTitle: {
            id: 'fabric.emoji.picker',
            defaultMessage: 'Emoji picker',
            description: 'Aria label for emoji picker'
        },
        emojiPickerListPanel: {
            id: 'fabric.emoji.pickerlist.tabpanel',
            defaultMessage: 'Emojis actions and list panel',
            description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
        },
        emojiPickerGrid: {
            id: 'fabric.emoji.pickerlist.grid',
            defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
            description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
        },
        emojiButtonRoleDescription: {
            id: 'fabric.emoji.emojipicker.emoi.roledescription',
            defaultMessage: 'emoji button',
            description: `Aria roledescription for emoji button, used in emoji picker.`
        },
        error: {
            id: 'fabric.emoji.emojipicker.error',
            defaultMessage: 'Error!',
            description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
        }
    });
});
parcelRegister("6ijiY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7fb75b3a9a8cce80$export$2e2bcd8739ae039);
    function $7fb75b3a9a8cce80$export$2e2bcd8739ae039(type) {
        if (typeof window === 'undefined') return false;
        var storage;
        try {
            storage = window[type];
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0;
        }
    }
});
parcelRegister("8JfNZ", function(module, exports) {
    $parcel$export(module.exports, "SearchSort", ()=>$8c3519878a856769$export$a15e9a4340d08b2e);
    $parcel$export(module.exports, "SearchSourceTypes", ()=>$8c3519878a856769$export$db41220f541db607);
    $parcel$export(module.exports, "ProviderTypes", ()=>$8c3519878a856769$export$bf337c9223e5c8b);
    $parcel$export(module.exports, "UfoExperienceName", ()=>$8c3519878a856769$export$d0d1c9cd31a11a64);
    $parcel$export(module.exports, "UfoComponentName", ()=>$8c3519878a856769$export$122ce5c8fda96269);
    $parcel$export(module.exports, "UfoEmojiTimingsKeys", ()=>$8c3519878a856769$export$265ee18146a6885e);
    $parcel$export(module.exports, "UfoEmojiTimings", ()=>$8c3519878a856769$export$482549d945a3723);
    var $8c3519878a856769$export$a15e9a4340d08b2e;
    (function(SearchSort) {
        SearchSort[SearchSort["None"] = 0] = "None";
        SearchSort[SearchSort["Default"] = 1] = "Default";
        SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    })($8c3519878a856769$export$a15e9a4340d08b2e || ($8c3519878a856769$export$a15e9a4340d08b2e = {}));
    var $8c3519878a856769$export$db41220f541db607;
    (function(SearchSourceTypes) {
        SearchSourceTypes["PICKER"] = "picker";
        SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    })($8c3519878a856769$export$db41220f541db607 || ($8c3519878a856769$export$db41220f541db607 = {}));
    var $8c3519878a856769$export$bf337c9223e5c8b;
    (function(ProviderTypes) {
        ProviderTypes["SITE"] = "SITE";
        ProviderTypes["STANDARD"] = "STANDARD";
        ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
        ProviderTypes["UNKNOWN"] = "UNKNOWN";
        ProviderTypes["SINGLE"] = "SINGLE";
    })($8c3519878a856769$export$bf337c9223e5c8b || ($8c3519878a856769$export$bf337c9223e5c8b = {}));
    var $8c3519878a856769$export$d0d1c9cd31a11a64;
    (function(UfoExperienceName) {
        UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
        UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
        UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
        UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
        UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
        UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    })($8c3519878a856769$export$d0d1c9cd31a11a64 || ($8c3519878a856769$export$d0d1c9cd31a11a64 = {}));
    var $8c3519878a856769$export$122ce5c8fda96269;
    (function(UfoComponentName) {
        UfoComponentName["EMOJI"] = "emoji";
        UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
        UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    })($8c3519878a856769$export$122ce5c8fda96269 || ($8c3519878a856769$export$122ce5c8fda96269 = {}));
    var $8c3519878a856769$export$265ee18146a6885e;
    (function(UfoEmojiTimingsKeys) {
        UfoEmojiTimingsKeys["FMP"] = "fmp";
        UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
        UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
        UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
        UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    })($8c3519878a856769$export$265ee18146a6885e || ($8c3519878a856769$export$265ee18146a6885e = {}));
    var $8c3519878a856769$export$482549d945a3723;
    (function(UfoEmojiTimings) {
        UfoEmojiTimings["FMP_END"] = "fmp";
        UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
        UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
        UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
        UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
        UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
        UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
        UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    })($8c3519878a856769$export$482549d945a3723 || ($8c3519878a856769$export$482549d945a3723 = {}));
});
parcelRegister("lpq8i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$668370d85f046903$export$2e2bcd8739ae039);
    var $6Bbdw;
    class $668370d85f046903$export$2e2bcd8739ae039 {
        constructor(config){
            this.config = config;
        }
        loadEmoji() {
            const emojisPromise = (0, (0, parcelRequire("6Bbdw")).emojiRequest)(this.config);
            return emojisPromise.then((emojiServiceResponse)=>(0, (0, parcelRequire("6Bbdw")).denormaliseEmojiServiceResponse)(emojiServiceResponse));
        }
    }
});
parcelRegister("6Bbdw", function(module, exports) {
    $parcel$export(module.exports, "emojiRequest", ()=>$d236f9f69a703211$export$ea1accde4cc117f4);
    $parcel$export(module.exports, "getAltRepresentation", ()=>$d236f9f69a703211$export$4a0301d636367e1d);
    $parcel$export(module.exports, "denormaliseEmojiServiceResponse", ()=>$d236f9f69a703211$export$afaea97e40b5ca70);
    $parcel$export(module.exports, "shouldUseAltRepresentation", ()=>$d236f9f69a703211$export$b7e9058f156d8d19);
    var $2Z5gN = parcelRequire("2Z5gN");
    var $ibnx0;
    var $gLnrw;
    const $d236f9f69a703211$export$ea1accde4cc117f4 = (provider, options)=>{
        const { getRatio: getRatio = $d236f9f69a703211$export$d39ce20a37bba061, ...serviceConfig } = provider;
        const scaleQueryParams = $d236f9f69a703211$var$calculateScale(getRatio);
        const { queryParams: queryParams = {}, ...otherOptions } = options || {};
        const requestOptions = {
            ...otherOptions,
            queryParams: {
                ...scaleQueryParams,
                ...queryParams,
                preferredRepresentation: 'IMAGE'
            }
        };
        return (0, $2Z5gN.utils).requestService(serviceConfig, requestOptions);
    };
    const $d236f9f69a703211$var$calculateScale = (getRatio)=>{
        if (getRatio() > 1) return {
            scale: 'XHDPI',
            altScale: 'XXXHDPI'
        };
        return {
            altScale: 'XHDPI'
        };
    };
    const $d236f9f69a703211$export$d39ce20a37bba061 = ()=>{
        if (typeof window === 'undefined') return 0;
        return window.devicePixelRatio;
    };
    const $d236f9f69a703211$export$4a0301d636367e1d = (reps)=>{
        return reps[$d236f9f69a703211$var$calculateScale($d236f9f69a703211$export$d39ce20a37bba061).altScale];
    };
    const $d236f9f69a703211$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
    const $d236f9f69a703211$export$55077db3efc820aa = (representation, meta)=>{
        if ((0, (0, parcelRequire("ibnx0")).isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
            const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
            const spriteSheet = meta.spriteSheets[spriteRef];
            if (spriteSheet) return {
                sprite: spriteSheet,
                height: height,
                width: width,
                x: x,
                y: y,
                xIndex: xIndex,
                yIndex: yIndex
            };
        } else if ((0, (0, parcelRequire("ibnx0")).isImageRepresentation)(representation)) {
            const { height: height, width: width, imagePath: imagePath } = representation;
            if ($d236f9f69a703211$export$db05e6ae1fd416af(imagePath, meta)) return (0, (0, parcelRequire("ibnx0")).convertImageToMediaRepresentation)(representation);
            return {
                height: height,
                width: width,
                imagePath: imagePath
            };
        }
        (0, (0, parcelRequire("gLnrw")).default)('failed conversion for representation', representation, meta);
        return undefined;
    };
    const $d236f9f69a703211$export$aa9faa01267cb2e7 = (altReps, meta)=>{
        return !altReps || Object.keys(altReps).length === 0 ? undefined : $d236f9f69a703211$export$55077db3efc820aa($d236f9f69a703211$export$4a0301d636367e1d(altReps), meta);
    };
    const $d236f9f69a703211$export$e3da49c88c2e54d5 = (emoji, meta)=>{
        if (!emoji.skinVariations) return [];
        const skinEmoji = emoji.skinVariations;
        const baseId = emoji.id;
        return skinEmoji.map((skin)=>{
            const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
            return {
                baseId: baseId,
                representation: $d236f9f69a703211$export$55077db3efc820aa(representation, meta),
                altRepresentation: $d236f9f69a703211$export$aa9faa01267cb2e7(altRepresentations, meta),
                ...other
            };
        });
    };
    const $d236f9f69a703211$export$afaea97e40b5ca70 = (emojiData)=>{
        const emojis = emojiData.emojis.map((emoji)=>{
            const newRepresentation = $d236f9f69a703211$export$55077db3efc820aa(emoji.representation, emojiData.meta);
            const altRepresentation = $d236f9f69a703211$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
            const newSkinVariations = $d236f9f69a703211$export$e3da49c88c2e54d5(emoji, emojiData.meta);
            const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
            const response = {
                ...trimmedServiceDesc,
                representation: newRepresentation,
                skinVariations: newSkinVariations
            };
            return (0, (0, parcelRequire("ibnx0")).buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
        });
        const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
        return {
            emojis: emojis,
            mediaApiToken: mediaApiToken
        };
    };
    const $d236f9f69a703211$var$getHeight = (fitToHeight)=>$d236f9f69a703211$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
    const $d236f9f69a703211$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $d236f9f69a703211$var$getHeight(fitToHeight) > emoji.representation.height);
});
parcelRegister("vcPXi", function(module, exports) {
    $parcel$export(module.exports, "getEmojiVariation", ()=>$86273dd3ec230831$export$e55e46e1520c899d);
    $parcel$export(module.exports, "default", ()=>$86273dd3ec230831$export$2e2bcd8739ae039);
    var $4vsHq = parcelRequire("4vsHq");
    var $8PD8v;
    var $ibnx0;
    var $8JfNZ;
    var $8uEVD;
    var $4YzS0;
    var $kVtxt;
    var $2oS3b;
    class $86273dd3ec230831$var$Tokenizer {
        tokenize(text) {
            return this.tokenizeAsTokens(text).map((token)=>token.token);
        }
        tokenizeAsTokens(text) {
            let match;
            let tokens = [];
            (0, (0, parcelRequire("8uEVD")).tokenizerRegex).lastIndex = 0;
            while((match = (0, (0, parcelRequire("8uEVD")).tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
                token: match[0],
                start: match.index
            });
            return tokens;
        }
    }
    const $86273dd3ec230831$var$addAllVariants = (emoji, fnKey, map)=>{
        const key = fnKey(emoji);
        if (!map.has(key)) map.set(key, []);
        const emojisForKey = map.get(key);
        if (emojisForKey) emojisForKey.push(emoji);
        if ((0, (0, parcelRequire("ibnx0")).isEmojiDescriptionWithVariations)(emoji)) {
            const variations = emoji.skinVariations;
            if (variations) variations.forEach((variation)=>$86273dd3ec230831$var$addAllVariants(variation, fnKey, map));
        }
    };
    const $86273dd3ec230831$var$findByKey = (map, key)=>{
        const emojis = map.get(key);
        if (emojis && emojis.length) return emojis[emojis.length - 1];
        return undefined;
    };
    const $86273dd3ec230831$var$splitQuery = (query = '')=>{
        const isColonQuery = query.indexOf(':') === 0;
        if (isColonQuery) return {
            nameQuery: query.slice(1),
            asciiQuery: query
        };
        return {
            nameQuery: query,
            asciiQuery: ''
        };
    };
    const $86273dd3ec230831$export$e55e46e1520c899d = (emoji, options)=>{
        if ((0, (0, parcelRequire("ibnx0")).isEmojiDescriptionWithVariations)(emoji) && options) {
            const skinTone = options.skinTone;
            if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
                const skinToneEmoji = emoji.skinVariations[skinTone - 1];
                if (skinToneEmoji) return skinToneEmoji;
            }
        }
        return emoji;
    };
    const $86273dd3ec230831$var$findEmojiIndex = (emojis, toFind)=>{
        const findId = toFind.id;
        let match = -1;
        emojis.forEach((emoji, index)=>{
            if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
                match = index;
                return;
            }
        });
        return match;
    };
    class $86273dd3ec230831$export$2e2bcd8739ae039 {
        static{
            this.defaultEmojiWeight = 1000000;
        }
        constructor(emojis, usageTracker){
            this.fullSearchReady = false;
            this.emojis = emojis;
            this.initMembers(usageTracker);
        }
        all() {
            const options = {
                sort: (0, (0, parcelRequire("8JfNZ")).SearchSort).None
            };
            return this.search('', options);
        }
        search(query, options) {
            let filteredEmoji = [];
            const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $86273dd3ec230831$var$splitQuery(query);
            if (nameQuery) {
                filteredEmoji = this.getSearchIndex().search(nameQuery);
                if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
            } else filteredEmoji = this.getAllSearchableEmojis();
            filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
            return {
                emojis: filteredEmoji,
                query: query
            };
        }
        findAllMatchingShortName(shortName) {
            return this.shortNameMap.get(shortName) || [];
        }
        findByShortName(shortName) {
            return $86273dd3ec230831$var$findByKey(this.shortNameMap, shortName);
        }
        findById(id) {
            return $86273dd3ec230831$var$findByKey(this.idMap, id);
        }
        findByAsciiRepresentation(asciiEmoji) {
            return this.asciiMap.get(asciiEmoji);
        }
        findInCategory(categoryId) {
            if (categoryId === (0, (0, parcelRequire("8PD8v")).frequentCategory)) return this.getFrequentlyUsed();
            else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
        }
        addUnknownEmoji(emoji) {
            this.emojis = [
                ...this.emojis,
                emoji
            ];
            this.getSearchIndex().addDocuments([
                emoji
            ]);
            this.addToMaps(emoji);
            this.addToDynamicCategories(emoji);
        }
        getAsciiMap() {
            return this.asciiMap;
        }
        getFrequentlyUsed(options) {
            const emojiIds = this.usageTracker.getOrder();
            let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
            if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
            return emojiResult;
        }
        getDynamicCategoryList() {
            return this.dynamicCategoryList.slice();
        }
        used(emoji) {
            this.usageTracker.recordUsage(emoji);
            if (this.dynamicCategoryList.indexOf((0, (0, parcelRequire("8PD8v")).frequentCategory)) === -1) {
                if (typeof window === 'undefined') return;
                window.setTimeout(()=>{
                    this.dynamicCategoryList.push((0, (0, parcelRequire("8PD8v")).frequentCategory));
                });
            }
        }
        delete(emoji) {
            const deletedIndex = $86273dd3ec230831$var$findEmojiIndex(this.emojis, emoji);
            if (deletedIndex !== -1) {
                this.emojis.splice(deletedIndex, 1);
                this.initMembers(this.usageTracker);
            }
        }
        withAsciiMatch(ascii, emojis) {
            let result = emojis;
            const asciiEmoji = this.findByAsciiRepresentation(ascii);
            if (asciiEmoji) {
                result = emojis.filter((e)=>e.id !== asciiEmoji.id);
                result = [
                    asciiEmoji,
                    ...result
                ];
            }
            return result;
        }
        applySearchOptions(emojis, query, options) {
            if (!options) options = {};
            if (options.sort === undefined) options.sort = (0, (0, parcelRequire("8JfNZ")).SearchSort).Default;
            let comparator;
            if (options.sort === (0, (0, parcelRequire("8JfNZ")).SearchSort).Default) comparator = (0, (0, parcelRequire("4YzS0")).createSearchEmojiComparator)(query, this.usageTracker.getOrder());
            else if (options.sort === (0, (0, parcelRequire("8JfNZ")).SearchSort).UsageFrequency) comparator = (0, (0, parcelRequire("4YzS0")).createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
            if (comparator) {
                comparator.compare = comparator.compare.bind(comparator);
                emojis = emojis.sort(comparator.compare);
            }
            if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
            if (options.skinTone) return emojis.map((emoji)=>{
                return $86273dd3ec230831$export$e55e46e1520c899d(emoji, options);
            });
            return emojis;
        }
        initMembers(usageTracker) {
            this.usageTracker = usageTracker || new (0, (0, parcelRequire("kVtxt")).UsageFrequencyTracker)();
            this.initRepositoryMetadata();
            if (!(0, (0, parcelRequire("2oS3b")).fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
        }
        initRepositoryMetadata() {
            this.shortNameMap = new Map();
            this.idMap = new Map();
            this.asciiMap = new Map();
            const categorySet = new Set();
            this.emojis.forEach((emoji)=>{
                categorySet.add(emoji.category);
                this.addToMaps(emoji);
            });
            if (this.usageTracker.getOrder().length) categorySet.add((0, (0, parcelRequire("8PD8v")).frequentCategory));
            this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, (0, parcelRequire("8PD8v")).defaultCategories).indexOf(category) === -1);
        }
        initSearchIndex() {
            this.fullSearch = new (0, $4vsHq.Search)('id');
            this.fullSearch.tokenizer = new $86273dd3ec230831$var$Tokenizer();
            this.fullSearch.searchIndex = new (0, $4vsHq.UnorderedSearchIndex)();
            this.fullSearch.addIndex('name');
            this.fullSearch.addIndex('shortName');
            this.fullSearch.addDocuments(this.getAllSearchableEmojis());
            this.fullSearchReady = true;
        }
        getSearchIndex() {
            if (!this.fullSearchReady) this.initSearchIndex();
            return this.fullSearch;
        }
        getAllSearchableEmojis() {
            return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
        }
        addToMaps(emoji) {
            if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $86273dd3ec230831$export$2e2bcd8739ae039.defaultEmojiWeight;
            if (typeof emoji.id === 'undefined') emoji.id = $86273dd3ec230831$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
            $86273dd3ec230831$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
            $86273dd3ec230831$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
            if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
        }
        addToDynamicCategories(emoji) {
            const category = (0, (0, parcelRequire("ibnx0")).getCategoryId)(emoji);
            if ((0, (0, parcelRequire("8PD8v")).defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
        }
    }
});
parcelRegister("4vsHq", function(module, exports) {
    $parcel$export(module.exports, "UnorderedSearchIndex", ()=>$348051c3be02fe74$export$5e70dbef3f0d47db);
    $parcel$export(module.exports, "Search", ()=>$348051c3be02fe74$export$4b85d3515bd863a5);
    var $348051c3be02fe74$export$58ac23006833dfe0 = function() {
        function AllSubstringsIndexStrategy() {}
        var _proto = AllSubstringsIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            var expandedTokens = [];
            var string;
            for(var i = 0, length = token.length; i < length; ++i){
                string = '';
                for(var j = i; j < length; ++j){
                    string += token.charAt(j);
                    expandedTokens.push(string);
                }
            }
            return expandedTokens;
        };
        return AllSubstringsIndexStrategy;
    }();
    var $348051c3be02fe74$export$1dcc2d6a64836c8f = function() {
        function ExactWordIndexStrategy() {}
        var _proto = ExactWordIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            return token ? [
                token
            ] : [];
        };
        return ExactWordIndexStrategy;
    }();
    var $348051c3be02fe74$export$eb7fc80cfe9abfe6 = function() {
        function PrefixIndexStrategy() {}
        var _proto = PrefixIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            var expandedTokens = [];
            var string = '';
            for(var i = 0, length = token.length; i < length; ++i){
                string += token.charAt(i);
                expandedTokens.push(string);
            }
            return expandedTokens;
        };
        return PrefixIndexStrategy;
    }();
    var $348051c3be02fe74$export$b88ffe9b5486f99a = function() {
        function CaseSensitiveSanitizer() {}
        var _proto = CaseSensitiveSanitizer.prototype;
        _proto.sanitize = function sanitize(text) {
            return text ? text.trim() : '';
        };
        return CaseSensitiveSanitizer;
    }();
    var $348051c3be02fe74$export$147e8ac43c84713a = function() {
        function LowerCaseSanitizer() {}
        var _proto = LowerCaseSanitizer.prototype;
        _proto.sanitize = function sanitize(text) {
            return text ? text.toLocaleLowerCase().trim() : '';
        };
        return LowerCaseSanitizer;
    }();
    function $348051c3be02fe74$var$getNestedFieldValue(object, path) {
        path = path || [];
        object = object || {};
        var value = object;
        for(var i = 0; i < path.length; i++){
            value = value[path[i]];
            if (value == null) return null;
        }
        return value;
    }
    var $348051c3be02fe74$export$a1138c79781169cc = function() {
        function TfIdfSearchIndex(uidFieldName) {
            this._uidFieldName = uidFieldName;
            this._tokenToIdfCache = {};
            this._tokenMap = {};
        }
        var _proto = TfIdfSearchIndex.prototype;
        _proto.indexDocument = function indexDocument(token, uid, doc) {
            this._tokenToIdfCache = {};
            var tokenMap = this._tokenMap;
            var tokenDatum;
            if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
                $numDocumentOccurrences: 0,
                $totalNumOccurrences: 1,
                $uidMap: {}
            };
            else {
                tokenDatum = tokenMap[token];
                tokenDatum.$totalNumOccurrences++;
            }
            var uidMap = tokenDatum.$uidMap;
            if (typeof uidMap[uid] !== 'object') {
                tokenDatum.$numDocumentOccurrences++;
                uidMap[uid] = {
                    $document: doc,
                    $numTokenOccurrences: 1
                };
            } else uidMap[uid].$numTokenOccurrences++;
        };
        _proto.search = function search(tokens, corpus) {
            var uidToDocumentMap = {};
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = tokens[i];
                var tokenMetadata = this._tokenMap[token];
                if (!tokenMetadata) return [];
                if (i === 0) {
                    var keys = Object.keys(tokenMetadata.$uidMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                    }
                } else {
                    var keys = Object.keys(uidToDocumentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                    }
                }
            }
            var documents = [];
            for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
            var calculateTfIdf = this._createCalculateTfIdf();
            return documents.sort(function(documentA, documentB) {
                return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
            });
        };
        _proto._createCalculateIdf = function _createCalculateIdf() {
            var tokenMap = this._tokenMap;
            var tokenToIdfCache = this._tokenToIdfCache;
            return function calculateIdf(token, documents) {
                if (!tokenToIdfCache[token]) {
                    var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                    tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
                }
                return tokenToIdfCache[token];
            };
        };
        _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
            var tokenMap = this._tokenMap;
            var uidFieldName = this._uidFieldName;
            var calculateIdf = this._createCalculateIdf();
            return function calculateTfIdf(tokens, document, documents) {
                var score = 0;
                for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                    var token = tokens[i];
                    var inverseDocumentFrequency = calculateIdf(token, documents);
                    if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                    var uid;
                    if (uidFieldName instanceof Array) uid = document && $348051c3be02fe74$var$getNestedFieldValue(document, uidFieldName);
                    else uid = document && document[uidFieldName];
                    var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                    score += termFrequency * inverseDocumentFrequency;
                }
                return score;
            };
        };
        return TfIdfSearchIndex;
    }();
    var $348051c3be02fe74$export$5e70dbef3f0d47db = function() {
        function UnorderedSearchIndex() {
            this._tokenToUidToDocumentMap = {};
        }
        var _proto = UnorderedSearchIndex.prototype;
        _proto.indexDocument = function indexDocument(token, uid, doc) {
            if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
            this._tokenToUidToDocumentMap[token][uid] = doc;
        };
        _proto.search = function search(tokens, corpus) {
            var intersectingDocumentMap = {};
            var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = tokens[i];
                var documentMap = tokenToUidToDocumentMap[token];
                if (!documentMap) return [];
                if (i === 0) {
                    var keys = Object.keys(documentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        intersectingDocumentMap[uid] = documentMap[uid];
                    }
                } else {
                    var keys = Object.keys(intersectingDocumentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                    }
                }
            }
            var keys = Object.keys(intersectingDocumentMap);
            var documents = [];
            for(var i = 0, numKeys = keys.length; i < numKeys; i++){
                var uid = keys[i];
                documents.push(intersectingDocumentMap[uid]);
            }
            return documents;
        };
        return UnorderedSearchIndex;
    }();
    var $348051c3be02fe74$var$REGEX = /[^a-zа-яё0-9\-']+/i;
    var $348051c3be02fe74$export$f5ac5ec3cb556ad6 = function() {
        function SimpleTokenizer() {}
        var _proto = SimpleTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return text.split($348051c3be02fe74$var$REGEX).filter(function(text) {
                return text;
            });
        };
        return SimpleTokenizer;
    }();
    var $348051c3be02fe74$export$d2c689c98d4dcb27 = function() {
        function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
            this._stemmingFunction = stemmingFunction;
            this._tokenizer = decoratedTokenizer;
        }
        var _proto = StemmingTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return this._tokenizer.tokenize(text).map(this._stemmingFunction);
        };
        return StemmingTokenizer;
    }();
    var $348051c3be02fe74$export$eeaf491a400e882a = {
        a: true,
        able: true,
        about: true,
        across: true,
        after: true,
        all: true,
        almost: true,
        also: true,
        am: true,
        among: true,
        an: true,
        and: true,
        any: true,
        are: true,
        as: true,
        at: true,
        be: true,
        because: true,
        been: true,
        but: true,
        by: true,
        can: true,
        cannot: true,
        could: true,
        dear: true,
        did: true,
        'do': true,
        does: true,
        either: true,
        'else': true,
        ever: true,
        every: true,
        'for': true,
        from: true,
        'get': true,
        got: true,
        had: true,
        has: true,
        have: true,
        he: true,
        her: true,
        hers: true,
        him: true,
        his: true,
        how: true,
        however: true,
        i: true,
        'if': true,
        'in': true,
        into: true,
        is: true,
        it: true,
        its: true,
        just: true,
        least: true,
        "let": true,
        like: true,
        likely: true,
        may: true,
        me: true,
        might: true,
        most: true,
        must: true,
        my: true,
        neither: true,
        no: true,
        nor: true,
        not: true,
        of: true,
        off: true,
        often: true,
        on: true,
        only: true,
        or: true,
        other: true,
        our: true,
        own: true,
        rather: true,
        said: true,
        say: true,
        says: true,
        she: true,
        should: true,
        since: true,
        so: true,
        some: true,
        than: true,
        that: true,
        the: true,
        their: true,
        them: true,
        then: true,
        there: true,
        these: true,
        they: true,
        'this': true,
        tis: true,
        to: true,
        too: true,
        twas: true,
        us: true,
        wants: true,
        was: true,
        we: true,
        were: true,
        what: true,
        when: true,
        where: true,
        which: true,
        'while': true,
        who: true,
        whom: true,
        why: true,
        will: true,
        'with': true,
        would: true,
        yet: true,
        you: true,
        your: true
    };
    $348051c3be02fe74$export$eeaf491a400e882a.constructor = false;
    $348051c3be02fe74$export$eeaf491a400e882a.hasOwnProperty = false;
    $348051c3be02fe74$export$eeaf491a400e882a.isPrototypeOf = false;
    $348051c3be02fe74$export$eeaf491a400e882a.propertyIsEnumerable = false;
    $348051c3be02fe74$export$eeaf491a400e882a.toLocaleString = false;
    $348051c3be02fe74$export$eeaf491a400e882a.toString = false;
    $348051c3be02fe74$export$eeaf491a400e882a.valueOf = false;
    var $348051c3be02fe74$export$59d4dfff8ed0ca89 = function() {
        function StopWordsTokenizer(decoratedTokenizer) {
            this._tokenizer = decoratedTokenizer;
        }
        var _proto = StopWordsTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return this._tokenizer.tokenize(text).filter(function(token) {
                return !$348051c3be02fe74$export$eeaf491a400e882a[token];
            });
        };
        return StopWordsTokenizer;
    }();
    function $348051c3be02fe74$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $348051c3be02fe74$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $348051c3be02fe74$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $348051c3be02fe74$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $348051c3be02fe74$export$4b85d3515bd863a5 = function() {
        function Search(uidFieldName) {
            if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
            this._uidFieldName = uidFieldName;
            this._indexStrategy = new $348051c3be02fe74$export$eb7fc80cfe9abfe6();
            this._searchIndex = new $348051c3be02fe74$export$a1138c79781169cc(uidFieldName);
            this._sanitizer = new $348051c3be02fe74$export$147e8ac43c84713a();
            this._tokenizer = new $348051c3be02fe74$export$f5ac5ec3cb556ad6();
            this._documents = [];
            this._searchableFields = [];
        }
        var _proto = Search.prototype;
        _proto.addDocument = function addDocument(document) {
            this.addDocuments([
                document
            ]);
        };
        _proto.addDocuments = function addDocuments(documents) {
            this._documents = this._documents.concat(documents);
            this.indexDocuments_(documents, this._searchableFields);
        };
        _proto.addIndex = function addIndex(field) {
            this._searchableFields.push(field);
            this.indexDocuments_(this._documents, [
                field
            ]);
        };
        _proto.search = function search(query) {
            var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
            return this._searchIndex.search(tokens, this._documents);
        };
        _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
            this._initialized = true;
            var indexStrategy = this._indexStrategy;
            var sanitizer = this._sanitizer;
            var searchIndex = this._searchIndex;
            var tokenizer = this._tokenizer;
            var uidFieldName = this._uidFieldName;
            for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
                var doc = documents[di];
                var uid;
                if (uidFieldName instanceof Array) uid = $348051c3be02fe74$var$getNestedFieldValue(doc, uidFieldName);
                else uid = doc[uidFieldName];
                for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                    var fieldValue;
                    var searchableField = _searchableFields[sfi];
                    if (searchableField instanceof Array) fieldValue = $348051c3be02fe74$var$getNestedFieldValue(doc, searchableField);
                    else fieldValue = doc[searchableField];
                    if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                    if (typeof fieldValue === 'string') {
                        var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                        for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                            var fieldToken = fieldTokens[fti];
                            var expandedTokens = indexStrategy.expandToken(fieldToken);
                            for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                                var expandedToken = expandedTokens[eti];
                                searchIndex.indexDocument(expandedToken, uid, doc);
                            }
                        }
                    }
                }
            }
        };
        $348051c3be02fe74$var$_createClass(Search, [
            {
                key: "indexStrategy",
                set: function set(value) {
                    if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                    this._indexStrategy = value;
                },
                get: function get() {
                    return this._indexStrategy;
                }
            },
            {
                key: "sanitizer",
                set: function set(value) {
                    if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                    this._sanitizer = value;
                },
                get: function get() {
                    return this._sanitizer;
                }
            },
            {
                key: "searchIndex",
                set: function set(value) {
                    if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                    this._searchIndex = value;
                },
                get: function get() {
                    return this._searchIndex;
                }
            },
            {
                key: "tokenizer",
                set: function set(value) {
                    if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                    this._tokenizer = value;
                },
                get: function get() {
                    return this._tokenizer;
                }
            }
        ]);
        return Search;
    }();
    var $348051c3be02fe74$export$11e693a7f8ce1bcc = function() {
        function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
            this._indexStrategy = opt_indexStrategy || new $348051c3be02fe74$export$eb7fc80cfe9abfe6();
            this._sanitizer = opt_sanitizer || new $348051c3be02fe74$export$147e8ac43c84713a();
            this._wrapperTagName = opt_wrapperTagName || 'mark';
        }
        var _proto = TokenHighlighter.prototype;
        _proto.highlight = function highlight(text, tokens) {
            var tagsLength = this._wrapText('').length;
            var tokenDictionary = Object.create(null);
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = this._sanitizer.sanitize(tokens[i]);
                var expandedTokens = this._indexStrategy.expandToken(token);
                for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                    var expandedToken = expandedTokens[j];
                    if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                        token
                    ];
                    else tokenDictionary[expandedToken].push(token);
                }
            }
            var actualCurrentWord = '';
            var sanitizedCurrentWord = '';
            var currentWordStartIndex = 0;
            for(var i = 0, textLength = text.length; i < textLength; i++){
                var character = text.charAt(i);
                if (character === ' ') {
                    actualCurrentWord = '';
                    sanitizedCurrentWord = '';
                    currentWordStartIndex = i + 1;
                } else {
                    actualCurrentWord += character;
                    sanitizedCurrentWord += this._sanitizer.sanitize(character);
                }
                if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                    actualCurrentWord = this._wrapText(actualCurrentWord);
                    text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                    i += tagsLength;
                    textLength += tagsLength;
                }
            }
            return text;
        };
        _proto._wrapText = function _wrapText(text) {
            var tagName = this._wrapperTagName;
            return "<" + tagName + ">" + text + "</" + tagName + ">";
        };
        return TokenHighlighter;
    }();
});
parcelRegister("8uEVD", function(module, exports) {
    $parcel$export(module.exports, "tokenizerRegex", ()=>$5b7729e4e8bca1a3$export$6558e5d0f0e834f8);
    const $5b7729e4e8bca1a3$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
});
parcelRegister("4YzS0", function(module, exports) {
    $parcel$export(module.exports, "createSearchEmojiComparator", ()=>$a9bb19222703c8eb$export$e6097b005751df7);
    $parcel$export(module.exports, "createUsageOnlyEmojiComparator", ()=>$a9bb19222703c8eb$export$1bd055808eeccb4e);
    var $8PD8v;
    var $ibnx0;
    function $a9bb19222703c8eb$export$e6097b005751df7(query, orderedIds) {
        const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
        const comparators = [];
        if (query) comparators.push(new $a9bb19222703c8eb$export$ff92575cd1bbad0e(query));
        if (textQuery) comparators.push(new $a9bb19222703c8eb$export$3026b08b79541139(textQuery));
        if (orderedIds && orderedIds.length) comparators.push(new $a9bb19222703c8eb$export$55e24837a4bf653(orderedIds));
        if (textQuery) comparators.push(new $a9bb19222703c8eb$export$587c775915dc4869(textQuery, 'shortName'), new $a9bb19222703c8eb$export$587c775915dc4869(textQuery, 'name'));
        comparators.push($a9bb19222703c8eb$export$165e96ceead77edd.Instance, $a9bb19222703c8eb$export$30ce221e1adf48c1.Instance);
        const comparator = new $a9bb19222703c8eb$export$a8052d0852821684(...comparators);
        comparator.compare = comparator.compare.bind(comparator);
        return comparator;
    }
    function $a9bb19222703c8eb$export$1bd055808eeccb4e(orderedIds) {
        const comparator = new $a9bb19222703c8eb$export$a8052d0852821684(new $a9bb19222703c8eb$export$55e24837a4bf653(orderedIds), new $a9bb19222703c8eb$export$a7f7a0b04013a8a8(), $a9bb19222703c8eb$export$165e96ceead77edd.Instance);
        comparator.compare = comparator.compare.bind(comparator);
        return comparator;
    }
    class $a9bb19222703c8eb$export$a8052d0852821684 {
        constructor(...comparators){
            this.chain = comparators;
        }
        compare(e1, e2) {
            for(let i = 0; i < this.chain.length; i++){
                const result = this.chain[i].compare(e1, e2);
                if (result !== 0) return result;
            }
            return 0;
        }
    }
    class $a9bb19222703c8eb$export$ff92575cd1bbad0e {
        constructor(query){
            this.query = query;
        }
        compare(e1, e2) {
            const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
            const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
            if (e1HasAscii && !e2HasAscii) return -1;
            else if (!e1HasAscii && e2HasAscii) return 1;
            return 0;
        }
    }
    class $a9bb19222703c8eb$export$3026b08b79541139 {
        constructor(query){
            this.colonQuery = `:${query}:`;
            this.typeComparator = new $a9bb19222703c8eb$export$a7f7a0b04013a8a8(true);
        }
        compare(e1, e2) {
            if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
            else if (e1.shortName === this.colonQuery) return -1;
            else if (e2.shortName === this.colonQuery) return 1;
            return 0;
        }
    }
    class $a9bb19222703c8eb$export$a7f7a0b04013a8a8 {
        constructor(reverse){
            if (reverse) this.typeToNumber = new Map([
                [
                    'SITE',
                    0
                ],
                [
                    'ATLASSIAN',
                    1
                ],
                [
                    'STANDARD',
                    2
                ]
            ]);
            else this.typeToNumber = new Map([
                [
                    'STANDARD',
                    0
                ],
                [
                    'ATLASSIAN',
                    1
                ],
                [
                    'SITE',
                    2
                ]
            ]);
        }
        compare(e1, e2) {
            return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
        }
        emojiTypeToOrdinal(emoji) {
            let ordinal = this.typeToNumber.get(emoji.type);
            if (ordinal === undefined) ordinal = 10;
            return ordinal;
        }
    }
    class $a9bb19222703c8eb$export$55e24837a4bf653 {
        constructor(orderedIds){
            this.positionLookup = new Map();
            orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
        }
        compare(e1, e2) {
            if (!e1.id || !e2.id) return 0;
            let i1 = this.getPositionInOrder(e1);
            let i2 = this.getPositionInOrder(e2);
            return i1 - i2;
        }
        getPositionInOrder(emoji) {
            let id = emoji.id ? emoji.id : '0';
            if ((0, (0, parcelRequire("ibnx0")).isEmojiVariationDescription)(emoji)) id = emoji.baseId;
            const position = this.positionLookup.get(id);
            if (position) return position;
            else return 0, (0, parcelRequire("8PD8v")).MAX_ORDINAL;
        }
    }
    class $a9bb19222703c8eb$export$587c775915dc4869 {
        constructor(query, propertyToCompare){
            this.query = query;
            if (!propertyToCompare) throw new Error('propertyToCompare is required');
            this.propertyName = propertyToCompare;
        }
        getScore(emoji) {
            const propertyValue = emoji[this.propertyName];
            const score = propertyValue ? propertyValue.indexOf(this.query) : (0, (0, parcelRequire("8PD8v")).MAX_ORDINAL);
            return score === -1 ? (0, (0, parcelRequire("8PD8v")).MAX_ORDINAL) : score;
        }
        compare(e1, e2) {
            return this.getScore(e1) - this.getScore(e2);
        }
    }
    class $a9bb19222703c8eb$export$165e96ceead77edd {
        constructor(){}
        static get Instance() {
            return this.INSTANCE || (this.INSTANCE = new this());
        }
        compare(e1, e2) {
            let o1 = e1.order ? e1.order : (0, (0, parcelRequire("8PD8v")).MAX_ORDINAL);
            let o2 = e2.order ? e2.order : (0, (0, parcelRequire("8PD8v")).MAX_ORDINAL);
            return o1 - o2;
        }
    }
    class $a9bb19222703c8eb$export$30ce221e1adf48c1 {
        constructor(){}
        static get Instance() {
            return this.INSTANCE || (this.INSTANCE = new this());
        }
        compare(e1, e2) {
            return e1.shortName.localeCompare(e2.shortName);
        }
    }
});
parcelRegister("kVtxt", function(module, exports) {
    $parcel$export(module.exports, "UsageFrequencyTracker", ()=>$7d995ab142f020ea$export$3f86810331c44209);
    var $ibnx0;
    var $8PD8v;
    var $jqd2C;
    var $gZZTQ;
    var $6ijiY;
    class $7d995ab142f020ea$export$3f86810331c44209 {
        static{
            this.queueOptions = {
                storage: (0, (0, parcelRequire("6ijiY")).default)('localStorage') ? window.localStorage : undefined,
                storagePrefix: (0, (0, parcelRequire("8PD8v")).localStoragePrefix),
                maxDuplicates: 25,
                minUniqueItems: 5
            };
        }
        constructor(useStorageIfPossible = true){
            const options = $7d995ab142f020ea$export$3f86810331c44209.queueOptions;
            if (useStorageIfPossible && options.storage) {
                const queueOptions = {
                    ...options,
                    storage: options.storage
                };
                this.queue = new (0, (0, parcelRequire("gZZTQ")).default)(queueOptions);
            } else this.queue = new (0, (0, parcelRequire("jqd2C")).default)(options);
            this.gateway = new $7d995ab142f020ea$export$a0e1fa6601cae894(10);
        }
        recordUsage(emoji) {
            let emojiId = emoji.id;
            if (emojiId) {
                if ((0, (0, parcelRequire("ibnx0")).isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
                this.gateway.submit(()=>{
                    if (emojiId) this.queue.enqueue(emojiId);
                });
            }
        }
        getOrder() {
            return this.queue.getItemsOrderedByDuplicateCount();
        }
        clear() {
            this.queue.clear();
        }
    }
    class $7d995ab142f020ea$export$a0e1fa6601cae894 {
        constructor(maximumPermitted){
            if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
            this.maximumPermitted = maximumPermitted;
            this.count = 0;
        }
        submit(f) {
            if (this.count >= this.maximumPermitted) return false;
            this.count++;
            const wrappedFunc = ()=>{
                try {
                    f();
                } finally{
                    this.completed();
                }
            };
            if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
            return true;
        }
        completed() {
            this.count--;
        }
    }
});
parcelRegister("jqd2C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$540a13a1151f73eb$export$2e2bcd8739ae039);
    class $540a13a1151f73eb$export$2e2bcd8739ae039 {
        constructor(options){
            if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
            if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
            this.maximumSize = options.maxDuplicates * options.minUniqueItems;
            this.perItemSize = options.maxDuplicates;
            this.createEmptyState();
        }
        enqueue(item) {
            this.enqueueWithoutOrdering(item);
            this.itemsOrderedByFrequency = this.orderItemsByFrequency();
        }
        getItemsOrderedByDuplicateCount() {
            return this.itemsOrderedByFrequency;
        }
        clear() {
            this.createEmptyState();
        }
        bulkEnqueue(items) {
            items.map((item)=>this.enqueueWithoutOrdering(item));
            this.itemsOrderedByFrequency = this.orderItemsByFrequency();
        }
        getItems() {
            return this.items;
        }
        createEmptyState() {
            this.items = new Array();
            this.itemCountMap = new Map();
            this.itemsOrderedByFrequency = new Array();
        }
        enqueueWithoutOrdering(item) {
            const count = this.itemCountMap.get(item);
            if (count && count >= this.perItemSize) this.removeFirstOccurrence(item);
            else if (this.items.length >= this.maximumSize) this.remove();
            this.add(item);
        }
        orderItemsByFrequency() {
            const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
                return b[1] - a[1];
            });
            return orderedEntries.map((value)=>value[0]);
        }
        decrementCount(item) {
            let count = this.itemCountMap.get(item);
            if (count) {
                count--;
                if (count > 0) this.itemCountMap.set(item, count);
                else this.itemCountMap.delete(item);
            }
        }
        removeFirstOccurrence(item) {
            const index = this.items.indexOf(item);
            if (index !== -1) {
                this.items.splice(index, 1);
                this.decrementCount(item);
            }
        }
        remove() {
            const removed = this.items.shift();
            if (removed !== undefined) this.decrementCount(removed);
            return removed;
        }
        add(item) {
            this.items.push(item);
            const count = this.itemCountMap.get(item);
            if (count) this.itemCountMap.set(item, count + 1);
            else this.itemCountMap.set(item, 1);
        }
    }
});
parcelRegister("gZZTQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9617e9253f78002c$export$2e2bcd8739ae039);
    var $jqd2C;
    var $gLnrw;
    class $9617e9253f78002c$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("jqd2C")).default) {
        static{
            this.storageKey = 'lastUsed';
        }
        constructor(options){
            super(options);
            this.storage = options.storage;
            this.prefixedStorageKey = `${options.storagePrefix}.${$9617e9253f78002c$export$2e2bcd8739ae039.storageKey}`;
            this.load();
        }
        enqueue(item) {
            super.enqueue(item);
            this.save();
        }
        clear() {
            super.clear();
            this.storage.removeItem(this.prefixedStorageKey);
        }
        load() {
            const itemsJson = this.storage.getItem(this.prefixedStorageKey);
            if (itemsJson) try {
                const items = JSON.parse(itemsJson);
                this.bulkEnqueue(items);
            } catch (e) {
                (0, (0, parcelRequire("gLnrw")).default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
            }
        }
        save() {
            const itemsJson = JSON.stringify(this.getItems());
            try {
                this.storage.setItem(this.prefixedStorageKey, itemsJson);
            } catch (e) {
                (0, (0, parcelRequire("gLnrw")).default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
            }
        }
    }
});
parcelRegister("aJRhE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fca3adb7dca5307e$export$2e2bcd8739ae039);
    var $2Z5gN = parcelRequire("2Z5gN");
    var $2KWq4;
    var $ibnx0;
    var $1qDSp;
    var $6Bbdw;
    var $bDcMG;
    var $gLnrw;
    const $fca3adb7dca5307e$export$6f3a08dea02a7b2b = 0.95;
    class $fca3adb7dca5307e$export$2e2bcd8739ae039 {
        constructor(siteServiceConfig, mediaApiToken){
            this.postToEmojiService = (upload, fileId)=>{
                const { shortName: shortName, name: name } = upload;
                const { width: width, height: height } = upload;
                const requestInit = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        shortName: shortName,
                        name: name,
                        width: width,
                        height: height,
                        fileId: fileId
                    })
                };
                return (0, $2Z5gN.utils).requestService(this.siteServiceConfig, {
                    requestInit: requestInit
                }).then((response)=>{
                    const { emojis: emojis } = response;
                    if (emojis.length) {
                        const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                        const response = {
                            ...emoji,
                            representation: (0, (0, parcelRequire("ibnx0")).convertImageToMediaRepresentation)(emoji.representation)
                        };
                        const altRepresentation = (0, (0, parcelRequire("6Bbdw")).getAltRepresentation)(altRepresentations || {});
                        const imgAltRepresentation = altRepresentation ? (0, (0, parcelRequire("ibnx0")).convertImageToMediaRepresentation)(altRepresentation) : undefined;
                        return (0, (0, parcelRequire("ibnx0")).buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                    }
                    throw new Error('No emoji returns from upload. Upload failed.');
                });
            };
            this.siteServiceConfig = siteServiceConfig;
            this.mediaApiToken = mediaApiToken;
            this.tokenManager = new (0, (0, parcelRequire("bDcMG")).default)(siteServiceConfig);
            this.tokenManager.addToken('read', mediaApiToken);
            this.mediaEmojiCache = new (0, (0, parcelRequire("1qDSp")).default)(this.tokenManager);
        }
        async generateTokenisedMediaURLS(representation, altRepresentation) {
            if (!(0, (0, parcelRequire("ibnx0")).isMediaRepresentation)(representation)) return {
                representation: representation,
                altRepresentation: altRepresentation
            };
            try {
                const readToken = await this.tokenManager.getToken('read');
                return Object.entries({
                    representation: representation,
                    altRepresentation: altRepresentation
                }).reduce((acc, [key, value])=>{
                    if (value && (0, (0, parcelRequire("ibnx0")).isMediaRepresentation)(value)) {
                        const path = new URL(value.mediaPath);
                        const params = path.searchParams;
                        if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                        if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                        acc[key] = {
                            ...value,
                            mediaPath: path.toString()
                        };
                    }
                    return acc;
                }, {
                    representation: representation,
                    altRepresentation: altRepresentation
                });
            } catch (error) {
                return {
                    representation: representation,
                    altRepresentation: altRepresentation
                };
            }
        }
        loadMediaEmoji(emoji, useAlt) {
            if (!(0, (0, parcelRequire("ibnx0")).isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
            return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
        }
        optimisticRendering(emoji, useAlt) {
            const representation = useAlt ? emoji.altRepresentation : emoji.representation;
            if (!(0, (0, parcelRequire("ibnx0")).isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
            const { mediaPath: mediaPath } = representation;
            return this.mediaEmojiCache.optimisticRendering(mediaPath);
        }
        uploadEmoji(upload, retry = false, progressCallback) {
            const startTime = Date.now();
            return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
                const tokenLoadTime = Date.now() - startTime;
                (0, (0, parcelRequire("gLnrw")).default)('upload token load time', tokenLoadTime);
                return new Promise((resolve, reject)=>{
                    const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                    const mediaClient = (0, (0, parcelRequire("2KWq4")).getMediaClient)({
                        authProvider: ()=>Promise.resolve({
                                clientId: clientId,
                                token: uploadToken.jwt,
                                baseUrl: url
                            }),
                        useSha256ForUploads: true
                    });
                    const subscription = mediaClient.file.upload({
                        content: upload.dataURL,
                        name: upload.filename,
                        collection: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $fca3adb7dca5307e$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, (0, parcelRequire("gLnrw")).default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, state.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                });
            });
        }
        hasUploadToken() {
            const tokenPromise = this.tokenManager.getToken('upload');
            return tokenPromise.then((token)=>{
                return token !== undefined;
            }, ()=>{
                return false;
            });
        }
        prepareForUpload() {
            this.tokenManager.getToken('upload');
        }
        findEmoji(emojiId) {
            if (!emojiId.id) return Promise.reject(false);
            const path = `../${encodeURIComponent(emojiId.id)}`;
            return (0, (0, parcelRequire("6Bbdw")).emojiRequest)(this.siteServiceConfig, {
                path: path
            }).then((serviceResponse)=>{
                const response = (0, (0, parcelRequire("6Bbdw")).denormaliseEmojiServiceResponse)(serviceResponse);
                return response.emojis[0];
            }).catch((error)=>{
                (0, (0, parcelRequire("gLnrw")).default)('failed to load emoji', emojiId, error);
                return undefined;
            });
        }
        deleteEmoji(emoji) {
            if (!(0, (0, parcelRequire("ibnx0")).isMediaEmoji)(emoji) && !(0, (0, parcelRequire("ibnx0")).isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
            if (!emoji.id) return Promise.reject(false);
            const path = `${encodeURIComponent(emoji.id)}`;
            const requestInit = {
                method: 'DELETE'
            };
            return (0, $2Z5gN.utils).requestService(this.siteServiceConfig, {
                path: path,
                requestInit: requestInit
            }).then(()=>true).catch(()=>false);
        }
    }
});
parcelRegister("1qDSp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd69dd80c71e8c82$export$2e2bcd8739ae039);
    var $ibnx0;
    var $7j5zT;
    var $gLnrw;
    var $iwKVT = parcelRequire("iwKVT");
    const $bd69dd80c71e8c82$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
    const $bd69dd80c71e8c82$var$isUnsupportedBrowser = ()=>{
        const isIE = !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        return isIE || isEdge;
    };
    class $bd69dd80c71e8c82$export$3850f566ce8d817a {
        constructor(mediaImageLoader){
            this.cachedImageUrls = new Set();
            (0, (0, parcelRequire("gLnrw")).default)('BrowserCacheStrategy');
            this.mediaImageLoader = mediaImageLoader;
        }
        loadEmoji(emoji, useAlt) {
            const representation = $bd69dd80c71e8c82$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("ibnx0")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            if (this.cachedImageUrls.has(mediaPath)) return emoji;
            return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
                this.cachedImageUrls.add(mediaPath);
                return emoji;
            }).catch(()=>{
                return undefined;
            });
        }
        optimisticRendering() {
            return true;
        }
        static supported(mediaPath, mediaImageLoader) {
            if ($bd69dd80c71e8c82$var$isUnsupportedBrowser()) return Promise.resolve(false);
            return mediaImageLoader.loadMediaImage(mediaPath).then(()=>new Promise((resolve)=>{
                    const img = new Image();
                    img.addEventListener('load', ()=>{
                        resolve(true);
                    });
                    img.addEventListener('error', ()=>{
                        resolve(false);
                    });
                    img.src = mediaPath;
                })).catch(()=>false);
        }
    }
    const $bd69dd80c71e8c82$var$maxImageCached = 1000;
    const $bd69dd80c71e8c82$var$maxImageSize = 10000;
    class $bd69dd80c71e8c82$export$b522858a3709f4c {
        constructor(mediaImageLoader){
            (0, (0, parcelRequire("gLnrw")).default)('MemoryCacheStrategy');
            this.mediaImageLoader = mediaImageLoader;
            this.dataURLCache = new (0, $iwKVT.LRUMap)($bd69dd80c71e8c82$var$maxImageCached);
        }
        loadEmoji(emoji, useAlt) {
            const representation = $bd69dd80c71e8c82$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("ibnx0")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            const dataURL = this.dataURLCache.get(mediaPath);
            if (dataURL) return (0, (0, parcelRequire("ibnx0")).convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
                const loadedEmoji = (0, (0, parcelRequire("ibnx0")).convertMediaToImageEmoji)(emoji, dataURL, useAlt);
                if (dataURL.length <= $bd69dd80c71e8c82$var$maxImageSize) this.dataURLCache.set(mediaPath, dataURL);
                else (0, (0, parcelRequire("gLnrw")).default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
                return loadedEmoji;
            }).catch(()=>{
                return undefined;
            });
        }
        optimisticRendering() {
            return false;
        }
    }
    class $bd69dd80c71e8c82$export$2e2bcd8739ae039 {
        constructor(tokenManager){
            this.waitingInitUrls = [];
            (0, (0, parcelRequire("gLnrw")).default)('MediaEmojiCache');
            this.mediaImageLoader = new (0, (0, parcelRequire("7j5zT")).default)(tokenManager);
        }
        loadEmoji(emoji, useAlt) {
            const representation = $bd69dd80c71e8c82$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("ibnx0")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            const emojiCache = this.getCache(mediaPath);
            if ((0, (0, parcelRequire("ibnx0")).isPromise)(emojiCache)) return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
            return emojiCache.loadEmoji(emoji, useAlt);
        }
        optimisticRendering(url) {
            const emojiCache = this.getCache(url);
            if ((0, (0, parcelRequire("ibnx0")).isPromise)(emojiCache)) return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
            return emojiCache.optimisticRendering();
        }
        getCache(url) {
            if (this.cache) return this.cache;
            this.waitingInitUrls.push(url);
            if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
                this.cache = cache;
                this.cacheLoading = undefined;
                return cache;
            }).catch((err)=>{
                this.cacheLoading = undefined;
                throw err;
            });
            return this.cacheLoading;
        }
        initCache() {
            const url = this.waitingInitUrls.pop();
            if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
            return $bd69dd80c71e8c82$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
                this.waitingInitUrls = [];
                this.cacheLoading = undefined;
                if (supported) return new $bd69dd80c71e8c82$export$3850f566ce8d817a(this.mediaImageLoader);
                return new $bd69dd80c71e8c82$export$b522858a3709f4c(this.mediaImageLoader);
            }).catch(()=>{
                return this.initCache();
            });
        }
    }
});
parcelRegister("7j5zT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa629fd85d5b24da$export$2e2bcd8739ae039);
    var $5BKCf;
    const $fa629fd85d5b24da$var$defaultConcurrentDownloadLimit = 16;
    const $fa629fd85d5b24da$var$backoffMaxDelayInMillis = 600;
    const $fa629fd85d5b24da$var$defaultMaxRetriesOnNotFound = 2;
    class $fa629fd85d5b24da$export$2e2bcd8739ae039 {
        constructor(tokenManager, options){
            this.mediaImageQueue = [];
            this.activeProcessing = 0;
            this.pendingRequests = new Map();
            this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $fa629fd85d5b24da$var$defaultConcurrentDownloadLimit;
            this.tokenManager = tokenManager;
        }
        loadMediaImage(url) {
            const maybePending = this.pendingRequests.get(url);
            if (maybePending !== undefined) return maybePending;
            const pending = new Promise((resolve, reject)=>{
                this.mediaImageQueue.push({
                    url: url,
                    resolve: resolve,
                    reject: reject
                });
                this.processFromQueue();
            }).then((result)=>{
                this.pendingRequests.delete(url);
                return result;
            }).catch((error)=>{
                this.pendingRequests.delete(url);
                throw error;
            });
            this.pendingRequests.set(url, pending);
            return pending;
        }
        getQueueSize() {
            return this.mediaImageQueue.length;
        }
        getActiveDownloads() {
            return this.activeProcessing;
        }
        processFromQueue() {
            while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
                this.activeProcessing++;
                const item = this.mediaImageQueue.shift();
                const { url: url, resolve: resolve, reject: reject } = item;
                this.tokenManager.getToken('read', false).then((token)=>{
                    this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                        resolve(dataURL);
                        this.completedItem();
                    }).catch((error)=>{
                        reject(error);
                        this.completedItem();
                    });
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }
        }
        completedItem() {
            this.activeProcessing--;
            this.processFromQueue();
        }
        delay(durationInMillis) {
            return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
        }
        requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $fa629fd85d5b24da$var$defaultMaxRetriesOnNotFound) {
            return (0, (0, parcelRequire("5BKCf")).imageAcceptHeader)().then((acceptHeader)=>{
                const options = {
                    headers: {
                        Authorization: `Bearer ${token.jwt}`,
                        'X-Client-Id': token.clientId,
                        Accept: acceptHeader
                    }
                };
                return fetch(url, options).then((response)=>{
                    if (response.status === 404 && retriesOnNotFound > 0) return this.delay($fa629fd85d5b24da$var$backoffMaxDelayInMillis / retriesOnNotFound).then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                    else if (response.status === 403 && retryOnAuthError) return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                    else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                    throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
                });
            });
        }
        readBlob(blob) {
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.addEventListener('load', ()=>resolve(reader.result));
                reader.addEventListener('error', ()=>reject(reader.error));
                reader.readAsDataURL(blob);
            });
        }
    }
});
parcelRegister("5BKCf", function(module, exports) {
    $parcel$export(module.exports, "getNaturalImageSize", ()=>$a7f5d1b5d0415587$export$90153ab95f408dfa);
    $parcel$export(module.exports, "parseImage", ()=>$a7f5d1b5d0415587$export$37bbb051492a18a7);
    $parcel$export(module.exports, "hasFileExceededSize", ()=>$a7f5d1b5d0415587$export$a115ddd5941792f1);
    $parcel$export(module.exports, "imageAcceptHeader", ()=>$a7f5d1b5d0415587$export$f8e7886bc155c2e6);
    const $a7f5d1b5d0415587$var$maxEmojiSizeInBytes = 1048576;
    const $a7f5d1b5d0415587$export$90153ab95f408dfa = (dataURL)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.addEventListener('load', ()=>{
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            });
            img.addEventListener('error', reject);
            img.src = dataURL;
        });
    };
    const $a7f5d1b5d0415587$export$37bbb051492a18a7 = (dataURL)=>{
        return new Promise((resolve, reject)=>{
            let img = new Image();
            img.onload = ()=>resolve({
                    src: img.src
                });
            img.onerror = ()=>reject();
            img.src = dataURL;
        });
    };
    const $a7f5d1b5d0415587$export$a115ddd5941792f1 = (file)=>{
        return file && file.size > $a7f5d1b5d0415587$var$maxEmojiSizeInBytes;
    };
    let $a7f5d1b5d0415587$var$isWebpSupported;
    const $a7f5d1b5d0415587$export$c5a964eb84c7fca8 = ()=>{
        if ($a7f5d1b5d0415587$var$isWebpSupported !== undefined) return Promise.resolve($a7f5d1b5d0415587$var$isWebpSupported);
        return new Promise((resolve)=>{
            const img = new Image();
            const checkSupport = ()=>{
                $a7f5d1b5d0415587$var$isWebpSupported = img.height === 2;
                resolve($a7f5d1b5d0415587$var$isWebpSupported);
            };
            img.addEventListener('load', checkSupport);
            img.addEventListener('error', checkSupport);
            img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
        });
    };
    const $a7f5d1b5d0415587$export$f8e7886bc155c2e6 = ()=>$a7f5d1b5d0415587$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
            const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
            const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
            return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
        });
});
parcelRegister("bDcMG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dbaf23388b8ee1b4$export$2e2bcd8739ae039);
    var $2Z5gN = parcelRequire("2Z5gN");
    const $dbaf23388b8ee1b4$export$866c20c059277b6 = 30;
    class $dbaf23388b8ee1b4$export$2e2bcd8739ae039 {
        constructor(siteServiceConfig){
            this.siteServiceConfig = siteServiceConfig;
            this.tokens = new Map();
        }
        isValidToken(mediaApiToken) {
            const nowInSeconds = Date.now() / 1000;
            const expiresAt = mediaApiToken.expiresAt - $dbaf23388b8ee1b4$export$866c20c059277b6;
            if (nowInSeconds < expiresAt) return true;
            return false;
        }
        fetchNewToken(type) {
            return (0, $2Z5gN.utils).requestService(this.siteServiceConfig, {
                path: `token/${type}`
            });
        }
        addToken(type, mediaApiToken) {
            this.tokens.set(type, {
                mediaApiToken: mediaApiToken
            });
        }
        getToken(type, forceRefresh) {
            let tokenDetail = this.tokens.get(type);
            if (!tokenDetail) {
                tokenDetail = {};
                this.tokens.set(type, tokenDetail);
            }
            const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
            if (mediaApiToken) {
                if (this.isValidToken(mediaApiToken) && !forceRefresh) return Promise.resolve(mediaApiToken);
            }
            if (activeTokenRefresh) return activeTokenRefresh;
            tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
                tokenDetail.mediaApiToken = token;
                tokenDetail.activeTokenRefresh = undefined;
                return token;
            });
            return tokenDetail.activeTokenRefresh;
        }
    }
});
parcelRegister("eNoEO", function(module, exports) {
    $parcel$export(module.exports, "ufoExperiences", ()=>$46c89ec479060c0c$export$615f888019c45765);
    $parcel$export(module.exports, "sampledUfoRenderedEmoji", ()=>$46c89ec479060c0c$export$71c8cba6f1251ea9);
    $parcel$export(module.exports, "hasUfoMarked", ()=>$46c89ec479060c0c$export$a9be054d2a5cedc0);
    $parcel$export(module.exports, "sampledUfoEmojiResourceFetched", ()=>$46c89ec479060c0c$export$1466212a1606133);
    var $8JfNZ;
    var $ghebK;
    var $aqOqs;
    var $2XSyz;
    var $3nDha;
    const $46c89ec479060c0c$var$createRenderExperience = (componentName)=>{
        return {
            platform: {
                component: componentName
            },
            type: (0, (0, parcelRequire("aqOqs")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).PageSegmentLoad
        };
    };
    const $46c89ec479060c0c$var$createInlineExperience = (componentName)=>{
        return {
            platform: {
                component: componentName
            },
            type: (0, (0, parcelRequire("aqOqs")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).InlineResult
        };
    };
    const $46c89ec479060c0c$var$customEmojiTimings = [
        {
            key: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimingsKeys).FMP,
            endMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).FMP_END
        },
        {
            key: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimingsKeys).METADATA,
            component: 'resourced-emoji',
            startMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).METADATA_START,
            endMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).METADATA_END
        },
        {
            key: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimingsKeys).MEDIADATA,
            component: 'caching-emoji',
            startMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).MEDIA_START,
            endMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).MEDIA_END
        },
        {
            key: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimingsKeys).MOUNTED,
            component: 'emoji',
            endMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).MOUNTED_END
        },
        {
            key: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimingsKeys).ONLOAD,
            startMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).ONLOAD_START,
            endMark: (0, (0, parcelRequire("8JfNZ")).UfoEmojiTimings).ONLOAD_END
        }
    ];
    const $46c89ec479060c0c$export$615f888019c45765 = {
        'emoji-rendered': new (0, (0, parcelRequire("ghebK")).ConcurrentExperience)((0, (0, parcelRequire("8JfNZ")).UfoExperienceName).EMOJI_RENDERED, {
            platform: {
                component: (0, (0, parcelRequire("8JfNZ")).UfoComponentName).EMOJI
            },
            type: (0, (0, parcelRequire("aqOqs")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).Custom,
            timings: $46c89ec479060c0c$var$customEmojiTimings
        }),
        'emoji-resource-fetched': new (0, (0, parcelRequire("ghebK")).ConcurrentExperience)((0, (0, parcelRequire("8JfNZ")).UfoExperienceName).EMOJI_RESOURCE_FETCHED, $46c89ec479060c0c$var$createRenderExperience((0, (0, parcelRequire("8JfNZ")).UfoComponentName).EMOJI_PROVIDER)),
        'emoji-picker-opened': new (0, (0, parcelRequire("2XSyz")).UFOExperience)((0, (0, parcelRequire("8JfNZ")).UfoExperienceName).EMOJI_PICKER_OPENED, $46c89ec479060c0c$var$createRenderExperience((0, (0, parcelRequire("8JfNZ")).UfoComponentName).EMOJI_PICKER)),
        'emoji-selection-recorded': new (0, (0, parcelRequire("2XSyz")).UFOExperience)((0, (0, parcelRequire("8JfNZ")).UfoExperienceName).EMOJI_SELECTION_RECORDED, $46c89ec479060c0c$var$createInlineExperience((0, (0, parcelRequire("8JfNZ")).UfoComponentName).EMOJI_PROVIDER)),
        'emoji-uploaded': new (0, (0, parcelRequire("2XSyz")).UFOExperience)((0, (0, parcelRequire("8JfNZ")).UfoExperienceName).EMOJI_UPLOADED, $46c89ec479060c0c$var$createInlineExperience((0, (0, parcelRequire("8JfNZ")).UfoComponentName).EMOJI_PICKER)),
        'emoji-searched': new (0, (0, parcelRequire("2XSyz")).UFOExperience)((0, (0, parcelRequire("8JfNZ")).UfoExperienceName).EMOJI_SEARCHED, $46c89ec479060c0c$var$createInlineExperience((0, (0, parcelRequire("8JfNZ")).UfoComponentName).EMOJI_PICKER))
    };
    const $46c89ec479060c0c$export$71c8cba6f1251ea9 = (emojiId)=>{
        return (0, (0, parcelRequire("3nDha")).withSampling)($46c89ec479060c0c$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
    };
    const $46c89ec479060c0c$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
        return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
    };
    const $46c89ec479060c0c$export$1466212a1606133 = (providerType)=>{
        return (0, (0, parcelRequire("3nDha")).withSampling)($46c89ec479060c0c$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
    };
});
parcelRegister("ghebK", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentExperience", ()=>$91cf7438378a96e0$export$ac1cddfee07ba6ac);
    var $62fYQ;
    var $2XSyz;
    class $91cf7438378a96e0$export$ac1cddfee07ba6ac {
        constructor(experienceId, config){
            this.instances = {};
            this.experienceId = experienceId;
            this.config = config;
        }
        getInstance(instanceId) {
            if (!this.instances[instanceId]) this.instances[instanceId] = new (0, (0, parcelRequire("2XSyz")).UFOExperience)(this.experienceId, this.config, instanceId);
            return this.instances[instanceId];
        }
        release(instanceId) {
            (0, (0, parcelRequire("62fYQ")).ufolog)('instanceId', instanceId);
            if (this.instances[instanceId]) this.instances[instanceId].abort();
            delete this.instances[instanceId];
        }
    }
});
parcelRegister("62fYQ", function(module, exports) {
    $parcel$export(module.exports, "ufolog", ()=>$4bc0c63af293ed27$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$4bc0c63af293ed27$export$d53d07b6034c4560);
    class $4bc0c63af293ed27$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($4bc0c63af293ed27$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($4bc0c63af293ed27$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $4bc0c63af293ed27$export$4ab84f6f04f6566d = new $4bc0c63af293ed27$var$UFOLogger();
    const $4bc0c63af293ed27$export$b4958caff08a0960 = (...args)=>{
        $4bc0c63af293ed27$export$4ab84f6f04f6566d.log(...args);
    };
    const $4bc0c63af293ed27$export$d53d07b6034c4560 = (...args)=>{
        $4bc0c63af293ed27$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("2XSyz", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$26d4e73aef5b14f5$export$c00d22927c60484a);
    var $2IxOa;
    class $26d4e73aef5b14f5$export$c00d22927c60484a extends (0, (0, parcelRequire("2IxOa")).UFOAbstractExperience) {
    }
});
parcelRegister("2IxOa", function(module, exports) {
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$bfa3c9fc4d93bda0$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $acZ3D;
    var $62fYQ;
    var $d7Kov;
    var $aSsb2;
    var $ig4s7;
    var $jYF4K;
    var $96hPo;
    var $9H7ZW;
    var $aqOqs;
    const $bfa3c9fc4d93bda0$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("jYF4K")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("aSsb2")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("aSsb2")).PageVisibleState).HIDDEN;
    };
    const $bfa3c9fc4d93bda0$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("ig4s7")).roundPerfNow)();
    };
    class $bfa3c9fc4d93bda0$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("96hPo")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("aSsb2")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("d7Kov")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $bfa3c9fc4d93bda0$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("62fYQ")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("9H7ZW")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("62fYQ")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $bfa3c9fc4d93bda0$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $bfa3c9fc4d93bda0$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("acZ3D")).getGlobalEventStream)().push((0, (0, parcelRequire("acZ3D")).unsubscribeEvent)((0, (0, parcelRequire("aSsb2")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("62fYQ")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("acZ3D")).getGlobalEventStream)().push((0, (0, parcelRequire("acZ3D")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("62fYQ")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("62fYQ")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $bfa3c9fc4d93bda0$var$getPageVisibleState();
                (0, (0, parcelRequire("d7Kov")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("62fYQ")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("acZ3D")).getGlobalEventStream)().push((0, (0, parcelRequire("acZ3D")).subscribeEvent)((0, (0, parcelRequire("aSsb2")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("aSsb2")).FMP_MARK) && name !== (0, (0, parcelRequire("aSsb2")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("62fYQ")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $bfa3c9fc4d93bda0$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("96hPo")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("aSsb2")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("aSsb2")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("62fYQ")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("d7Kov")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("62fYQ")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $1eb7c4a30cbc58af$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $1eb7c4a30cbc58af$export$2295b861f318254a = '0.1.5';
parcelRegister("acZ3D", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$0633ff94b27ae7b4$export$6123a44dc2384540);
    $parcel$export(module.exports, "subscribeEvent", ()=>$0633ff94b27ae7b4$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$0633ff94b27ae7b4$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$0633ff94b27ae7b4$export$7c957416596ca127);
    var $62fYQ;
    var $aSsb2;
    const $0633ff94b27ae7b4$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $0633ff94b27ae7b4$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $0633ff94b27ae7b4$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $0633ff94b27ae7b4$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("62fYQ")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $0633ff94b27ae7b4$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("aSsb2")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $0633ff94b27ae7b4$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("aSsb2")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $0633ff94b27ae7b4$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("aSsb2")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("aSsb2", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$41a85b2e81c8c4f3$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$41a85b2e81c8c4f3$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$41a85b2e81c8c4f3$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$41a85b2e81c8c4f3$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$41a85b2e81c8c4f3$export$837e0f79a8056912);
    var $41a85b2e81c8c4f3$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($41a85b2e81c8c4f3$export$96253c35c37cf96b || ($41a85b2e81c8c4f3$export$96253c35c37cf96b = {}));
    var $41a85b2e81c8c4f3$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($41a85b2e81c8c4f3$export$a12c67b37a306b13 || ($41a85b2e81c8c4f3$export$a12c67b37a306b13 = {}));
    var $41a85b2e81c8c4f3$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($41a85b2e81c8c4f3$export$66b33c055cbb625e || ($41a85b2e81c8c4f3$export$66b33c055cbb625e = {}));
    var $41a85b2e81c8c4f3$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($41a85b2e81c8c4f3$export$3ce489cbe02dc21b || ($41a85b2e81c8c4f3$export$3ce489cbe02dc21b = {}));
    var $41a85b2e81c8c4f3$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($41a85b2e81c8c4f3$export$341b330828bd3906 || ($41a85b2e81c8c4f3$export$341b330828bd3906 = {}));
    var $41a85b2e81c8c4f3$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($41a85b2e81c8c4f3$export$b9b20160f581e4f8 || ($41a85b2e81c8c4f3$export$b9b20160f581e4f8 = {}));
    const $41a85b2e81c8c4f3$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $41a85b2e81c8c4f3$export$9f2bf58999404c75 = 'fmp';
    const $41a85b2e81c8c4f3$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("d7Kov", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$21d3f4c31012d0de$export$13e680397ec8f3eb);
    var $jYF4K;
    class $21d3f4c31012d0de$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("jYF4K")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $21d3f4c31012d0de$export$13e680397ec8f3eb = new $21d3f4c31012d0de$var$VisibilityChangeObserver();
});
parcelRegister("jYF4K", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$09163a75f4be6221$export$15e172712955e18f);
    const $09163a75f4be6221$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("ig4s7", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$7501739250682377$export$5f490af6b2b115cf);
    const $7501739250682377$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("96hPo", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$73905af5f1478b41$export$81b70111112841a0);
    const $73905af5f1478b41$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("9H7ZW", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$1e0dd223ad1dc9f0$export$178881f329fdb81f);
    var $96hPo;
    const $1e0dd223ad1dc9f0$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("96hPo")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id
        ]
    };
    const $1e0dd223ad1dc9f0$export$178881f329fdb81f = (state1, state2)=>{
        return $1e0dd223ad1dc9f0$var$UFOStateAvailableTransitions[state1.id] && $1e0dd223ad1dc9f0$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("aqOqs", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$3d61aacd9c2d5148$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$3d61aacd9c2d5148$export$cc26007c03242fff);
    var $3d61aacd9c2d5148$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($3d61aacd9c2d5148$export$994164cf3ae1cc9a || ($3d61aacd9c2d5148$export$994164cf3ae1cc9a = {}));
    var $3d61aacd9c2d5148$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($3d61aacd9c2d5148$export$cc26007c03242fff || ($3d61aacd9c2d5148$export$cc26007c03242fff = {}));
});
parcelRegister("3nDha", function(module, exports) {
    $parcel$export(module.exports, "withSampling", ()=>$942d2ba87b34daa5$export$dc2f0946255b3f89);
    const $942d2ba87b34daa5$export$c7c4959fece2f3ec = {};
    const $942d2ba87b34daa5$export$cdff9a865136ae27 = ()=>{
        for (const prop of Object.getOwnPropertyNames($942d2ba87b34daa5$export$c7c4959fece2f3ec))delete $942d2ba87b34daa5$export$c7c4959fece2f3ec[prop];
    };
    const $942d2ba87b34daa5$export$1c967630b3ea2d58 = (rate)=>{
        if (rate === 1) return true;
        if (rate === 0) return false;
        return Math.random() * rate <= 1;
    };
    const $942d2ba87b34daa5$var$hasSampledFromStart = (experience)=>{
        if (!$942d2ba87b34daa5$export$c7c4959fece2f3ec[experience.id]) return false;
        if (experience.instanceId) return $942d2ba87b34daa5$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
        return $942d2ba87b34daa5$export$c7c4959fece2f3ec[experience.id].sampled;
    };
    const $942d2ba87b34daa5$export$dc2f0946255b3f89 = (ufoExperience)=>{
        const init = ()=>{
            if (!$942d2ba87b34daa5$export$c7c4959fece2f3ec[ufoExperience.id]) $942d2ba87b34daa5$export$c7c4959fece2f3ec[ufoExperience.id] = {
                sampled: false,
                sampledInstance: {}
            };
        };
        const start = async (options)=>{
            if ($942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return;
            const isSampled = options.samplingFunc || $942d2ba87b34daa5$export$1c967630b3ea2d58;
            if (!isSampled(options.samplingRate)) {
                if (ufoExperience.instanceId) $942d2ba87b34daa5$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
                $942d2ba87b34daa5$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
                return;
            }
            if (ufoExperience.instanceId) {
                $942d2ba87b34daa5$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
                $942d2ba87b34daa5$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
            }
            return ufoExperience.start(options.startTime);
        };
        const success = async (config)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.success(config);
        };
        const failure = async (config)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.failure(config);
        };
        const abort = async (config)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.abort(config);
        };
        const addMetadata = (data)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.addMetadata(data);
        };
        const mark = (name, timestamp)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.mark(name, timestamp);
        };
        const markFMP = (timestamp)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.markFMP(timestamp);
        };
        const markInlineResponse = (timestamp)=>{
            if (!$942d2ba87b34daa5$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.markInlineResponse(timestamp);
        };
        init();
        return {
            ...ufoExperience,
            start: start,
            addMetadata: addMetadata,
            success: success,
            failure: failure,
            abort: abort,
            mark: mark,
            markFMP: markFMP,
            markInlineResponse: markInlineResponse
        };
    };
});
parcelRegister("9CGZY", function(module, exports) {
    $parcel$export(module.exports, "EMOJI_SERVICEID", ()=>$2d9090d159781c68$export$f3c4ed49c0fff3de);
    $parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", ()=>$2d9090d159781c68$export$f8b39b441e3e8eb2);
    $parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", ()=>$2d9090d159781c68$export$2cdcb9248b6d4704);
    $parcel$export(module.exports, "getServiceProvider", ()=>$2d9090d159781c68$export$a4c27db78169052e);
    $parcel$export(module.exports, "default", ()=>$2d9090d159781c68$export$2e2bcd8739ae039);
    var $j8DrX;
    const $2d9090d159781c68$var$providersRepository = {};
    const $2d9090d159781c68$export$f3c4ed49c0fff3de = 'emoji';
    const $2d9090d159781c68$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
    const $2d9090d159781c68$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
    const $2d9090d159781c68$var$getServiceBaseUrl = (serviceId)=>{
        if (serviceId === $2d9090d159781c68$export$f8b39b441e3e8eb2 || serviceId === $2d9090d159781c68$export$2cdcb9248b6d4704) return (0, (0, parcelRequire("j8DrX")).default)('ajs-fabric-emoji-url');
        return (0, (0, parcelRequire("j8DrX")).default)(`ajs-fabric-${serviceId}-url`);
    };
    const $2d9090d159781c68$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
        try {
            let serviceProvider = $2d9090d159781c68$var$providersRepository[serviceId];
            if (serviceProvider === undefined) {
                const serviceBaseUrl = $2d9090d159781c68$var$getServiceBaseUrl(serviceId);
                if (serviceBaseUrl) {
                    serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                    $2d9090d159781c68$var$providersRepository[serviceId] = serviceProvider;
                }
            }
            return serviceProvider;
        } catch (e) {
            return null;
        }
    };
    const $2d9090d159781c68$export$59790759c19337ec = ()=>{
        Object.keys($2d9090d159781c68$var$providersRepository).forEach((key)=>{
            delete $2d9090d159781c68$var$providersRepository[key];
        });
    };
    var $2d9090d159781c68$export$2e2bcd8739ae039 = $2d9090d159781c68$var$getServiceBaseUrl;
});
parcelRegister("6a30R", function(module, exports) {
    $parcel$export(module.exports, "isExternalLink", ()=>$97cd92cd81dfd9ff$export$b98882f166bb7ce2);
    $parcel$export(module.exports, "onLinkClick", ()=>$97cd92cd81dfd9ff$export$dccc97e4cadc9724);
    $parcel$export(module.exports, "smartLinksDefault", ()=>$97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
    $parcel$export(module.exports, "useSmartCardProductType", ()=>$97cd92cd81dfd9ff$export$3f864e37674c79e7);
    $parcel$export(module.exports, "useSmartCardIsAIEnabled", ()=>$97cd92cd81dfd9ff$export$af081b1242bfa300);
    $parcel$export(module.exports, "SmartCardProviderWithAIHooks", ()=>$97cd92cd81dfd9ff$export$ca9fa6647337e334);
    var $5uXOq = parcelRequire("5uXOq");
    var $lTi0t;
    var $crcF9;
    var $2vSU6;
    var $2gCtH;
    var $iixvy;
    var $93Yeu;
    const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
    const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
    const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
    const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
        try {
            const { hostname: hostname, pathname: pathname } = new URL(url);
            return (hostname !== window.location.hostname || ![
                '/jira',
                '/browse'
            ].some((includedPath)=>pathname.startsWith(includedPath)));
        } catch (err) {
            return true;
        }
    };
    const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
        if (!url) return;
        if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
            event.preventDefault();
            window.open(url, '_blank', 'noopener,noreferrer');
            return;
        }
        if (event.defaultPrevented) {
            const mouseEvent = event;
            $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
        }
    };
    const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
        actionOptions: {
            hide: false,
            exclude: [
                (0, (0, parcelRequire("crcF9")).CardAction).ChangeStatusAction
            ]
        }
    };
    const $97cd92cd81dfd9ff$export$4761115a9e18aa47 = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 'JWM';
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return 'JSW';
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 'JSM';
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return 'JPD';
            default:
                return undefined;
        }
    };
    const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        const product = (0, $5uXOq.useMemo)(()=>$97cd92cd81dfd9ff$export$4761115a9e18aa47(projectType) ?? 'JSW', [
            projectType
        ]);
        return product;
    };
    const $97cd92cd81dfd9ff$export$af081b1242bfa300 = ()=>{
        const isAiOptInEnabled = (0, (0, parcelRequire("2gCtH")).useIsAiOptInEnabled)();
        const isPremium = (0, (0, parcelRequire("iixvy")).useIsPremium)();
        const isAIFeatureEnabled = (0, $5uXOq.useMemo)(()=>isAiOptInEnabled && isPremium, [
            isAiOptInEnabled,
            isPremium
        ]);
        return isAIFeatureEnabled;
    };
    const $97cd92cd81dfd9ff$export$ca9fa6647337e334 = (props)=>{
        const product = $97cd92cd81dfd9ff$export$3f864e37674c79e7();
        const isAIEnabled = $97cd92cd81dfd9ff$export$af081b1242bfa300();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lTi0t")).SmartCardProvider), {
            product: product,
            isAdminHubAIEnabled: isAIEnabled,
            ...props
        }, props.children);
    };
});
parcelRegister("lTi0t", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$b98bbeb25e1d2548$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $eD0Al;
    var $fEYrk;
    var $7xZkH;
    var $dDG3T;
    var $DBP6E;
    function $b98bbeb25e1d2548$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("dDG3T")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("7xZkH")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("DBP6E")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("eD0Al")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("fEYrk")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDG3T")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $b98bbeb25e1d2548$export$2e2bcd8739ae039 = $b98bbeb25e1d2548$export$497ecb0280204df4;
});
parcelRegister("eD0Al", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$591919e0b0c46c76$export$94df0e59ebebf4a7);
    const $591919e0b0c46c76$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("fEYrk", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$4aa123338f5ff5a5$export$4b0d98b1b7f6d115);
    var $9VtNq;
    var $h629g;
    const $4aa123338f5ff5a5$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("9VtNq")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("h629g")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("h629g")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("9VtNq", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$6fc6b1875aad7076$export$3e8ad908070b68b2);
    const $6fc6b1875aad7076$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("h629g", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$6d7121f90416f5a9$export$396ba4ef2e37dc65);
    const $6d7121f90416f5a9$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $6d7121f90416f5a9$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("7xZkH", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$e703612c84199f48$export$3c7c3113a97b6492);
    var $HLU9D;
    var $cLTKl;
    const $e703612c84199f48$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("HLU9D")).ACTION_PENDING),
            (0, (0, parcelRequire("HLU9D")).ACTION_RESOLVING),
            (0, (0, parcelRequire("HLU9D")).ACTION_RESOLVED),
            (0, (0, parcelRequire("HLU9D")).ACTION_RELOADING),
            (0, (0, parcelRequire("HLU9D")).ACTION_ERROR),
            (0, (0, parcelRequire("HLU9D")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("HLU9D")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $e703612c84199f48$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("cLTKl")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $e703612c84199f48$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("HLU9D")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("HLU9D")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("HLU9D")).ACTION_RESOLVED:
                return $e703612c84199f48$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("HLU9D")).ACTION_RELOADING:
                return $e703612c84199f48$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("HLU9D")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("HLU9D")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("HLU9D")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $e703612c84199f48$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$e703612c84199f48$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $e703612c84199f48$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("HLU9D", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$c71a7100f488cb42$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$c71a7100f488cb42$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$c71a7100f488cb42$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$c71a7100f488cb42$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$c71a7100f488cb42$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$c71a7100f488cb42$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$c71a7100f488cb42$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$c71a7100f488cb42$export$a884a52152489cc3);
    const $c71a7100f488cb42$export$6e470aad5ba8952e = 'pending';
    const $c71a7100f488cb42$export$9a6a932a0a39498e = 'resolving';
    const $c71a7100f488cb42$export$63ec8bc7a8a75482 = 'resolved';
    const $c71a7100f488cb42$export$b8cfaa842c9ab487 = 'reloading';
    const $c71a7100f488cb42$export$6d8ed3f9433dd372 = 'errored';
    const $c71a7100f488cb42$export$cfbbb7126bc8a0c6 = 'fallback';
    const $c71a7100f488cb42$export$76b5c1aca20759c6 = 'preload';
    const $c71a7100f488cb42$export$2c5edb971b673330 = 'metadata';
    const $c71a7100f488cb42$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("cLTKl", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5d9ddfe26a176336$export$b70265791d2079d4);
    const $5d9ddfe26a176336$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5d9ddfe26a176336$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5d9ddfe26a176336$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("dDG3T", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$407057f5694379a8$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$407057f5694379a8$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $407057f5694379a8$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $407057f5694379a8$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($407057f5694379a8$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $407057f5694379a8$export$2e2bcd8739ae039 = $407057f5694379a8$export$156b523e63b4f63a;
});
parcelRegister("DBP6E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd0f7d9aefa9b8e1$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $265IE;
    var $kJiWm;
    var $cLTKl;
    var $jARdT;
    var $bj8PR;
    var $iwKVT = parcelRequire("iwKVT");
    const $cd0f7d9aefa9b8e1$var$MAX_BATCH_SIZE = 50;
    const $cd0f7d9aefa9b8e1$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $cd0f7d9aefa9b8e1$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $cd0f7d9aefa9b8e1$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($cd0f7d9aefa9b8e1$var$URL_RESPONSE_CACHE_SIZE);
    class $cd0f7d9aefa9b8e1$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("jARdT")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("jARdT")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("bj8PR")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("kJiWm")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $cd0f7d9aefa9b8e1$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $cd0f7d9aefa9b8e1$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $cd0f7d9aefa9b8e1$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $cd0f7d9aefa9b8e1$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $cd0f7d9aefa9b8e1$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("bj8PR")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("cLTKl")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $cd0f7d9aefa9b8e1$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("bj8PR")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("bj8PR")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("bj8PR")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("bj8PR")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("jARdT")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("jARdT")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("bj8PR")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("jARdT")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("jARdT")).NetworkError)) return new (0, (0, parcelRequire("265IE")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("265IE")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("265IE")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("265IE")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("265IE")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("265IE")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("265IE", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$a580ab942880deaa$export$3e5b797e39668f84);
    class $a580ab942880deaa$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`);
            this.kind = kind;
            this.hostname = hostname;
            this.message = message;
            this.type = type;
            this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("kJiWm", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$7f31bbba243f08b7$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$7f31bbba243f08b7$export$dc37652c1696f231);
    const $7f31bbba243f08b7$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $7f31bbba243f08b7$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $7f31bbba243f08b7$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $7f31bbba243f08b7$export$e2b040f052407032 = {
        dev: $7f31bbba243f08b7$var$devBaseUrl,
        development: $7f31bbba243f08b7$var$devBaseUrl,
        stg: $7f31bbba243f08b7$var$stgBaseUrl,
        staging: $7f31bbba243f08b7$var$stgBaseUrl,
        prd: $7f31bbba243f08b7$var$prodBaseUrl,
        prod: $7f31bbba243f08b7$var$prodBaseUrl,
        production: $7f31bbba243f08b7$var$prodBaseUrl
    };
    const $7f31bbba243f08b7$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $7f31bbba243f08b7$export$e2b040f052407032 ? $7f31bbba243f08b7$export$e2b040f052407032[envKey] : $7f31bbba243f08b7$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $7f31bbba243f08b7$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $7f31bbba243f08b7$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $7f31bbba243f08b7$export$2e2bcd8739ae039 = $7f31bbba243f08b7$export$e2b040f052407032;
});
parcelRegister("jARdT", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$acbfa85cf80652fd$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$acbfa85cf80652fd$export$b5fe3f66a567bec0);
    const $acbfa85cf80652fd$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $acbfa85cf80652fd$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $acbfa85cf80652fd$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $acbfa85cf80652fd$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $acbfa85cf80652fd$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("bj8PR", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$3006a5067ce3a8a9$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$3006a5067ce3a8a9$export$bea7bee8a87e7c52);
    const $3006a5067ce3a8a9$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $3006a5067ce3a8a9$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("crcF9", function(module, exports) {
    $parcel$export(module.exports, "CardAction", ()=>$04fb30ed27a0dfb9$export$f40b7e0b762b928b);
    var $04fb30ed27a0dfb9$export$f40b7e0b762b928b;
    (function(CardAction) {
        CardAction["DownloadAction"] = "DownloadAction";
        CardAction["PreviewAction"] = "PreviewAction";
        CardAction["ViewAction"] = "ViewAction";
        CardAction["ChangeStatusAction"] = "ChangeStatusAction";
        CardAction["FollowAction"] = "FollowAction";
        CardAction["CopyLinkAction"] = "CopyLinkAction";
        CardAction["AISummaryAction"] = "AISummaryAction";
        CardAction["AutomationAction"] = "AutomationAction";
    })($04fb30ed27a0dfb9$export$f40b7e0b762b928b || ($04fb30ed27a0dfb9$export$f40b7e0b762b928b = {}));
});
parcelRegister("iixvy", function(module, exports) {
    $parcel$export(module.exports, "useIsPremium", ()=>$545133d1825caa45$export$1bb5840a003dc643);
    $parcel$export(module.exports, "useCanOptIn", ()=>$545133d1825caa45$export$bd66bcf1f00b19d2);
    $parcel$export(module.exports, "useOptInStatus", ()=>$545133d1825caa45$export$5e56b08674e48311);
    $parcel$export(module.exports, "useAIOptIn", ()=>$545133d1825caa45$export$49e57b9044cda91c);
    var $5uXOq = parcelRequire("5uXOq");
    var $escc7;
    var $hnsNR;
    var $2vSU6;
    var $6s1PB;
    var $4R6GH;
    var $2gCtH;
    var $5NH95;
    var $93Yeu;
    var $14XJw;
    var $ldyPw;
    var $k9JTq;
    var $cNd4s;
    var $ljlOe;
    var $44KLa;
    const $545133d1825caa45$var$DISABLED = 'disabled';
    const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
    const $545133d1825caa45$var$ENABLED = 'enabled';
    const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        if (!appEditions) return false;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
            default:
                return false;
        }
    };
    const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        if (!appEditions) return false;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return appEditions.core === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return appEditions.software === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            default:
                return false;
        }
    };
    const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
        const isSupportedENV = (0, (0, parcelRequire("4R6GH")).fg)('jira_jet_admin_config_ai_upsell_isfedramp_check') ? !(0, (0, parcelRequire("hnsNR")).isFedRamp)() : true;
        return isOrgAdmin && isPremium && isSupportedENV;
    };
    const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
        const isSupportedENV = (0, (0, parcelRequire("4R6GH")).fg)('jira_jet_admin_config_ai_upsell_isfedramp_check') ? !(0, (0, parcelRequire("hnsNR")).isFedRamp)() : true;
        return isOrgAdmin && isStandard && isSupportedENV;
    };
    const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
        const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
        const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
        if ((0, (0, parcelRequire("hnsNR")).isFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_jet_admin_config_ai_upsell_isfedramp_check')) return $545133d1825caa45$var$DISABLED;
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { experimentValue: aiUpsellInEditorEnabled } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorRequirements)(product) : {
            experimentValue: false
        };
        if (aiUpsellInEditorEnabled) return $545133d1825caa45$var$DISABLED_OPT_IN;
        const isValidForGlobalOptIn = [
            product !== 'JPD',
            canOptIn
        ].every((condition)=>condition === true);
        const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
        const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
        return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
    };
    const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
        const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
        const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
        const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorFree)(optInStatus, product) : {
            isExperimentEnabled: false,
            triggerUpsellFlow: ()=>{},
            UpsellModal: null
        };
        const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
            setShowOptInModal(true);
        }, [
            setShowOptInModal
        ]);
        const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
            setShowPremiumTrialModal(true);
        }, [
            setShowPremiumTrialModal
        ]);
        const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
            const onCloseModal = ()=>setShowOptInModal(false);
            const adminLink = `${(0, (0, parcelRequire("escc7")).getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44KLa")).OptInModal), {
                showOptInModal: showOptInModal,
                isOrgAdmin: isOrgAdmin,
                onCloseModal: onCloseModal,
                adminLink: adminLink
            });
        }, [
            orgId,
            isOrgAdmin,
            showOptInModal
        ]);
        const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
            const onCloseModal = ()=>setShowPremiumTrialModal(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44KLa")).OptInUpsellModal), {
                "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
                showPremiumTrialModal: showPremiumTrialModal,
                onCloseModal: onCloseModal
            }));
        }, [
            showPremiumTrialModal
        ]);
        if ((0, (0, parcelRequire("hnsNR")).isFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_jet_admin_config_ai_upsell_isfedramp_check')) return {
            optInStatus: $545133d1825caa45$var$DISABLED,
            triggerOptInFlow: ()=>{},
            AIOptInModal: null
        };
        if (isAIUpsellInEditorFreeEnabled) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
            AIOptInModal: AIUpsellInEditorFreeModal
        };
        if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerOptInFlow,
            AIOptInModal: null
        };
        if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerUpsellFlow,
            AIOptInModal: aiUpsellModal
        };
        return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerOptInFlow,
            AIOptInModal: aiOptInModal
        };
    };
});
parcelRegister("5NH95", function(module, exports) {
    $parcel$export(module.exports, "useAIUpsellInEditorRequirements", ()=>$26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
    $parcel$export(module.exports, "useAIUpsellInEditorFree", ()=>$26b3b3762ac33b52$export$beacfd188d344f95);
    $parcel$export(module.exports, "AIUpsellButtonWrapper", ()=>$26b3b3762ac33b52$export$c44b9b0347b51c37);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hnsNR;
    var $2vSU6;
    var $6s1PB;
    var $fmQtB;
    var $8zOmE;
    var $lwMsT;
    var $ldyPw;
    var $k9JTq;
    var $cNd4s;
    var $7xCut;
    const { fireEventOnce: $26b3b3762ac33b52$var$fireEventOnce } = (()=>{
        let hasFired = false;
        return {
            fireEventOnce: (fireFunction)=>{
                if (!hasFired) {
                    fireFunction();
                    hasFired = true;
                }
            }
        };
    })();
    const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
        switch(product){
            case 'JSW':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'JSM':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'JWM':
            case 'JPD':
            default:
                return undefined;
        }
    };
    const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
        if (!appEditions) return undefined;
        if (projectType) return (0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions);
        return undefined;
    };
    const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [config, fireExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const statsigExperimentValue = config.get('experimentEnabled', undefined);
        const siteMeetsRequirements = $26b3b3762ac33b52$var$useGetSupportedEdition(product) === (0, (0, parcelRequire("ldyPw")).FREE_EDITION) && isOrgAdmin && !(0, (0, parcelRequire("hnsNR")).isFedRamp)() && typeof statsigExperimentValue === 'boolean';
        const experimentValue = siteMeetsRequirements ? statsigExperimentValue : undefined;
        const fireExposure = (0, $5uXOq.useCallback)(()=>{
            fireExperimentExposure();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'experiment exposed', {
                experimentKey: 'aiUpsellInEditorFree',
                isEligible: siteMeetsRequirements,
                cohort: experimentValue
            });
        }, [
            createAnalyticsEvent,
            experimentValue,
            fireExperimentExposure,
            siteMeetsRequirements
        ]);
        return {
            siteMeetsRequirements: siteMeetsRequirements,
            experimentValue: experimentValue,
            statsigExperimentValue: statsigExperimentValue,
            fireExperimentExposure: fireExposure
        };
    };
    const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
        const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
        const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
        const siteMeetsOptInRequirements = siteMeetsRequirements && optInStatus !== 'enabled';
        const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : undefined;
        const isEnrolledInExperiment = typeof experimentValue === 'boolean';
        const isExperimentEnabled = isEnrolledInExperiment && experimentValue;
        const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'triggerUpsellFlow',
                actionSubject: 'aiUpsellInEditorFree'
            }), 'aiUpsellInEditorFreeTrigger', {});
            setShowUpsellModal(true);
            (0, (0, parcelRequire("7xCut")).setUpsellButtonWrapperClicked)(true);
        }, [
            createAnalyticsEvent
        ]);
        const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fmQtB")).AsyncAiUpsellInEditorFreeModal), {
                projectType: projectType,
                testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
                onModalClose: ()=>setShowUpsellModal(false)
            }) : null, [
            showUpsellModal,
            projectType
        ]);
        return {
            isEnrolledInExperiment: isEnrolledInExperiment,
            isExperimentEnabled: isExperimentEnabled,
            fireExperimentExposure: fireExperimentExposure,
            triggerUpsellFlow: triggerUpsellFlow,
            UpsellModal: UpsellModal
        };
    };
    const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const isClicked = (0, (0, parcelRequire("7xCut")).getUpsellButtonWrapperClicked)();
        (0, $5uXOq.useEffect)(()=>{
            $26b3b3762ac33b52$var$fireEventOnce(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {}));
        }, [
            createAnalyticsEvent
        ]);
        return !isClicked ? (0, ($parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
            "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $26b3b3762ac33b52$var$AIUpsellButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $26b3b3762ac33b52$var$AIUpsellButtonInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fmQtB", function(module, exports) {
    $parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", ()=>$2c23576aa5eb8dba$export$827041a383456a6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $1jUsD;
    const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("6zDy2")), {
        ssr: false,
        moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
    });
    const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "asyncAiUpsellInEditorFreeModal",
            packageName: "jira-growth-ai-upsell-in-editor-free-modal",
            teamName: "growth-tako",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));
});
parcelRegister("6zDy2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bQd01")
    ]).then(()=>parcelRequire('b738i'));
});
parcelRegister("7xCut", function(module, exports) {
    $parcel$export(module.exports, "getUpsellButtonWrapperClicked", ()=>$b8d3bd23ca283e73$export$f7d51ee95145148b);
    $parcel$export(module.exports, "setUpsellButtonWrapperClicked", ()=>$b8d3bd23ca283e73$export$b595420beb43f9ce);
    var $bSSG7;
    const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('ai-upsell-in-editor-free');
    function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
        return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
    }
    function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
        $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
    }
});
parcelRegister("ljlOe", function(module, exports) {
    $parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", ()=>$82777381236a0306$export$77aa5ca661b0742c);
    $parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", ()=>$82777381236a0306$export$dd0a751f23b19473);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mO32;
    var $l37qh;
    var $b3Gth;
    const $82777381236a0306$export$77aa5ca661b0742c = (0, (0, parcelRequire("l37qh")).createUseEntryPointContext)();
    const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
        const entryPointParams = {};
        const entryPointResult = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("b3Gth")).entryPointPremiumUpgradeModal), entryPointParams);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
            value: entryPointResult
        }, children);
    };
});
parcelRegister("l37qh", function(module, exports) {
    $parcel$export(module.exports, "createUseEntryPointContext", ()=>$6e7e19c2d291c94c$export$41bce2223126846b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>(0, $5uXOq.createContext)({
            entryPointActions: {
                cancelPreload () {},
                load () {},
                preload () {},
                unload () {}
            },
            entryPointReferenceSubject: {
                getValue: ()=>null,
                subscribe: ()=>()=>{}
            },
            stopMetric () {}
        });
});
parcelRegister("b3Gth", function(module, exports) {
    $parcel$export(module.exports, "entryPointPremiumUpgradeModal", ()=>$a50fd4829307668f$export$7116d5b1a93db8d6);
    var $evanD;
    var $7KfpL;
    const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("paDrG")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
            moduleId: "1102b440"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("paDrG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5azfZ")
    ]).then(()=>parcelRequire('5s8iH'));
});
parcelRegister("44KLa", function(module, exports) {
    $parcel$export(module.exports, "OptInModal", ()=>$bf7c19a18c627984$export$1697f043758ae8d2);
    $parcel$export(module.exports, "OptInUpsellModal", ()=>$bf7c19a18c627984$export$bbf8d259a508a485);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTmOP;
    var $4uJJm;
    var $5ChkL;
    var $7XluA;
    var $8zOmE;
    var $lwMsT;
    var $ljlOe;
    var $ejjdc;
    const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uJJm")).default), null, showOptInModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
            testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
            width: "fit-content",
            onClose: onCloseModal
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ChkL")).default), {
            source: "jira-editor",
            product: "jira",
            isOrgAdmin: isOrgAdmin,
            onAdminClose: onCloseModal,
            adminLink: adminLink
        })));
    const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>{
                    entryPointActions.unload();
                    const analyticsEvent = createAnalyticsEvent({
                        actionSubject: 'button',
                        action: 'clicked'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
                }
            }), [
            entryPointActions,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uJJm")).default), null, showPremiumTrialModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
            testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
            width: "fit-content",
            onClose: onCloseModal
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejjdc")).AIOptInPremiumUpsell), {
            onClose: onCloseModal
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
            packageName: "platform-react-hooks-use-ai-opt-in",
            runtimeProps: runtimeProps
        }));
    };
});
parcelRegister("5ChkL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce1528fc16a342a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lwMsT;
    var $42Si9;
    var $bjfoJ;
    var $6Ll2T;
    var $99gde;
    var $1TpH7 = parcelRequire("1TpH7");
    var $fC5Va;
    var $lCMFu;
    const $ce1528fc16a342a9$var$VisibleTextOrgAdminStyles = (0, (0, parcelRequire("99gde")).xcss)({
        color: 'color.text.subtlest',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $ce1528fc16a342a9$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onLearnMoreClicked = (e)=>{
            e.stopPropagation();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                    attributes: {
                        product: product,
                        isOrgAdmin: !!isOrgAdmin
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        const formatMessageValues = {
            a: (s)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: (0, $61036a3444e181fd$export$550fac1a4ec3d365),
                    target: "_blank",
                    onClick: onLearnMoreClicked
                }, s),
            br: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
        };
        const defaultHeader = formatMessage((0, (0, parcelRequire("fC5Va")).messages).aiOptInDialogHeaderText);
        const header = headerText ?? defaultHeader;
        const body = bodyText ?? formatMessage((0, (0, parcelRequire("fC5Va")).messages).aiOptInDialogBodyText, formatMessageValues);
        const orgAdminBody = adminBodyText ?? formatMessage((0, (0, parcelRequire("fC5Va")).messages).aiOptInDialogAdminBodyText, formatMessageValues);
        const orgAdminHeader = adminHeaderText ?? defaultHeader;
        (0, $5uXOq.useEffect)(()=>{
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                (0, ($parcel$interopDefault($1TpH7)))
            ]);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'aiGlobalOptInDialog',
                    attributes: {
                        source: source,
                        product: product,
                        isOrgAdmin: !!isOrgAdmin
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        }, [
            createAnalyticsEvent,
            source,
            product,
            isOrgAdmin
        ]);
        const onCloseClicked = (e)=>{
            e.stopPropagation();
            onAdminClose?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                    attributes: {
                        product: product
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        const onCTAClicked = (e)=>{
            e.stopPropagation();
            onAdminCTA?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                    attributes: {
                        product: product
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).OptInBackgroundBorder), {
            width: width,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).OptInContainer), null, image ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).ImageWrapper), null, image) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).ImageWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($1TpH7))),
            height: "96px",
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).ContentContainer), null, isOrgAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $ce1528fc16a342a9$var$VisibleTextOrgAdminStyles
        }, formatMessage((0, (0, parcelRequire("fC5Va")).messages).aiOptInAdminOnlyVisible)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).BodyWrapper), {
            "data-testid": "dialog-body-text"
        }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCMFu")).ButtonContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            appearance: "subtle",
            onClick: onCloseClicked,
            testId: "admin-close-button"
        }, adminCloseCTAText ?? formatMessage((0, (0, parcelRequire("fC5Va")).messages).aiOptInDialogAdminMaybeLaterButtonText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjfoJ")).default), {
            appearance: "primary",
            onClick: onCTAClicked,
            href: adminLink ?? (0, $61036a3444e181fd$export$bae9a077d7ed5dfe),
            target: "_blank",
            testId: "admin-cta-button"
        }, adminCTAText ?? formatMessage((0, (0, parcelRequire("fC5Va")).messages).aiOptInDialogAdminGetStartedButtonText))))));
    };
    var $ce1528fc16a342a9$export$2e2bcd8739ae039 = $ce1528fc16a342a9$var$AiOptIn;
});
parcelRegister("bjfoJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7588122d6645d5d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aPPLm;
    var $guTo4;
    const $f7588122d6645d5d$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("guTo4")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPPLm")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $f7588122d6645d5d$var$WithRef = (0, $5uXOq.forwardRef)($f7588122d6645d5d$var$LinkButtonBase);
    const $f7588122d6645d5d$var$LinkButton = (0, $5uXOq.memo)($f7588122d6645d5d$var$WithRef);
    var $f7588122d6645d5d$export$2e2bcd8739ae039 = $f7588122d6645d5d$var$LinkButton;
});
parcelRegister("1TpH7", function(module, exports) {
    module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();
});
const $61036a3444e181fd$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $61036a3444e181fd$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
parcelRegister("fC5Va", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$af49fc73f5dbf100$export$defe85febe8b728c);
    var $7VHMR;
    const $af49fc73f5dbf100$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aiOptInDialogHeaderText: {
            id: 'ai-opt-in.dialog.header.text',
            defaultMessage: 'Work smarter, not harder',
            description: 'Header text for AI Opt In Dialog'
        },
        aiOptInDialogBodyText: {
            id: 'ai-opt-in.dialog.body.text',
            defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
            description: 'Body text for AI Opt In Dialog'
        },
        aiOptInDialogLearnMoreLinkText: {
            id: 'ai-opt-in.dialog.learn-more.link.text',
            defaultMessage: 'Learn more about Atlassian Intelligence',
            description: 'Learn more link text for AI Opt In Dialog'
        },
        aiOptInDialogAdminBodyText: {
            id: 'ai-opt-in.dialog.admin.body.text',
            defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
            description: 'Body text for Admin version of AI Opt In Dialog'
        },
        aiOptInDialogAdminMaybeLaterButtonText: {
            id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
            defaultMessage: 'Maybe later',
            description: 'Admin maybe later button text'
        },
        aiOptInDialogAdminGetStartedButtonText: {
            id: 'ai-opt-in.dialog.admin.get-started.button.text',
            defaultMessage: 'Get started',
            description: 'Admin get started button text'
        },
        aiOptInBannerBodyText: {
            id: 'ai-opt-in.banner.body.text',
            defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
            description: 'Body text for Banner version of AI Opt In Dialog'
        },
        aiOptInBannerLearnMoreText: {
            id: 'ai-opt-in.banner.learn.more.text',
            defaultMessage: 'Learn more',
            description: 'Learn more text for Banner cta of AI Opt In Dialog'
        },
        aiOptInAdminBannerBodyText: {
            id: 'ai-opt-in.banner.admin.body.text',
            defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
            description: 'Body text for Admin version of the Banner Ai Opt In'
        },
        aiOptInAdminOnlyVisible: {
            id: 'ai-opt-in.admin.only.visible.text',
            defaultMessage: 'This message is only visible to org admins.',
            description: 'Text message to let org admins know that the content is only visible to them.'
        }
    });
});
parcelRegister("lCMFu", function(module, exports) {
    $parcel$export(module.exports, "OptInBackgroundBorder", ()=>$6c937858a0573144$export$24c280970213bb11);
    $parcel$export(module.exports, "OptInContainer", ()=>$6c937858a0573144$export$a0fab83bea8ccf2e);
    $parcel$export(module.exports, "ImageWrapper", ()=>$6c937858a0573144$export$75f07c36086c2c81);
    $parcel$export(module.exports, "ContentContainer", ()=>$6c937858a0573144$export$9d2b4227a95687cc);
    $parcel$export(module.exports, "HeaderWrapper", ()=>$6c937858a0573144$export$960a49cc3d27a090);
    $parcel$export(module.exports, "BodyWrapper", ()=>$6c937858a0573144$export$14966827497f4695);
    $parcel$export(module.exports, "ButtonContainer", ()=>$6c937858a0573144$export$eddf54ea3db8d0f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $6c937858a0573144$export$24c280970213bb11 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1vcp0mh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16qs1o46 _2rko14y2 _1yt4v77o _kqswh2mm _11q71lxv",
                __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
                __cmplp.className
            ])
        });
    });
    const $6c937858a0573144$export$a0fab83bea8ccf2e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
                __cmplp.className
            ])
        });
    });
    const $6c937858a0573144$export$75f07c36086c2c81 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a",
                __cmplp.className
            ])
        });
    });
    const $6c937858a0573144$export$9d2b4227a95687cc = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
    const $6c937858a0573144$export$960a49cc3d27a090 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81bk4",
                __cmplp.className
            ])
        });
    });
    const $6c937858a0573144$export$14966827497f4695 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81oud",
                __cmplp.className
            ])
        });
    });
    const $6c937858a0573144$export$eddf54ea3db8d0f0 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ejjdc", function(module, exports) {
    $parcel$export(module.exports, "AIOptInPremiumUpsell", ()=>$678322372bbc5cca$export$54e4ba490d2c6bb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $cZ1Pf;
    var $bciic;
    var $ffej8;
    var $6Ll2T;
    var $fm763;
    var $k0Jvh;
    var $ZuPvl;
    var $99gde;
    var $gEusR;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $2ogyS;
    var $iau6N;
    const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'screen',
                action: 'viewed'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $678322372bbc5cca$var$containerBorderStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            alignBlock: "stretch",
            xcss: $678322372bbc5cca$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            alignInline: "end",
            grow: "fill",
            xcss: $678322372bbc5cca$var$headerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            appearance: "subtle",
            onClick: onClose,
            label: formatMessage((0, (0, parcelRequire("2ogyS")).messages).closeModal),
            icon: (0, ($parcel$interopDefault((0, parcelRequire("bciic")))))
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ffej8")).default), {
            all: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEusR")).default), {
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            alignInline: "stretch",
            space: "space.200",
            xcss: $678322372bbc5cca$var$textContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "medium",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "p"
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).body)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            alignInline: "end",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iau6N")).StartPremiumTrialButton), {
            onCloseParent: onClose
        })))));
    };
    const $678322372bbc5cca$var$containerBorderStyles = (0, (0, parcelRequire("99gde")).xcss)({
        overflow: 'hidden',
        boxShadow: 'elevation.shadow.overlay',
        borderRadius: 'border.radius',
        width: '438px',
        position: 'relative',
        padding: 'space.025',
        background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$export$c71e4279dd54a18d)})`} 100%
    )`
    });
    const $678322372bbc5cca$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        backgroundColor: 'elevation.surface.overlay',
        overflow: 'hidden'
    });
    const $678322372bbc5cca$var$headerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        padding: 'space.075',
        right: 'space.025'
    });
    const $678322372bbc5cca$var$textContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.300'
    });
});
parcelRegister("bciic", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $826f0138e1c81e0b$var$_react = $826f0138e1c81e0b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $826f0138e1c81e0b$var$_close = $826f0138e1c81e0b$var$_interopRequireDefault((parcelRequire("2X0Jj")));
    function $826f0138e1c81e0b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $826f0138e1c81e0b$var$EditorCloseIcon = (props)=>$826f0138e1c81e0b$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $826f0138e1c81e0b$var$_close.default
        }));
    $826f0138e1c81e0b$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $826f0138e1c81e0b$var$_default = module.exports.default = $826f0138e1c81e0b$var$EditorCloseIcon;
});
parcelRegister("ffej8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5f55aa94ba90013$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $99gde;
    function $b5f55aa94ba90013$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b5f55aa94ba90013$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $b5f55aa94ba90013$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $b5f55aa94ba90013$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $b5f55aa94ba90013$var$Bleed = (0, ($parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("99gde")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $b5f55aa94ba90013$var$baseStyles,
                (inline || all) && $b5f55aa94ba90013$var$inlineBleedMap[inline || all],
                (block || all) && $b5f55aa94ba90013$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $b5f55aa94ba90013$var$Bleed.displayName = 'Bleed';
    var $b5f55aa94ba90013$export$2e2bcd8739ae039 = $b5f55aa94ba90013$var$Bleed;
});
parcelRegister("gEusR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daf0e2023e742d66$export$2e2bcd8739ae039);
    var $dCLgq;
    var $8nOP6 = parcelRequire("8nOP6");
    var $4aPxh = parcelRequire("4aPxh");
    const $daf0e2023e742d66$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($4aPxh)),
        srcDark: ($parcel$interopDefault($8nOP6))
    });
    var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
    const $daf0e2023e742d66$export$a179c88182cb9d56 = [
        0,
        0,
        438,
        96
    ];
});
parcelRegister("8nOP6", function(module, exports) {
    module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();
});
parcelRegister("4aPxh", function(module, exports) {
    module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();
});
parcelRegister("2ogyS", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$703e8ca8733c69fc$export$defe85febe8b728c);
    var $7VHMR;
    const $703e8ca8733c69fc$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
            "defaultMessage": "Write better, work faster with Atlassian Intelligence"
        },
        body: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
            "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
        },
        closeModal: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
            "defaultMessage": "Close Modal"
        },
        tryItFreeButton: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
            "defaultMessage": "Try it free"
        }
    });
});
parcelRegister("iau6N", function(module, exports) {
    $parcel$export(module.exports, "StartPremiumTrialButton", ()=>$d916fa2fae12e75a$export$a2651a739f515dd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $4nceh;
    var $47bxC;
    var $47gW9;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $ljlOe;
    var $2ogyS;
    const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContext));
        const triggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
        }, [
            createAnalyticsEvent
        ]);
        const onClick = ()=>{
            onCloseParent && onCloseParent();
            onClickAnalytics();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nceh")).default), {
            onClick: onClick,
            ref: triggerRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("47bxC"))))), {
                size: "small",
                label: "",
                primaryColor: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`
            }),
            theme: (current, themeProps)=>({
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        display: 'flex',
                        alignItems: 'center',
                        background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                        color: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
                        outline: 'none',
                        boxSizing: 'border-box',
                        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                        borderRadius: "var(--ds-space-050, 4px)",
                        height: "var(--ds-space-400, 32px)",
                        border: 'none',
                        fontSize: '14px',
                        gap: "var(--ds-space-025, 2px)"
                    },
                    spinnerStyles: current(themeProps).spinnerStyles
                })
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).tryItFreeButton));
    };
});
parcelRegister("47gW9", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$1be876415a945060$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$1be876415a945060$export$5f13515bd3a35325);
    var $5uXOq = parcelRequire("5uXOq");
    var $iRKpN;
    const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
        const removePreviousListeners = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $5uXOq.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
            } else removePreviousListeners.current = null;
        }, [
            eventMap,
            isActive
        ]);
    };
    const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("iRKpN", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$62bae43418420b8a$export$15257a36a7e3f9d6);
    function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("4IoOR", function(module, exports) {
    $parcel$export(module.exports, "convertWikiToAdf", ()=>$7c8efe67867622a1$export$3dfdef94497f0395);
    var $kOFhM;
    var $jLwE5;
    var $dU21Y;
    const $7c8efe67867622a1$var$wikiTransformer = new (0, (0, parcelRequire("dU21Y")).WikiMarkupTransformer)((0, (0, parcelRequire("kOFhM")).defaultSchema));
    const $7c8efe67867622a1$var$adfTransformer = new (0, (0, parcelRequire("jLwE5")).JSONTransformer)();
    const $7c8efe67867622a1$export$3dfdef94497f0395 = (wiki)=>{
        if (wiki === null || wiki === undefined || wiki === '') return null;
        const pmNode = $7c8efe67867622a1$var$wikiTransformer.parse(wiki);
        return $7c8efe67867622a1$var$adfTransformer.encode(pmNode);
    };
});
parcelRegister("dU21Y", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "WikiMarkupTransformer", ()=>$992cfb2877890a1f$export$caaa00407b56b900);
    $parcel$export(module.exports, "default", ()=>$992cfb2877890a1f$export$2e2bcd8739ae039);
    var $kOFhM;
    var $2m8bC;
    var $eUD5S;
    var $77lzI;
    class $992cfb2877890a1f$export$caaa00407b56b900 {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema)){
            this.schema = schema;
        }
        sanitizeWikiMarkup(wikiMarkup) {
            return wikiMarkup.replace(/\0/g, '');
        }
        encode(node, context) {
            const wikiMarkup = (0, (0, parcelRequire("2m8bC")).encode)(node, $992cfb2877890a1f$var$normalizeContextObject(context));
            const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
            return sanitizedWikiMarkup;
        }
        parse(wikiMarkup, context) {
            const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
            const tree = new (0, (0, parcelRequire("eUD5S")).default)(this.schema, sanitizedWikiMarkup);
            return tree.getProseMirrorModel(this.buildContext($992cfb2877890a1f$var$normalizeContextObject(context)));
        }
        buildContext(context) {
            return context ? {
                ...context,
                issueKeyRegex: context.conversion ? (0, (0, parcelRequire("77lzI")).buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
            } : {};
        }
    }
    const $992cfb2877890a1f$var$normalizeContextObject = (context)=>{
        if (!context || !context.conversion || !context.conversion.mentionConversion) return context;
        const mentionConversion = {};
        for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
        context.conversion.mentionConversion = mentionConversion;
        return context;
    };
    var $992cfb2877890a1f$export$2e2bcd8739ae039 = $992cfb2877890a1f$export$caaa00407b56b900;
});
parcelRegister("2m8bC", function(module, exports) {
    $parcel$export(module.exports, "encode", ()=>$b1340da774b6b3a2$export$c564cdbbe6da493);
    var $5fbAm;
    var $7eb5Z;
    var $4B3TF;
    var $aPVUf;
    var $hOFbV;
    var $lnLsa;
    var $372cg;
    var $1Gh0T;
    var $mxur4;
    var $38SPg;
    var $dZHVv;
    var $aF5s6;
    var $jkQfD;
    var $jQCGt;
    var $k2I1S;
    var $kjntr;
    var $OUW1A;
    var $eJTbS;
    var $4me33;
    const $b1340da774b6b3a2$var$nodeEncoderMapping = {
        blockquote: (0, parcelRequire("5fbAm")).blockquote,
        bulletList: (0, parcelRequire("7eb5Z")).bulletList,
        taskList: (0, parcelRequire("4B3TF")).taskList,
        decisionList: (0, parcelRequire("aPVUf")).decisionList,
        codeBlock: (0, parcelRequire("hOFbV")).codeBlock,
        doc: (0, parcelRequire("lnLsa")).doc,
        heading: (0, parcelRequire("1Gh0T")).heading,
        caption: (0, parcelRequire("4me33")).caption,
        mediaGroup: (0, parcelRequire("mxur4")).mediaGroup,
        mediaInline: (0, parcelRequire("38SPg")).mediaInline,
        mediaSingle: (0, (0, parcelRequire("mxur4")).mediaGroup),
        orderedList: (0, parcelRequire("dZHVv")).orderedList,
        panel: (0, parcelRequire("aF5s6")).panel,
        paragraph: (0, parcelRequire("jkQfD")).paragraph,
        rule: (0, parcelRequire("jQCGt")).rule,
        table: (0, parcelRequire("k2I1S")).table,
        blockCard: (0, parcelRequire("OUW1A")).blockCard,
        embedCard: (0, parcelRequire("eJTbS")).embedCard,
        expand: (0, parcelRequire("372cg")).expand
    };
    function $b1340da774b6b3a2$export$c564cdbbe6da493(node, context) {
        const encoder = $b1340da774b6b3a2$var$nodeEncoderMapping[node.type.name];
        try {
            if (encoder) return encoder(node, {
                context: context
            });
            return (0, (0, parcelRequire("kjntr")).unknown)(node);
        } catch (err) {
            return (0, (0, parcelRequire("kjntr")).unknown)(node);
        }
    }
});
parcelRegister("5fbAm", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$cec51bad5a749e6c$export$67dc04e652a298ca);
    var $2m8bC;
    const $cec51bad5a749e6c$export$67dc04e652a298ca = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("2m8bC")).encode)(n, context));
        });
        return `{quote}${result.join('\n\n')}{quote}`;
    };
});
parcelRegister("7eb5Z", function(module, exports) {
    $parcel$export(module.exports, "bulletList", ()=>$337f41a67a336f95$export$a140c94e5ea26bee);
    var $8ceXI;
    const $337f41a67a336f95$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("8ceXI")).listItem)(item, '*', context));
        });
        return result.join('\n');
    };
});
parcelRegister("8ceXI", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$528c25085f9f920e$export$76c7e83ecc9cdf05);
    var $2m8bC;
    var $jkQfD;
    var $kjntr;
    var $hOFbV;
    var $mxur4;
    var $38SPg;
    const $528c25085f9f920e$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
        const result = [];
        let contentBuffer = [];
        node.forEach((n)=>{
            switch(n.type.name){
                case 'paragraph':
                    contentBuffer.push((0, (0, parcelRequire("jkQfD")).paragraph)(n, {
                        context: context
                    }));
                    break;
                case 'bulletList':
                case 'orderedList':
                    {
                        if (contentBuffer.length) {
                            result.push(`${prefix} ${contentBuffer.join('\n')}`);
                            contentBuffer = [];
                        }
                        const nestedList = (0, (0, parcelRequire("2m8bC")).encode)(n, context).split('\n').map((line)=>{
                            if ([
                                '#',
                                '*'
                            ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                            return line;
                        }).join('\n');
                        result.push(nestedList);
                        break;
                    }
                case 'codeBlock':
                    contentBuffer.push((0, (0, parcelRequire("hOFbV")).codeBlock)(n));
                    break;
                case 'mediaInline':
                    contentBuffer.push((0, (0, parcelRequire("38SPg")).mediaInline)(n, {
                        context: context
                    }));
                    break;
                case 'mediaSingle':
                    contentBuffer.push((0, (0, parcelRequire("mxur4")).mediaGroup)(n, {
                        context: context
                    }));
                    break;
                default:
                    contentBuffer.push((0, (0, parcelRequire("kjntr")).unknown)(n));
            }
        });
        if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
        return result.join('\n');
    };
});
parcelRegister("jkQfD", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$d14f22f66ca23e83$export$9c206ddddb32a9b);
    var $aNFJk;
    const $d14f22f66ca23e83$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("aNFJk")).inlines)(n, {
                context: context
            });
        });
        return result;
    };
});
parcelRegister("aNFJk", function(module, exports) {
    $parcel$export(module.exports, "inlines", ()=>$ba03fc4ee171a86a$export$96c94bfc00b85760);
    var $8SyTE;
    var $5dfLN;
    var $38SPg;
    var $3UNeh;
    var $71tTl;
    var $iPrWY;
    var $6WgQP;
    var $kjntr;
    var $bmVBj;
    const $ba03fc4ee171a86a$var$inlinesEncoderMapping = {
        emoji: (0, parcelRequire("8SyTE")).emoji,
        hardBreak: (0, parcelRequire("5dfLN")).hardBreak,
        mediaInline: (0, parcelRequire("38SPg")).mediaInline,
        mention: (0, parcelRequire("3UNeh")).mention,
        text: (0, parcelRequire("71tTl")).text,
        inlineCard: (0, parcelRequire("iPrWY")).inlineCard,
        status: (0, parcelRequire("6WgQP")).status,
        date: (0, parcelRequire("bmVBj")).date
    };
    const $ba03fc4ee171a86a$export$96c94bfc00b85760 = (node, opts)=>{
        const encoder = $ba03fc4ee171a86a$var$inlinesEncoderMapping[node.type.name];
        if (encoder) return encoder(node, opts);
        return (0, (0, parcelRequire("kjntr")).unknown)(node);
    };
});
parcelRegister("8SyTE", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$536c4863a3f9b0bd$export$a19185d1233fc4b2);
    var $46nHN;
    var $kjntr;
    const $536c4863a3f9b0bd$export$a19185d1233fc4b2 = (node)=>{
        const value = (0, (0, parcelRequire("46nHN")).mapping)[node.attrs.id];
        if (value) return value;
        if (node.attrs.shortName) return node.attrs.shortName;
        return (0, (0, parcelRequire("kjntr")).unknown)(node);
    };
});
parcelRegister("46nHN", function(module, exports) {
    $parcel$export(module.exports, "mapping", ()=>$ac1f36f8b06168a7$export$83e1f26587c4acd2);
    const $ac1f36f8b06168a7$export$83e1f26587c4acd2 = {
        '1f600': "\uD83D\uDE00",
        '1f603': "\uD83D\uDE03",
        '1f604': "\uD83D\uDE04",
        '1f601': "\uD83D\uDE01",
        '1f606': "\uD83D\uDE06",
        '1f605': "\uD83D\uDE05",
        '1f602': "\uD83D\uDE02",
        '1f923': "\uD83E\uDD23",
        '263a': "\u263A\uFE0F",
        '1f60a': "\uD83D\uDE0A",
        '1f607': "\uD83D\uDE07",
        '1f642': "\uD83D\uDE42",
        '1f643': "\uD83D\uDE43",
        '1f609': "\uD83D\uDE09",
        '1f60c': "\uD83D\uDE0C",
        '1f60d': "\uD83D\uDE0D",
        '1f618': "\uD83D\uDE18",
        '1f617': "\uD83D\uDE17",
        '1f619': "\uD83D\uDE19",
        '1f61a': "\uD83D\uDE1A",
        '1f60b': "\uD83D\uDE0B",
        '1f61c': "\uD83D\uDE1C",
        '1f61d': "\uD83D\uDE1D",
        '1f61b': "\uD83D\uDE1B",
        '1f911': "\uD83E\uDD11",
        '1f917': "\uD83E\uDD17",
        '1f913': "\uD83E\uDD13",
        '1f60e': "\uD83D\uDE0E",
        '1f921': "\uD83E\uDD21",
        '1f920': "\uD83E\uDD20",
        '1f60f': "\uD83D\uDE0F",
        '1f612': "\uD83D\uDE12",
        '1f61e': "\uD83D\uDE1E",
        '1f614': "\uD83D\uDE14",
        '1f61f': "\uD83D\uDE1F",
        '1f615': "\uD83D\uDE15",
        '1f641': "\uD83D\uDE41",
        '2639': "\u2639\uFE0F",
        '1f623': "\uD83D\uDE23",
        '1f616': "\uD83D\uDE16",
        '1f62b': "\uD83D\uDE2B",
        '1f629': "\uD83D\uDE29",
        '1f624': "\uD83D\uDE24",
        '1f620': "\uD83D\uDE20",
        '1f621': "\uD83D\uDE21",
        '1f636': "\uD83D\uDE36",
        '1f610': "\uD83D\uDE10",
        '1f611': "\uD83D\uDE11",
        '1f62f': "\uD83D\uDE2F",
        '1f626': "\uD83D\uDE26",
        '1f627': "\uD83D\uDE27",
        '1f62e': "\uD83D\uDE2E",
        '1f632': "\uD83D\uDE32",
        '1f635': "\uD83D\uDE35",
        '1f633': "\uD83D\uDE33",
        '1f631': "\uD83D\uDE31",
        '1f628': "\uD83D\uDE28",
        '1f630': "\uD83D\uDE30",
        '1f622': "\uD83D\uDE22",
        '1f625': "\uD83D\uDE25",
        '1f924': "\uD83E\uDD24",
        '1f62d': "\uD83D\uDE2D",
        '1f613': "\uD83D\uDE13",
        '1f62a': "\uD83D\uDE2A",
        '1f634': "\uD83D\uDE34",
        '1f644': "\uD83D\uDE44",
        '1f914': "\uD83E\uDD14",
        '1f925': "\uD83E\uDD25",
        '1f62c': "\uD83D\uDE2C",
        '1f910': "\uD83E\uDD10",
        '1f922': "\uD83E\uDD22",
        '1f927': "\uD83E\uDD27",
        '1f637': "\uD83D\uDE37",
        '1f912': "\uD83E\uDD12",
        '1f915': "\uD83E\uDD15",
        '1f608': "\uD83D\uDE08",
        '1f47f': "\uD83D\uDC7F",
        '1f479': "\uD83D\uDC79",
        '1f47a': "\uD83D\uDC7A",
        '1f4a9': "\uD83D\uDCA9",
        '1f47b': "\uD83D\uDC7B",
        '1f480': "\uD83D\uDC80",
        '2620': "\u2620\uFE0F",
        '1f47d': "\uD83D\uDC7D",
        '1f47e': "\uD83D\uDC7E",
        '1f916': "\uD83E\uDD16",
        '1f383': "\uD83C\uDF83",
        '1f63a': "\uD83D\uDE3A",
        '1f638': "\uD83D\uDE38",
        '1f639': "\uD83D\uDE39",
        '1f63b': "\uD83D\uDE3B",
        '1f63c': "\uD83D\uDE3C",
        '1f63d': "\uD83D\uDE3D",
        '1f640': "\uD83D\uDE40",
        '1f63f': "\uD83D\uDE3F",
        '1f63e': "\uD83D\uDE3E",
        '1f450': "\uD83D\uDC50",
        '1f64c': "\uD83D\uDE4C",
        '1f44f': "\uD83D\uDC4F",
        '1f64f': "\uD83D\uDE4F",
        '1f91d': "\uD83E\uDD1D",
        '1f44d': "\uD83D\uDC4D",
        '1f44e': "\uD83D\uDC4E",
        '1f44a': "\uD83D\uDC4A",
        '270a': "\u270A",
        '1f91b': "\uD83E\uDD1B",
        '1f91c': "\uD83E\uDD1C",
        '1f91e': "\uD83E\uDD1E",
        '270c': "\u270C\uFE0F",
        '1f918': "\uD83E\uDD18",
        '1f44c': "\uD83D\uDC4C",
        '1f448': "\uD83D\uDC48",
        '1f449': "\uD83D\uDC49",
        '1f446': "\uD83D\uDC46",
        '1f447': "\uD83D\uDC47",
        '261d': "\u261D\uFE0F",
        '270b': "\u270B",
        '1f91a': "\uD83E\uDD1A",
        '1f590': "\uD83D\uDD90\uFE0F",
        '1f596': "\uD83D\uDD96",
        '1f44b': "\uD83D\uDC4B",
        '1f919': "\uD83E\uDD19",
        '1f4aa': "\uD83D\uDCAA",
        '1f595': "\uD83D\uDD95",
        '270d': "\u270D\uFE0F",
        '1f933': "\uD83E\uDD33",
        '1f485': "\uD83D\uDC85",
        '1f48d': "\uD83D\uDC8D",
        '1f484': "\uD83D\uDC84",
        '1f48b': "\uD83D\uDC8B",
        '1f444': "\uD83D\uDC44",
        '1f445': "\uD83D\uDC45",
        '1f442': "\uD83D\uDC42",
        '1f443': "\uD83D\uDC43",
        '1f463': "\uD83D\uDC63",
        '1f441': "\uD83D\uDC41\uFE0F",
        '1f440': "\uD83D\uDC40",
        '1f5e3': "\uD83D\uDDE3\uFE0F",
        '1f464': "\uD83D\uDC64",
        '1f465': "\uD83D\uDC65",
        '1f476': "\uD83D\uDC76",
        '1f466': "\uD83D\uDC66",
        '1f467': "\uD83D\uDC67",
        '1f468': "\uD83D\uDC68",
        '1f469': "\uD83D\uDC69",
        '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
        '1f471': "\uD83D\uDC71",
        '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
        '1f474': "\uD83D\uDC74",
        '1f475': "\uD83D\uDC75",
        '1f472': "\uD83D\uDC72",
        '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
        '1f473': "\uD83D\uDC73",
        '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
        '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
        '1f46e': "\uD83D\uDC6E",
        '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
        '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
        '1f477': "\uD83D\uDC77",
        '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
        '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
        '1f482': "\uD83D\uDC82",
        '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
        '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
        '1f575': "\uD83D\uDD75\uFE0F",
        '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
        '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
        '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
        '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
        '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
        '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
        '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
        '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
        '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
        '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
        '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
        '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
        '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
        '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
        '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
        '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
        '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
        '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
        '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
        '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
        '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
        '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
        '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
        '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
        '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
        '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
        '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
        '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
        '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
        '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
        '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
        '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
        '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
        '1f936': "\uD83E\uDD36",
        '1f385': "\uD83C\uDF85",
        '1f478': "\uD83D\uDC78",
        '1f934': "\uD83E\uDD34",
        '1f470': "\uD83D\uDC70",
        '1f935': "\uD83E\uDD35",
        '1f47c': "\uD83D\uDC7C",
        '1f930': "\uD83E\uDD30",
        '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
        '1f647': "\uD83D\uDE47",
        '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
        '1f481': "\uD83D\uDC81",
        '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
        '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
        '1f645': "\uD83D\uDE45",
        '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
        '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
        '1f646': "\uD83D\uDE46",
        '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
        '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
        '1f64b': "\uD83D\uDE4B",
        '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
        '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
        '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
        '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
        '1f926': "\uD83E\uDD26",
        '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
        '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
        '1f937': "\uD83E\uDD37",
        '1f64e': "\uD83D\uDE4E",
        '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
        '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
        '1f64d': "\uD83D\uDE4D",
        '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
        '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
        '1f487': "\uD83D\uDC87",
        '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
        '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
        '1f486': "\uD83D\uDC86",
        '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
        '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
        '1f574': "\uD83D\uDD74\uFE0F",
        '1f483': "\uD83D\uDC83",
        '1f57a': "\uD83D\uDD7A",
        '1f46f': "\uD83D\uDC6F",
        '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
        '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
        '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
        '1f6b6': "\uD83D\uDEB6",
        '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
        '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
        '1f3c3': "\uD83C\uDFC3",
        '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
        '1f46b': "\uD83D\uDC6B",
        '1f46d': "\uD83D\uDC6D",
        '1f46c': "\uD83D\uDC6C",
        '1f491': "\uD83D\uDC91",
        '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
        '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
        '1f48f': "\uD83D\uDC8F",
        '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
        '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
        '1f46a': "\uD83D\uDC6A",
        '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
        '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
        '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
        '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f45a': "\uD83D\uDC5A",
        '1f455': "\uD83D\uDC55",
        '1f456': "\uD83D\uDC56",
        '1f454': "\uD83D\uDC54",
        '1f457': "\uD83D\uDC57",
        '1f459': "\uD83D\uDC59",
        '1f458': "\uD83D\uDC58",
        '1f460': "\uD83D\uDC60",
        '1f461': "\uD83D\uDC61",
        '1f462': "\uD83D\uDC62",
        '1f45e': "\uD83D\uDC5E",
        '1f45f': "\uD83D\uDC5F",
        '1f452': "\uD83D\uDC52",
        '1f3a9': "\uD83C\uDFA9",
        '1f393': "\uD83C\uDF93",
        '1f451': "\uD83D\uDC51",
        '26d1': "\u26D1\uFE0F",
        '1f392': "\uD83C\uDF92",
        '1f45d': "\uD83D\uDC5D",
        '1f45b': "\uD83D\uDC5B",
        '1f45c': "\uD83D\uDC5C",
        '1f4bc': "\uD83D\uDCBC",
        '1f453': "\uD83D\uDC53",
        '1f576': "\uD83D\uDD76\uFE0F",
        '1f302': "\uD83C\uDF02",
        '2602': "\u2602\uFE0F",
        '1f436': "\uD83D\uDC36",
        '1f431': "\uD83D\uDC31",
        '1f42d': "\uD83D\uDC2D",
        '1f439': "\uD83D\uDC39",
        '1f430': "\uD83D\uDC30",
        '1f98a': "\uD83E\uDD8A",
        '1f43b': "\uD83D\uDC3B",
        '1f43c': "\uD83D\uDC3C",
        '1f428': "\uD83D\uDC28",
        '1f42f': "\uD83D\uDC2F",
        '1f981': "\uD83E\uDD81",
        '1f42e': "\uD83D\uDC2E",
        '1f437': "\uD83D\uDC37",
        '1f43d': "\uD83D\uDC3D",
        '1f438': "\uD83D\uDC38",
        '1f435': "\uD83D\uDC35",
        '1f648': "\uD83D\uDE48",
        '1f649': "\uD83D\uDE49",
        '1f64a': "\uD83D\uDE4A",
        '1f412': "\uD83D\uDC12",
        '1f414': "\uD83D\uDC14",
        '1f427': "\uD83D\uDC27",
        '1f426': "\uD83D\uDC26",
        '1f424': "\uD83D\uDC24",
        '1f423': "\uD83D\uDC23",
        '1f425': "\uD83D\uDC25",
        '1f986': "\uD83E\uDD86",
        '1f985': "\uD83E\uDD85",
        '1f989': "\uD83E\uDD89",
        '1f987': "\uD83E\uDD87",
        '1f43a': "\uD83D\uDC3A",
        '1f417': "\uD83D\uDC17",
        '1f434': "\uD83D\uDC34",
        '1f984': "\uD83E\uDD84",
        '1f41d': "\uD83D\uDC1D",
        '1f41b': "\uD83D\uDC1B",
        '1f98b': "\uD83E\uDD8B",
        '1f40c': "\uD83D\uDC0C",
        '1f41a': "\uD83D\uDC1A",
        '1f41e': "\uD83D\uDC1E",
        '1f41c': "\uD83D\uDC1C",
        '1f577': "\uD83D\uDD77\uFE0F",
        '1f578': "\uD83D\uDD78\uFE0F",
        '1f422': "\uD83D\uDC22",
        '1f40d': "\uD83D\uDC0D",
        '1f98e': "\uD83E\uDD8E",
        '1f982': "\uD83E\uDD82",
        '1f980': "\uD83E\uDD80",
        '1f991': "\uD83E\uDD91",
        '1f419': "\uD83D\uDC19",
        '1f990': "\uD83E\uDD90",
        '1f420': "\uD83D\uDC20",
        '1f41f': "\uD83D\uDC1F",
        '1f421': "\uD83D\uDC21",
        '1f42c': "\uD83D\uDC2C",
        '1f988': "\uD83E\uDD88",
        '1f433': "\uD83D\uDC33",
        '1f40b': "\uD83D\uDC0B",
        '1f40a': "\uD83D\uDC0A",
        '1f406': "\uD83D\uDC06",
        '1f405': "\uD83D\uDC05",
        '1f403': "\uD83D\uDC03",
        '1f402': "\uD83D\uDC02",
        '1f404': "\uD83D\uDC04",
        '1f98c': "\uD83E\uDD8C",
        '1f42a': "\uD83D\uDC2A",
        '1f42b': "\uD83D\uDC2B",
        '1f418': "\uD83D\uDC18",
        '1f98f': "\uD83E\uDD8F",
        '1f98d': "\uD83E\uDD8D",
        '1f40e': "\uD83D\uDC0E",
        '1f416': "\uD83D\uDC16",
        '1f410': "\uD83D\uDC10",
        '1f40f': "\uD83D\uDC0F",
        '1f411': "\uD83D\uDC11",
        '1f415': "\uD83D\uDC15",
        '1f429': "\uD83D\uDC29",
        '1f408': "\uD83D\uDC08",
        '1f413': "\uD83D\uDC13",
        '1f983': "\uD83E\uDD83",
        '1f54a': "\uD83D\uDD4A\uFE0F",
        '1f407': "\uD83D\uDC07",
        '1f401': "\uD83D\uDC01",
        '1f400': "\uD83D\uDC00",
        '1f43f': "\uD83D\uDC3F\uFE0F",
        '1f43e': "\uD83D\uDC3E",
        '1f409': "\uD83D\uDC09",
        '1f432': "\uD83D\uDC32",
        '1f335': "\uD83C\uDF35",
        '1f384': "\uD83C\uDF84",
        '1f332': "\uD83C\uDF32",
        '1f333': "\uD83C\uDF33",
        '1f334': "\uD83C\uDF34",
        '1f331': "\uD83C\uDF31",
        '1f33f': "\uD83C\uDF3F",
        '2618': "\u2618\uFE0F",
        '1f340': "\uD83C\uDF40",
        '1f38d': "\uD83C\uDF8D",
        '1f38b': "\uD83C\uDF8B",
        '1f343': "\uD83C\uDF43",
        '1f342': "\uD83C\uDF42",
        '1f341': "\uD83C\uDF41",
        '1f344': "\uD83C\uDF44",
        '1f33e': "\uD83C\uDF3E",
        '1f490': "\uD83D\uDC90",
        '1f337': "\uD83C\uDF37",
        '1f339': "\uD83C\uDF39",
        '1f940': "\uD83E\uDD40",
        '1f33b': "\uD83C\uDF3B",
        '1f33c': "\uD83C\uDF3C",
        '1f338': "\uD83C\uDF38",
        '1f33a': "\uD83C\uDF3A",
        '1f30e': "\uD83C\uDF0E",
        '1f30d': "\uD83C\uDF0D",
        '1f30f': "\uD83C\uDF0F",
        '1f315': "\uD83C\uDF15",
        '1f316': "\uD83C\uDF16",
        '1f317': "\uD83C\uDF17",
        '1f318': "\uD83C\uDF18",
        '1f311': "\uD83C\uDF11",
        '1f312': "\uD83C\uDF12",
        '1f313': "\uD83C\uDF13",
        '1f314': "\uD83C\uDF14",
        '1f31a': "\uD83C\uDF1A",
        '1f31d': "\uD83C\uDF1D",
        '1f31e': "\uD83C\uDF1E",
        '1f31b': "\uD83C\uDF1B",
        '1f31c': "\uD83C\uDF1C",
        '1f319': "\uD83C\uDF19",
        '1f4ab': "\uD83D\uDCAB",
        '2b50': "\u2B50",
        '1f31f': "\uD83C\uDF1F",
        '2728': "\u2728",
        '26a1': "\u26A1",
        '1f525': "\uD83D\uDD25",
        '1f4a5': "\uD83D\uDCA5",
        '2604': "\u2604\uFE0F",
        '2600': "\u2600\uFE0F",
        '1f324': "\uD83C\uDF24\uFE0F",
        '26c5': "\u26C5",
        '1f325': "\uD83C\uDF25\uFE0F",
        '1f326': "\uD83C\uDF26\uFE0F",
        '1f308': "\uD83C\uDF08",
        '2601': "\u2601\uFE0F",
        '1f327': "\uD83C\uDF27\uFE0F",
        '26c8': "\u26C8\uFE0F",
        '1f329': "\uD83C\uDF29\uFE0F",
        '1f328': "\uD83C\uDF28\uFE0F",
        '2603': "\u2603\uFE0F",
        '26c4': "\u26C4",
        '2744': "\u2744\uFE0F",
        '1f32c': "\uD83C\uDF2C\uFE0F",
        '1f4a8': "\uD83D\uDCA8",
        '1f32a': "\uD83C\uDF2A\uFE0F",
        '1f32b': "\uD83C\uDF2B\uFE0F",
        '1f30a': "\uD83C\uDF0A",
        '1f4a7': "\uD83D\uDCA7",
        '1f4a6': "\uD83D\uDCA6",
        '2614': "\u2614",
        '1f992': "\uD83E\uDD92",
        '1f993': "\uD83E\uDD93",
        '1f994': "\uD83E\uDD94",
        '1f995': "\uD83E\uDD95",
        '1f996': "\uD83E\uDD96",
        '1f997': "\uD83E\uDD97",
        '1f34f': "\uD83C\uDF4F",
        '1f34e': "\uD83C\uDF4E",
        '1f350': "\uD83C\uDF50",
        '1f34a': "\uD83C\uDF4A",
        '1f34b': "\uD83C\uDF4B",
        '1f34c': "\uD83C\uDF4C",
        '1f349': "\uD83C\uDF49",
        '1f347': "\uD83C\uDF47",
        '1f353': "\uD83C\uDF53",
        '1f348': "\uD83C\uDF48",
        '1f352': "\uD83C\uDF52",
        '1f351': "\uD83C\uDF51",
        '1f34d': "\uD83C\uDF4D",
        '1f95d': "\uD83E\uDD5D",
        '1f951': "\uD83E\uDD51",
        '1f345': "\uD83C\uDF45",
        '1f346': "\uD83C\uDF46",
        '1f952': "\uD83E\uDD52",
        '1f955': "\uD83E\uDD55",
        '1f33d': "\uD83C\uDF3D",
        '1f336': "\uD83C\uDF36\uFE0F",
        '1f954': "\uD83E\uDD54",
        '1f360': "\uD83C\uDF60",
        '1f330': "\uD83C\uDF30",
        '1f95c': "\uD83E\uDD5C",
        '1f36f': "\uD83C\uDF6F",
        '1f950': "\uD83E\uDD50",
        '1f35e': "\uD83C\uDF5E",
        '1f956': "\uD83E\uDD56",
        '1f9c0': "\uD83E\uDDC0",
        '1f95a': "\uD83E\uDD5A",
        '1f373': "\uD83C\uDF73",
        '1f953': "\uD83E\uDD53",
        '1f95e': "\uD83E\uDD5E",
        '1f364': "\uD83C\uDF64",
        '1f357': "\uD83C\uDF57",
        '1f356': "\uD83C\uDF56",
        '1f355': "\uD83C\uDF55",
        '1f32d': "\uD83C\uDF2D",
        '1f354': "\uD83C\uDF54",
        '1f35f': "\uD83C\uDF5F",
        '1f959': "\uD83E\uDD59",
        '1f32e': "\uD83C\uDF2E",
        '1f32f': "\uD83C\uDF2F",
        '1f957': "\uD83E\uDD57",
        '1f958': "\uD83E\uDD58",
        '1f35d': "\uD83C\uDF5D",
        '1f35c': "\uD83C\uDF5C",
        '1f372': "\uD83C\uDF72",
        '1f365': "\uD83C\uDF65",
        '1f363': "\uD83C\uDF63",
        '1f371': "\uD83C\uDF71",
        '1f35b': "\uD83C\uDF5B",
        '1f359': "\uD83C\uDF59",
        '1f35a': "\uD83C\uDF5A",
        '1f358': "\uD83C\uDF58",
        '1f362': "\uD83C\uDF62",
        '1f361': "\uD83C\uDF61",
        '1f367': "\uD83C\uDF67",
        '1f368': "\uD83C\uDF68",
        '1f366': "\uD83C\uDF66",
        '1f370': "\uD83C\uDF70",
        '1f382': "\uD83C\uDF82",
        '1f36e': "\uD83C\uDF6E",
        '1f36d': "\uD83C\uDF6D",
        '1f36c': "\uD83C\uDF6C",
        '1f36b': "\uD83C\uDF6B",
        '1f37f': "\uD83C\uDF7F",
        '1f369': "\uD83C\uDF69",
        '1f36a': "\uD83C\uDF6A",
        '1f95b': "\uD83E\uDD5B",
        '1f37c': "\uD83C\uDF7C",
        '2615': "\u2615",
        '1f375': "\uD83C\uDF75",
        '1f376': "\uD83C\uDF76",
        '1f37a': "\uD83C\uDF7A",
        '1f37b': "\uD83C\uDF7B",
        '1f942': "\uD83E\uDD42",
        '1f377': "\uD83C\uDF77",
        '1f943': "\uD83E\uDD43",
        '1f378': "\uD83C\uDF78",
        '1f379': "\uD83C\uDF79",
        '1f37e': "\uD83C\uDF7E",
        '1f944': "\uD83E\uDD44",
        '1f374': "\uD83C\uDF74",
        '1f37d': "\uD83C\uDF7D\uFE0F",
        '1f95f': "\uD83E\uDD5F",
        '1f960': "\uD83E\uDD60",
        '1f961': "\uD83E\uDD61",
        '1f962': "\uD83E\uDD62",
        '1f963': "\uD83E\uDD63",
        '1f964': "\uD83E\uDD64",
        '1f965': "\uD83E\uDD65",
        '1f966': "\uD83E\uDD66",
        '1f967': "\uD83E\uDD67",
        '1f968': "\uD83E\uDD68",
        '1f969': "\uD83E\uDD69",
        '1f96a': "\uD83E\uDD6A",
        '1f96b': "\uD83E\uDD6B",
        '26bd': "\u26BD",
        '1f3c0': "\uD83C\uDFC0",
        '1f3c8': "\uD83C\uDFC8",
        '26be': "\u26BE",
        '1f3be': "\uD83C\uDFBE",
        '1f3d0': "\uD83C\uDFD0",
        '1f3c9': "\uD83C\uDFC9",
        '1f3b1': "\uD83C\uDFB1",
        '1f3d3': "\uD83C\uDFD3",
        '1f3f8': "\uD83C\uDFF8",
        '1f945': "\uD83E\uDD45",
        '1f3d2': "\uD83C\uDFD2",
        '1f3d1': "\uD83C\uDFD1",
        '1f3cf': "\uD83C\uDFCF",
        '26f3': "\u26F3",
        '1f3f9': "\uD83C\uDFF9",
        '1f3a3': "\uD83C\uDFA3",
        '1f94a': "\uD83E\uDD4A",
        '1f94b': "\uD83E\uDD4B",
        '26f8': "\u26F8\uFE0F",
        '1f3bf': "\uD83C\uDFBF",
        '26f7': "\u26F7\uFE0F",
        '1f3c2': "\uD83C\uDFC2",
        '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
        '1f3cb': "\uD83C\uDFCB\uFE0F",
        '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
        '1f93a': "\uD83E\uDD3A",
        '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
        '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
        '1f93c': "\uD83E\uDD3C",
        '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
        '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
        '1f938': "\uD83E\uDD38",
        '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
        '26f9': "\u26F9\uFE0F",
        '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
        '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
        '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
        '1f93e': "\uD83E\uDD3E",
        '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
        '1f3cc': "\uD83C\uDFCC\uFE0F",
        '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
        '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
        '1f3c4': "\uD83C\uDFC4",
        '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
        '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
        '1f3ca': "\uD83C\uDFCA",
        '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
        '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
        '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
        '1f93d': "\uD83E\uDD3D",
        '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
        '1f6a3': "\uD83D\uDEA3",
        '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
        '1f3c7': "\uD83C\uDFC7",
        '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
        '1f6b4': "\uD83D\uDEB4",
        '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
        '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
        '1f6b5': "\uD83D\uDEB5",
        '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
        '1f3bd': "\uD83C\uDFBD",
        '1f3c5': "\uD83C\uDFC5",
        '1f396': "\uD83C\uDF96\uFE0F",
        '1f947': "\uD83E\uDD47",
        '1f948': "\uD83E\uDD48",
        '1f949': "\uD83E\uDD49",
        '1f3c6': "\uD83C\uDFC6",
        '1f3f5': "\uD83C\uDFF5\uFE0F",
        '1f397': "\uD83C\uDF97\uFE0F",
        '1f3ab': "\uD83C\uDFAB",
        '1f39f': "\uD83C\uDF9F\uFE0F",
        '1f3aa': "\uD83C\uDFAA",
        '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
        '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
        '1f939': "\uD83E\uDD39",
        '1f3ad': "\uD83C\uDFAD",
        '1f3a8': "\uD83C\uDFA8",
        '1f3ac': "\uD83C\uDFAC",
        '1f3a4': "\uD83C\uDFA4",
        '1f3a7': "\uD83C\uDFA7",
        '1f3bc': "\uD83C\uDFBC",
        '1f3b9': "\uD83C\uDFB9",
        '1f941': "\uD83E\uDD41",
        '1f3b7': "\uD83C\uDFB7",
        '1f3ba': "\uD83C\uDFBA",
        '1f3b8': "\uD83C\uDFB8",
        '1f3bb': "\uD83C\uDFBB",
        '1f3b2': "\uD83C\uDFB2",
        '1f3af': "\uD83C\uDFAF",
        '1f3b3': "\uD83C\uDFB3",
        '1f3ae': "\uD83C\uDFAE",
        '1f3b0': "\uD83C\uDFB0",
        '1f6f7': "\uD83D\uDEF7",
        '1f931': "\uD83E\uDD31",
        '1f94c': "\uD83E\uDD4C",
        '1f9d6': "\uD83E\uDDD6",
        '1f9d7': "\uD83E\uDDD7",
        '1f9d8': "\uD83E\uDDD8",
        '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
        '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
        '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
        '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
        '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
        '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
        '1f697': "\uD83D\uDE97",
        '1f695': "\uD83D\uDE95",
        '1f699': "\uD83D\uDE99",
        '1f68c': "\uD83D\uDE8C",
        '1f68e': "\uD83D\uDE8E",
        '1f3ce': "\uD83C\uDFCE\uFE0F",
        '1f693': "\uD83D\uDE93",
        '1f691': "\uD83D\uDE91",
        '1f692': "\uD83D\uDE92",
        '1f690': "\uD83D\uDE90",
        '1f69a': "\uD83D\uDE9A",
        '1f69b': "\uD83D\uDE9B",
        '1f69c': "\uD83D\uDE9C",
        '1f6f4': "\uD83D\uDEF4",
        '1f6b2': "\uD83D\uDEB2",
        '1f6f5': "\uD83D\uDEF5",
        '1f3cd': "\uD83C\uDFCD\uFE0F",
        '1f6a8': "\uD83D\uDEA8",
        '1f694': "\uD83D\uDE94",
        '1f68d': "\uD83D\uDE8D",
        '1f698': "\uD83D\uDE98",
        '1f696': "\uD83D\uDE96",
        '1f6a1': "\uD83D\uDEA1",
        '1f6a0': "\uD83D\uDEA0",
        '1f69f': "\uD83D\uDE9F",
        '1f683': "\uD83D\uDE83",
        '1f68b': "\uD83D\uDE8B",
        '1f69e': "\uD83D\uDE9E",
        '1f69d': "\uD83D\uDE9D",
        '1f684': "\uD83D\uDE84",
        '1f685': "\uD83D\uDE85",
        '1f688': "\uD83D\uDE88",
        '1f682': "\uD83D\uDE82",
        '1f686': "\uD83D\uDE86",
        '1f687': "\uD83D\uDE87",
        '1f68a': "\uD83D\uDE8A",
        '1f689': "\uD83D\uDE89",
        '1f681': "\uD83D\uDE81",
        '1f6e9': "\uD83D\uDEE9\uFE0F",
        '2708': "\u2708\uFE0F",
        '1f6eb': "\uD83D\uDEEB",
        '1f6ec': "\uD83D\uDEEC",
        '1f680': "\uD83D\uDE80",
        '1f6f0': "\uD83D\uDEF0\uFE0F",
        '1f4ba': "\uD83D\uDCBA",
        '1f6f6': "\uD83D\uDEF6",
        '26f5': "\u26F5",
        '1f6e5': "\uD83D\uDEE5\uFE0F",
        '1f6a4': "\uD83D\uDEA4",
        '1f6f3': "\uD83D\uDEF3\uFE0F",
        '26f4': "\u26F4\uFE0F",
        '1f6a2': "\uD83D\uDEA2",
        '2693': "\u2693",
        '1f6a7': "\uD83D\uDEA7",
        '26fd': "\u26FD",
        '1f68f': "\uD83D\uDE8F",
        '1f6a6': "\uD83D\uDEA6",
        '1f6a5': "\uD83D\uDEA5",
        '1f5fa': "\uD83D\uDDFA\uFE0F",
        '1f5ff': "\uD83D\uDDFF",
        '1f5fd': "\uD83D\uDDFD",
        '26f2': "\u26F2",
        '1f5fc': "\uD83D\uDDFC",
        '1f3f0': "\uD83C\uDFF0",
        '1f3ef': "\uD83C\uDFEF",
        '1f3df': "\uD83C\uDFDF\uFE0F",
        '1f3a1': "\uD83C\uDFA1",
        '1f3a2': "\uD83C\uDFA2",
        '1f3a0': "\uD83C\uDFA0",
        '26f1': "\u26F1\uFE0F",
        '1f3d6': "\uD83C\uDFD6\uFE0F",
        '1f3dd': "\uD83C\uDFDD\uFE0F",
        '26f0': "\u26F0\uFE0F",
        '1f3d4': "\uD83C\uDFD4\uFE0F",
        '1f5fb': "\uD83D\uDDFB",
        '1f30b': "\uD83C\uDF0B",
        '1f3dc': "\uD83C\uDFDC\uFE0F",
        '1f3d5': "\uD83C\uDFD5\uFE0F",
        '26fa': "\u26FA",
        '1f6e4': "\uD83D\uDEE4\uFE0F",
        '1f6e3': "\uD83D\uDEE3\uFE0F",
        '1f3d7': "\uD83C\uDFD7\uFE0F",
        '1f3ed': "\uD83C\uDFED",
        '1f3e0': "\uD83C\uDFE0",
        '1f3e1': "\uD83C\uDFE1",
        '1f3d8': "\uD83C\uDFD8\uFE0F",
        '1f3da': "\uD83C\uDFDA\uFE0F",
        '1f3e2': "\uD83C\uDFE2",
        '1f3ec': "\uD83C\uDFEC",
        '1f3e3': "\uD83C\uDFE3",
        '1f3e4': "\uD83C\uDFE4",
        '1f3e5': "\uD83C\uDFE5",
        '1f3e6': "\uD83C\uDFE6",
        '1f3e8': "\uD83C\uDFE8",
        '1f3ea': "\uD83C\uDFEA",
        '1f3eb': "\uD83C\uDFEB",
        '1f3e9': "\uD83C\uDFE9",
        '1f492': "\uD83D\uDC92",
        '1f3db': "\uD83C\uDFDB\uFE0F",
        '26ea': "\u26EA",
        '1f54c': "\uD83D\uDD4C",
        '1f54d': "\uD83D\uDD4D",
        '1f54b': "\uD83D\uDD4B",
        '26e9': "\u26E9\uFE0F",
        '1f5fe': "\uD83D\uDDFE",
        '1f391': "\uD83C\uDF91",
        '1f3de': "\uD83C\uDFDE\uFE0F",
        '1f305': "\uD83C\uDF05",
        '1f304': "\uD83C\uDF04",
        '1f320': "\uD83C\uDF20",
        '1f387': "\uD83C\uDF87",
        '1f386': "\uD83C\uDF86",
        '1f307': "\uD83C\uDF07",
        '1f306': "\uD83C\uDF06",
        '1f3d9': "\uD83C\uDFD9\uFE0F",
        '1f303': "\uD83C\uDF03",
        '1f30c': "\uD83C\uDF0C",
        '1f309': "\uD83C\uDF09",
        '1f301': "\uD83C\uDF01",
        '1f6f8': "\uD83D\uDEF8",
        '231a': "\u231A",
        '1f4f1': "\uD83D\uDCF1",
        '1f4f2': "\uD83D\uDCF2",
        '1f4bb': "\uD83D\uDCBB",
        '2328': "\u2328\uFE0F",
        '1f5a5': "\uD83D\uDDA5\uFE0F",
        '1f5a8': "\uD83D\uDDA8\uFE0F",
        '1f5b1': "\uD83D\uDDB1\uFE0F",
        '1f5b2': "\uD83D\uDDB2\uFE0F",
        '1f579': "\uD83D\uDD79\uFE0F",
        '1f5dc': "\uD83D\uDDDC\uFE0F",
        '1f4bd': "\uD83D\uDCBD",
        '1f4be': "\uD83D\uDCBE",
        '1f4bf': "\uD83D\uDCBF",
        '1f4c0': "\uD83D\uDCC0",
        '1f4fc': "\uD83D\uDCFC",
        '1f4f7': "\uD83D\uDCF7",
        '1f4f8': "\uD83D\uDCF8",
        '1f4f9': "\uD83D\uDCF9",
        '1f3a5': "\uD83C\uDFA5",
        '1f4fd': "\uD83D\uDCFD\uFE0F",
        '1f39e': "\uD83C\uDF9E\uFE0F",
        '1f4de': "\uD83D\uDCDE",
        '260e': "\u260E\uFE0F",
        '1f4df': "\uD83D\uDCDF",
        '1f4e0': "\uD83D\uDCE0",
        '1f4fa': "\uD83D\uDCFA",
        '1f4fb': "\uD83D\uDCFB",
        '1f399': "\uD83C\uDF99\uFE0F",
        '1f39a': "\uD83C\uDF9A\uFE0F",
        '1f39b': "\uD83C\uDF9B\uFE0F",
        '23f1': "\u23F1\uFE0F",
        '23f2': "\u23F2\uFE0F",
        '23f0': "\u23F0",
        '1f570': "\uD83D\uDD70\uFE0F",
        '231b': "\u231B",
        '23f3': "\u23F3",
        '1f4e1': "\uD83D\uDCE1",
        '1f50b': "\uD83D\uDD0B",
        '1f50c': "\uD83D\uDD0C",
        '1f4a1': "\uD83D\uDCA1",
        '1f526': "\uD83D\uDD26",
        '1f56f': "\uD83D\uDD6F\uFE0F",
        '1f5d1': "\uD83D\uDDD1\uFE0F",
        '1f6e2': "\uD83D\uDEE2\uFE0F",
        '1f4b8': "\uD83D\uDCB8",
        '1f4b5': "\uD83D\uDCB5",
        '1f4b4': "\uD83D\uDCB4",
        '1f4b6': "\uD83D\uDCB6",
        '1f4b7': "\uD83D\uDCB7",
        '1f4b0': "\uD83D\uDCB0",
        '1f4b3': "\uD83D\uDCB3",
        '1f48e': "\uD83D\uDC8E",
        '2696': "\u2696\uFE0F",
        '1f527': "\uD83D\uDD27",
        '1f528': "\uD83D\uDD28",
        '2692': "\u2692\uFE0F",
        '1f6e0': "\uD83D\uDEE0\uFE0F",
        '26cf': "\u26CF\uFE0F",
        '1f529': "\uD83D\uDD29",
        '2699': "\u2699\uFE0F",
        '26d3': "\u26D3\uFE0F",
        '1f52b': "\uD83D\uDD2B",
        '1f4a3': "\uD83D\uDCA3",
        '1f52a': "\uD83D\uDD2A",
        '1f5e1': "\uD83D\uDDE1\uFE0F",
        '2694': "\u2694\uFE0F",
        '1f6e1': "\uD83D\uDEE1\uFE0F",
        '1f6ac': "\uD83D\uDEAC",
        '26b0': "\u26B0\uFE0F",
        '26b1': "\u26B1\uFE0F",
        '1f3fa': "\uD83C\uDFFA",
        '1f52e': "\uD83D\uDD2E",
        '1f4ff': "\uD83D\uDCFF",
        '1f488': "\uD83D\uDC88",
        '2697': "\u2697\uFE0F",
        '1f52d': "\uD83D\uDD2D",
        '1f52c': "\uD83D\uDD2C",
        '1f573': "\uD83D\uDD73\uFE0F",
        '1f48a': "\uD83D\uDC8A",
        '1f489': "\uD83D\uDC89",
        '1f321': "\uD83C\uDF21\uFE0F",
        '1f6bd': "\uD83D\uDEBD",
        '1f6b0': "\uD83D\uDEB0",
        '1f6bf': "\uD83D\uDEBF",
        '1f6c1': "\uD83D\uDEC1",
        '1f6c0': "\uD83D\uDEC0",
        '1f6ce': "\uD83D\uDECE\uFE0F",
        '1f511': "\uD83D\uDD11",
        '1f5dd': "\uD83D\uDDDD\uFE0F",
        '1f6aa': "\uD83D\uDEAA",
        '1f6cb': "\uD83D\uDECB\uFE0F",
        '1f6cf': "\uD83D\uDECF\uFE0F",
        '1f6cc': "\uD83D\uDECC",
        '1f5bc': "\uD83D\uDDBC\uFE0F",
        '1f6cd': "\uD83D\uDECD\uFE0F",
        '1f6d2': "\uD83D\uDED2",
        '1f381': "\uD83C\uDF81",
        '1f388': "\uD83C\uDF88",
        '1f38f': "\uD83C\uDF8F",
        '1f380': "\uD83C\uDF80",
        '1f38a': "\uD83C\uDF8A",
        '1f389': "\uD83C\uDF89",
        '1f38e': "\uD83C\uDF8E",
        '1f3ee': "\uD83C\uDFEE",
        '1f390': "\uD83C\uDF90",
        '2709': "\u2709\uFE0F",
        '1f4e9': "\uD83D\uDCE9",
        '1f4e8': "\uD83D\uDCE8",
        '1f4e7': "\uD83D\uDCE7",
        '1f48c': "\uD83D\uDC8C",
        '1f4e5': "\uD83D\uDCE5",
        '1f4e4': "\uD83D\uDCE4",
        '1f4e6': "\uD83D\uDCE6",
        '1f3f7': "\uD83C\uDFF7\uFE0F",
        '1f4ea': "\uD83D\uDCEA",
        '1f4eb': "\uD83D\uDCEB",
        '1f4ec': "\uD83D\uDCEC",
        '1f4ed': "\uD83D\uDCED",
        '1f4ee': "\uD83D\uDCEE",
        '1f4ef': "\uD83D\uDCEF",
        '1f4dc': "\uD83D\uDCDC",
        '1f4c3': "\uD83D\uDCC3",
        '1f4c4': "\uD83D\uDCC4",
        '1f4d1': "\uD83D\uDCD1",
        '1f4ca': "\uD83D\uDCCA",
        '1f4c8': "\uD83D\uDCC8",
        '1f4c9': "\uD83D\uDCC9",
        '1f5d2': "\uD83D\uDDD2\uFE0F",
        '1f5d3': "\uD83D\uDDD3\uFE0F",
        '1f4c6': "\uD83D\uDCC6",
        '1f4c5': "\uD83D\uDCC5",
        '1f4c7': "\uD83D\uDCC7",
        '1f5c3': "\uD83D\uDDC3\uFE0F",
        '1f5f3': "\uD83D\uDDF3\uFE0F",
        '1f5c4': "\uD83D\uDDC4\uFE0F",
        '1f4cb': "\uD83D\uDCCB",
        '1f4c1': "\uD83D\uDCC1",
        '1f4c2': "\uD83D\uDCC2",
        '1f5c2': "\uD83D\uDDC2\uFE0F",
        '1f5de': "\uD83D\uDDDE\uFE0F",
        '1f4f0': "\uD83D\uDCF0",
        '1f4d3': "\uD83D\uDCD3",
        '1f4d4': "\uD83D\uDCD4",
        '1f4d2': "\uD83D\uDCD2",
        '1f4d5': "\uD83D\uDCD5",
        '1f4d7': "\uD83D\uDCD7",
        '1f4d8': "\uD83D\uDCD8",
        '1f4d9': "\uD83D\uDCD9",
        '1f4da': "\uD83D\uDCDA",
        '1f4d6': "\uD83D\uDCD6",
        '1f516': "\uD83D\uDD16",
        '1f517': "\uD83D\uDD17",
        '1f4ce': "\uD83D\uDCCE",
        '1f587': "\uD83D\uDD87\uFE0F",
        '1f4d0': "\uD83D\uDCD0",
        '1f4cf': "\uD83D\uDCCF",
        '1f4cc': "\uD83D\uDCCC",
        '1f4cd': "\uD83D\uDCCD",
        '2702': "\u2702\uFE0F",
        '1f58a': "\uD83D\uDD8A\uFE0F",
        '1f58b': "\uD83D\uDD8B\uFE0F",
        '2712': "\u2712\uFE0F",
        '1f58c': "\uD83D\uDD8C\uFE0F",
        '1f58d': "\uD83D\uDD8D\uFE0F",
        '1f4dd': "\uD83D\uDCDD",
        '270f': "\u270F\uFE0F",
        '1f50d': "\uD83D\uDD0D",
        '1f50e': "\uD83D\uDD0E",
        '1f50f': "\uD83D\uDD0F",
        '1f510': "\uD83D\uDD10",
        '1f512': "\uD83D\uDD12",
        '1f513': "\uD83D\uDD13",
        '1f9e1': "\uD83E\uDDE1",
        '2764': "\u2764\uFE0F",
        '1f49b': "\uD83D\uDC9B",
        '1f49a': "\uD83D\uDC9A",
        '1f499': "\uD83D\uDC99",
        '1f49c': "\uD83D\uDC9C",
        '1f5a4': "\uD83D\uDDA4",
        '1f494': "\uD83D\uDC94",
        '2763': "\u2763\uFE0F",
        '1f495': "\uD83D\uDC95",
        '1f49e': "\uD83D\uDC9E",
        '1f493': "\uD83D\uDC93",
        '1f497': "\uD83D\uDC97",
        '1f496': "\uD83D\uDC96",
        '1f498': "\uD83D\uDC98",
        '1f49d': "\uD83D\uDC9D",
        '1f49f': "\uD83D\uDC9F",
        '262e': "\u262E\uFE0F",
        '271d': "\u271D\uFE0F",
        '262a': "\u262A\uFE0F",
        '1f549': "\uD83D\uDD49\uFE0F",
        '2638': "\u2638\uFE0F",
        '2721': "\u2721\uFE0F",
        '1f52f': "\uD83D\uDD2F",
        '1f54e': "\uD83D\uDD4E",
        '262f': "\u262F\uFE0F",
        '2626': "\u2626\uFE0F",
        '1f6d0': "\uD83D\uDED0",
        '26ce': "\u26CE",
        '2648': "\u2648",
        '2649': "\u2649",
        '264a': "\u264A",
        '264b': "\u264B",
        '264c': "\u264C",
        '264d': "\u264D",
        '264e': "\u264E",
        '264f': "\u264F",
        '2650': "\u2650",
        '2651': "\u2651",
        '2652': "\u2652",
        '2653': "\u2653",
        '1f194': "\uD83C\uDD94",
        '269b': "\u269B\uFE0F",
        '1f251': "\uD83C\uDE51",
        '2622': "\u2622\uFE0F",
        '2623': "\u2623\uFE0F",
        '1f4f4': "\uD83D\uDCF4",
        '1f4f3': "\uD83D\uDCF3",
        '1f236': "\uD83C\uDE36",
        '1f21a': "\uD83C\uDE1A",
        '1f238': "\uD83C\uDE38",
        '1f23a': "\uD83C\uDE3A",
        '1f237': "\uD83C\uDE37\uFE0F",
        '2734': "\u2734\uFE0F",
        '1f19a': "\uD83C\uDD9A",
        '1f4ae': "\uD83D\uDCAE",
        '1f250': "\uD83C\uDE50",
        '3299': "\u3299\uFE0F",
        '3297': "\u3297\uFE0F",
        '1f234': "\uD83C\uDE34",
        '1f235': "\uD83C\uDE35",
        '1f239': "\uD83C\uDE39",
        '1f232': "\uD83C\uDE32",
        '1f170': "\uD83C\uDD70\uFE0F",
        '1f171': "\uD83C\uDD71\uFE0F",
        '1f18e': "\uD83C\uDD8E",
        '1f191': "\uD83C\uDD91",
        '1f17e': "\uD83C\uDD7E\uFE0F",
        '1f198': "\uD83C\uDD98",
        '274c': "\u274C",
        '2b55': "\u2B55",
        '1f6d1': "\uD83D\uDED1",
        '26d4': "\u26D4",
        '1f4db': "\uD83D\uDCDB",
        '1f6ab': "\uD83D\uDEAB",
        '1f4af': "\uD83D\uDCAF",
        '1f4a2': "\uD83D\uDCA2",
        '2668': "\u2668\uFE0F",
        '1f6b7': "\uD83D\uDEB7",
        '1f6af': "\uD83D\uDEAF",
        '1f6b3': "\uD83D\uDEB3",
        '1f6b1': "\uD83D\uDEB1",
        '1f51e': "\uD83D\uDD1E",
        '1f4f5': "\uD83D\uDCF5",
        '1f6ad': "\uD83D\uDEAD",
        '2757': "\u2757",
        '2755': "\u2755",
        '2753': "\u2753",
        '2754': "\u2754",
        '203c': "\u203C\uFE0F",
        '2049': "\u2049\uFE0F",
        '1f505': "\uD83D\uDD05",
        '1f506': "\uD83D\uDD06",
        '303d': "\u303D\uFE0F",
        '26a0': "\u26A0\uFE0F",
        '1f6b8': "\uD83D\uDEB8",
        '1f531': "\uD83D\uDD31",
        '269c': "\u269C\uFE0F",
        '1f530': "\uD83D\uDD30",
        '267b': "\u267B\uFE0F",
        '2705': "\u2705",
        '1f22f': "\uD83C\uDE2F",
        '1f4b9': "\uD83D\uDCB9",
        '2747': "\u2747\uFE0F",
        '2733': "\u2733\uFE0F",
        '274e': "\u274E",
        '1f310': "\uD83C\uDF10",
        '1f4a0': "\uD83D\uDCA0",
        '24c2': "\u24C2\uFE0F",
        '1f300': "\uD83C\uDF00",
        '1f4a4': "\uD83D\uDCA4",
        '1f3e7': "\uD83C\uDFE7",
        '1f6be': "\uD83D\uDEBE",
        '267f': "\u267F",
        '1f17f': "\uD83C\uDD7F\uFE0F",
        '1f233': "\uD83C\uDE33",
        '1f202': "\uD83C\uDE02\uFE0F",
        '1f6c2': "\uD83D\uDEC2",
        '1f6c3': "\uD83D\uDEC3",
        '1f6c4': "\uD83D\uDEC4",
        '1f6c5': "\uD83D\uDEC5",
        '1f6b9': "\uD83D\uDEB9",
        '1f6ba': "\uD83D\uDEBA",
        '1f6bc': "\uD83D\uDEBC",
        '1f6bb': "\uD83D\uDEBB",
        '1f6ae': "\uD83D\uDEAE",
        '1f3a6': "\uD83C\uDFA6",
        '1f4f6': "\uD83D\uDCF6",
        '1f201': "\uD83C\uDE01",
        '1f523': "\uD83D\uDD23",
        '2139': "\u2139\uFE0F",
        '1f524': "\uD83D\uDD24",
        '1f521': "\uD83D\uDD21",
        '1f520': "\uD83D\uDD20",
        '1f196': "\uD83C\uDD96",
        '1f197': "\uD83C\uDD97",
        '1f199': "\uD83C\uDD99",
        '1f192': "\uD83C\uDD92",
        '1f195': "\uD83C\uDD95",
        '1f193': "\uD83C\uDD93",
        '30-20e3': "0\uFE0F\u20E3",
        '31-20e3': "1\uFE0F\u20E3",
        '32-20e3': "2\uFE0F\u20E3",
        '33-20e3': "3\uFE0F\u20E3",
        '34-20e3': "4\uFE0F\u20E3",
        '35-20e3': "5\uFE0F\u20E3",
        '36-20e3': "6\uFE0F\u20E3",
        '37-20e3': "7\uFE0F\u20E3",
        '38-20e3': "8\uFE0F\u20E3",
        '39-20e3': "9\uFE0F\u20E3",
        '1f51f': "\uD83D\uDD1F",
        '1f522': "\uD83D\uDD22",
        '23-20e3': "#\uFE0F\u20E3",
        '2a-20e3': "*\uFE0F\u20E3",
        '25b6': "\u25B6\uFE0F",
        '23f8': "\u23F8\uFE0F",
        '23ef': "\u23EF\uFE0F",
        '23f9': "\u23F9\uFE0F",
        '23fa': "\u23FA\uFE0F",
        '23cf': "\u23CF\uFE0F",
        '23ed': "\u23ED\uFE0F",
        '23ee': "\u23EE\uFE0F",
        '23e9': "\u23E9",
        '23ea': "\u23EA",
        '23eb': "\u23EB",
        '23ec': "\u23EC",
        '25c0': "\u25C0\uFE0F",
        '1f53c': "\uD83D\uDD3C",
        '1f53d': "\uD83D\uDD3D",
        '27a1': "\u27A1\uFE0F",
        '2b05': "\u2B05\uFE0F",
        '2b06': "\u2B06\uFE0F",
        '2b07': "\u2B07\uFE0F",
        '2197': "\u2197\uFE0F",
        '2198': "\u2198\uFE0F",
        '2199': "\u2199\uFE0F",
        '2196': "\u2196\uFE0F",
        '2195': "\u2195\uFE0F",
        '2194': "\u2194\uFE0F",
        '21aa': "\u21AA\uFE0F",
        '21a9': "\u21A9\uFE0F",
        '2934': "\u2934\uFE0F",
        '2935': "\u2935\uFE0F",
        '1f500': "\uD83D\uDD00",
        '1f501': "\uD83D\uDD01",
        '1f502': "\uD83D\uDD02",
        '1f504': "\uD83D\uDD04",
        '1f503': "\uD83D\uDD03",
        '1f3b5': "\uD83C\uDFB5",
        '1f3b6': "\uD83C\uDFB6",
        '2795': "\u2795",
        '2796': "\u2796",
        '2797': "\u2797",
        '2716': "\u2716\uFE0F",
        '1f4b2': "\uD83D\uDCB2",
        '1f4b1': "\uD83D\uDCB1",
        '2122': "\u2122\uFE0F",
        a9: "\xa9\uFE0F",
        ae: "\xae\uFE0F",
        '3030': "\u3030\uFE0F",
        '27b0': "\u27B0",
        '27bf': "\u27BF",
        '1f51a': "\uD83D\uDD1A",
        '1f519': "\uD83D\uDD19",
        '1f51b': "\uD83D\uDD1B",
        '1f51d': "\uD83D\uDD1D",
        '1f51c': "\uD83D\uDD1C",
        '2714': "\u2714\uFE0F",
        '2611': "\u2611\uFE0F",
        '1f518': "\uD83D\uDD18",
        '26aa': "\u26AA",
        '26ab': "\u26AB",
        '1f534': "\uD83D\uDD34",
        '1f535': "\uD83D\uDD35",
        '1f53a': "\uD83D\uDD3A",
        '1f53b': "\uD83D\uDD3B",
        '1f538': "\uD83D\uDD38",
        '1f539': "\uD83D\uDD39",
        '1f536': "\uD83D\uDD36",
        '1f537': "\uD83D\uDD37",
        '1f533': "\uD83D\uDD33",
        '1f532': "\uD83D\uDD32",
        '25aa': "\u25AA\uFE0F",
        '25ab': "\u25AB\uFE0F",
        '25fe': "\u25FE",
        '25fd': "\u25FD",
        '25fc': "\u25FC\uFE0F",
        '25fb': "\u25FB\uFE0F",
        '2b1b': "\u2B1B",
        '2b1c': "\u2B1C",
        '1f508': "\uD83D\uDD08",
        '1f507': "\uD83D\uDD07",
        '1f509': "\uD83D\uDD09",
        '1f50a': "\uD83D\uDD0A",
        '1f514': "\uD83D\uDD14",
        '1f515': "\uD83D\uDD15",
        '1f4e3': "\uD83D\uDCE3",
        '1f4e2': "\uD83D\uDCE2",
        '1f5e8': "\uD83D\uDDE8\uFE0F",
        '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
        '1f4ac': "\uD83D\uDCAC",
        '1f4ad': "\uD83D\uDCAD",
        '1f5ef': "\uD83D\uDDEF\uFE0F",
        '2660': "\u2660\uFE0F",
        '2663': "\u2663\uFE0F",
        '2665': "\u2665\uFE0F",
        '2666': "\u2666\uFE0F",
        '1f0cf': "\uD83C\uDCCF",
        '1f3b4': "\uD83C\uDFB4",
        '1f004': "\uD83C\uDC04",
        '1f550': "\uD83D\uDD50",
        '1f551': "\uD83D\uDD51",
        '1f552': "\uD83D\uDD52",
        '1f553': "\uD83D\uDD53",
        '1f554': "\uD83D\uDD54",
        '1f555': "\uD83D\uDD55",
        '1f556': "\uD83D\uDD56",
        '1f557': "\uD83D\uDD57",
        '1f558': "\uD83D\uDD58",
        '1f559': "\uD83D\uDD59",
        '1f55a': "\uD83D\uDD5A",
        '1f55b': "\uD83D\uDD5B",
        '1f55c': "\uD83D\uDD5C",
        '1f55d': "\uD83D\uDD5D",
        '1f55e': "\uD83D\uDD5E",
        '1f55f': "\uD83D\uDD5F",
        '1f560': "\uD83D\uDD60",
        '1f561': "\uD83D\uDD61",
        '1f562': "\uD83D\uDD62",
        '1f563': "\uD83D\uDD63",
        '1f564': "\uD83D\uDD64",
        '1f565': "\uD83D\uDD65",
        '1f566': "\uD83D\uDD66",
        '1f567': "\uD83D\uDD67",
        '1f3f3': "\uD83C\uDFF3\uFE0F",
        '1f3f4': "\uD83C\uDFF4",
        '1f3c1': "\uD83C\uDFC1",
        '1f6a9': "\uD83D\uDEA9",
        '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
        '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
        '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
        '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
        '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
        '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
        '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
        '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
        '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
        '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
        '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
        '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
        '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
        '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
        '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
        '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
        '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
        '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
        '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
        '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
        '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
        '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
        '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
        '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
        '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
        '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
        '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
        '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
        '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
        '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
        '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
        '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
        '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
        '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
        '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
        '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
        '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
        '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
        '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
        '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
        '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
        '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
        '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
        '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
        '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
        '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
        '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
        '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
        '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
        '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
        '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
        '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
        '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
        '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
        '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
        '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
        '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
        '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
        '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
        '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
        '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
        '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
        '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
        '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
        '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
        '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
        '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
        '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
        '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
        '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
        '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
        '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
        '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
        '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
        '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
        '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
        '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
        '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
        '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
        '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
        '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
        '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
        '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
        '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
        '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
        '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
        '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
        '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
        '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
        '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
        '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
        '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
        '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
        '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
        '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
        '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
        '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
        '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
        '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
        '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
        '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
        '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
        '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
        '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
        '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
        '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
        '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
        '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
        '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
        '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
        '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
        '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
        '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
        '1f38c': "\uD83C\uDF8C",
        '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
        '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
        '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
        '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
        '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
        '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
        '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
        '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
        '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
        '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
        '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
        '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
        '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
        '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
        '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
        '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
        '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
        '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
        '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
        '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
        '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
        '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
        '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
        '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
        '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
        '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
        '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
        '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
        '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
        '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
        '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
        '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
        '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
        '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
        '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
        '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
        '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
        '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
        '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
        '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
        '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
        '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
        '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
        '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
        '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
        '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
        '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
        '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
        '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
        '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
        '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
        '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
        '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
        '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
        '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
        '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
        '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
        '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
        '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
        '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
        '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
        '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
        '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
        '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
        '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
        '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
        '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
        '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
        '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
        '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
        '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
        '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
        '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
        '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
        '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
        '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
        '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
        '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
        '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
        '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
        '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
        '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
        '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
        '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
        '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
        '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
        '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
        '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
        '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
        '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
        '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
        '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
        '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
        '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
        '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
        '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
        '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
        '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
        '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
        '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
        '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
        '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
        '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
        '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
        '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
        '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
        '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
        '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
        '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
        '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
        '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
        '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
        '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
        '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
        '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
        '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
        '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
        '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
        '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
        '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
        '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
        '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
        '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
        '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
        '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
        '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
        '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
        '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
        '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
        '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
        '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
        '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
        '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
        '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
        '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
        '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
        '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
        '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
        '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
        '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
        '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
        '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
        '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
        '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
        '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
        '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
        '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
        '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
        '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
        '1f1ff': "\uD83C\uDDFF",
        '1f1fe': "\uD83C\uDDFE",
        '1f1fd': "\uD83C\uDDFD",
        '1f3fb': "\uD83C\uDFFB",
        '1f3fc': "\uD83C\uDFFC",
        '1f3fd': "\uD83C\uDFFD",
        '1f3fe': "\uD83C\uDFFE",
        '1f3ff': "\uD83C\uDFFF",
        '1f1fc': "\uD83C\uDDFC",
        '1f1fb': "\uD83C\uDDFB",
        '1f1fa': "\uD83C\uDDFA",
        '1f1f9': "\uD83C\uDDF9",
        '1f1f8': "\uD83C\uDDF8",
        '1f1f7': "\uD83C\uDDF7",
        '1f1f6': "\uD83C\uDDF6",
        '1f1f5': "\uD83C\uDDF5",
        '1f1f4': "\uD83C\uDDF4",
        '1f1f3': "\uD83C\uDDF3",
        '1f1f2': "\uD83C\uDDF2",
        '1f1f1': "\uD83C\uDDF1",
        '1f1f0': "\uD83C\uDDF0",
        '1f1ef': "\uD83C\uDDEF",
        '1f1ee': "\uD83C\uDDEE",
        '1f1ed': "\uD83C\uDDED",
        '1f1ec': "\uD83C\uDDEC",
        '1f1eb': "\uD83C\uDDEB",
        '1f1ea': "\uD83C\uDDEA",
        '1f1e9': "\uD83C\uDDE9",
        '1f1e8': "\uD83C\uDDE8",
        '1f1e7': "\uD83C\uDDE7",
        '1f1e6': "\uD83C\uDDE6",
        '2640': "\u2640\uFE0F",
        '2642': "\u2642\uFE0F",
        '2695': "\u2695\uFE0F",
        '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
        '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
        '1f928': "\uD83E\uDD28",
        '1f929': "\uD83E\uDD29",
        '1f92a': "\uD83E\uDD2A",
        '1f92b': "\uD83E\uDD2B",
        '1f92c': "\uD83E\uDD2C",
        '1f92d': "\uD83E\uDD2D",
        '1f92e': "\uD83E\uDD2E",
        '1f92f': "\uD83E\uDD2F",
        '1f9d0': "\uD83E\uDDD0",
        '1f9d1': "\uD83E\uDDD1",
        '1f9d2': "\uD83E\uDDD2",
        '1f9d3': "\uD83E\uDDD3",
        '1f9d4': "\uD83E\uDDD4",
        '1f9d5': "\uD83E\uDDD5",
        '1f9e0': "\uD83E\uDDE0",
        '1f9e2': "\uD83E\uDDE2",
        '1f9d9': "\uD83E\uDDD9",
        '1f9da': "\uD83E\uDDDA",
        '1f9db': "\uD83E\uDDDB",
        '1f9dc': "\uD83E\uDDDC",
        '1f9dd': "\uD83E\uDDDD",
        '1f9de': "\uD83E\uDDDE",
        '1f9df': "\uD83E\uDDDF",
        '1f9e3': "\uD83E\uDDE3",
        '1f9e4': "\uD83E\uDDE4",
        '1f9e5': "\uD83E\uDDE5",
        '1f9e6': "\uD83E\uDDE6",
        '1f91f': "\uD83E\uDD1F",
        '1f932': "\uD83E\uDD32",
        '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
        '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
        '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
        '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
        '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
        '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
        '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
        '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
        '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
        '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
        '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
        '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
        '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
        '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
        'atlassian-check_mark': '(/)',
        'atlassian-cross_mark': '(x)',
        'atlassian-plus': '(+)',
        'atlassian-minus': '(-)',
        'atlassian-light_bulb_on': '(on)',
        'atlassian-light_bulb_off': '(off)',
        'atlassian-flag_on': '(flag)',
        'atlassian-flag_off': '(flagoff)',
        'atlassian-warning': '(!)',
        'atlassian-question_mark': '(?)',
        'atlassian-info': '(i)',
        'atlassian-yellow_star': '(*y)',
        'atlassian-blue_star': '(*b)',
        'atlassian-green_star': '(*g)',
        'atlassian-red_star': '(*r)'
    };
});
parcelRegister("kjntr", function(module, exports) {
    $parcel$export(module.exports, "unknown", ()=>$ce2ebb4d4d6acec3$export$19282c40b967aec6);
    var $jLwE5;
    const $ce2ebb4d4d6acec3$var$jsonTransformer = new (0, (0, parcelRequire("jLwE5")).JSONTransformer)();
    const $ce2ebb4d4d6acec3$export$19282c40b967aec6 = (node)=>{
        const content = JSON.stringify($ce2ebb4d4d6acec3$var$jsonTransformer.encodeNode(node));
        return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
    };
});
parcelRegister("5dfLN", function(module, exports) {
    $parcel$export(module.exports, "hardBreak", ()=>$da1af233c2e52523$export$371da9dd35aba193);
    const $da1af233c2e52523$export$371da9dd35aba193 = (_node)=>{
        return '\n';
    };
});
parcelRegister("38SPg", function(module, exports) {
    $parcel$export(module.exports, "mediaInline", ()=>$28d32e995882cd08$export$38bab695e3f720f1);
    const $28d32e995882cd08$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
        let fileName;
        fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
        return `[^${fileName}]`;
    };
});
parcelRegister("3UNeh", function(module, exports) {
    $parcel$export(module.exports, "mention", ()=>$5e0f9e99dd39d133$export$db83999c14438df4);
    const $5e0f9e99dd39d133$var$PREFIX = 'accountid:';
    const $5e0f9e99dd39d133$var$UNKNOWN_USER = 'UNKNOWN_USER';
    const $5e0f9e99dd39d133$var$addPrefix = (content)=>content.toLowerCase().startsWith($5e0f9e99dd39d133$var$PREFIX) ? content : `${$5e0f9e99dd39d133$var$PREFIX}${content}`;
    const $5e0f9e99dd39d133$export$db83999c14438df4 = (node, { context: context } = {})=>{
        if (node.attrs.id === $5e0f9e99dd39d133$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
        const mentionKey = node.attrs.id.toLowerCase();
        const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $5e0f9e99dd39d133$var$addPrefix(node.attrs.id);
        return `[~${content}]`;
    };
});
parcelRegister("71tTl", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$293ec1762cdaf9d1$export$6f093cfa640b7166);
    var $QYqpZ;
    var $7xa0k;
    var $bZYA2;
    var $jELZl;
    var $gzE8d;
    var $iRXtU;
    var $hfgdh;
    var $f8Dnv;
    var $7f8rN;
    const $293ec1762cdaf9d1$var$markEncoderMapping = new Map([
        [
            'em',
            (0, (0, parcelRequire("jELZl")).em)
        ],
        [
            'strike',
            (0, (0, parcelRequire("iRXtU")).strike)
        ],
        [
            'strong',
            (0, (0, parcelRequire("hfgdh")).strong)
        ],
        [
            'subsup',
            (0, (0, parcelRequire("f8Dnv")).subsup)
        ],
        [
            'underline',
            (0, (0, parcelRequire("7f8rN")).underline)
        ],
        [
            'textColor',
            (0, (0, parcelRequire("bZYA2")).textColor)
        ],
        [
            'link',
            (0, (0, parcelRequire("gzE8d")).link)
        ],
        [
            'code',
            (0, (0, parcelRequire("7xa0k")).code)
        ]
    ]);
    const $293ec1762cdaf9d1$var$MENTION_ESCAPE_PATTERN = '(\\[~)';
    const $293ec1762cdaf9d1$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)';
    const $293ec1762cdaf9d1$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])';
    const $293ec1762cdaf9d1$var$isEscapeNeeded = (node, parent)=>{
        return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
    };
    function $293ec1762cdaf9d1$var$escapingWikiFormatter(text) {
        const pattern = [
            $293ec1762cdaf9d1$var$MENTION_ESCAPE_PATTERN,
            ...(0, (0, parcelRequire("QYqpZ")).macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
        ].join('|');
        return text.replace(new RegExp(pattern, 'g'), '\\$&').replace(new RegExp($293ec1762cdaf9d1$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2').replace(new RegExp($293ec1762cdaf9d1$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
    }
    const $293ec1762cdaf9d1$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
        let result = $293ec1762cdaf9d1$var$isEscapeNeeded(node, parent) ? $293ec1762cdaf9d1$var$escapingWikiFormatter(node.text) : node.text;
        $293ec1762cdaf9d1$var$markEncoderMapping.forEach((encoder, markName)=>{
            const mark = node.marks.find((m)=>m.type.name === markName);
            if (mark) result = encoder(result, mark.attrs);
        });
        return result;
    };
});
parcelRegister("QYqpZ", function(module, exports) {
    $parcel$export(module.exports, "macroKeywordTokenMap", ()=>$a89b0b22efdcbbd8$export$afcd7edeca61ca93);
    $parcel$export(module.exports, "parseMacroKeyword", ()=>$a89b0b22efdcbbd8$export$39c29c0b4f759e52);
    $parcel$export(module.exports, "parseOtherKeyword", ()=>$a89b0b22efdcbbd8$export$ce89e528658ee2ac);
    $parcel$export(module.exports, "parseLeadingKeyword", ()=>$a89b0b22efdcbbd8$export$68162fc57528b560);
    $parcel$export(module.exports, "parseIssueKeyword", ()=>$a89b0b22efdcbbd8$export$bcec6d03770b152c);
    var $aNQyn;
    var $aS0J2;
    const $a89b0b22efdcbbd8$export$afcd7edeca61ca93 = [
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).ADF_MACRO,
            regex: /^{adf/i
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).ANCHOR_MACRO,
            regex: /^{anchor/i
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).CODE_MACRO,
            regex: /^{code/i
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).QUOTE_MACRO,
            regex: /^{quote/i
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).NOFORMAT_MACRO,
            regex: /^{noformat/i
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).PANEL_MACRO,
            regex: /^{panel/i
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).COLOR_MACRO,
            regex: /^{color/
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).LOREM_MACRO,
            regex: /^{loremipsum/i
        }
    ];
    const $a89b0b22efdcbbd8$var$keywordTokenMap = {
        '[': (0, (0, parcelRequire("aNQyn")).TokenType).LINK_FORMAT,
        http: (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
        ftp: (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
        jamfselfservice: (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
        irc: (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
        mailto: (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
        '\\\\': (0, (0, parcelRequire("aNQyn")).TokenType).FORCE_LINE_BREAK,
        '\r': (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK,
        '\n': (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK,
        '\r\n': (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK,
        '!': (0, (0, parcelRequire("aNQyn")).TokenType).MEDIA,
        '----': (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
        '---': (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
        '--': (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
        '{-}': (0, (0, parcelRequire("aNQyn")).TokenType).DELETED,
        '{+}': (0, (0, parcelRequire("aNQyn")).TokenType).INSERTED,
        '{*}': (0, (0, parcelRequire("aNQyn")).TokenType).STRONG,
        '{^}': (0, (0, parcelRequire("aNQyn")).TokenType).SUPERSCRIPT,
        '{~}': (0, (0, parcelRequire("aNQyn")).TokenType).SUBSCRIPT,
        '{_}': (0, (0, parcelRequire("aNQyn")).TokenType).EMPHASIS,
        '{{{}': (0, (0, parcelRequire("aNQyn")).TokenType).MONOSPACE,
        '{??}': (0, (0, parcelRequire("aNQyn")).TokenType).CITATION,
        '-': (0, (0, parcelRequire("aNQyn")).TokenType).DELETED,
        '+': (0, (0, parcelRequire("aNQyn")).TokenType).INSERTED,
        '*': (0, (0, parcelRequire("aNQyn")).TokenType).STRONG,
        '^': (0, (0, parcelRequire("aNQyn")).TokenType).SUPERSCRIPT,
        '~': (0, (0, parcelRequire("aNQyn")).TokenType).SUBSCRIPT,
        _: (0, (0, parcelRequire("aNQyn")).TokenType).EMPHASIS,
        '{{': (0, (0, parcelRequire("aNQyn")).TokenType).MONOSPACE,
        '??': (0, (0, parcelRequire("aNQyn")).TokenType).CITATION
    };
    const $a89b0b22efdcbbd8$var$keywordTokenMapKeys = Object.keys($a89b0b22efdcbbd8$var$keywordTokenMap);
    function $a89b0b22efdcbbd8$export$39c29c0b4f759e52(input) {
        for(let i = 0; i < $a89b0b22efdcbbd8$export$afcd7edeca61ca93.length; i++){
            const keyword = $a89b0b22efdcbbd8$export$afcd7edeca61ca93[i];
            if (keyword.regex.test(input)) return {
                type: keyword.type
            };
        }
        return null;
    }
    function $a89b0b22efdcbbd8$export$ce89e528658ee2ac(input) {
        for(let i = 0; i < $a89b0b22efdcbbd8$var$keywordTokenMapKeys.length; i++){
            if (input.startsWith($a89b0b22efdcbbd8$var$keywordTokenMapKeys[i])) return {
                type: $a89b0b22efdcbbd8$var$keywordTokenMap[$a89b0b22efdcbbd8$var$keywordTokenMapKeys[i]]
            };
        }
        const char = input.charAt(0);
        if ([
            ':',
            '(',
            ';'
        ].indexOf(char) !== -1) return {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).EMOJI
        };
        return null;
    }
    const $a89b0b22efdcbbd8$var$leadingKeywordTokenMap = [
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).QUOTE,
            regex: /^bq\./
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).HEADING,
            regex: /^h[1-6]\./
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).RULER,
            regex: /^-{4,5}(\s|$)/
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            regex: /^-{3}\s/
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            regex: /^-{2}\s/
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).LIST,
            regex: new RegExp(`^([*#]{1,${(0, (0, parcelRequire("aS0J2")).MAX_LIST_DEPTH)}}|-) `)
        },
        {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).TABLE,
            regex: /^\|{1,2}/
        }
    ];
    function $a89b0b22efdcbbd8$export$68162fc57528b560(input) {
        for(let i = 0; i < $a89b0b22efdcbbd8$var$leadingKeywordTokenMap.length; i++){
            const keyword = $a89b0b22efdcbbd8$var$leadingKeywordTokenMap[i];
            if (keyword.regex.test(input)) return {
                type: keyword.type
            };
        }
        return null;
    }
    function $a89b0b22efdcbbd8$export$bcec6d03770b152c(input, issueKeyRegex) {
        if (issueKeyRegex && issueKeyRegex.test(input)) return {
            type: (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY
        };
        return null;
    }
});
parcelRegister("aNQyn", function(module, exports) {
    $parcel$export(module.exports, "TokenType", ()=>$1bf28fe08c0f85c4$export$f435f793048e7a0f);
    $parcel$export(module.exports, "parseToken", ()=>$1bf28fe08c0f85c4$export$af8f4e8328578827);
    var $5tJfb;
    var $iHU0h;
    var $hXmWC;
    var $bhGcp;
    var $eAYdE;
    var $6bw9N;
    var $84Nuv;
    var $3QCnP;
    var $iwiCz;
    var $aw5rH;
    var $aVm6p;
    var $kYY8c;
    var $aS0J2;
    var $gqu8t;
    var $aRcdQ;
    var $ejTUJ;
    var $j7X8D;
    var $ckpoY;
    var $31G7u;
    var $7LAPf;
    var $bv814;
    var $czfGv;
    var $6xW0F;
    var $bStxj;
    var $3GfRf;
    var $C9v5b;
    var $5x6Ur;
    var $fuaGT;
    var $7oSVB;
    var $77lzI;
    var $1bf28fe08c0f85c4$export$f435f793048e7a0f;
    (function(TokenType) {
        TokenType["ADF_MACRO"] = "ADF_MACRO";
        TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
        TokenType["CODE_MACRO"] = "CODE_MACRO";
        TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
        TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
        TokenType["PANEL_MACRO"] = "PANEL_MACRO";
        TokenType["COLOR_MACRO"] = "COLOR_MACRO";
        TokenType["LOREM_MACRO"] = "LOREM_MACRO";
        TokenType["QUOTE"] = "QUOTE";
        TokenType["STRING"] = "STRING";
        TokenType["ISSUE_KEY"] = "ISSUE_KEY";
        TokenType["LINK_FORMAT"] = "LINK_FORMAT";
        TokenType["LINK_TEXT"] = "LINK_TEXT";
        TokenType["MEDIA"] = "MEDIA";
        TokenType["HEADING"] = "HEADING";
        TokenType["LIST"] = "LIST";
        TokenType["TABLE"] = "TABLE";
        TokenType["RULER"] = "RULER";
        TokenType["HARD_BREAK"] = "HARD_BREAK";
        TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
        TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
        TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
        TokenType["STRONG"] = "STRONG";
        TokenType["MONOSPACE"] = "MONOSPACE";
        TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
        TokenType["SUBSCRIPT"] = "SUBSCRIPT";
        TokenType["EMPHASIS"] = "EMPHASIS";
        TokenType["CITATION"] = "CITATION";
        TokenType["DELETED"] = "DELETED";
        TokenType["INSERTED"] = "INSERTED";
        TokenType["EMOJI"] = "EMOJI";
        TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    })($1bf28fe08c0f85c4$export$f435f793048e7a0f || ($1bf28fe08c0f85c4$export$f435f793048e7a0f = {}));
    const $1bf28fe08c0f85c4$var$tokenToTokenParserMapping = {
        ["DOUBLE_DASH_SYMBOL"]: (0, (0, parcelRequire("eAYdE")).doubleDashSymbol),
        ["TRIPLE_DASH_SYMBOL"]: (0, (0, parcelRequire("bv814")).tripleDashSymbol),
        ["QUADRUPLE_DASH_SYMBOL"]: (0, (0, parcelRequire("aRcdQ")).quadrupleDashSymbol),
        ["RULER"]: (0, (0, parcelRequire("ejTUJ")).ruler),
        ["STRONG"]: (0, (0, parcelRequire("j7X8D")).strong),
        ["MONOSPACE"]: (0, (0, parcelRequire("gqu8t")).monospace),
        ["SUPERSCRIPT"]: (0, (0, parcelRequire("31G7u")).superscript),
        ["SUBSCRIPT"]: (0, (0, parcelRequire("ckpoY")).subscript),
        ["EMPHASIS"]: (0, (0, parcelRequire("84Nuv")).emphasis),
        ["CITATION"]: (0, (0, parcelRequire("hXmWC")).citation),
        ["DELETED"]: (0, (0, parcelRequire("bhGcp")).deleted),
        ["INSERTED"]: (0, (0, parcelRequire("aw5rH")).inserted),
        ["HARD_BREAK"]: (0, (0, parcelRequire("3QCnP")).hardbreak),
        ["LINK_FORMAT"]: (0, (0, parcelRequire("aVm6p")).linkFormat),
        ["LINK_TEXT"]: (0, (0, parcelRequire("kYY8c")).linkText),
        ["HEADING"]: (0, (0, parcelRequire("iwiCz")).heading),
        ["MEDIA"]: (0, (0, parcelRequire("5tJfb")).media),
        ["LIST"]: (0, (0, parcelRequire("aS0J2")).list),
        ["QUOTE"]: (0, (0, parcelRequire("iHU0h")).blockquote),
        ["TABLE"]: (0, (0, parcelRequire("7LAPf")).table),
        ["EMOJI"]: (0, (0, parcelRequire("6bw9N")).emoji),
        ["ADF_MACRO"]: (0, (0, parcelRequire("6xW0F")).adfMacro),
        ["ANCHOR_MACRO"]: (0, (0, parcelRequire("bStxj")).anchorMacro),
        ["CODE_MACRO"]: (0, (0, parcelRequire("3GfRf")).codeMacro),
        ["QUOTE_MACRO"]: (0, (0, parcelRequire("C9v5b")).quoteMacro),
        ["NOFORMAT_MACRO"]: (0, (0, parcelRequire("fuaGT")).noformatMacro),
        ["PANEL_MACRO"]: (0, (0, parcelRequire("czfGv")).panelMacro),
        ["COLOR_MACRO"]: (0, (0, parcelRequire("5x6Ur")).colorMacro),
        ["FORCE_LINE_BREAK"]: (0, (0, parcelRequire("7oSVB")).forceLineBreak),
        ["ISSUE_KEY"]: (0, (0, parcelRequire("77lzI")).issueKey)
    };
    function $1bf28fe08c0f85c4$export$af8f4e8328578827(input, type, position, schema, context) {
        const tokenParser = $1bf28fe08c0f85c4$var$tokenToTokenParserMapping[type];
        if (tokenParser) try {
            return tokenParser({
                input: input,
                position: position,
                schema: schema,
                context: context
            });
        } catch (err) {
            if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
            return $1bf28fe08c0f85c4$var$fallback(input, position);
        }
        return $1bf28fe08c0f85c4$var$fallback(input, position);
    }
    function $1bf28fe08c0f85c4$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("5tJfb", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$7a7fca4045a75621$export$987d49ffe1b0900f);
    var $dfbkA;
    var $lmw7e;
    var $k6dG2;
    const $7a7fca4045a75621$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
        const rawContentProcessor = (raw, length)=>{
            const [rawContent, rawAttrs = ''] = raw.split('|');
            const node = (0, (0, parcelRequire("dfbkA")).default)(schema, rawContent, (0, (0, parcelRequire("lmw7e")).parseAttrs)(rawAttrs, ','), context);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        };
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: '!',
            closing: '!',
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("dfbkA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2563dfb73c7b99a6$export$2e2bcd8739ae039);
    var $kYY8c;
    const $2563dfb73c7b99a6$var$defaultWidth = 200;
    const $2563dfb73c7b99a6$var$defaultHeight = 183;
    const $2563dfb73c7b99a6$var$clamp = (input, lower, upper)=>{
        if (upper !== undefined) input = input <= upper ? input : upper;
        if (lower !== undefined) input = input >= lower ? input : lower;
        return input;
    };
    function $2563dfb73c7b99a6$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const { link: link } = schema.marks;
        const mediaMarks = [];
        let mediaNodeAttrs = {};
        if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2563dfb73c7b99a6$var$defaultWidth;
        if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2563dfb73c7b99a6$var$defaultHeight;
        const mediaSingleAttrs = {
            layout: 'center'
        };
        if (attrs.width && attrs.width.endsWith('%')) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaSingleAttrs.width = $2563dfb73c7b99a6$var$clamp(parsed, 0, 100);
            mediaNodeAttrs = {};
        } else {
            if (attrs.width) {
                const parsed = parseInt(attrs.width, 10);
                if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
            }
            if (attrs.height) {
                const parsed = parseInt(attrs.height, 10);
                if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
            }
        }
        if (attrs.href) {
            const href = attrs.href.replace(/^"(.+)"$/, '$1');
            mediaMarks.push(link.create({
                href: href
            }));
        }
        if (attrs.alt) {
            const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
            mediaNodeAttrs.alt = altText;
        }
        if (filename.match((0, (0, parcelRequire("kYY8c")).LINK_TEXT_REGEXP))) {
            const externalMediaNode = media.createChecked({
                type: 'external',
                url: filename,
                ...mediaNodeAttrs
            }, undefined, mediaMarks);
            return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
        } else {
            const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
            const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
            const mediaNode = media.createChecked({
                id: id,
                type: 'file',
                collection: collection || '',
                ...mediaNodeAttrs
            }, undefined, mediaMarks);
            return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
        }
    }
});
parcelRegister("kYY8c", function(module, exports) {
    $parcel$export(module.exports, "LINK_TEXT_REGEXP", ()=>$6abfe6aaa35ef072$export$f69d1dce349473aa);
    $parcel$export(module.exports, "linkText", ()=>$6abfe6aaa35ef072$export$cb7bcf09a05b7705);
    var $iZOJ9;
    var $lBjLf;
    const $6abfe6aaa35ef072$export$f69d1dce349473aa = /^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
    const $6abfe6aaa35ef072$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
        let matches = input.substring(position).match($6abfe6aaa35ef072$export$f69d1dce349473aa);
        if (!matches) return $6abfe6aaa35ef072$var$fallback(input, position);
        const match = $6abfe6aaa35ef072$var$trimBadEndChar(matches);
        const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
        const url = (0, (0, parcelRequire("lBjLf")).decode)($6abfe6aaa35ef072$var$unescape(match[0]));
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return $6abfe6aaa35ef072$var$fallback(input, position);
        const mark = schema.marks.link.create({
            href: url
        });
        const textNode = schema.text(textRepresentation, [
            mark
        ]);
        return {
            type: 'pmnode',
            nodes: [
                textNode
            ],
            length: match[0].length
        };
    };
    function $6abfe6aaa35ef072$var$unescape(url) {
        let result = '';
        for(let i = 0; i < url.length; i++){
            const char = url[i];
            if (char !== '\\') {
                result += char;
                continue;
            }
            const nextChar = url[i + 1];
            if (nextChar) {
                result += nextChar;
                i++;
            }
        }
        return result;
    }
    function $6abfe6aaa35ef072$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
    function $6abfe6aaa35ef072$var$trimBadEndChar(input) {
        return [
            input[0].replace(/[.,>)\];}"\'!]*$/, ''),
            input[1],
            input[2].replace(/[.,>)\];}"\'!]*$/, '')
        ];
    }
});
parcelRegister("lBjLf", function(module, exports) {
    $parcel$export(module.exports, "decode", ()=>$b1b3fd4c134d89e3$export$2f872c0f2117be69);
    function $b1b3fd4c134d89e3$export$2f872c0f2117be69(raw) {
        if (typeof URL === 'function') {
            const decoded = new URL(raw);
            if (decoded.href) return decoded.href;
        }
        const anchor = document.createElement('a');
        anchor.href = raw;
        return anchor.href;
    }
});
parcelRegister("lmw7e", function(module, exports) {
    $parcel$export(module.exports, "parseAttrs", ()=>$4c6e9c1f3ecea1ba$export$e1a9355cfd8f6c64);
    function $4c6e9c1f3ecea1ba$export$e1a9355cfd8f6c64(str, sep = '|') {
        const output = {};
        if (!str) return output;
        const attributesStr = str.split(sep);
        attributesStr.forEach((attributeStr)=>{
            const [key, ...value] = attributeStr.split('=');
            if (!output[key]) output[key] = value.join('=');
        });
        return output;
    }
});
parcelRegister("k6dG2", function(module, exports) {
    $parcel$export(module.exports, "commonFormatter", ()=>$5ba58e3324c6841b$export$a71d57024d3da1c5);
    var $aNQyn;
    var $aVm6p;
    var $jcXK3;
    var $QYqpZ;
    var $aNQyn;
    var $dvMBy;
    const $5ba58e3324c6841b$var$processState = {
        START: 0,
        BUFFER: 1,
        END: 2,
        INLINE_MACRO: 3,
        LINK_FORMAT: 4,
        ESCAPE: 5
    };
    function $5ba58e3324c6841b$export$a71d57024d3da1c5(input, position, schema, opt) {
        let index = position;
        let state = $5ba58e3324c6841b$var$processState.START;
        let buffer = [];
        const openingSymbolLength = opt.opening.length;
        const closingSymbolLength = opt.closing.length;
        const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
        const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
        while(index < input.length){
            const char = input.charAt(index);
            const twoChar = input.substr(index, 2);
            const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
            switch(state){
                case $5ba58e3324c6841b$var$processState.START:
                    {
                        if (position > 0) {
                            const charBeforeOpening = input.charAt(position - 1);
                            if (!openingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $5ba58e3324c6841b$var$fallback(input, index, openingSymbolLength);
                        }
                        const charAfterOpening = input.charAt(index + openingSymbolLength);
                        if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
                        state = $5ba58e3324c6841b$var$processState.BUFFER;
                        index += openingSymbolLength;
                        continue;
                    }
                case $5ba58e3324c6841b$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("jcXK3")).parseNewlineOnly)(input.substring(index));
                        if (length) return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
                        if (charsMatchClosingSymbol === opt.closing) {
                            state = $5ba58e3324c6841b$var$processState.END;
                            continue;
                        } else if (twoChar === '{{') {
                            buffer.push(twoChar);
                            index += 2;
                            continue;
                        } else if (char === '{') {
                            state = $5ba58e3324c6841b$var$processState.INLINE_MACRO;
                            continue;
                        } else if (char === '[') {
                            state = $5ba58e3324c6841b$var$processState.LINK_FORMAT;
                            continue;
                        } else if (char === '\\') {
                            state = $5ba58e3324c6841b$var$processState.ESCAPE;
                            continue;
                        } else buffer.push(char);
                        break;
                    }
                case $5ba58e3324c6841b$var$processState.END:
                    index += closingSymbolLength;
                    if (buffer.length === 0) return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
                    if (index < input.length) {
                        const charAfterEnd = input.charAt(index);
                        if (!closingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                            buffer.push(charsMatchClosingSymbol);
                            state = $5ba58e3324c6841b$var$processState.BUFFER;
                            continue;
                        }
                    }
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
                    return opt.rawContentProcessor(buffer.join(''), index - position);
                case $5ba58e3324c6841b$var$processState.INLINE_MACRO:
                    {
                        const match = (0, (0, parcelRequire("QYqpZ")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            state = $5ba58e3324c6841b$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("aNQyn")).parseToken)(input, match.type, index, schema, {});
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            state = $5ba58e3324c6841b$var$processState.BUFFER;
                            continue;
                        } else if (match.type === (0, (0, parcelRequire("aNQyn")).TokenType).COLOR_MACRO) {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            state = $5ba58e3324c6841b$var$processState.BUFFER;
                            continue;
                        } else return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
                    }
                case $5ba58e3324c6841b$var$processState.LINK_FORMAT:
                    {
                        const token = (0, (0, parcelRequire("aVm6p")).linkFormat)({
                            input: input,
                            schema: schema,
                            position: index,
                            context: {}
                        });
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            state = $5ba58e3324c6841b$var$processState.BUFFER;
                            continue;
                        } else if (token.type === 'pmnode') {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            state = $5ba58e3324c6841b$var$processState.BUFFER;
                            continue;
                        }
                        return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
                    }
                case $5ba58e3324c6841b$var$processState.ESCAPE:
                    {
                        const token = (0, (0, parcelRequire("dvMBy")).escapeHandler)(input, index);
                        buffer.push(token.text);
                        index += token.length;
                        state = $5ba58e3324c6841b$var$processState.BUFFER;
                        continue;
                    }
                default:
            }
            index++;
        }
        return $5ba58e3324c6841b$var$fallback(input, position, openingSymbolLength);
    }
    function $5ba58e3324c6841b$var$fallback(input, position, length) {
        return {
            type: 'text',
            text: input.substr(position, length),
            length: length
        };
    }
});
parcelRegister("aVm6p", function(module, exports) {
    $parcel$export(module.exports, "linkFormat", ()=>$a27dc8e290f74134$export$e1f888a4b6f2ee53);
    var $aNQyn;
    var $jfR8V;
    var $bcu6t;
    var $1hTYO;
    const $a27dc8e290f74134$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
    const $a27dc8e290f74134$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
        const match = input.substring(position).match($a27dc8e290f74134$var$LINK_FORMAT_REGEXP);
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE,
            (0, (0, parcelRequire("aNQyn")).TokenType).RULER,
            (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("aNQyn")).TokenType).LINK_FORMAT
        ];
        if (!match) return $a27dc8e290f74134$var$fallback();
        const content = (0, (0, parcelRequire("1hTYO")).parseContentLink)(match[1]);
        const resolvedLink = (0, (0, parcelRequire("bcu6t")).resolveLink)(content, schema, context);
        if (resolvedLink) return resolvedLink;
        const nodes = (0, (0, parcelRequire("jfR8V")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: match[0]
        });
        return {
            type: 'pmnode',
            nodes: nodes,
            length: match[0].length
        };
    };
    function $a27dc8e290f74134$var$fallback() {
        return {
            type: 'text',
            text: '[',
            length: 1
        };
    }
});
parcelRegister("jfR8V", function(module, exports) {
    $parcel$export(module.exports, "parseString", ()=>$feec748f91b47941$export$960addfb9e5a0cde);
    var $lqDVJ;
    var $QYqpZ;
    var $aNQyn;
    var $jcXK3;
    var $dvMBy;
    var $eZoBm;
    const $feec748f91b47941$var$processState = {
        NEWLINE: 0,
        BUFFER: 1,
        TOKEN: 2,
        ESCAPE: 3
    };
    function $feec748f91b47941$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
        let index = 0;
        let state = $feec748f91b47941$var$processState.NEWLINE;
        let buffer = [];
        let tokenType = (0, (0, parcelRequire("aNQyn")).TokenType).STRING;
        let newLines = [];
        const output = [];
        let inlineNodes = [];
        while(index < input.length){
            const char = input.charAt(index);
            switch(state){
                case $feec748f91b47941$var$processState.NEWLINE:
                    {
                        const substring = input.substring(index);
                        const length = (0, (0, parcelRequire("jcXK3")).parseWhitespaceOnly)(substring);
                        if (length) {
                            index += length;
                            if (includeLeadingSpace) buffer.push(char);
                            continue;
                        }
                        const match = (0, (0, parcelRequire("QYqpZ")).parseLeadingKeyword)(substring) || (0, (0, parcelRequire("QYqpZ")).parseMacroKeyword)(substring) || (0, (0, parcelRequire("QYqpZ")).parseOtherKeyword)(substring) || (0, (0, parcelRequire("QYqpZ")).parseIssueKeyword)(substring, context.issueKeyRegex);
                        if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                            tokenType = match.type;
                            state = $feec748f91b47941$var$processState.TOKEN;
                            continue;
                        } else {
                            state = $feec748f91b47941$var$processState.BUFFER;
                            continue;
                        }
                    }
                case $feec748f91b47941$var$processState.BUFFER:
                    {
                        const substring = input.substring(index);
                        let match = null;
                        if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, (0, parcelRequire("QYqpZ")).parseOtherKeyword)(substring);
                        else match = (0, (0, parcelRequire("QYqpZ")).parseMacroKeyword)(substring) || (0, (0, parcelRequire("QYqpZ")).parseOtherKeyword)(substring) || (0, (0, parcelRequire("QYqpZ")).parseIssueKeyword)(substring, context.issueKeyRegex);
                        if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                            tokenType = match.type;
                            state = $feec748f91b47941$var$processState.TOKEN;
                            continue;
                        }
                        if (char === '\\') {
                            state = $feec748f91b47941$var$processState.ESCAPE;
                            continue;
                        }
                        buffer.push(char);
                        break;
                    }
                case $feec748f91b47941$var$processState.TOKEN:
                    {
                        const token = (0, (0, parcelRequire("aNQyn")).parseToken)(input, tokenType, index, schema, context);
                        if (token.type === 'text') buffer.push(token.text);
                        else if (token.type === 'pmnode') {
                            if (newLines.length >= 2 && (tokenType !== (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK || buffer.length > 0)) {
                                output.push(...(0, (0, parcelRequire("eZoBm")).normalizePMNodes)(inlineNodes, schema));
                                inlineNodes = $feec748f91b47941$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                    ...newLines
                                ] : [];
                                newLines = [];
                            }
                            if (inlineNodes.length === 0) newLines = [];
                            if (newLines.length > 0 && $feec748f91b47941$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                                inlineNodes.push(...newLines);
                                newLines = [];
                            }
                            inlineNodes.push(...(0, (0, parcelRequire("lqDVJ")).createTextNode)(buffer.join(''), schema));
                            if (tokenType === (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK) newLines.push(...token.nodes);
                            else {
                                inlineNodes.push(...token.nodes);
                                if (token.nodes.length > 0) newLines = [];
                            }
                            buffer = [];
                        }
                        index += token.length;
                        if (tokenType === (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK) state = $feec748f91b47941$var$processState.NEWLINE;
                        else state = $feec748f91b47941$var$processState.BUFFER;
                        continue;
                    }
                case $feec748f91b47941$var$processState.ESCAPE:
                    {
                        const token = (0, (0, parcelRequire("dvMBy")).escapeHandler)(input, index);
                        buffer.push(token.text);
                        index += token.length;
                        state = $feec748f91b47941$var$processState.BUFFER;
                        continue;
                    }
                default:
            }
            index++;
        }
        const bufferedStr = buffer.join('');
        if (bufferedStr.length > 0) {
            if (newLines.length >= 2) {
                output.push(...(0, (0, parcelRequire("eZoBm")).normalizePMNodes)(inlineNodes, schema));
                inlineNodes = [];
                newLines = [];
            }
            if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
            inlineNodes.push(...(0, (0, parcelRequire("lqDVJ")).createTextNode)(bufferedStr, schema));
        }
        return [
            ...output,
            ...inlineNodes
        ];
    }
    function $feec748f91b47941$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
        if (currentNodes.length === 0) return false;
        if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
        if (buffer.length === 0) {
            if (nextNodes.length === 0) return false;
            if (nextNodes[0]?.type.name === 'hardBreak') return false;
            if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
        }
        return true;
    }
    function $feec748f91b47941$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
        return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
    }
});
parcelRegister("lqDVJ", function(module, exports) {
    $parcel$export(module.exports, "createTextNode", ()=>$2853cefb6d9f2b0b$export$b2ce9ad90858ed7a);
    function $2853cefb6d9f2b0b$export$b2ce9ad90858ed7a(input, schema, marks) {
        if (input === '') return [];
        const node = schema.text(input, marks || []);
        return [
            node
        ];
    }
});
parcelRegister("jcXK3", function(module, exports) {
    $parcel$export(module.exports, "parseNewlineOnly", ()=>$225d75175b39114d$export$1b7a83d725c8acf);
    $parcel$export(module.exports, "parseWhitespaceOnly", ()=>$225d75175b39114d$export$9c597b035e16623b);
    function $225d75175b39114d$export$877995a80ec11782(input) {
        const newlineLength = $225d75175b39114d$export$1b7a83d725c8acf(input);
        if (newlineLength) return newlineLength;
        const whitespaceLength = $225d75175b39114d$export$9c597b035e16623b(input);
        if (whitespaceLength) return whitespaceLength;
        return 0;
    }
    function $225d75175b39114d$export$9c597b035e16623b(input) {
        let index = 0;
        const char = input.charAt(index);
        if (char === '\t' || char === ' ') index++;
        return index;
    }
    function $225d75175b39114d$export$1b7a83d725c8acf(input) {
        let index = 0;
        const char = input.charAt(index);
        if (char === '\r') {
            index++;
            if (input.charAt(index) === '\n') index++;
        } else if (char === '\n') index++;
        return index;
    }
});
parcelRegister("dvMBy", function(module, exports) {
    $parcel$export(module.exports, "escapeHandler", ()=>$c86a1554ea460cb4$export$d16e8e6cf9622f9a);
    const $c86a1554ea460cb4$var$escapedChar = [
        '-',
        '#',
        '*',
        '_',
        '+',
        '?',
        '^',
        '~',
        '|',
        '%',
        '{',
        '}',
        '[',
        ']',
        '(',
        ')',
        '!',
        '@'
    ];
    function $c86a1554ea460cb4$export$d16e8e6cf9622f9a(input, position) {
        let buffer = [];
        const char = input.charAt(position);
        const prevChar = input.charAt(position - 1);
        const nextChar = input.charAt(position + 1);
        if ($c86a1554ea460cb4$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') buffer.push(char);
        buffer.push(nextChar);
        return {
            type: 'text',
            text: buffer.join(''),
            length: 2
        };
    }
});
parcelRegister("eZoBm", function(module, exports) {
    $parcel$export(module.exports, "normalizePMNodes", ()=>$882900fef3f71ea2$export$e21f6b7efdaf8b5d);
    var $aFfbR;
    function $882900fef3f71ea2$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
        return [
            $882900fef3f71ea2$var$normalizeMediaGroups,
            $882900fef3f71ea2$export$2cef2a4c047f9887,
            $882900fef3f71ea2$export$cd936b894f116ed8
        ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
    }
    function $882900fef3f71ea2$export$2cef2a4c047f9887(nodes, schema, parentNode) {
        const output = [];
        for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($882900fef3f71ea2$var$convertNodeToExpand(node, schema));
        else output.push(node);
        return output;
    }
    function $882900fef3f71ea2$export$cd936b894f116ed8(nodes, schema, _parentNode) {
        const output = [];
        let inlineNodeBuffer = [];
        for (const node of nodes){
            if (!node.isBlock) {
                inlineNodeBuffer.push(node);
                continue;
            }
            if (inlineNodeBuffer.length > 0) output.push(...(0, (0, parcelRequire("aFfbR")).createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
            inlineNodeBuffer = [];
            output.push(node);
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, (0, parcelRequire("aFfbR")).createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        if (output.length === 0) return [
            (0, (0, parcelRequire("aFfbR")).createEmptyParagraphNode)(schema)
        ];
        return output;
    }
    function $882900fef3f71ea2$var$normalizeMediaGroups(nodes, schema, _parentNode) {
        const output = [];
        let mediaGroupBuffer = [];
        let separatorBuffer = [];
        for (const n of nodes){
            if (n.type.name === 'mediaGroup' && n.childCount === 1) {
                mediaGroupBuffer.push(n);
                separatorBuffer = [];
                continue;
            }
            if (mediaGroupBuffer.length > 0) {
                if ($882900fef3f71ea2$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                    output.push($882900fef3f71ea2$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                    output.push(...separatorBuffer);
                    output.push(n);
                    mediaGroupBuffer = [];
                    separatorBuffer = [];
                } else separatorBuffer.push(n);
                continue;
            }
            output.push(n);
        }
        if (mediaGroupBuffer.length > 0) output.push($882900fef3f71ea2$var$createMergedMediaGroup(mediaGroupBuffer, schema));
        output.push(...separatorBuffer);
        return output;
    }
    function $882900fef3f71ea2$var$createMergedMediaGroup(mediaGroupNodes, schema) {
        const { mediaGroup: mediaGroup } = schema.nodes;
        const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
        return mediaGroup.createChecked({}, mediaNodes);
    }
    function $882900fef3f71ea2$var$isSignificantSeparatorNode(n, separatorBuffer) {
        return $882900fef3f71ea2$var$isHardBreak(n, separatorBuffer) || !$882900fef3f71ea2$var$isEmptyTextNode(n) || $882900fef3f71ea2$var$isMediaGroupWithMultipleChildren(n);
    }
    function $882900fef3f71ea2$var$isMediaGroupWithMultipleChildren(n) {
        return n.type.name === 'mediaGroup' && n.childCount > 1;
    }
    function $882900fef3f71ea2$var$isHardBreak(n, separatorBuffer) {
        return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
    }
    function $882900fef3f71ea2$var$isEmptyTextNode(n) {
        return n.textContent !== undefined && n.textContent.trim().length === 0;
    }
    function $882900fef3f71ea2$export$19b6d0f3f1dd6ddf(input) {
        return input.trim().length === 0;
    }
    function $882900fef3f71ea2$var$convertNodeToExpand(node, schema) {
        const { expand: expand } = schema.nodes;
        return expand.createChecked(node.attrs, node.content);
    }
});
parcelRegister("aFfbR", function(module, exports) {
    $parcel$export(module.exports, "createEmptyParagraphNode", ()=>$e89aa022205e6299$export$e930a5cfe8596ea0);
    $parcel$export(module.exports, "createParagraphNodeFromInlineNodes", ()=>$e89aa022205e6299$export$f0eaed48ea684567);
    function $e89aa022205e6299$export$e930a5cfe8596ea0(schema) {
        const { paragraph: paragraph } = schema.nodes;
        return paragraph.createChecked({}, []);
    }
    function $e89aa022205e6299$export$f0eaed48ea684567(inlineNodes, schema) {
        const { paragraph: paragraph } = schema.nodes;
        const result = [];
        const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
        if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
        return result;
    }
});
parcelRegister("bcu6t", function(module, exports) {
    $parcel$export(module.exports, "resolveLink", ()=>$395838c9d0665307$export$c2baa561eb017101);
    var $90tmE;
    var $iKOS2;
    var $1vO49;
    var $kbsSj;
    const $395838c9d0665307$var$linkResolverStrategies = [
        (0, (0, parcelRequire("iKOS2")).attachmentLinkResolver),
        (0, (0, parcelRequire("90tmE")).mentionLinkResolver),
        (0, (0, parcelRequire("kbsSj")).issueLinkResolver),
        (0, (0, parcelRequire("1vO49")).urlLinkResolver)
    ];
    function $395838c9d0665307$export$c2baa561eb017101(link, schema, context) {
        const length = link.originalLinkText.length + 2;
        for (const resolver of $395838c9d0665307$var$linkResolverStrategies){
            const resolvedLink = resolver(link, schema, context);
            if (resolvedLink) return {
                length: length,
                nodes: resolvedLink,
                type: 'pmnode'
            };
        }
        return undefined;
    }
});
parcelRegister("90tmE", function(module, exports) {
    $parcel$export(module.exports, "mentionLinkResolver", ()=>$096e676c01ae8041$export$1da3b34e38fc6ca8);
    function $096e676c01ae8041$export$1da3b34e38fc6ca8(link, schema, context) {
        if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
            schema.nodes.paragraph.createChecked({}, [
                schema.nodes.text.create({})
            ])
        ];
        if (link.notLinkBody.startsWith('~')) {
            const mentionText = link.notLinkBody.substring(1);
            const mentionKey = mentionText.toLowerCase();
            const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
            return [
                schema.nodes.mention.createChecked({
                    id: id
                })
            ];
        }
        return;
    }
});
parcelRegister("iKOS2", function(module, exports) {
    $parcel$export(module.exports, "attachmentLinkResolver", ()=>$4b98fc00c73022c5$export$ce918f41a76b8445);
    var $jikAA;
    function $4b98fc00c73022c5$export$ce918f41a76b8445(link, schema, context) {
        if (link.attachmentName) return [
            (0, (0, parcelRequire("jikAA")).default)(schema, link.attachmentName, context)
        ];
        return;
    }
});
parcelRegister("jikAA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddb7250bbdf5e8fe$export$2e2bcd8739ae039);
    function $ddb7250bbdf5e8fe$export$2e2bcd8739ae039(schema, filename, context = {}) {
        const { media: media, mediaGroup: mediaGroup } = schema.nodes;
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || ''
        });
        return mediaGroup.createChecked({}, mediaNode);
    }
});
parcelRegister("1vO49", function(module, exports) {
    $parcel$export(module.exports, "urlLinkResolver", ()=>$8722f0985327f514$export$b737d556d2167f9);
    var $aNQyn;
    var $iZOJ9;
    var $jfR8V;
    var $lAr8I;
    function $8722f0985327f514$export$b737d556d2167f9(link, schema, context) {
        const output = [];
        const url = link.notLinkBody;
        const textRepresentation = link.linkBody || link.notLinkBody;
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return;
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY
        ];
        const rawContent = (0, (0, parcelRequire("jfR8V")).parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: textRepresentation.replace(/^mailto:/, '')
        });
        const decoratedContent = rawContent.map((n)=>{
            const mark = schema.marks.link.create({
                href: url
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'link',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        });
        output.push(...decoratedContent);
        if (!$8722f0985327f514$var$hasTextNode(rawContent)) {
            const mark = schema.marks.link.create({
                href: url
            });
            const linkTextNode = schema.text(textRepresentation, [
                mark
            ]);
            output.push(linkTextNode);
        }
        return output;
    }
    function $8722f0985327f514$var$hasTextNode(nodes) {
        return nodes.find((n)=>{
            return n.type.name === 'text';
        });
    }
});
parcelRegister("lAr8I", function(module, exports) {
    $parcel$export(module.exports, "hasAnyOfMarks", ()=>$96f686d0f3185e9f$export$30c14ec359b8cbf0);
    $parcel$export(module.exports, "isDigit", ()=>$96f686d0f3185e9f$export$727d9dbc4fbb948f);
    $parcel$export(module.exports, "isBlank", ()=>$96f686d0f3185e9f$export$7ee701e290d9865);
    $parcel$export(module.exports, "isNotBlank", ()=>$96f686d0f3185e9f$export$4d9e7a1c098df5e2);
    $parcel$export(module.exports, "getSurroundingSymbols", ()=>$96f686d0f3185e9f$export$ddec3d40bf5e3693);
    $parcel$export(module.exports, "StringBuffer", ()=>$96f686d0f3185e9f$export$83347051c3437dc9);
    function $96f686d0f3185e9f$export$30c14ec359b8cbf0(node, types) {
        return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
    }
    function $96f686d0f3185e9f$export$727d9dbc4fbb948f(value) {
        return !!value.match(/^\d$/);
    }
    function $96f686d0f3185e9f$export$7ee701e290d9865(value) {
        return value === null || value.trim() === '';
    }
    function $96f686d0f3185e9f$export$4d9e7a1c098df5e2(value) {
        return !$96f686d0f3185e9f$export$7ee701e290d9865(value);
    }
    const $96f686d0f3185e9f$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
        const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
        const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
        const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
        return {
            openingSymbol: openingSymbol,
            closingSymbol: closingSymbol
        };
    };
    class $96f686d0f3185e9f$export$83347051c3437dc9 {
        constructor(buffer = ''){
            this.buffer = buffer;
        }
        indexOf(value) {
            return this.buffer.indexOf(value);
        }
        lastIndexOf(value) {
            return this.buffer.lastIndexOf(value);
        }
        charAt(index) {
            return this.buffer.charAt(index);
        }
        length() {
            return this.buffer.length;
        }
        delete(start, end) {
            this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
        }
        append(value) {
            this.buffer += value;
        }
        substring(start, end) {
            return this.buffer.substring(start, end);
        }
        deleteCharAt(index) {
            this.delete(index, index + 1);
        }
        toString() {
            return this.buffer;
        }
    }
});
parcelRegister("kbsSj", function(module, exports) {
    $parcel$export(module.exports, "issueLinkResolver", ()=>$7a8ae1e3a6130d99$export$f40ed0efa65d4e8);
    var $77lzI;
    function $7a8ae1e3a6130d99$export$f40ed0efa65d4e8(link, schema, context) {
        const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
        if (linkTitle === 'smart-card' || linkTitle === 'block-link') return [
            schema.nodes.blockCard.createChecked({
                url: notLinkBody
            })
        ];
        if (linkTitle === 'smart-link') return [
            schema.nodes.inlineCard.createChecked({
                url: notLinkBody
            })
        ];
        if (linkTitle === 'smart-embed') return [
            schema.nodes.embedCard.createChecked({
                url: notLinkBody
            })
        ];
        const issue = (0, (0, parcelRequire("77lzI")).getIssue)(context, originalLinkText);
        if (issue) return (0, (0, parcelRequire("77lzI")).buildInlineCard)(schema, issue);
        return undefined;
    }
});
parcelRegister("77lzI", function(module, exports) {
    $parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", ()=>$bee26d923f340b44$export$a1a15f4d91e860d9);
    $parcel$export(module.exports, "issueKey", ()=>$bee26d923f340b44$export$a0d841e329cebd91);
    $parcel$export(module.exports, "getIssue", ()=>$bee26d923f340b44$export$34403cb88b30d33b);
    $parcel$export(module.exports, "buildInlineCard", ()=>$bee26d923f340b44$export$cdebb4bc59c595a);
    $parcel$export(module.exports, "buildIssueKeyRegex", ()=>$bee26d923f340b44$export$cd8701ad7512efee);
    var $lAr8I;
    const $bee26d923f340b44$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
    const $bee26d923f340b44$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
        if (!context.issueKeyRegex) return $bee26d923f340b44$var$fallback(input, position);
        const match = input.substring(position).match(context.issueKeyRegex);
        if (!match) return $bee26d923f340b44$var$fallback(input, position);
        const issue = $bee26d923f340b44$export$34403cb88b30d33b(context, match[0]);
        if (!issue) return $bee26d923f340b44$var$fallback(input, position);
        const charBefore = input.charAt(position - 1);
        const charAfter = input.charAt(position + issue.key.length);
        if ((0, (0, parcelRequire("lAr8I")).isNotBlank)(charBefore) && $bee26d923f340b44$var$isNotAllowedChars(charBefore) || (0, (0, parcelRequire("lAr8I")).isNotBlank)(charAfter) && $bee26d923f340b44$var$isNotAllowedChars(charAfter)) return $bee26d923f340b44$var$fallback(input, position);
        return {
            type: 'pmnode',
            nodes: $bee26d923f340b44$export$cdebb4bc59c595a(schema, issue),
            length: match[0].length
        };
    };
    const $bee26d923f340b44$var$fallback = (input, position)=>({
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        });
    const $bee26d923f340b44$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
            key: key,
            url: context.conversion.inlineCardConversion[key]
        } : null;
    const $bee26d923f340b44$export$cdebb4bc59c595a = (schema, issue)=>{
        return [
            schema.nodes.inlineCard.createChecked({
                url: $bee26d923f340b44$var$withInlineCardFromTextStamp(issue)
            })
        ];
    };
    const $bee26d923f340b44$var$withInlineCardFromTextStamp = (issue)=>$bee26d923f340b44$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
    const $bee26d923f340b44$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
    const $bee26d923f340b44$export$cd8701ad7512efee = (inlineCardConversion)=>{
        if (!inlineCardConversion) return undefined;
        const pattern = Object.keys(inlineCardConversion).join('|');
        if (!pattern) return undefined;
        return new RegExp(`^(${pattern})`);
    };
});
parcelRegister("1hTYO", function(module, exports) {
    $parcel$export(module.exports, "parseContentLink", ()=>$c10a07aebb27804c$export$3a250a08d37b0eae);
    var $lAr8I;
    function $c10a07aebb27804c$var$trimIfPossible(s) {
        if (s === null) return null;
        return s.trim();
    }
    function $c10a07aebb27804c$var$extractLinkBody(buffer) {
        const indexOfBang = buffer.indexOf('!');
        const indexOfPipe = buffer.indexOf('|');
        const lastIndexOfBang = buffer.lastIndexOf('!');
        const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
        if (notEscaped) return $c10a07aebb27804c$var$divideOn(buffer, '|');
        const body = new (0, (0, parcelRequire("lAr8I")).StringBuffer)();
        let inEscape = false;
        for(let i = 0; i < buffer.length(); i++){
            const c = buffer.charAt(i);
            if (c === '!') inEscape = !inEscape;
            if (c === '|' && !inEscape) {
                buffer.delete(0, i + 1);
                return body.toString();
            }
            body.append(c);
        }
        return null;
    }
    function $c10a07aebb27804c$var$divideAfterLast(buffer, divider) {
        if (buffer.length() === 0) return null;
        return $c10a07aebb27804c$var$divideAfter(buffer, buffer.lastIndexOf(divider));
    }
    function $c10a07aebb27804c$var$divideAfter(buffer, index) {
        if (typeof index === 'string') index = buffer.indexOf(index);
        if (index < 0) return null;
        else if (index === buffer.length() - 1) {
            buffer.deleteCharAt(buffer.length() - 1);
            return null;
        } else {
            const body = buffer.substring(index + 1);
            buffer.delete(index, buffer.length());
            return body;
        }
    }
    function $c10a07aebb27804c$var$divideOn(buffer, divider) {
        if (buffer.length() === 0) return null;
        const i = buffer.indexOf(divider);
        if (i < 0) return null;
        else if (i === 0) {
            buffer.deleteCharAt(0);
            return null;
        } else {
            const body = buffer.substring(0, i);
            buffer.delete(0, i + 1);
            return body;
        }
    }
    function $c10a07aebb27804c$var$extractNumber(buf) {
        const digits = new (0, (0, parcelRequire("lAr8I")).StringBuffer)();
        let i = 0;
        for(; i < buf.length() && (0, (0, parcelRequire("lAr8I")).isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
        if (i > 0) buf.delete(0, i);
        try {
            return parseInt(digits.toString(), 10);
        } catch (e) {
            return 0;
        }
    }
    function $c10a07aebb27804c$export$2d20cd44728d07a1(linkText) {
        const originalLinkText = linkText;
        if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
        const buf = new (0, (0, parcelRequire("lAr8I")).StringBuffer)(linkText);
        const linkBody = $c10a07aebb27804c$var$extractLinkBody(buf);
        const linkTitle = $c10a07aebb27804c$var$trimIfPossible($c10a07aebb27804c$var$divideAfter(buf, '|'));
        const notLinkBody = buf.toString().trim();
        return {
            originalLinkText: originalLinkText,
            linkBody: linkBody,
            linkTitle: linkTitle,
            notLinkBody: notLinkBody
        };
    }
    function $c10a07aebb27804c$export$3a250a08d37b0eae(link) {
        if (typeof link === 'string') link = $c10a07aebb27804c$export$2d20cd44728d07a1(link);
        const { notLinkBody: notLinkBody } = link;
        let shortcutName = null;
        let shortcutValue = null;
        let spaceKey = null;
        let attachmentName = null;
        let anchor = null;
        let destinationTitle = '';
        let contentId = 0;
        if (!notLinkBody.startsWith('~')) {
            const shortcutBuf = new (0, (0, parcelRequire("lAr8I")).StringBuffer)(notLinkBody);
            shortcutName = $c10a07aebb27804c$var$trimIfPossible($c10a07aebb27804c$var$divideAfterLast(shortcutBuf, '@'));
            if ((0, (0, parcelRequire("lAr8I")).isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
        }
        const buf = new (0, (0, parcelRequire("lAr8I")).StringBuffer)(notLinkBody);
        if ((0, (0, parcelRequire("lAr8I")).isBlank)(shortcutName)) {
            spaceKey = $c10a07aebb27804c$var$trimIfPossible($c10a07aebb27804c$var$divideOn(buf, ':'));
            if (buf.indexOf('$') === 0) {
                buf.deleteCharAt(0);
                contentId = $c10a07aebb27804c$var$extractNumber(buf);
                if (contentId === 0) return {
                    ...link,
                    shortcutName: shortcutName,
                    shortcutValue: shortcutValue,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    attachmentName: attachmentName,
                    anchor: anchor,
                    destinationTitle: destinationTitle
                };
            }
            attachmentName = $c10a07aebb27804c$var$trimIfPossible($c10a07aebb27804c$var$divideAfter(buf, '^'));
            anchor = $c10a07aebb27804c$var$trimIfPossible($c10a07aebb27804c$var$divideAfter(buf, '#'));
        }
        if (contentId === 0) destinationTitle = buf.toString().trim();
        return {
            ...link,
            shortcutName: shortcutName,
            shortcutValue: shortcutValue,
            spaceKey: spaceKey,
            contentId: contentId,
            attachmentName: attachmentName,
            anchor: anchor,
            destinationTitle: destinationTitle
        };
    }
});
parcelRegister("iHU0h", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$d3236b0778eae269$export$67dc04e652a298ca);
    var $C9v5b;
    const $d3236b0778eae269$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
    const $d3236b0778eae269$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
        const match = input.substring(position).match($d3236b0778eae269$var$BLOCKQUOTE_REGEXP);
        if (!match) return $d3236b0778eae269$var$fallback(input, position);
        const [, rawContent] = match;
        return (0, (0, parcelRequire("C9v5b")).rawContentProcessor)('', rawContent, match[0].length, schema, context);
    };
    function $d3236b0778eae269$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("C9v5b", function(module, exports) {
    $parcel$export(module.exports, "quoteMacro", ()=>$5eab1d5d9cad46ad$export$8f9545cee64b3251);
    $parcel$export(module.exports, "rawContentProcessor", ()=>$5eab1d5d9cad46ad$export$c2a5e4612254bfa);
    var $8hkXU;
    var $lAr8I;
    var $eZoBm;
    var $jfR8V;
    const $5eab1d5d9cad46ad$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'quote',
            paired: true,
            rawContentProcessor: $5eab1d5d9cad46ad$export$c2a5e4612254bfa,
            context: context
        });
    };
    const $5eab1d5d9cad46ad$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
        if (!rawContent.length) {
            const emptyQuote = $5eab1d5d9cad46ad$var$emptyBlockquote(schema);
            return {
                type: 'pmnode',
                nodes: [
                    emptyQuote
                ],
                length: length
            };
        }
        const parsedContent = (0, (0, parcelRequire("jfR8V")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: [],
            input: rawContent
        });
        const normalizedContent = (0, (0, parcelRequire("eZoBm")).normalizePMNodes)(parsedContent, schema);
        return {
            type: 'pmnode',
            nodes: $5eab1d5d9cad46ad$var$sanitize(normalizedContent, schema),
            length: length
        };
    };
    function $5eab1d5d9cad46ad$var$emptyBlockquote(schema) {
        const p = schema.nodes.paragraph.createChecked({}, []);
        return schema.nodes.blockquote.createChecked({}, p);
    }
    function $5eab1d5d9cad46ad$var$sanitize(nodes, schema) {
        const output = [];
        let contentBuffer = [];
        for (const n of nodes)switch(n.type.name){
            case 'paragraph':
            case 'bulletList':
            case 'orderedList':
            case 'codeBlock':
            case 'mediaSingle':
            case 'mediaGroup':
                contentBuffer.push(n);
                break;
            case 'heading':
                contentBuffer.push($5eab1d5d9cad46ad$var$transformHeading(n, schema));
                break;
            default:
                if (contentBuffer.length) {
                    const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                    output.push(blockquote);
                    contentBuffer = [];
                }
                output.push(n);
        }
        if (contentBuffer.length) {
            const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
            output.push(blockquote);
        }
        return output;
    }
    function $5eab1d5d9cad46ad$var$transformHeading(heading, schema) {
        const contentBuffer = [];
        heading.content.forEach((n)=>{
            const strong = schema.marks.strong.create();
            const italic = schema.marks.em.create();
            const gray = schema.marks.textColor.create({
                color: '#97a0af'
            });
            if (n.type.name === 'text') {
                if (n.text && heading.attrs.level === 1) n.text = n.text.toUpperCase();
                if (heading.attrs.level <= 4 && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                    'strong',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    strong
                ]);
                if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                    'em',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    italic
                ]);
                if (heading.attrs.level > 3 && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                    'textColor',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    gray
                ]);
            }
            contentBuffer.push(n);
        });
        return schema.nodes.paragraph.createChecked({}, contentBuffer);
    }
});
parcelRegister("8hkXU", function(module, exports) {
    $parcel$export(module.exports, "commonMacro", ()=>$44ed898282bac753$export$b6a12943ac1bb1ba);
    function $44ed898282bac753$export$b6a12943ac1bb1ba(input, schema, opt) {
        const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
        const matchOpening = input.match(opening);
        if (!matchOpening) return $44ed898282bac753$var$fallback(input);
        const [, name, rawAttrs] = matchOpening;
        const openingLength = matchOpening[0].length;
        if (!opt.paired) return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
        const closing = new RegExp(`\{${name}\}`);
        const matchClosing = closing.exec(input.substring(openingLength));
        let rawContent = '';
        if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
        const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
        return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
    }
    function $44ed898282bac753$var$fallback(input) {
        return {
            type: 'text',
            text: input.substr(0, 1),
            length: 1
        };
    }
});
parcelRegister("hXmWC", function(module, exports) {
    $parcel$export(module.exports, "citation", ()=>$349f7be48e6cbc01$export$258632c953c109e9);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $349f7be48e6cbc01$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY
        ];
        const contentDecorator = (n, index)=>{
            const mark = schema.marks.em.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) {
                if (index === 0) n.text = `${0, $0e180799c3c9dc26$export$3bca9fae3002bd9b} ${n.text}`;
                return n.mark([
                    ...n.marks,
                    mark
                ]);
            }
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '??', '??');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
const $0e180799c3c9dc26$export$3bca9fae3002bd9b = "\u2014";
parcelRegister("bhGcp", function(module, exports) {
    $parcel$export(module.exports, "deleted", ()=>$45594bafb26092f2$export$bccbf0c716f226f4);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $45594bafb26092f2$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.strike.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'strike',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '-', '-');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("eAYdE", function(module, exports) {
    $parcel$export(module.exports, "doubleDashSymbol", ()=>$345e2fbe204b6ea9$export$65e3ca7c95899a2d);
    var $2YNdw;
    const $345e2fbe204b6ea9$var$token = {
        type: 'text',
        text: '\u2013',
        length: 2
    };
    const $345e2fbe204b6ea9$var$fallback = {
        ...$345e2fbe204b6ea9$var$token,
        text: '--'
    };
    const $345e2fbe204b6ea9$export$65e3ca7c95899a2d = (0, (0, parcelRequire("2YNdw")).createDashTokenParser)($345e2fbe204b6ea9$var$token, $345e2fbe204b6ea9$var$fallback);
});
parcelRegister("2YNdw", function(module, exports) {
    $parcel$export(module.exports, "createDashTokenParser", ()=>$d5d1d23e51ccf51f$export$d43b58865d429e3c);
    const $d5d1d23e51ccf51f$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
            if (position > 0) {
                const charBeforeToken = input.charAt(position - 1);
                if (!$d5d1d23e51ccf51f$var$isSpace(charBeforeToken)) return fallback;
            }
            if (position + token.length < input.length) {
                const charAfterToken = input.charAt(position + token.length);
                if (!$d5d1d23e51ccf51f$var$isSpace(charAfterToken)) return fallback;
            }
            return token;
        };
    const $d5d1d23e51ccf51f$var$isSpace = (char)=>{
        return /\s/.test(char);
    };
});
parcelRegister("6bw9N", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$dbc286b16b6ea58c$export$a19185d1233fc4b2);
    const $dbc286b16b6ea58c$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
    const $dbc286b16b6ea58c$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
        const substring = input.substring(position);
        for(let i = 2; i <= 9 && i <= substring.length; ++i){
            const candidateText = substring.substring(0, i);
            const emojiId = $dbc286b16b6ea58c$export$fabd2c9504f5bf35[candidateText];
            if (emojiId && $dbc286b16b6ea58c$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
                type: 'pmnode',
                nodes: [
                    schema.nodes.emoji.createChecked($dbc286b16b6ea58c$export$797c048dfde076a1[emojiId])
                ],
                length: i
            };
        }
        return {
            type: 'text',
            text: substring.substr(0, 1),
            length: 1
        };
    };
    const $dbc286b16b6ea58c$export$797c048dfde076a1 = {
        '1f642': {
            id: '1f642',
            shortName: ':slight_smile:',
            text: "\uD83D\uDE42"
        },
        '1f61e': {
            id: '1f61e',
            shortName: ':disappointed:',
            text: "\uD83D\uDE1E"
        },
        '1f61b': {
            id: '1f61b',
            shortName: ':stuck_out_tongue:',
            text: "\uD83D\uDE1B"
        },
        '1f603': {
            id: '1f603',
            shortName: ':smiley:',
            text: "\uD83D\uDE03"
        },
        '1f609': {
            id: '1f609',
            shortName: ':wink:',
            text: "\uD83D\uDE09"
        },
        '1f44d': {
            id: '1f44d',
            shortName: ':thumbsup:',
            text: "\uD83D\uDC4D"
        },
        '1f44e': {
            id: '1f44e',
            shortName: ':thumbsdown:',
            text: "\uD83D\uDC4E"
        },
        'atlassian-info': {
            id: 'atlassian-info',
            shortName: ':info:',
            text: ':info:'
        },
        'atlassian-check_mark': {
            id: 'atlassian-check_mark',
            shortName: ':check_mark:',
            text: ':check_mark:'
        },
        'atlassian-cross_mark': {
            id: 'atlassian-cross_mark',
            shortName: ':cross_mark:',
            text: ':cross_mark:'
        },
        'atlassian-warning': {
            id: 'atlassian-warning',
            shortName: ':warning:',
            text: ':warning:'
        },
        'atlassian-plus': {
            id: 'atlassian-plus',
            shortName: ':plus:',
            text: ':plus:'
        },
        'atlassian-minus': {
            id: 'atlassian-minus',
            shortName: ':minus:',
            text: ':minus:'
        },
        'atlassian-question_mark': {
            id: 'atlassian-question_mark',
            shortName: ':question:',
            text: ':question:'
        },
        'atlassian-light_bulb_on': {
            id: 'atlassian-light_bulb_on',
            shortName: ':light_bulb_on:',
            text: ':light_bulb_on:'
        },
        'atlassian-light_bulb_off': {
            id: 'atlassian-light_bulb_off',
            shortName: ':light_bulb_off:',
            text: ':light_bulb_off:'
        },
        'atlassian-yellow_star': {
            id: 'atlassian-yellow_star',
            shortName: ':yellow_star:',
            text: ':yellow_star:'
        },
        'atlassian-red_star': {
            id: 'atlassian-red_star',
            shortName: ':red_star:',
            text: ':red_star:'
        },
        'atlassian-green_star': {
            id: 'atlassian-green_star',
            shortName: ':green_star:',
            text: ':green_star:'
        },
        'atlassian-blue_star': {
            id: 'atlassian-blue_star',
            shortName: ':blue_star:',
            text: ':blue_star:'
        },
        'atlassian-flag_on': {
            id: 'atlassian-flag_on',
            shortName: ':flag_on:',
            text: ':flag_on:'
        },
        'atlassian-flag_off': {
            id: 'atlassian-flag_off',
            shortName: ':flag_off:',
            text: ':flag_off:'
        }
    };
    const $dbc286b16b6ea58c$export$fabd2c9504f5bf35 = {
        ':)': '1f642',
        ':-)': '1f642',
        ':(': '1f61e',
        ':-(': '1f61e',
        ':P': '1f61b',
        ':-P': '1f61b',
        ':p': '1f61b',
        ':-p': '1f61b',
        ':D': '1f603',
        ':-D': '1f603',
        ';)': '1f609',
        ';-)': '1f609',
        '(y)': '1f44d',
        '(n)': '1f44e',
        '(i)': 'atlassian-info',
        '(/)': 'atlassian-check_mark',
        '(x)': 'atlassian-cross_mark',
        '(!)': 'atlassian-warning',
        '(+)': 'atlassian-plus',
        '(-)': 'atlassian-minus',
        '(?)': 'atlassian-question_mark',
        '(on)': 'atlassian-light_bulb_on',
        '(off)': 'atlassian-light_bulb_off',
        '(*)': 'atlassian-yellow_star',
        '(*y)': 'atlassian-yellow_star',
        '(*r)': 'atlassian-red_star',
        '(*g)': 'atlassian-green_star',
        '(*b)': 'atlassian-blue_star',
        '(flag)': 'atlassian-flag_on',
        '(flagoff)': 'atlassian-flag_off'
    };
});
parcelRegister("84Nuv", function(module, exports) {
    $parcel$export(module.exports, "emphasis", ()=>$2e2e9c8e17c0a77f$export$bef81ba411953b51);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $2e2e9c8e17c0a77f$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.em.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '_', '_');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("3QCnP", function(module, exports) {
    $parcel$export(module.exports, "hardbreak", ()=>$1478851bf84aaa51$export$ac55bb44695749c1);
    var $jcXK3;
    const $1478851bf84aaa51$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
        const length = (0, (0, parcelRequire("jcXK3")).parseNewlineOnly)(input.substring(position));
        if (length === 0) return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
        return {
            type: 'pmnode',
            nodes: [
                schema.nodes.hardBreak.createChecked()
            ],
            length: length
        };
    };
});
parcelRegister("iwiCz", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$89664b8c81cb68b9$export$46e4a324ac90507f);
    var $jfR8V;
    var $aNQyn;
    const $89664b8c81cb68b9$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
    const $89664b8c81cb68b9$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL
        ];
        const match = input.substring(position).match($89664b8c81cb68b9$var$HEADING_REGEXP);
        if (!match) return $89664b8c81cb68b9$var$fallback(input, position);
        const level = parseInt(match[1], 10);
        const content = (0, (0, parcelRequire("jfR8V")).parseString)({
            schema: schema,
            ignoreTokenTypes: ignoreTokenTypes,
            context: context,
            input: match[2]
        });
        try {
            const headingNode = schema.nodes.heading.createChecked({
                level: level
            }, content);
            return {
                type: 'pmnode',
                nodes: [
                    headingNode
                ],
                length: match[0].length
            };
        } catch (err) {
            return {
                type: 'text',
                text: '',
                length: 4
            };
        }
    };
    function $89664b8c81cb68b9$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("aw5rH", function(module, exports) {
    $parcel$export(module.exports, "inserted", ()=>$234015a9e964a932$export$744ba74fb86b8ca7);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $234015a9e964a932$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.underline.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'underline',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '+', '+');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("aS0J2", function(module, exports) {
    $parcel$export(module.exports, "MAX_LIST_DEPTH", ()=>$205ccfde1ad21268$export$d2a2f0ec33d903e1);
    $parcel$export(module.exports, "list", ()=>$205ccfde1ad21268$export$8837f4fc672e936d);
    var $1ndkn;
    var $jfR8V;
    var $eZoBm;
    var $QYqpZ;
    var $aNQyn;
    var $jcXK3;
    var $lAr8I;
    const $205ccfde1ad21268$export$d2a2f0ec33d903e1 = 20;
    const $205ccfde1ad21268$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$205ccfde1ad21268$export$d2a2f0ec33d903e1}}) `);
    const $205ccfde1ad21268$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
    const $205ccfde1ad21268$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
    const $205ccfde1ad21268$var$processState = {
        NEW_LINE: 0,
        BUFFER: 1,
        END: 2,
        MACRO: 3
    };
    const $205ccfde1ad21268$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).LIST,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        let index = position;
        let state = $205ccfde1ad21268$var$processState.NEW_LINE;
        let buffer = [];
        let lastListSymbols = null;
        let builder = null;
        let contentBuffer = [];
        const output = [];
        while(index < input.length){
            const char = input.charAt(index);
            switch(state){
                case $205ccfde1ad21268$var$processState.NEW_LINE:
                    {
                        const substring = input.substring(index);
                        const listMatch = substring.match($205ccfde1ad21268$var$LIST_ITEM_REGEXP);
                        if (listMatch) {
                            const [, symbols] = listMatch;
                            const rulerMatch = symbols.match($205ccfde1ad21268$var$RULER_SYMBOL_REGEXP);
                            if (rulerMatch) {
                                const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                                const emptyLineMatch = remainingAfterSymbol.match($205ccfde1ad21268$var$EMPTY_LINE_REGEXP);
                                if (emptyLineMatch) {
                                    state = $205ccfde1ad21268$var$processState.BUFFER;
                                    continue;
                                }
                            }
                            if (!builder) {
                                builder = new (0, (0, parcelRequire("1ndkn")).ListBuilder)(schema, symbols);
                                lastListSymbols = symbols;
                            } else {
                                if (buffer.length > 0) {
                                    const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                                        ignoreTokenTypes: ignoreTokenTypes,
                                        schema: schema,
                                        context: context,
                                        input: buffer.join(''),
                                        includeLeadingSpace: true
                                    });
                                    contentBuffer.push(...content);
                                    builder.add([
                                        {
                                            style: lastListSymbols,
                                            content: $205ccfde1ad21268$var$sanitize((0, (0, parcelRequire("eZoBm")).normalizePMNodes)(contentBuffer, schema), schema)
                                        }
                                    ]);
                                    buffer = [];
                                    contentBuffer = [];
                                }
                                lastListSymbols = symbols;
                                const type = (0, (0, parcelRequire("1ndkn")).getType)(symbols);
                                if (type !== builder.type && symbols.length === 1) {
                                    output.push(...builder.buildPMNode());
                                    builder = new (0, (0, parcelRequire("1ndkn")).ListBuilder)(schema, symbols);
                                }
                            }
                            index += listMatch[0].length;
                        }
                        const emptyLineMatch = substring.match($205ccfde1ad21268$var$EMPTY_LINE_REGEXP);
                        if (emptyLineMatch) {
                            state = $205ccfde1ad21268$var$processState.END;
                            continue;
                        }
                        state = $205ccfde1ad21268$var$processState.BUFFER;
                        continue;
                    }
                case $205ccfde1ad21268$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("jcXK3")).parseNewlineOnly)(input.substring(index));
                        if (length) {
                            buffer.push(input.substr(index, length));
                            state = $205ccfde1ad21268$var$processState.NEW_LINE;
                            index += length;
                            continue;
                        }
                        if (char === '{') {
                            state = $205ccfde1ad21268$var$processState.MACRO;
                            continue;
                        } else buffer.push(char);
                        break;
                    }
                case $205ccfde1ad21268$var$processState.MACRO:
                    {
                        const match = (0, (0, parcelRequire("QYqpZ")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            state = $205ccfde1ad21268$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("aNQyn")).parseToken)(input, match.type, index, schema, context);
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $205ccfde1ad21268$var$processState.BUFFER;
                        continue;
                    }
                case $205ccfde1ad21268$var$processState.END:
                    if (!builder) return $205ccfde1ad21268$var$fallback(input, position);
                    if (buffer.length > 0) {
                        const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                            ignoreTokenTypes: ignoreTokenTypes,
                            schema: schema,
                            context: context,
                            input: buffer.join(''),
                            includeLeadingSpace: true
                        });
                        contentBuffer.push(...content);
                    }
                    builder.add([
                        {
                            style: lastListSymbols,
                            content: $205ccfde1ad21268$var$sanitize((0, (0, parcelRequire("eZoBm")).normalizePMNodes)(contentBuffer, schema), schema)
                        }
                    ]);
                    output.push(...builder.buildPMNode());
                    return {
                        type: 'pmnode',
                        nodes: output,
                        length: index - position
                    };
            }
            index++;
        }
        if (buffer.length > 0) {
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: buffer.join(''),
                includeLeadingSpace: true
            });
            contentBuffer.push(...content);
        }
        if (builder) {
            builder.add([
                {
                    style: lastListSymbols,
                    content: $205ccfde1ad21268$var$sanitize((0, (0, parcelRequire("eZoBm")).normalizePMNodes)(contentBuffer, schema), schema)
                }
            ]);
            output.push(...builder.buildPMNode());
        }
        return {
            type: 'pmnode',
            nodes: output,
            length: index - position
        };
    };
    function $205ccfde1ad21268$var$sanitize(nodes, schema) {
        return nodes.reduce((result, curr)=>{
            switch(curr.type.name){
                case 'blockquote':
                    curr.content.forEach((n)=>{
                        result.push(n);
                    });
                    break;
                case 'heading':
                    {
                        const contentBuffer = [];
                        curr.content.forEach((n)=>{
                            const mark = schema.marks.strong.create();
                            if (n.type.name === 'text') {
                                if (n.text) n.text = n.text.toUpperCase();
                                if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                                    'strong',
                                    'code'
                                ])) contentBuffer.push(n.mark([
                                    ...n.marks,
                                    mark
                                ]));
                                else contentBuffer.push(n);
                            } else contentBuffer.push(n);
                        });
                        const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                        result.push(p);
                        break;
                    }
                default:
                    result.push(curr);
            }
            return result;
        }, []);
    }
    function $205ccfde1ad21268$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("1ndkn", function(module, exports) {
    $parcel$export(module.exports, "getType", ()=>$95e2d5d0a1268540$export$e2b5c5db9e2009fd);
    $parcel$export(module.exports, "ListBuilder", ()=>$95e2d5d0a1268540$export$876cfa3161bef296);
    const $95e2d5d0a1268540$var$supportedContentType = [
        'paragraph',
        'orderedList',
        'bulletList',
        'mediaSingle',
        'codeBlock'
    ];
    function $95e2d5d0a1268540$export$e2b5c5db9e2009fd(bullets) {
        return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
    }
    class $95e2d5d0a1268540$export$876cfa3161bef296 {
        constructor(schema, bullets){
            this.parseList = (list)=>{
                const listNode = this.schema.nodes[list.type];
                const output = [];
                let listItemsBuffer = [];
                for(let i = 0; i < list.children.length; i++){
                    const parsedContent = this.parseListItem(list.children[i]);
                    for(let j = 0; j < parsedContent.length; j++){
                        const parsedNode = parsedContent[j];
                        if (parsedNode.type.name === 'listItem') {
                            listItemsBuffer.push(parsedNode);
                            continue;
                        }
                        if (listItemsBuffer.length) {
                            const list = listNode.createChecked({}, listItemsBuffer);
                            output.push(list);
                        }
                        output.push(parsedNode);
                        listItemsBuffer = [];
                    }
                }
                if (listItemsBuffer.length) {
                    const list = listNode.createChecked({}, listItemsBuffer);
                    output.push(list);
                }
                return output;
            };
            this.parseListItem = (item)=>{
                const output = [];
                if (!item.content) item.content = [];
                const parsedChildren = item.children.reduce((result, list)=>{
                    const parsedList = this.parseList(list);
                    result.push(...parsedList);
                    return result;
                }, []);
                item.content.push(...parsedChildren);
                let contentBuffer = [];
                for(let i = 0; i < item.content.length; i++){
                    const pmNode = item.content[i];
                    if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                    if (this.isParagraphEmptyTextNode(pmNode)) continue;
                    if ($95e2d5d0a1268540$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                        const listItem = this.createListItem(contentBuffer, this.schema);
                        output.push(listItem);
                        output.push(pmNode);
                        contentBuffer = [];
                        continue;
                    }
                    contentBuffer.push(pmNode);
                }
                if (contentBuffer.length) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                }
                return output;
            };
            this.schema = schema;
            this.root = {
                children: [],
                type: $95e2d5d0a1268540$export$e2b5c5db9e2009fd(bullets)
            };
            this.lastDepth = 1;
            this.lastList = this.root;
        }
        get type() {
            return this.root.type;
        }
        add(items) {
            for (const item of items){
                const { style: style, content: content } = item;
                if (style === null) {
                    this.appendToLastItem(content);
                    continue;
                }
                const depth = style.length;
                const type = $95e2d5d0a1268540$export$e2b5c5db9e2009fd(style);
                if (depth > this.lastDepth) {
                    this.createNest(depth - this.lastDepth, type);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                } else if (depth === this.lastDepth) this.lastList = this.addListItem(type, content);
                else {
                    this.lastList = this.findAncestor(this.lastDepth - depth);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                }
            }
        }
        buildPMNode() {
            return this.parseList(this.root);
        }
        isParagraphEmptyTextNode(node) {
            if (node.type.name !== 'paragraph' || !node.childCount) return false;
            for(let i = 0; i < node.childCount; i++){
                const n = node.content.child(i);
                if (n.type.name !== 'text') return false;
                else if (n.textContent.trim() !== '') return false;
            }
            return true;
        }
        createListItem(content, schema) {
            if (content.length === 0 || [
                'paragraph',
                'mediaSingle'
            ].indexOf(content[0].type.name) === -1) content.unshift(this.schema.nodes.paragraph.createChecked());
            return schema.nodes.listItem.createChecked({}, content);
        }
        addListItem(type, content) {
            let list = this.lastList;
            if (list.type !== type) {
                const parent = list.parent;
                const newList = {
                    children: [],
                    type: type,
                    parent: parent
                };
                parent.children.push(newList);
                this.lastList = list = newList;
            }
            const listItem = {
                content: content,
                parent: list,
                children: []
            };
            list.children = [
                ...list.children,
                listItem
            ];
            return list;
        }
        appendToLastItem(content) {
            const { children: children } = this.lastList;
            const lastItem = children[children.length - 1];
            lastItem.content.push(...content);
        }
        createNest(depth, type) {
            while(depth-- > 0){
                if (this.lastList.children.length === 0) {
                    const listItem = {
                        parent: this.lastList,
                        children: []
                    };
                    this.lastList.children = [
                        listItem
                    ];
                }
                const nextItem = this.lastList.children[this.lastList.children.length - 1];
                nextItem.children = [
                    {
                        children: [],
                        parent: nextItem,
                        type: type
                    }
                ];
                this.lastList = nextItem.children[0];
            }
        }
        findAncestor(depth) {
            let list = this.lastList;
            while(depth-- > 0 && list.parent){
                const listItem = list.parent;
                if (listItem && listItem.parent) list = listItem.parent;
            }
            return list;
        }
    }
});
parcelRegister("gqu8t", function(module, exports) {
    $parcel$export(module.exports, "monospace", ()=>$4037c5d5dd0dc381$export$2b90969bbc9ff4c9);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $4037c5d5dd0dc381$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).ADF_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).ANCHOR_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).CODE_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUOTE_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).NOFORMAT_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).PANEL_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).COLOR_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).LOREM_MACRO,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUOTE,
            (0, (0, parcelRequire("aNQyn")).TokenType).STRING,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).LINK_FORMAT,
            (0, (0, parcelRequire("aNQyn")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("aNQyn")).TokenType).MEDIA,
            (0, (0, parcelRequire("aNQyn")).TokenType).HEADING,
            (0, (0, parcelRequire("aNQyn")).TokenType).LIST,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE,
            (0, (0, parcelRequire("aNQyn")).TokenType).RULER,
            (0, (0, parcelRequire("aNQyn")).TokenType).HARD_BREAK,
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).STRONG,
            (0, (0, parcelRequire("aNQyn")).TokenType).MONOSPACE,
            (0, (0, parcelRequire("aNQyn")).TokenType).SUPERSCRIPT,
            (0, (0, parcelRequire("aNQyn")).TokenType).SUBSCRIPT,
            (0, (0, parcelRequire("aNQyn")).TokenType).EMPHASIS,
            (0, (0, parcelRequire("aNQyn")).TokenType).CITATION,
            (0, (0, parcelRequire("aNQyn")).TokenType).DELETED,
            (0, (0, parcelRequire("aNQyn")).TokenType).INSERTED,
            (0, (0, parcelRequire("aNQyn")).TokenType).EMOJI,
            (0, (0, parcelRequire("aNQyn")).TokenType).FORCE_LINE_BREAK
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.code.create();
            if (n.type.name === 'text' && n.marks.length) return n;
            return n.mark([
                mark
            ]);
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '{{', '}}');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("aRcdQ", function(module, exports) {
    $parcel$export(module.exports, "quadrupleDashSymbol", ()=>$5d2e32e3c8340468$export$95a7907a71f31921);
    const $5d2e32e3c8340468$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
    const $5d2e32e3c8340468$export$95a7907a71f31921 = ({ input: input, position: position })=>{
        const match = input.substring(position).match($5d2e32e3c8340468$var$MULTI_DASH_REGEX);
        if (!match) return {
            type: 'text',
            text: '----',
            length: 4
        };
        return {
            type: 'text',
            text: input.substr(position, match[0].length),
            length: match[0].length
        };
    };
});
parcelRegister("ejTUJ", function(module, exports) {
    $parcel$export(module.exports, "ruler", ()=>$8b098940a378e90a$export$f9adada2013e846e);
    var $d8YhJ;
    const $8b098940a378e90a$var$RULER_REGEX = /^-{4,5}(\s|$)/;
    const $8b098940a378e90a$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
        const match = input.substring(position).match($8b098940a378e90a$var$RULER_REGEX);
        if (match) return {
            type: 'pmnode',
            nodes: (0, (0, parcelRequire("d8YhJ")).createRuleNode)(schema),
            length: match[0].length
        };
        return {
            type: 'text',
            text: input.substring(position, 1),
            length: 1
        };
    };
});
parcelRegister("d8YhJ", function(module, exports) {
    $parcel$export(module.exports, "createRuleNode", ()=>$2ad181d275084ec2$export$4267f2e5716b018a);
    const $2ad181d275084ec2$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
    function $2ad181d275084ec2$export$2e2bcd8739ae039(schema, containerNodeType) {
        const { paragraph: paragraph, rule: rule } = schema.nodes;
        if (containerNodeType) {
            const textNode = schema.text($2ad181d275084ec2$var$HORIZONTAL_LINE_INSIDE_MACRO);
            return paragraph.createChecked({}, textNode);
        } else return rule.createChecked();
    }
    function $2ad181d275084ec2$export$4267f2e5716b018a(schema) {
        const { rule: rule } = schema.nodes;
        const ruleNode = rule.createChecked();
        return [
            ruleNode
        ];
    }
});
parcelRegister("j7X8D", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$02aa85f3aefd11e5$export$59ae2c325a998f89);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $02aa85f3aefd11e5$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const contentDecorator = (pmNode)=>{
            const mark = schema.marks.strong.create();
            if (pmNode.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(pmNode, [
                'strong',
                'code'
            ])) return pmNode.mark([
                ...pmNode.marks,
                mark
            ]);
            return pmNode;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '*', '*');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("ckpoY", function(module, exports) {
    $parcel$export(module.exports, "subscript", ()=>$9ba482cafc368639$export$bc5390e4688d2822);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $9ba482cafc368639$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.subsup.create({
                type: 'sub'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'subsup',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '~', '~');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("31G7u", function(module, exports) {
    $parcel$export(module.exports, "superscript", ()=>$85ca33118e16ff49$export$b4aab94a5fcfcead);
    var $aNQyn;
    var $lAr8I;
    var $k6dG2;
    var $jfR8V;
    const $85ca33118e16ff49$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.subsup.create({
                type: 'sup'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'subsup',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("lAr8I")).getSurroundingSymbols)(input.substring(position), '^', '^');
        return (0, (0, parcelRequire("k6dG2")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("7LAPf", function(module, exports) {
    $parcel$export(module.exports, "table", ()=>$b9aa7e1601699b23$export$9852986a3ec5f6a0);
    var $ejV7v;
    var $jfR8V;
    var $eZoBm;
    var $aVm6p;
    var $5tJfb;
    var $6bw9N;
    var $aNQyn;
    var $jcXK3;
    var $QYqpZ;
    var $lAr8I;
    const $b9aa7e1601699b23$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
    const $b9aa7e1601699b23$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
    const $b9aa7e1601699b23$var$processState = {
        END_TABLE: 2,
        BUFFER: 4,
        CLOSE_ROW: 5,
        NEW_ROW: 6,
        LINE_BREAK: 7,
        LINK: 8,
        MEDIA: 9,
        MACRO: 10,
        EMOJI: 11
    };
    const $b9aa7e1601699b23$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE,
            (0, (0, parcelRequire("aNQyn")).TokenType).RULER
        ];
        const output = [];
        let index = position;
        let currentState = $b9aa7e1601699b23$var$processState.NEW_ROW;
        let buffer = [];
        let cellsBuffer = [];
        let cellStyle = '';
        let builder = null;
        while(index < input.length){
            const char = input.charAt(index);
            const substring = input.substring(index);
            switch(currentState){
                case $b9aa7e1601699b23$var$processState.NEW_ROW:
                    {
                        const tableMatch = substring.match($b9aa7e1601699b23$var$CELL_REGEXP);
                        if (tableMatch) {
                            if (!builder) builder = new (0, (0, parcelRequire("ejV7v")).TableBuilder)(schema);
                            index += tableMatch[1].length;
                            cellStyle = tableMatch[2];
                            index += tableMatch[2].length;
                            currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                            continue;
                        }
                        currentState = $b9aa7e1601699b23$var$processState.END_TABLE;
                        continue;
                    }
                case $b9aa7e1601699b23$var$processState.LINE_BREAK:
                    {
                        const emptyLineMatch = substring.match($b9aa7e1601699b23$var$EMPTY_LINE_REGEXP);
                        if (emptyLineMatch) {
                            $b9aa7e1601699b23$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                            currentState = $b9aa7e1601699b23$var$processState.END_TABLE;
                            continue;
                        }
                        const cellMatch = substring.match($b9aa7e1601699b23$var$CELL_REGEXP);
                        if (cellMatch) currentState = $b9aa7e1601699b23$var$processState.CLOSE_ROW;
                        else currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                        continue;
                    }
                case $b9aa7e1601699b23$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("jcXK3")).parseNewlineOnly)(substring);
                        if (length) {
                            const endIndex = index;
                            const startIndex = input.lastIndexOf('|', endIndex) + 1;
                            const charsBefore = input.substring(startIndex, endIndex);
                            if (charsBefore === '' || charsBefore.match($b9aa7e1601699b23$var$EMPTY_LINE_REGEXP)) currentState = $b9aa7e1601699b23$var$processState.CLOSE_ROW;
                            else {
                                currentState = $b9aa7e1601699b23$var$processState.LINE_BREAK;
                                buffer.push(input.substr(index, length));
                            }
                            index += length;
                            continue;
                        }
                        switch(char){
                            case '|':
                                {
                                    $b9aa7e1601699b23$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                    buffer = [];
                                    const cellMatch = substring.match($b9aa7e1601699b23$var$CELL_REGEXP);
                                    if (cellMatch) {
                                        cellStyle = cellMatch[2];
                                        index += cellMatch[2].length;
                                        continue;
                                    }
                                    break;
                                }
                            case ':':
                            case ';':
                            case '(':
                                currentState = $b9aa7e1601699b23$var$processState.EMOJI;
                                continue;
                            case '[':
                                currentState = $b9aa7e1601699b23$var$processState.LINK;
                                continue;
                            case '!':
                                currentState = $b9aa7e1601699b23$var$processState.MEDIA;
                                continue;
                            case '{':
                                currentState = $b9aa7e1601699b23$var$processState.MACRO;
                                continue;
                            default:
                                buffer.push(char);
                                index++;
                                continue;
                        }
                        break;
                    }
                case $b9aa7e1601699b23$var$processState.CLOSE_ROW:
                    {
                        const bufferOutput = buffer.join('');
                        if (bufferOutput.trim().length > 0) {
                            $b9aa7e1601699b23$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                            buffer = [];
                        }
                        if (builder) {
                            builder.add(cellsBuffer);
                            cellsBuffer = [];
                        }
                        currentState = $b9aa7e1601699b23$var$processState.NEW_ROW;
                        continue;
                    }
                case $b9aa7e1601699b23$var$processState.END_TABLE:
                    if (builder) {
                        if (cellsBuffer.length) builder.add(cellsBuffer);
                        output.push(builder.buildPMNode());
                    }
                    return {
                        type: 'pmnode',
                        nodes: output,
                        length: index - position
                    };
                case $b9aa7e1601699b23$var$processState.MEDIA:
                    {
                        const token = (0, (0, parcelRequire("5tJfb")).media)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                        continue;
                    }
                case $b9aa7e1601699b23$var$processState.EMOJI:
                    {
                        const token = (0, (0, parcelRequire("6bw9N")).emoji)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                        continue;
                    }
                case $b9aa7e1601699b23$var$processState.LINK:
                    {
                        const token = (0, (0, parcelRequire("aVm6p")).linkFormat)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                            continue;
                        } else if (token.type === 'pmnode') {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                            continue;
                        }
                        break;
                    }
                case $b9aa7e1601699b23$var$processState.MACRO:
                    {
                        const match = (0, (0, parcelRequire("QYqpZ")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("aNQyn")).parseToken)(input, match.type, index, schema, context);
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $b9aa7e1601699b23$var$processState.BUFFER;
                        continue;
                    }
            }
            index++;
        }
        const bufferOutput = buffer.join('');
        if (bufferOutput.trim().length > 0) $b9aa7e1601699b23$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
        if (builder) {
            if (cellsBuffer.length) builder.add(cellsBuffer);
            output.push(builder.buildPMNode());
        }
        return {
            type: 'pmnode',
            nodes: output,
            length: index - position
        };
    };
    function $b9aa7e1601699b23$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
        if (buffer.length) {
            let contentNode = (0, (0, parcelRequire("jfR8V")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: buffer
            });
            if (style === '||') contentNode = contentNode.map((e)=>{
                return $b9aa7e1601699b23$var$createTableHeader(e, schema);
            });
            cellsBuffer.push({
                style: style,
                content: (0, (0, parcelRequire("eZoBm")).normalizePMNodes)(contentNode, schema)
            });
        }
    }
    function $b9aa7e1601699b23$var$createTableHeader(node, schema) {
        const mark = schema.marks.strong.create();
        return $b9aa7e1601699b23$var$traverseNodeAndAddMarks(node, mark, schema);
    }
    function $b9aa7e1601699b23$var$traverseContent(node, mark, schema) {
        if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
        for(let i = 0; i < node.content.childCount; i++){
            const child = node.content.child(i);
            const markedChild = $b9aa7e1601699b23$var$traverseNodeAndAddMarks(child, mark, schema);
            const updatedContent = node.content.replaceChild(i, markedChild);
            node = node.copy(updatedContent);
        }
        return node;
    }
    function $b9aa7e1601699b23$var$traverseNodeAndAddMarks(node, mark, schema) {
        if (node.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(node, [
            'strong',
            'code'
        ])) {
            const newNode = node.mark([
                ...node.marks,
                mark
            ]);
            return newNode;
        }
        return $b9aa7e1601699b23$var$traverseContent(node, mark, schema);
    }
});
parcelRegister("ejV7v", function(module, exports) {
    $parcel$export(module.exports, "TableBuilder", ()=>$2cfe1dc36946d24b$export$9e18c07f56f31a89);
    function $2cfe1dc36946d24b$var$getType(style) {
        return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
    }
    class $2cfe1dc36946d24b$export$9e18c07f56f31a89 {
        constructor(schema){
            this.emptyTableCell = ()=>{
                const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
                return tableCell.createChecked({}, paragraph.createChecked());
            };
            this.emptyTableRow = ()=>{
                const { tableRow: tableRow } = this.schema.nodes;
                return tableRow.createChecked({}, this.emptyTableCell());
            };
            this.buildTableNode = ()=>{
                const { root: root } = this;
                const { table: table } = this.schema.nodes;
                const content = root.rows.map(this.buildTableRowNode);
                if (content.length === 0) content.push(this.emptyTableRow());
                return table.createChecked({}, content);
            };
            this.buildTableRowNode = (row)=>{
                const { tableRow: tableRow } = this.schema.nodes;
                return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
            };
            this.buildTableCellNode = (cell)=>{
                const { type: type, content: content } = cell;
                if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
                const cellNode = this.schema.nodes[type];
                return cellNode.createChecked({}, content);
            };
            this.schema = schema;
            this.root = {
                rows: []
            };
        }
        get type() {
            return 'table';
        }
        add(cells) {
            if (!cells.length) return;
            let index = 0;
            for (const cell of cells){
                const { content: content, style: style } = cell;
                const cellType = $2cfe1dc36946d24b$var$getType(style);
                if (index === 0) this.addRow();
                const newCell = {
                    type: cellType,
                    content: content
                };
                this.lastRow.cells.push(newCell);
                index += 1;
            }
        }
        buildPMNode() {
            return this.buildTableNode();
        }
        addRow() {
            const { rows: rows } = this.root;
            const row = {
                cells: []
            };
            rows.push(row);
            this.lastRow = row;
        }
    }
});
parcelRegister("bv814", function(module, exports) {
    $parcel$export(module.exports, "tripleDashSymbol", ()=>$4cf9e345a26cbc6f$export$edbcd749367de060);
    var $2YNdw;
    const $4cf9e345a26cbc6f$var$token = {
        type: 'text',
        text: '\u2014',
        length: 3
    };
    const $4cf9e345a26cbc6f$var$fallback = {
        ...$4cf9e345a26cbc6f$var$token,
        text: '---'
    };
    const $4cf9e345a26cbc6f$export$edbcd749367de060 = (0, (0, parcelRequire("2YNdw")).createDashTokenParser)($4cf9e345a26cbc6f$var$token, $4cf9e345a26cbc6f$var$fallback);
});
parcelRegister("czfGv", function(module, exports) {
    $parcel$export(module.exports, "panelMacro", ()=>$8b62063d2b6cc135$export$5d7bf7e31a674541);
    var $8hkXU;
    var $jfR8V;
    var $lmw7e;
    var $eZoBm;
    var $4DXaO;
    var $ce7tp;
    const $8b62063d2b6cc135$var$allowedNodeType = [
        'paragraph',
        'heading',
        'orderedList',
        'bulletList'
    ];
    const $8b62063d2b6cc135$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'panel',
            paired: true,
            context: context,
            rawContentProcessor: $8b62063d2b6cc135$var$rawContentProcessor
        });
    };
    const $8b62063d2b6cc135$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
        const output = [];
        const parsedAttrs = (0, (0, parcelRequire("lmw7e")).parseAttrs)(rawAttrs);
        const nodeAttrs = {
            ...parsedAttrs,
            panelType: (0, (0, parcelRequire("4DXaO")).getPanelType)(parsedAttrs)
        };
        const parsedContent = (0, (0, parcelRequire("jfR8V")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: [],
            input: rawContent
        });
        const normalizedContent = (0, (0, parcelRequire("eZoBm")).normalizePMNodes)(parsedContent, schema);
        let contentBuffer = parsedAttrs.title ? [
            (0, (0, parcelRequire("ce7tp")).title)(parsedAttrs.title, schema)
        ] : [];
        for (const n of normalizedContent)if ($8b62063d2b6cc135$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
        else {
            const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
            contentBuffer = [];
            output.push(panelNode);
            output.push(n);
        }
        if (contentBuffer.length > 0) {
            const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
            output.push(panelNode);
        }
        return {
            type: 'pmnode',
            nodes: output.length ? output : [
                $8b62063d2b6cc135$var$emptyPanel(schema)
            ],
            length: length
        };
    };
    function $8b62063d2b6cc135$var$emptyPanel(schema) {
        const p = schema.nodes.paragraph.createChecked();
        return schema.nodes.panel.createChecked({}, p);
    }
});
parcelRegister("4DXaO", function(module, exports) {
    $parcel$export(module.exports, "getPanelType", ()=>$de96c37a86dfbb95$export$fa00fa3d6c22a747);
    var $31Wvy;
    const $de96c37a86dfbb95$var$COLOR_TYPE_REGEX = {
        hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
        prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
    };
    const $de96c37a86dfbb95$var$PANEL_TYPE_TO_RGB = {
        info: {
            r: 222,
            g: 235,
            b: 255
        },
        note: {
            r: 234,
            g: 230,
            b: 255
        },
        success: {
            r: 227,
            g: 252,
            b: 239
        },
        warning: {
            r: 255,
            g: 250,
            b: 230
        },
        error: {
            r: 255,
            g: 235,
            b: 230
        }
    };
    function $de96c37a86dfbb95$export$fa00fa3d6c22a747(attrs) {
        const rgb = $de96c37a86dfbb95$var$generateRgb(attrs.bgColor);
        if (!rgb) return 'info';
        let mapTo = 'info';
        let smallestDistance = Infinity;
        Object.keys($de96c37a86dfbb95$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
            const distance = $de96c37a86dfbb95$var$distanceOfRgb($de96c37a86dfbb95$var$PANEL_TYPE_TO_RGB[panelType], rgb);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                mapTo = panelType;
            }
        });
        return mapTo;
    }
    function $de96c37a86dfbb95$var$distanceOfRgb(a, b) {
        return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
    }
    function $de96c37a86dfbb95$var$generateRgb(color) {
        switch(true){
            case $de96c37a86dfbb95$var$COLOR_TYPE_REGEX.hexShort.test(color) || $de96c37a86dfbb95$var$COLOR_TYPE_REGEX.hexLong.test(color):
                return $de96c37a86dfbb95$var$parseHex(color);
            case $de96c37a86dfbb95$var$COLOR_TYPE_REGEX.rgb.test(color):
                return $de96c37a86dfbb95$var$parseRgb(color);
            case $de96c37a86dfbb95$var$COLOR_TYPE_REGEX.prgb.test(color):
                return $de96c37a86dfbb95$var$parsePrgb(color);
            default:
                return $de96c37a86dfbb95$var$parseColorName(color);
        }
    }
    function $de96c37a86dfbb95$var$parseHex(hex) {
        hex = hex.replace($de96c37a86dfbb95$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
            return r + r + g + g + b + b;
        });
        const result = $de96c37a86dfbb95$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    function $de96c37a86dfbb95$var$parseRgb(rgb) {
        const result = rgb.match($de96c37a86dfbb95$var$COLOR_TYPE_REGEX.rgb);
        return result ? {
            r: parseInt(result[1], 10),
            g: parseInt(result[2], 10),
            b: parseInt(result[3], 10)
        } : null;
    }
    function $de96c37a86dfbb95$var$parsePrgb(prgb) {
        const result = prgb.match($de96c37a86dfbb95$var$COLOR_TYPE_REGEX.prgb);
        return result ? {
            r: Math.floor(255 * parseInt(result[1], 10) / 100),
            g: Math.floor(255 * parseInt(result[2], 10) / 100),
            b: Math.floor(255 * parseInt(result[4], 10) / 100)
        } : null;
    }
    function $de96c37a86dfbb95$var$parseColorName(color) {
        return (0, (0, parcelRequire("31Wvy")).default)[color];
    }
});
parcelRegister("31Wvy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5afd3505ec4cb545$export$2e2bcd8739ae039);
    const $5afd3505ec4cb545$var$mapping = {
        crimson: {
            r: 220,
            g: 20,
            b: 60
        },
        lightpink: {
            r: 255,
            g: 182,
            b: 193
        },
        pink: {
            r: 255,
            g: 192,
            b: 203
        },
        palevioletred: {
            r: 219,
            g: 112,
            b: 147
        },
        lavenderblush: {
            r: 255,
            g: 240,
            b: 245
        },
        hotpink: {
            r: 255,
            g: 105,
            b: 180
        },
        deeppink: {
            r: 255,
            g: 20,
            b: 147
        },
        mediumvioletred: {
            r: 199,
            g: 21,
            b: 133
        },
        orchid: {
            r: 218,
            g: 112,
            b: 214
        },
        thistle: {
            r: 216,
            g: 191,
            b: 216
        },
        plum: {
            r: 221,
            g: 160,
            b: 221
        },
        violet: {
            r: 238,
            g: 130,
            b: 238
        },
        fuchsia: {
            r: 255,
            g: 0,
            b: 255
        },
        darkmagenta: {
            r: 139,
            g: 0,
            b: 139
        },
        purple: {
            r: 128,
            g: 0,
            b: 128
        },
        mediumorchid: {
            r: 186,
            g: 85,
            b: 211
        },
        darkviolet: {
            r: 148,
            g: 0,
            b: 211
        },
        darkorchid: {
            r: 153,
            g: 50,
            b: 204
        },
        indigo: {
            r: 75,
            g: 0,
            b: 130
        },
        blueviolet: {
            r: 138,
            g: 43,
            b: 226
        },
        mediumpurple: {
            r: 147,
            g: 112,
            b: 219
        },
        darkslateblue: {
            r: 72,
            g: 61,
            b: 139
        },
        mediumslateblue: {
            r: 123,
            g: 104,
            b: 238
        },
        slateblue: {
            r: 106,
            g: 90,
            b: 205
        },
        ghostwhite: {
            r: 248,
            g: 248,
            b: 255
        },
        lavender: {
            r: 230,
            g: 230,
            b: 250
        },
        blue: {
            r: 0,
            g: 0,
            b: 255
        },
        mediumblue: {
            r: 0,
            g: 0,
            b: 205
        },
        darkblue: {
            r: 0,
            g: 0,
            b: 139
        },
        navy: {
            r: 0,
            g: 0,
            b: 128
        },
        midnightblue: {
            r: 25,
            g: 25,
            b: 112
        },
        royalblue: {
            r: 65,
            g: 105,
            b: 225
        },
        cornflowerblue: {
            r: 100,
            g: 149,
            b: 237
        },
        lightsteelblue: {
            r: 176,
            g: 196,
            b: 222
        },
        lightslategray: {
            r: 119,
            g: 136,
            b: 153
        },
        slategray: {
            r: 112,
            g: 128,
            b: 144
        },
        dodgerblue: {
            r: 30,
            g: 144,
            b: 255
        },
        aliceblue: {
            r: 240,
            g: 248,
            b: 255
        },
        steelblue: {
            r: 70,
            g: 130,
            b: 180
        },
        lightskyblue: {
            r: 135,
            g: 206,
            b: 250
        },
        skyblue: {
            r: 135,
            g: 206,
            b: 235
        },
        deepskyblue: {
            r: 0,
            g: 191,
            b: 255
        },
        lightblue: {
            r: 173,
            g: 216,
            b: 230
        },
        powderblue: {
            r: 176,
            g: 224,
            b: 230
        },
        cadetblue: {
            r: 95,
            g: 158,
            b: 160
        },
        darkturquoise: {
            r: 0,
            g: 206,
            b: 209
        },
        azure: {
            r: 240,
            g: 255,
            b: 255
        },
        lightcyan: {
            r: 224,
            g: 255,
            b: 255
        },
        paleturquoise: {
            r: 174,
            g: 238,
            b: 238
        },
        darkslategray: {
            r: 47,
            g: 79,
            b: 79
        },
        aqua: {
            r: 0,
            g: 255,
            b: 255
        },
        darkcyan: {
            r: 0,
            g: 139,
            b: 139
        },
        teal: {
            r: 0,
            g: 128,
            b: 128
        },
        mediumturquoise: {
            r: 72,
            g: 209,
            b: 204
        },
        lightseagreen: {
            r: 32,
            g: 178,
            b: 170
        },
        turquoise: {
            r: 64,
            g: 224,
            b: 208
        },
        aquamarine: {
            r: 127,
            g: 255,
            b: 212
        },
        mediumaquamarine: {
            r: 102,
            g: 205,
            b: 170
        },
        mediumspringgreen: {
            r: 0,
            g: 250,
            b: 154
        },
        mintcream: {
            r: 245,
            g: 255,
            b: 250
        },
        springgreen: {
            r: 0,
            g: 255,
            b: 127
        },
        mediumseagreen: {
            r: 60,
            g: 179,
            b: 113
        },
        seagreen: {
            r: 46,
            g: 139,
            b: 87
        },
        honeydew: {
            r: 240,
            g: 255,
            b: 240
        },
        darkseagreen: {
            r: 143,
            g: 188,
            b: 143
        },
        palegreen: {
            r: 152,
            g: 251,
            b: 152
        },
        lightgreen: {
            r: 144,
            g: 238,
            b: 144
        },
        limegreen: {
            r: 50,
            g: 205,
            b: 50
        },
        forestgreen: {
            r: 34,
            g: 139,
            b: 34
        },
        lime: {
            r: 0,
            g: 255,
            b: 0
        },
        green: {
            r: 0,
            g: 128,
            b: 0
        },
        darkgreen: {
            r: 0,
            g: 100,
            b: 0
        },
        lawngreen: {
            r: 124,
            g: 252,
            b: 0
        },
        chartreuse: {
            r: 127,
            g: 255,
            b: 0
        },
        greenyellow: {
            r: 173,
            g: 255,
            b: 47
        },
        darkolivegreen: {
            r: 85,
            g: 107,
            b: 47
        },
        olivedrab: {
            r: 107,
            g: 142,
            b: 35
        },
        yellowgreen: {
            r: 154,
            g: 205,
            b: 50
        },
        ivory: {
            r: 255,
            g: 255,
            b: 240
        },
        beige: {
            r: 245,
            g: 245,
            b: 220
        },
        lightyellow: {
            r: 255,
            g: 255,
            b: 224
        },
        lightgoldenrodyellow: {
            r: 250,
            g: 250,
            b: 210
        },
        yellow: {
            r: 255,
            g: 255,
            b: 0
        },
        olive: {
            r: 128,
            g: 128,
            b: 0
        },
        darkkhaki: {
            r: 189,
            g: 183,
            b: 107
        },
        khaki: {
            r: 240,
            g: 230,
            b: 140
        },
        palegoldenrod: {
            r: 238,
            g: 232,
            b: 170
        },
        lemonchiffon: {
            r: 255,
            g: 250,
            b: 205
        },
        gold: {
            r: 255,
            g: 215,
            b: 0
        },
        cornsilk: {
            r: 255,
            g: 248,
            b: 220
        },
        goldenrod: {
            r: 218,
            g: 165,
            b: 32
        },
        darkgoldenrod: {
            r: 184,
            g: 134,
            b: 11
        },
        orange: {
            r: 255,
            g: 128,
            b: 0
        },
        floralwhite: {
            r: 255,
            g: 250,
            b: 240
        },
        oldlace: {
            r: 253,
            g: 245,
            b: 230
        },
        wheat: {
            r: 245,
            g: 222,
            b: 179
        },
        moccasin: {
            r: 255,
            g: 228,
            b: 181
        },
        papayawhip: {
            r: 255,
            g: 239,
            b: 213
        },
        blanchedalmond: {
            r: 255,
            g: 235,
            b: 205
        },
        navajowhite: {
            r: 255,
            g: 222,
            b: 173
        },
        tan: {
            r: 210,
            g: 180,
            b: 140
        },
        antiquewhite: {
            r: 250,
            g: 235,
            b: 215
        },
        burlywood: {
            r: 222,
            g: 184,
            b: 135
        },
        bisque: {
            r: 255,
            g: 228,
            b: 196
        },
        darkorange: {
            r: 255,
            g: 140,
            b: 0
        },
        peru: {
            r: 205,
            g: 133,
            b: 63
        },
        linen: {
            r: 250,
            g: 240,
            b: 230
        },
        peachpuff: {
            r: 255,
            g: 218,
            b: 185
        },
        seashell: {
            r: 255,
            g: 245,
            b: 238
        },
        sandybrown: {
            r: 244,
            g: 164,
            b: 96
        },
        chocolate: {
            r: 210,
            g: 105,
            b: 30
        },
        saddlebrown: {
            r: 139,
            g: 69,
            b: 19
        },
        sienna: {
            r: 160,
            g: 82,
            b: 45
        },
        lightsalmon: {
            r: 255,
            g: 160,
            b: 122
        },
        coral: {
            r: 255,
            g: 127,
            b: 80
        },
        orangered: {
            r: 255,
            g: 69,
            b: 0
        },
        darksalmon: {
            r: 233,
            g: 150,
            b: 122
        },
        tomato: {
            r: 255,
            g: 99,
            b: 71
        },
        salmon: {
            r: 250,
            g: 128,
            b: 114
        },
        mistyrose: {
            r: 255,
            g: 228,
            b: 225
        },
        snow: {
            r: 255,
            g: 250,
            b: 250
        },
        rosybrown: {
            r: 188,
            g: 143,
            b: 143
        },
        lightcoral: {
            r: 240,
            g: 128,
            b: 128
        },
        indianred: {
            r: 205,
            g: 92,
            b: 92
        },
        brown: {
            r: 165,
            g: 42,
            b: 42
        },
        firebrick: {
            r: 178,
            g: 34,
            b: 34
        },
        red: {
            r: 255,
            g: 0,
            b: 0
        },
        darkred: {
            r: 139,
            g: 0,
            b: 0
        },
        maroon: {
            r: 128,
            g: 0,
            b: 0
        },
        white: {
            r: 255,
            g: 255,
            b: 255
        },
        gainsboro: {
            r: 220,
            g: 220,
            b: 220
        },
        lightgray: {
            r: 211,
            g: 211,
            b: 211
        },
        silver: {
            r: 192,
            g: 192,
            b: 192
        },
        darkgray: {
            r: 169,
            g: 169,
            b: 169
        },
        gray: {
            r: 128,
            g: 128,
            b: 128
        },
        dimgray: {
            r: 105,
            g: 105,
            b: 105
        },
        black: {
            r: 0,
            g: 0,
            b: 0
        },
        whitesmoke: {
            r: 245,
            g: 245,
            b: 245
        }
    };
    var $5afd3505ec4cb545$export$2e2bcd8739ae039 = $5afd3505ec4cb545$var$mapping;
});
parcelRegister("ce7tp", function(module, exports) {
    $parcel$export(module.exports, "title", ()=>$5bc2dda50d78d6f3$export$fb184b623420d9be);
    function $5bc2dda50d78d6f3$export$fb184b623420d9be(text, schema) {
        const mark = schema.marks.strong.create();
        const title = schema.text(text, [
            mark
        ]);
        return schema.nodes.paragraph.createChecked({}, [
            title
        ]);
    }
});
parcelRegister("6xW0F", function(module, exports) {
    $parcel$export(module.exports, "adfMacro", ()=>$b90e6e3686cdfe5a$export$8fb4b58db8f664fb);
    var $8hkXU;
    const $b90e6e3686cdfe5a$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'adf',
            paired: true,
            context: context,
            rawContentProcessor: $b90e6e3686cdfe5a$var$rawContentProcessor
        });
    };
    const $b90e6e3686cdfe5a$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
        try {
            const json = JSON.parse(rawContent);
            const node = schema.nodeFromJSON(json);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        } catch (_e) {
            const textContent = `Invalid ADF Macro: ${rawContent}`;
            const textNode = rawContent.length ? schema.text(textContent) : undefined;
            const { codeBlock: codeBlock } = schema.nodes;
            const node = codeBlock.create({
                language: undefined
            }, textNode);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        }
    };
});
parcelRegister("bStxj", function(module, exports) {
    $parcel$export(module.exports, "anchorMacro", ()=>$6800fef71521d924$export$e660dadc21580fa2);
    var $8hkXU;
    const $6800fef71521d924$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'anchor',
            paired: false,
            context: context,
            rawContentProcessor: $6800fef71521d924$var$rawContentProcessor
        });
    };
    const $6800fef71521d924$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
        return {
            type: 'text',
            text: '',
            length: length
        };
    };
});
parcelRegister("3GfRf", function(module, exports) {
    $parcel$export(module.exports, "codeMacro", ()=>$d808dd88835c50b0$export$db6c131ac26c7700);
    var $8hkXU;
    var $lmw7e;
    var $ce7tp;
    const $d808dd88835c50b0$var$SUPPORTED_CODEBOCK_LANGUAGES = [
        'abap',
        'actionscript',
        'ada',
        'arduino',
        'autoit',
        'c',
        'c++',
        'clojure',
        'coffeescript',
        'csharp',
        'css',
        'cuda',
        'd',
        'dart',
        'delphi',
        'elixir',
        'erlang',
        'fortran',
        'foxpro',
        'go',
        'groovy',
        'haskell',
        'haxe',
        'html',
        'java',
        'javascript',
        'json',
        'julia',
        'kotlin',
        'latex',
        'livescript',
        'lua',
        'mathematica',
        'matlab',
        'objective-c',
        'objective-j',
        'objectpascal',
        'ocaml',
        'octave',
        'perl',
        'php',
        'powershell',
        'prolog',
        'puppet',
        'python',
        'qml',
        'r',
        'racket',
        'restructuredtext',
        'ruby',
        'rust',
        'sass',
        'scala',
        'scheme',
        'shell',
        'smalltalk',
        'sql',
        'standardml',
        'swift',
        'tcl',
        'tex',
        'typescript',
        'vala',
        'vbnet',
        'verilog',
        'vhdl',
        'xml',
        'xquery'
    ];
    const $d808dd88835c50b0$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'code',
            paired: true,
            context: context,
            rawContentProcessor: $d808dd88835c50b0$var$rawContentProcessor
        });
    };
    const $d808dd88835c50b0$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
        const output = [];
        const { codeBlock: codeBlock } = schema.nodes;
        const parsedAttrs = (0, (0, parcelRequire("lmw7e")).parseAttrs)(rawAttrs);
        const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
        const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
        if (parsedAttrs.title) output.push((0, (0, parcelRequire("ce7tp")).title)(parsedAttrs.title, schema));
        const nodeAttrs = {
            ...parsedAttrs,
            language: $d808dd88835c50b0$var$getCodeLanguage(parsedAttrs)
        };
        output.push(codeBlock.createChecked(nodeAttrs, textNode));
        return {
            type: 'pmnode',
            nodes: output,
            length: length
        };
    };
    function $d808dd88835c50b0$var$getCodeLanguage(attrs) {
        const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
        for (const language of $d808dd88835c50b0$var$SUPPORTED_CODEBOCK_LANGUAGES){
            if (keys.indexOf(language) !== -1) return language;
        }
        if (keys.indexOf('objc') !== -1) return 'objective-c';
        return 'java';
    }
});
parcelRegister("5x6Ur", function(module, exports) {
    $parcel$export(module.exports, "colorMacro", ()=>$edd5adda764c4425$export$b557be495948d995);
    var $aNQyn;
    var $8hkXU;
    var $lmw7e;
    var $jfR8V;
    var $h4uIn;
    var $lAr8I;
    const $edd5adda764c4425$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'color',
            paired: true,
            context: context,
            rawContentProcessor: $edd5adda764c4425$var$rawContentProcessor
        });
    };
    const $edd5adda764c4425$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("aNQyn")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("aNQyn")).TokenType).TABLE
        ];
        const parsedAttrs = (0, (0, parcelRequire("lmw7e")).parseAttrs)(rawAttrs);
        const content = (0, (0, parcelRequire("jfR8V")).parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: rawContent
        });
        const decoratedContent = content.map((n)=>{
            const mark = schema.marks.textColor.create({
                color: (0, (0, parcelRequire("h4uIn")).getEditorColor)(parsedAttrs) || '#000000'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("lAr8I")).hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        });
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
});
parcelRegister("h4uIn", function(module, exports) {
    $parcel$export(module.exports, "getEditorColor", ()=>$3534298dbed5e404$export$c0cfc6f23e0b7578);
    var $51H8P;
    function $3534298dbed5e404$export$c0cfc6f23e0b7578(attrs) {
        const keys = Object.keys(attrs);
        return (0, (0, parcelRequire("51H8P")).normalizeHexColor)(keys[0]);
    }
});
parcelRegister("fuaGT", function(module, exports) {
    $parcel$export(module.exports, "noformatMacro", ()=>$eae36744365d6be2$export$9199752eb9b2d5b4);
    var $8hkXU;
    var $lmw7e;
    var $ce7tp;
    const $eae36744365d6be2$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("8hkXU")).commonMacro)(input.substring(position), schema, {
            keyword: 'noformat',
            paired: true,
            context: context,
            rawContentProcessor: $eae36744365d6be2$var$rawContentProcessor
        });
    };
    const $eae36744365d6be2$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
        const output = [];
        const { codeBlock: codeBlock } = schema.nodes;
        const parsedAttrs = (0, (0, parcelRequire("lmw7e")).parseAttrs)(rawAttrs);
        const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
        const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
        if (parsedAttrs.title) output.push((0, (0, parcelRequire("ce7tp")).title)(parsedAttrs.title, schema));
        output.push(codeBlock.createChecked({}, textNode));
        return {
            type: 'pmnode',
            nodes: output,
            length: length
        };
    };
});
parcelRegister("7oSVB", function(module, exports) {
    $parcel$export(module.exports, "forceLineBreak", ()=>$9c03b9f46f689ef4$export$2de3d7fd25cbc36);
    const $9c03b9f46f689ef4$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
    const $9c03b9f46f689ef4$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
        if (position > 0) {
            const charBefore = input.charAt(position - 1);
            if (charBefore === '\\') return $9c03b9f46f689ef4$var$fallback(input, position);
        }
        const match = input.substring(position).match($9c03b9f46f689ef4$var$FORCE_LINE_BREAK_REGEX);
        if (match) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.hardBreak.createChecked()
            ],
            length: 2
        };
        return $9c03b9f46f689ef4$var$fallback(input, position);
    };
    function $9c03b9f46f689ef4$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 2),
            length: 2
        };
    }
});
parcelRegister("7xa0k", function(module, exports) {
    $parcel$export(module.exports, "code", ()=>$999b8918ed3c1b93$export$6565f9f03506010b);
    const $999b8918ed3c1b93$export$6565f9f03506010b = (text)=>{
        return `{{${text}}}`;
    };
});
parcelRegister("bZYA2", function(module, exports) {
    $parcel$export(module.exports, "textColor", ()=>$ca3b09260a4514fc$export$32f78bffcd82ff28);
    const $ca3b09260a4514fc$export$32f78bffcd82ff28 = (text, attrs)=>{
        return `{color:${attrs.color}}${text}{color}`;
    };
});
parcelRegister("jELZl", function(module, exports) {
    $parcel$export(module.exports, "em", ()=>$f9b993984f2371df$export$c63c6f932822f543);
    var $h6OAe;
    const $f9b993984f2371df$export$c63c6f932822f543 = (text)=>{
        if (text.startsWith("\u2014 ")) return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text.substring(2), '??');
        return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text, '_');
    };
});
parcelRegister("h6OAe", function(module, exports) {
    $parcel$export(module.exports, "baseMarkPattern", ()=>$a6a7780ad772f264$export$3d8aed7830783c75);
    const $a6a7780ad772f264$export$3d8aed7830783c75 = (text, token)=>{
        if (/^\s*$/.test(text)) return text;
        return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
    };
});
parcelRegister("gzE8d", function(module, exports) {
    $parcel$export(module.exports, "link", ()=>$7e0b86129a7e50a9$export$9c30223ca0a664fb);
    const $7e0b86129a7e50a9$export$9c30223ca0a664fb = (text, attrs)=>{
        return `[${text}|${attrs.href}]`;
    };
});
parcelRegister("iRXtU", function(module, exports) {
    $parcel$export(module.exports, "strike", ()=>$52bfdf68dcbc9297$export$4899a95d70ec5056);
    var $h6OAe;
    const $52bfdf68dcbc9297$export$4899a95d70ec5056 = (text)=>{
        return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text, '-');
    };
});
parcelRegister("hfgdh", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$ad8a8117ee587521$export$59ae2c325a998f89);
    var $h6OAe;
    const $ad8a8117ee587521$export$59ae2c325a998f89 = (text)=>{
        return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text, '*');
    };
});
parcelRegister("f8Dnv", function(module, exports) {
    $parcel$export(module.exports, "subsup", ()=>$2e7b686d7aa28852$export$b3401ee80eb31041);
    var $h6OAe;
    const $2e7b686d7aa28852$export$b3401ee80eb31041 = (text, attrs)=>{
        if (attrs.type === 'sub') return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text, '~');
        else return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text, '^');
    };
});
parcelRegister("7f8rN", function(module, exports) {
    $parcel$export(module.exports, "underline", ()=>$65f48efdd4cf6bde$export$425327af25286e5e);
    var $h6OAe;
    const $65f48efdd4cf6bde$export$425327af25286e5e = (text)=>{
        return (0, (0, parcelRequire("h6OAe")).baseMarkPattern)(text, '+');
    };
});
parcelRegister("iPrWY", function(module, exports) {
    $parcel$export(module.exports, "inlineCard", ()=>$9d0d0e7bd2c89087$export$cbf8224b64e0d942);
    var $kjntr;
    var $77lzI;
    const $9d0d0e7bd2c89087$export$cbf8224b64e0d942 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("kjntr")).unknown)(node);
        const match = node.attrs.url.match((0, (0, parcelRequire("77lzI")).INLINE_CARD_FROM_TEXT_STAMP));
        if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
        return `[${match[2]}]`;
    };
});
parcelRegister("6WgQP", function(module, exports) {
    $parcel$export(module.exports, "status", ()=>$7b363baea1a24c1b$export$471f7ae5c4103ae1);
    var $bZYA2;
    const $7b363baea1a24c1b$var$color = {
        grey: (0, $72ba03e317f3d228$export$eaa8c8a70ac22806),
        purple: (0, $72ba03e317f3d228$export$b48405b95304b5a1),
        blue: (0, $72ba03e317f3d228$export$9dc1ef0f3f48059b),
        red: (0, $72ba03e317f3d228$export$4a7404f376229999),
        yellow: (0, $72ba03e317f3d228$export$59619663aa6500fb),
        green: (0, $72ba03e317f3d228$export$940e1f69e873f202)
    };
    const $7b363baea1a24c1b$export$471f7ae5c4103ae1 = (node)=>{
        const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
        const newAttrs = {
            ...node.attrs
        };
        if ($7b363baea1a24c1b$var$color[node.attrs.color]) newAttrs.color = $7b363baea1a24c1b$var$color[node.attrs.color];
        else newAttrs.color = $7b363baea1a24c1b$var$color['grey'];
        return (0, (0, parcelRequire("bZYA2")).textColor)(text, newAttrs);
    };
});
parcelRegister("bmVBj", function(module, exports) {
    $parcel$export(module.exports, "date", ()=>$15e2936b7ca836bc$export$324d90190a8b822a);
    const $15e2936b7ca836bc$export$324d90190a8b822a = (node)=>{
        const addLeadingZero = (val)=>{
            if (val < 10) return `0${val}`;
            return val;
        };
        const result = new Date(Number(node.attrs.timestamp));
        return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
    };
});
parcelRegister("hOFbV", function(module, exports) {
    $parcel$export(module.exports, "codeBlock", ()=>$153cf89aad4aff8e$export$7bb0d5c671655cc4);
    var $aNFJk;
    const $153cf89aad4aff8e$var$supportedLanguageInWiki = [
        'actionscript',
        'ada',
        'applescript',
        'bash',
        'c',
        'c#',
        'c++',
        'cpp',
        'css',
        'erlang',
        'go',
        'groovy',
        'haskell',
        'html',
        'java',
        'javascript',
        'js',
        'json',
        'lua',
        'none',
        'nyan',
        'objc',
        'perl',
        'php',
        'python',
        'r',
        'rainbow',
        'ruby',
        'scala',
        'sh',
        'sql',
        'swift',
        'visualbasic',
        'xml',
        'yaml'
    ];
    const $153cf89aad4aff8e$export$7bb0d5c671655cc4 = (node)=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("aNFJk")).inlines)(n, {
                parent: node
            });
        });
        if ($153cf89aad4aff8e$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
        else return `{noformat}${result}{noformat}`;
    };
});
parcelRegister("mxur4", function(module, exports) {
    $parcel$export(module.exports, "mediaGroup", ()=>$ecdfe032bd435e7f$export$2855e964765eac9);
    var $4me33;
    var $gUk8r;
    var $kjntr;
    const $ecdfe032bd435e7f$export$2855e964765eac9 = (node, opts = {})=>{
        const result = [];
        node.forEach((n)=>{
            switch(n.type.name){
                case 'media':
                    result.push((0, (0, parcelRequire("gUk8r")).media)(n, {
                        ...opts,
                        parent: node
                    }));
                    break;
                case 'caption':
                    result.push((0, (0, parcelRequire("4me33")).caption)(n, opts));
                    break;
                default:
                    result.push((0, (0, parcelRequire("kjntr")).unknown)(n));
                    break;
            }
        });
        return result.join('\n');
    };
});
parcelRegister("4me33", function(module, exports) {
    $parcel$export(module.exports, "caption", ()=>$c4942fc624868632$export$8e3c2dfdc4f0453d);
    var $aNFJk;
    const $c4942fc624868632$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("aNFJk")).inlines)(n, {
                context: context
            });
        });
        return result;
    };
});
parcelRegister("gUk8r", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$1924d2eafc71130e$export$987d49ffe1b0900f);
    const $1924d2eafc71130e$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
        let wikiAttrs = [];
        if (parent && parent.attrs.width) wikiAttrs.push(`width=${parent.attrs.width}%`);
        else {
            if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
            if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
        }
        if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
        if (node.marks.length) {
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
        }
        let fileName;
        if (node.attrs.type === 'external') fileName = node.attrs.url;
        else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
        if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
        if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
        return `!${fileName}|thumbnail!`;
    };
});
parcelRegister("4B3TF", function(module, exports) {
    $parcel$export(module.exports, "taskList", ()=>$d94ffc9b7b4ddd9a$export$375b6afcc5f4d291);
    var $iSCez;
    const $d94ffc9b7b4ddd9a$var$nestedNode = (node, depth = 1)=>{
        const result = [];
        node.forEach((item)=>{
            if (item.type.name === 'taskList') result.push($d94ffc9b7b4ddd9a$var$nestedNode(item, depth + 1));
            else result.push((0, (0, parcelRequire("iSCez")).taskItem)(item, depth));
        });
        return result.join('\n');
    };
    const $d94ffc9b7b4ddd9a$export$375b6afcc5f4d291 = (node)=>{
        return $d94ffc9b7b4ddd9a$var$nestedNode(node);
    };
});
parcelRegister("iSCez", function(module, exports) {
    $parcel$export(module.exports, "taskItem", ()=>$6ff77f351e9de95c$export$6d8b0ef52e2e6390);
    var $aNFJk;
    const $6ff77f351e9de95c$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            const prefix = Array(nestedLevel).fill('*').join('');
            if (node.attrs.state === 'DONE') result += `${prefix} -${(0, (0, parcelRequire("aNFJk")).inlines)(n, {
                context: context
            })}-`;
            else result += `${prefix} ${(0, (0, parcelRequire("aNFJk")).inlines)(n, {
                context: context
            })}`;
        });
        return result;
    };
});
parcelRegister("aPVUf", function(module, exports) {
    $parcel$export(module.exports, "decisionList", ()=>$84f70ea1aa3dcb5d$export$62d45a65fb43d95e);
    var $k2OsS;
    const $84f70ea1aa3dcb5d$export$62d45a65fb43d95e = (node)=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("k2OsS")).decisionItem)(item));
        });
        return result.join('\n');
    };
});
parcelRegister("k2OsS", function(module, exports) {
    $parcel$export(module.exports, "decisionItem", ()=>$4ff003fbc86006f0$export$6959e16eeff859b4);
    var $aNFJk;
    const $4ff003fbc86006f0$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += `* <> ${(0, (0, parcelRequire("aNFJk")).inlines)(n, {
                context: context
            })}`;
        });
        return result;
    };
});
parcelRegister("lnLsa", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$500a2258b0b58620$export$2a111da947c407d2);
    var $2m8bC;
    const $500a2258b0b58620$export$2a111da947c407d2 = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("2m8bC")).encode)(n, context));
        });
        return result.join('\n\n');
    };
});
parcelRegister("372cg", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>$f1526fe5d3f3b4e0$export$9f77e0932fb78f72);
    var $2m8bC;
    const $f1526fe5d3f3b4e0$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
        const result = [
            `*${node.attrs.title}*`,
            ''
        ];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("2m8bC")).encode)(n, context));
        });
        return result.join('\n');
    };
});
parcelRegister("1Gh0T", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$132e091129174291$export$46e4a324ac90507f);
    var $aNFJk;
    const $132e091129174291$export$46e4a324ac90507f = (node)=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("aNFJk")).inlines)(n);
        });
        return `h${node.attrs.level}. ${result}`;
    };
});
parcelRegister("dZHVv", function(module, exports) {
    $parcel$export(module.exports, "orderedList", ()=>$d7c208df3f83960b$export$a5dc81035676e7a);
    var $8ceXI;
    const $d7c208df3f83960b$export$a5dc81035676e7a = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("8ceXI")).listItem)(item, '#', context));
        });
        return result.join('\n');
    };
});
parcelRegister("aF5s6", function(module, exports) {
    $parcel$export(module.exports, "panel", ()=>$065353fd71ef8a3b$export$21f42ab9b6679f44);
    var $2m8bC;
    const $065353fd71ef8a3b$var$panelTypeColorMapping = {
        info: '#deebff',
        note: '#eae6ff',
        success: '#e3fcef',
        warning: '#fffae6',
        error: '#ffebe6'
    };
    const $065353fd71ef8a3b$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("2m8bC")).encode)(n, context));
        });
        return `{panel:bgColor=${$065353fd71ef8a3b$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
    };
});
parcelRegister("jQCGt", function(module, exports) {
    $parcel$export(module.exports, "rule", ()=>$54cb0b5142bb194e$export$fbeb3a3956e8a3c7);
    const $54cb0b5142bb194e$export$fbeb3a3956e8a3c7 = (_node)=>{
        return '----';
    };
});
parcelRegister("k2I1S", function(module, exports) {
    $parcel$export(module.exports, "table", ()=>$8fdad845fae86757$export$9852986a3ec5f6a0);
    var $2m8bC;
    var $kjntr;
    const $8fdad845fae86757$export$9852986a3ec5f6a0 = (node, opts = {})=>{
        try {
            const result = [];
            node.forEach((n)=>{
                result.push($8fdad845fae86757$var$tableRow(n, opts));
            });
            return result.join('\n');
        } catch (err) {
            return (0, (0, parcelRequire("kjntr")).unknown)(node);
        }
    };
    const $8fdad845fae86757$var$tableRow = (node, opts = {})=>{
        let result = '';
        let separator = '|';
        node.forEach((n)=>{
            if (n.type.name === 'tableHeader') separator = '||';
            else separator = '|';
            result = `${result}${separator}${$8fdad845fae86757$var$tableCell(n, opts)}`;
        });
        return `${result}${separator}`;
    };
    const $8fdad845fae86757$var$tableCell = (node, { context: context } = {})=>{
        if ($8fdad845fae86757$var$hasMergedCell(node)) throw new Error('Advanced feature of table is not supported');
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("2m8bC")).encode)(n, context));
        });
        const output = result.join('\n').trim();
        return output === '' ? ' ' : output;
    };
    const $8fdad845fae86757$var$hasMergedCell = (node)=>{
        if (!node.attrs) return false;
        if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
        if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
        return false;
    };
});
parcelRegister("OUW1A", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$3a15f3b6725eb693$export$c4c2f833baaebdb8);
    var $kjntr;
    const $3a15f3b6725eb693$export$c4c2f833baaebdb8 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("kjntr")).unknown)(node);
        return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
    };
});
parcelRegister("eJTbS", function(module, exports) {
    $parcel$export(module.exports, "embedCard", ()=>$7a9bb3189853eca0$export$be4283d9a1cb1ff6);
    var $kjntr;
    const $7a9bb3189853eca0$export$be4283d9a1cb1ff6 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("kjntr")).unknown)(node);
        return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
    };
});
parcelRegister("eUD5S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$170c267466d5396f$export$2e2bcd8739ae039);
    var $jfR8V;
    var $eZoBm;
    class $170c267466d5396f$export$2e2bcd8739ae039 {
        constructor(schema, wikiMarkup){
            this.schema = schema;
            this.wikiMarkup = wikiMarkup;
        }
        getProseMirrorModel(context) {
            const content = (0, (0, parcelRequire("jfR8V")).parseString)({
                context: context,
                ignoreTokenTypes: [],
                input: this.wikiMarkup,
                schema: this.schema
            });
            return this.schema.nodes.doc.createChecked({}, (0, (0, parcelRequire("eZoBm")).normalizePMNodes)(content, this.schema, 'doc'));
        }
    }
});
parcelRegister("aQb3V", function(module, exports) {
    $parcel$export(module.exports, "getLearnMoreMessage", ()=>$8cc68cbdef3ac4a4$export$2c1e5dc35269c547);
    $parcel$export(module.exports, "getHelpText", ()=>$8cc68cbdef3ac4a4$export$188aeee1ab8948d8);
    $parcel$export(module.exports, "getErrorMessage", ()=>$8cc68cbdef3ac4a4$export$82f46aa4e6535a45);
    var $6s1PB;
    var $bGrWH;
    var $7vNya;
    var $dOrZq;
    const $8cc68cbdef3ac4a4$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
        const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
        if (urlSuffix in (0, (0, parcelRequire("7vNya")).LEARN_MORE_MESSAGES)) return (0, (0, parcelRequire("7vNya")).LEARN_MORE_MESSAGES)[urlSuffix];
        return (0, (0, parcelRequire("dOrZq")).default).fieldHelpTextLabel;
    };
    const $8cc68cbdef3ac4a4$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
        const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
        const helperMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7vNya")).LEARN_MORE_MESSAGES_WITH_ISSUE_TERM)[urlSuffix] : $8cc68cbdef3ac4a4$export$2c1e5dc35269c547(fieldHelpTextUrl);
        return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
    };
    const $8cc68cbdef3ac4a4$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
        switch(validationError){
            case 0, (0, parcelRequire("bGrWH")).REQUIRED:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).requiredErrorMessage, {
                    fieldName: fieldName
                });
            case 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).labelsMaxErrorMessage, {
                    MAX_ALLOWED_LABELS: formatNumber((0, $d46ffa3990e23a4d$export$1fdf850c93de8bae))
                });
            case 0, $d46ffa3990e23a4d$export$e77d629cc732976d:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).labelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
                });
            case 0, $d46ffa3990e23a4d$export$618e922e89e8bcae:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).stringInvalidErrorMessage, {
                    fieldName: fieldName,
                    MAX_STRING_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$fe1a70381f6491b5))
                });
            case 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).forgeLabelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
                });
            default:
                return validationError;
        }
    };
});
parcelRegister("bGrWH", function(module, exports) {
    $parcel$export(module.exports, "REQUIRED", ()=>$4aabf2a0e09eb856$export$b1c05b34d317c074);
    $parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$1a020bd73f33e5a);
    $parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$9eadc594a5383580);
    $parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
    $parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$cf70f9220e6a2f50);
    $parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$aac4661200ba4104);
    $parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a23c32d5cf54cba0);
    $parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$74ab3898ae683660);
    $parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$983715bb9b0f9b2c);
    $parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", ()=>$4aabf2a0e09eb856$export$40f6793dd75f4e52);
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", ()=>$4aabf2a0e09eb856$export$3bf5bce483cc2c30);
    $parcel$export(module.exports, "ISSUE_CREATE_TYPE", ()=>$4aabf2a0e09eb856$export$30cc1fd33e7c7258);
    $parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", ()=>$4aabf2a0e09eb856$export$8170252f0ea43511);
    const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
    const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
    const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
    const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
    const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
    const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
    const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
    const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
    const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
    const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
    const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
    const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
        'worklog_adjustmentAmount',
        'worklog_adjustEstimate',
        'worklog_activate'
    ];
    const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
        ...$4aabf2a0e09eb856$export$74ab3898ae683660,
        $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
        $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
        $4aabf2a0e09eb856$export$aac4661200ba4104,
        $4aabf2a0e09eb856$export$a23c32d5cf54cba0
    ];
    const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
        [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
    };
    const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
        behavior: 'auto',
        scrollMode: 'if-needed',
        block: 'start'
    };
    const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
        'com.atlassian.servicedesk:sd-request-participants'
    ];
    const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
        linkedIssue: 'LINKED_ISSUE_CREATE',
        standard: 'STANDARD'
    };
    const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';
});
const $d46ffa3990e23a4d$export$9151073f92820ff8 = 255;
const $d46ffa3990e23a4d$export$fe1a70381f6491b5 = 255;
const $d46ffa3990e23a4d$export$1fdf850c93de8bae = 55;
const $d46ffa3990e23a4d$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $d46ffa3990e23a4d$export$e77d629cc732976d = 'LABELS INVALID';
const $d46ffa3990e23a4d$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $d46ffa3990e23a4d$export$618e922e89e8bcae = 'STRING_INVALID';
parcelRegister("7vNya", function(module, exports) {
    $parcel$export(module.exports, "LEARN_MORE_MESSAGES_WITH_ISSUE_TERM", ()=>$6a6781d11d912198$export$1b2b0fc2cd5817de);
    $parcel$export(module.exports, "LEARN_MORE_MESSAGES", ()=>$6a6781d11d912198$export$eedb1bf75e1efb26);
    var $dOrZq;
    const $6a6781d11d912198$var$LEARN_MORE_TYPES = {
        IssueTypes: '#IssueTypes',
        PriorityLevels: '#PriorityLevels',
        ResolutionTypes: '#ResolutionTypes',
        SecurityLevels: '#SecurityLevels'
    };
    const $6a6781d11d912198$export$1b2b0fc2cd5817de = {
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpIssueTypesIssueTermRefresh,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpPriorityLevels,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpResolutionDefinitions,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpSecurityLevels
    };
    const $6a6781d11d912198$export$eedb1bf75e1efb26 = {
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpIssueTypes,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpPriorityLevels,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpResolutionDefinitions,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpSecurityLevels
    };
});
parcelRegister("dOrZq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c5d9a42d37b19ea$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c5d9a42d37b19ea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        requiredErrorMessage: {
            "id": "issue-create-commons.common.field-message.required-error-message",
            "defaultMessage": "{fieldName} is required"
        },
        labelsInvalidErrorMessage: {
            "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
            "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
        },
        stringInvalidErrorMessage: {
            "id": "issue-create-commons.common.field-message.string-invalid-error-message",
            "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
        },
        forgeLabelsInvalidErrorMessage: {
            "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
            "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
        },
        labelsMaxErrorMessage: {
            "id": "issue-create-commons.common.field-message.labels-max-error-message",
            "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
        },
        fieldHelpTextLabel: {
            "id": "issue-create-commons.common.field-message.field-help-text-label",
            "defaultMessage": "Learn more"
        },
        fieldHelpIssueTypes: {
            "id": "issue-create-commons.common.field-message.field-help-issue-types",
            "defaultMessage": "Learn about issue types"
        },
        fieldHelpPriorityLevels: {
            "id": "issue-create-commons.common.field-message.field-help-priority-levels",
            "defaultMessage": "Learn about priority levels"
        },
        fieldHelpResolutionDefinitions: {
            "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
            "defaultMessage": "Resolutions definitions"
        },
        fieldHelpSecurityLevels: {
            "id": "issue-create-commons.common.field-message.field-help-security-levels",
            "defaultMessage": "More on security levels"
        },
        fieldHelpIssueTypesIssueTermRefresh: {
            "id": "issue-create-commons.common.field-message.field-help-issue-types-issue-term-refresh",
            "defaultMessage": "Learn about work types"
        }
    });
});
parcelRegister("iblgc", function(module, exports) {
    $parcel$export(module.exports, "FieldSkeleton", ()=>$20aa6a3390c971a5$export$f102dad4aafe4ad4);
    $parcel$export(module.exports, "default", ()=>$20aa6a3390c971a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    var $YSJPS;
    const $20aa6a3390c971a5$export$f102dad4aafe4ad4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
            "data-testid": "issue-create-commons.common.ui.loader.skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Label, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Description, null));
    const $20aa6a3390c971a5$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, Array.from({
            length: skeletonCount
        }, (_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$export$f102dad4aafe4ad4, {
                key: `field-skeleton-${index}`
            })));
    var $20aa6a3390c971a5$export$2e2bcd8739ae039 = $20aa6a3390c971a5$var$IssueCreateLoader;
    const $20aa6a3390c971a5$var$Label = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
                __cmplp.className
            ])
        });
    });
    $20aa6a3390c971a5$var$Label.displayName = 'LabelSkeleton';
    const $20aa6a3390c971a5$var$Description = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ipxbi _1bsb1mjv",
                __cmplp.className
            ])
        });
    });
    $20aa6a3390c971a5$var$Description.displayName = 'DescriptionSkeleton';
});
parcelRegister("1wbtX", function(module, exports) {
    $parcel$export(module.exports, "getKeyframes", ()=>$39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
    $parcel$export(module.exports, "Skeleton", ()=>$39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "Spacer", ()=>$39c21c8edc6f2616$export$d7a54cba636a8cd6);
    $parcel$export(module.exports, "SkeletonCompiled", ()=>$39c21c8edc6f2616$export$dc84d515085190e);
    $parcel$export(module.exports, "SpacerCompiled", ()=>$39c21c8edc6f2616$export$e477bb7d17087f28);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
        const fromPositionX = -Math.abs(offsetX) - 300;
        const toPositionX = fromPositionX + 2000;
        return (0, $47bDC.keyframes)({
            '0%': {
                backgroundPosition: `${fromPositionX}px 0`
            },
            '100%': {
                backgroundPosition: `${toPositionX}px 0`
            }
        });
    };
    const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
    const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-0"
    })((props)=>({
            animationDelay: props.theme.animationDelay || '0s',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$exports).N30})`,
            backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $72ba03e317f3d228$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $72ba03e317f3d228$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $72ba03e317f3d228$exports).N30})`} 50% )`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '2px',
            height: props.height,
            width: props.width
        }));
    const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-1"
    })((props)=>({
            height: props.height
        }));
    const $39c21c8edc6f2616$export$dc84d515085190e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
                __cmplp.className
            ])
        });
    });
    const $39c21c8edc6f2616$export$e477bb7d17087f28 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1474",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("YSJPS", function(module, exports) {
    $parcel$export(module.exports, "StyledFieldSkeleton", ()=>$f113eb09b8933f94$export$ed5de990fe261b7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    const $f113eb09b8933f94$export$ed5de990fe261b7b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _1bsb1edt _otyr12x7",
                __cmplp.className
            ])
        });
    });
    $f113eb09b8933f94$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';
});
parcelRegister("86fzT", function(module, exports) {
    $parcel$export(module.exports, "generateKeyForRequiredFromUIM", ()=>$81f27e245685507d$export$920d96e4692b3d51);
    const $81f27e245685507d$export$920d96e4692b3d51 = (parameters)=>{
        const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
        return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
    };
});
parcelRegister("ii6hB", function(module, exports) {
    $parcel$export(module.exports, "AffectedServicesField", ()=>$387f926e9d9168ff$export$dbde2fdac14e77d6);
    $parcel$export(module.exports, "default", ()=>$387f926e9d9168ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $f0bro;
    var $7C5S0;
    var $YSJPS;
    var $hpV4g;
    var $gLdtQ;
    var $aZJYe;
    const $387f926e9d9168ff$export$dbde2fdac14e77d6 = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
        const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
        const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
        const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, (0, parcelRequire("aZJYe")).useFetchAffectedServicesName)();
        (0, $5uXOq.useEffect)(()=>{
            if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
                const ids = defaultValue.reduce((serviceIds, service)=>service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
                if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
                setShouldFetchServiceName(false);
            } else setSelectedOptions(value);
        }, [
            defaultValue,
            fetchAffectedServicesName,
            setSelectedOptions,
            shouldFetchServiceName,
            value
        ]);
        const getAffectedServicesEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f0bro")).default), {
                ...fieldProps,
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: selectedOptions,
                fieldId: fieldId,
                isInvalid: Boolean(error),
                isDisabled: !isEditable,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                fetchSuggestionsOnFocus: true
            });
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: nonEditableReason?.message || ''
        }, getAffectedServicesEdit()) : getAffectedServicesEdit());
    };
    var $387f926e9d9168ff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aZJYe")).transformDefaultAffectedServices)
    })($387f926e9d9168ff$export$dbde2fdac14e77d6);
});
parcelRegister("f0bro", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64bb95b3ef8c5394$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lHuuV;
    var $koVbs;
    var $lElIo;
    var $FtZX9;
    var $kEqrP;
    var $2WZSx;
    var $2ngL6;
    const $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
    const $64bb95b3ef8c5394$var$AffectedServicesPickerEdit = (props)=>{
        const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
        const searchAffectedServices = async (query = '')=>{
            setLastFetchFailed(false);
            try {
                (0, (0, parcelRequire("kEqrP")).fetchAffectedServicesExperience).start();
                const affectedServices = await (0, (0, parcelRequire("2ngL6")).fetchAffectedServices)(query, autoCompleteUrl);
                (0, (0, parcelRequire("kEqrP")).fetchAffectedServicesExperience).success();
                return affectedServices;
            } catch (err) {
                setLastFetchFailed(true);
                (0, (0, parcelRequire("kEqrP")).fetchAffectedServicesExperience).failure();
                return [];
            }
        };
        const onFocus = async ()=>{
            if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
                shouldFetchDefaultOptions.current = false;
                setIsLoading && setIsLoading(true);
                const options = await searchAffectedServices();
                setDefaultOptions && setDefaultOptions(options);
                setIsLoading && setIsLoading(false);
            }
        };
        const loadOptionsDebounced = (0, (0, parcelRequire("FtZX9")).default)(searchAffectedServices, $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
        const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, (0, parcelRequire("2WZSx")).default).failedFetch : (0, (0, parcelRequire("2WZSx")).default).noMatches), [
            formatMessage,
            lastFetchFailed
        ]);
        const defaultOptionsProps = ()=>{
            if (fetchSuggestionsOnFocus) return {
                onFocus: onFocus,
                isLoading: isLoading,
                defaultOptions: defaultOptions
            };
            return {};
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lHuuV")).default), {
            ...fieldProps,
            fieldId: fieldId,
            loadOptions: loadOptionsDebounced,
            onChange: onChange,
            autoFocus: false,
            ...defaultOptionsProps(),
            isClearable: Boolean(value),
            isMulti: true,
            value: value,
            validationState: isInvalid === true ? 'error' : null,
            noOptionsMessage: noOptionsMessage,
            placeholder: placeholder,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            "data-testid": "issue-field-affected-services.ui.edit.async-select"
        });
    };
    var $64bb95b3ef8c5394$export$2e2bcd8739ae039 = $64bb95b3ef8c5394$var$AffectedServicesPickerEdit;
});
parcelRegister("lHuuV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$88cd7d9d5d0ba0d8$export$2e2bcd8739ae039);
    var $kWDSl;
    var $2s2ld;
    const $88cd7d9d5d0ba0d8$var$AsyncSelect = (0, (0, parcelRequire("2s2ld")).default)((0, (0, parcelRequire("kWDSl")).default));
    var $88cd7d9d5d0ba0d8$export$2e2bcd8739ae039 = $88cd7d9d5d0ba0d8$var$AsyncSelect;
});
parcelRegister("kWDSl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f69c74a471c03f5$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("6vVYA")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $3uzTK;
    var $6vVYA;
    var $dIVa9;
    const $4f69c74a471c03f5$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("6vVYA")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("dIVa9")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uzTK")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $4f69c74a471c03f5$export$2e2bcd8739ae039 = $4f69c74a471c03f5$var$AsyncSelect;
});
parcelRegister("3uzTK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c6e1da0a778b1ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oS3b;
    var $3vyhk;
    var $g6yke;
    var $2JKLA;
    var $aFNBY;
    var $gSXak;
    var $iTuaH;
    var $fenYw;
    var $b4pnV;
    var $by9Y7;
    var $crsHE;
    var $gZxD5;
    var $g2UN3;
    const $9c6e1da0a778b1ba$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("g2UN3")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("g2UN3")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("by9Y7")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("g6yke")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("g6yke")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("g6yke")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("g6yke")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("g2UN3")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $9c6e1da0a778b1ba$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $9c6e1da0a778b1ba$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $9c6e1da0a778b1ba$var$isOptionSelected(props, option, selectValue);
        const label = $9c6e1da0a778b1ba$var$getOptionLabel(props, option);
        const value = $9c6e1da0a778b1ba$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$9c6e1da0a778b1ba$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $9c6e1da0a778b1ba$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("g2UN3")).notNullish));
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptions(props, selectValue) {
        return $9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions($9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue));
    }
    function $9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$9c6e1da0a778b1ba$var$shouldHideSelectedOptions(props) || !isSelected) && $9c6e1da0a778b1ba$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $9c6e1da0a778b1ba$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $9c6e1da0a778b1ba$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $9c6e1da0a778b1ba$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $9c6e1da0a778b1ba$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $9c6e1da0a778b1ba$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $9c6e1da0a778b1ba$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $9c6e1da0a778b1ba$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $9c6e1da0a778b1ba$var$getOptionValue(props, option);
        return selectValue.some((i)=>$9c6e1da0a778b1ba$var$getOptionValue(props, i) === candidate);
    }
    function $9c6e1da0a778b1ba$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $9c6e1da0a778b1ba$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $9c6e1da0a778b1ba$var$instanceId = 1;
    class $9c6e1da0a778b1ba$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $9c6e1da0a778b1ba$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("3vyhk")).isSafari)() : (0, (0, parcelRequire("3vyhk")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("g2UN3")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("g2UN3")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("g2UN3")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("g2UN3")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("g2UN3")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $9c6e1da0a778b1ba$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds($9c6e1da0a778b1ba$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("g2UN3")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $9c6e1da0a778b1ba$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $9c6e1da0a778b1ba$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("crsHE")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("2JKLA")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$9c6e1da0a778b1ba$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("g2UN3")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $9c6e1da0a778b1ba$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$9c6e1da0a778b1ba$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("g2UN3")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $9c6e1da0a778b1ba$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("g2UN3")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $9c6e1da0a778b1ba$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds($9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $9c6e1da0a778b1ba$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $9c6e1da0a778b1ba$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $9c6e1da0a778b1ba$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("g2UN3")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("g2UN3")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("gZxD5")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("gZxD5")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("gZxD5")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $9c6e1da0a778b1ba$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $9c6e1da0a778b1ba$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $9c6e1da0a778b1ba$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aFNBY")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("g2UN3")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b4pnV")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iTuaH")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSXak")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fenYw")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("3vyhk", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$2274fb9bfe3ef11a$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$2274fb9bfe3ef11a$export$e1865c3bedcd822b);
    function $2274fb9bfe3ef11a$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $2274fb9bfe3ef11a$export$186c6964ca17d99() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^iPhone/i);
    }
    function $2274fb9bfe3ef11a$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $2274fb9bfe3ef11a$export$9ac100e40613ea10() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^Mac/i);
    }
    function $2274fb9bfe3ef11a$export$7bef049ce92e4224() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^iPad/i) || $2274fb9bfe3ef11a$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $2274fb9bfe3ef11a$export$fedb369cb70207f1() {
        return $2274fb9bfe3ef11a$export$186c6964ca17d99() || $2274fb9bfe3ef11a$export$7bef049ce92e4224();
    }
    function $2274fb9bfe3ef11a$export$e1865c3bedcd822b() {
        return $2274fb9bfe3ef11a$export$9ac100e40613ea10() || $2274fb9bfe3ef11a$export$fedb369cb70207f1();
    }
});
parcelRegister("g6yke", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$949b2d8695786188$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$949b2d8695786188$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$949b2d8695786188$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$949b2d8695786188$export$56bd0c8d90db075);
    const $949b2d8695786188$export$f4da216a6ca54656 = (group)=>group.label;
    const $949b2d8695786188$export$dac6ace3020563ca = (option)=>option.label;
    const $949b2d8695786188$export$40be908210c5a79c = (option)=>option.value;
    const $949b2d8695786188$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("2JKLA", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$d8841908a1a3116c$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$d8841908a1a3116c$export$71abc632aa29e6fe);
    var $hekcY;
    var $5EgAF;
    var $5dHSO;
    var $8KLo7;
    var $loRFz;
    var $b4pnV;
    var $hti3c;
    var $1MDaa;
    var $hklN8;
    var $7SnYw;
    const $d8841908a1a3116c$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("8KLo7")).ClearIndicator),
        Control: (0, (0, parcelRequire("5EgAF")).default),
        DropdownIndicator: (0, (0, parcelRequire("8KLo7")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("8KLo7")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("8KLo7")).CrossIcon),
        Group: (0, (0, parcelRequire("5dHSO")).default),
        GroupHeading: (0, (0, parcelRequire("5dHSO")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("hekcY")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("8KLo7")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("loRFz")).default),
        LoadingIndicator: (0, (0, parcelRequire("8KLo7")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("b4pnV")).default),
        MenuList: (0, (0, parcelRequire("b4pnV")).MenuList),
        MenuPortal: (0, (0, parcelRequire("b4pnV")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("b4pnV")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("b4pnV")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hti3c")).default),
        MultiValueContainer: (0, (0, parcelRequire("hti3c")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hti3c")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hti3c")).MultiValueRemove),
        Option: (0, (0, parcelRequire("1MDaa")).default),
        Placeholder: (0, (0, parcelRequire("hklN8")).default),
        SelectContainer: (0, (0, parcelRequire("hekcY")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("7SnYw")).default),
        ValueContainer: (0, (0, parcelRequire("hekcY")).ValueContainer)
    };
    const $d8841908a1a3116c$export$71abc632aa29e6fe = (props)=>({
            ...$d8841908a1a3116c$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("hekcY", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$c0357af0bdb2c3e2$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$c0357af0bdb2c3e2$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$c0357af0bdb2c3e2$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$c0357af0bdb2c3e2$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$c0357af0bdb2c3e2$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$c0357af0bdb2c3e2$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $g2UN3;
    const $c0357af0bdb2c3e2$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $c0357af0bdb2c3e2$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $c0357af0bdb2c3e2$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $c0357af0bdb2c3e2$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $c0357af0bdb2c3e2$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $c0357af0bdb2c3e2$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("g2UN3", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$d301bcbf5bee5718$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$d301bcbf5bee5718$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$d301bcbf5bee5718$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$d301bcbf5bee5718$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$d301bcbf5bee5718$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$d301bcbf5bee5718$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$d301bcbf5bee5718$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$d301bcbf5bee5718$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$d301bcbf5bee5718$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$d301bcbf5bee5718$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$d301bcbf5bee5718$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$d301bcbf5bee5718$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$d301bcbf5bee5718$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$d301bcbf5bee5718$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$d301bcbf5bee5718$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$d301bcbf5bee5718$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$d301bcbf5bee5718$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$d301bcbf5bee5718$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$d301bcbf5bee5718$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$d301bcbf5bee5718$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$d301bcbf5bee5718$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$d301bcbf5bee5718$export$4213b25a1c4e877);
    const $d301bcbf5bee5718$export$8793edee2d425525 = ()=>{};
    const $d301bcbf5bee5718$export$1643ccb46f49255c = ()=>'';
    function $d301bcbf5bee5718$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $d301bcbf5bee5718$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$d301bcbf5bee5718$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $d301bcbf5bee5718$export$33f062f47f21a01 = (value)=>{
        if ($d301bcbf5bee5718$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $d301bcbf5bee5718$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $d301bcbf5bee5718$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $d301bcbf5bee5718$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $d301bcbf5bee5718$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $d301bcbf5bee5718$export$2e0654fad740d2e4(el) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $d301bcbf5bee5718$export$c4a223a8ba9e4ea5(el) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $d301bcbf5bee5718$export$3f99968195accfaf(el, top) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $d301bcbf5bee5718$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $d301bcbf5bee5718$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $d301bcbf5bee5718$export$858c30343199f3af(element, to, duration = 200, callback = $d301bcbf5bee5718$export$8793edee2d425525) {
        const start = $d301bcbf5bee5718$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $d301bcbf5bee5718$var$easeOutCubic(currentTime, start, change, duration);
            $d301bcbf5bee5718$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $d301bcbf5bee5718$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $d301bcbf5bee5718$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $d301bcbf5bee5718$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $d301bcbf5bee5718$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $d301bcbf5bee5718$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $d301bcbf5bee5718$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $d301bcbf5bee5718$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $d301bcbf5bee5718$var$passiveOptionAccessed = false;
    const $d301bcbf5bee5718$var$options = {
        get passive () {
            return $d301bcbf5bee5718$var$passiveOptionAccessed = true;
        }
    };
    const $d301bcbf5bee5718$var$w = typeof window !== 'undefined' ? window : {};
    if ($d301bcbf5bee5718$var$w.addEventListener && $d301bcbf5bee5718$var$w.removeEventListener) {
        $d301bcbf5bee5718$var$w.addEventListener('p', $d301bcbf5bee5718$export$8793edee2d425525, $d301bcbf5bee5718$var$options);
        $d301bcbf5bee5718$var$w.removeEventListener('p', $d301bcbf5bee5718$export$8793edee2d425525, false);
    }
    const $d301bcbf5bee5718$export$b0622a6911dbeaf5 = $d301bcbf5bee5718$var$passiveOptionAccessed;
    function $d301bcbf5bee5718$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $d301bcbf5bee5718$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $d301bcbf5bee5718$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $d301bcbf5bee5718$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $d301bcbf5bee5718$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $d301bcbf5bee5718$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("5EgAF", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$112794acdb2bce64$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$112794acdb2bce64$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $112794acdb2bce64$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $112794acdb2bce64$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $112794acdb2bce64$export$2e2bcd8739ae039 = $112794acdb2bce64$var$Control;
});
parcelRegister("5dHSO", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$f6fdd3148ce7aff3$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$f6fdd3148ce7aff3$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$f6fdd3148ce7aff3$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$f6fdd3148ce7aff3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $f6fdd3148ce7aff3$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $f6fdd3148ce7aff3$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $f6fdd3148ce7aff3$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $f6fdd3148ce7aff3$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("g2UN3")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $f6fdd3148ce7aff3$export$2e2bcd8739ae039 = $f6fdd3148ce7aff3$var$Group;
});
parcelRegister("8KLo7", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$c5c80ec94c3996b7$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$c5c80ec94c3996b7$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$c5c80ec94c3996b7$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$c5c80ec94c3996b7$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$c5c80ec94c3996b7$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$c5c80ec94c3996b7$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$c5c80ec94c3996b7$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$c5c80ec94c3996b7$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$c5c80ec94c3996b7$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$c5c80ec94c3996b7$export$7c20be4c1d342248);
    var $f8Sb3;
    var $g2UN3;
    function $c5c80ec94c3996b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5c80ec94c3996b7$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $c5c80ec94c3996b7$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $c5c80ec94c3996b7$var$styles,
            ...props
        });
    const $c5c80ec94c3996b7$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $c5c80ec94c3996b7$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $c5c80ec94c3996b7$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $c5c80ec94c3996b7$export$e1687335805e1230 = $c5c80ec94c3996b7$var$baseCSS;
    const $c5c80ec94c3996b7$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$export$c5cbe1656ba71e6c, null));
    };
    const $c5c80ec94c3996b7$export$9c0419fd944c1def = $c5c80ec94c3996b7$var$baseCSS;
    const $c5c80ec94c3996b7$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$export$3b621d86b1566b2, null));
    };
    const $c5c80ec94c3996b7$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $c5c80ec94c3996b7$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $c5c80ec94c3996b7$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $c5c80ec94c3996b7$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $c5c80ec94c3996b7$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$c5c80ec94c3996b7$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $c5c80ec94c3996b7$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("loRFz", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$722f6bdaf9005a3c$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$722f6bdaf9005a3c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $722f6bdaf9005a3c$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$722f6bdaf9005a3c$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $722f6bdaf9005a3c$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $722f6bdaf9005a3c$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$722f6bdaf9005a3c$var$spacingStyle
        }
    };
    const $722f6bdaf9005a3c$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$722f6bdaf9005a3c$var$spacingStyle
        });
    const $722f6bdaf9005a3c$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("g2UN3")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $722f6bdaf9005a3c$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $722f6bdaf9005a3c$export$2e2bcd8739ae039 = $722f6bdaf9005a3c$var$Input;
});
parcelRegister("b4pnV", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$b1a905a6e7ee6f32$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$b1a905a6e7ee6f32$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$b1a905a6e7ee6f32$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$b1a905a6e7ee6f32$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$b1a905a6e7ee6f32$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$b1a905a6e7ee6f32$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$b1a905a6e7ee6f32$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$b1a905a6e7ee6f32$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$b1a905a6e7ee6f32$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$b1a905a6e7ee6f32$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$b1a905a6e7ee6f32$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $g2UN3;
    function $b1a905a6e7ee6f32$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("g2UN3")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("g2UN3")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("g2UN3")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $b1a905a6e7ee6f32$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $b1a905a6e7ee6f32$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $b1a905a6e7ee6f32$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$b1a905a6e7ee6f32$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $b1a905a6e7ee6f32$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $b1a905a6e7ee6f32$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b1a905a6e7ee6f32$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $b1a905a6e7ee6f32$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $b1a905a6e7ee6f32$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $b1a905a6e7ee6f32$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $b1a905a6e7ee6f32$export$2e2bcd8739ae039 = $b1a905a6e7ee6f32$var$Menu;
    const $b1a905a6e7ee6f32$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $b1a905a6e7ee6f32$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $b1a905a6e7ee6f32$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $b1a905a6e7ee6f32$export$cf0e22534d8b0074 = $b1a905a6e7ee6f32$var$noticeCSS;
    const $b1a905a6e7ee6f32$export$98ec46397a8cb3cd = $b1a905a6e7ee6f32$var$noticeCSS;
    const $b1a905a6e7ee6f32$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $b1a905a6e7ee6f32$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $b1a905a6e7ee6f32$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $b1a905a6e7ee6f32$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b1a905a6e7ee6f32$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("g2UN3")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b1a905a6e7ee6f32$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hti3c", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$04718750df22b9a9$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$04718750df22b9a9$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$04718750df22b9a9$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$04718750df22b9a9$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$04718750df22b9a9$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$04718750df22b9a9$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$04718750df22b9a9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    var $8KLo7;
    const $04718750df22b9a9$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $04718750df22b9a9$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $04718750df22b9a9$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $04718750df22b9a9$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $04718750df22b9a9$export$cf9cf2a30a59265c = $04718750df22b9a9$export$e1de505c1242dc1a;
    const $04718750df22b9a9$export$544aeea2a5ce08ee = $04718750df22b9a9$export$e1de505c1242dc1a;
    function $04718750df22b9a9$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8KLo7")).CrossIcon), {
            size: 14
        }));
    }
    const $04718750df22b9a9$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $04718750df22b9a9$export$2e2bcd8739ae039 = $04718750df22b9a9$var$MultiValue;
});
parcelRegister("1MDaa", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$32784da36597034c$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$32784da36597034c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $32784da36597034c$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $32784da36597034c$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $32784da36597034c$export$2e2bcd8739ae039 = $32784da36597034c$var$Option;
});
parcelRegister("hklN8", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$897d07c49a2fc3b7$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$897d07c49a2fc3b7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $897d07c49a2fc3b7$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $897d07c49a2fc3b7$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $897d07c49a2fc3b7$export$2e2bcd8739ae039 = $897d07c49a2fc3b7$var$Placeholder;
});
parcelRegister("7SnYw", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$8be3a115a328f6d6$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$8be3a115a328f6d6$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $8be3a115a328f6d6$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $8be3a115a328f6d6$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $8be3a115a328f6d6$export$2e2bcd8739ae039 = $8be3a115a328f6d6$var$SingleValue;
});
parcelRegister("aFNBY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53a19d4b009f6971$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $53a19d4b009f6971$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $53a19d4b009f6971$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("g2UN3")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $53a19d4b009f6971$var$dummyInputStyles
        });
    }
});
parcelRegister("gSXak", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cda2f07a4dd034e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gCBvJ;
    function $5cda2f07a4dd034e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5cda2f07a4dd034e$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $5cda2f07a4dd034e$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $5cda2f07a4dd034e$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("gCBvJ")).default)
        });
    var $5cda2f07a4dd034e$export$2e2bcd8739ae039 = $5cda2f07a4dd034e$var$RequiredInput;
});
parcelRegister("iTuaH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$117d781a987cee69$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7pQpP;
    var $6QLsL;
    function $117d781a987cee69$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $117d781a987cee69$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $117d781a987cee69$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $117d781a987cee69$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("7pQpP")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("6QLsL")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $117d781a987cee69$var$blurSelectInput,
            css: $117d781a987cee69$var$styles
        }), children(targetRef));
    }
});
parcelRegister("7pQpP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$356f91d0bcb9815a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2UN3;
    const $356f91d0bcb9815a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $356f91d0bcb9815a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $356f91d0bcb9815a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("g2UN3")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("6QLsL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9237a2ecafc7ea7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b9237a2ecafc7ea7$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $b9237a2ecafc7ea7$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $b9237a2ecafc7ea7$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $b9237a2ecafc7ea7$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $b9237a2ecafc7ea7$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $b9237a2ecafc7ea7$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $b9237a2ecafc7ea7$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $b9237a2ecafc7ea7$var$activeScrollLocks = 0;
    const $b9237a2ecafc7ea7$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $b9237a2ecafc7ea7$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$b9237a2ecafc7ea7$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $b9237a2ecafc7ea7$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $b9237a2ecafc7ea7$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($b9237a2ecafc7ea7$var$LOCK_STYLES).forEach((key)=>{
                    const val = $b9237a2ecafc7ea7$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $b9237a2ecafc7ea7$var$isTouchDevice()) {
                target.addEventListener('touchmove', $b9237a2ecafc7ea7$var$preventTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $b9237a2ecafc7ea7$var$preventInertiaScroll, $b9237a2ecafc7ea7$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $b9237a2ecafc7ea7$var$allowTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                }
            }
            $b9237a2ecafc7ea7$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$b9237a2ecafc7ea7$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $b9237a2ecafc7ea7$var$activeScrollLocks = Math.max($b9237a2ecafc7ea7$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $b9237a2ecafc7ea7$var$activeScrollLocks < 1) $b9237a2ecafc7ea7$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $b9237a2ecafc7ea7$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $b9237a2ecafc7ea7$var$preventTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $b9237a2ecafc7ea7$var$preventInertiaScroll, $b9237a2ecafc7ea7$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $b9237a2ecafc7ea7$var$allowTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("fenYw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bb923c406dba917$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2oS3b;
    var $7y9my;
    var $bsT3T;
    const $8bb923c406dba917$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("7y9my")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bsT3T")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bsT3T")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $8bb923c406dba917$export$2e2bcd8739ae039 = $8bb923c406dba917$var$LiveRegion;
});
parcelRegister("7y9my", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$a7b3e13a3bcf9c77$export$a7265767c78f9bae);
    var $2oS3b;
    const $a7b3e13a3bcf9c77$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bsT3T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974422c50fb59952$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $974422c50fb59952$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $974422c50fb59952$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $974422c50fb59952$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $974422c50fb59952$var$styles,
            ...props
        });
    var $974422c50fb59952$export$2e2bcd8739ae039 = $974422c50fb59952$var$A11yText;
});
parcelRegister("by9Y7", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$1012133c72ff468e$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $4PUAy;
    const $1012133c72ff468e$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("4PUAy")).stripDiacritics));
    const $1012133c72ff468e$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $1012133c72ff468e$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $1012133c72ff468e$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $1012133c72ff468e$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $1012133c72ff468e$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $1012133c72ff468e$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $1012133c72ff468e$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("4PUAy")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("4PUAy", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$a5a026396014cf91$export$b5bee4b27048330b);
    const $a5a026396014cf91$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $a5a026396014cf91$var$anyDiacritic = new RegExp('[' + $a5a026396014cf91$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $a5a026396014cf91$var$diacriticToBase = {};
    for(let i = 0; i < $a5a026396014cf91$var$diacritics.length; i++){
        let diacritic = $a5a026396014cf91$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$a5a026396014cf91$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $a5a026396014cf91$export$b5bee4b27048330b = (str)=>{
        return str.replace($a5a026396014cf91$var$anyDiacritic, (match)=>$a5a026396014cf91$var$diacriticToBase[match]);
    };
});
parcelRegister("crsHE", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$b3155602f5f642fc$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$b3155602f5f642fc$export$e618dc39ac9ad607);
    var $hekcY;
    var $5EgAF;
    var $5dHSO;
    var $8KLo7;
    var $loRFz;
    var $b4pnV;
    var $hti3c;
    var $1MDaa;
    var $hklN8;
    var $7SnYw;
    const $b3155602f5f642fc$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("8KLo7")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("hekcY")).containerCSS),
        control: (0, (0, parcelRequire("5EgAF")).css),
        dropdownIndicator: (0, (0, parcelRequire("8KLo7")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("5dHSO")).groupCSS),
        groupHeading: (0, (0, parcelRequire("5dHSO")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("hekcY")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("8KLo7")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("loRFz")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("8KLo7")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("b4pnV")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("b4pnV")).menuCSS),
        menuList: (0, (0, parcelRequire("b4pnV")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("b4pnV")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hti3c")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hti3c")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hti3c")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("b4pnV")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("1MDaa")).optionCSS),
        placeholder: (0, (0, parcelRequire("hklN8")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("7SnYw")).css),
        valueContainer: (0, (0, parcelRequire("hekcY")).valueContainerCSS)
    };
    function $b3155602f5f642fc$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("gZxD5", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$87a511a775a34fb9$export$164de7ab8df77ef0);
    const $87a511a775a34fb9$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $87a511a775a34fb9$var$borderRadius = 4;
    const $87a511a775a34fb9$var$baseUnit = 4;
    const $87a511a775a34fb9$var$controlHeight = 38;
    const $87a511a775a34fb9$var$menuGutter = $87a511a775a34fb9$var$baseUnit * 2;
    const $87a511a775a34fb9$export$5458b64234d1333c = {
        baseUnit: $87a511a775a34fb9$var$baseUnit,
        controlHeight: $87a511a775a34fb9$var$controlHeight,
        menuGutter: $87a511a775a34fb9$var$menuGutter
    };
    const $87a511a775a34fb9$export$164de7ab8df77ef0 = {
        borderRadius: $87a511a775a34fb9$var$borderRadius,
        colors: $87a511a775a34fb9$export$8f45430ccf837300,
        spacing: $87a511a775a34fb9$export$5458b64234d1333c
    };
});
parcelRegister("6vVYA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9332a65322bdfb79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2UN3;
    function $9332a65322bdfb79$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("g2UN3")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("dIVa9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dbf9d49c9b24aee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $7dbf9d49c9b24aee$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("2s2ld", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5214de49fe3c4d80$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $crsHE;
    var $hjioQ;
    var $kbK1u;
    var $aKHA6;
    var $b7a6t;
    var $imyI2;
    var $HFUaQ;
    function $5214de49fe3c4d80$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("hjioQ")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("hjioQ")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("hjioQ")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("kbK1u")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("kbK1u")).IndicatorSeparator,
                    Input: (0, parcelRequire("aKHA6")).Input,
                    NoOptionsMessage: (0, parcelRequire("b7a6t")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("HFUaQ")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("HFUaQ")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("crsHE")).mergeStyles)((0, (0, parcelRequire("imyI2")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("hjioQ", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$e3b166afd75430c9$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$e3b166afd75430c9$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$e3b166afd75430c9$export$7c20be4c1d342248);
    var $f8Sb3;
    var $h8Wzd;
    var $2uz6y;
    var $fm763;
    var $a95o8;
    var $99gde;
    var $2JKLA;
    var $113Tq;
    const $e3b166afd75430c9$var$iconContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $e3b166afd75430c9$var$dropdownWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.075'
    });
    const $e3b166afd75430c9$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
            xcss: $e3b166afd75430c9$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2uz6y"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $e3b166afd75430c9$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
            as: "span",
            xcss: $e3b166afd75430c9$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h8Wzd"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $e3b166afd75430c9$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("113Tq")).default), {
            size: "small"
        })));
    };
});
parcelRegister("2uz6y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1d099d27a685bf63$var$_react = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1d099d27a685bf63$var$_crossCircle = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("2gX5A")));
    var $1d099d27a685bf63$var$_selectClear = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("3h0rt")));
    function $1d099d27a685bf63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1d099d27a685bf63$var$CrossCircleIcon = (props)=>$1d099d27a685bf63$var$_react.default.createElement($1d099d27a685bf63$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $1d099d27a685bf63$var$_selectClear.default
        }, props));
    $1d099d27a685bf63$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $1d099d27a685bf63$var$_default = module.exports.default = $1d099d27a685bf63$var$CrossCircleIcon;
});
parcelRegister("2gX5A", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1a7ae93c4f2b7ce5$var$_react = $1a7ae93c4f2b7ce5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1a7ae93c4f2b7ce5$var$_UNSAFE_baseNew = $1a7ae93c4f2b7ce5$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $1a7ae93c4f2b7ce5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1a7ae93c4f2b7ce5$var$CrossCircleIcon = (props)=>$1a7ae93c4f2b7ce5$var$_react.default.createElement($1a7ae93c4f2b7ce5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $1a7ae93c4f2b7ce5$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $1a7ae93c4f2b7ce5$var$_default = module.exports.default = $1a7ae93c4f2b7ce5$var$CrossCircleIcon;
});
parcelRegister("3h0rt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $26234d72bec5adf7$var$_react = $26234d72bec5adf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $26234d72bec5adf7$var$_crossCircle = $26234d72bec5adf7$var$_interopRequireDefault((parcelRequire("hA8Dz")));
    function $26234d72bec5adf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $26234d72bec5adf7$var$SelectClearIcon = (props)=>$26234d72bec5adf7$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $26234d72bec5adf7$var$_crossCircle.default
        }));
    $26234d72bec5adf7$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $26234d72bec5adf7$var$_default = module.exports.default = $26234d72bec5adf7$var$SelectClearIcon;
});
parcelRegister("hA8Dz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cccc7fa1583dbf38$var$_react = $cccc7fa1583dbf38$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cccc7fa1583dbf38$var$_UNSAFE_baseNew = $cccc7fa1583dbf38$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $cccc7fa1583dbf38$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cccc7fa1583dbf38$var$CrossCircleIcon = (props)=>$cccc7fa1583dbf38$var$_react.default.createElement($cccc7fa1583dbf38$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $cccc7fa1583dbf38$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $cccc7fa1583dbf38$var$_default = module.exports.default = $cccc7fa1583dbf38$var$CrossCircleIcon;
});
parcelRegister("kbK1u", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$440bbf009bc44946$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$440bbf009bc44946$export$bd638c2ba7915668);
    var $f8Sb3;
    var $3h0rt;
    var $eM5qw;
    var $2oS3b;
    var $fm763;
    var $99gde;
    var $2JKLA;
    var $hjioQ;
    function $440bbf009bc44946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $440bbf009bc44946$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $440bbf009bc44946$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $440bbf009bc44946$var$iconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.025'
    });
    const $440bbf009bc44946$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eM5qw"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
                xcss: $440bbf009bc44946$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eM5qw"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("3h0rt"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $440bbf009bc44946$var$disabledStyles : $440bbf009bc44946$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $440bbf009bc44946$export$bd638c2ba7915668 = null;
});
parcelRegister("eM5qw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ac19c20d14390f4c$var$_react = $ac19c20d14390f4c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ac19c20d14390f4c$var$_UNSAFE_baseNew = $ac19c20d14390f4c$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $ac19c20d14390f4c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ac19c20d14390f4c$var$CrossIcon = (props)=>$ac19c20d14390f4c$var$_react.default.createElement($ac19c20d14390f4c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $ac19c20d14390f4c$var$CrossIcon.displayName = 'CrossIcon';
    var $ac19c20d14390f4c$var$_default = module.exports.default = $ac19c20d14390f4c$var$CrossIcon;
});
parcelRegister("aKHA6", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$54e7208482951c00$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    function $54e7208482951c00$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("b7a6t", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$cde8873635d1057d$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ZuPvl;
    var $2JKLA;
    const $cde8873635d1057d$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("imyI2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b98022bba24ece5$export$2e2bcd8739ae039);
    var $2oS3b;
    function $6b98022bba24ece5$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $72ba03e317f3d228$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $72ba03e317f3d228$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $72ba03e317f3d228$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $72ba03e317f3d228$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $72ba03e317f3d228$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $72ba03e317f3d228$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $72ba03e317f3d228$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("HFUaQ", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$79b4bf05f1ff4469$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$79b4bf05f1ff4469$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$79b4bf05f1ff4469$export$8ee33f304118fce4);
    function $79b4bf05f1ff4469$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $79b4bf05f1ff4469$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $79b4bf05f1ff4469$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("lElIo", function(module, exports) {
    $parcel$export(module.exports, "defaultSelectStyles", ()=>$f1f1a093823579de$export$b12192ea1a215e5f);
    $parcel$export(module.exports, "indicatorFixSelectStyles", ()=>$f1f1a093823579de$export$eca30945eaf474dd);
    var $gwIPs;
    const $f1f1a093823579de$export$b12192ea1a215e5f = {
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            }),
        menu: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            })
    };
    const $f1f1a093823579de$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
    const $f1f1a093823579de$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
    const $f1f1a093823579de$export$eca30945eaf474dd = {
        loadingIndicator: (base)=>({
                ...base,
                paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
                paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
            }),
        clearIndicator: (base)=>({
                ...base,
                paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
                paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
            })
    };
    const $f1f1a093823579de$export$a9f371909ef7b4d6 = {
        container: (base)=>({
                ...base,
                border: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border-danger, ${(0, $72ba03e317f3d228$exports).R400})`}`,
                borderRadius: "var(--ds-space-050, 4px)"
            })
    };
});
parcelRegister("FtZX9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebb46637e8f856b8$export$2e2bcd8739ae039);
    const $ebb46637e8f856b8$var$defer = ()=>{
        const deferred = {};
        deferred.promise = new Promise((resolve, reject)=>{
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    };
    function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
        let deferred;
        let timer;
        let lastArgs;
        function flush() {
            const thisDeferred = deferred;
            clearTimeout(timer);
            if (thisDeferred) Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
            lastArgs = [];
            deferred = null;
        }
        return function debounced(...args) {
            if (deferred) clearTimeout(timer);
            else deferred = $ebb46637e8f856b8$var$defer();
            lastArgs = args;
            timer = setTimeout(flush.bind(this), wait);
            return deferred.promise;
        };
    }
    var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;
});
parcelRegister("kEqrP", function(module, exports) {
    $parcel$export(module.exports, "graphModalExperience", ()=>$92ce1ce82a42bb8a$export$1b179afadba799dc);
    $parcel$export(module.exports, "rapidSearchExperience", ()=>$92ce1ce82a42bb8a$export$1a90deecc86e78f8);
    $parcel$export(module.exports, "autocompleteInsightFieldExperience", ()=>$92ce1ce82a42bb8a$export$94337fa170a193d2);
    $parcel$export(module.exports, "fetchAffectedServicesExperience", ()=>$92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
    $parcel$export(module.exports, "objectDetailsViewExperience", ()=>$92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
    $parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", ()=>$92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
    $parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", ()=>$92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
    $parcel$export(module.exports, "createObjectTypeExperience", ()=>$92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
    $parcel$export(module.exports, "createObjectExperience", ()=>$92ce1ce82a42bb8a$export$aaf507c87c29ab22);
    $parcel$export(module.exports, "loadSchemaObjectListExperience", ()=>$92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
    $parcel$export(module.exports, "loadAttributesConfigurationExperience", ()=>$92ce1ce82a42bb8a$export$8f63f06b0486e498);
    $parcel$export(module.exports, "updateObjectFilterExperience", ()=>$92ce1ce82a42bb8a$export$967859e6be8e6f4b);
    $parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", ()=>$92ce1ce82a42bb8a$export$e4deb66475dfa46b);
    $parcel$export(module.exports, "loadObjectDetailExperience", ()=>$92ce1ce82a42bb8a$export$3f1da23c065671d2);
    var $cqpQr;
    var $fwViQ;
    const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        featureFlags: [
            'jsm-insight-field-performance-improvements_fplgq'
        ]
    });
    const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jsm-cmdb-object-details-view', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jsm-cmdb-create-object-type', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom,
        timings: [
            {
                key: 'created-on-server',
                endMark: 'object-type-created-on-server'
            }
        ]
    });
    const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.create-object', {
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jsm-cmdb-load-object-list', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jsm-cmdb-load-attributes-tab', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jsm-cmdb-object-filter', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom,
        timings: [
            {
                key: 'response-received',
                endMark: 'server-response-received'
            },
            {
                key: 'object-table-rendered',
                endMark: 'object-table-rendered'
            },
            {
                key: 'object-list-rendered',
                endMark: 'object-list-rendered'
            },
            {
                key: 'no-filter-results-rendered',
                endMark: 'no-filter-results-rendered'
            }
        ]
    });
    const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
            performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).InlineResult,
            type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience
        });
    const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
});
parcelRegister("2WZSx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a56352311f156b3$export$2e2bcd8739ae039);
    var $7VHMR;
    const $9a56352311f156b3$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "issue-field-affected-services.edit.no-matches",
            "defaultMessage": "No Matches"
        },
        failedFetch: {
            "id": "issue-field-affected-services.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        }
    });
    var $9a56352311f156b3$export$2e2bcd8739ae039 = $9a56352311f156b3$var$messages;
});
parcelRegister("2ngL6", function(module, exports) {
    $parcel$export(module.exports, "mapServiceEntitiesToOptions", ()=>$ee273b75b82219a4$export$23b96a30f377b741);
    $parcel$export(module.exports, "mapOptionsToServiceEntities", ()=>$ee273b75b82219a4$export$7dcfc49587479fac);
    $parcel$export(module.exports, "fetchAffectedServices", ()=>$ee273b75b82219a4$export$66d34216c85d32cb);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $jJZqs;
    var $eusud;
    const $ee273b75b82219a4$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
                label: name,
                value: id
            }));
    const $ee273b75b82219a4$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
                id: value,
                name: label
            }));
    const $ee273b75b82219a4$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify({
            query: inputValue
        });
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$ee273b75b82219a4$export$23b96a30f377b741(response.services)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchAffectedServices',
                packageName: 'jiraIssueFieldAffectedServices',
                logToSentry: !(0, (0, parcelRequire("jJZqs")).isValidationError)(error),
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    errorMessage: error.message
                }
            });
            throw error;
        });
    };
});
parcelRegister("7C5S0", function(module, exports) {
    $parcel$export(module.exports, "FieldContainer", ()=>$17c5ea94a7a7a600$export$b5c4b0e7cd7f148b);
    $parcel$export(module.exports, "Description", ()=>$17c5ea94a7a7a600$export$393edc798c47379d);
    $parcel$export(module.exports, "SelectContainer", ()=>$17c5ea94a7a7a600$export$446eebadefe1123b);
    $parcel$export(module.exports, "Divider", ()=>$17c5ea94a7a7a600$export$2e0a83ec2e27ecbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $c0dQj;
    const $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_m2j5rp": (0, (0, parcelRequire("lD23V")).default)((()=>{
                    return typeof (__cmplp.width ?? ((0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? '100%' : 350)) === 'number' ? `${__cmplp.width ?? ((0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? '100%' : 350)}px` : __cmplp.width ?? ((0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? '100%' : 350);
                })()),
                "--_1glwpqj": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.marginTop ?? 0}px`),
                "--_1i3s0vn": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.paddingBottom ?? 0}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb13r0 _19pknek2 _n3td11zn",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$393edc798c47379d = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$446eebadefe1123b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1mjv",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3it94y _1bsb1osq _bfhkb5v6 _18s8gx6n",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$32dd8f1956fe77b1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01wug _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("gLdtQ", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", ()=>$60f472fd3d28277e$export$7c7171667037b275);
    $parcel$export(module.exports, "closeMenuOnScroll", ()=>$60f472fd3d28277e$export$fe334d83c6aac80f);
    const $60f472fd3d28277e$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
    const $60f472fd3d28277e$var$MENU_CLOSE_SELECTORS = [
        $60f472fd3d28277e$export$7c7171667037b275
    ];
    const $60f472fd3d28277e$export$fe334d83c6aac80f = (e)=>{
        if ($60f472fd3d28277e$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
        return false;
    };
});
parcelRegister("aZJYe", function(module, exports) {
    $parcel$export(module.exports, "mutateAffectedServicesField", ()=>$3cf4650743fd53da$export$c5ca3c9d905a51f0);
    $parcel$export(module.exports, "transformDefaultAffectedServices", ()=>$3cf4650743fd53da$export$6f4e94c57a16128c);
    $parcel$export(module.exports, "useFetchAffectedServicesName", ()=>$3cf4650743fd53da$export$9abe2f602f72a411);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $7f4tk;
    var $2ngL6;
    const $3cf4650743fd53da$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
            affectedServicesField: {
                fieldId: fieldId,
                affectedServices: selectedAffectedServices.map(({ value: value })=>({
                        serviceId: value
                    }))
            }
        });
    const $3cf4650743fd53da$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
                value: service.serviceId
            }));
    const $3cf4650743fd53da$export$9abe2f602f72a411 = ()=>{
        const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
        const baseUrl = '';
        const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
            setLoading(true);
            (0, (0, parcelRequire("7f4tk")).default)(`${baseUrl}/rest/service-registry-api/service`, {
                method: 'POST',
                body: JSON.stringify({
                    ids: ids
                })
            }).then((response)=>{
                setLoading(false);
                setSelectedOptions((0, (0, parcelRequire("2ngL6")).mapServiceEntitiesToOptions)(response.services));
            }).catch((error)=>{
                setLoading(false);
                setSelectedOptions([]);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchAffectedServicesName',
                        packageName: 'jiraIssueCreateCommons',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        });
        return [
            {
                isLoading: isLoading
            },
            handleFetch.current
        ];
    };
});
parcelRegister("6iZh4", function(module, exports) {
    $parcel$export(module.exports, "validateRequired", ()=>$2a21f21632a09b2e$export$2e85a6f149681784);
    var $bGrWH;
    const $2a21f21632a09b2e$export$2e85a6f149681784 = (value, isRequired, _)=>{
        if (isRequired) {
            if (!value || Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
parcelRegister("kShoa", function(module, exports) {
    $parcel$export(module.exports, "toLabelsField", ()=>$e44b536616936050$export$7a0cc61c6cdac523);
    $parcel$export(module.exports, "textFieldWriter", ()=>$e44b536616936050$export$3f2b7c786f4381f3);
    $parcel$export(module.exports, "selectFieldWriter", ()=>$e44b536616936050$export$9ed21ff1d3f239ed);
    $parcel$export(module.exports, "checkboxSelectFieldWriter", ()=>$e44b536616936050$export$6372f460d19ccf04);
    $parcel$export(module.exports, "textAreaFieldWriter", ()=>$e44b536616936050$export$daf547ed9d724058);
    $parcel$export(module.exports, "dateFieldWriter", ()=>$e44b536616936050$export$ab1ac718ca53b3a2);
    $parcel$export(module.exports, "labelsFieldWriter", ()=>$e44b536616936050$export$ad0f5c4a81b9b717);
    $parcel$export(module.exports, "priorityFieldWriter", ()=>$e44b536616936050$export$255f6ed818b27fe9);
    $parcel$export(module.exports, "numberFieldWriter", ()=>$e44b536616936050$export$f187c825de05664b);
    $parcel$export(module.exports, "dateTimeFieldWriter", ()=>$e44b536616936050$export$aa8970635118882c);
    $parcel$export(module.exports, "urlFieldWriter", ()=>$e44b536616936050$export$823b946bef17fbde);
    $parcel$export(module.exports, "multiUserPickerFieldWriter", ()=>$e44b536616936050$export$f56da03febf03bbe);
    $parcel$export(module.exports, "cascadingSelectFieldWriter", ()=>$e44b536616936050$export$dd0315e6bb70be50);
    $parcel$export(module.exports, "singleUserPickerFieldWriter", ()=>$e44b536616936050$export$44ca38ec8bc1b849);
    $parcel$export(module.exports, "radioSelectFieldWriter", ()=>$e44b536616936050$export$3930624833f8c678);
    $parcel$export(module.exports, "multiSelectFieldWriter", ()=>$e44b536616936050$export$550c89601caa8cb);
    $parcel$export(module.exports, "attachmentFieldWriter", ()=>$e44b536616936050$export$a751298e00103db5);
    $parcel$export(module.exports, "descriptionFieldWriter", ()=>$e44b536616936050$export$8545d310869fe805);
    $parcel$export(module.exports, "singleGroupPickerFieldWriter", ()=>$e44b536616936050$export$8b286e49fa801799);
    $parcel$export(module.exports, "multipleGroupPickerFieldWriter", ()=>$e44b536616936050$export$ada212938d86109a);
    $parcel$export(module.exports, "teamFieldWriter", ()=>$e44b536616936050$export$77028ba2835a8f1c);
    $parcel$export(module.exports, "assigneeFieldWriter", ()=>$e44b536616936050$export$1c1d0a4431d22b72);
    var $5kDIl;
    var $bWtQ8;
    var $em1U0;
    var $hx8g7;
    var $2QTbq;
    var $4IxfP;
    var $aSk8p;
    var $5pHXe;
    var $1K3Xb;
    const $e44b536616936050$var$toMultipleSelectField = (id, ids)=>{
        const toOptionInput = (optionId)=>({
                id: optionId
            });
        return {
            fieldId: id,
            options: ids.map(toOptionInput)
        };
    };
    const $e44b536616936050$var$toStringField = (id, value)=>({
            fieldId: id,
            value: value
        });
    const $e44b536616936050$export$7a0cc61c6cdac523 = (id, labels)=>({
            fieldId: id,
            values: {
                values: labels
            }
        });
    const $e44b536616936050$var$toPriorityField = (priorityId)=>({
            priorityId: priorityId
        });
    const $e44b536616936050$export$f27a949cf2ef9fc6 = (id, accountId)=>({
            fieldId: id,
            user: {
                accountId: accountId
            }
        });
    const $e44b536616936050$var$toADFField = (id, adf)=>{
        const { version: version } = adf;
        return {
            fieldId: id,
            adf: {
                version: version,
                jsonValue: adf
            }
        };
    };
    const $e44b536616936050$var$toGroupInput = (pickerOption)=>({
            groupName: pickerOption.name
        });
    const $e44b536616936050$export$3f2b7c786f4381f3 = (id, value, fields)=>{
        fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
    };
    const $e44b536616936050$export$9ed21ff1d3f239ed = (id, value, fields)=>{
        if (value) fields.stringFields.push($e44b536616936050$var$toStringField(id, String((0, (0, parcelRequire("5pHXe")).mapSelectOptionsToData)(value).id)));
    };
    const $e44b536616936050$export$6372f460d19ccf04 = (id, value, fields)=>{
        fields.multipleSelectFields.push($e44b536616936050$var$toMultipleSelectField(id, (0, (0, parcelRequire("hx8g7")).mapOptionsToData)(value).map((o)=>o.id)));
    };
    const $e44b536616936050$export$daf547ed9d724058 = (id, value, fields)=>{
        fields.adfFields.push($e44b536616936050$var$toADFField(id, (0, (0, parcelRequire("1K3Xb")).convertTextToAdf)(value)));
    };
    const $e44b536616936050$export$ab1ac718ca53b3a2 = (id, value, fields)=>{
        fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
    };
    const $e44b536616936050$export$ad0f5c4a81b9b717 = (id, value, fields)=>{
        fields.labels.push($e44b536616936050$export$7a0cc61c6cdac523(id, (0, (0, parcelRequire("2QTbq")).mapLabelOptionsToData)(value)));
    };
    const $e44b536616936050$export$255f6ed818b27fe9 = (_id, value, fields)=>{
        fields.priority = $e44b536616936050$var$toPriorityField((0, (0, parcelRequire("4IxfP")).mapOptionToData)(value).id);
    };
    const $e44b536616936050$export$f187c825de05664b = (id, value, fields)=>{
        fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
    };
    const $e44b536616936050$export$aa8970635118882c = (id, value, fields)=>{
        fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
    };
    const $e44b536616936050$export$823b946bef17fbde = (id, value, fields)=>{
        fields.stringFields.push($e44b536616936050$var$toStringField(id, value));
    };
    const $e44b536616936050$export$f56da03febf03bbe = (id, value, fields)=>{
        const accountIds = (0, (0, parcelRequire("5kDIl")).mapUserOptionsToAccountIds)(value);
        fields.multipleSelectUserPickerFields.push({
            fieldId: id,
            users: accountIds
        });
    };
    const $e44b536616936050$export$dd0315e6bb70be50 = (id, value, fields)=>{
        const option = (0, (0, parcelRequire("em1U0")).transformToServerValue)(value);
        if (option !== null) {
            fields.stringFields.push($e44b536616936050$var$toStringField(id, option.id));
            if (option.child) fields.stringFields.push($e44b536616936050$var$toStringField(`${id}:1`, option.child.id));
        }
    };
    const $e44b536616936050$export$44ca38ec8bc1b849 = (id, value, fields)=>{
        if (!value) return;
        const result = (0, (0, parcelRequire("5kDIl")).mapUserOptionsToIds)(value);
        if (!Array.isArray(result)) fields.users.push($e44b536616936050$export$f27a949cf2ef9fc6(id, result.id));
    };
    const $e44b536616936050$export$3930624833f8c678 = (id, value, fields)=>{
        fields.stringFields.push($e44b536616936050$var$toStringField(id, (0, (0, parcelRequire("aSk8p")).mapOptionToData)(value).id));
    };
    const $e44b536616936050$export$550c89601caa8cb = (id, value, fields)=>{
        fields.multipleSelectFields.push($e44b536616936050$var$toMultipleSelectField(id, value.map((o)=>o.value).filter((selectedValue)=>typeof selectedValue === 'string' || typeof selectedValue === 'number').map((o)=>String(o))));
    };
    const $e44b536616936050$export$a751298e00103db5 = (_id, value, fields)=>{
        if (Array.isArray(value) && value.length >= 1) {
            const ids = (0, (0, parcelRequire("bWtQ8")).getFileIdsFromFiles)(value);
            fields.stringFields.push($e44b536616936050$var$toStringField('attachment', ids.join(',')));
        }
    };
    const $e44b536616936050$export$8545d310869fe805 = (id, value, fields)=>{
        if (!value) return;
        fields.adfFields.push($e44b536616936050$var$toADFField(id, value));
    };
    const $e44b536616936050$export$8b286e49fa801799 = (id, value, fields)=>{
        const group = $e44b536616936050$var$toGroupInput(value);
        fields.singleGroupPickerFields.push({
            fieldId: id,
            group: group
        });
    };
    const $e44b536616936050$export$ada212938d86109a = (id, value, fields)=>{
        const groups = value.map($e44b536616936050$var$toGroupInput);
        fields.multipleGroupPickerFields.push({
            fieldId: id,
            groups: groups
        });
    };
    const $e44b536616936050$export$77028ba2835a8f1c = (id, value, fields)=>{
        if (value) fields.stringFields.push($e44b536616936050$var$toStringField(id, value.value));
    };
    const $e44b536616936050$export$1c1d0a4431d22b72 = (id, value, fields)=>{
        if (value?.accountId) fields.users.push($e44b536616936050$export$f27a949cf2ef9fc6(id, value.accountId));
    };
});
parcelRegister("5kDIl", function(module, exports) {
    $parcel$export(module.exports, "transformJiraUserToUserOption", ()=>$5870d9a04b0eab40$export$3e406786572c35b0);
    $parcel$export(module.exports, "transformDefaultUserValues", ()=>$5870d9a04b0eab40$export$26760e7b66ccf1e1);
    $parcel$export(module.exports, "mapUserOptionsToIds", ()=>$5870d9a04b0eab40$export$2482a6858a4714ad);
    $parcel$export(module.exports, "mapUserOptionsToAccountIds", ()=>$5870d9a04b0eab40$export$e4490ea0dfe4173f);
    $parcel$export(module.exports, "mutateSingleUserPicker", ()=>$5870d9a04b0eab40$export$7937ee6404102aff);
    $parcel$export(module.exports, "mutateMultiUserPicker", ()=>$5870d9a04b0eab40$export$53e350638c0acebc);
    const $5870d9a04b0eab40$export$3e406786572c35b0 = (userData)=>({
            id: userData.accountId || '',
            name: userData.name || '',
            avatarUrl: userData.picture || ''
        });
    const $5870d9a04b0eab40$export$26760e7b66ccf1e1 = (defaultValue)=>{
        if (Array.isArray(defaultValue)) return defaultValue.map($5870d9a04b0eab40$export$3e406786572c35b0);
        return $5870d9a04b0eab40$export$3e406786572c35b0(defaultValue);
    };
    const $5870d9a04b0eab40$export$2482a6858a4714ad = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                id: option.id
            }));
        return {
            id: userOption.id
        };
    };
    const $5870d9a04b0eab40$export$e4490ea0dfe4173f = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                accountId: option.id
            }));
        return {
            accountId: userOption.id
        };
    };
    const $5870d9a04b0eab40$export$7937ee6404102aff = (selectedUser, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
            user: {
                accountId: selectedUser.id
            }
        });
    const $5870d9a04b0eab40$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $2b6d45687558f2b0$export$52003ca9b6035e0c),
            users: selectedUsers.map((user)=>({
                    accountId: user.id
                }))
        });
});
const $2b6d45687558f2b0$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $2b6d45687558f2b0$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';
parcelRegister("bWtQ8", function(module, exports) {
    $parcel$export(module.exports, "getFileIdsFromFiles", ()=>$7bad3ba374b5e258$export$90bf402b5b4274c7);
    $parcel$export(module.exports, "validateAttachment", ()=>$7bad3ba374b5e258$export$8af997fabc69757a);
    $parcel$export(module.exports, "getFieldDropZoneContainerID", ()=>$7bad3ba374b5e258$export$2fab292eea84487a);
    var $bGrWH;
    const $7bad3ba374b5e258$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
    const $7bad3ba374b5e258$export$8af997fabc69757a = (value, isRequired)=>{
        if (isRequired) {
            if (!value || value.length === 0) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $7bad3ba374b5e258$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;
});
parcelRegister("em1U0", function(module, exports) {
    $parcel$export(module.exports, "transformToOptionValue", ()=>$657085c715b654ca$export$d1480328df7a42bf);
    $parcel$export(module.exports, "transformToOptions", ()=>$657085c715b654ca$export$899758961952c638);
    $parcel$export(module.exports, "transformToParentChildOptionMap", ()=>$657085c715b654ca$export$575da772c90849b8);
    $parcel$export(module.exports, "transformToServerValue", ()=>$657085c715b654ca$export$6f0c6eec5b71d787);
    var $gJBT6 = parcelRequire("gJBT6");
    const $657085c715b654ca$export$d1480328df7a42bf = (serverValue)=>{
        if (!serverValue) return null;
        const { id: id, value: value, child: child } = serverValue;
        return {
            value: id,
            label: value,
            child: child && {
                value: child.id,
                label: child.value
            }
        };
    };
    const $657085c715b654ca$export$899758961952c638 = (0, ($parcel$interopDefault($gJBT6)))((values)=>values.map(({ id: id, value: value })=>({
                value: id,
                label: value
            })));
    const $657085c715b654ca$export$575da772c90849b8 = (0, ($parcel$interopDefault($gJBT6)))((values)=>values.reduce((acc, { id: id, children: children })=>{
            acc[id] = children ? $657085c715b654ca$export$899758961952c638(children) : [];
            return acc;
        }, {}));
    const $657085c715b654ca$export$6f0c6eec5b71d787 = (option)=>{
        if (!option) return null;
        const { label: label, value: value } = option;
        const child = option.child || undefined;
        return {
            id: value,
            value: label,
            child: child && {
                id: child.value,
                value: child.label
            }
        };
    };
});
parcelRegister("hx8g7", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$551084a6b97f85f9$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionsToData", ()=>$551084a6b97f85f9$export$ffef3a401aef987b);
    const $551084a6b97f85f9$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
                label: value,
                value: id
            }));
    const $551084a6b97f85f9$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
                id: value,
                value: label
            }));
});
parcelRegister("4IxfP", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$ae732ed1951f68ed$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$ae732ed1951f68ed$export$fc800909123977f3);
    const $ae732ed1951f68ed$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
                label: name,
                value: id,
                iconUrl: iconUrl
            }));
    const $ae732ed1951f68ed$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
            id: value,
            name: label,
            iconUrl: iconUrl
        });
});
parcelRegister("aSk8p", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$08634f5a5ba1d218$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$08634f5a5ba1d218$export$fc800909123977f3);
    const $08634f5a5ba1d218$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
                label: value,
                value: id
            }));
    const $08634f5a5ba1d218$export$fc800909123977f3 = ({ label: label, value: value })=>({
            id: value,
            value: label
        });
});
parcelRegister("5pHXe", function(module, exports) {
    $parcel$export(module.exports, "mapSelectOptionsToData", ()=>$aeaea2f472af8476$export$7cdfccbc726f6f22);
    $parcel$export(module.exports, "mapMultiSelectOptionsToData", ()=>$aeaea2f472af8476$export$b91253d30be01e62);
    $parcel$export(module.exports, "mapDataToSelectOption", ()=>$aeaea2f472af8476$export$8f475f1fdc96a964);
    $parcel$export(module.exports, "mapDataToSelectOptions", ()=>$aeaea2f472af8476$export$dc22cde66e28d4af);
    const $aeaea2f472af8476$export$7cdfccbc726f6f22 = (option)=>({
            id: option.value,
            value: option.label
        });
    const $aeaea2f472af8476$export$b91253d30be01e62 = (options)=>options.map((option)=>({
                id: option.value,
                value: option.label
            }));
    const $aeaea2f472af8476$export$8f475f1fdc96a964 = (optionExternal)=>({
            label: optionExternal.value,
            value: optionExternal.id
        });
    const $aeaea2f472af8476$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$aeaea2f472af8476$export$8f475f1fdc96a964(optionExternal));
});
parcelRegister("1K3Xb", function(module, exports) {
    $parcel$export(module.exports, "convertTextToAdf", ()=>$903ba9c436cc186a$export$c10cf32c4acc1d57);
    var $kYDma;
    var $2cxMR;
    var $lMkQE;
    const $903ba9c436cc186a$export$c10cf32c4acc1d57 = (text)=>{
        if (text === '') return (0, (0, parcelRequire("lMkQE")).getEmptyADF)();
        return (0, (0, parcelRequire("kYDma")).doc)((0, (0, parcelRequire("2cxMR")).paragraph)(text));
    };
});
parcelRegister("kYDma", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$fe355ab3c849cfbd$export$2a111da947c407d2);
    const $fe355ab3c849cfbd$export$2a111da947c407d2 = (...content)=>({
            type: 'doc',
            version: 1,
            content: content
        });
});
parcelRegister("2cxMR", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$35f79387eebd280e$export$9c206ddddb32a9b);
    var $47tWT;
    const $35f79387eebd280e$export$9c206ddddb32a9b = (...content)=>({
            type: 'paragraph',
            content: (0, (0, parcelRequire("47tWT")).createTextNodes)(content)
        });
});
parcelRegister("47tWT", function(module, exports) {
    $parcel$export(module.exports, "createTextNodes", ()=>$4a3c486f703bece5$export$3a269a5941b62f04);
    var $g5NIx;
    function $4a3c486f703bece5$export$3a269a5941b62f04(nodes) {
        return nodes.map($4a3c486f703bece5$export$72b9432ea0656b50);
    }
    function $4a3c486f703bece5$export$72b9432ea0656b50(str) {
        return typeof str === 'string' ? (0, (0, parcelRequire("g5NIx")).text)(str) : str;
    }
});
parcelRegister("g5NIx", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$e264fee35c342b28$export$6f093cfa640b7166);
    const $e264fee35c342b28$export$6f093cfa640b7166 = (text)=>({
            type: 'text',
            text: text
        });
});
parcelRegister("lMkQE", function(module, exports) {
    $parcel$export(module.exports, "getEmptyADF", ()=>$2fc27f72535f31ac$export$d109ab46c9575565);
    var $8XC9r;
    const $2fc27f72535f31ac$export$d109ab46c9575565 = ()=>({
            type: 'doc',
            version: 1,
            content: []
        });
});
parcelRegister("8XC9r", function(module, exports) {
    $parcel$export(module.exports, "isEmpty", ()=>$ceb9fa91d1b94fc0$export$dd1bc94b04021eeb);
    const $ceb9fa91d1b94fc0$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;
});
parcelRegister("22Wo8", function(module, exports) {
    $parcel$export(module.exports, "AssigneeFieldTypeConfig", ()=>$818cad83f092a8b9$export$760aa32e02dd931e);
    var $5uXOq = parcelRequire("5uXOq");
    var $h4hXX;
    var $5FwUN;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $818cad83f092a8b9$var$AssigneeFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5FwUN")).default), props);
    const $818cad83f092a8b9$export$760aa32e02dd931e = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("h4hXX"))))),
        type: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        Component: $818cad83f092a8b9$var$AssigneeFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).AssigneeFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).assigneeFieldWriter)
    };
});
parcelRegister("5FwUN", function(module, exports) {
    $parcel$export(module.exports, "AssigneeField", ()=>$489f100aee3a6307$export$7c52097ee36bd91);
    $parcel$export(module.exports, "default", ()=>$489f100aee3a6307$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    var $7XYc4;
    var $koVbs;
    var $89S0t;
    var $leRCk;
    var $dCm1o;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    var $bfnma;
    var $5rYSU;
    const $489f100aee3a6307$export$7c52097ee36bd91 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
        const [{ data: loggedInUser }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        const onAssignToMeClick = ()=>{
            onChange(loggedInUser);
        };
        const onAddAssigneeKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (id && (event.key === 'Enter' || event.key === ' ')) {
                onChange(loggedInUser);
                setTimeout(()=>document.getElementById(id)?.focus());
            }
        }, [
            id,
            loggedInUser,
            onChange
        ]);
        const showAssignToMe = loggedInUser && !isReadOnly;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($489f100aee3a6307$var$FieldContainer, {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89S0t")).default), {
            ...fieldProps,
            value: value,
            onChange: onChange,
            shouldPreloadAssignToMe: true,
            autoCompleteUrl: autoCompleteUrl,
            enableAutomaticOption: true,
            autoFocus: autoFocus,
            isDisabled: isReadOnly,
            width: width,
            inputId: id,
            openMenuOnClick: true
        }), showAssignToMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "link",
            spacing: "none",
            onClick: onAssignToMeClick,
            onKeyDown: onAddAssigneeKeyDown,
            testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
        }, formatMessage((0, (0, parcelRequire("bfnma")).default).assignToMe)));
    };
    var $489f100aee3a6307$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateAssigneeField),
        transformDefaultValue: (0, (0, parcelRequire("5rYSU")).transformDefaultAssigneeValue)
    })($489f100aee3a6307$export$7c52097ee36bd91);
    const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("7C5S0")).FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1v091b66",
                __cmplp.className
            ])
        });
    });
    const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("7C5S0")).FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
                __cmplp.className
            ])
        });
    });
    const $489f100aee3a6307$var$FieldContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)(), $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn, $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff);
});
parcelRegister("89S0t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a7ac4b7108cf6a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $kEnpg;
    var $aWse0;
    var $ecbCU;
    var $5fc53;
    var $8zOmE;
    var $lwMsT;
    var $cqpQr;
    var $fwViQ;
    var $fhSLy;
    var $7lGt2;
    var $h36wX;
    var $kt8K4;
    const $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
    const $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('inline-assignee-picker.field-options-load', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom,
        category: 'inline-assignee-picker.field-options-load'
    });
    const $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ariaLabel: ariaLabel, ...fieldProps })=>{
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const self = (0, $5uXOq.useRef)({
            previousQuery: undefined
        }).current;
        const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, (0, parcelRequire("kt8K4")).default)(autoCompleteUrl || '');
        const [assigneeValue, assigneeOptions] = (0, (0, parcelRequire("h36wX")).useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption);
        const [, { openDrawer: openDrawer }] = (0, (0, parcelRequire("ecbCU")).useInvitePeopleDrawer)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (loading) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'inlineAssigneePicker',
                    action: 'loading'
                }), 'inlineAssigneeOptions loading');
                $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.start();
            }
            if (error) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'inlineAssigneePicker',
                    action: 'failed'
                }), 'inlineAssigneeOptions failed');
                $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.failure();
            }
            if (users.length) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'inlineAssigneePicker',
                    action: 'loaded'
                }), 'inlineAssigneeOptions loaded');
                $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.success();
            }
        }, [
            loading,
            error,
            users,
            createAnalyticsEvent
        ]);
        const handleSearch = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((query)=>{
                if (query === '' && self.previousQuery === undefined) return;
                query !== self.previousQuery && fetchUsers(query);
                self.previousQuery = query;
            }, searchDebounceTimeout), [
            fetchUsers,
            searchDebounceTimeout,
            self.previousQuery
        ]);
        const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
            onFocus?.(sessionId);
            if (!users || !users.length) fetchUsers();
        }, [
            onFocus,
            users,
            fetchUsers
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
            onBlur?.(sessionId);
            self.previousQuery = undefined;
        }, [
            onBlur,
            self
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)((updatedValue, action)=>{
            if (!updatedValue || Array.isArray(updatedValue)) return;
            if (enablePeopleInvite && updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) {
                openDrawer(createAnalyticsEvent ?? null, {
                    inviteFlow: 'assignee'
                });
                onChange?.(value, action);
                return;
            }
            let newValue;
            if (updatedValue.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) || updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) newValue = null;
            else newValue = (0, (0, parcelRequire("fhSLy")).getUserFromUserOption)(updatedValue);
            onChange?.(newValue, action);
        }, [
            enablePeopleInvite,
            onChange,
            openDrawer,
            value,
            createAnalyticsEvent
        ]);
        const controlProps = openMenuOnClick ? {
            openMenuOnClick: openMenuOnClick,
            onOpen: handleOnFocus
        } : {
            onFocus: handleOnFocus
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kEnpg")).UserPicker), {
            inputId: inputId,
            fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
            autoFocus: autoFocus,
            placeholder: intl.formatMessage((0, (0, parcelRequire("7lGt2")).default).searchForAssignee),
            isLoading: loading,
            options: assigneeOptions,
            value: assigneeValue,
            isMulti: false,
            isClearable: false,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onInputChange: handleSearch,
            subtle: isSubtle,
            appearance: appearance,
            width: width,
            isDisabled: isDisabled,
            ariaLabelledBy: fieldProps['aria-labelledby'],
            UNSAFE_hasDraggableParentComponent: true,
            ariaLabel: ariaLabel,
            ...controlProps
        });
    };
    var $3a7ac4b7108cf6a7$export$2e2bcd8739ae039 = $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit;
});
parcelRegister("kEnpg", function(module, exports) {
    $parcel$export(module.exports, "UserPicker", ()=>$26bed3b7e7119450$export$83e0c73b09b3a9cd);
    var $7GEKO;
    var $6AKkW;
    var $gN6Vx;
    var $96hPo;
    var $5uXOq = parcelRequire("5uXOq");
    var $1j8VJ;
    var $cpua2;
    var $3Qd9S;
    var $iPQR2;
    var $kkSH2;
    var $l3nuY;
    var $kYAL2;
    var $cEoAI;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $26bed3b7e7119450$export$164f4d95e5d7e2f5 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.ufoId = (0, $7Jxgt.v4)();
            const experienceForId = (0, (0, parcelRequire("cEoAI")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            experienceForId.start();
        }
        static{
            this.defaultProps = {
                width: 350,
                isMulti: false
            };
        }
        componentDidMount() {
            const experienceForId = (0, (0, parcelRequire("cEoAI")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            if ([
                (0, (0, parcelRequire("96hPo")).UFOExperienceState).IN_PROGRESS.id,
                (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id
            ].includes(experienceForId.state.id)) experienceForId.success();
        }
        render() {
            const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
            const width = this.props.width;
            const SelectComponent = allowEmail ? (0, (0, parcelRequire("6AKkW")).default) : (0, (0, parcelRequire("gN6Vx")).default);
            const creatableProps = suggestEmailsForDomain ? (0, (0, parcelRequire("kkSH2")).getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, (0, parcelRequire("iPQR2")).getCreatableProps)(isValidEmail);
            const defaultPickerProps = {
                closeMenuOnScroll: closeMenuOnScroll,
                menuPortalTarget: menuPortalTarget,
                menuPosition: menuPosition,
                menuShouldBlockScroll: menuShouldBlockScroll,
                captureMenuScroll: captureMenuScroll,
                required: required
            };
            const pickerProps = allowEmail ? {
                ...defaultPickerProps,
                ...creatableProps,
                emailLabel: emailLabel
            } : {
                ...defaultPickerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEoAI")).UfoErrorBoundary), {
                id: this.ufoId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l3nuY")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kYAL2")).ExusUserSourceProvider), {
                fetchUserSource: loadUserSource
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1j8VJ")).BaseUserPickerWithoutAnalytics), {
                ...this.props,
                width: width,
                SelectComponent: SelectComponent,
                styles: (0, (0, parcelRequire("cpua2")).getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid),
                components: (0, (0, parcelRequire("3Qd9S")).getComponents)(isMulti, anchor),
                pickerProps: pickerProps
            }))));
        }
    }
    const $26bed3b7e7119450$export$83e0c73b09b3a9cd = (0, (0, parcelRequire("7GEKO")).default)()($26bed3b7e7119450$export$164f4d95e5d7e2f5);
});
parcelRegister("6AKkW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08832d3364dd9ee1$export$2e2bcd8739ae039);
    var $2fUWr;
    var $2s2ld;
    const $08832d3364dd9ee1$var$CreatableSelect = (0, (0, parcelRequire("2s2ld")).default)((0, (0, parcelRequire("2fUWr")).default));
    var $08832d3364dd9ee1$export$2e2bcd8739ae039 = $08832d3364dd9ee1$var$CreatableSelect;
});
parcelRegister("2fUWr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3ec4cb8c46b81bd$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("hbdm9")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $3uzTK;
    var $hbdm9;
    var $dIVa9;
    const $f3ec4cb8c46b81bd$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("dIVa9")).default)(props);
        const selectProps = (0, (0, parcelRequire("hbdm9")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uzTK")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $f3ec4cb8c46b81bd$export$2e2bcd8739ae039 = $f3ec4cb8c46b81bd$var$CreatableSelect;
});
parcelRegister("hbdm9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15d5558800f1e4f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g6yke;
    var $g2UN3;
    const $15d5558800f1e4f5$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $15d5558800f1e4f5$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$15d5558800f1e4f5$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$15d5558800f1e4f5$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $15d5558800f1e4f5$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $15d5558800f1e4f5$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $15d5558800f1e4f5$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $15d5558800f1e4f5$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("g6yke")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("g6yke")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("g2UN3")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("g2UN3")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("gN6Vx", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$8c2db7d5c814622a$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$8c2db7d5c814622a$export$2e2bcd8739ae039);
    var $4ZiMV;
    var $dvXtt;
    var $7GEKO;
    var $kWDSl;
    var $2s2ld;
    const $8c2db7d5c814622a$var$packageName = "platform-pkg";
    const $8c2db7d5c814622a$var$packageVersion = "0.0.0-use.local";
    const $8c2db7d5c814622a$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("2s2ld")).default)((0, (0, parcelRequire("kWDSl")).default));
    const $8c2db7d5c814622a$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("4ZiMV")).default)('atlaskit');
    const $8c2db7d5c814622a$var$Select = (0, (0, parcelRequire("dvXtt")).default)({
        componentName: 'select',
        packageName: $8c2db7d5c814622a$var$packageName,
        packageVersion: $8c2db7d5c814622a$var$packageVersion
    })((0, (0, parcelRequire("7GEKO")).default)({
        onChange: $8c2db7d5c814622a$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $8c2db7d5c814622a$var$packageName,
                packageVersion: $8c2db7d5c814622a$var$packageVersion
            }
        })
    })($8c2db7d5c814622a$export$d1de3b251ccaa8a3));
    var $8c2db7d5c814622a$export$2e2bcd8739ae039 = $8c2db7d5c814622a$var$Select;
});
parcelRegister("1j8VJ", function(module, exports) {
    $parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", ()=>$bc96975c28edaff2$export$b4ff48c8d43b18c3);
    var $7GEKO;
    var $96hPo;
    var $lFKmC = parcelRequire("lFKmC");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $857dZ;
    var $7Nt7x;
    var $cOo9h;
    var $5NzgX;
    var $cEoAI;
    const $bc96975c28edaff2$var$loadingMessage = ()=>null;
    const $bc96975c28edaff2$var$classNamePrefix = 'fabric-user-picker';
    class $bc96975c28edaff2$export$b4ff48c8d43b18c3 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isMulti: false,
                subtle: false,
                noBorder: false,
                textFieldBackgroundColor: false,
                isClearable: true,
                loadOptionsErrorMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("cOo9h")).messages).errorMessage),
                openMenuOnClick: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            const derivedState = {};
            if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
            if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
            if (nextProps.value !== undefined) derivedState.value = (0, (0, parcelRequire("5NzgX")).optionToSelectableOptions)(nextProps.value);
            else if ((0, (0, parcelRequire("5NzgX")).isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
                derivedState.value = (0, (0, parcelRequire("5NzgX")).optionToSelectableOptions)(nextProps.defaultValue);
                derivedState.isDefaultSet = true;
            }
            if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
            if (nextProps.options !== undefined) derivedState.options = nextProps.options;
            return derivedState;
        }
        constructor(props){
            super(props);
            this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
            this.withSelectRef = (callback)=>()=>{
                    if (this.selectRef) callback(this.selectRef);
                };
            this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
            this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
            this.focus = ()=>{
                if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
            };
            this.blur = ()=>{
                if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
            };
            this.selectOption = this.withSelectRef((select)=>{
                const focusedOption = select.state.focusedOption;
                select.selectOption(focusedOption);
            });
            this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
                if (removedValue && removedValue.data.fixed) return;
                this.resetInputState();
                const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
                (0, (0, parcelRequire("5NzgX")).callCallback)(onChange, (0, (0, parcelRequire("5NzgX")).extractOptionValue)(value), action);
                switch(action){
                    case 'select-option':
                        if (value) (0, (0, parcelRequire("5NzgX")).callCallback)(onSelection, (0, (0, parcelRequire("5NzgX")).extractOptionValue)(value), this.getSessionId(), this);
                        this.fireEvent((0, (0, parcelRequire("857dZ")).selectEvent), isMulti ? option : value);
                        this.session = isMulti ? (0, (0, parcelRequire("857dZ")).startSession)() : undefined;
                        break;
                    case 'clear':
                        (0, (0, parcelRequire("5NzgX")).callCallback)(onClear);
                        this.fireEvent((0, (0, parcelRequire("857dZ")).clearEvent));
                        break;
                    case 'remove-value':
                    case 'pop-value':
                        if (removedValue) this.fireEvent((0, (0, parcelRequire("857dZ")).deleteEvent), removedValue.data);
                        break;
                }
                this.fireEvent((0, (0, parcelRequire("857dZ")).searchedEvent));
                if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                    const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                    this.setState({
                        value: remainingValues ? remainingValues : [],
                        menuIsOpen: true
                    });
                }
                if (!this.props.value) this.setState({
                    value: value ? value : []
                });
            };
            this.handleSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.addOptions = (0, (0, parcelRequire("7Nt7x")).batchByKey)((request, newOptions)=>{
                const { resolving: resolving } = this.state;
                this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                    if (inflightRequest.toString() === request) return {
                        options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                        count: count - newOptions.length,
                        resolving: count - newOptions.length !== 0
                    };
                    return null;
                });
            });
            this.handleLoadOptionsError = ()=>{
                const { count: count } = this.state;
                const newCount = count - 1;
                const resolving = newCount !== 0;
                let showError = false;
                if (!resolving) showError = true;
                this.setState({
                    count: newCount,
                    resolving: resolving,
                    showError: showError
                });
                this.fireEvent((0, (0, parcelRequire("857dZ")).failedEvent));
            };
            this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                    const inflightRequest = previousRequest + 1;
                    const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                    const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                    let count = 0;
                    if ((0, (0, parcelRequire("5NzgX")).isIterable)(result)) for (const value of result){
                        Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    else {
                        Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    return {
                        inflightRequest: inflightRequest,
                        count: count,
                        resolving: count !== 0,
                        options: []
                    };
                });
            }, 200);
            this.abortOptionsShownUfoExperience = ()=>{
                if (this.optionsShownUfoExperienceInstance.state.id === (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id) this.optionsShownUfoExperienceInstance.abort();
            };
            this.startOptionsShownUfoExperience = ()=>{
                this.abortOptionsShownUfoExperience();
                this.optionsShownUfoExperienceInstance.start();
            };
            this.executeLoadOptions = (search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState({
                    resolving: true,
                    showError: false
                }, ()=>this.debouncedLoadOptions(search));
            };
            this.handleFocus = (event)=>{
                const { value: value, menuIsOpen: menuIsOpen } = this.state;
                if (!menuIsOpen || !this.session) this.startSession();
                this.startOptionsShownUfoExperience();
                (0, (0, parcelRequire("5NzgX")).callCallback)(this.props.onFocus, this.getSessionId());
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    this.setState({
                        menuIsOpen: true
                    });
                    if (!this.props.isMulti && (0, (0, parcelRequire("5NzgX")).isSingleValue)(value)) {
                        const input = event.target;
                        this.setState({
                            inputValue: value.label
                        }, ()=>{
                            if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                        });
                    }
                }
            };
            this.resetInputState = ()=>{
                this.setState({
                    inputValue: ''
                });
                (0, (0, parcelRequire("5NzgX")).callCallback)(this.props.onInputChange, '', this.getSessionId());
            };
            this.handleBlur = ()=>{
                (0, (0, parcelRequire("5NzgX")).callCallback)(this.props.onBlur, this.getSessionId());
                if ((0, (0, parcelRequire("5NzgX")).isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
                this.resetInputState();
                this.abortOptionsShownUfoExperience();
                this.setState({
                    menuIsOpen: false,
                    initialFocusHandled: false,
                    options: []
                });
            };
            this.handleOpen = ()=>{
                (0, (0, parcelRequire("5NzgX")).callCallback)(this.props.onOpen, this.getSessionId());
                this.setState({
                    menuIsOpen: true
                });
            };
            this.handleClose = ()=>{
                this.resetInputState();
                (0, (0, parcelRequire("5NzgX")).callCallback)(this.props.onClose, this.getSessionId());
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
            };
            this.handleInputChange = (search, { action: action })=>{
                if (action === 'input-change' || action === 'set-value') {
                    (0, (0, parcelRequire("5NzgX")).callCallback)(this.props.onInputChange, search, this.getSessionId());
                    this.setState({
                        inputValue: search
                    });
                    this.startOptionsShownUfoExperience();
                }
            };
            this.fireEvent = (eventCreator, ...args)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) (0, (0, parcelRequire("857dZ")).createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
            };
            this.startSession = ()=>{
                this.session = (0, (0, parcelRequire("857dZ")).startSession)();
                this.journeyId = this.getSessionId();
                this.fireEvent((0, (0, parcelRequire("857dZ")).focusEvent));
            };
            this.handleKeyDown = (event)=>{
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    if (event.keyCode === 27) this.blur();
                    if (event.keyCode === 32 && !this.state.inputValue) {
                        event.preventDefault();
                        !this.props.disableInput && this.setState({
                            inputValue: ' '
                        });
                    }
                }
                if (this.session) {
                    this.session.lastKey = event.keyCode;
                    switch(event.keyCode){
                        case 38:
                            this.session.upCount++;
                            break;
                        case 40:
                            this.session.downCount++;
                            break;
                    }
                }
                this.props.onKeyDown && this.props.onKeyDown(event);
            };
            this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
                this.setState({
                    hoveringClearIndicator: hoveringClearIndicator
                });
            };
            this.getOptions = ()=>{
                const options = (0, (0, parcelRequire("5NzgX")).getOptions)(this.state.options) || [];
                const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
                if (maxOptions === 0) return [];
                if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                    const { value: value } = this.state;
                    let filteredOptions = options;
                    if (isMulti && Array.isArray(value)) {
                        const valueIds = value.map((item)=>item.data.id);
                        filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                    }
                    return filteredOptions.slice(0, maxOptions);
                }
                return options;
            };
            this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
            this.handleClickDraggableParentComponent = ()=>{
                if (this.state.initialFocusHandled) {
                    if (this.state.menuIsOpen) this.handleClose();
                    else this.handleOpen();
                } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                    this.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            this.state = {
                options: [],
                isDefaultSet: false,
                inflightRequest: 0,
                count: 0,
                hoveringClearIndicator: false,
                menuIsOpen: !!this.props.open,
                inputValue: props.search || '',
                resolving: false,
                showError: false,
                initialFocusHandled: false
            };
            this.optionsShownUfoExperienceInstance = (0, (0, parcelRequire("cEoAI")).userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        }
        get isMenuOpenOnClickForSingleSelect() {
            return this.props.openMenuOnClick && !this.props.isMulti;
        }
        componentDidMount() {
            const { open: open, search: search } = this.props;
            if (open) {
                if (!this.session) this.startSession();
                this.executeLoadOptions(search);
            }
        }
        componentDidUpdate(_, prevState) {
            const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
            if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
            if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
            if (!menuIsOpen && prevState.menuIsOpen && this.session) {
                this.fireEvent((0, (0, parcelRequire("857dZ")).cancelEvent), prevState);
                this.session = undefined;
            }
            if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, (0, parcelRequire("857dZ")).searchedEvent));
            if (this.state.inputValue !== prevState.inputValue) {
                if (this.session) this.session.inputChangeTime = Date.now();
            }
            if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
                (0, (0, parcelRequire("96hPo")).UFOExperienceState).STARTED.id,
                (0, (0, parcelRequire("96hPo")).UFOExperienceState).IN_PROGRESS.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
        }
        get ariaProps() {
            const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
            const props = {
                ...this.props
            };
            return ariaLabels.reduce((obj, key)=>({
                    ...obj,
                    [key]: props[key]
                }), {});
        }
        render() {
            const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
            const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
            const appearance = this.getAppearance();
            const menuOpenDeciderProps = {
                ...!this.isMenuOpenOnClickForSingleSelect && {
                    menuIsOpen: menuIsOpen,
                    blurInputOnSelect: !isMulti,
                    openMenuOnFocus: true
                }
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                name: name,
                value: value,
                autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
                "aria-labelledby": ariaLabelledBy,
                "aria-label": ariaLabel,
                "aria-live": ariaLive,
                "aria-required": required,
                required: required,
                ref: this.handleSelectRef,
                isMulti: isMulti,
                options: this.getOptions(),
                styles: styles,
                enableAnimation: isMulti,
                components: components,
                inputValue: inputValue,
                isLoading: count > 0 || resolving || isLoading,
                loadingMessage: $bc96975c28edaff2$var$loadingMessage,
                menuPlacement: "auto",
                placeholder: placeholder ?? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("cOo9h")).messages).placeholder),
                addMoreMessage: addMoreMessage,
                classNamePrefix: $bc96975c28edaff2$var$classNamePrefix,
                hoveringClearIndicator: hoveringClearIndicator,
                appearance: appearance,
                isClearable: isClearable,
                noBorder: noBorder,
                subtle: subtle,
                closeMenuOnSelect: !isMulti,
                noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
                footer: footer,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isFocused: menuIsOpen,
                backspaceRemovesValue: isMulti,
                filterOption: null,
                clearValueLabel: clearValueLabel,
                menuMinWidth: menuMinWidth,
                menuPortalTarget: menuPortalTarget,
                disableInput: disableInput || isDisabled,
                instanceId: fieldId,
                inputId: inputId,
                onChange: this.handleChange,
                onMenuOpen: this.handleOpen,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onMenuClose: this.handleClose,
                onInputChange: this.handleInputChange,
                onClearIndicatorHover: this.handleClearIndicatorHover,
                onKeyDown: this.handleKeyDown,
                maxPickerHeight: maxPickerHeight,
                textFieldBackgroundColor: textFieldBackgroundColor,
                header: header,
                placeholderAvatar: placeholderAvatar,
                ...this.ariaProps,
                ...pickerProps,
                ...UNSAFE_hasDraggableParentComponent && {
                    onValueContainerClick: this.handleClickDraggableParentComponent
                },
                ...menuOpenDeciderProps
            });
        }
    }
    const $bc96975c28edaff2$export$d099ade7b4f4d2a4 = (0, (0, parcelRequire("7GEKO")).default)()($bc96975c28edaff2$export$b4ff48c8d43b18c3);
});
parcelRegister("857dZ", function(module, exports) {
    $parcel$export(module.exports, "startSession", ()=>$ca0945965824e2fe$export$c0d84948cecf78d8);
    $parcel$export(module.exports, "createAndFireEventInElementsChannel", ()=>$ca0945965824e2fe$export$53eef0dcd9611650);
    $parcel$export(module.exports, "focusEvent", ()=>$ca0945965824e2fe$export$e7818c470f37c4bd);
    $parcel$export(module.exports, "clearEvent", ()=>$ca0945965824e2fe$export$7b5800e732182efb);
    $parcel$export(module.exports, "deleteEvent", ()=>$ca0945965824e2fe$export$95711ec6c6227e9a);
    $parcel$export(module.exports, "cancelEvent", ()=>$ca0945965824e2fe$export$e9caaaecfee38128);
    $parcel$export(module.exports, "selectEvent", ()=>$ca0945965824e2fe$export$48143d759475d90f);
    $parcel$export(module.exports, "searchedEvent", ()=>$ca0945965824e2fe$export$911fb7184b6037eb);
    $parcel$export(module.exports, "failedEvent", ()=>$ca0945965824e2fe$export$c2aec355fef65c9c);
    $parcel$export(module.exports, "userInfoEvent", ()=>$ca0945965824e2fe$export$f541f04954b0c11e);
    var $4ZiMV;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5NzgX;
    const $ca0945965824e2fe$var$packageName = "platform-pkg";
    const $ca0945965824e2fe$var$packageVersion = "0.0.0-use.local";
    const $ca0945965824e2fe$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $ca0945965824e2fe$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $ca0945965824e2fe$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
    const $ca0945965824e2fe$export$c0d84948cecf78d8 = ()=>({
            id: (0, $7Jxgt.v4)(),
            start: Date.now(),
            inputChangeTime: Date.now(),
            upCount: 0,
            downCount: 0,
            lastKey: undefined
        });
    const $ca0945965824e2fe$export$53eef0dcd9611650 = (0, (0, parcelRequire("4ZiMV")).default)('fabric-elements');
    const $ca0945965824e2fe$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            attributes: {
                packageName: $ca0945965824e2fe$var$packageName,
                packageVersion: $ca0945965824e2fe$var$packageVersion,
                ...attributes
            }
        });
    const $ca0945965824e2fe$var$checkValidId = (id)=>{
        return $ca0945965824e2fe$var$UUID_REGEXP_NEW_AAID.test(id) || $ca0945965824e2fe$var$UUID_REGEXP_OLD_AAID.test(id) || $ca0945965824e2fe$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
    };
    const $ca0945965824e2fe$var$optionData2Analytics = (option)=>{
        const { id: id, type: type } = option;
        const validatedData = {
            id: $ca0945965824e2fe$var$checkValidId(id) ? id : null,
            type: type || null
        };
        if ((0, (0, parcelRequire("5NzgX")).isExternalUser)(option)) return {
            ...validatedData,
            type: 'external_user',
            sources: option.sources,
            externalUserType: option.externalUserType
        };
        if ((0, (0, parcelRequire("5NzgX")).isCustom)(option) && option.analyticsType) return {
            ...validatedData,
            type: option.analyticsType
        };
        return validatedData;
    };
    const $ca0945965824e2fe$var$buildValueForAnalytics = (value)=>{
        if (value) {
            const valueToConvert = Array.isArray(value) ? value : [
                value
            ];
            return valueToConvert.map(({ data: data })=>$ca0945965824e2fe$var$optionData2Analytics(data));
        }
        return [];
    };
    const $ca0945965824e2fe$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
            context: props.fieldId,
            sessionId: $ca0945965824e2fe$var$sessionId(session),
            pickerType: $ca0945965824e2fe$var$pickerType(props),
            journeyId: journeyId
        });
    const $ca0945965824e2fe$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$ca0945965824e2fe$var$createEvent('ui', 'focused', 'userPicker', {
            ...$ca0945965824e2fe$var$createDefaultPickerAttributes(props, session, journeyId),
            values: $ca0945965824e2fe$var$buildValueForAnalytics(state.value)
        });
    const $ca0945965824e2fe$export$7b5800e732182efb = (props, state, session, journeyId)=>$ca0945965824e2fe$var$createEvent('ui', 'cleared', 'userPicker', {
            ...$ca0945965824e2fe$var$createDefaultPickerAttributes(props, session, journeyId),
            pickerOpen: state.menuIsOpen,
            values: $ca0945965824e2fe$var$values(state)
        });
    const $ca0945965824e2fe$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$ca0945965824e2fe$var$createEvent('ui', 'deleted', 'userPickerItem', {
            context: props.fieldId,
            sessionId: $ca0945965824e2fe$var$sessionId(session),
            journeyId: journeyId,
            value: $ca0945965824e2fe$var$optionData2Analytics(args[0]),
            pickerOpen: state.menuIsOpen
        });
    const $ca0945965824e2fe$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$ca0945965824e2fe$var$createEvent('ui', 'cancelled', 'userPicker', {
            ...$ca0945965824e2fe$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $ca0945965824e2fe$var$sessionDuration(session),
            queryLength: $ca0945965824e2fe$var$queryLength(args[0]),
            spaceInQuery: $ca0945965824e2fe$var$spaceInQuery(args[0]),
            upKeyCount: $ca0945965824e2fe$var$upKeyCount(session),
            downKeyCount: $ca0945965824e2fe$var$downKeyCount(session)
        });
    const $ca0945965824e2fe$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
        return $ca0945965824e2fe$var$createEvent('ui', $ca0945965824e2fe$var$selectEventType(session), 'userPicker', {
            ...$ca0945965824e2fe$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $ca0945965824e2fe$var$sessionDuration(session),
            position: $ca0945965824e2fe$var$position(state, args[0]),
            queryLength: $ca0945965824e2fe$var$queryLength(state),
            spaceInQuery: $ca0945965824e2fe$var$spaceInQuery(state),
            upKeyCount: $ca0945965824e2fe$var$upKeyCount(session),
            downKeyCount: $ca0945965824e2fe$var$downKeyCount(session),
            result: $ca0945965824e2fe$var$result(args[0]),
            numberOfResults: $ca0945965824e2fe$var$numberOfResults(state)
        });
    };
    const $ca0945965824e2fe$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
        const searchResults = $ca0945965824e2fe$var$results(state);
        return $ca0945965824e2fe$var$createEvent('operational', 'searched', 'userPicker', {
            ...$ca0945965824e2fe$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $ca0945965824e2fe$var$sessionDuration(session),
            durationSinceInputChange: $ca0945965824e2fe$var$durationSinceInputChange(session),
            queryLength: $ca0945965824e2fe$var$queryLength(state),
            isLoading: $ca0945965824e2fe$var$isLoading(props, state),
            results: searchResults,
            numberOfResults: searchResults.length
        });
    };
    const $ca0945965824e2fe$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$ca0945965824e2fe$var$createEvent('operational', 'failed', 'userPicker', {
            ...$ca0945965824e2fe$var$createDefaultPickerAttributes(props, session, journeyId)
        });
    const $ca0945965824e2fe$export$f541f04954b0c11e = (sources, accountId)=>$ca0945965824e2fe$var$createEvent('ui', 'displayed', 'userInfo', {
            sources: sources,
            accountId: $ca0945965824e2fe$var$checkValidId(accountId) ? accountId : null
        });
    function $ca0945965824e2fe$var$queryLength(state) {
        return state.inputValue.length;
    }
    function $ca0945965824e2fe$var$selectEventType(session) {
        return session && session.lastKey === 13 ? 'pressed' : 'clicked';
    }
    function $ca0945965824e2fe$var$upKeyCount(session) {
        return session ? session.upCount : null;
    }
    function $ca0945965824e2fe$var$downKeyCount(session) {
        return session ? session.downCount : null;
    }
    function $ca0945965824e2fe$var$spaceInQuery(state) {
        return state.inputValue.indexOf(' ') !== -1;
    }
    function $ca0945965824e2fe$var$sessionDuration(session) {
        return session ? Date.now() - session.start : null;
    }
    function $ca0945965824e2fe$var$durationSinceInputChange(session) {
        return session ? Date.now() - session.inputChangeTime : null;
    }
    function $ca0945965824e2fe$var$sessionId(session) {
        return session && session.id;
    }
    function $ca0945965824e2fe$var$position(state, value) {
        return value ? state.options.findIndex((option)=>option === value.data) : -1;
    }
    function $ca0945965824e2fe$var$pickerType(props) {
        return props.isMulti ? 'multi' : 'single';
    }
    function $ca0945965824e2fe$var$result(option) {
        return option ? $ca0945965824e2fe$var$optionData2Analytics(option.data) : null;
    }
    function $ca0945965824e2fe$var$results(state) {
        return (state.options || []).map($ca0945965824e2fe$var$optionData2Analytics);
    }
    function $ca0945965824e2fe$var$isLoading(props, state) {
        return state.count > 0 || props.isLoading;
    }
    function $ca0945965824e2fe$var$values(state) {
        return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$ca0945965824e2fe$var$optionData2Analytics(option.data)) : [
            $ca0945965824e2fe$var$optionData2Analytics(state.value.data)
        ] : [];
    }
    function $ca0945965824e2fe$var$numberOfResults(state) {
        return (state.options || []).length;
    }
});
parcelRegister("5NzgX", function(module, exports) {
    $parcel$export(module.exports, "isExternalUser", ()=>$dfbbf7fede7b9939$export$f6058dbcb5980cb);
    $parcel$export(module.exports, "isUser", ()=>$dfbbf7fede7b9939$export$2e44165f1da65304);
    $parcel$export(module.exports, "isTeam", ()=>$dfbbf7fede7b9939$export$f8c4277cb588611f);
    $parcel$export(module.exports, "isGroup", ()=>$dfbbf7fede7b9939$export$d7976824e9f55785);
    $parcel$export(module.exports, "isEmail", ()=>$dfbbf7fede7b9939$export$7fbbfbca30081d0);
    $parcel$export(module.exports, "isCustom", ()=>$dfbbf7fede7b9939$export$d3a8f0b77e9737fc);
    $parcel$export(module.exports, "isDefaultValuePopulated", ()=>$dfbbf7fede7b9939$export$d6978985a41b0c8);
    $parcel$export(module.exports, "extractOptionValue", ()=>$dfbbf7fede7b9939$export$7ae97131df521bff);
    $parcel$export(module.exports, "isIterable", ()=>$dfbbf7fede7b9939$export$9652023d9040757);
    $parcel$export(module.exports, "getOptions", ()=>$dfbbf7fede7b9939$export$d2312e68e1f5ad00);
    $parcel$export(module.exports, "optionToSelectableOptions", ()=>$dfbbf7fede7b9939$export$e6fda14a194bcbcc);
    $parcel$export(module.exports, "getAvatarSize", ()=>$dfbbf7fede7b9939$export$695fb564e621339a);
    $parcel$export(module.exports, "isChildInput", ()=>$dfbbf7fede7b9939$export$3c62cf9a01367f27);
    $parcel$export(module.exports, "isSingleValue", ()=>$dfbbf7fede7b9939$export$203c2bd2662d1ca2);
    $parcel$export(module.exports, "hasValue", ()=>$dfbbf7fede7b9939$export$96bdbc84526f3739);
    $parcel$export(module.exports, "callCallback", ()=>$dfbbf7fede7b9939$export$df325aa844b03c31);
    $parcel$export(module.exports, "getAvatarUrl", ()=>$dfbbf7fede7b9939$export$b4f8f1f54acec99b);
    $parcel$export(module.exports, "isPopupUserPickerByComponent", ()=>$dfbbf7fede7b9939$export$4f60a74234178416);
    $parcel$export(module.exports, "isLozengeText", ()=>$dfbbf7fede7b9939$export$5419897287f5f1c7);
    var $8QpSo;
    var $3t0PE;
    const $dfbbf7fede7b9939$export$f6058dbcb5980cb = (option)=>option.type === (0, $deda2b1ce401799e$export$50042ec1d2e00e63) || Boolean(option.isExternal);
    const $dfbbf7fede7b9939$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $deda2b1ce401799e$export$8436e53e45ffe15b);
    const $dfbbf7fede7b9939$export$f8c4277cb588611f = (option)=>option.type === (0, $deda2b1ce401799e$export$26bc40b960693765);
    const $dfbbf7fede7b9939$export$d7976824e9f55785 = (option)=>option.type === (0, $deda2b1ce401799e$export$d460f747b73abb10);
    const $dfbbf7fede7b9939$export$7fbbfbca30081d0 = (option)=>option.type === (0, $deda2b1ce401799e$export$6662b3461398ef8c);
    const $dfbbf7fede7b9939$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $deda2b1ce401799e$export$eafd0979afa5b224);
    const $dfbbf7fede7b9939$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
    const $dfbbf7fede7b9939$var$isOptionData = (option)=>option.name !== undefined;
    const $dfbbf7fede7b9939$export$3f993c492bd6c728 = (option)=>{
        if ($dfbbf7fede7b9939$var$isOptionData(option)) return {
            data: option,
            isDisabled: option.isDisabled,
            label: option.name,
            value: option.id
        };
        else return {
            data: {
                ...option,
                name: option.id
            },
            isDisabled: option.isDisabled,
            label: option.id,
            value: option.id
        };
    };
    const $dfbbf7fede7b9939$export$7ae97131df521bff = (value)=>{
        if (!value) return undefined;
        if (Array.isArray(value)) return value.map(({ data: option })=>option);
        return value.data;
    };
    const $dfbbf7fede7b9939$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
    const $dfbbf7fede7b9939$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((options)=>options.map($dfbbf7fede7b9939$export$3f993c492bd6c728));
    const $dfbbf7fede7b9939$export$e6fda14a194bcbcc = (0, (0, parcelRequire("8QpSo")).default)((defaultValue)=>{
        if (!defaultValue) return null;
        if (Array.isArray(defaultValue)) return defaultValue.map($dfbbf7fede7b9939$export$3f993c492bd6c728);
        return $dfbbf7fede7b9939$export$3f993c492bd6c728(defaultValue);
    });
    const $dfbbf7fede7b9939$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
    const $dfbbf7fede7b9939$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
    const $dfbbf7fede7b9939$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
    const $dfbbf7fede7b9939$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
    const $dfbbf7fede7b9939$export$df325aa844b03c31 = (callback, ...args)=>{
        if (typeof callback === 'function') try {
            return callback(...args);
        } catch (error) {
            console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
        }
    };
    const $dfbbf7fede7b9939$export$b4f8f1f54acec99b = (optionData)=>{
        if ($dfbbf7fede7b9939$export$2e44165f1da65304(optionData) || $dfbbf7fede7b9939$export$f8c4277cb588611f(optionData) || $dfbbf7fede7b9939$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
        return undefined;
    };
    const $dfbbf7fede7b9939$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, (0, parcelRequire("3t0PE")).default);
    const $dfbbf7fede7b9939$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
    const $dfbbf7fede7b9939$export$5419897287f5f1c7 = (lozengeProp)=>{
        return lozengeProp?.hasOwnProperty('text') || false;
    };
});
const $deda2b1ce401799e$export$8436e53e45ffe15b = 'user';
const $deda2b1ce401799e$export$50042ec1d2e00e63 = 'external_user';
const $deda2b1ce401799e$export$26bc40b960693765 = 'team';
const $deda2b1ce401799e$export$d460f747b73abb10 = 'group';
const $deda2b1ce401799e$export$6662b3461398ef8c = 'email';
const $deda2b1ce401799e$export$eafd0979afa5b224 = 'custom';
parcelRegister("3t0PE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38a8e58d05b19458$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $9ZKDH = parcelRequire("9ZKDH");
    var $dI393 = parcelRequire("dI393");
    var $2w28i;
    var $43fmF;
    var $lr9Km;
    var $4wJSY = parcelRequire("4wJSY");
    var $bkJDg;
    var $2oS3b;
    var $crsHE;
    var $gN6Vx;
    var $imyI2;
    var $HFUaQ;
    var $hhPK6;
    const $38a8e58d05b19458$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $38a8e58d05b19458$var$FocusLock = (0, (0, parcelRequire("2oS3b")).fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    const $38a8e58d05b19458$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $38a8e58d05b19458$var$defaultPopperProps = {
        modifiers: $38a8e58d05b19458$var$modifiers,
        placement: 'bottom-start'
    };
    const $38a8e58d05b19458$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $38a8e58d05b19458$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$38a8e58d05b19458$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hhPK6")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$38a8e58d05b19458$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w28i")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bkJDg")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lr9Km")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args);
            this.menuRef = null;
            this.selectRef = null;
            this.targetRef = null;
            this.unbindWindowClick = null;
            this.unbindWindowKeydown = null;
            this.defaultStyles = (0, (0, parcelRequire("crsHE")).mergeStyles)((0, (0, parcelRequire("imyI2")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$eaa8c8a70ac22806})`
                    })
            });
            this.isOpenControlled = this.props.isOpen !== undefined;
            this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
            this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hhPK6")).defaultComponents),
                mergedPopperProps: $38a8e58d05b19458$var$defaultPopperProps
            };
            this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            };
            this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            };
            this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            };
            this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            };
            this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            };
            this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen && (0, (0, parcelRequire("2oS3b")).fg)('platform_design_system_team_select_node_resolver')) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            };
            this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose && (0, (0, parcelRequire("2oS3b")).fg)('platform_design_system_team_select_node_resolver')) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            };
            this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                };
            this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                };
            this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            };
            this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            };
            this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            };
            this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const menuHandlers = !(0, (0, parcelRequire("2oS3b")).fg)('platform_design_system_team_select_node_resolver') ? {
                    onMenuOpen: onMenuOpen,
                    onMenuClose: onMenuClose
                } : {};
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $38a8e58d05b19458$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hhPK6")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("HFUaQ")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("HFUaQ")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("HFUaQ")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("43fmF")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement($38a8e58d05b19458$var$ConditionalNodeResolverWrapper, {
                        hasNodeResolver: !(0, (0, parcelRequire("2oS3b")).fg)('platform_design_system_team_select_node_resolver'),
                        innerRef: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hhPK6")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: !(0, (0, parcelRequire("2oS3b")).fg)('platform_design_system_team_select_node_resolver') ? null : this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($38a8e58d05b19458$var$FocusLock, {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        ...menuHandlers,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("crsHE")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer))));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
    const $38a8e58d05b19458$var$ConditionalNodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
        if (hasNodeResolver) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($dI393))), {
            innerRef: innerRef
        }, children);
        return children;
    };
});
parcelRegister("2w28i", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$1d503975cdd11d34$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$1d503975cdd11d34$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$1d503975cdd11d34$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $1d503975cdd11d34$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $1d503975cdd11d34$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $1d503975cdd11d34$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($1d503975cdd11d34$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($1d503975cdd11d34$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("43fmF", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$2f335c501a47fe9f$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $2w28i;
    var $etveP;
    var $69Kah;
    var $2f335c501a47fe9f$var$NOOP = function NOOP() {
        return void 0;
    };
    var $2f335c501a47fe9f$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $2f335c501a47fe9f$var$EMPTY_MODIFIERS = [];
    function $2f335c501a47fe9f$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $2f335c501a47fe9f$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("2w28i")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("etveP")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("69Kah")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $2f335c501a47fe9f$var$NOOP,
                update: update || $2f335c501a47fe9f$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("etveP")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("etveP", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$02b8319206411a7f$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$02b8319206411a7f$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$02b8319206411a7f$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$02b8319206411a7f$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$02b8319206411a7f$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $02b8319206411a7f$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $02b8319206411a7f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $02b8319206411a7f$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $02b8319206411a7f$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $02b8319206411a7f$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $02b8319206411a7f$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("69Kah", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$47b764b13664bf65$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $b6zvG;
    var $lHrkK = parcelRequire("lHrkK");
    var $etveP;
    var $47b764b13664bf65$var$EMPTY_MODIFIERS = [];
    var $47b764b13664bf65$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $47b764b13664bf65$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("etveP")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("etveP")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("etveP")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("etveP")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("b6zvG")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("b6zvG", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$815bcccec8b17332$export$8f7491d57c8f97a9);
    var $8qShm;
    var $fPKjp;
    var $1f2fL;
    var $eAVjh;
    var $7aswo;
    var $hI00f;
    var $a20zu;
    var $byg8Y;
    var $9XETd;
    var $lRyJl;
    var $815bcccec8b17332$export$d34966752335dd47 = [
        (0, (0, parcelRequire("fPKjp")).default),
        (0, (0, parcelRequire("1f2fL")).default),
        (0, (0, parcelRequire("eAVjh")).default),
        (0, (0, parcelRequire("7aswo")).default),
        (0, (0, parcelRequire("hI00f")).default),
        (0, (0, parcelRequire("a20zu")).default),
        (0, (0, parcelRequire("byg8Y")).default),
        (0, (0, parcelRequire("9XETd")).default),
        (0, (0, parcelRequire("lRyJl")).default)
    ];
    var $815bcccec8b17332$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("8qShm")).popperGenerator)({
        defaultModifiers: $815bcccec8b17332$export$d34966752335dd47
    });
});
parcelRegister("8qShm", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$623adb24260301ef$export$ed5e13716264f202);
    var $evIj2;
    var $hbezI;
    var $liMGx;
    var $4Ae4p;
    var $8MQuK;
    var $inHsT;
    var $7w3x4;
    var $49wse;
    var $623adb24260301ef$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $623adb24260301ef$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $623adb24260301ef$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $623adb24260301ef$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $623adb24260301ef$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("49wse")).isElement)(reference) ? (0, (0, parcelRequire("liMGx")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("liMGx")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("liMGx")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("8MQuK")).default)((0, (0, parcelRequire("7w3x4")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$623adb24260301ef$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("evIj2")).default)(reference, (0, (0, parcelRequire("4Ae4p")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("hbezI")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("inHsT")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$623adb24260301ef$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $623adb24260301ef$export$8f7491d57c8f97a9 = $623adb24260301ef$export$ed5e13716264f202();
});
parcelRegister("evIj2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9065436b281a39e$export$2e2bcd8739ae039);
    var $861mM;
    var $Tywfg;
    var $jVmXH;
    var $49wse;
    var $3p4xw;
    var $fVbyj;
    var $7FflJ;
    var $asHtE;
    function $a9065436b281a39e$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("asHtE")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("asHtE")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $a9065436b281a39e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("49wse")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("49wse")).isHTMLElement)(offsetParent) && $a9065436b281a39e$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("fVbyj")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("861mM")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("jVmXH")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("7FflJ")).default)(documentElement)) scroll = (0, (0, parcelRequire("Tywfg")).default)(offsetParent);
            if ((0, (0, parcelRequire("49wse")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("861mM")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("3p4xw")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("861mM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e4ff19d6beb6b5e$export$2e2bcd8739ae039);
    var $49wse;
    var $asHtE;
    var $4tZah;
    var $9bn5x;
    function $5e4ff19d6beb6b5e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("49wse")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("asHtE")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("asHtE")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("49wse")).isElement)(element) ? (0, (0, parcelRequire("4tZah")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("9bn5x")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("49wse", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$30612d6fb7d8b190$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$30612d6fb7d8b190$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$30612d6fb7d8b190$export$af51f0f06c0f328a);
    var $4tZah;
    function $30612d6fb7d8b190$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("4tZah")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $30612d6fb7d8b190$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("4tZah")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $30612d6fb7d8b190$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("4tZah")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("4tZah", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$343950ecb629c3e0$export$2e2bcd8739ae039);
    function $343950ecb629c3e0$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("asHtE", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$79de3e960c18d7d8$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$79de3e960c18d7d8$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$79de3e960c18d7d8$export$2077e0241d6afd3c);
    var $79de3e960c18d7d8$export$8960430cfd85939f = Math.max;
    var $79de3e960c18d7d8$export$96ec731ed4dcb222 = Math.min;
    var $79de3e960c18d7d8$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("9bn5x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6af70d0534b27122$export$2e2bcd8739ae039);
    var $gbwtB;
    function $6af70d0534b27122$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("gbwtB")).default)());
    }
});
parcelRegister("gbwtB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc86dd98cd9f5c8d$export$2e2bcd8739ae039);
    function $bc86dd98cd9f5c8d$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("Tywfg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a6fe9f083e73612$export$2e2bcd8739ae039);
    var $dbYNm;
    var $4tZah;
    var $49wse;
    var $l0DYW;
    function $0a6fe9f083e73612$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("4tZah")).default)(node) || !(0, (0, parcelRequire("49wse")).isHTMLElement)(node)) return (0, (0, parcelRequire("dbYNm")).default)(node);
        else return (0, (0, parcelRequire("l0DYW")).default)(node);
    }
});
parcelRegister("dbYNm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99ab76185531e6fb$export$2e2bcd8739ae039);
    var $4tZah;
    function $99ab76185531e6fb$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("4tZah")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("l0DYW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4b89ca735cb1144$export$2e2bcd8739ae039);
    function $f4b89ca735cb1144$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("jVmXH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e81526f60e8d94f6$export$2e2bcd8739ae039);
    function $e81526f60e8d94f6$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("3p4xw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27a73a65b060e00f$export$2e2bcd8739ae039);
    var $861mM;
    var $fVbyj;
    var $dbYNm;
    function $27a73a65b060e00f$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("861mM")).default)((0, (0, parcelRequire("fVbyj")).default)(element)).left + (0, (0, parcelRequire("dbYNm")).default)(element).scrollLeft;
    }
});
parcelRegister("fVbyj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b97523faca7d1157$export$2e2bcd8739ae039);
    var $49wse;
    function $b97523faca7d1157$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("49wse")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("7FflJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$594844d3202a6e1d$export$2e2bcd8739ae039);
    var $ctZLK;
    function $594844d3202a6e1d$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("ctZLK")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("ctZLK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91681b837d46108b$export$2e2bcd8739ae039);
    var $4tZah;
    function $91681b837d46108b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("4tZah")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("hbezI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c81ec50f65ad08dd$export$2e2bcd8739ae039);
    var $861mM;
    function $c81ec50f65ad08dd$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("861mM")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("liMGx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8210b42bb44ac8d$export$2e2bcd8739ae039);
    var $lidy0;
    var $jFVZH;
    var $4tZah;
    var $7FflJ;
    function $f8210b42bb44ac8d$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("lidy0")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("4tZah")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("7FflJ")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($f8210b42bb44ac8d$export$2e2bcd8739ae039((0, (0, parcelRequire("jFVZH")).default)(target)));
    }
});
parcelRegister("lidy0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f805c9aa06299b9b$export$2e2bcd8739ae039);
    var $jFVZH;
    var $7FflJ;
    var $jVmXH;
    var $49wse;
    function $f805c9aa06299b9b$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("jVmXH")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("49wse")).isHTMLElement)(node) && (0, (0, parcelRequire("7FflJ")).default)(node)) return node;
        return $f805c9aa06299b9b$export$2e2bcd8739ae039((0, (0, parcelRequire("jFVZH")).default)(node));
    }
});
parcelRegister("jFVZH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e52ed50fe9115a7d$export$2e2bcd8739ae039);
    var $jVmXH;
    var $fVbyj;
    var $49wse;
    function $e52ed50fe9115a7d$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("jVmXH")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("49wse")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("fVbyj")).default)(element));
    }
});
parcelRegister("4Ae4p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3565703ec1b3d38e$export$2e2bcd8739ae039);
    var $4tZah;
    var $jVmXH;
    var $ctZLK;
    var $49wse;
    var $kDJeH;
    var $jFVZH;
    var $gbwtB;
    function $3565703ec1b3d38e$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("49wse")).isHTMLElement)(element) || (0, (0, parcelRequire("ctZLK")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $3565703ec1b3d38e$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("gbwtB")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("gbwtB")).default)());
        if (isIE && (0, (0, parcelRequire("49wse")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("ctZLK")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("jFVZH")).default)(element);
        if ((0, (0, parcelRequire("49wse")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("49wse")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("jVmXH")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("ctZLK")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $3565703ec1b3d38e$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("4tZah")).default)(element);
        var offsetParent = $3565703ec1b3d38e$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("kDJeH")).default)(offsetParent) && (0, (0, parcelRequire("ctZLK")).default)(offsetParent).position === 'static')offsetParent = $3565703ec1b3d38e$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("jVmXH")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("jVmXH")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("ctZLK")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $3565703ec1b3d38e$var$getContainingBlock(element) || window;
    }
});
parcelRegister("kDJeH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f06a8a1eb4cebbbe$export$2e2bcd8739ae039);
    var $jVmXH;
    function $f06a8a1eb4cebbbe$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("jVmXH")).default)(element)) >= 0;
    }
});
parcelRegister("8MQuK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$665b86d2c2d27f8a$export$2e2bcd8739ae039);
    var $e2YFf;
    function $665b86d2c2d27f8a$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $665b86d2c2d27f8a$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $665b86d2c2d27f8a$var$order(modifiers);
        return (0, (0, parcelRequire("e2YFf")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("e2YFf", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$a3a04f44e93af771$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$a3a04f44e93af771$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$a3a04f44e93af771$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$a3a04f44e93af771$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$a3a04f44e93af771$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$a3a04f44e93af771$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$a3a04f44e93af771$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$a3a04f44e93af771$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$a3a04f44e93af771$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$a3a04f44e93af771$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$a3a04f44e93af771$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$a3a04f44e93af771$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$a3a04f44e93af771$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$a3a04f44e93af771$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$a3a04f44e93af771$export$d087d3878fdf71d5);
    var $a3a04f44e93af771$export$1e95b668f3b82d = 'top';
    var $a3a04f44e93af771$export$40e543e69a8b3fbb = 'bottom';
    var $a3a04f44e93af771$export$79ffe56a765070d2 = 'right';
    var $a3a04f44e93af771$export$eabcd2c8791e7bf4 = 'left';
    var $a3a04f44e93af771$export$dfb5619354ba860 = 'auto';
    var $a3a04f44e93af771$export$aec2ce47c367b8c3 = [
        $a3a04f44e93af771$export$1e95b668f3b82d,
        $a3a04f44e93af771$export$40e543e69a8b3fbb,
        $a3a04f44e93af771$export$79ffe56a765070d2,
        $a3a04f44e93af771$export$eabcd2c8791e7bf4
    ];
    var $a3a04f44e93af771$export$b3571188c770cc5a = 'start';
    var $a3a04f44e93af771$export$bd5df0f255a350f8 = 'end';
    var $a3a04f44e93af771$export$390fd549c5303b4d = 'clippingParents';
    var $a3a04f44e93af771$export$d7b7311ec04a3e8f = 'viewport';
    var $a3a04f44e93af771$export$ae5ab1c730825774 = 'popper';
    var $a3a04f44e93af771$export$ca50aac9f3ba507f = 'reference';
    var $a3a04f44e93af771$export$368f9a87e87fa4e1 = $a3a04f44e93af771$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $a3a04f44e93af771$export$b3571188c770cc5a,
            placement + "-" + $a3a04f44e93af771$export$bd5df0f255a350f8
        ]);
    }, []);
    var $a3a04f44e93af771$export$803cd8101b6c182b = [].concat($a3a04f44e93af771$export$aec2ce47c367b8c3, [
        $a3a04f44e93af771$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $a3a04f44e93af771$export$b3571188c770cc5a,
            placement + "-" + $a3a04f44e93af771$export$bd5df0f255a350f8
        ]);
    }, []);
    var $a3a04f44e93af771$export$421679a7c3d56e = 'beforeRead';
    var $a3a04f44e93af771$export$aafa59e2e03f2942 = 'read';
    var $a3a04f44e93af771$export$6964f6c886723980 = 'afterRead';
    var $a3a04f44e93af771$export$c65e99957a05207c = 'beforeMain';
    var $a3a04f44e93af771$export$f22da7240b7add18 = 'main';
    var $a3a04f44e93af771$export$bab79516f2d662fe = 'afterMain';
    var $a3a04f44e93af771$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $a3a04f44e93af771$export$68d8715fc104d294 = 'write';
    var $a3a04f44e93af771$export$70a6e5159acce2e6 = 'afterWrite';
    var $a3a04f44e93af771$export$d087d3878fdf71d5 = [
        $a3a04f44e93af771$export$421679a7c3d56e,
        $a3a04f44e93af771$export$aafa59e2e03f2942,
        $a3a04f44e93af771$export$6964f6c886723980,
        $a3a04f44e93af771$export$c65e99957a05207c,
        $a3a04f44e93af771$export$f22da7240b7add18,
        $a3a04f44e93af771$export$bab79516f2d662fe,
        $a3a04f44e93af771$export$8d4d2d70e7d46032,
        $a3a04f44e93af771$export$68d8715fc104d294,
        $a3a04f44e93af771$export$70a6e5159acce2e6
    ];
});
parcelRegister("inHsT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d61c173c9120db20$export$2e2bcd8739ae039);
    function $d61c173c9120db20$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("7w3x4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$578e430b42ab53a7$export$2e2bcd8739ae039);
    function $578e430b42ab53a7$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("fPKjp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b86f8b04ac280765$export$2e2bcd8739ae039);
    var $4tZah;
    var $b86f8b04ac280765$var$passive = {
        passive: true
    };
    function $b86f8b04ac280765$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("4tZah")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $b86f8b04ac280765$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $b86f8b04ac280765$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $b86f8b04ac280765$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $b86f8b04ac280765$var$passive);
        };
    }
    var $b86f8b04ac280765$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $b86f8b04ac280765$var$effect,
        data: {}
    };
});
parcelRegister("1f2fL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e78f09923d109fd$export$2e2bcd8739ae039);
    var $dMroj;
    function $0e78f09923d109fd$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dMroj")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $0e78f09923d109fd$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $0e78f09923d109fd$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dMroj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a08501606cb385a0$export$2e2bcd8739ae039);
    var $j9mpk;
    var $3VNj3;
    var $gbIja;
    var $e2YFf;
    function $a08501606cb385a0$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("j9mpk")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("3VNj3")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("e2YFf")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("e2YFf")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("e2YFf")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("e2YFf")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("gbIja")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("e2YFf")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("e2YFf")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("j9mpk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df103d3e60d151e1$export$2e2bcd8739ae039);
    function $df103d3e60d151e1$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("3VNj3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dccf12928872ddc$export$2e2bcd8739ae039);
    function $2dccf12928872ddc$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("gbIja", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc900b177ad4cf78$export$2e2bcd8739ae039);
    function $bc900b177ad4cf78$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("eAVjh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa00e206a7660329$export$2e2bcd8739ae039);
    var $e2YFf;
    var $4Ae4p;
    var $4tZah;
    var $fVbyj;
    var $ctZLK;
    var $j9mpk;
    var $3VNj3;
    var $asHtE;
    var $aa00e206a7660329$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $aa00e206a7660329$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("asHtE")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("asHtE")).round)(y * dpr) / dpr || 0
        };
    }
    function $aa00e206a7660329$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("e2YFf")).left);
        var sideY = (0, (0, parcelRequire("e2YFf")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("4Ae4p")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("4tZah")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("fVbyj")).default)(popper);
                if ((0, (0, parcelRequire("ctZLK")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("e2YFf")).top) || (placement === (0, (0, parcelRequire("e2YFf")).left) || placement === (0, (0, parcelRequire("e2YFf")).right)) && variation === (0, (0, parcelRequire("e2YFf")).end)) {
                sideY = (0, (0, parcelRequire("e2YFf")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("e2YFf")).left) || (placement === (0, (0, parcelRequire("e2YFf")).top) || placement === (0, (0, parcelRequire("e2YFf")).bottom)) && variation === (0, (0, parcelRequire("e2YFf")).end)) {
                sideX = (0, (0, parcelRequire("e2YFf")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $aa00e206a7660329$var$unsetSides);
        var _ref4 = roundOffsets === true ? $aa00e206a7660329$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("4tZah")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $aa00e206a7660329$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("j9mpk")).default)(state.placement),
            variation: (0, (0, parcelRequire("3VNj3")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $aa00e206a7660329$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $aa00e206a7660329$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $aa00e206a7660329$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $aa00e206a7660329$var$computeStyles,
        data: {}
    };
});
parcelRegister("7aswo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$537f975557003bb1$export$2e2bcd8739ae039);
    var $jVmXH;
    var $49wse;
    function $537f975557003bb1$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("49wse")).isHTMLElement)(element) || !(0, (0, parcelRequire("jVmXH")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $537f975557003bb1$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("49wse")).isHTMLElement)(element) || !(0, (0, parcelRequire("jVmXH")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $537f975557003bb1$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $537f975557003bb1$var$applyStyles,
        effect: $537f975557003bb1$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("hI00f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce468c57ebe9fba2$export$2e2bcd8739ae039);
    var $j9mpk;
    var $e2YFf;
    function $ce468c57ebe9fba2$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("e2YFf")).left),
            (0, (0, parcelRequire("e2YFf")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("e2YFf")).left),
            (0, (0, parcelRequire("e2YFf")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $ce468c57ebe9fba2$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("e2YFf")).placements).reduce(function(acc, placement) {
            acc[placement] = $ce468c57ebe9fba2$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $ce468c57ebe9fba2$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $ce468c57ebe9fba2$var$offset
    };
});
parcelRegister("a20zu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74da88c18e1bf1ad$export$2e2bcd8739ae039);
    var $jmkt6;
    var $j9mpk;
    var $akgJU;
    var $kb66N;
    var $xYYSU;
    var $e2YFf;
    var $3VNj3;
    function $74da88c18e1bf1ad$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("j9mpk")).default)(placement) === (0, (0, parcelRequire("e2YFf")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jmkt6")).default)(placement);
        return [
            (0, (0, parcelRequire("akgJU")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("akgJU")).default)(oppositePlacement)
        ];
    }
    function $74da88c18e1bf1ad$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jmkt6")).default)(preferredPlacement)
        ] : $74da88c18e1bf1ad$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("j9mpk")).default)(placement) === (0, (0, parcelRequire("e2YFf")).auto) ? (0, (0, parcelRequire("xYYSU")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("j9mpk")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("3VNj3")).default)(placement) === (0, (0, parcelRequire("e2YFf")).start);
            var isVertical = [
                (0, (0, parcelRequire("e2YFf")).top),
                (0, (0, parcelRequire("e2YFf")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kb66N")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("e2YFf")).right) : (0, (0, parcelRequire("e2YFf")).left) : isStartVariation ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jmkt6")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jmkt6")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $74da88c18e1bf1ad$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $74da88c18e1bf1ad$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jmkt6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e17ff2fc84215f3e$export$2e2bcd8739ae039);
    var $e17ff2fc84215f3e$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e17ff2fc84215f3e$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e17ff2fc84215f3e$var$hash[matched];
        });
    }
});
parcelRegister("akgJU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7848c1c349945010$export$2e2bcd8739ae039);
    var $7848c1c349945010$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $7848c1c349945010$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $7848c1c349945010$var$hash[matched];
        });
    }
});
parcelRegister("kb66N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb0992bfe43fdb98$export$2e2bcd8739ae039);
    var $240nb;
    var $fVbyj;
    var $861mM;
    var $dMroj;
    var $agoTm;
    var $e2YFf;
    var $49wse;
    var $4I7vH;
    var $6DetQ;
    function $eb0992bfe43fdb98$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("e2YFf")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("e2YFf")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("e2YFf")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("4I7vH")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("6DetQ")).default)(padding, (0, (0, parcelRequire("e2YFf")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("e2YFf")).popper) ? (0, (0, parcelRequire("e2YFf")).reference) : (0, (0, parcelRequire("e2YFf")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("240nb")).default)((0, (0, parcelRequire("49wse")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("fVbyj")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("861mM")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dMroj")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("agoTm")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("e2YFf")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("e2YFf")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("e2YFf")).right),
                    (0, (0, parcelRequire("e2YFf")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("e2YFf")).top),
                    (0, (0, parcelRequire("e2YFf")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("240nb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$180c3e86dcd2f87c$export$2e2bcd8739ae039);
    var $e2YFf;
    var $5CQTs;
    var $cUrUp;
    var $liMGx;
    var $4Ae4p;
    var $fVbyj;
    var $ctZLK;
    var $49wse;
    var $861mM;
    var $jFVZH;
    var $aMVvs;
    var $jVmXH;
    var $agoTm;
    var $asHtE;
    function $180c3e86dcd2f87c$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("861mM")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $180c3e86dcd2f87c$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("e2YFf")).viewport) ? (0, (0, parcelRequire("agoTm")).default)((0, (0, parcelRequire("5CQTs")).default)(element, strategy)) : (0, (0, parcelRequire("49wse")).isElement)(clippingParent) ? $180c3e86dcd2f87c$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("agoTm")).default)((0, (0, parcelRequire("cUrUp")).default)((0, (0, parcelRequire("fVbyj")).default)(element)));
    }
    function $180c3e86dcd2f87c$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("liMGx")).default)((0, (0, parcelRequire("jFVZH")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("ctZLK")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("49wse")).isHTMLElement)(element) ? (0, (0, parcelRequire("4Ae4p")).default)(element) : element;
        if (!(0, (0, parcelRequire("49wse")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("49wse")).isElement)(clippingParent) && (0, (0, parcelRequire("aMVvs")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("jVmXH")).default)(clippingParent) !== 'body';
        });
    }
    function $180c3e86dcd2f87c$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $180c3e86dcd2f87c$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $180c3e86dcd2f87c$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("asHtE")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("asHtE")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("asHtE")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("asHtE")).max)(rect.left, accRect.left);
            return accRect;
        }, $180c3e86dcd2f87c$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("5CQTs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$418987e551afe718$export$2e2bcd8739ae039);
    var $4tZah;
    var $fVbyj;
    var $3p4xw;
    var $9bn5x;
    function $418987e551afe718$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("4tZah")).default)(element);
        var html = (0, (0, parcelRequire("fVbyj")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("9bn5x")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("3p4xw")).default)(element),
            y: y
        };
    }
});
parcelRegister("cUrUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96605d1e3b809cd4$export$2e2bcd8739ae039);
    var $fVbyj;
    var $ctZLK;
    var $3p4xw;
    var $dbYNm;
    var $asHtE;
    function $96605d1e3b809cd4$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("fVbyj")).default)(element);
        var winScroll = (0, (0, parcelRequire("dbYNm")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("asHtE")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("asHtE")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("3p4xw")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("ctZLK")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("asHtE")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("aMVvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7daafea4cdd8a599$export$2e2bcd8739ae039);
    var $49wse;
    function $7daafea4cdd8a599$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("49wse")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("agoTm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$778eb4fefa402e23$export$2e2bcd8739ae039);
    function $778eb4fefa402e23$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("4I7vH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36e118df3bac2bb9$export$2e2bcd8739ae039);
    var $1BXbW;
    function $36e118df3bac2bb9$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1BXbW")).default)(), paddingObject);
    }
});
parcelRegister("1BXbW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12c7296361f3b238$export$2e2bcd8739ae039);
    function $12c7296361f3b238$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("6DetQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d419e1810273975$export$2e2bcd8739ae039);
    function $4d419e1810273975$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("xYYSU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$066262bd906ca4b5$export$2e2bcd8739ae039);
    var $3VNj3;
    var $e2YFf;
    var $kb66N;
    var $j9mpk;
    function $066262bd906ca4b5$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("e2YFf")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("3VNj3")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("e2YFf")).variationPlacements) : (0, (0, parcelRequire("e2YFf")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("3VNj3")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("e2YFf")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kb66N")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("j9mpk")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("byg8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$868f647925e44d69$export$2e2bcd8739ae039);
    var $e2YFf;
    var $j9mpk;
    var $gbIja;
    var $g0eTI;
    var $2JB9F;
    var $hbezI;
    var $4Ae4p;
    var $kb66N;
    var $3VNj3;
    var $1BXbW;
    var $asHtE;
    function $868f647925e44d69$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kb66N")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(state.placement);
        var variation = (0, (0, parcelRequire("3VNj3")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("gbIja")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("g0eTI")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("e2YFf")).top) : (0, (0, parcelRequire("e2YFf")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("e2YFf")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("e2YFf")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("hbezI")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1BXbW")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("2JB9F")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("4Ae4p")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("2JB9F")).within)(tether ? (0, (0, parcelRequire("asHtE")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("asHtE")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("e2YFf")).top) : (0, (0, parcelRequire("e2YFf")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("e2YFf")).top),
                (0, (0, parcelRequire("e2YFf")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("2JB9F")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("2JB9F")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $868f647925e44d69$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $868f647925e44d69$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("g0eTI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba6833c805ad3c93$export$2e2bcd8739ae039);
    function $ba6833c805ad3c93$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("2JB9F", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$1fdc9aea7b0c4ec0$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$1fdc9aea7b0c4ec0$export$86c8af6d3ef0b4a);
    var $asHtE;
    function $1fdc9aea7b0c4ec0$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("asHtE")).max)(min, (0, (0, parcelRequire("asHtE")).min)(value, max));
    }
    function $1fdc9aea7b0c4ec0$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $1fdc9aea7b0c4ec0$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("9XETd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74095795cf93fc91$export$2e2bcd8739ae039);
    var $j9mpk;
    var $hbezI;
    var $aMVvs;
    var $4Ae4p;
    var $gbIja;
    var $2JB9F;
    var $4I7vH;
    var $6DetQ;
    var $e2YFf;
    var $74095795cf93fc91$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("4I7vH")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("6DetQ")).default)(padding, (0, (0, parcelRequire("e2YFf")).basePlacements)));
    };
    function $74095795cf93fc91$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(state.placement);
        var axis = (0, (0, parcelRequire("gbIja")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("e2YFf")).left),
            (0, (0, parcelRequire("e2YFf")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $74095795cf93fc91$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("hbezI")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("e2YFf")).top) : (0, (0, parcelRequire("e2YFf")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("4Ae4p")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("2JB9F")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $74095795cf93fc91$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("aMVvs")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $74095795cf93fc91$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $74095795cf93fc91$var$arrow,
        effect: $74095795cf93fc91$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("lRyJl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fea97cf55e1c5bdd$export$2e2bcd8739ae039);
    var $e2YFf;
    var $kb66N;
    function $fea97cf55e1c5bdd$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $fea97cf55e1c5bdd$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("e2YFf")).top),
            (0, (0, parcelRequire("e2YFf")).right),
            (0, (0, parcelRequire("e2YFf")).bottom),
            (0, (0, parcelRequire("e2YFf")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $fea97cf55e1c5bdd$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kb66N")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kb66N")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $fea97cf55e1c5bdd$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $fea97cf55e1c5bdd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $fea97cf55e1c5bdd$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $fea97cf55e1c5bdd$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $fea97cf55e1c5bdd$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $fea97cf55e1c5bdd$var$hide
    };
});
parcelRegister("lr9Km", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$f9b3ae1ae85fd5ed$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $2w28i;
    var $etveP;
    function $f9b3ae1ae85fd5ed$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("2w28i")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("etveP")).setRef)(innerRef, node);
            (0, (0, parcelRequire("etveP")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("etveP")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("etveP")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hhPK6", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$640395697d9647ea$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$640395697d9647ea$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$640395697d9647ea$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5Zz0F;
    var $2JKLA;
    var $bUQGL;
    var $AHUyh;
    function $640395697d9647ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $640395697d9647ea$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("bUQGL")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)}`})`
    });
    const $640395697d9647ea$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $640395697d9647ea$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $640395697d9647ea$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $640395697d9647ea$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $640395697d9647ea$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5Zz0F"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $640395697d9647ea$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $640395697d9647ea$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $640395697d9647ea$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $640395697d9647ea$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).Control, props));
    const $640395697d9647ea$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $640395697d9647ea$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).IndicatorSeparator, props);
    const $640395697d9647ea$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).ClearIndicator, props);
    const $640395697d9647ea$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).MultiValueRemove, props);
    const $640395697d9647ea$export$71abc632aa29e6fe = {
        Control: $640395697d9647ea$var$Control,
        DropdownIndicator: $640395697d9647ea$var$DropdownIndicator,
        Menu: $640395697d9647ea$var$Menu,
        IndicatorSeparator: $640395697d9647ea$var$IndicatorSeparator,
        ClearIndicator: $640395697d9647ea$var$ClearIndicator,
        MultiValueRemove: $640395697d9647ea$var$MultiValueRemove
    };
});
parcelRegister("5Zz0F", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $45cdce71504a0b34$var$_react = $45cdce71504a0b34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $45cdce71504a0b34$var$_search = $45cdce71504a0b34$var$_interopRequireDefault((parcelRequire("682zz")));
    var $45cdce71504a0b34$var$_search2 = $45cdce71504a0b34$var$_interopRequireDefault((parcelRequire("c6suK")));
    function $45cdce71504a0b34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $45cdce71504a0b34$var$SearchIcon = (props)=>$45cdce71504a0b34$var$_react.default.createElement($45cdce71504a0b34$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $45cdce71504a0b34$var$_search2.default
        }, props));
    $45cdce71504a0b34$var$SearchIcon.Name = 'SearchIconMigration';
    var $45cdce71504a0b34$var$_default = module.exports.default = $45cdce71504a0b34$var$SearchIcon;
});
parcelRegister("c6suK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8cfc261858871813$var$_react = $8cfc261858871813$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $8cfc261858871813$var$_search = $8cfc261858871813$var$_interopRequireDefault((parcelRequire("682zz")));
    function $8cfc261858871813$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8cfc261858871813$var$EditorSearchIcon = (props)=>$8cfc261858871813$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $8cfc261858871813$var$_search.default
        }));
    $8cfc261858871813$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $8cfc261858871813$var$_default = module.exports.default = $8cfc261858871813$var$EditorSearchIcon;
});
parcelRegister("7Nt7x", function(module, exports) {
    $parcel$export(module.exports, "batchByKey", ()=>$5eb8758a3defbae4$export$da86c38211c1c0a8);
    function $5eb8758a3defbae4$export$da86c38211c1c0a8(callback) {
        const calls = {};
        return (key, ...args)=>{
            if (!calls[key]) {
                window.setTimeout(()=>{
                    callback(key, calls[key]);
                    delete calls[key];
                });
                calls[key] = [];
            }
            calls[key].push(args);
        };
    }
});
parcelRegister("cOo9h", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d4710c3292c679b0$export$defe85febe8b728c);
    var $7VHMR;
    const $d4710c3292c679b0$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.elements.user-picker.placeholder',
            defaultMessage: 'Enter people or teams...',
            description: 'Placeholder description for empty user/team/email select field.'
        },
        addMore: {
            id: 'fabric.elements.user-picker.placeholder.add-more',
            defaultMessage: 'add more people...',
            description: 'Placeholder for multi user picker when the field is not empty.'
        },
        remove: {
            id: 'fabric.elements.user-picker.multi.remove-item',
            defaultMessage: 'Remove',
            description: 'Tooltip for the single item remove button in a multi user select field.'
        },
        clear: {
            id: 'fabric.elements.user-picker.single.clear',
            defaultMessage: 'Clear',
            description: 'Tooltip for clear button in the single user select field.'
        },
        errorMessage: {
            id: 'fabric.elements.user-picker.error.message',
            defaultMessage: 'Something went wrong',
            description: 'Error message to display when options fail to load.'
        },
        memberCountWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team when the current user is not a member of the team'
        },
        memberCountWithYou: {
            id: 'fabric.elements.user-picker.team.member.count.including.you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team when the current user is also a member of the team'
        },
        plus50MembersWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.50plus',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the number of members in the team when the number exceeds 50'
        },
        plus50MembersWithYou: {
            id: 'fabric.elements.user-picker.team.member.50plus.including.you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
        },
        addEmail: {
            id: 'fabric.elements.user-picker.email.add',
            defaultMessage: 'Add user',
            description: 'Byline for valid email option.'
        },
        selectToAddEmail: {
            id: 'fabric.elements.user-picker.email.select.to.add',
            defaultMessage: 'Select an email address',
            description: 'Byline for valid email option.'
        },
        continueToAddEmail: {
            id: 'fabric.elements.user-picker.email.add.potential',
            defaultMessage: 'Enter an email address',
            description: 'Byline for a potentially valid email option.'
        },
        groupByline: {
            id: 'fabric.elements.user-picker.group.byline',
            defaultMessage: 'Admin-managed group',
            description: 'Byline for admin-managed groups'
        },
        externalUserSourcesHeading: {
            id: 'fabric.elements.user-picker.external.sourced.from',
            defaultMessage: 'Found in:',
            description: 'From where the external user is coming'
        },
        externalUserSourcesError: {
            id: 'fabric.elements.user-picker.external.sourced.error',
            defaultMessage: "We can't connect you right now.",
            description: "Error message when we can't fetch a user's import sources"
        },
        slackProvider: {
            id: 'fabric.elements.user-picker.slack.provider',
            defaultMessage: 'Slack',
            description: 'This external user is sourced from Slack provider'
        },
        googleProvider: {
            id: 'fabric.elements.user-picker.google.provider',
            defaultMessage: 'Google',
            description: 'This external user is sourced from Google provider'
        },
        microsoftProvider: {
            id: 'fabric.elements.user-picker.microsoft.provider',
            defaultMessage: 'Microsoft',
            description: 'This external user is sourced from Microsoft provider'
        },
        gitHubProvider: {
            id: 'fabric.elements.user-picker.github.provider',
            defaultMessage: 'GitHub',
            description: 'This external user is sourced from GitHub provider'
        },
        jiraSource: {
            id: 'fabric.elements.user-picker.source.jira',
            defaultMessage: 'Jira',
            description: 'This external user is sourced from Jira'
        },
        confluenceSource: {
            id: 'fabric.elements.user-picker.source.confluence',
            defaultMessage: 'Confluence',
            description: 'This external user is sourced from Confluence'
        },
        otherAtlassianSource: {
            id: 'fabric.elements.user-picker.source.other-atlassian',
            defaultMessage: 'Other Atlassian products',
            description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
        },
        memberLozengeText: {
            id: 'fabric.elements.user-picker.member.lozenge.text',
            defaultMessage: 'MEMBER',
            description: 'Text within the Lozenge when the user is a workspace member'
        },
        guestLozengeText: {
            id: 'fabric.elements.user-picker.guest.lozenge.text',
            defaultMessage: 'GUEST',
            description: 'Text within the lozenge when the user is a guest of confluence'
        },
        guestUserLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
            defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
        },
        guestGroupLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
            defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
        }
    });
});
parcelRegister("cEoAI", function(module, exports) {
    $parcel$export(module.exports, "userPickerRenderedUfoExperience", ()=>$4f5537b55c971a4e$export$b49757166e1acfc2);
    $parcel$export(module.exports, "userPickerOptionsShownUfoExperience", ()=>$4f5537b55c971a4e$export$135a264e0da507ae);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$4f5537b55c971a4e$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $ghebK;
    var $aqOqs;
    var $96hPo;
    const $4f5537b55c971a4e$export$b49757166e1acfc2 = new (0, (0, parcelRequire("ghebK")).ConcurrentExperience)('user-picker-rendered', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("aqOqs")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $4f5537b55c971a4e$export$135a264e0da507ae = new (0, (0, parcelRequire("ghebK")).ConcurrentExperience)('user-picker-options-shown', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("aqOqs")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("aqOqs")).ExperiencePerformanceTypes).InlineResult
    });
    class $4f5537b55c971a4e$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            const instance = $4f5537b55c971a4e$export$b49757166e1acfc2.getInstance(this.props.id);
            if (instance.state.id !== (0, (0, parcelRequire("96hPo")).UFOExperienceState).FAILED.id) instance.failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("cpua2", function(module, exports) {
    $parcel$export(module.exports, "BORDER_PADDING", ()=>$773dad685127237a$export$59c188914e58c94b);
    $parcel$export(module.exports, "getStyles", ()=>$773dad685127237a$export$ffd58b7f6f099a57);
    $parcel$export(module.exports, "getPopupStyles", ()=>$773dad685127237a$export$4e983f376ad8a3af);
    var $8QpSo;
    var $crsHE;
    const $773dad685127237a$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
    const $773dad685127237a$export$53937c04f7dfc2ae = 6;
    const $773dad685127237a$export$2c62ba763e976c54 = 39;
    const $773dad685127237a$export$ffd58b7f6f099a57 = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, isCompact, overrideStyles, isInvalid)=>{
        let styles = {
            menu: (css, state)=>({
                    ...css,
                    width: width,
                    minWidth: state.selectProps.menuMinWidth,
                    zIndex: '400'
                }),
            menuList: (css)=>({
                    ...css,
                    zIndex: '400'
                }),
            control: (css, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    width: width,
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$7c87d337fb91a97d})`,
                    backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`,
                    '&:hover .fabric-user-picker__clear-indicator': {
                        opacity: 1
                    },
                    ':hover': {
                        ...css[':hover'],
                        borderColor: isInvalid ? `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$7c87d337fb91a97d})`,
                        backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $72ba03e317f3d228$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`
                    },
                    padding: 0,
                    minHeight: isCompact ? 'none' : 44,
                    height: isCompact || isMulti ? '100%' : 44,
                    maxWidth: '100%'
                };
            },
            clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                    ...css,
                    opacity: 1,
                    '@media (hover: hover) and (pointer: fine)': {
                        opacity: 0
                    },
                    transition: css.transition + ', opacity 150ms',
                    paddingTop: 0,
                    padding: 0,
                    ':hover': {
                        color: `var(--ds-icon-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`
                    }
                }),
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    gridTemplateColumns: 'auto 1fr',
                    paddingTop: isCompact ? 0 : $773dad685127237a$export$59c188914e58c94b,
                    paddingBottom: isCompact ? 0 : $773dad685127237a$export$59c188914e58c94b,
                    paddingLeft: isMulti ? $773dad685127237a$export$59c188914e58c94b : 0,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    maxHeight: state.selectProps.maxPickerHeight || '100%',
                    '::-webkit-scrollbar': {
                        width: 0,
                        background: 'transparent'
                    }
                };
            },
            multiValue: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'default'
                }),
            multiValueLabel: (css)=>({
                    ...css,
                    fontSize: '100%',
                    display: 'flex'
                }),
            multiValueRemove: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'pointer'
                }),
            placeholder: (css, state)=>{
                if (css.position === 'absolute' && !css.left) css.left = `${$773dad685127237a$export$59c188914e58c94b}px`;
                return {
                    ...css,
                    gridArea: '1/2/2/3',
                    paddingLeft: state.selectProps.isMulti ? 0 : $773dad685127237a$export$59c188914e58c94b,
                    margin: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                };
            },
            option: (css)=>({
                    ...css,
                    overflow: 'hidden'
                }),
            input: (css, state)=>({
                    ...css,
                    gridArea: '1/2/2/3',
                    gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                    margin: `${"var(--ds-space-050, 4px)"} 0`,
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: state.selectProps.isMulti ? 0 : $773dad685127237a$export$59c188914e58c94b,
                    '& input::placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$d6447c357493214f})`,
                        opacity: 1
                    },
                    '& input:-ms-input-placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$d6447c357493214f})`
                    }
                }),
            singleValue: (css)=>({
                    ...css,
                    margin: 0,
                    gridArea: '1/2/2/3'
                })
        };
        return overrideStyles ? (0, (0, parcelRequire("crsHE")).mergeStyles)(styles, overrideStyles) : styles;
    });
    const $773dad685127237a$export$4e983f376ad8a3af = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, overrideStyles)=>({
            ...$773dad685127237a$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
        }));
});
parcelRegister("3Qd9S", function(module, exports) {
    $parcel$export(module.exports, "getComponents", ()=>$5c7f8452b11899c3$export$4e811121b221213b);
    $parcel$export(module.exports, "getPopupComponents", ()=>$5c7f8452b11899c3$export$19205fd341a6bb08);
    var $8QpSo;
    var $cUrsP;
    var $jm6bH;
    var $fNjEJ;
    var $i3u4e;
    var $2ZMa6;
    var $7EQ4r;
    var $kZ4Mo;
    var $5bdQ2;
    var $c3ajP;
    var $9UZHD;
    const $5c7f8452b11899c3$export$4e811121b221213b = (0, (0, parcelRequire("8QpSo")).default)((multi, anchor)=>{
        if (anchor) return {
            Control: anchor,
            Option: (0, parcelRequire("i3u4e")).Option
        };
        else return {
            MultiValue: (0, parcelRequire("jm6bH")).MultiValue,
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("2ZMa6")).SingleValue,
            ClearIndicator: multi ? null : (0, (0, parcelRequire("cUrsP")).ClearIndicator),
            Option: (0, parcelRequire("i3u4e")).Option,
            ValueContainer: multi ? (0, (0, parcelRequire("fNjEJ")).MultiValueContainer) : (0, (0, parcelRequire("kZ4Mo")).SingleValueContainer),
            Input: (0, parcelRequire("7EQ4r")).Input,
            Menu: (0, parcelRequire("9UZHD")).Menu
        };
    });
    const $5c7f8452b11899c3$export$19205fd341a6bb08 = (0, (0, parcelRequire("8QpSo")).default)((hasPopupTitle)=>{
        const baseProps = {
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("2ZMa6")).SingleValue,
            ClearIndicator: (0, parcelRequire("cUrsP")).ClearIndicator,
            Option: (0, parcelRequire("i3u4e")).Option,
            ValueContainer: (0, (0, parcelRequire("kZ4Mo")).SingleValueContainer),
            Input: (0, (0, parcelRequire("5bdQ2")).PopupInput)
        };
        if (hasPopupTitle) return {
            ...baseProps,
            Control: (0, (0, parcelRequire("c3ajP")).PopupControl)
        };
        return baseProps;
    });
});
parcelRegister("cUrsP", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$f2321a52e091bbab$export$ecf9cf59142dd54a);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    const $f2321a52e091bbab$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("2sjgl")).then((module)=>{
            return {
                default: module.default
            };
        }));
    class $f2321a52e091bbab$export$ecf9cf59142dd54a extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
            const Indicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).ClearIndicator, {
                ...this.props,
                innerProps: {
                    ...this.props.innerProps,
                    onMouseDown: this.handleMouseDown
                }
            });
            return clearValueLabel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                fallback: Indicator
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($f2321a52e091bbab$var$AsyncTooltip, {
                content: clearValueLabel
            }, Indicator)) : Indicator;
        }
        constructor(...args){
            super(...args);
            this.handleMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                const { clearValue: clearValue, selectProps: selectProps } = this.props;
                clearValue();
                if (selectProps && !selectProps.isFocused) event.stopPropagation();
            };
        }
    }
});
parcelRegister("2sjgl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6F7dY").then(()=>parcelRequire('iEfb3'));
});
parcelRegister("jm6bH", function(module, exports) {
    $parcel$export(module.exports, "MultiValue", ()=>$c905129beceb8369$export$419cdf50db8b579);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $fm763;
    var $99gde;
    var $2JKLA;
    var $f8Sb3;
    var $llvxs;
    var $2NPcU;
    var $5NzgX;
    var $b0aMW;
    var $dT8VX;
    var $2oS3b;
    function $c905129beceb8369$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c905129beceb8369$export$118122ebc1e626fa = (valueContainer, control)=>{
        const { top: top, height: height } = valueContainer.getBoundingClientRect();
        const { height: controlHeight } = control.getBoundingClientRect();
        if (top - height < 0) valueContainer.scrollIntoView();
        if (top + height > controlHeight) valueContainer.scrollIntoView(false);
    };
    const $c905129beceb8369$var$groupTagContainer = (0, (0, parcelRequire("99gde")).xcss)({
        paddingLeft: 'space.025',
        marginTop: 'space.025'
    });
    const $c905129beceb8369$var$nameWrapper = {
        name: "6urmvo",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
    };
    class $c905129beceb8369$export$419cdf50db8b579 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.getElemBefore = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("5NzgX")).isEmail)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("llvxs")).AddOptionAvatar), {
                    isLozenge: true
                });
                if ((0, (0, parcelRequire("5NzgX")).isGroup)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                    xcss: $c905129beceb8369$var$groupTagContainer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("b0aMW"))))), {
                    LEGACY_margin: "-2px 0 0 0",
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "small"
                }));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NPcU")).SizeableAvatar), {
                    appearance: "multi",
                    src: (0, (0, parcelRequire("5NzgX")).getAvatarUrl)(data),
                    type: (0, (0, parcelRequire("5NzgX")).isTeam)(data) && (0, (0, parcelRequire("2oS3b")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
                });
            };
            this.getElemAfter = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("5NzgX")).isTeam)(data) && data.verified && (0, (0, parcelRequire("2oS3b")).fg)('verified-team-in-user-picker')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dT8VX")).VerifiedTeamIcon), {
                    size: "small"
                });
                return null;
            };
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
        }
        componentDidUpdate() {
            const { isFocused: isFocused } = this.props;
            if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $c905129beceb8369$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
        }
        shouldComponentUpdate(nextProps) {
            const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
            const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
            return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        }
        render() {
            const { children: children, innerProps: innerProps, ...rest } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).MultiValue, {
                ...rest,
                innerProps: {
                    ref: this.containerRef
                },
                cropWithEllipsis: false
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
                alignBlock: "center"
            }, this.getElemBefore(), " ", (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $c905129beceb8369$var$nameWrapper
            }, children), this.getElemAfter()));
        }
    }
});
parcelRegister("llvxs", function(module, exports) {
    $parcel$export(module.exports, "AddOptionAvatar", ()=>$029e144644a1c8c3$export$df396db45e491922);
    var $kebys;
    var $f8Sb3;
    parcelRequire("5uXOq");
    const $029e144644a1c8c3$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
        const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: padding,
            backgroundColor: `var(--ds-background-neutral, ${(0, $72ba03e317f3d228$export$1ce2d1575d444ceb)})`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            marginLeft: "var(--ds-space-025, 2px)"
        });
    };
    const $029e144644a1c8c3$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $029e144644a1c8c3$var$getEmailAvatarWrapperStyle(isLozenge)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("kebys"))))), {
            testId: "add-option-avatar-email-icon",
            label: label || '',
            LEGACY_size: isLozenge ? 'small' : 'medium',
            LEGACY_margin: "0 0 0 -2px",
            color: `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`
        })));
    };
});
parcelRegister("kebys", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb9e13fee8ce1dbd$var$_react = $eb9e13fee8ce1dbd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb9e13fee8ce1dbd$var$_email = $eb9e13fee8ce1dbd$var$_interopRequireDefault((parcelRequire("kvNTL")));
    var $eb9e13fee8ce1dbd$var$_email2 = $eb9e13fee8ce1dbd$var$_interopRequireDefault((parcelRequire("21B0p")));
    function $eb9e13fee8ce1dbd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb9e13fee8ce1dbd$var$EmailIcon = (props)=>$eb9e13fee8ce1dbd$var$_react.default.createElement($eb9e13fee8ce1dbd$var$_email.default, Object.assign({
            LEGACY_fallbackIcon: $eb9e13fee8ce1dbd$var$_email2.default
        }, props));
    $eb9e13fee8ce1dbd$var$EmailIcon.Name = 'EmailIconMigration';
    var $eb9e13fee8ce1dbd$var$_default = module.exports.default = $eb9e13fee8ce1dbd$var$EmailIcon;
});
parcelRegister("kvNTL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eeed68b1c1352d4e$var$_react = $eeed68b1c1352d4e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eeed68b1c1352d4e$var$_UNSAFE_baseNew = $eeed68b1c1352d4e$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $eeed68b1c1352d4e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eeed68b1c1352d4e$var$EmailIcon = (props)=>$eeed68b1c1352d4e$var$_react.default.createElement($eeed68b1c1352d4e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
        }, props));
    $eeed68b1c1352d4e$var$EmailIcon.displayName = 'EmailIcon';
    var $eeed68b1c1352d4e$var$_default = module.exports.default = $eeed68b1c1352d4e$var$EmailIcon;
});
parcelRegister("21B0p", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1798614c15f1ec1e$var$_react = $1798614c15f1ec1e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $1798614c15f1ec1e$var$_email = $1798614c15f1ec1e$var$_interopRequireDefault((parcelRequire("kvNTL")));
    function $1798614c15f1ec1e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1798614c15f1ec1e$var$EmailIcon = (props)=>$1798614c15f1ec1e$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
        }, props, {
            newIcon: $1798614c15f1ec1e$var$_email.default
        }));
    $1798614c15f1ec1e$var$EmailIcon.displayName = 'EmailIcon';
    var $1798614c15f1ec1e$var$_default = module.exports.default = $1798614c15f1ec1e$var$EmailIcon;
});
parcelRegister("2NPcU", function(module, exports) {
    $parcel$export(module.exports, "SizeableAvatar", ()=>$9eaee6b89c6ca8e1$export$44d81a88129649da);
    var $1IqIJ;
    var $gE9rB;
    var $5uXOq = parcelRequire("5uXOq");
    var $5NzgX;
    class $9eaee6b89c6ca8e1$export$44d81a88129649da extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
            const props = {
                size: (0, (0, parcelRequire("5NzgX")).getAvatarSize)(appearance),
                src: src,
                borderColor: 'transparent',
                presence: presence
            };
            return type === 'team' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gE9rB")).default), props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), props);
        }
    }
});
parcelRegister("gE9rB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f040700defc4d50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1IqIJ;
    var $6Xata;
    const $3f040700defc4d50$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`;
    const $3f040700defc4d50$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $72ba03e317f3d228$export$7c87d337fb91a97d)})`;
    function $3f040700defc4d50$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            appearance: "circle",
            ...props,
            size: size,
            src: src,
            testId: `${testId}-team-avatar`
        }, (innerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Xata")).TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                ...innerProps
            }));
    }
});
parcelRegister("6Xata", function(module, exports) {
    $parcel$export(module.exports, "TeamAvatarImage", ()=>$eff03942abcfbdec$export$ac3673635a5387be);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jTDAI;
    var $1lX2S;
    function $eff03942abcfbdec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $eff03942abcfbdec$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`;
    const $eff03942abcfbdec$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $72ba03e317f3d228$export$7c87d337fb91a97d)})`;
    const $eff03942abcfbdec$var$ICON_PADDING = 4;
    const $eff03942abcfbdec$var$avatarDefaultIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        backgroundColor: $eff03942abcfbdec$var$ICON_COLOR,
        borderRadius: '50%',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $eff03942abcfbdec$var$nestedAvatarStyles = Object.entries((0, (0, parcelRequire("jTDAI")).AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                width: `${size}px`,
                height: `${size}px`,
                '& svg': {
                    width: `${size - $eff03942abcfbdec$var$ICON_PADDING}px`,
                    height: `${size - $eff03942abcfbdec$var$ICON_PADDING}px`
                }
            })
        };
    }, {});
    const $eff03942abcfbdec$var$avatarImageStyles = {
        name: "n68006",
        styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
    };
    const $eff03942abcfbdec$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
        const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasImageErrored(false);
        }, [
            src
        ]);
        if (!src || hasImageErrored) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $eff03942abcfbdec$var$avatarDefaultIconStyles,
                $eff03942abcfbdec$var$nestedAvatarStyles[size]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("1lX2S"))))), {
            label: alt,
            primaryColor: $eff03942abcfbdec$var$ICON_BACKGROUND,
            secondaryColor: $eff03942abcfbdec$var$ICON_COLOR,
            testId: testId && `${testId}--team`
        }));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", rest, (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            src: src,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            css: $eff03942abcfbdec$var$avatarImageStyles,
            onError: ()=>setHasImageErrored(true)
        }));
    };
});
parcelRegister("1lX2S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0fc58dc5f42a2cd4$var$_react = $0fc58dc5f42a2cd4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $0fc58dc5f42a2cd4$var$_peopleGroup = $0fc58dc5f42a2cd4$var$_interopRequireDefault((parcelRequire("7uWFl")));
    function $0fc58dc5f42a2cd4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0fc58dc5f42a2cd4$var$PeopleIcon = (props)=>$0fc58dc5f42a2cd4$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
        }, props, {
            newIcon: $0fc58dc5f42a2cd4$var$_peopleGroup.default
        }));
    $0fc58dc5f42a2cd4$var$PeopleIcon.displayName = 'PeopleIcon';
    var $0fc58dc5f42a2cd4$var$_default = module.exports.default = $0fc58dc5f42a2cd4$var$PeopleIcon;
});
parcelRegister("b0aMW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $802810212b97e9e3$var$_react = $802810212b97e9e3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $802810212b97e9e3$var$_peopleGroup = $802810212b97e9e3$var$_interopRequireDefault((parcelRequire("7uWFl")));
    var $802810212b97e9e3$var$_people = $802810212b97e9e3$var$_interopRequireDefault((parcelRequire("1lX2S")));
    function $802810212b97e9e3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $802810212b97e9e3$var$PeopleGroupIcon = (props)=>$802810212b97e9e3$var$_react.default.createElement($802810212b97e9e3$var$_peopleGroup.default, Object.assign({
            LEGACY_fallbackIcon: $802810212b97e9e3$var$_people.default
        }, props));
    $802810212b97e9e3$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
    var $802810212b97e9e3$var$_default = module.exports.default = $802810212b97e9e3$var$PeopleGroupIcon;
});
parcelRegister("dT8VX", function(module, exports) {
    $parcel$export(module.exports, "VerifiedTeamIcon", ()=>$ccb439c652debdbf$export$d7949f68d31e5edd);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wNB1;
    const $ccb439c652debdbf$export$d7949f68d31e5edd = ({ size: size, label: label = 'Verified Team' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wNB1")).default), {
            primaryColor: "var(--ds-icon-accent-blue, #1D7AFC)",
            size: size,
            label: label
        });
});
parcelRegister("1wNB1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f904127342027377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1h2s1;
    const $f904127342027377$var$VerifiedIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        }));
    const $f904127342027377$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1h2s1")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $f904127342027377$var$VerifiedIconGlyph
        });
    var $f904127342027377$export$2e2bcd8739ae039 = $f904127342027377$var$VerifiedIcon;
});
parcelRegister("fNjEJ", function(module, exports) {
    $parcel$export(module.exports, "MultiValueContainer", ()=>$a38b34c6ad217225$export$cf9cf2a30a59265c);
    var $2JKLA;
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $ousew;
    var $cOo9h;
    var $5NzgX;
    var $5cb8l;
    class $a38b34c6ad217225$export$cf9cf2a30a59265c extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static getDerivedStateFromProps(nextProps, prevState) {
            return {
                valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
                previousValueSize: prevState.valueSize
            };
        }
        constructor(props){
            super(props);
            this.timeoutId = null;
            this.scrollToBottom = ()=>{
                this.timeoutId = window.setTimeout(()=>{
                    const { ref: { current: current } } = this.valueContainerInnerProps;
                    if (current !== null) {
                        const container = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(current);
                        if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                    }
                    this.timeoutId = null;
                });
            };
            this.showPlaceholder = ()=>{
                const { selectProps: { value: value } } = this.props;
                return value && value.length > 0;
            };
            this.addPlaceholder = (placeholder)=>{
                const children = (0, ($parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, (0, parcelRequire("5NzgX")).isChildInput)(child) && this.showPlaceholder() ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        placeholder: placeholder
                    }) : child);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children);
            };
            this.renderChildren = ()=>{
                const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
                if (isDisabled) return this.props.children;
                if (addMoreMessage === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("cOo9h")).messages).addMore, (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                });
                return this.addPlaceholder(addMoreMessage);
            };
            this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
            this.state = {
                valueSize: 0,
                previousValueSize: 0
            };
            this.valueContainerInnerProps = {
                ref: (0, ($parcel$interopDefault($5uXOq))).createRef()
            };
        }
        componentDidUpdate() {
            const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
            const { isFocused: isFocused } = this.props.selectProps;
            if (valueSize > previousValueSize && isFocused) {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.scrollToBottom();
            }
        }
        componentWillUnmount() {
            if (this.timeoutId) window.clearTimeout(this.timeoutId);
        }
        render() {
            const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
            const props = {
                ...valueContainerProps,
                innerProps: this.valueContainerInnerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5cb8l")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).ValueContainer, props, this.renderChildren()));
        }
    }
});
parcelRegister("5cb8l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a675a6728681e2ec$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $a675a6728681e2ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $a675a6728681e2ec$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    const $a675a6728681e2ec$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
        return isEnabled ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $a675a6728681e2ec$var$_ref,
            onMouseDown: onMouseDown
        }, children) : children;
    };
    var $a675a6728681e2ec$export$2e2bcd8739ae039 = $a675a6728681e2ec$var$ValueContainerWrapper;
});
parcelRegister("i3u4e", function(module, exports) {
    $parcel$export(module.exports, "Option", ()=>$bf01048f6562bb32$export$36d18380658d5d20);
    var $6Ll2T;
    var $2JKLA;
    var $loZC0;
    var $5uXOq = parcelRequire("5uXOq");
    var $k1btt;
    var $dACFp;
    var $icj6S;
    var $khxpf;
    var $lUjbX;
    var $hXeHB;
    var $5NzgX;
    var $fWMUO;
    const $bf01048f6562bb32$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1btt")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
    const $bf01048f6562bb32$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
        if ((0, (0, parcelRequire("5NzgX")).isExternalUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dACFp")).default), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("5NzgX")).isUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k1btt")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("5NzgX")).isEmail)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lUjbX")).default), {
            email: data,
            emailValidity: (0, (0, parcelRequire("fWMUO")).isValidEmail)(data.id),
            isSelected: isSelected,
            label: selectProps.emailLabel
        });
        if ((0, (0, parcelRequire("5NzgX")).isTeam)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("icj6S")).default), {
            team: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("5NzgX")).isGroup)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("khxpf")).default), {
            group: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("5NzgX")).isCustom)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hXeHB")).default), {
            data: data,
            isSelected: isSelected
        });
        return null;
    };
    const $bf01048f6562bb32$var$dataOptionWithTooltip = (props)=>{
        if (props.data?.data?.tooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: props.data?.data?.tooltip
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), tooltipProps, $bf01048f6562bb32$var$dataOption(props)));
        return $bf01048f6562bb32$var$dataOption(props);
    };
    const $bf01048f6562bb32$export$36d18380658d5d20 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $bf01048f6562bb32$var$defaultOption(props)
        }, $bf01048f6562bb32$var$dataOptionWithTooltip(props)));
});
parcelRegister("k1btt", function(module, exports) {
    $parcel$export(module.exports, "UserOption", ()=>$874c8ad895cb27e7$export$8e59f78010871662);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $6wiqn;
    var $8IsWD;
    var $2NPcU;
    var $5NzgX;
    class $874c8ad895cb27e7$export$8e59f78010871662 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6wiqn")).AvatarItemOption), {
                avatar: this.renderAvatar(),
                lozenge: this.getLozengeProps(),
                isDisabled: this.props.user.isDisabled,
                primaryText: this.getPrimaryText(),
                secondaryText: this.renderSecondaryText()
            });
        }
        constructor(...args){
            super(...args);
            this.getPrimaryText = ()=>{
                const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
                const result = [
                    (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                        key: "name",
                        css: (0, (0, parcelRequire("6wiqn")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $72ba03e317f3d228$export$7d61b15e0da132af})`)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8IsWD")).HighlightText), {
                        highlights: highlight && highlight.name
                    }, name))
                ];
                if ((0, (0, parcelRequire("5NzgX")).hasValue)(publicName) && name.trim() !== publicName.trim()) result.push((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                    key: "publicName"
                }, ' ', (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("6wiqn")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`)
                }, "(", (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8IsWD")).HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
                return result;
            };
            this.renderSecondaryText = ()=>this.props.user.byline ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("6wiqn")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`)
                }, this.props.user.byline) : undefined;
            this.renderAvatar = ()=>{
                const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NPcU")).SizeableAvatar), {
                    appearance: "big",
                    src: avatarUrl,
                    presence: status
                });
            };
            this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                    text: this.props.user.lozenge
                } : this.props.user.lozenge;
        }
    }
});
parcelRegister("6wiqn", function(module, exports) {
    $parcel$export(module.exports, "textWrapper", ()=>$5750889d30cb4685$export$aa6223da92b253dd);
    $parcel$export(module.exports, "AvatarItemOption", ()=>$5750889d30cb4685$export$164a9d9b3b86dd0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8ptrG;
    var $5NzgX;
    function $5750889d30cb4685$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5750889d30cb4685$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("2sjgl")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $5750889d30cb4685$var$wrapper = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            lineHeight: 1,
            outline: 'none',
            margin: 0,
            width: '100%',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
        });
    const $5750889d30cb4685$var$optionWrapper = {
        name: "yyrqoa",
        styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
    };
    const $5750889d30cb4685$var$getTextStyle = (isSecondary)=>{
        const secondaryCssArgs = isSecondary ? {
            fontSize: '0.85em'
        } : {};
        return (0, (0, parcelRequire("f8Sb3")).css)({
            margin: 0,
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...secondaryCssArgs
        });
    };
    const $5750889d30cb4685$var$additionalInfo = {
        name: "tjo4qw",
        styles: "float:right"
    };
    const $5750889d30cb4685$export$aa6223da92b253dd = (color)=>(0, (0, parcelRequire("f8Sb3")).css)({
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline',
            color: color
        });
    const $5750889d30cb4685$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
        const renderLozenge = ()=>{
            if ((0, (0, parcelRequire("5NzgX")).isLozengeText)(lozenge)) {
                if (lozenge?.tooltip) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                    fallback: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8ptrG")).default), lozenge, lozenge.text)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($5750889d30cb4685$var$AsyncTooltip, {
                    content: lozenge.tooltip
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8ptrG")).default), lozenge, lozenge.text)));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8ptrG")).default), lozenge, lozenge.text);
            }
            return lozenge;
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5750889d30cb4685$var$wrapper(isDisabled)
        }, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $5750889d30cb4685$var$optionWrapper
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $5750889d30cb4685$var$getTextStyle()
        }, primaryText), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $5750889d30cb4685$var$getTextStyle(true)
        }, secondaryText))), lozenge && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $5750889d30cb4685$var$additionalInfo
        }, renderLozenge())));
    };
});
parcelRegister("8IsWD", function(module, exports) {
    $parcel$export(module.exports, "HighlightText", ()=>$59c63edee9b23854$export$bb02e7bc6e1a7119);
    var $5uXOq = parcelRequire("5uXOq");
    class $59c63edee9b23854$export$bb02e7bc6e1a7119 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { children: children, highlights: highlights } = this.props;
            const parts = [];
            let lastIndex = 0;
            if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
                const lastHighlight = highlights[highlights.length - 1];
                if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
                if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
                return highlights;
            }, []).forEach((highlight)=>{
                const { start: start, end: end } = highlight;
                if (start >= end) return;
                if (start > lastIndex) parts.push({
                    value: children.substring(lastIndex, start),
                    matches: false
                });
                parts.push({
                    value: children.substring(start, end + 1),
                    matches: true
                });
                lastIndex = end + 1;
            });
            if (lastIndex < children.length) parts.push({
                value: children.substring(lastIndex, children.length),
                matches: false
            });
            return parts.map((part, index)=>{
                if (part.matches) return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: index
                }, part.value);
                return part.value;
            });
        }
    }
});
parcelRegister("dACFp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73597574ed37b845$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $73597574ed37b845$var$AsyncExternalUserOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7kTCs")).then((module)=>{
            return {
                default: module.ExternalUserOption
            };
        }));
    var $73597574ed37b845$export$2e2bcd8739ae039 = $73597574ed37b845$var$AsyncExternalUserOption;
});
parcelRegister("7kTCs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9yn7S")
    ]).then(()=>parcelRequire('6uPVq'));
});
parcelRegister("icj6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5cf854e3ae8ae88$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $c5cf854e3ae8ae88$var$AsyncTeamOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("fV3l0")).then((module)=>{
            return {
                default: module.TeamOption
            };
        }));
    var $c5cf854e3ae8ae88$export$2e2bcd8739ae039 = $c5cf854e3ae8ae88$var$AsyncTeamOption;
});
parcelRegister("fV3l0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jqbbZ").then(()=>parcelRequire('eUpgg'));
});
parcelRegister("khxpf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c78f3f1f2f2ca918$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $c78f3f1f2f2ca918$var$AsyncGroupOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("hiz2R")).then((module)=>{
            return {
                default: module.GroupOption
            };
        }));
    var $c78f3f1f2f2ca918$export$2e2bcd8739ae039 = $c78f3f1f2f2ca918$var$AsyncGroupOption;
});
parcelRegister("hiz2R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1xRTP").then(()=>parcelRequire('4BOwL'));
});
parcelRegister("lUjbX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26ce4d920089c54e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $26ce4d920089c54e$var$AsyncEmailOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("godVi")).then((module)=>{
            return {
                default: module.EmailOption
            };
        }));
    var $26ce4d920089c54e$export$2e2bcd8739ae039 = $26ce4d920089c54e$var$AsyncEmailOption;
});
parcelRegister("godVi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6rohZ").then(()=>parcelRequire('3lAoR'));
});
parcelRegister("hXeHB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bfda6b507e28fff4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $bfda6b507e28fff4$var$AsyncCustomOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("7z22Q")).then((module)=>{
            return {
                default: module.CustomOption
            };
        }));
    var $bfda6b507e28fff4$export$2e2bcd8739ae039 = $bfda6b507e28fff4$var$AsyncCustomOption;
});
parcelRegister("7z22Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hBZat").then(()=>parcelRequire('aufcj'));
});
parcelRegister("fWMUO", function(module, exports) {
    $parcel$export(module.exports, "isValidEmail", ()=>$dbd0574d859f7cba$export$371e338370561054);
    const $dbd0574d859f7cba$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const $dbd0574d859f7cba$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
    const $dbd0574d859f7cba$export$371e338370561054 = (inputText)=>{
        if (inputText.match($dbd0574d859f7cba$var$validRegex)) return 'VALID';
        if (inputText.match($dbd0574d859f7cba$var$potentialRegex)) return 'POTENTIAL';
        return 'INVALID';
    };
});
parcelRegister("2ZMa6", function(module, exports) {
    $parcel$export(module.exports, "SingleValue", ()=>$6eb32a502aac58b6$export$1949dac661ba6e3a);
    var $57wiv;
    var $f8Sb3;
    var $2JKLA;
    var $2NPcU;
    var $5NzgX;
    var $dT8VX;
    var $2oS3b;
    var $fm763;
    const $6eb32a502aac58b6$var$avatarItemComponent = (0, (0, parcelRequire("f8Sb3")).css)({
        border: 'none !important',
        padding: `${"var(--ds-space-0, 0px)"} !important`,
        width: 'auto',
        overflow: 'hidden',
        minWidth: '100px',
        '& > span': {
            boxSizing: 'border-box'
        },
        '&:hover': {
            width: 'auto',
            padding: 0,
            border: 'none'
        }
    });
    const $6eb32a502aac58b6$var$ElementAfter = (props)=>{
        const { data: { data: data } } = props;
        if ((0, (0, parcelRequire("5NzgX")).isTeam)(data) && data.verified) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dT8VX")).VerifiedTeamIcon), {
            size: "small"
        });
        return null;
    };
    const $6eb32a502aac58b6$export$1949dac661ba6e3a = (props)=>{
        const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
        return !isFocused ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).SingleValue, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("57wiv")).default), {
            backgroundColor: "transparent",
            avatar: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NPcU")).SizeableAvatar), {
                src: (0, (0, parcelRequire("5NzgX")).getAvatarUrl)(data),
                appearance: appearance,
                type: (0, (0, parcelRequire("5NzgX")).isTeam)(data) && (0, (0, parcelRequire("2oS3b")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
            }),
            primaryText: (0, (0, parcelRequire("2oS3b")).fg)('verified-team-in-user-picker') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
                alignBlock: "center"
            }, label, (0, (0, parcelRequire("f8Sb3")).jsx)($6eb32a502aac58b6$var$ElementAfter, props)) : label
        }, ({ ref: ref, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $6eb32a502aac58b6$var$avatarItemComponent,
                ...props
            }))) : null;
    };
});
parcelRegister("57wiv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b8c1cb9f146b324$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2oS3b;
    var $ZuPvl;
    var $bUQGL;
    var $jTDAI;
    var $eaHPZ;
    function $2b8c1cb9f146b324$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2b8c1cb9f146b324$var$avatarItemStyles = {
        name: "1dq1lfl",
        styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
    };
    const $2b8c1cb9f146b324$var$secondaryTextOldStyles = {
        name: "1udad45",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
    };
    const $2b8c1cb9f146b324$var$baseTextStyles = {
        name: "1sodx6b",
        styles: "display:block;color:var(--ds-text, #172B4D)"
    };
    const $2b8c1cb9f146b324$var$truncationStyles = {
        name: "n3ut7m",
        styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $2b8c1cb9f146b324$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, (0, parcelRequire("bUQGL")).borderRadius)()}px;
		border: ${0, (0, parcelRequire("jTDAI")).BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
    const $2b8c1cb9f146b324$var$AvatarItem = (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
        const getTestId = (testId, children)=>!children ? {
                'data-testid': `${testId}--itemInner`
            } : {
                testId: `${testId}--itemInner`
            };
        const componentProps = ()=>{
            if (isDisabled) return {
                disabled: true
            };
            return {
                ...href && (0, (0, parcelRequire("eaHPZ")).getLinkProps)(href, target),
                ...onClick && !href ? (0, (0, parcelRequire("eaHPZ")).getButtonProps)(onClick) : {
                    onClick: onClick
                }
            };
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>{
            const props = {
                ref: ref,
                className: $2b8c1cb9f146b324$var$getStyles(css, {
                    backgroundColor: backgroundColor,
                    isInteractive: Boolean(onClick || href),
                    isDisabled: isDisabled
                }),
                ...componentProps(),
                ...testId && getTestId(testId, children),
                ...(onClick || href) && {
                    'aria-label': label
                },
                children: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $2b8c1cb9f146b324$var$avatarItemStyles
                }, (0, (0, parcelRequire("2oS3b")).fg)('platform.design-system-team.avatar-item-font-size_830x6') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
                    maxLines: isTruncationDisabled ? undefined : 1
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
                    color: "color.text.subtlest",
                    maxLines: isTruncationDisabled ? undefined : 1,
                    size: "UNSAFE_small"
                }, secondaryText)) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $2b8c1cb9f146b324$var$baseTextStyles,
                        !isTruncationDisabled && $2b8c1cb9f146b324$var$truncationStyles
                    ]
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $2b8c1cb9f146b324$var$baseTextStyles,
                        $2b8c1cb9f146b324$var$secondaryTextOldStyles,
                        !isTruncationDisabled && $2b8c1cb9f146b324$var$truncationStyles
                    ]
                }, secondaryText))))
            };
            return children ? children(props) : (0, $5uXOq.createElement)((0, (0, parcelRequire("eaHPZ")).getCustomElement)(isDisabled, href, onClick), props);
        });
    });
    $2b8c1cb9f146b324$var$AvatarItem.displayName = 'AvatarItem';
    var $2b8c1cb9f146b324$export$2e2bcd8739ae039 = $2b8c1cb9f146b324$var$AvatarItem;
});
parcelRegister("7EQ4r", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$c3dd7e0b47a8eb2a$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    class $c3dd7e0b47a8eb2a$export$f5b8910cec6cf069 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        get ariaLabelledBy() {
            return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
        }
        get ariaDescribedBy() {
            return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Input, {
                ...this.props,
                "aria-labelledby": this.ariaLabelledBy,
                "aria-describedby": this.ariaDescribedBy,
                innerRef: this.props.innerRef,
                onKeyPress: this.handleKeyPress
            });
        }
        constructor(...args){
            super(...args);
            this.handleKeyPress = (e)=>{
                if (e.key === 'Enter') e.preventDefault();
                if (this.props.selectProps?.disableInput) e.preventDefault();
            };
        }
    }
});
parcelRegister("kZ4Mo", function(module, exports) {
    $parcel$export(module.exports, "SingleValueContainer", ()=>$14887044253c726c$export$afa5f855316c6a48);
    var $2JKLA;
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $2NPcU;
    var $cpua2;
    var $5cb8l;
    function $14887044253c726c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $14887044253c726c$var$placeholderIconContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: (0, (0, parcelRequire("cpua2")).BORDER_PADDING),
        lineHeight: 0,
        gridArea: '1/1/2/2'
    });
    const $14887044253c726c$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
    var $14887044253c726c$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    class $14887044253c726c$export$afa5f855316c6a48 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, ...valueContainerProps } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5cb8l")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).ValueContainer, valueContainerProps, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $14887044253c726c$var$placeholderIconContainer
            }, this.renderAvatar()), children));
        }
        constructor(...args){
            super(...args);
            this.renderAvatar = ()=>{
                const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
                if (isFocused || !hasValue) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NPcU")).SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: $14887044253c726c$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
                });
                return null;
            };
            this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
            this.Wrapper = ({ children: children })=>{
                return this.onValueContainerClick ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $14887044253c726c$var$_ref,
                    onMouseDown: this.onValueContainerClick
                }, children) : children;
            };
        }
    }
});
parcelRegister("5bdQ2", function(module, exports) {
    $parcel$export(module.exports, "PopupInput", ()=>$0dc2021705121c97$export$d8edbfd510a7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $7EQ4r;
    class $0dc2021705121c97$export$d8edbfd510a7db82 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            if (this.ref) this.ref.select();
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7EQ4r")).Input), {
                ...this.props,
                innerRef: this.handleInnerRef
            });
        }
        constructor(...args){
            super(...args);
            this.ref = null;
            this.handleInnerRef = (ref)=>{
                this.ref = ref;
                if (this.props.innerRef) this.props.innerRef(ref);
            };
        }
    }
});
parcelRegister("c3ajP", function(module, exports) {
    $parcel$export(module.exports, "PopupControl", ()=>$6ffa96e6871f1d83$export$a0cb1b4352357fcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    var $f8Sb3;
    const $6ffa96e6871f1d83$var$spacing = 8;
    const $6ffa96e6871f1d83$var$fontSize = 12;
    const $6ffa96e6871f1d83$var$innerHeight = $6ffa96e6871f1d83$var$spacing * 2;
    const $6ffa96e6871f1d83$var$lineHeight = $6ffa96e6871f1d83$var$innerHeight / $6ffa96e6871f1d83$var$fontSize;
    const $6ffa96e6871f1d83$var$controlWrapper = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexDirection: 'column',
        padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    });
    const $6ffa96e6871f1d83$var$getLabelStyle = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$f563ee71e9ee74cd)})`,
            fontSize: `${$6ffa96e6871f1d83$var$fontSize}px`,
            fontWeight: 600,
            lineHeight: `${$6ffa96e6871f1d83$var$lineHeight}`,
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-0, 0px)",
            paddingRight: "var(--ds-space-0, 0px)",
            paddingTop: "var(--ds-space-250, 20px)"
        });
    class $6ffa96e6871f1d83$export$a0cb1b4352357fcc extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { popupTitle: popupTitle } } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $6ffa96e6871f1d83$var$controlWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $6ffa96e6871f1d83$var$getLabelStyle()
            }, popupTitle), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).Control, this.props));
        }
    }
});
parcelRegister("9UZHD", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$7bb94e0e11e9342d$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    var $f8Sb3;
    const $7bb94e0e11e9342d$var$getFooterStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
        });
    };
    class $7bb94e0e11e9342d$export$d9b273488cd8ce6f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $7bb94e0e11e9342d$var$getFooterStyle()
            }, this.props.selectProps.footer));
        }
    }
});
parcelRegister("iPQR2", function(module, exports) {
    $parcel$export(module.exports, "getCreatableProps", ()=>$eb29ae6c713d7577$export$36f97d8afa97203d);
    var $8QpSo;
    var $fWMUO;
    var $5NzgX;
    const $eb29ae6c713d7577$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $eb29ae6c713d7577$var$isValidNewOption = (isValidEmail = (0, (0, parcelRequire("fWMUO")).isValidEmail))=>(inputValue)=>inputValue && $eb29ae6c713d7577$var$validOption.includes(isValidEmail(inputValue));
    const $eb29ae6c713d7577$var$getNewOptionData = (inputValue)=>({
            label: inputValue,
            value: inputValue,
            data: {
                id: inputValue,
                name: inputValue,
                type: (0, $deda2b1ce401799e$export$6662b3461398ef8c)
            }
        });
    const $eb29ae6c713d7577$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $eb29ae6c713d7577$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("fWMUO")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("5NzgX")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    function $eb29ae6c713d7577$var$creatableProps(isValidEmail) {
        return {
            allowCreateWhileLoading: true,
            createOptionPosition: 'first',
            isValidNewOption: $eb29ae6c713d7577$var$isValidNewOption(isValidEmail),
            getNewOptionData: $eb29ae6c713d7577$var$getNewOptionData,
            formatCreateLabel: $eb29ae6c713d7577$var$formatCreateLabel,
            isOptionDisabled: $eb29ae6c713d7577$var$isOptionDisabled(isValidEmail)
        };
    }
    const $eb29ae6c713d7577$export$36f97d8afa97203d = (0, (0, parcelRequire("8QpSo")).default)($eb29ae6c713d7577$var$creatableProps);
});
parcelRegister("kkSH2", function(module, exports) {
    $parcel$export(module.exports, "getCreatableSuggestedEmailProps", ()=>$9bfece4c41d24fec$export$34b9dd2dd6a225e5);
    var $8QpSo;
    var $fWMUO;
    var $5NzgX;
    const $9bfece4c41d24fec$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $9bfece4c41d24fec$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
    const $9bfece4c41d24fec$var$getNewOptionData = (isValidEmail = (0, (0, parcelRequire("fWMUO")).isValidEmail), emailDomain)=>(inputValue)=>{
            if (!inputValue) return null;
            const isEmail = inputValue && $9bfece4c41d24fec$var$validOption.includes(isValidEmail(inputValue));
            const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
            return {
                label: value,
                value: value,
                data: {
                    id: value,
                    name: value,
                    type: (0, $deda2b1ce401799e$export$6662b3461398ef8c),
                    suggestion: true
                }
            };
        };
    const $9bfece4c41d24fec$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $9bfece4c41d24fec$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("fWMUO")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("5NzgX")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    const $9bfece4c41d24fec$export$34b9dd2dd6a225e5 = (0, (0, parcelRequire("8QpSo")).default)((emailDomain, isValidEmail)=>({
            allowCreateWhileLoading: true,
            createOptionPosition: 'last',
            isValidNewOption: $9bfece4c41d24fec$var$isValidNewOption,
            getNewOptionData: $9bfece4c41d24fec$var$getNewOptionData(isValidEmail, emailDomain),
            formatCreateLabel: $9bfece4c41d24fec$var$formatCreateLabel,
            isOptionDisabled: $9bfece4c41d24fec$var$isOptionDisabled(isValidEmail)
        }));
});
parcelRegister("l3nuY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d76ab568ec662345$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $3GpEQ;
    const $d76ab568ec662345$var$EMPTY = {};
    const $d76ab568ec662345$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($d76ab568ec662345$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($d76ab568ec662345$var$EMPTY);
            (0, (0, parcelRequire("3GpEQ")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $d76ab568ec662345$var$MessagesIntlProvider = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children } = props;
        const messages = $d76ab568ec662345$var$useI18n(intl.locale);
        const mergedMessages = (0, $5uXOq.useMemo)(()=>{
            return {
                ...intl.messages,
                ...messages
            };
        }, [
            intl.messages,
            messages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
    };
    var $d76ab568ec662345$export$2e2bcd8739ae039 = $d76ab568ec662345$var$MessagesIntlProvider;
});
parcelRegister("3GpEQ", function(module, exports) {
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$3cb0279c1e2105d6$export$d0a3169680473b6c);
    const $3cb0279c1e2105d6$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("1msbz")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("jVs6v")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("5IxjG")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("4uTrf")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("ct3Uc")).then((mod)=>mod.default);
            case 'en_ZZ':
                return (parcelRequire("i6uxl")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("bJKg4")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("jNAlg")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("ht7Nz")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("6Cq8a")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("6rMaw")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("g6w5q")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("5oukK")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("boBx2")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("lPbo5")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("fCfBt")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("knjo9")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("4iGH8")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("1P8Fd")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("bIT1e")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("7ryvT")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("6eXzx")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("5D1fA")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("44I1h")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("3oJLd")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("7uc62")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("h1DeU")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("hpnkf")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("fsK8S")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("gV7yb")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $3cb0279c1e2105d6$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("4uTrf")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("1msbz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kJN0G").then(()=>parcelRequire('6Pclx'));
});
parcelRegister("jVs6v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ewqt2").then(()=>parcelRequire('bdwUT'));
});
parcelRegister("5IxjG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eilf5").then(()=>parcelRequire('27Zk0'));
});
parcelRegister("4uTrf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("23HL0").then(()=>parcelRequire('2fMyI'));
});
parcelRegister("ct3Uc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("607YV").then(()=>parcelRequire('avn4w'));
});
parcelRegister("i6uxl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ipdqG").then(()=>parcelRequire('k3Iub'));
});
parcelRegister("bJKg4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3wM6s").then(()=>parcelRequire('aRTt7'));
});
parcelRegister("jNAlg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7tC3b").then(()=>parcelRequire('lXWX2'));
});
parcelRegister("ht7Nz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gK54l").then(()=>parcelRequire('3auH4'));
});
parcelRegister("6Cq8a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7G7m0").then(()=>parcelRequire('cR17J'));
});
parcelRegister("6rMaw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fBxPH").then(()=>parcelRequire('iia9X'));
});
parcelRegister("g6w5q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4SkG1").then(()=>parcelRequire('lQ49T'));
});
parcelRegister("5oukK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6PIof").then(()=>parcelRequire('jVWun'));
});
parcelRegister("boBx2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aCZNn").then(()=>parcelRequire('bO7JH'));
});
parcelRegister("lPbo5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jat64").then(()=>parcelRequire('kFwwe'));
});
parcelRegister("fCfBt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2JohC").then(()=>parcelRequire('abbtc'));
});
parcelRegister("knjo9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5QyXa").then(()=>parcelRequire('hD0lk'));
});
parcelRegister("4iGH8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l7E8e").then(()=>parcelRequire('3eX6o'));
});
parcelRegister("1P8Fd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hGzUK").then(()=>parcelRequire('iCmIo'));
});
parcelRegister("bIT1e", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aPN9D").then(()=>parcelRequire('24UK4'));
});
parcelRegister("7ryvT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h8luh").then(()=>parcelRequire('49LMe'));
});
parcelRegister("6eXzx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lRJbz").then(()=>parcelRequire('3skpp'));
});
parcelRegister("5D1fA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lokka").then(()=>parcelRequire('b0773'));
});
parcelRegister("44I1h", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cKvXn").then(()=>parcelRequire('bITUs'));
});
parcelRegister("3oJLd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f3HiU").then(()=>parcelRequire('FKBFH'));
});
parcelRegister("7uc62", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lWOQl").then(()=>parcelRequire('6qrYr'));
});
parcelRegister("h1DeU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("afyfr").then(()=>parcelRequire('3dCO0'));
});
parcelRegister("hpnkf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d0TJn").then(()=>parcelRequire('80CgP'));
});
parcelRegister("fsK8S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("idjEm").then(()=>parcelRequire('emkzL'));
});
parcelRegister("gV7yb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Z8xZ").then(()=>parcelRequire('8y92w'));
});
parcelRegister("kYAL2", function(module, exports) {
    $parcel$export(module.exports, "ExusUserSourceProvider", ()=>$03c54134dca7e94c$export$bcd5c65b586ee3c3);
    $parcel$export(module.exports, "useUserSource", ()=>$03c54134dca7e94c$export$c6c0c1a2bac363f);
    var $5uXOq = parcelRequire("5uXOq");
    const $03c54134dca7e94c$var$ExusUserSourceContext = (0, $5uXOq.createContext)({});
    const $03c54134dca7e94c$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($03c54134dca7e94c$var$ExusUserSourceContext.Provider, {
            value: {
                fetchUserSource: fetchUserSource
            }
        }, children);
    const $03c54134dca7e94c$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
        const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($03c54134dca7e94c$var$ExusUserSourceContext);
        const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const abortController = (0, $5uXOq.useMemo)(()=>{
            if (typeof AbortController === 'undefined') return;
            return new AbortController();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources.map((source)=>source.sourceType);
                setExternalSources(externalSourceTypes);
            }).catch((error)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error);
            });
            return cleanup;
        }, [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                sources: Array.from(new Set([
                    ...existingSources ?? [],
                    ...externalSources
                ])),
                loading: loading,
                error: error
            }), [
            error,
            existingSources,
            externalSources,
            loading
        ]);
    };
});
parcelRegister("ecbCU", function(module, exports) {
    $parcel$export(module.exports, "useInvitePeopleDrawer", ()=>$6f07668563b12d68$export$48fb2d80745c5e67);
    $parcel$export(module.exports, "triggerOpenDrawer", ()=>$6f07668563b12d68$export$b7dab610045052db);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $bKpgX;
    var $2fX5x;
    const $6f07668563b12d68$var$CONTROLLER_NAME = 'invite-people-drawer';
    const $6f07668563b12d68$var$initialState = {
        isOpen: false,
        inviteFlow: 'unknown',
        continueUrl: undefined
    };
    const $6f07668563b12d68$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $6f07668563b12d68$var$CONTROLLER_NAME,
        initialState: $6f07668563b12d68$var$initialState,
        actions: {
            openDrawer: (createAnalyticsEvent, { inviteFlow: inviteFlow, analyticsSource: analyticsSource, continueUrl: continueUrl })=>({ setState: setState })=>{
                    (0, (0, parcelRequire("2fX5x")).fireAddTeammatetoJiraAnalytics)(createAnalyticsEvent, analyticsSource);
                    (0, (0, parcelRequire("2fX5x")).fireModalTriggeredAnalytics)(createAnalyticsEvent, inviteFlow, analyticsSource);
                    setState({
                        isOpen: true,
                        inviteFlow: inviteFlow,
                        continueUrl: continueUrl
                    });
                },
            closeDrawer: ()=>({ setState: setState })=>setState($6f07668563b12d68$var$initialState)
        }
    });
    const $6f07668563b12d68$export$48fb2d80745c5e67 = (0, (0, parcelRequire("3sQ5x")).createHook)($6f07668563b12d68$var$Store);
    const $6f07668563b12d68$export$ac7fed664b4735b5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($6f07668563b12d68$var$Store, {
        onInit: ()=>({ setState: setState }, { isOpen: isOpen })=>{
                setState({
                    isOpen: isOpen
                });
            }
    });
    const $6f07668563b12d68$export$4358742cbaf4a6d4 = (0, (0, parcelRequire("51nlc")).createSubscriber)($6f07668563b12d68$var$Store, {
        displayName: 'InvitePeopleDrawerSubscriber',
        selector: (state)=>state.isOpen
    });
    const $6f07668563b12d68$export$b7dab610045052db = (createAnalyticsEvent, contextConfig)=>{
        (0, (0, parcelRequire("bKpgX")).defaultRegistry).getStore($6f07668563b12d68$var$Store)?.actions.openDrawer(createAnalyticsEvent, contextConfig);
    };
});
parcelRegister("2fX5x", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsProvider", ()=>$b69ddc7a728288ef$export$1b581a2ec13e37f1);
    $parcel$export(module.exports, "fireModalTriggeredAnalytics", ()=>$b69ddc7a728288ef$export$6815765da918b983);
    $parcel$export(module.exports, "fireAddTeammatetoJiraAnalytics", ()=>$b69ddc7a728288ef$export$21b810258e82d438);
    var $5uXOq = parcelRequire("5uXOq");
    var $cLVNj;
    var $8zOmE;
    var $lhVtI;
    var $fjcgS;
    var $d3xqi;
    const $b69ddc7a728288ef$var$useAnalyticsClient = ()=>{
        const analyticsWebClientRef = (0, $5uXOq.useRef)((0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)());
        return {
            sendEvent: (analyticsEvent)=>{
                analyticsWebClientRef.current.then((webClient)=>webClient.sendEvent((0, (0, parcelRequire("lhVtI")).getEvent)(analyticsEvent)));
            }
        };
    };
    const $b69ddc7a728288ef$export$1b581a2ec13e37f1 = ({ children: children })=>{
        const { sendEvent: sendEvent } = $b69ddc7a728288ef$var$useAnalyticsClient();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLVNj")).default), {
            channel: "peopleAndTeams",
            onEvent: sendEvent
        }, children);
    };
    const $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent = async (createAnalyticsEvent, analyticsPayload)=>{
        if (createAnalyticsEvent) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), `${analyticsPayload.actionSubject} ${analyticsPayload.action}`, analyticsPayload?.actionSubjectId || '', analyticsPayload.attributes);
        else {
            const webAnalyticsClient = await (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)();
            const analyticsClient = webAnalyticsClient.getInstance();
            if (analyticsClient) analyticsClient.sendUIEvent(analyticsPayload);
        }
    };
    const $b69ddc7a728288ef$export$6815765da918b983 = async (createAnalyticsEvent, inviteFlow, source)=>{
        const analyticsPayload = {
            action: 'triggered',
            actionSubject: 'modal',
            actionSubjectId: 'invitePeopleModal',
            attributes: {
                source: (0, (0, parcelRequire("d3xqi")).getSourceByInviteFlow)(inviteFlow)
            },
            source: source != null && source !== '' ? source : 'unknown'
        };
        $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
    };
    const $b69ddc7a728288ef$export$21b810258e82d438 = async (createAnalyticsEvent, source)=>{
        const analyticsPayload = {
            action: 'clicked',
            actionSubject: 'addTeammatetoJira',
            product: 'jira',
            source: source != null && source !== '' ? source : 'unknown'
        };
        $b69ddc7a728288ef$var$sendAnalyticsClientUIEvent(createAnalyticsEvent, analyticsPayload);
    };
});
parcelRegister("d3xqi", function(module, exports) {
    $parcel$export(module.exports, "getSourceByInviteFlow", ()=>$1b54655f5f68975f$export$c35cd18e9d0123e3);
    const $1b54655f5f68975f$export$c35cd18e9d0123e3 = (inviteFlow)=>{
        let source = inviteFlow;
        if (inviteFlow === 'mention') source = 'mentionInEditor';
        else if (inviteFlow === 'assignee') source = 'assigneeField';
        return source;
    };
});
const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';
parcelRegister("fhSLy", function(module, exports) {
    $parcel$export(module.exports, "getUnassignedUser", ()=>$bdabf260f25df73f$export$42c5a0b65ef9ee80);
    $parcel$export(module.exports, "getAutomaticUserOption", ()=>$bdabf260f25df73f$export$8d7a63500893c8c);
    $parcel$export(module.exports, "getInvitePeopleOption", ()=>$bdabf260f25df73f$export$84a82764cf0a696e);
    $parcel$export(module.exports, "getUserOptionFromUser", ()=>$bdabf260f25df73f$export$16086438354dcc85);
    $parcel$export(module.exports, "getUserFromUserOption", ()=>$bdabf260f25df73f$export$78a8bcc5bd21caa2);
    $parcel$export(module.exports, "getUserAvatarUrl", ()=>$bdabf260f25df73f$export$7d801d84202c7743);
    $parcel$export(module.exports, "getUserShape", ()=>$bdabf260f25df73f$export$322b6ab8c29a006e);
    var $7lGt2;
    var $12ZsE = parcelRequire("12ZsE");
    const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
            accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
            displayName: formatMessage((0, (0, parcelRequire("7lGt2")).default).unassignedOption),
            avatarUrls: {}
        });
    const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
            accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
            displayName: formatMessage((0, (0, parcelRequire("7lGt2")).default).automaticOption),
            avatarUrls: {}
        });
    const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
            accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
            displayName: formatMessage(isAdmin ? (0, (0, parcelRequire("7lGt2")).default).invitePeopleOptionAdmin : (0, (0, parcelRequire("7lGt2")).default).invitePeopleOption),
            avatarUrls: {
                '48x48': (0, ($parcel$interopDefault($12ZsE)))
            }
        });
    const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
            id: accountId || '',
            name: displayName,
            avatarUrl: avatarUrls['48x48'],
            byline: emailAddress
        });
    const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
            accountId: id,
            displayName: name,
            avatarUrls: {
                '48x48': avatarUrl
            }
        });
    const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
    const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
            accountId: accountId,
            displayName: displayName,
            avatarUrls: {
                '48x48': avatarUrl
            }
        });
});
parcelRegister("7lGt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2aaed3328149e1d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unassignedOption: {
            "id": "issue-field-assignee.unassigned-option",
            "defaultMessage": "Unassigned"
        },
        automaticOption: {
            "id": "issue-field-assignee.automatic-option",
            "defaultMessage": "Automatic"
        },
        assignToMe: {
            "id": "issue-field-assignee.assign-to-me",
            "defaultMessage": "Assign to me"
        },
        searchForAssignee: {
            "id": "issue-field-assignee.search-for-assignee",
            "defaultMessage": "Search for assignee"
        },
        invitePeopleOption: {
            "id": "issue-field-assignee.invite-people-option",
            "defaultMessage": "Add teammate to Jira"
        },
        invitePeopleOptionAdmin: {
            "id": "issue-field-assignee.invite-people-option-admin",
            "defaultMessage": "Invite teammate to Jira"
        }
    });
});
parcelRegister("12ZsE", function(module, exports) {
    module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();
});
parcelRegister("h36wX", function(module, exports) {
    $parcel$export(module.exports, "useAssigneeOptions", ()=>$92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);
    var $3OKtJ;
    var $8zOmE;
    var $lwMsT;
    var $itmJb;
    var $leRCk;
    var $fhSLy;
    var $7lGt2;
    const $92b31ca8d85d4433$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
        if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
        const action = 'rendered';
        const actionSubject = 'inviteItem';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const attrs = {
            fieldId: 'assignee',
            userRole: isAdmin ? 'admin' : 'basic',
            suggestionsCount: suggestionsCount,
            source: 'assigneeField',
            ...isInviteAndAssignFromBoard && {
                isInviteAndAssignFromBoard: true
            }
        };
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
    };
    const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign)=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const unassigned = (0, (0, parcelRequire("fhSLy")).getUnassignedUser)(intl);
        const automaticOption = (0, (0, parcelRequire("fhSLy")).getAutomaticUserOption)(intl);
        const valueOption = (0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(value || unassigned);
        const [{ data: loggedInUser }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const loggedInUserOption = loggedInUser ? {
            ...(0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(loggedInUser),
            publicName: intl.formatMessage((0, (0, parcelRequire("7lGt2")).default).assignToMe)
        } : null;
        const isInvalidSearch = search === undefined || search === '';
        const showUnassigned = isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase());
        let showAutomaticOption = false;
        if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
        const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
        const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
        const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
        const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
        const userOptions = users.filter((user)=>(!isInvalidSearch || user.accountId !== valueOption.id) && !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, (0, parcelRequire("fhSLy")).getUserOptionFromUser));
        const invitePeopleOptions = [];
        if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
            if (isEligibleForInviteAndAssign) {
                invitePeopleOptions.push((0, (0, parcelRequire("3OKtJ")).getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
                $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
            } else {
                $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
                invitePeopleOptions.push((0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)((0, (0, parcelRequire("fhSLy")).getInvitePeopleOption)(intl, isAdmin)));
            }
        }
        const options = [
            ...showUnassigned ? [
                (0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(unassigned)
            ] : [],
            ...showAutomaticOption ? [
                (0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(automaticOption)
            ] : [],
            ...showAssignToMe && loggedInUserOption !== null ? [
                loggedInUserOption
            ] : [],
            ...userOptions,
            ...invitePeopleOptions
        ];
        return [
            valueOption,
            options
        ];
    };
});
parcelRegister("3OKtJ", function(module, exports) {
    $parcel$export(module.exports, "isValidEmailAddress", ()=>$d369cb9a3149539e$export$866f45a7554d0870);
    $parcel$export(module.exports, "getInviteAndAssignPeopleOption", ()=>$d369cb9a3149539e$export$34e0d98131b0b98a);
    var $fWMUO;
    var $ivhIb = parcelRequire("ivhIb");
    var $eXneb;
    const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
        const isEmail = inputValue && [
            (0, $a56e5eac5897104f$export$18d36911c7f94286),
            (0, $a56e5eac5897104f$export$da1c529049028734)
        ].includes((0, (0, parcelRequire("fWMUO")).isValidEmail)(inputValue));
        const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
        return value;
    };
    const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, (0, parcelRequire("fWMUO")).isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
    const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
        const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
        return {
            id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
            name: possibleEmail,
            avatarUrl: (0, ($parcel$interopDefault($ivhIb))),
            byline: formatMessage((0, (0, parcelRequire("eXneb")).default).inviteAndAssign),
            isDisabled: (0, (0, parcelRequire("fWMUO")).isValidEmail)(possibleEmail) !== 'VALID'
        };
    };
});
parcelRegister("ivhIb", function(module, exports) {
    module.exports = new URL("email.very-specific-illu.43fa850c.png", import.meta.url).toString();
});
const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';
parcelRegister("eXneb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31de51ead46cb5cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteAndAssign: {
            "id": "invite-and-assign.common.invite-and-assign",
            "defaultMessage": "Invite and assign"
        }
    });
});
parcelRegister("kt8K4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$564a5b059c2a0fff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $7f4tk;
    const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl)=>{
        const [users, setUsers] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const currentQuery = (0, $5uXOq.useRef)('');
        const fetchUsers = (0, $5uXOq.useCallback)((query = '')=>{
            if ([
                '',
                null,
                undefined
            ].includes(autoCompleteUrl)) return Promise.resolve([]);
            const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
            setLoading(true);
            currentQuery.current = query;
            if (error) setError(undefined);
            return (0, (0, parcelRequire("7f4tk")).default)(usersFetchUrl).then((response)=>{
                if (query === currentQuery.current) setUsers(response);
            }).catch((err)=>{
                if (query === currentQuery.current) setError(err);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.assigne', 'Failed to fetch users', err);
            }).finally(()=>setLoading(false));
        }, [
            autoCompleteUrl,
            error
        ]);
        return [
            {
                data: users,
                error: error,
                loading: loading
            },
            fetchUsers
        ];
    };
    var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;
});
parcelRegister("jGVMX", function(module, exports) {
    $parcel$export(module.exports, "validateString", ()=>$e5b3b607ab8affce$export$d7b0a588f685ba7e);
    $parcel$export(module.exports, "validateSelectField", ()=>$e5b3b607ab8affce$export$53ded7ceec493f10);
    $parcel$export(module.exports, "validateCascadingSelectField", ()=>$e5b3b607ab8affce$export$837294b8fc732f20);
    $parcel$export(module.exports, "validateAssigneeField", ()=>$e5b3b607ab8affce$export$dd17aabe3f77b2ba);
    $parcel$export(module.exports, "validateUserPickerField", ()=>$e5b3b607ab8affce$export$356346770aab95cb);
    $parcel$export(module.exports, "validateCheckboxField", ()=>$e5b3b607ab8affce$export$7aa5e0976d0c384b);
    $parcel$export(module.exports, "validateComponentField", ()=>$e5b3b607ab8affce$export$89943b0814df306d);
    $parcel$export(module.exports, "validateCustomTeamsField", ()=>$e5b3b607ab8affce$export$364ea91bee38a994);
    $parcel$export(module.exports, "validateGroupPickerField", ()=>$e5b3b607ab8affce$export$c6d4785f3f46f73a);
    $parcel$export(module.exports, "validateMultiVersionsField", ()=>$e5b3b607ab8affce$export$727e23f536334715);
    $parcel$export(module.exports, "validateOrganizationsField", ()=>$e5b3b607ab8affce$export$b97bb8e170430af8);
    $parcel$export(module.exports, "validatePriorityField", ()=>$e5b3b607ab8affce$export$17fd881b060187f7);
    $parcel$export(module.exports, "validateRadioSelectField", ()=>$e5b3b607ab8affce$export$f69029476f9179b);
    $parcel$export(module.exports, "validateRadioGroupField", ()=>$e5b3b607ab8affce$export$d60dcaa093bca71d);
    $parcel$export(module.exports, "validateResolutionField", ()=>$e5b3b607ab8affce$export$316feff8e636f81f);
    $parcel$export(module.exports, "validateSingleVersionField", ()=>$e5b3b607ab8affce$export$45f7908dc93110fb);
    $parcel$export(module.exports, "validateLabelField", ()=>$e5b3b607ab8affce$export$1a8caa895b9fda26);
    $parcel$export(module.exports, "validateForgeLabelField", ()=>$e5b3b607ab8affce$export$bf4287ae453e2aab);
    var $bGrWH;
    const $e5b3b607ab8affce$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
        if (isRequired && !value?.trim?.()) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        if (typeof value === 'string' && type === 'text' && value?.length > (0, $d46ffa3990e23a4d$export$fe1a70381f6491b5)) return 0, $d46ffa3990e23a4d$export$618e922e89e8bcae;
        return undefined;
    };
    const $e5b3b607ab8affce$export$53ded7ceec493f10 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$837294b8fc732f20 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$dd17aabe3f77b2ba = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$356346770aab95cb = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$7aa5e0976d0c384b = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$89943b0814df306d = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$364ea91bee38a994 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$c6d4785f3f46f73a = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$727e23f536334715 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (!value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$b97bb8e170430af8 = (data, isRequired)=>{
        if (isRequired) {
            if (!data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(data) && !data.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$17fd881b060187f7 = (data, isRequired)=>{
        if (isRequired && !data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        return undefined;
    };
    const $e5b3b607ab8affce$export$f69029476f9179b = (data, isRequired)=>{
        if (isRequired && !data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        return undefined;
    };
    const $e5b3b607ab8affce$export$d60dcaa093bca71d = (data, isRequired)=>{
        if (isRequired && !data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        return undefined;
    };
    const $e5b3b607ab8affce$export$316feff8e636f81f = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$45f7908dc93110fb = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$1a8caa895b9fda26 = (labels, isRequired)=>{
        if (isRequired) {
            if (!labels) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(labels) && !labels.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
        if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.includes(' ') || value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$e77d629cc732976d;
        return undefined;
    };
    const $e5b3b607ab8affce$export$bf4287ae453e2aab = (labels, isRequired)=>{
        if (isRequired) {
            if (!labels) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(labels) && !labels.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
        if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f;
        return undefined;
    };
});
parcelRegister("bfnma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd95939e2e05e754$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dd95939e2e05e754$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        assignToMe: {
            "id": "issue-create-commons.assignee-field.assign-to-me",
            "defaultMessage": "Assign to me"
        }
    });
});
parcelRegister("5rYSU", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultAssigneeValue", ()=>$b31c169a5b4e6cfd$export$f5415de9103f1c69);
    $parcel$export(module.exports, "mapUserToAssigneeValue", ()=>$b31c169a5b4e6cfd$export$c4dfa893fba82437);
    $parcel$export(module.exports, "mutateAssigneeUserPicker", ()=>$b31c169a5b4e6cfd$export$a6706b2f4762043b);
    const $b31c169a5b4e6cfd$export$f5415de9103f1c69 = (value)=>({
            accountId: (value.accountId === '-1' ? (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027) : value.accountId) || '',
            displayName: value.name || '',
            avatarUrls: value.picture !== undefined ? {
                '16x16': value.picture,
                '24x24': value.picture,
                '32x32': value.picture,
                '48x48': value.picture
            } : {}
        });
    const $b31c169a5b4e6cfd$export$c4dfa893fba82437 = (value)=>{
        if (value === null) return null;
        if (value.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) return undefined;
        return {
            id: value.accountId
        };
    };
    const $b31c169a5b4e6cfd$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
        if (selectedUser === null || selectedUser.accountId === null) return null;
        return {
            fieldId: fieldId,
            mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
            user: {
                accountId: selectedUser.accountId
            }
        };
    };
});
parcelRegister("1Zt9x", function(module, exports) {
    $parcel$export(module.exports, "AttachmentFieldTypeConfig", ()=>$4f864de41952e13f$export$ada1e5fc2d37745a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ftaHx;
    var $azL7v;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $4f864de41952e13f$var$AttachmentFieldTypeComponent = (props)=>props.mediaUploadContexts.attachmentUploadContext ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azL7v")).default), {
            ...props,
            mediaUploadContext: props.mediaUploadContexts.attachmentUploadContext
        }) : null;
    const $4f864de41952e13f$export$ada1e5fc2d37745a = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("ftaHx"))))),
        type: (0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE),
        Component: $4f864de41952e13f$var$AttachmentFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).AttachmentFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).attachmentFieldWriter)
    };
});
parcelRegister("ftaHx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b431dd78f7873814$var$_react = $b431dd78f7873814$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b431dd78f7873814$var$_UNSAFE_baseNew = $b431dd78f7873814$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $b431dd78f7873814$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b431dd78f7873814$var$AttachmentIcon = (props)=>$b431dd78f7873814$var$_react.default.createElement($b431dd78f7873814$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 4.5 5.75 9a1.414 1.414 0 1 0 2 2l4.5-4.5a2.828 2.828 0 1 0-4-4L3.75 7a4.243 4.243 0 0 0 6 6l2.5-2.5"/>`
        }, props));
    $b431dd78f7873814$var$AttachmentIcon.displayName = 'AttachmentIcon';
    var $b431dd78f7873814$var$_default = module.exports.default = $b431dd78f7873814$var$AttachmentIcon;
});
parcelRegister("azL7v", function(module, exports) {
    $parcel$export(module.exports, "AttachmentsField", ()=>$e446c7b6c6df08e3$export$f7c49e57ef98664f);
    $parcel$export(module.exports, "default", ()=>$e446c7b6c6df08e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $k9tnV;
    var $42Si9;
    var $30Rxs;
    var $6Ll2T;
    var $99gde;
    var $koVbs;
    var $bGrWH;
    var $3F8e9;
    var $lySs6;
    var $6UFK0;
    var $lfTZh;
    var $hpV4g;
    var $c431P;
    var $bWtQ8;
    const $e446c7b6c6df08e3$export$f7c49e57ef98664f = (props)=>{
        const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, (0, parcelRequire("lySs6")).default)({
            mediaUploadContext: mediaUploadContext,
            projectId: projectId,
            maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
            onAttachmentSizeValidation: onAttachmentSizeValidation,
            attachmentCustomUploadURL: attachmentCustomUploadURL
        });
        const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
        (0, $5uXOq.useEffect)(()=>{
            if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
                const currentAttachments = [];
                setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: false
                    }))));
                setDefaultValueInitialized(true);
            }
        }, [
            setAttachments,
            defaultValue,
            isDefaultValueInitialized,
            setDefaultValueInitialized
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let shouldCallOnChange = false;
            const isValueAnArray = Array.isArray(value);
            if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
            if (!isValueAnArray && files.length) shouldCallOnChange = true;
            if (shouldCallOnChange) onChange(files);
        }, [
            files,
            onChange,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (value && value.shouldClear === true) setAttachments([]);
        }, [
            setAttachments,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onInProgressChange && onInProgressChange(isUploading);
        }, [
            isUploading,
            onInProgressChange
        ]);
        if (!mediaUploadContext) return null;
        const onAttachmentUploadStart = (uploadStartPayload)=>{
            onUploadStart(uploadStartPayload);
            if (shouldScrollIntoViewOnUploadStart) {
                const fieldElement = document.getElementById((0, (0, parcelRequire("bWtQ8")).getFieldDropZoneContainerID)(fieldId));
                if (fieldElement) (0, (0, parcelRequire("k9tnV")).default)(fieldElement, (0, (0, parcelRequire("bGrWH")).DEFAULT_SCROLL_OPTIONS));
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$FieldDropzoneContainer, {
            id: (0, (0, parcelRequire("bWtQ8")).getFieldDropZoneContainerID)(fieldId)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneArea, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("30Rxs"))))), {
            label: "Upload",
            primaryColor: `var(--ds-icon, ${(0, $72ba03e317f3d228$exports).N100})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneAreaText, null, `${formatMessage((0, (0, parcelRequire("c431P")).default).dropzone)}`, "\xa0"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6UFK0")).default), {
            ...fieldProps,
            mediaClientConfig: mediaClientConfig,
            uploadConfig: uploadConfig,
            onUploadError: onUploadError,
            onUploadStart: onAttachmentUploadStart,
            onUploadEnd: onUploadEnd,
            dropzoneContainer: document.getElementById(dropzoneContainerId || (0, (0, parcelRequire("bWtQ8")).getFieldDropZoneContainerID)(fieldId))
        }, ({ setIsBrowserOpen: setIsBrowserOpen })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $e446c7b6c6df08e3$var$browseButtonStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
                onClick: ()=>setIsBrowserOpen(true),
                "aria-label": formatMessage((0, (0, parcelRequire("c431P")).default).browseAriaLabel)
            }, formatMessage((0, (0, parcelRequire("c431P")).default).browse)))))), files.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $e446c7b6c6df08e3$var$mediaContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "attachments-filmstrip-view",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3F8e9")).AsyncAttachmentsFilmstripView), {
            mediaClientConfig: mediaClientConfig,
            files: files,
            onRemoveFile: onRemoveFile,
            collectionName: mediaUploadContext.collection
        }))));
    };
    var $e446c7b6c6df08e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("bWtQ8")).validateAttachment)
    })($e446c7b6c6df08e3$export$f7c49e57ef98664f);
    const $e446c7b6c6df08e3$var$FieldDropzoneContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _1yt4utpp _189et94y _1dqogq9o _1h6dq6nq _syaz1e9r",
                __cmplp.className
            ])
        });
    });
    const $e446c7b6c6df08e3$var$mediaContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.050'
    });
    const $e446c7b6c6df08e3$var$browseButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.075'
    });
    const $e446c7b6c6df08e3$var$BrowseDropzoneArea = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $e446c7b6c6df08e3$var$BrowseDropzoneAreaText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3F8e9", function(module, exports) {
    $parcel$export(module.exports, "AsyncAttachmentsFilmstripView", ()=>$eb0c63a29297e8e6$export$85605b8f3b532b83);
    var $1jUsD;
    const $eb0c63a29297e8e6$export$85605b8f3b532b83 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("6tE5l")).then((module)=>module.AttachmentsFilmstripView), {
        moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
    });
});
parcelRegister("6tE5l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kiYwA")
    ]).then(()=>parcelRequire('4MZE8'));
});
parcelRegister("lySs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25872ff6af438731$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $f4KvR;
    const $25872ff6af438731$var$useAttachments = (attachmentArgs)=>{
        const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
        if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
        const [attachments, setAttachments] = (0, $5uXOq.useState)([]);
        const [files, setFiles] = (0, $5uXOq.useState)([]);
        const [isUploading, setUploading] = (0, $5uXOq.useState)(false);
        const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $5uXOq.useState)(false);
        const stateRef = (0, $5uXOq.useRef)();
        stateRef.current = files;
        (0, $5uXOq.useEffect)(()=>{
            setFiles(attachments.map((attachment)=>attachment.mediaFile));
            setUploading(attachments.some((attachment)=>attachment.isUploading));
        }, [
            attachments
        ]);
        const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
                authProvider: ()=>Promise.resolve({
                        baseUrl: mediaUploadContext.serviceHost,
                        clientId: mediaUploadContext.clientId,
                        token: mediaUploadContext.token
                    }),
                useSha256ForUploads: true
            }), [
            mediaUploadContext
        ]);
        const uploadConfig = (0, $5uXOq.useMemo)(()=>({
                uploadParams: {
                    collection: mediaUploadContext.collection
                }
            }), [
            mediaUploadContext.collection
        ]);
        const onUploadStart = (0, $5uXOq.useCallback)((uploadStartPayload)=>{
            const currentFiles = stateRef.current ? stateRef.current : [];
            const totalAttachments = [
                ...uploadStartPayload.files,
                ...currentFiles
            ];
            if (maxAllowedTotalAttachmentsSize === undefined || (0, (0, parcelRequire("f4KvR")).getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
                if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
                setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                            mediaFile: mediaFile,
                            isUploading: true
                        }))));
            } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
        }, [
            onAttachmentSizeValidation,
            maxAllowedTotalAttachmentsSize
        ]);
        const onUploadError = (0, $5uXOq.useCallback)((uploadError)=>{
            setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
        }, []);
        const onUploadEnd = (0, $5uXOq.useCallback)((uploadEndPayload)=>{
            (async ()=>{
                const mediaFile = uploadEndPayload.file;
                if (!(0, ($parcel$interopDefault($hGgHi)))(projectId)) await (0, (0, parcelRequire("f4KvR")).copyToAttachment)({
                    id: projectId,
                    isProjectId: true,
                    mediaFile: mediaFile,
                    attachmentCustomUploadURL: attachmentCustomUploadURL
                });
                else if (!(0, ($parcel$interopDefault($hGgHi)))(issueId)) await (0, (0, parcelRequire("f4KvR")).copyToAttachment)({
                    id: issueId,
                    isProjectId: false,
                    mediaFile: mediaFile,
                    attachmentCustomUploadURL: attachmentCustomUploadURL
                });
                setAttachments((currentAttachments)=>{
                    const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                    if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                        {
                            mediaFile: mediaFile,
                            isUploading: false
                        }
                    ]);
                    return currentAttachments;
                });
            })();
        }, [
            issueId,
            projectId,
            attachmentCustomUploadURL
        ]);
        const onRemoveFile = (fileToBeRemoved)=>{
            setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
        };
        return {
            files: files,
            setAttachments: setAttachments,
            onUploadStart: onUploadStart,
            onUploadError: onUploadError,
            mediaClientConfig: mediaClientConfig,
            uploadConfig: uploadConfig,
            onRemoveFile: onRemoveFile,
            onUploadEnd: onUploadEnd,
            isUploading: isUploading,
            isDefaultValueInitialized: isDefaultValueInitialized,
            setDefaultValueInitialized: setDefaultValueInitialized
        };
    };
    var $25872ff6af438731$export$2e2bcd8739ae039 = $25872ff6af438731$var$useAttachments;
});
parcelRegister("f4KvR", function(module, exports) {
    $parcel$export(module.exports, "copyToAttachment", ()=>$ac4c15282d67ab83$export$b9a44fdbc3de4b85);
    $parcel$export(module.exports, "getAttachmentsSize", ()=>$ac4c15282d67ab83$export$ed1597b81cfdb5f6);
    var $eusud;
    const $ac4c15282d67ab83$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
    const $ac4c15282d67ab83$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
    const $ac4c15282d67ab83$export$b9a44fdbc3de4b85 = async (props)=>{
        const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
        const { attachmentId: attachmentId } = await (0, (0, parcelRequire("eusud")).performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $ac4c15282d67ab83$export$a7455b0d8bb5c44e(id) : $ac4c15282d67ab83$export$cf1f2654bf86294f(id)), {
            body: JSON.stringify({
                fileId: mediaFile.id
            })
        });
        return attachmentId;
    };
    const $ac4c15282d67ab83$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);
});
parcelRegister("6UFK0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c958c4e419db9df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9p6PW;
    var $8xnFr;
    var $495Tz;
    const $2c958c4e419db9df$var$AttachmentsUpload = (props)=>{
        const [isBrowserOpen, setIsBrowserOpen] = (0, $5uXOq.useState)(false);
        const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
        const dropzoneConfig = {
            ...uploadConfig
        };
        const browserConfig = {
            ...uploadConfig,
            multiple: true
        };
        const clipboardConfig = {
            ...uploadConfig
        };
        if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9p6PW")).BrowserLoader), {
            isOpen: isBrowserOpen,
            config: browserConfig,
            mediaClientConfig: mediaClientConfig,
            onUploadsStart: onUploadStart,
            onError: onUploadError,
            onEnd: onUploadEnd,
            onClose: ()=>setIsBrowserOpen(false)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8xnFr")).DropzoneLoader), {
            mediaClientConfig: mediaClientConfig,
            config: dropzoneConfig,
            onUploadsStart: onUploadStart,
            onEnd: onUploadEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("495Tz")).Clipboard), {
            mediaClientConfig: mediaClientConfig,
            config: clipboardConfig,
            onUploadsStart: onUploadStart,
            onEnd: onUploadEnd,
            isolated: false
        }), renderPropFn({
            setIsBrowserOpen: setIsBrowserOpen
        }));
    };
    var $2c958c4e419db9df$export$2e2bcd8739ae039 = $2c958c4e419db9df$var$AttachmentsUpload;
});
parcelRegister("9p6PW", function(module, exports) {
    $parcel$export(module.exports, "BrowserLoader", ()=>$6e9a4d969c430fad$export$3ce634ac4a869e2c);
    var $5uXOq = parcelRequire("5uXOq");
    class $6e9a4d969c430fad$export$3ce634ac4a869e2c extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.displayName = 'AsyncBrowser';
        }
        componentDidMount() {
            this.mounted = true;
        }
        componentWillUnmount() {
            this.mounted = false;
        }
        async UNSAFE_componentWillMount() {
            if (!this.state.Browser) {
                const [mediaClient, browserModule] = await Promise.all([
                    (parcelRequire("dKC6A")),
                    (parcelRequire("dGotx"))
                ]);
                $6e9a4d969c430fad$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
                if (this.mounted) this.setState({
                    Browser: $6e9a4d969c430fad$export$3ce634ac4a869e2c.Browser
                });
            }
        }
        render() {
            if (!this.state.Browser) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(this.state.Browser, this.props);
        }
        constructor(...args){
            super(...args);
            this.mounted = false;
            this.state = {
                Browser: $6e9a4d969c430fad$export$3ce634ac4a869e2c.Browser
            };
        }
    }
});
parcelRegister("dKC6A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6VcD8").then(()=>parcelRequire('idzoY'));
});
parcelRegister("dGotx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ee8Hx").then(()=>parcelRequire('3vWbD'));
});
parcelRegister("8xnFr", function(module, exports) {
    $parcel$export(module.exports, "DropzoneLoader", ()=>$079ccd752f34d8ec$export$66201d263cd6342);
    var $5uXOq = parcelRequire("5uXOq");
    class $079ccd752f34d8ec$export$66201d263cd6342 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.displayName = 'AsyncDropzone';
        }
        async UNSAFE_componentWillMount() {
            if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
                const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                    (parcelRequire("dKC6A")),
                    (parcelRequire("6gdWq")),
                    (parcelRequire("aHN5G"))
                ]);
                $079ccd752f34d8ec$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
                $079ccd752f34d8ec$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
                this.setState({
                    Dropzone: $079ccd752f34d8ec$export$66201d263cd6342.Dropzone,
                    MediaPickerErrorBoundary: $079ccd752f34d8ec$export$66201d263cd6342.MediaPickerErrorBoundary
                });
            } catch (error) {}
        }
        render() {
            const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
            if (!Dropzone || !MediaPickerErrorBoundary) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(MediaPickerErrorBoundary, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Dropzone, this.props));
        }
        constructor(...args){
            super(...args);
            this.state = {
                Dropzone: $079ccd752f34d8ec$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $079ccd752f34d8ec$export$66201d263cd6342.MediaPickerErrorBoundary
            };
        }
    }
});
parcelRegister("6gdWq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2NY6w").then(()=>parcelRequire('cHr59'));
});
parcelRegister("aHN5G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("kRL9l")
    ]).then(()=>parcelRequire('jGuMy'));
});
parcelRegister("495Tz", function(module, exports) {
    $parcel$export(module.exports, "Clipboard", ()=>$a204c5b4c1d898fb$export$8b44c43c7d8f0830);
    var $5uXOq = parcelRequire("5uXOq");
    var $4okT6;
    var $46dC9;
    const $a204c5b4c1d898fb$export$7b1ba4955557a858 = ()=>null;
    const $a204c5b4c1d898fb$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
        const container = (0, (0, parcelRequire("46dC9")).useClipboardContextBoundary)();
        const onPaste = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            return false;
        }, []);
        const derivedConfig = (0, $5uXOq.useMemo)(()=>container ? {
                ...config,
                container: container,
                onPaste: onPaste
            } : config, [
            config,
            container,
            onPaste
        ]);
        if (!container && isolated !== false) return (0, ($parcel$interopDefault($5uXOq))).createElement($a204c5b4c1d898fb$export$7b1ba4955557a858, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4okT6")).ClipboardLoader), {
            ...props,
            config: derivedConfig
        });
    };
});
parcelRegister("4okT6", function(module, exports) {
    $parcel$export(module.exports, "ClipboardLoader", ()=>$b3e1d8b3d2c2b063$export$d7936799bf32b554);
    var $5uXOq = parcelRequire("5uXOq");
    class $b3e1d8b3d2c2b063$export$d7936799bf32b554 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.displayName = 'AsyncClipboard';
        }
        async UNSAFE_componentWillMount() {
            if (!this.state.Clipboard) {
                const [mediaClient, clipboardModule] = await Promise.all([
                    (parcelRequire("dKC6A")),
                    (parcelRequire("6poBe"))
                ]);
                $b3e1d8b3d2c2b063$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
                this.setState({
                    Clipboard: $b3e1d8b3d2c2b063$export$d7936799bf32b554.Clipboard
                });
            }
        }
        render() {
            if (!this.state.Clipboard) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(this.state.Clipboard, this.props);
        }
        constructor(...args){
            super(...args);
            this.state = {
                Clipboard: $b3e1d8b3d2c2b063$export$d7936799bf32b554.Clipboard
            };
        }
    }
});
parcelRegister("6poBe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d3IZ1").then(()=>parcelRequire('29orM'));
});
parcelRegister("46dC9", function(module, exports) {
    $parcel$export(module.exports, "ClipboardStoreContainer", ()=>$315b0e877a12fb17$export$c4bc9440a978eec1);
    $parcel$export(module.exports, "useClipboardContextActions", ()=>$315b0e877a12fb17$export$a3e41c5b3d4c30b7);
    $parcel$export(module.exports, "useClipboardContextBoundary", ()=>$315b0e877a12fb17$export$37046969a30ae0a0);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    const $315b0e877a12fb17$var$ClipboardStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'clipboard-store',
        initialState: {
            boundary: null
        },
        actions: {
            setClipBoardContext: (boundary)=>({ setState: setState })=>{
                    setState({
                        boundary: boundary
                    });
                }
        }
    });
    const $315b0e877a12fb17$export$c4bc9440a978eec1 = (0, (0, parcelRequire("gg7kZ")).createContainer)($315b0e877a12fb17$var$ClipboardStore);
    const $315b0e877a12fb17$export$a3e41c5b3d4c30b7 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($315b0e877a12fb17$var$ClipboardStore);
    const $315b0e877a12fb17$var$useClipboardContextBoundarySelector = (0, (0, parcelRequire("3sQ5x")).createHook)($315b0e877a12fb17$var$ClipboardStore, {
        selector: (state)=>state.boundary
    });
    const $315b0e877a12fb17$export$37046969a30ae0a0 = ()=>$315b0e877a12fb17$var$useClipboardContextBoundarySelector()[0];
});
parcelRegister("c431P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23a51dc4ce208a9a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $23a51dc4ce208a9a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dropzone: {
            "id": "issue-create-commons.attachments-field.dropzone",
            "defaultMessage": "Drop files to attach or"
        },
        browse: {
            "id": "issue-create-commons.attachments-field.browse",
            "defaultMessage": "Browse"
        },
        browseAriaLabel: {
            "id": "issue-create-commons.attachments-field.browse-aria-label",
            "defaultMessage": "Browse attachment"
        },
        missingToken: {
            "id": "issue-create-commons.attachments-field.missing-token",
            "defaultMessage": "Something went wrong"
        }
    });
    var $23a51dc4ce208a9a$export$2e2bcd8739ae039 = $23a51dc4ce208a9a$var$messages;
});
parcelRegister("1C9NJ", function(module, exports) {
    $parcel$export(module.exports, "CascadingSelectFieldTypeConfig", ()=>$19ee995e12970e69$export$b1cccbe22677a87b);
    var $5uXOq = parcelRequire("5uXOq");
    var $aEee1;
    var $gbo8w;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $19ee995e12970e69$var$CascadingSelectFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gbo8w")).default), props);
    const $19ee995e12970e69$export$b1cccbe22677a87b = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("aEee1"))))),
        type: (0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE),
        Component: $19ee995e12970e69$var$CascadingSelectFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).cascadingSelectFieldWriter)
    };
});
parcelRegister("aEee1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c08aca142bc8eff$var$_react = $7c08aca142bc8eff$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c08aca142bc8eff$var$_UNSAFE_baseNew = $7c08aca142bc8eff$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $7c08aca142bc8eff$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c08aca142bc8eff$var$TaskIcon = (props)=>$7c08aca142bc8eff$var$_react.default.createElement($7c08aca142bc8eff$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M3 14.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $7c08aca142bc8eff$var$TaskIcon.displayName = 'TaskIcon';
    var $7c08aca142bc8eff$var$_default = module.exports.default = $7c08aca142bc8eff$var$TaskIcon;
});
parcelRegister("gbo8w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$094c2ce3abc8686f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $4zFcG;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $j0pqC;
    const $094c2ce3abc8686f$var$CascadingSelectField = (props)=>{
        const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
        const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, (0, parcelRequire("j0pqC")).transformToCascadingSelectOptions)(cascadingSelectOptions);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4zFcG")).AsyncCascadingSelectEdit), {
            ...fieldProps,
            value: value,
            allowedValues: allowedValues,
            allowedChildValues: allowedChildValues,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onChange: onChange,
            isInvalid: false,
            autoFocus: autoFocus,
            areOptionsOnSameRow: false,
            isEditable: (0, (0, parcelRequire("4R6GH")).fg)('uim-cascading-select-field-support-gic_h1cda') ? !isReadOnly && isEditable : isEditable
        }));
    };
    var $094c2ce3abc8686f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateCascadingSelectField),
        transformDefaultValue: (0, parcelRequire("j0pqC")).transformDefaultValue
    })($094c2ce3abc8686f$var$CascadingSelectField);
});
parcelRegister("4zFcG", function(module, exports) {
    $parcel$export(module.exports, "AsyncCascadingSelectEdit", ()=>$0a411cf33e78ceb6$export$7db21897d0716698);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $kmnNN;
    const $0a411cf33e78ceb6$var$EMPTY_OBJECT = {};
    const $0a411cf33e78ceb6$export$7db21897d0716698 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kmnNN")).asyncCascadingSelectEditEntryPoint), $0a411cf33e78ceb6$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "async-jira-issue-field-cascading-select-edit",
            packageName: "jira-issue-field-cascading-select",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                width: "350px",
                height: "40px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("kmnNN", function(module, exports) {
    $parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", ()=>$8f41019f840ae33a$export$336a3a4bd9539e41);
    var $evanD;
    var $7KfpL;
    const $8f41019f840ae33a$export$336a3a4bd9539e41 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("4cejO")).then((module)=>module.CascadingSelectViewEntryPointContent), {
            moduleId: "dba9fb26"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("4cejO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bhpAB").then(()=>parcelRequire('aKsI4'));
});
parcelRegister("j0pqC", function(module, exports) {
    $parcel$export(module.exports, "transformToCascadingSelectOptions", ()=>$c7fead76ffb795b3$export$b06e6053830d7554);
    $parcel$export(module.exports, "transformDefaultValue", ()=>$c7fead76ffb795b3$export$e2f4e5d31db527cc);
    $parcel$export(module.exports, "mutateCascadingSelectField", ()=>$c7fead76ffb795b3$export$f402e35d933d11b5);
    const $c7fead76ffb795b3$export$facac75482a8e0c5 = (option)=>{
        const { value: value, id: id } = option || {};
        if (value && id) return {
            label: value,
            value: id
        };
        return null;
    };
    const $c7fead76ffb795b3$export$b06e6053830d7554 = (cascadingSelectData)=>{
        const allowedValues = [];
        const allowedChildValues = {};
        cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
            const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
            if (parentOptionValue !== null && transformedParentOption !== null) {
                allowedValues.push(transformedParentOption);
                allowedChildValues[parentOptionValue.id] = childOptionValues.map($c7fead76ffb795b3$export$facac75482a8e0c5);
            }
        });
        return {
            allowedValues: allowedValues,
            allowedChildValues: allowedChildValues
        };
    };
    const $c7fead76ffb795b3$export$e2f4e5d31db527cc = (defaultValue)=>{
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
        const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
        let transformedDefaultValue = null;
        if (transformedParentOption !== null) transformedDefaultValue = {
            ...transformedParentOption,
            child: childOptionValue ? $c7fead76ffb795b3$export$facac75482a8e0c5(childOptionValue) : undefined
        };
        return transformedDefaultValue;
    };
    const $c7fead76ffb795b3$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
            fieldId: fieldId,
            parentOptionValue: {
                optionId: selectedOption.value
            },
            childOptionValue: selectedOption.child ? {
                optionId: selectedOption.child.value
            } : null,
            mutationGroup: (0, $4a7dfdb992f68644$export$31fd86f8f183952c)
        });
});
const $4a7dfdb992f68644$export$31fd86f8f183952c = 'cascadingSelectFields';
parcelRegister("97VNg", function(module, exports) {
    $parcel$export(module.exports, "CategoryFieldTypeConfig", ()=>$8500d0c5b0bf9983$export$3e2ea7bfd7261cb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $aucDX;
    var $k4tyx;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $8500d0c5b0bf9983$var$CategoryFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k4tyx")).default), {
            ...props,
            defaultValue: undefined
        });
    const $8500d0c5b0bf9983$export$3e2ea7bfd7261cb5 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("aucDX"))))),
        type: (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        Component: $8500d0c5b0bf9983$var$CategoryFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).selectFieldWriter)
    };
});
parcelRegister("k4tyx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$108361897c01a8f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d3RWa;
    const $108361897c01a8f5$var$SingleSelectField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3RWa")).default), {
            ...props,
            isMulti: false
        });
    var $108361897c01a8f5$export$2e2bcd8739ae039 = $108361897c01a8f5$var$SingleSelectField;
});
parcelRegister("d3RWa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da96ee86c52df1e6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cOyAh;
    var $5pHXe;
    var $gLdtQ;
    var $jGVMX;
    var $hpV4g;
    var $7C5S0;
    var $90YqS;
    const $da96ee86c52df1e6$var$SelectField = (props)=>{
        const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOyAh")).default), {
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            options: (0, (0, parcelRequire("5pHXe")).mapDataToSelectOptions)(allowedValues),
            value: value,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            classNamePrefix: `select-${fieldId}`,
            isMulti: isMulti,
            hideSelectedOptions: true,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isClearable: true,
            onFilterOption: (0, (0, parcelRequire("90YqS")).onFilterOption),
            isDisabled: isReadOnly,
            isRequired: isRequired,
            inputId: id
        }));
    };
    var $da96ee86c52df1e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("90YqS")).transformDefaultSelectValues),
        validator: (0, (0, parcelRequire("jGVMX")).validateSelectField)
    })($da96ee86c52df1e6$var$SelectField);
});
parcelRegister("cOyAh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45ff8480905da065$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gN6Vx;
    var $lElIo;
    const $45ff8480905da065$var$SelectEdit = (props)=>{
        const { classNamePrefix: classNamePrefix, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            placeholder: placeholder,
            options: options,
            value: value,
            classNamePrefix: classNamePrefix,
            onChange: onChange,
            onBlur: onBlur,
            isMulti: isMulti,
            onFocus: onFocus,
            autoFocus: autoFocus,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            isClearable: isClearable,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            filterOption: onFilterOption,
            inputId: inputId,
            required: isRequired,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $45ff8480905da065$export$2e2bcd8739ae039 = $45ff8480905da065$var$SelectEdit;
});
parcelRegister("90YqS", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultSelectValues", ()=>$3a49366a4ffd7ccc$export$cfb7677fb5241257);
    $parcel$export(module.exports, "onFilterOption", ()=>$3a49366a4ffd7ccc$export$5fde4483c43b93b);
    var $5pHXe;
    const $3a49366a4ffd7ccc$export$cfb7677fb5241257 = (defaultValue)=>{
        if (Array.isArray(defaultValue)) return (0, (0, parcelRequire("5pHXe")).mapDataToSelectOptions)(defaultValue);
        return (0, (0, parcelRequire("5pHXe")).mapDataToSelectOption)(defaultValue);
    };
    const $3a49366a4ffd7ccc$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());
});
parcelRegister("aR835", function(module, exports) {
    $parcel$export(module.exports, "ComponentsFieldTypeConfig", ()=>$004c360808306af4$export$75a450cecebc09fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $beKPf;
    var $776me;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $004c360808306af4$var$ComponentsFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("776me")).default), props);
    const $004c360808306af4$var$componentsFieldWriter = (id, value, fields)=>{
        const filteredValues = value.filter((option)=>option.value !== null);
        (0, (0, parcelRequire("kShoa")).multiSelectFieldWriter)(id, filteredValues, fields);
    };
    const $004c360808306af4$export$75a450cecebc09fa = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("beKPf"))))),
        type: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        Component: $004c360808306af4$var$ComponentsFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: $004c360808306af4$var$componentsFieldWriter
    };
});
parcelRegister("776me", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6c3a95c2efe6aba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $hFon0;
    var $koVbs;
    var $as9La;
    var $6Fkzt;
    var $45JN1;
    var $7C5S0;
    var $YSJPS;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $b399U;
    const $f6c3a95c2efe6aba$var$ComponentsField = (props)=>{
        const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isDisabled = allowedValues.length === 0;
        const options = (0, (0, parcelRequire("6Fkzt")).mapDataToOptions)(allowedValues);
        const { projectKey: projectKey } = selectedProject || {};
        const projectKeyStr = projectKey || '';
        const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, (0, parcelRequire("hFon0")).useGlobalComponentsProperty)(projectKeyStr);
        const getComponentSelectEdit = ()=>{
            if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("as9La")).default), {
                ...fieldProps,
                options: options,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                value: value,
                onChange: onChange,
                autoFocus: autoFocus,
                isInvalid: Boolean(error),
                showFooter: false,
                projectKey: projectKeyStr,
                placeholder: isDisabled ? formatMessage((0, (0, parcelRequire("b399U")).default).none) : '',
                isDisabled: isDisabled || isReadOnly,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                canCreateNewItem: !areGlobalComponentsEnabled,
                inputId: id,
                isRequired: isRequired
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("b399U")).default).tooltipWhenDisabled)
        }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }));
    };
    var $f6c3a95c2efe6aba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("6Fkzt")).mapDataToOptions),
        validator: (0, (0, parcelRequire("jGVMX")).validateComponentField),
        shouldRenderFieldMessage: false
    })($f6c3a95c2efe6aba$var$ComponentsField);
});
parcelRegister("hFon0", function(module, exports) {
    $parcel$export(module.exports, "useGlobalComponentsProperty", ()=>$e88d764a116eddca$export$a070f388fcd93df0);
    var $5uXOq = parcelRequire("5uXOq");
    var $do78Z;
    var $feQhf;
    function $e88d764a116eddca$export$a070f388fcd93df0(projectKey) {
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [enabled, setEnabled] = (0, $5uXOq.useState)(undefined);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const loadGlobalComponentsProperty = (0, $5uXOq.useCallback)(()=>{
            setEnabled(undefined);
            setError(undefined);
            setLoading(true);
        }, [
            setEnabled,
            setError,
            setLoading
        ]);
        const resolveGlobalComponentsProperty = (0, $5uXOq.useCallback)((value)=>{
            if (value instanceof Error) {
                setEnabled(undefined);
                setError(value);
            } else {
                setEnabled(value);
                setError(undefined);
            }
            setLoading(false);
        }, [
            setEnabled,
            setError,
            setLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            loadGlobalComponentsProperty();
            (0, (0, parcelRequire("feQhf")).getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
        }, [
            loadGlobalComponentsProperty,
            resolveGlobalComponentsProperty,
            projectKey
        ]);
        const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
            loadGlobalComponentsProperty();
            return (0, (0, parcelRequire("feQhf")).setGlobalComponentsProperty)(projectKey, newValue).then(()=>(0, (0, parcelRequire("do78Z")).default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
                resolveGlobalComponentsProperty(e);
                throw e;
            });
        }, [
            loadGlobalComponentsProperty,
            resolveGlobalComponentsProperty,
            projectKey
        ]);
        return {
            enabled: enabled,
            loading: loading,
            error: error,
            setProperty: setProperty
        };
    }
});
parcelRegister("do78Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b15e5e3de311da0$export$2e2bcd8739ae039);
    var $c3jsi;
    var $1AJVB;
    var $2b15e5e3de311da0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c3jsi")).default)((0, (0, parcelRequire("1AJVB")).props));
});
parcelRegister("c3jsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccdca2a0bd8756d7$export$2e2bcd8739ae039);
    var $8Op28;
    const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
    var $ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
        if (!false) {
            const Cache = (0, (0, parcelRequire("8Op28")).default)(config);
            const getAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
            const get = (key)=>Cache.then((cache)=>cache.get(key));
            const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
            const remove = (key)=>Cache.then((cache)=>cache.delete(key));
            const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
            const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
            const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>Promise.all(entries.map(([key])=>cache.delete(key)))).then(()=>{}));
            return {
                get: get,
                getAll: getAll,
                set: set,
                remove: remove,
                update: update,
                refresh: refresh,
                clearAll: clearAll
            };
        }
        return {
            get: $ccdca2a0bd8756d7$var$pNothing,
            getAll: ()=>Promise.resolve([]),
            set: ()=>Promise.resolve(),
            remove: $ccdca2a0bd8756d7$var$pNothing,
            update: $ccdca2a0bd8756d7$var$pNothing,
            refresh: ()=>Promise.resolve([]),
            clearAll: $ccdca2a0bd8756d7$var$pNothing
        };
    };
});
parcelRegister("8Op28", function(module, exports) {
    $parcel$export(module.exports, "Cache", ()=>$3e46065a4b1d2500$export$94affb487e701bf2);
    $parcel$export(module.exports, "default", ()=>$3e46065a4b1d2500$export$2e2bcd8739ae039);
    var $bSSG7;
    var $eNf8a;
    var $dJl1T;
    var $1NZBJ;
    const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
    function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
        const cache = new Map();
        const { size: size } = props;
        let storage;
        let hasSyncedFromStorage = false;
        const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
            name: `Cache ${props.cacheKey}`,
            serialize: true
        }) : null;
        const syncWithDevTools = (type, payload)=>{
            if ((0, (0, parcelRequire("1NZBJ")).default).devTools) devTools && devTools.send({
                type: type,
                payload: payload
            }, cache, {}, props.cacheKey);
        };
        const removeExpiredKeysFromStorage = async (store)=>{
            const updatedStore = {
                ...store
            };
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
            const { cacheKey: cacheKey, maxAge: maxAge } = props;
            if (maxAge !== undefined) {
                Object.keys(store).forEach((key)=>{
                    const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                    if (keyAge > maxAge) {
                        syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                            [String(key)]: updatedStore[key]
                        });
                        delete updatedStore[key];
                        cache.delete(key);
                    }
                });
                storage.set(cacheKey, updatedStore);
            }
            return updatedStore;
        };
        const removeExpiredEntry = (key, val)=>{
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { maxAge: maxAge } = props;
                if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: val
                    });
                    cache.delete(key);
                    return true;
                }
            }
            return false;
        };
        const createStore = ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            else storage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            return storage;
        };
        const set = async (key, value)=>{
            await load();
            cache.delete(key);
            const entry = {
                value: value,
                timestamp: Date.now()
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
                [String(key)]: entry
            });
            if (cache.size > size) {
                const keys = cache.keys();
                const firstEntry = keys.next().value;
                if (firstEntry !== undefined) {
                    cache.delete(firstEntry);
                    syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                    if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) delete storedContent[firstEntry];
                }
            }
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const load = async ()=>{
            if (false || hasSyncedFromStorage) return;
            hasSyncedFromStorage = true;
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            const { cacheKey: cacheKey } = props;
            storage = createStore();
            try {
                let data = storage.get(cacheKey) || {};
                data = await removeExpiredKeysFromStorage(data);
                syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
                const orderedKeys = Object.keys(data).sort((key1, key2)=>data[key1].timestamp - data[key2].timestamp);
                await Promise.all(orderedKeys.map(async (key)=>{
                    await set(key, data[key].value);
                }));
            } catch (err) {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
                throw err;
            }
        };
        const clear = async ()=>{
            await load();
            cache.clear();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { cacheKey: cacheKey } = props;
                storage.remove(cacheKey);
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
        };
        const get = async (key)=>{
            await load();
            let val = cache.get(key);
            if (val) {
                if (removeExpiredEntry(key, val)) val = undefined;
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
                [String(key)]: val
            });
            return val && val.value;
        };
        const update = async (key, value)=>{
            await load();
            const previousValue = cache.get(key);
            if (!previousValue) return;
            const entry = {
                value: value,
                timestamp: previousValue.timestamp
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
                [String(key)]: entry
            });
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const getEntries = async ()=>{
            await load();
            const entries = Array.from(cache.entries()).filter(([key, value])=>!removeExpiredEntry(key, value));
            syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
            return entries.map(([key, { value: value }])=>[
                    key,
                    value
                ]);
        };
        const deleteEntry = async (key)=>{
            await load();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const storedContent = storage.get(props.cacheKey) || {};
                delete storedContent[key];
                storage.set(props.cacheKey, storedContent);
            }
            cache.delete(key);
            syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
                [String(key)]: cache.get(key)
            });
        };
        const refresh = async ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            cache.clear();
            hasSyncedFromStorage = false;
            await load();
        };
        if ((0, (0, parcelRequire("1NZBJ")).default).scopes.current !== (0, (0, parcelRequire("1NZBJ")).default).scopes.prev) clear();
        return {
            cache: cache,
            get: get,
            set: set,
            delete: deleteEntry,
            clear: clear,
            load: load,
            update: update,
            getEntries: getEntries,
            refresh: refresh
        };
    }
    const $3e46065a4b1d2500$var$cacheMap = {};
    const $3e46065a4b1d2500$var$getCache = async (props)=>{
        await (0, (0, parcelRequire("1NZBJ")).scopeGuard)().catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
        });
        const { cacheKey: cacheKey } = props;
        $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
        return $3e46065a4b1d2500$var$cacheMap[cacheKey];
    };
    const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
        Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
    };
    var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;
});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';
parcelRegister("1AJVB", function(module, exports) {
    $parcel$export(module.exports, "props", ()=>$68c0e7b1e3ad3adb$export$8128bb6492cf3de7);
    const $68c0e7b1e3ad3adb$var$MAX_RESULTS = 10;
    const $68c0e7b1e3ad3adb$var$CACHE_SIZE = $68c0e7b1e3ad3adb$var$MAX_RESULTS * 2;
    const $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY = 'components';
    const $68c0e7b1e3ad3adb$export$8128bb6492cf3de7 = {
        size: $68c0e7b1e3ad3adb$var$CACHE_SIZE,
        cacheKey: $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY,
        maxAge: 604800000,
        storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
    };
});
parcelRegister("feQhf", function(module, exports) {
    $parcel$export(module.exports, "getGlobalComponentsProperty", ()=>$f3ade48088ec15c3$export$1db3503600a1638e);
    $parcel$export(module.exports, "setGlobalComponentsProperty", ()=>$f3ade48088ec15c3$export$71702a5b14caff65);
    var $jcw0u;
    var $eusud;
    const $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
    const $f3ade48088ec15c3$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
    const $f3ade48088ec15c3$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
    const $f3ade48088ec15c3$var$getProjectId = async (projectKey)=>{
        const project = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/project/${projectKey}`);
        return project?.id;
    };
    const $f3ade48088ec15c3$export$1db3503600a1638e = async (projectKey)=>{
        try {
            let endpoint;
            if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
                const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
                if (!projectId) return {
                    key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                    value: null
                };
                endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(endpoint);
        } catch (error) {
            if (error.statusCode === 404) return {
                key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getGlobalComponentsProperty',
                    packageName: 'jiraCompassCommon',
                    teamName: 'compass-lodestone'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectKey: projectKey
                }
            });
            throw error;
        }
    };
    async function $f3ade48088ec15c3$export$71702a5b14caff65(projectKey, value) {
        try {
            let endpoint;
            if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
                const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
                if (!projectId) return;
                endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            await (0, (0, parcelRequire("eusud")).performPutRequest)(endpoint, {
                body: JSON.stringify(value)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'setGlobalComponentsProperty',
                    packageName: 'jiraCompassCommon',
                    teamName: 'compass-lodestone'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectKey: projectKey
                }
            });
            throw error;
        }
    }
});
parcelRegister("as9La", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974a261702eec2af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6AKkW;
    var $koVbs;
    var $lElIo;
    var $2Icx9;
    var $lMeVa;
    const $974a261702eec2af$var$ComponentsSelectEdit = (props)=>{
        const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getNewInlineComponentCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, (0, parcelRequire("lMeVa")).default).createNewItem)})`, [
            formatNewInlineComponentCreateLabel,
            formatMessage
        ]);
        const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
            const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
            return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
        }, [
            canCreateNewItem,
            options
        ]);
        const handleInlineComponentCreate = (inputValue)=>{
            onChange([
                ...value || [],
                {
                    label: inputValue,
                    value: null
                }
            ]);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6AKkW")).default), {
            inputId: inputId,
            required: isRequired,
            ...fieldProps,
            value: value,
            options: options,
            placeholder: placeholder || formatMessage((0, (0, parcelRequire("lMeVa")).default).placeholder),
            onChange: onChange,
            onFocus: onFocus,
            onBlur: onBlur,
            autoFocus: autoFocus,
            closeMenuOnScroll: onCloseMenuOnScroll,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            components: {
                MenuList: (menuListProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Icx9")).default), {
                        ...menuListProps,
                        showFooter: showFooter,
                        projectKey: projectKey
                    })
            },
            isMulti: true,
            isDisabled: isDisabled,
            isValidNewOption: isValidNewOption,
            formatCreateLabel: getNewInlineComponentCreateLabel,
            onCreateOption: handleInlineComponentCreate,
            className: "components-field-select",
            classNamePrefix: "components-field-select"
        });
    };
    var $974a261702eec2af$export$2e2bcd8739ae039 = $974a261702eec2af$var$ComponentsSelectEdit;
});
parcelRegister("2Icx9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5b255b0441ea615$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2mHtV;
    var $2JKLA;
    var $koVbs;
    var $dyW5a;
    const $b5b255b0441ea615$var$MenuWithFooter = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).MenuList, restProps, children), showFooter && (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$fd9000017733fabf, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$500fb058ad7aeb1, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$e0513c91be1318ca, {
            href: `/plugins/servlet/project-config/${projectKey}/administer-components`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2mHtV"))))), {
            label: "componentFooterAddIcon",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$var$LinkText, null, footerLabel ?? formatMessage((0, (0, parcelRequire("dyW5a")).default).componentLabel))))));
    };
    var $b5b255b0441ea615$export$2e2bcd8739ae039 = $b5b255b0441ea615$var$MenuWithFooter;
    const $b5b255b0441ea615$var$LinkText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $b5b255b0441ea615$export$fd9000017733fabf = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1yt41bpf _x3dope8f",
                __cmplp.className
            ])
        });
    });
    const $b5b255b0441ea615$export$500fb058ad7aeb1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41r6r _1bsb1osq _irr314ae",
                __cmplp.className
            ])
        });
    });
    const $b5b255b0441ea615$export$e0513c91be1318ca = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dyW5a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86ca6088d964e72a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $86ca6088d964e72a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        componentLabel: {
            "id": "issue-field-components-field.edit.menu.component-label",
            "defaultMessage": "Create new component"
        }
    });
});
parcelRegister("lMeVa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb020ac6d54b422f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fb020ac6d54b422f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-field-components-field.edit.placeholder",
            "defaultMessage": "Select Component"
        },
        createNewItem: {
            "id": "issue-field-components-field.edit.create-new-item",
            "defaultMessage": "New Component"
        }
    });
});
parcelRegister("6Fkzt", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$4d2c67350b914b81$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionsToData", ()=>$4d2c67350b914b81$export$ffef3a401aef987b);
    const $4d2c67350b914b81$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
                label: name,
                value: id
            }));
    const $4d2c67350b914b81$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
                id: value,
                name: label
            }));
});
parcelRegister("b399U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f31bbe63abb7b51a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $f31bbe63abb7b51a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        none: {
            "id": "issue-create-commons.components-field.none",
            "defaultMessage": "None"
        },
        tooltipWhenDisabled: {
            "id": "issue-create-commons.components-field.tooltip-when-disabled",
            "defaultMessage": "We couldn't find any components for this project"
        }
    });
    var $f31bbe63abb7b51a$export$2e2bcd8739ae039 = $f31bbe63abb7b51a$var$messages;
});
parcelRegister("9Hxrl", function(module, exports) {
    $parcel$export(module.exports, "DateCustomFieldTypeConfig", ()=>$bdb941f53f9415a4$export$a7f793e7c226ca61);
    var $5uXOq = parcelRequire("5uXOq");
    var $6XmIG;
    var $iY8FG;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $bdb941f53f9415a4$var$DateCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iY8FG")).default), props);
    const $bdb941f53f9415a4$export$a7f793e7c226ca61 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("6XmIG"))))),
        type: (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        Component: $bdb941f53f9415a4$var$DateCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DateFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).dateFieldWriter)
    };
});
parcelRegister("iY8FG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f022abefd67c0e3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1PqPz;
    var $koVbs;
    var $1p96B;
    var $DVljb;
    var $7C5S0;
    var $hpV4g;
    var $9FL4D;
    var $jGVMX;
    var $eVzdP;
    const $f022abefd67c0e3c$var$DateField = (props)=>{
        const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const weekStartDay = (0, (0, parcelRequire("1p96B")).getLocale)(locale)?.options?.weekStartsOn;
        const safeValue = value === null ? undefined : value;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1PqPz")).default), {
            value: safeValue,
            isDisabled: isReadOnly,
            onChange: onChange,
            autoFocus: autoFocus,
            locale: locale,
            isInvalid: Boolean(error),
            selectProps: {
                onKeyDown: (0, (0, parcelRequire("9FL4D")).preventFormSubmitOnEnterKeyPress)
            },
            weekStartDay: weekStartDay,
            label: formatMessage((0, (0, parcelRequire("eVzdP")).default).ariaLabel),
            "aria-describedby": `${id}-helper`,
            id: id,
            placeholder: formatMessage((0, (0, parcelRequire("eVzdP")).default).placeholder)
        }));
    };
    var $f022abefd67c0e3c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($f022abefd67c0e3c$var$DateField);
});
parcelRegister("1PqPz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7a9ff772bf03053$export$2e2bcd8739ae039);
    var $2oS3b;
    var $ggf8m;
    var $5JmJ5;
    var $j0OrS;
    const $b7a9ff772bf03053$var$DatePicker = (0, (0, parcelRequire("ggf8m")).componentWithCondition)(()=>(0, (0, parcelRequire("2oS3b")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("j0OrS")).default), (0, (0, parcelRequire("5JmJ5")).default));
    var $b7a9ff772bf03053$export$2e2bcd8739ae039 = $b7a9ff772bf03053$var$DatePicker;
});
parcelRegister("ggf8m", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8c8e59faefa0075d$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8c8e59faefa0075d$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("5JmJ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f82d402b9e451fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $4ZiMV;
    var $dvXtt;
    var $7GEKO;
    var $bkJDg;
    var $Zmmeo;
    var $bLDEj;
    var $czw3v;
    var $2oS3b;
    var $6Ll2T;
    var $a95o8;
    var $99gde;
    var $gN6Vx;
    var $crsHE;
    var $AHUyh;
    var $bs2mW;
    var $fe3ss;
    var $VlOuZ;
    var $dcRCd;
    var $dfejw;
    var $bjeU4;
    function $f82d402b9e451fad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f82d402b9e451fad$var$packageName = "platform-pkg";
    const $f82d402b9e451fad$var$packageVersion = "0.0.0-use.local";
    const $f82d402b9e451fad$var$dropdownIndicatorStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $f82d402b9e451fad$var$CalendarIcon = (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("Zmmeo"))))) : (0, ($parcel$interopDefault((0, parcelRequire("bLDEj")))));
    const $f82d402b9e451fad$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $f82d402b9e451fad$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $f82d402b9e451fad$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`
        }
    });
    const $f82d402b9e451fad$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $f82d402b9e451fad$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $f82d402b9e451fad$var$calendarButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $f82d402b9e451fad$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $f82d402b9e451fad$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props);
            this.containerRef = null;
            this.calendarRef = (0, $5uXOq.createRef)();
            this.calendarButtonRef = (0, $5uXOq.createRef)();
            this.getValue = ()=>this.props.value ?? this.state.value;
            this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen;
            this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("fe3ss")).getParsedISO)({
                        iso: iso
                    })
                });
            };
            this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            };
            this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            };
            this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            };
            this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            };
            this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("fe3ss")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("dfejw")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            };
            this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("fe3ss")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("dfejw")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (this.state.isOpen && !this.state.shouldSetFocusOnCurrentDay) this.setState({
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            };
            this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            };
            this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            };
            this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            };
            this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            };
            this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            };
            this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("czw3v")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("czw3v")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $f82d402b9e451fad$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                    xcss: $f82d402b9e451fad$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("bjeU4")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("bs2mW")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("VlOuZ")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("dcRCd")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("bs2mW")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("dfejw")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("crsHE")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("fe3ss")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $f82d402b9e451fad$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gN6Vx")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("fe3ss")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bkJDg")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $f82d402b9e451fad$var$iconContainerStyles,
                        value && !hideIcon ? $f82d402b9e451fad$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStylesNew : $f82d402b9e451fad$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $f82d402b9e451fad$var$calendarButtonStyles,
                        (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') && $f82d402b9e451fad$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($f82d402b9e451fad$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $f82d402b9e451fad$var$DatePicker = (0, (0, parcelRequire("dvXtt")).default)({
        componentName: 'datePicker',
        packageName: $f82d402b9e451fad$var$packageName,
        packageVersion: $f82d402b9e451fad$var$packageVersion
    })((0, (0, parcelRequire("7GEKO")).default)({
        onChange: (0, (0, parcelRequire("4ZiMV")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $f82d402b9e451fad$var$packageName,
                packageVersion: $f82d402b9e451fad$var$packageVersion
            }
        })
    })($f82d402b9e451fad$export$df43d21f5faca9f7));
    var $f82d402b9e451fad$export$2e2bcd8739ae039 = $f82d402b9e451fad$var$DatePicker;
});
parcelRegister("Zmmeo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0b870a5dd988cc2f$var$_react = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0b870a5dd988cc2f$var$_calendar = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("lL8mO")));
    var $0b870a5dd988cc2f$var$_calendar2 = $0b870a5dd988cc2f$var$_interopRequireDefault((parcelRequire("bLDEj")));
    function $0b870a5dd988cc2f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0b870a5dd988cc2f$var$CalendarIcon = (props)=>$0b870a5dd988cc2f$var$_react.default.createElement($0b870a5dd988cc2f$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $0b870a5dd988cc2f$var$_calendar2.default
        }, props));
    $0b870a5dd988cc2f$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $0b870a5dd988cc2f$var$_default = module.exports.default = $0b870a5dd988cc2f$var$CalendarIcon;
});
parcelRegister("czw3v", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$047faaad49e2ca54$export$ea56ca58f08ffa52);
    var $kaZ5I;
    var $bciOi;
    var $foH1K;
    const $047faaad49e2ca54$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("kaZ5I")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("bciOi")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("foH1K")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("foH1K")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("kaZ5I", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$9ca0adfc15679689$export$dca0327c9b9c6498);
    const $9ca0adfc15679689$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("bciOi", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$f81fbac7b9fa6173$export$cfa2ef2687faeda2);
    var $adbFL;
    var $kaZ5I;
    const $f81fbac7b9fa6173$var$INVALID_DATE = new Date(NaN);
    const $f81fbac7b9fa6173$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $f81fbac7b9fa6173$var$INVARIANT_DATE = (0, (0, parcelRequire("adbFL")).toDate)($f81fbac7b9fa6173$var$INVARIANT);
    const $f81fbac7b9fa6173$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $f81fbac7b9fa6173$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $f81fbac7b9fa6173$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $f81fbac7b9fa6173$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $f81fbac7b9fa6173$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("kaZ5I")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($f81fbac7b9fa6173$var$INVARIANT_DATE);
        const shortDate = $f81fbac7b9fa6173$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($f81fbac7b9fa6173$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $f81fbac7b9fa6173$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($f81fbac7b9fa6173$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($f81fbac7b9fa6173$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($f81fbac7b9fa6173$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $f81fbac7b9fa6173$var$stripExtras(date).match($f81fbac7b9fa6173$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $f81fbac7b9fa6173$var$INVALID_DATE;
            const dateParts = $f81fbac7b9fa6173$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("adbFL")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("adbFL")).isValid)(normalizedDate)) return $f81fbac7b9fa6173$var$INVALID_DATE;
            return (0, (0, parcelRequire("adbFL")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("adbFL", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$cc7776c87982d016$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$cc7776c87982d016$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$cc7776c87982d016$export$fcc71269590ba0a8);
    const $cc7776c87982d016$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $cc7776c87982d016$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $cc7776c87982d016$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $cc7776c87982d016$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $cc7776c87982d016$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $cc7776c87982d016$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $cc7776c87982d016$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $cc7776c87982d016$export$fcc71269590ba0a8 = (date)=>{
        const now = $cc7776c87982d016$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("foH1K", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$3ff49b479a5f8f06$export$9b7ca29af37c192);
    const $3ff49b479a5f8f06$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("bs2mW", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$83fe1f9bc0251903$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$83fe1f9bc0251903$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$83fe1f9bc0251903$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$83fe1f9bc0251903$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$83fe1f9bc0251903$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$83fe1f9bc0251903$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$83fe1f9bc0251903$export$2eeb05a2ecc2ce0a);
    const $83fe1f9bc0251903$export$5e30e9a24d6c1203 = ()=>null;
    const $83fe1f9bc0251903$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $83fe1f9bc0251903$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $83fe1f9bc0251903$export$9e6d8fcf62256b85 = 'h:mma';
    const $83fe1f9bc0251903$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $83fe1f9bc0251903$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $83fe1f9bc0251903$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("fe3ss", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$3668e6d89a8f2990$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$3668e6d89a8f2990$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$3668e6d89a8f2990$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$3668e6d89a8f2990$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$3668e6d89a8f2990$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $uTa2o;
    var $bs2mW;
    const $3668e6d89a8f2990$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $3668e6d89a8f2990$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("bs2mW")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $3668e6d89a8f2990$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("bs2mW")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $3668e6d89a8f2990$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("bs2mW")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("uTa2o")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $3668e6d89a8f2990$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("bs2mW")).placeholderDatetime));
    };
});
parcelRegister("uTa2o", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$6653de9d6f157fc3$export$4d5430175be73d45);
    const $6653de9d6f157fc3$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $6653de9d6f157fc3$var$v1tokens = Object.keys($6653de9d6f157fc3$var$tokensMap).sort().reverse();
    const $6653de9d6f157fc3$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $6653de9d6f157fc3$var$v1tokens.join('|') + '|.)', 'g');
    function $6653de9d6f157fc3$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($6653de9d6f157fc3$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $6653de9d6f157fc3$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("VlOuZ", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$387a1fc7d4da19ac$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $2JKLA;
    function $387a1fc7d4da19ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $387a1fc7d4da19ac$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $387a1fc7d4da19ac$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $387a1fc7d4da19ac$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $387a1fc7d4da19ac$var$calendarButtonInclusionStyles : $387a1fc7d4da19ac$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).IndicatorsContainer, rest));
});
parcelRegister("dcRCd", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$6ff67a91201a79f3$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $kYQh1;
    var $8ftoa;
    var $bUQGL;
    var $kcwgO;
    function $6ff67a91201a79f3$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $6ff67a91201a79f3$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("bUQGL")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $72ba03e317f3d228$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $72ba03e317f3d228$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $6ff67a91201a79f3$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $6ff67a91201a79f3$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        const onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8ftoa")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kcwgO")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $6ff67a91201a79f3$var$menuStyles,
                ...innerProps,
                onMouseDown: onMenuMouseDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kYQh1")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("kYQh1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02d6b440f1b43dcd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $gCBvJ;
    var $bkJDg;
    var $6Ll2T;
    var $k0Jvh;
    var $99gde;
    var $3GUIq;
    var $jOPPf;
    var $ijHGX;
    var $dCeMv;
    var $cmovf;
    var $d6s06;
    var $i7w6K;
    var $5u0Mq;
    var $gIplh;
    var $iSoE5;
    const $02d6b440f1b43dcd$var$boxStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $02d6b440f1b43dcd$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $02d6b440f1b43dcd$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("dCeMv")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("dCeMv")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("gCBvJ")).default), onChange: onChange = (0, (0, parcelRequire("gCBvJ")).default), onFocus: onFocus = (0, (0, parcelRequire("gCBvJ")).default), onSelect: onSelect = (0, (0, parcelRequire("gCBvJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("cmovf")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$02d6b440f1b43dcd$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("5u0Mq")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$02d6b440f1b43dcd$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("gIplh")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("d6s06")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("iSoE5")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("i7w6K")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("bkJDg")).useId)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $02d6b440f1b43dcd$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k0Jvh")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3GUIq")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ijHGX")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jOPPf")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        })))));
    });
    const $02d6b440f1b43dcd$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($02d6b440f1b43dcd$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $02d6b440f1b43dcd$var$Calendar.displayName = 'Calendar';
    var $02d6b440f1b43dcd$export$2e2bcd8739ae039 = $02d6b440f1b43dcd$var$Calendar;
});
parcelRegister("3GUIq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31ae19bb9453b0ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9jNMw;
    var $bkJDg;
    var $cZ1Pf;
    var $asmPY;
    var $80QIn;
    var $6Ll2T;
    var $fm763;
    const $31ae19bb9453b0ed$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("bkJDg")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9jNMw")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("asmPY"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cZ1Pf")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9jNMw")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("80QIn"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $31ae19bb9453b0ed$var$Header.displayName = 'Header';
    var $31ae19bb9453b0ed$export$2e2bcd8739ae039 = $31ae19bb9453b0ed$var$Header;
});
parcelRegister("asmPY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $79ce3be6fdbee77d$var$_react = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $79ce3be6fdbee77d$var$_chevronLeft = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("fY25f")));
    var $79ce3be6fdbee77d$var$_chevronLeftLarge = $79ce3be6fdbee77d$var$_interopRequireDefault((parcelRequire("f7JN7")));
    function $79ce3be6fdbee77d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $79ce3be6fdbee77d$var$ChevronLeftIcon = (props)=>$79ce3be6fdbee77d$var$_react.default.createElement($79ce3be6fdbee77d$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $79ce3be6fdbee77d$var$_chevronLeftLarge.default
        }, props));
    $79ce3be6fdbee77d$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $79ce3be6fdbee77d$var$_default = module.exports.default = $79ce3be6fdbee77d$var$ChevronLeftIcon;
});
parcelRegister("fY25f", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b9fe135dcc94eb49$var$_react = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b9fe135dcc94eb49$var$_UNSAFE_baseNew = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $b9fe135dcc94eb49$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b9fe135dcc94eb49$var$ChevronLeftIcon = (props)=>$b9fe135dcc94eb49$var$_react.default.createElement($b9fe135dcc94eb49$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $b9fe135dcc94eb49$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $b9fe135dcc94eb49$var$_default = module.exports.default = $b9fe135dcc94eb49$var$ChevronLeftIcon;
});
parcelRegister("f7JN7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b02b07a3c9f0c0ab$var$_react = $b02b07a3c9f0c0ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $b02b07a3c9f0c0ab$var$_chevronLeft = $b02b07a3c9f0c0ab$var$_interopRequireDefault((parcelRequire("fY25f")));
    function $b02b07a3c9f0c0ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon = (props)=>$b02b07a3c9f0c0ab$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $b02b07a3c9f0c0ab$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $b02b07a3c9f0c0ab$var$_default = module.exports.default = $b02b07a3c9f0c0ab$var$ChevronLeftLargeIcon;
});
parcelRegister("80QIn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d5736e094bab377$var$_react = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5d5736e094bab377$var$_chevronRight = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("jkePi")));
    var $5d5736e094bab377$var$_chevronRightLarge = $5d5736e094bab377$var$_interopRequireDefault((parcelRequire("4T92P")));
    function $5d5736e094bab377$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d5736e094bab377$var$ChevronRightIcon = (props)=>$5d5736e094bab377$var$_react.default.createElement($5d5736e094bab377$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $5d5736e094bab377$var$_chevronRightLarge.default
        }, props));
    $5d5736e094bab377$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $5d5736e094bab377$var$_default = module.exports.default = $5d5736e094bab377$var$ChevronRightIcon;
});
parcelRegister("4T92P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $38f3508bf8b7f617$var$_react = $38f3508bf8b7f617$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $38f3508bf8b7f617$var$_chevronRight = $38f3508bf8b7f617$var$_interopRequireDefault((parcelRequire("jkePi")));
    function $38f3508bf8b7f617$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $38f3508bf8b7f617$var$ChevronRightLargeIcon = (props)=>$38f3508bf8b7f617$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $38f3508bf8b7f617$var$_chevronRight.default,
            iconType: "utility"
        }));
    $38f3508bf8b7f617$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $38f3508bf8b7f617$var$_default = module.exports.default = $38f3508bf8b7f617$var$ChevronRightLargeIcon;
});
parcelRegister("jOPPf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1debce2d24cddd8b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $ciaUb;
    var $kTVUo;
    const $1debce2d24cddd8b$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kTVUo")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ciaUb")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $1debce2d24cddd8b$var$WeekDays.displayName = 'WeekDays';
    var $1debce2d24cddd8b$export$2e2bcd8739ae039 = $1debce2d24cddd8b$var$WeekDays;
});
parcelRegister("ciaUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a38e4fc2d454c91d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gCBvJ;
    var $2NYPZ;
    var $8se5h;
    const $a38e4fc2d454c91d$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("gCBvJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("8se5h")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NYPZ")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $a38e4fc2d454c91d$var$Date.displayName = 'Date';
    var $a38e4fc2d454c91d$export$2e2bcd8739ae039 = $a38e4fc2d454c91d$var$Date;
});
parcelRegister("8se5h", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$027048cc62663b6f$export$f62807af68630d86);
    const $027048cc62663b6f$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("kTVUo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$892d99999f450b8d$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2NYPZ;
    const $892d99999f450b8d$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2NYPZ")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $892d99999f450b8d$export$2e2bcd8739ae039 = $892d99999f450b8d$var$WeekDayGrid;
});
parcelRegister("ijHGX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b57d282f034f3ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $kTVUo;
    const $3b57d282f034f3ec$var$columnHeaderStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $3b57d282f034f3ec$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kTVUo")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                padding: "space.100",
                xcss: $3b57d282f034f3ec$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $3b57d282f034f3ec$var$WeekHeader.displayName = 'WeekHeader';
    var $3b57d282f034f3ec$export$2e2bcd8739ae039 = $3b57d282f034f3ec$var$WeekHeader;
});
parcelRegister("dCeMv", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$e2e59ee8d488f5cc$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$e2e59ee8d488f5cc$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$e2e59ee8d488f5cc$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$e2e59ee8d488f5cc$export$8fa20d70624f8b9d);
    const $e2e59ee8d488f5cc$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $e2e59ee8d488f5cc$export$3ae905d9742bef55 = 7;
    const $e2e59ee8d488f5cc$export$c9b7c010035d60c6 = 12;
    const $e2e59ee8d488f5cc$export$8fa20d70624f8b9d = [];
});
parcelRegister("cmovf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e312976738ceb23$export$2e2bcd8739ae039);
    var $cI4Vd;
    var $4Ybnr;
    var $2Coha;
    function $1e312976738ceb23$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("4Ybnr")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("cI4Vd")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("cI4Vd")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("cI4Vd")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("cI4Vd")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("2Coha")).default)(thisMonth)}-${(0, (0, parcelRequire("2Coha")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("cI4Vd")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("cI4Vd")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("2Coha", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d50e0112bd0e0be$export$2e2bcd8739ae039);
    function $8d50e0112bd0e0be$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("d6s06", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e42ef4255870deb3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $e42ef4255870deb3$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("i7w6K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b0bdc97ebc874dd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $dCeMv;
    var $dgjvv;
    var $61dkV;
    function $6b0bdc97ebc874dd$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("dCeMv")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("61dkV")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("dCeMv")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $6b0bdc97ebc874dd$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("61dkV")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $6b0bdc97ebc874dd$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("dgjvv")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("dgjvv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac834acee3d5efb8$export$2e2bcd8739ae039);
    var $2Coha;
    function $ac834acee3d5efb8$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("2Coha")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("2Coha")).default)(date.day)}`;
    }
});
parcelRegister("61dkV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7aa43d5fe6f4c0f9$export$2e2bcd8739ae039);
    var $dCeMv;
    var $lRz9J;
    function $7aa43d5fe6f4c0f9$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("dCeMv")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("dCeMv")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("lRz9J")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("dCeMv")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("lRz9J")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("dCeMv")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("dCeMv")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("dCeMv")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("dCeMv")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("dCeMv")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("lRz9J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$734856d8c616cad9$export$2e2bcd8739ae039);
    function $734856d8c616cad9$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("5u0Mq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd9ee79f364c0103$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dCeMv;
    var $dgjvv;
    var $lRz9J;
    const $fd9ee79f364c0103$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("dCeMv")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $fd9ee79f364c0103$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("dCeMv")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $fd9ee79f364c0103$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("dgjvv")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("dCeMv")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("lRz9J")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $fd9ee79f364c0103$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $fd9ee79f364c0103$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("lRz9J")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("lRz9J")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $fd9ee79f364c0103$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("dCeMv")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $fd9ee79f364c0103$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("lRz9J")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$fd9ee79f364c0103$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$fd9ee79f364c0103$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("gIplh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1ab74d3a687b21b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dCeMv;
    var $dgjvv;
    function $b1ab74d3a687b21b$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("dgjvv")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("dCeMv")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("iSoE5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$389da60b06bc3c2f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $czw3v;
    function $389da60b06bc3c2f$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("czw3v")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("kcwgO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d32ccb92d217080c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gCBvJ;
    var $bH6vj;
    var $hRbZE;
    var $itR3E;
    var $71yya;
    var $bUQGL;
    class $d32ccb92d217080c$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("bH6vj")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("bUQGL")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hRbZE")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71yya")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("itR3E")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("bUQGL")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args);
            this.update = (0, (0, parcelRequire("gCBvJ")).default);
        }
    }
});
parcelRegister("dfejw", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$c43aa0d990fc9aec$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$c43aa0d990fc9aec$export$ff525416014fb67d);
    var $k7m40;
    var $uTa2o;
    function $c43aa0d990fc9aec$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("uTa2o")).convertTokens)('YYYY-MM-DD'));
    }
    function $c43aa0d990fc9aec$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $c43aa0d990fc9aec$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("bjeU4", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$f9cee91e1b5ee962$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    const $f9cee91e1b5ee962$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("j0OrS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62d63fe30176b88d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $2cjvv;
    var $bkJDg;
    var $Zmmeo;
    var $bLDEj;
    var $czw3v;
    var $2oS3b;
    var $6Ll2T;
    var $a95o8;
    var $99gde;
    var $gN6Vx;
    var $crsHE;
    var $AHUyh;
    var $bs2mW;
    var $fe3ss;
    var $VlOuZ;
    var $dcRCd;
    var $dfejw;
    var $bjeU4;
    function $62d63fe30176b88d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $62d63fe30176b88d$var$packageName = "platform-pkg";
    const $62d63fe30176b88d$var$packageVersion = "0.0.0-use.local";
    const $62d63fe30176b88d$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $62d63fe30176b88d$var$packageName,
        packageVersion: $62d63fe30176b88d$var$packageVersion
    };
    const $62d63fe30176b88d$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $62d63fe30176b88d$var$dropdownIndicatorStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $62d63fe30176b88d$var$CalendarIcon = (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("Zmmeo"))))) : (0, ($parcel$interopDefault((0, parcelRequire("bLDEj")))));
    const $62d63fe30176b88d$var$iconContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $62d63fe30176b88d$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("99gde")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $62d63fe30176b88d$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $62d63fe30176b88d$var$calendarButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $62d63fe30176b88d$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $62d63fe30176b88d$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("czw3v")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$62d63fe30176b88d$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("czw3v")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("fe3ss")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("fe3ss")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("dfejw")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("fe3ss")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("dfejw")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (isOpen && !shouldSetFocusOnCurrentDay) setShouldSetFocusOnCurrentDay(true);
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("dfejw")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $62d63fe30176b88d$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("bjeU4")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("bs2mW")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("VlOuZ")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("dcRCd")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("bs2mW")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("dfejw")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("crsHE")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("fe3ss")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("bkJDg")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $62d63fe30176b88d$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gN6Vx")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("fe3ss")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $62d63fe30176b88d$var$iconContainerStyles,
                value && !hideIcon ? $62d63fe30176b88d$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStylesNew : $62d63fe30176b88d$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $62d63fe30176b88d$var$calendarButtonStyles,
                (0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') && $62d63fe30176b88d$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($62d63fe30176b88d$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $62d63fe30176b88d$export$2e2bcd8739ae039 = $62d63fe30176b88d$var$DatePicker;
});
parcelRegister("9FL4D", function(module, exports) {
    $parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", ()=>$ee02e7651d6a8221$export$9d2267fe165de4b6);
    const $ee02e7651d6a8221$export$9d2267fe165de4b6 = (event)=>{
        event.key === 'Enter' && event.preventDefault();
    };
});
parcelRegister("eVzdP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049ff715c3e8bf03$export$2e2bcd8739ae039);
    var $7VHMR;
    const $049ff715c3e8bf03$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-create-commons.date-field.placeholder",
            "defaultMessage": "Select date"
        },
        ariaLabel: {
            "id": "issue-create-commons.date-field.aria-label",
            "defaultMessage": "Enter a Date"
        }
    });
    var $049ff715c3e8bf03$export$2e2bcd8739ae039 = $049ff715c3e8bf03$var$messages;
});
parcelRegister("bunMY", function(module, exports) {
    $parcel$export(module.exports, "DateTimeCustomFieldTypeConfig", ()=>$f1af920deed83f57$export$f2143df7edd6483d);
    var $5uXOq = parcelRequire("5uXOq");
    var $6XmIG;
    var $fpis9;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $f1af920deed83f57$var$DateTimeCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fpis9")).default), props);
    const $f1af920deed83f57$export$f2143df7edd6483d = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("6XmIG"))))),
        type: (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
        Component: $f1af920deed83f57$var$DateTimeCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DateTimeFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).dateTimeFieldWriter)
    };
});
parcelRegister("fpis9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9d01bc814484554$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cHu6v;
    var $lfTZh;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $9FL4D;
    var $jGVMX;
    var $lkRXf;
    const $a9d01bc814484554$export$ae1ced156568f0b0 = (props)=>{
        const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleChange = (dateTimeValue)=>{
            onChange(dateTimeValue || '');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "date-time-field-edit-view",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHu6v")).AsyncDateTimeFieldEditView), {
            label: fieldName,
            ...fieldProps,
            isDisabled: isDisabled || isReadOnly,
            autoFocus: autoFocus,
            value: value,
            onChange: handleChange,
            isInvalid: Boolean(error),
            datePickerProps: {
                selectProps: {
                    onKeyDown: (0, (0, parcelRequire("9FL4D")).preventFormSubmitOnEnterKeyPress)
                },
                placeholder: formatMessage((0, (0, parcelRequire("lkRXf")).default).datePickerPlaceholder)
            },
            timePickerProps: {
                placeholder: formatMessage((0, (0, parcelRequire("lkRXf")).default).timePickerPlaceholder)
            }
        })));
    };
    var $a9d01bc814484554$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($a9d01bc814484554$export$ae1ced156568f0b0);
});
parcelRegister("cHu6v", function(module, exports) {
    $parcel$export(module.exports, "AsyncDateTimeFieldEditView", ()=>$f165d6e156b4ac02$export$657a1b8545a979b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $fwbTL;
    const $f165d6e156b4ac02$var$EMPTY_OBJECT = {};
    const $f165d6e156b4ac02$export$657a1b8545a979b8 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("fwbTL")).asyncDateTimeFieldEditViewEntrypoint), $f165d6e156b4ac02$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "async-jira-issue-field-date-time-edit-view",
            packageName: "jira-issue-field-date-time",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                width: "350px",
                height: "40px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("fwbTL", function(module, exports) {
    $parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", ()=>$d8c60609c3da1617$export$971e82244ad6d423);
    var $evanD;
    var $7KfpL;
    const $d8c60609c3da1617$export$971e82244ad6d423 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("iS54p")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
            moduleId: "267b9282"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("iS54p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hoRHv").then(()=>parcelRequire('7p4p7'));
});
parcelRegister("bGEod", function(module, exports) {
    $parcel$export(module.exports, "FieldLoader", ()=>$6a1003bb52c05df4$export$dbd27b551621740c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    const $6a1003bb52c05df4$export$dbd27b551621740c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "350px",
            height: "40px"
        });
});
parcelRegister("lkRXf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb6bff0fa93541ec$export$2e2bcd8739ae039);
    var $7VHMR;
    const $bb6bff0fa93541ec$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        datePickerPlaceholder: {
            "id": "issue-create-commons.date-time-field.date-picker-placeholder",
            "defaultMessage": "Select date"
        },
        timePickerPlaceholder: {
            "id": "issue-create-commons.date-time-field.time-picker-placeholder",
            "defaultMessage": "Select time"
        }
    });
    var $bb6bff0fa93541ec$export$2e2bcd8739ae039 = $bb6bff0fa93541ec$var$messages;
});
parcelRegister("bxMnv", function(module, exports) {
    $parcel$export(module.exports, "DescriptionFieldTypeConfig", ()=>$72a9f72b3b249b64$export$efd98ef2e1e5f7e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $HDQ7u;
    var $5fc53;
    var $9gHYS;
    var $hDpqy;
    var $kShoa;
    const $72a9f72b3b249b64$var$DescriptionFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDpqy")).default), {
            ...props,
            defaultValue: undefined,
            fieldWrapperElement: null,
            mediaUploadContext: props.mediaUploadContexts.uploadContext
        });
    const $72a9f72b3b249b64$export$efd98ef2e1e5f7e9 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("HDQ7u"))))),
        type: (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE),
        Component: $72a9f72b3b249b64$var$DescriptionFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DescriptionFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).descriptionFieldWriter)
    };
});
parcelRegister("HDQ7u", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0832eb9702ec6614$var$_react = $0832eb9702ec6614$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0832eb9702ec6614$var$_UNSAFE_baseNew = $0832eb9702ec6614$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $0832eb9702ec6614$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0832eb9702ec6614$var$TextIcon = (props)=>$0832eb9702ec6614$var$_react.default.createElement($0832eb9702ec6614$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.063 1.75H2.75V5m5.313-3.25h5.187V5M8.063 1.75v12.5m0 0H10.5m-2.437 0H5.5"/>`
        }, props));
    $0832eb9702ec6614$var$TextIcon.displayName = 'TextIcon';
    var $0832eb9702ec6614$var$_default = module.exports.default = $0832eb9702ec6614$var$TextIcon;
});
parcelRegister("hDpqy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef1b91f5985cb5ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7C5S0;
    var $hpV4g;
    var $h0fZ7;
    var $9GobK;
    const $ef1b91f5985cb5ff$export$336230c809f2ec53 = (props)=>{
        const editorKey = (0, $5uXOq.useRef)(Date.now());
        const { fieldProps: { value: value, onChange: onChange }, mediaUploadContext: mediaUploadContext } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: "100%"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9GobK")).DescriptionEdit), {
            key: editorKey.current,
            onChange: onChange,
            defaultValue: value,
            mediaContext: {
                viewContext: mediaUploadContext || {},
                uploadContext: mediaUploadContext,
                userAuth: null
            }
        }));
    };
    const $ef1b91f5985cb5ff$var$DescriptionFormField = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("h0fZ7")).validateDescriptionField)
    })($ef1b91f5985cb5ff$export$336230c809f2ec53);
    var $ef1b91f5985cb5ff$export$2e2bcd8739ae039 = $ef1b91f5985cb5ff$var$DescriptionFormField;
});
parcelRegister("h0fZ7", function(module, exports) {
    $parcel$export(module.exports, "sanitizeADFField", ()=>$e0781922eb7ae616$export$28941b736a01da7b);
    $parcel$export(module.exports, "mutateADFField", ()=>$e0781922eb7ae616$export$82a40b3982cf31c4);
    $parcel$export(module.exports, "validateDescriptionField", ()=>$e0781922eb7ae616$export$78b1417f15a51a4f);
    var $fr1K2 = parcelRequire("fr1K2");
    var $lMkQE;
    var $jcw0u;
    var $4R6GH;
    var $bGrWH;
    const $e0781922eb7ae616$var$emptyADFString = JSON.stringify((0, (0, parcelRequire("lMkQE")).getEmptyADF)());
    const $e0781922eb7ae616$export$28941b736a01da7b = (adfValue)=>{
        if (adfValue?.overrideRequired || adfValue?.resetRequired) (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'adfObjectTypeErrorIssueCreate',
                packageName: 'jiraIssueCreateModal',
                teamName: 'gryffindor'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const sanitizedValue = (0, ($parcel$interopDefault($fr1K2)))(adfValue, [
            'overrideRequired',
            'resetRequired'
        ]);
        return sanitizedValue;
    };
    const $e0781922eb7ae616$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('adf_validation_backend_interaction_issue_create')) {
            const adfValueString = JSON.stringify(adfValue);
            return $e0781922eb7ae616$var$emptyADFString === adfValueString ? null : {
                fieldId: fieldId,
                mutationGroup: (0, $6aa4505c49fca768$export$31fd86f8f183952c),
                richText: {
                    adfValue: adfValue
                }
            };
        }
        const sanitizedValue = $e0781922eb7ae616$export$28941b736a01da7b(adfValue);
        const sanitizedADFValueString = JSON.stringify(sanitizedValue);
        return $e0781922eb7ae616$var$emptyADFString === sanitizedADFValueString ? null : {
            fieldId: fieldId,
            mutationGroup: (0, $6aa4505c49fca768$export$31fd86f8f183952c),
            richText: {
                adfValue: sanitizedValue
            }
        };
    };
    const $e0781922eb7ae616$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
        if (!isRequired) return undefined;
        const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, (0, parcelRequire("lMkQE")).getEmptyADF)());
        if (isAdfEmptyOrUndefined) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        const hardBreakNodeType = 'hardBreak';
        let isAnythingThereApartFromHardBreaks = false;
        if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
            const block = adfValue.content[i];
            const blockContent = block.content;
            isAnythingThereApartFromHardBreaks = blockContent?.some((blockItem)=>blockItem.type !== hardBreakNodeType);
            if (isAnythingThereApartFromHardBreaks) break;
        }
        if (isAnythingThereApartFromHardBreaks) return undefined;
        return 0, (0, parcelRequire("bGrWH")).REQUIRED;
    };
});
const $6aa4505c49fca768$export$31fd86f8f183952c = 'richTextFields';
parcelRegister("9GobK", function(module, exports) {
    $parcel$export(module.exports, "DescriptionEdit", ()=>$91ea1cf50c5539fa$export$cd5df8eea6a360e2);
    var $5uXOq = parcelRequire("5uXOq");
    var $lTi0t;
    var $1wbtX;
    var $9ah8z;
    var $lfTZh;
    const $91ea1cf50c5539fa$export$cd5df8eea6a360e2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "smart-card-provider",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
                height: "150px",
                width: "auto"
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lTi0t")).SmartCardProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ah8z")).AsyncRichTextEditView), props)));
});
parcelRegister("9ah8z", function(module, exports) {
    $parcel$export(module.exports, "AsyncRichTextEditView", ()=>$5d9d583311ca074a$export$ba962c8a1ae57ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $30zeq;
    const $5d9d583311ca074a$var$EMPTY_OBJECT = {};
    const $5d9d583311ca074a$export$ba962c8a1ae57ac = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("30zeq")).asyncRichTextEditEntryPoint), $5d9d583311ca074a$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-issue-field-rich-text-edit-async",
            packageName: "jira-issue-field-rich-text",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                height: "150px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("30zeq", function(module, exports) {
    $parcel$export(module.exports, "asyncRichTextEditEntryPoint", ()=>$33d1c4c4e757e553$export$153c0381975152a7);
    var $evanD;
    var $7KfpL;
    const $33d1c4c4e757e553$export$153c0381975152a7 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("74Gma")).then((module)=>module.EntryPointContent), {
            moduleId: "7ade4e9b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("74Gma", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gNIa8")
    ]).then(()=>parcelRequire('dhLv0'));
});
parcelRegister("iNY3w", function(module, exports) {
    $parcel$export(module.exports, "DueDateFieldTypeConfig", ()=>$c9f18c52a31bf116$export$1f36cc37f9d9ead0);
    var $5uXOq = parcelRequire("5uXOq");
    var $6XmIG;
    var $iY8FG;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $c9f18c52a31bf116$var$DueDateFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iY8FG")).default), props);
    const $c9f18c52a31bf116$export$1f36cc37f9d9ead0 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("6XmIG"))))),
        type: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
        Component: $c9f18c52a31bf116$var$DueDateFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DateFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).dateFieldWriter)
    };
});
parcelRegister("jbGY4", function(module, exports) {
    $parcel$export(module.exports, "GroupCustomFieldTypeConfig", ()=>$6b8eaafecaddddf0$export$fcafcf9905a0ab43);
    var $5uXOq = parcelRequire("5uXOq");
    var $3XWBa;
    var $3Z98Z;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $6b8eaafecaddddf0$var$GroupCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z98Z")).default), props);
    const $6b8eaafecaddddf0$export$fcafcf9905a0ab43 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("3XWBa"))))),
        type: (0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE),
        Component: $6b8eaafecaddddf0$var$GroupCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).singleGroupPickerFieldWriter)
    };
});
parcelRegister("3Z98Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ebb6e060acd861c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9EuZf;
    var $5fnvk;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $d8h6M;
    const $4ebb6e060acd861c$var$SingleGroupPickerField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
        const getExtraProps = ()=>{
            if (isDropdownMenuFixedAndLayered) return {
                menuPosition: 'fixed',
                groupPickerStyles: (0, (0, parcelRequire("9EuZf")).defaultUserPickerStyles),
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
            return {
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fnvk")).default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            autoFocus: autoFocus,
            isMulti: false,
            "aria-labelledby": ariaLabelledBy,
            width: width,
            isInvalid: Boolean(error),
            placeholder: " ",
            ...getExtraProps()
        });
    };
    var $4ebb6e060acd861c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateGroupPickerField),
        transformDefaultValue: (0, (0, parcelRequire("d8h6M")).transformGroupDefaultValueToUserOption)
    })($4ebb6e060acd861c$var$SingleGroupPickerField);
});
parcelRegister("9EuZf", function(module, exports) {
    $parcel$export(module.exports, "defaultUserPickerStyles", ()=>$378ea0219a6c1ff7$export$ddd4b90ea2d7a329);
    var $gwIPs;
    const $378ea0219a6c1ff7$export$ddd4b90ea2d7a329 = {
        menuPortal: (base)=>({
                ...base,
                zIndex: String((0, (0, parcelRequire("gwIPs")).layers).modal)
            })
    };
});
parcelRegister("5fnvk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81263082e0845513$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $kEnpg;
    var $koVbs;
    var $arYvt;
    var $hSBXu;
    var $lGKF5;
    var $3PgDR;
    const $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
    const $81263082e0845513$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: searchDebounceTimeout = $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const previousQuery = (0, $5uXOq.useRef)('');
        const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, (0, parcelRequire("hSBXu")).default)(autoCompleteUrl || '');
        const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(false);
        const getUserPickerControlStyle = (0, $5uXOq.useCallback)((styles)=>{
            if (isInvalid === true) return {
                ...styles,
                ...(0, (0, parcelRequire("3PgDR")).invalidStateStyle)
            };
            return styles;
        }, [
            isInvalid
        ]);
        const handleSearch = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((query)=>{
                setIsDropdownVisible(!!query);
                if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
                previousQuery.current = query || '';
            }, searchDebounceTimeout), [
            fetchGroups,
            previousQuery,
            searchDebounceTimeout
        ]);
        const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
            setIsDropdownVisible(true);
            onFocus?.(sessionId);
            if (!groups || !groups.length) fetchGroups();
        }, [
            fetchGroups,
            groups,
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
            setIsDropdownVisible(false);
            onBlur?.(sessionId);
            previousQuery.current = '';
        }, [
            onBlur,
            previousQuery
        ]);
        const handleOnChange = (updatedValue)=>{
            onChange(updatedValue);
        };
        const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(group));
        const onClear = ()=>{
            onChange(null);
        };
        const closeMenuOnScroll = (e)=>{
            if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
        };
        const getIsClearable = ()=>isClearable ? Boolean(value) : false;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kEnpg")).UserPicker), {
            ariaLabelledBy: fieldProps['aria-labelledby'],
            fieldId: fieldId,
            width: width,
            autoFocus: autoFocus,
            isLoading: loading,
            options: getOptions(),
            value: value,
            onFocus: handleOnFocus,
            onClear: onClear,
            isMulti: isMulti,
            isDisabled: isDisabled,
            isClearable: getIsClearable(),
            onBlur: handleOnBlur,
            onInputChange: handleSearch,
            onChange: handleOnChange,
            placeholder: placeholder,
            addMoreMessage: formatMessage((0, (0, parcelRequire("lGKF5")).default).addMoreGroupsPrompt),
            UNSAFE_hasDraggableParentComponent: true,
            closeMenuOnScroll: closeMenuOnScroll,
            open: isDropdownVisible,
            menuPosition: menuPosition,
            styles: {
                control: getUserPickerControlStyle,
                ...groupPickerStyles
            }
        });
    };
    var $81263082e0845513$export$2e2bcd8739ae039 = $81263082e0845513$var$GroupPicker;
});
parcelRegister("arYvt", function(module, exports) {
    $parcel$export(module.exports, "transformGroupToUserOption", ()=>$70d728bf86d0ecee$export$f9f97cb0418e400f);
    $parcel$export(module.exports, "transformUserPickerOptionToGroup", ()=>$70d728bf86d0ecee$export$7727449e04185a4c);
    $parcel$export(module.exports, "transformGroupToName", ()=>$70d728bf86d0ecee$export$c76efe48b8ca8203);
    $parcel$export(module.exports, "transformGroupsToNames", ()=>$70d728bf86d0ecee$export$285022bf9288513e);
    $parcel$export(module.exports, "appendTypePropertyToGroupOptions", ()=>$70d728bf86d0ecee$export$705009f1a414da46);
    const $70d728bf86d0ecee$export$f9f97cb0418e400f = (group)=>({
            id: group.name,
            name: group.name,
            type: 'group'
        });
    const $70d728bf86d0ecee$export$7727449e04185a4c = (userOption)=>({
            groupId: userOption.id,
            name: userOption.name,
            type: 'group'
        });
    const $70d728bf86d0ecee$export$c76efe48b8ca8203 = (group)=>({
            name: group.name
        });
    const $70d728bf86d0ecee$export$285022bf9288513e = (groups)=>groups.map((group)=>$70d728bf86d0ecee$export$c76efe48b8ca8203(group));
    const $70d728bf86d0ecee$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
                ...group,
                type: 'group'
            }));
});
parcelRegister("hSBXu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9613200b5cbe8cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $eusud;
    var $arYvt;
    const $b9613200b5cbe8cb$var$useGroupsQuery = (autoCompleteUrl)=>{
        const [groups, setGroups] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const currentQuery = (0, $5uXOq.useRef)('');
        const fetchGroups = (0, $5uXOq.useCallback)(async (query = '')=>{
            if ([
                '',
                null,
                undefined
            ].includes(autoCompleteUrl)) return Promise.resolve([]);
            const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
            setLoading(true);
            currentQuery.current = query;
            if (error) setError(undefined);
            try {
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(groupsFetchUrl);
                let groupsWithType = [];
                if (query === currentQuery.current) {
                    if (response && response.groups) {
                        groupsWithType = (0, (0, parcelRequire("arYvt")).appendTypePropertyToGroupOptions)(response.groups);
                        setGroups(groupsWithType);
                    } else setGroups([]);
                }
                return groupsWithType;
            } catch (err) {
                if (query === currentQuery.current) setError(err);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
                return err;
            } finally{
                setLoading(false);
            }
        }, [
            autoCompleteUrl,
            error
        ]);
        return {
            groups: groups,
            error: error,
            loading: loading,
            fetchGroups: fetchGroups
        };
    };
    var $b9613200b5cbe8cb$export$2e2bcd8739ae039 = $b9613200b5cbe8cb$var$useGroupsQuery;
});
parcelRegister("lGKF5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82d585cea41a3a80$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82d585cea41a3a80$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addMoreGroupsPrompt: {
            "id": "issue-field-group-picker.edit.add-more-groups-prompt",
            "defaultMessage": "add more groups..."
        }
    });
});
parcelRegister("3PgDR", function(module, exports) {
    $parcel$export(module.exports, "invalidStateStyle", ()=>$2e61feb10eb63767$export$f204658c943efb85);
    const $2e61feb10eb63767$export$f204658c943efb85 = {
        borderColor: `var(--ds-border-danger, ${(0, $72ba03e317f3d228$exports).R400})`
    };
});
parcelRegister("d8h6M", function(module, exports) {
    $parcel$export(module.exports, "transformGroupDefaultValueToUserOption", ()=>$dab4f2debb035d9d$export$d9591be6713fcfc8);
    $parcel$export(module.exports, "mutateSingleGroupPickerField", ()=>$dab4f2debb035d9d$export$daeca2ffaa5d8b62);
    var $arYvt;
    const $dab4f2debb035d9d$export$d9591be6713fcfc8 = (group)=>{
        if (!group) return null;
        return (0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(group);
    };
    const $dab4f2debb035d9d$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
            fieldId: fieldId,
            group: {
                groupName: selectedGroup.name
            },
            mutationGroup: (0, $b977eeb5f24a5299$export$31fd86f8f183952c)
        });
});
const $b977eeb5f24a5299$export$31fd86f8f183952c = 'singleGroupPickerFields';
parcelRegister("awO6U", function(module, exports) {
    $parcel$export(module.exports, "LabelsCustomFieldTypeConfig", ()=>$337cc26aaa6435a9$export$c08ea7a9c6fbd5e0);
    var $5uXOq = parcelRequire("5uXOq");
    var $lLTtI;
    var $8GQyc;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $337cc26aaa6435a9$var$LabelsCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8GQyc")).default), props);
    const $337cc26aaa6435a9$export$c08ea7a9c6fbd5e0 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("lLTtI"))))),
        type: (0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE),
        Component: $337cc26aaa6435a9$var$LabelsCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).labelsFieldWriter)
    };
});
parcelRegister("lLTtI", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd99059a80feed32$var$_react = $fd99059a80feed32$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fd99059a80feed32$var$_UNSAFE_baseNew = $fd99059a80feed32$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fd99059a80feed32$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd99059a80feed32$var$TagIcon = (props)=>$fd99059a80feed32$var$_react.default.createElement($fd99059a80feed32$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.768 1.75H13c.69 0 1.25.56 1.25 1.25v4.232c0 .332-.132.65-.366.884l-5.75 5.75a1.25 1.25 0 0 1-1.768 0L2.134 9.634a1.25 1.25 0 0 1 0-1.768l5.75-5.75a1.25 1.25 0 0 1 .884-.366Z"/><rect width="2" height="2" x="10" y="4" fill="currentcolor" rx="1"/>`
        }, props));
    $fd99059a80feed32$var$TagIcon.displayName = 'TagIcon';
    var $fd99059a80feed32$var$_default = module.exports.default = $fd99059a80feed32$var$TagIcon;
});
parcelRegister("8GQyc", function(module, exports) {
    $parcel$export(module.exports, "ForgeLabelsField", ()=>$34600c8cb7aa4373$export$f77bab10d748bb71);
    $parcel$export(module.exports, "default", ()=>$34600c8cb7aa4373$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $800rQ;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $evGBv;
    const $34600c8cb7aa4373$var$LabelsField = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("800rQ")).LabelsEdit), {
            isInvalid: Boolean(error),
            fetchSuggestionsOnMount: false,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly,
            inputId: id,
            isRequired: isRequired
        }));
    };
    const $34600c8cb7aa4373$export$f77bab10d748bb71 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateForgeLabelField),
        transformDefaultValue: (0, (0, parcelRequire("evGBv")).mapDataToLabelOptions)
    })($34600c8cb7aa4373$var$LabelsField);
    var $34600c8cb7aa4373$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateLabelField),
        transformDefaultValue: (0, (0, parcelRequire("evGBv")).mapDataToLabelOptions)
    })($34600c8cb7aa4373$var$LabelsField);
});
parcelRegister("800rQ", function(module, exports) {
    $parcel$export(module.exports, "LabelsEdit", ()=>$392f4ecadcf70f0f$export$23584166c0ffb901);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $koVbs;
    var $6Vzc4;
    var $3BhEA;
    var $lElIo;
    var $5fc53;
    var $2QTbq;
    var $l2SvC;
    var $e3wnO;
    var $l5gEe;
    const $392f4ecadcf70f0f$export$251bdbdbce9550ea = 300;
    const $392f4ecadcf70f0f$export$23584166c0ffb901 = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, (0, parcelRequire("5fc53")).LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const lastQuery = (0, $5uXOq.useRef)('');
        const sessionId = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($7Jxgt))).v4());
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, (0, parcelRequire("l2SvC")).useLabelsSuggestions)({
            fieldId: fieldId,
            getSuggestions: getSuggestions
        });
        const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).FailedFetchOptionWrapper), null, formatMessage((0, (0, parcelRequire("l5gEe")).default).failedFetch)), [
            formatMessage
        ]);
        const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            try {
                const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
                setIsLoadingSuggestions(false);
                if (lastQuery.current === query) {
                    const results = (0, (0, parcelRequire("2QTbq")).mapLabelsResponseToLabelOptions)(response);
                    setSuggestions(results);
                    if (query === '') setDefaultSuggestions(results);
                }
            } catch (err) {
                setIsLoadingSuggestions(false);
                setHasLastFetchFailed(true);
                setSuggestions([
                    {
                        label: getFailedFetchMessage(),
                        value: '',
                        isDisabled: true
                    }
                ]);
            }
        }, [
            autoCompleteUrl,
            getFailedFetchMessage,
            getLabelsSuggestions,
            lastQuery,
            sessionId,
            setHasLastFetchFailed,
            setIsLoadingSuggestions
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                } else if (options && !defaultSuggestions) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                }
            }
        }, []);
        const groupedSuggestions = (0, $5uXOq.useMemo)(()=>[
                {
                    label: formatMessage((0, (0, parcelRequire("l5gEe")).default).recent),
                    options: cachedOptions
                },
                {
                    label: formatMessage((0, (0, parcelRequire("l5gEe")).default).all),
                    options: suggestions || []
                }
            ], [
            cachedOptions,
            formatMessage,
            suggestions
        ]);
        const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(fetchSuggestions, $392f4ecadcf70f0f$export$251bdbdbce9550ea), []);
        const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, (0, parcelRequire("l5gEe")).default).createNewItem)})`, [
            formatCreateLabel,
            formatMessage
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, (0, parcelRequire("l5gEe")).default).empty), [
            formatMessage,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, (0, parcelRequire("l5gEe")).default).loading), [
            formatMessage,
            loadingMessage
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, query || '');
        }, [
            hasLastFetchFailed
        ]);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedFetchSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                lastQuery.current = query;
                setIsLoadingSuggestions(true);
                debouncedFetchSuggestions(query);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedFetchSuggestions,
            defaultSuggestions,
            setIsLoadingSuggestions,
            setSuggestions
        ]);
        const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
            if (!suggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions('');
            }
            onFocus && onFocus(e);
        }, [
            suggestions,
            onFocus,
            setIsLoadingSuggestions,
            fetchSuggestions
        ]);
        const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
            onBlur && onBlur(e);
        }, [
            onBlur
        ]);
        const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
        const isLoading = isLoadingSuggestions;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e3wnO")).default), {
            isMulti: true,
            autoFocus: autoFocus,
            fieldId: fieldId,
            options: groupedSuggestions,
            value: value,
            isDisabled: isDisabled,
            onBlur: onSelectBlur,
            menuPosition: menuPosition,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            closeMenuOnScroll: onCloseMenuOnScroll,
            loadingMessage: getLoadingMessage,
            placeholder: formatMessage((0, (0, parcelRequire("l5gEe")).default).placeholder),
            onInputChange: onQueryChange,
            onChange: onChange,
            spacing: spacing,
            isLoading: isLoading,
            filterOption: filterOption,
            formatCreateLabel: getCreateLabel,
            validationState: isInvalid === true ? 'error' : null,
            sessionId: sessionId.current,
            "aria-label": ariaLabel,
            inputId: inputId,
            isRequired: isRequired,
            openMenuOnFocus: openMenuOnFocus
        });
    };
    var $392f4ecadcf70f0f$export$2e2bcd8739ae039 = $392f4ecadcf70f0f$export$23584166c0ffb901;
});
parcelRegister("6Vzc4", function(module, exports) {
    $parcel$export(module.exports, "FailedFetchOptionWrapper", ()=>$9302f6c83ce60c04$export$38a1a0a811e06255);
    $parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", ()=>$9302f6c83ce60c04$export$aa3357fb0ebcdb2b);
    $parcel$export(module.exports, "OptionWrapper", ()=>$9302f6c83ce60c04$export$d6f6a072cce04542);
    $parcel$export(module.exports, "ImgSpan", ()=>$9302f6c83ce60c04$export$df67068a00dece12);
    $parcel$export(module.exports, "FlexSpan", ()=>$9302f6c83ce60c04$export$d90eccb59fb62cab);
    $parcel$export(module.exports, "ErrorMessageWrapper", ()=>$9302f6c83ce60c04$export$9e874bb1adc98a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6s1PB;
    var $koVbs;
    var $goAgE;
    const $9302f6c83ce60c04$export$6ed0d629c0656ce1 = (query, label)=>[
            {
                options: [
                    {
                        label: label,
                        value: '',
                        isDisabled: true,
                        filterValues: [
                            query
                        ]
                    }
                ]
            }
        ];
    const $9302f6c83ce60c04$var$DefaultFailedFetchMessage = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const failedFetchMessage = (0, (0, parcelRequire("goAgE")).default).failedFetch;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$export$38a1a0a811e06255, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage(failedFetchMessage), " ", (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            role: "button",
            href: window.location.href,
            onClick: ()=>window.location.reload()
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("goAgE")).default).reloadIssueIssueTermRefresh : (0, (0, parcelRequire("goAgE")).default).reloadIssue))));
    };
    const $9302f6c83ce60c04$export$aa3357fb0ebcdb2b = (query)=>$9302f6c83ce60c04$export$6ed0d629c0656ce1(query, (0, ($parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$var$DefaultFailedFetchMessage, null));
    const $9302f6c83ce60c04$export$d6f6a072cce04542 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$38a1a0a811e06255 = (0, $5uXOq.forwardRef)(({ as: C = $9302f6c83ce60c04$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$df67068a00dece12 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _u5f3u2gc",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$d90eccb59fb62cab = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$9e874bb1adc98a55 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("goAgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7a2287a5c23e167$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b7a2287a5c23e167$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        failedFetch: {
            "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
            "defaultMessage": "Search failed."
        },
        reloadIssue: {
            "id": "issue-field-select-base.failed-fetch-options.reload-issue",
            "defaultMessage": "Try reloading the issue."
        },
        reloadIssueIssueTermRefresh: {
            "id": "issue-field-select-base.failed-fetch-options.reload-issue-issue-term-refresh",
            "defaultMessage": "Try reloading"
        }
    });
});
parcelRegister("3BhEA", function(module, exports) {
    $parcel$export(module.exports, "filterOptionByLabelAndFilterValues", ()=>$0eb6c4d40c779509$export$58bb91b619b113f6);
    var $8QpSo;
    var $by9Y7;
    const $0eb6c4d40c779509$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>typeof val === 'string' && val.toLowerCase().includes(inputValueIgnoredCase);
    const $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues = (option)=>{
        const { label: label, data: data } = option || {};
        const { filterValues: filterValues } = data || {};
        const labelString = typeof label === 'string' ? label : '';
        const filterValuesString = (filterValues || []).join(' ');
        return `${labelString} ${filterValuesString}`;
    };
    const $0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, (0, parcelRequire("by9Y7")).createFilter)({
            stringify: $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues
        }));
    const $0eb6c4d40c779509$export$58bb91b619b113f6 = (option, inputValue)=>$0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);
});
parcelRegister("l2SvC", function(module, exports) {
    $parcel$export(module.exports, "useLabelsSuggestions", ()=>$aed9af8029ae7a32$export$c5b80cd78ff71c5f);
    var $5uXOq = parcelRequire("5uXOq");
    var $6RCeq;
    var $eusud;
    var $8SCDp;
    var $5fc53;
    var $lwMsT;
    const $aed9af8029ae7a32$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
        let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url);
    };
    const $aed9af8029ae7a32$export$c5b80cd78ff71c5f = (props)=>{
        const { fieldId: fieldId, getSuggestions: getSuggestions = $aed9af8029ae7a32$export$343652b9755c68e7 } = props;
        const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const getLabelsSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
            const startTime = (0, (0, parcelRequire("6RCeq")).default).now();
            const queryLength = query.length;
            try {
                const response = await getSuggestions(autoCompleteUrl, query, sessionId);
                if (fieldId === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) (0, (0, parcelRequire("8SCDp")).fireSuggestionsRequestSuccessEvent)((0, (0, parcelRequire("5fc53")).LABELS_TYPE), startTime, createAnalyticsEvent, {
                    sessionId: sessionId,
                    queryLength: queryLength
                });
                setIsLoadingSuggestions(false);
                return response;
            } catch (error) {
                if (fieldId === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) (0, (0, parcelRequire("8SCDp")).fireSuggestionsRequestFailedEvent)((0, (0, parcelRequire("5fc53")).LABELS_TYPE), startTime, createAnalyticsEvent, {
                    sessionId: sessionId
                });
                setIsLoadingSuggestions(false);
                throw error;
            }
        }, [
            createAnalyticsEvent,
            fieldId,
            getSuggestions,
            setIsLoadingSuggestions
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>({
                getLabelsSuggestions: getLabelsSuggestions,
                setIsLoadingSuggestions: setIsLoadingSuggestions
            }), [
            getLabelsSuggestions,
            setIsLoadingSuggestions
        ]);
        return [
            {
                isLoadingSuggestions: isLoadingSuggestions
            },
            actions
        ];
    };
});
parcelRegister("8SCDp", function(module, exports) {
    $parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", ()=>$305439819cb2bcec$export$7eeca21c46efa338);
    $parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", ()=>$305439819cb2bcec$export$a31ac580130dee62);
    var $6RCeq;
    var $8zOmE;
    const $305439819cb2bcec$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
        const attributes = {
            ...additionalAttributes,
            elapsedTimeMs: (0, (0, parcelRequire("6RCeq")).default).now() - startTime
        };
        createAnalyticsEvent && (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), `${actionSubject} ${action}`, attributes);
    };
    const $305439819cb2bcec$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
        $305439819cb2bcec$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
    };
    const $305439819cb2bcec$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
        $305439819cb2bcec$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
    };
});
parcelRegister("e3wnO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35584119a49c4bd8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $hGgHi = parcelRequire("hGgHi");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $6AKkW;
    var $6RCeq;
    var $6s1PB;
    var $cSD7y;
    var $4R6GH;
    var $db8jg;
    var $2OMDV;
    var $8zOmE;
    var $lwMsT;
    var $biBfP;
    const $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
    const $35584119a49c4bd8$var$analyticsProps = {
        onChange: 'valueChanged',
        onInputChange: 'inputChanged',
        onMenuOpen: 'menuOpened',
        onMenuClose: 'menuClosed'
    };
    const $35584119a49c4bd8$export$29e0f2c0983c7379 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('select', $35584119a49c4bd8$var$analyticsProps)((0, (0, parcelRequire("6AKkW")).default));
    const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsViewOld = (props)=>{
        const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
        const sessionId = (0, $5uXOq.useRef)(customSessionId);
        const sessionStartedAt = (0, $5uXOq.useRef)(0);
        const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, (0, parcelRequire("biBfP")).flattenOptions)(options));
        const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
        const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
            const selectedOptions = !(0, ($parcel$interopDefault($hGgHi)))(value) ? value : [];
            let filteredOptions = (0, (0, parcelRequire("biBfP")).filterOptions)(flatOptions, query);
            const optionsLength = filteredOptions.length;
            filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
            const safeFilteredOptions = (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(filteredOptions);
            return {
                inputId: inputId,
                required: isRequired,
                fieldId: fieldId,
                isLoading: isLoading,
                isDisabled: isDisabled,
                optionsLength: optionsLength,
                componentName: 'select',
                packageName: '@atlaskit/select',
                optionValuesSafeForAnalytics: false,
                options: safeFilteredOptions,
                optionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(filteredOptions),
                queryLength: query.length,
                queryHash: query === '' ? query : (0, (0, parcelRequire("db8jg")).memoizedHashString)(query),
                selectedOptions: (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(selectedOptions),
                selectedOptionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(selectedOptions),
                sessionId: sessionId.current,
                truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
            };
        }, [
            value,
            flatOptions,
            inputId,
            isRequired,
            fieldId,
            isLoading,
            isDisabled
        ]);
        const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
            const matchedIndexes = [];
            flatOptions.forEach((option, index)=>{
                if (option.value === selectedItem.value) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        }, [
            flatOptions
        ]);
        const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(query),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
        }, [
            getAnalyticsAttributes
        ]);
        const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(savedQuery),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
        }, [
            getAnalyticsAttributes,
            savedQuery
        ]);
        const startSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current === undefined) sessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            sessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const endSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current !== undefined) {
                const currentStartedAt = sessionStartedAt.current;
                const elapsedTime = currentStartedAt === 0 ? (0, (0, parcelRequire("6RCeq")).default).now() - currentStartedAt : 0;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime
                });
            }
            sessionId.current = undefined;
            sessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const restartSession = (0, $5uXOq.useCallback)(()=>{
            endSession();
            startSession();
        }, [
            endSession,
            startSession
        ]);
        const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') setQueryAtSetValue(savedQuery);
            setSavedQuery(query);
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            fireUIAnalyticsEvent(analyticsEvent, query);
        }, [
            fireUIAnalyticsEvent,
            savedQuery,
            setSavedQuery,
            setQueryAtSetValue
        ]);
        const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
                removedItem: option ? (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value) : undefined
            });
        }, [
            fireUIAnalyticsEvent,
            savedQuery
        ]);
        const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                selectedOrder: getItemOrder(option),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            getItemOrder,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
            if (onChange) onChange(selectedValue, actionMeta);
        }, [
            fireOptionCreatedEvent,
            fireOptionRemovedEvent,
            fireOptionSelectedEvent,
            onChange,
            isMulti
        ]);
        const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
            onInputChange(query, sessionId.current);
        }, [
            fireInputChangedEvent,
            onInputChange,
            sessionId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            return ()=>{
                endSession();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const flattenedOption = (0, (0, parcelRequire("biBfP")).flattenOptions)(options);
            if (!(0, ($parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
        }, [
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$29e0f2c0983c7379, {
            ...props,
            onChange: onChangeWithAnalytics,
            onInputChange: onInputChangeWithAnalytics
        });
    };
    const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView = (props)=>{
        const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
        const sessionId = (0, $5uXOq.useRef)(customSessionId);
        const editSessionId = (0, $5uXOq.useRef)();
        const sessionStartedAt = (0, $5uXOq.useRef)(0);
        const editSessionStartedAt = (0, $5uXOq.useRef)(0);
        const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, (0, parcelRequire("biBfP")).flattenOptions)(options));
        const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
        const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
            const selectedOptions = !(0, ($parcel$interopDefault($hGgHi)))(value) ? value : [];
            let filteredOptions = (0, (0, parcelRequire("biBfP")).filterOptions)(flatOptions, query);
            const optionsLength = filteredOptions.length;
            filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
            const safeFilteredOptions = (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(filteredOptions);
            return {
                inputId: inputId,
                required: isRequired,
                fieldId: fieldId,
                isLoading: isLoading,
                isDisabled: isDisabled,
                optionsLength: optionsLength,
                componentName: 'select',
                packageName: '@atlaskit/select',
                optionValuesSafeForAnalytics: false,
                options: safeFilteredOptions,
                optionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(filteredOptions),
                queryLength: query.length,
                queryHash: query === '' ? query : (0, (0, parcelRequire("db8jg")).memoizedHashString)(query),
                selectedOptions: (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(selectedOptions),
                selectedOptionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(selectedOptions),
                sessionId: sessionId.current,
                truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
            };
        }, [
            value,
            flatOptions,
            inputId,
            isRequired,
            fieldId,
            isLoading,
            isDisabled
        ]);
        const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
            const matchedIndexes = [];
            flatOptions.forEach((option, index)=>{
                if (option.value === selectedItem.value) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        }, [
            flatOptions
        ]);
        const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(query),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
        }, [
            getAnalyticsAttributes
        ]);
        const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(savedQuery),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
        }, [
            getAnalyticsAttributes,
            savedQuery
        ]);
        const startEditSession = (0, $5uXOq.useCallback)(()=>{
            if (editSessionId.current === undefined) editSessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            editSessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'fieldEditSession', {
                editSessionId: editSessionId.current
            });
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent
        ]);
        const endEditSession = (0, $5uXOq.useCallback)(()=>{
            if (editSessionId.current !== undefined) {
                const config = (0, (0, parcelRequire("4R6GH")).fg)('labels_restricted_to_project_experiment') && (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('labels_restricted_to_project')[0];
                const elapsedTime = (0, (0, parcelRequire("6RCeq")).default).now() - editSessionStartedAt.current;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'fieldEditSession', {
                    elapsedTime: elapsedTime,
                    editSessionId: editSessionId.current,
                    ...config ? {
                        hasProjectScopedLabels: config.get('showProjectFilter', false)
                    } : {}
                });
            }
            editSessionId.current = undefined;
            editSessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent
        ]);
        const startSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current === undefined) sessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            sessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const endSession = (0, $5uXOq.useCallback)((interactionType)=>{
            if (sessionId.current !== undefined) {
                const currentStartedAt = sessionStartedAt.current;
                const elapsedTime = currentStartedAt !== 0 ? (0, (0, parcelRequire("6RCeq")).default).now() - currentStartedAt : 0;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime,
                    interactionType: interactionType
                });
            }
            sessionId.current = undefined;
            sessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const restartSession = (0, $5uXOq.useCallback)((interactionType)=>{
            endSession(interactionType);
            startSession();
        }, [
            endSession,
            startSession
        ]);
        const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') setQueryAtSetValue(savedQuery);
            setSavedQuery(query);
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            fireUIAnalyticsEvent(analyticsEvent, query);
        }, [
            fireUIAnalyticsEvent,
            savedQuery,
            setSavedQuery,
            setQueryAtSetValue
        ]);
        const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession('option created');
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
                removedItem: option ? (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value) : undefined
            });
        }, [
            fireUIAnalyticsEvent,
            savedQuery
        ]);
        const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession('option selected');
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                selectedOrder: getItemOrder(option),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            getItemOrder,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
            if (onChange) onChange(selectedValue, actionMeta);
        }, [
            fireOptionCreatedEvent,
            fireOptionRemovedEvent,
            fireOptionSelectedEvent,
            onChange,
            isMulti
        ]);
        const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
            onInputChange(query, sessionId.current);
        }, [
            fireInputChangedEvent,
            onInputChange,
            sessionId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            startSession();
            startEditSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            return ()=>{
                endSession();
                endEditSession();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const flattenedOption = (0, (0, parcelRequire("biBfP")).flattenOptions)(options);
            if (!(0, ($parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
        }, [
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$29e0f2c0983c7379, {
            ...props,
            onChange: onChangeWithAnalytics,
            onInputChange: onInputChangeWithAnalytics
        });
    };
    var $35584119a49c4bd8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('labels_select_with_interaction_analytics', $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView, $35584119a49c4bd8$var$CreatableSelectWithAnalyticsViewOld);
});
parcelRegister("db8jg", function(module, exports) {
    $parcel$export(module.exports, "memoizedHashString", ()=>$6aa2f917648b2dec$export$c9e165da390f6283);
    var $gvK9N;
    var $8QpSo;
    var $4Pf62;
    const $6aa2f917648b2dec$export$fdd2c0ba94025c3c = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        return cloudId;
    });
    const $6aa2f917648b2dec$export$c9e165da390f6283 = (attribute)=>{
        const cloudId = $6aa2f917648b2dec$export$fdd2c0ba94025c3c();
        const hash = (0, (0, parcelRequire("gvK9N")).createHash)('sha256').update(`${cloudId}_${attribute.trim()}`).digest('hex');
        return hash;
    };
});
parcelRegister("gvK9N", function(module, exports) {
    $parcel$export(module.exports, "randomBytes", ()=>$c053586507d63757$export$5f828d93ff035aa8, (v)=>$c053586507d63757$export$5f828d93ff035aa8 = v);
    $parcel$export(module.exports, "rng", ()=>$c053586507d63757$export$cd94982b18c6332c, (v)=>$c053586507d63757$export$cd94982b18c6332c = v);
    $parcel$export(module.exports, "pseudoRandomBytes", ()=>$c053586507d63757$export$1d518568e4f529b0, (v)=>$c053586507d63757$export$1d518568e4f529b0 = v);
    $parcel$export(module.exports, "prng", ()=>$c053586507d63757$export$5285b6d41c912b41, (v)=>$c053586507d63757$export$5285b6d41c912b41 = v);
    $parcel$export(module.exports, "createHash", ()=>$c053586507d63757$export$2fb37efbf6ae0c0e, (v)=>$c053586507d63757$export$2fb37efbf6ae0c0e = v);
    $parcel$export(module.exports, "Hash", ()=>$c053586507d63757$export$ab85ecd77ce6a5cd, (v)=>$c053586507d63757$export$ab85ecd77ce6a5cd = v);
    $parcel$export(module.exports, "createHmac", ()=>$c053586507d63757$export$da39cf97e1eb7c91, (v)=>$c053586507d63757$export$da39cf97e1eb7c91 = v);
    $parcel$export(module.exports, "Hmac", ()=>$c053586507d63757$export$52a9039d7177394f, (v)=>$c053586507d63757$export$52a9039d7177394f = v);
    $parcel$export(module.exports, "getHashes", ()=>$c053586507d63757$export$f7201db400317331, (v)=>$c053586507d63757$export$f7201db400317331 = v);
    $parcel$export(module.exports, "pbkdf2", ()=>$c053586507d63757$export$448fa22aedc9dbca, (v)=>$c053586507d63757$export$448fa22aedc9dbca = v);
    $parcel$export(module.exports, "pbkdf2Sync", ()=>$c053586507d63757$export$b80c7ba289c8fa56, (v)=>$c053586507d63757$export$b80c7ba289c8fa56 = v);
    $parcel$export(module.exports, "Cipher", ()=>$c053586507d63757$export$26e5786e8ac8e530, (v)=>$c053586507d63757$export$26e5786e8ac8e530 = v);
    $parcel$export(module.exports, "createCipher", ()=>$c053586507d63757$export$bdd223f16383713e, (v)=>$c053586507d63757$export$bdd223f16383713e = v);
    $parcel$export(module.exports, "Cipheriv", ()=>$c053586507d63757$export$20533d26f07f1ee0, (v)=>$c053586507d63757$export$20533d26f07f1ee0 = v);
    $parcel$export(module.exports, "createCipheriv", ()=>$c053586507d63757$export$2f64596b8cbf08b4, (v)=>$c053586507d63757$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "Decipher", ()=>$c053586507d63757$export$2ce6d8d0e8b04e1a, (v)=>$c053586507d63757$export$2ce6d8d0e8b04e1a = v);
    $parcel$export(module.exports, "createDecipher", ()=>$c053586507d63757$export$12ada9414fbc594c, (v)=>$c053586507d63757$export$12ada9414fbc594c = v);
    $parcel$export(module.exports, "Decipheriv", ()=>$c053586507d63757$export$f5e7e39d57cd9700, (v)=>$c053586507d63757$export$f5e7e39d57cd9700 = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$c053586507d63757$export$36b6d6ef312eab39, (v)=>$c053586507d63757$export$36b6d6ef312eab39 = v);
    $parcel$export(module.exports, "getCiphers", ()=>$c053586507d63757$export$58a258485f1e49f6, (v)=>$c053586507d63757$export$58a258485f1e49f6 = v);
    $parcel$export(module.exports, "listCiphers", ()=>$c053586507d63757$export$dedd8dc3dc62b370, (v)=>$c053586507d63757$export$dedd8dc3dc62b370 = v);
    $parcel$export(module.exports, "DiffieHellmanGroup", ()=>$c053586507d63757$export$971862a2fcb1bb40, (v)=>$c053586507d63757$export$971862a2fcb1bb40 = v);
    $parcel$export(module.exports, "createDiffieHellmanGroup", ()=>$c053586507d63757$export$c6ff6a88acbeaf40, (v)=>$c053586507d63757$export$c6ff6a88acbeaf40 = v);
    $parcel$export(module.exports, "getDiffieHellman", ()=>$c053586507d63757$export$fdc27893e98845cc, (v)=>$c053586507d63757$export$fdc27893e98845cc = v);
    $parcel$export(module.exports, "createDiffieHellman", ()=>$c053586507d63757$export$6671fb9a1323bed, (v)=>$c053586507d63757$export$6671fb9a1323bed = v);
    $parcel$export(module.exports, "DiffieHellman", ()=>$c053586507d63757$export$d74daf141a551db, (v)=>$c053586507d63757$export$d74daf141a551db = v);
    $parcel$export(module.exports, "createSign", ()=>$c053586507d63757$export$45df7cae684751af, (v)=>$c053586507d63757$export$45df7cae684751af = v);
    $parcel$export(module.exports, "Sign", ()=>$c053586507d63757$export$1db683ad541682f6, (v)=>$c053586507d63757$export$1db683ad541682f6 = v);
    $parcel$export(module.exports, "createVerify", ()=>$c053586507d63757$export$6f65485f87568e37, (v)=>$c053586507d63757$export$6f65485f87568e37 = v);
    $parcel$export(module.exports, "Verify", ()=>$c053586507d63757$export$91a8e56769aeb334, (v)=>$c053586507d63757$export$91a8e56769aeb334 = v);
    $parcel$export(module.exports, "createECDH", ()=>$c053586507d63757$export$2d4117e99c2179e4, (v)=>$c053586507d63757$export$2d4117e99c2179e4 = v);
    $parcel$export(module.exports, "publicEncrypt", ()=>$c053586507d63757$export$512823e338ddb1b7, (v)=>$c053586507d63757$export$512823e338ddb1b7 = v);
    $parcel$export(module.exports, "privateEncrypt", ()=>$c053586507d63757$export$9d0e0c0c4a8d30f3, (v)=>$c053586507d63757$export$9d0e0c0c4a8d30f3 = v);
    $parcel$export(module.exports, "publicDecrypt", ()=>$c053586507d63757$export$b9d55ff329113abd, (v)=>$c053586507d63757$export$b9d55ff329113abd = v);
    $parcel$export(module.exports, "privateDecrypt", ()=>$c053586507d63757$export$7efb24e2fddf99b9, (v)=>$c053586507d63757$export$7efb24e2fddf99b9 = v);
    $parcel$export(module.exports, "randomFill", ()=>$c053586507d63757$export$bb1abf2ce84fc7e8, (v)=>$c053586507d63757$export$bb1abf2ce84fc7e8 = v);
    $parcel$export(module.exports, "randomFillSync", ()=>$c053586507d63757$export$2f7171e78e524d5e, (v)=>$c053586507d63757$export$2f7171e78e524d5e = v);
    $parcel$export(module.exports, "createCredentials", ()=>$c053586507d63757$export$e1d879b482f37d98, (v)=>$c053586507d63757$export$e1d879b482f37d98 = v);
    $parcel$export(module.exports, "constants", ()=>$c053586507d63757$export$1a988e7317c65621, (v)=>$c053586507d63757$export$1a988e7317c65621 = v);
    var $c053586507d63757$export$5f828d93ff035aa8;
    var $c053586507d63757$export$cd94982b18c6332c;
    var $c053586507d63757$export$1d518568e4f529b0;
    var $c053586507d63757$export$5285b6d41c912b41;
    var $c053586507d63757$export$2fb37efbf6ae0c0e;
    var $c053586507d63757$export$ab85ecd77ce6a5cd;
    var $c053586507d63757$export$da39cf97e1eb7c91;
    var $c053586507d63757$export$52a9039d7177394f;
    var $c053586507d63757$export$f7201db400317331;
    var $c053586507d63757$export$448fa22aedc9dbca;
    var $c053586507d63757$export$b80c7ba289c8fa56;
    var $c053586507d63757$export$26e5786e8ac8e530;
    var $c053586507d63757$export$bdd223f16383713e;
    var $c053586507d63757$export$20533d26f07f1ee0;
    var $c053586507d63757$export$2f64596b8cbf08b4;
    var $c053586507d63757$export$2ce6d8d0e8b04e1a;
    var $c053586507d63757$export$12ada9414fbc594c;
    var $c053586507d63757$export$f5e7e39d57cd9700;
    var $c053586507d63757$export$36b6d6ef312eab39;
    var $c053586507d63757$export$58a258485f1e49f6;
    var $c053586507d63757$export$dedd8dc3dc62b370;
    var $c053586507d63757$export$971862a2fcb1bb40;
    var $c053586507d63757$export$c6ff6a88acbeaf40;
    var $c053586507d63757$export$fdc27893e98845cc;
    var $c053586507d63757$export$6671fb9a1323bed;
    var $c053586507d63757$export$d74daf141a551db;
    var $c053586507d63757$export$45df7cae684751af;
    var $c053586507d63757$export$1db683ad541682f6;
    var $c053586507d63757$export$6f65485f87568e37;
    var $c053586507d63757$export$91a8e56769aeb334;
    var $c053586507d63757$export$2d4117e99c2179e4;
    var $c053586507d63757$export$512823e338ddb1b7;
    var $c053586507d63757$export$9d0e0c0c4a8d30f3;
    var $c053586507d63757$export$b9d55ff329113abd;
    var $c053586507d63757$export$7efb24e2fddf99b9;
    var $c053586507d63757$export$bb1abf2ce84fc7e8;
    var $c053586507d63757$export$2f7171e78e524d5e;
    var $c053586507d63757$export$e1d879b482f37d98;
    var $c053586507d63757$export$1a988e7317c65621;
    'use strict';
    $c053586507d63757$export$5f828d93ff035aa8 = $c053586507d63757$export$cd94982b18c6332c = $c053586507d63757$export$1d518568e4f529b0 = $c053586507d63757$export$5285b6d41c912b41 = (parcelRequire("1DyI6"));
    $c053586507d63757$export$2fb37efbf6ae0c0e = $c053586507d63757$export$ab85ecd77ce6a5cd = (parcelRequire("7K4uY"));
    $c053586507d63757$export$da39cf97e1eb7c91 = $c053586507d63757$export$52a9039d7177394f = (parcelRequire("j65bP"));
    var $NKdOQ = parcelRequire("NKdOQ");
    var $c053586507d63757$var$algoKeys = Object.keys($NKdOQ);
    var $c053586507d63757$var$hashes = [
        'sha1',
        'sha224',
        'sha256',
        'sha384',
        'sha512',
        'md5',
        'rmd160'
    ].concat($c053586507d63757$var$algoKeys);
    $c053586507d63757$export$f7201db400317331 = function() {
        return $c053586507d63757$var$hashes;
    };
    var $fS6zE = parcelRequire("fS6zE");
    $c053586507d63757$export$448fa22aedc9dbca = $fS6zE.pbkdf2;
    $c053586507d63757$export$b80c7ba289c8fa56 = $fS6zE.pbkdf2Sync;
    var $a2ApW = parcelRequire("a2ApW");
    $c053586507d63757$export$26e5786e8ac8e530 = $a2ApW.Cipher;
    $c053586507d63757$export$bdd223f16383713e = $a2ApW.createCipher;
    $c053586507d63757$export$20533d26f07f1ee0 = $a2ApW.Cipheriv;
    $c053586507d63757$export$2f64596b8cbf08b4 = $a2ApW.createCipheriv;
    $c053586507d63757$export$2ce6d8d0e8b04e1a = $a2ApW.Decipher;
    $c053586507d63757$export$12ada9414fbc594c = $a2ApW.createDecipher;
    $c053586507d63757$export$f5e7e39d57cd9700 = $a2ApW.Decipheriv;
    $c053586507d63757$export$36b6d6ef312eab39 = $a2ApW.createDecipheriv;
    $c053586507d63757$export$58a258485f1e49f6 = $a2ApW.getCiphers;
    $c053586507d63757$export$dedd8dc3dc62b370 = $a2ApW.listCiphers;
    var $ilRwV = parcelRequire("ilRwV");
    $c053586507d63757$export$971862a2fcb1bb40 = $ilRwV.DiffieHellmanGroup;
    $c053586507d63757$export$c6ff6a88acbeaf40 = $ilRwV.createDiffieHellmanGroup;
    $c053586507d63757$export$fdc27893e98845cc = $ilRwV.getDiffieHellman;
    $c053586507d63757$export$6671fb9a1323bed = $ilRwV.createDiffieHellman;
    $c053586507d63757$export$d74daf141a551db = $ilRwV.DiffieHellman;
    var $kqxVX = parcelRequire("kqxVX");
    $c053586507d63757$export$45df7cae684751af = $kqxVX.createSign;
    $c053586507d63757$export$1db683ad541682f6 = $kqxVX.Sign;
    $c053586507d63757$export$6f65485f87568e37 = $kqxVX.createVerify;
    $c053586507d63757$export$91a8e56769aeb334 = $kqxVX.Verify;
    $c053586507d63757$export$2d4117e99c2179e4 = (parcelRequire("bsZLy"));
    var $bIasb = parcelRequire("bIasb");
    $c053586507d63757$export$512823e338ddb1b7 = $bIasb.publicEncrypt;
    $c053586507d63757$export$9d0e0c0c4a8d30f3 = $bIasb.privateEncrypt;
    $c053586507d63757$export$b9d55ff329113abd = $bIasb.publicDecrypt;
    $c053586507d63757$export$7efb24e2fddf99b9 = $bIasb.privateDecrypt;
    var $9hQRv = parcelRequire("9hQRv");
    $c053586507d63757$export$bb1abf2ce84fc7e8 = $9hQRv.randomFill;
    $c053586507d63757$export$2f7171e78e524d5e = $9hQRv.randomFillSync;
    $c053586507d63757$export$e1d879b482f37d98 = function() {
        throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
    };
    $c053586507d63757$export$1a988e7317c65621 = {
        DH_CHECK_P_NOT_SAFE_PRIME: 2,
        DH_CHECK_P_NOT_PRIME: 1,
        DH_UNABLE_TO_CHECK_GENERATOR: 4,
        DH_NOT_SUITABLE_GENERATOR: 8,
        NPN_ENABLED: 1,
        ALPN_ENABLED: 1,
        RSA_PKCS1_PADDING: 1,
        RSA_SSLV23_PADDING: 2,
        RSA_NO_PADDING: 3,
        RSA_PKCS1_OAEP_PADDING: 4,
        RSA_X931_PADDING: 5,
        RSA_PKCS1_PSS_PADDING: 6,
        POINT_CONVERSION_COMPRESSED: 2,
        POINT_CONVERSION_UNCOMPRESSED: 4,
        POINT_CONVERSION_HYBRID: 6
    };
});
parcelRegister("1DyI6", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $13145bb397e3672d$var$MAX_BYTES = 65536;
    var $13145bb397e3672d$var$MAX_UINT32 = 4294967295;
    function $13145bb397e3672d$var$oldBrowser() {
        throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
    }
    var $Wth4q = parcelRequire("Wth4q");
    var $13145bb397e3672d$require$Buffer = $Wth4q.Buffer;
    var $13145bb397e3672d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
    if ($13145bb397e3672d$var$crypto && $13145bb397e3672d$var$crypto.getRandomValues) module.exports = $13145bb397e3672d$var$randomBytes;
    else module.exports = $13145bb397e3672d$var$oldBrowser;
    function $13145bb397e3672d$var$randomBytes(size, cb) {
        if (size > $13145bb397e3672d$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
        var bytes = $13145bb397e3672d$require$Buffer.allocUnsafe(size);
        if (size > 0) {
            if (size > $13145bb397e3672d$var$MAX_BYTES) for(var generated = 0; generated < size; generated += $13145bb397e3672d$var$MAX_BYTES)$13145bb397e3672d$var$crypto.getRandomValues(bytes.slice(generated, generated + $13145bb397e3672d$var$MAX_BYTES));
            else $13145bb397e3672d$var$crypto.getRandomValues(bytes);
        }
        if (typeof cb === 'function') return $6cAn5.nextTick(function() {
            cb(null, bytes);
        });
        return bytes;
    }
});
parcelRegister("Wth4q", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $0afc202a9b74167d$var$Buffer = $5k7LC.Buffer;
    function $0afc202a9b74167d$var$copyProps(src, dst) {
        for(var key in src)dst[key] = src[key];
    }
    if ($0afc202a9b74167d$var$Buffer.from && $0afc202a9b74167d$var$Buffer.alloc && $0afc202a9b74167d$var$Buffer.allocUnsafe && $0afc202a9b74167d$var$Buffer.allocUnsafeSlow) module.exports = $5k7LC;
    else {
        $0afc202a9b74167d$var$copyProps($5k7LC, module.exports);
        module.exports.Buffer = $0afc202a9b74167d$var$SafeBuffer;
    }
    function $0afc202a9b74167d$var$SafeBuffer(arg, encodingOrOffset, length) {
        return $0afc202a9b74167d$var$Buffer(arg, encodingOrOffset, length);
    }
    $0afc202a9b74167d$var$SafeBuffer.prototype = Object.create($0afc202a9b74167d$var$Buffer.prototype);
    $0afc202a9b74167d$var$copyProps($0afc202a9b74167d$var$Buffer, $0afc202a9b74167d$var$SafeBuffer);
    $0afc202a9b74167d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
        return $0afc202a9b74167d$var$Buffer(arg, encodingOrOffset, length);
    };
    $0afc202a9b74167d$var$SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        var buf = $0afc202a9b74167d$var$Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === 'string') buf.fill(fill, encoding);
            else buf.fill(fill);
        } else buf.fill(0);
        return buf;
    };
    $0afc202a9b74167d$var$SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $0afc202a9b74167d$var$Buffer(size);
    };
    $0afc202a9b74167d$var$SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $5k7LC.SlowBuffer(size);
    };
});
parcelRegister("7K4uY", function(module, exports) {
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $8ZJxF = parcelRequire("8ZJxF");
    var $6EPBm = parcelRequire("6EPBm");
    var $a21Ya = parcelRequire("a21Ya");
    var $77fwb = parcelRequire("77fwb");
    function $5a3051967cf0fdc1$var$Hash(hash) {
        $77fwb.call(this, 'digest');
        this._hash = hash;
    }
    $v3bBu($5a3051967cf0fdc1$var$Hash, $77fwb);
    $5a3051967cf0fdc1$var$Hash.prototype._update = function(data) {
        this._hash.update(data);
    };
    $5a3051967cf0fdc1$var$Hash.prototype._final = function() {
        return this._hash.digest();
    };
    module.exports = function createHash(alg) {
        alg = alg.toLowerCase();
        if (alg === 'md5') return new $8ZJxF();
        if (alg === 'rmd160' || alg === 'ripemd160') return new $6EPBm();
        return new $5a3051967cf0fdc1$var$Hash($a21Ya(alg));
    };
});
parcelRegister("v3bBu", function(module, exports) {
    if (typeof Object.create === 'function') module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
parcelRegister("8ZJxF", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $68c758ebde74a508$require$Buffer = $5k7LC.Buffer;
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $gOR7Z = parcelRequire("gOR7Z");
    var $68c758ebde74a508$var$ARRAY16 = new Array(16);
    function $68c758ebde74a508$var$MD5() {
        $gOR7Z.call(this, 64);
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
    }
    $v3bBu($68c758ebde74a508$var$MD5, $gOR7Z);
    $68c758ebde74a508$var$MD5.prototype._update = function() {
        var M = $68c758ebde74a508$var$ARRAY16;
        for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
        var a = this._a;
        var b = this._b;
        var c = this._c;
        var d = this._d;
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
        a = $68c758ebde74a508$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
        d = $68c758ebde74a508$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
        c = $68c758ebde74a508$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
        b = $68c758ebde74a508$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
        a = $68c758ebde74a508$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
        d = $68c758ebde74a508$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
        c = $68c758ebde74a508$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
        b = $68c758ebde74a508$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
        a = $68c758ebde74a508$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
        d = $68c758ebde74a508$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
        c = $68c758ebde74a508$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
        b = $68c758ebde74a508$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
        a = $68c758ebde74a508$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
        d = $68c758ebde74a508$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
        c = $68c758ebde74a508$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
        b = $68c758ebde74a508$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
        this._a = this._a + a | 0;
        this._b = this._b + b | 0;
        this._c = this._c + c | 0;
        this._d = this._d + d | 0;
    };
    $68c758ebde74a508$var$MD5.prototype._digest = function() {
        this._block[this._blockOffset++] = 0x80;
        if (this._blockOffset > 56) {
            this._block.fill(0, this._blockOffset, 64);
            this._update();
            this._blockOffset = 0;
        }
        this._block.fill(0, this._blockOffset, 56);
        this._block.writeUInt32LE(this._length[0], 56);
        this._block.writeUInt32LE(this._length[1], 60);
        this._update();
        var buffer = new $68c758ebde74a508$require$Buffer(16);
        buffer.writeInt32LE(this._a, 0);
        buffer.writeInt32LE(this._b, 4);
        buffer.writeInt32LE(this._c, 8);
        buffer.writeInt32LE(this._d, 12);
        return buffer;
    };
    function $68c758ebde74a508$var$rotl(x, n) {
        return x << n | x >>> 32 - n;
    }
    function $68c758ebde74a508$var$fnF(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
    }
    function $68c758ebde74a508$var$fnG(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
    }
    function $68c758ebde74a508$var$fnH(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
    }
    function $68c758ebde74a508$var$fnI(a, b, c, d, m, k, s) {
        return $68c758ebde74a508$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
    }
    module.exports = $68c758ebde74a508$var$MD5;
});
parcelRegister("gOR7Z", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $c3ea86f24fd070bd$require$Buffer = $Wth4q.Buffer;
    var $e2HvS = parcelRequire("e2HvS");
    var $c3ea86f24fd070bd$require$Transform = $e2HvS.Transform;
    var $v3bBu = parcelRequire("v3bBu");
    function $c3ea86f24fd070bd$var$throwIfNotStringOrBuffer(val, prefix) {
        if (!$c3ea86f24fd070bd$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
    }
    function $c3ea86f24fd070bd$var$HashBase(blockSize) {
        $c3ea86f24fd070bd$require$Transform.call(this);
        this._block = $c3ea86f24fd070bd$require$Buffer.allocUnsafe(blockSize);
        this._blockSize = blockSize;
        this._blockOffset = 0;
        this._length = [
            0,
            0,
            0,
            0
        ];
        this._finalized = false;
    }
    $v3bBu($c3ea86f24fd070bd$var$HashBase, $c3ea86f24fd070bd$require$Transform);
    $c3ea86f24fd070bd$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
        var error = null;
        try {
            this.update(chunk, encoding);
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    $c3ea86f24fd070bd$var$HashBase.prototype._flush = function(callback) {
        var error = null;
        try {
            this.push(this.digest());
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    $c3ea86f24fd070bd$var$HashBase.prototype.update = function(data, encoding) {
        $c3ea86f24fd070bd$var$throwIfNotStringOrBuffer(data, 'Data');
        if (this._finalized) throw new Error('Digest already called');
        if (!$c3ea86f24fd070bd$require$Buffer.isBuffer(data)) data = $c3ea86f24fd070bd$require$Buffer.from(data, encoding);
        var block = this._block;
        var offset = 0;
        while(this._blockOffset + data.length - offset >= this._blockSize){
            for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
            this._update();
            this._blockOffset = 0;
        }
        while(offset < data.length)block[this._blockOffset++] = data[offset++];
        for(var j = 0, carry = data.length * 8; carry > 0; ++j){
            this._length[j] += carry;
            carry = this._length[j] / 0x0100000000 | 0;
            if (carry > 0) this._length[j] -= 0x0100000000 * carry;
        }
        return this;
    };
    $c3ea86f24fd070bd$var$HashBase.prototype._update = function() {
        throw new Error('_update is not implemented');
    };
    $c3ea86f24fd070bd$var$HashBase.prototype.digest = function(encoding) {
        if (this._finalized) throw new Error('Digest already called');
        this._finalized = true;
        var digest = this._digest();
        if (encoding !== undefined) digest = digest.toString(encoding);
        this._block.fill(0);
        this._blockOffset = 0;
        for(var i = 0; i < 4; ++i)this._length[i] = 0;
        return digest;
    };
    $c3ea86f24fd070bd$var$HashBase.prototype._digest = function() {
        throw new Error('_digest is not implemented');
    };
    module.exports = $c3ea86f24fd070bd$var$HashBase;
});
parcelRegister("e2HvS", function(module, exports) {
    module.exports = $a393016297afccce$var$Stream;
    var $6Oghe = parcelRequire("6Oghe");
    var $a393016297afccce$require$EE = $6Oghe.EventEmitter;
    var $v3bBu = parcelRequire("v3bBu");
    $v3bBu($a393016297afccce$var$Stream, $a393016297afccce$require$EE);
    $a393016297afccce$var$Stream.Readable = (parcelRequire("bf0eV"));
    $a393016297afccce$var$Stream.Writable = (parcelRequire("eys0S"));
    $a393016297afccce$var$Stream.Duplex = (parcelRequire("i5T1N"));
    $a393016297afccce$var$Stream.Transform = (parcelRequire("imCs6"));
    $a393016297afccce$var$Stream.PassThrough = (parcelRequire("7UmdZ"));
    $a393016297afccce$var$Stream.finished = (parcelRequire("fdhlO"));
    $a393016297afccce$var$Stream.pipeline = (parcelRequire("4kgjk"));
    $a393016297afccce$var$Stream.Stream = $a393016297afccce$var$Stream;
    function $a393016297afccce$var$Stream() {
        $a393016297afccce$require$EE.call(this);
    }
    $a393016297afccce$var$Stream.prototype.pipe = function(dest, options) {
        var source = this;
        function ondata(chunk) {
            if (dest.writable) {
                if (false === dest.write(chunk) && source.pause) source.pause();
            }
        }
        source.on('data', ondata);
        function ondrain() {
            if (source.readable && source.resume) source.resume();
        }
        dest.on('drain', ondrain);
        if (!dest._isStdio && (!options || options.end !== false)) {
            source.on('end', onend);
            source.on('close', onclose);
        }
        var didOnEnd = false;
        function onend() {
            if (didOnEnd) return;
            didOnEnd = true;
            dest.end();
        }
        function onclose() {
            if (didOnEnd) return;
            didOnEnd = true;
            if (typeof dest.destroy === 'function') dest.destroy();
        }
        function onerror(er) {
            cleanup();
            if ($a393016297afccce$require$EE.listenerCount(this, 'error') === 0) throw er;
        }
        source.on('error', onerror);
        dest.on('error', onerror);
        function cleanup() {
            source.removeListener('data', ondata);
            dest.removeListener('drain', ondrain);
            source.removeListener('end', onend);
            source.removeListener('close', onclose);
            source.removeListener('error', onerror);
            dest.removeListener('error', onerror);
            source.removeListener('end', cleanup);
            source.removeListener('close', cleanup);
            dest.removeListener('close', cleanup);
        }
        source.on('end', cleanup);
        source.on('close', cleanup);
        dest.on('close', cleanup);
        dest.emit('pipe', source);
        return dest;
    };
});
parcelRegister("bf0eV", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    module.exports = $82f1480952ab7c7d$var$Readable;
    var $82f1480952ab7c7d$var$Duplex;
    $82f1480952ab7c7d$var$Readable.ReadableState = $82f1480952ab7c7d$var$ReadableState;
    var $6Oghe = parcelRequire("6Oghe");
    var $82f1480952ab7c7d$require$EE = $6Oghe.EventEmitter;
    var $82f1480952ab7c7d$var$EElistenerCount = function EElistenerCount(emitter, type) {
        return emitter.listeners(type).length;
    };
    var $aX75n = parcelRequire("aX75n");
    var $5k7LC = parcelRequire("5k7LC");
    var $82f1480952ab7c7d$require$Buffer = $5k7LC.Buffer;
    var $82f1480952ab7c7d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $82f1480952ab7c7d$var$_uint8ArrayToBuffer(chunk) {
        return $82f1480952ab7c7d$require$Buffer.from(chunk);
    }
    function $82f1480952ab7c7d$var$_isUint8Array(obj) {
        return $82f1480952ab7c7d$require$Buffer.isBuffer(obj) || obj instanceof $82f1480952ab7c7d$var$OurUint8Array;
    }
    var $3gWwf = parcelRequire("3gWwf");
    var $82f1480952ab7c7d$var$debug;
    if ($3gWwf && $3gWwf.debuglog) $82f1480952ab7c7d$var$debug = $3gWwf.debuglog('stream');
    else $82f1480952ab7c7d$var$debug = function debug() {};
    var $ifkfB = parcelRequire("ifkfB");
    var $kZqR5 = parcelRequire("kZqR5");
    var $9GAcH = parcelRequire("9GAcH");
    var $82f1480952ab7c7d$var$getHighWaterMark = $9GAcH.getHighWaterMark;
    var $bBIKv = parcelRequire("bBIKv");
    var $82f1480952ab7c7d$require$_require$codes = $bBIKv.codes;
    var $82f1480952ab7c7d$var$ERR_INVALID_ARG_TYPE = $82f1480952ab7c7d$require$_require$codes.ERR_INVALID_ARG_TYPE, $82f1480952ab7c7d$var$ERR_STREAM_PUSH_AFTER_EOF = $82f1480952ab7c7d$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $82f1480952ab7c7d$var$ERR_METHOD_NOT_IMPLEMENTED = $82f1480952ab7c7d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $82f1480952ab7c7d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $82f1480952ab7c7d$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
    var $82f1480952ab7c7d$var$StringDecoder;
    var $82f1480952ab7c7d$var$createReadableStreamAsyncIterator;
    var $82f1480952ab7c7d$var$from;
    (parcelRequire("v3bBu"))($82f1480952ab7c7d$var$Readable, $aX75n);
    var $82f1480952ab7c7d$var$errorOrDestroy = $kZqR5.errorOrDestroy;
    var $82f1480952ab7c7d$var$kProxyEvents = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    function $82f1480952ab7c7d$var$prependListener(emitter, event, fn) {
        if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
    function $82f1480952ab7c7d$var$ReadableState(options, stream, isDuplex) {
        $82f1480952ab7c7d$var$Duplex = $82f1480952ab7c7d$var$Duplex || (parcelRequire("i5T1N"));
        options = options || {};
        if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $82f1480952ab7c7d$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
        this.highWaterMark = $82f1480952ab7c7d$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
        this.buffer = new $ifkfB();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        this.sync = true;
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        this.paused = true;
        this.emitClose = options.emitClose !== false;
        this.autoDestroy = !!options.autoDestroy;
        this.destroyed = false;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.awaitDrain = 0;
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options.encoding) {
            if (!$82f1480952ab7c7d$var$StringDecoder) $82f1480952ab7c7d$var$StringDecoder = (parcelRequire("3872E")).StringDecoder;
            this.decoder = new $82f1480952ab7c7d$var$StringDecoder(options.encoding);
            this.encoding = options.encoding;
        }
    }
    function $82f1480952ab7c7d$var$Readable(options) {
        $82f1480952ab7c7d$var$Duplex = $82f1480952ab7c7d$var$Duplex || (parcelRequire("i5T1N"));
        if (!(this instanceof $82f1480952ab7c7d$var$Readable)) return new $82f1480952ab7c7d$var$Readable(options);
        var isDuplex = this instanceof $82f1480952ab7c7d$var$Duplex;
        this._readableState = new $82f1480952ab7c7d$var$ReadableState(options, this, isDuplex);
        this.readable = true;
        if (options) {
            if (typeof options.read === 'function') this._read = options.read;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
        }
        $aX75n.call(this);
    }
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'destroyed', {
        enumerable: false,
        get: function get() {
            if (this._readableState === undefined) return false;
            return this._readableState.destroyed;
        },
        set: function set(value) {
            if (!this._readableState) return;
            this._readableState.destroyed = value;
        }
    });
    $82f1480952ab7c7d$var$Readable.prototype.destroy = $kZqR5.destroy;
    $82f1480952ab7c7d$var$Readable.prototype._undestroy = $kZqR5.undestroy;
    $82f1480952ab7c7d$var$Readable.prototype._destroy = function(err, cb) {
        cb(err);
    };
    $82f1480952ab7c7d$var$Readable.prototype.push = function(chunk, encoding) {
        var state = this._readableState;
        var skipChunkCheck;
        if (!state.objectMode) {
            if (typeof chunk === 'string') {
                encoding = encoding || state.defaultEncoding;
                if (encoding !== state.encoding) {
                    chunk = $82f1480952ab7c7d$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
                skipChunkCheck = true;
            }
        } else skipChunkCheck = true;
        return $82f1480952ab7c7d$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };
    $82f1480952ab7c7d$var$Readable.prototype.unshift = function(chunk) {
        return $82f1480952ab7c7d$var$readableAddChunk(this, chunk, null, true, false);
    };
    function $82f1480952ab7c7d$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
        $82f1480952ab7c7d$var$debug('readableAddChunk', chunk);
        var state = stream._readableState;
        if (chunk === null) {
            state.reading = false;
            $82f1480952ab7c7d$var$onEofChunk(stream, state);
        } else {
            var er;
            if (!skipChunkCheck) er = $82f1480952ab7c7d$var$chunkInvalid(state, chunk);
            if (er) $82f1480952ab7c7d$var$errorOrDestroy(stream, er);
            else if (state.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $82f1480952ab7c7d$require$Buffer.prototype) chunk = $82f1480952ab7c7d$var$_uint8ArrayToBuffer(chunk);
                if (addToFront) {
                    if (state.endEmitted) $82f1480952ab7c7d$var$errorOrDestroy(stream, new $82f1480952ab7c7d$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                    else $82f1480952ab7c7d$var$addChunk(stream, state, chunk, true);
                } else if (state.ended) $82f1480952ab7c7d$var$errorOrDestroy(stream, new $82f1480952ab7c7d$var$ERR_STREAM_PUSH_AFTER_EOF());
                else if (state.destroyed) return false;
                else {
                    state.reading = false;
                    if (state.decoder && !encoding) {
                        chunk = state.decoder.write(chunk);
                        if (state.objectMode || chunk.length !== 0) $82f1480952ab7c7d$var$addChunk(stream, state, chunk, false);
                        else $82f1480952ab7c7d$var$maybeReadMore(stream, state);
                    } else $82f1480952ab7c7d$var$addChunk(stream, state, chunk, false);
                }
            } else if (!addToFront) {
                state.reading = false;
                $82f1480952ab7c7d$var$maybeReadMore(stream, state);
            }
        }
        return !state.ended && (state.length < state.highWaterMark || state.length === 0);
    }
    function $82f1480952ab7c7d$var$addChunk(stream, state, chunk, addToFront) {
        if (state.flowing && state.length === 0 && !state.sync) {
            state.awaitDrain = 0;
            stream.emit('data', chunk);
        } else {
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);
            else state.buffer.push(chunk);
            if (state.needReadable) $82f1480952ab7c7d$var$emitReadable(stream);
        }
        $82f1480952ab7c7d$var$maybeReadMore(stream, state);
    }
    function $82f1480952ab7c7d$var$chunkInvalid(state, chunk) {
        var er;
        if (!$82f1480952ab7c7d$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $82f1480952ab7c7d$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer',
            'Uint8Array'
        ], chunk);
        return er;
    }
    $82f1480952ab7c7d$var$Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    $82f1480952ab7c7d$var$Readable.prototype.setEncoding = function(enc) {
        if (!$82f1480952ab7c7d$var$StringDecoder) $82f1480952ab7c7d$var$StringDecoder = (parcelRequire("3872E")).StringDecoder;
        var decoder = new $82f1480952ab7c7d$var$StringDecoder(enc);
        this._readableState.decoder = decoder;
        this._readableState.encoding = this._readableState.decoder.encoding;
        var p = this._readableState.buffer.head;
        var content = '';
        while(p !== null){
            content += decoder.write(p.data);
            p = p.next;
        }
        this._readableState.buffer.clear();
        if (content !== '') this._readableState.buffer.push(content);
        this._readableState.length = content.length;
        return this;
    };
    var $82f1480952ab7c7d$var$MAX_HWM = 0x40000000;
    function $82f1480952ab7c7d$var$computeNewHighWaterMark(n) {
        if (n >= $82f1480952ab7c7d$var$MAX_HWM) n = $82f1480952ab7c7d$var$MAX_HWM;
        else {
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    function $82f1480952ab7c7d$var$howMuchToRead(n, state) {
        if (n <= 0 || state.length === 0 && state.ended) return 0;
        if (state.objectMode) return 1;
        if (n !== n) {
            if (state.flowing && state.length) return state.buffer.head.data.length;
            else return state.length;
        }
        if (n > state.highWaterMark) state.highWaterMark = $82f1480952ab7c7d$var$computeNewHighWaterMark(n);
        if (n <= state.length) return n;
        if (!state.ended) {
            state.needReadable = true;
            return 0;
        }
        return state.length;
    }
    $82f1480952ab7c7d$var$Readable.prototype.read = function(n) {
        $82f1480952ab7c7d$var$debug('read', n);
        n = parseInt(n, 10);
        var state = this._readableState;
        var nOrig = n;
        if (n !== 0) state.emittedReadable = false;
        if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
            $82f1480952ab7c7d$var$debug('read: emitReadable', state.length, state.ended);
            if (state.length === 0 && state.ended) $82f1480952ab7c7d$var$endReadable(this);
            else $82f1480952ab7c7d$var$emitReadable(this);
            return null;
        }
        n = $82f1480952ab7c7d$var$howMuchToRead(n, state);
        if (n === 0 && state.ended) {
            if (state.length === 0) $82f1480952ab7c7d$var$endReadable(this);
            return null;
        }
        var doRead = state.needReadable;
        $82f1480952ab7c7d$var$debug('need readable', doRead);
        if (state.length === 0 || state.length - n < state.highWaterMark) {
            doRead = true;
            $82f1480952ab7c7d$var$debug('length less than watermark', doRead);
        }
        if (state.ended || state.reading) {
            doRead = false;
            $82f1480952ab7c7d$var$debug('reading or ended', doRead);
        } else if (doRead) {
            $82f1480952ab7c7d$var$debug('do read');
            state.reading = true;
            state.sync = true;
            if (state.length === 0) state.needReadable = true;
            this._read(state.highWaterMark);
            state.sync = false;
            if (!state.reading) n = $82f1480952ab7c7d$var$howMuchToRead(nOrig, state);
        }
        var ret;
        if (n > 0) ret = $82f1480952ab7c7d$var$fromList(n, state);
        else ret = null;
        if (ret === null) {
            state.needReadable = state.length <= state.highWaterMark;
            n = 0;
        } else {
            state.length -= n;
            state.awaitDrain = 0;
        }
        if (state.length === 0) {
            if (!state.ended) state.needReadable = true;
            if (nOrig !== n && state.ended) $82f1480952ab7c7d$var$endReadable(this);
        }
        if (ret !== null) this.emit('data', ret);
        return ret;
    };
    function $82f1480952ab7c7d$var$onEofChunk(stream, state) {
        $82f1480952ab7c7d$var$debug('onEofChunk');
        if (state.ended) return;
        if (state.decoder) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
            }
        }
        state.ended = true;
        if (state.sync) $82f1480952ab7c7d$var$emitReadable(stream);
        else {
            state.needReadable = false;
            if (!state.emittedReadable) {
                state.emittedReadable = true;
                $82f1480952ab7c7d$var$emitReadable_(stream);
            }
        }
    }
    function $82f1480952ab7c7d$var$emitReadable(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('emitReadable', state.needReadable, state.emittedReadable);
        state.needReadable = false;
        if (!state.emittedReadable) {
            $82f1480952ab7c7d$var$debug('emitReadable', state.flowing);
            state.emittedReadable = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$emitReadable_, stream);
        }
    }
    function $82f1480952ab7c7d$var$emitReadable_(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
        if (!state.destroyed && (state.length || state.ended)) {
            stream.emit('readable');
            state.emittedReadable = false;
        }
        state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
        $82f1480952ab7c7d$var$flow(stream);
    }
    function $82f1480952ab7c7d$var$maybeReadMore(stream, state) {
        if (!state.readingMore) {
            state.readingMore = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$maybeReadMore_, stream, state);
        }
    }
    function $82f1480952ab7c7d$var$maybeReadMore_(stream, state) {
        while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
            var len = state.length;
            $82f1480952ab7c7d$var$debug('maybeReadMore read 0');
            stream.read(0);
            if (len === state.length) break;
        }
        state.readingMore = false;
    }
    $82f1480952ab7c7d$var$Readable.prototype._read = function(n) {
        $82f1480952ab7c7d$var$errorOrDestroy(this, new $82f1480952ab7c7d$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
    };
    $82f1480952ab7c7d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state = this._readableState;
        switch(state.pipesCount){
            case 0:
                state.pipes = dest;
                break;
            case 1:
                state.pipes = [
                    state.pipes,
                    dest
                ];
                break;
            default:
                state.pipes.push(dest);
                break;
        }
        state.pipesCount += 1;
        $82f1480952ab7c7d$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
        var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6cAn5.stdout && dest !== $6cAn5.stderr;
        var endFn = doEnd ? onend : unpipe;
        if (state.endEmitted) $6cAn5.nextTick(endFn);
        else src.once('end', endFn);
        dest.on('unpipe', onunpipe);
        function onunpipe(readable, unpipeInfo) {
            $82f1480952ab7c7d$var$debug('onunpipe');
            if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                    unpipeInfo.hasUnpiped = true;
                    cleanup();
                }
            }
        }
        function onend() {
            $82f1480952ab7c7d$var$debug('onend');
            dest.end();
        }
        var ondrain = $82f1480952ab7c7d$var$pipeOnDrain(src);
        dest.on('drain', ondrain);
        var cleanedUp = false;
        function cleanup() {
            $82f1480952ab7c7d$var$debug('cleanup');
            dest.removeListener('close', onclose);
            dest.removeListener('finish', onfinish);
            dest.removeListener('drain', ondrain);
            dest.removeListener('error', onerror);
            dest.removeListener('unpipe', onunpipe);
            src.removeListener('end', onend);
            src.removeListener('end', unpipe);
            src.removeListener('data', ondata);
            cleanedUp = true;
            if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        src.on('data', ondata);
        function ondata(chunk) {
            $82f1480952ab7c7d$var$debug('ondata');
            var ret = dest.write(chunk);
            $82f1480952ab7c7d$var$debug('dest.write', ret);
            if (ret === false) {
                if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $82f1480952ab7c7d$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                    $82f1480952ab7c7d$var$debug('false write response, pause', state.awaitDrain);
                    state.awaitDrain++;
                }
                src.pause();
            }
        }
        function onerror(er) {
            $82f1480952ab7c7d$var$debug('onerror', er);
            unpipe();
            dest.removeListener('error', onerror);
            if ($82f1480952ab7c7d$var$EElistenerCount(dest, 'error') === 0) $82f1480952ab7c7d$var$errorOrDestroy(dest, er);
        }
        $82f1480952ab7c7d$var$prependListener(dest, 'error', onerror);
        function onclose() {
            dest.removeListener('finish', onfinish);
            unpipe();
        }
        dest.once('close', onclose);
        function onfinish() {
            $82f1480952ab7c7d$var$debug('onfinish');
            dest.removeListener('close', onclose);
            unpipe();
        }
        dest.once('finish', onfinish);
        function unpipe() {
            $82f1480952ab7c7d$var$debug('unpipe');
            src.unpipe(dest);
        }
        dest.emit('pipe', src);
        if (!state.flowing) {
            $82f1480952ab7c7d$var$debug('pipe resume');
            src.resume();
        }
        return dest;
    };
    function $82f1480952ab7c7d$var$pipeOnDrain(src) {
        return function pipeOnDrainFunctionResult() {
            var state = src._readableState;
            $82f1480952ab7c7d$var$debug('pipeOnDrain', state.awaitDrain);
            if (state.awaitDrain) state.awaitDrain--;
            if (state.awaitDrain === 0 && $82f1480952ab7c7d$var$EElistenerCount(src, 'data')) {
                state.flowing = true;
                $82f1480952ab7c7d$var$flow(src);
            }
        };
    }
    $82f1480952ab7c7d$var$Readable.prototype.unpipe = function(dest) {
        var state = this._readableState;
        var unpipeInfo = {
            hasUnpiped: false
        };
        if (state.pipesCount === 0) return this;
        if (state.pipesCount === 1) {
            if (dest && dest !== state.pipes) return this;
            if (!dest) dest = state.pipes;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            if (dest) dest.emit('unpipe', this, unpipeInfo);
            return this;
        }
        if (!dest) {
            var dests = state.pipes;
            var len = state.pipesCount;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
                hasUnpiped: false
            });
            return this;
        }
        var index = $82f1480952ab7c7d$var$indexOf(state.pipes, dest);
        if (index === -1) return this;
        state.pipes.splice(index, 1);
        state.pipesCount -= 1;
        if (state.pipesCount === 1) state.pipes = state.pipes[0];
        dest.emit('unpipe', this, unpipeInfo);
        return this;
    };
    $82f1480952ab7c7d$var$Readable.prototype.on = function(ev, fn) {
        var res = $aX75n.prototype.on.call(this, ev, fn);
        var state = this._readableState;
        if (ev === 'data') {
            state.readableListening = this.listenerCount('readable') > 0;
            if (state.flowing !== false) this.resume();
        } else if (ev === 'readable') {
            if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.flowing = false;
                state.emittedReadable = false;
                $82f1480952ab7c7d$var$debug('on readable', state.length, state.reading);
                if (state.length) $82f1480952ab7c7d$var$emitReadable(this);
                else if (!state.reading) $6cAn5.nextTick($82f1480952ab7c7d$var$nReadingNextTick, this);
            }
        }
        return res;
    };
    $82f1480952ab7c7d$var$Readable.prototype.addListener = $82f1480952ab7c7d$var$Readable.prototype.on;
    $82f1480952ab7c7d$var$Readable.prototype.removeListener = function(ev, fn) {
        var res = $aX75n.prototype.removeListener.call(this, ev, fn);
        if (ev === 'readable') $6cAn5.nextTick($82f1480952ab7c7d$var$updateReadableListening, this);
        return res;
    };
    $82f1480952ab7c7d$var$Readable.prototype.removeAllListeners = function(ev) {
        var res = $aX75n.prototype.removeAllListeners.apply(this, arguments);
        if (ev === 'readable' || ev === undefined) $6cAn5.nextTick($82f1480952ab7c7d$var$updateReadableListening, this);
        return res;
    };
    function $82f1480952ab7c7d$var$updateReadableListening(self1) {
        var state = self1._readableState;
        state.readableListening = self1.listenerCount('readable') > 0;
        if (state.resumeScheduled && !state.paused) state.flowing = true;
        else if (self1.listenerCount('data') > 0) self1.resume();
    }
    function $82f1480952ab7c7d$var$nReadingNextTick(self1) {
        $82f1480952ab7c7d$var$debug('readable nexttick read 0');
        self1.read(0);
    }
    $82f1480952ab7c7d$var$Readable.prototype.resume = function() {
        var state = this._readableState;
        if (!state.flowing) {
            $82f1480952ab7c7d$var$debug('resume');
            state.flowing = !state.readableListening;
            $82f1480952ab7c7d$var$resume(this, state);
        }
        state.paused = false;
        return this;
    };
    function $82f1480952ab7c7d$var$resume(stream, state) {
        if (!state.resumeScheduled) {
            state.resumeScheduled = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$resume_, stream, state);
        }
    }
    function $82f1480952ab7c7d$var$resume_(stream, state) {
        $82f1480952ab7c7d$var$debug('resume', state.reading);
        if (!state.reading) stream.read(0);
        state.resumeScheduled = false;
        stream.emit('resume');
        $82f1480952ab7c7d$var$flow(stream);
        if (state.flowing && !state.reading) stream.read(0);
    }
    $82f1480952ab7c7d$var$Readable.prototype.pause = function() {
        $82f1480952ab7c7d$var$debug('call pause flowing=%j', this._readableState.flowing);
        if (this._readableState.flowing !== false) {
            $82f1480952ab7c7d$var$debug('pause');
            this._readableState.flowing = false;
            this.emit('pause');
        }
        this._readableState.paused = true;
        return this;
    };
    function $82f1480952ab7c7d$var$flow(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('flow', state.flowing);
        while(state.flowing && stream.read() !== null);
    }
    $82f1480952ab7c7d$var$Readable.prototype.wrap = function(stream) {
        var _this = this;
        var state = this._readableState;
        var paused = false;
        stream.on('end', function() {
            $82f1480952ab7c7d$var$debug('wrapped end');
            if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
            }
            _this.push(null);
        });
        stream.on('data', function(chunk) {
            $82f1480952ab7c7d$var$debug('wrapped data');
            if (state.decoder) chunk = state.decoder.write(chunk);
            if (state.objectMode && (chunk === null || chunk === undefined)) return;
            else if (!state.objectMode && (!chunk || !chunk.length)) return;
            var ret = _this.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
            return function methodWrapReturnFunction() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        for(var n = 0; n < $82f1480952ab7c7d$var$kProxyEvents.length; n++)stream.on($82f1480952ab7c7d$var$kProxyEvents[n], this.emit.bind(this, $82f1480952ab7c7d$var$kProxyEvents[n]));
        this._read = function(n) {
            $82f1480952ab7c7d$var$debug('wrapped _read', n);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return this;
    };
    if (typeof Symbol === 'function') $82f1480952ab7c7d$var$Readable.prototype[Symbol.asyncIterator] = function() {
        if ($82f1480952ab7c7d$var$createReadableStreamAsyncIterator === undefined) $82f1480952ab7c7d$var$createReadableStreamAsyncIterator = (parcelRequire("LC63a"));
        return $82f1480952ab7c7d$var$createReadableStreamAsyncIterator(this);
    };
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableHighWaterMark', {
        enumerable: false,
        get: function get() {
            return this._readableState.highWaterMark;
        }
    });
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableBuffer', {
        enumerable: false,
        get: function get() {
            return this._readableState && this._readableState.buffer;
        }
    });
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableFlowing', {
        enumerable: false,
        get: function get() {
            return this._readableState.flowing;
        },
        set: function set(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    });
    $82f1480952ab7c7d$var$Readable._fromList = $82f1480952ab7c7d$var$fromList;
    Object.defineProperty($82f1480952ab7c7d$var$Readable.prototype, 'readableLength', {
        enumerable: false,
        get: function get() {
            return this._readableState.length;
        }
    });
    function $82f1480952ab7c7d$var$fromList(n, state) {
        if (state.length === 0) return null;
        var ret;
        if (state.objectMode) ret = state.buffer.shift();
        else if (!n || n >= state.length) {
            if (state.decoder) ret = state.buffer.join('');
            else if (state.buffer.length === 1) ret = state.buffer.first();
            else ret = state.buffer.concat(state.length);
            state.buffer.clear();
        } else ret = state.buffer.consume(n, state.decoder);
        return ret;
    }
    function $82f1480952ab7c7d$var$endReadable(stream) {
        var state = stream._readableState;
        $82f1480952ab7c7d$var$debug('endReadable', state.endEmitted);
        if (!state.endEmitted) {
            state.ended = true;
            $6cAn5.nextTick($82f1480952ab7c7d$var$endReadableNT, state, stream);
        }
    }
    function $82f1480952ab7c7d$var$endReadableNT(state, stream) {
        $82f1480952ab7c7d$var$debug('endReadableNT', state.endEmitted, state.length);
        if (!state.endEmitted && state.length === 0) {
            state.endEmitted = true;
            stream.readable = false;
            stream.emit('end');
            if (state.autoDestroy) {
                var wState = stream._writableState;
                if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
            }
        }
    }
    if (typeof Symbol === 'function') $82f1480952ab7c7d$var$Readable.from = function(iterable, opts) {
        if ($82f1480952ab7c7d$var$from === undefined) $82f1480952ab7c7d$var$from = (parcelRequire("jV0Pb"));
        return $82f1480952ab7c7d$var$from($82f1480952ab7c7d$var$Readable, iterable, opts);
    };
    function $82f1480952ab7c7d$var$indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
});
parcelRegister("aX75n", function(module, exports) {
    module.exports = (parcelRequire("6Oghe")).EventEmitter;
});
parcelRegister("ifkfB", function(module, exports) {
    'use strict';
    function $d4895617e8f18431$var$ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function $d4895617e8f18431$var$_objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? $d4895617e8f18431$var$ownKeys(Object(source), !0).forEach(function(key) {
                $d4895617e8f18431$var$_defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d4895617e8f18431$var$ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function $d4895617e8f18431$var$_defineProperty(obj, key, value) {
        key = $d4895617e8f18431$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $d4895617e8f18431$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $d4895617e8f18431$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $d4895617e8f18431$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $d4895617e8f18431$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $d4895617e8f18431$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $d4895617e8f18431$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $d4895617e8f18431$var$_toPropertyKey(arg) {
        var key = $d4895617e8f18431$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $d4895617e8f18431$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $5k7LC = parcelRequire("5k7LC");
    var $d4895617e8f18431$var$Buffer = $5k7LC.Buffer;
    var $3gWwf = parcelRequire("3gWwf");
    var $d4895617e8f18431$var$inspect = $3gWwf.inspect;
    var $d4895617e8f18431$var$custom = $d4895617e8f18431$var$inspect && $d4895617e8f18431$var$inspect.custom || 'inspect';
    function $d4895617e8f18431$var$copyBuffer(src, target, offset) {
        $d4895617e8f18431$var$Buffer.prototype.copy.call(src, target, offset);
    }
    module.exports = function() {
        function BufferList() {
            $d4895617e8f18431$var$_classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        $d4895617e8f18431$var$_createClass(BufferList, [
            {
                key: "push",
                value: function push(v) {
                    var entry = {
                        data: v,
                        next: null
                    };
                    if (this.length > 0) this.tail.next = entry;
                    else this.head = entry;
                    this.tail = entry;
                    ++this.length;
                }
            },
            {
                key: "unshift",
                value: function unshift(v) {
                    var entry = {
                        data: v,
                        next: this.head
                    };
                    if (this.length === 0) this.tail = entry;
                    this.head = entry;
                    ++this.length;
                }
            },
            {
                key: "shift",
                value: function shift() {
                    if (this.length === 0) return;
                    var ret = this.head.data;
                    if (this.length === 1) this.head = this.tail = null;
                    else this.head = this.head.next;
                    --this.length;
                    return ret;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.head = this.tail = null;
                    this.length = 0;
                }
            },
            {
                key: "join",
                value: function join(s) {
                    if (this.length === 0) return '';
                    var p = this.head;
                    var ret = '' + p.data;
                    while(p = p.next)ret += s + p.data;
                    return ret;
                }
            },
            {
                key: "concat",
                value: function concat(n) {
                    if (this.length === 0) return $d4895617e8f18431$var$Buffer.alloc(0);
                    var ret = $d4895617e8f18431$var$Buffer.allocUnsafe(n >>> 0);
                    var p = this.head;
                    var i = 0;
                    while(p){
                        $d4895617e8f18431$var$copyBuffer(p.data, ret, i);
                        i += p.data.length;
                        p = p.next;
                    }
                    return ret;
                }
            },
            {
                key: "consume",
                value: function consume(n, hasStrings) {
                    var ret;
                    if (n < this.head.data.length) {
                        ret = this.head.data.slice(0, n);
                        this.head.data = this.head.data.slice(n);
                    } else if (n === this.head.data.length) ret = this.shift();
                    else ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                    return ret;
                }
            },
            {
                key: "first",
                value: function first() {
                    return this.head.data;
                }
            },
            {
                key: "_getString",
                value: function _getString(n) {
                    var p = this.head;
                    var c = 1;
                    var ret = p.data;
                    n -= ret.length;
                    while(p = p.next){
                        var str = p.data;
                        var nb = n > str.length ? str.length : n;
                        if (nb === str.length) ret += str;
                        else ret += str.slice(0, n);
                        n -= nb;
                        if (n === 0) {
                            if (nb === str.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = str.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: "_getBuffer",
                value: function _getBuffer(n) {
                    var ret = $d4895617e8f18431$var$Buffer.allocUnsafe(n);
                    var p = this.head;
                    var c = 1;
                    p.data.copy(ret);
                    n -= p.data.length;
                    while(p = p.next){
                        var buf = p.data;
                        var nb = n > buf.length ? buf.length : n;
                        buf.copy(ret, ret.length - n, 0, nb);
                        n -= nb;
                        if (n === 0) {
                            if (nb === buf.length) {
                                ++c;
                                if (p.next) this.head = p.next;
                                else this.head = this.tail = null;
                            } else {
                                this.head = p;
                                p.data = buf.slice(nb);
                            }
                            break;
                        }
                        ++c;
                    }
                    this.length -= c;
                    return ret;
                }
            },
            {
                key: $d4895617e8f18431$var$custom,
                value: function value(_, options) {
                    return $d4895617e8f18431$var$inspect(this, $d4895617e8f18431$var$_objectSpread($d4895617e8f18431$var$_objectSpread({}, options), {}, {
                        depth: 0,
                        customInspect: false
                    }));
                }
            }
        ]);
        return BufferList;
    }();
});
parcelRegister("kZqR5", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $f47e560b8425ff2b$var$destroy(err, cb) {
        var _this = this;
        var readableDestroyed = this._readableState && this._readableState.destroyed;
        var writableDestroyed = this._writableState && this._writableState.destroyed;
        if (readableDestroyed || writableDestroyed) {
            if (cb) cb(err);
            else if (err) {
                if (!this._writableState) $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorNT, this, err);
                else if (!this._writableState.errorEmitted) {
                    this._writableState.errorEmitted = true;
                    $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorNT, this, err);
                }
            }
            return this;
        }
        if (this._readableState) this._readableState.destroyed = true;
        if (this._writableState) this._writableState.destroyed = true;
        this._destroy(err || null, function(err) {
            if (!cb && err) {
                if (!_this._writableState) $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorAndCloseNT, _this, err);
                else if (!_this._writableState.errorEmitted) {
                    _this._writableState.errorEmitted = true;
                    $6cAn5.nextTick($f47e560b8425ff2b$var$emitErrorAndCloseNT, _this, err);
                } else $6cAn5.nextTick($f47e560b8425ff2b$var$emitCloseNT, _this);
            } else if (cb) {
                $6cAn5.nextTick($f47e560b8425ff2b$var$emitCloseNT, _this);
                cb(err);
            } else $6cAn5.nextTick($f47e560b8425ff2b$var$emitCloseNT, _this);
        });
        return this;
    }
    function $f47e560b8425ff2b$var$emitErrorAndCloseNT(self, err) {
        $f47e560b8425ff2b$var$emitErrorNT(self, err);
        $f47e560b8425ff2b$var$emitCloseNT(self);
    }
    function $f47e560b8425ff2b$var$emitCloseNT(self) {
        if (self._writableState && !self._writableState.emitClose) return;
        if (self._readableState && !self._readableState.emitClose) return;
        self.emit('close');
    }
    function $f47e560b8425ff2b$var$undestroy() {
        if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
        }
        if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
        }
    }
    function $f47e560b8425ff2b$var$emitErrorNT(self, err) {
        self.emit('error', err);
    }
    function $f47e560b8425ff2b$var$errorOrDestroy(stream, err) {
        var rState = stream._readableState;
        var wState = stream._writableState;
        if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
        else stream.emit('error', err);
    }
    module.exports = {
        destroy: $f47e560b8425ff2b$var$destroy,
        undestroy: $f47e560b8425ff2b$var$undestroy,
        errorOrDestroy: $f47e560b8425ff2b$var$errorOrDestroy
    };
});
parcelRegister("9GAcH", function(module, exports) {
    'use strict';
    var $70d41e9da8f0bbbf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("bBIKv")).codes.ERR_INVALID_OPT_VALUE;
    function $70d41e9da8f0bbbf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
        return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
    }
    function $70d41e9da8f0bbbf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
        var hwm = $70d41e9da8f0bbbf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
        if (hwm != null) {
            if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
                var name = isDuplex ? duplexKey : 'highWaterMark';
                throw new $70d41e9da8f0bbbf$var$ERR_INVALID_OPT_VALUE(name, hwm);
            }
            return Math.floor(hwm);
        }
        return state.objectMode ? 16 : 16384;
    }
    module.exports = {
        getHighWaterMark: $70d41e9da8f0bbbf$var$getHighWaterMark
    };
});
parcelRegister("bBIKv", function(module, exports) {
    $parcel$export(module.exports, "codes", ()=>$8735dc9fe35b6ad4$export$e45cb6485273080e, (v)=>$8735dc9fe35b6ad4$export$e45cb6485273080e = v);
    var $8735dc9fe35b6ad4$export$e45cb6485273080e;
    'use strict';
    function $8735dc9fe35b6ad4$var$_inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        subClass.__proto__ = superClass;
    }
    var $8735dc9fe35b6ad4$var$codes = {};
    function $8735dc9fe35b6ad4$var$createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = function(_Base) {
            $8735dc9fe35b6ad4$var$_inheritsLoose(NodeError, _Base);
            function NodeError(arg1, arg2, arg3) {
                return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
            }
            return NodeError;
        }(Base);
        NodeError.prototype.name = Base.name;
        NodeError.prototype.code = code;
        $8735dc9fe35b6ad4$var$codes[code] = NodeError;
    }
    function $8735dc9fe35b6ad4$var$oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function $8735dc9fe35b6ad4$var$startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function $8735dc9fe35b6ad4$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $8735dc9fe35b6ad4$var$includes(str, search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    $8735dc9fe35b6ad4$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
        return 'The value "' + value + '" is invalid for option "' + name + '"';
    }, TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
        var determiner;
        if (typeof expected === 'string' && $8735dc9fe35b6ad4$var$startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
        } else determiner = 'must be';
        var msg;
        if ($8735dc9fe35b6ad4$var$endsWith(name, ' argument')) msg = "The ".concat(name, " ").concat(determiner, " ").concat($8735dc9fe35b6ad4$var$oneOf(expected, 'type'));
        else {
            var type = $8735dc9fe35b6ad4$var$includes(name, '.') ? 'property' : 'argument';
            msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($8735dc9fe35b6ad4$var$oneOf(expected, 'type'));
        }
        msg += ". Received type ".concat(typeof actual);
        return msg;
    }, TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
        return 'The ' + name + ' method is not implemented';
    });
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
        return 'Cannot call ' + name + ' after a stream was destroyed';
    });
    $8735dc9fe35b6ad4$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
        return 'Unknown encoding: ' + arg;
    }, TypeError);
    $8735dc9fe35b6ad4$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
    $8735dc9fe35b6ad4$export$e45cb6485273080e = $8735dc9fe35b6ad4$var$codes;
});
parcelRegister("i5T1N", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $d2c36102fbaedf53$var$objectKeys = Object.keys || function(obj) {
        var keys = [];
        for(var key in obj)keys.push(key);
        return keys;
    };
    module.exports = $d2c36102fbaedf53$var$Duplex;
    var $bf0eV = parcelRequire("bf0eV");
    var $eys0S = parcelRequire("eys0S");
    (parcelRequire("v3bBu"))($d2c36102fbaedf53$var$Duplex, $bf0eV);
    var $d2c36102fbaedf53$var$keys = $d2c36102fbaedf53$var$objectKeys($eys0S.prototype);
    for(var $d2c36102fbaedf53$var$v = 0; $d2c36102fbaedf53$var$v < $d2c36102fbaedf53$var$keys.length; $d2c36102fbaedf53$var$v++){
        var $d2c36102fbaedf53$var$method = $d2c36102fbaedf53$var$keys[$d2c36102fbaedf53$var$v];
        if (!$d2c36102fbaedf53$var$Duplex.prototype[$d2c36102fbaedf53$var$method]) $d2c36102fbaedf53$var$Duplex.prototype[$d2c36102fbaedf53$var$method] = $eys0S.prototype[$d2c36102fbaedf53$var$method];
    }
    function $d2c36102fbaedf53$var$Duplex(options) {
        if (!(this instanceof $d2c36102fbaedf53$var$Duplex)) return new $d2c36102fbaedf53$var$Duplex(options);
        $bf0eV.call(this, options);
        $eys0S.call(this, options);
        this.allowHalfOpen = true;
        if (options) {
            if (options.readable === false) this.readable = false;
            if (options.writable === false) this.writable = false;
            if (options.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once('end', $d2c36102fbaedf53$var$onend);
            }
        }
    }
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function get() {
            return this._writableState.highWaterMark;
        }
    });
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'writableBuffer', {
        enumerable: false,
        get: function get() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'writableLength', {
        enumerable: false,
        get: function get() {
            return this._writableState.length;
        }
    });
    function $d2c36102fbaedf53$var$onend() {
        if (this._writableState.ended) return;
        $6cAn5.nextTick($d2c36102fbaedf53$var$onEndNT, this);
    }
    function $d2c36102fbaedf53$var$onEndNT(self) {
        self.end();
    }
    Object.defineProperty($d2c36102fbaedf53$var$Duplex.prototype, 'destroyed', {
        enumerable: false,
        get: function get() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function set(value) {
            if (this._readableState === undefined || this._writableState === undefined) return;
            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
        }
    });
});
parcelRegister("eys0S", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    module.exports = $a989f87ed04e2b91$var$Writable;
    function $a989f87ed04e2b91$var$WriteReq(chunk, encoding, cb) {
        this.chunk = chunk;
        this.encoding = encoding;
        this.callback = cb;
        this.next = null;
    }
    function $a989f87ed04e2b91$var$CorkedRequest(state) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function() {
            $a989f87ed04e2b91$var$onCorkedFinish(_this, state);
        };
    }
    var $a989f87ed04e2b91$var$Duplex;
    $a989f87ed04e2b91$var$Writable.WritableState = $a989f87ed04e2b91$var$WritableState;
    var $a989f87ed04e2b91$var$internalUtil = {
        deprecate: (parcelRequire("geQ6V"))
    };
    var $aX75n = parcelRequire("aX75n");
    var $5k7LC = parcelRequire("5k7LC");
    var $a989f87ed04e2b91$require$Buffer = $5k7LC.Buffer;
    var $a989f87ed04e2b91$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $a989f87ed04e2b91$var$_uint8ArrayToBuffer(chunk) {
        return $a989f87ed04e2b91$require$Buffer.from(chunk);
    }
    function $a989f87ed04e2b91$var$_isUint8Array(obj) {
        return $a989f87ed04e2b91$require$Buffer.isBuffer(obj) || obj instanceof $a989f87ed04e2b91$var$OurUint8Array;
    }
    var $kZqR5 = parcelRequire("kZqR5");
    var $9GAcH = parcelRequire("9GAcH");
    var $a989f87ed04e2b91$var$getHighWaterMark = $9GAcH.getHighWaterMark;
    var $bBIKv = parcelRequire("bBIKv");
    var $a989f87ed04e2b91$require$_require$codes = $bBIKv.codes;
    var $a989f87ed04e2b91$var$ERR_INVALID_ARG_TYPE = $a989f87ed04e2b91$require$_require$codes.ERR_INVALID_ARG_TYPE, $a989f87ed04e2b91$var$ERR_METHOD_NOT_IMPLEMENTED = $a989f87ed04e2b91$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $a989f87ed04e2b91$var$ERR_MULTIPLE_CALLBACK = $a989f87ed04e2b91$require$_require$codes.ERR_MULTIPLE_CALLBACK, $a989f87ed04e2b91$var$ERR_STREAM_CANNOT_PIPE = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $a989f87ed04e2b91$var$ERR_STREAM_DESTROYED = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_DESTROYED, $a989f87ed04e2b91$var$ERR_STREAM_NULL_VALUES = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_NULL_VALUES, $a989f87ed04e2b91$var$ERR_STREAM_WRITE_AFTER_END = $a989f87ed04e2b91$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $a989f87ed04e2b91$var$ERR_UNKNOWN_ENCODING = $a989f87ed04e2b91$require$_require$codes.ERR_UNKNOWN_ENCODING;
    var $a989f87ed04e2b91$var$errorOrDestroy = $kZqR5.errorOrDestroy;
    (parcelRequire("v3bBu"))($a989f87ed04e2b91$var$Writable, $aX75n);
    function $a989f87ed04e2b91$var$nop() {}
    function $a989f87ed04e2b91$var$WritableState(options, stream, isDuplex) {
        $a989f87ed04e2b91$var$Duplex = $a989f87ed04e2b91$var$Duplex || (parcelRequire("i5T1N"));
        options = options || {};
        if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $a989f87ed04e2b91$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
        this.highWaterMark = $a989f87ed04e2b91$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        var noDecode = options.decodeStrings === false;
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = function(er) {
            $a989f87ed04e2b91$var$onwrite(stream, er);
        };
        this.writecb = null;
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        this.pendingcb = 0;
        this.prefinished = false;
        this.errorEmitted = false;
        this.emitClose = options.emitClose !== false;
        this.autoDestroy = !!options.autoDestroy;
        this.bufferedRequestCount = 0;
        this.corkedRequestsFree = new $a989f87ed04e2b91$var$CorkedRequest(this);
    }
    $a989f87ed04e2b91$var$WritableState.prototype.getBuffer = function getBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    (function() {
        try {
            Object.defineProperty($a989f87ed04e2b91$var$WritableState.prototype, 'buffer', {
                get: $a989f87ed04e2b91$var$internalUtil.deprecate(function writableStateBufferGetter() {
                    return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
            });
        } catch (_) {}
    })();
    var $a989f87ed04e2b91$var$realHasInstance;
    if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
        $a989f87ed04e2b91$var$realHasInstance = Function.prototype[Symbol.hasInstance];
        Object.defineProperty($a989f87ed04e2b91$var$Writable, Symbol.hasInstance, {
            value: function value(object) {
                if ($a989f87ed04e2b91$var$realHasInstance.call(this, object)) return true;
                if (this !== $a989f87ed04e2b91$var$Writable) return false;
                return object && object._writableState instanceof $a989f87ed04e2b91$var$WritableState;
            }
        });
    } else $a989f87ed04e2b91$var$realHasInstance = function realHasInstance(object) {
        return object instanceof this;
    };
    function $a989f87ed04e2b91$var$Writable(options) {
        $a989f87ed04e2b91$var$Duplex = $a989f87ed04e2b91$var$Duplex || (parcelRequire("i5T1N"));
        var isDuplex = this instanceof $a989f87ed04e2b91$var$Duplex;
        if (!isDuplex && !$a989f87ed04e2b91$var$realHasInstance.call($a989f87ed04e2b91$var$Writable, this)) return new $a989f87ed04e2b91$var$Writable(options);
        this._writableState = new $a989f87ed04e2b91$var$WritableState(options, this, isDuplex);
        this.writable = true;
        if (options) {
            if (typeof options.write === 'function') this._write = options.write;
            if (typeof options.writev === 'function') this._writev = options.writev;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
            if (typeof options.final === 'function') this._final = options.final;
        }
        $aX75n.call(this);
    }
    $a989f87ed04e2b91$var$Writable.prototype.pipe = function() {
        $a989f87ed04e2b91$var$errorOrDestroy(this, new $a989f87ed04e2b91$var$ERR_STREAM_CANNOT_PIPE());
    };
    function $a989f87ed04e2b91$var$writeAfterEnd(stream, cb) {
        var er = new $a989f87ed04e2b91$var$ERR_STREAM_WRITE_AFTER_END();
        $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
        $6cAn5.nextTick(cb, er);
    }
    function $a989f87ed04e2b91$var$validChunk(stream, state, chunk, cb) {
        var er;
        if (chunk === null) er = new $a989f87ed04e2b91$var$ERR_STREAM_NULL_VALUES();
        else if (typeof chunk !== 'string' && !state.objectMode) er = new $a989f87ed04e2b91$var$ERR_INVALID_ARG_TYPE('chunk', [
            'string',
            'Buffer'
        ], chunk);
        if (er) {
            $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
            $6cAn5.nextTick(cb, er);
            return false;
        }
        return true;
    }
    $a989f87ed04e2b91$var$Writable.prototype.write = function(chunk, encoding, cb) {
        var state = this._writableState;
        var ret = false;
        var isBuf = !state.objectMode && $a989f87ed04e2b91$var$_isUint8Array(chunk);
        if (isBuf && !$a989f87ed04e2b91$require$Buffer.isBuffer(chunk)) chunk = $a989f87ed04e2b91$var$_uint8ArrayToBuffer(chunk);
        if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (isBuf) encoding = 'buffer';
        else if (!encoding) encoding = state.defaultEncoding;
        if (typeof cb !== 'function') cb = $a989f87ed04e2b91$var$nop;
        if (state.ending) $a989f87ed04e2b91$var$writeAfterEnd(this, cb);
        else if (isBuf || $a989f87ed04e2b91$var$validChunk(this, state, chunk, cb)) {
            state.pendingcb++;
            ret = $a989f87ed04e2b91$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
        }
        return ret;
    };
    $a989f87ed04e2b91$var$Writable.prototype.cork = function() {
        this._writableState.corked++;
    };
    $a989f87ed04e2b91$var$Writable.prototype.uncork = function() {
        var state = this._writableState;
        if (state.corked) {
            state.corked--;
            if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a989f87ed04e2b91$var$clearBuffer(this, state);
        }
    };
    $a989f87ed04e2b91$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === 'string') encoding = encoding.toLowerCase();
        if (!([
            'hex',
            'utf8',
            'utf-8',
            'ascii',
            'binary',
            'base64',
            'ucs2',
            'ucs-2',
            'utf16le',
            'utf-16le',
            'raw'
        ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $a989f87ed04e2b91$var$ERR_UNKNOWN_ENCODING(encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'writableBuffer', {
        enumerable: false,
        get: function get() {
            return this._writableState && this._writableState.getBuffer();
        }
    });
    function $a989f87ed04e2b91$var$decodeChunk(state, chunk, encoding) {
        if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $a989f87ed04e2b91$require$Buffer.from(chunk, encoding);
        return chunk;
    }
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function get() {
            return this._writableState.highWaterMark;
        }
    });
    function $a989f87ed04e2b91$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
        if (!isBuf) {
            var newChunk = $a989f87ed04e2b91$var$decodeChunk(state, chunk, encoding);
            if (chunk !== newChunk) {
                isBuf = true;
                encoding = 'buffer';
                chunk = newChunk;
            }
        }
        var len = state.objectMode ? 1 : chunk.length;
        state.length += len;
        var ret = state.length < state.highWaterMark;
        if (!ret) state.needDrain = true;
        if (state.writing || state.corked) {
            var last = state.lastBufferedRequest;
            state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
            };
            if (last) last.next = state.lastBufferedRequest;
            else state.bufferedRequest = state.lastBufferedRequest;
            state.bufferedRequestCount += 1;
        } else $a989f87ed04e2b91$var$doWrite(stream, state, false, len, chunk, encoding, cb);
        return ret;
    }
    function $a989f87ed04e2b91$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
        state.writelen = len;
        state.writecb = cb;
        state.writing = true;
        state.sync = true;
        if (state.destroyed) state.onwrite(new $a989f87ed04e2b91$var$ERR_STREAM_DESTROYED('write'));
        else if (writev) stream._writev(chunk, state.onwrite);
        else stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    function $a989f87ed04e2b91$var$onwriteError(stream, state, sync, er, cb) {
        --state.pendingcb;
        if (sync) {
            $6cAn5.nextTick(cb, er);
            $6cAn5.nextTick($a989f87ed04e2b91$var$finishMaybe, stream, state);
            stream._writableState.errorEmitted = true;
            $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
        } else {
            cb(er);
            stream._writableState.errorEmitted = true;
            $a989f87ed04e2b91$var$errorOrDestroy(stream, er);
            $a989f87ed04e2b91$var$finishMaybe(stream, state);
        }
    }
    function $a989f87ed04e2b91$var$onwriteStateUpdate(state) {
        state.writing = false;
        state.writecb = null;
        state.length -= state.writelen;
        state.writelen = 0;
    }
    function $a989f87ed04e2b91$var$onwrite(stream, er) {
        var state = stream._writableState;
        var sync = state.sync;
        var cb = state.writecb;
        if (typeof cb !== 'function') throw new $a989f87ed04e2b91$var$ERR_MULTIPLE_CALLBACK();
        $a989f87ed04e2b91$var$onwriteStateUpdate(state);
        if (er) $a989f87ed04e2b91$var$onwriteError(stream, state, sync, er, cb);
        else {
            var finished = $a989f87ed04e2b91$var$needFinish(state) || stream.destroyed;
            if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $a989f87ed04e2b91$var$clearBuffer(stream, state);
            if (sync) $6cAn5.nextTick($a989f87ed04e2b91$var$afterWrite, stream, state, finished, cb);
            else $a989f87ed04e2b91$var$afterWrite(stream, state, finished, cb);
        }
    }
    function $a989f87ed04e2b91$var$afterWrite(stream, state, finished, cb) {
        if (!finished) $a989f87ed04e2b91$var$onwriteDrain(stream, state);
        state.pendingcb--;
        cb();
        $a989f87ed04e2b91$var$finishMaybe(stream, state);
    }
    function $a989f87ed04e2b91$var$onwriteDrain(stream, state) {
        if (state.length === 0 && state.needDrain) {
            state.needDrain = false;
            stream.emit('drain');
        }
    }
    function $a989f87ed04e2b91$var$clearBuffer(stream, state) {
        state.bufferProcessing = true;
        var entry = state.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            var l = state.bufferedRequestCount;
            var buffer = new Array(l);
            var holder = state.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            var allBuffers = true;
            while(entry){
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
            }
            buffer.allBuffers = allBuffers;
            $a989f87ed04e2b91$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
            state.pendingcb++;
            state.lastBufferedRequest = null;
            if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state.corkedRequestsFree = new $a989f87ed04e2b91$var$CorkedRequest(state);
            state.bufferedRequestCount = 0;
        } else {
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                $a989f87ed04e2b91$var$doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--;
                if (state.writing) break;
            }
            if (entry === null) state.lastBufferedRequest = null;
        }
        state.bufferedRequest = entry;
        state.bufferProcessing = false;
    }
    $a989f87ed04e2b91$var$Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new $a989f87ed04e2b91$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
    };
    $a989f87ed04e2b91$var$Writable.prototype._writev = null;
    $a989f87ed04e2b91$var$Writable.prototype.end = function(chunk, encoding, cb) {
        var state = this._writableState;
        if (typeof chunk === 'function') {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
        if (state.corked) {
            state.corked = 1;
            this.uncork();
        }
        if (!state.ending) $a989f87ed04e2b91$var$endWritable(this, state, cb);
        return this;
    };
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'writableLength', {
        enumerable: false,
        get: function get() {
            return this._writableState.length;
        }
    });
    function $a989f87ed04e2b91$var$needFinish(state) {
        return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }
    function $a989f87ed04e2b91$var$callFinal(stream, state) {
        stream._final(function(err) {
            state.pendingcb--;
            if (err) $a989f87ed04e2b91$var$errorOrDestroy(stream, err);
            state.prefinished = true;
            stream.emit('prefinish');
            $a989f87ed04e2b91$var$finishMaybe(stream, state);
        });
    }
    function $a989f87ed04e2b91$var$prefinish(stream, state) {
        if (!state.prefinished && !state.finalCalled) {
            if (typeof stream._final === 'function' && !state.destroyed) {
                state.pendingcb++;
                state.finalCalled = true;
                $6cAn5.nextTick($a989f87ed04e2b91$var$callFinal, stream, state);
            } else {
                state.prefinished = true;
                stream.emit('prefinish');
            }
        }
    }
    function $a989f87ed04e2b91$var$finishMaybe(stream, state) {
        var need = $a989f87ed04e2b91$var$needFinish(state);
        if (need) {
            $a989f87ed04e2b91$var$prefinish(stream, state);
            if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit('finish');
                if (state.autoDestroy) {
                    var rState = stream._readableState;
                    if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
                }
            }
        }
        return need;
    }
    function $a989f87ed04e2b91$var$endWritable(stream, state, cb) {
        state.ending = true;
        $a989f87ed04e2b91$var$finishMaybe(stream, state);
        if (cb) {
            if (state.finished) $6cAn5.nextTick(cb);
            else stream.once('finish', cb);
        }
        state.ended = true;
        stream.writable = false;
    }
    function $a989f87ed04e2b91$var$onCorkedFinish(corkReq, state, err) {
        var entry = corkReq.entry;
        corkReq.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        state.corkedRequestsFree.next = corkReq;
    }
    Object.defineProperty($a989f87ed04e2b91$var$Writable.prototype, 'destroyed', {
        enumerable: false,
        get: function get() {
            if (this._writableState === undefined) return false;
            return this._writableState.destroyed;
        },
        set: function set(value) {
            if (!this._writableState) return;
            this._writableState.destroyed = value;
        }
    });
    $a989f87ed04e2b91$var$Writable.prototype.destroy = $kZqR5.destroy;
    $a989f87ed04e2b91$var$Writable.prototype._undestroy = $kZqR5.undestroy;
    $a989f87ed04e2b91$var$Writable.prototype._destroy = function(err, cb) {
        cb(err);
    };
});
parcelRegister("geQ6V", function(module, exports) {
    module.exports = $bd26603cb430fbe6$var$deprecate;
    function $bd26603cb430fbe6$var$deprecate(fn, msg) {
        if ($bd26603cb430fbe6$var$config('noDeprecation')) return fn;
        var warned = false;
        function deprecated() {
            if (!warned) {
                if ($bd26603cb430fbe6$var$config('throwDeprecation')) throw new Error(msg);
                else if ($bd26603cb430fbe6$var$config('traceDeprecation')) console.trace(msg);
                else console.warn(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    }
    function $bd26603cb430fbe6$var$config(name) {
        try {
            if (!$parcel$global.localStorage) return false;
        } catch (_) {
            return false;
        }
        var val = $parcel$global.localStorage[name];
        if (null == val) return false;
        return String(val).toLowerCase() === 'true';
    }
});
parcelRegister("3872E", function(module, exports) {
    $parcel$export(module.exports, "StringDecoder", ()=>$247794d1c930d1a9$export$63a7aa211a91ed69, (v)=>$247794d1c930d1a9$export$63a7aa211a91ed69 = v);
    var $247794d1c930d1a9$export$63a7aa211a91ed69;
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $247794d1c930d1a9$require$Buffer = $Wth4q.Buffer;
    var $247794d1c930d1a9$var$isEncoding = $247794d1c930d1a9$require$Buffer.isEncoding || function(encoding) {
        encoding = '' + encoding;
        switch(encoding && encoding.toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
            case 'raw':
                return true;
            default:
                return false;
        }
    };
    function $247794d1c930d1a9$var$_normalizeEncoding(enc) {
        if (!enc) return 'utf8';
        var retried;
        while(true)switch(enc){
            case 'utf8':
            case 'utf-8':
                return 'utf8';
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return 'utf16le';
            case 'latin1':
            case 'binary':
                return 'latin1';
            case 'base64':
            case 'ascii':
            case 'hex':
                return enc;
            default:
                if (retried) return;
                enc = ('' + enc).toLowerCase();
                retried = true;
        }
    }
    function $247794d1c930d1a9$var$normalizeEncoding(enc) {
        var nenc = $247794d1c930d1a9$var$_normalizeEncoding(enc);
        if (typeof nenc !== 'string' && ($247794d1c930d1a9$require$Buffer.isEncoding === $247794d1c930d1a9$var$isEncoding || !$247794d1c930d1a9$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
        return nenc || enc;
    }
    $247794d1c930d1a9$export$63a7aa211a91ed69 = $247794d1c930d1a9$var$StringDecoder;
    function $247794d1c930d1a9$var$StringDecoder(encoding) {
        this.encoding = $247794d1c930d1a9$var$normalizeEncoding(encoding);
        var nb;
        switch(this.encoding){
            case 'utf16le':
                this.text = $247794d1c930d1a9$var$utf16Text;
                this.end = $247794d1c930d1a9$var$utf16End;
                nb = 4;
                break;
            case 'utf8':
                this.fillLast = $247794d1c930d1a9$var$utf8FillLast;
                nb = 4;
                break;
            case 'base64':
                this.text = $247794d1c930d1a9$var$base64Text;
                this.end = $247794d1c930d1a9$var$base64End;
                nb = 3;
                break;
            default:
                this.write = $247794d1c930d1a9$var$simpleWrite;
                this.end = $247794d1c930d1a9$var$simpleEnd;
                return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = $247794d1c930d1a9$require$Buffer.allocUnsafe(nb);
    }
    $247794d1c930d1a9$var$StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return '';
        var r;
        var i;
        if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === undefined) return '';
            i = this.lastNeed;
            this.lastNeed = 0;
        } else i = 0;
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || '';
    };
    $247794d1c930d1a9$var$StringDecoder.prototype.end = $247794d1c930d1a9$var$utf8End;
    $247794d1c930d1a9$var$StringDecoder.prototype.text = $247794d1c930d1a9$var$utf8Text;
    $247794d1c930d1a9$var$StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
    };
    function $247794d1c930d1a9$var$utf8CheckByte(byte) {
        if (byte <= 0x7F) return 0;
        else if (byte >> 5 === 0x06) return 2;
        else if (byte >> 4 === 0x0E) return 3;
        else if (byte >> 3 === 0x1E) return 4;
        return byte >> 6 === 0x02 ? -1 : -2;
    }
    function $247794d1c930d1a9$var$utf8CheckIncomplete(self, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 1;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 2;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $247794d1c930d1a9$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) {
                if (nb === 2) nb = 0;
                else self.lastNeed = nb - 3;
            }
            return nb;
        }
        return 0;
    }
    function $247794d1c930d1a9$var$utf8CheckExtraBytes(self, buf, p) {
        if ((buf[0] & 0xC0) !== 0x80) {
            self.lastNeed = 0;
            return '\ufffd';
        }
        if (self.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 0xC0) !== 0x80) {
                self.lastNeed = 1;
                return '\ufffd';
            }
            if (self.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 0xC0) !== 0x80) {
                    self.lastNeed = 2;
                    return '\ufffd';
                }
            }
        }
    }
    function $247794d1c930d1a9$var$utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = $247794d1c930d1a9$var$utf8CheckExtraBytes(this, buf, p);
        if (r !== undefined) return r;
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
    }
    function $247794d1c930d1a9$var$utf8Text(buf, i) {
        var total = $247794d1c930d1a9$var$utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString('utf8', i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString('utf8', i, end);
    }
    function $247794d1c930d1a9$var$utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + '\ufffd';
        return r;
    }
    function $247794d1c930d1a9$var$utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
            var r = buf.toString('utf16le', i);
            if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 0xD800 && c <= 0xDBFF) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                }
            }
            return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString('utf16le', i, buf.length - 1);
    }
    function $247794d1c930d1a9$var$utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) {
            var end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString('utf16le', 0, end);
        }
        return r;
    }
    function $247794d1c930d1a9$var$base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString('base64', i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) this.lastChar[0] = buf[buf.length - 1];
        else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString('base64', i, buf.length - n);
    }
    function $247794d1c930d1a9$var$base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
        return r;
    }
    function $247794d1c930d1a9$var$simpleWrite(buf) {
        return buf.toString(this.encoding);
    }
    function $247794d1c930d1a9$var$simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : '';
    }
});
parcelRegister("LC63a", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $08f1f116beb38af8$var$_Object$setPrototypeO;
    function $08f1f116beb38af8$var$_defineProperty(obj, key, value) {
        key = $08f1f116beb38af8$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $08f1f116beb38af8$var$_toPropertyKey(arg) {
        var key = $08f1f116beb38af8$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $08f1f116beb38af8$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $fdhlO = parcelRequire("fdhlO");
    var $08f1f116beb38af8$var$kLastResolve = Symbol('lastResolve');
    var $08f1f116beb38af8$var$kLastReject = Symbol('lastReject');
    var $08f1f116beb38af8$var$kError = Symbol('error');
    var $08f1f116beb38af8$var$kEnded = Symbol('ended');
    var $08f1f116beb38af8$var$kLastPromise = Symbol('lastPromise');
    var $08f1f116beb38af8$var$kHandlePromise = Symbol('handlePromise');
    var $08f1f116beb38af8$var$kStream = Symbol('stream');
    function $08f1f116beb38af8$var$createIterResult(value, done) {
        return {
            value: value,
            done: done
        };
    }
    function $08f1f116beb38af8$var$readAndResolve(iter) {
        var resolve = iter[$08f1f116beb38af8$var$kLastResolve];
        if (resolve !== null) {
            var data = iter[$08f1f116beb38af8$var$kStream].read();
            if (data !== null) {
                iter[$08f1f116beb38af8$var$kLastPromise] = null;
                iter[$08f1f116beb38af8$var$kLastResolve] = null;
                iter[$08f1f116beb38af8$var$kLastReject] = null;
                resolve($08f1f116beb38af8$var$createIterResult(data, false));
            }
        }
    }
    function $08f1f116beb38af8$var$onReadable(iter) {
        $6cAn5.nextTick($08f1f116beb38af8$var$readAndResolve, iter);
    }
    function $08f1f116beb38af8$var$wrapForNext(lastPromise, iter) {
        return function(resolve, reject) {
            lastPromise.then(function() {
                if (iter[$08f1f116beb38af8$var$kEnded]) {
                    resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
                    return;
                }
                iter[$08f1f116beb38af8$var$kHandlePromise](resolve, reject);
            }, reject);
        };
    }
    var $08f1f116beb38af8$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
    var $08f1f116beb38af8$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($08f1f116beb38af8$var$_Object$setPrototypeO = {
        get stream () {
            return this[$08f1f116beb38af8$var$kStream];
        },
        next: function next() {
            var _this = this;
            var error = this[$08f1f116beb38af8$var$kError];
            if (error !== null) return Promise.reject(error);
            if (this[$08f1f116beb38af8$var$kEnded]) return Promise.resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
            if (this[$08f1f116beb38af8$var$kStream].destroyed) return new Promise(function(resolve, reject) {
                $6cAn5.nextTick(function() {
                    if (_this[$08f1f116beb38af8$var$kError]) reject(_this[$08f1f116beb38af8$var$kError]);
                    else resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
                });
            });
            var lastPromise = this[$08f1f116beb38af8$var$kLastPromise];
            var promise;
            if (lastPromise) promise = new Promise($08f1f116beb38af8$var$wrapForNext(lastPromise, this));
            else {
                var data = this[$08f1f116beb38af8$var$kStream].read();
                if (data !== null) return Promise.resolve($08f1f116beb38af8$var$createIterResult(data, false));
                promise = new Promise(this[$08f1f116beb38af8$var$kHandlePromise]);
            }
            this[$08f1f116beb38af8$var$kLastPromise] = promise;
            return promise;
        }
    }, $08f1f116beb38af8$var$_defineProperty($08f1f116beb38af8$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
        return this;
    }), $08f1f116beb38af8$var$_defineProperty($08f1f116beb38af8$var$_Object$setPrototypeO, "return", function _return() {
        var _this2 = this;
        return new Promise(function(resolve, reject) {
            _this2[$08f1f116beb38af8$var$kStream].destroy(null, function(err) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
            });
        });
    }), $08f1f116beb38af8$var$_Object$setPrototypeO), $08f1f116beb38af8$var$AsyncIteratorPrototype);
    var $08f1f116beb38af8$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
        var _Object$create;
        var iterator = Object.create($08f1f116beb38af8$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kStream, {
            value: stream,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kLastResolve, {
            value: null,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kLastReject, {
            value: null,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kError, {
            value: null,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kEnded, {
            value: stream._readableState.endEmitted,
            writable: true
        }), $08f1f116beb38af8$var$_defineProperty(_Object$create, $08f1f116beb38af8$var$kHandlePromise, {
            value: function value(resolve, reject) {
                var data = iterator[$08f1f116beb38af8$var$kStream].read();
                if (data) {
                    iterator[$08f1f116beb38af8$var$kLastPromise] = null;
                    iterator[$08f1f116beb38af8$var$kLastResolve] = null;
                    iterator[$08f1f116beb38af8$var$kLastReject] = null;
                    resolve($08f1f116beb38af8$var$createIterResult(data, false));
                } else {
                    iterator[$08f1f116beb38af8$var$kLastResolve] = resolve;
                    iterator[$08f1f116beb38af8$var$kLastReject] = reject;
                }
            },
            writable: true
        }), _Object$create));
        iterator[$08f1f116beb38af8$var$kLastPromise] = null;
        $fdhlO(stream, function(err) {
            if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
                var reject = iterator[$08f1f116beb38af8$var$kLastReject];
                if (reject !== null) {
                    iterator[$08f1f116beb38af8$var$kLastPromise] = null;
                    iterator[$08f1f116beb38af8$var$kLastResolve] = null;
                    iterator[$08f1f116beb38af8$var$kLastReject] = null;
                    reject(err);
                }
                iterator[$08f1f116beb38af8$var$kError] = err;
                return;
            }
            var resolve = iterator[$08f1f116beb38af8$var$kLastResolve];
            if (resolve !== null) {
                iterator[$08f1f116beb38af8$var$kLastPromise] = null;
                iterator[$08f1f116beb38af8$var$kLastResolve] = null;
                iterator[$08f1f116beb38af8$var$kLastReject] = null;
                resolve($08f1f116beb38af8$var$createIterResult(undefined, true));
            }
            iterator[$08f1f116beb38af8$var$kEnded] = true;
        });
        stream.on('readable', $08f1f116beb38af8$var$onReadable.bind(null, iterator));
        return iterator;
    };
    module.exports = $08f1f116beb38af8$var$createReadableStreamAsyncIterator;
});
parcelRegister("fdhlO", function(module, exports) {
    'use strict';
    var $b135876c7ee1da99$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("bBIKv")).codes.ERR_STREAM_PREMATURE_CLOSE;
    function $b135876c7ee1da99$var$once(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            callback.apply(this, args);
        };
    }
    function $b135876c7ee1da99$var$noop() {}
    function $b135876c7ee1da99$var$isRequest(stream) {
        return stream.setHeader && typeof stream.abort === 'function';
    }
    function $b135876c7ee1da99$var$eos(stream, opts, callback) {
        if (typeof opts === 'function') return $b135876c7ee1da99$var$eos(stream, null, opts);
        if (!opts) opts = {};
        callback = $b135876c7ee1da99$var$once(callback || $b135876c7ee1da99$var$noop);
        var readable = opts.readable || opts.readable !== false && stream.readable;
        var writable = opts.writable || opts.writable !== false && stream.writable;
        var onlegacyfinish = function onlegacyfinish() {
            if (!stream.writable) onfinish();
        };
        var writableEnded = stream._writableState && stream._writableState.finished;
        var onfinish = function onfinish() {
            writable = false;
            writableEnded = true;
            if (!readable) callback.call(stream);
        };
        var readableEnded = stream._readableState && stream._readableState.endEmitted;
        var onend = function onend() {
            readable = false;
            readableEnded = true;
            if (!writable) callback.call(stream);
        };
        var onerror = function onerror(err) {
            callback.call(stream, err);
        };
        var onclose = function onclose() {
            var err;
            if (readable && !readableEnded) {
                if (!stream._readableState || !stream._readableState.ended) err = new $b135876c7ee1da99$var$ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
            if (writable && !writableEnded) {
                if (!stream._writableState || !stream._writableState.ended) err = new $b135876c7ee1da99$var$ERR_STREAM_PREMATURE_CLOSE();
                return callback.call(stream, err);
            }
        };
        var onrequest = function onrequest() {
            stream.req.on('finish', onfinish);
        };
        if ($b135876c7ee1da99$var$isRequest(stream)) {
            stream.on('complete', onfinish);
            stream.on('abort', onclose);
            if (stream.req) onrequest();
            else stream.on('request', onrequest);
        } else if (writable && !stream._writableState) {
            stream.on('end', onlegacyfinish);
            stream.on('close', onlegacyfinish);
        }
        stream.on('end', onend);
        stream.on('finish', onfinish);
        if (opts.error !== false) stream.on('error', onerror);
        stream.on('close', onclose);
        return function() {
            stream.removeListener('complete', onfinish);
            stream.removeListener('abort', onclose);
            stream.removeListener('request', onrequest);
            if (stream.req) stream.req.removeListener('finish', onfinish);
            stream.removeListener('end', onlegacyfinish);
            stream.removeListener('close', onlegacyfinish);
            stream.removeListener('finish', onfinish);
            stream.removeListener('end', onend);
            stream.removeListener('error', onerror);
            stream.removeListener('close', onclose);
        };
    }
    module.exports = $b135876c7ee1da99$var$eos;
});
parcelRegister("jV0Pb", function(module, exports) {
    module.exports = function() {
        throw new Error('Readable.from is not available in the browser');
    };
});
parcelRegister("imCs6", function(module, exports) {
    'use strict';
    module.exports = $d5e81be4a04bf4ac$var$Transform;
    var $bBIKv = parcelRequire("bBIKv");
    var $d5e81be4a04bf4ac$require$_require$codes = $bBIKv.codes;
    var $d5e81be4a04bf4ac$var$ERR_METHOD_NOT_IMPLEMENTED = $d5e81be4a04bf4ac$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d5e81be4a04bf4ac$var$ERR_MULTIPLE_CALLBACK = $d5e81be4a04bf4ac$require$_require$codes.ERR_MULTIPLE_CALLBACK, $d5e81be4a04bf4ac$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $d5e81be4a04bf4ac$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $d5e81be4a04bf4ac$var$ERR_TRANSFORM_WITH_LENGTH_0 = $d5e81be4a04bf4ac$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
    var $i5T1N = parcelRequire("i5T1N");
    (parcelRequire("v3bBu"))($d5e81be4a04bf4ac$var$Transform, $i5T1N);
    function $d5e81be4a04bf4ac$var$afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (cb === null) return this.emit('error', new $d5e81be4a04bf4ac$var$ERR_MULTIPLE_CALLBACK());
        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
    function $d5e81be4a04bf4ac$var$Transform(options) {
        if (!(this instanceof $d5e81be4a04bf4ac$var$Transform)) return new $d5e81be4a04bf4ac$var$Transform(options);
        $i5T1N.call(this, options);
        this._transformState = {
            afterTransform: $d5e81be4a04bf4ac$var$afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null
        };
        this._readableState.needReadable = true;
        this._readableState.sync = false;
        if (options) {
            if (typeof options.transform === 'function') this._transform = options.transform;
            if (typeof options.flush === 'function') this._flush = options.flush;
        }
        this.on('prefinish', $d5e81be4a04bf4ac$var$prefinish);
    }
    function $d5e81be4a04bf4ac$var$prefinish() {
        var _this = this;
        if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
            $d5e81be4a04bf4ac$var$done(_this, er, data);
        });
        else $d5e81be4a04bf4ac$var$done(this, null, null);
    }
    $d5e81be4a04bf4ac$var$Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return $i5T1N.prototype.push.call(this, chunk, encoding);
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._transform = function(chunk, encoding, cb) {
        cb(new $d5e81be4a04bf4ac$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else ts.needTransform = true;
    };
    $d5e81be4a04bf4ac$var$Transform.prototype._destroy = function(err, cb) {
        $i5T1N.prototype._destroy.call(this, err, function(err2) {
            cb(err2);
        });
    };
    function $d5e81be4a04bf4ac$var$done(stream, er, data) {
        if (er) return stream.emit('error', er);
        if (data != null) stream.push(data);
        if (stream._writableState.length) throw new $d5e81be4a04bf4ac$var$ERR_TRANSFORM_WITH_LENGTH_0();
        if (stream._transformState.transforming) throw new $d5e81be4a04bf4ac$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
        return stream.push(null);
    }
});
parcelRegister("7UmdZ", function(module, exports) {
    'use strict';
    module.exports = $5c1f00b9234785d5$var$PassThrough;
    var $imCs6 = parcelRequire("imCs6");
    (parcelRequire("v3bBu"))($5c1f00b9234785d5$var$PassThrough, $imCs6);
    function $5c1f00b9234785d5$var$PassThrough(options) {
        if (!(this instanceof $5c1f00b9234785d5$var$PassThrough)) return new $5c1f00b9234785d5$var$PassThrough(options);
        $imCs6.call(this, options);
    }
    $5c1f00b9234785d5$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
});
parcelRegister("4kgjk", function(module, exports) {
    'use strict';
    var $3265aea6500b968a$var$eos;
    function $3265aea6500b968a$var$once(callback) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            callback.apply(void 0, arguments);
        };
    }
    var $bBIKv = parcelRequire("bBIKv");
    var $3265aea6500b968a$require$_require$codes = $bBIKv.codes;
    var $3265aea6500b968a$var$ERR_MISSING_ARGS = $3265aea6500b968a$require$_require$codes.ERR_MISSING_ARGS, $3265aea6500b968a$var$ERR_STREAM_DESTROYED = $3265aea6500b968a$require$_require$codes.ERR_STREAM_DESTROYED;
    function $3265aea6500b968a$var$noop(err) {
        if (err) throw err;
    }
    function $3265aea6500b968a$var$isRequest(stream) {
        return stream.setHeader && typeof stream.abort === 'function';
    }
    function $3265aea6500b968a$var$destroyer(stream, reading, writing, callback) {
        callback = $3265aea6500b968a$var$once(callback);
        var closed = false;
        stream.on('close', function() {
            closed = true;
        });
        if ($3265aea6500b968a$var$eos === undefined) $3265aea6500b968a$var$eos = (parcelRequire("fdhlO"));
        $3265aea6500b968a$var$eos(stream, {
            readable: reading,
            writable: writing
        }, function(err) {
            if (err) return callback(err);
            closed = true;
            callback();
        });
        var destroyed = false;
        return function(err) {
            if (closed) return;
            if (destroyed) return;
            destroyed = true;
            if ($3265aea6500b968a$var$isRequest(stream)) return stream.abort();
            if (typeof stream.destroy === 'function') return stream.destroy();
            callback(err || new $3265aea6500b968a$var$ERR_STREAM_DESTROYED('pipe'));
        };
    }
    function $3265aea6500b968a$var$call(fn) {
        fn();
    }
    function $3265aea6500b968a$var$pipe(from, to) {
        return from.pipe(to);
    }
    function $3265aea6500b968a$var$popCallback(streams) {
        if (!streams.length) return $3265aea6500b968a$var$noop;
        if (typeof streams[streams.length - 1] !== 'function') return $3265aea6500b968a$var$noop;
        return streams.pop();
    }
    function $3265aea6500b968a$var$pipeline() {
        for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
        var callback = $3265aea6500b968a$var$popCallback(streams);
        if (Array.isArray(streams[0])) streams = streams[0];
        if (streams.length < 2) throw new $3265aea6500b968a$var$ERR_MISSING_ARGS('streams');
        var error;
        var destroys = streams.map(function(stream, i) {
            var reading = i < streams.length - 1;
            var writing = i > 0;
            return $3265aea6500b968a$var$destroyer(stream, reading, writing, function(err) {
                if (!error) error = err;
                if (err) destroys.forEach($3265aea6500b968a$var$call);
                if (reading) return;
                destroys.forEach($3265aea6500b968a$var$call);
                callback(error);
            });
        });
        return streams.reduce($3265aea6500b968a$var$pipe);
    }
    module.exports = $3265aea6500b968a$var$pipeline;
});
parcelRegister("6EPBm", function(module, exports) {
    'use strict';
    var $5k7LC = parcelRequire("5k7LC");
    var $4d8e8181b4bf2e98$require$Buffer = $5k7LC.Buffer;
    var $v3bBu = parcelRequire("v3bBu");
    var $gOR7Z = parcelRequire("gOR7Z");
    var $4d8e8181b4bf2e98$var$ARRAY16 = new Array(16);
    var $4d8e8181b4bf2e98$var$zl = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        7,
        4,
        13,
        1,
        10,
        6,
        15,
        3,
        12,
        0,
        9,
        5,
        2,
        14,
        11,
        8,
        3,
        10,
        14,
        4,
        9,
        15,
        8,
        1,
        2,
        7,
        0,
        6,
        13,
        11,
        5,
        12,
        1,
        9,
        11,
        10,
        0,
        8,
        12,
        4,
        13,
        3,
        7,
        15,
        14,
        5,
        6,
        2,
        4,
        0,
        5,
        9,
        7,
        12,
        2,
        10,
        14,
        1,
        3,
        8,
        11,
        6,
        15,
        13
    ];
    var $4d8e8181b4bf2e98$var$zr = [
        5,
        14,
        7,
        0,
        9,
        2,
        11,
        4,
        13,
        6,
        15,
        8,
        1,
        10,
        3,
        12,
        6,
        11,
        3,
        7,
        0,
        13,
        5,
        10,
        14,
        15,
        8,
        12,
        4,
        9,
        1,
        2,
        15,
        5,
        1,
        3,
        7,
        14,
        6,
        9,
        11,
        8,
        12,
        2,
        10,
        0,
        4,
        13,
        8,
        6,
        4,
        1,
        3,
        11,
        15,
        0,
        5,
        12,
        2,
        13,
        9,
        7,
        10,
        14,
        12,
        15,
        10,
        4,
        1,
        5,
        8,
        7,
        6,
        2,
        13,
        14,
        0,
        3,
        9,
        11
    ];
    var $4d8e8181b4bf2e98$var$sl = [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8,
        7,
        6,
        8,
        13,
        11,
        9,
        7,
        15,
        7,
        12,
        15,
        9,
        11,
        7,
        13,
        12,
        11,
        13,
        6,
        7,
        14,
        9,
        13,
        15,
        14,
        8,
        13,
        6,
        5,
        12,
        7,
        5,
        11,
        12,
        14,
        15,
        14,
        15,
        9,
        8,
        9,
        14,
        5,
        6,
        8,
        6,
        5,
        12,
        9,
        15,
        5,
        11,
        6,
        8,
        13,
        12,
        5,
        12,
        13,
        14,
        11,
        8,
        5,
        6
    ];
    var $4d8e8181b4bf2e98$var$sr = [
        8,
        9,
        9,
        11,
        13,
        15,
        15,
        5,
        7,
        7,
        8,
        11,
        14,
        14,
        12,
        6,
        9,
        13,
        15,
        7,
        12,
        8,
        9,
        11,
        7,
        7,
        12,
        7,
        6,
        15,
        13,
        11,
        9,
        7,
        15,
        11,
        8,
        6,
        6,
        14,
        12,
        13,
        5,
        14,
        13,
        13,
        7,
        5,
        15,
        5,
        8,
        11,
        14,
        14,
        6,
        14,
        6,
        9,
        12,
        9,
        12,
        5,
        15,
        8,
        8,
        5,
        12,
        9,
        12,
        5,
        14,
        6,
        8,
        13,
        6,
        5,
        15,
        13,
        11,
        11
    ];
    var $4d8e8181b4bf2e98$var$hl = [
        0x00000000,
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xa953fd4e
    ];
    var $4d8e8181b4bf2e98$var$hr = [
        0x50a28be6,
        0x5c4dd124,
        0x6d703ef3,
        0x7a6d76e9,
        0x00000000
    ];
    function $4d8e8181b4bf2e98$var$RIPEMD160() {
        $gOR7Z.call(this, 64);
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._e = 0xc3d2e1f0;
    }
    $v3bBu($4d8e8181b4bf2e98$var$RIPEMD160, $gOR7Z);
    $4d8e8181b4bf2e98$var$RIPEMD160.prototype._update = function() {
        var words = $4d8e8181b4bf2e98$var$ARRAY16;
        for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
        var al = this._a | 0;
        var bl = this._b | 0;
        var cl = this._c | 0;
        var dl = this._d | 0;
        var el = this._e | 0;
        var ar = this._a | 0;
        var br = this._b | 0;
        var cr = this._c | 0;
        var dr = this._d | 0;
        var er = this._e | 0;
        for(var i = 0; i < 80; i += 1){
            var tl;
            var tr;
            if (i < 16) {
                tl = $4d8e8181b4bf2e98$var$fn1(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[0], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn5(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[0], $4d8e8181b4bf2e98$var$sr[i]);
            } else if (i < 32) {
                tl = $4d8e8181b4bf2e98$var$fn2(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[1], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn4(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[1], $4d8e8181b4bf2e98$var$sr[i]);
            } else if (i < 48) {
                tl = $4d8e8181b4bf2e98$var$fn3(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[2], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn3(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[2], $4d8e8181b4bf2e98$var$sr[i]);
            } else if (i < 64) {
                tl = $4d8e8181b4bf2e98$var$fn4(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[3], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn2(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[3], $4d8e8181b4bf2e98$var$sr[i]);
            } else {
                tl = $4d8e8181b4bf2e98$var$fn5(al, bl, cl, dl, el, words[$4d8e8181b4bf2e98$var$zl[i]], $4d8e8181b4bf2e98$var$hl[4], $4d8e8181b4bf2e98$var$sl[i]);
                tr = $4d8e8181b4bf2e98$var$fn1(ar, br, cr, dr, er, words[$4d8e8181b4bf2e98$var$zr[i]], $4d8e8181b4bf2e98$var$hr[4], $4d8e8181b4bf2e98$var$sr[i]);
            }
            al = el;
            el = dl;
            dl = $4d8e8181b4bf2e98$var$rotl(cl, 10);
            cl = bl;
            bl = tl;
            ar = er;
            er = dr;
            dr = $4d8e8181b4bf2e98$var$rotl(cr, 10);
            cr = br;
            br = tr;
        }
        var t = this._b + cl + dr | 0;
        this._b = this._c + dl + er | 0;
        this._c = this._d + el + ar | 0;
        this._d = this._e + al + br | 0;
        this._e = this._a + bl + cr | 0;
        this._a = t;
    };
    $4d8e8181b4bf2e98$var$RIPEMD160.prototype._digest = function() {
        this._block[this._blockOffset++] = 0x80;
        if (this._blockOffset > 56) {
            this._block.fill(0, this._blockOffset, 64);
            this._update();
            this._blockOffset = 0;
        }
        this._block.fill(0, this._blockOffset, 56);
        this._block.writeUInt32LE(this._length[0], 56);
        this._block.writeUInt32LE(this._length[1], 60);
        this._update();
        var buffer = $4d8e8181b4bf2e98$require$Buffer.alloc ? $4d8e8181b4bf2e98$require$Buffer.alloc(20) : new $4d8e8181b4bf2e98$require$Buffer(20);
        buffer.writeInt32LE(this._a, 0);
        buffer.writeInt32LE(this._b, 4);
        buffer.writeInt32LE(this._c, 8);
        buffer.writeInt32LE(this._d, 12);
        buffer.writeInt32LE(this._e, 16);
        return buffer;
    };
    function $4d8e8181b4bf2e98$var$rotl(x, n) {
        return x << n | x >>> 32 - n;
    }
    function $4d8e8181b4bf2e98$var$fn1(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn2(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn3(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn4(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
    }
    function $4d8e8181b4bf2e98$var$fn5(a, b, c, d, e, m, k, s) {
        return $4d8e8181b4bf2e98$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
    }
    module.exports = $4d8e8181b4bf2e98$var$RIPEMD160;
});
parcelRegister("a21Ya", function(module, exports) {
    var $74db9e664dfd9270$var$exports = module.exports = function SHA(algorithm) {
        algorithm = algorithm.toLowerCase();
        var Algorithm = $74db9e664dfd9270$var$exports[algorithm];
        if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
        return new Algorithm();
    };
    $74db9e664dfd9270$var$exports.sha = (parcelRequire("dFso9"));
    $74db9e664dfd9270$var$exports.sha1 = (parcelRequire("fWNgi"));
    $74db9e664dfd9270$var$exports.sha224 = (parcelRequire("dCenE"));
    $74db9e664dfd9270$var$exports.sha256 = (parcelRequire("jtWQG"));
    $74db9e664dfd9270$var$exports.sha384 = (parcelRequire("1c7yZ"));
    $74db9e664dfd9270$var$exports.sha512 = (parcelRequire("c0lzM"));
});
parcelRegister("dFso9", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $9f35200cb3ec19b0$require$Buffer = $Wth4q.Buffer;
    var $9f35200cb3ec19b0$var$K = [
        0x5a827999,
        0x6ed9eba1,
        -1894007588,
        -899497514
    ];
    var $9f35200cb3ec19b0$var$W = new Array(80);
    function $9f35200cb3ec19b0$var$Sha() {
        this.init();
        this._w = $9f35200cb3ec19b0$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($9f35200cb3ec19b0$var$Sha, $jCRNn);
    $9f35200cb3ec19b0$var$Sha.prototype.init = function() {
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._e = 0xc3d2e1f0;
        return this;
    };
    function $9f35200cb3ec19b0$var$rotl5(num) {
        return num << 5 | num >>> 27;
    }
    function $9f35200cb3ec19b0$var$rotl30(num) {
        return num << 30 | num >>> 2;
    }
    function $9f35200cb3ec19b0$var$ft(s, b, c, d) {
        if (s === 0) return b & c | ~b & d;
        if (s === 2) return b & c | b & d | c & d;
        return b ^ c ^ d;
    }
    $9f35200cb3ec19b0$var$Sha.prototype._update = function(M) {
        var W = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e = this._e | 0;
        for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
        for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
        for(var j = 0; j < 80; ++j){
            var s = ~~(j / 20);
            var t = $9f35200cb3ec19b0$var$rotl5(a) + $9f35200cb3ec19b0$var$ft(s, b, c, d) + e + W[j] + $9f35200cb3ec19b0$var$K[s] | 0;
            e = d;
            d = c;
            c = $9f35200cb3ec19b0$var$rotl30(b);
            b = a;
            a = t;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e + this._e | 0;
    };
    $9f35200cb3ec19b0$var$Sha.prototype._hash = function() {
        var H = $9f35200cb3ec19b0$require$Buffer.allocUnsafe(20);
        H.writeInt32BE(this._a | 0, 0);
        H.writeInt32BE(this._b | 0, 4);
        H.writeInt32BE(this._c | 0, 8);
        H.writeInt32BE(this._d | 0, 12);
        H.writeInt32BE(this._e | 0, 16);
        return H;
    };
    module.exports = $9f35200cb3ec19b0$var$Sha;
});
parcelRegister("jCRNn", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $e49b4b9320828ebb$require$Buffer = $Wth4q.Buffer;
    function $e49b4b9320828ebb$var$Hash(blockSize, finalSize) {
        this._block = $e49b4b9320828ebb$require$Buffer.alloc(blockSize);
        this._finalSize = finalSize;
        this._blockSize = blockSize;
        this._len = 0;
    }
    $e49b4b9320828ebb$var$Hash.prototype.update = function(data, enc) {
        if (typeof data === 'string') {
            enc = enc || 'utf8';
            data = $e49b4b9320828ebb$require$Buffer.from(data, enc);
        }
        var block = this._block;
        var blockSize = this._blockSize;
        var length = data.length;
        var accum = this._len;
        for(var offset = 0; offset < length;){
            var assigned = accum % blockSize;
            var remainder = Math.min(length - offset, blockSize - assigned);
            for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
            accum += remainder;
            offset += remainder;
            if (accum % blockSize === 0) this._update(block);
        }
        this._len += length;
        return this;
    };
    $e49b4b9320828ebb$var$Hash.prototype.digest = function(enc) {
        var rem = this._len % this._blockSize;
        this._block[rem] = 0x80;
        this._block.fill(0, rem + 1);
        if (rem >= this._finalSize) {
            this._update(this._block);
            this._block.fill(0);
        }
        var bits = this._len * 8;
        if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
        else {
            var lowBits = (bits & 0xffffffff) >>> 0;
            var highBits = (bits - lowBits) / 0x100000000;
            this._block.writeUInt32BE(highBits, this._blockSize - 8);
            this._block.writeUInt32BE(lowBits, this._blockSize - 4);
        }
        this._update(this._block);
        var hash = this._hash();
        return enc ? hash.toString(enc) : hash;
    };
    $e49b4b9320828ebb$var$Hash.prototype._update = function() {
        throw new Error('_update must be implemented by subclass');
    };
    module.exports = $e49b4b9320828ebb$var$Hash;
});
parcelRegister("fWNgi", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $b9c27c2bc18fcde5$require$Buffer = $Wth4q.Buffer;
    var $b9c27c2bc18fcde5$var$K = [
        0x5a827999,
        0x6ed9eba1,
        -1894007588,
        -899497514
    ];
    var $b9c27c2bc18fcde5$var$W = new Array(80);
    function $b9c27c2bc18fcde5$var$Sha1() {
        this.init();
        this._w = $b9c27c2bc18fcde5$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($b9c27c2bc18fcde5$var$Sha1, $jCRNn);
    $b9c27c2bc18fcde5$var$Sha1.prototype.init = function() {
        this._a = 0x67452301;
        this._b = 0xefcdab89;
        this._c = 0x98badcfe;
        this._d = 0x10325476;
        this._e = 0xc3d2e1f0;
        return this;
    };
    function $b9c27c2bc18fcde5$var$rotl1(num) {
        return num << 1 | num >>> 31;
    }
    function $b9c27c2bc18fcde5$var$rotl5(num) {
        return num << 5 | num >>> 27;
    }
    function $b9c27c2bc18fcde5$var$rotl30(num) {
        return num << 30 | num >>> 2;
    }
    function $b9c27c2bc18fcde5$var$ft(s, b, c, d) {
        if (s === 0) return b & c | ~b & d;
        if (s === 2) return b & c | b & d | c & d;
        return b ^ c ^ d;
    }
    $b9c27c2bc18fcde5$var$Sha1.prototype._update = function(M) {
        var W = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e = this._e | 0;
        for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
        for(; i < 80; ++i)W[i] = $b9c27c2bc18fcde5$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
        for(var j = 0; j < 80; ++j){
            var s = ~~(j / 20);
            var t = $b9c27c2bc18fcde5$var$rotl5(a) + $b9c27c2bc18fcde5$var$ft(s, b, c, d) + e + W[j] + $b9c27c2bc18fcde5$var$K[s] | 0;
            e = d;
            d = c;
            c = $b9c27c2bc18fcde5$var$rotl30(b);
            b = a;
            a = t;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e + this._e | 0;
    };
    $b9c27c2bc18fcde5$var$Sha1.prototype._hash = function() {
        var H = $b9c27c2bc18fcde5$require$Buffer.allocUnsafe(20);
        H.writeInt32BE(this._a | 0, 0);
        H.writeInt32BE(this._b | 0, 4);
        H.writeInt32BE(this._c | 0, 8);
        H.writeInt32BE(this._d | 0, 12);
        H.writeInt32BE(this._e | 0, 16);
        return H;
    };
    module.exports = $b9c27c2bc18fcde5$var$Sha1;
});
parcelRegister("dCenE", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jtWQG = parcelRequire("jtWQG");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $9e99faa5be7d643e$require$Buffer = $Wth4q.Buffer;
    var $9e99faa5be7d643e$var$W = new Array(64);
    function $9e99faa5be7d643e$var$Sha224() {
        this.init();
        this._w = $9e99faa5be7d643e$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($9e99faa5be7d643e$var$Sha224, $jtWQG);
    $9e99faa5be7d643e$var$Sha224.prototype.init = function() {
        this._a = 0xc1059ed8;
        this._b = 0x367cd507;
        this._c = 0x3070dd17;
        this._d = 0xf70e5939;
        this._e = 0xffc00b31;
        this._f = 0x68581511;
        this._g = 0x64f98fa7;
        this._h = 0xbefa4fa4;
        return this;
    };
    $9e99faa5be7d643e$var$Sha224.prototype._hash = function() {
        var H = $9e99faa5be7d643e$require$Buffer.allocUnsafe(28);
        H.writeInt32BE(this._a, 0);
        H.writeInt32BE(this._b, 4);
        H.writeInt32BE(this._c, 8);
        H.writeInt32BE(this._d, 12);
        H.writeInt32BE(this._e, 16);
        H.writeInt32BE(this._f, 20);
        H.writeInt32BE(this._g, 24);
        return H;
    };
    module.exports = $9e99faa5be7d643e$var$Sha224;
});
parcelRegister("jtWQG", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $e2ee5fe8d7032812$require$Buffer = $Wth4q.Buffer;
    var $e2ee5fe8d7032812$var$K = [
        0x428A2F98,
        0x71374491,
        0xB5C0FBCF,
        0xE9B5DBA5,
        0x3956C25B,
        0x59F111F1,
        0x923F82A4,
        0xAB1C5ED5,
        0xD807AA98,
        0x12835B01,
        0x243185BE,
        0x550C7DC3,
        0x72BE5D74,
        0x80DEB1FE,
        0x9BDC06A7,
        0xC19BF174,
        0xE49B69C1,
        0xEFBE4786,
        0x0FC19DC6,
        0x240CA1CC,
        0x2DE92C6F,
        0x4A7484AA,
        0x5CB0A9DC,
        0x76F988DA,
        0x983E5152,
        0xA831C66D,
        0xB00327C8,
        0xBF597FC7,
        0xC6E00BF3,
        0xD5A79147,
        0x06CA6351,
        0x14292967,
        0x27B70A85,
        0x2E1B2138,
        0x4D2C6DFC,
        0x53380D13,
        0x650A7354,
        0x766A0ABB,
        0x81C2C92E,
        0x92722C85,
        0xA2BFE8A1,
        0xA81A664B,
        0xC24B8B70,
        0xC76C51A3,
        0xD192E819,
        0xD6990624,
        0xF40E3585,
        0x106AA070,
        0x19A4C116,
        0x1E376C08,
        0x2748774C,
        0x34B0BCB5,
        0x391C0CB3,
        0x4ED8AA4A,
        0x5B9CCA4F,
        0x682E6FF3,
        0x748F82EE,
        0x78A5636F,
        0x84C87814,
        0x8CC70208,
        0x90BEFFFA,
        0xA4506CEB,
        0xBEF9A3F7,
        0xC67178F2
    ];
    var $e2ee5fe8d7032812$var$W = new Array(64);
    function $e2ee5fe8d7032812$var$Sha256() {
        this.init();
        this._w = $e2ee5fe8d7032812$var$W;
        $jCRNn.call(this, 64, 56);
    }
    $v3bBu($e2ee5fe8d7032812$var$Sha256, $jCRNn);
    $e2ee5fe8d7032812$var$Sha256.prototype.init = function() {
        this._a = 0x6a09e667;
        this._b = 0xbb67ae85;
        this._c = 0x3c6ef372;
        this._d = 0xa54ff53a;
        this._e = 0x510e527f;
        this._f = 0x9b05688c;
        this._g = 0x1f83d9ab;
        this._h = 0x5be0cd19;
        return this;
    };
    function $e2ee5fe8d7032812$var$ch(x, y, z) {
        return z ^ x & (y ^ z);
    }
    function $e2ee5fe8d7032812$var$maj(x, y, z) {
        return x & y | z & (x | y);
    }
    function $e2ee5fe8d7032812$var$sigma0(x) {
        return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
    }
    function $e2ee5fe8d7032812$var$sigma1(x) {
        return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
    }
    function $e2ee5fe8d7032812$var$gamma0(x) {
        return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
    }
    function $e2ee5fe8d7032812$var$gamma1(x) {
        return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
    }
    $e2ee5fe8d7032812$var$Sha256.prototype._update = function(M) {
        var W = this._w;
        var a = this._a | 0;
        var b = this._b | 0;
        var c = this._c | 0;
        var d = this._d | 0;
        var e = this._e | 0;
        var f = this._f | 0;
        var g = this._g | 0;
        var h = this._h | 0;
        for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
        for(; i < 64; ++i)W[i] = $e2ee5fe8d7032812$var$gamma1(W[i - 2]) + W[i - 7] + $e2ee5fe8d7032812$var$gamma0(W[i - 15]) + W[i - 16] | 0;
        for(var j = 0; j < 64; ++j){
            var T1 = h + $e2ee5fe8d7032812$var$sigma1(e) + $e2ee5fe8d7032812$var$ch(e, f, g) + $e2ee5fe8d7032812$var$K[j] + W[j] | 0;
            var T2 = $e2ee5fe8d7032812$var$sigma0(a) + $e2ee5fe8d7032812$var$maj(a, b, c) | 0;
            h = g;
            g = f;
            f = e;
            e = d + T1 | 0;
            d = c;
            c = b;
            b = a;
            a = T1 + T2 | 0;
        }
        this._a = a + this._a | 0;
        this._b = b + this._b | 0;
        this._c = c + this._c | 0;
        this._d = d + this._d | 0;
        this._e = e + this._e | 0;
        this._f = f + this._f | 0;
        this._g = g + this._g | 0;
        this._h = h + this._h | 0;
    };
    $e2ee5fe8d7032812$var$Sha256.prototype._hash = function() {
        var H = $e2ee5fe8d7032812$require$Buffer.allocUnsafe(32);
        H.writeInt32BE(this._a, 0);
        H.writeInt32BE(this._b, 4);
        H.writeInt32BE(this._c, 8);
        H.writeInt32BE(this._d, 12);
        H.writeInt32BE(this._e, 16);
        H.writeInt32BE(this._f, 20);
        H.writeInt32BE(this._g, 24);
        H.writeInt32BE(this._h, 28);
        return H;
    };
    module.exports = $e2ee5fe8d7032812$var$Sha256;
});
parcelRegister("1c7yZ", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $c0lzM = parcelRequire("c0lzM");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $0decc7569dc7c272$require$Buffer = $Wth4q.Buffer;
    var $0decc7569dc7c272$var$W = new Array(160);
    function $0decc7569dc7c272$var$Sha384() {
        this.init();
        this._w = $0decc7569dc7c272$var$W;
        $jCRNn.call(this, 128, 112);
    }
    $v3bBu($0decc7569dc7c272$var$Sha384, $c0lzM);
    $0decc7569dc7c272$var$Sha384.prototype.init = function() {
        this._ah = 0xcbbb9d5d;
        this._bh = 0x629a292a;
        this._ch = 0x9159015a;
        this._dh = 0x152fecd8;
        this._eh = 0x67332667;
        this._fh = 0x8eb44a87;
        this._gh = 0xdb0c2e0d;
        this._hh = 0x47b5481d;
        this._al = 0xc1059ed8;
        this._bl = 0x367cd507;
        this._cl = 0x3070dd17;
        this._dl = 0xf70e5939;
        this._el = 0xffc00b31;
        this._fl = 0x68581511;
        this._gl = 0x64f98fa7;
        this._hl = 0xbefa4fa4;
        return this;
    };
    $0decc7569dc7c272$var$Sha384.prototype._hash = function() {
        var H = $0decc7569dc7c272$require$Buffer.allocUnsafe(48);
        function writeInt64BE(h, l, offset) {
            H.writeInt32BE(h, offset);
            H.writeInt32BE(l, offset + 4);
        }
        writeInt64BE(this._ah, this._al, 0);
        writeInt64BE(this._bh, this._bl, 8);
        writeInt64BE(this._ch, this._cl, 16);
        writeInt64BE(this._dh, this._dl, 24);
        writeInt64BE(this._eh, this._el, 32);
        writeInt64BE(this._fh, this._fl, 40);
        return H;
    };
    module.exports = $0decc7569dc7c272$var$Sha384;
});
parcelRegister("c0lzM", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $jCRNn = parcelRequire("jCRNn");
    var $Wth4q = parcelRequire("Wth4q");
    var $8bd638b23ac34e9a$require$Buffer = $Wth4q.Buffer;
    var $8bd638b23ac34e9a$var$K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    var $8bd638b23ac34e9a$var$W = new Array(160);
    function $8bd638b23ac34e9a$var$Sha512() {
        this.init();
        this._w = $8bd638b23ac34e9a$var$W;
        $jCRNn.call(this, 128, 112);
    }
    $v3bBu($8bd638b23ac34e9a$var$Sha512, $jCRNn);
    $8bd638b23ac34e9a$var$Sha512.prototype.init = function() {
        this._ah = 0x6a09e667;
        this._bh = 0xbb67ae85;
        this._ch = 0x3c6ef372;
        this._dh = 0xa54ff53a;
        this._eh = 0x510e527f;
        this._fh = 0x9b05688c;
        this._gh = 0x1f83d9ab;
        this._hh = 0x5be0cd19;
        this._al = 0xf3bcc908;
        this._bl = 0x84caa73b;
        this._cl = 0xfe94f82b;
        this._dl = 0x5f1d36f1;
        this._el = 0xade682d1;
        this._fl = 0x2b3e6c1f;
        this._gl = 0xfb41bd6b;
        this._hl = 0x137e2179;
        return this;
    };
    function $8bd638b23ac34e9a$var$Ch(x, y, z) {
        return z ^ x & (y ^ z);
    }
    function $8bd638b23ac34e9a$var$maj(x, y, z) {
        return x & y | z & (x | y);
    }
    function $8bd638b23ac34e9a$var$sigma0(x, xl) {
        return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
    }
    function $8bd638b23ac34e9a$var$sigma1(x, xl) {
        return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
    }
    function $8bd638b23ac34e9a$var$Gamma0(x, xl) {
        return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
    }
    function $8bd638b23ac34e9a$var$Gamma0l(x, xl) {
        return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
    }
    function $8bd638b23ac34e9a$var$Gamma1(x, xl) {
        return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
    }
    function $8bd638b23ac34e9a$var$Gamma1l(x, xl) {
        return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
    }
    function $8bd638b23ac34e9a$var$getCarry(a, b) {
        return a >>> 0 < b >>> 0 ? 1 : 0;
    }
    $8bd638b23ac34e9a$var$Sha512.prototype._update = function(M) {
        var W = this._w;
        var ah = this._ah | 0;
        var bh = this._bh | 0;
        var ch = this._ch | 0;
        var dh = this._dh | 0;
        var eh = this._eh | 0;
        var fh = this._fh | 0;
        var gh = this._gh | 0;
        var hh = this._hh | 0;
        var al = this._al | 0;
        var bl = this._bl | 0;
        var cl = this._cl | 0;
        var dl = this._dl | 0;
        var el = this._el | 0;
        var fl = this._fl | 0;
        var gl = this._gl | 0;
        var hl = this._hl | 0;
        for(var i = 0; i < 32; i += 2){
            W[i] = M.readInt32BE(i * 4);
            W[i + 1] = M.readInt32BE(i * 4 + 4);
        }
        for(; i < 160; i += 2){
            var xh = W[i - 30];
            var xl = W[i - 30 + 1];
            var gamma0 = $8bd638b23ac34e9a$var$Gamma0(xh, xl);
            var gamma0l = $8bd638b23ac34e9a$var$Gamma0l(xl, xh);
            xh = W[i - 4];
            xl = W[i - 4 + 1];
            var gamma1 = $8bd638b23ac34e9a$var$Gamma1(xh, xl);
            var gamma1l = $8bd638b23ac34e9a$var$Gamma1l(xl, xh);
            var Wi7h = W[i - 14];
            var Wi7l = W[i - 14 + 1];
            var Wi16h = W[i - 32];
            var Wi16l = W[i - 32 + 1];
            var Wil = gamma0l + Wi7l | 0;
            var Wih = gamma0 + Wi7h + $8bd638b23ac34e9a$var$getCarry(Wil, gamma0l) | 0;
            Wil = Wil + gamma1l | 0;
            Wih = Wih + gamma1 + $8bd638b23ac34e9a$var$getCarry(Wil, gamma1l) | 0;
            Wil = Wil + Wi16l | 0;
            Wih = Wih + Wi16h + $8bd638b23ac34e9a$var$getCarry(Wil, Wi16l) | 0;
            W[i] = Wih;
            W[i + 1] = Wil;
        }
        for(var j = 0; j < 160; j += 2){
            Wih = W[j];
            Wil = W[j + 1];
            var majh = $8bd638b23ac34e9a$var$maj(ah, bh, ch);
            var majl = $8bd638b23ac34e9a$var$maj(al, bl, cl);
            var sigma0h = $8bd638b23ac34e9a$var$sigma0(ah, al);
            var sigma0l = $8bd638b23ac34e9a$var$sigma0(al, ah);
            var sigma1h = $8bd638b23ac34e9a$var$sigma1(eh, el);
            var sigma1l = $8bd638b23ac34e9a$var$sigma1(el, eh);
            var Kih = $8bd638b23ac34e9a$var$K[j];
            var Kil = $8bd638b23ac34e9a$var$K[j + 1];
            var chh = $8bd638b23ac34e9a$var$Ch(eh, fh, gh);
            var chl = $8bd638b23ac34e9a$var$Ch(el, fl, gl);
            var t1l = hl + sigma1l | 0;
            var t1h = hh + sigma1h + $8bd638b23ac34e9a$var$getCarry(t1l, hl) | 0;
            t1l = t1l + chl | 0;
            t1h = t1h + chh + $8bd638b23ac34e9a$var$getCarry(t1l, chl) | 0;
            t1l = t1l + Kil | 0;
            t1h = t1h + Kih + $8bd638b23ac34e9a$var$getCarry(t1l, Kil) | 0;
            t1l = t1l + Wil | 0;
            t1h = t1h + Wih + $8bd638b23ac34e9a$var$getCarry(t1l, Wil) | 0;
            var t2l = sigma0l + majl | 0;
            var t2h = sigma0h + majh + $8bd638b23ac34e9a$var$getCarry(t2l, sigma0l) | 0;
            hh = gh;
            hl = gl;
            gh = fh;
            gl = fl;
            fh = eh;
            fl = el;
            el = dl + t1l | 0;
            eh = dh + t1h + $8bd638b23ac34e9a$var$getCarry(el, dl) | 0;
            dh = ch;
            dl = cl;
            ch = bh;
            cl = bl;
            bh = ah;
            bl = al;
            al = t1l + t2l | 0;
            ah = t1h + t2h + $8bd638b23ac34e9a$var$getCarry(al, t1l) | 0;
        }
        this._al = this._al + al | 0;
        this._bl = this._bl + bl | 0;
        this._cl = this._cl + cl | 0;
        this._dl = this._dl + dl | 0;
        this._el = this._el + el | 0;
        this._fl = this._fl + fl | 0;
        this._gl = this._gl + gl | 0;
        this._hl = this._hl + hl | 0;
        this._ah = this._ah + ah + $8bd638b23ac34e9a$var$getCarry(this._al, al) | 0;
        this._bh = this._bh + bh + $8bd638b23ac34e9a$var$getCarry(this._bl, bl) | 0;
        this._ch = this._ch + ch + $8bd638b23ac34e9a$var$getCarry(this._cl, cl) | 0;
        this._dh = this._dh + dh + $8bd638b23ac34e9a$var$getCarry(this._dl, dl) | 0;
        this._eh = this._eh + eh + $8bd638b23ac34e9a$var$getCarry(this._el, el) | 0;
        this._fh = this._fh + fh + $8bd638b23ac34e9a$var$getCarry(this._fl, fl) | 0;
        this._gh = this._gh + gh + $8bd638b23ac34e9a$var$getCarry(this._gl, gl) | 0;
        this._hh = this._hh + hh + $8bd638b23ac34e9a$var$getCarry(this._hl, hl) | 0;
    };
    $8bd638b23ac34e9a$var$Sha512.prototype._hash = function() {
        var H = $8bd638b23ac34e9a$require$Buffer.allocUnsafe(64);
        function writeInt64BE(h, l, offset) {
            H.writeInt32BE(h, offset);
            H.writeInt32BE(l, offset + 4);
        }
        writeInt64BE(this._ah, this._al, 0);
        writeInt64BE(this._bh, this._bl, 8);
        writeInt64BE(this._ch, this._cl, 16);
        writeInt64BE(this._dh, this._dl, 24);
        writeInt64BE(this._eh, this._el, 32);
        writeInt64BE(this._fh, this._fl, 40);
        writeInt64BE(this._gh, this._gl, 48);
        writeInt64BE(this._hh, this._hl, 56);
        return H;
    };
    module.exports = $8bd638b23ac34e9a$var$Sha512;
});
parcelRegister("77fwb", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $52e5397100350dcf$require$Buffer = $Wth4q.Buffer;
    var $e2HvS = parcelRequire("e2HvS");
    var $52e5397100350dcf$require$Transform = $e2HvS.Transform;
    var $3872E = parcelRequire("3872E");
    var $52e5397100350dcf$require$StringDecoder = $3872E.StringDecoder;
    var $v3bBu = parcelRequire("v3bBu");
    function $52e5397100350dcf$var$CipherBase(hashMode) {
        $52e5397100350dcf$require$Transform.call(this);
        this.hashMode = typeof hashMode === 'string';
        if (this.hashMode) this[hashMode] = this._finalOrDigest;
        else this.final = this._finalOrDigest;
        if (this._final) {
            this.__final = this._final;
            this._final = null;
        }
        this._decoder = null;
        this._encoding = null;
    }
    $v3bBu($52e5397100350dcf$var$CipherBase, $52e5397100350dcf$require$Transform);
    $52e5397100350dcf$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
        if (typeof data === 'string') data = $52e5397100350dcf$require$Buffer.from(data, inputEnc);
        var outData = this._update(data);
        if (this.hashMode) return this;
        if (outputEnc) outData = this._toString(outData, outputEnc);
        return outData;
    };
    $52e5397100350dcf$var$CipherBase.prototype.setAutoPadding = function() {};
    $52e5397100350dcf$var$CipherBase.prototype.getAuthTag = function() {
        throw new Error('trying to get auth tag in unsupported state');
    };
    $52e5397100350dcf$var$CipherBase.prototype.setAuthTag = function() {
        throw new Error('trying to set auth tag in unsupported state');
    };
    $52e5397100350dcf$var$CipherBase.prototype.setAAD = function() {
        throw new Error('trying to set aad in unsupported state');
    };
    $52e5397100350dcf$var$CipherBase.prototype._transform = function(data, _, next) {
        var err;
        try {
            if (this.hashMode) this._update(data);
            else this.push(this._update(data));
        } catch (e) {
            err = e;
        } finally{
            next(err);
        }
    };
    $52e5397100350dcf$var$CipherBase.prototype._flush = function(done) {
        var err;
        try {
            this.push(this.__final());
        } catch (e) {
            err = e;
        }
        done(err);
    };
    $52e5397100350dcf$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
        var outData = this.__final() || $52e5397100350dcf$require$Buffer.alloc(0);
        if (outputEnc) outData = this._toString(outData, outputEnc, true);
        return outData;
    };
    $52e5397100350dcf$var$CipherBase.prototype._toString = function(value, enc, fin) {
        if (!this._decoder) {
            this._decoder = new $52e5397100350dcf$require$StringDecoder(enc);
            this._encoding = enc;
        }
        if (this._encoding !== enc) throw new Error('can\'t switch encodings');
        var out = this._decoder.write(value);
        if (fin) out += this._decoder.end();
        return out;
    };
    module.exports = $52e5397100350dcf$var$CipherBase;
});
parcelRegister("j65bP", function(module, exports) {
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $3nQOH = parcelRequire("3nQOH");
    var $77fwb = parcelRequire("77fwb");
    var $Wth4q = parcelRequire("Wth4q");
    var $de729a71cb7df339$require$Buffer = $Wth4q.Buffer;
    var $2BrHl = parcelRequire("2BrHl");
    var $6EPBm = parcelRequire("6EPBm");
    var $a21Ya = parcelRequire("a21Ya");
    var $de729a71cb7df339$var$ZEROS = $de729a71cb7df339$require$Buffer.alloc(128);
    function $de729a71cb7df339$var$Hmac(alg, key) {
        $77fwb.call(this, 'digest');
        if (typeof key === 'string') key = $de729a71cb7df339$require$Buffer.from(key);
        var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
        this._alg = alg;
        this._key = key;
        if (key.length > blocksize) {
            var hash = alg === 'rmd160' ? new $6EPBm() : $a21Ya(alg);
            key = hash.update(key).digest();
        } else if (key.length < blocksize) key = $de729a71cb7df339$require$Buffer.concat([
            key,
            $de729a71cb7df339$var$ZEROS
        ], blocksize);
        var ipad = this._ipad = $de729a71cb7df339$require$Buffer.allocUnsafe(blocksize);
        var opad = this._opad = $de729a71cb7df339$require$Buffer.allocUnsafe(blocksize);
        for(var i = 0; i < blocksize; i++){
            ipad[i] = key[i] ^ 0x36;
            opad[i] = key[i] ^ 0x5C;
        }
        this._hash = alg === 'rmd160' ? new $6EPBm() : $a21Ya(alg);
        this._hash.update(ipad);
    }
    $v3bBu($de729a71cb7df339$var$Hmac, $77fwb);
    $de729a71cb7df339$var$Hmac.prototype._update = function(data) {
        this._hash.update(data);
    };
    $de729a71cb7df339$var$Hmac.prototype._final = function() {
        var h = this._hash.digest();
        var hash = this._alg === 'rmd160' ? new $6EPBm() : $a21Ya(this._alg);
        return hash.update(this._opad).update(h).digest();
    };
    module.exports = function createHmac(alg, key) {
        alg = alg.toLowerCase();
        if (alg === 'rmd160' || alg === 'ripemd160') return new $de729a71cb7df339$var$Hmac('rmd160', key);
        if (alg === 'md5') return new $3nQOH($2BrHl, key);
        return new $de729a71cb7df339$var$Hmac(alg, key);
    };
});
parcelRegister("3nQOH", function(module, exports) {
    'use strict';
    var $v3bBu = parcelRequire("v3bBu");
    var $Wth4q = parcelRequire("Wth4q");
    var $276c7d685fb1f219$require$Buffer = $Wth4q.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $276c7d685fb1f219$var$ZEROS = $276c7d685fb1f219$require$Buffer.alloc(128);
    var $276c7d685fb1f219$var$blocksize = 64;
    function $276c7d685fb1f219$var$Hmac(alg, key) {
        $77fwb.call(this, 'digest');
        if (typeof key === 'string') key = $276c7d685fb1f219$require$Buffer.from(key);
        this._alg = alg;
        this._key = key;
        if (key.length > $276c7d685fb1f219$var$blocksize) key = alg(key);
        else if (key.length < $276c7d685fb1f219$var$blocksize) key = $276c7d685fb1f219$require$Buffer.concat([
            key,
            $276c7d685fb1f219$var$ZEROS
        ], $276c7d685fb1f219$var$blocksize);
        var ipad = this._ipad = $276c7d685fb1f219$require$Buffer.allocUnsafe($276c7d685fb1f219$var$blocksize);
        var opad = this._opad = $276c7d685fb1f219$require$Buffer.allocUnsafe($276c7d685fb1f219$var$blocksize);
        for(var i = 0; i < $276c7d685fb1f219$var$blocksize; i++){
            ipad[i] = key[i] ^ 0x36;
            opad[i] = key[i] ^ 0x5C;
        }
        this._hash = [
            ipad
        ];
    }
    $v3bBu($276c7d685fb1f219$var$Hmac, $77fwb);
    $276c7d685fb1f219$var$Hmac.prototype._update = function(data) {
        this._hash.push(data);
    };
    $276c7d685fb1f219$var$Hmac.prototype._final = function() {
        var h = this._alg($276c7d685fb1f219$require$Buffer.concat(this._hash));
        return this._alg($276c7d685fb1f219$require$Buffer.concat([
            this._opad,
            h
        ]));
    };
    module.exports = $276c7d685fb1f219$var$Hmac;
});
parcelRegister("2BrHl", function(module, exports) {
    var $8ZJxF = parcelRequire("8ZJxF");
    module.exports = function(buffer) {
        return new $8ZJxF().update(buffer).digest();
    };
});
parcelRegister("NKdOQ", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("5kFDZ"));
});
parcelRegister("5kFDZ", function(module, exports) {
    module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");
});
parcelRegister("fS6zE", function(module, exports) {
    $parcel$export(module.exports, "pbkdf2", ()=>$b8e0ffa4349c8ce4$export$448fa22aedc9dbca, (v)=>$b8e0ffa4349c8ce4$export$448fa22aedc9dbca = v);
    $parcel$export(module.exports, "pbkdf2Sync", ()=>$b8e0ffa4349c8ce4$export$b80c7ba289c8fa56, (v)=>$b8e0ffa4349c8ce4$export$b80c7ba289c8fa56 = v);
    var $b8e0ffa4349c8ce4$export$448fa22aedc9dbca;
    var $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56;
    $b8e0ffa4349c8ce4$export$448fa22aedc9dbca = (parcelRequire("8U4Ei"));
    $b8e0ffa4349c8ce4$export$b80c7ba289c8fa56 = (parcelRequire("5GCF3"));
});
parcelRegister("8U4Ei", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $67b728dbcfdb7234$require$Buffer = $Wth4q.Buffer;
    var $4ryRx = parcelRequire("4ryRx");
    var $7DfkD = parcelRequire("7DfkD");
    var $5GCF3 = parcelRequire("5GCF3");
    var $fpAzU = parcelRequire("fpAzU");
    var $67b728dbcfdb7234$var$ZERO_BUF;
    var $67b728dbcfdb7234$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
    var $67b728dbcfdb7234$var$toBrowser = {
        sha: 'SHA-1',
        'sha-1': 'SHA-1',
        sha1: 'SHA-1',
        sha256: 'SHA-256',
        'sha-256': 'SHA-256',
        sha384: 'SHA-384',
        'sha-384': 'SHA-384',
        'sha-512': 'SHA-512',
        sha512: 'SHA-512'
    };
    var $67b728dbcfdb7234$var$checks = [];
    function $67b728dbcfdb7234$var$checkNative(algo) {
        if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
        if (!$67b728dbcfdb7234$var$subtle || !$67b728dbcfdb7234$var$subtle.importKey || !$67b728dbcfdb7234$var$subtle.deriveBits) return Promise.resolve(false);
        if ($67b728dbcfdb7234$var$checks[algo] !== undefined) return $67b728dbcfdb7234$var$checks[algo];
        $67b728dbcfdb7234$var$ZERO_BUF = $67b728dbcfdb7234$var$ZERO_BUF || $67b728dbcfdb7234$require$Buffer.alloc(8);
        var prom = $67b728dbcfdb7234$var$browserPbkdf2($67b728dbcfdb7234$var$ZERO_BUF, $67b728dbcfdb7234$var$ZERO_BUF, 10, 128, algo).then(function() {
            return true;
        }).catch(function() {
            return false;
        });
        $67b728dbcfdb7234$var$checks[algo] = prom;
        return prom;
    }
    var $67b728dbcfdb7234$var$nextTick;
    function $67b728dbcfdb7234$var$getNextTick() {
        if ($67b728dbcfdb7234$var$nextTick) return $67b728dbcfdb7234$var$nextTick;
        if ($parcel$global.process && $parcel$global.process.nextTick) $67b728dbcfdb7234$var$nextTick = $parcel$global.process.nextTick;
        else if ($parcel$global.queueMicrotask) $67b728dbcfdb7234$var$nextTick = $parcel$global.queueMicrotask;
        else if ($parcel$global.setImmediate) $67b728dbcfdb7234$var$nextTick = $parcel$global.setImmediate;
        else $67b728dbcfdb7234$var$nextTick = $parcel$global.setTimeout;
        return $67b728dbcfdb7234$var$nextTick;
    }
    function $67b728dbcfdb7234$var$browserPbkdf2(password, salt, iterations, length, algo) {
        return $67b728dbcfdb7234$var$subtle.importKey('raw', password, {
            name: 'PBKDF2'
        }, false, [
            'deriveBits'
        ]).then(function(key) {
            return $67b728dbcfdb7234$var$subtle.deriveBits({
                name: 'PBKDF2',
                salt: salt,
                iterations: iterations,
                hash: {
                    name: algo
                }
            }, key, length << 3);
        }).then(function(res) {
            return $67b728dbcfdb7234$require$Buffer.from(res);
        });
    }
    function $67b728dbcfdb7234$var$resolvePromise(promise, callback) {
        promise.then(function(out) {
            $67b728dbcfdb7234$var$getNextTick()(function() {
                callback(null, out);
            });
        }, function(e) {
            $67b728dbcfdb7234$var$getNextTick()(function() {
                callback(e);
            });
        });
    }
    module.exports = function(password, salt, iterations, keylen, digest, callback) {
        if (typeof digest === 'function') {
            callback = digest;
            digest = undefined;
        }
        digest = digest || 'sha1';
        var algo = $67b728dbcfdb7234$var$toBrowser[digest.toLowerCase()];
        if (!algo || typeof $parcel$global.Promise !== 'function') {
            $67b728dbcfdb7234$var$getNextTick()(function() {
                var out;
                try {
                    out = $5GCF3(password, salt, iterations, keylen, digest);
                } catch (e) {
                    return callback(e);
                }
                callback(null, out);
            });
            return;
        }
        $4ryRx(iterations, keylen);
        password = $fpAzU(password, $7DfkD, 'Password');
        salt = $fpAzU(salt, $7DfkD, 'Salt');
        if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
        $67b728dbcfdb7234$var$resolvePromise($67b728dbcfdb7234$var$checkNative(algo).then(function(resp) {
            if (resp) return $67b728dbcfdb7234$var$browserPbkdf2(password, salt, iterations, keylen, algo);
            return $5GCF3(password, salt, iterations, keylen, digest);
        }), callback);
    };
});
parcelRegister("4ryRx", function(module, exports) {
    var $33c4ba00ce725092$var$MAX_ALLOC = Math.pow(2, 30) - 1;
    module.exports = function(iterations, keylen) {
        if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
        if (iterations < 0) throw new TypeError('Bad iterations');
        if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
        if (keylen < 0 || keylen > $33c4ba00ce725092$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
    };
});
parcelRegister("7DfkD", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    var $58e8117f50848d7e$var$defaultEncoding;
    if ($parcel$global.process && $parcel$global.process.browser) $58e8117f50848d7e$var$defaultEncoding = 'utf-8';
    else if ($parcel$global.process && $parcel$global.process.version) {
        var $58e8117f50848d7e$var$pVersionMajor = parseInt($6cAn5.version.split('.')[0].slice(1), 10);
        $58e8117f50848d7e$var$defaultEncoding = $58e8117f50848d7e$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
    } else $58e8117f50848d7e$var$defaultEncoding = 'utf-8';
    module.exports = $58e8117f50848d7e$var$defaultEncoding;
});
parcelRegister("5GCF3", function(module, exports) {
    var $2BrHl = parcelRequire("2BrHl");
    var $6EPBm = parcelRequire("6EPBm");
    var $a21Ya = parcelRequire("a21Ya");
    var $Wth4q = parcelRequire("Wth4q");
    var $423edd4c77469706$require$Buffer = $Wth4q.Buffer;
    var $4ryRx = parcelRequire("4ryRx");
    var $7DfkD = parcelRequire("7DfkD");
    var $fpAzU = parcelRequire("fpAzU");
    var $423edd4c77469706$var$ZEROS = $423edd4c77469706$require$Buffer.alloc(128);
    var $423edd4c77469706$var$sizes = {
        md5: 16,
        sha1: 20,
        sha224: 28,
        sha256: 32,
        sha384: 48,
        sha512: 64,
        rmd160: 20,
        ripemd160: 20
    };
    function $423edd4c77469706$var$Hmac(alg, key, saltLen) {
        var hash = $423edd4c77469706$var$getDigest(alg);
        var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
        if (key.length > blocksize) key = hash(key);
        else if (key.length < blocksize) key = $423edd4c77469706$require$Buffer.concat([
            key,
            $423edd4c77469706$var$ZEROS
        ], blocksize);
        var ipad = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + $423edd4c77469706$var$sizes[alg]);
        var opad = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + $423edd4c77469706$var$sizes[alg]);
        for(var i = 0; i < blocksize; i++){
            ipad[i] = key[i] ^ 0x36;
            opad[i] = key[i] ^ 0x5C;
        }
        var ipad1 = $423edd4c77469706$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
        ipad.copy(ipad1, 0, 0, blocksize);
        this.ipad1 = ipad1;
        this.ipad2 = ipad;
        this.opad = opad;
        this.alg = alg;
        this.blocksize = blocksize;
        this.hash = hash;
        this.size = $423edd4c77469706$var$sizes[alg];
    }
    $423edd4c77469706$var$Hmac.prototype.run = function(data, ipad) {
        data.copy(ipad, this.blocksize);
        var h = this.hash(ipad);
        h.copy(this.opad, this.blocksize);
        return this.hash(this.opad);
    };
    function $423edd4c77469706$var$getDigest(alg) {
        function shaFunc(data) {
            return $a21Ya(alg).update(data).digest();
        }
        function rmd160Func(data) {
            return new $6EPBm().update(data).digest();
        }
        if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func;
        if (alg === 'md5') return $2BrHl;
        return shaFunc;
    }
    function $423edd4c77469706$var$pbkdf2(password, salt, iterations, keylen, digest) {
        $4ryRx(iterations, keylen);
        password = $fpAzU(password, $7DfkD, 'Password');
        salt = $fpAzU(salt, $7DfkD, 'Salt');
        digest = digest || 'sha1';
        var hmac = new $423edd4c77469706$var$Hmac(digest, password, salt.length);
        var DK = $423edd4c77469706$require$Buffer.allocUnsafe(keylen);
        var block1 = $423edd4c77469706$require$Buffer.allocUnsafe(salt.length + 4);
        salt.copy(block1, 0, 0, salt.length);
        var destPos = 0;
        var hLen = $423edd4c77469706$var$sizes[digest];
        var l = Math.ceil(keylen / hLen);
        for(var i = 1; i <= l; i++){
            block1.writeUInt32BE(i, salt.length);
            var T = hmac.run(block1, hmac.ipad1);
            var U = T;
            for(var j = 1; j < iterations; j++){
                U = hmac.run(U, hmac.ipad2);
                for(var k = 0; k < hLen; k++)T[k] ^= U[k];
            }
            T.copy(DK, destPos);
            destPos += hLen;
        }
        return DK;
    }
    module.exports = $423edd4c77469706$var$pbkdf2;
});
parcelRegister("fpAzU", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $b38590769b62ee4f$require$Buffer = $Wth4q.Buffer;
    module.exports = function(thing, encoding, name) {
        if ($b38590769b62ee4f$require$Buffer.isBuffer(thing)) return thing;
        else if (typeof thing === 'string') return $b38590769b62ee4f$require$Buffer.from(thing, encoding);
        else if (ArrayBuffer.isView(thing)) return $b38590769b62ee4f$require$Buffer.from(thing.buffer);
        else throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView');
    };
});
parcelRegister("a2ApW", function(module, exports) {
    $parcel$export(module.exports, "createCipher", ()=>$74f6570266d69f84$export$bdd223f16383713e, (v)=>$74f6570266d69f84$export$bdd223f16383713e = v);
    $parcel$export(module.exports, "Cipher", ()=>$74f6570266d69f84$export$26e5786e8ac8e530, (v)=>$74f6570266d69f84$export$26e5786e8ac8e530 = v);
    $parcel$export(module.exports, "createCipheriv", ()=>$74f6570266d69f84$export$2f64596b8cbf08b4, (v)=>$74f6570266d69f84$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "Cipheriv", ()=>$74f6570266d69f84$export$20533d26f07f1ee0, (v)=>$74f6570266d69f84$export$20533d26f07f1ee0 = v);
    $parcel$export(module.exports, "createDecipher", ()=>$74f6570266d69f84$export$12ada9414fbc594c, (v)=>$74f6570266d69f84$export$12ada9414fbc594c = v);
    $parcel$export(module.exports, "Decipher", ()=>$74f6570266d69f84$export$2ce6d8d0e8b04e1a, (v)=>$74f6570266d69f84$export$2ce6d8d0e8b04e1a = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$74f6570266d69f84$export$36b6d6ef312eab39, (v)=>$74f6570266d69f84$export$36b6d6ef312eab39 = v);
    $parcel$export(module.exports, "Decipheriv", ()=>$74f6570266d69f84$export$f5e7e39d57cd9700, (v)=>$74f6570266d69f84$export$f5e7e39d57cd9700 = v);
    $parcel$export(module.exports, "listCiphers", ()=>$74f6570266d69f84$export$dedd8dc3dc62b370, (v)=>$74f6570266d69f84$export$dedd8dc3dc62b370 = v);
    $parcel$export(module.exports, "getCiphers", ()=>$74f6570266d69f84$export$58a258485f1e49f6, (v)=>$74f6570266d69f84$export$58a258485f1e49f6 = v);
    var $74f6570266d69f84$export$bdd223f16383713e;
    var $74f6570266d69f84$export$26e5786e8ac8e530;
    var $74f6570266d69f84$export$2f64596b8cbf08b4;
    var $74f6570266d69f84$export$20533d26f07f1ee0;
    var $74f6570266d69f84$export$12ada9414fbc594c;
    var $74f6570266d69f84$export$2ce6d8d0e8b04e1a;
    var $74f6570266d69f84$export$36b6d6ef312eab39;
    var $74f6570266d69f84$export$f5e7e39d57cd9700;
    var $74f6570266d69f84$export$dedd8dc3dc62b370;
    var $74f6570266d69f84$export$58a258485f1e49f6;
    var $1Awtz = parcelRequire("1Awtz");
    var $gcaJj = parcelRequire("gcaJj");
    var $6WLno = parcelRequire("6WLno");
    var $dQ4TD = parcelRequire("dQ4TD");
    var $55KiC = parcelRequire("55KiC");
    function $74f6570266d69f84$var$createCipher(suite, password) {
        suite = suite.toLowerCase();
        var keyLen, ivLen;
        if ($6WLno[suite]) {
            keyLen = $6WLno[suite].key;
            ivLen = $6WLno[suite].iv;
        } else if ($dQ4TD[suite]) {
            keyLen = $dQ4TD[suite].key * 8;
            ivLen = $dQ4TD[suite].iv;
        } else throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, keyLen, ivLen);
        return $74f6570266d69f84$var$createCipheriv(suite, keys.key, keys.iv);
    }
    function $74f6570266d69f84$var$createDecipher(suite, password) {
        suite = suite.toLowerCase();
        var keyLen, ivLen;
        if ($6WLno[suite]) {
            keyLen = $6WLno[suite].key;
            ivLen = $6WLno[suite].iv;
        } else if ($dQ4TD[suite]) {
            keyLen = $dQ4TD[suite].key * 8;
            ivLen = $dQ4TD[suite].iv;
        } else throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, keyLen, ivLen);
        return $74f6570266d69f84$var$createDecipheriv(suite, keys.key, keys.iv);
    }
    function $74f6570266d69f84$var$createCipheriv(suite, key, iv) {
        suite = suite.toLowerCase();
        if ($6WLno[suite]) return $gcaJj.createCipheriv(suite, key, iv);
        if ($dQ4TD[suite]) return new $1Awtz({
            key: key,
            iv: iv,
            mode: suite
        });
        throw new TypeError('invalid suite type');
    }
    function $74f6570266d69f84$var$createDecipheriv(suite, key, iv) {
        suite = suite.toLowerCase();
        if ($6WLno[suite]) return $gcaJj.createDecipheriv(suite, key, iv);
        if ($dQ4TD[suite]) return new $1Awtz({
            key: key,
            iv: iv,
            mode: suite,
            decrypt: true
        });
        throw new TypeError('invalid suite type');
    }
    function $74f6570266d69f84$var$getCiphers() {
        return Object.keys($dQ4TD).concat($gcaJj.getCiphers());
    }
    $74f6570266d69f84$export$bdd223f16383713e = $74f6570266d69f84$export$26e5786e8ac8e530 = $74f6570266d69f84$var$createCipher;
    $74f6570266d69f84$export$2f64596b8cbf08b4 = $74f6570266d69f84$export$20533d26f07f1ee0 = $74f6570266d69f84$var$createCipheriv;
    $74f6570266d69f84$export$12ada9414fbc594c = $74f6570266d69f84$export$2ce6d8d0e8b04e1a = $74f6570266d69f84$var$createDecipher;
    $74f6570266d69f84$export$36b6d6ef312eab39 = $74f6570266d69f84$export$f5e7e39d57cd9700 = $74f6570266d69f84$var$createDecipheriv;
    $74f6570266d69f84$export$dedd8dc3dc62b370 = $74f6570266d69f84$export$58a258485f1e49f6 = $74f6570266d69f84$var$getCiphers;
});
parcelRegister("1Awtz", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $12825845b88e2981$require$Buffer = $5k7LC.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $bsIyp = parcelRequire("bsIyp");
    var $v3bBu = parcelRequire("v3bBu");
    var $12825845b88e2981$var$modes = {
        'des-ede3-cbc': $bsIyp.CBC.instantiate($bsIyp.EDE),
        'des-ede3': $bsIyp.EDE,
        'des-ede-cbc': $bsIyp.CBC.instantiate($bsIyp.EDE),
        'des-ede': $bsIyp.EDE,
        'des-cbc': $bsIyp.CBC.instantiate($bsIyp.DES),
        'des-ecb': $bsIyp.DES
    };
    $12825845b88e2981$var$modes.des = $12825845b88e2981$var$modes['des-cbc'];
    $12825845b88e2981$var$modes.des3 = $12825845b88e2981$var$modes['des-ede3-cbc'];
    module.exports = $12825845b88e2981$var$DES;
    $v3bBu($12825845b88e2981$var$DES, $77fwb);
    function $12825845b88e2981$var$DES(opts) {
        $77fwb.call(this);
        var modeName = opts.mode.toLowerCase();
        var mode = $12825845b88e2981$var$modes[modeName];
        var type;
        if (opts.decrypt) type = 'decrypt';
        else type = 'encrypt';
        var key = opts.key;
        if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $12825845b88e2981$require$Buffer.concat([
            key,
            key.slice(0, 8)
        ]);
        var iv = opts.iv;
        this._des = mode.create({
            key: key,
            iv: iv,
            type: type
        });
    }
    $12825845b88e2981$var$DES.prototype._update = function(data) {
        return new $12825845b88e2981$require$Buffer(this._des.update(data));
    };
    $12825845b88e2981$var$DES.prototype._final = function() {
        return new $12825845b88e2981$require$Buffer(this._des.final());
    };
});
parcelRegister("bsIyp", function(module, exports) {
    $parcel$export(module.exports, "utils", ()=>$8584dec09db13d9c$export$eab97d15b1788b8d, (v)=>$8584dec09db13d9c$export$eab97d15b1788b8d = v);
    $parcel$export(module.exports, "Cipher", ()=>$8584dec09db13d9c$export$26e5786e8ac8e530, (v)=>$8584dec09db13d9c$export$26e5786e8ac8e530 = v);
    $parcel$export(module.exports, "DES", ()=>$8584dec09db13d9c$export$cc8859615686b300, (v)=>$8584dec09db13d9c$export$cc8859615686b300 = v);
    $parcel$export(module.exports, "CBC", ()=>$8584dec09db13d9c$export$8ad3f227af08fcc5, (v)=>$8584dec09db13d9c$export$8ad3f227af08fcc5 = v);
    $parcel$export(module.exports, "EDE", ()=>$8584dec09db13d9c$export$947646e34766044f, (v)=>$8584dec09db13d9c$export$947646e34766044f = v);
    var $8584dec09db13d9c$export$eab97d15b1788b8d;
    var $8584dec09db13d9c$export$26e5786e8ac8e530;
    var $8584dec09db13d9c$export$cc8859615686b300;
    var $8584dec09db13d9c$export$8ad3f227af08fcc5;
    var $8584dec09db13d9c$export$947646e34766044f;
    'use strict';
    $8584dec09db13d9c$export$eab97d15b1788b8d = (parcelRequire("1Qr12"));
    $8584dec09db13d9c$export$26e5786e8ac8e530 = (parcelRequire("lE1WX"));
    $8584dec09db13d9c$export$cc8859615686b300 = (parcelRequire("6uemC"));
    $8584dec09db13d9c$export$8ad3f227af08fcc5 = (parcelRequire("bdh1b"));
    $8584dec09db13d9c$export$947646e34766044f = (parcelRequire("d53eL"));
});
parcelRegister("1Qr12", function(module, exports) {
    $parcel$export(module.exports, "readUInt32BE", ()=>$157f9a87c9609c03$export$cfaef8ed399428b0, (v)=>$157f9a87c9609c03$export$cfaef8ed399428b0 = v);
    $parcel$export(module.exports, "writeUInt32BE", ()=>$157f9a87c9609c03$export$a80c7deaea7cbd80, (v)=>$157f9a87c9609c03$export$a80c7deaea7cbd80 = v);
    $parcel$export(module.exports, "ip", ()=>$157f9a87c9609c03$export$ed7577ae6e1cd0ef, (v)=>$157f9a87c9609c03$export$ed7577ae6e1cd0ef = v);
    $parcel$export(module.exports, "rip", ()=>$157f9a87c9609c03$export$5dcbef3aa594f567, (v)=>$157f9a87c9609c03$export$5dcbef3aa594f567 = v);
    $parcel$export(module.exports, "pc1", ()=>$157f9a87c9609c03$export$5bc8001ca71ed9c5, (v)=>$157f9a87c9609c03$export$5bc8001ca71ed9c5 = v);
    $parcel$export(module.exports, "r28shl", ()=>$157f9a87c9609c03$export$3e714e2c5d5d8cb2, (v)=>$157f9a87c9609c03$export$3e714e2c5d5d8cb2 = v);
    $parcel$export(module.exports, "pc2", ()=>$157f9a87c9609c03$export$94c3e544fd062b7f, (v)=>$157f9a87c9609c03$export$94c3e544fd062b7f = v);
    $parcel$export(module.exports, "expand", ()=>$157f9a87c9609c03$export$9f77e0932fb78f72, (v)=>$157f9a87c9609c03$export$9f77e0932fb78f72 = v);
    $parcel$export(module.exports, "substitute", ()=>$157f9a87c9609c03$export$d865ce2836f5927f, (v)=>$157f9a87c9609c03$export$d865ce2836f5927f = v);
    $parcel$export(module.exports, "permute", ()=>$157f9a87c9609c03$export$95e62ad65da8b7d2, (v)=>$157f9a87c9609c03$export$95e62ad65da8b7d2 = v);
    $parcel$export(module.exports, "padSplit", ()=>$157f9a87c9609c03$export$209139ff098c441a, (v)=>$157f9a87c9609c03$export$209139ff098c441a = v);
    var $157f9a87c9609c03$export$cfaef8ed399428b0;
    var $157f9a87c9609c03$export$a80c7deaea7cbd80;
    var $157f9a87c9609c03$export$ed7577ae6e1cd0ef;
    var $157f9a87c9609c03$export$5dcbef3aa594f567;
    var $157f9a87c9609c03$export$5bc8001ca71ed9c5;
    var $157f9a87c9609c03$export$3e714e2c5d5d8cb2;
    var $157f9a87c9609c03$export$94c3e544fd062b7f;
    var $157f9a87c9609c03$export$9f77e0932fb78f72;
    var $157f9a87c9609c03$export$d865ce2836f5927f;
    var $157f9a87c9609c03$export$95e62ad65da8b7d2;
    var $157f9a87c9609c03$export$209139ff098c441a;
    'use strict';
    $157f9a87c9609c03$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
        var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
        return res >>> 0;
    };
    $157f9a87c9609c03$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
        bytes[0 + off] = value >>> 24;
        bytes[1 + off] = value >>> 16 & 0xff;
        bytes[2 + off] = value >>> 8 & 0xff;
        bytes[3 + off] = value & 0xff;
    };
    $157f9a87c9609c03$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        for(var i = 6; i >= 0; i -= 2){
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inR >>> j + i & 1;
            }
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inL >>> j + i & 1;
            }
        }
        for(var i = 6; i >= 0; i -= 2){
            for(var j = 1; j <= 25; j += 8){
                outR <<= 1;
                outR |= inR >>> j + i & 1;
            }
            for(var j = 1; j <= 25; j += 8){
                outR <<= 1;
                outR |= inL >>> j + i & 1;
            }
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
        for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        for(var i = 7; i >= 5; i--){
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inR >> j + i & 1;
            }
            for(var j = 0; j <= 24; j += 8){
                outL <<= 1;
                outL |= inL >> j + i & 1;
            }
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var i = 1; i <= 3; i++){
            for(var j = 0; j <= 24; j += 8){
                outR <<= 1;
                outR |= inR >> j + i & 1;
            }
            for(var j = 0; j <= 24; j += 8){
                outR <<= 1;
                outR |= inL >> j + i & 1;
            }
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
        return num << shift & 0xfffffff | num >>> 28 - shift;
    };
    var $157f9a87c9609c03$var$pc2table = [
        14,
        11,
        17,
        4,
        27,
        23,
        25,
        0,
        13,
        22,
        7,
        18,
        5,
        9,
        16,
        24,
        2,
        20,
        12,
        21,
        1,
        8,
        15,
        26,
        15,
        4,
        25,
        19,
        9,
        1,
        26,
        16,
        5,
        11,
        23,
        8,
        12,
        7,
        17,
        0,
        22,
        3,
        10,
        14,
        6,
        20,
        27,
        24
    ];
    $157f9a87c9609c03$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;
        var len = $157f9a87c9609c03$var$pc2table.length >>> 1;
        for(var i = 0; i < len; i++){
            outL <<= 1;
            outL |= inL >>> $157f9a87c9609c03$var$pc2table[i] & 0x1;
        }
        for(var i = len; i < $157f9a87c9609c03$var$pc2table.length; i++){
            outR <<= 1;
            outR |= inR >>> $157f9a87c9609c03$var$pc2table[i] & 0x1;
        }
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    $157f9a87c9609c03$export$9f77e0932fb78f72 = function expand(r, out, off) {
        var outL = 0;
        var outR = 0;
        outL = (r & 1) << 5 | r >>> 27;
        for(var i = 23; i >= 15; i -= 4){
            outL <<= 6;
            outL |= r >>> i & 0x3f;
        }
        for(var i = 11; i >= 3; i -= 4){
            outR |= r >>> i & 0x3f;
            outR <<= 6;
        }
        outR |= (r & 0x1f) << 1 | r >>> 31;
        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
    };
    var $157f9a87c9609c03$var$sTable = [
        14,
        0,
        4,
        15,
        13,
        7,
        1,
        4,
        2,
        14,
        15,
        2,
        11,
        13,
        8,
        1,
        3,
        10,
        10,
        6,
        6,
        12,
        12,
        11,
        5,
        9,
        9,
        5,
        0,
        3,
        7,
        8,
        4,
        15,
        1,
        12,
        14,
        8,
        8,
        2,
        13,
        4,
        6,
        9,
        2,
        1,
        11,
        7,
        15,
        5,
        12,
        11,
        9,
        3,
        7,
        14,
        3,
        10,
        10,
        0,
        5,
        6,
        0,
        13,
        15,
        3,
        1,
        13,
        8,
        4,
        14,
        7,
        6,
        15,
        11,
        2,
        3,
        8,
        4,
        14,
        9,
        12,
        7,
        0,
        2,
        1,
        13,
        10,
        12,
        6,
        0,
        9,
        5,
        11,
        10,
        5,
        0,
        13,
        14,
        8,
        7,
        10,
        11,
        1,
        10,
        3,
        4,
        15,
        13,
        4,
        1,
        2,
        5,
        11,
        8,
        6,
        12,
        7,
        6,
        12,
        9,
        0,
        3,
        5,
        2,
        14,
        15,
        9,
        10,
        13,
        0,
        7,
        9,
        0,
        14,
        9,
        6,
        3,
        3,
        4,
        15,
        6,
        5,
        10,
        1,
        2,
        13,
        8,
        12,
        5,
        7,
        14,
        11,
        12,
        4,
        11,
        2,
        15,
        8,
        1,
        13,
        1,
        6,
        10,
        4,
        13,
        9,
        0,
        8,
        6,
        15,
        9,
        3,
        8,
        0,
        7,
        11,
        4,
        1,
        15,
        2,
        14,
        12,
        3,
        5,
        11,
        10,
        5,
        14,
        2,
        7,
        12,
        7,
        13,
        13,
        8,
        14,
        11,
        3,
        5,
        0,
        6,
        6,
        15,
        9,
        0,
        10,
        3,
        1,
        4,
        2,
        7,
        8,
        2,
        5,
        12,
        11,
        1,
        12,
        10,
        4,
        14,
        15,
        9,
        10,
        3,
        6,
        15,
        9,
        0,
        0,
        6,
        12,
        10,
        11,
        1,
        7,
        13,
        13,
        8,
        15,
        9,
        1,
        4,
        3,
        5,
        14,
        11,
        5,
        12,
        2,
        7,
        8,
        2,
        4,
        14,
        2,
        14,
        12,
        11,
        4,
        2,
        1,
        12,
        7,
        4,
        10,
        7,
        11,
        13,
        6,
        1,
        8,
        5,
        5,
        0,
        3,
        15,
        15,
        10,
        13,
        3,
        0,
        9,
        14,
        8,
        9,
        6,
        4,
        11,
        2,
        8,
        1,
        12,
        11,
        7,
        10,
        1,
        13,
        14,
        7,
        2,
        8,
        13,
        15,
        6,
        9,
        15,
        12,
        0,
        5,
        9,
        6,
        10,
        3,
        4,
        0,
        5,
        14,
        3,
        12,
        10,
        1,
        15,
        10,
        4,
        15,
        2,
        9,
        7,
        2,
        12,
        6,
        9,
        8,
        5,
        0,
        6,
        13,
        1,
        3,
        13,
        4,
        14,
        14,
        0,
        7,
        11,
        5,
        3,
        11,
        8,
        9,
        4,
        14,
        3,
        15,
        2,
        5,
        12,
        2,
        9,
        8,
        5,
        12,
        15,
        3,
        10,
        7,
        11,
        0,
        14,
        4,
        1,
        10,
        7,
        1,
        6,
        13,
        0,
        11,
        8,
        6,
        13,
        4,
        13,
        11,
        0,
        2,
        11,
        14,
        7,
        15,
        4,
        0,
        9,
        8,
        1,
        13,
        10,
        3,
        14,
        12,
        3,
        9,
        5,
        7,
        12,
        5,
        2,
        10,
        15,
        6,
        8,
        1,
        6,
        1,
        6,
        4,
        11,
        11,
        13,
        13,
        8,
        12,
        1,
        3,
        4,
        7,
        10,
        14,
        7,
        10,
        9,
        15,
        5,
        6,
        0,
        8,
        15,
        0,
        14,
        5,
        2,
        9,
        3,
        2,
        12,
        13,
        1,
        2,
        15,
        8,
        13,
        4,
        8,
        6,
        10,
        15,
        3,
        11,
        7,
        1,
        4,
        10,
        12,
        9,
        5,
        3,
        6,
        14,
        11,
        5,
        0,
        0,
        14,
        12,
        9,
        7,
        2,
        7,
        2,
        11,
        1,
        4,
        14,
        1,
        7,
        9,
        4,
        12,
        10,
        14,
        8,
        2,
        13,
        0,
        15,
        6,
        12,
        10,
        9,
        13,
        0,
        15,
        3,
        3,
        5,
        5,
        6,
        8,
        11
    ];
    $157f9a87c9609c03$export$d865ce2836f5927f = function substitute(inL, inR) {
        var out = 0;
        for(var i = 0; i < 4; i++){
            var b = inL >>> 18 - i * 6 & 0x3f;
            var sb = $157f9a87c9609c03$var$sTable[i * 0x40 + b];
            out <<= 4;
            out |= sb;
        }
        for(var i = 0; i < 4; i++){
            var b = inR >>> 18 - i * 6 & 0x3f;
            var sb = $157f9a87c9609c03$var$sTable[256 + i * 0x40 + b];
            out <<= 4;
            out |= sb;
        }
        return out >>> 0;
    };
    var $157f9a87c9609c03$var$permuteTable = [
        16,
        25,
        12,
        11,
        3,
        20,
        4,
        15,
        31,
        17,
        9,
        6,
        27,
        14,
        1,
        22,
        30,
        24,
        8,
        18,
        0,
        5,
        29,
        23,
        13,
        19,
        2,
        26,
        10,
        21,
        28,
        7
    ];
    $157f9a87c9609c03$export$95e62ad65da8b7d2 = function permute(num) {
        var out = 0;
        for(var i = 0; i < $157f9a87c9609c03$var$permuteTable.length; i++){
            out <<= 1;
            out |= num >>> $157f9a87c9609c03$var$permuteTable[i] & 0x1;
        }
        return out >>> 0;
    };
    $157f9a87c9609c03$export$209139ff098c441a = function padSplit(num, size, group) {
        var str = num.toString(2);
        while(str.length < size)str = '0' + str;
        var out = [];
        for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
        return out.join(' ');
    };
});
parcelRegister("lE1WX", function(module, exports) {
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    function $fc1ed8a00916f8f8$var$Cipher(options) {
        this.options = options;
        this.type = this.options.type;
        this.blockSize = 8;
        this._init();
        this.buffer = new Array(this.blockSize);
        this.bufferOff = 0;
    }
    module.exports = $fc1ed8a00916f8f8$var$Cipher;
    $fc1ed8a00916f8f8$var$Cipher.prototype._init = function _init() {};
    $fc1ed8a00916f8f8$var$Cipher.prototype.update = function update(data) {
        if (data.length === 0) return [];
        if (this.type === 'decrypt') return this._updateDecrypt(data);
        else return this._updateEncrypt(data);
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._buffer = function _buffer(data, off) {
        var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
        for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
        this.bufferOff += min;
        return min;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
        this._update(this.buffer, 0, out, off);
        this.bufferOff = 0;
        return this.blockSize;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
        var inputOff = 0;
        var outputOff = 0;
        var count = (this.bufferOff + data.length) / this.blockSize | 0;
        var out = new Array(count * this.blockSize);
        if (this.bufferOff !== 0) {
            inputOff += this._buffer(data, inputOff);
            if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
        }
        var max = data.length - (data.length - inputOff) % this.blockSize;
        for(; inputOff < max; inputOff += this.blockSize){
            this._update(data, inputOff, out, outputOff);
            outputOff += this.blockSize;
        }
        for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
        return out;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
        var inputOff = 0;
        var outputOff = 0;
        var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
        var out = new Array(count * this.blockSize);
        for(; count > 0; count--){
            inputOff += this._buffer(data, inputOff);
            outputOff += this._flushBuffer(out, outputOff);
        }
        inputOff += this._buffer(data, inputOff);
        return out;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype.final = function final(buffer) {
        var first;
        if (buffer) first = this.update(buffer);
        var last;
        if (this.type === 'encrypt') last = this._finalEncrypt();
        else last = this._finalDecrypt();
        if (first) return first.concat(last);
        else return last;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._pad = function _pad(buffer, off) {
        if (off === 0) return false;
        while(off < buffer.length)buffer[off++] = 0;
        return true;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
        if (!this._pad(this.buffer, this.bufferOff)) return [];
        var out = new Array(this.blockSize);
        this._update(this.buffer, 0, out, 0);
        return out;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._unpad = function _unpad(buffer) {
        return buffer;
    };
    $fc1ed8a00916f8f8$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
        $gxaFy.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
        var out = new Array(this.blockSize);
        this._flushBuffer(out, 0);
        return this._unpad(out);
    };
});
parcelRegister("gxaFy", function(module, exports) {
    module.exports = $c098011ba04e0256$var$assert;
    function $c098011ba04e0256$var$assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    $c098011ba04e0256$var$assert.equal = function assertEqual(l, r, msg) {
        if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
    };
});
parcelRegister("6uemC", function(module, exports) {
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    var $bsIyp = parcelRequire("bsIyp");
    var $4b90afcb2a1cbace$var$utils = $bsIyp.utils;
    var $4b90afcb2a1cbace$var$Cipher = $bsIyp.Cipher;
    function $4b90afcb2a1cbace$var$DESState() {
        this.tmp = new Array(2);
        this.keys = null;
    }
    function $4b90afcb2a1cbace$var$DES(options) {
        $4b90afcb2a1cbace$var$Cipher.call(this, options);
        var state = new $4b90afcb2a1cbace$var$DESState();
        this._desState = state;
        this.deriveKeys(state, options.key);
    }
    $v3bBu($4b90afcb2a1cbace$var$DES, $4b90afcb2a1cbace$var$Cipher);
    module.exports = $4b90afcb2a1cbace$var$DES;
    $4b90afcb2a1cbace$var$DES.create = function create(options) {
        return new $4b90afcb2a1cbace$var$DES(options);
    };
    var $4b90afcb2a1cbace$var$shiftTable = [
        1,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        1,
        2,
        2,
        2,
        2,
        2,
        2,
        1
    ];
    $4b90afcb2a1cbace$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
        state.keys = new Array(32);
        $gxaFy.equal(key.length, this.blockSize, 'Invalid key length');
        var kL = $4b90afcb2a1cbace$var$utils.readUInt32BE(key, 0);
        var kR = $4b90afcb2a1cbace$var$utils.readUInt32BE(key, 4);
        $4b90afcb2a1cbace$var$utils.pc1(kL, kR, state.tmp, 0);
        kL = state.tmp[0];
        kR = state.tmp[1];
        for(var i = 0; i < state.keys.length; i += 2){
            var shift = $4b90afcb2a1cbace$var$shiftTable[i >>> 1];
            kL = $4b90afcb2a1cbace$var$utils.r28shl(kL, shift);
            kR = $4b90afcb2a1cbace$var$utils.r28shl(kR, shift);
            $4b90afcb2a1cbace$var$utils.pc2(kL, kR, state.keys, i);
        }
    };
    $4b90afcb2a1cbace$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
        var state = this._desState;
        var l = $4b90afcb2a1cbace$var$utils.readUInt32BE(inp, inOff);
        var r = $4b90afcb2a1cbace$var$utils.readUInt32BE(inp, inOff + 4);
        $4b90afcb2a1cbace$var$utils.ip(l, r, state.tmp, 0);
        l = state.tmp[0];
        r = state.tmp[1];
        if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
        else this._decrypt(state, l, r, state.tmp, 0);
        l = state.tmp[0];
        r = state.tmp[1];
        $4b90afcb2a1cbace$var$utils.writeUInt32BE(out, l, outOff);
        $4b90afcb2a1cbace$var$utils.writeUInt32BE(out, r, outOff + 4);
    };
    $4b90afcb2a1cbace$var$DES.prototype._pad = function _pad(buffer, off) {
        var value = buffer.length - off;
        for(var i = off; i < buffer.length; i++)buffer[i] = value;
        return true;
    };
    $4b90afcb2a1cbace$var$DES.prototype._unpad = function _unpad(buffer) {
        var pad = buffer[buffer.length - 1];
        for(var i = buffer.length - pad; i < buffer.length; i++)$gxaFy.equal(buffer[i], pad);
        return buffer.slice(0, buffer.length - pad);
    };
    $4b90afcb2a1cbace$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
        var l = lStart;
        var r = rStart;
        for(var i = 0; i < state.keys.length; i += 2){
            var keyL = state.keys[i];
            var keyR = state.keys[i + 1];
            $4b90afcb2a1cbace$var$utils.expand(r, state.tmp, 0);
            keyL ^= state.tmp[0];
            keyR ^= state.tmp[1];
            var s = $4b90afcb2a1cbace$var$utils.substitute(keyL, keyR);
            var f = $4b90afcb2a1cbace$var$utils.permute(s);
            var t = r;
            r = (l ^ f) >>> 0;
            l = t;
        }
        $4b90afcb2a1cbace$var$utils.rip(r, l, out, off);
    };
    $4b90afcb2a1cbace$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
        var l = rStart;
        var r = lStart;
        for(var i = state.keys.length - 2; i >= 0; i -= 2){
            var keyL = state.keys[i];
            var keyR = state.keys[i + 1];
            $4b90afcb2a1cbace$var$utils.expand(l, state.tmp, 0);
            keyL ^= state.tmp[0];
            keyR ^= state.tmp[1];
            var s = $4b90afcb2a1cbace$var$utils.substitute(keyL, keyR);
            var f = $4b90afcb2a1cbace$var$utils.permute(s);
            var t = l;
            l = (r ^ f) >>> 0;
            r = t;
        }
        $4b90afcb2a1cbace$var$utils.rip(l, r, out, off);
    };
});
parcelRegister("bdh1b", function(module, exports) {
    $parcel$export(module.exports, "instantiate", ()=>$829e1c11ed1f1a2c$export$f9bb8d20ccc7477a, (v)=>$829e1c11ed1f1a2c$export$f9bb8d20ccc7477a = v);
    var $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a;
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    var $829e1c11ed1f1a2c$var$proto = {};
    function $829e1c11ed1f1a2c$var$CBCState(iv) {
        $gxaFy.equal(iv.length, 8, 'Invalid IV length');
        this.iv = new Array(8);
        for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
    }
    function $829e1c11ed1f1a2c$var$instantiate(Base) {
        function CBC(options) {
            Base.call(this, options);
            this._cbcInit();
        }
        $v3bBu(CBC, Base);
        var keys = Object.keys($829e1c11ed1f1a2c$var$proto);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            CBC.prototype[key] = $829e1c11ed1f1a2c$var$proto[key];
        }
        CBC.create = function create(options) {
            return new CBC(options);
        };
        return CBC;
    }
    $829e1c11ed1f1a2c$export$f9bb8d20ccc7477a = $829e1c11ed1f1a2c$var$instantiate;
    $829e1c11ed1f1a2c$var$proto._cbcInit = function _cbcInit() {
        var state = new $829e1c11ed1f1a2c$var$CBCState(this.options.iv);
        this._cbcState = state;
    };
    $829e1c11ed1f1a2c$var$proto._update = function _update(inp, inOff, out, outOff) {
        var state = this._cbcState;
        var superProto = this.constructor.super_.prototype;
        var iv = state.iv;
        if (this.type === 'encrypt') {
            for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
            superProto._update.call(this, iv, 0, out, outOff);
            for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
        } else {
            superProto._update.call(this, inp, inOff, out, outOff);
            for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
            for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
        }
    };
});
parcelRegister("d53eL", function(module, exports) {
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    var $bsIyp = parcelRequire("bsIyp");
    var $02752213ee35ee04$var$Cipher = $bsIyp.Cipher;
    var $02752213ee35ee04$var$DES = $bsIyp.DES;
    function $02752213ee35ee04$var$EDEState(type, key) {
        $gxaFy.equal(key.length, 24, 'Invalid key length');
        var k1 = key.slice(0, 8);
        var k2 = key.slice(8, 16);
        var k3 = key.slice(16, 24);
        if (type === 'encrypt') this.ciphers = [
            $02752213ee35ee04$var$DES.create({
                type: 'encrypt',
                key: k1
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'decrypt',
                key: k2
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'encrypt',
                key: k3
            })
        ];
        else this.ciphers = [
            $02752213ee35ee04$var$DES.create({
                type: 'decrypt',
                key: k3
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'encrypt',
                key: k2
            }),
            $02752213ee35ee04$var$DES.create({
                type: 'decrypt',
                key: k1
            })
        ];
    }
    function $02752213ee35ee04$var$EDE(options) {
        $02752213ee35ee04$var$Cipher.call(this, options);
        var state = new $02752213ee35ee04$var$EDEState(this.type, this.options.key);
        this._edeState = state;
    }
    $v3bBu($02752213ee35ee04$var$EDE, $02752213ee35ee04$var$Cipher);
    module.exports = $02752213ee35ee04$var$EDE;
    $02752213ee35ee04$var$EDE.create = function create(options) {
        return new $02752213ee35ee04$var$EDE(options);
    };
    $02752213ee35ee04$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
        var state = this._edeState;
        state.ciphers[0]._update(inp, inOff, out, outOff);
        state.ciphers[1]._update(out, outOff, out, outOff);
        state.ciphers[2]._update(out, outOff, out, outOff);
    };
    $02752213ee35ee04$var$EDE.prototype._pad = $02752213ee35ee04$var$DES.prototype._pad;
    $02752213ee35ee04$var$EDE.prototype._unpad = $02752213ee35ee04$var$DES.prototype._unpad;
});
parcelRegister("gcaJj", function(module, exports) {
    $parcel$export(module.exports, "createCipheriv", ()=>$bca6170d70d22f8b$export$2f64596b8cbf08b4, (v)=>$bca6170d70d22f8b$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$bca6170d70d22f8b$export$36b6d6ef312eab39, (v)=>$bca6170d70d22f8b$export$36b6d6ef312eab39 = v);
    $parcel$export(module.exports, "getCiphers", ()=>$bca6170d70d22f8b$export$58a258485f1e49f6, (v)=>$bca6170d70d22f8b$export$58a258485f1e49f6 = v);
    var $bca6170d70d22f8b$export$bdd223f16383713e;
    var $bca6170d70d22f8b$export$26e5786e8ac8e530;
    var $bca6170d70d22f8b$export$2f64596b8cbf08b4;
    var $bca6170d70d22f8b$export$20533d26f07f1ee0;
    var $bca6170d70d22f8b$export$12ada9414fbc594c;
    var $bca6170d70d22f8b$export$2ce6d8d0e8b04e1a;
    var $bca6170d70d22f8b$export$36b6d6ef312eab39;
    var $bca6170d70d22f8b$export$f5e7e39d57cd9700;
    var $bca6170d70d22f8b$export$dedd8dc3dc62b370;
    var $bca6170d70d22f8b$export$58a258485f1e49f6;
    var $8YWSl = parcelRequire("8YWSl");
    var $i9P5q = parcelRequire("i9P5q");
    var $8DplL = parcelRequire("8DplL");
    function $bca6170d70d22f8b$var$getCiphers() {
        return Object.keys($8DplL);
    }
    $bca6170d70d22f8b$export$bdd223f16383713e = $bca6170d70d22f8b$export$26e5786e8ac8e530 = $8YWSl.createCipher;
    $bca6170d70d22f8b$export$2f64596b8cbf08b4 = $bca6170d70d22f8b$export$20533d26f07f1ee0 = $8YWSl.createCipheriv;
    $bca6170d70d22f8b$export$12ada9414fbc594c = $bca6170d70d22f8b$export$2ce6d8d0e8b04e1a = $i9P5q.createDecipher;
    $bca6170d70d22f8b$export$36b6d6ef312eab39 = $bca6170d70d22f8b$export$f5e7e39d57cd9700 = $i9P5q.createDecipheriv;
    $bca6170d70d22f8b$export$dedd8dc3dc62b370 = $bca6170d70d22f8b$export$58a258485f1e49f6 = $bca6170d70d22f8b$var$getCiphers;
});
parcelRegister("8YWSl", function(module, exports) {
    $parcel$export(module.exports, "createCipheriv", ()=>$68a198cd46e098a5$export$2f64596b8cbf08b4, (v)=>$68a198cd46e098a5$export$2f64596b8cbf08b4 = v);
    $parcel$export(module.exports, "createCipher", ()=>$68a198cd46e098a5$export$bdd223f16383713e, (v)=>$68a198cd46e098a5$export$bdd223f16383713e = v);
    var $68a198cd46e098a5$export$2f64596b8cbf08b4;
    var $68a198cd46e098a5$export$bdd223f16383713e;
    var $6WLno = parcelRequire("6WLno");
    var $dsL7z = parcelRequire("dsL7z");
    var $Wth4q = parcelRequire("Wth4q");
    var $68a198cd46e098a5$require$Buffer = $Wth4q.Buffer;
    var $ecK7f = parcelRequire("ecK7f");
    var $77fwb = parcelRequire("77fwb");
    var $h0C5b = parcelRequire("h0C5b");
    var $55KiC = parcelRequire("55KiC");
    var $v3bBu = parcelRequire("v3bBu");
    function $68a198cd46e098a5$var$Cipher(mode, key, iv) {
        $77fwb.call(this);
        this._cache = new $68a198cd46e098a5$var$Splitter();
        this._cipher = new $h0C5b.AES(key);
        this._prev = $68a198cd46e098a5$require$Buffer.from(iv);
        this._mode = mode;
        this._autopadding = true;
    }
    $v3bBu($68a198cd46e098a5$var$Cipher, $77fwb);
    $68a198cd46e098a5$var$Cipher.prototype._update = function(data) {
        this._cache.add(data);
        var chunk;
        var thing;
        var out = [];
        while(chunk = this._cache.get()){
            thing = this._mode.encrypt(this, chunk);
            out.push(thing);
        }
        return $68a198cd46e098a5$require$Buffer.concat(out);
    };
    var $68a198cd46e098a5$var$PADDING = $68a198cd46e098a5$require$Buffer.alloc(16, 0x10);
    $68a198cd46e098a5$var$Cipher.prototype._final = function() {
        var chunk = this._cache.flush();
        if (this._autopadding) {
            chunk = this._mode.encrypt(this, chunk);
            this._cipher.scrub();
            return chunk;
        }
        if (!chunk.equals($68a198cd46e098a5$var$PADDING)) {
            this._cipher.scrub();
            throw new Error('data not multiple of block length');
        }
    };
    $68a198cd46e098a5$var$Cipher.prototype.setAutoPadding = function(setTo) {
        this._autopadding = !!setTo;
        return this;
    };
    function $68a198cd46e098a5$var$Splitter() {
        this.cache = $68a198cd46e098a5$require$Buffer.allocUnsafe(0);
    }
    $68a198cd46e098a5$var$Splitter.prototype.add = function(data) {
        this.cache = $68a198cd46e098a5$require$Buffer.concat([
            this.cache,
            data
        ]);
    };
    $68a198cd46e098a5$var$Splitter.prototype.get = function() {
        if (this.cache.length > 15) {
            var out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
        return null;
    };
    $68a198cd46e098a5$var$Splitter.prototype.flush = function() {
        var len = 16 - this.cache.length;
        var padBuff = $68a198cd46e098a5$require$Buffer.allocUnsafe(len);
        var i = -1;
        while(++i < len)padBuff.writeUInt8(len, i);
        return $68a198cd46e098a5$require$Buffer.concat([
            this.cache,
            padBuff
        ]);
    };
    function $68a198cd46e098a5$var$createCipheriv(suite, password, iv) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        if (typeof password === 'string') password = $68a198cd46e098a5$require$Buffer.from(password);
        if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
        if (typeof iv === 'string') iv = $68a198cd46e098a5$require$Buffer.from(iv);
        if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
        if (config.type === 'stream') return new $ecK7f(config.module, password, iv);
        else if (config.type === 'auth') return new $dsL7z(config.module, password, iv);
        return new $68a198cd46e098a5$var$Cipher(config.module, password, iv);
    }
    function $68a198cd46e098a5$var$createCipher(suite, password) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, config.key, config.iv);
        return $68a198cd46e098a5$var$createCipheriv(suite, keys.key, keys.iv);
    }
    $68a198cd46e098a5$export$2f64596b8cbf08b4 = $68a198cd46e098a5$var$createCipheriv;
    $68a198cd46e098a5$export$bdd223f16383713e = $68a198cd46e098a5$var$createCipher;
});
parcelRegister("6WLno", function(module, exports) {
    var $50ece8ccaacc95aa$var$modeModules = {
        ECB: (parcelRequire("2r4jQ")),
        CBC: (parcelRequire("171QV")),
        CFB: (parcelRequire("7gub3")),
        CFB8: (parcelRequire("hHOIy")),
        CFB1: (parcelRequire("hJx3X")),
        OFB: (parcelRequire("3PEE4")),
        CTR: (parcelRequire("5VEEg")),
        GCM: (parcelRequire("5VEEg"))
    };
    var $8DplL = parcelRequire("8DplL");
    for(var $50ece8ccaacc95aa$var$key in $8DplL)$8DplL[$50ece8ccaacc95aa$var$key].module = $50ece8ccaacc95aa$var$modeModules[$8DplL[$50ece8ccaacc95aa$var$key].mode];
    module.exports = $8DplL;
});
parcelRegister("2r4jQ", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$1c61741219819c7a$export$5b0f6292f11d1d18, (v)=>$1c61741219819c7a$export$5b0f6292f11d1d18 = v);
    $parcel$export(module.exports, "decrypt", ()=>$1c61741219819c7a$export$e85a0c9a1067c5d3, (v)=>$1c61741219819c7a$export$e85a0c9a1067c5d3 = v);
    var $1c61741219819c7a$export$5b0f6292f11d1d18;
    var $1c61741219819c7a$export$e85a0c9a1067c5d3;
    $1c61741219819c7a$export$5b0f6292f11d1d18 = function(self, block) {
        return self._cipher.encryptBlock(block);
    };
    $1c61741219819c7a$export$e85a0c9a1067c5d3 = function(self, block) {
        return self._cipher.decryptBlock(block);
    };
});
parcelRegister("171QV", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$0cf7e1c4789e90b1$export$5b0f6292f11d1d18, (v)=>$0cf7e1c4789e90b1$export$5b0f6292f11d1d18 = v);
    $parcel$export(module.exports, "decrypt", ()=>$0cf7e1c4789e90b1$export$e85a0c9a1067c5d3, (v)=>$0cf7e1c4789e90b1$export$e85a0c9a1067c5d3 = v);
    var $0cf7e1c4789e90b1$export$5b0f6292f11d1d18;
    var $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3;
    var $hWuQG = parcelRequire("hWuQG");
    $0cf7e1c4789e90b1$export$5b0f6292f11d1d18 = function(self, block) {
        var data = $hWuQG(block, self._prev);
        self._prev = self._cipher.encryptBlock(data);
        return self._prev;
    };
    $0cf7e1c4789e90b1$export$e85a0c9a1067c5d3 = function(self, block) {
        var pad = self._prev;
        self._prev = block;
        var out = self._cipher.decryptBlock(block);
        return $hWuQG(out, pad);
    };
});
parcelRegister("hWuQG", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $d0ffc85ebd18b8c9$require$Buffer = $5k7LC.Buffer;
    module.exports = function xor(a, b) {
        var length = Math.min(a.length, b.length);
        var buffer = new $d0ffc85ebd18b8c9$require$Buffer(length);
        for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
        return buffer;
    };
});
parcelRegister("7gub3", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$54a16fa1fdb145af$export$5b0f6292f11d1d18, (v)=>$54a16fa1fdb145af$export$5b0f6292f11d1d18 = v);
    var $54a16fa1fdb145af$export$5b0f6292f11d1d18;
    var $Wth4q = parcelRequire("Wth4q");
    var $54a16fa1fdb145af$require$Buffer = $Wth4q.Buffer;
    var $hWuQG = parcelRequire("hWuQG");
    function $54a16fa1fdb145af$var$encryptStart(self, data, decrypt) {
        var len = data.length;
        var out = $hWuQG(data, self._cache);
        self._cache = self._cache.slice(len);
        self._prev = $54a16fa1fdb145af$require$Buffer.concat([
            self._prev,
            decrypt ? data : out
        ]);
        return out;
    }
    $54a16fa1fdb145af$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
        var out = $54a16fa1fdb145af$require$Buffer.allocUnsafe(0);
        var len;
        while(data.length){
            if (self._cache.length === 0) {
                self._cache = self._cipher.encryptBlock(self._prev);
                self._prev = $54a16fa1fdb145af$require$Buffer.allocUnsafe(0);
            }
            if (self._cache.length <= data.length) {
                len = self._cache.length;
                out = $54a16fa1fdb145af$require$Buffer.concat([
                    out,
                    $54a16fa1fdb145af$var$encryptStart(self, data.slice(0, len), decrypt)
                ]);
                data = data.slice(len);
            } else {
                out = $54a16fa1fdb145af$require$Buffer.concat([
                    out,
                    $54a16fa1fdb145af$var$encryptStart(self, data, decrypt)
                ]);
                break;
            }
        }
        return out;
    };
});
parcelRegister("hHOIy", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$ce3dcb4bc3fa3501$export$5b0f6292f11d1d18, (v)=>$ce3dcb4bc3fa3501$export$5b0f6292f11d1d18 = v);
    var $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18;
    var $Wth4q = parcelRequire("Wth4q");
    var $ce3dcb4bc3fa3501$require$Buffer = $Wth4q.Buffer;
    function $ce3dcb4bc3fa3501$var$encryptByte(self, byteParam, decrypt) {
        var pad = self._cipher.encryptBlock(self._prev);
        var out = pad[0] ^ byteParam;
        self._prev = $ce3dcb4bc3fa3501$require$Buffer.concat([
            self._prev.slice(1),
            $ce3dcb4bc3fa3501$require$Buffer.from([
                decrypt ? byteParam : out
            ])
        ]);
        return out;
    }
    $ce3dcb4bc3fa3501$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
        var len = chunk.length;
        var out = $ce3dcb4bc3fa3501$require$Buffer.allocUnsafe(len);
        var i = -1;
        while(++i < len)out[i] = $ce3dcb4bc3fa3501$var$encryptByte(self, chunk[i], decrypt);
        return out;
    };
});
parcelRegister("hJx3X", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$ce90493eb3a7fe0a$export$5b0f6292f11d1d18, (v)=>$ce90493eb3a7fe0a$export$5b0f6292f11d1d18 = v);
    var $ce90493eb3a7fe0a$export$5b0f6292f11d1d18;
    var $Wth4q = parcelRequire("Wth4q");
    var $ce90493eb3a7fe0a$require$Buffer = $Wth4q.Buffer;
    function $ce90493eb3a7fe0a$var$encryptByte(self, byteParam, decrypt) {
        var pad;
        var i = -1;
        var len = 8;
        var out = 0;
        var bit, value;
        while(++i < len){
            pad = self._cipher.encryptBlock(self._prev);
            bit = byteParam & 1 << 7 - i ? 0x80 : 0;
            value = pad[0] ^ bit;
            out += (value & 0x80) >> i % 8;
            self._prev = $ce90493eb3a7fe0a$var$shiftIn(self._prev, decrypt ? bit : value);
        }
        return out;
    }
    function $ce90493eb3a7fe0a$var$shiftIn(buffer, value) {
        var len = buffer.length;
        var i = -1;
        var out = $ce90493eb3a7fe0a$require$Buffer.allocUnsafe(buffer.length);
        buffer = $ce90493eb3a7fe0a$require$Buffer.concat([
            buffer,
            $ce90493eb3a7fe0a$require$Buffer.from([
                value
            ])
        ]);
        while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
        return out;
    }
    $ce90493eb3a7fe0a$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
        var len = chunk.length;
        var out = $ce90493eb3a7fe0a$require$Buffer.allocUnsafe(len);
        var i = -1;
        while(++i < len)out[i] = $ce90493eb3a7fe0a$var$encryptByte(self, chunk[i], decrypt);
        return out;
    };
});
parcelRegister("3PEE4", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$2ca5a9cd9f4302f4$export$5b0f6292f11d1d18, (v)=>$2ca5a9cd9f4302f4$export$5b0f6292f11d1d18 = v);
    var $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18;
    var $5k7LC = parcelRequire("5k7LC");
    var $2ca5a9cd9f4302f4$require$Buffer = $5k7LC.Buffer;
    var $hWuQG = parcelRequire("hWuQG");
    function $2ca5a9cd9f4302f4$var$getBlock(self) {
        self._prev = self._cipher.encryptBlock(self._prev);
        return self._prev;
    }
    $2ca5a9cd9f4302f4$export$5b0f6292f11d1d18 = function(self, chunk) {
        while(self._cache.length < chunk.length)self._cache = $2ca5a9cd9f4302f4$require$Buffer.concat([
            self._cache,
            $2ca5a9cd9f4302f4$var$getBlock(self)
        ]);
        var pad = self._cache.slice(0, chunk.length);
        self._cache = self._cache.slice(chunk.length);
        return $hWuQG(chunk, pad);
    };
});
parcelRegister("5VEEg", function(module, exports) {
    $parcel$export(module.exports, "encrypt", ()=>$4511ce87a2b6ec4f$export$5b0f6292f11d1d18, (v)=>$4511ce87a2b6ec4f$export$5b0f6292f11d1d18 = v);
    var $4511ce87a2b6ec4f$export$5b0f6292f11d1d18;
    var $hWuQG = parcelRequire("hWuQG");
    var $Wth4q = parcelRequire("Wth4q");
    var $4511ce87a2b6ec4f$require$Buffer = $Wth4q.Buffer;
    var $eYeWA = parcelRequire("eYeWA");
    function $4511ce87a2b6ec4f$var$getBlock(self) {
        var out = self._cipher.encryptBlockRaw(self._prev);
        $eYeWA(self._prev);
        return out;
    }
    var $4511ce87a2b6ec4f$var$blockSize = 16;
    $4511ce87a2b6ec4f$export$5b0f6292f11d1d18 = function(self, chunk) {
        var chunkNum = Math.ceil(chunk.length / $4511ce87a2b6ec4f$var$blockSize);
        var start = self._cache.length;
        self._cache = $4511ce87a2b6ec4f$require$Buffer.concat([
            self._cache,
            $4511ce87a2b6ec4f$require$Buffer.allocUnsafe(chunkNum * $4511ce87a2b6ec4f$var$blockSize)
        ]);
        for(var i = 0; i < chunkNum; i++){
            var out = $4511ce87a2b6ec4f$var$getBlock(self);
            var offset = start + i * $4511ce87a2b6ec4f$var$blockSize;
            self._cache.writeUInt32BE(out[0], offset + 0);
            self._cache.writeUInt32BE(out[1], offset + 4);
            self._cache.writeUInt32BE(out[2], offset + 8);
            self._cache.writeUInt32BE(out[3], offset + 12);
        }
        var pad = self._cache.slice(0, chunk.length);
        self._cache = self._cache.slice(chunk.length);
        return $hWuQG(chunk, pad);
    };
});
parcelRegister("eYeWA", function(module, exports) {
    function $ae6242d5e2554d0f$var$incr32(iv) {
        var len = iv.length;
        var item;
        while(len--){
            item = iv.readUInt8(len);
            if (item === 255) iv.writeUInt8(0, len);
            else {
                item++;
                iv.writeUInt8(item, len);
                break;
            }
        }
    }
    module.exports = $ae6242d5e2554d0f$var$incr32;
});
parcelRegister("8DplL", function(module, exports) {
    module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");
});
parcelRegister("dsL7z", function(module, exports) {
    var $h0C5b = parcelRequire("h0C5b");
    var $Wth4q = parcelRequire("Wth4q");
    var $9cd2712b02891133$require$Buffer = $Wth4q.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $v3bBu = parcelRequire("v3bBu");
    var $3wyrd = parcelRequire("3wyrd");
    var $hWuQG = parcelRequire("hWuQG");
    var $eYeWA = parcelRequire("eYeWA");
    function $9cd2712b02891133$var$xorTest(a, b) {
        var out = 0;
        if (a.length !== b.length) out++;
        var len = Math.min(a.length, b.length);
        for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
        return out;
    }
    function $9cd2712b02891133$var$calcIv(self, iv, ck) {
        if (iv.length === 12) {
            self._finID = $9cd2712b02891133$require$Buffer.concat([
                iv,
                $9cd2712b02891133$require$Buffer.from([
                    0,
                    0,
                    0,
                    1
                ])
            ]);
            return $9cd2712b02891133$require$Buffer.concat([
                iv,
                $9cd2712b02891133$require$Buffer.from([
                    0,
                    0,
                    0,
                    2
                ])
            ]);
        }
        var ghash = new $3wyrd(ck);
        var len = iv.length;
        var toPad = len % 16;
        ghash.update(iv);
        if (toPad) {
            toPad = 16 - toPad;
            ghash.update($9cd2712b02891133$require$Buffer.alloc(toPad, 0));
        }
        ghash.update($9cd2712b02891133$require$Buffer.alloc(8, 0));
        var ivBits = len * 8;
        var tail = $9cd2712b02891133$require$Buffer.alloc(8);
        tail.writeUIntBE(ivBits, 0, 8);
        ghash.update(tail);
        self._finID = ghash.state;
        var out = $9cd2712b02891133$require$Buffer.from(self._finID);
        $eYeWA(out);
        return out;
    }
    function $9cd2712b02891133$var$StreamCipher(mode, key, iv, decrypt) {
        $77fwb.call(this);
        var h = $9cd2712b02891133$require$Buffer.alloc(4, 0);
        this._cipher = new $h0C5b.AES(key);
        var ck = this._cipher.encryptBlock(h);
        this._ghash = new $3wyrd(ck);
        iv = $9cd2712b02891133$var$calcIv(this, iv, ck);
        this._prev = $9cd2712b02891133$require$Buffer.from(iv);
        this._cache = $9cd2712b02891133$require$Buffer.allocUnsafe(0);
        this._secCache = $9cd2712b02891133$require$Buffer.allocUnsafe(0);
        this._decrypt = decrypt;
        this._alen = 0;
        this._len = 0;
        this._mode = mode;
        this._authTag = null;
        this._called = false;
    }
    $v3bBu($9cd2712b02891133$var$StreamCipher, $77fwb);
    $9cd2712b02891133$var$StreamCipher.prototype._update = function(chunk) {
        if (!this._called && this._alen) {
            var rump = 16 - this._alen % 16;
            if (rump < 16) {
                rump = $9cd2712b02891133$require$Buffer.alloc(rump, 0);
                this._ghash.update(rump);
            }
        }
        this._called = true;
        var out = this._mode.encrypt(this, chunk);
        if (this._decrypt) this._ghash.update(chunk);
        else this._ghash.update(out);
        this._len += chunk.length;
        return out;
    };
    $9cd2712b02891133$var$StreamCipher.prototype._final = function() {
        if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
        var tag = $hWuQG(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
        if (this._decrypt && $9cd2712b02891133$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
        this._authTag = tag;
        this._cipher.scrub();
    };
    $9cd2712b02891133$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
        if (this._decrypt || !$9cd2712b02891133$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
        return this._authTag;
    };
    $9cd2712b02891133$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
        if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
        this._authTag = tag;
    };
    $9cd2712b02891133$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
        if (this._called) throw new Error('Attempting to set AAD in unsupported state');
        this._ghash.update(buf);
        this._alen += buf.length;
    };
    module.exports = $9cd2712b02891133$var$StreamCipher;
});
parcelRegister("h0C5b", function(module, exports) {
    $parcel$export(module.exports, "AES", ()=>$c61ffa2be163e1f3$export$b80fbe1c3a2b92b5, (v)=>$c61ffa2be163e1f3$export$b80fbe1c3a2b92b5 = v);
    var $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5;
    var $Wth4q = parcelRequire("Wth4q");
    var $c61ffa2be163e1f3$require$Buffer = $Wth4q.Buffer;
    function $c61ffa2be163e1f3$var$asUInt32Array(buf) {
        if (!$c61ffa2be163e1f3$require$Buffer.isBuffer(buf)) buf = $c61ffa2be163e1f3$require$Buffer.from(buf);
        var len = buf.length / 4 | 0;
        var out = new Array(len);
        for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
        return out;
    }
    function $c61ffa2be163e1f3$var$scrubVec(v) {
        for(var i = 0; i < v.length; v++)v[i] = 0;
    }
    function $c61ffa2be163e1f3$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
        var SUB_MIX0 = SUB_MIX[0];
        var SUB_MIX1 = SUB_MIX[1];
        var SUB_MIX2 = SUB_MIX[2];
        var SUB_MIX3 = SUB_MIX[3];
        var s0 = M[0] ^ keySchedule[0];
        var s1 = M[1] ^ keySchedule[1];
        var s2 = M[2] ^ keySchedule[2];
        var s3 = M[3] ^ keySchedule[3];
        var t0, t1, t2, t3;
        var ksRow = 4;
        for(var round = 1; round < nRounds; round++){
            t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
            t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
            t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
            t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
            s0 = t0;
            s1 = t1;
            s2 = t2;
            s3 = t3;
        }
        t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
        t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
        t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
        t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
        t0 = t0 >>> 0;
        t1 = t1 >>> 0;
        t2 = t2 >>> 0;
        t3 = t3 >>> 0;
        return [
            t0,
            t1,
            t2,
            t3
        ];
    }
    var $c61ffa2be163e1f3$var$RCON = [
        0x00,
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36
    ];
    var $c61ffa2be163e1f3$var$G = function() {
        var d = new Array(256);
        for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
        else d[j] = j << 1 ^ 0x11b;
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX = [
            [],
            [],
            [],
            []
        ];
        var INV_SUB_MIX = [
            [],
            [],
            [],
            []
        ];
        var x = 0;
        var xi = 0;
        for(var i = 0; i < 256; ++i){
            var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            SBOX[x] = sx;
            INV_SBOX[sx] = x;
            var x2 = d[x];
            var x4 = d[x2];
            var x8 = d[x4];
            var t = d[sx] * 0x101 ^ sx * 0x1010100;
            SUB_MIX[0][x] = t << 24 | t >>> 8;
            SUB_MIX[1][x] = t << 16 | t >>> 16;
            SUB_MIX[2][x] = t << 8 | t >>> 24;
            SUB_MIX[3][x] = t;
            t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
            INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
            INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
            INV_SUB_MIX[3][sx] = t;
            if (x === 0) x = xi = 1;
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
        return {
            SBOX: SBOX,
            INV_SBOX: INV_SBOX,
            SUB_MIX: SUB_MIX,
            INV_SUB_MIX: INV_SUB_MIX
        };
    }();
    function $c61ffa2be163e1f3$var$AES(key) {
        this._key = $c61ffa2be163e1f3$var$asUInt32Array(key);
        this._reset();
    }
    $c61ffa2be163e1f3$var$AES.blockSize = 16;
    $c61ffa2be163e1f3$var$AES.keySize = 32;
    $c61ffa2be163e1f3$var$AES.prototype.blockSize = $c61ffa2be163e1f3$var$AES.blockSize;
    $c61ffa2be163e1f3$var$AES.prototype.keySize = $c61ffa2be163e1f3$var$AES.keySize;
    $c61ffa2be163e1f3$var$AES.prototype._reset = function() {
        var keyWords = this._key;
        var keySize = keyWords.length;
        var nRounds = keySize + 6;
        var ksRows = (nRounds + 1) * 4;
        var keySchedule = [];
        for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
        for(k = keySize; k < ksRows; k++){
            var t = keySchedule[k - 1];
            if (k % keySize === 0) {
                t = t << 8 | t >>> 24;
                t = $c61ffa2be163e1f3$var$G.SBOX[t >>> 24] << 24 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c61ffa2be163e1f3$var$G.SBOX[t & 0xff];
                t ^= $c61ffa2be163e1f3$var$RCON[k / keySize | 0] << 24;
            } else if (keySize > 6 && k % keySize === 4) t = $c61ffa2be163e1f3$var$G.SBOX[t >>> 24] << 24 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 16 & 0xff] << 16 | $c61ffa2be163e1f3$var$G.SBOX[t >>> 8 & 0xff] << 8 | $c61ffa2be163e1f3$var$G.SBOX[t & 0xff];
            keySchedule[k] = keySchedule[k - keySize] ^ t;
        }
        var invKeySchedule = [];
        for(var ik = 0; ik < ksRows; ik++){
            var ksR = ksRows - ik;
            var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
            if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
            else invKeySchedule[ik] = $c61ffa2be163e1f3$var$G.INV_SUB_MIX[0][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 24]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[1][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 16 & 0xff]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[2][$c61ffa2be163e1f3$var$G.SBOX[tt >>> 8 & 0xff]] ^ $c61ffa2be163e1f3$var$G.INV_SUB_MIX[3][$c61ffa2be163e1f3$var$G.SBOX[tt & 0xff]];
        }
        this._nRounds = nRounds;
        this._keySchedule = keySchedule;
        this._invKeySchedule = invKeySchedule;
    };
    $c61ffa2be163e1f3$var$AES.prototype.encryptBlockRaw = function(M) {
        M = $c61ffa2be163e1f3$var$asUInt32Array(M);
        return $c61ffa2be163e1f3$var$cryptBlock(M, this._keySchedule, $c61ffa2be163e1f3$var$G.SUB_MIX, $c61ffa2be163e1f3$var$G.SBOX, this._nRounds);
    };
    $c61ffa2be163e1f3$var$AES.prototype.encryptBlock = function(M) {
        var out = this.encryptBlockRaw(M);
        var buf = $c61ffa2be163e1f3$require$Buffer.allocUnsafe(16);
        buf.writeUInt32BE(out[0], 0);
        buf.writeUInt32BE(out[1], 4);
        buf.writeUInt32BE(out[2], 8);
        buf.writeUInt32BE(out[3], 12);
        return buf;
    };
    $c61ffa2be163e1f3$var$AES.prototype.decryptBlock = function(M) {
        M = $c61ffa2be163e1f3$var$asUInt32Array(M);
        var m1 = M[1];
        M[1] = M[3];
        M[3] = m1;
        var out = $c61ffa2be163e1f3$var$cryptBlock(M, this._invKeySchedule, $c61ffa2be163e1f3$var$G.INV_SUB_MIX, $c61ffa2be163e1f3$var$G.INV_SBOX, this._nRounds);
        var buf = $c61ffa2be163e1f3$require$Buffer.allocUnsafe(16);
        buf.writeUInt32BE(out[0], 0);
        buf.writeUInt32BE(out[3], 4);
        buf.writeUInt32BE(out[2], 8);
        buf.writeUInt32BE(out[1], 12);
        return buf;
    };
    $c61ffa2be163e1f3$var$AES.prototype.scrub = function() {
        $c61ffa2be163e1f3$var$scrubVec(this._keySchedule);
        $c61ffa2be163e1f3$var$scrubVec(this._invKeySchedule);
        $c61ffa2be163e1f3$var$scrubVec(this._key);
    };
    $c61ffa2be163e1f3$export$b80fbe1c3a2b92b5 = $c61ffa2be163e1f3$var$AES;
});
parcelRegister("3wyrd", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $290f12eeb62fc0f2$require$Buffer = $Wth4q.Buffer;
    var $290f12eeb62fc0f2$var$ZEROES = $290f12eeb62fc0f2$require$Buffer.alloc(16, 0);
    function $290f12eeb62fc0f2$var$toArray(buf) {
        return [
            buf.readUInt32BE(0),
            buf.readUInt32BE(4),
            buf.readUInt32BE(8),
            buf.readUInt32BE(12)
        ];
    }
    function $290f12eeb62fc0f2$var$fromArray(out) {
        var buf = $290f12eeb62fc0f2$require$Buffer.allocUnsafe(16);
        buf.writeUInt32BE(out[0] >>> 0, 0);
        buf.writeUInt32BE(out[1] >>> 0, 4);
        buf.writeUInt32BE(out[2] >>> 0, 8);
        buf.writeUInt32BE(out[3] >>> 0, 12);
        return buf;
    }
    function $290f12eeb62fc0f2$var$GHASH(key) {
        this.h = key;
        this.state = $290f12eeb62fc0f2$require$Buffer.alloc(16, 0);
        this.cache = $290f12eeb62fc0f2$require$Buffer.allocUnsafe(0);
    }
    $290f12eeb62fc0f2$var$GHASH.prototype.ghash = function(block) {
        var i = -1;
        while(++i < block.length)this.state[i] ^= block[i];
        this._multiply();
    };
    $290f12eeb62fc0f2$var$GHASH.prototype._multiply = function() {
        var Vi = $290f12eeb62fc0f2$var$toArray(this.h);
        var Zi = [
            0,
            0,
            0,
            0
        ];
        var j, xi, lsbVi;
        var i = -1;
        while(++i < 128){
            xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
            if (xi) {
                Zi[0] ^= Vi[0];
                Zi[1] ^= Vi[1];
                Zi[2] ^= Vi[2];
                Zi[3] ^= Vi[3];
            }
            lsbVi = (Vi[3] & 1) !== 0;
            for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
            Vi[0] = Vi[0] >>> 1;
            if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
        }
        this.state = $290f12eeb62fc0f2$var$fromArray(Zi);
    };
    $290f12eeb62fc0f2$var$GHASH.prototype.update = function(buf) {
        this.cache = $290f12eeb62fc0f2$require$Buffer.concat([
            this.cache,
            buf
        ]);
        var chunk;
        while(this.cache.length >= 16){
            chunk = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            this.ghash(chunk);
        }
    };
    $290f12eeb62fc0f2$var$GHASH.prototype.final = function(abl, bl) {
        if (this.cache.length) this.ghash($290f12eeb62fc0f2$require$Buffer.concat([
            this.cache,
            $290f12eeb62fc0f2$var$ZEROES
        ], 16));
        this.ghash($290f12eeb62fc0f2$var$fromArray([
            0,
            abl,
            0,
            bl
        ]));
        return this.state;
    };
    module.exports = $290f12eeb62fc0f2$var$GHASH;
});
parcelRegister("ecK7f", function(module, exports) {
    var $h0C5b = parcelRequire("h0C5b");
    var $Wth4q = parcelRequire("Wth4q");
    var $a575f54f3a1f9ff7$require$Buffer = $Wth4q.Buffer;
    var $77fwb = parcelRequire("77fwb");
    var $v3bBu = parcelRequire("v3bBu");
    function $a575f54f3a1f9ff7$var$StreamCipher(mode, key, iv, decrypt) {
        $77fwb.call(this);
        this._cipher = new $h0C5b.AES(key);
        this._prev = $a575f54f3a1f9ff7$require$Buffer.from(iv);
        this._cache = $a575f54f3a1f9ff7$require$Buffer.allocUnsafe(0);
        this._secCache = $a575f54f3a1f9ff7$require$Buffer.allocUnsafe(0);
        this._decrypt = decrypt;
        this._mode = mode;
    }
    $v3bBu($a575f54f3a1f9ff7$var$StreamCipher, $77fwb);
    $a575f54f3a1f9ff7$var$StreamCipher.prototype._update = function(chunk) {
        return this._mode.encrypt(this, chunk, this._decrypt);
    };
    $a575f54f3a1f9ff7$var$StreamCipher.prototype._final = function() {
        this._cipher.scrub();
    };
    module.exports = $a575f54f3a1f9ff7$var$StreamCipher;
});
parcelRegister("55KiC", function(module, exports) {
    var $Wth4q = parcelRequire("Wth4q");
    var $3b515579f6a05835$require$Buffer = $Wth4q.Buffer;
    var $8ZJxF = parcelRequire("8ZJxF");
    function $3b515579f6a05835$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
        if (!$3b515579f6a05835$require$Buffer.isBuffer(password)) password = $3b515579f6a05835$require$Buffer.from(password, 'binary');
        if (salt) {
            if (!$3b515579f6a05835$require$Buffer.isBuffer(salt)) salt = $3b515579f6a05835$require$Buffer.from(salt, 'binary');
            if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
        }
        var keyLen = keyBits / 8;
        var key = $3b515579f6a05835$require$Buffer.alloc(keyLen);
        var iv = $3b515579f6a05835$require$Buffer.alloc(ivLen || 0);
        var tmp = $3b515579f6a05835$require$Buffer.alloc(0);
        while(keyLen > 0 || ivLen > 0){
            var hash = new $8ZJxF();
            hash.update(tmp);
            hash.update(password);
            if (salt) hash.update(salt);
            tmp = hash.digest();
            var used = 0;
            if (keyLen > 0) {
                var keyStart = key.length - keyLen;
                used = Math.min(keyLen, tmp.length);
                tmp.copy(key, keyStart, 0, used);
                keyLen -= used;
            }
            if (used < tmp.length && ivLen > 0) {
                var ivStart = iv.length - ivLen;
                var length = Math.min(ivLen, tmp.length - used);
                tmp.copy(iv, ivStart, used, used + length);
                ivLen -= length;
            }
        }
        tmp.fill(0);
        return {
            key: key,
            iv: iv
        };
    }
    module.exports = $3b515579f6a05835$var$EVP_BytesToKey;
});
parcelRegister("i9P5q", function(module, exports) {
    $parcel$export(module.exports, "createDecipher", ()=>$d380b1fbce65edb7$export$12ada9414fbc594c, (v)=>$d380b1fbce65edb7$export$12ada9414fbc594c = v);
    $parcel$export(module.exports, "createDecipheriv", ()=>$d380b1fbce65edb7$export$36b6d6ef312eab39, (v)=>$d380b1fbce65edb7$export$36b6d6ef312eab39 = v);
    var $d380b1fbce65edb7$export$12ada9414fbc594c;
    var $d380b1fbce65edb7$export$36b6d6ef312eab39;
    var $dsL7z = parcelRequire("dsL7z");
    var $Wth4q = parcelRequire("Wth4q");
    var $d380b1fbce65edb7$require$Buffer = $Wth4q.Buffer;
    var $6WLno = parcelRequire("6WLno");
    var $ecK7f = parcelRequire("ecK7f");
    var $77fwb = parcelRequire("77fwb");
    var $h0C5b = parcelRequire("h0C5b");
    var $55KiC = parcelRequire("55KiC");
    var $v3bBu = parcelRequire("v3bBu");
    function $d380b1fbce65edb7$var$Decipher(mode, key, iv) {
        $77fwb.call(this);
        this._cache = new $d380b1fbce65edb7$var$Splitter();
        this._last = void 0;
        this._cipher = new $h0C5b.AES(key);
        this._prev = $d380b1fbce65edb7$require$Buffer.from(iv);
        this._mode = mode;
        this._autopadding = true;
    }
    $v3bBu($d380b1fbce65edb7$var$Decipher, $77fwb);
    $d380b1fbce65edb7$var$Decipher.prototype._update = function(data) {
        this._cache.add(data);
        var chunk;
        var thing;
        var out = [];
        while(chunk = this._cache.get(this._autopadding)){
            thing = this._mode.decrypt(this, chunk);
            out.push(thing);
        }
        return $d380b1fbce65edb7$require$Buffer.concat(out);
    };
    $d380b1fbce65edb7$var$Decipher.prototype._final = function() {
        var chunk = this._cache.flush();
        if (this._autopadding) return $d380b1fbce65edb7$var$unpad(this._mode.decrypt(this, chunk));
        else if (chunk) throw new Error('data not multiple of block length');
    };
    $d380b1fbce65edb7$var$Decipher.prototype.setAutoPadding = function(setTo) {
        this._autopadding = !!setTo;
        return this;
    };
    function $d380b1fbce65edb7$var$Splitter() {
        this.cache = $d380b1fbce65edb7$require$Buffer.allocUnsafe(0);
    }
    $d380b1fbce65edb7$var$Splitter.prototype.add = function(data) {
        this.cache = $d380b1fbce65edb7$require$Buffer.concat([
            this.cache,
            data
        ]);
    };
    $d380b1fbce65edb7$var$Splitter.prototype.get = function(autoPadding) {
        var out;
        if (autoPadding) {
            if (this.cache.length > 16) {
                out = this.cache.slice(0, 16);
                this.cache = this.cache.slice(16);
                return out;
            }
        } else if (this.cache.length >= 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
        return null;
    };
    $d380b1fbce65edb7$var$Splitter.prototype.flush = function() {
        if (this.cache.length) return this.cache;
    };
    function $d380b1fbce65edb7$var$unpad(last) {
        var padded = last[15];
        if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
        var i = -1;
        while(++i < padded){
            if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
        }
        if (padded === 16) return;
        return last.slice(0, 16 - padded);
    }
    function $d380b1fbce65edb7$var$createDecipheriv(suite, password, iv) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        if (typeof iv === 'string') iv = $d380b1fbce65edb7$require$Buffer.from(iv);
        if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
        if (typeof password === 'string') password = $d380b1fbce65edb7$require$Buffer.from(password);
        if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
        if (config.type === 'stream') return new $ecK7f(config.module, password, iv, true);
        else if (config.type === 'auth') return new $dsL7z(config.module, password, iv, true);
        return new $d380b1fbce65edb7$var$Decipher(config.module, password, iv);
    }
    function $d380b1fbce65edb7$var$createDecipher(suite, password) {
        var config = $6WLno[suite.toLowerCase()];
        if (!config) throw new TypeError('invalid suite type');
        var keys = $55KiC(password, false, config.key, config.iv);
        return $d380b1fbce65edb7$var$createDecipheriv(suite, keys.key, keys.iv);
    }
    $d380b1fbce65edb7$export$12ada9414fbc594c = $d380b1fbce65edb7$var$createDecipher;
    $d380b1fbce65edb7$export$36b6d6ef312eab39 = $d380b1fbce65edb7$var$createDecipheriv;
});
parcelRegister("dQ4TD", function(module, exports) {
    $parcel$export(module.exports, "des-ecb", ()=>$a133ee05e0543499$export$116f8a5cee447347, (v)=>$a133ee05e0543499$export$116f8a5cee447347 = v);
    $parcel$export(module.exports, "des-cbc", ()=>$a133ee05e0543499$export$7483c4066bfb7ae9, (v)=>$a133ee05e0543499$export$7483c4066bfb7ae9 = v);
    $parcel$export(module.exports, "des", ()=>$a133ee05e0543499$export$e7a565d2e588bb06, (v)=>$a133ee05e0543499$export$e7a565d2e588bb06 = v);
    $parcel$export(module.exports, "des-ede3-cbc", ()=>$a133ee05e0543499$export$aaa2f54a426f3eb8, (v)=>$a133ee05e0543499$export$aaa2f54a426f3eb8 = v);
    $parcel$export(module.exports, "des3", ()=>$a133ee05e0543499$export$eba20568dde4ada, (v)=>$a133ee05e0543499$export$eba20568dde4ada = v);
    $parcel$export(module.exports, "des-ede3", ()=>$a133ee05e0543499$export$d3b5e5996938f5ae, (v)=>$a133ee05e0543499$export$d3b5e5996938f5ae = v);
    $parcel$export(module.exports, "des-ede-cbc", ()=>$a133ee05e0543499$export$57c08356130bc99b, (v)=>$a133ee05e0543499$export$57c08356130bc99b = v);
    $parcel$export(module.exports, "des-ede", ()=>$a133ee05e0543499$export$c7169791d5c1e65d, (v)=>$a133ee05e0543499$export$c7169791d5c1e65d = v);
    var $a133ee05e0543499$export$116f8a5cee447347;
    var $a133ee05e0543499$export$7483c4066bfb7ae9;
    var $a133ee05e0543499$export$e7a565d2e588bb06;
    var $a133ee05e0543499$export$aaa2f54a426f3eb8;
    var $a133ee05e0543499$export$eba20568dde4ada;
    var $a133ee05e0543499$export$d3b5e5996938f5ae;
    var $a133ee05e0543499$export$57c08356130bc99b;
    var $a133ee05e0543499$export$c7169791d5c1e65d;
    $a133ee05e0543499$export$116f8a5cee447347 = {
        key: 8,
        iv: 0
    };
    $a133ee05e0543499$export$7483c4066bfb7ae9 = $a133ee05e0543499$export$e7a565d2e588bb06 = {
        key: 8,
        iv: 8
    };
    $a133ee05e0543499$export$aaa2f54a426f3eb8 = $a133ee05e0543499$export$eba20568dde4ada = {
        key: 24,
        iv: 8
    };
    $a133ee05e0543499$export$d3b5e5996938f5ae = {
        key: 24,
        iv: 0
    };
    $a133ee05e0543499$export$57c08356130bc99b = {
        key: 16,
        iv: 8
    };
    $a133ee05e0543499$export$c7169791d5c1e65d = {
        key: 16,
        iv: 0
    };
});
parcelRegister("ilRwV", function(module, exports) {
    $parcel$export(module.exports, "DiffieHellmanGroup", ()=>$d5c3b620b637e62c$export$971862a2fcb1bb40, (v)=>$d5c3b620b637e62c$export$971862a2fcb1bb40 = v);
    $parcel$export(module.exports, "createDiffieHellmanGroup", ()=>$d5c3b620b637e62c$export$c6ff6a88acbeaf40, (v)=>$d5c3b620b637e62c$export$c6ff6a88acbeaf40 = v);
    $parcel$export(module.exports, "getDiffieHellman", ()=>$d5c3b620b637e62c$export$fdc27893e98845cc, (v)=>$d5c3b620b637e62c$export$fdc27893e98845cc = v);
    $parcel$export(module.exports, "createDiffieHellman", ()=>$d5c3b620b637e62c$export$6671fb9a1323bed, (v)=>$d5c3b620b637e62c$export$6671fb9a1323bed = v);
    $parcel$export(module.exports, "DiffieHellman", ()=>$d5c3b620b637e62c$export$d74daf141a551db, (v)=>$d5c3b620b637e62c$export$d74daf141a551db = v);
    var $d5c3b620b637e62c$export$971862a2fcb1bb40;
    var $d5c3b620b637e62c$export$c6ff6a88acbeaf40;
    var $d5c3b620b637e62c$export$fdc27893e98845cc;
    var $d5c3b620b637e62c$export$6671fb9a1323bed;
    var $d5c3b620b637e62c$export$d74daf141a551db;
    var $5k7LC = parcelRequire("5k7LC");
    var $d5c3b620b637e62c$require$Buffer = $5k7LC.Buffer;
    var $iQ4lm = parcelRequire("iQ4lm");
    var $9TmmS = parcelRequire("9TmmS");
    var $9UDry = parcelRequire("9UDry");
    function $d5c3b620b637e62c$var$getDiffieHellman(mod) {
        var prime = new $d5c3b620b637e62c$require$Buffer($9TmmS[mod].prime, 'hex');
        var gen = new $d5c3b620b637e62c$require$Buffer($9TmmS[mod].gen, 'hex');
        return new $9UDry(prime, gen);
    }
    var $d5c3b620b637e62c$var$ENCODINGS = {
        'binary': true,
        'hex': true,
        'base64': true
    };
    function $d5c3b620b637e62c$var$createDiffieHellman(prime, enc, generator, genc) {
        if ($d5c3b620b637e62c$require$Buffer.isBuffer(enc) || $d5c3b620b637e62c$var$ENCODINGS[enc] === undefined) return $d5c3b620b637e62c$var$createDiffieHellman(prime, 'binary', enc, generator);
        enc = enc || 'binary';
        genc = genc || 'binary';
        generator = generator || new $d5c3b620b637e62c$require$Buffer([
            2
        ]);
        if (!$d5c3b620b637e62c$require$Buffer.isBuffer(generator)) generator = new $d5c3b620b637e62c$require$Buffer(generator, genc);
        if (typeof prime === 'number') return new $9UDry($iQ4lm(prime, generator), generator, true);
        if (!$d5c3b620b637e62c$require$Buffer.isBuffer(prime)) prime = new $d5c3b620b637e62c$require$Buffer(prime, enc);
        return new $9UDry(prime, generator, true);
    }
    $d5c3b620b637e62c$export$971862a2fcb1bb40 = $d5c3b620b637e62c$export$c6ff6a88acbeaf40 = $d5c3b620b637e62c$export$fdc27893e98845cc = $d5c3b620b637e62c$var$getDiffieHellman;
    $d5c3b620b637e62c$export$6671fb9a1323bed = $d5c3b620b637e62c$export$d74daf141a551db = $d5c3b620b637e62c$var$createDiffieHellman;
});
parcelRegister("iQ4lm", function(module, exports) {
    var $1DyI6 = parcelRequire("1DyI6");
    module.exports = $db7073d92ed84da3$var$findPrime;
    $db7073d92ed84da3$var$findPrime.simpleSieve = $db7073d92ed84da3$var$simpleSieve;
    $db7073d92ed84da3$var$findPrime.fermatTest = $db7073d92ed84da3$var$fermatTest;
    var $9pbIC = parcelRequire("9pbIC");
    var $db7073d92ed84da3$var$TWENTYFOUR = new $9pbIC(24);
    var $j2pYc = parcelRequire("j2pYc");
    var $db7073d92ed84da3$var$millerRabin = new $j2pYc();
    var $db7073d92ed84da3$var$ONE = new $9pbIC(1);
    var $db7073d92ed84da3$var$TWO = new $9pbIC(2);
    var $db7073d92ed84da3$var$FIVE = new $9pbIC(5);
    var $db7073d92ed84da3$var$SIXTEEN = new $9pbIC(16);
    var $db7073d92ed84da3$var$EIGHT = new $9pbIC(8);
    var $db7073d92ed84da3$var$TEN = new $9pbIC(10);
    var $db7073d92ed84da3$var$THREE = new $9pbIC(3);
    var $db7073d92ed84da3$var$SEVEN = new $9pbIC(7);
    var $db7073d92ed84da3$var$ELEVEN = new $9pbIC(11);
    var $db7073d92ed84da3$var$FOUR = new $9pbIC(4);
    var $db7073d92ed84da3$var$TWELVE = new $9pbIC(12);
    var $db7073d92ed84da3$var$primes = null;
    function $db7073d92ed84da3$var$_getPrimes() {
        if ($db7073d92ed84da3$var$primes !== null) return $db7073d92ed84da3$var$primes;
        var limit = 0x100000;
        var res = [];
        res[0] = 2;
        for(var i = 1, k = 3; k < limit; k += 2){
            var sqrt = Math.ceil(Math.sqrt(k));
            for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
            if (i !== j && res[j] <= sqrt) continue;
            res[i++] = k;
        }
        $db7073d92ed84da3$var$primes = res;
        return res;
    }
    function $db7073d92ed84da3$var$simpleSieve(p) {
        var primes = $db7073d92ed84da3$var$_getPrimes();
        for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
            if (p.cmpn(primes[i]) === 0) return true;
            else return false;
        }
        return true;
    }
    function $db7073d92ed84da3$var$fermatTest(p) {
        var red = $9pbIC.mont(p);
        return $db7073d92ed84da3$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
    }
    function $db7073d92ed84da3$var$findPrime(bits, gen) {
        if (bits < 16) {
            if (gen === 2 || gen === 5) return new $9pbIC([
                0x8c,
                0x7b
            ]);
            else return new $9pbIC([
                0x8c,
                0x27
            ]);
        }
        gen = new $9pbIC(gen);
        var num, n2;
        while(true){
            num = new $9pbIC($1DyI6(Math.ceil(bits / 8)));
            while(num.bitLength() > bits)num.ishrn(1);
            if (num.isEven()) num.iadd($db7073d92ed84da3$var$ONE);
            if (!num.testn(1)) num.iadd($db7073d92ed84da3$var$TWO);
            if (!gen.cmp($db7073d92ed84da3$var$TWO)) while(num.mod($db7073d92ed84da3$var$TWENTYFOUR).cmp($db7073d92ed84da3$var$ELEVEN))num.iadd($db7073d92ed84da3$var$FOUR);
            else if (!gen.cmp($db7073d92ed84da3$var$FIVE)) while(num.mod($db7073d92ed84da3$var$TEN).cmp($db7073d92ed84da3$var$THREE))num.iadd($db7073d92ed84da3$var$FOUR);
            n2 = num.shrn(1);
            if ($db7073d92ed84da3$var$simpleSieve(n2) && $db7073d92ed84da3$var$simpleSieve(num) && $db7073d92ed84da3$var$fermatTest(n2) && $db7073d92ed84da3$var$fermatTest(num) && $db7073d92ed84da3$var$millerRabin.test(n2) && $db7073d92ed84da3$var$millerRabin.test(num)) return num;
        }
    }
});
parcelRegister("9pbIC", function(module, exports) {
    (function(module1, exports) {
        'use strict';
        function assert(val, msg) {
            if (!val) throw new Error(msg || 'Assertion failed');
        }
        function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
        function BN(number, base, endian) {
            if (BN.isBN(number)) return number;
            this.negative = 0;
            this.words = null;
            this.length = 0;
            this.red = null;
            if (number !== null) {
                if (base === 'le' || base === 'be') {
                    endian = base;
                    base = 10;
                }
                this._init(number || 0, base || 10, endian || 'be');
            }
        }
        if (typeof module1 === 'object') module1.exports = BN;
        else exports.BN = BN;
        BN.BN = BN;
        BN.wordSize = 26;
        var Buffer;
        try {
            if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
            else Buffer = (parcelRequire("3gWwf")).Buffer;
        } catch (e) {}
        BN.isBN = function isBN(num) {
            if (num instanceof BN) return true;
            return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };
        BN.max = function max(left, right) {
            if (left.cmp(right) > 0) return left;
            return right;
        };
        BN.min = function min(left, right) {
            if (left.cmp(right) < 0) return left;
            return right;
        };
        BN.prototype._init = function init(number, base, endian) {
            if (typeof number === 'number') return this._initNumber(number, base, endian);
            if (typeof number === 'object') return this._initArray(number, base, endian);
            if (base === 'hex') base = 16;
            assert(base === (base | 0) && base >= 2 && base <= 36);
            number = number.toString().replace(/\s+/g, '');
            var start = 0;
            if (number[0] === '-') {
                start++;
                this.negative = 1;
            }
            if (start < number.length) {
                if (base === 16) this._parseHex(number, start, endian);
                else {
                    this._parseBase(number, base, start);
                    if (endian === 'le') this._initArray(this.toArray(), base, endian);
                }
            }
        };
        BN.prototype._initNumber = function _initNumber(number, base, endian) {
            if (number < 0) {
                this.negative = 1;
                number = -number;
            }
            if (number < 0x4000000) {
                this.words = [
                    number & 0x3ffffff
                ];
                this.length = 1;
            } else if (number < 0x10000000000000) {
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff
                ];
                this.length = 2;
            } else {
                assert(number < 0x20000000000000);
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff,
                    1
                ];
                this.length = 3;
            }
            if (endian !== 'le') return;
            this._initArray(this.toArray(), base, endian);
        };
        BN.prototype._initArray = function _initArray(number, base, endian) {
            assert(typeof number.length === 'number');
            if (number.length <= 0) {
                this.words = [
                    0
                ];
                this.length = 1;
                return this;
            }
            this.length = Math.ceil(number.length / 3);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var j, w;
            var off = 0;
            if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            return this.strip();
        };
        function parseHex4Bits(string, index) {
            var c = string.charCodeAt(index);
            if (c >= 65 && c <= 70) return c - 55;
            else if (c >= 97 && c <= 102) return c - 87;
            else return c - 48 & 0xf;
        }
        function parseHexByte(string, lowerBound, index) {
            var r = parseHex4Bits(string, index);
            if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
            return r;
        }
        BN.prototype._parseHex = function _parseHex(number, start, endian) {
            this.length = Math.ceil((number.length - start) / 6);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var off = 0;
            var j = 0;
            var w;
            if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
            else {
                var parseLength = number.length - start;
                for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                    w = parseHexByte(number, start, i) << off;
                    this.words[j] |= w & 0x3ffffff;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
            }
            this.strip();
        };
        function parseBase(str, start, end, mul) {
            var r = 0;
            var len = Math.min(str.length, end);
            for(var i = start; i < len; i++){
                var c = str.charCodeAt(i) - 48;
                r *= mul;
                if (c >= 49) r += c - 49 + 0xa;
                else if (c >= 17) r += c - 17 + 0xa;
                else r += c;
            }
            return r;
        }
        BN.prototype._parseBase = function _parseBase(number, base, start) {
            this.words = [
                0
            ];
            this.length = 1;
            for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
            limbLen--;
            limbPow = limbPow / base | 0;
            var total = number.length - start;
            var mod = total % limbLen;
            var end = Math.min(total, total - mod) + start;
            var word = 0;
            for(var i = start; i < end; i += limbLen){
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for(i = 0; i < mod; i++)pow *= base;
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            this.strip();
        };
        BN.prototype.copy = function copy(dest) {
            dest.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
            dest.length = this.length;
            dest.negative = this.negative;
            dest.red = this.red;
        };
        BN.prototype.clone = function clone() {
            var r = new BN(null);
            this.copy(r);
            return r;
        };
        BN.prototype._expand = function _expand(size) {
            while(this.length < size)this.words[this.length++] = 0;
            return this;
        };
        BN.prototype.strip = function strip() {
            while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
            return this._normSign();
        };
        BN.prototype._normSign = function _normSign() {
            if (this.length === 1 && this.words[0] === 0) this.negative = 0;
            return this;
        };
        BN.prototype.inspect = function inspect() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        };
        var zeros = [
            '',
            '0',
            '00',
            '000',
            '0000',
            '00000',
            '000000',
            '0000000',
            '00000000',
            '000000000',
            '0000000000',
            '00000000000',
            '000000000000',
            '0000000000000',
            '00000000000000',
            '000000000000000',
            '0000000000000000',
            '00000000000000000',
            '000000000000000000',
            '0000000000000000000',
            '00000000000000000000',
            '000000000000000000000',
            '0000000000000000000000',
            '00000000000000000000000',
            '000000000000000000000000',
            '0000000000000000000000000'
        ];
        var groupSizes = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ];
        var groupBases = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            10000000,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64000000,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            24300000,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        BN.prototype.toString = function toString(base, padding) {
            base = base || 10;
            padding = padding | 0 || 1;
            var out;
            if (base === 16 || base === 'hex') {
                out = '';
                var off = 0;
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = this.words[i];
                    var word = ((w << off | carry) & 0xffffff).toString(16);
                    carry = w >>> 24 - off & 0xffffff;
                    off += 2;
                    if (off >= 26) {
                        off -= 26;
                        i--;
                    }
                    if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                    else out = word + out;
                }
                if (carry !== 0) out = carry.toString(16) + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            if (base === (base | 0) && base >= 2 && base <= 36) {
                var groupSize = groupSizes[base];
                var groupBase = groupBases[base];
                out = '';
                var c = this.clone();
                c.negative = 0;
                while(!c.isZero()){
                    var r = c.modn(groupBase).toString(base);
                    c = c.idivn(groupBase);
                    if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                    else out = r + out;
                }
                if (this.isZero()) out = '0' + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            assert(false, 'Base should be between 2 and 36');
        };
        BN.prototype.toNumber = function toNumber() {
            var ret = this.words[0];
            if (this.length === 2) ret += this.words[1] * 0x4000000;
            else if (this.length === 3 && this.words[2] === 0x01) ret += 0x10000000000000 + this.words[1] * 0x4000000;
            else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
            return this.negative !== 0 ? -ret : ret;
        };
        BN.prototype.toJSON = function toJSON() {
            return this.toString(16);
        };
        BN.prototype.toBuffer = function toBuffer(endian, length) {
            assert(typeof Buffer !== 'undefined');
            return this.toArrayLike(Buffer, endian, length);
        };
        BN.prototype.toArray = function toArray(endian, length) {
            return this.toArrayLike(Array, endian, length);
        };
        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
            var byteLength = this.byteLength();
            var reqLength = length || Math.max(1, byteLength);
            assert(byteLength <= reqLength, 'byte array longer than desired length');
            assert(reqLength > 0, 'Requested array length <= 0');
            this.strip();
            var littleEndian = endian === 'le';
            var res = new ArrayType(reqLength);
            var b, i;
            var q = this.clone();
            if (!littleEndian) {
                for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
                for(i = 0; !q.isZero(); i++){
                    b = q.andln(0xff);
                    q.iushrn(8);
                    res[reqLength - i - 1] = b;
                }
            } else {
                for(i = 0; !q.isZero(); i++){
                    b = q.andln(0xff);
                    q.iushrn(8);
                    res[i] = b;
                }
                for(; i < reqLength; i++)res[i] = 0;
            }
            return res;
        };
        if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
        };
        else BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
                r += 13;
                t >>>= 13;
            }
            if (t >= 0x40) {
                r += 7;
                t >>>= 7;
            }
            if (t >= 0x8) {
                r += 4;
                t >>>= 4;
            }
            if (t >= 0x02) {
                r += 2;
                t >>>= 2;
            }
            return r + t;
        };
        BN.prototype._zeroBits = function _zeroBits(w) {
            if (w === 0) return 26;
            var t = w;
            var r = 0;
            if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
            }
            if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
            }
            if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
            }
            if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
            }
            if ((t & 0x1) === 0) r++;
            return r;
        };
        BN.prototype.bitLength = function bitLength() {
            var w = this.words[this.length - 1];
            var hi = this._countBits(w);
            return (this.length - 1) * 26 + hi;
        };
        function toBitArray(num) {
            var w = new Array(num.bitLength());
            for(var bit = 0; bit < w.length; bit++){
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
            }
            return w;
        }
        BN.prototype.zeroBits = function zeroBits() {
            if (this.isZero()) return 0;
            var r = 0;
            for(var i = 0; i < this.length; i++){
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
            }
            return r;
        };
        BN.prototype.byteLength = function byteLength() {
            return Math.ceil(this.bitLength() / 8);
        };
        BN.prototype.toTwos = function toTwos(width) {
            if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
            return this.clone();
        };
        BN.prototype.fromTwos = function fromTwos(width) {
            if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
            return this.clone();
        };
        BN.prototype.isNeg = function isNeg() {
            return this.negative !== 0;
        };
        BN.prototype.neg = function neg() {
            return this.clone().ineg();
        };
        BN.prototype.ineg = function ineg() {
            if (!this.isZero()) this.negative ^= 1;
            return this;
        };
        BN.prototype.iuor = function iuor(num) {
            while(this.length < num.length)this.words[this.length++] = 0;
            for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
            return this.strip();
        };
        BN.prototype.ior = function ior(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuor(num);
        };
        BN.prototype.or = function or(num) {
            if (this.length > num.length) return this.clone().ior(num);
            return num.clone().ior(this);
        };
        BN.prototype.uor = function uor(num) {
            if (this.length > num.length) return this.clone().iuor(num);
            return num.clone().iuor(this);
        };
        BN.prototype.iuand = function iuand(num) {
            var b;
            if (this.length > num.length) b = num;
            else b = this;
            for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
            this.length = b.length;
            return this.strip();
        };
        BN.prototype.iand = function iand(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuand(num);
        };
        BN.prototype.and = function and(num) {
            if (this.length > num.length) return this.clone().iand(num);
            return num.clone().iand(this);
        };
        BN.prototype.uand = function uand(num) {
            if (this.length > num.length) return this.clone().iuand(num);
            return num.clone().iuand(this);
        };
        BN.prototype.iuxor = function iuxor(num) {
            var a;
            var b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
            if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = a.length;
            return this.strip();
        };
        BN.prototype.ixor = function ixor(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuxor(num);
        };
        BN.prototype.xor = function xor(num) {
            if (this.length > num.length) return this.clone().ixor(num);
            return num.clone().ixor(this);
        };
        BN.prototype.uxor = function uxor(num) {
            if (this.length > num.length) return this.clone().iuxor(num);
            return num.clone().iuxor(this);
        };
        BN.prototype.inotn = function inotn(width) {
            assert(typeof width === 'number' && width >= 0);
            var bytesNeeded = Math.ceil(width / 26) | 0;
            var bitsLeft = width % 26;
            this._expand(bytesNeeded);
            if (bitsLeft > 0) bytesNeeded--;
            for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
            if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            return this.strip();
        };
        BN.prototype.notn = function notn(width) {
            return this.clone().inotn(width);
        };
        BN.prototype.setn = function setn(bit, val) {
            assert(typeof bit === 'number' && bit >= 0);
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            this._expand(off + 1);
            if (val) this.words[off] = this.words[off] | 1 << wbit;
            else this.words[off] = this.words[off] & ~(1 << wbit);
            return this.strip();
        };
        BN.prototype.iadd = function iadd(num) {
            var r;
            if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign();
            } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
            }
            var a, b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            this.length = a.length;
            if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++;
            } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            return this;
        };
        BN.prototype.add = function add(num) {
            var res;
            if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
            } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
            }
            if (this.length > num.length) return this.clone().iadd(num);
            return num.clone().iadd(this);
        };
        BN.prototype.isub = function isub(num) {
            if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign();
            } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
            }
            var cmp = this.cmp(num);
            if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
            }
            var a, b;
            if (cmp > 0) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = Math.max(this.length, i);
            if (a !== this) this.negative = 1;
            return this.strip();
        };
        BN.prototype.sub = function sub(num) {
            return this.clone().isub(num);
        };
        function smallMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            var len = self.length + num.length | 0;
            out.length = len;
            len = len - 1 | 0;
            var a = self.words[0] | 0;
            var b = num.words[0] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            var carry = r / 0x4000000 | 0;
            out.words[0] = lo;
            for(var k = 1; k < len; k++){
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j | 0;
                    a = self.words[i] | 0;
                    b = num.words[j] | 0;
                    r = a * b + rword;
                    ncarry += r / 0x4000000 | 0;
                    rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
            }
            if (carry !== 0) out.words[k] = carry | 0;
            else out.length--;
            return out.strip();
        }
        var comb10MulTo = function comb10MulTo(self, num, out) {
            var a = self.words;
            var b = num.words;
            var o = out.words;
            var c = 0;
            var lo;
            var mid;
            var hi;
            var a0 = a[0] | 0;
            var al0 = a0 & 0x1fff;
            var ah0 = a0 >>> 13;
            var a1 = a[1] | 0;
            var al1 = a1 & 0x1fff;
            var ah1 = a1 >>> 13;
            var a2 = a[2] | 0;
            var al2 = a2 & 0x1fff;
            var ah2 = a2 >>> 13;
            var a3 = a[3] | 0;
            var al3 = a3 & 0x1fff;
            var ah3 = a3 >>> 13;
            var a4 = a[4] | 0;
            var al4 = a4 & 0x1fff;
            var ah4 = a4 >>> 13;
            var a5 = a[5] | 0;
            var al5 = a5 & 0x1fff;
            var ah5 = a5 >>> 13;
            var a6 = a[6] | 0;
            var al6 = a6 & 0x1fff;
            var ah6 = a6 >>> 13;
            var a7 = a[7] | 0;
            var al7 = a7 & 0x1fff;
            var ah7 = a7 >>> 13;
            var a8 = a[8] | 0;
            var al8 = a8 & 0x1fff;
            var ah8 = a8 >>> 13;
            var a9 = a[9] | 0;
            var al9 = a9 & 0x1fff;
            var ah9 = a9 >>> 13;
            var b0 = b[0] | 0;
            var bl0 = b0 & 0x1fff;
            var bh0 = b0 >>> 13;
            var b1 = b[1] | 0;
            var bl1 = b1 & 0x1fff;
            var bh1 = b1 >>> 13;
            var b2 = b[2] | 0;
            var bl2 = b2 & 0x1fff;
            var bh2 = b2 >>> 13;
            var b3 = b[3] | 0;
            var bl3 = b3 & 0x1fff;
            var bh3 = b3 >>> 13;
            var b4 = b[4] | 0;
            var bl4 = b4 & 0x1fff;
            var bh4 = b4 >>> 13;
            var b5 = b[5] | 0;
            var bl5 = b5 & 0x1fff;
            var bh5 = b5 >>> 13;
            var b6 = b[6] | 0;
            var bl6 = b6 & 0x1fff;
            var bh6 = b6 >>> 13;
            var b7 = b[7] | 0;
            var bl7 = b7 & 0x1fff;
            var bh7 = b7 >>> 13;
            var b8 = b[8] | 0;
            var bl8 = b8 & 0x1fff;
            var bh8 = b8 >>> 13;
            var b9 = b[9] | 0;
            var bl9 = b9 & 0x1fff;
            var bh9 = b9 >>> 13;
            out.negative = self.negative ^ num.negative;
            out.length = 19;
            lo = Math.imul(al0, bl0);
            mid = Math.imul(al0, bh0);
            mid = mid + Math.imul(ah0, bl0) | 0;
            hi = Math.imul(ah0, bh0);
            var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
            w0 &= 0x3ffffff;
            lo = Math.imul(al1, bl0);
            mid = Math.imul(al1, bh0);
            mid = mid + Math.imul(ah1, bl0) | 0;
            hi = Math.imul(ah1, bh0);
            lo = lo + Math.imul(al0, bl1) | 0;
            mid = mid + Math.imul(al0, bh1) | 0;
            mid = mid + Math.imul(ah0, bl1) | 0;
            hi = hi + Math.imul(ah0, bh1) | 0;
            var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
            w1 &= 0x3ffffff;
            lo = Math.imul(al2, bl0);
            mid = Math.imul(al2, bh0);
            mid = mid + Math.imul(ah2, bl0) | 0;
            hi = Math.imul(ah2, bh0);
            lo = lo + Math.imul(al1, bl1) | 0;
            mid = mid + Math.imul(al1, bh1) | 0;
            mid = mid + Math.imul(ah1, bl1) | 0;
            hi = hi + Math.imul(ah1, bh1) | 0;
            lo = lo + Math.imul(al0, bl2) | 0;
            mid = mid + Math.imul(al0, bh2) | 0;
            mid = mid + Math.imul(ah0, bl2) | 0;
            hi = hi + Math.imul(ah0, bh2) | 0;
            var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
            w2 &= 0x3ffffff;
            lo = Math.imul(al3, bl0);
            mid = Math.imul(al3, bh0);
            mid = mid + Math.imul(ah3, bl0) | 0;
            hi = Math.imul(ah3, bh0);
            lo = lo + Math.imul(al2, bl1) | 0;
            mid = mid + Math.imul(al2, bh1) | 0;
            mid = mid + Math.imul(ah2, bl1) | 0;
            hi = hi + Math.imul(ah2, bh1) | 0;
            lo = lo + Math.imul(al1, bl2) | 0;
            mid = mid + Math.imul(al1, bh2) | 0;
            mid = mid + Math.imul(ah1, bl2) | 0;
            hi = hi + Math.imul(ah1, bh2) | 0;
            lo = lo + Math.imul(al0, bl3) | 0;
            mid = mid + Math.imul(al0, bh3) | 0;
            mid = mid + Math.imul(ah0, bl3) | 0;
            hi = hi + Math.imul(ah0, bh3) | 0;
            var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
            w3 &= 0x3ffffff;
            lo = Math.imul(al4, bl0);
            mid = Math.imul(al4, bh0);
            mid = mid + Math.imul(ah4, bl0) | 0;
            hi = Math.imul(ah4, bh0);
            lo = lo + Math.imul(al3, bl1) | 0;
            mid = mid + Math.imul(al3, bh1) | 0;
            mid = mid + Math.imul(ah3, bl1) | 0;
            hi = hi + Math.imul(ah3, bh1) | 0;
            lo = lo + Math.imul(al2, bl2) | 0;
            mid = mid + Math.imul(al2, bh2) | 0;
            mid = mid + Math.imul(ah2, bl2) | 0;
            hi = hi + Math.imul(ah2, bh2) | 0;
            lo = lo + Math.imul(al1, bl3) | 0;
            mid = mid + Math.imul(al1, bh3) | 0;
            mid = mid + Math.imul(ah1, bl3) | 0;
            hi = hi + Math.imul(ah1, bh3) | 0;
            lo = lo + Math.imul(al0, bl4) | 0;
            mid = mid + Math.imul(al0, bh4) | 0;
            mid = mid + Math.imul(ah0, bl4) | 0;
            hi = hi + Math.imul(ah0, bh4) | 0;
            var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
            w4 &= 0x3ffffff;
            lo = Math.imul(al5, bl0);
            mid = Math.imul(al5, bh0);
            mid = mid + Math.imul(ah5, bl0) | 0;
            hi = Math.imul(ah5, bh0);
            lo = lo + Math.imul(al4, bl1) | 0;
            mid = mid + Math.imul(al4, bh1) | 0;
            mid = mid + Math.imul(ah4, bl1) | 0;
            hi = hi + Math.imul(ah4, bh1) | 0;
            lo = lo + Math.imul(al3, bl2) | 0;
            mid = mid + Math.imul(al3, bh2) | 0;
            mid = mid + Math.imul(ah3, bl2) | 0;
            hi = hi + Math.imul(ah3, bh2) | 0;
            lo = lo + Math.imul(al2, bl3) | 0;
            mid = mid + Math.imul(al2, bh3) | 0;
            mid = mid + Math.imul(ah2, bl3) | 0;
            hi = hi + Math.imul(ah2, bh3) | 0;
            lo = lo + Math.imul(al1, bl4) | 0;
            mid = mid + Math.imul(al1, bh4) | 0;
            mid = mid + Math.imul(ah1, bl4) | 0;
            hi = hi + Math.imul(ah1, bh4) | 0;
            lo = lo + Math.imul(al0, bl5) | 0;
            mid = mid + Math.imul(al0, bh5) | 0;
            mid = mid + Math.imul(ah0, bl5) | 0;
            hi = hi + Math.imul(ah0, bh5) | 0;
            var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
            w5 &= 0x3ffffff;
            lo = Math.imul(al6, bl0);
            mid = Math.imul(al6, bh0);
            mid = mid + Math.imul(ah6, bl0) | 0;
            hi = Math.imul(ah6, bh0);
            lo = lo + Math.imul(al5, bl1) | 0;
            mid = mid + Math.imul(al5, bh1) | 0;
            mid = mid + Math.imul(ah5, bl1) | 0;
            hi = hi + Math.imul(ah5, bh1) | 0;
            lo = lo + Math.imul(al4, bl2) | 0;
            mid = mid + Math.imul(al4, bh2) | 0;
            mid = mid + Math.imul(ah4, bl2) | 0;
            hi = hi + Math.imul(ah4, bh2) | 0;
            lo = lo + Math.imul(al3, bl3) | 0;
            mid = mid + Math.imul(al3, bh3) | 0;
            mid = mid + Math.imul(ah3, bl3) | 0;
            hi = hi + Math.imul(ah3, bh3) | 0;
            lo = lo + Math.imul(al2, bl4) | 0;
            mid = mid + Math.imul(al2, bh4) | 0;
            mid = mid + Math.imul(ah2, bl4) | 0;
            hi = hi + Math.imul(ah2, bh4) | 0;
            lo = lo + Math.imul(al1, bl5) | 0;
            mid = mid + Math.imul(al1, bh5) | 0;
            mid = mid + Math.imul(ah1, bl5) | 0;
            hi = hi + Math.imul(ah1, bh5) | 0;
            lo = lo + Math.imul(al0, bl6) | 0;
            mid = mid + Math.imul(al0, bh6) | 0;
            mid = mid + Math.imul(ah0, bl6) | 0;
            hi = hi + Math.imul(ah0, bh6) | 0;
            var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
            w6 &= 0x3ffffff;
            lo = Math.imul(al7, bl0);
            mid = Math.imul(al7, bh0);
            mid = mid + Math.imul(ah7, bl0) | 0;
            hi = Math.imul(ah7, bh0);
            lo = lo + Math.imul(al6, bl1) | 0;
            mid = mid + Math.imul(al6, bh1) | 0;
            mid = mid + Math.imul(ah6, bl1) | 0;
            hi = hi + Math.imul(ah6, bh1) | 0;
            lo = lo + Math.imul(al5, bl2) | 0;
            mid = mid + Math.imul(al5, bh2) | 0;
            mid = mid + Math.imul(ah5, bl2) | 0;
            hi = hi + Math.imul(ah5, bh2) | 0;
            lo = lo + Math.imul(al4, bl3) | 0;
            mid = mid + Math.imul(al4, bh3) | 0;
            mid = mid + Math.imul(ah4, bl3) | 0;
            hi = hi + Math.imul(ah4, bh3) | 0;
            lo = lo + Math.imul(al3, bl4) | 0;
            mid = mid + Math.imul(al3, bh4) | 0;
            mid = mid + Math.imul(ah3, bl4) | 0;
            hi = hi + Math.imul(ah3, bh4) | 0;
            lo = lo + Math.imul(al2, bl5) | 0;
            mid = mid + Math.imul(al2, bh5) | 0;
            mid = mid + Math.imul(ah2, bl5) | 0;
            hi = hi + Math.imul(ah2, bh5) | 0;
            lo = lo + Math.imul(al1, bl6) | 0;
            mid = mid + Math.imul(al1, bh6) | 0;
            mid = mid + Math.imul(ah1, bl6) | 0;
            hi = hi + Math.imul(ah1, bh6) | 0;
            lo = lo + Math.imul(al0, bl7) | 0;
            mid = mid + Math.imul(al0, bh7) | 0;
            mid = mid + Math.imul(ah0, bl7) | 0;
            hi = hi + Math.imul(ah0, bh7) | 0;
            var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
            w7 &= 0x3ffffff;
            lo = Math.imul(al8, bl0);
            mid = Math.imul(al8, bh0);
            mid = mid + Math.imul(ah8, bl0) | 0;
            hi = Math.imul(ah8, bh0);
            lo = lo + Math.imul(al7, bl1) | 0;
            mid = mid + Math.imul(al7, bh1) | 0;
            mid = mid + Math.imul(ah7, bl1) | 0;
            hi = hi + Math.imul(ah7, bh1) | 0;
            lo = lo + Math.imul(al6, bl2) | 0;
            mid = mid + Math.imul(al6, bh2) | 0;
            mid = mid + Math.imul(ah6, bl2) | 0;
            hi = hi + Math.imul(ah6, bh2) | 0;
            lo = lo + Math.imul(al5, bl3) | 0;
            mid = mid + Math.imul(al5, bh3) | 0;
            mid = mid + Math.imul(ah5, bl3) | 0;
            hi = hi + Math.imul(ah5, bh3) | 0;
            lo = lo + Math.imul(al4, bl4) | 0;
            mid = mid + Math.imul(al4, bh4) | 0;
            mid = mid + Math.imul(ah4, bl4) | 0;
            hi = hi + Math.imul(ah4, bh4) | 0;
            lo = lo + Math.imul(al3, bl5) | 0;
            mid = mid + Math.imul(al3, bh5) | 0;
            mid = mid + Math.imul(ah3, bl5) | 0;
            hi = hi + Math.imul(ah3, bh5) | 0;
            lo = lo + Math.imul(al2, bl6) | 0;
            mid = mid + Math.imul(al2, bh6) | 0;
            mid = mid + Math.imul(ah2, bl6) | 0;
            hi = hi + Math.imul(ah2, bh6) | 0;
            lo = lo + Math.imul(al1, bl7) | 0;
            mid = mid + Math.imul(al1, bh7) | 0;
            mid = mid + Math.imul(ah1, bl7) | 0;
            hi = hi + Math.imul(ah1, bh7) | 0;
            lo = lo + Math.imul(al0, bl8) | 0;
            mid = mid + Math.imul(al0, bh8) | 0;
            mid = mid + Math.imul(ah0, bl8) | 0;
            hi = hi + Math.imul(ah0, bh8) | 0;
            var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
            w8 &= 0x3ffffff;
            lo = Math.imul(al9, bl0);
            mid = Math.imul(al9, bh0);
            mid = mid + Math.imul(ah9, bl0) | 0;
            hi = Math.imul(ah9, bh0);
            lo = lo + Math.imul(al8, bl1) | 0;
            mid = mid + Math.imul(al8, bh1) | 0;
            mid = mid + Math.imul(ah8, bl1) | 0;
            hi = hi + Math.imul(ah8, bh1) | 0;
            lo = lo + Math.imul(al7, bl2) | 0;
            mid = mid + Math.imul(al7, bh2) | 0;
            mid = mid + Math.imul(ah7, bl2) | 0;
            hi = hi + Math.imul(ah7, bh2) | 0;
            lo = lo + Math.imul(al6, bl3) | 0;
            mid = mid + Math.imul(al6, bh3) | 0;
            mid = mid + Math.imul(ah6, bl3) | 0;
            hi = hi + Math.imul(ah6, bh3) | 0;
            lo = lo + Math.imul(al5, bl4) | 0;
            mid = mid + Math.imul(al5, bh4) | 0;
            mid = mid + Math.imul(ah5, bl4) | 0;
            hi = hi + Math.imul(ah5, bh4) | 0;
            lo = lo + Math.imul(al4, bl5) | 0;
            mid = mid + Math.imul(al4, bh5) | 0;
            mid = mid + Math.imul(ah4, bl5) | 0;
            hi = hi + Math.imul(ah4, bh5) | 0;
            lo = lo + Math.imul(al3, bl6) | 0;
            mid = mid + Math.imul(al3, bh6) | 0;
            mid = mid + Math.imul(ah3, bl6) | 0;
            hi = hi + Math.imul(ah3, bh6) | 0;
            lo = lo + Math.imul(al2, bl7) | 0;
            mid = mid + Math.imul(al2, bh7) | 0;
            mid = mid + Math.imul(ah2, bl7) | 0;
            hi = hi + Math.imul(ah2, bh7) | 0;
            lo = lo + Math.imul(al1, bl8) | 0;
            mid = mid + Math.imul(al1, bh8) | 0;
            mid = mid + Math.imul(ah1, bl8) | 0;
            hi = hi + Math.imul(ah1, bh8) | 0;
            lo = lo + Math.imul(al0, bl9) | 0;
            mid = mid + Math.imul(al0, bh9) | 0;
            mid = mid + Math.imul(ah0, bl9) | 0;
            hi = hi + Math.imul(ah0, bh9) | 0;
            var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
            w9 &= 0x3ffffff;
            lo = Math.imul(al9, bl1);
            mid = Math.imul(al9, bh1);
            mid = mid + Math.imul(ah9, bl1) | 0;
            hi = Math.imul(ah9, bh1);
            lo = lo + Math.imul(al8, bl2) | 0;
            mid = mid + Math.imul(al8, bh2) | 0;
            mid = mid + Math.imul(ah8, bl2) | 0;
            hi = hi + Math.imul(ah8, bh2) | 0;
            lo = lo + Math.imul(al7, bl3) | 0;
            mid = mid + Math.imul(al7, bh3) | 0;
            mid = mid + Math.imul(ah7, bl3) | 0;
            hi = hi + Math.imul(ah7, bh3) | 0;
            lo = lo + Math.imul(al6, bl4) | 0;
            mid = mid + Math.imul(al6, bh4) | 0;
            mid = mid + Math.imul(ah6, bl4) | 0;
            hi = hi + Math.imul(ah6, bh4) | 0;
            lo = lo + Math.imul(al5, bl5) | 0;
            mid = mid + Math.imul(al5, bh5) | 0;
            mid = mid + Math.imul(ah5, bl5) | 0;
            hi = hi + Math.imul(ah5, bh5) | 0;
            lo = lo + Math.imul(al4, bl6) | 0;
            mid = mid + Math.imul(al4, bh6) | 0;
            mid = mid + Math.imul(ah4, bl6) | 0;
            hi = hi + Math.imul(ah4, bh6) | 0;
            lo = lo + Math.imul(al3, bl7) | 0;
            mid = mid + Math.imul(al3, bh7) | 0;
            mid = mid + Math.imul(ah3, bl7) | 0;
            hi = hi + Math.imul(ah3, bh7) | 0;
            lo = lo + Math.imul(al2, bl8) | 0;
            mid = mid + Math.imul(al2, bh8) | 0;
            mid = mid + Math.imul(ah2, bl8) | 0;
            hi = hi + Math.imul(ah2, bh8) | 0;
            lo = lo + Math.imul(al1, bl9) | 0;
            mid = mid + Math.imul(al1, bh9) | 0;
            mid = mid + Math.imul(ah1, bl9) | 0;
            hi = hi + Math.imul(ah1, bh9) | 0;
            var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
            w10 &= 0x3ffffff;
            lo = Math.imul(al9, bl2);
            mid = Math.imul(al9, bh2);
            mid = mid + Math.imul(ah9, bl2) | 0;
            hi = Math.imul(ah9, bh2);
            lo = lo + Math.imul(al8, bl3) | 0;
            mid = mid + Math.imul(al8, bh3) | 0;
            mid = mid + Math.imul(ah8, bl3) | 0;
            hi = hi + Math.imul(ah8, bh3) | 0;
            lo = lo + Math.imul(al7, bl4) | 0;
            mid = mid + Math.imul(al7, bh4) | 0;
            mid = mid + Math.imul(ah7, bl4) | 0;
            hi = hi + Math.imul(ah7, bh4) | 0;
            lo = lo + Math.imul(al6, bl5) | 0;
            mid = mid + Math.imul(al6, bh5) | 0;
            mid = mid + Math.imul(ah6, bl5) | 0;
            hi = hi + Math.imul(ah6, bh5) | 0;
            lo = lo + Math.imul(al5, bl6) | 0;
            mid = mid + Math.imul(al5, bh6) | 0;
            mid = mid + Math.imul(ah5, bl6) | 0;
            hi = hi + Math.imul(ah5, bh6) | 0;
            lo = lo + Math.imul(al4, bl7) | 0;
            mid = mid + Math.imul(al4, bh7) | 0;
            mid = mid + Math.imul(ah4, bl7) | 0;
            hi = hi + Math.imul(ah4, bh7) | 0;
            lo = lo + Math.imul(al3, bl8) | 0;
            mid = mid + Math.imul(al3, bh8) | 0;
            mid = mid + Math.imul(ah3, bl8) | 0;
            hi = hi + Math.imul(ah3, bh8) | 0;
            lo = lo + Math.imul(al2, bl9) | 0;
            mid = mid + Math.imul(al2, bh9) | 0;
            mid = mid + Math.imul(ah2, bl9) | 0;
            hi = hi + Math.imul(ah2, bh9) | 0;
            var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
            w11 &= 0x3ffffff;
            lo = Math.imul(al9, bl3);
            mid = Math.imul(al9, bh3);
            mid = mid + Math.imul(ah9, bl3) | 0;
            hi = Math.imul(ah9, bh3);
            lo = lo + Math.imul(al8, bl4) | 0;
            mid = mid + Math.imul(al8, bh4) | 0;
            mid = mid + Math.imul(ah8, bl4) | 0;
            hi = hi + Math.imul(ah8, bh4) | 0;
            lo = lo + Math.imul(al7, bl5) | 0;
            mid = mid + Math.imul(al7, bh5) | 0;
            mid = mid + Math.imul(ah7, bl5) | 0;
            hi = hi + Math.imul(ah7, bh5) | 0;
            lo = lo + Math.imul(al6, bl6) | 0;
            mid = mid + Math.imul(al6, bh6) | 0;
            mid = mid + Math.imul(ah6, bl6) | 0;
            hi = hi + Math.imul(ah6, bh6) | 0;
            lo = lo + Math.imul(al5, bl7) | 0;
            mid = mid + Math.imul(al5, bh7) | 0;
            mid = mid + Math.imul(ah5, bl7) | 0;
            hi = hi + Math.imul(ah5, bh7) | 0;
            lo = lo + Math.imul(al4, bl8) | 0;
            mid = mid + Math.imul(al4, bh8) | 0;
            mid = mid + Math.imul(ah4, bl8) | 0;
            hi = hi + Math.imul(ah4, bh8) | 0;
            lo = lo + Math.imul(al3, bl9) | 0;
            mid = mid + Math.imul(al3, bh9) | 0;
            mid = mid + Math.imul(ah3, bl9) | 0;
            hi = hi + Math.imul(ah3, bh9) | 0;
            var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
            w12 &= 0x3ffffff;
            lo = Math.imul(al9, bl4);
            mid = Math.imul(al9, bh4);
            mid = mid + Math.imul(ah9, bl4) | 0;
            hi = Math.imul(ah9, bh4);
            lo = lo + Math.imul(al8, bl5) | 0;
            mid = mid + Math.imul(al8, bh5) | 0;
            mid = mid + Math.imul(ah8, bl5) | 0;
            hi = hi + Math.imul(ah8, bh5) | 0;
            lo = lo + Math.imul(al7, bl6) | 0;
            mid = mid + Math.imul(al7, bh6) | 0;
            mid = mid + Math.imul(ah7, bl6) | 0;
            hi = hi + Math.imul(ah7, bh6) | 0;
            lo = lo + Math.imul(al6, bl7) | 0;
            mid = mid + Math.imul(al6, bh7) | 0;
            mid = mid + Math.imul(ah6, bl7) | 0;
            hi = hi + Math.imul(ah6, bh7) | 0;
            lo = lo + Math.imul(al5, bl8) | 0;
            mid = mid + Math.imul(al5, bh8) | 0;
            mid = mid + Math.imul(ah5, bl8) | 0;
            hi = hi + Math.imul(ah5, bh8) | 0;
            lo = lo + Math.imul(al4, bl9) | 0;
            mid = mid + Math.imul(al4, bh9) | 0;
            mid = mid + Math.imul(ah4, bl9) | 0;
            hi = hi + Math.imul(ah4, bh9) | 0;
            var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
            w13 &= 0x3ffffff;
            lo = Math.imul(al9, bl5);
            mid = Math.imul(al9, bh5);
            mid = mid + Math.imul(ah9, bl5) | 0;
            hi = Math.imul(ah9, bh5);
            lo = lo + Math.imul(al8, bl6) | 0;
            mid = mid + Math.imul(al8, bh6) | 0;
            mid = mid + Math.imul(ah8, bl6) | 0;
            hi = hi + Math.imul(ah8, bh6) | 0;
            lo = lo + Math.imul(al7, bl7) | 0;
            mid = mid + Math.imul(al7, bh7) | 0;
            mid = mid + Math.imul(ah7, bl7) | 0;
            hi = hi + Math.imul(ah7, bh7) | 0;
            lo = lo + Math.imul(al6, bl8) | 0;
            mid = mid + Math.imul(al6, bh8) | 0;
            mid = mid + Math.imul(ah6, bl8) | 0;
            hi = hi + Math.imul(ah6, bh8) | 0;
            lo = lo + Math.imul(al5, bl9) | 0;
            mid = mid + Math.imul(al5, bh9) | 0;
            mid = mid + Math.imul(ah5, bl9) | 0;
            hi = hi + Math.imul(ah5, bh9) | 0;
            var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
            w14 &= 0x3ffffff;
            lo = Math.imul(al9, bl6);
            mid = Math.imul(al9, bh6);
            mid = mid + Math.imul(ah9, bl6) | 0;
            hi = Math.imul(ah9, bh6);
            lo = lo + Math.imul(al8, bl7) | 0;
            mid = mid + Math.imul(al8, bh7) | 0;
            mid = mid + Math.imul(ah8, bl7) | 0;
            hi = hi + Math.imul(ah8, bh7) | 0;
            lo = lo + Math.imul(al7, bl8) | 0;
            mid = mid + Math.imul(al7, bh8) | 0;
            mid = mid + Math.imul(ah7, bl8) | 0;
            hi = hi + Math.imul(ah7, bh8) | 0;
            lo = lo + Math.imul(al6, bl9) | 0;
            mid = mid + Math.imul(al6, bh9) | 0;
            mid = mid + Math.imul(ah6, bl9) | 0;
            hi = hi + Math.imul(ah6, bh9) | 0;
            var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
            w15 &= 0x3ffffff;
            lo = Math.imul(al9, bl7);
            mid = Math.imul(al9, bh7);
            mid = mid + Math.imul(ah9, bl7) | 0;
            hi = Math.imul(ah9, bh7);
            lo = lo + Math.imul(al8, bl8) | 0;
            mid = mid + Math.imul(al8, bh8) | 0;
            mid = mid + Math.imul(ah8, bl8) | 0;
            hi = hi + Math.imul(ah8, bh8) | 0;
            lo = lo + Math.imul(al7, bl9) | 0;
            mid = mid + Math.imul(al7, bh9) | 0;
            mid = mid + Math.imul(ah7, bl9) | 0;
            hi = hi + Math.imul(ah7, bh9) | 0;
            var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
            w16 &= 0x3ffffff;
            lo = Math.imul(al9, bl8);
            mid = Math.imul(al9, bh8);
            mid = mid + Math.imul(ah9, bl8) | 0;
            hi = Math.imul(ah9, bh8);
            lo = lo + Math.imul(al8, bl9) | 0;
            mid = mid + Math.imul(al8, bh9) | 0;
            mid = mid + Math.imul(ah8, bl9) | 0;
            hi = hi + Math.imul(ah8, bh9) | 0;
            var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
            w17 &= 0x3ffffff;
            lo = Math.imul(al9, bl9);
            mid = Math.imul(al9, bh9);
            mid = mid + Math.imul(ah9, bl9) | 0;
            hi = Math.imul(ah9, bh9);
            var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
            w18 &= 0x3ffffff;
            o[0] = w0;
            o[1] = w1;
            o[2] = w2;
            o[3] = w3;
            o[4] = w4;
            o[5] = w5;
            o[6] = w6;
            o[7] = w7;
            o[8] = w8;
            o[9] = w9;
            o[10] = w10;
            o[11] = w11;
            o[12] = w12;
            o[13] = w13;
            o[14] = w14;
            o[15] = w15;
            o[16] = w16;
            o[17] = w17;
            o[18] = w18;
            if (c !== 0) {
                o[19] = c;
                out.length++;
            }
            return out;
        };
        if (!Math.imul) comb10MulTo = smallMulTo;
        function bigMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            out.length = self.length + num.length;
            var carry = 0;
            var hncarry = 0;
            for(var k = 0; k < out.length - 1; k++){
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j;
                    var a = self.words[i] | 0;
                    var b = num.words[j] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                    lo = lo + rword | 0;
                    rword = lo & 0x3ffffff;
                    ncarry = ncarry + (lo >>> 26) | 0;
                    hncarry += ncarry >>> 26;
                    ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
            }
            if (carry !== 0) out.words[k] = carry;
            else out.length--;
            return out.strip();
        }
        function jumboMulTo(self, num, out) {
            var fftm = new FFTM();
            return fftm.mulp(self, num, out);
        }
        BN.prototype.mulTo = function mulTo(num, out) {
            var res;
            var len = this.length + num.length;
            if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
            else if (len < 63) res = smallMulTo(this, num, out);
            else if (len < 1024) res = bigMulTo(this, num, out);
            else res = jumboMulTo(this, num, out);
            return res;
        };
        function FFTM(x, y) {
            this.x = x;
            this.y = y;
        }
        FFTM.prototype.makeRBT = function makeRBT(N) {
            var t = new Array(N);
            var l = BN.prototype._countBits(N) - 1;
            for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
            return t;
        };
        FFTM.prototype.revBin = function revBin(x, l, N) {
            if (x === 0 || x === N - 1) return x;
            var rb = 0;
            for(var i = 0; i < l; i++){
                rb |= (x & 1) << l - i - 1;
                x >>= 1;
            }
            return rb;
        };
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
            for(var i = 0; i < N; i++){
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
            }
        };
        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
            this.permute(rbt, rws, iws, rtws, itws, N);
            for(var s = 1; s < N; s <<= 1){
                var l = s << 1;
                var rtwdf = Math.cos(2 * Math.PI / l);
                var itwdf = Math.sin(2 * Math.PI / l);
                for(var p = 0; p < N; p += l){
                    var rtwdf_ = rtwdf;
                    var itwdf_ = itwdf;
                    for(var j = 0; j < s; j++){
                        var re = rtws[p + j];
                        var ie = itws[p + j];
                        var ro = rtws[p + j + s];
                        var io = itws[p + j + s];
                        var rx = rtwdf_ * ro - itwdf_ * io;
                        io = rtwdf_ * io + itwdf_ * ro;
                        ro = rx;
                        rtws[p + j] = re + ro;
                        itws[p + j] = ie + io;
                        rtws[p + j + s] = re - ro;
                        itws[p + j + s] = ie - io;
                        if (j !== l) {
                            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                            rtwdf_ = rx;
                        }
                    }
                }
            }
        };
        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
            var N = Math.max(m, n) | 1;
            var odd = N & 1;
            var i = 0;
            for(N = N / 2 | 0; N; N = N >>> 1)i++;
            return 1 << i + 1 + odd;
        };
        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
            if (N <= 1) return;
            for(var i = 0; i < N / 2; i++){
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
            }
        };
        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
            var carry = 0;
            for(var i = 0; i < N / 2; i++){
                var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) carry = 0;
                else carry = w / 0x4000000 | 0;
            }
            return ws;
        };
        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
            var carry = 0;
            for(var i = 0; i < len; i++){
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
            }
            for(i = 2 * len; i < N; ++i)rws[i] = 0;
            assert(carry === 0);
            assert((carry & -8192) === 0);
        };
        FFTM.prototype.stub = function stub(N) {
            var ph = new Array(N);
            for(var i = 0; i < N; i++)ph[i] = 0;
            return ph;
        };
        FFTM.prototype.mulp = function mulp(x, y, out) {
            var N = 2 * this.guessLen13b(x.length, y.length);
            var rbt = this.makeRBT(N);
            var _ = this.stub(N);
            var rws = new Array(N);
            var rwst = new Array(N);
            var iwst = new Array(N);
            var nrws = new Array(N);
            var nrwst = new Array(N);
            var niwst = new Array(N);
            var rmws = out.words;
            rmws.length = N;
            this.convert13b(x.words, x.length, rws, N);
            this.convert13b(y.words, y.length, nrws, N);
            this.transform(rws, _, rwst, iwst, N, rbt);
            this.transform(nrws, _, nrwst, niwst, N, rbt);
            for(var i = 0; i < N; i++){
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
            }
            this.conjugate(rwst, iwst, N);
            this.transform(rwst, iwst, rmws, _, N, rbt);
            this.conjugate(rmws, _, N);
            this.normalize13b(rmws, N);
            out.negative = x.negative ^ y.negative;
            out.length = x.length + y.length;
            return out.strip();
        };
        BN.prototype.mul = function mul(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return this.mulTo(num, out);
        };
        BN.prototype.mulf = function mulf(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return jumboMulTo(this, num, out);
        };
        BN.prototype.imul = function imul(num) {
            return this.clone().mulTo(num, this);
        };
        BN.prototype.imuln = function imuln(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += w / 0x4000000 | 0;
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.muln = function muln(num) {
            return this.clone().imuln(num);
        };
        BN.prototype.sqr = function sqr() {
            return this.mul(this);
        };
        BN.prototype.isqr = function isqr() {
            return this.imul(this.clone());
        };
        BN.prototype.pow = function pow(num) {
            var w = toBitArray(num);
            if (w.length === 0) return new BN(1);
            var res = this;
            for(var i = 0; i < w.length; i++, res = res.sqr()){
                if (w[i] !== 0) break;
            }
            if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                if (w[i] === 0) continue;
                res = res.mul(q);
            }
            return res;
        };
        BN.prototype.iushln = function iushln(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
            var i;
            if (r !== 0) {
                var carry = 0;
                for(i = 0; i < this.length; i++){
                    var newCarry = this.words[i] & carryMask;
                    var c = (this.words[i] | 0) - newCarry << r;
                    this.words[i] = c | carry;
                    carry = newCarry >>> 26 - r;
                }
                if (carry) {
                    this.words[i] = carry;
                    this.length++;
                }
            }
            if (s !== 0) {
                for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                for(i = 0; i < s; i++)this.words[i] = 0;
                this.length += s;
            }
            return this.strip();
        };
        BN.prototype.ishln = function ishln(bits) {
            assert(this.negative === 0);
            return this.iushln(bits);
        };
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
            assert(typeof bits === 'number' && bits >= 0);
            var h;
            if (hint) h = (hint - hint % 26) / 26;
            else h = 0;
            var r = bits % 26;
            var s = Math.min((bits - r) / 26, this.length);
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            var maskedWords = extended;
            h -= s;
            h = Math.max(0, h);
            if (maskedWords) {
                for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                maskedWords.length = s;
            }
            if (s === 0) ;
            else if (this.length > s) {
                this.length -= s;
                for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
            } else {
                this.words[0] = 0;
                this.length = 1;
            }
            var carry = 0;
            for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                var word = this.words[i] | 0;
                this.words[i] = carry << 26 - r | word >>> r;
                carry = word & mask;
            }
            if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
            if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
            }
            return this.strip();
        };
        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
            assert(this.negative === 0);
            return this.iushrn(bits, hint, extended);
        };
        BN.prototype.shln = function shln(bits) {
            return this.clone().ishln(bits);
        };
        BN.prototype.ushln = function ushln(bits) {
            return this.clone().iushln(bits);
        };
        BN.prototype.shrn = function shrn(bits) {
            return this.clone().ishrn(bits);
        };
        BN.prototype.ushrn = function ushrn(bits) {
            return this.clone().iushrn(bits);
        };
        BN.prototype.testn = function testn(bit) {
            assert(typeof bit === 'number' && bit >= 0);
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) return false;
            var w = this.words[s];
            return !!(w & q);
        };
        BN.prototype.imaskn = function imaskn(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            assert(this.negative === 0, 'imaskn works only with positive numbers');
            if (this.length <= s) return this;
            if (r !== 0) s++;
            this.length = Math.min(s, this.length);
            if (r !== 0) {
                var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                this.words[this.length - 1] &= mask;
            }
            return this.strip();
        };
        BN.prototype.maskn = function maskn(bits) {
            return this.clone().imaskn(bits);
        };
        BN.prototype.iaddn = function iaddn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.isubn(-num);
            if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) < num) {
                    this.words[0] = num - (this.words[0] | 0);
                    this.negative = 0;
                    return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
            }
            return this._iaddn(num);
        };
        BN.prototype._iaddn = function _iaddn(num) {
            this.words[0] += num;
            for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) this.words[i + 1] = 1;
                else this.words[i + 1]++;
            }
            this.length = Math.max(this.length, i + 1);
            return this;
        };
        BN.prototype.isubn = function isubn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.iaddn(-num);
            if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
            }
            this.words[0] -= num;
            if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
            } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                this.words[i] += 0x4000000;
                this.words[i + 1] -= 1;
            }
            return this.strip();
        };
        BN.prototype.addn = function addn(num) {
            return this.clone().iaddn(num);
        };
        BN.prototype.subn = function subn(num) {
            return this.clone().isubn(num);
        };
        BN.prototype.iabs = function iabs() {
            this.negative = 0;
            return this;
        };
        BN.prototype.abs = function abs() {
            return this.clone().iabs();
        };
        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
            var len = num.length + shift;
            var i;
            this._expand(len);
            var w;
            var carry = 0;
            for(i = 0; i < num.length; i++){
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - (right / 0x4000000 | 0);
                this.words[i + shift] = w & 0x3ffffff;
            }
            for(; i < this.length - shift; i++){
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
            }
            if (carry === 0) return this.strip();
            assert(carry === -1);
            carry = 0;
            for(i = 0; i < this.length; i++){
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
            }
            this.negative = 1;
            return this.strip();
        };
        BN.prototype._wordDiv = function _wordDiv(num, mode) {
            var shift = this.length - num.length;
            var a = this.clone();
            var b = num;
            var bhi = b.words[b.length - 1] | 0;
            var bhiBits = this._countBits(bhi);
            shift = 26 - bhiBits;
            if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
            }
            var m = a.length - b.length;
            var q;
            if (mode !== 'mod') {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for(var i = 0; i < q.length; i++)q.words[i] = 0;
            }
            var diff = a.clone()._ishlnsubmul(b, 1, m);
            if (diff.negative === 0) {
                a = diff;
                if (q) q.words[m] = 1;
            }
            for(var j = m - 1; j >= 0; j--){
                var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                qj = Math.min(qj / bhi | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while(a.negative !== 0){
                    qj--;
                    a.negative = 0;
                    a._ishlnsubmul(b, 1, j);
                    if (!a.isZero()) a.negative ^= 1;
                }
                if (q) q.words[j] = qj;
            }
            if (q) q.strip();
            a.strip();
            if (mode !== 'div' && shift !== 0) a.iushrn(shift);
            return {
                div: q || null,
                mod: a
            };
        };
        BN.prototype.divmod = function divmod(num, mode, positive) {
            assert(!num.isZero());
            if (this.isZero()) return {
                div: new BN(0),
                mod: new BN(0)
            };
            var div, mod, res;
            if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== 'mod') div = res.div.neg();
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.iadd(num);
                }
                return {
                    div: div,
                    mod: mod
                };
            }
            if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== 'mod') div = res.div.neg();
                return {
                    div: div,
                    mod: res.mod
                };
            }
            if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.isub(num);
                }
                return {
                    div: res.div,
                    mod: mod
                };
            }
            if (num.length > this.length || this.cmp(num) < 0) return {
                div: new BN(0),
                mod: this
            };
            if (num.length === 1) {
                if (mode === 'div') return {
                    div: this.divn(num.words[0]),
                    mod: null
                };
                if (mode === 'mod') return {
                    div: null,
                    mod: new BN(this.modn(num.words[0]))
                };
                return {
                    div: this.divn(num.words[0]),
                    mod: new BN(this.modn(num.words[0]))
                };
            }
            return this._wordDiv(num, mode);
        };
        BN.prototype.div = function div(num) {
            return this.divmod(num, 'div', false).div;
        };
        BN.prototype.mod = function mod(num) {
            return this.divmod(num, 'mod', false).mod;
        };
        BN.prototype.umod = function umod(num) {
            return this.divmod(num, 'mod', true).mod;
        };
        BN.prototype.divRound = function divRound(num) {
            var dm = this.divmod(num);
            if (dm.mod.isZero()) return dm.div;
            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
            var half = num.ushrn(1);
            var r2 = num.andln(1);
            var cmp = mod.cmp(half);
            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };
        BN.prototype.modn = function modn(num) {
            assert(num <= 0x3ffffff);
            var p = 67108864 % num;
            var acc = 0;
            for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
            return acc;
        };
        BN.prototype.idivn = function idivn(num) {
            assert(num <= 0x3ffffff);
            var carry = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = w / num | 0;
                carry = w % num;
            }
            return this.strip();
        };
        BN.prototype.divn = function divn(num) {
            return this.clone().idivn(num);
        };
        BN.prototype.egcd = function egcd(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var x = this;
            var y = p.clone();
            if (x.negative !== 0) x = x.umod(p);
            else x = x.clone();
            var A = new BN(1);
            var B = new BN(0);
            var C = new BN(0);
            var D = new BN(1);
            var g = 0;
            while(x.isEven() && y.isEven()){
                x.iushrn(1);
                y.iushrn(1);
                ++g;
            }
            var yp = y.clone();
            var xp = x.clone();
            while(!x.isZero()){
                for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    x.iushrn(i);
                    while(i-- > 0){
                        if (A.isOdd() || B.isOdd()) {
                            A.iadd(yp);
                            B.isub(xp);
                        }
                        A.iushrn(1);
                        B.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    y.iushrn(j);
                    while(j-- > 0){
                        if (C.isOdd() || D.isOdd()) {
                            C.iadd(yp);
                            D.isub(xp);
                        }
                        C.iushrn(1);
                        D.iushrn(1);
                    }
                }
                if (x.cmp(y) >= 0) {
                    x.isub(y);
                    A.isub(C);
                    B.isub(D);
                } else {
                    y.isub(x);
                    C.isub(A);
                    D.isub(B);
                }
            }
            return {
                a: C,
                b: D,
                gcd: y.iushln(g)
            };
        };
        BN.prototype._invmp = function _invmp(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var a = this;
            var b = p.clone();
            if (a.negative !== 0) a = a.umod(p);
            else a = a.clone();
            var x1 = new BN(1);
            var x2 = new BN(0);
            var delta = b.clone();
            while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    a.iushrn(i);
                    while(i-- > 0){
                        if (x1.isOdd()) x1.iadd(delta);
                        x1.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    b.iushrn(j);
                    while(j-- > 0){
                        if (x2.isOdd()) x2.iadd(delta);
                        x2.iushrn(1);
                    }
                }
                if (a.cmp(b) >= 0) {
                    a.isub(b);
                    x1.isub(x2);
                } else {
                    b.isub(a);
                    x2.isub(x1);
                }
            }
            var res;
            if (a.cmpn(1) === 0) res = x1;
            else res = x2;
            if (res.cmpn(0) < 0) res.iadd(p);
            return res;
        };
        BN.prototype.gcd = function gcd(num) {
            if (this.isZero()) return num.abs();
            if (num.isZero()) return this.abs();
            var a = this.clone();
            var b = num.clone();
            a.negative = 0;
            b.negative = 0;
            for(var shift = 0; a.isEven() && b.isEven(); shift++){
                a.iushrn(1);
                b.iushrn(1);
            }
            do {
                while(a.isEven())a.iushrn(1);
                while(b.isEven())b.iushrn(1);
                var r = a.cmp(b);
                if (r < 0) {
                    var t = a;
                    a = b;
                    b = t;
                } else if (r === 0 || b.cmpn(1) === 0) break;
                a.isub(b);
            }while (true)
            return b.iushln(shift);
        };
        BN.prototype.invm = function invm(num) {
            return this.egcd(num).a.umod(num);
        };
        BN.prototype.isEven = function isEven() {
            return (this.words[0] & 1) === 0;
        };
        BN.prototype.isOdd = function isOdd() {
            return (this.words[0] & 1) === 1;
        };
        BN.prototype.andln = function andln(num) {
            return this.words[0] & num;
        };
        BN.prototype.bincn = function bincn(bit) {
            assert(typeof bit === 'number');
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
            }
            var carry = q;
            for(var i = s; carry !== 0 && i < this.length; i++){
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.isZero = function isZero() {
            return this.length === 1 && this.words[0] === 0;
        };
        BN.prototype.cmpn = function cmpn(num) {
            var negative = num < 0;
            if (this.negative !== 0 && !negative) return -1;
            if (this.negative === 0 && negative) return 1;
            this.strip();
            var res;
            if (this.length > 1) res = 1;
            else {
                if (negative) num = -num;
                assert(num <= 0x3ffffff, 'Number is too big');
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
            }
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.cmp = function cmp(num) {
            if (this.negative !== 0 && num.negative === 0) return -1;
            if (this.negative === 0 && num.negative !== 0) return 1;
            var res = this.ucmp(num);
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.ucmp = function ucmp(num) {
            if (this.length > num.length) return 1;
            if (this.length < num.length) return -1;
            var res = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) res = -1;
                else if (a > b) res = 1;
                break;
            }
            return res;
        };
        BN.prototype.gtn = function gtn(num) {
            return this.cmpn(num) === 1;
        };
        BN.prototype.gt = function gt(num) {
            return this.cmp(num) === 1;
        };
        BN.prototype.gten = function gten(num) {
            return this.cmpn(num) >= 0;
        };
        BN.prototype.gte = function gte(num) {
            return this.cmp(num) >= 0;
        };
        BN.prototype.ltn = function ltn(num) {
            return this.cmpn(num) === -1;
        };
        BN.prototype.lt = function lt(num) {
            return this.cmp(num) === -1;
        };
        BN.prototype.lten = function lten(num) {
            return this.cmpn(num) <= 0;
        };
        BN.prototype.lte = function lte(num) {
            return this.cmp(num) <= 0;
        };
        BN.prototype.eqn = function eqn(num) {
            return this.cmpn(num) === 0;
        };
        BN.prototype.eq = function eq(num) {
            return this.cmp(num) === 0;
        };
        BN.red = function red(num) {
            return new Red(num);
        };
        BN.prototype.toRed = function toRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            assert(this.negative === 0, 'red works only with positives');
            return ctx.convertTo(this)._forceRed(ctx);
        };
        BN.prototype.fromRed = function fromRed() {
            assert(this.red, 'fromRed works only with numbers in reduction context');
            return this.red.convertFrom(this);
        };
        BN.prototype._forceRed = function _forceRed(ctx) {
            this.red = ctx;
            return this;
        };
        BN.prototype.forceRed = function forceRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            return this._forceRed(ctx);
        };
        BN.prototype.redAdd = function redAdd(num) {
            assert(this.red, 'redAdd works only with red numbers');
            return this.red.add(this, num);
        };
        BN.prototype.redIAdd = function redIAdd(num) {
            assert(this.red, 'redIAdd works only with red numbers');
            return this.red.iadd(this, num);
        };
        BN.prototype.redSub = function redSub(num) {
            assert(this.red, 'redSub works only with red numbers');
            return this.red.sub(this, num);
        };
        BN.prototype.redISub = function redISub(num) {
            assert(this.red, 'redISub works only with red numbers');
            return this.red.isub(this, num);
        };
        BN.prototype.redShl = function redShl(num) {
            assert(this.red, 'redShl works only with red numbers');
            return this.red.shl(this, num);
        };
        BN.prototype.redMul = function redMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.mul(this, num);
        };
        BN.prototype.redIMul = function redIMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.imul(this, num);
        };
        BN.prototype.redSqr = function redSqr() {
            assert(this.red, 'redSqr works only with red numbers');
            this.red._verify1(this);
            return this.red.sqr(this);
        };
        BN.prototype.redISqr = function redISqr() {
            assert(this.red, 'redISqr works only with red numbers');
            this.red._verify1(this);
            return this.red.isqr(this);
        };
        BN.prototype.redSqrt = function redSqrt() {
            assert(this.red, 'redSqrt works only with red numbers');
            this.red._verify1(this);
            return this.red.sqrt(this);
        };
        BN.prototype.redInvm = function redInvm() {
            assert(this.red, 'redInvm works only with red numbers');
            this.red._verify1(this);
            return this.red.invm(this);
        };
        BN.prototype.redNeg = function redNeg() {
            assert(this.red, 'redNeg works only with red numbers');
            this.red._verify1(this);
            return this.red.neg(this);
        };
        BN.prototype.redPow = function redPow(num) {
            assert(this.red && !num.red, 'redPow(normalNum)');
            this.red._verify1(this);
            return this.red.pow(this, num);
        };
        var primes = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function MPrime(name, p) {
            this.name = name;
            this.p = new BN(p, 16);
            this.n = this.p.bitLength();
            this.k = new BN(1).iushln(this.n).isub(this.p);
            this.tmp = this._tmp();
        }
        MPrime.prototype._tmp = function _tmp() {
            var tmp = new BN(null);
            tmp.words = new Array(Math.ceil(this.n / 13));
            return tmp;
        };
        MPrime.prototype.ireduce = function ireduce(num) {
            var r = num;
            var rlen;
            do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
            }while (rlen > this.n)
            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
            if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
            } else if (cmp > 0) r.isub(this.p);
            else if (r.strip !== undefined) r.strip();
            else r._strip();
            return r;
        };
        MPrime.prototype.split = function split(input, out) {
            input.iushrn(this.n, 0, out);
        };
        MPrime.prototype.imulK = function imulK(num) {
            return num.imul(this.k);
        };
        function K256() {
            MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);
        K256.prototype.split = function split(input, output) {
            var mask = 0x3fffff;
            var outLen = Math.min(input.length, 9);
            for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
            output.length = outLen;
            if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
            }
            var prev = input.words[9];
            output.words[output.length++] = prev & mask;
            for(i = 10; i < input.length; i++){
                var next = input.words[i] | 0;
                input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                prev = next;
            }
            prev >>>= 22;
            input.words[i - 10] = prev;
            if (prev === 0 && input.length > 10) input.length -= 10;
            else input.length -= 9;
        };
        K256.prototype.imulK = function imulK(num) {
            num.words[num.length] = 0;
            num.words[num.length + 1] = 0;
            num.length += 2;
            var lo = 0;
            for(var i = 0; i < num.length; i++){
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + (lo / 0x4000000 | 0);
            }
            if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) num.length--;
            }
            return num;
        };
        function P224() {
            MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);
        function P192() {
            MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);
        function P25519() {
            MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);
        P25519.prototype.imulK = function imulK(num) {
            var carry = 0;
            for(var i = 0; i < num.length; i++){
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
            }
            if (carry !== 0) num.words[num.length++] = carry;
            return num;
        };
        BN._prime = function prime(name) {
            if (primes[name]) return primes[name];
            var prime;
            if (name === 'k256') prime = new K256();
            else if (name === 'p224') prime = new P224();
            else if (name === 'p192') prime = new P192();
            else if (name === 'p25519') prime = new P25519();
            else throw new Error('Unknown prime ' + name);
            primes[name] = prime;
            return prime;
        };
        function Red(m) {
            if (typeof m === 'string') {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
            } else {
                assert(m.gtn(1), 'modulus must be greater than 1');
                this.m = m;
                this.prime = null;
            }
        }
        Red.prototype._verify1 = function _verify1(a) {
            assert(a.negative === 0, 'red works only with positives');
            assert(a.red, 'red works only with red numbers');
        };
        Red.prototype._verify2 = function _verify2(a, b) {
            assert((a.negative | b.negative) === 0, 'red works only with positives');
            assert(a.red && a.red === b.red, 'red works only with red numbers');
        };
        Red.prototype.imod = function imod(a) {
            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
            return a.umod(this.m)._forceRed(this);
        };
        Red.prototype.neg = function neg(a) {
            if (a.isZero()) return a.clone();
            return this.m.sub(a)._forceRed(this);
        };
        Red.prototype.add = function add(a, b) {
            this._verify2(a, b);
            var res = a.add(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res._forceRed(this);
        };
        Red.prototype.iadd = function iadd(a, b) {
            this._verify2(a, b);
            var res = a.iadd(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res;
        };
        Red.prototype.sub = function sub(a, b) {
            this._verify2(a, b);
            var res = a.sub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res._forceRed(this);
        };
        Red.prototype.isub = function isub(a, b) {
            this._verify2(a, b);
            var res = a.isub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res;
        };
        Red.prototype.shl = function shl(a, num) {
            this._verify1(a);
            return this.imod(a.ushln(num));
        };
        Red.prototype.imul = function imul(a, b) {
            this._verify2(a, b);
            return this.imod(a.imul(b));
        };
        Red.prototype.mul = function mul(a, b) {
            this._verify2(a, b);
            return this.imod(a.mul(b));
        };
        Red.prototype.isqr = function isqr(a) {
            return this.imul(a, a.clone());
        };
        Red.prototype.sqr = function sqr(a) {
            return this.mul(a, a);
        };
        Red.prototype.sqrt = function sqrt(a) {
            if (a.isZero()) return a.clone();
            var mod3 = this.m.andln(3);
            assert(mod3 % 2 === 1);
            if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
            }
            var q = this.m.subn(1);
            var s = 0;
            while(!q.isZero() && q.andln(1) === 0){
                s++;
                q.iushrn(1);
            }
            assert(!q.isZero());
            var one = new BN(1).toRed(this);
            var nOne = one.redNeg();
            var lpow = this.m.subn(1).iushrn(1);
            var z = this.m.bitLength();
            z = new BN(2 * z * z).toRed(this);
            while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
            var c = this.pow(z, q);
            var r = this.pow(a, q.addn(1).iushrn(1));
            var t = this.pow(a, q);
            var m = s;
            while(t.cmp(one) !== 0){
                var tmp = t;
                for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
            }
            return r;
        };
        Red.prototype.invm = function invm(a) {
            var inv = a._invmp(this.m);
            if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
            } else return this.imod(inv);
        };
        Red.prototype.pow = function pow(a, num) {
            if (num.isZero()) return new BN(1).toRed(this);
            if (num.cmpn(1) === 0) return a.clone();
            var windowSize = 4;
            var wnd = new Array(1 << windowSize);
            wnd[0] = new BN(1).toRed(this);
            wnd[1] = a;
            for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
            var res = wnd[0];
            var current = 0;
            var currentLen = 0;
            var start = num.bitLength() % 26;
            if (start === 0) start = 26;
            for(i = num.length - 1; i >= 0; i--){
                var word = num.words[i];
                for(var j = start - 1; j >= 0; j--){
                    var bit = word >> j & 1;
                    if (res !== wnd[0]) res = this.sqr(res);
                    if (bit === 0 && current === 0) {
                        currentLen = 0;
                        continue;
                    }
                    current <<= 1;
                    current |= bit;
                    currentLen++;
                    if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                    res = this.mul(res, wnd[current]);
                    currentLen = 0;
                    current = 0;
                }
                start = 26;
            }
            return res;
        };
        Red.prototype.convertTo = function convertTo(num) {
            var r = num.umod(this.m);
            return r === num ? r.clone() : r;
        };
        Red.prototype.convertFrom = function convertFrom(num) {
            var res = num.clone();
            res.red = null;
            return res;
        };
        BN.mont = function mont(num) {
            return new Mont(num);
        };
        function Mont(m) {
            Red.call(this, m);
            this.shift = this.m.bitLength();
            if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
            this.r = new BN(1).iushln(this.shift);
            this.r2 = this.imod(this.r.sqr());
            this.rinv = this.r._invmp(this.m);
            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
            this.minv = this.minv.umod(this.r);
            this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);
        Mont.prototype.convertTo = function convertTo(num) {
            return this.imod(num.ushln(this.shift));
        };
        Mont.prototype.convertFrom = function convertFrom(num) {
            var r = this.imod(num.mul(this.rinv));
            r.red = null;
            return r;
        };
        Mont.prototype.imul = function imul(a, b) {
            if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
            }
            var t = a.imul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.mul = function mul(a, b) {
            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
            var t = a.mul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.invm = function invm(a) {
            var res = this.imod(a._invmp(this.m).mul(this.r2));
            return res._forceRed(this);
        };
    })(module, this);
});
parcelRegister("j2pYc", function(module, exports) {
    var $9pbIC = parcelRequire("9pbIC");
    var $9D8YT = parcelRequire("9D8YT");
    function $ddc2594cff22236f$var$MillerRabin(rand) {
        this.rand = rand || new $9D8YT.Rand();
    }
    module.exports = $ddc2594cff22236f$var$MillerRabin;
    $ddc2594cff22236f$var$MillerRabin.create = function create(rand) {
        return new $ddc2594cff22236f$var$MillerRabin(rand);
    };
    $ddc2594cff22236f$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
        var len = n.bitLength();
        var min_bytes = Math.ceil(len / 8);
        do var a = new $9pbIC(this.rand.generate(min_bytes));
        while (a.cmp(n) >= 0)
        return a;
    };
    $ddc2594cff22236f$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
        var size = stop.sub(start);
        return start.add(this._randbelow(size));
    };
    $ddc2594cff22236f$var$MillerRabin.prototype.test = function test(n, k, cb) {
        var len = n.bitLength();
        var red = $9pbIC.mont(n);
        var rone = new $9pbIC(1).toRed(red);
        if (!k) k = Math.max(1, len / 48 | 0);
        var n1 = n.subn(1);
        for(var s = 0; !n1.testn(s); s++);
        var d = n.shrn(s);
        var rn1 = n1.toRed(red);
        var prime = true;
        for(; k > 0; k--){
            var a = this._randrange(new $9pbIC(2), n1);
            if (cb) cb(a);
            var x = a.toRed(red).redPow(d);
            if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
            for(var i = 1; i < s; i++){
                x = x.redSqr();
                if (x.cmp(rone) === 0) return false;
                if (x.cmp(rn1) === 0) break;
            }
            if (i === s) return false;
        }
        return prime;
    };
    $ddc2594cff22236f$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
        var len = n.bitLength();
        var red = $9pbIC.mont(n);
        var rone = new $9pbIC(1).toRed(red);
        if (!k) k = Math.max(1, len / 48 | 0);
        var n1 = n.subn(1);
        for(var s = 0; !n1.testn(s); s++);
        var d = n.shrn(s);
        var rn1 = n1.toRed(red);
        for(; k > 0; k--){
            var a = this._randrange(new $9pbIC(2), n1);
            var g = n.gcd(a);
            if (g.cmpn(1) !== 0) return g;
            var x = a.toRed(red).redPow(d);
            if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
            for(var i = 1; i < s; i++){
                x = x.redSqr();
                if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
                if (x.cmp(rn1) === 0) break;
            }
            if (i === s) {
                x = x.redSqr();
                return x.fromRed().subn(1).gcd(n);
            }
        }
        return false;
    };
});
parcelRegister("9D8YT", function(module, exports) {
    var $01cf348867612932$var$r;
    module.exports = function rand(len) {
        if (!$01cf348867612932$var$r) $01cf348867612932$var$r = new $01cf348867612932$var$Rand(null);
        return $01cf348867612932$var$r.generate(len);
    };
    function $01cf348867612932$var$Rand(rand) {
        this.rand = rand;
    }
    module.exports.Rand = $01cf348867612932$var$Rand;
    $01cf348867612932$var$Rand.prototype.generate = function generate(len) {
        return this._rand(len);
    };
    $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
        if (this.rand.getBytes) return this.rand.getBytes(n);
        var res = new Uint8Array(n);
        for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
        return res;
    };
    if (typeof self === 'object') {
        if (self.crypto && self.crypto.getRandomValues) $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
            var arr = new Uint8Array(n);
            self.crypto.getRandomValues(arr);
            return arr;
        };
        else if (self.msCrypto && self.msCrypto.getRandomValues) $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
            var arr = new Uint8Array(n);
            self.msCrypto.getRandomValues(arr);
            return arr;
        };
        else if (typeof window === 'object') $01cf348867612932$var$Rand.prototype._rand = function() {
            throw new Error('Not implemented yet');
        };
    } else try {
        var $01cf348867612932$var$crypto = (parcelRequire("3gWwf"));
        if (typeof $01cf348867612932$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
        $01cf348867612932$var$Rand.prototype._rand = function _rand(n) {
            return $01cf348867612932$var$crypto.randomBytes(n);
        };
    } catch (e) {}
});
parcelRegister("9TmmS", function(module, exports) {
    module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");
});
parcelRegister("9UDry", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $7377f0aaf3b8b68d$require$Buffer = $5k7LC.Buffer;
    var $9pbIC = parcelRequire("9pbIC");
    var $j2pYc = parcelRequire("j2pYc");
    var $7377f0aaf3b8b68d$var$millerRabin = new $j2pYc();
    var $7377f0aaf3b8b68d$var$TWENTYFOUR = new $9pbIC(24);
    var $7377f0aaf3b8b68d$var$ELEVEN = new $9pbIC(11);
    var $7377f0aaf3b8b68d$var$TEN = new $9pbIC(10);
    var $7377f0aaf3b8b68d$var$THREE = new $9pbIC(3);
    var $7377f0aaf3b8b68d$var$SEVEN = new $9pbIC(7);
    var $iQ4lm = parcelRequire("iQ4lm");
    var $1DyI6 = parcelRequire("1DyI6");
    module.exports = $7377f0aaf3b8b68d$var$DH;
    function $7377f0aaf3b8b68d$var$setPublicKey(pub, enc) {
        enc = enc || 'utf8';
        if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(pub)) pub = new $7377f0aaf3b8b68d$require$Buffer(pub, enc);
        this._pub = new $9pbIC(pub);
        return this;
    }
    function $7377f0aaf3b8b68d$var$setPrivateKey(priv, enc) {
        enc = enc || 'utf8';
        if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(priv)) priv = new $7377f0aaf3b8b68d$require$Buffer(priv, enc);
        this._priv = new $9pbIC(priv);
        return this;
    }
    var $7377f0aaf3b8b68d$var$primeCache = {};
    function $7377f0aaf3b8b68d$var$checkPrime(prime, generator) {
        var gen = generator.toString('hex');
        var hex = [
            gen,
            prime.toString(16)
        ].join('_');
        if (hex in $7377f0aaf3b8b68d$var$primeCache) return $7377f0aaf3b8b68d$var$primeCache[hex];
        var error = 0;
        if (prime.isEven() || !$iQ4lm.simpleSieve || !$iQ4lm.fermatTest(prime) || !$7377f0aaf3b8b68d$var$millerRabin.test(prime)) {
            error += 1;
            if (gen === '02' || gen === '05') error += 8;
            else error += 4;
            $7377f0aaf3b8b68d$var$primeCache[hex] = error;
            return error;
        }
        if (!$7377f0aaf3b8b68d$var$millerRabin.test(prime.shrn(1))) error += 2;
        var rem;
        switch(gen){
            case '02':
                if (prime.mod($7377f0aaf3b8b68d$var$TWENTYFOUR).cmp($7377f0aaf3b8b68d$var$ELEVEN)) error += 8;
                break;
            case '05':
                rem = prime.mod($7377f0aaf3b8b68d$var$TEN);
                if (rem.cmp($7377f0aaf3b8b68d$var$THREE) && rem.cmp($7377f0aaf3b8b68d$var$SEVEN)) error += 8;
                break;
            default:
                error += 4;
        }
        $7377f0aaf3b8b68d$var$primeCache[hex] = error;
        return error;
    }
    function $7377f0aaf3b8b68d$var$DH(prime, generator, malleable) {
        this.setGenerator(generator);
        this.__prime = new $9pbIC(prime);
        this._prime = $9pbIC.mont(this.__prime);
        this._primeLen = prime.length;
        this._pub = undefined;
        this._priv = undefined;
        this._primeCode = undefined;
        if (malleable) {
            this.setPublicKey = $7377f0aaf3b8b68d$var$setPublicKey;
            this.setPrivateKey = $7377f0aaf3b8b68d$var$setPrivateKey;
        } else this._primeCode = 8;
    }
    Object.defineProperty($7377f0aaf3b8b68d$var$DH.prototype, 'verifyError', {
        enumerable: true,
        get: function() {
            if (typeof this._primeCode !== 'number') this._primeCode = $7377f0aaf3b8b68d$var$checkPrime(this.__prime, this.__gen);
            return this._primeCode;
        }
    });
    $7377f0aaf3b8b68d$var$DH.prototype.generateKeys = function() {
        if (!this._priv) this._priv = new $9pbIC($1DyI6(this._primeLen));
        this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
        return this.getPublicKey();
    };
    $7377f0aaf3b8b68d$var$DH.prototype.computeSecret = function(other) {
        other = new $9pbIC(other);
        other = other.toRed(this._prime);
        var secret = other.redPow(this._priv).fromRed();
        var out = new $7377f0aaf3b8b68d$require$Buffer(secret.toArray());
        var prime = this.getPrime();
        if (out.length < prime.length) {
            var front = new $7377f0aaf3b8b68d$require$Buffer(prime.length - out.length);
            front.fill(0);
            out = $7377f0aaf3b8b68d$require$Buffer.concat([
                front,
                out
            ]);
        }
        return out;
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this._pub, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this._priv, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getPrime = function(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this.__prime, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.getGenerator = function(enc) {
        return $7377f0aaf3b8b68d$var$formatReturnValue(this._gen, enc);
    };
    $7377f0aaf3b8b68d$var$DH.prototype.setGenerator = function(gen, enc) {
        enc = enc || 'utf8';
        if (!$7377f0aaf3b8b68d$require$Buffer.isBuffer(gen)) gen = new $7377f0aaf3b8b68d$require$Buffer(gen, enc);
        this.__gen = gen;
        this._gen = new $9pbIC(gen);
        return this;
    };
    function $7377f0aaf3b8b68d$var$formatReturnValue(bn, enc) {
        var buf = new $7377f0aaf3b8b68d$require$Buffer(bn.toArray());
        if (!enc) return buf;
        else return buf.toString(enc);
    }
});
parcelRegister("kqxVX", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $edf08eeced55ab26$require$Buffer = $Wth4q.Buffer;
    var $7K4uY = parcelRequire("7K4uY");
    var $67Fhe = parcelRequire("67Fhe");
    var $v3bBu = parcelRequire("v3bBu");
    var $kYhYb = parcelRequire("kYhYb");
    var $1LYL6 = parcelRequire("1LYL6");
    var $5kFDZ = parcelRequire("5kFDZ");
    Object.keys($5kFDZ).forEach(function(key) {
        $5kFDZ[key].id = $edf08eeced55ab26$require$Buffer.from($5kFDZ[key].id, 'hex');
        $5kFDZ[key.toLowerCase()] = $5kFDZ[key];
    });
    function $edf08eeced55ab26$var$Sign(algorithm) {
        $67Fhe.Writable.call(this);
        var data = $5kFDZ[algorithm];
        if (!data) throw new Error('Unknown message digest');
        this._hashType = data.hash;
        this._hash = $7K4uY(data.hash);
        this._tag = data.id;
        this._signType = data.sign;
    }
    $v3bBu($edf08eeced55ab26$var$Sign, $67Fhe.Writable);
    $edf08eeced55ab26$var$Sign.prototype._write = function _write(data, _, done) {
        this._hash.update(data);
        done();
    };
    $edf08eeced55ab26$var$Sign.prototype.update = function update(data, enc) {
        this._hash.update(typeof data === 'string' ? $edf08eeced55ab26$require$Buffer.from(data, enc) : data);
        return this;
    };
    $edf08eeced55ab26$var$Sign.prototype.sign = function signMethod(key, enc) {
        this.end();
        var hash = this._hash.digest();
        var sig = $kYhYb(hash, key, this._hashType, this._signType, this._tag);
        return enc ? sig.toString(enc) : sig;
    };
    function $edf08eeced55ab26$var$Verify(algorithm) {
        $67Fhe.Writable.call(this);
        var data = $5kFDZ[algorithm];
        if (!data) throw new Error('Unknown message digest');
        this._hash = $7K4uY(data.hash);
        this._tag = data.id;
        this._signType = data.sign;
    }
    $v3bBu($edf08eeced55ab26$var$Verify, $67Fhe.Writable);
    $edf08eeced55ab26$var$Verify.prototype._write = function _write(data, _, done) {
        this._hash.update(data);
        done();
    };
    $edf08eeced55ab26$var$Verify.prototype.update = function update(data, enc) {
        this._hash.update(typeof data === 'string' ? $edf08eeced55ab26$require$Buffer.from(data, enc) : data);
        return this;
    };
    $edf08eeced55ab26$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
        var sigBuffer = typeof sig === 'string' ? $edf08eeced55ab26$require$Buffer.from(sig, enc) : sig;
        this.end();
        var hash = this._hash.digest();
        return $1LYL6(sigBuffer, hash, key, this._signType, this._tag);
    };
    function $edf08eeced55ab26$var$createSign(algorithm) {
        return new $edf08eeced55ab26$var$Sign(algorithm);
    }
    function $edf08eeced55ab26$var$createVerify(algorithm) {
        return new $edf08eeced55ab26$var$Verify(algorithm);
    }
    module.exports = {
        Sign: $edf08eeced55ab26$var$createSign,
        Verify: $edf08eeced55ab26$var$createVerify,
        createSign: $edf08eeced55ab26$var$createSign,
        createVerify: $edf08eeced55ab26$var$createVerify
    };
});
parcelRegister("67Fhe", function(module, exports) {
    exports = module.exports = (parcelRequire("hVjIO"));
    exports.Stream = exports;
    exports.Readable = exports;
    exports.Writable = (parcelRequire("3YGVr"));
    exports.Duplex = (parcelRequire("fAlCy"));
    exports.Transform = (parcelRequire("8iQyH"));
    exports.PassThrough = (parcelRequire("WEefO"));
});
parcelRegister("hVjIO", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    module.exports = $d0c70edb1200ac87$var$Readable;
    var $4phNF = parcelRequire("4phNF");
    var $d0c70edb1200ac87$var$Duplex;
    $d0c70edb1200ac87$var$Readable.ReadableState = $d0c70edb1200ac87$var$ReadableState;
    var $6Oghe = parcelRequire("6Oghe");
    var $d0c70edb1200ac87$require$EE = $6Oghe.EventEmitter;
    var $d0c70edb1200ac87$var$EElistenerCount = function(emitter, type) {
        return emitter.listeners(type).length;
    };
    var $4t6fq = parcelRequire("4t6fq");
    var $cmRjm = parcelRequire("cmRjm");
    var $d0c70edb1200ac87$require$Buffer = $cmRjm.Buffer;
    var $d0c70edb1200ac87$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $d0c70edb1200ac87$var$_uint8ArrayToBuffer(chunk) {
        return $d0c70edb1200ac87$require$Buffer.from(chunk);
    }
    function $d0c70edb1200ac87$var$_isUint8Array(obj) {
        return $d0c70edb1200ac87$require$Buffer.isBuffer(obj) || obj instanceof $d0c70edb1200ac87$var$OurUint8Array;
    }
    var $d0c70edb1200ac87$var$util = Object.create((parcelRequire("fvDPy")));
    $d0c70edb1200ac87$var$util.inherits = (parcelRequire("v3bBu"));
    var $3gWwf = parcelRequire("3gWwf");
    var $d0c70edb1200ac87$var$debug = void 0;
    if ($3gWwf && $3gWwf.debuglog) $d0c70edb1200ac87$var$debug = $3gWwf.debuglog('stream');
    else $d0c70edb1200ac87$var$debug = function() {};
    var $ZaRag = parcelRequire("ZaRag");
    var $9tGJn = parcelRequire("9tGJn");
    var $d0c70edb1200ac87$var$StringDecoder;
    $d0c70edb1200ac87$var$util.inherits($d0c70edb1200ac87$var$Readable, $4t6fq);
    var $d0c70edb1200ac87$var$kProxyEvents = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    function $d0c70edb1200ac87$var$prependListener(emitter, event, fn) {
        if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if ($4phNF(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
    function $d0c70edb1200ac87$var$ReadableState(options, stream) {
        $d0c70edb1200ac87$var$Duplex = $d0c70edb1200ac87$var$Duplex || (parcelRequire("fAlCy"));
        options = options || {};
        var isDuplex = stream instanceof $d0c70edb1200ac87$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
        var hwm = options.highWaterMark;
        var readableHwm = options.readableHighWaterMark;
        var defaultHwm = this.objectMode ? 16 : 16384;
        if (hwm || hwm === 0) this.highWaterMark = hwm;
        else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
        else this.highWaterMark = defaultHwm;
        this.highWaterMark = Math.floor(this.highWaterMark);
        this.buffer = new $ZaRag();
        this.length = 0;
        this.pipes = null;
        this.pipesCount = 0;
        this.flowing = null;
        this.ended = false;
        this.endEmitted = false;
        this.reading = false;
        this.sync = true;
        this.needReadable = false;
        this.emittedReadable = false;
        this.readableListening = false;
        this.resumeScheduled = false;
        this.destroyed = false;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.awaitDrain = 0;
        this.readingMore = false;
        this.decoder = null;
        this.encoding = null;
        if (options.encoding) {
            if (!$d0c70edb1200ac87$var$StringDecoder) $d0c70edb1200ac87$var$StringDecoder = (parcelRequire("6ayCS")).StringDecoder;
            this.decoder = new $d0c70edb1200ac87$var$StringDecoder(options.encoding);
            this.encoding = options.encoding;
        }
    }
    function $d0c70edb1200ac87$var$Readable(options) {
        $d0c70edb1200ac87$var$Duplex = $d0c70edb1200ac87$var$Duplex || (parcelRequire("fAlCy"));
        if (!(this instanceof $d0c70edb1200ac87$var$Readable)) return new $d0c70edb1200ac87$var$Readable(options);
        this._readableState = new $d0c70edb1200ac87$var$ReadableState(options, this);
        this.readable = true;
        if (options) {
            if (typeof options.read === 'function') this._read = options.read;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
        }
        $4t6fq.call(this);
    }
    Object.defineProperty($d0c70edb1200ac87$var$Readable.prototype, 'destroyed', {
        get: function() {
            if (this._readableState === undefined) return false;
            return this._readableState.destroyed;
        },
        set: function(value) {
            if (!this._readableState) return;
            this._readableState.destroyed = value;
        }
    });
    $d0c70edb1200ac87$var$Readable.prototype.destroy = $9tGJn.destroy;
    $d0c70edb1200ac87$var$Readable.prototype._undestroy = $9tGJn.undestroy;
    $d0c70edb1200ac87$var$Readable.prototype._destroy = function(err, cb) {
        this.push(null);
        cb(err);
    };
    $d0c70edb1200ac87$var$Readable.prototype.push = function(chunk, encoding) {
        var state = this._readableState;
        var skipChunkCheck;
        if (!state.objectMode) {
            if (typeof chunk === 'string') {
                encoding = encoding || state.defaultEncoding;
                if (encoding !== state.encoding) {
                    chunk = $d0c70edb1200ac87$require$Buffer.from(chunk, encoding);
                    encoding = '';
                }
                skipChunkCheck = true;
            }
        } else skipChunkCheck = true;
        return $d0c70edb1200ac87$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
    };
    $d0c70edb1200ac87$var$Readable.prototype.unshift = function(chunk) {
        return $d0c70edb1200ac87$var$readableAddChunk(this, chunk, null, true, false);
    };
    function $d0c70edb1200ac87$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
        var state = stream._readableState;
        if (chunk === null) {
            state.reading = false;
            $d0c70edb1200ac87$var$onEofChunk(stream, state);
        } else {
            var er;
            if (!skipChunkCheck) er = $d0c70edb1200ac87$var$chunkInvalid(state, chunk);
            if (er) stream.emit('error', er);
            else if (state.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $d0c70edb1200ac87$require$Buffer.prototype) chunk = $d0c70edb1200ac87$var$_uint8ArrayToBuffer(chunk);
                if (addToFront) {
                    if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                    else $d0c70edb1200ac87$var$addChunk(stream, state, chunk, true);
                } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
                else {
                    state.reading = false;
                    if (state.decoder && !encoding) {
                        chunk = state.decoder.write(chunk);
                        if (state.objectMode || chunk.length !== 0) $d0c70edb1200ac87$var$addChunk(stream, state, chunk, false);
                        else $d0c70edb1200ac87$var$maybeReadMore(stream, state);
                    } else $d0c70edb1200ac87$var$addChunk(stream, state, chunk, false);
                }
            } else if (!addToFront) state.reading = false;
        }
        return $d0c70edb1200ac87$var$needMoreData(state);
    }
    function $d0c70edb1200ac87$var$addChunk(stream, state, chunk, addToFront) {
        if (state.flowing && state.length === 0 && !state.sync) {
            stream.emit('data', chunk);
            stream.read(0);
        } else {
            state.length += state.objectMode ? 1 : chunk.length;
            if (addToFront) state.buffer.unshift(chunk);
            else state.buffer.push(chunk);
            if (state.needReadable) $d0c70edb1200ac87$var$emitReadable(stream);
        }
        $d0c70edb1200ac87$var$maybeReadMore(stream, state);
    }
    function $d0c70edb1200ac87$var$chunkInvalid(state, chunk) {
        var er;
        if (!$d0c70edb1200ac87$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
        return er;
    }
    function $d0c70edb1200ac87$var$needMoreData(state) {
        return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
    }
    $d0c70edb1200ac87$var$Readable.prototype.isPaused = function() {
        return this._readableState.flowing === false;
    };
    $d0c70edb1200ac87$var$Readable.prototype.setEncoding = function(enc) {
        if (!$d0c70edb1200ac87$var$StringDecoder) $d0c70edb1200ac87$var$StringDecoder = (parcelRequire("6ayCS")).StringDecoder;
        this._readableState.decoder = new $d0c70edb1200ac87$var$StringDecoder(enc);
        this._readableState.encoding = enc;
        return this;
    };
    var $d0c70edb1200ac87$var$MAX_HWM = 0x800000;
    function $d0c70edb1200ac87$var$computeNewHighWaterMark(n) {
        if (n >= $d0c70edb1200ac87$var$MAX_HWM) n = $d0c70edb1200ac87$var$MAX_HWM;
        else {
            n--;
            n |= n >>> 1;
            n |= n >>> 2;
            n |= n >>> 4;
            n |= n >>> 8;
            n |= n >>> 16;
            n++;
        }
        return n;
    }
    function $d0c70edb1200ac87$var$howMuchToRead(n, state) {
        if (n <= 0 || state.length === 0 && state.ended) return 0;
        if (state.objectMode) return 1;
        if (n !== n) {
            if (state.flowing && state.length) return state.buffer.head.data.length;
            else return state.length;
        }
        if (n > state.highWaterMark) state.highWaterMark = $d0c70edb1200ac87$var$computeNewHighWaterMark(n);
        if (n <= state.length) return n;
        if (!state.ended) {
            state.needReadable = true;
            return 0;
        }
        return state.length;
    }
    $d0c70edb1200ac87$var$Readable.prototype.read = function(n) {
        $d0c70edb1200ac87$var$debug('read', n);
        n = parseInt(n, 10);
        var state = this._readableState;
        var nOrig = n;
        if (n !== 0) state.emittedReadable = false;
        if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
            $d0c70edb1200ac87$var$debug('read: emitReadable', state.length, state.ended);
            if (state.length === 0 && state.ended) $d0c70edb1200ac87$var$endReadable(this);
            else $d0c70edb1200ac87$var$emitReadable(this);
            return null;
        }
        n = $d0c70edb1200ac87$var$howMuchToRead(n, state);
        if (n === 0 && state.ended) {
            if (state.length === 0) $d0c70edb1200ac87$var$endReadable(this);
            return null;
        }
        var doRead = state.needReadable;
        $d0c70edb1200ac87$var$debug('need readable', doRead);
        if (state.length === 0 || state.length - n < state.highWaterMark) {
            doRead = true;
            $d0c70edb1200ac87$var$debug('length less than watermark', doRead);
        }
        if (state.ended || state.reading) {
            doRead = false;
            $d0c70edb1200ac87$var$debug('reading or ended', doRead);
        } else if (doRead) {
            $d0c70edb1200ac87$var$debug('do read');
            state.reading = true;
            state.sync = true;
            if (state.length === 0) state.needReadable = true;
            this._read(state.highWaterMark);
            state.sync = false;
            if (!state.reading) n = $d0c70edb1200ac87$var$howMuchToRead(nOrig, state);
        }
        var ret;
        if (n > 0) ret = $d0c70edb1200ac87$var$fromList(n, state);
        else ret = null;
        if (ret === null) {
            state.needReadable = true;
            n = 0;
        } else state.length -= n;
        if (state.length === 0) {
            if (!state.ended) state.needReadable = true;
            if (nOrig !== n && state.ended) $d0c70edb1200ac87$var$endReadable(this);
        }
        if (ret !== null) this.emit('data', ret);
        return ret;
    };
    function $d0c70edb1200ac87$var$onEofChunk(stream, state) {
        if (state.ended) return;
        if (state.decoder) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
            }
        }
        state.ended = true;
        $d0c70edb1200ac87$var$emitReadable(stream);
    }
    function $d0c70edb1200ac87$var$emitReadable(stream) {
        var state = stream._readableState;
        state.needReadable = false;
        if (!state.emittedReadable) {
            $d0c70edb1200ac87$var$debug('emitReadable', state.flowing);
            state.emittedReadable = true;
            if (state.sync) $iWV9i.nextTick($d0c70edb1200ac87$var$emitReadable_, stream);
            else $d0c70edb1200ac87$var$emitReadable_(stream);
        }
    }
    function $d0c70edb1200ac87$var$emitReadable_(stream) {
        $d0c70edb1200ac87$var$debug('emit readable');
        stream.emit('readable');
        $d0c70edb1200ac87$var$flow(stream);
    }
    function $d0c70edb1200ac87$var$maybeReadMore(stream, state) {
        if (!state.readingMore) {
            state.readingMore = true;
            $iWV9i.nextTick($d0c70edb1200ac87$var$maybeReadMore_, stream, state);
        }
    }
    function $d0c70edb1200ac87$var$maybeReadMore_(stream, state) {
        var len = state.length;
        while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
            $d0c70edb1200ac87$var$debug('maybeReadMore read 0');
            stream.read(0);
            if (len === state.length) break;
            else len = state.length;
        }
        state.readingMore = false;
    }
    $d0c70edb1200ac87$var$Readable.prototype._read = function(n) {
        this.emit('error', new Error('_read() is not implemented'));
    };
    $d0c70edb1200ac87$var$Readable.prototype.pipe = function(dest, pipeOpts) {
        var src = this;
        var state = this._readableState;
        switch(state.pipesCount){
            case 0:
                state.pipes = dest;
                break;
            case 1:
                state.pipes = [
                    state.pipes,
                    dest
                ];
                break;
            default:
                state.pipes.push(dest);
                break;
        }
        state.pipesCount += 1;
        $d0c70edb1200ac87$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
        var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $6cAn5.stdout && dest !== $6cAn5.stderr;
        var endFn = doEnd ? onend : unpipe;
        if (state.endEmitted) $iWV9i.nextTick(endFn);
        else src.once('end', endFn);
        dest.on('unpipe', onunpipe);
        function onunpipe(readable, unpipeInfo) {
            $d0c70edb1200ac87$var$debug('onunpipe');
            if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                    unpipeInfo.hasUnpiped = true;
                    cleanup();
                }
            }
        }
        function onend() {
            $d0c70edb1200ac87$var$debug('onend');
            dest.end();
        }
        var ondrain = $d0c70edb1200ac87$var$pipeOnDrain(src);
        dest.on('drain', ondrain);
        var cleanedUp = false;
        function cleanup() {
            $d0c70edb1200ac87$var$debug('cleanup');
            dest.removeListener('close', onclose);
            dest.removeListener('finish', onfinish);
            dest.removeListener('drain', ondrain);
            dest.removeListener('error', onerror);
            dest.removeListener('unpipe', onunpipe);
            src.removeListener('end', onend);
            src.removeListener('end', unpipe);
            src.removeListener('data', ondata);
            cleanedUp = true;
            if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
        }
        var increasedAwaitDrain = false;
        src.on('data', ondata);
        function ondata(chunk) {
            $d0c70edb1200ac87$var$debug('ondata');
            increasedAwaitDrain = false;
            var ret = dest.write(chunk);
            if (false === ret && !increasedAwaitDrain) {
                if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d0c70edb1200ac87$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                    $d0c70edb1200ac87$var$debug('false write response, pause', state.awaitDrain);
                    state.awaitDrain++;
                    increasedAwaitDrain = true;
                }
                src.pause();
            }
        }
        function onerror(er) {
            $d0c70edb1200ac87$var$debug('onerror', er);
            unpipe();
            dest.removeListener('error', onerror);
            if ($d0c70edb1200ac87$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
        }
        $d0c70edb1200ac87$var$prependListener(dest, 'error', onerror);
        function onclose() {
            dest.removeListener('finish', onfinish);
            unpipe();
        }
        dest.once('close', onclose);
        function onfinish() {
            $d0c70edb1200ac87$var$debug('onfinish');
            dest.removeListener('close', onclose);
            unpipe();
        }
        dest.once('finish', onfinish);
        function unpipe() {
            $d0c70edb1200ac87$var$debug('unpipe');
            src.unpipe(dest);
        }
        dest.emit('pipe', src);
        if (!state.flowing) {
            $d0c70edb1200ac87$var$debug('pipe resume');
            src.resume();
        }
        return dest;
    };
    function $d0c70edb1200ac87$var$pipeOnDrain(src) {
        return function() {
            var state = src._readableState;
            $d0c70edb1200ac87$var$debug('pipeOnDrain', state.awaitDrain);
            if (state.awaitDrain) state.awaitDrain--;
            if (state.awaitDrain === 0 && $d0c70edb1200ac87$var$EElistenerCount(src, 'data')) {
                state.flowing = true;
                $d0c70edb1200ac87$var$flow(src);
            }
        };
    }
    $d0c70edb1200ac87$var$Readable.prototype.unpipe = function(dest) {
        var state = this._readableState;
        var unpipeInfo = {
            hasUnpiped: false
        };
        if (state.pipesCount === 0) return this;
        if (state.pipesCount === 1) {
            if (dest && dest !== state.pipes) return this;
            if (!dest) dest = state.pipes;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            if (dest) dest.emit('unpipe', this, unpipeInfo);
            return this;
        }
        if (!dest) {
            var dests = state.pipes;
            var len = state.pipesCount;
            state.pipes = null;
            state.pipesCount = 0;
            state.flowing = false;
            for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
                hasUnpiped: false
            });
            return this;
        }
        var index = $d0c70edb1200ac87$var$indexOf(state.pipes, dest);
        if (index === -1) return this;
        state.pipes.splice(index, 1);
        state.pipesCount -= 1;
        if (state.pipesCount === 1) state.pipes = state.pipes[0];
        dest.emit('unpipe', this, unpipeInfo);
        return this;
    };
    $d0c70edb1200ac87$var$Readable.prototype.on = function(ev, fn) {
        var res = $4t6fq.prototype.on.call(this, ev, fn);
        if (ev === 'data') {
            if (this._readableState.flowing !== false) this.resume();
        } else if (ev === 'readable') {
            var state = this._readableState;
            if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.emittedReadable = false;
                if (!state.reading) $iWV9i.nextTick($d0c70edb1200ac87$var$nReadingNextTick, this);
                else if (state.length) $d0c70edb1200ac87$var$emitReadable(this);
            }
        }
        return res;
    };
    $d0c70edb1200ac87$var$Readable.prototype.addListener = $d0c70edb1200ac87$var$Readable.prototype.on;
    function $d0c70edb1200ac87$var$nReadingNextTick(self1) {
        $d0c70edb1200ac87$var$debug('readable nexttick read 0');
        self1.read(0);
    }
    $d0c70edb1200ac87$var$Readable.prototype.resume = function() {
        var state = this._readableState;
        if (!state.flowing) {
            $d0c70edb1200ac87$var$debug('resume');
            state.flowing = true;
            $d0c70edb1200ac87$var$resume(this, state);
        }
        return this;
    };
    function $d0c70edb1200ac87$var$resume(stream, state) {
        if (!state.resumeScheduled) {
            state.resumeScheduled = true;
            $iWV9i.nextTick($d0c70edb1200ac87$var$resume_, stream, state);
        }
    }
    function $d0c70edb1200ac87$var$resume_(stream, state) {
        if (!state.reading) {
            $d0c70edb1200ac87$var$debug('resume read 0');
            stream.read(0);
        }
        state.resumeScheduled = false;
        state.awaitDrain = 0;
        stream.emit('resume');
        $d0c70edb1200ac87$var$flow(stream);
        if (state.flowing && !state.reading) stream.read(0);
    }
    $d0c70edb1200ac87$var$Readable.prototype.pause = function() {
        $d0c70edb1200ac87$var$debug('call pause flowing=%j', this._readableState.flowing);
        if (false !== this._readableState.flowing) {
            $d0c70edb1200ac87$var$debug('pause');
            this._readableState.flowing = false;
            this.emit('pause');
        }
        return this;
    };
    function $d0c70edb1200ac87$var$flow(stream) {
        var state = stream._readableState;
        $d0c70edb1200ac87$var$debug('flow', state.flowing);
        while(state.flowing && stream.read() !== null);
    }
    $d0c70edb1200ac87$var$Readable.prototype.wrap = function(stream) {
        var _this = this;
        var state = this._readableState;
        var paused = false;
        stream.on('end', function() {
            $d0c70edb1200ac87$var$debug('wrapped end');
            if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
            }
            _this.push(null);
        });
        stream.on('data', function(chunk) {
            $d0c70edb1200ac87$var$debug('wrapped data');
            if (state.decoder) chunk = state.decoder.write(chunk);
            if (state.objectMode && (chunk === null || chunk === undefined)) return;
            else if (!state.objectMode && (!chunk || !chunk.length)) return;
            var ret = _this.push(chunk);
            if (!ret) {
                paused = true;
                stream.pause();
            }
        });
        for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
            return function() {
                return stream[method].apply(stream, arguments);
            };
        }(i);
        for(var n = 0; n < $d0c70edb1200ac87$var$kProxyEvents.length; n++)stream.on($d0c70edb1200ac87$var$kProxyEvents[n], this.emit.bind(this, $d0c70edb1200ac87$var$kProxyEvents[n]));
        this._read = function(n) {
            $d0c70edb1200ac87$var$debug('wrapped _read', n);
            if (paused) {
                paused = false;
                stream.resume();
            }
        };
        return this;
    };
    Object.defineProperty($d0c70edb1200ac87$var$Readable.prototype, 'readableHighWaterMark', {
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    });
    $d0c70edb1200ac87$var$Readable._fromList = $d0c70edb1200ac87$var$fromList;
    function $d0c70edb1200ac87$var$fromList(n, state) {
        if (state.length === 0) return null;
        var ret;
        if (state.objectMode) ret = state.buffer.shift();
        else if (!n || n >= state.length) {
            if (state.decoder) ret = state.buffer.join('');
            else if (state.buffer.length === 1) ret = state.buffer.head.data;
            else ret = state.buffer.concat(state.length);
            state.buffer.clear();
        } else ret = $d0c70edb1200ac87$var$fromListPartial(n, state.buffer, state.decoder);
        return ret;
    }
    function $d0c70edb1200ac87$var$fromListPartial(n, list, hasStrings) {
        var ret;
        if (n < list.head.data.length) {
            ret = list.head.data.slice(0, n);
            list.head.data = list.head.data.slice(n);
        } else if (n === list.head.data.length) ret = list.shift();
        else ret = hasStrings ? $d0c70edb1200ac87$var$copyFromBufferString(n, list) : $d0c70edb1200ac87$var$copyFromBuffer(n, list);
        return ret;
    }
    function $d0c70edb1200ac87$var$copyFromBufferString(n, list) {
        var p = list.head;
        var c = 1;
        var ret = p.data;
        n -= ret.length;
        while(p = p.next){
            var str = p.data;
            var nb = n > str.length ? str.length : n;
            if (nb === str.length) ret += str;
            else ret += str.slice(0, n);
            n -= nb;
            if (n === 0) {
                if (nb === str.length) {
                    ++c;
                    if (p.next) list.head = p.next;
                    else list.head = list.tail = null;
                } else {
                    list.head = p;
                    p.data = str.slice(nb);
                }
                break;
            }
            ++c;
        }
        list.length -= c;
        return ret;
    }
    function $d0c70edb1200ac87$var$copyFromBuffer(n, list) {
        var ret = $d0c70edb1200ac87$require$Buffer.allocUnsafe(n);
        var p = list.head;
        var c = 1;
        p.data.copy(ret);
        n -= p.data.length;
        while(p = p.next){
            var buf = p.data;
            var nb = n > buf.length ? buf.length : n;
            buf.copy(ret, ret.length - n, 0, nb);
            n -= nb;
            if (n === 0) {
                if (nb === buf.length) {
                    ++c;
                    if (p.next) list.head = p.next;
                    else list.head = list.tail = null;
                } else {
                    list.head = p;
                    p.data = buf.slice(nb);
                }
                break;
            }
            ++c;
        }
        list.length -= c;
        return ret;
    }
    function $d0c70edb1200ac87$var$endReadable(stream) {
        var state = stream._readableState;
        if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        if (!state.endEmitted) {
            state.ended = true;
            $iWV9i.nextTick($d0c70edb1200ac87$var$endReadableNT, state, stream);
        }
    }
    function $d0c70edb1200ac87$var$endReadableNT(state, stream) {
        if (!state.endEmitted && state.length === 0) {
            state.endEmitted = true;
            stream.readable = false;
            stream.emit('end');
        }
    }
    function $d0c70edb1200ac87$var$indexOf(xs, x) {
        for(var i = 0, l = xs.length; i < l; i++){
            if (xs[i] === x) return i;
        }
        return -1;
    }
});
parcelRegister("iWV9i", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    if (typeof $6cAn5 === 'undefined' || !$6cAn5.version || $6cAn5.version.indexOf('v0.') === 0 || $6cAn5.version.indexOf('v1.') === 0 && $6cAn5.version.indexOf('v1.8.') !== 0) module.exports = {
        nextTick: $dcb9f95cdc97f624$var$nextTick
    };
    else module.exports = $6cAn5;
    function $dcb9f95cdc97f624$var$nextTick(fn, arg1, arg2, arg3) {
        if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
        var len = arguments.length;
        var args, i;
        switch(len){
            case 0:
            case 1:
                return $6cAn5.nextTick(fn);
            case 2:
                return $6cAn5.nextTick(function afterTickOne() {
                    fn.call(null, arg1);
                });
            case 3:
                return $6cAn5.nextTick(function afterTickTwo() {
                    fn.call(null, arg1, arg2);
                });
            case 4:
                return $6cAn5.nextTick(function afterTickThree() {
                    fn.call(null, arg1, arg2, arg3);
                });
            default:
                args = new Array(len - 1);
                i = 0;
                while(i < args.length)args[i++] = arguments[i];
                return $6cAn5.nextTick(function afterTick() {
                    fn.apply(null, args);
                });
        }
    }
});
parcelRegister("4phNF", function(module, exports) {
    var $33574df078d04d7d$var$toString = {}.toString;
    module.exports = Array.isArray || function(arr) {
        return $33574df078d04d7d$var$toString.call(arr) == '[object Array]';
    };
});
parcelRegister("4t6fq", function(module, exports) {
    module.exports = (parcelRequire("6Oghe")).EventEmitter;
});
parcelRegister("cmRjm", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $9010e498dbe0c8b2$var$Buffer = $5k7LC.Buffer;
    function $9010e498dbe0c8b2$var$copyProps(src, dst) {
        for(var key in src)dst[key] = src[key];
    }
    if ($9010e498dbe0c8b2$var$Buffer.from && $9010e498dbe0c8b2$var$Buffer.alloc && $9010e498dbe0c8b2$var$Buffer.allocUnsafe && $9010e498dbe0c8b2$var$Buffer.allocUnsafeSlow) module.exports = $5k7LC;
    else {
        $9010e498dbe0c8b2$var$copyProps($5k7LC, module.exports);
        module.exports.Buffer = $9010e498dbe0c8b2$var$SafeBuffer;
    }
    function $9010e498dbe0c8b2$var$SafeBuffer(arg, encodingOrOffset, length) {
        return $9010e498dbe0c8b2$var$Buffer(arg, encodingOrOffset, length);
    }
    $9010e498dbe0c8b2$var$copyProps($9010e498dbe0c8b2$var$Buffer, $9010e498dbe0c8b2$var$SafeBuffer);
    $9010e498dbe0c8b2$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
        if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
        return $9010e498dbe0c8b2$var$Buffer(arg, encodingOrOffset, length);
    };
    $9010e498dbe0c8b2$var$SafeBuffer.alloc = function(size, fill, encoding) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        var buf = $9010e498dbe0c8b2$var$Buffer(size);
        if (fill !== undefined) {
            if (typeof encoding === 'string') buf.fill(fill, encoding);
            else buf.fill(fill);
        } else buf.fill(0);
        return buf;
    };
    $9010e498dbe0c8b2$var$SafeBuffer.allocUnsafe = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $9010e498dbe0c8b2$var$Buffer(size);
    };
    $9010e498dbe0c8b2$var$SafeBuffer.allocUnsafeSlow = function(size) {
        if (typeof size !== 'number') throw new TypeError('Argument must be a number');
        return $5k7LC.SlowBuffer(size);
    };
});
parcelRegister("fvDPy", function(module, exports) {
    $parcel$export(module.exports, "isArray", ()=>$b4a8a5c310566eb2$export$43bee75e5e14138e, (v)=>$b4a8a5c310566eb2$export$43bee75e5e14138e = v);
    $parcel$export(module.exports, "isBoolean", ()=>$b4a8a5c310566eb2$export$f9ce7b637dfbe238, (v)=>$b4a8a5c310566eb2$export$f9ce7b637dfbe238 = v);
    $parcel$export(module.exports, "isNull", ()=>$b4a8a5c310566eb2$export$630801d484da15df, (v)=>$b4a8a5c310566eb2$export$630801d484da15df = v);
    $parcel$export(module.exports, "isNullOrUndefined", ()=>$b4a8a5c310566eb2$export$bedb7023a7733221, (v)=>$b4a8a5c310566eb2$export$bedb7023a7733221 = v);
    $parcel$export(module.exports, "isNumber", ()=>$b4a8a5c310566eb2$export$7e4aa119212bc614, (v)=>$b4a8a5c310566eb2$export$7e4aa119212bc614 = v);
    $parcel$export(module.exports, "isString", ()=>$b4a8a5c310566eb2$export$844ec244b1367d54, (v)=>$b4a8a5c310566eb2$export$844ec244b1367d54 = v);
    $parcel$export(module.exports, "isSymbol", ()=>$b4a8a5c310566eb2$export$a244864fd9645c7f, (v)=>$b4a8a5c310566eb2$export$a244864fd9645c7f = v);
    $parcel$export(module.exports, "isUndefined", ()=>$b4a8a5c310566eb2$export$fce6876652108ab, (v)=>$b4a8a5c310566eb2$export$fce6876652108ab = v);
    $parcel$export(module.exports, "isRegExp", ()=>$b4a8a5c310566eb2$export$49841c62b9eff15, (v)=>$b4a8a5c310566eb2$export$49841c62b9eff15 = v);
    $parcel$export(module.exports, "isObject", ()=>$b4a8a5c310566eb2$export$a6cdc56e425d0d0a, (v)=>$b4a8a5c310566eb2$export$a6cdc56e425d0d0a = v);
    $parcel$export(module.exports, "isDate", ()=>$b4a8a5c310566eb2$export$871608497c498473, (v)=>$b4a8a5c310566eb2$export$871608497c498473 = v);
    $parcel$export(module.exports, "isError", ()=>$b4a8a5c310566eb2$export$e6127cc7fe7395c3, (v)=>$b4a8a5c310566eb2$export$e6127cc7fe7395c3 = v);
    $parcel$export(module.exports, "isFunction", ()=>$b4a8a5c310566eb2$export$f6e2535fb5126e54, (v)=>$b4a8a5c310566eb2$export$f6e2535fb5126e54 = v);
    $parcel$export(module.exports, "isPrimitive", ()=>$b4a8a5c310566eb2$export$c3825b437cbdea5c, (v)=>$b4a8a5c310566eb2$export$c3825b437cbdea5c = v);
    $parcel$export(module.exports, "isBuffer", ()=>$b4a8a5c310566eb2$export$a7884ebc965f8f54, (v)=>$b4a8a5c310566eb2$export$a7884ebc965f8f54 = v);
    var $b4a8a5c310566eb2$export$43bee75e5e14138e;
    var $b4a8a5c310566eb2$export$f9ce7b637dfbe238;
    var $b4a8a5c310566eb2$export$630801d484da15df;
    var $b4a8a5c310566eb2$export$bedb7023a7733221;
    var $b4a8a5c310566eb2$export$7e4aa119212bc614;
    var $b4a8a5c310566eb2$export$844ec244b1367d54;
    var $b4a8a5c310566eb2$export$a244864fd9645c7f;
    var $b4a8a5c310566eb2$export$fce6876652108ab;
    var $b4a8a5c310566eb2$export$49841c62b9eff15;
    var $b4a8a5c310566eb2$export$a6cdc56e425d0d0a;
    var $b4a8a5c310566eb2$export$871608497c498473;
    var $b4a8a5c310566eb2$export$e6127cc7fe7395c3;
    var $b4a8a5c310566eb2$export$f6e2535fb5126e54;
    var $b4a8a5c310566eb2$export$c3825b437cbdea5c;
    var $b4a8a5c310566eb2$export$a7884ebc965f8f54;
    function $b4a8a5c310566eb2$var$isArray(arg) {
        if (Array.isArray) return Array.isArray(arg);
        return $b4a8a5c310566eb2$var$objectToString(arg) === '[object Array]';
    }
    $b4a8a5c310566eb2$export$43bee75e5e14138e = $b4a8a5c310566eb2$var$isArray;
    function $b4a8a5c310566eb2$var$isBoolean(arg) {
        return typeof arg === 'boolean';
    }
    $b4a8a5c310566eb2$export$f9ce7b637dfbe238 = $b4a8a5c310566eb2$var$isBoolean;
    function $b4a8a5c310566eb2$var$isNull(arg) {
        return arg === null;
    }
    $b4a8a5c310566eb2$export$630801d484da15df = $b4a8a5c310566eb2$var$isNull;
    function $b4a8a5c310566eb2$var$isNullOrUndefined(arg) {
        return arg == null;
    }
    $b4a8a5c310566eb2$export$bedb7023a7733221 = $b4a8a5c310566eb2$var$isNullOrUndefined;
    function $b4a8a5c310566eb2$var$isNumber(arg) {
        return typeof arg === 'number';
    }
    $b4a8a5c310566eb2$export$7e4aa119212bc614 = $b4a8a5c310566eb2$var$isNumber;
    function $b4a8a5c310566eb2$var$isString(arg) {
        return typeof arg === 'string';
    }
    $b4a8a5c310566eb2$export$844ec244b1367d54 = $b4a8a5c310566eb2$var$isString;
    function $b4a8a5c310566eb2$var$isSymbol(arg) {
        return typeof arg === 'symbol';
    }
    $b4a8a5c310566eb2$export$a244864fd9645c7f = $b4a8a5c310566eb2$var$isSymbol;
    function $b4a8a5c310566eb2$var$isUndefined(arg) {
        return arg === void 0;
    }
    $b4a8a5c310566eb2$export$fce6876652108ab = $b4a8a5c310566eb2$var$isUndefined;
    function $b4a8a5c310566eb2$var$isRegExp(re) {
        return $b4a8a5c310566eb2$var$objectToString(re) === '[object RegExp]';
    }
    $b4a8a5c310566eb2$export$49841c62b9eff15 = $b4a8a5c310566eb2$var$isRegExp;
    function $b4a8a5c310566eb2$var$isObject(arg) {
        return typeof arg === 'object' && arg !== null;
    }
    $b4a8a5c310566eb2$export$a6cdc56e425d0d0a = $b4a8a5c310566eb2$var$isObject;
    function $b4a8a5c310566eb2$var$isDate(d) {
        return $b4a8a5c310566eb2$var$objectToString(d) === '[object Date]';
    }
    $b4a8a5c310566eb2$export$871608497c498473 = $b4a8a5c310566eb2$var$isDate;
    function $b4a8a5c310566eb2$var$isError(e) {
        return $b4a8a5c310566eb2$var$objectToString(e) === '[object Error]' || e instanceof Error;
    }
    $b4a8a5c310566eb2$export$e6127cc7fe7395c3 = $b4a8a5c310566eb2$var$isError;
    function $b4a8a5c310566eb2$var$isFunction(arg) {
        return typeof arg === 'function';
    }
    $b4a8a5c310566eb2$export$f6e2535fb5126e54 = $b4a8a5c310566eb2$var$isFunction;
    function $b4a8a5c310566eb2$var$isPrimitive(arg) {
        return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined';
    }
    $b4a8a5c310566eb2$export$c3825b437cbdea5c = $b4a8a5c310566eb2$var$isPrimitive;
    $b4a8a5c310566eb2$export$a7884ebc965f8f54 = (parcelRequire("5k7LC")).Buffer.isBuffer;
    function $b4a8a5c310566eb2$var$objectToString(o) {
        return Object.prototype.toString.call(o);
    }
});
parcelRegister("ZaRag", function(module, exports) {
    'use strict';
    function $0b7e1e7e4868f65f$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $cmRjm = parcelRequire("cmRjm");
    var $0b7e1e7e4868f65f$require$Buffer = $cmRjm.Buffer;
    var $3gWwf = parcelRequire("3gWwf");
    function $0b7e1e7e4868f65f$var$copyBuffer(src, target, offset) {
        src.copy(target, offset);
    }
    module.exports = function() {
        function BufferList() {
            $0b7e1e7e4868f65f$var$_classCallCheck(this, BufferList);
            this.head = null;
            this.tail = null;
            this.length = 0;
        }
        BufferList.prototype.push = function push(v) {
            var entry = {
                data: v,
                next: null
            };
            if (this.length > 0) this.tail.next = entry;
            else this.head = entry;
            this.tail = entry;
            ++this.length;
        };
        BufferList.prototype.unshift = function unshift(v) {
            var entry = {
                data: v,
                next: this.head
            };
            if (this.length === 0) this.tail = entry;
            this.head = entry;
            ++this.length;
        };
        BufferList.prototype.shift = function shift() {
            if (this.length === 0) return;
            var ret = this.head.data;
            if (this.length === 1) this.head = this.tail = null;
            else this.head = this.head.next;
            --this.length;
            return ret;
        };
        BufferList.prototype.clear = function clear() {
            this.head = this.tail = null;
            this.length = 0;
        };
        BufferList.prototype.join = function join(s) {
            if (this.length === 0) return '';
            var p = this.head;
            var ret = '' + p.data;
            while(p = p.next)ret += s + p.data;
            return ret;
        };
        BufferList.prototype.concat = function concat(n) {
            if (this.length === 0) return $0b7e1e7e4868f65f$require$Buffer.alloc(0);
            var ret = $0b7e1e7e4868f65f$require$Buffer.allocUnsafe(n >>> 0);
            var p = this.head;
            var i = 0;
            while(p){
                $0b7e1e7e4868f65f$var$copyBuffer(p.data, ret, i);
                i += p.data.length;
                p = p.next;
            }
            return ret;
        };
        return BufferList;
    }();
    if ($3gWwf && $3gWwf.inspect && $3gWwf.inspect.custom) module.exports.prototype[$3gWwf.inspect.custom] = function() {
        var obj = $3gWwf.inspect({
            length: this.length
        });
        return this.constructor.name + ' ' + obj;
    };
});
parcelRegister("9tGJn", function(module, exports) {
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    function $6e67f7f8fc7376f2$var$destroy(err, cb) {
        var _this = this;
        var readableDestroyed = this._readableState && this._readableState.destroyed;
        var writableDestroyed = this._writableState && this._writableState.destroyed;
        if (readableDestroyed || writableDestroyed) {
            if (cb) cb(err);
            else if (err) {
                if (!this._writableState) $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, this, err);
                else if (!this._writableState.errorEmitted) {
                    this._writableState.errorEmitted = true;
                    $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, this, err);
                }
            }
            return this;
        }
        if (this._readableState) this._readableState.destroyed = true;
        if (this._writableState) this._writableState.destroyed = true;
        this._destroy(err || null, function(err) {
            if (!cb && err) {
                if (!_this._writableState) $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, _this, err);
                else if (!_this._writableState.errorEmitted) {
                    _this._writableState.errorEmitted = true;
                    $iWV9i.nextTick($6e67f7f8fc7376f2$var$emitErrorNT, _this, err);
                }
            } else if (cb) cb(err);
        });
        return this;
    }
    function $6e67f7f8fc7376f2$var$undestroy() {
        if (this._readableState) {
            this._readableState.destroyed = false;
            this._readableState.reading = false;
            this._readableState.ended = false;
            this._readableState.endEmitted = false;
        }
        if (this._writableState) {
            this._writableState.destroyed = false;
            this._writableState.ended = false;
            this._writableState.ending = false;
            this._writableState.finalCalled = false;
            this._writableState.prefinished = false;
            this._writableState.finished = false;
            this._writableState.errorEmitted = false;
        }
    }
    function $6e67f7f8fc7376f2$var$emitErrorNT(self, err) {
        self.emit('error', err);
    }
    module.exports = {
        destroy: $6e67f7f8fc7376f2$var$destroy,
        undestroy: $6e67f7f8fc7376f2$var$undestroy
    };
});
parcelRegister("fAlCy", function(module, exports) {
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    var $b58afd4655d03bd4$var$objectKeys = Object.keys || function(obj) {
        var keys = [];
        for(var key in obj)keys.push(key);
        return keys;
    };
    module.exports = $b58afd4655d03bd4$var$Duplex;
    var $b58afd4655d03bd4$var$util = Object.create((parcelRequire("fvDPy")));
    $b58afd4655d03bd4$var$util.inherits = (parcelRequire("v3bBu"));
    var $hVjIO = parcelRequire("hVjIO");
    var $3YGVr = parcelRequire("3YGVr");
    $b58afd4655d03bd4$var$util.inherits($b58afd4655d03bd4$var$Duplex, $hVjIO);
    var $b58afd4655d03bd4$var$keys = $b58afd4655d03bd4$var$objectKeys($3YGVr.prototype);
    for(var $b58afd4655d03bd4$var$v = 0; $b58afd4655d03bd4$var$v < $b58afd4655d03bd4$var$keys.length; $b58afd4655d03bd4$var$v++){
        var $b58afd4655d03bd4$var$method = $b58afd4655d03bd4$var$keys[$b58afd4655d03bd4$var$v];
        if (!$b58afd4655d03bd4$var$Duplex.prototype[$b58afd4655d03bd4$var$method]) $b58afd4655d03bd4$var$Duplex.prototype[$b58afd4655d03bd4$var$method] = $3YGVr.prototype[$b58afd4655d03bd4$var$method];
    }
    function $b58afd4655d03bd4$var$Duplex(options) {
        if (!(this instanceof $b58afd4655d03bd4$var$Duplex)) return new $b58afd4655d03bd4$var$Duplex(options);
        $hVjIO.call(this, options);
        $3YGVr.call(this, options);
        if (options && options.readable === false) this.readable = false;
        if (options && options.writable === false) this.writable = false;
        this.allowHalfOpen = true;
        if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
        this.once('end', $b58afd4655d03bd4$var$onend);
    }
    Object.defineProperty($b58afd4655d03bd4$var$Duplex.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function() {
            return this._writableState.highWaterMark;
        }
    });
    function $b58afd4655d03bd4$var$onend() {
        if (this.allowHalfOpen || this._writableState.ended) return;
        $iWV9i.nextTick($b58afd4655d03bd4$var$onEndNT, this);
    }
    function $b58afd4655d03bd4$var$onEndNT(self) {
        self.end();
    }
    Object.defineProperty($b58afd4655d03bd4$var$Duplex.prototype, 'destroyed', {
        get: function() {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set: function(value) {
            if (this._readableState === undefined || this._writableState === undefined) return;
            this._readableState.destroyed = value;
            this._writableState.destroyed = value;
        }
    });
    $b58afd4655d03bd4$var$Duplex.prototype._destroy = function(err, cb) {
        this.push(null);
        this.end();
        $iWV9i.nextTick(cb, err);
    };
});
parcelRegister("3YGVr", function(module, exports) {
    'use strict';
    var $iWV9i = parcelRequire("iWV9i");
    module.exports = $2e5845c95b44c650$var$Writable;
    function $2e5845c95b44c650$var$WriteReq(chunk, encoding, cb) {
        this.chunk = chunk;
        this.encoding = encoding;
        this.callback = cb;
        this.next = null;
    }
    function $2e5845c95b44c650$var$CorkedRequest(state) {
        var _this = this;
        this.next = null;
        this.entry = null;
        this.finish = function() {
            $2e5845c95b44c650$var$onCorkedFinish(_this, state);
        };
    }
    var $2e5845c95b44c650$var$asyncWrite = (0, $iWV9i.nextTick);
    var $2e5845c95b44c650$var$Duplex;
    $2e5845c95b44c650$var$Writable.WritableState = $2e5845c95b44c650$var$WritableState;
    var $2e5845c95b44c650$var$util = Object.create((parcelRequire("fvDPy")));
    $2e5845c95b44c650$var$util.inherits = (parcelRequire("v3bBu"));
    var $2e5845c95b44c650$var$internalUtil = {
        deprecate: (parcelRequire("geQ6V"))
    };
    var $4t6fq = parcelRequire("4t6fq");
    var $cmRjm = parcelRequire("cmRjm");
    var $2e5845c95b44c650$require$Buffer = $cmRjm.Buffer;
    var $2e5845c95b44c650$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
    function $2e5845c95b44c650$var$_uint8ArrayToBuffer(chunk) {
        return $2e5845c95b44c650$require$Buffer.from(chunk);
    }
    function $2e5845c95b44c650$var$_isUint8Array(obj) {
        return $2e5845c95b44c650$require$Buffer.isBuffer(obj) || obj instanceof $2e5845c95b44c650$var$OurUint8Array;
    }
    var $9tGJn = parcelRequire("9tGJn");
    $2e5845c95b44c650$var$util.inherits($2e5845c95b44c650$var$Writable, $4t6fq);
    function $2e5845c95b44c650$var$nop() {}
    function $2e5845c95b44c650$var$WritableState(options, stream) {
        $2e5845c95b44c650$var$Duplex = $2e5845c95b44c650$var$Duplex || (parcelRequire("fAlCy"));
        options = options || {};
        var isDuplex = stream instanceof $2e5845c95b44c650$var$Duplex;
        this.objectMode = !!options.objectMode;
        if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
        var hwm = options.highWaterMark;
        var writableHwm = options.writableHighWaterMark;
        var defaultHwm = this.objectMode ? 16 : 16384;
        if (hwm || hwm === 0) this.highWaterMark = hwm;
        else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
        else this.highWaterMark = defaultHwm;
        this.highWaterMark = Math.floor(this.highWaterMark);
        this.finalCalled = false;
        this.needDrain = false;
        this.ending = false;
        this.ended = false;
        this.finished = false;
        this.destroyed = false;
        var noDecode = options.decodeStrings === false;
        this.decodeStrings = !noDecode;
        this.defaultEncoding = options.defaultEncoding || 'utf8';
        this.length = 0;
        this.writing = false;
        this.corked = 0;
        this.sync = true;
        this.bufferProcessing = false;
        this.onwrite = function(er) {
            $2e5845c95b44c650$var$onwrite(stream, er);
        };
        this.writecb = null;
        this.writelen = 0;
        this.bufferedRequest = null;
        this.lastBufferedRequest = null;
        this.pendingcb = 0;
        this.prefinished = false;
        this.errorEmitted = false;
        this.bufferedRequestCount = 0;
        this.corkedRequestsFree = new $2e5845c95b44c650$var$CorkedRequest(this);
    }
    $2e5845c95b44c650$var$WritableState.prototype.getBuffer = function getBuffer() {
        var current = this.bufferedRequest;
        var out = [];
        while(current){
            out.push(current);
            current = current.next;
        }
        return out;
    };
    (function() {
        try {
            Object.defineProperty($2e5845c95b44c650$var$WritableState.prototype, 'buffer', {
                get: $2e5845c95b44c650$var$internalUtil.deprecate(function() {
                    return this.getBuffer();
                }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
            });
        } catch (_) {}
    })();
    var $2e5845c95b44c650$var$realHasInstance;
    if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
        $2e5845c95b44c650$var$realHasInstance = Function.prototype[Symbol.hasInstance];
        Object.defineProperty($2e5845c95b44c650$var$Writable, Symbol.hasInstance, {
            value: function(object) {
                if ($2e5845c95b44c650$var$realHasInstance.call(this, object)) return true;
                if (this !== $2e5845c95b44c650$var$Writable) return false;
                return object && object._writableState instanceof $2e5845c95b44c650$var$WritableState;
            }
        });
    } else $2e5845c95b44c650$var$realHasInstance = function(object) {
        return object instanceof this;
    };
    function $2e5845c95b44c650$var$Writable(options) {
        $2e5845c95b44c650$var$Duplex = $2e5845c95b44c650$var$Duplex || (parcelRequire("fAlCy"));
        if (!$2e5845c95b44c650$var$realHasInstance.call($2e5845c95b44c650$var$Writable, this) && !(this instanceof $2e5845c95b44c650$var$Duplex)) return new $2e5845c95b44c650$var$Writable(options);
        this._writableState = new $2e5845c95b44c650$var$WritableState(options, this);
        this.writable = true;
        if (options) {
            if (typeof options.write === 'function') this._write = options.write;
            if (typeof options.writev === 'function') this._writev = options.writev;
            if (typeof options.destroy === 'function') this._destroy = options.destroy;
            if (typeof options.final === 'function') this._final = options.final;
        }
        $4t6fq.call(this);
    }
    $2e5845c95b44c650$var$Writable.prototype.pipe = function() {
        this.emit('error', new Error('Cannot pipe, not readable'));
    };
    function $2e5845c95b44c650$var$writeAfterEnd(stream, cb) {
        var er = new Error('write after end');
        stream.emit('error', er);
        $iWV9i.nextTick(cb, er);
    }
    function $2e5845c95b44c650$var$validChunk(stream, state, chunk, cb) {
        var valid = true;
        var er = false;
        if (chunk === null) er = new TypeError('May not write null values to stream');
        else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
        if (er) {
            stream.emit('error', er);
            $iWV9i.nextTick(cb, er);
            valid = false;
        }
        return valid;
    }
    $2e5845c95b44c650$var$Writable.prototype.write = function(chunk, encoding, cb) {
        var state = this._writableState;
        var ret = false;
        var isBuf = !state.objectMode && $2e5845c95b44c650$var$_isUint8Array(chunk);
        if (isBuf && !$2e5845c95b44c650$require$Buffer.isBuffer(chunk)) chunk = $2e5845c95b44c650$var$_uint8ArrayToBuffer(chunk);
        if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (isBuf) encoding = 'buffer';
        else if (!encoding) encoding = state.defaultEncoding;
        if (typeof cb !== 'function') cb = $2e5845c95b44c650$var$nop;
        if (state.ended) $2e5845c95b44c650$var$writeAfterEnd(this, cb);
        else if (isBuf || $2e5845c95b44c650$var$validChunk(this, state, chunk, cb)) {
            state.pendingcb++;
            ret = $2e5845c95b44c650$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
        }
        return ret;
    };
    $2e5845c95b44c650$var$Writable.prototype.cork = function() {
        var state = this._writableState;
        state.corked++;
    };
    $2e5845c95b44c650$var$Writable.prototype.uncork = function() {
        var state = this._writableState;
        if (state.corked) {
            state.corked--;
            if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2e5845c95b44c650$var$clearBuffer(this, state);
        }
    };
    $2e5845c95b44c650$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
        if (typeof encoding === 'string') encoding = encoding.toLowerCase();
        if (!([
            'hex',
            'utf8',
            'utf-8',
            'ascii',
            'binary',
            'base64',
            'ucs2',
            'ucs-2',
            'utf16le',
            'utf-16le',
            'raw'
        ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
        this._writableState.defaultEncoding = encoding;
        return this;
    };
    function $2e5845c95b44c650$var$decodeChunk(state, chunk, encoding) {
        if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $2e5845c95b44c650$require$Buffer.from(chunk, encoding);
        return chunk;
    }
    Object.defineProperty($2e5845c95b44c650$var$Writable.prototype, 'writableHighWaterMark', {
        enumerable: false,
        get: function() {
            return this._writableState.highWaterMark;
        }
    });
    function $2e5845c95b44c650$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
        if (!isBuf) {
            var newChunk = $2e5845c95b44c650$var$decodeChunk(state, chunk, encoding);
            if (chunk !== newChunk) {
                isBuf = true;
                encoding = 'buffer';
                chunk = newChunk;
            }
        }
        var len = state.objectMode ? 1 : chunk.length;
        state.length += len;
        var ret = state.length < state.highWaterMark;
        if (!ret) state.needDrain = true;
        if (state.writing || state.corked) {
            var last = state.lastBufferedRequest;
            state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
            };
            if (last) last.next = state.lastBufferedRequest;
            else state.bufferedRequest = state.lastBufferedRequest;
            state.bufferedRequestCount += 1;
        } else $2e5845c95b44c650$var$doWrite(stream, state, false, len, chunk, encoding, cb);
        return ret;
    }
    function $2e5845c95b44c650$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
        state.writelen = len;
        state.writecb = cb;
        state.writing = true;
        state.sync = true;
        if (writev) stream._writev(chunk, state.onwrite);
        else stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    function $2e5845c95b44c650$var$onwriteError(stream, state, sync, er, cb) {
        --state.pendingcb;
        if (sync) {
            $iWV9i.nextTick(cb, er);
            $iWV9i.nextTick($2e5845c95b44c650$var$finishMaybe, stream, state);
            stream._writableState.errorEmitted = true;
            stream.emit('error', er);
        } else {
            cb(er);
            stream._writableState.errorEmitted = true;
            stream.emit('error', er);
            $2e5845c95b44c650$var$finishMaybe(stream, state);
        }
    }
    function $2e5845c95b44c650$var$onwriteStateUpdate(state) {
        state.writing = false;
        state.writecb = null;
        state.length -= state.writelen;
        state.writelen = 0;
    }
    function $2e5845c95b44c650$var$onwrite(stream, er) {
        var state = stream._writableState;
        var sync = state.sync;
        var cb = state.writecb;
        $2e5845c95b44c650$var$onwriteStateUpdate(state);
        if (er) $2e5845c95b44c650$var$onwriteError(stream, state, sync, er, cb);
        else {
            var finished = $2e5845c95b44c650$var$needFinish(state);
            if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2e5845c95b44c650$var$clearBuffer(stream, state);
            if (sync) $2e5845c95b44c650$var$asyncWrite($2e5845c95b44c650$var$afterWrite, stream, state, finished, cb);
            else $2e5845c95b44c650$var$afterWrite(stream, state, finished, cb);
        }
    }
    function $2e5845c95b44c650$var$afterWrite(stream, state, finished, cb) {
        if (!finished) $2e5845c95b44c650$var$onwriteDrain(stream, state);
        state.pendingcb--;
        cb();
        $2e5845c95b44c650$var$finishMaybe(stream, state);
    }
    function $2e5845c95b44c650$var$onwriteDrain(stream, state) {
        if (state.length === 0 && state.needDrain) {
            state.needDrain = false;
            stream.emit('drain');
        }
    }
    function $2e5845c95b44c650$var$clearBuffer(stream, state) {
        state.bufferProcessing = true;
        var entry = state.bufferedRequest;
        if (stream._writev && entry && entry.next) {
            var l = state.bufferedRequestCount;
            var buffer = new Array(l);
            var holder = state.corkedRequestsFree;
            holder.entry = entry;
            var count = 0;
            var allBuffers = true;
            while(entry){
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
            }
            buffer.allBuffers = allBuffers;
            $2e5845c95b44c650$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
            state.pendingcb++;
            state.lastBufferedRequest = null;
            if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
            } else state.corkedRequestsFree = new $2e5845c95b44c650$var$CorkedRequest(state);
            state.bufferedRequestCount = 0;
        } else {
            while(entry){
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                $2e5845c95b44c650$var$doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--;
                if (state.writing) break;
            }
            if (entry === null) state.lastBufferedRequest = null;
        }
        state.bufferedRequest = entry;
        state.bufferProcessing = false;
    }
    $2e5845c95b44c650$var$Writable.prototype._write = function(chunk, encoding, cb) {
        cb(new Error('_write() is not implemented'));
    };
    $2e5845c95b44c650$var$Writable.prototype._writev = null;
    $2e5845c95b44c650$var$Writable.prototype.end = function(chunk, encoding, cb) {
        var state = this._writableState;
        if (typeof chunk === 'function') {
            cb = chunk;
            chunk = null;
            encoding = null;
        } else if (typeof encoding === 'function') {
            cb = encoding;
            encoding = null;
        }
        if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
        if (state.corked) {
            state.corked = 1;
            this.uncork();
        }
        if (!state.ending) $2e5845c95b44c650$var$endWritable(this, state, cb);
    };
    function $2e5845c95b44c650$var$needFinish(state) {
        return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
    }
    function $2e5845c95b44c650$var$callFinal(stream, state) {
        stream._final(function(err) {
            state.pendingcb--;
            if (err) stream.emit('error', err);
            state.prefinished = true;
            stream.emit('prefinish');
            $2e5845c95b44c650$var$finishMaybe(stream, state);
        });
    }
    function $2e5845c95b44c650$var$prefinish(stream, state) {
        if (!state.prefinished && !state.finalCalled) {
            if (typeof stream._final === 'function') {
                state.pendingcb++;
                state.finalCalled = true;
                $iWV9i.nextTick($2e5845c95b44c650$var$callFinal, stream, state);
            } else {
                state.prefinished = true;
                stream.emit('prefinish');
            }
        }
    }
    function $2e5845c95b44c650$var$finishMaybe(stream, state) {
        var need = $2e5845c95b44c650$var$needFinish(state);
        if (need) {
            $2e5845c95b44c650$var$prefinish(stream, state);
            if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit('finish');
            }
        }
        return need;
    }
    function $2e5845c95b44c650$var$endWritable(stream, state, cb) {
        state.ending = true;
        $2e5845c95b44c650$var$finishMaybe(stream, state);
        if (cb) {
            if (state.finished) $iWV9i.nextTick(cb);
            else stream.once('finish', cb);
        }
        state.ended = true;
        stream.writable = false;
    }
    function $2e5845c95b44c650$var$onCorkedFinish(corkReq, state, err) {
        var entry = corkReq.entry;
        corkReq.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        state.corkedRequestsFree.next = corkReq;
    }
    Object.defineProperty($2e5845c95b44c650$var$Writable.prototype, 'destroyed', {
        get: function() {
            if (this._writableState === undefined) return false;
            return this._writableState.destroyed;
        },
        set: function(value) {
            if (!this._writableState) return;
            this._writableState.destroyed = value;
        }
    });
    $2e5845c95b44c650$var$Writable.prototype.destroy = $9tGJn.destroy;
    $2e5845c95b44c650$var$Writable.prototype._undestroy = $9tGJn.undestroy;
    $2e5845c95b44c650$var$Writable.prototype._destroy = function(err, cb) {
        this.end();
        cb(err);
    };
});
parcelRegister("6ayCS", function(module, exports) {
    $parcel$export(module.exports, "StringDecoder", ()=>$0128c026524ba8eb$export$63a7aa211a91ed69, (v)=>$0128c026524ba8eb$export$63a7aa211a91ed69 = v);
    var $0128c026524ba8eb$export$63a7aa211a91ed69;
    'use strict';
    var $cmRjm = parcelRequire("cmRjm");
    var $0128c026524ba8eb$require$Buffer = $cmRjm.Buffer;
    var $0128c026524ba8eb$var$isEncoding = $0128c026524ba8eb$require$Buffer.isEncoding || function(encoding) {
        encoding = '' + encoding;
        switch(encoding && encoding.toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
            case 'raw':
                return true;
            default:
                return false;
        }
    };
    function $0128c026524ba8eb$var$_normalizeEncoding(enc) {
        if (!enc) return 'utf8';
        var retried;
        while(true)switch(enc){
            case 'utf8':
            case 'utf-8':
                return 'utf8';
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return 'utf16le';
            case 'latin1':
            case 'binary':
                return 'latin1';
            case 'base64':
            case 'ascii':
            case 'hex':
                return enc;
            default:
                if (retried) return;
                enc = ('' + enc).toLowerCase();
                retried = true;
        }
    }
    function $0128c026524ba8eb$var$normalizeEncoding(enc) {
        var nenc = $0128c026524ba8eb$var$_normalizeEncoding(enc);
        if (typeof nenc !== 'string' && ($0128c026524ba8eb$require$Buffer.isEncoding === $0128c026524ba8eb$var$isEncoding || !$0128c026524ba8eb$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
        return nenc || enc;
    }
    $0128c026524ba8eb$export$63a7aa211a91ed69 = $0128c026524ba8eb$var$StringDecoder;
    function $0128c026524ba8eb$var$StringDecoder(encoding) {
        this.encoding = $0128c026524ba8eb$var$normalizeEncoding(encoding);
        var nb;
        switch(this.encoding){
            case 'utf16le':
                this.text = $0128c026524ba8eb$var$utf16Text;
                this.end = $0128c026524ba8eb$var$utf16End;
                nb = 4;
                break;
            case 'utf8':
                this.fillLast = $0128c026524ba8eb$var$utf8FillLast;
                nb = 4;
                break;
            case 'base64':
                this.text = $0128c026524ba8eb$var$base64Text;
                this.end = $0128c026524ba8eb$var$base64End;
                nb = 3;
                break;
            default:
                this.write = $0128c026524ba8eb$var$simpleWrite;
                this.end = $0128c026524ba8eb$var$simpleEnd;
                return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = $0128c026524ba8eb$require$Buffer.allocUnsafe(nb);
    }
    $0128c026524ba8eb$var$StringDecoder.prototype.write = function(buf) {
        if (buf.length === 0) return '';
        var r;
        var i;
        if (this.lastNeed) {
            r = this.fillLast(buf);
            if (r === undefined) return '';
            i = this.lastNeed;
            this.lastNeed = 0;
        } else i = 0;
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || '';
    };
    $0128c026524ba8eb$var$StringDecoder.prototype.end = $0128c026524ba8eb$var$utf8End;
    $0128c026524ba8eb$var$StringDecoder.prototype.text = $0128c026524ba8eb$var$utf8Text;
    $0128c026524ba8eb$var$StringDecoder.prototype.fillLast = function(buf) {
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
    };
    function $0128c026524ba8eb$var$utf8CheckByte(byte) {
        if (byte <= 0x7F) return 0;
        else if (byte >> 5 === 0x06) return 2;
        else if (byte >> 4 === 0x0E) return 3;
        else if (byte >> 3 === 0x1E) return 4;
        return byte >> 6 === 0x02 ? -1 : -2;
    }
    function $0128c026524ba8eb$var$utf8CheckIncomplete(self, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 1;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) self.lastNeed = nb - 2;
            return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = $0128c026524ba8eb$var$utf8CheckByte(buf[j]);
        if (nb >= 0) {
            if (nb > 0) {
                if (nb === 2) nb = 0;
                else self.lastNeed = nb - 3;
            }
            return nb;
        }
        return 0;
    }
    function $0128c026524ba8eb$var$utf8CheckExtraBytes(self, buf, p) {
        if ((buf[0] & 0xC0) !== 0x80) {
            self.lastNeed = 0;
            return '\ufffd';
        }
        if (self.lastNeed > 1 && buf.length > 1) {
            if ((buf[1] & 0xC0) !== 0x80) {
                self.lastNeed = 1;
                return '\ufffd';
            }
            if (self.lastNeed > 2 && buf.length > 2) {
                if ((buf[2] & 0xC0) !== 0x80) {
                    self.lastNeed = 2;
                    return '\ufffd';
                }
            }
        }
    }
    function $0128c026524ba8eb$var$utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = $0128c026524ba8eb$var$utf8CheckExtraBytes(this, buf, p);
        if (r !== undefined) return r;
        if (this.lastNeed <= buf.length) {
            buf.copy(this.lastChar, p, 0, this.lastNeed);
            return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
    }
    function $0128c026524ba8eb$var$utf8Text(buf, i) {
        var total = $0128c026524ba8eb$var$utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString('utf8', i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString('utf8', i, end);
    }
    function $0128c026524ba8eb$var$utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + '\ufffd';
        return r;
    }
    function $0128c026524ba8eb$var$utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
            var r = buf.toString('utf16le', i);
            if (r) {
                var c = r.charCodeAt(r.length - 1);
                if (c >= 0xD800 && c <= 0xDBFF) {
                    this.lastNeed = 2;
                    this.lastTotal = 4;
                    this.lastChar[0] = buf[buf.length - 2];
                    this.lastChar[1] = buf[buf.length - 1];
                    return r.slice(0, -1);
                }
            }
            return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString('utf16le', i, buf.length - 1);
    }
    function $0128c026524ba8eb$var$utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) {
            var end = this.lastTotal - this.lastNeed;
            return r + this.lastChar.toString('utf16le', 0, end);
        }
        return r;
    }
    function $0128c026524ba8eb$var$base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString('base64', i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) this.lastChar[0] = buf[buf.length - 1];
        else {
            this.lastChar[0] = buf[buf.length - 2];
            this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString('base64', i, buf.length - n);
    }
    function $0128c026524ba8eb$var$base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
        return r;
    }
    function $0128c026524ba8eb$var$simpleWrite(buf) {
        return buf.toString(this.encoding);
    }
    function $0128c026524ba8eb$var$simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : '';
    }
});
parcelRegister("8iQyH", function(module, exports) {
    'use strict';
    module.exports = $60b8c636590317a6$var$Transform;
    var $fAlCy = parcelRequire("fAlCy");
    var $60b8c636590317a6$var$util = Object.create((parcelRequire("fvDPy")));
    $60b8c636590317a6$var$util.inherits = (parcelRequire("v3bBu"));
    $60b8c636590317a6$var$util.inherits($60b8c636590317a6$var$Transform, $fAlCy);
    function $60b8c636590317a6$var$afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;
        if (!cb) return this.emit('error', new Error('write callback called multiple times'));
        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;
        if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
    function $60b8c636590317a6$var$Transform(options) {
        if (!(this instanceof $60b8c636590317a6$var$Transform)) return new $60b8c636590317a6$var$Transform(options);
        $fAlCy.call(this, options);
        this._transformState = {
            afterTransform: $60b8c636590317a6$var$afterTransform.bind(this),
            needTransform: false,
            transforming: false,
            writecb: null,
            writechunk: null,
            writeencoding: null
        };
        this._readableState.needReadable = true;
        this._readableState.sync = false;
        if (options) {
            if (typeof options.transform === 'function') this._transform = options.transform;
            if (typeof options.flush === 'function') this._flush = options.flush;
        }
        this.on('prefinish', $60b8c636590317a6$var$prefinish);
    }
    function $60b8c636590317a6$var$prefinish() {
        var _this = this;
        if (typeof this._flush === 'function') this._flush(function(er, data) {
            $60b8c636590317a6$var$done(_this, er, data);
        });
        else $60b8c636590317a6$var$done(this, null, null);
    }
    $60b8c636590317a6$var$Transform.prototype.push = function(chunk, encoding) {
        this._transformState.needTransform = false;
        return $fAlCy.prototype.push.call(this, chunk, encoding);
    };
    $60b8c636590317a6$var$Transform.prototype._transform = function(chunk, encoding, cb) {
        throw new Error('_transform() is not implemented');
    };
    $60b8c636590317a6$var$Transform.prototype._write = function(chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;
        if (!ts.transforming) {
            var rs = this._readableState;
            if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
    };
    $60b8c636590317a6$var$Transform.prototype._read = function(n) {
        var ts = this._transformState;
        if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
            ts.transforming = true;
            this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else ts.needTransform = true;
    };
    $60b8c636590317a6$var$Transform.prototype._destroy = function(err, cb) {
        var _this2 = this;
        $fAlCy.prototype._destroy.call(this, err, function(err2) {
            cb(err2);
            _this2.emit('close');
        });
    };
    function $60b8c636590317a6$var$done(stream, er, data) {
        if (er) return stream.emit('error', er);
        if (data != null) stream.push(data);
        if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
        if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
        return stream.push(null);
    }
});
parcelRegister("WEefO", function(module, exports) {
    'use strict';
    module.exports = $0b049f8430f02ec4$var$PassThrough;
    var $8iQyH = parcelRequire("8iQyH");
    var $0b049f8430f02ec4$var$util = Object.create((parcelRequire("fvDPy")));
    $0b049f8430f02ec4$var$util.inherits = (parcelRequire("v3bBu"));
    $0b049f8430f02ec4$var$util.inherits($0b049f8430f02ec4$var$PassThrough, $8iQyH);
    function $0b049f8430f02ec4$var$PassThrough(options) {
        if (!(this instanceof $0b049f8430f02ec4$var$PassThrough)) return new $0b049f8430f02ec4$var$PassThrough(options);
        $8iQyH.call(this, options);
    }
    $0b049f8430f02ec4$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
        cb(null, chunk);
    };
});
parcelRegister("kYhYb", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $f44759abe9feb4ae$require$Buffer = $Wth4q.Buffer;
    var $j65bP = parcelRequire("j65bP");
    var $cfrZu;
    var $8JoQd = parcelRequire("8JoQd");
    var $f44759abe9feb4ae$require$EC = $8JoQd.ec;
    var $bxS53 = parcelRequire("bxS53");
    var $ejFGc = parcelRequire("ejFGc");
    var $jf5f0 = parcelRequire("jf5f0");
    var $f44759abe9feb4ae$var$RSA_PKCS1_PADDING = 1;
    function $f44759abe9feb4ae$var$sign(hash, key, hashType, signType, tag) {
        var priv = $ejFGc(key);
        if (priv.curve) {
            if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
            return $f44759abe9feb4ae$var$ecSign(hash, priv);
        } else if (priv.type === 'dsa') {
            if (signType !== 'dsa') throw new Error('wrong private key type');
            return $f44759abe9feb4ae$var$dsaSign(hash, priv, hashType);
        }
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        if (key.padding !== undefined && key.padding !== $f44759abe9feb4ae$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
        hash = $f44759abe9feb4ae$require$Buffer.concat([
            tag,
            hash
        ]);
        var len = priv.modulus.byteLength();
        var pad = [
            0,
            1
        ];
        while(hash.length + pad.length + 1 < len)pad.push(0xff);
        pad.push(0x00);
        var i = -1;
        while(++i < hash.length)pad.push(hash[i]);
        var out = (0, parcelRequire("cfrZu"))(pad, priv);
        return out;
    }
    function $f44759abe9feb4ae$var$ecSign(hash, priv) {
        var curveId = $jf5f0[priv.curve.join('.')];
        if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
        var curve = new $f44759abe9feb4ae$require$EC(curveId);
        var key = curve.keyFromPrivate(priv.privateKey);
        var out = key.sign(hash);
        return $f44759abe9feb4ae$require$Buffer.from(out.toDER());
    }
    function $f44759abe9feb4ae$var$dsaSign(hash, priv, algo) {
        var x = priv.params.priv_key;
        var p = priv.params.p;
        var q = priv.params.q;
        var g = priv.params.g;
        var r = new $bxS53(0);
        var k;
        var H = $f44759abe9feb4ae$var$bits2int(hash, q).mod(q);
        var s = false;
        var kv = $f44759abe9feb4ae$var$getKey(x, q, hash, algo);
        while(s === false){
            k = $f44759abe9feb4ae$var$makeKey(q, kv, algo);
            r = $f44759abe9feb4ae$var$makeR(g, k, p, q);
            s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
            if (s.cmpn(0) === 0) {
                s = false;
                r = new $bxS53(0);
            }
        }
        return $f44759abe9feb4ae$var$toDER(r, s);
    }
    function $f44759abe9feb4ae$var$toDER(r, s) {
        r = r.toArray();
        s = s.toArray();
        if (r[0] & 0x80) r = [
            0
        ].concat(r);
        if (s[0] & 0x80) s = [
            0
        ].concat(s);
        var total = r.length + s.length + 4;
        var res = [
            0x30,
            total,
            0x02,
            r.length
        ];
        res = res.concat(r, [
            0x02,
            s.length
        ], s);
        return $f44759abe9feb4ae$require$Buffer.from(res);
    }
    function $f44759abe9feb4ae$var$getKey(x, q, hash, algo) {
        x = $f44759abe9feb4ae$require$Buffer.from(x.toArray());
        if (x.length < q.byteLength()) {
            var zeros = $f44759abe9feb4ae$require$Buffer.alloc(q.byteLength() - x.length);
            x = $f44759abe9feb4ae$require$Buffer.concat([
                zeros,
                x
            ]);
        }
        var hlen = hash.length;
        var hbits = $f44759abe9feb4ae$var$bits2octets(hash, q);
        var v = $f44759abe9feb4ae$require$Buffer.alloc(hlen);
        v.fill(1);
        var k = $f44759abe9feb4ae$require$Buffer.alloc(hlen);
        k = $j65bP(algo, k).update(v).update($f44759abe9feb4ae$require$Buffer.from([
            0
        ])).update(x).update(hbits).digest();
        v = $j65bP(algo, k).update(v).digest();
        k = $j65bP(algo, k).update(v).update($f44759abe9feb4ae$require$Buffer.from([
            1
        ])).update(x).update(hbits).digest();
        v = $j65bP(algo, k).update(v).digest();
        return {
            k: k,
            v: v
        };
    }
    function $f44759abe9feb4ae$var$bits2int(obits, q) {
        var bits = new $bxS53(obits);
        var shift = (obits.length << 3) - q.bitLength();
        if (shift > 0) bits.ishrn(shift);
        return bits;
    }
    function $f44759abe9feb4ae$var$bits2octets(bits, q) {
        bits = $f44759abe9feb4ae$var$bits2int(bits, q);
        bits = bits.mod(q);
        var out = $f44759abe9feb4ae$require$Buffer.from(bits.toArray());
        if (out.length < q.byteLength()) {
            var zeros = $f44759abe9feb4ae$require$Buffer.alloc(q.byteLength() - out.length);
            out = $f44759abe9feb4ae$require$Buffer.concat([
                zeros,
                out
            ]);
        }
        return out;
    }
    function $f44759abe9feb4ae$var$makeKey(q, kv, algo) {
        var t;
        var k;
        do {
            t = $f44759abe9feb4ae$require$Buffer.alloc(0);
            while(t.length * 8 < q.bitLength()){
                kv.v = $j65bP(algo, kv.k).update(kv.v).digest();
                t = $f44759abe9feb4ae$require$Buffer.concat([
                    t,
                    kv.v
                ]);
            }
            k = $f44759abe9feb4ae$var$bits2int(t, q);
            kv.k = $j65bP(algo, kv.k).update(kv.v).update($f44759abe9feb4ae$require$Buffer.from([
                0
            ])).digest();
            kv.v = $j65bP(algo, kv.k).update(kv.v).digest();
        }while (k.cmp(q) !== -1)
        return k;
    }
    function $f44759abe9feb4ae$var$makeR(g, k, p, q) {
        return g.toRed($bxS53.mont(p)).redPow(k).fromRed().mod(q);
    }
    module.exports = $f44759abe9feb4ae$var$sign;
    module.exports.getKey = $f44759abe9feb4ae$var$getKey;
    module.exports.makeKey = $f44759abe9feb4ae$var$makeKey;
});
parcelRegister("cfrZu", function(module, exports) {
    'use strict';
    var $bSSUf = parcelRequire("bSSUf");
    var $1DyI6 = parcelRequire("1DyI6");
    var $Wth4q = parcelRequire("Wth4q");
    var $8eac99241a98d6c0$require$Buffer = $Wth4q.Buffer;
    function $8eac99241a98d6c0$var$getr(priv) {
        var len = priv.modulus.byteLength();
        var r;
        do r = new $bSSUf($1DyI6(len));
        while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
        return r;
    }
    function $8eac99241a98d6c0$var$blind(priv) {
        var r = $8eac99241a98d6c0$var$getr(priv);
        var blinder = r.toRed($bSSUf.mont(priv.modulus)).redPow(new $bSSUf(priv.publicExponent)).fromRed();
        return {
            blinder: blinder,
            unblinder: r.invm(priv.modulus)
        };
    }
    function $8eac99241a98d6c0$var$crt(msg, priv) {
        var blinds = $8eac99241a98d6c0$var$blind(priv);
        var len = priv.modulus.byteLength();
        var blinded = new $bSSUf(msg).mul(blinds.blinder).umod(priv.modulus);
        var c1 = blinded.toRed($bSSUf.mont(priv.prime1));
        var c2 = blinded.toRed($bSSUf.mont(priv.prime2));
        var qinv = priv.coefficient;
        var p = priv.prime1;
        var q = priv.prime2;
        var m1 = c1.redPow(priv.exponent1).fromRed();
        var m2 = c2.redPow(priv.exponent2).fromRed();
        var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
        return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($8eac99241a98d6c0$require$Buffer, 'be', len);
    }
    $8eac99241a98d6c0$var$crt.getr = $8eac99241a98d6c0$var$getr;
    module.exports = $8eac99241a98d6c0$var$crt;
});
parcelRegister("bSSUf", function(module, exports) {
    (function(module1, exports) {
        'use strict';
        function assert(val, msg) {
            if (!val) throw new Error(msg || 'Assertion failed');
        }
        function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
        function BN(number, base, endian) {
            if (BN.isBN(number)) return number;
            this.negative = 0;
            this.words = null;
            this.length = 0;
            this.red = null;
            if (number !== null) {
                if (base === 'le' || base === 'be') {
                    endian = base;
                    base = 10;
                }
                this._init(number || 0, base || 10, endian || 'be');
            }
        }
        if (typeof module1 === 'object') module1.exports = BN;
        else exports.BN = BN;
        BN.BN = BN;
        BN.wordSize = 26;
        var Buffer;
        try {
            if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
            else Buffer = (parcelRequire("3gWwf")).Buffer;
        } catch (e) {}
        BN.isBN = function isBN(num) {
            if (num instanceof BN) return true;
            return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };
        BN.max = function max(left, right) {
            if (left.cmp(right) > 0) return left;
            return right;
        };
        BN.min = function min(left, right) {
            if (left.cmp(right) < 0) return left;
            return right;
        };
        BN.prototype._init = function init(number, base, endian) {
            if (typeof number === 'number') return this._initNumber(number, base, endian);
            if (typeof number === 'object') return this._initArray(number, base, endian);
            if (base === 'hex') base = 16;
            assert(base === (base | 0) && base >= 2 && base <= 36);
            number = number.toString().replace(/\s+/g, '');
            var start = 0;
            if (number[0] === '-') {
                start++;
                this.negative = 1;
            }
            if (start < number.length) {
                if (base === 16) this._parseHex(number, start, endian);
                else {
                    this._parseBase(number, base, start);
                    if (endian === 'le') this._initArray(this.toArray(), base, endian);
                }
            }
        };
        BN.prototype._initNumber = function _initNumber(number, base, endian) {
            if (number < 0) {
                this.negative = 1;
                number = -number;
            }
            if (number < 0x4000000) {
                this.words = [
                    number & 0x3ffffff
                ];
                this.length = 1;
            } else if (number < 0x10000000000000) {
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff
                ];
                this.length = 2;
            } else {
                assert(number < 0x20000000000000);
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff,
                    1
                ];
                this.length = 3;
            }
            if (endian !== 'le') return;
            this._initArray(this.toArray(), base, endian);
        };
        BN.prototype._initArray = function _initArray(number, base, endian) {
            assert(typeof number.length === 'number');
            if (number.length <= 0) {
                this.words = [
                    0
                ];
                this.length = 1;
                return this;
            }
            this.length = Math.ceil(number.length / 3);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var j, w;
            var off = 0;
            if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            return this._strip();
        };
        function parseHex4Bits(string, index) {
            var c = string.charCodeAt(index);
            if (c >= 48 && c <= 57) return c - 48;
            else if (c >= 65 && c <= 70) return c - 55;
            else if (c >= 97 && c <= 102) return c - 87;
            else assert(false, 'Invalid character in ' + string);
        }
        function parseHexByte(string, lowerBound, index) {
            var r = parseHex4Bits(string, index);
            if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
            return r;
        }
        BN.prototype._parseHex = function _parseHex(number, start, endian) {
            this.length = Math.ceil((number.length - start) / 6);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var off = 0;
            var j = 0;
            var w;
            if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
            else {
                var parseLength = number.length - start;
                for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                    w = parseHexByte(number, start, i) << off;
                    this.words[j] |= w & 0x3ffffff;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
            }
            this._strip();
        };
        function parseBase(str, start, end, mul) {
            var r = 0;
            var b = 0;
            var len = Math.min(str.length, end);
            for(var i = start; i < len; i++){
                var c = str.charCodeAt(i) - 48;
                r *= mul;
                if (c >= 49) b = c - 49 + 0xa;
                else if (c >= 17) b = c - 17 + 0xa;
                else b = c;
                assert(c >= 0 && b < mul, 'Invalid character');
                r += b;
            }
            return r;
        }
        BN.prototype._parseBase = function _parseBase(number, base, start) {
            this.words = [
                0
            ];
            this.length = 1;
            for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
            limbLen--;
            limbPow = limbPow / base | 0;
            var total = number.length - start;
            var mod = total % limbLen;
            var end = Math.min(total, total - mod) + start;
            var word = 0;
            for(var i = start; i < end; i += limbLen){
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for(i = 0; i < mod; i++)pow *= base;
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            this._strip();
        };
        BN.prototype.copy = function copy(dest) {
            dest.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
            dest.length = this.length;
            dest.negative = this.negative;
            dest.red = this.red;
        };
        function move(dest, src) {
            dest.words = src.words;
            dest.length = src.length;
            dest.negative = src.negative;
            dest.red = src.red;
        }
        BN.prototype._move = function _move(dest) {
            move(dest, this);
        };
        BN.prototype.clone = function clone() {
            var r = new BN(null);
            this.copy(r);
            return r;
        };
        BN.prototype._expand = function _expand(size) {
            while(this.length < size)this.words[this.length++] = 0;
            return this;
        };
        BN.prototype._strip = function strip() {
            while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
            return this._normSign();
        };
        BN.prototype._normSign = function _normSign() {
            if (this.length === 1 && this.words[0] === 0) this.negative = 0;
            return this;
        };
        if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
            BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
        } catch (e) {
            BN.prototype.inspect = inspect;
        }
        else BN.prototype.inspect = inspect;
        function inspect() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        }
        var zeros = [
            '',
            '0',
            '00',
            '000',
            '0000',
            '00000',
            '000000',
            '0000000',
            '00000000',
            '000000000',
            '0000000000',
            '00000000000',
            '000000000000',
            '0000000000000',
            '00000000000000',
            '000000000000000',
            '0000000000000000',
            '00000000000000000',
            '000000000000000000',
            '0000000000000000000',
            '00000000000000000000',
            '000000000000000000000',
            '0000000000000000000000',
            '00000000000000000000000',
            '000000000000000000000000',
            '0000000000000000000000000'
        ];
        var groupSizes = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ];
        var groupBases = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            10000000,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64000000,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            24300000,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        BN.prototype.toString = function toString(base, padding) {
            base = base || 10;
            padding = padding | 0 || 1;
            var out;
            if (base === 16 || base === 'hex') {
                out = '';
                var off = 0;
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = this.words[i];
                    var word = ((w << off | carry) & 0xffffff).toString(16);
                    carry = w >>> 24 - off & 0xffffff;
                    off += 2;
                    if (off >= 26) {
                        off -= 26;
                        i--;
                    }
                    if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                    else out = word + out;
                }
                if (carry !== 0) out = carry.toString(16) + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            if (base === (base | 0) && base >= 2 && base <= 36) {
                var groupSize = groupSizes[base];
                var groupBase = groupBases[base];
                out = '';
                var c = this.clone();
                c.negative = 0;
                while(!c.isZero()){
                    var r = c.modrn(groupBase).toString(base);
                    c = c.idivn(groupBase);
                    if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                    else out = r + out;
                }
                if (this.isZero()) out = '0' + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            assert(false, 'Base should be between 2 and 36');
        };
        BN.prototype.toNumber = function toNumber() {
            var ret = this.words[0];
            if (this.length === 2) ret += this.words[1] * 0x4000000;
            else if (this.length === 3 && this.words[2] === 0x01) ret += 0x10000000000000 + this.words[1] * 0x4000000;
            else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
            return this.negative !== 0 ? -ret : ret;
        };
        BN.prototype.toJSON = function toJSON() {
            return this.toString(16, 2);
        };
        if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
            return this.toArrayLike(Buffer, endian, length);
        };
        BN.prototype.toArray = function toArray(endian, length) {
            return this.toArrayLike(Array, endian, length);
        };
        var allocate = function allocate(ArrayType, size) {
            if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
            return new ArrayType(size);
        };
        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
            this._strip();
            var byteLength = this.byteLength();
            var reqLength = length || Math.max(1, byteLength);
            assert(byteLength <= reqLength, 'byte array longer than desired length');
            assert(reqLength > 0, 'Requested array length <= 0');
            var res = allocate(ArrayType, reqLength);
            var postfix = endian === 'le' ? 'LE' : 'BE';
            this['_toArrayLike' + postfix](res, byteLength);
            return res;
        };
        BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
            var position = 0;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position++] = word & 0xff;
                if (position < res.length) res[position++] = word >> 8 & 0xff;
                if (position < res.length) res[position++] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position < res.length) res[position++] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position < res.length) {
                res[position++] = carry;
                while(position < res.length)res[position++] = 0;
            }
        };
        BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
            var position = res.length - 1;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position--] = word & 0xff;
                if (position >= 0) res[position--] = word >> 8 & 0xff;
                if (position >= 0) res[position--] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position >= 0) res[position--] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position >= 0) {
                res[position--] = carry;
                while(position >= 0)res[position--] = 0;
            }
        };
        if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
        };
        else BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
                r += 13;
                t >>>= 13;
            }
            if (t >= 0x40) {
                r += 7;
                t >>>= 7;
            }
            if (t >= 0x8) {
                r += 4;
                t >>>= 4;
            }
            if (t >= 0x02) {
                r += 2;
                t >>>= 2;
            }
            return r + t;
        };
        BN.prototype._zeroBits = function _zeroBits(w) {
            if (w === 0) return 26;
            var t = w;
            var r = 0;
            if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
            }
            if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
            }
            if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
            }
            if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
            }
            if ((t & 0x1) === 0) r++;
            return r;
        };
        BN.prototype.bitLength = function bitLength() {
            var w = this.words[this.length - 1];
            var hi = this._countBits(w);
            return (this.length - 1) * 26 + hi;
        };
        function toBitArray(num) {
            var w = new Array(num.bitLength());
            for(var bit = 0; bit < w.length; bit++){
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                w[bit] = num.words[off] >>> wbit & 0x01;
            }
            return w;
        }
        BN.prototype.zeroBits = function zeroBits() {
            if (this.isZero()) return 0;
            var r = 0;
            for(var i = 0; i < this.length; i++){
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
            }
            return r;
        };
        BN.prototype.byteLength = function byteLength() {
            return Math.ceil(this.bitLength() / 8);
        };
        BN.prototype.toTwos = function toTwos(width) {
            if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
            return this.clone();
        };
        BN.prototype.fromTwos = function fromTwos(width) {
            if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
            return this.clone();
        };
        BN.prototype.isNeg = function isNeg() {
            return this.negative !== 0;
        };
        BN.prototype.neg = function neg() {
            return this.clone().ineg();
        };
        BN.prototype.ineg = function ineg() {
            if (!this.isZero()) this.negative ^= 1;
            return this;
        };
        BN.prototype.iuor = function iuor(num) {
            while(this.length < num.length)this.words[this.length++] = 0;
            for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
            return this._strip();
        };
        BN.prototype.ior = function ior(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuor(num);
        };
        BN.prototype.or = function or(num) {
            if (this.length > num.length) return this.clone().ior(num);
            return num.clone().ior(this);
        };
        BN.prototype.uor = function uor(num) {
            if (this.length > num.length) return this.clone().iuor(num);
            return num.clone().iuor(this);
        };
        BN.prototype.iuand = function iuand(num) {
            var b;
            if (this.length > num.length) b = num;
            else b = this;
            for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
            this.length = b.length;
            return this._strip();
        };
        BN.prototype.iand = function iand(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuand(num);
        };
        BN.prototype.and = function and(num) {
            if (this.length > num.length) return this.clone().iand(num);
            return num.clone().iand(this);
        };
        BN.prototype.uand = function uand(num) {
            if (this.length > num.length) return this.clone().iuand(num);
            return num.clone().iuand(this);
        };
        BN.prototype.iuxor = function iuxor(num) {
            var a;
            var b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
            if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = a.length;
            return this._strip();
        };
        BN.prototype.ixor = function ixor(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuxor(num);
        };
        BN.prototype.xor = function xor(num) {
            if (this.length > num.length) return this.clone().ixor(num);
            return num.clone().ixor(this);
        };
        BN.prototype.uxor = function uxor(num) {
            if (this.length > num.length) return this.clone().iuxor(num);
            return num.clone().iuxor(this);
        };
        BN.prototype.inotn = function inotn(width) {
            assert(typeof width === 'number' && width >= 0);
            var bytesNeeded = Math.ceil(width / 26) | 0;
            var bitsLeft = width % 26;
            this._expand(bytesNeeded);
            if (bitsLeft > 0) bytesNeeded--;
            for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
            if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            return this._strip();
        };
        BN.prototype.notn = function notn(width) {
            return this.clone().inotn(width);
        };
        BN.prototype.setn = function setn(bit, val) {
            assert(typeof bit === 'number' && bit >= 0);
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            this._expand(off + 1);
            if (val) this.words[off] = this.words[off] | 1 << wbit;
            else this.words[off] = this.words[off] & ~(1 << wbit);
            return this._strip();
        };
        BN.prototype.iadd = function iadd(num) {
            var r;
            if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign();
            } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
            }
            var a, b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            this.length = a.length;
            if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++;
            } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            return this;
        };
        BN.prototype.add = function add(num) {
            var res;
            if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
            } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
            }
            if (this.length > num.length) return this.clone().iadd(num);
            return num.clone().iadd(this);
        };
        BN.prototype.isub = function isub(num) {
            if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign();
            } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
            }
            var cmp = this.cmp(num);
            if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
            }
            var a, b;
            if (cmp > 0) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = Math.max(this.length, i);
            if (a !== this) this.negative = 1;
            return this._strip();
        };
        BN.prototype.sub = function sub(num) {
            return this.clone().isub(num);
        };
        function smallMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            var len = self.length + num.length | 0;
            out.length = len;
            len = len - 1 | 0;
            var a = self.words[0] | 0;
            var b = num.words[0] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            var carry = r / 0x4000000 | 0;
            out.words[0] = lo;
            for(var k = 1; k < len; k++){
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j | 0;
                    a = self.words[i] | 0;
                    b = num.words[j] | 0;
                    r = a * b + rword;
                    ncarry += r / 0x4000000 | 0;
                    rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
            }
            if (carry !== 0) out.words[k] = carry | 0;
            else out.length--;
            return out._strip();
        }
        var comb10MulTo = function comb10MulTo(self, num, out) {
            var a = self.words;
            var b = num.words;
            var o = out.words;
            var c = 0;
            var lo;
            var mid;
            var hi;
            var a0 = a[0] | 0;
            var al0 = a0 & 0x1fff;
            var ah0 = a0 >>> 13;
            var a1 = a[1] | 0;
            var al1 = a1 & 0x1fff;
            var ah1 = a1 >>> 13;
            var a2 = a[2] | 0;
            var al2 = a2 & 0x1fff;
            var ah2 = a2 >>> 13;
            var a3 = a[3] | 0;
            var al3 = a3 & 0x1fff;
            var ah3 = a3 >>> 13;
            var a4 = a[4] | 0;
            var al4 = a4 & 0x1fff;
            var ah4 = a4 >>> 13;
            var a5 = a[5] | 0;
            var al5 = a5 & 0x1fff;
            var ah5 = a5 >>> 13;
            var a6 = a[6] | 0;
            var al6 = a6 & 0x1fff;
            var ah6 = a6 >>> 13;
            var a7 = a[7] | 0;
            var al7 = a7 & 0x1fff;
            var ah7 = a7 >>> 13;
            var a8 = a[8] | 0;
            var al8 = a8 & 0x1fff;
            var ah8 = a8 >>> 13;
            var a9 = a[9] | 0;
            var al9 = a9 & 0x1fff;
            var ah9 = a9 >>> 13;
            var b0 = b[0] | 0;
            var bl0 = b0 & 0x1fff;
            var bh0 = b0 >>> 13;
            var b1 = b[1] | 0;
            var bl1 = b1 & 0x1fff;
            var bh1 = b1 >>> 13;
            var b2 = b[2] | 0;
            var bl2 = b2 & 0x1fff;
            var bh2 = b2 >>> 13;
            var b3 = b[3] | 0;
            var bl3 = b3 & 0x1fff;
            var bh3 = b3 >>> 13;
            var b4 = b[4] | 0;
            var bl4 = b4 & 0x1fff;
            var bh4 = b4 >>> 13;
            var b5 = b[5] | 0;
            var bl5 = b5 & 0x1fff;
            var bh5 = b5 >>> 13;
            var b6 = b[6] | 0;
            var bl6 = b6 & 0x1fff;
            var bh6 = b6 >>> 13;
            var b7 = b[7] | 0;
            var bl7 = b7 & 0x1fff;
            var bh7 = b7 >>> 13;
            var b8 = b[8] | 0;
            var bl8 = b8 & 0x1fff;
            var bh8 = b8 >>> 13;
            var b9 = b[9] | 0;
            var bl9 = b9 & 0x1fff;
            var bh9 = b9 >>> 13;
            out.negative = self.negative ^ num.negative;
            out.length = 19;
            lo = Math.imul(al0, bl0);
            mid = Math.imul(al0, bh0);
            mid = mid + Math.imul(ah0, bl0) | 0;
            hi = Math.imul(ah0, bh0);
            var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
            w0 &= 0x3ffffff;
            lo = Math.imul(al1, bl0);
            mid = Math.imul(al1, bh0);
            mid = mid + Math.imul(ah1, bl0) | 0;
            hi = Math.imul(ah1, bh0);
            lo = lo + Math.imul(al0, bl1) | 0;
            mid = mid + Math.imul(al0, bh1) | 0;
            mid = mid + Math.imul(ah0, bl1) | 0;
            hi = hi + Math.imul(ah0, bh1) | 0;
            var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
            w1 &= 0x3ffffff;
            lo = Math.imul(al2, bl0);
            mid = Math.imul(al2, bh0);
            mid = mid + Math.imul(ah2, bl0) | 0;
            hi = Math.imul(ah2, bh0);
            lo = lo + Math.imul(al1, bl1) | 0;
            mid = mid + Math.imul(al1, bh1) | 0;
            mid = mid + Math.imul(ah1, bl1) | 0;
            hi = hi + Math.imul(ah1, bh1) | 0;
            lo = lo + Math.imul(al0, bl2) | 0;
            mid = mid + Math.imul(al0, bh2) | 0;
            mid = mid + Math.imul(ah0, bl2) | 0;
            hi = hi + Math.imul(ah0, bh2) | 0;
            var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
            w2 &= 0x3ffffff;
            lo = Math.imul(al3, bl0);
            mid = Math.imul(al3, bh0);
            mid = mid + Math.imul(ah3, bl0) | 0;
            hi = Math.imul(ah3, bh0);
            lo = lo + Math.imul(al2, bl1) | 0;
            mid = mid + Math.imul(al2, bh1) | 0;
            mid = mid + Math.imul(ah2, bl1) | 0;
            hi = hi + Math.imul(ah2, bh1) | 0;
            lo = lo + Math.imul(al1, bl2) | 0;
            mid = mid + Math.imul(al1, bh2) | 0;
            mid = mid + Math.imul(ah1, bl2) | 0;
            hi = hi + Math.imul(ah1, bh2) | 0;
            lo = lo + Math.imul(al0, bl3) | 0;
            mid = mid + Math.imul(al0, bh3) | 0;
            mid = mid + Math.imul(ah0, bl3) | 0;
            hi = hi + Math.imul(ah0, bh3) | 0;
            var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
            w3 &= 0x3ffffff;
            lo = Math.imul(al4, bl0);
            mid = Math.imul(al4, bh0);
            mid = mid + Math.imul(ah4, bl0) | 0;
            hi = Math.imul(ah4, bh0);
            lo = lo + Math.imul(al3, bl1) | 0;
            mid = mid + Math.imul(al3, bh1) | 0;
            mid = mid + Math.imul(ah3, bl1) | 0;
            hi = hi + Math.imul(ah3, bh1) | 0;
            lo = lo + Math.imul(al2, bl2) | 0;
            mid = mid + Math.imul(al2, bh2) | 0;
            mid = mid + Math.imul(ah2, bl2) | 0;
            hi = hi + Math.imul(ah2, bh2) | 0;
            lo = lo + Math.imul(al1, bl3) | 0;
            mid = mid + Math.imul(al1, bh3) | 0;
            mid = mid + Math.imul(ah1, bl3) | 0;
            hi = hi + Math.imul(ah1, bh3) | 0;
            lo = lo + Math.imul(al0, bl4) | 0;
            mid = mid + Math.imul(al0, bh4) | 0;
            mid = mid + Math.imul(ah0, bl4) | 0;
            hi = hi + Math.imul(ah0, bh4) | 0;
            var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
            w4 &= 0x3ffffff;
            lo = Math.imul(al5, bl0);
            mid = Math.imul(al5, bh0);
            mid = mid + Math.imul(ah5, bl0) | 0;
            hi = Math.imul(ah5, bh0);
            lo = lo + Math.imul(al4, bl1) | 0;
            mid = mid + Math.imul(al4, bh1) | 0;
            mid = mid + Math.imul(ah4, bl1) | 0;
            hi = hi + Math.imul(ah4, bh1) | 0;
            lo = lo + Math.imul(al3, bl2) | 0;
            mid = mid + Math.imul(al3, bh2) | 0;
            mid = mid + Math.imul(ah3, bl2) | 0;
            hi = hi + Math.imul(ah3, bh2) | 0;
            lo = lo + Math.imul(al2, bl3) | 0;
            mid = mid + Math.imul(al2, bh3) | 0;
            mid = mid + Math.imul(ah2, bl3) | 0;
            hi = hi + Math.imul(ah2, bh3) | 0;
            lo = lo + Math.imul(al1, bl4) | 0;
            mid = mid + Math.imul(al1, bh4) | 0;
            mid = mid + Math.imul(ah1, bl4) | 0;
            hi = hi + Math.imul(ah1, bh4) | 0;
            lo = lo + Math.imul(al0, bl5) | 0;
            mid = mid + Math.imul(al0, bh5) | 0;
            mid = mid + Math.imul(ah0, bl5) | 0;
            hi = hi + Math.imul(ah0, bh5) | 0;
            var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
            w5 &= 0x3ffffff;
            lo = Math.imul(al6, bl0);
            mid = Math.imul(al6, bh0);
            mid = mid + Math.imul(ah6, bl0) | 0;
            hi = Math.imul(ah6, bh0);
            lo = lo + Math.imul(al5, bl1) | 0;
            mid = mid + Math.imul(al5, bh1) | 0;
            mid = mid + Math.imul(ah5, bl1) | 0;
            hi = hi + Math.imul(ah5, bh1) | 0;
            lo = lo + Math.imul(al4, bl2) | 0;
            mid = mid + Math.imul(al4, bh2) | 0;
            mid = mid + Math.imul(ah4, bl2) | 0;
            hi = hi + Math.imul(ah4, bh2) | 0;
            lo = lo + Math.imul(al3, bl3) | 0;
            mid = mid + Math.imul(al3, bh3) | 0;
            mid = mid + Math.imul(ah3, bl3) | 0;
            hi = hi + Math.imul(ah3, bh3) | 0;
            lo = lo + Math.imul(al2, bl4) | 0;
            mid = mid + Math.imul(al2, bh4) | 0;
            mid = mid + Math.imul(ah2, bl4) | 0;
            hi = hi + Math.imul(ah2, bh4) | 0;
            lo = lo + Math.imul(al1, bl5) | 0;
            mid = mid + Math.imul(al1, bh5) | 0;
            mid = mid + Math.imul(ah1, bl5) | 0;
            hi = hi + Math.imul(ah1, bh5) | 0;
            lo = lo + Math.imul(al0, bl6) | 0;
            mid = mid + Math.imul(al0, bh6) | 0;
            mid = mid + Math.imul(ah0, bl6) | 0;
            hi = hi + Math.imul(ah0, bh6) | 0;
            var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
            w6 &= 0x3ffffff;
            lo = Math.imul(al7, bl0);
            mid = Math.imul(al7, bh0);
            mid = mid + Math.imul(ah7, bl0) | 0;
            hi = Math.imul(ah7, bh0);
            lo = lo + Math.imul(al6, bl1) | 0;
            mid = mid + Math.imul(al6, bh1) | 0;
            mid = mid + Math.imul(ah6, bl1) | 0;
            hi = hi + Math.imul(ah6, bh1) | 0;
            lo = lo + Math.imul(al5, bl2) | 0;
            mid = mid + Math.imul(al5, bh2) | 0;
            mid = mid + Math.imul(ah5, bl2) | 0;
            hi = hi + Math.imul(ah5, bh2) | 0;
            lo = lo + Math.imul(al4, bl3) | 0;
            mid = mid + Math.imul(al4, bh3) | 0;
            mid = mid + Math.imul(ah4, bl3) | 0;
            hi = hi + Math.imul(ah4, bh3) | 0;
            lo = lo + Math.imul(al3, bl4) | 0;
            mid = mid + Math.imul(al3, bh4) | 0;
            mid = mid + Math.imul(ah3, bl4) | 0;
            hi = hi + Math.imul(ah3, bh4) | 0;
            lo = lo + Math.imul(al2, bl5) | 0;
            mid = mid + Math.imul(al2, bh5) | 0;
            mid = mid + Math.imul(ah2, bl5) | 0;
            hi = hi + Math.imul(ah2, bh5) | 0;
            lo = lo + Math.imul(al1, bl6) | 0;
            mid = mid + Math.imul(al1, bh6) | 0;
            mid = mid + Math.imul(ah1, bl6) | 0;
            hi = hi + Math.imul(ah1, bh6) | 0;
            lo = lo + Math.imul(al0, bl7) | 0;
            mid = mid + Math.imul(al0, bh7) | 0;
            mid = mid + Math.imul(ah0, bl7) | 0;
            hi = hi + Math.imul(ah0, bh7) | 0;
            var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
            w7 &= 0x3ffffff;
            lo = Math.imul(al8, bl0);
            mid = Math.imul(al8, bh0);
            mid = mid + Math.imul(ah8, bl0) | 0;
            hi = Math.imul(ah8, bh0);
            lo = lo + Math.imul(al7, bl1) | 0;
            mid = mid + Math.imul(al7, bh1) | 0;
            mid = mid + Math.imul(ah7, bl1) | 0;
            hi = hi + Math.imul(ah7, bh1) | 0;
            lo = lo + Math.imul(al6, bl2) | 0;
            mid = mid + Math.imul(al6, bh2) | 0;
            mid = mid + Math.imul(ah6, bl2) | 0;
            hi = hi + Math.imul(ah6, bh2) | 0;
            lo = lo + Math.imul(al5, bl3) | 0;
            mid = mid + Math.imul(al5, bh3) | 0;
            mid = mid + Math.imul(ah5, bl3) | 0;
            hi = hi + Math.imul(ah5, bh3) | 0;
            lo = lo + Math.imul(al4, bl4) | 0;
            mid = mid + Math.imul(al4, bh4) | 0;
            mid = mid + Math.imul(ah4, bl4) | 0;
            hi = hi + Math.imul(ah4, bh4) | 0;
            lo = lo + Math.imul(al3, bl5) | 0;
            mid = mid + Math.imul(al3, bh5) | 0;
            mid = mid + Math.imul(ah3, bl5) | 0;
            hi = hi + Math.imul(ah3, bh5) | 0;
            lo = lo + Math.imul(al2, bl6) | 0;
            mid = mid + Math.imul(al2, bh6) | 0;
            mid = mid + Math.imul(ah2, bl6) | 0;
            hi = hi + Math.imul(ah2, bh6) | 0;
            lo = lo + Math.imul(al1, bl7) | 0;
            mid = mid + Math.imul(al1, bh7) | 0;
            mid = mid + Math.imul(ah1, bl7) | 0;
            hi = hi + Math.imul(ah1, bh7) | 0;
            lo = lo + Math.imul(al0, bl8) | 0;
            mid = mid + Math.imul(al0, bh8) | 0;
            mid = mid + Math.imul(ah0, bl8) | 0;
            hi = hi + Math.imul(ah0, bh8) | 0;
            var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
            w8 &= 0x3ffffff;
            lo = Math.imul(al9, bl0);
            mid = Math.imul(al9, bh0);
            mid = mid + Math.imul(ah9, bl0) | 0;
            hi = Math.imul(ah9, bh0);
            lo = lo + Math.imul(al8, bl1) | 0;
            mid = mid + Math.imul(al8, bh1) | 0;
            mid = mid + Math.imul(ah8, bl1) | 0;
            hi = hi + Math.imul(ah8, bh1) | 0;
            lo = lo + Math.imul(al7, bl2) | 0;
            mid = mid + Math.imul(al7, bh2) | 0;
            mid = mid + Math.imul(ah7, bl2) | 0;
            hi = hi + Math.imul(ah7, bh2) | 0;
            lo = lo + Math.imul(al6, bl3) | 0;
            mid = mid + Math.imul(al6, bh3) | 0;
            mid = mid + Math.imul(ah6, bl3) | 0;
            hi = hi + Math.imul(ah6, bh3) | 0;
            lo = lo + Math.imul(al5, bl4) | 0;
            mid = mid + Math.imul(al5, bh4) | 0;
            mid = mid + Math.imul(ah5, bl4) | 0;
            hi = hi + Math.imul(ah5, bh4) | 0;
            lo = lo + Math.imul(al4, bl5) | 0;
            mid = mid + Math.imul(al4, bh5) | 0;
            mid = mid + Math.imul(ah4, bl5) | 0;
            hi = hi + Math.imul(ah4, bh5) | 0;
            lo = lo + Math.imul(al3, bl6) | 0;
            mid = mid + Math.imul(al3, bh6) | 0;
            mid = mid + Math.imul(ah3, bl6) | 0;
            hi = hi + Math.imul(ah3, bh6) | 0;
            lo = lo + Math.imul(al2, bl7) | 0;
            mid = mid + Math.imul(al2, bh7) | 0;
            mid = mid + Math.imul(ah2, bl7) | 0;
            hi = hi + Math.imul(ah2, bh7) | 0;
            lo = lo + Math.imul(al1, bl8) | 0;
            mid = mid + Math.imul(al1, bh8) | 0;
            mid = mid + Math.imul(ah1, bl8) | 0;
            hi = hi + Math.imul(ah1, bh8) | 0;
            lo = lo + Math.imul(al0, bl9) | 0;
            mid = mid + Math.imul(al0, bh9) | 0;
            mid = mid + Math.imul(ah0, bl9) | 0;
            hi = hi + Math.imul(ah0, bh9) | 0;
            var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
            w9 &= 0x3ffffff;
            lo = Math.imul(al9, bl1);
            mid = Math.imul(al9, bh1);
            mid = mid + Math.imul(ah9, bl1) | 0;
            hi = Math.imul(ah9, bh1);
            lo = lo + Math.imul(al8, bl2) | 0;
            mid = mid + Math.imul(al8, bh2) | 0;
            mid = mid + Math.imul(ah8, bl2) | 0;
            hi = hi + Math.imul(ah8, bh2) | 0;
            lo = lo + Math.imul(al7, bl3) | 0;
            mid = mid + Math.imul(al7, bh3) | 0;
            mid = mid + Math.imul(ah7, bl3) | 0;
            hi = hi + Math.imul(ah7, bh3) | 0;
            lo = lo + Math.imul(al6, bl4) | 0;
            mid = mid + Math.imul(al6, bh4) | 0;
            mid = mid + Math.imul(ah6, bl4) | 0;
            hi = hi + Math.imul(ah6, bh4) | 0;
            lo = lo + Math.imul(al5, bl5) | 0;
            mid = mid + Math.imul(al5, bh5) | 0;
            mid = mid + Math.imul(ah5, bl5) | 0;
            hi = hi + Math.imul(ah5, bh5) | 0;
            lo = lo + Math.imul(al4, bl6) | 0;
            mid = mid + Math.imul(al4, bh6) | 0;
            mid = mid + Math.imul(ah4, bl6) | 0;
            hi = hi + Math.imul(ah4, bh6) | 0;
            lo = lo + Math.imul(al3, bl7) | 0;
            mid = mid + Math.imul(al3, bh7) | 0;
            mid = mid + Math.imul(ah3, bl7) | 0;
            hi = hi + Math.imul(ah3, bh7) | 0;
            lo = lo + Math.imul(al2, bl8) | 0;
            mid = mid + Math.imul(al2, bh8) | 0;
            mid = mid + Math.imul(ah2, bl8) | 0;
            hi = hi + Math.imul(ah2, bh8) | 0;
            lo = lo + Math.imul(al1, bl9) | 0;
            mid = mid + Math.imul(al1, bh9) | 0;
            mid = mid + Math.imul(ah1, bl9) | 0;
            hi = hi + Math.imul(ah1, bh9) | 0;
            var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
            w10 &= 0x3ffffff;
            lo = Math.imul(al9, bl2);
            mid = Math.imul(al9, bh2);
            mid = mid + Math.imul(ah9, bl2) | 0;
            hi = Math.imul(ah9, bh2);
            lo = lo + Math.imul(al8, bl3) | 0;
            mid = mid + Math.imul(al8, bh3) | 0;
            mid = mid + Math.imul(ah8, bl3) | 0;
            hi = hi + Math.imul(ah8, bh3) | 0;
            lo = lo + Math.imul(al7, bl4) | 0;
            mid = mid + Math.imul(al7, bh4) | 0;
            mid = mid + Math.imul(ah7, bl4) | 0;
            hi = hi + Math.imul(ah7, bh4) | 0;
            lo = lo + Math.imul(al6, bl5) | 0;
            mid = mid + Math.imul(al6, bh5) | 0;
            mid = mid + Math.imul(ah6, bl5) | 0;
            hi = hi + Math.imul(ah6, bh5) | 0;
            lo = lo + Math.imul(al5, bl6) | 0;
            mid = mid + Math.imul(al5, bh6) | 0;
            mid = mid + Math.imul(ah5, bl6) | 0;
            hi = hi + Math.imul(ah5, bh6) | 0;
            lo = lo + Math.imul(al4, bl7) | 0;
            mid = mid + Math.imul(al4, bh7) | 0;
            mid = mid + Math.imul(ah4, bl7) | 0;
            hi = hi + Math.imul(ah4, bh7) | 0;
            lo = lo + Math.imul(al3, bl8) | 0;
            mid = mid + Math.imul(al3, bh8) | 0;
            mid = mid + Math.imul(ah3, bl8) | 0;
            hi = hi + Math.imul(ah3, bh8) | 0;
            lo = lo + Math.imul(al2, bl9) | 0;
            mid = mid + Math.imul(al2, bh9) | 0;
            mid = mid + Math.imul(ah2, bl9) | 0;
            hi = hi + Math.imul(ah2, bh9) | 0;
            var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
            w11 &= 0x3ffffff;
            lo = Math.imul(al9, bl3);
            mid = Math.imul(al9, bh3);
            mid = mid + Math.imul(ah9, bl3) | 0;
            hi = Math.imul(ah9, bh3);
            lo = lo + Math.imul(al8, bl4) | 0;
            mid = mid + Math.imul(al8, bh4) | 0;
            mid = mid + Math.imul(ah8, bl4) | 0;
            hi = hi + Math.imul(ah8, bh4) | 0;
            lo = lo + Math.imul(al7, bl5) | 0;
            mid = mid + Math.imul(al7, bh5) | 0;
            mid = mid + Math.imul(ah7, bl5) | 0;
            hi = hi + Math.imul(ah7, bh5) | 0;
            lo = lo + Math.imul(al6, bl6) | 0;
            mid = mid + Math.imul(al6, bh6) | 0;
            mid = mid + Math.imul(ah6, bl6) | 0;
            hi = hi + Math.imul(ah6, bh6) | 0;
            lo = lo + Math.imul(al5, bl7) | 0;
            mid = mid + Math.imul(al5, bh7) | 0;
            mid = mid + Math.imul(ah5, bl7) | 0;
            hi = hi + Math.imul(ah5, bh7) | 0;
            lo = lo + Math.imul(al4, bl8) | 0;
            mid = mid + Math.imul(al4, bh8) | 0;
            mid = mid + Math.imul(ah4, bl8) | 0;
            hi = hi + Math.imul(ah4, bh8) | 0;
            lo = lo + Math.imul(al3, bl9) | 0;
            mid = mid + Math.imul(al3, bh9) | 0;
            mid = mid + Math.imul(ah3, bl9) | 0;
            hi = hi + Math.imul(ah3, bh9) | 0;
            var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
            w12 &= 0x3ffffff;
            lo = Math.imul(al9, bl4);
            mid = Math.imul(al9, bh4);
            mid = mid + Math.imul(ah9, bl4) | 0;
            hi = Math.imul(ah9, bh4);
            lo = lo + Math.imul(al8, bl5) | 0;
            mid = mid + Math.imul(al8, bh5) | 0;
            mid = mid + Math.imul(ah8, bl5) | 0;
            hi = hi + Math.imul(ah8, bh5) | 0;
            lo = lo + Math.imul(al7, bl6) | 0;
            mid = mid + Math.imul(al7, bh6) | 0;
            mid = mid + Math.imul(ah7, bl6) | 0;
            hi = hi + Math.imul(ah7, bh6) | 0;
            lo = lo + Math.imul(al6, bl7) | 0;
            mid = mid + Math.imul(al6, bh7) | 0;
            mid = mid + Math.imul(ah6, bl7) | 0;
            hi = hi + Math.imul(ah6, bh7) | 0;
            lo = lo + Math.imul(al5, bl8) | 0;
            mid = mid + Math.imul(al5, bh8) | 0;
            mid = mid + Math.imul(ah5, bl8) | 0;
            hi = hi + Math.imul(ah5, bh8) | 0;
            lo = lo + Math.imul(al4, bl9) | 0;
            mid = mid + Math.imul(al4, bh9) | 0;
            mid = mid + Math.imul(ah4, bl9) | 0;
            hi = hi + Math.imul(ah4, bh9) | 0;
            var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
            w13 &= 0x3ffffff;
            lo = Math.imul(al9, bl5);
            mid = Math.imul(al9, bh5);
            mid = mid + Math.imul(ah9, bl5) | 0;
            hi = Math.imul(ah9, bh5);
            lo = lo + Math.imul(al8, bl6) | 0;
            mid = mid + Math.imul(al8, bh6) | 0;
            mid = mid + Math.imul(ah8, bl6) | 0;
            hi = hi + Math.imul(ah8, bh6) | 0;
            lo = lo + Math.imul(al7, bl7) | 0;
            mid = mid + Math.imul(al7, bh7) | 0;
            mid = mid + Math.imul(ah7, bl7) | 0;
            hi = hi + Math.imul(ah7, bh7) | 0;
            lo = lo + Math.imul(al6, bl8) | 0;
            mid = mid + Math.imul(al6, bh8) | 0;
            mid = mid + Math.imul(ah6, bl8) | 0;
            hi = hi + Math.imul(ah6, bh8) | 0;
            lo = lo + Math.imul(al5, bl9) | 0;
            mid = mid + Math.imul(al5, bh9) | 0;
            mid = mid + Math.imul(ah5, bl9) | 0;
            hi = hi + Math.imul(ah5, bh9) | 0;
            var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
            w14 &= 0x3ffffff;
            lo = Math.imul(al9, bl6);
            mid = Math.imul(al9, bh6);
            mid = mid + Math.imul(ah9, bl6) | 0;
            hi = Math.imul(ah9, bh6);
            lo = lo + Math.imul(al8, bl7) | 0;
            mid = mid + Math.imul(al8, bh7) | 0;
            mid = mid + Math.imul(ah8, bl7) | 0;
            hi = hi + Math.imul(ah8, bh7) | 0;
            lo = lo + Math.imul(al7, bl8) | 0;
            mid = mid + Math.imul(al7, bh8) | 0;
            mid = mid + Math.imul(ah7, bl8) | 0;
            hi = hi + Math.imul(ah7, bh8) | 0;
            lo = lo + Math.imul(al6, bl9) | 0;
            mid = mid + Math.imul(al6, bh9) | 0;
            mid = mid + Math.imul(ah6, bl9) | 0;
            hi = hi + Math.imul(ah6, bh9) | 0;
            var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
            w15 &= 0x3ffffff;
            lo = Math.imul(al9, bl7);
            mid = Math.imul(al9, bh7);
            mid = mid + Math.imul(ah9, bl7) | 0;
            hi = Math.imul(ah9, bh7);
            lo = lo + Math.imul(al8, bl8) | 0;
            mid = mid + Math.imul(al8, bh8) | 0;
            mid = mid + Math.imul(ah8, bl8) | 0;
            hi = hi + Math.imul(ah8, bh8) | 0;
            lo = lo + Math.imul(al7, bl9) | 0;
            mid = mid + Math.imul(al7, bh9) | 0;
            mid = mid + Math.imul(ah7, bl9) | 0;
            hi = hi + Math.imul(ah7, bh9) | 0;
            var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
            w16 &= 0x3ffffff;
            lo = Math.imul(al9, bl8);
            mid = Math.imul(al9, bh8);
            mid = mid + Math.imul(ah9, bl8) | 0;
            hi = Math.imul(ah9, bh8);
            lo = lo + Math.imul(al8, bl9) | 0;
            mid = mid + Math.imul(al8, bh9) | 0;
            mid = mid + Math.imul(ah8, bl9) | 0;
            hi = hi + Math.imul(ah8, bh9) | 0;
            var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
            w17 &= 0x3ffffff;
            lo = Math.imul(al9, bl9);
            mid = Math.imul(al9, bh9);
            mid = mid + Math.imul(ah9, bl9) | 0;
            hi = Math.imul(ah9, bh9);
            var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
            w18 &= 0x3ffffff;
            o[0] = w0;
            o[1] = w1;
            o[2] = w2;
            o[3] = w3;
            o[4] = w4;
            o[5] = w5;
            o[6] = w6;
            o[7] = w7;
            o[8] = w8;
            o[9] = w9;
            o[10] = w10;
            o[11] = w11;
            o[12] = w12;
            o[13] = w13;
            o[14] = w14;
            o[15] = w15;
            o[16] = w16;
            o[17] = w17;
            o[18] = w18;
            if (c !== 0) {
                o[19] = c;
                out.length++;
            }
            return out;
        };
        if (!Math.imul) comb10MulTo = smallMulTo;
        function bigMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            out.length = self.length + num.length;
            var carry = 0;
            var hncarry = 0;
            for(var k = 0; k < out.length - 1; k++){
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j;
                    var a = self.words[i] | 0;
                    var b = num.words[j] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                    lo = lo + rword | 0;
                    rword = lo & 0x3ffffff;
                    ncarry = ncarry + (lo >>> 26) | 0;
                    hncarry += ncarry >>> 26;
                    ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
            }
            if (carry !== 0) out.words[k] = carry;
            else out.length--;
            return out._strip();
        }
        function jumboMulTo(self, num, out) {
            return bigMulTo(self, num, out);
        }
        BN.prototype.mulTo = function mulTo(num, out) {
            var res;
            var len = this.length + num.length;
            if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
            else if (len < 63) res = smallMulTo(this, num, out);
            else if (len < 1024) res = bigMulTo(this, num, out);
            else res = jumboMulTo(this, num, out);
            return res;
        };
        function FFTM(x, y) {
            this.x = x;
            this.y = y;
        }
        FFTM.prototype.makeRBT = function makeRBT(N) {
            var t = new Array(N);
            var l = BN.prototype._countBits(N) - 1;
            for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
            return t;
        };
        FFTM.prototype.revBin = function revBin(x, l, N) {
            if (x === 0 || x === N - 1) return x;
            var rb = 0;
            for(var i = 0; i < l; i++){
                rb |= (x & 1) << l - i - 1;
                x >>= 1;
            }
            return rb;
        };
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
            for(var i = 0; i < N; i++){
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
            }
        };
        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
            this.permute(rbt, rws, iws, rtws, itws, N);
            for(var s = 1; s < N; s <<= 1){
                var l = s << 1;
                var rtwdf = Math.cos(2 * Math.PI / l);
                var itwdf = Math.sin(2 * Math.PI / l);
                for(var p = 0; p < N; p += l){
                    var rtwdf_ = rtwdf;
                    var itwdf_ = itwdf;
                    for(var j = 0; j < s; j++){
                        var re = rtws[p + j];
                        var ie = itws[p + j];
                        var ro = rtws[p + j + s];
                        var io = itws[p + j + s];
                        var rx = rtwdf_ * ro - itwdf_ * io;
                        io = rtwdf_ * io + itwdf_ * ro;
                        ro = rx;
                        rtws[p + j] = re + ro;
                        itws[p + j] = ie + io;
                        rtws[p + j + s] = re - ro;
                        itws[p + j + s] = ie - io;
                        if (j !== l) {
                            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                            rtwdf_ = rx;
                        }
                    }
                }
            }
        };
        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
            var N = Math.max(m, n) | 1;
            var odd = N & 1;
            var i = 0;
            for(N = N / 2 | 0; N; N = N >>> 1)i++;
            return 1 << i + 1 + odd;
        };
        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
            if (N <= 1) return;
            for(var i = 0; i < N / 2; i++){
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
            }
        };
        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
            var carry = 0;
            for(var i = 0; i < N / 2; i++){
                var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) carry = 0;
                else carry = w / 0x4000000 | 0;
            }
            return ws;
        };
        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
            var carry = 0;
            for(var i = 0; i < len; i++){
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
            }
            for(i = 2 * len; i < N; ++i)rws[i] = 0;
            assert(carry === 0);
            assert((carry & -8192) === 0);
        };
        FFTM.prototype.stub = function stub(N) {
            var ph = new Array(N);
            for(var i = 0; i < N; i++)ph[i] = 0;
            return ph;
        };
        FFTM.prototype.mulp = function mulp(x, y, out) {
            var N = 2 * this.guessLen13b(x.length, y.length);
            var rbt = this.makeRBT(N);
            var _ = this.stub(N);
            var rws = new Array(N);
            var rwst = new Array(N);
            var iwst = new Array(N);
            var nrws = new Array(N);
            var nrwst = new Array(N);
            var niwst = new Array(N);
            var rmws = out.words;
            rmws.length = N;
            this.convert13b(x.words, x.length, rws, N);
            this.convert13b(y.words, y.length, nrws, N);
            this.transform(rws, _, rwst, iwst, N, rbt);
            this.transform(nrws, _, nrwst, niwst, N, rbt);
            for(var i = 0; i < N; i++){
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
            }
            this.conjugate(rwst, iwst, N);
            this.transform(rwst, iwst, rmws, _, N, rbt);
            this.conjugate(rmws, _, N);
            this.normalize13b(rmws, N);
            out.negative = x.negative ^ y.negative;
            out.length = x.length + y.length;
            return out._strip();
        };
        BN.prototype.mul = function mul(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return this.mulTo(num, out);
        };
        BN.prototype.mulf = function mulf(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return jumboMulTo(this, num, out);
        };
        BN.prototype.imul = function imul(num) {
            return this.clone().mulTo(num, this);
        };
        BN.prototype.imuln = function imuln(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += w / 0x4000000 | 0;
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.muln = function muln(num) {
            return this.clone().imuln(num);
        };
        BN.prototype.sqr = function sqr() {
            return this.mul(this);
        };
        BN.prototype.isqr = function isqr() {
            return this.imul(this.clone());
        };
        BN.prototype.pow = function pow(num) {
            var w = toBitArray(num);
            if (w.length === 0) return new BN(1);
            var res = this;
            for(var i = 0; i < w.length; i++, res = res.sqr()){
                if (w[i] !== 0) break;
            }
            if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                if (w[i] === 0) continue;
                res = res.mul(q);
            }
            return res;
        };
        BN.prototype.iushln = function iushln(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
            var i;
            if (r !== 0) {
                var carry = 0;
                for(i = 0; i < this.length; i++){
                    var newCarry = this.words[i] & carryMask;
                    var c = (this.words[i] | 0) - newCarry << r;
                    this.words[i] = c | carry;
                    carry = newCarry >>> 26 - r;
                }
                if (carry) {
                    this.words[i] = carry;
                    this.length++;
                }
            }
            if (s !== 0) {
                for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                for(i = 0; i < s; i++)this.words[i] = 0;
                this.length += s;
            }
            return this._strip();
        };
        BN.prototype.ishln = function ishln(bits) {
            assert(this.negative === 0);
            return this.iushln(bits);
        };
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
            assert(typeof bits === 'number' && bits >= 0);
            var h;
            if (hint) h = (hint - hint % 26) / 26;
            else h = 0;
            var r = bits % 26;
            var s = Math.min((bits - r) / 26, this.length);
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            var maskedWords = extended;
            h -= s;
            h = Math.max(0, h);
            if (maskedWords) {
                for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                maskedWords.length = s;
            }
            if (s === 0) ;
            else if (this.length > s) {
                this.length -= s;
                for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
            } else {
                this.words[0] = 0;
                this.length = 1;
            }
            var carry = 0;
            for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                var word = this.words[i] | 0;
                this.words[i] = carry << 26 - r | word >>> r;
                carry = word & mask;
            }
            if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
            if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
            }
            return this._strip();
        };
        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
            assert(this.negative === 0);
            return this.iushrn(bits, hint, extended);
        };
        BN.prototype.shln = function shln(bits) {
            return this.clone().ishln(bits);
        };
        BN.prototype.ushln = function ushln(bits) {
            return this.clone().iushln(bits);
        };
        BN.prototype.shrn = function shrn(bits) {
            return this.clone().ishrn(bits);
        };
        BN.prototype.ushrn = function ushrn(bits) {
            return this.clone().iushrn(bits);
        };
        BN.prototype.testn = function testn(bit) {
            assert(typeof bit === 'number' && bit >= 0);
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) return false;
            var w = this.words[s];
            return !!(w & q);
        };
        BN.prototype.imaskn = function imaskn(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            assert(this.negative === 0, 'imaskn works only with positive numbers');
            if (this.length <= s) return this;
            if (r !== 0) s++;
            this.length = Math.min(s, this.length);
            if (r !== 0) {
                var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                this.words[this.length - 1] &= mask;
            }
            return this._strip();
        };
        BN.prototype.maskn = function maskn(bits) {
            return this.clone().imaskn(bits);
        };
        BN.prototype.iaddn = function iaddn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.isubn(-num);
            if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) <= num) {
                    this.words[0] = num - (this.words[0] | 0);
                    this.negative = 0;
                    return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
            }
            return this._iaddn(num);
        };
        BN.prototype._iaddn = function _iaddn(num) {
            this.words[0] += num;
            for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) this.words[i + 1] = 1;
                else this.words[i + 1]++;
            }
            this.length = Math.max(this.length, i + 1);
            return this;
        };
        BN.prototype.isubn = function isubn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.iaddn(-num);
            if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
            }
            this.words[0] -= num;
            if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
            } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                this.words[i] += 0x4000000;
                this.words[i + 1] -= 1;
            }
            return this._strip();
        };
        BN.prototype.addn = function addn(num) {
            return this.clone().iaddn(num);
        };
        BN.prototype.subn = function subn(num) {
            return this.clone().isubn(num);
        };
        BN.prototype.iabs = function iabs() {
            this.negative = 0;
            return this;
        };
        BN.prototype.abs = function abs() {
            return this.clone().iabs();
        };
        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
            var len = num.length + shift;
            var i;
            this._expand(len);
            var w;
            var carry = 0;
            for(i = 0; i < num.length; i++){
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - (right / 0x4000000 | 0);
                this.words[i + shift] = w & 0x3ffffff;
            }
            for(; i < this.length - shift; i++){
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
            }
            if (carry === 0) return this._strip();
            assert(carry === -1);
            carry = 0;
            for(i = 0; i < this.length; i++){
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
            }
            this.negative = 1;
            return this._strip();
        };
        BN.prototype._wordDiv = function _wordDiv(num, mode) {
            var shift = this.length - num.length;
            var a = this.clone();
            var b = num;
            var bhi = b.words[b.length - 1] | 0;
            var bhiBits = this._countBits(bhi);
            shift = 26 - bhiBits;
            if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
            }
            var m = a.length - b.length;
            var q;
            if (mode !== 'mod') {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for(var i = 0; i < q.length; i++)q.words[i] = 0;
            }
            var diff = a.clone()._ishlnsubmul(b, 1, m);
            if (diff.negative === 0) {
                a = diff;
                if (q) q.words[m] = 1;
            }
            for(var j = m - 1; j >= 0; j--){
                var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                qj = Math.min(qj / bhi | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while(a.negative !== 0){
                    qj--;
                    a.negative = 0;
                    a._ishlnsubmul(b, 1, j);
                    if (!a.isZero()) a.negative ^= 1;
                }
                if (q) q.words[j] = qj;
            }
            if (q) q._strip();
            a._strip();
            if (mode !== 'div' && shift !== 0) a.iushrn(shift);
            return {
                div: q || null,
                mod: a
            };
        };
        BN.prototype.divmod = function divmod(num, mode, positive) {
            assert(!num.isZero());
            if (this.isZero()) return {
                div: new BN(0),
                mod: new BN(0)
            };
            var div, mod, res;
            if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== 'mod') div = res.div.neg();
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.iadd(num);
                }
                return {
                    div: div,
                    mod: mod
                };
            }
            if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== 'mod') div = res.div.neg();
                return {
                    div: div,
                    mod: res.mod
                };
            }
            if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.isub(num);
                }
                return {
                    div: res.div,
                    mod: mod
                };
            }
            if (num.length > this.length || this.cmp(num) < 0) return {
                div: new BN(0),
                mod: this
            };
            if (num.length === 1) {
                if (mode === 'div') return {
                    div: this.divn(num.words[0]),
                    mod: null
                };
                if (mode === 'mod') return {
                    div: null,
                    mod: new BN(this.modrn(num.words[0]))
                };
                return {
                    div: this.divn(num.words[0]),
                    mod: new BN(this.modrn(num.words[0]))
                };
            }
            return this._wordDiv(num, mode);
        };
        BN.prototype.div = function div(num) {
            return this.divmod(num, 'div', false).div;
        };
        BN.prototype.mod = function mod(num) {
            return this.divmod(num, 'mod', false).mod;
        };
        BN.prototype.umod = function umod(num) {
            return this.divmod(num, 'mod', true).mod;
        };
        BN.prototype.divRound = function divRound(num) {
            var dm = this.divmod(num);
            if (dm.mod.isZero()) return dm.div;
            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
            var half = num.ushrn(1);
            var r2 = num.andln(1);
            var cmp = mod.cmp(half);
            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };
        BN.prototype.modrn = function modrn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var p = 67108864 % num;
            var acc = 0;
            for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
            return isNegNum ? -acc : acc;
        };
        BN.prototype.modn = function modn(num) {
            return this.modrn(num);
        };
        BN.prototype.idivn = function idivn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var carry = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = w / num | 0;
                carry = w % num;
            }
            this._strip();
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.divn = function divn(num) {
            return this.clone().idivn(num);
        };
        BN.prototype.egcd = function egcd(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var x = this;
            var y = p.clone();
            if (x.negative !== 0) x = x.umod(p);
            else x = x.clone();
            var A = new BN(1);
            var B = new BN(0);
            var C = new BN(0);
            var D = new BN(1);
            var g = 0;
            while(x.isEven() && y.isEven()){
                x.iushrn(1);
                y.iushrn(1);
                ++g;
            }
            var yp = y.clone();
            var xp = x.clone();
            while(!x.isZero()){
                for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    x.iushrn(i);
                    while(i-- > 0){
                        if (A.isOdd() || B.isOdd()) {
                            A.iadd(yp);
                            B.isub(xp);
                        }
                        A.iushrn(1);
                        B.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    y.iushrn(j);
                    while(j-- > 0){
                        if (C.isOdd() || D.isOdd()) {
                            C.iadd(yp);
                            D.isub(xp);
                        }
                        C.iushrn(1);
                        D.iushrn(1);
                    }
                }
                if (x.cmp(y) >= 0) {
                    x.isub(y);
                    A.isub(C);
                    B.isub(D);
                } else {
                    y.isub(x);
                    C.isub(A);
                    D.isub(B);
                }
            }
            return {
                a: C,
                b: D,
                gcd: y.iushln(g)
            };
        };
        BN.prototype._invmp = function _invmp(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var a = this;
            var b = p.clone();
            if (a.negative !== 0) a = a.umod(p);
            else a = a.clone();
            var x1 = new BN(1);
            var x2 = new BN(0);
            var delta = b.clone();
            while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    a.iushrn(i);
                    while(i-- > 0){
                        if (x1.isOdd()) x1.iadd(delta);
                        x1.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    b.iushrn(j);
                    while(j-- > 0){
                        if (x2.isOdd()) x2.iadd(delta);
                        x2.iushrn(1);
                    }
                }
                if (a.cmp(b) >= 0) {
                    a.isub(b);
                    x1.isub(x2);
                } else {
                    b.isub(a);
                    x2.isub(x1);
                }
            }
            var res;
            if (a.cmpn(1) === 0) res = x1;
            else res = x2;
            if (res.cmpn(0) < 0) res.iadd(p);
            return res;
        };
        BN.prototype.gcd = function gcd(num) {
            if (this.isZero()) return num.abs();
            if (num.isZero()) return this.abs();
            var a = this.clone();
            var b = num.clone();
            a.negative = 0;
            b.negative = 0;
            for(var shift = 0; a.isEven() && b.isEven(); shift++){
                a.iushrn(1);
                b.iushrn(1);
            }
            do {
                while(a.isEven())a.iushrn(1);
                while(b.isEven())b.iushrn(1);
                var r = a.cmp(b);
                if (r < 0) {
                    var t = a;
                    a = b;
                    b = t;
                } else if (r === 0 || b.cmpn(1) === 0) break;
                a.isub(b);
            }while (true)
            return b.iushln(shift);
        };
        BN.prototype.invm = function invm(num) {
            return this.egcd(num).a.umod(num);
        };
        BN.prototype.isEven = function isEven() {
            return (this.words[0] & 1) === 0;
        };
        BN.prototype.isOdd = function isOdd() {
            return (this.words[0] & 1) === 1;
        };
        BN.prototype.andln = function andln(num) {
            return this.words[0] & num;
        };
        BN.prototype.bincn = function bincn(bit) {
            assert(typeof bit === 'number');
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
            }
            var carry = q;
            for(var i = s; carry !== 0 && i < this.length; i++){
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.isZero = function isZero() {
            return this.length === 1 && this.words[0] === 0;
        };
        BN.prototype.cmpn = function cmpn(num) {
            var negative = num < 0;
            if (this.negative !== 0 && !negative) return -1;
            if (this.negative === 0 && negative) return 1;
            this._strip();
            var res;
            if (this.length > 1) res = 1;
            else {
                if (negative) num = -num;
                assert(num <= 0x3ffffff, 'Number is too big');
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
            }
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.cmp = function cmp(num) {
            if (this.negative !== 0 && num.negative === 0) return -1;
            if (this.negative === 0 && num.negative !== 0) return 1;
            var res = this.ucmp(num);
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.ucmp = function ucmp(num) {
            if (this.length > num.length) return 1;
            if (this.length < num.length) return -1;
            var res = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) res = -1;
                else if (a > b) res = 1;
                break;
            }
            return res;
        };
        BN.prototype.gtn = function gtn(num) {
            return this.cmpn(num) === 1;
        };
        BN.prototype.gt = function gt(num) {
            return this.cmp(num) === 1;
        };
        BN.prototype.gten = function gten(num) {
            return this.cmpn(num) >= 0;
        };
        BN.prototype.gte = function gte(num) {
            return this.cmp(num) >= 0;
        };
        BN.prototype.ltn = function ltn(num) {
            return this.cmpn(num) === -1;
        };
        BN.prototype.lt = function lt(num) {
            return this.cmp(num) === -1;
        };
        BN.prototype.lten = function lten(num) {
            return this.cmpn(num) <= 0;
        };
        BN.prototype.lte = function lte(num) {
            return this.cmp(num) <= 0;
        };
        BN.prototype.eqn = function eqn(num) {
            return this.cmpn(num) === 0;
        };
        BN.prototype.eq = function eq(num) {
            return this.cmp(num) === 0;
        };
        BN.red = function red(num) {
            return new Red(num);
        };
        BN.prototype.toRed = function toRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            assert(this.negative === 0, 'red works only with positives');
            return ctx.convertTo(this)._forceRed(ctx);
        };
        BN.prototype.fromRed = function fromRed() {
            assert(this.red, 'fromRed works only with numbers in reduction context');
            return this.red.convertFrom(this);
        };
        BN.prototype._forceRed = function _forceRed(ctx) {
            this.red = ctx;
            return this;
        };
        BN.prototype.forceRed = function forceRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            return this._forceRed(ctx);
        };
        BN.prototype.redAdd = function redAdd(num) {
            assert(this.red, 'redAdd works only with red numbers');
            return this.red.add(this, num);
        };
        BN.prototype.redIAdd = function redIAdd(num) {
            assert(this.red, 'redIAdd works only with red numbers');
            return this.red.iadd(this, num);
        };
        BN.prototype.redSub = function redSub(num) {
            assert(this.red, 'redSub works only with red numbers');
            return this.red.sub(this, num);
        };
        BN.prototype.redISub = function redISub(num) {
            assert(this.red, 'redISub works only with red numbers');
            return this.red.isub(this, num);
        };
        BN.prototype.redShl = function redShl(num) {
            assert(this.red, 'redShl works only with red numbers');
            return this.red.shl(this, num);
        };
        BN.prototype.redMul = function redMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.mul(this, num);
        };
        BN.prototype.redIMul = function redIMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.imul(this, num);
        };
        BN.prototype.redSqr = function redSqr() {
            assert(this.red, 'redSqr works only with red numbers');
            this.red._verify1(this);
            return this.red.sqr(this);
        };
        BN.prototype.redISqr = function redISqr() {
            assert(this.red, 'redISqr works only with red numbers');
            this.red._verify1(this);
            return this.red.isqr(this);
        };
        BN.prototype.redSqrt = function redSqrt() {
            assert(this.red, 'redSqrt works only with red numbers');
            this.red._verify1(this);
            return this.red.sqrt(this);
        };
        BN.prototype.redInvm = function redInvm() {
            assert(this.red, 'redInvm works only with red numbers');
            this.red._verify1(this);
            return this.red.invm(this);
        };
        BN.prototype.redNeg = function redNeg() {
            assert(this.red, 'redNeg works only with red numbers');
            this.red._verify1(this);
            return this.red.neg(this);
        };
        BN.prototype.redPow = function redPow(num) {
            assert(this.red && !num.red, 'redPow(normalNum)');
            this.red._verify1(this);
            return this.red.pow(this, num);
        };
        var primes = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function MPrime(name, p) {
            this.name = name;
            this.p = new BN(p, 16);
            this.n = this.p.bitLength();
            this.k = new BN(1).iushln(this.n).isub(this.p);
            this.tmp = this._tmp();
        }
        MPrime.prototype._tmp = function _tmp() {
            var tmp = new BN(null);
            tmp.words = new Array(Math.ceil(this.n / 13));
            return tmp;
        };
        MPrime.prototype.ireduce = function ireduce(num) {
            var r = num;
            var rlen;
            do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
            }while (rlen > this.n)
            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
            if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
            } else if (cmp > 0) r.isub(this.p);
            else if (r.strip !== undefined) r.strip();
            else r._strip();
            return r;
        };
        MPrime.prototype.split = function split(input, out) {
            input.iushrn(this.n, 0, out);
        };
        MPrime.prototype.imulK = function imulK(num) {
            return num.imul(this.k);
        };
        function K256() {
            MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);
        K256.prototype.split = function split(input, output) {
            var mask = 0x3fffff;
            var outLen = Math.min(input.length, 9);
            for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
            output.length = outLen;
            if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
            }
            var prev = input.words[9];
            output.words[output.length++] = prev & mask;
            for(i = 10; i < input.length; i++){
                var next = input.words[i] | 0;
                input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                prev = next;
            }
            prev >>>= 22;
            input.words[i - 10] = prev;
            if (prev === 0 && input.length > 10) input.length -= 10;
            else input.length -= 9;
        };
        K256.prototype.imulK = function imulK(num) {
            num.words[num.length] = 0;
            num.words[num.length + 1] = 0;
            num.length += 2;
            var lo = 0;
            for(var i = 0; i < num.length; i++){
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + (lo / 0x4000000 | 0);
            }
            if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) num.length--;
            }
            return num;
        };
        function P224() {
            MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);
        function P192() {
            MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);
        function P25519() {
            MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);
        P25519.prototype.imulK = function imulK(num) {
            var carry = 0;
            for(var i = 0; i < num.length; i++){
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
            }
            if (carry !== 0) num.words[num.length++] = carry;
            return num;
        };
        BN._prime = function prime(name) {
            if (primes[name]) return primes[name];
            var prime;
            if (name === 'k256') prime = new K256();
            else if (name === 'p224') prime = new P224();
            else if (name === 'p192') prime = new P192();
            else if (name === 'p25519') prime = new P25519();
            else throw new Error('Unknown prime ' + name);
            primes[name] = prime;
            return prime;
        };
        function Red(m) {
            if (typeof m === 'string') {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
            } else {
                assert(m.gtn(1), 'modulus must be greater than 1');
                this.m = m;
                this.prime = null;
            }
        }
        Red.prototype._verify1 = function _verify1(a) {
            assert(a.negative === 0, 'red works only with positives');
            assert(a.red, 'red works only with red numbers');
        };
        Red.prototype._verify2 = function _verify2(a, b) {
            assert((a.negative | b.negative) === 0, 'red works only with positives');
            assert(a.red && a.red === b.red, 'red works only with red numbers');
        };
        Red.prototype.imod = function imod(a) {
            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
            move(a, a.umod(this.m)._forceRed(this));
            return a;
        };
        Red.prototype.neg = function neg(a) {
            if (a.isZero()) return a.clone();
            return this.m.sub(a)._forceRed(this);
        };
        Red.prototype.add = function add(a, b) {
            this._verify2(a, b);
            var res = a.add(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res._forceRed(this);
        };
        Red.prototype.iadd = function iadd(a, b) {
            this._verify2(a, b);
            var res = a.iadd(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res;
        };
        Red.prototype.sub = function sub(a, b) {
            this._verify2(a, b);
            var res = a.sub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res._forceRed(this);
        };
        Red.prototype.isub = function isub(a, b) {
            this._verify2(a, b);
            var res = a.isub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res;
        };
        Red.prototype.shl = function shl(a, num) {
            this._verify1(a);
            return this.imod(a.ushln(num));
        };
        Red.prototype.imul = function imul(a, b) {
            this._verify2(a, b);
            return this.imod(a.imul(b));
        };
        Red.prototype.mul = function mul(a, b) {
            this._verify2(a, b);
            return this.imod(a.mul(b));
        };
        Red.prototype.isqr = function isqr(a) {
            return this.imul(a, a.clone());
        };
        Red.prototype.sqr = function sqr(a) {
            return this.mul(a, a);
        };
        Red.prototype.sqrt = function sqrt(a) {
            if (a.isZero()) return a.clone();
            var mod3 = this.m.andln(3);
            assert(mod3 % 2 === 1);
            if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
            }
            var q = this.m.subn(1);
            var s = 0;
            while(!q.isZero() && q.andln(1) === 0){
                s++;
                q.iushrn(1);
            }
            assert(!q.isZero());
            var one = new BN(1).toRed(this);
            var nOne = one.redNeg();
            var lpow = this.m.subn(1).iushrn(1);
            var z = this.m.bitLength();
            z = new BN(2 * z * z).toRed(this);
            while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
            var c = this.pow(z, q);
            var r = this.pow(a, q.addn(1).iushrn(1));
            var t = this.pow(a, q);
            var m = s;
            while(t.cmp(one) !== 0){
                var tmp = t;
                for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
            }
            return r;
        };
        Red.prototype.invm = function invm(a) {
            var inv = a._invmp(this.m);
            if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
            } else return this.imod(inv);
        };
        Red.prototype.pow = function pow(a, num) {
            if (num.isZero()) return new BN(1).toRed(this);
            if (num.cmpn(1) === 0) return a.clone();
            var windowSize = 4;
            var wnd = new Array(1 << windowSize);
            wnd[0] = new BN(1).toRed(this);
            wnd[1] = a;
            for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
            var res = wnd[0];
            var current = 0;
            var currentLen = 0;
            var start = num.bitLength() % 26;
            if (start === 0) start = 26;
            for(i = num.length - 1; i >= 0; i--){
                var word = num.words[i];
                for(var j = start - 1; j >= 0; j--){
                    var bit = word >> j & 1;
                    if (res !== wnd[0]) res = this.sqr(res);
                    if (bit === 0 && current === 0) {
                        currentLen = 0;
                        continue;
                    }
                    current <<= 1;
                    current |= bit;
                    currentLen++;
                    if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                    res = this.mul(res, wnd[current]);
                    currentLen = 0;
                    current = 0;
                }
                start = 26;
            }
            return res;
        };
        Red.prototype.convertTo = function convertTo(num) {
            var r = num.umod(this.m);
            return r === num ? r.clone() : r;
        };
        Red.prototype.convertFrom = function convertFrom(num) {
            var res = num.clone();
            res.red = null;
            return res;
        };
        BN.mont = function mont(num) {
            return new Mont(num);
        };
        function Mont(m) {
            Red.call(this, m);
            this.shift = this.m.bitLength();
            if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
            this.r = new BN(1).iushln(this.shift);
            this.r2 = this.imod(this.r.sqr());
            this.rinv = this.r._invmp(this.m);
            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
            this.minv = this.minv.umod(this.r);
            this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);
        Mont.prototype.convertTo = function convertTo(num) {
            return this.imod(num.ushln(this.shift));
        };
        Mont.prototype.convertFrom = function convertFrom(num) {
            var r = this.imod(num.mul(this.rinv));
            r.red = null;
            return r;
        };
        Mont.prototype.imul = function imul(a, b) {
            if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
            }
            var t = a.imul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.mul = function mul(a, b) {
            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
            var t = a.mul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.invm = function invm(a) {
            var res = this.imod(a._invmp(this.m).mul(this.r2));
            return res._forceRed(this);
        };
    })(module, this);
});
parcelRegister("8JoQd", function(module, exports) {
    'use strict';
    var $65b5cb9dd0661cc3$var$elliptic = module.exports;
    $65b5cb9dd0661cc3$var$elliptic.version = (parcelRequire("gkWIM")).version;
    $65b5cb9dd0661cc3$var$elliptic.utils = (parcelRequire("onO0l"));
    $65b5cb9dd0661cc3$var$elliptic.rand = (parcelRequire("9D8YT"));
    $65b5cb9dd0661cc3$var$elliptic.curve = (parcelRequire("9QOKF"));
    $65b5cb9dd0661cc3$var$elliptic.curves = (parcelRequire("gli5y"));
    $65b5cb9dd0661cc3$var$elliptic.ec = (parcelRequire("9Cxq1"));
    $65b5cb9dd0661cc3$var$elliptic.eddsa = (parcelRequire("5xIaV"));
});
parcelRegister("gkWIM", function(module, exports) {
    module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");
});
parcelRegister("onO0l", function(module, exports) {
    'use strict';
    var $0494b54965d0d2c4$var$utils = module.exports;
    var $9pbIC = parcelRequire("9pbIC");
    var $gxaFy = parcelRequire("gxaFy");
    var $2WqN6 = parcelRequire("2WqN6");
    $0494b54965d0d2c4$var$utils.assert = $gxaFy;
    $0494b54965d0d2c4$var$utils.toArray = $2WqN6.toArray;
    $0494b54965d0d2c4$var$utils.zero2 = $2WqN6.zero2;
    $0494b54965d0d2c4$var$utils.toHex = $2WqN6.toHex;
    $0494b54965d0d2c4$var$utils.encode = $2WqN6.encode;
    function $0494b54965d0d2c4$var$getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        var i;
        for(i = 0; i < naf.length; i += 1)naf[i] = 0;
        var ws = 1 << w + 1;
        var k = num.clone();
        for(i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    $0494b54965d0d2c4$var$utils.getNAF = $0494b54965d0d2c4$var$getNAF;
    function $0494b54965d0d2c4$var$getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    $0494b54965d0d2c4$var$utils.getJSF = $0494b54965d0d2c4$var$getJSF;
    function $0494b54965d0d2c4$var$cachedProperty(obj, name, computer) {
        var key = '_' + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    $0494b54965d0d2c4$var$utils.cachedProperty = $0494b54965d0d2c4$var$cachedProperty;
    function $0494b54965d0d2c4$var$parseBytes(bytes) {
        return typeof bytes === 'string' ? $0494b54965d0d2c4$var$utils.toArray(bytes, 'hex') : bytes;
    }
    $0494b54965d0d2c4$var$utils.parseBytes = $0494b54965d0d2c4$var$parseBytes;
    function $0494b54965d0d2c4$var$intFromLE(bytes) {
        return new $9pbIC(bytes, 'hex', 'le');
    }
    $0494b54965d0d2c4$var$utils.intFromLE = $0494b54965d0d2c4$var$intFromLE;
});
parcelRegister("2WqN6", function(module, exports) {
    'use strict';
    var $2245c7a9bbd83d59$var$utils = module.exports;
    function $2245c7a9bbd83d59$var$toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== 'string') {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    $2245c7a9bbd83d59$var$utils.toArray = $2245c7a9bbd83d59$var$toArray;
    function $2245c7a9bbd83d59$var$zero2(word) {
        if (word.length === 1) return '0' + word;
        else return word;
    }
    $2245c7a9bbd83d59$var$utils.zero2 = $2245c7a9bbd83d59$var$zero2;
    function $2245c7a9bbd83d59$var$toHex(msg) {
        var res = '';
        for(var i = 0; i < msg.length; i++)res += $2245c7a9bbd83d59$var$zero2(msg[i].toString(16));
        return res;
    }
    $2245c7a9bbd83d59$var$utils.toHex = $2245c7a9bbd83d59$var$toHex;
    $2245c7a9bbd83d59$var$utils.encode = function encode(arr, enc) {
        if (enc === 'hex') return $2245c7a9bbd83d59$var$toHex(arr);
        else return arr;
    };
});
parcelRegister("9QOKF", function(module, exports) {
    'use strict';
    var $72c056a3dd9c1fd5$var$curve = module.exports;
    $72c056a3dd9c1fd5$var$curve.base = (parcelRequire("5DDDX"));
    $72c056a3dd9c1fd5$var$curve.short = (parcelRequire("adWZB"));
    $72c056a3dd9c1fd5$var$curve.mont = (parcelRequire("8yFev"));
    $72c056a3dd9c1fd5$var$curve.edwards = (parcelRequire("4wgwz"));
});
parcelRegister("5DDDX", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $41af58a397e0e961$var$getNAF = $onO0l.getNAF;
    var $41af58a397e0e961$var$getJSF = $onO0l.getJSF;
    var $41af58a397e0e961$var$assert = $onO0l.assert;
    function $41af58a397e0e961$var$BaseCurve(type, conf) {
        this.type = type;
        this.p = new $9pbIC(conf.p, 16);
        this.red = conf.prime ? $9pbIC.red(conf.prime) : $9pbIC.mont(this.p);
        this.zero = new $9pbIC(0).toRed(this.red);
        this.one = new $9pbIC(1).toRed(this.red);
        this.two = new $9pbIC(2).toRed(this.red);
        this.n = conf.n && new $9pbIC(conf.n, 16);
        this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
        this._wnafT1 = new Array(4);
        this._wnafT2 = new Array(4);
        this._wnafT3 = new Array(4);
        this._wnafT4 = new Array(4);
        this._bitLength = this.n ? this.n.bitLength() : 0;
        var adjustCount = this.n && this.p.div(this.n);
        if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
        else {
            this._maxwellTrick = true;
            this.redN = this.n.toRed(this.red);
        }
    }
    module.exports = $41af58a397e0e961$var$BaseCurve;
    $41af58a397e0e961$var$BaseCurve.prototype.point = function point() {
        throw new Error('Not implemented');
    };
    $41af58a397e0e961$var$BaseCurve.prototype.validate = function validate() {
        throw new Error('Not implemented');
    };
    $41af58a397e0e961$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
        $41af58a397e0e961$var$assert(p.precomputed);
        var doubles = p._getDoubles();
        var naf = $41af58a397e0e961$var$getNAF(k, 1, this._bitLength);
        var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
        I /= 3;
        var repr = [];
        var j;
        var nafW;
        for(j = 0; j < naf.length; j += doubles.step){
            nafW = 0;
            for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
            repr.push(nafW);
        }
        var a = this.jpoint(null, null, null);
        var b = this.jpoint(null, null, null);
        for(var i = I; i > 0; i--){
            for(j = 0; j < repr.length; j++){
                nafW = repr[j];
                if (nafW === i) b = b.mixedAdd(doubles.points[j]);
                else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
            }
            a = a.add(b);
        }
        return a.toP();
    };
    $41af58a397e0e961$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
        var w = 4;
        var nafPoints = p._getNAFPoints(w);
        w = nafPoints.wnd;
        var wnd = nafPoints.points;
        var naf = $41af58a397e0e961$var$getNAF(k, w, this._bitLength);
        var acc = this.jpoint(null, null, null);
        for(var i = naf.length - 1; i >= 0; i--){
            for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
            if (i >= 0) l++;
            acc = acc.dblp(l);
            if (i < 0) break;
            var z = naf[i];
            $41af58a397e0e961$var$assert(z !== 0);
            if (p.type === 'affine') {
                if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
                else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
            } else if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
            else acc = acc.add(wnd[-z - 1 >> 1].neg());
        }
        return p.type === 'affine' ? acc.toP() : acc;
    };
    $41af58a397e0e961$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
        var wndWidth = this._wnafT1;
        var wnd = this._wnafT2;
        var naf = this._wnafT3;
        var max = 0;
        var i;
        var j;
        var p;
        for(i = 0; i < len; i++){
            p = points[i];
            var nafPoints = p._getNAFPoints(defW);
            wndWidth[i] = nafPoints.wnd;
            wnd[i] = nafPoints.points;
        }
        for(i = len - 1; i >= 1; i -= 2){
            var a = i - 1;
            var b = i;
            if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
                naf[a] = $41af58a397e0e961$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
                naf[b] = $41af58a397e0e961$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
                max = Math.max(naf[a].length, max);
                max = Math.max(naf[b].length, max);
                continue;
            }
            var comb = [
                points[a],
                null,
                null,
                points[b]
            ];
            if (points[a].y.cmp(points[b].y) === 0) {
                comb[1] = points[a].add(points[b]);
                comb[2] = points[a].toJ().mixedAdd(points[b].neg());
            } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
                comb[1] = points[a].toJ().mixedAdd(points[b]);
                comb[2] = points[a].add(points[b].neg());
            } else {
                comb[1] = points[a].toJ().mixedAdd(points[b]);
                comb[2] = points[a].toJ().mixedAdd(points[b].neg());
            }
            var index = [
                -3,
                -1,
                -5,
                -7,
                0,
                7,
                5,
                1,
                3
            ];
            var jsf = $41af58a397e0e961$var$getJSF(coeffs[a], coeffs[b]);
            max = Math.max(jsf[0].length, max);
            naf[a] = new Array(max);
            naf[b] = new Array(max);
            for(j = 0; j < max; j++){
                var ja = jsf[0][j] | 0;
                var jb = jsf[1][j] | 0;
                naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
                naf[b][j] = 0;
                wnd[a] = comb;
            }
        }
        var acc = this.jpoint(null, null, null);
        var tmp = this._wnafT4;
        for(i = max; i >= 0; i--){
            var k = 0;
            while(i >= 0){
                var zero = true;
                for(j = 0; j < len; j++){
                    tmp[j] = naf[j][i] | 0;
                    if (tmp[j] !== 0) zero = false;
                }
                if (!zero) break;
                k++;
                i--;
            }
            if (i >= 0) k++;
            acc = acc.dblp(k);
            if (i < 0) break;
            for(j = 0; j < len; j++){
                var z = tmp[j];
                p;
                if (z === 0) continue;
                else if (z > 0) p = wnd[j][z - 1 >> 1];
                else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
                if (p.type === 'affine') acc = acc.mixedAdd(p);
                else acc = acc.add(p);
            }
        }
        for(i = 0; i < len; i++)wnd[i] = null;
        if (jacobianResult) return acc;
        else return acc.toP();
    };
    function $41af58a397e0e961$var$BasePoint(curve, type) {
        this.curve = curve;
        this.type = type;
        this.precomputed = null;
    }
    $41af58a397e0e961$var$BaseCurve.BasePoint = $41af58a397e0e961$var$BasePoint;
    $41af58a397e0e961$var$BasePoint.prototype.eq = function eq() {
        throw new Error('Not implemented');
    };
    $41af58a397e0e961$var$BasePoint.prototype.validate = function validate() {
        return this.curve.validate(this);
    };
    $41af58a397e0e961$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
        bytes = $onO0l.toArray(bytes, enc);
        var len = this.p.byteLength();
        if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
            if (bytes[0] === 0x06) $41af58a397e0e961$var$assert(bytes[bytes.length - 1] % 2 === 0);
            else if (bytes[0] === 0x07) $41af58a397e0e961$var$assert(bytes[bytes.length - 1] % 2 === 1);
            var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
            return res;
        } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
        throw new Error('Unknown point format');
    };
    $41af58a397e0e961$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
        return this.encode(enc, true);
    };
    $41af58a397e0e961$var$BasePoint.prototype._encode = function _encode(compact) {
        var len = this.curve.p.byteLength();
        var x = this.getX().toArray('be', len);
        if (compact) return [
            this.getY().isEven() ? 0x02 : 0x03
        ].concat(x);
        return [
            0x04
        ].concat(x, this.getY().toArray('be', len));
    };
    $41af58a397e0e961$var$BasePoint.prototype.encode = function encode(enc, compact) {
        return $onO0l.encode(this._encode(compact), enc);
    };
    $41af58a397e0e961$var$BasePoint.prototype.precompute = function precompute(power) {
        if (this.precomputed) return this;
        var precomputed = {
            doubles: null,
            naf: null,
            beta: null
        };
        precomputed.naf = this._getNAFPoints(8);
        precomputed.doubles = this._getDoubles(4, power);
        precomputed.beta = this._getBeta();
        this.precomputed = precomputed;
        return this;
    };
    $41af58a397e0e961$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
        if (!this.precomputed) return false;
        var doubles = this.precomputed.doubles;
        if (!doubles) return false;
        return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
    };
    $41af58a397e0e961$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
        if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
        var doubles = [
            this
        ];
        var acc = this;
        for(var i = 0; i < power; i += step){
            for(var j = 0; j < step; j++)acc = acc.dbl();
            doubles.push(acc);
        }
        return {
            step: step,
            points: doubles
        };
    };
    $41af58a397e0e961$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
        if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
        var res = [
            this
        ];
        var max = (1 << wnd) - 1;
        var dbl = max === 1 ? null : this.dbl();
        for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
        return {
            wnd: wnd,
            points: res
        };
    };
    $41af58a397e0e961$var$BasePoint.prototype._getBeta = function _getBeta() {
        return null;
    };
    $41af58a397e0e961$var$BasePoint.prototype.dblp = function dblp(k) {
        var r = this;
        for(var i = 0; i < k; i++)r = r.dbl();
        return r;
    };
});
parcelRegister("adWZB", function(module, exports) {
    'use strict';
    var $onO0l = parcelRequire("onO0l");
    var $9pbIC = parcelRequire("9pbIC");
    var $v3bBu = parcelRequire("v3bBu");
    var $5DDDX = parcelRequire("5DDDX");
    var $7718e0f8fe39ea5b$var$assert = $onO0l.assert;
    function $7718e0f8fe39ea5b$var$ShortCurve(conf) {
        $5DDDX.call(this, 'short', conf);
        this.a = new $9pbIC(conf.a, 16).toRed(this.red);
        this.b = new $9pbIC(conf.b, 16).toRed(this.red);
        this.tinv = this.two.redInvm();
        this.zeroA = this.a.fromRed().cmpn(0) === 0;
        this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
        this.endo = this._getEndomorphism(conf);
        this._endoWnafT1 = new Array(4);
        this._endoWnafT2 = new Array(4);
    }
    $v3bBu($7718e0f8fe39ea5b$var$ShortCurve, $5DDDX);
    module.exports = $7718e0f8fe39ea5b$var$ShortCurve;
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
        if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
        var beta;
        var lambda;
        if (conf.beta) beta = new $9pbIC(conf.beta, 16).toRed(this.red);
        else {
            var betas = this._getEndoRoots(this.p);
            beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
            beta = beta.toRed(this.red);
        }
        if (conf.lambda) lambda = new $9pbIC(conf.lambda, 16);
        else {
            var lambdas = this._getEndoRoots(this.n);
            if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
            else {
                lambda = lambdas[1];
                $7718e0f8fe39ea5b$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
            }
        }
        var basis;
        if (conf.basis) basis = conf.basis.map(function(vec) {
            return {
                a: new $9pbIC(vec.a, 16),
                b: new $9pbIC(vec.b, 16)
            };
        });
        else basis = this._getEndoBasis(lambda);
        return {
            beta: beta,
            lambda: lambda,
            basis: basis
        };
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
        var red = num === this.p ? this.red : $9pbIC.mont(num);
        var tinv = new $9pbIC(2).toRed(red).redInvm();
        var ntinv = tinv.redNeg();
        var s = new $9pbIC(3).toRed(red).redNeg().redSqrt().redMul(tinv);
        var l1 = ntinv.redAdd(s).fromRed();
        var l2 = ntinv.redSub(s).fromRed();
        return [
            l1,
            l2
        ];
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
        var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
        var u = lambda;
        var v = this.n.clone();
        var x1 = new $9pbIC(1);
        var y1 = new $9pbIC(0);
        var x2 = new $9pbIC(0);
        var y2 = new $9pbIC(1);
        var a0;
        var b0;
        var a1;
        var b1;
        var a2;
        var b2;
        var prevR;
        var i = 0;
        var r;
        var x;
        while(u.cmpn(0) !== 0){
            var q = v.div(u);
            r = v.sub(q.mul(u));
            x = x2.sub(q.mul(x1));
            var y = y2.sub(q.mul(y1));
            if (!a1 && r.cmp(aprxSqrt) < 0) {
                a0 = prevR.neg();
                b0 = x1;
                a1 = r.neg();
                b1 = x;
            } else if (a1 && ++i === 2) break;
            prevR = r;
            v = u;
            u = r;
            x2 = x1;
            x1 = x;
            y2 = y1;
            y1 = y;
        }
        a2 = r.neg();
        b2 = x;
        var len1 = a1.sqr().add(b1.sqr());
        var len2 = a2.sqr().add(b2.sqr());
        if (len2.cmp(len1) >= 0) {
            a2 = a0;
            b2 = b0;
        }
        if (a1.negative) {
            a1 = a1.neg();
            b1 = b1.neg();
        }
        if (a2.negative) {
            a2 = a2.neg();
            b2 = b2.neg();
        }
        return [
            {
                a: a1,
                b: b1
            },
            {
                a: a2,
                b: b2
            }
        ];
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
        var basis = this.endo.basis;
        var v1 = basis[0];
        var v2 = basis[1];
        var c1 = v2.b.mul(k).divRound(this.n);
        var c2 = v1.b.neg().mul(k).divRound(this.n);
        var p1 = c1.mul(v1.a);
        var p2 = c2.mul(v2.a);
        var q1 = c1.mul(v1.b);
        var q2 = c2.mul(v2.b);
        var k1 = k.sub(p1).sub(p2);
        var k2 = q1.add(q2).neg();
        return {
            k1: k1,
            k2: k2
        };
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
        x = new $9pbIC(x, 16);
        if (!x.red) x = x.toRed(this.red);
        var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
        var y = y2.redSqrt();
        if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
        var isOdd = y.fromRed().isOdd();
        if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
        return this.point(x, y);
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.validate = function validate(point) {
        if (point.inf) return true;
        var x = point.x;
        var y = point.y;
        var ax = this.a.redMul(x);
        var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
        return y.redSqr().redISub(rhs).cmpn(0) === 0;
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
        var npoints = this._endoWnafT1;
        var ncoeffs = this._endoWnafT2;
        for(var i = 0; i < points.length; i++){
            var split = this._endoSplit(coeffs[i]);
            var p = points[i];
            var beta = p._getBeta();
            if (split.k1.negative) {
                split.k1.ineg();
                p = p.neg(true);
            }
            if (split.k2.negative) {
                split.k2.ineg();
                beta = beta.neg(true);
            }
            npoints[i * 2] = p;
            npoints[i * 2 + 1] = beta;
            ncoeffs[i * 2] = split.k1;
            ncoeffs[i * 2 + 1] = split.k2;
        }
        var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
        for(var j = 0; j < i * 2; j++){
            npoints[j] = null;
            ncoeffs[j] = null;
        }
        return res;
    };
    function $7718e0f8fe39ea5b$var$Point(curve, x, y, isRed) {
        $5DDDX.BasePoint.call(this, curve, 'affine');
        if (x === null && y === null) {
            this.x = null;
            this.y = null;
            this.inf = true;
        } else {
            this.x = new $9pbIC(x, 16);
            this.y = new $9pbIC(y, 16);
            if (isRed) {
                this.x.forceRed(this.curve.red);
                this.y.forceRed(this.curve.red);
            }
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.y.red) this.y = this.y.toRed(this.curve.red);
            this.inf = false;
        }
    }
    $v3bBu($7718e0f8fe39ea5b$var$Point, $5DDDX.BasePoint);
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
        return new $7718e0f8fe39ea5b$var$Point(this, x, y, isRed);
    };
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
        return $7718e0f8fe39ea5b$var$Point.fromJSON(this, obj, red);
    };
    $7718e0f8fe39ea5b$var$Point.prototype._getBeta = function _getBeta() {
        if (!this.curve.endo) return;
        var pre = this.precomputed;
        if (pre && pre.beta) return pre.beta;
        var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (pre) {
            var curve = this.curve;
            var endoMul = function(p) {
                return curve.point(p.x.redMul(curve.endo.beta), p.y);
            };
            pre.beta = beta;
            beta.precomputed = {
                beta: null,
                naf: pre.naf && {
                    wnd: pre.naf.wnd,
                    points: pre.naf.points.map(endoMul)
                },
                doubles: pre.doubles && {
                    step: pre.doubles.step,
                    points: pre.doubles.points.map(endoMul)
                }
            };
        }
        return beta;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.toJSON = function toJSON() {
        if (!this.precomputed) return [
            this.x,
            this.y
        ];
        return [
            this.x,
            this.y,
            this.precomputed && {
                doubles: this.precomputed.doubles && {
                    step: this.precomputed.doubles.step,
                    points: this.precomputed.doubles.points.slice(1)
                },
                naf: this.precomputed.naf && {
                    wnd: this.precomputed.naf.wnd,
                    points: this.precomputed.naf.points.slice(1)
                }
            }
        ];
    };
    $7718e0f8fe39ea5b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
        if (typeof obj === 'string') obj = JSON.parse(obj);
        var res = curve.point(obj[0], obj[1], red);
        if (!obj[2]) return res;
        function obj2point(obj) {
            return curve.point(obj[0], obj[1], red);
        }
        var pre = obj[2];
        res.precomputed = {
            beta: null,
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: [
                    res
                ].concat(pre.doubles.points.map(obj2point))
            },
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: [
                    res
                ].concat(pre.naf.points.map(obj2point))
            }
        };
        return res;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
    };
    $7718e0f8fe39ea5b$var$Point.prototype.isInfinity = function isInfinity() {
        return this.inf;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.add = function add(p) {
        if (this.inf) return p;
        if (p.inf) return this;
        if (this.eq(p)) return this.dbl();
        if (this.neg().eq(p)) return this.curve.point(null, null);
        if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
        var c = this.y.redSub(p.y);
        if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
        var nx = c.redSqr().redISub(this.x).redISub(p.x);
        var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
        return this.curve.point(nx, ny);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.dbl = function dbl() {
        if (this.inf) return this;
        var ys1 = this.y.redAdd(this.y);
        if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
        var a = this.curve.a;
        var x2 = this.x.redSqr();
        var dyinv = ys1.redInvm();
        var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
        var nx = c.redSqr().redISub(this.x.redAdd(this.x));
        var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
        return this.curve.point(nx, ny);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.getX = function getX() {
        return this.x.fromRed();
    };
    $7718e0f8fe39ea5b$var$Point.prototype.getY = function getY() {
        return this.y.fromRed();
    };
    $7718e0f8fe39ea5b$var$Point.prototype.mul = function mul(k) {
        k = new $9pbIC(k, 16);
        if (this.isInfinity()) return this;
        else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
        else if (this.curve.endo) return this.curve._endoWnafMulAdd([
            this
        ], [
            k
        ]);
        else return this.curve._wnafMul(this, k);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
        var points = [
            this,
            p2
        ];
        var coeffs = [
            k1,
            k2
        ];
        if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
        else return this.curve._wnafMulAdd(1, points, coeffs, 2);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
        var points = [
            this,
            p2
        ];
        var coeffs = [
            k1,
            k2
        ];
        if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
        else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.eq = function eq(p) {
        return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
    };
    $7718e0f8fe39ea5b$var$Point.prototype.neg = function neg(_precompute) {
        if (this.inf) return this;
        var res = this.curve.point(this.x, this.y.redNeg());
        if (_precompute && this.precomputed) {
            var pre = this.precomputed;
            var negate = function(p) {
                return p.neg();
            };
            res.precomputed = {
                naf: pre.naf && {
                    wnd: pre.naf.wnd,
                    points: pre.naf.points.map(negate)
                },
                doubles: pre.doubles && {
                    step: pre.doubles.step,
                    points: pre.doubles.points.map(negate)
                }
            };
        }
        return res;
    };
    $7718e0f8fe39ea5b$var$Point.prototype.toJ = function toJ() {
        if (this.inf) return this.curve.jpoint(null, null, null);
        var res = this.curve.jpoint(this.x, this.y, this.curve.one);
        return res;
    };
    function $7718e0f8fe39ea5b$var$JPoint(curve, x, y, z) {
        $5DDDX.BasePoint.call(this, curve, 'jacobian');
        if (x === null && y === null && z === null) {
            this.x = this.curve.one;
            this.y = this.curve.one;
            this.z = new $9pbIC(0);
        } else {
            this.x = new $9pbIC(x, 16);
            this.y = new $9pbIC(y, 16);
            this.z = new $9pbIC(z, 16);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
    }
    $v3bBu($7718e0f8fe39ea5b$var$JPoint, $5DDDX.BasePoint);
    $7718e0f8fe39ea5b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
        return new $7718e0f8fe39ea5b$var$JPoint(this, x, y, z);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.toP = function toP() {
        if (this.isInfinity()) return this.curve.point(null, null);
        var zinv = this.z.redInvm();
        var zinv2 = zinv.redSqr();
        var ax = this.x.redMul(zinv2);
        var ay = this.y.redMul(zinv2).redMul(zinv);
        return this.curve.point(ax, ay);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.neg = function neg() {
        return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.add = function add(p) {
        if (this.isInfinity()) return p;
        if (p.isInfinity()) return this;
        var pz2 = p.z.redSqr();
        var z2 = this.z.redSqr();
        var u1 = this.x.redMul(pz2);
        var u2 = p.x.redMul(z2);
        var s1 = this.y.redMul(pz2.redMul(p.z));
        var s2 = p.y.redMul(z2.redMul(this.z));
        var h = u1.redSub(u2);
        var r = s1.redSub(s2);
        if (h.cmpn(0) === 0) {
            if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
            else return this.dbl();
        }
        var h2 = h.redSqr();
        var h3 = h2.redMul(h);
        var v = u1.redMul(h2);
        var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
        var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
        var nz = this.z.redMul(p.z).redMul(h);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
        if (this.isInfinity()) return p.toJ();
        if (p.isInfinity()) return this;
        var z2 = this.z.redSqr();
        var u1 = this.x;
        var u2 = p.x.redMul(z2);
        var s1 = this.y;
        var s2 = p.y.redMul(z2).redMul(this.z);
        var h = u1.redSub(u2);
        var r = s1.redSub(s2);
        if (h.cmpn(0) === 0) {
            if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
            else return this.dbl();
        }
        var h2 = h.redSqr();
        var h3 = h2.redMul(h);
        var v = u1.redMul(h2);
        var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
        var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
        var nz = this.z.redMul(h);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.dblp = function dblp(pow) {
        if (pow === 0) return this;
        if (this.isInfinity()) return this;
        if (!pow) return this.dbl();
        var i;
        if (this.curve.zeroA || this.curve.threeA) {
            var r = this;
            for(i = 0; i < pow; i++)r = r.dbl();
            return r;
        }
        var a = this.curve.a;
        var tinv = this.curve.tinv;
        var jx = this.x;
        var jy = this.y;
        var jz = this.z;
        var jz4 = jz.redSqr().redSqr();
        var jyd = jy.redAdd(jy);
        for(i = 0; i < pow; i++){
            var jx2 = jx.redSqr();
            var jyd2 = jyd.redSqr();
            var jyd4 = jyd2.redSqr();
            var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
            var t1 = jx.redMul(jyd2);
            var nx = c.redSqr().redISub(t1.redAdd(t1));
            var t2 = t1.redISub(nx);
            var dny = c.redMul(t2);
            dny = dny.redIAdd(dny).redISub(jyd4);
            var nz = jyd.redMul(jz);
            if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
            jx = nx;
            jz = nz;
            jyd = dny;
        }
        return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.dbl = function dbl() {
        if (this.isInfinity()) return this;
        if (this.curve.zeroA) return this._zeroDbl();
        else if (this.curve.threeA) return this._threeDbl();
        else return this._dbl();
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
        var nx;
        var ny;
        var nz;
        if (this.zOne) {
            var xx = this.x.redSqr();
            var yy = this.y.redSqr();
            var yyyy = yy.redSqr();
            var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
            s = s.redIAdd(s);
            var m = xx.redAdd(xx).redIAdd(xx);
            var t = m.redSqr().redISub(s).redISub(s);
            var yyyy8 = yyyy.redIAdd(yyyy);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            nx = t;
            ny = m.redMul(s.redISub(t)).redISub(yyyy8);
            nz = this.y.redAdd(this.y);
        } else {
            var a = this.x.redSqr();
            var b = this.y.redSqr();
            var c = b.redSqr();
            var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
            d = d.redIAdd(d);
            var e = a.redAdd(a).redIAdd(a);
            var f = e.redSqr();
            var c8 = c.redIAdd(c);
            c8 = c8.redIAdd(c8);
            c8 = c8.redIAdd(c8);
            nx = f.redISub(d).redISub(d);
            ny = e.redMul(d.redISub(nx)).redISub(c8);
            nz = this.y.redMul(this.z);
            nz = nz.redIAdd(nz);
        }
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype._threeDbl = function _threeDbl() {
        var nx;
        var ny;
        var nz;
        if (this.zOne) {
            var xx = this.x.redSqr();
            var yy = this.y.redSqr();
            var yyyy = yy.redSqr();
            var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
            s = s.redIAdd(s);
            var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
            var t = m.redSqr().redISub(s).redISub(s);
            nx = t;
            var yyyy8 = yyyy.redIAdd(yyyy);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            yyyy8 = yyyy8.redIAdd(yyyy8);
            ny = m.redMul(s.redISub(t)).redISub(yyyy8);
            nz = this.y.redAdd(this.y);
        } else {
            var delta = this.z.redSqr();
            var gamma = this.y.redSqr();
            var beta = this.x.redMul(gamma);
            var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
            alpha = alpha.redAdd(alpha).redIAdd(alpha);
            var beta4 = beta.redIAdd(beta);
            beta4 = beta4.redIAdd(beta4);
            var beta8 = beta4.redAdd(beta4);
            nx = alpha.redSqr().redISub(beta8);
            nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
            var ggamma8 = gamma.redSqr();
            ggamma8 = ggamma8.redIAdd(ggamma8);
            ggamma8 = ggamma8.redIAdd(ggamma8);
            ggamma8 = ggamma8.redIAdd(ggamma8);
            ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
        }
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype._dbl = function _dbl() {
        var a = this.curve.a;
        var jx = this.x;
        var jy = this.y;
        var jz = this.z;
        var jz4 = jz.redSqr().redSqr();
        var jx2 = jx.redSqr();
        var jy2 = jy.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var jxd4 = jx.redAdd(jx);
        jxd4 = jxd4.redIAdd(jxd4);
        var t1 = jxd4.redMul(jy2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var jyd8 = jy2.redSqr();
        jyd8 = jyd8.redIAdd(jyd8);
        jyd8 = jyd8.redIAdd(jyd8);
        jyd8 = jyd8.redIAdd(jyd8);
        var ny = c.redMul(t2).redISub(jyd8);
        var nz = jy.redAdd(jy).redMul(jz);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.trpl = function trpl() {
        if (!this.curve.zeroA) return this.dbl().add(this);
        var xx = this.x.redSqr();
        var yy = this.y.redSqr();
        var zz = this.z.redSqr();
        var yyyy = yy.redSqr();
        var m = xx.redAdd(xx).redIAdd(xx);
        var mm = m.redSqr();
        var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        e = e.redIAdd(e);
        e = e.redAdd(e).redIAdd(e);
        e = e.redISub(mm);
        var ee = e.redSqr();
        var t = yyyy.redIAdd(yyyy);
        t = t.redIAdd(t);
        t = t.redIAdd(t);
        t = t.redIAdd(t);
        var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
        var yyu4 = yy.redMul(u);
        yyu4 = yyu4.redIAdd(yyu4);
        yyu4 = yyu4.redIAdd(yyu4);
        var nx = this.x.redMul(ee).redISub(yyu4);
        nx = nx.redIAdd(nx);
        nx = nx.redIAdd(nx);
        var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
        ny = ny.redIAdd(ny);
        ny = ny.redIAdd(ny);
        ny = ny.redIAdd(ny);
        var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
        return this.curve.jpoint(nx, ny, nz);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.mul = function mul(k, kbase) {
        k = new $9pbIC(k, kbase);
        return this.curve._wnafMul(this, k);
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.eq = function eq(p) {
        if (p.type === 'affine') return this.eq(p.toJ());
        if (this === p) return true;
        var z2 = this.z.redSqr();
        var pz2 = p.z.redSqr();
        if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
        var z3 = z2.redMul(this.z);
        var pz3 = pz2.redMul(p.z);
        return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
        var zs = this.z.redSqr();
        var rx = x.toRed(this.curve.red).redMul(zs);
        if (this.x.cmp(rx) === 0) return true;
        var xc = x.clone();
        var t = this.curve.redN.redMul(zs);
        for(;;){
            xc.iadd(this.curve.n);
            if (xc.cmp(this.curve.p) >= 0) return false;
            rx.redIAdd(t);
            if (this.x.cmp(rx) === 0) return true;
        }
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC JPoint Infinity>';
        return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
    };
    $7718e0f8fe39ea5b$var$JPoint.prototype.isInfinity = function isInfinity() {
        return this.z.cmpn(0) === 0;
    };
});
parcelRegister("8yFev", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $v3bBu = parcelRequire("v3bBu");
    var $5DDDX = parcelRequire("5DDDX");
    var $onO0l = parcelRequire("onO0l");
    function $63b17bb79b50781b$var$MontCurve(conf) {
        $5DDDX.call(this, 'mont', conf);
        this.a = new $9pbIC(conf.a, 16).toRed(this.red);
        this.b = new $9pbIC(conf.b, 16).toRed(this.red);
        this.i4 = new $9pbIC(4).toRed(this.red).redInvm();
        this.two = new $9pbIC(2).toRed(this.red);
        this.a24 = this.i4.redMul(this.a.redAdd(this.two));
    }
    $v3bBu($63b17bb79b50781b$var$MontCurve, $5DDDX);
    module.exports = $63b17bb79b50781b$var$MontCurve;
    $63b17bb79b50781b$var$MontCurve.prototype.validate = function validate(point) {
        var x = point.normalize().x;
        var x2 = x.redSqr();
        var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
        var y = rhs.redSqrt();
        return y.redSqr().cmp(rhs) === 0;
    };
    function $63b17bb79b50781b$var$Point(curve, x, z) {
        $5DDDX.BasePoint.call(this, curve, 'projective');
        if (x === null && z === null) {
            this.x = this.curve.one;
            this.z = this.curve.zero;
        } else {
            this.x = new $9pbIC(x, 16);
            this.z = new $9pbIC(z, 16);
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        }
    }
    $v3bBu($63b17bb79b50781b$var$Point, $5DDDX.BasePoint);
    $63b17bb79b50781b$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
        return this.point($onO0l.toArray(bytes, enc), 1);
    };
    $63b17bb79b50781b$var$MontCurve.prototype.point = function point(x, z) {
        return new $63b17bb79b50781b$var$Point(this, x, z);
    };
    $63b17bb79b50781b$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
        return $63b17bb79b50781b$var$Point.fromJSON(this, obj);
    };
    $63b17bb79b50781b$var$Point.prototype.precompute = function precompute() {};
    $63b17bb79b50781b$var$Point.prototype._encode = function _encode() {
        return this.getX().toArray('be', this.curve.p.byteLength());
    };
    $63b17bb79b50781b$var$Point.fromJSON = function fromJSON(curve, obj) {
        return new $63b17bb79b50781b$var$Point(curve, obj[0], obj[1] || curve.one);
    };
    $63b17bb79b50781b$var$Point.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    };
    $63b17bb79b50781b$var$Point.prototype.isInfinity = function isInfinity() {
        return this.z.cmpn(0) === 0;
    };
    $63b17bb79b50781b$var$Point.prototype.dbl = function dbl() {
        var a = this.x.redAdd(this.z);
        var aa = a.redSqr();
        var b = this.x.redSub(this.z);
        var bb = b.redSqr();
        var c = aa.redSub(bb);
        var nx = aa.redMul(bb);
        var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
        return this.curve.point(nx, nz);
    };
    $63b17bb79b50781b$var$Point.prototype.add = function add() {
        throw new Error('Not supported on Montgomery curve');
    };
    $63b17bb79b50781b$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
        var a = this.x.redAdd(this.z);
        var b = this.x.redSub(this.z);
        var c = p.x.redAdd(p.z);
        var d = p.x.redSub(p.z);
        var da = d.redMul(a);
        var cb = c.redMul(b);
        var nx = diff.z.redMul(da.redAdd(cb).redSqr());
        var nz = diff.x.redMul(da.redISub(cb).redSqr());
        return this.curve.point(nx, nz);
    };
    $63b17bb79b50781b$var$Point.prototype.mul = function mul(k) {
        var t = k.clone();
        var a = this;
        var b = this.curve.point(null, null);
        var c = this;
        for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
        for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
            a = a.diffAdd(b, c);
            b = b.dbl();
        } else {
            b = a.diffAdd(b, c);
            a = a.dbl();
        }
        return b;
    };
    $63b17bb79b50781b$var$Point.prototype.mulAdd = function mulAdd() {
        throw new Error('Not supported on Montgomery curve');
    };
    $63b17bb79b50781b$var$Point.prototype.jumlAdd = function jumlAdd() {
        throw new Error('Not supported on Montgomery curve');
    };
    $63b17bb79b50781b$var$Point.prototype.eq = function eq(other) {
        return this.getX().cmp(other.getX()) === 0;
    };
    $63b17bb79b50781b$var$Point.prototype.normalize = function normalize() {
        this.x = this.x.redMul(this.z.redInvm());
        this.z = this.curve.one;
        return this;
    };
    $63b17bb79b50781b$var$Point.prototype.getX = function getX() {
        this.normalize();
        return this.x.fromRed();
    };
});
parcelRegister("4wgwz", function(module, exports) {
    'use strict';
    var $onO0l = parcelRequire("onO0l");
    var $9pbIC = parcelRequire("9pbIC");
    var $v3bBu = parcelRequire("v3bBu");
    var $5DDDX = parcelRequire("5DDDX");
    var $34a6f7f58efb73a0$var$assert = $onO0l.assert;
    function $34a6f7f58efb73a0$var$EdwardsCurve(conf) {
        this.twisted = (conf.a | 0) !== 1;
        this.mOneA = this.twisted && (conf.a | 0) === -1;
        this.extended = this.mOneA;
        $5DDDX.call(this, 'edwards', conf);
        this.a = new $9pbIC(conf.a, 16).umod(this.red.m);
        this.a = this.a.toRed(this.red);
        this.c = new $9pbIC(conf.c, 16).toRed(this.red);
        this.c2 = this.c.redSqr();
        this.d = new $9pbIC(conf.d, 16).toRed(this.red);
        this.dd = this.d.redAdd(this.d);
        $34a6f7f58efb73a0$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
        this.oneC = (conf.c | 0) === 1;
    }
    $v3bBu($34a6f7f58efb73a0$var$EdwardsCurve, $5DDDX);
    module.exports = $34a6f7f58efb73a0$var$EdwardsCurve;
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
        if (this.mOneA) return num.redNeg();
        else return this.a.redMul(num);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
        if (this.oneC) return num;
        else return this.c.redMul(num);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
        return this.point(x, y, z, t);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
        x = new $9pbIC(x, 16);
        if (!x.red) x = x.toRed(this.red);
        var x2 = x.redSqr();
        var rhs = this.c2.redSub(this.a.redMul(x2));
        var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
        var y2 = rhs.redMul(lhs.redInvm());
        var y = y2.redSqrt();
        if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
        var isOdd = y.fromRed().isOdd();
        if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
        return this.point(x, y);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
        y = new $9pbIC(y, 16);
        if (!y.red) y = y.toRed(this.red);
        var y2 = y.redSqr();
        var lhs = y2.redSub(this.c2);
        var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
        var x2 = lhs.redMul(rhs.redInvm());
        if (x2.cmp(this.zero) === 0) {
            if (odd) throw new Error('invalid point');
            else return this.point(this.zero, y);
        }
        var x = x2.redSqrt();
        if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
        if (x.fromRed().isOdd() !== odd) x = x.redNeg();
        return this.point(x, y);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.validate = function validate(point) {
        if (point.isInfinity()) return true;
        point.normalize();
        var x2 = point.x.redSqr();
        var y2 = point.y.redSqr();
        var lhs = x2.redMul(this.a).redAdd(y2);
        var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
        return lhs.cmp(rhs) === 0;
    };
    function $34a6f7f58efb73a0$var$Point(curve, x, y, z, t) {
        $5DDDX.BasePoint.call(this, curve, 'projective');
        if (x === null && y === null && z === null) {
            this.x = this.curve.zero;
            this.y = this.curve.one;
            this.z = this.curve.one;
            this.t = this.curve.zero;
            this.zOne = true;
        } else {
            this.x = new $9pbIC(x, 16);
            this.y = new $9pbIC(y, 16);
            this.z = z ? new $9pbIC(z, 16) : this.curve.one;
            this.t = t && new $9pbIC(t, 16);
            if (!this.x.red) this.x = this.x.toRed(this.curve.red);
            if (!this.y.red) this.y = this.y.toRed(this.curve.red);
            if (!this.z.red) this.z = this.z.toRed(this.curve.red);
            if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
            this.zOne = this.z === this.curve.one;
            if (this.curve.extended && !this.t) {
                this.t = this.x.redMul(this.y);
                if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
            }
        }
    }
    $v3bBu($34a6f7f58efb73a0$var$Point, $5DDDX.BasePoint);
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
        return $34a6f7f58efb73a0$var$Point.fromJSON(this, obj);
    };
    $34a6f7f58efb73a0$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
        return new $34a6f7f58efb73a0$var$Point(this, x, y, z, t);
    };
    $34a6f7f58efb73a0$var$Point.fromJSON = function fromJSON(curve, obj) {
        return new $34a6f7f58efb73a0$var$Point(curve, obj[0], obj[1], obj[2]);
    };
    $34a6f7f58efb73a0$var$Point.prototype.inspect = function inspect() {
        if (this.isInfinity()) return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
    };
    $34a6f7f58efb73a0$var$Point.prototype.isInfinity = function isInfinity() {
        return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
    };
    $34a6f7f58efb73a0$var$Point.prototype._extDbl = function _extDbl() {
        var a = this.x.redSqr();
        var b = this.y.redSqr();
        var c = this.z.redSqr();
        c = c.redIAdd(c);
        var d = this.curve._mulA(a);
        var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
        var g = d.redAdd(b);
        var f = g.redSub(c);
        var h = d.redSub(b);
        var nx = e.redMul(f);
        var ny = g.redMul(h);
        var nt = e.redMul(h);
        var nz = f.redMul(g);
        return this.curve.point(nx, ny, nz, nt);
    };
    $34a6f7f58efb73a0$var$Point.prototype._projDbl = function _projDbl() {
        var b = this.x.redAdd(this.y).redSqr();
        var c = this.x.redSqr();
        var d = this.y.redSqr();
        var nx;
        var ny;
        var nz;
        var e;
        var h;
        var j;
        if (this.curve.twisted) {
            e = this.curve._mulA(c);
            var f = e.redAdd(d);
            if (this.zOne) {
                nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
                ny = f.redMul(e.redSub(d));
                nz = f.redSqr().redSub(f).redSub(f);
            } else {
                h = this.z.redSqr();
                j = f.redSub(h).redISub(h);
                nx = b.redSub(c).redISub(d).redMul(j);
                ny = f.redMul(e.redSub(d));
                nz = f.redMul(j);
            }
        } else {
            e = c.redAdd(d);
            h = this.curve._mulC(this.z).redSqr();
            j = e.redSub(h).redSub(h);
            nx = this.curve._mulC(b.redISub(e)).redMul(j);
            ny = this.curve._mulC(e).redMul(c.redISub(d));
            nz = e.redMul(j);
        }
        return this.curve.point(nx, ny, nz);
    };
    $34a6f7f58efb73a0$var$Point.prototype.dbl = function dbl() {
        if (this.isInfinity()) return this;
        if (this.curve.extended) return this._extDbl();
        else return this._projDbl();
    };
    $34a6f7f58efb73a0$var$Point.prototype._extAdd = function _extAdd(p) {
        var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
        var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
        var c = this.t.redMul(this.curve.dd).redMul(p.t);
        var d = this.z.redMul(p.z.redAdd(p.z));
        var e = b.redSub(a);
        var f = d.redSub(c);
        var g = d.redAdd(c);
        var h = b.redAdd(a);
        var nx = e.redMul(f);
        var ny = g.redMul(h);
        var nt = e.redMul(h);
        var nz = f.redMul(g);
        return this.curve.point(nx, ny, nz, nt);
    };
    $34a6f7f58efb73a0$var$Point.prototype._projAdd = function _projAdd(p) {
        var a = this.z.redMul(p.z);
        var b = a.redSqr();
        var c = this.x.redMul(p.x);
        var d = this.y.redMul(p.y);
        var e = this.curve.d.redMul(c).redMul(d);
        var f = b.redSub(e);
        var g = b.redAdd(e);
        var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
        var nx = a.redMul(f).redMul(tmp);
        var ny;
        var nz;
        if (this.curve.twisted) {
            ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
            nz = f.redMul(g);
        } else {
            ny = a.redMul(g).redMul(d.redSub(c));
            nz = this.curve._mulC(f).redMul(g);
        }
        return this.curve.point(nx, ny, nz);
    };
    $34a6f7f58efb73a0$var$Point.prototype.add = function add(p) {
        if (this.isInfinity()) return p;
        if (p.isInfinity()) return this;
        if (this.curve.extended) return this._extAdd(p);
        else return this._projAdd(p);
    };
    $34a6f7f58efb73a0$var$Point.prototype.mul = function mul(k) {
        if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
        else return this.curve._wnafMul(this, k);
    };
    $34a6f7f58efb73a0$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
        return this.curve._wnafMulAdd(1, [
            this,
            p
        ], [
            k1,
            k2
        ], 2, false);
    };
    $34a6f7f58efb73a0$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
        return this.curve._wnafMulAdd(1, [
            this,
            p
        ], [
            k1,
            k2
        ], 2, true);
    };
    $34a6f7f58efb73a0$var$Point.prototype.normalize = function normalize() {
        if (this.zOne) return this;
        var zi = this.z.redInvm();
        this.x = this.x.redMul(zi);
        this.y = this.y.redMul(zi);
        if (this.t) this.t = this.t.redMul(zi);
        this.z = this.curve.one;
        this.zOne = true;
        return this;
    };
    $34a6f7f58efb73a0$var$Point.prototype.neg = function neg() {
        return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    };
    $34a6f7f58efb73a0$var$Point.prototype.getX = function getX() {
        this.normalize();
        return this.x.fromRed();
    };
    $34a6f7f58efb73a0$var$Point.prototype.getY = function getY() {
        this.normalize();
        return this.y.fromRed();
    };
    $34a6f7f58efb73a0$var$Point.prototype.eq = function eq(other) {
        return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
    };
    $34a6f7f58efb73a0$var$Point.prototype.eqXToP = function eqXToP(x) {
        var rx = x.toRed(this.curve.red).redMul(this.z);
        if (this.x.cmp(rx) === 0) return true;
        var xc = x.clone();
        var t = this.curve.redN.redMul(this.z);
        for(;;){
            xc.iadd(this.curve.n);
            if (xc.cmp(this.curve.p) >= 0) return false;
            rx.redIAdd(t);
            if (this.x.cmp(rx) === 0) return true;
        }
    };
    $34a6f7f58efb73a0$var$Point.prototype.toP = $34a6f7f58efb73a0$var$Point.prototype.normalize;
    $34a6f7f58efb73a0$var$Point.prototype.mixedAdd = $34a6f7f58efb73a0$var$Point.prototype.add;
});
parcelRegister("gli5y", function(module, exports) {
    'use strict';
    var $be5ca37f73d5b5bb$var$curves = module.exports;
    var $hx0iN = parcelRequire("hx0iN");
    var $9QOKF = parcelRequire("9QOKF");
    var $onO0l = parcelRequire("onO0l");
    var $be5ca37f73d5b5bb$var$assert = $onO0l.assert;
    function $be5ca37f73d5b5bb$var$PresetCurve(options) {
        if (options.type === 'short') this.curve = new $9QOKF.short(options);
        else if (options.type === 'edwards') this.curve = new $9QOKF.edwards(options);
        else this.curve = new $9QOKF.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        $be5ca37f73d5b5bb$var$assert(this.g.validate(), 'Invalid curve');
        $be5ca37f73d5b5bb$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
    }
    $be5ca37f73d5b5bb$var$curves.PresetCurve = $be5ca37f73d5b5bb$var$PresetCurve;
    function $be5ca37f73d5b5bb$var$defineCurve(name, options) {
        Object.defineProperty($be5ca37f73d5b5bb$var$curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new $be5ca37f73d5b5bb$var$PresetCurve(options);
                Object.defineProperty($be5ca37f73d5b5bb$var$curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    $be5ca37f73d5b5bb$var$defineCurve('p192', {
        type: 'short',
        prime: 'p192',
        p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
        b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
        n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
            '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p224', {
        type: 'short',
        prime: 'p224',
        p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
        b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
        n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
            'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p256', {
        type: 'short',
        prime: null,
        p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
        a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
        b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
        n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
            '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p384', {
        type: 'short',
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: $hx0iN.sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('p521', {
        type: 'short',
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: $hx0iN.sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('curve25519', {
        type: 'mont',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '76d06',
        b: '1',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '9'
        ]
    });
    $be5ca37f73d5b5bb$var$defineCurve('ed25519', {
        type: 'edwards',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '-1',
        c: '1',
        d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: $hx0iN.sha256,
        gRed: false,
        g: [
            '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
            '6666666666666666666666666666666666666666666666666666666666666658'
        ]
    });
    var $be5ca37f73d5b5bb$var$pre;
    try {
        $be5ca37f73d5b5bb$var$pre = (parcelRequire("6pt7M"));
    } catch (e) {
        $be5ca37f73d5b5bb$var$pre = undefined;
    }
    $be5ca37f73d5b5bb$var$defineCurve('secp256k1', {
        type: 'short',
        prime: 'k256',
        p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
        a: '0',
        b: '7',
        n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
        h: '1',
        hash: $hx0iN.sha256,
        beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
        lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
        basis: [
            {
                a: '3086d221a7d46bcde86c90e49284eb15',
                b: '-e4437ed6010e88286f547fa90abfe4c3'
            },
            {
                a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
                b: '3086d221a7d46bcde86c90e49284eb15'
            }
        ],
        gRed: false,
        g: [
            '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
            '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
            $be5ca37f73d5b5bb$var$pre
        ]
    });
});
parcelRegister("hx0iN", function(module, exports) {
    var $cc35c0beabff9706$var$hash = module.exports;
    $cc35c0beabff9706$var$hash.utils = (parcelRequire("3OMi8"));
    $cc35c0beabff9706$var$hash.common = (parcelRequire("37Fr9"));
    $cc35c0beabff9706$var$hash.sha = (parcelRequire("h6ox1"));
    $cc35c0beabff9706$var$hash.ripemd = (parcelRequire("7uO26"));
    $cc35c0beabff9706$var$hash.hmac = (parcelRequire("aFtrN"));
    $cc35c0beabff9706$var$hash.sha1 = $cc35c0beabff9706$var$hash.sha.sha1;
    $cc35c0beabff9706$var$hash.sha256 = $cc35c0beabff9706$var$hash.sha.sha256;
    $cc35c0beabff9706$var$hash.sha224 = $cc35c0beabff9706$var$hash.sha.sha224;
    $cc35c0beabff9706$var$hash.sha384 = $cc35c0beabff9706$var$hash.sha.sha384;
    $cc35c0beabff9706$var$hash.sha512 = $cc35c0beabff9706$var$hash.sha.sha512;
    $cc35c0beabff9706$var$hash.ripemd160 = $cc35c0beabff9706$var$hash.ripemd.ripemd160;
});
parcelRegister("3OMi8", function(module, exports) {
    $parcel$export(module.exports, "inherits", ()=>$2c7b8050559f98bf$export$69f1b2dcda23c5f8, (v)=>$2c7b8050559f98bf$export$69f1b2dcda23c5f8 = v);
    $parcel$export(module.exports, "toArray", ()=>$2c7b8050559f98bf$export$45b10814cc054894, (v)=>$2c7b8050559f98bf$export$45b10814cc054894 = v);
    $parcel$export(module.exports, "toHex", ()=>$2c7b8050559f98bf$export$7ea66e3774a60b67, (v)=>$2c7b8050559f98bf$export$7ea66e3774a60b67 = v);
    $parcel$export(module.exports, "htonl", ()=>$2c7b8050559f98bf$export$34a52f00f601f6f1, (v)=>$2c7b8050559f98bf$export$34a52f00f601f6f1 = v);
    $parcel$export(module.exports, "toHex32", ()=>$2c7b8050559f98bf$export$812b0cbd5e8a72ab, (v)=>$2c7b8050559f98bf$export$812b0cbd5e8a72ab = v);
    $parcel$export(module.exports, "zero2", ()=>$2c7b8050559f98bf$export$f24f9e11d63bb314, (v)=>$2c7b8050559f98bf$export$f24f9e11d63bb314 = v);
    $parcel$export(module.exports, "zero8", ()=>$2c7b8050559f98bf$export$b71357c7e07ca1f1, (v)=>$2c7b8050559f98bf$export$b71357c7e07ca1f1 = v);
    $parcel$export(module.exports, "join32", ()=>$2c7b8050559f98bf$export$2e58a4b541fdcbe8, (v)=>$2c7b8050559f98bf$export$2e58a4b541fdcbe8 = v);
    $parcel$export(module.exports, "split32", ()=>$2c7b8050559f98bf$export$183b950bde9faab8, (v)=>$2c7b8050559f98bf$export$183b950bde9faab8 = v);
    $parcel$export(module.exports, "rotr32", ()=>$2c7b8050559f98bf$export$4785c77169fea59e, (v)=>$2c7b8050559f98bf$export$4785c77169fea59e = v);
    $parcel$export(module.exports, "rotl32", ()=>$2c7b8050559f98bf$export$242a185dfcffac5b, (v)=>$2c7b8050559f98bf$export$242a185dfcffac5b = v);
    $parcel$export(module.exports, "sum32", ()=>$2c7b8050559f98bf$export$58c04ae0ae31877d, (v)=>$2c7b8050559f98bf$export$58c04ae0ae31877d = v);
    $parcel$export(module.exports, "sum32_3", ()=>$2c7b8050559f98bf$export$d058ca695f8c6f11, (v)=>$2c7b8050559f98bf$export$d058ca695f8c6f11 = v);
    $parcel$export(module.exports, "sum32_4", ()=>$2c7b8050559f98bf$export$a1efd7fc3e986367, (v)=>$2c7b8050559f98bf$export$a1efd7fc3e986367 = v);
    $parcel$export(module.exports, "sum32_5", ()=>$2c7b8050559f98bf$export$bbfea4a2b5abaab4, (v)=>$2c7b8050559f98bf$export$bbfea4a2b5abaab4 = v);
    $parcel$export(module.exports, "sum64", ()=>$2c7b8050559f98bf$export$97ad4afc7de86152, (v)=>$2c7b8050559f98bf$export$97ad4afc7de86152 = v);
    $parcel$export(module.exports, "sum64_hi", ()=>$2c7b8050559f98bf$export$ce4673d9a79f6a4b, (v)=>$2c7b8050559f98bf$export$ce4673d9a79f6a4b = v);
    $parcel$export(module.exports, "sum64_lo", ()=>$2c7b8050559f98bf$export$786cc99fc6eedc0b, (v)=>$2c7b8050559f98bf$export$786cc99fc6eedc0b = v);
    $parcel$export(module.exports, "sum64_4_hi", ()=>$2c7b8050559f98bf$export$45c59b9a1848dd0, (v)=>$2c7b8050559f98bf$export$45c59b9a1848dd0 = v);
    $parcel$export(module.exports, "sum64_4_lo", ()=>$2c7b8050559f98bf$export$50d8f613e76d3034, (v)=>$2c7b8050559f98bf$export$50d8f613e76d3034 = v);
    $parcel$export(module.exports, "sum64_5_hi", ()=>$2c7b8050559f98bf$export$b8e83683c60ee162, (v)=>$2c7b8050559f98bf$export$b8e83683c60ee162 = v);
    $parcel$export(module.exports, "sum64_5_lo", ()=>$2c7b8050559f98bf$export$aeeb51790d1bcc4a, (v)=>$2c7b8050559f98bf$export$aeeb51790d1bcc4a = v);
    $parcel$export(module.exports, "rotr64_hi", ()=>$2c7b8050559f98bf$export$bb7c616f719ad9c, (v)=>$2c7b8050559f98bf$export$bb7c616f719ad9c = v);
    $parcel$export(module.exports, "rotr64_lo", ()=>$2c7b8050559f98bf$export$4d63290824f9d7df, (v)=>$2c7b8050559f98bf$export$4d63290824f9d7df = v);
    $parcel$export(module.exports, "shr64_hi", ()=>$2c7b8050559f98bf$export$2f64ceb90ef28ea1, (v)=>$2c7b8050559f98bf$export$2f64ceb90ef28ea1 = v);
    $parcel$export(module.exports, "shr64_lo", ()=>$2c7b8050559f98bf$export$8d2089d465f6d10d, (v)=>$2c7b8050559f98bf$export$8d2089d465f6d10d = v);
    var $2c7b8050559f98bf$export$69f1b2dcda23c5f8;
    var $2c7b8050559f98bf$export$45b10814cc054894;
    var $2c7b8050559f98bf$export$7ea66e3774a60b67;
    var $2c7b8050559f98bf$export$34a52f00f601f6f1;
    var $2c7b8050559f98bf$export$812b0cbd5e8a72ab;
    var $2c7b8050559f98bf$export$f24f9e11d63bb314;
    var $2c7b8050559f98bf$export$b71357c7e07ca1f1;
    var $2c7b8050559f98bf$export$2e58a4b541fdcbe8;
    var $2c7b8050559f98bf$export$183b950bde9faab8;
    var $2c7b8050559f98bf$export$4785c77169fea59e;
    var $2c7b8050559f98bf$export$242a185dfcffac5b;
    var $2c7b8050559f98bf$export$58c04ae0ae31877d;
    var $2c7b8050559f98bf$export$d058ca695f8c6f11;
    var $2c7b8050559f98bf$export$a1efd7fc3e986367;
    var $2c7b8050559f98bf$export$bbfea4a2b5abaab4;
    var $2c7b8050559f98bf$export$97ad4afc7de86152;
    var $2c7b8050559f98bf$export$ce4673d9a79f6a4b;
    var $2c7b8050559f98bf$export$786cc99fc6eedc0b;
    var $2c7b8050559f98bf$export$45c59b9a1848dd0;
    var $2c7b8050559f98bf$export$50d8f613e76d3034;
    var $2c7b8050559f98bf$export$b8e83683c60ee162;
    var $2c7b8050559f98bf$export$aeeb51790d1bcc4a;
    var $2c7b8050559f98bf$export$bb7c616f719ad9c;
    var $2c7b8050559f98bf$export$4d63290824f9d7df;
    var $2c7b8050559f98bf$export$2f64ceb90ef28ea1;
    var $2c7b8050559f98bf$export$8d2089d465f6d10d;
    'use strict';
    var $gxaFy = parcelRequire("gxaFy");
    var $v3bBu = parcelRequire("v3bBu");
    $2c7b8050559f98bf$export$69f1b2dcda23c5f8 = $v3bBu;
    function $2c7b8050559f98bf$var$toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg === 'string') {
            if (!enc) for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                var hi = c >> 8;
                var lo = c & 0xff;
                if (hi) res.push(hi, lo);
                else res.push(lo);
            }
            else if (enc === 'hex') {
                msg = msg.replace(/[^a-z0-9]+/ig, '');
                if (msg.length % 2 !== 0) msg = '0' + msg;
                for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
            }
        } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    $2c7b8050559f98bf$export$45b10814cc054894 = $2c7b8050559f98bf$var$toArray;
    function $2c7b8050559f98bf$var$toHex(msg) {
        var res = '';
        for(var i = 0; i < msg.length; i++)res += $2c7b8050559f98bf$var$zero2(msg[i].toString(16));
        return res;
    }
    $2c7b8050559f98bf$export$7ea66e3774a60b67 = $2c7b8050559f98bf$var$toHex;
    function $2c7b8050559f98bf$var$htonl(w) {
        var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
        return res >>> 0;
    }
    $2c7b8050559f98bf$export$34a52f00f601f6f1 = $2c7b8050559f98bf$var$htonl;
    function $2c7b8050559f98bf$var$toHex32(msg, endian) {
        var res = '';
        for(var i = 0; i < msg.length; i++){
            var w = msg[i];
            if (endian === 'little') w = $2c7b8050559f98bf$var$htonl(w);
            res += $2c7b8050559f98bf$var$zero8(w.toString(16));
        }
        return res;
    }
    $2c7b8050559f98bf$export$812b0cbd5e8a72ab = $2c7b8050559f98bf$var$toHex32;
    function $2c7b8050559f98bf$var$zero2(word) {
        if (word.length === 1) return '0' + word;
        else return word;
    }
    $2c7b8050559f98bf$export$f24f9e11d63bb314 = $2c7b8050559f98bf$var$zero2;
    function $2c7b8050559f98bf$var$zero8(word) {
        if (word.length === 7) return '0' + word;
        else if (word.length === 6) return '00' + word;
        else if (word.length === 5) return '000' + word;
        else if (word.length === 4) return '0000' + word;
        else if (word.length === 3) return '00000' + word;
        else if (word.length === 2) return '000000' + word;
        else if (word.length === 1) return '0000000' + word;
        else return word;
    }
    $2c7b8050559f98bf$export$b71357c7e07ca1f1 = $2c7b8050559f98bf$var$zero8;
    function $2c7b8050559f98bf$var$join32(msg, start, end, endian) {
        var len = end - start;
        $gxaFy(len % 4 === 0);
        var res = new Array(len / 4);
        for(var i = 0, k = start; i < res.length; i++, k += 4){
            var w;
            if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
            else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
            res[i] = w >>> 0;
        }
        return res;
    }
    $2c7b8050559f98bf$export$2e58a4b541fdcbe8 = $2c7b8050559f98bf$var$join32;
    function $2c7b8050559f98bf$var$split32(msg, endian) {
        var res = new Array(msg.length * 4);
        for(var i = 0, k = 0; i < msg.length; i++, k += 4){
            var m = msg[i];
            if (endian === 'big') {
                res[k] = m >>> 24;
                res[k + 1] = m >>> 16 & 0xff;
                res[k + 2] = m >>> 8 & 0xff;
                res[k + 3] = m & 0xff;
            } else {
                res[k + 3] = m >>> 24;
                res[k + 2] = m >>> 16 & 0xff;
                res[k + 1] = m >>> 8 & 0xff;
                res[k] = m & 0xff;
            }
        }
        return res;
    }
    $2c7b8050559f98bf$export$183b950bde9faab8 = $2c7b8050559f98bf$var$split32;
    function $2c7b8050559f98bf$var$rotr32(w, b) {
        return w >>> b | w << 32 - b;
    }
    $2c7b8050559f98bf$export$4785c77169fea59e = $2c7b8050559f98bf$var$rotr32;
    function $2c7b8050559f98bf$var$rotl32(w, b) {
        return w << b | w >>> 32 - b;
    }
    $2c7b8050559f98bf$export$242a185dfcffac5b = $2c7b8050559f98bf$var$rotl32;
    function $2c7b8050559f98bf$var$sum32(a, b) {
        return a + b >>> 0;
    }
    $2c7b8050559f98bf$export$58c04ae0ae31877d = $2c7b8050559f98bf$var$sum32;
    function $2c7b8050559f98bf$var$sum32_3(a, b, c) {
        return a + b + c >>> 0;
    }
    $2c7b8050559f98bf$export$d058ca695f8c6f11 = $2c7b8050559f98bf$var$sum32_3;
    function $2c7b8050559f98bf$var$sum32_4(a, b, c, d) {
        return a + b + c + d >>> 0;
    }
    $2c7b8050559f98bf$export$a1efd7fc3e986367 = $2c7b8050559f98bf$var$sum32_4;
    function $2c7b8050559f98bf$var$sum32_5(a, b, c, d, e) {
        return a + b + c + d + e >>> 0;
    }
    $2c7b8050559f98bf$export$bbfea4a2b5abaab4 = $2c7b8050559f98bf$var$sum32_5;
    function $2c7b8050559f98bf$var$sum64(buf, pos, ah, al) {
        var bh = buf[pos];
        var bl = buf[pos + 1];
        var lo = al + bl >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        buf[pos] = hi >>> 0;
        buf[pos + 1] = lo;
    }
    $2c7b8050559f98bf$export$97ad4afc7de86152 = $2c7b8050559f98bf$var$sum64;
    function $2c7b8050559f98bf$var$sum64_hi(ah, al, bh, bl) {
        var lo = al + bl >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        return hi >>> 0;
    }
    $2c7b8050559f98bf$export$ce4673d9a79f6a4b = $2c7b8050559f98bf$var$sum64_hi;
    function $2c7b8050559f98bf$var$sum64_lo(ah, al, bh, bl) {
        var lo = al + bl;
        return lo >>> 0;
    }
    $2c7b8050559f98bf$export$786cc99fc6eedc0b = $2c7b8050559f98bf$var$sum64_lo;
    function $2c7b8050559f98bf$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
        var carry = 0;
        var lo = al;
        lo = lo + bl >>> 0;
        carry += lo < al ? 1 : 0;
        lo = lo + cl >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = lo + dl >>> 0;
        carry += lo < dl ? 1 : 0;
        var hi = ah + bh + ch + dh + carry;
        return hi >>> 0;
    }
    $2c7b8050559f98bf$export$45c59b9a1848dd0 = $2c7b8050559f98bf$var$sum64_4_hi;
    function $2c7b8050559f98bf$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
        var lo = al + bl + cl + dl;
        return lo >>> 0;
    }
    $2c7b8050559f98bf$export$50d8f613e76d3034 = $2c7b8050559f98bf$var$sum64_4_lo;
    function $2c7b8050559f98bf$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var carry = 0;
        var lo = al;
        lo = lo + bl >>> 0;
        carry += lo < al ? 1 : 0;
        lo = lo + cl >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = lo + dl >>> 0;
        carry += lo < dl ? 1 : 0;
        lo = lo + el >>> 0;
        carry += lo < el ? 1 : 0;
        var hi = ah + bh + ch + dh + eh + carry;
        return hi >>> 0;
    }
    $2c7b8050559f98bf$export$b8e83683c60ee162 = $2c7b8050559f98bf$var$sum64_5_hi;
    function $2c7b8050559f98bf$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var lo = al + bl + cl + dl + el;
        return lo >>> 0;
    }
    $2c7b8050559f98bf$export$aeeb51790d1bcc4a = $2c7b8050559f98bf$var$sum64_5_lo;
    function $2c7b8050559f98bf$var$rotr64_hi(ah, al, num) {
        var r = al << 32 - num | ah >>> num;
        return r >>> 0;
    }
    $2c7b8050559f98bf$export$bb7c616f719ad9c = $2c7b8050559f98bf$var$rotr64_hi;
    function $2c7b8050559f98bf$var$rotr64_lo(ah, al, num) {
        var r = ah << 32 - num | al >>> num;
        return r >>> 0;
    }
    $2c7b8050559f98bf$export$4d63290824f9d7df = $2c7b8050559f98bf$var$rotr64_lo;
    function $2c7b8050559f98bf$var$shr64_hi(ah, al, num) {
        return ah >>> num;
    }
    $2c7b8050559f98bf$export$2f64ceb90ef28ea1 = $2c7b8050559f98bf$var$shr64_hi;
    function $2c7b8050559f98bf$var$shr64_lo(ah, al, num) {
        var r = ah << 32 - num | al >>> num;
        return r >>> 0;
    }
    $2c7b8050559f98bf$export$8d2089d465f6d10d = $2c7b8050559f98bf$var$shr64_lo;
});
parcelRegister("37Fr9", function(module, exports) {
    $parcel$export(module.exports, "BlockHash", ()=>$24622b0c2a9af610$export$8687658379b577e6, (v)=>$24622b0c2a9af610$export$8687658379b577e6 = v);
    var $24622b0c2a9af610$export$8687658379b577e6;
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $gxaFy = parcelRequire("gxaFy");
    function $24622b0c2a9af610$var$BlockHash() {
        this.pending = null;
        this.pendingTotal = 0;
        this.blockSize = this.constructor.blockSize;
        this.outSize = this.constructor.outSize;
        this.hmacStrength = this.constructor.hmacStrength;
        this.padLength = this.constructor.padLength / 8;
        this.endian = 'big';
        this._delta8 = this.blockSize / 8;
        this._delta32 = this.blockSize / 32;
    }
    $24622b0c2a9af610$export$8687658379b577e6 = $24622b0c2a9af610$var$BlockHash;
    $24622b0c2a9af610$var$BlockHash.prototype.update = function update(msg, enc) {
        msg = $3OMi8.toArray(msg, enc);
        if (!this.pending) this.pending = msg;
        else this.pending = this.pending.concat(msg);
        this.pendingTotal += msg.length;
        if (this.pending.length >= this._delta8) {
            msg = this.pending;
            var r = msg.length % this._delta8;
            this.pending = msg.slice(msg.length - r, msg.length);
            if (this.pending.length === 0) this.pending = null;
            msg = $3OMi8.join32(msg, 0, msg.length - r, this.endian);
            for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
        }
        return this;
    };
    $24622b0c2a9af610$var$BlockHash.prototype.digest = function digest(enc) {
        this.update(this._pad());
        $gxaFy(this.pending === null);
        return this._digest(enc);
    };
    $24622b0c2a9af610$var$BlockHash.prototype._pad = function pad() {
        var len = this.pendingTotal;
        var bytes = this._delta8;
        var k = bytes - (len + this.padLength) % bytes;
        var res = new Array(k + this.padLength);
        res[0] = 0x80;
        for(var i = 1; i < k; i++)res[i] = 0;
        len <<= 3;
        if (this.endian === 'big') {
            for(var t = 8; t < this.padLength; t++)res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = len >>> 24 & 0xff;
            res[i++] = len >>> 16 & 0xff;
            res[i++] = len >>> 8 & 0xff;
            res[i++] = len & 0xff;
        } else {
            res[i++] = len & 0xff;
            res[i++] = len >>> 8 & 0xff;
            res[i++] = len >>> 16 & 0xff;
            res[i++] = len >>> 24 & 0xff;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            res[i++] = 0;
            for(t = 8; t < this.padLength; t++)res[i++] = 0;
        }
        return res;
    };
});
parcelRegister("h6ox1", function(module, exports) {
    $parcel$export(module.exports, "sha1", ()=>$c73606a9c2933b70$export$5091bdda49ba90f5, (v)=>$c73606a9c2933b70$export$5091bdda49ba90f5 = v);
    $parcel$export(module.exports, "sha224", ()=>$c73606a9c2933b70$export$97b70509d4e397ea, (v)=>$c73606a9c2933b70$export$97b70509d4e397ea = v);
    $parcel$export(module.exports, "sha256", ()=>$c73606a9c2933b70$export$bced8d2aada2d1c9, (v)=>$c73606a9c2933b70$export$bced8d2aada2d1c9 = v);
    $parcel$export(module.exports, "sha384", ()=>$c73606a9c2933b70$export$612d47d55dedde45, (v)=>$c73606a9c2933b70$export$612d47d55dedde45 = v);
    $parcel$export(module.exports, "sha512", ()=>$c73606a9c2933b70$export$a888d2532e6dc7bb, (v)=>$c73606a9c2933b70$export$a888d2532e6dc7bb = v);
    var $c73606a9c2933b70$export$5091bdda49ba90f5;
    var $c73606a9c2933b70$export$97b70509d4e397ea;
    var $c73606a9c2933b70$export$bced8d2aada2d1c9;
    var $c73606a9c2933b70$export$612d47d55dedde45;
    var $c73606a9c2933b70$export$a888d2532e6dc7bb;
    'use strict';
    $c73606a9c2933b70$export$5091bdda49ba90f5 = (parcelRequire("fjde1"));
    $c73606a9c2933b70$export$97b70509d4e397ea = (parcelRequire("9SOcT"));
    $c73606a9c2933b70$export$bced8d2aada2d1c9 = (parcelRequire("56TG7"));
    $c73606a9c2933b70$export$612d47d55dedde45 = (parcelRequire("bmcCc"));
    $c73606a9c2933b70$export$a888d2532e6dc7bb = (parcelRequire("5EQvK"));
});
parcelRegister("fjde1", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $35KxV = parcelRequire("35KxV");
    var $02e04dfe542928ee$var$rotl32 = $3OMi8.rotl32;
    var $02e04dfe542928ee$var$sum32 = $3OMi8.sum32;
    var $02e04dfe542928ee$var$sum32_5 = $3OMi8.sum32_5;
    var $02e04dfe542928ee$var$ft_1 = $35KxV.ft_1;
    var $02e04dfe542928ee$var$BlockHash = $37Fr9.BlockHash;
    var $02e04dfe542928ee$var$sha1_K = [
        0x5A827999,
        0x6ED9EBA1,
        0x8F1BBCDC,
        0xCA62C1D6
    ];
    function $02e04dfe542928ee$var$SHA1() {
        if (!(this instanceof $02e04dfe542928ee$var$SHA1)) return new $02e04dfe542928ee$var$SHA1();
        $02e04dfe542928ee$var$BlockHash.call(this);
        this.h = [
            0x67452301,
            0xefcdab89,
            0x98badcfe,
            0x10325476,
            0xc3d2e1f0
        ];
        this.W = new Array(80);
    }
    $3OMi8.inherits($02e04dfe542928ee$var$SHA1, $02e04dfe542928ee$var$BlockHash);
    module.exports = $02e04dfe542928ee$var$SHA1;
    $02e04dfe542928ee$var$SHA1.blockSize = 512;
    $02e04dfe542928ee$var$SHA1.outSize = 160;
    $02e04dfe542928ee$var$SHA1.hmacStrength = 80;
    $02e04dfe542928ee$var$SHA1.padLength = 64;
    $02e04dfe542928ee$var$SHA1.prototype._update = function _update(msg, start) {
        var W = this.W;
        for(var i = 0; i < 16; i++)W[i] = msg[start + i];
        for(; i < W.length; i++)W[i] = $02e04dfe542928ee$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        for(i = 0; i < W.length; i++){
            var s = ~~(i / 20);
            var t = $02e04dfe542928ee$var$sum32_5($02e04dfe542928ee$var$rotl32(a, 5), $02e04dfe542928ee$var$ft_1(s, b, c, d), e, W[i], $02e04dfe542928ee$var$sha1_K[s]);
            e = d;
            d = c;
            c = $02e04dfe542928ee$var$rotl32(b, 30);
            b = a;
            a = t;
        }
        this.h[0] = $02e04dfe542928ee$var$sum32(this.h[0], a);
        this.h[1] = $02e04dfe542928ee$var$sum32(this.h[1], b);
        this.h[2] = $02e04dfe542928ee$var$sum32(this.h[2], c);
        this.h[3] = $02e04dfe542928ee$var$sum32(this.h[3], d);
        this.h[4] = $02e04dfe542928ee$var$sum32(this.h[4], e);
    };
    $02e04dfe542928ee$var$SHA1.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
        else return $3OMi8.split32(this.h, 'big');
    };
});
parcelRegister("35KxV", function(module, exports) {
    $parcel$export(module.exports, "ft_1", ()=>$2405f1d094d8bdf3$export$5a92649d7ddb9f63, (v)=>$2405f1d094d8bdf3$export$5a92649d7ddb9f63 = v);
    $parcel$export(module.exports, "ch32", ()=>$2405f1d094d8bdf3$export$c6d0d020c3a6269, (v)=>$2405f1d094d8bdf3$export$c6d0d020c3a6269 = v);
    $parcel$export(module.exports, "maj32", ()=>$2405f1d094d8bdf3$export$eb90c27fca05f956, (v)=>$2405f1d094d8bdf3$export$eb90c27fca05f956 = v);
    $parcel$export(module.exports, "s0_256", ()=>$2405f1d094d8bdf3$export$14a4a98e063b1999, (v)=>$2405f1d094d8bdf3$export$14a4a98e063b1999 = v);
    $parcel$export(module.exports, "s1_256", ()=>$2405f1d094d8bdf3$export$d20cecfa1564c686, (v)=>$2405f1d094d8bdf3$export$d20cecfa1564c686 = v);
    $parcel$export(module.exports, "g0_256", ()=>$2405f1d094d8bdf3$export$44fd472a12fc6db, (v)=>$2405f1d094d8bdf3$export$44fd472a12fc6db = v);
    $parcel$export(module.exports, "g1_256", ()=>$2405f1d094d8bdf3$export$1ed238bb6ea1dd47, (v)=>$2405f1d094d8bdf3$export$1ed238bb6ea1dd47 = v);
    var $2405f1d094d8bdf3$export$5a92649d7ddb9f63;
    var $2405f1d094d8bdf3$export$c6d0d020c3a6269;
    var $2405f1d094d8bdf3$export$eb90c27fca05f956;
    var $2405f1d094d8bdf3$export$cc992891a14496a1;
    var $2405f1d094d8bdf3$export$14a4a98e063b1999;
    var $2405f1d094d8bdf3$export$d20cecfa1564c686;
    var $2405f1d094d8bdf3$export$44fd472a12fc6db;
    var $2405f1d094d8bdf3$export$1ed238bb6ea1dd47;
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $2405f1d094d8bdf3$var$rotr32 = $3OMi8.rotr32;
    function $2405f1d094d8bdf3$var$ft_1(s, x, y, z) {
        if (s === 0) return $2405f1d094d8bdf3$var$ch32(x, y, z);
        if (s === 1 || s === 3) return $2405f1d094d8bdf3$var$p32(x, y, z);
        if (s === 2) return $2405f1d094d8bdf3$var$maj32(x, y, z);
    }
    $2405f1d094d8bdf3$export$5a92649d7ddb9f63 = $2405f1d094d8bdf3$var$ft_1;
    function $2405f1d094d8bdf3$var$ch32(x, y, z) {
        return x & y ^ ~x & z;
    }
    $2405f1d094d8bdf3$export$c6d0d020c3a6269 = $2405f1d094d8bdf3$var$ch32;
    function $2405f1d094d8bdf3$var$maj32(x, y, z) {
        return x & y ^ x & z ^ y & z;
    }
    $2405f1d094d8bdf3$export$eb90c27fca05f956 = $2405f1d094d8bdf3$var$maj32;
    function $2405f1d094d8bdf3$var$p32(x, y, z) {
        return x ^ y ^ z;
    }
    $2405f1d094d8bdf3$export$cc992891a14496a1 = $2405f1d094d8bdf3$var$p32;
    function $2405f1d094d8bdf3$var$s0_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 2) ^ $2405f1d094d8bdf3$var$rotr32(x, 13) ^ $2405f1d094d8bdf3$var$rotr32(x, 22);
    }
    $2405f1d094d8bdf3$export$14a4a98e063b1999 = $2405f1d094d8bdf3$var$s0_256;
    function $2405f1d094d8bdf3$var$s1_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 6) ^ $2405f1d094d8bdf3$var$rotr32(x, 11) ^ $2405f1d094d8bdf3$var$rotr32(x, 25);
    }
    $2405f1d094d8bdf3$export$d20cecfa1564c686 = $2405f1d094d8bdf3$var$s1_256;
    function $2405f1d094d8bdf3$var$g0_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 7) ^ $2405f1d094d8bdf3$var$rotr32(x, 18) ^ x >>> 3;
    }
    $2405f1d094d8bdf3$export$44fd472a12fc6db = $2405f1d094d8bdf3$var$g0_256;
    function $2405f1d094d8bdf3$var$g1_256(x) {
        return $2405f1d094d8bdf3$var$rotr32(x, 17) ^ $2405f1d094d8bdf3$var$rotr32(x, 19) ^ x >>> 10;
    }
    $2405f1d094d8bdf3$export$1ed238bb6ea1dd47 = $2405f1d094d8bdf3$var$g1_256;
});
parcelRegister("9SOcT", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $56TG7 = parcelRequire("56TG7");
    function $73201a428a00b147$var$SHA224() {
        if (!(this instanceof $73201a428a00b147$var$SHA224)) return new $73201a428a00b147$var$SHA224();
        $56TG7.call(this);
        this.h = [
            0xc1059ed8,
            0x367cd507,
            0x3070dd17,
            0xf70e5939,
            0xffc00b31,
            0x68581511,
            0x64f98fa7,
            0xbefa4fa4
        ];
    }
    $3OMi8.inherits($73201a428a00b147$var$SHA224, $56TG7);
    module.exports = $73201a428a00b147$var$SHA224;
    $73201a428a00b147$var$SHA224.blockSize = 512;
    $73201a428a00b147$var$SHA224.outSize = 224;
    $73201a428a00b147$var$SHA224.hmacStrength = 192;
    $73201a428a00b147$var$SHA224.padLength = 64;
    $73201a428a00b147$var$SHA224.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h.slice(0, 7), 'big');
        else return $3OMi8.split32(this.h.slice(0, 7), 'big');
    };
});
parcelRegister("56TG7", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $35KxV = parcelRequire("35KxV");
    var $gxaFy = parcelRequire("gxaFy");
    var $3b88b3dcc017da11$var$sum32 = $3OMi8.sum32;
    var $3b88b3dcc017da11$var$sum32_4 = $3OMi8.sum32_4;
    var $3b88b3dcc017da11$var$sum32_5 = $3OMi8.sum32_5;
    var $3b88b3dcc017da11$var$ch32 = $35KxV.ch32;
    var $3b88b3dcc017da11$var$maj32 = $35KxV.maj32;
    var $3b88b3dcc017da11$var$s0_256 = $35KxV.s0_256;
    var $3b88b3dcc017da11$var$s1_256 = $35KxV.s1_256;
    var $3b88b3dcc017da11$var$g0_256 = $35KxV.g0_256;
    var $3b88b3dcc017da11$var$g1_256 = $35KxV.g1_256;
    var $3b88b3dcc017da11$var$BlockHash = $37Fr9.BlockHash;
    var $3b88b3dcc017da11$var$sha256_K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    function $3b88b3dcc017da11$var$SHA256() {
        if (!(this instanceof $3b88b3dcc017da11$var$SHA256)) return new $3b88b3dcc017da11$var$SHA256();
        $3b88b3dcc017da11$var$BlockHash.call(this);
        this.h = [
            0x6a09e667,
            0xbb67ae85,
            0x3c6ef372,
            0xa54ff53a,
            0x510e527f,
            0x9b05688c,
            0x1f83d9ab,
            0x5be0cd19
        ];
        this.k = $3b88b3dcc017da11$var$sha256_K;
        this.W = new Array(64);
    }
    $3OMi8.inherits($3b88b3dcc017da11$var$SHA256, $3b88b3dcc017da11$var$BlockHash);
    module.exports = $3b88b3dcc017da11$var$SHA256;
    $3b88b3dcc017da11$var$SHA256.blockSize = 512;
    $3b88b3dcc017da11$var$SHA256.outSize = 256;
    $3b88b3dcc017da11$var$SHA256.hmacStrength = 192;
    $3b88b3dcc017da11$var$SHA256.padLength = 64;
    $3b88b3dcc017da11$var$SHA256.prototype._update = function _update(msg, start) {
        var W = this.W;
        for(var i = 0; i < 16; i++)W[i] = msg[start + i];
        for(; i < W.length; i++)W[i] = $3b88b3dcc017da11$var$sum32_4($3b88b3dcc017da11$var$g1_256(W[i - 2]), W[i - 7], $3b88b3dcc017da11$var$g0_256(W[i - 15]), W[i - 16]);
        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        var f = this.h[5];
        var g = this.h[6];
        var h = this.h[7];
        $gxaFy(this.k.length === W.length);
        for(i = 0; i < W.length; i++){
            var T1 = $3b88b3dcc017da11$var$sum32_5(h, $3b88b3dcc017da11$var$s1_256(e), $3b88b3dcc017da11$var$ch32(e, f, g), this.k[i], W[i]);
            var T2 = $3b88b3dcc017da11$var$sum32($3b88b3dcc017da11$var$s0_256(a), $3b88b3dcc017da11$var$maj32(a, b, c));
            h = g;
            g = f;
            f = e;
            e = $3b88b3dcc017da11$var$sum32(d, T1);
            d = c;
            c = b;
            b = a;
            a = $3b88b3dcc017da11$var$sum32(T1, T2);
        }
        this.h[0] = $3b88b3dcc017da11$var$sum32(this.h[0], a);
        this.h[1] = $3b88b3dcc017da11$var$sum32(this.h[1], b);
        this.h[2] = $3b88b3dcc017da11$var$sum32(this.h[2], c);
        this.h[3] = $3b88b3dcc017da11$var$sum32(this.h[3], d);
        this.h[4] = $3b88b3dcc017da11$var$sum32(this.h[4], e);
        this.h[5] = $3b88b3dcc017da11$var$sum32(this.h[5], f);
        this.h[6] = $3b88b3dcc017da11$var$sum32(this.h[6], g);
        this.h[7] = $3b88b3dcc017da11$var$sum32(this.h[7], h);
    };
    $3b88b3dcc017da11$var$SHA256.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
        else return $3OMi8.split32(this.h, 'big');
    };
});
parcelRegister("bmcCc", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $5EQvK = parcelRequire("5EQvK");
    function $844b88dda8a6facd$var$SHA384() {
        if (!(this instanceof $844b88dda8a6facd$var$SHA384)) return new $844b88dda8a6facd$var$SHA384();
        $5EQvK.call(this);
        this.h = [
            0xcbbb9d5d,
            0xc1059ed8,
            0x629a292a,
            0x367cd507,
            0x9159015a,
            0x3070dd17,
            0x152fecd8,
            0xf70e5939,
            0x67332667,
            0xffc00b31,
            0x8eb44a87,
            0x68581511,
            0xdb0c2e0d,
            0x64f98fa7,
            0x47b5481d,
            0xbefa4fa4
        ];
    }
    $3OMi8.inherits($844b88dda8a6facd$var$SHA384, $5EQvK);
    module.exports = $844b88dda8a6facd$var$SHA384;
    $844b88dda8a6facd$var$SHA384.blockSize = 1024;
    $844b88dda8a6facd$var$SHA384.outSize = 384;
    $844b88dda8a6facd$var$SHA384.hmacStrength = 192;
    $844b88dda8a6facd$var$SHA384.padLength = 128;
    $844b88dda8a6facd$var$SHA384.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h.slice(0, 12), 'big');
        else return $3OMi8.split32(this.h.slice(0, 12), 'big');
    };
});
parcelRegister("5EQvK", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $gxaFy = parcelRequire("gxaFy");
    var $41e96bc7d61a2263$var$rotr64_hi = $3OMi8.rotr64_hi;
    var $41e96bc7d61a2263$var$rotr64_lo = $3OMi8.rotr64_lo;
    var $41e96bc7d61a2263$var$shr64_hi = $3OMi8.shr64_hi;
    var $41e96bc7d61a2263$var$shr64_lo = $3OMi8.shr64_lo;
    var $41e96bc7d61a2263$var$sum64 = $3OMi8.sum64;
    var $41e96bc7d61a2263$var$sum64_hi = $3OMi8.sum64_hi;
    var $41e96bc7d61a2263$var$sum64_lo = $3OMi8.sum64_lo;
    var $41e96bc7d61a2263$var$sum64_4_hi = $3OMi8.sum64_4_hi;
    var $41e96bc7d61a2263$var$sum64_4_lo = $3OMi8.sum64_4_lo;
    var $41e96bc7d61a2263$var$sum64_5_hi = $3OMi8.sum64_5_hi;
    var $41e96bc7d61a2263$var$sum64_5_lo = $3OMi8.sum64_5_lo;
    var $41e96bc7d61a2263$var$BlockHash = $37Fr9.BlockHash;
    var $41e96bc7d61a2263$var$sha512_K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function $41e96bc7d61a2263$var$SHA512() {
        if (!(this instanceof $41e96bc7d61a2263$var$SHA512)) return new $41e96bc7d61a2263$var$SHA512();
        $41e96bc7d61a2263$var$BlockHash.call(this);
        this.h = [
            0x6a09e667,
            0xf3bcc908,
            0xbb67ae85,
            0x84caa73b,
            0x3c6ef372,
            0xfe94f82b,
            0xa54ff53a,
            0x5f1d36f1,
            0x510e527f,
            0xade682d1,
            0x9b05688c,
            0x2b3e6c1f,
            0x1f83d9ab,
            0xfb41bd6b,
            0x5be0cd19,
            0x137e2179
        ];
        this.k = $41e96bc7d61a2263$var$sha512_K;
        this.W = new Array(160);
    }
    $3OMi8.inherits($41e96bc7d61a2263$var$SHA512, $41e96bc7d61a2263$var$BlockHash);
    module.exports = $41e96bc7d61a2263$var$SHA512;
    $41e96bc7d61a2263$var$SHA512.blockSize = 1024;
    $41e96bc7d61a2263$var$SHA512.outSize = 512;
    $41e96bc7d61a2263$var$SHA512.hmacStrength = 192;
    $41e96bc7d61a2263$var$SHA512.padLength = 128;
    $41e96bc7d61a2263$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
        var W = this.W;
        for(var i = 0; i < 32; i++)W[i] = msg[start + i];
        for(; i < W.length; i += 2){
            var c0_hi = $41e96bc7d61a2263$var$g1_512_hi(W[i - 4], W[i - 3]);
            var c0_lo = $41e96bc7d61a2263$var$g1_512_lo(W[i - 4], W[i - 3]);
            var c1_hi = W[i - 14];
            var c1_lo = W[i - 13];
            var c2_hi = $41e96bc7d61a2263$var$g0_512_hi(W[i - 30], W[i - 29]);
            var c2_lo = $41e96bc7d61a2263$var$g0_512_lo(W[i - 30], W[i - 29]);
            var c3_hi = W[i - 32];
            var c3_lo = W[i - 31];
            W[i] = $41e96bc7d61a2263$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
            W[i + 1] = $41e96bc7d61a2263$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        }
    };
    $41e96bc7d61a2263$var$SHA512.prototype._update = function _update(msg, start) {
        this._prepareBlock(msg, start);
        var W = this.W;
        var ah = this.h[0];
        var al = this.h[1];
        var bh = this.h[2];
        var bl = this.h[3];
        var ch = this.h[4];
        var cl = this.h[5];
        var dh = this.h[6];
        var dl = this.h[7];
        var eh = this.h[8];
        var el = this.h[9];
        var fh = this.h[10];
        var fl = this.h[11];
        var gh = this.h[12];
        var gl = this.h[13];
        var hh = this.h[14];
        var hl = this.h[15];
        $gxaFy(this.k.length === W.length);
        for(var i = 0; i < W.length; i += 2){
            var c0_hi = hh;
            var c0_lo = hl;
            var c1_hi = $41e96bc7d61a2263$var$s1_512_hi(eh, el);
            var c1_lo = $41e96bc7d61a2263$var$s1_512_lo(eh, el);
            var c2_hi = $41e96bc7d61a2263$var$ch64_hi(eh, el, fh, fl, gh, gl);
            var c2_lo = $41e96bc7d61a2263$var$ch64_lo(eh, el, fh, fl, gh, gl);
            var c3_hi = this.k[i];
            var c3_lo = this.k[i + 1];
            var c4_hi = W[i];
            var c4_lo = W[i + 1];
            var T1_hi = $41e96bc7d61a2263$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
            var T1_lo = $41e96bc7d61a2263$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
            c0_hi = $41e96bc7d61a2263$var$s0_512_hi(ah, al);
            c0_lo = $41e96bc7d61a2263$var$s0_512_lo(ah, al);
            c1_hi = $41e96bc7d61a2263$var$maj64_hi(ah, al, bh, bl, ch, cl);
            c1_lo = $41e96bc7d61a2263$var$maj64_lo(ah, al, bh, bl, ch, cl);
            var T2_hi = $41e96bc7d61a2263$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
            var T2_lo = $41e96bc7d61a2263$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
            hh = gh;
            hl = gl;
            gh = fh;
            gl = fl;
            fh = eh;
            fl = el;
            eh = $41e96bc7d61a2263$var$sum64_hi(dh, dl, T1_hi, T1_lo);
            el = $41e96bc7d61a2263$var$sum64_lo(dl, dl, T1_hi, T1_lo);
            dh = ch;
            dl = cl;
            ch = bh;
            cl = bl;
            bh = ah;
            bl = al;
            ah = $41e96bc7d61a2263$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
            al = $41e96bc7d61a2263$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
        }
        $41e96bc7d61a2263$var$sum64(this.h, 0, ah, al);
        $41e96bc7d61a2263$var$sum64(this.h, 2, bh, bl);
        $41e96bc7d61a2263$var$sum64(this.h, 4, ch, cl);
        $41e96bc7d61a2263$var$sum64(this.h, 6, dh, dl);
        $41e96bc7d61a2263$var$sum64(this.h, 8, eh, el);
        $41e96bc7d61a2263$var$sum64(this.h, 10, fh, fl);
        $41e96bc7d61a2263$var$sum64(this.h, 12, gh, gl);
        $41e96bc7d61a2263$var$sum64(this.h, 14, hh, hl);
    };
    $41e96bc7d61a2263$var$SHA512.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'big');
        else return $3OMi8.split32(this.h, 'big');
    };
    function $41e96bc7d61a2263$var$ch64_hi(xh, xl, yh, yl, zh) {
        var r = xh & yh ^ ~xh & zh;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
        var r = xl & yl ^ ~xl & zl;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$maj64_hi(xh, xl, yh, yl, zh) {
        var r = xh & yh ^ xh & zh ^ yh & zh;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
        var r = xl & yl ^ xl & zl ^ yl & zl;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s0_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 28);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 2);
        var c2_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 7);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s0_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 28);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 2);
        var c2_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 7);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s1_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 14);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 18);
        var c2_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 9);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$s1_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 14);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 18);
        var c2_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 9);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g0_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 1);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 8);
        var c2_hi = $41e96bc7d61a2263$var$shr64_hi(xh, xl, 7);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g0_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 1);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 8);
        var c2_lo = $41e96bc7d61a2263$var$shr64_lo(xh, xl, 7);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g1_512_hi(xh, xl) {
        var c0_hi = $41e96bc7d61a2263$var$rotr64_hi(xh, xl, 19);
        var c1_hi = $41e96bc7d61a2263$var$rotr64_hi(xl, xh, 29);
        var c2_hi = $41e96bc7d61a2263$var$shr64_hi(xh, xl, 6);
        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0) r += 0x100000000;
        return r;
    }
    function $41e96bc7d61a2263$var$g1_512_lo(xh, xl) {
        var c0_lo = $41e96bc7d61a2263$var$rotr64_lo(xh, xl, 19);
        var c1_lo = $41e96bc7d61a2263$var$rotr64_lo(xl, xh, 29);
        var c2_lo = $41e96bc7d61a2263$var$shr64_lo(xh, xl, 6);
        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0) r += 0x100000000;
        return r;
    }
});
parcelRegister("7uO26", function(module, exports) {
    $parcel$export(module.exports, "ripemd160", ()=>$575225433f68bc9a$export$d1cea0ee4e3f0d3e, (v)=>$575225433f68bc9a$export$d1cea0ee4e3f0d3e = v);
    var $575225433f68bc9a$export$d1cea0ee4e3f0d3e;
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $37Fr9 = parcelRequire("37Fr9");
    var $575225433f68bc9a$var$rotl32 = $3OMi8.rotl32;
    var $575225433f68bc9a$var$sum32 = $3OMi8.sum32;
    var $575225433f68bc9a$var$sum32_3 = $3OMi8.sum32_3;
    var $575225433f68bc9a$var$sum32_4 = $3OMi8.sum32_4;
    var $575225433f68bc9a$var$BlockHash = $37Fr9.BlockHash;
    function $575225433f68bc9a$var$RIPEMD160() {
        if (!(this instanceof $575225433f68bc9a$var$RIPEMD160)) return new $575225433f68bc9a$var$RIPEMD160();
        $575225433f68bc9a$var$BlockHash.call(this);
        this.h = [
            0x67452301,
            0xefcdab89,
            0x98badcfe,
            0x10325476,
            0xc3d2e1f0
        ];
        this.endian = 'little';
    }
    $3OMi8.inherits($575225433f68bc9a$var$RIPEMD160, $575225433f68bc9a$var$BlockHash);
    $575225433f68bc9a$export$d1cea0ee4e3f0d3e = $575225433f68bc9a$var$RIPEMD160;
    $575225433f68bc9a$var$RIPEMD160.blockSize = 512;
    $575225433f68bc9a$var$RIPEMD160.outSize = 160;
    $575225433f68bc9a$var$RIPEMD160.hmacStrength = 192;
    $575225433f68bc9a$var$RIPEMD160.padLength = 64;
    $575225433f68bc9a$var$RIPEMD160.prototype._update = function update(msg, start) {
        var A = this.h[0];
        var B = this.h[1];
        var C = this.h[2];
        var D = this.h[3];
        var E = this.h[4];
        var Ah = A;
        var Bh = B;
        var Ch = C;
        var Dh = D;
        var Eh = E;
        for(var j = 0; j < 80; j++){
            var T = $575225433f68bc9a$var$sum32($575225433f68bc9a$var$rotl32($575225433f68bc9a$var$sum32_4(A, $575225433f68bc9a$var$f(j, B, C, D), msg[$575225433f68bc9a$var$r[j] + start], $575225433f68bc9a$var$K(j)), $575225433f68bc9a$var$s[j]), E);
            A = E;
            E = D;
            D = $575225433f68bc9a$var$rotl32(C, 10);
            C = B;
            B = T;
            T = $575225433f68bc9a$var$sum32($575225433f68bc9a$var$rotl32($575225433f68bc9a$var$sum32_4(Ah, $575225433f68bc9a$var$f(79 - j, Bh, Ch, Dh), msg[$575225433f68bc9a$var$rh[j] + start], $575225433f68bc9a$var$Kh(j)), $575225433f68bc9a$var$sh[j]), Eh);
            Ah = Eh;
            Eh = Dh;
            Dh = $575225433f68bc9a$var$rotl32(Ch, 10);
            Ch = Bh;
            Bh = T;
        }
        T = $575225433f68bc9a$var$sum32_3(this.h[1], C, Dh);
        this.h[1] = $575225433f68bc9a$var$sum32_3(this.h[2], D, Eh);
        this.h[2] = $575225433f68bc9a$var$sum32_3(this.h[3], E, Ah);
        this.h[3] = $575225433f68bc9a$var$sum32_3(this.h[4], A, Bh);
        this.h[4] = $575225433f68bc9a$var$sum32_3(this.h[0], B, Ch);
        this.h[0] = T;
    };
    $575225433f68bc9a$var$RIPEMD160.prototype._digest = function digest(enc) {
        if (enc === 'hex') return $3OMi8.toHex32(this.h, 'little');
        else return $3OMi8.split32(this.h, 'little');
    };
    function $575225433f68bc9a$var$f(j, x, y, z) {
        if (j <= 15) return x ^ y ^ z;
        else if (j <= 31) return x & y | ~x & z;
        else if (j <= 47) return (x | ~y) ^ z;
        else if (j <= 63) return x & z | y & ~z;
        else return x ^ (y | ~z);
    }
    function $575225433f68bc9a$var$K(j) {
        if (j <= 15) return 0x00000000;
        else if (j <= 31) return 0x5a827999;
        else if (j <= 47) return 0x6ed9eba1;
        else if (j <= 63) return 0x8f1bbcdc;
        else return 0xa953fd4e;
    }
    function $575225433f68bc9a$var$Kh(j) {
        if (j <= 15) return 0x50a28be6;
        else if (j <= 31) return 0x5c4dd124;
        else if (j <= 47) return 0x6d703ef3;
        else if (j <= 63) return 0x7a6d76e9;
        else return 0x00000000;
    }
    var $575225433f68bc9a$var$r = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        7,
        4,
        13,
        1,
        10,
        6,
        15,
        3,
        12,
        0,
        9,
        5,
        2,
        14,
        11,
        8,
        3,
        10,
        14,
        4,
        9,
        15,
        8,
        1,
        2,
        7,
        0,
        6,
        13,
        11,
        5,
        12,
        1,
        9,
        11,
        10,
        0,
        8,
        12,
        4,
        13,
        3,
        7,
        15,
        14,
        5,
        6,
        2,
        4,
        0,
        5,
        9,
        7,
        12,
        2,
        10,
        14,
        1,
        3,
        8,
        11,
        6,
        15,
        13
    ];
    var $575225433f68bc9a$var$rh = [
        5,
        14,
        7,
        0,
        9,
        2,
        11,
        4,
        13,
        6,
        15,
        8,
        1,
        10,
        3,
        12,
        6,
        11,
        3,
        7,
        0,
        13,
        5,
        10,
        14,
        15,
        8,
        12,
        4,
        9,
        1,
        2,
        15,
        5,
        1,
        3,
        7,
        14,
        6,
        9,
        11,
        8,
        12,
        2,
        10,
        0,
        4,
        13,
        8,
        6,
        4,
        1,
        3,
        11,
        15,
        0,
        5,
        12,
        2,
        13,
        9,
        7,
        10,
        14,
        12,
        15,
        10,
        4,
        1,
        5,
        8,
        7,
        6,
        2,
        13,
        14,
        0,
        3,
        9,
        11
    ];
    var $575225433f68bc9a$var$s = [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8,
        7,
        6,
        8,
        13,
        11,
        9,
        7,
        15,
        7,
        12,
        15,
        9,
        11,
        7,
        13,
        12,
        11,
        13,
        6,
        7,
        14,
        9,
        13,
        15,
        14,
        8,
        13,
        6,
        5,
        12,
        7,
        5,
        11,
        12,
        14,
        15,
        14,
        15,
        9,
        8,
        9,
        14,
        5,
        6,
        8,
        6,
        5,
        12,
        9,
        15,
        5,
        11,
        6,
        8,
        13,
        12,
        5,
        12,
        13,
        14,
        11,
        8,
        5,
        6
    ];
    var $575225433f68bc9a$var$sh = [
        8,
        9,
        9,
        11,
        13,
        15,
        15,
        5,
        7,
        7,
        8,
        11,
        14,
        14,
        12,
        6,
        9,
        13,
        15,
        7,
        12,
        8,
        9,
        11,
        7,
        7,
        12,
        7,
        6,
        15,
        13,
        11,
        9,
        7,
        15,
        11,
        8,
        6,
        6,
        14,
        12,
        13,
        5,
        14,
        13,
        13,
        7,
        5,
        15,
        5,
        8,
        11,
        14,
        14,
        6,
        14,
        6,
        9,
        12,
        9,
        12,
        5,
        15,
        8,
        8,
        5,
        12,
        9,
        12,
        5,
        14,
        6,
        8,
        13,
        6,
        5,
        15,
        13,
        11,
        11
    ];
});
parcelRegister("aFtrN", function(module, exports) {
    'use strict';
    var $3OMi8 = parcelRequire("3OMi8");
    var $gxaFy = parcelRequire("gxaFy");
    function $7c44935cedad0a05$var$Hmac(hash, key, enc) {
        if (!(this instanceof $7c44935cedad0a05$var$Hmac)) return new $7c44935cedad0a05$var$Hmac(hash, key, enc);
        this.Hash = hash;
        this.blockSize = hash.blockSize / 8;
        this.outSize = hash.outSize / 8;
        this.inner = null;
        this.outer = null;
        this._init($3OMi8.toArray(key, enc));
    }
    module.exports = $7c44935cedad0a05$var$Hmac;
    $7c44935cedad0a05$var$Hmac.prototype._init = function init(key) {
        if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
        $gxaFy(key.length <= this.blockSize);
        for(var i = key.length; i < this.blockSize; i++)key.push(0);
        for(i = 0; i < key.length; i++)key[i] ^= 0x36;
        this.inner = new this.Hash().update(key);
        for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
        this.outer = new this.Hash().update(key);
    };
    $7c44935cedad0a05$var$Hmac.prototype.update = function update(msg, enc) {
        this.inner.update(msg, enc);
        return this;
    };
    $7c44935cedad0a05$var$Hmac.prototype.digest = function digest(enc) {
        this.outer.update(this.inner.digest());
        return this.outer.digest(enc);
    };
});
parcelRegister("6pt7M", function(module, exports) {
    module.exports = {
        doubles: {
            step: 4,
            points: [
                [
                    'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                    'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
                ],
                [
                    '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                    '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
                ],
                [
                    '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                    'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
                ],
                [
                    '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                    '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
                ],
                [
                    '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                    '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
                ],
                [
                    '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                    '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
                ],
                [
                    'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                    '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
                ],
                [
                    '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                    'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
                ],
                [
                    'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                    '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
                ],
                [
                    'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                    'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
                ],
                [
                    'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                    '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
                ],
                [
                    '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                    '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
                ],
                [
                    '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                    '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
                ],
                [
                    '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                    '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
                ],
                [
                    '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                    '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
                ],
                [
                    '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                    '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
                ],
                [
                    '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                    '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
                ],
                [
                    '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                    '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
                ],
                [
                    '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                    'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
                ],
                [
                    'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                    '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
                ],
                [
                    'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                    '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
                ],
                [
                    '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                    '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
                ],
                [
                    '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                    '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
                ],
                [
                    'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                    '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
                ],
                [
                    '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                    'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
                ],
                [
                    'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                    '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
                ],
                [
                    'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                    'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
                ],
                [
                    'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                    '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
                ],
                [
                    'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                    'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
                ],
                [
                    'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                    '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
                ],
                [
                    '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                    'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
                ],
                [
                    '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                    '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
                ],
                [
                    'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                    '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
                ],
                [
                    '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                    'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
                ],
                [
                    'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                    '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
                ],
                [
                    'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                    '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
                ],
                [
                    'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                    'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
                ],
                [
                    '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                    '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
                ],
                [
                    '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                    '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
                ],
                [
                    '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                    'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
                ],
                [
                    '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                    '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
                ],
                [
                    'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                    '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
                ],
                [
                    '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                    '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
                ],
                [
                    '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                    'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
                ],
                [
                    '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                    '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
                ],
                [
                    'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                    '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
                ],
                [
                    '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                    'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
                ],
                [
                    'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                    'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
                ],
                [
                    'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                    '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
                ],
                [
                    '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                    'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
                ],
                [
                    '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                    'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
                ],
                [
                    'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                    '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
                ],
                [
                    'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                    '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
                ],
                [
                    'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                    '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
                ],
                [
                    '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                    'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
                ],
                [
                    '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                    '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
                ],
                [
                    'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                    'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
                ],
                [
                    '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                    'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
                ],
                [
                    '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                    '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
                ],
                [
                    '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                    '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
                ],
                [
                    'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                    'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
                ],
                [
                    '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                    '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
                ],
                [
                    '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                    '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
                ],
                [
                    'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                    '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
                ],
                [
                    'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                    'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
                ]
            ]
        },
        naf: {
            wnd: 7,
            points: [
                [
                    'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                    '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
                ],
                [
                    '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                    'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
                ],
                [
                    '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                    '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
                ],
                [
                    'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                    'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
                ],
                [
                    '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                    'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
                ],
                [
                    'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                    'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
                ],
                [
                    'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                    '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
                ],
                [
                    'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                    '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
                ],
                [
                    '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                    '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
                ],
                [
                    '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                    '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
                ],
                [
                    '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                    '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
                ],
                [
                    '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                    '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
                ],
                [
                    'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                    'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
                ],
                [
                    'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                    '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
                ],
                [
                    '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                    'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
                ],
                [
                    '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                    'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
                ],
                [
                    '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                    '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
                ],
                [
                    '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                    '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
                ],
                [
                    '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                    '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
                ],
                [
                    '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                    'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
                ],
                [
                    'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                    'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
                ],
                [
                    '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                    '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
                ],
                [
                    '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                    '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
                ],
                [
                    'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                    'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
                ],
                [
                    '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                    '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
                ],
                [
                    'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                    'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
                ],
                [
                    'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                    'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
                ],
                [
                    '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                    '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
                ],
                [
                    '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                    '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
                ],
                [
                    '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                    '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
                ],
                [
                    'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                    '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
                ],
                [
                    '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                    '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
                ],
                [
                    'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                    '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
                ],
                [
                    '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                    'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
                ],
                [
                    '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                    'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
                ],
                [
                    'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                    'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
                ],
                [
                    '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                    '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
                ],
                [
                    '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                    'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
                ],
                [
                    'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                    'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
                ],
                [
                    '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                    '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
                ],
                [
                    '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                    'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
                ],
                [
                    '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                    '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
                ],
                [
                    '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                    'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
                ],
                [
                    'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                    '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
                ],
                [
                    '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                    '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
                ],
                [
                    '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                    'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
                ],
                [
                    '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                    'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
                ],
                [
                    'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                    'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
                ],
                [
                    'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                    'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
                ],
                [
                    '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                    '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
                ],
                [
                    '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                    '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
                ],
                [
                    'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                    '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
                ],
                [
                    'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                    'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
                ],
                [
                    '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                    '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
                ],
                [
                    '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                    '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
                ],
                [
                    'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                    '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
                ],
                [
                    '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                    '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
                ],
                [
                    'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                    'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
                ],
                [
                    '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                    'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
                ],
                [
                    '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                    '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
                ],
                [
                    'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                    '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
                ],
                [
                    'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                    '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
                ],
                [
                    '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                    '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
                ],
                [
                    '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                    '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
                ],
                [
                    '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                    'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
                ],
                [
                    '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                    'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
                ],
                [
                    '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                    '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
                ],
                [
                    '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                    '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
                ],
                [
                    '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                    '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
                ],
                [
                    '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                    'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
                ],
                [
                    'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                    'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
                ],
                [
                    '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                    'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
                ],
                [
                    'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                    '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
                ],
                [
                    'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                    '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
                ],
                [
                    'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                    '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
                ],
                [
                    'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                    '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
                ],
                [
                    '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                    'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
                ],
                [
                    '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                    '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
                ],
                [
                    '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                    'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
                ],
                [
                    'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                    'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
                ],
                [
                    'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                    '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
                ],
                [
                    'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                    'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
                ],
                [
                    'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                    '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
                ],
                [
                    '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                    '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
                ],
                [
                    'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                    '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
                ],
                [
                    'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                    '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
                ],
                [
                    '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                    '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
                ],
                [
                    '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                    'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
                ],
                [
                    'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                    '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
                ],
                [
                    'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                    '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
                ],
                [
                    'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                    '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
                ],
                [
                    '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                    '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
                ],
                [
                    'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                    'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
                ],
                [
                    '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                    'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
                ],
                [
                    'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                    'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
                ],
                [
                    'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                    '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
                ],
                [
                    '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                    'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
                ],
                [
                    'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                    '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
                ],
                [
                    'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                    '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
                ],
                [
                    'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                    '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
                ],
                [
                    '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                    'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
                ],
                [
                    '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                    'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
                ],
                [
                    'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                    '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
                ],
                [
                    '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                    'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
                ],
                [
                    '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                    '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
                ],
                [
                    '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                    'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
                ],
                [
                    'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                    'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
                ],
                [
                    '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                    'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
                ],
                [
                    '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                    '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
                ],
                [
                    '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                    'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
                ],
                [
                    '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                    '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
                ],
                [
                    'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                    'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
                ],
                [
                    '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                    '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
                ],
                [
                    'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                    '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
                ],
                [
                    '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                    '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
                ],
                [
                    'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                    'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
                ],
                [
                    'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                    '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
                ],
                [
                    'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                    'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
                ],
                [
                    '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                    'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
                ],
                [
                    '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                    '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
                ],
                [
                    '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                    'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
                ],
                [
                    '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                    '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
                ],
                [
                    '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                    '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
                ],
                [
                    '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                    'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
                ],
                [
                    '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                    '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
                ],
                [
                    '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                    '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
                ],
                [
                    '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                    '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
                ]
            ]
        }
    };
});
parcelRegister("9Cxq1", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $kj2Mi = parcelRequire("kj2Mi");
    var $onO0l = parcelRequire("onO0l");
    var $gli5y = parcelRequire("gli5y");
    var $9D8YT = parcelRequire("9D8YT");
    var $701195e88ddcfeac$var$assert = $onO0l.assert;
    var $1h5tm = parcelRequire("1h5tm");
    var $hKBzv = parcelRequire("hKBzv");
    function $701195e88ddcfeac$var$EC(options) {
        if (!(this instanceof $701195e88ddcfeac$var$EC)) return new $701195e88ddcfeac$var$EC(options);
        if (typeof options === 'string') {
            $701195e88ddcfeac$var$assert(Object.prototype.hasOwnProperty.call($gli5y, options), 'Unknown curve ' + options);
            options = $gli5y[options];
        }
        if (options instanceof $gli5y.PresetCurve) options = {
            curve: options
        };
        this.curve = options.curve.curve;
        this.n = this.curve.n;
        this.nh = this.n.ushrn(1);
        this.g = this.curve.g;
        this.g = options.curve.g;
        this.g.precompute(options.curve.n.bitLength() + 1);
        this.hash = options.hash || options.curve.hash;
    }
    module.exports = $701195e88ddcfeac$var$EC;
    $701195e88ddcfeac$var$EC.prototype.keyPair = function keyPair(options) {
        return new $1h5tm(this, options);
    };
    $701195e88ddcfeac$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
        return $1h5tm.fromPrivate(this, priv, enc);
    };
    $701195e88ddcfeac$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
        return $1h5tm.fromPublic(this, pub, enc);
    };
    $701195e88ddcfeac$var$EC.prototype.genKeyPair = function genKeyPair(options) {
        if (!options) options = {};
        var drbg = new $kj2Mi({
            hash: this.hash,
            pers: options.pers,
            persEnc: options.persEnc || 'utf8',
            entropy: options.entropy || $9D8YT(this.hash.hmacStrength),
            entropyEnc: options.entropy && options.entropyEnc || 'utf8',
            nonce: this.n.toArray()
        });
        var bytes = this.n.byteLength();
        var ns2 = this.n.sub(new $9pbIC(2));
        for(;;){
            var priv = new $9pbIC(drbg.generate(bytes));
            if (priv.cmp(ns2) > 0) continue;
            priv.iaddn(1);
            return this.keyFromPrivate(priv);
        }
    };
    $701195e88ddcfeac$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
        var byteLength;
        if ($9pbIC.isBN(msg) || typeof msg === 'number') {
            msg = new $9pbIC(msg, 16);
            byteLength = msg.byteLength();
        } else if (typeof msg === 'object') {
            byteLength = msg.length;
            msg = new $9pbIC(msg, 16);
        } else {
            var str = msg.toString();
            byteLength = str.length + 1 >>> 1;
            msg = new $9pbIC(str, 16);
        }
        if (typeof bitLength !== 'number') bitLength = byteLength * 8;
        var delta = bitLength - this.n.bitLength();
        if (delta > 0) msg = msg.ushrn(delta);
        if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
        else return msg;
    };
    $701195e88ddcfeac$var$EC.prototype.sign = function sign(msg, key, enc, options) {
        if (typeof enc === 'object') {
            options = enc;
            enc = null;
        }
        if (!options) options = {};
        if (typeof msg !== 'string' && typeof msg !== 'number' && !$9pbIC.isBN(msg)) {
            $701195e88ddcfeac$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
            $701195e88ddcfeac$var$assert(msg.length >>> 0 === msg.length);
            for(var i = 0; i < msg.length; i++)$701195e88ddcfeac$var$assert((msg[i] & 255) === msg[i]);
        }
        key = this.keyFromPrivate(key, enc);
        msg = this._truncateToN(msg, false, options.msgBitLength);
        $701195e88ddcfeac$var$assert(!msg.isNeg(), 'Can not sign a negative message');
        var bytes = this.n.byteLength();
        var bkey = key.getPrivate().toArray('be', bytes);
        var nonce = msg.toArray('be', bytes);
        $701195e88ddcfeac$var$assert(new $9pbIC(nonce).eq(msg), 'Can not sign message');
        var drbg = new $kj2Mi({
            hash: this.hash,
            entropy: bkey,
            nonce: nonce,
            pers: options.pers,
            persEnc: options.persEnc || 'utf8'
        });
        var ns1 = this.n.sub(new $9pbIC(1));
        for(var iter = 0;; iter++){
            var k = options.k ? options.k(iter) : new $9pbIC(drbg.generate(this.n.byteLength()));
            k = this._truncateToN(k, true);
            if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
            var kp = this.g.mul(k);
            if (kp.isInfinity()) continue;
            var kpX = kp.getX();
            var r = kpX.umod(this.n);
            if (r.cmpn(0) === 0) continue;
            var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
            s = s.umod(this.n);
            if (s.cmpn(0) === 0) continue;
            var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
            if (options.canonical && s.cmp(this.nh) > 0) {
                s = this.n.sub(s);
                recoveryParam ^= 1;
            }
            return new $hKBzv({
                r: r,
                s: s,
                recoveryParam: recoveryParam
            });
        }
    };
    $701195e88ddcfeac$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
        if (!options) options = {};
        msg = this._truncateToN(msg, false, options.msgBitLength);
        key = this.keyFromPublic(key, enc);
        signature = new $hKBzv(signature, 'hex');
        var r = signature.r;
        var s = signature.s;
        if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
        if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
        var sinv = s.invm(this.n);
        var u1 = sinv.mul(msg).umod(this.n);
        var u2 = sinv.mul(r).umod(this.n);
        var p;
        if (!this.curve._maxwellTrick) {
            p = this.g.mulAdd(u1, key.getPublic(), u2);
            if (p.isInfinity()) return false;
            return p.getX().umod(this.n).cmp(r) === 0;
        }
        p = this.g.jmulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.eqXToP(r);
    };
    $701195e88ddcfeac$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
        $701195e88ddcfeac$var$assert((3 & j) === j, 'The recovery param is more than two bits');
        signature = new $hKBzv(signature, enc);
        var n = this.n;
        var e = new $9pbIC(msg);
        var r = signature.r;
        var s = signature.s;
        var isYOdd = j & 1;
        var isSecondKey = j >> 1;
        if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
        if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
        else r = this.curve.pointFromX(r, isYOdd);
        var rInv = signature.r.invm(n);
        var s1 = n.sub(e).mul(rInv).umod(n);
        var s2 = s.mul(rInv).umod(n);
        return this.g.mulAdd(s1, r, s2);
    };
    $701195e88ddcfeac$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
        signature = new $hKBzv(signature, enc);
        if (signature.recoveryParam !== null) return signature.recoveryParam;
        for(var i = 0; i < 4; i++){
            var Qprime;
            try {
                Qprime = this.recoverPubKey(e, signature, i);
            } catch (e) {
                continue;
            }
            if (Qprime.eq(Q)) return i;
        }
        throw new Error('Unable to find valid recovery factor');
    };
});
parcelRegister("kj2Mi", function(module, exports) {
    'use strict';
    var $hx0iN = parcelRequire("hx0iN");
    var $2WqN6 = parcelRequire("2WqN6");
    var $gxaFy = parcelRequire("gxaFy");
    function $ec87bca0fe3c0ec7$var$HmacDRBG(options) {
        if (!(this instanceof $ec87bca0fe3c0ec7$var$HmacDRBG)) return new $ec87bca0fe3c0ec7$var$HmacDRBG(options);
        this.hash = options.hash;
        this.predResist = !!options.predResist;
        this.outLen = this.hash.outSize;
        this.minEntropy = options.minEntropy || this.hash.hmacStrength;
        this._reseed = null;
        this.reseedInterval = null;
        this.K = null;
        this.V = null;
        var entropy = $2WqN6.toArray(options.entropy, options.entropyEnc || 'hex');
        var nonce = $2WqN6.toArray(options.nonce, options.nonceEnc || 'hex');
        var pers = $2WqN6.toArray(options.pers, options.persEnc || 'hex');
        $gxaFy(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._init(entropy, nonce, pers);
    }
    module.exports = $ec87bca0fe3c0ec7$var$HmacDRBG;
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
        var seed = entropy.concat(nonce).concat(pers);
        this.K = new Array(this.outLen / 8);
        this.V = new Array(this.outLen / 8);
        for(var i = 0; i < this.V.length; i++){
            this.K[i] = 0x00;
            this.V[i] = 0x01;
        }
        this._update(seed);
        this._reseed = 1;
        this.reseedInterval = 0x1000000000000;
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype._hmac = function hmac() {
        return new $hx0iN.hmac(this.hash, this.K);
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype._update = function update(seed) {
        var kmac = this._hmac().update(this.V).update([
            0x00
        ]);
        if (seed) kmac = kmac.update(seed);
        this.K = kmac.digest();
        this.V = this._hmac().update(this.V).digest();
        if (!seed) return;
        this.K = this._hmac().update(this.V).update([
            0x01
        ]).update(seed).digest();
        this.V = this._hmac().update(this.V).digest();
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
        if (typeof entropyEnc !== 'string') {
            addEnc = add;
            add = entropyEnc;
            entropyEnc = null;
        }
        entropy = $2WqN6.toArray(entropy, entropyEnc);
        add = $2WqN6.toArray(add, addEnc);
        $gxaFy(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._update(entropy.concat(add || []));
        this._reseed = 1;
    };
    $ec87bca0fe3c0ec7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
        if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
        if (typeof enc !== 'string') {
            addEnc = add;
            add = enc;
            enc = null;
        }
        if (add) {
            add = $2WqN6.toArray(add, addEnc || 'hex');
            this._update(add);
        }
        var temp = [];
        while(temp.length < len){
            this.V = this._hmac().update(this.V).digest();
            temp = temp.concat(this.V);
        }
        var res = temp.slice(0, len);
        this._update(add);
        this._reseed++;
        return $2WqN6.encode(res, enc);
    };
});
parcelRegister("1h5tm", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $0edb9fb4895d148b$var$assert = $onO0l.assert;
    function $0edb9fb4895d148b$var$KeyPair(ec, options) {
        this.ec = ec;
        this.priv = null;
        this.pub = null;
        if (options.priv) this._importPrivate(options.priv, options.privEnc);
        if (options.pub) this._importPublic(options.pub, options.pubEnc);
    }
    module.exports = $0edb9fb4895d148b$var$KeyPair;
    $0edb9fb4895d148b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
        if (pub instanceof $0edb9fb4895d148b$var$KeyPair) return pub;
        return new $0edb9fb4895d148b$var$KeyPair(ec, {
            pub: pub,
            pubEnc: enc
        });
    };
    $0edb9fb4895d148b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
        if (priv instanceof $0edb9fb4895d148b$var$KeyPair) return priv;
        return new $0edb9fb4895d148b$var$KeyPair(ec, {
            priv: priv,
            privEnc: enc
        });
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.validate = function validate() {
        var pub = this.getPublic();
        if (pub.isInfinity()) return {
            result: false,
            reason: 'Invalid public key'
        };
        if (!pub.validate()) return {
            result: false,
            reason: 'Public key is not a point'
        };
        if (!pub.mul(this.ec.curve.n).isInfinity()) return {
            result: false,
            reason: 'Public key * N != O'
        };
        return {
            result: true,
            reason: null
        };
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
        if (typeof compact === 'string') {
            enc = compact;
            compact = null;
        }
        if (!this.pub) this.pub = this.ec.g.mul(this.priv);
        if (!enc) return this.pub;
        return this.pub.encode(enc, compact);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
        if (enc === 'hex') return this.priv.toString(16, 2);
        else return this.priv;
    };
    $0edb9fb4895d148b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
        this.priv = new $9pbIC(key, enc || 16);
        this.priv = this.priv.umod(this.ec.curve.n);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
        if (key.x || key.y) {
            if (this.ec.curve.type === 'mont') $0edb9fb4895d148b$var$assert(key.x, 'Need x coordinate');
            else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $0edb9fb4895d148b$var$assert(key.x && key.y, 'Need both x and y coordinate');
            this.pub = this.ec.curve.point(key.x, key.y);
            return;
        }
        this.pub = this.ec.curve.decodePoint(key, enc);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.derive = function derive(pub) {
        if (!pub.validate()) $0edb9fb4895d148b$var$assert(pub.validate(), 'public point not validated');
        return pub.mul(this.priv).getX();
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
        return this.ec.sign(msg, this, enc, options);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
        return this.ec.verify(msg, signature, this, undefined, options);
    };
    $0edb9fb4895d148b$var$KeyPair.prototype.inspect = function inspect() {
        return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
    };
});
parcelRegister("hKBzv", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $cec3e07d0e69d400$var$assert = $onO0l.assert;
    function $cec3e07d0e69d400$var$Signature(options, enc) {
        if (options instanceof $cec3e07d0e69d400$var$Signature) return options;
        if (this._importDER(options, enc)) return;
        $cec3e07d0e69d400$var$assert(options.r && options.s, 'Signature without r or s');
        this.r = new $9pbIC(options.r, 16);
        this.s = new $9pbIC(options.s, 16);
        if (options.recoveryParam === undefined) this.recoveryParam = null;
        else this.recoveryParam = options.recoveryParam;
    }
    module.exports = $cec3e07d0e69d400$var$Signature;
    function $cec3e07d0e69d400$var$Position() {
        this.place = 0;
    }
    function $cec3e07d0e69d400$var$getLength(buf, p) {
        var initial = buf[p.place++];
        if (!(initial & 0x80)) return initial;
        var octetLen = initial & 0xf;
        if (octetLen === 0 || octetLen > 4) return false;
        if (buf[p.place] === 0x00) return false;
        var val = 0;
        for(var i = 0, off = p.place; i < octetLen; i++, off++){
            val <<= 8;
            val |= buf[off];
            val >>>= 0;
        }
        if (val <= 0x7f) return false;
        p.place = off;
        return val;
    }
    function $cec3e07d0e69d400$var$rmPadding(buf) {
        var i = 0;
        var len = buf.length - 1;
        while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
        if (i === 0) return buf;
        return buf.slice(i);
    }
    $cec3e07d0e69d400$var$Signature.prototype._importDER = function _importDER(data, enc) {
        data = $onO0l.toArray(data, enc);
        var p = new $cec3e07d0e69d400$var$Position();
        if (data[p.place++] !== 0x30) return false;
        var len = $cec3e07d0e69d400$var$getLength(data, p);
        if (len === false) return false;
        if (len + p.place !== data.length) return false;
        if (data[p.place++] !== 0x02) return false;
        var rlen = $cec3e07d0e69d400$var$getLength(data, p);
        if (rlen === false) return false;
        if ((data[p.place] & 128) !== 0) return false;
        var r = data.slice(p.place, rlen + p.place);
        p.place += rlen;
        if (data[p.place++] !== 0x02) return false;
        var slen = $cec3e07d0e69d400$var$getLength(data, p);
        if (slen === false) return false;
        if (data.length !== slen + p.place) return false;
        if ((data[p.place] & 128) !== 0) return false;
        var s = data.slice(p.place, slen + p.place);
        if (r[0] === 0) {
            if (r[1] & 0x80) r = r.slice(1);
            else return false;
        }
        if (s[0] === 0) {
            if (s[1] & 0x80) s = s.slice(1);
            else return false;
        }
        this.r = new $9pbIC(r);
        this.s = new $9pbIC(s);
        this.recoveryParam = null;
        return true;
    };
    function $cec3e07d0e69d400$var$constructLength(arr, len) {
        if (len < 0x80) {
            arr.push(len);
            return;
        }
        var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
        arr.push(octets | 0x80);
        while(--octets)arr.push(len >>> (octets << 3) & 0xff);
        arr.push(len);
    }
    $cec3e07d0e69d400$var$Signature.prototype.toDER = function toDER(enc) {
        var r = this.r.toArray();
        var s = this.s.toArray();
        if (r[0] & 0x80) r = [
            0
        ].concat(r);
        if (s[0] & 0x80) s = [
            0
        ].concat(s);
        r = $cec3e07d0e69d400$var$rmPadding(r);
        s = $cec3e07d0e69d400$var$rmPadding(s);
        while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
        var arr = [
            0x02
        ];
        $cec3e07d0e69d400$var$constructLength(arr, r.length);
        arr = arr.concat(r);
        arr.push(0x02);
        $cec3e07d0e69d400$var$constructLength(arr, s.length);
        var backHalf = arr.concat(s);
        var res = [
            0x30
        ];
        $cec3e07d0e69d400$var$constructLength(res, backHalf.length);
        res = res.concat(backHalf);
        return $onO0l.encode(res, enc);
    };
});
parcelRegister("5xIaV", function(module, exports) {
    'use strict';
    var $hx0iN = parcelRequire("hx0iN");
    var $gli5y = parcelRequire("gli5y");
    var $onO0l = parcelRequire("onO0l");
    var $40924d19a5087ed3$var$assert = $onO0l.assert;
    var $40924d19a5087ed3$var$parseBytes = $onO0l.parseBytes;
    var $jMnN9 = parcelRequire("jMnN9");
    var $4AHiD = parcelRequire("4AHiD");
    function $40924d19a5087ed3$var$EDDSA(curve) {
        $40924d19a5087ed3$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
        if (!(this instanceof $40924d19a5087ed3$var$EDDSA)) return new $40924d19a5087ed3$var$EDDSA(curve);
        curve = $gli5y[curve].curve;
        this.curve = curve;
        this.g = curve.g;
        this.g.precompute(curve.n.bitLength() + 1);
        this.pointClass = curve.point().constructor;
        this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
        this.hash = $hx0iN.sha512;
    }
    module.exports = $40924d19a5087ed3$var$EDDSA;
    $40924d19a5087ed3$var$EDDSA.prototype.sign = function sign(message, secret) {
        message = $40924d19a5087ed3$var$parseBytes(message);
        var key = this.keyFromSecret(secret);
        var r = this.hashInt(key.messagePrefix(), message);
        var R = this.g.mul(r);
        var Rencoded = this.encodePoint(R);
        var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
        var S = r.add(s_).umod(this.curve.n);
        return this.makeSignature({
            R: R,
            S: S,
            Rencoded: Rencoded
        });
    };
    $40924d19a5087ed3$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
        message = $40924d19a5087ed3$var$parseBytes(message);
        sig = this.makeSignature(sig);
        if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
        var key = this.keyFromPublic(pub);
        var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
        var SG = this.g.mul(sig.S());
        var RplusAh = sig.R().add(key.pub().mul(h));
        return RplusAh.eq(SG);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.hashInt = function hashInt() {
        var hash = this.hash();
        for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
        return $onO0l.intFromLE(hash.digest()).umod(this.curve.n);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
        return $jMnN9.fromPublic(this, pub);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
        return $jMnN9.fromSecret(this, secret);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
        if (sig instanceof $4AHiD) return sig;
        return new $4AHiD(this, sig);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
        var enc = point.getY().toArray('le', this.encodingLength);
        enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
        return enc;
    };
    $40924d19a5087ed3$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
        bytes = $onO0l.parseBytes(bytes);
        var lastIx = bytes.length - 1;
        var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
        var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
        var y = $onO0l.intFromLE(normed);
        return this.curve.pointFromY(y, xIsOdd);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
        return num.toArray('le', this.encodingLength);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
        return $onO0l.intFromLE(bytes);
    };
    $40924d19a5087ed3$var$EDDSA.prototype.isPoint = function isPoint(val) {
        return val instanceof this.pointClass;
    };
});
parcelRegister("jMnN9", function(module, exports) {
    'use strict';
    var $onO0l = parcelRequire("onO0l");
    var $e664f48c9a4229a6$var$assert = $onO0l.assert;
    var $e664f48c9a4229a6$var$parseBytes = $onO0l.parseBytes;
    var $e664f48c9a4229a6$var$cachedProperty = $onO0l.cachedProperty;
    function $e664f48c9a4229a6$var$KeyPair(eddsa, params) {
        this.eddsa = eddsa;
        this._secret = $e664f48c9a4229a6$var$parseBytes(params.secret);
        if (eddsa.isPoint(params.pub)) this._pub = params.pub;
        else this._pubBytes = $e664f48c9a4229a6$var$parseBytes(params.pub);
    }
    $e664f48c9a4229a6$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
        if (pub instanceof $e664f48c9a4229a6$var$KeyPair) return pub;
        return new $e664f48c9a4229a6$var$KeyPair(eddsa, {
            pub: pub
        });
    };
    $e664f48c9a4229a6$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
        if (secret instanceof $e664f48c9a4229a6$var$KeyPair) return secret;
        return new $e664f48c9a4229a6$var$KeyPair(eddsa, {
            secret: secret
        });
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.secret = function secret() {
        return this._secret;
    };
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'pubBytes', function pubBytes() {
        return this.eddsa.encodePoint(this.pub());
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'pub', function pub() {
        if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
        return this.eddsa.g.mul(this.priv());
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'privBytes', function privBytes() {
        var eddsa = this.eddsa;
        var hash = this.hash();
        var lastIx = eddsa.encodingLength - 1;
        var a = hash.slice(0, eddsa.encodingLength);
        a[0] &= 248;
        a[lastIx] &= 127;
        a[lastIx] |= 64;
        return a;
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'priv', function priv() {
        return this.eddsa.decodeInt(this.privBytes());
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'hash', function hash() {
        return this.eddsa.hash().update(this.secret()).digest();
    });
    $e664f48c9a4229a6$var$cachedProperty($e664f48c9a4229a6$var$KeyPair, 'messagePrefix', function messagePrefix() {
        return this.hash().slice(this.eddsa.encodingLength);
    });
    $e664f48c9a4229a6$var$KeyPair.prototype.sign = function sign(message) {
        $e664f48c9a4229a6$var$assert(this._secret, 'KeyPair can only verify');
        return this.eddsa.sign(message, this);
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.verify = function verify(message, sig) {
        return this.eddsa.verify(message, sig, this);
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.getSecret = function getSecret(enc) {
        $e664f48c9a4229a6$var$assert(this._secret, 'KeyPair is public only');
        return $onO0l.encode(this.secret(), enc);
    };
    $e664f48c9a4229a6$var$KeyPair.prototype.getPublic = function getPublic(enc) {
        return $onO0l.encode(this.pubBytes(), enc);
    };
    module.exports = $e664f48c9a4229a6$var$KeyPair;
});
parcelRegister("4AHiD", function(module, exports) {
    'use strict';
    var $9pbIC = parcelRequire("9pbIC");
    var $onO0l = parcelRequire("onO0l");
    var $357c1ca1a96c331d$var$assert = $onO0l.assert;
    var $357c1ca1a96c331d$var$cachedProperty = $onO0l.cachedProperty;
    var $357c1ca1a96c331d$var$parseBytes = $onO0l.parseBytes;
    function $357c1ca1a96c331d$var$Signature(eddsa, sig) {
        this.eddsa = eddsa;
        if (typeof sig !== 'object') sig = $357c1ca1a96c331d$var$parseBytes(sig);
        if (Array.isArray(sig)) {
            $357c1ca1a96c331d$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
            sig = {
                R: sig.slice(0, eddsa.encodingLength),
                S: sig.slice(eddsa.encodingLength)
            };
        }
        $357c1ca1a96c331d$var$assert(sig.R && sig.S, 'Signature without R or S');
        if (eddsa.isPoint(sig.R)) this._R = sig.R;
        if (sig.S instanceof $9pbIC) this._S = sig.S;
        this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
        this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
    }
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'S', function S() {
        return this.eddsa.decodeInt(this.Sencoded());
    });
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'R', function R() {
        return this.eddsa.decodePoint(this.Rencoded());
    });
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'Rencoded', function Rencoded() {
        return this.eddsa.encodePoint(this.R());
    });
    $357c1ca1a96c331d$var$cachedProperty($357c1ca1a96c331d$var$Signature, 'Sencoded', function Sencoded() {
        return this.eddsa.encodeInt(this.S());
    });
    $357c1ca1a96c331d$var$Signature.prototype.toBytes = function toBytes() {
        return this.Rencoded().concat(this.Sencoded());
    };
    $357c1ca1a96c331d$var$Signature.prototype.toHex = function toHex() {
        return $onO0l.encode(this.toBytes(), 'hex').toUpperCase();
    };
    module.exports = $357c1ca1a96c331d$var$Signature;
});
parcelRegister("bxS53", function(module, exports) {
    (function(module1, exports) {
        'use strict';
        function assert(val, msg) {
            if (!val) throw new Error(msg || 'Assertion failed');
        }
        function inherits(ctor, superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
        function BN(number, base, endian) {
            if (BN.isBN(number)) return number;
            this.negative = 0;
            this.words = null;
            this.length = 0;
            this.red = null;
            if (number !== null) {
                if (base === 'le' || base === 'be') {
                    endian = base;
                    base = 10;
                }
                this._init(number || 0, base || 10, endian || 'be');
            }
        }
        if (typeof module1 === 'object') module1.exports = BN;
        else exports.BN = BN;
        BN.BN = BN;
        BN.wordSize = 26;
        var Buffer;
        try {
            if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
            else Buffer = (parcelRequire("3gWwf")).Buffer;
        } catch (e) {}
        BN.isBN = function isBN(num) {
            if (num instanceof BN) return true;
            return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };
        BN.max = function max(left, right) {
            if (left.cmp(right) > 0) return left;
            return right;
        };
        BN.min = function min(left, right) {
            if (left.cmp(right) < 0) return left;
            return right;
        };
        BN.prototype._init = function init(number, base, endian) {
            if (typeof number === 'number') return this._initNumber(number, base, endian);
            if (typeof number === 'object') return this._initArray(number, base, endian);
            if (base === 'hex') base = 16;
            assert(base === (base | 0) && base >= 2 && base <= 36);
            number = number.toString().replace(/\s+/g, '');
            var start = 0;
            if (number[0] === '-') {
                start++;
                this.negative = 1;
            }
            if (start < number.length) {
                if (base === 16) this._parseHex(number, start, endian);
                else {
                    this._parseBase(number, base, start);
                    if (endian === 'le') this._initArray(this.toArray(), base, endian);
                }
            }
        };
        BN.prototype._initNumber = function _initNumber(number, base, endian) {
            if (number < 0) {
                this.negative = 1;
                number = -number;
            }
            if (number < 0x4000000) {
                this.words = [
                    number & 0x3ffffff
                ];
                this.length = 1;
            } else if (number < 0x10000000000000) {
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff
                ];
                this.length = 2;
            } else {
                assert(number < 0x20000000000000);
                this.words = [
                    number & 0x3ffffff,
                    number / 0x4000000 & 0x3ffffff,
                    1
                ];
                this.length = 3;
            }
            if (endian !== 'le') return;
            this._initArray(this.toArray(), base, endian);
        };
        BN.prototype._initArray = function _initArray(number, base, endian) {
            assert(typeof number.length === 'number');
            if (number.length <= 0) {
                this.words = [
                    0
                ];
                this.length = 1;
                return this;
            }
            this.length = Math.ceil(number.length / 3);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var j, w;
            var off = 0;
            if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
                w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
                w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
                this.words[j] |= w << off & 0x3ffffff;
                this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
                off += 24;
                if (off >= 26) {
                    off -= 26;
                    j++;
                }
            }
            return this._strip();
        };
        function parseHex4Bits(string, index) {
            var c = string.charCodeAt(index);
            if (c >= 48 && c <= 57) return c - 48;
            else if (c >= 65 && c <= 70) return c - 55;
            else if (c >= 97 && c <= 102) return c - 87;
            else assert(false, 'Invalid character in ' + string);
        }
        function parseHexByte(string, lowerBound, index) {
            var r = parseHex4Bits(string, index);
            if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
            return r;
        }
        BN.prototype._parseHex = function _parseHex(number, start, endian) {
            this.length = Math.ceil((number.length - start) / 6);
            this.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)this.words[i] = 0;
            var off = 0;
            var j = 0;
            var w;
            if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
            else {
                var parseLength = number.length - start;
                for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                    w = parseHexByte(number, start, i) << off;
                    this.words[j] |= w & 0x3ffffff;
                    if (off >= 18) {
                        off -= 18;
                        j += 1;
                        this.words[j] |= w >>> 26;
                    } else off += 8;
                }
            }
            this._strip();
        };
        function parseBase(str, start, end, mul) {
            var r = 0;
            var b = 0;
            var len = Math.min(str.length, end);
            for(var i = start; i < len; i++){
                var c = str.charCodeAt(i) - 48;
                r *= mul;
                if (c >= 49) b = c - 49 + 0xa;
                else if (c >= 17) b = c - 17 + 0xa;
                else b = c;
                assert(c >= 0 && b < mul, 'Invalid character');
                r += b;
            }
            return r;
        }
        BN.prototype._parseBase = function _parseBase(number, base, start) {
            this.words = [
                0
            ];
            this.length = 1;
            for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
            limbLen--;
            limbPow = limbPow / base | 0;
            var total = number.length - start;
            var mod = total % limbLen;
            var end = Math.min(total, total - mod) + start;
            var word = 0;
            for(var i = start; i < end; i += limbLen){
                word = parseBase(number, i, i + limbLen, base);
                this.imuln(limbPow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            if (mod !== 0) {
                var pow = 1;
                word = parseBase(number, i, number.length, base);
                for(i = 0; i < mod; i++)pow *= base;
                this.imuln(pow);
                if (this.words[0] + word < 0x4000000) this.words[0] += word;
                else this._iaddn(word);
            }
            this._strip();
        };
        BN.prototype.copy = function copy(dest) {
            dest.words = new Array(this.length);
            for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
            dest.length = this.length;
            dest.negative = this.negative;
            dest.red = this.red;
        };
        function move(dest, src) {
            dest.words = src.words;
            dest.length = src.length;
            dest.negative = src.negative;
            dest.red = src.red;
        }
        BN.prototype._move = function _move(dest) {
            move(dest, this);
        };
        BN.prototype.clone = function clone() {
            var r = new BN(null);
            this.copy(r);
            return r;
        };
        BN.prototype._expand = function _expand(size) {
            while(this.length < size)this.words[this.length++] = 0;
            return this;
        };
        BN.prototype._strip = function strip() {
            while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
            return this._normSign();
        };
        BN.prototype._normSign = function _normSign() {
            if (this.length === 1 && this.words[0] === 0) this.negative = 0;
            return this;
        };
        if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
            BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
        } catch (e) {
            BN.prototype.inspect = inspect;
        }
        else BN.prototype.inspect = inspect;
        function inspect() {
            return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        }
        var zeros = [
            '',
            '0',
            '00',
            '000',
            '0000',
            '00000',
            '000000',
            '0000000',
            '00000000',
            '000000000',
            '0000000000',
            '00000000000',
            '000000000000',
            '0000000000000',
            '00000000000000',
            '000000000000000',
            '0000000000000000',
            '00000000000000000',
            '000000000000000000',
            '0000000000000000000',
            '00000000000000000000',
            '000000000000000000000',
            '0000000000000000000000',
            '00000000000000000000000',
            '000000000000000000000000',
            '0000000000000000000000000'
        ];
        var groupSizes = [
            0,
            0,
            25,
            16,
            12,
            11,
            10,
            9,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5
        ];
        var groupBases = [
            0,
            0,
            33554432,
            43046721,
            16777216,
            48828125,
            60466176,
            40353607,
            16777216,
            43046721,
            10000000,
            19487171,
            35831808,
            62748517,
            7529536,
            11390625,
            16777216,
            24137569,
            34012224,
            47045881,
            64000000,
            4084101,
            5153632,
            6436343,
            7962624,
            9765625,
            11881376,
            14348907,
            17210368,
            20511149,
            24300000,
            28629151,
            33554432,
            39135393,
            45435424,
            52521875,
            60466176
        ];
        BN.prototype.toString = function toString(base, padding) {
            base = base || 10;
            padding = padding | 0 || 1;
            var out;
            if (base === 16 || base === 'hex') {
                out = '';
                var off = 0;
                var carry = 0;
                for(var i = 0; i < this.length; i++){
                    var w = this.words[i];
                    var word = ((w << off | carry) & 0xffffff).toString(16);
                    carry = w >>> 24 - off & 0xffffff;
                    off += 2;
                    if (off >= 26) {
                        off -= 26;
                        i--;
                    }
                    if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                    else out = word + out;
                }
                if (carry !== 0) out = carry.toString(16) + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            if (base === (base | 0) && base >= 2 && base <= 36) {
                var groupSize = groupSizes[base];
                var groupBase = groupBases[base];
                out = '';
                var c = this.clone();
                c.negative = 0;
                while(!c.isZero()){
                    var r = c.modrn(groupBase).toString(base);
                    c = c.idivn(groupBase);
                    if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                    else out = r + out;
                }
                if (this.isZero()) out = '0' + out;
                while(out.length % padding !== 0)out = '0' + out;
                if (this.negative !== 0) out = '-' + out;
                return out;
            }
            assert(false, 'Base should be between 2 and 36');
        };
        BN.prototype.toNumber = function toNumber() {
            var ret = this.words[0];
            if (this.length === 2) ret += this.words[1] * 0x4000000;
            else if (this.length === 3 && this.words[2] === 0x01) ret += 0x10000000000000 + this.words[1] * 0x4000000;
            else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
            return this.negative !== 0 ? -ret : ret;
        };
        BN.prototype.toJSON = function toJSON() {
            return this.toString(16, 2);
        };
        if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
            return this.toArrayLike(Buffer, endian, length);
        };
        BN.prototype.toArray = function toArray(endian, length) {
            return this.toArrayLike(Array, endian, length);
        };
        var allocate = function allocate(ArrayType, size) {
            if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
            return new ArrayType(size);
        };
        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
            this._strip();
            var byteLength = this.byteLength();
            var reqLength = length || Math.max(1, byteLength);
            assert(byteLength <= reqLength, 'byte array longer than desired length');
            assert(reqLength > 0, 'Requested array length <= 0');
            var res = allocate(ArrayType, reqLength);
            var postfix = endian === 'le' ? 'LE' : 'BE';
            this['_toArrayLike' + postfix](res, byteLength);
            return res;
        };
        BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
            var position = 0;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position++] = word & 0xff;
                if (position < res.length) res[position++] = word >> 8 & 0xff;
                if (position < res.length) res[position++] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position < res.length) res[position++] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position < res.length) {
                res[position++] = carry;
                while(position < res.length)res[position++] = 0;
            }
        };
        BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
            var position = res.length - 1;
            var carry = 0;
            for(var i = 0, shift = 0; i < this.length; i++){
                var word = this.words[i] << shift | carry;
                res[position--] = word & 0xff;
                if (position >= 0) res[position--] = word >> 8 & 0xff;
                if (position >= 0) res[position--] = word >> 16 & 0xff;
                if (shift === 6) {
                    if (position >= 0) res[position--] = word >> 24 & 0xff;
                    carry = 0;
                    shift = 0;
                } else {
                    carry = word >>> 24;
                    shift += 2;
                }
            }
            if (position >= 0) {
                res[position--] = carry;
                while(position >= 0)res[position--] = 0;
            }
        };
        if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
        };
        else BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
                r += 13;
                t >>>= 13;
            }
            if (t >= 0x40) {
                r += 7;
                t >>>= 7;
            }
            if (t >= 0x8) {
                r += 4;
                t >>>= 4;
            }
            if (t >= 0x02) {
                r += 2;
                t >>>= 2;
            }
            return r + t;
        };
        BN.prototype._zeroBits = function _zeroBits(w) {
            if (w === 0) return 26;
            var t = w;
            var r = 0;
            if ((t & 0x1fff) === 0) {
                r += 13;
                t >>>= 13;
            }
            if ((t & 0x7f) === 0) {
                r += 7;
                t >>>= 7;
            }
            if ((t & 0xf) === 0) {
                r += 4;
                t >>>= 4;
            }
            if ((t & 0x3) === 0) {
                r += 2;
                t >>>= 2;
            }
            if ((t & 0x1) === 0) r++;
            return r;
        };
        BN.prototype.bitLength = function bitLength() {
            var w = this.words[this.length - 1];
            var hi = this._countBits(w);
            return (this.length - 1) * 26 + hi;
        };
        function toBitArray(num) {
            var w = new Array(num.bitLength());
            for(var bit = 0; bit < w.length; bit++){
                var off = bit / 26 | 0;
                var wbit = bit % 26;
                w[bit] = num.words[off] >>> wbit & 0x01;
            }
            return w;
        }
        BN.prototype.zeroBits = function zeroBits() {
            if (this.isZero()) return 0;
            var r = 0;
            for(var i = 0; i < this.length; i++){
                var b = this._zeroBits(this.words[i]);
                r += b;
                if (b !== 26) break;
            }
            return r;
        };
        BN.prototype.byteLength = function byteLength() {
            return Math.ceil(this.bitLength() / 8);
        };
        BN.prototype.toTwos = function toTwos(width) {
            if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
            return this.clone();
        };
        BN.prototype.fromTwos = function fromTwos(width) {
            if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
            return this.clone();
        };
        BN.prototype.isNeg = function isNeg() {
            return this.negative !== 0;
        };
        BN.prototype.neg = function neg() {
            return this.clone().ineg();
        };
        BN.prototype.ineg = function ineg() {
            if (!this.isZero()) this.negative ^= 1;
            return this;
        };
        BN.prototype.iuor = function iuor(num) {
            while(this.length < num.length)this.words[this.length++] = 0;
            for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
            return this._strip();
        };
        BN.prototype.ior = function ior(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuor(num);
        };
        BN.prototype.or = function or(num) {
            if (this.length > num.length) return this.clone().ior(num);
            return num.clone().ior(this);
        };
        BN.prototype.uor = function uor(num) {
            if (this.length > num.length) return this.clone().iuor(num);
            return num.clone().iuor(this);
        };
        BN.prototype.iuand = function iuand(num) {
            var b;
            if (this.length > num.length) b = num;
            else b = this;
            for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
            this.length = b.length;
            return this._strip();
        };
        BN.prototype.iand = function iand(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuand(num);
        };
        BN.prototype.and = function and(num) {
            if (this.length > num.length) return this.clone().iand(num);
            return num.clone().iand(this);
        };
        BN.prototype.uand = function uand(num) {
            if (this.length > num.length) return this.clone().iuand(num);
            return num.clone().iuand(this);
        };
        BN.prototype.iuxor = function iuxor(num) {
            var a;
            var b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
            if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = a.length;
            return this._strip();
        };
        BN.prototype.ixor = function ixor(num) {
            assert((this.negative | num.negative) === 0);
            return this.iuxor(num);
        };
        BN.prototype.xor = function xor(num) {
            if (this.length > num.length) return this.clone().ixor(num);
            return num.clone().ixor(this);
        };
        BN.prototype.uxor = function uxor(num) {
            if (this.length > num.length) return this.clone().iuxor(num);
            return num.clone().iuxor(this);
        };
        BN.prototype.inotn = function inotn(width) {
            assert(typeof width === 'number' && width >= 0);
            var bytesNeeded = Math.ceil(width / 26) | 0;
            var bitsLeft = width % 26;
            this._expand(bytesNeeded);
            if (bitsLeft > 0) bytesNeeded--;
            for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
            if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
            return this._strip();
        };
        BN.prototype.notn = function notn(width) {
            return this.clone().inotn(width);
        };
        BN.prototype.setn = function setn(bit, val) {
            assert(typeof bit === 'number' && bit >= 0);
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            this._expand(off + 1);
            if (val) this.words[off] = this.words[off] | 1 << wbit;
            else this.words[off] = this.words[off] & ~(1 << wbit);
            return this._strip();
        };
        BN.prototype.iadd = function iadd(num) {
            var r;
            if (this.negative !== 0 && num.negative === 0) {
                this.negative = 0;
                r = this.isub(num);
                this.negative ^= 1;
                return this._normSign();
            } else if (this.negative === 0 && num.negative !== 0) {
                num.negative = 0;
                r = this.isub(num);
                num.negative = 1;
                return r._normSign();
            }
            var a, b;
            if (this.length > num.length) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                this.words[i] = r & 0x3ffffff;
                carry = r >>> 26;
            }
            this.length = a.length;
            if (carry !== 0) {
                this.words[this.length] = carry;
                this.length++;
            } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            return this;
        };
        BN.prototype.add = function add(num) {
            var res;
            if (num.negative !== 0 && this.negative === 0) {
                num.negative = 0;
                res = this.sub(num);
                num.negative ^= 1;
                return res;
            } else if (num.negative === 0 && this.negative !== 0) {
                this.negative = 0;
                res = num.sub(this);
                this.negative = 1;
                return res;
            }
            if (this.length > num.length) return this.clone().iadd(num);
            return num.clone().iadd(this);
        };
        BN.prototype.isub = function isub(num) {
            if (num.negative !== 0) {
                num.negative = 0;
                var r = this.iadd(num);
                num.negative = 1;
                return r._normSign();
            } else if (this.negative !== 0) {
                this.negative = 0;
                this.iadd(num);
                this.negative = 1;
                return this._normSign();
            }
            var cmp = this.cmp(num);
            if (cmp === 0) {
                this.negative = 0;
                this.length = 1;
                this.words[0] = 0;
                return this;
            }
            var a, b;
            if (cmp > 0) {
                a = this;
                b = num;
            } else {
                a = num;
                b = this;
            }
            var carry = 0;
            for(var i = 0; i < b.length; i++){
                r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            for(; carry !== 0 && i < a.length; i++){
                r = (a.words[i] | 0) + carry;
                carry = r >> 26;
                this.words[i] = r & 0x3ffffff;
            }
            if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
            this.length = Math.max(this.length, i);
            if (a !== this) this.negative = 1;
            return this._strip();
        };
        BN.prototype.sub = function sub(num) {
            return this.clone().isub(num);
        };
        function smallMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            var len = self.length + num.length | 0;
            out.length = len;
            len = len - 1 | 0;
            var a = self.words[0] | 0;
            var b = num.words[0] | 0;
            var r = a * b;
            var lo = r & 0x3ffffff;
            var carry = r / 0x4000000 | 0;
            out.words[0] = lo;
            for(var k = 1; k < len; k++){
                var ncarry = carry >>> 26;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j | 0;
                    a = self.words[i] | 0;
                    b = num.words[j] | 0;
                    r = a * b + rword;
                    ncarry += r / 0x4000000 | 0;
                    rword = r & 0x3ffffff;
                }
                out.words[k] = rword | 0;
                carry = ncarry | 0;
            }
            if (carry !== 0) out.words[k] = carry | 0;
            else out.length--;
            return out._strip();
        }
        var comb10MulTo = function comb10MulTo(self, num, out) {
            var a = self.words;
            var b = num.words;
            var o = out.words;
            var c = 0;
            var lo;
            var mid;
            var hi;
            var a0 = a[0] | 0;
            var al0 = a0 & 0x1fff;
            var ah0 = a0 >>> 13;
            var a1 = a[1] | 0;
            var al1 = a1 & 0x1fff;
            var ah1 = a1 >>> 13;
            var a2 = a[2] | 0;
            var al2 = a2 & 0x1fff;
            var ah2 = a2 >>> 13;
            var a3 = a[3] | 0;
            var al3 = a3 & 0x1fff;
            var ah3 = a3 >>> 13;
            var a4 = a[4] | 0;
            var al4 = a4 & 0x1fff;
            var ah4 = a4 >>> 13;
            var a5 = a[5] | 0;
            var al5 = a5 & 0x1fff;
            var ah5 = a5 >>> 13;
            var a6 = a[6] | 0;
            var al6 = a6 & 0x1fff;
            var ah6 = a6 >>> 13;
            var a7 = a[7] | 0;
            var al7 = a7 & 0x1fff;
            var ah7 = a7 >>> 13;
            var a8 = a[8] | 0;
            var al8 = a8 & 0x1fff;
            var ah8 = a8 >>> 13;
            var a9 = a[9] | 0;
            var al9 = a9 & 0x1fff;
            var ah9 = a9 >>> 13;
            var b0 = b[0] | 0;
            var bl0 = b0 & 0x1fff;
            var bh0 = b0 >>> 13;
            var b1 = b[1] | 0;
            var bl1 = b1 & 0x1fff;
            var bh1 = b1 >>> 13;
            var b2 = b[2] | 0;
            var bl2 = b2 & 0x1fff;
            var bh2 = b2 >>> 13;
            var b3 = b[3] | 0;
            var bl3 = b3 & 0x1fff;
            var bh3 = b3 >>> 13;
            var b4 = b[4] | 0;
            var bl4 = b4 & 0x1fff;
            var bh4 = b4 >>> 13;
            var b5 = b[5] | 0;
            var bl5 = b5 & 0x1fff;
            var bh5 = b5 >>> 13;
            var b6 = b[6] | 0;
            var bl6 = b6 & 0x1fff;
            var bh6 = b6 >>> 13;
            var b7 = b[7] | 0;
            var bl7 = b7 & 0x1fff;
            var bh7 = b7 >>> 13;
            var b8 = b[8] | 0;
            var bl8 = b8 & 0x1fff;
            var bh8 = b8 >>> 13;
            var b9 = b[9] | 0;
            var bl9 = b9 & 0x1fff;
            var bh9 = b9 >>> 13;
            out.negative = self.negative ^ num.negative;
            out.length = 19;
            lo = Math.imul(al0, bl0);
            mid = Math.imul(al0, bh0);
            mid = mid + Math.imul(ah0, bl0) | 0;
            hi = Math.imul(ah0, bh0);
            var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
            w0 &= 0x3ffffff;
            lo = Math.imul(al1, bl0);
            mid = Math.imul(al1, bh0);
            mid = mid + Math.imul(ah1, bl0) | 0;
            hi = Math.imul(ah1, bh0);
            lo = lo + Math.imul(al0, bl1) | 0;
            mid = mid + Math.imul(al0, bh1) | 0;
            mid = mid + Math.imul(ah0, bl1) | 0;
            hi = hi + Math.imul(ah0, bh1) | 0;
            var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
            w1 &= 0x3ffffff;
            lo = Math.imul(al2, bl0);
            mid = Math.imul(al2, bh0);
            mid = mid + Math.imul(ah2, bl0) | 0;
            hi = Math.imul(ah2, bh0);
            lo = lo + Math.imul(al1, bl1) | 0;
            mid = mid + Math.imul(al1, bh1) | 0;
            mid = mid + Math.imul(ah1, bl1) | 0;
            hi = hi + Math.imul(ah1, bh1) | 0;
            lo = lo + Math.imul(al0, bl2) | 0;
            mid = mid + Math.imul(al0, bh2) | 0;
            mid = mid + Math.imul(ah0, bl2) | 0;
            hi = hi + Math.imul(ah0, bh2) | 0;
            var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
            w2 &= 0x3ffffff;
            lo = Math.imul(al3, bl0);
            mid = Math.imul(al3, bh0);
            mid = mid + Math.imul(ah3, bl0) | 0;
            hi = Math.imul(ah3, bh0);
            lo = lo + Math.imul(al2, bl1) | 0;
            mid = mid + Math.imul(al2, bh1) | 0;
            mid = mid + Math.imul(ah2, bl1) | 0;
            hi = hi + Math.imul(ah2, bh1) | 0;
            lo = lo + Math.imul(al1, bl2) | 0;
            mid = mid + Math.imul(al1, bh2) | 0;
            mid = mid + Math.imul(ah1, bl2) | 0;
            hi = hi + Math.imul(ah1, bh2) | 0;
            lo = lo + Math.imul(al0, bl3) | 0;
            mid = mid + Math.imul(al0, bh3) | 0;
            mid = mid + Math.imul(ah0, bl3) | 0;
            hi = hi + Math.imul(ah0, bh3) | 0;
            var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
            w3 &= 0x3ffffff;
            lo = Math.imul(al4, bl0);
            mid = Math.imul(al4, bh0);
            mid = mid + Math.imul(ah4, bl0) | 0;
            hi = Math.imul(ah4, bh0);
            lo = lo + Math.imul(al3, bl1) | 0;
            mid = mid + Math.imul(al3, bh1) | 0;
            mid = mid + Math.imul(ah3, bl1) | 0;
            hi = hi + Math.imul(ah3, bh1) | 0;
            lo = lo + Math.imul(al2, bl2) | 0;
            mid = mid + Math.imul(al2, bh2) | 0;
            mid = mid + Math.imul(ah2, bl2) | 0;
            hi = hi + Math.imul(ah2, bh2) | 0;
            lo = lo + Math.imul(al1, bl3) | 0;
            mid = mid + Math.imul(al1, bh3) | 0;
            mid = mid + Math.imul(ah1, bl3) | 0;
            hi = hi + Math.imul(ah1, bh3) | 0;
            lo = lo + Math.imul(al0, bl4) | 0;
            mid = mid + Math.imul(al0, bh4) | 0;
            mid = mid + Math.imul(ah0, bl4) | 0;
            hi = hi + Math.imul(ah0, bh4) | 0;
            var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
            w4 &= 0x3ffffff;
            lo = Math.imul(al5, bl0);
            mid = Math.imul(al5, bh0);
            mid = mid + Math.imul(ah5, bl0) | 0;
            hi = Math.imul(ah5, bh0);
            lo = lo + Math.imul(al4, bl1) | 0;
            mid = mid + Math.imul(al4, bh1) | 0;
            mid = mid + Math.imul(ah4, bl1) | 0;
            hi = hi + Math.imul(ah4, bh1) | 0;
            lo = lo + Math.imul(al3, bl2) | 0;
            mid = mid + Math.imul(al3, bh2) | 0;
            mid = mid + Math.imul(ah3, bl2) | 0;
            hi = hi + Math.imul(ah3, bh2) | 0;
            lo = lo + Math.imul(al2, bl3) | 0;
            mid = mid + Math.imul(al2, bh3) | 0;
            mid = mid + Math.imul(ah2, bl3) | 0;
            hi = hi + Math.imul(ah2, bh3) | 0;
            lo = lo + Math.imul(al1, bl4) | 0;
            mid = mid + Math.imul(al1, bh4) | 0;
            mid = mid + Math.imul(ah1, bl4) | 0;
            hi = hi + Math.imul(ah1, bh4) | 0;
            lo = lo + Math.imul(al0, bl5) | 0;
            mid = mid + Math.imul(al0, bh5) | 0;
            mid = mid + Math.imul(ah0, bl5) | 0;
            hi = hi + Math.imul(ah0, bh5) | 0;
            var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
            w5 &= 0x3ffffff;
            lo = Math.imul(al6, bl0);
            mid = Math.imul(al6, bh0);
            mid = mid + Math.imul(ah6, bl0) | 0;
            hi = Math.imul(ah6, bh0);
            lo = lo + Math.imul(al5, bl1) | 0;
            mid = mid + Math.imul(al5, bh1) | 0;
            mid = mid + Math.imul(ah5, bl1) | 0;
            hi = hi + Math.imul(ah5, bh1) | 0;
            lo = lo + Math.imul(al4, bl2) | 0;
            mid = mid + Math.imul(al4, bh2) | 0;
            mid = mid + Math.imul(ah4, bl2) | 0;
            hi = hi + Math.imul(ah4, bh2) | 0;
            lo = lo + Math.imul(al3, bl3) | 0;
            mid = mid + Math.imul(al3, bh3) | 0;
            mid = mid + Math.imul(ah3, bl3) | 0;
            hi = hi + Math.imul(ah3, bh3) | 0;
            lo = lo + Math.imul(al2, bl4) | 0;
            mid = mid + Math.imul(al2, bh4) | 0;
            mid = mid + Math.imul(ah2, bl4) | 0;
            hi = hi + Math.imul(ah2, bh4) | 0;
            lo = lo + Math.imul(al1, bl5) | 0;
            mid = mid + Math.imul(al1, bh5) | 0;
            mid = mid + Math.imul(ah1, bl5) | 0;
            hi = hi + Math.imul(ah1, bh5) | 0;
            lo = lo + Math.imul(al0, bl6) | 0;
            mid = mid + Math.imul(al0, bh6) | 0;
            mid = mid + Math.imul(ah0, bl6) | 0;
            hi = hi + Math.imul(ah0, bh6) | 0;
            var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
            w6 &= 0x3ffffff;
            lo = Math.imul(al7, bl0);
            mid = Math.imul(al7, bh0);
            mid = mid + Math.imul(ah7, bl0) | 0;
            hi = Math.imul(ah7, bh0);
            lo = lo + Math.imul(al6, bl1) | 0;
            mid = mid + Math.imul(al6, bh1) | 0;
            mid = mid + Math.imul(ah6, bl1) | 0;
            hi = hi + Math.imul(ah6, bh1) | 0;
            lo = lo + Math.imul(al5, bl2) | 0;
            mid = mid + Math.imul(al5, bh2) | 0;
            mid = mid + Math.imul(ah5, bl2) | 0;
            hi = hi + Math.imul(ah5, bh2) | 0;
            lo = lo + Math.imul(al4, bl3) | 0;
            mid = mid + Math.imul(al4, bh3) | 0;
            mid = mid + Math.imul(ah4, bl3) | 0;
            hi = hi + Math.imul(ah4, bh3) | 0;
            lo = lo + Math.imul(al3, bl4) | 0;
            mid = mid + Math.imul(al3, bh4) | 0;
            mid = mid + Math.imul(ah3, bl4) | 0;
            hi = hi + Math.imul(ah3, bh4) | 0;
            lo = lo + Math.imul(al2, bl5) | 0;
            mid = mid + Math.imul(al2, bh5) | 0;
            mid = mid + Math.imul(ah2, bl5) | 0;
            hi = hi + Math.imul(ah2, bh5) | 0;
            lo = lo + Math.imul(al1, bl6) | 0;
            mid = mid + Math.imul(al1, bh6) | 0;
            mid = mid + Math.imul(ah1, bl6) | 0;
            hi = hi + Math.imul(ah1, bh6) | 0;
            lo = lo + Math.imul(al0, bl7) | 0;
            mid = mid + Math.imul(al0, bh7) | 0;
            mid = mid + Math.imul(ah0, bl7) | 0;
            hi = hi + Math.imul(ah0, bh7) | 0;
            var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
            w7 &= 0x3ffffff;
            lo = Math.imul(al8, bl0);
            mid = Math.imul(al8, bh0);
            mid = mid + Math.imul(ah8, bl0) | 0;
            hi = Math.imul(ah8, bh0);
            lo = lo + Math.imul(al7, bl1) | 0;
            mid = mid + Math.imul(al7, bh1) | 0;
            mid = mid + Math.imul(ah7, bl1) | 0;
            hi = hi + Math.imul(ah7, bh1) | 0;
            lo = lo + Math.imul(al6, bl2) | 0;
            mid = mid + Math.imul(al6, bh2) | 0;
            mid = mid + Math.imul(ah6, bl2) | 0;
            hi = hi + Math.imul(ah6, bh2) | 0;
            lo = lo + Math.imul(al5, bl3) | 0;
            mid = mid + Math.imul(al5, bh3) | 0;
            mid = mid + Math.imul(ah5, bl3) | 0;
            hi = hi + Math.imul(ah5, bh3) | 0;
            lo = lo + Math.imul(al4, bl4) | 0;
            mid = mid + Math.imul(al4, bh4) | 0;
            mid = mid + Math.imul(ah4, bl4) | 0;
            hi = hi + Math.imul(ah4, bh4) | 0;
            lo = lo + Math.imul(al3, bl5) | 0;
            mid = mid + Math.imul(al3, bh5) | 0;
            mid = mid + Math.imul(ah3, bl5) | 0;
            hi = hi + Math.imul(ah3, bh5) | 0;
            lo = lo + Math.imul(al2, bl6) | 0;
            mid = mid + Math.imul(al2, bh6) | 0;
            mid = mid + Math.imul(ah2, bl6) | 0;
            hi = hi + Math.imul(ah2, bh6) | 0;
            lo = lo + Math.imul(al1, bl7) | 0;
            mid = mid + Math.imul(al1, bh7) | 0;
            mid = mid + Math.imul(ah1, bl7) | 0;
            hi = hi + Math.imul(ah1, bh7) | 0;
            lo = lo + Math.imul(al0, bl8) | 0;
            mid = mid + Math.imul(al0, bh8) | 0;
            mid = mid + Math.imul(ah0, bl8) | 0;
            hi = hi + Math.imul(ah0, bh8) | 0;
            var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
            w8 &= 0x3ffffff;
            lo = Math.imul(al9, bl0);
            mid = Math.imul(al9, bh0);
            mid = mid + Math.imul(ah9, bl0) | 0;
            hi = Math.imul(ah9, bh0);
            lo = lo + Math.imul(al8, bl1) | 0;
            mid = mid + Math.imul(al8, bh1) | 0;
            mid = mid + Math.imul(ah8, bl1) | 0;
            hi = hi + Math.imul(ah8, bh1) | 0;
            lo = lo + Math.imul(al7, bl2) | 0;
            mid = mid + Math.imul(al7, bh2) | 0;
            mid = mid + Math.imul(ah7, bl2) | 0;
            hi = hi + Math.imul(ah7, bh2) | 0;
            lo = lo + Math.imul(al6, bl3) | 0;
            mid = mid + Math.imul(al6, bh3) | 0;
            mid = mid + Math.imul(ah6, bl3) | 0;
            hi = hi + Math.imul(ah6, bh3) | 0;
            lo = lo + Math.imul(al5, bl4) | 0;
            mid = mid + Math.imul(al5, bh4) | 0;
            mid = mid + Math.imul(ah5, bl4) | 0;
            hi = hi + Math.imul(ah5, bh4) | 0;
            lo = lo + Math.imul(al4, bl5) | 0;
            mid = mid + Math.imul(al4, bh5) | 0;
            mid = mid + Math.imul(ah4, bl5) | 0;
            hi = hi + Math.imul(ah4, bh5) | 0;
            lo = lo + Math.imul(al3, bl6) | 0;
            mid = mid + Math.imul(al3, bh6) | 0;
            mid = mid + Math.imul(ah3, bl6) | 0;
            hi = hi + Math.imul(ah3, bh6) | 0;
            lo = lo + Math.imul(al2, bl7) | 0;
            mid = mid + Math.imul(al2, bh7) | 0;
            mid = mid + Math.imul(ah2, bl7) | 0;
            hi = hi + Math.imul(ah2, bh7) | 0;
            lo = lo + Math.imul(al1, bl8) | 0;
            mid = mid + Math.imul(al1, bh8) | 0;
            mid = mid + Math.imul(ah1, bl8) | 0;
            hi = hi + Math.imul(ah1, bh8) | 0;
            lo = lo + Math.imul(al0, bl9) | 0;
            mid = mid + Math.imul(al0, bh9) | 0;
            mid = mid + Math.imul(ah0, bl9) | 0;
            hi = hi + Math.imul(ah0, bh9) | 0;
            var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
            w9 &= 0x3ffffff;
            lo = Math.imul(al9, bl1);
            mid = Math.imul(al9, bh1);
            mid = mid + Math.imul(ah9, bl1) | 0;
            hi = Math.imul(ah9, bh1);
            lo = lo + Math.imul(al8, bl2) | 0;
            mid = mid + Math.imul(al8, bh2) | 0;
            mid = mid + Math.imul(ah8, bl2) | 0;
            hi = hi + Math.imul(ah8, bh2) | 0;
            lo = lo + Math.imul(al7, bl3) | 0;
            mid = mid + Math.imul(al7, bh3) | 0;
            mid = mid + Math.imul(ah7, bl3) | 0;
            hi = hi + Math.imul(ah7, bh3) | 0;
            lo = lo + Math.imul(al6, bl4) | 0;
            mid = mid + Math.imul(al6, bh4) | 0;
            mid = mid + Math.imul(ah6, bl4) | 0;
            hi = hi + Math.imul(ah6, bh4) | 0;
            lo = lo + Math.imul(al5, bl5) | 0;
            mid = mid + Math.imul(al5, bh5) | 0;
            mid = mid + Math.imul(ah5, bl5) | 0;
            hi = hi + Math.imul(ah5, bh5) | 0;
            lo = lo + Math.imul(al4, bl6) | 0;
            mid = mid + Math.imul(al4, bh6) | 0;
            mid = mid + Math.imul(ah4, bl6) | 0;
            hi = hi + Math.imul(ah4, bh6) | 0;
            lo = lo + Math.imul(al3, bl7) | 0;
            mid = mid + Math.imul(al3, bh7) | 0;
            mid = mid + Math.imul(ah3, bl7) | 0;
            hi = hi + Math.imul(ah3, bh7) | 0;
            lo = lo + Math.imul(al2, bl8) | 0;
            mid = mid + Math.imul(al2, bh8) | 0;
            mid = mid + Math.imul(ah2, bl8) | 0;
            hi = hi + Math.imul(ah2, bh8) | 0;
            lo = lo + Math.imul(al1, bl9) | 0;
            mid = mid + Math.imul(al1, bh9) | 0;
            mid = mid + Math.imul(ah1, bl9) | 0;
            hi = hi + Math.imul(ah1, bh9) | 0;
            var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
            w10 &= 0x3ffffff;
            lo = Math.imul(al9, bl2);
            mid = Math.imul(al9, bh2);
            mid = mid + Math.imul(ah9, bl2) | 0;
            hi = Math.imul(ah9, bh2);
            lo = lo + Math.imul(al8, bl3) | 0;
            mid = mid + Math.imul(al8, bh3) | 0;
            mid = mid + Math.imul(ah8, bl3) | 0;
            hi = hi + Math.imul(ah8, bh3) | 0;
            lo = lo + Math.imul(al7, bl4) | 0;
            mid = mid + Math.imul(al7, bh4) | 0;
            mid = mid + Math.imul(ah7, bl4) | 0;
            hi = hi + Math.imul(ah7, bh4) | 0;
            lo = lo + Math.imul(al6, bl5) | 0;
            mid = mid + Math.imul(al6, bh5) | 0;
            mid = mid + Math.imul(ah6, bl5) | 0;
            hi = hi + Math.imul(ah6, bh5) | 0;
            lo = lo + Math.imul(al5, bl6) | 0;
            mid = mid + Math.imul(al5, bh6) | 0;
            mid = mid + Math.imul(ah5, bl6) | 0;
            hi = hi + Math.imul(ah5, bh6) | 0;
            lo = lo + Math.imul(al4, bl7) | 0;
            mid = mid + Math.imul(al4, bh7) | 0;
            mid = mid + Math.imul(ah4, bl7) | 0;
            hi = hi + Math.imul(ah4, bh7) | 0;
            lo = lo + Math.imul(al3, bl8) | 0;
            mid = mid + Math.imul(al3, bh8) | 0;
            mid = mid + Math.imul(ah3, bl8) | 0;
            hi = hi + Math.imul(ah3, bh8) | 0;
            lo = lo + Math.imul(al2, bl9) | 0;
            mid = mid + Math.imul(al2, bh9) | 0;
            mid = mid + Math.imul(ah2, bl9) | 0;
            hi = hi + Math.imul(ah2, bh9) | 0;
            var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
            w11 &= 0x3ffffff;
            lo = Math.imul(al9, bl3);
            mid = Math.imul(al9, bh3);
            mid = mid + Math.imul(ah9, bl3) | 0;
            hi = Math.imul(ah9, bh3);
            lo = lo + Math.imul(al8, bl4) | 0;
            mid = mid + Math.imul(al8, bh4) | 0;
            mid = mid + Math.imul(ah8, bl4) | 0;
            hi = hi + Math.imul(ah8, bh4) | 0;
            lo = lo + Math.imul(al7, bl5) | 0;
            mid = mid + Math.imul(al7, bh5) | 0;
            mid = mid + Math.imul(ah7, bl5) | 0;
            hi = hi + Math.imul(ah7, bh5) | 0;
            lo = lo + Math.imul(al6, bl6) | 0;
            mid = mid + Math.imul(al6, bh6) | 0;
            mid = mid + Math.imul(ah6, bl6) | 0;
            hi = hi + Math.imul(ah6, bh6) | 0;
            lo = lo + Math.imul(al5, bl7) | 0;
            mid = mid + Math.imul(al5, bh7) | 0;
            mid = mid + Math.imul(ah5, bl7) | 0;
            hi = hi + Math.imul(ah5, bh7) | 0;
            lo = lo + Math.imul(al4, bl8) | 0;
            mid = mid + Math.imul(al4, bh8) | 0;
            mid = mid + Math.imul(ah4, bl8) | 0;
            hi = hi + Math.imul(ah4, bh8) | 0;
            lo = lo + Math.imul(al3, bl9) | 0;
            mid = mid + Math.imul(al3, bh9) | 0;
            mid = mid + Math.imul(ah3, bl9) | 0;
            hi = hi + Math.imul(ah3, bh9) | 0;
            var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
            w12 &= 0x3ffffff;
            lo = Math.imul(al9, bl4);
            mid = Math.imul(al9, bh4);
            mid = mid + Math.imul(ah9, bl4) | 0;
            hi = Math.imul(ah9, bh4);
            lo = lo + Math.imul(al8, bl5) | 0;
            mid = mid + Math.imul(al8, bh5) | 0;
            mid = mid + Math.imul(ah8, bl5) | 0;
            hi = hi + Math.imul(ah8, bh5) | 0;
            lo = lo + Math.imul(al7, bl6) | 0;
            mid = mid + Math.imul(al7, bh6) | 0;
            mid = mid + Math.imul(ah7, bl6) | 0;
            hi = hi + Math.imul(ah7, bh6) | 0;
            lo = lo + Math.imul(al6, bl7) | 0;
            mid = mid + Math.imul(al6, bh7) | 0;
            mid = mid + Math.imul(ah6, bl7) | 0;
            hi = hi + Math.imul(ah6, bh7) | 0;
            lo = lo + Math.imul(al5, bl8) | 0;
            mid = mid + Math.imul(al5, bh8) | 0;
            mid = mid + Math.imul(ah5, bl8) | 0;
            hi = hi + Math.imul(ah5, bh8) | 0;
            lo = lo + Math.imul(al4, bl9) | 0;
            mid = mid + Math.imul(al4, bh9) | 0;
            mid = mid + Math.imul(ah4, bl9) | 0;
            hi = hi + Math.imul(ah4, bh9) | 0;
            var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
            w13 &= 0x3ffffff;
            lo = Math.imul(al9, bl5);
            mid = Math.imul(al9, bh5);
            mid = mid + Math.imul(ah9, bl5) | 0;
            hi = Math.imul(ah9, bh5);
            lo = lo + Math.imul(al8, bl6) | 0;
            mid = mid + Math.imul(al8, bh6) | 0;
            mid = mid + Math.imul(ah8, bl6) | 0;
            hi = hi + Math.imul(ah8, bh6) | 0;
            lo = lo + Math.imul(al7, bl7) | 0;
            mid = mid + Math.imul(al7, bh7) | 0;
            mid = mid + Math.imul(ah7, bl7) | 0;
            hi = hi + Math.imul(ah7, bh7) | 0;
            lo = lo + Math.imul(al6, bl8) | 0;
            mid = mid + Math.imul(al6, bh8) | 0;
            mid = mid + Math.imul(ah6, bl8) | 0;
            hi = hi + Math.imul(ah6, bh8) | 0;
            lo = lo + Math.imul(al5, bl9) | 0;
            mid = mid + Math.imul(al5, bh9) | 0;
            mid = mid + Math.imul(ah5, bl9) | 0;
            hi = hi + Math.imul(ah5, bh9) | 0;
            var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
            w14 &= 0x3ffffff;
            lo = Math.imul(al9, bl6);
            mid = Math.imul(al9, bh6);
            mid = mid + Math.imul(ah9, bl6) | 0;
            hi = Math.imul(ah9, bh6);
            lo = lo + Math.imul(al8, bl7) | 0;
            mid = mid + Math.imul(al8, bh7) | 0;
            mid = mid + Math.imul(ah8, bl7) | 0;
            hi = hi + Math.imul(ah8, bh7) | 0;
            lo = lo + Math.imul(al7, bl8) | 0;
            mid = mid + Math.imul(al7, bh8) | 0;
            mid = mid + Math.imul(ah7, bl8) | 0;
            hi = hi + Math.imul(ah7, bh8) | 0;
            lo = lo + Math.imul(al6, bl9) | 0;
            mid = mid + Math.imul(al6, bh9) | 0;
            mid = mid + Math.imul(ah6, bl9) | 0;
            hi = hi + Math.imul(ah6, bh9) | 0;
            var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
            w15 &= 0x3ffffff;
            lo = Math.imul(al9, bl7);
            mid = Math.imul(al9, bh7);
            mid = mid + Math.imul(ah9, bl7) | 0;
            hi = Math.imul(ah9, bh7);
            lo = lo + Math.imul(al8, bl8) | 0;
            mid = mid + Math.imul(al8, bh8) | 0;
            mid = mid + Math.imul(ah8, bl8) | 0;
            hi = hi + Math.imul(ah8, bh8) | 0;
            lo = lo + Math.imul(al7, bl9) | 0;
            mid = mid + Math.imul(al7, bh9) | 0;
            mid = mid + Math.imul(ah7, bl9) | 0;
            hi = hi + Math.imul(ah7, bh9) | 0;
            var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
            w16 &= 0x3ffffff;
            lo = Math.imul(al9, bl8);
            mid = Math.imul(al9, bh8);
            mid = mid + Math.imul(ah9, bl8) | 0;
            hi = Math.imul(ah9, bh8);
            lo = lo + Math.imul(al8, bl9) | 0;
            mid = mid + Math.imul(al8, bh9) | 0;
            mid = mid + Math.imul(ah8, bl9) | 0;
            hi = hi + Math.imul(ah8, bh9) | 0;
            var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
            w17 &= 0x3ffffff;
            lo = Math.imul(al9, bl9);
            mid = Math.imul(al9, bh9);
            mid = mid + Math.imul(ah9, bl9) | 0;
            hi = Math.imul(ah9, bh9);
            var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
            c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
            w18 &= 0x3ffffff;
            o[0] = w0;
            o[1] = w1;
            o[2] = w2;
            o[3] = w3;
            o[4] = w4;
            o[5] = w5;
            o[6] = w6;
            o[7] = w7;
            o[8] = w8;
            o[9] = w9;
            o[10] = w10;
            o[11] = w11;
            o[12] = w12;
            o[13] = w13;
            o[14] = w14;
            o[15] = w15;
            o[16] = w16;
            o[17] = w17;
            o[18] = w18;
            if (c !== 0) {
                o[19] = c;
                out.length++;
            }
            return out;
        };
        if (!Math.imul) comb10MulTo = smallMulTo;
        function bigMulTo(self, num, out) {
            out.negative = num.negative ^ self.negative;
            out.length = self.length + num.length;
            var carry = 0;
            var hncarry = 0;
            for(var k = 0; k < out.length - 1; k++){
                var ncarry = hncarry;
                hncarry = 0;
                var rword = carry & 0x3ffffff;
                var maxJ = Math.min(k, num.length - 1);
                for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                    var i = k - j;
                    var a = self.words[i] | 0;
                    var b = num.words[j] | 0;
                    var r = a * b;
                    var lo = r & 0x3ffffff;
                    ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                    lo = lo + rword | 0;
                    rword = lo & 0x3ffffff;
                    ncarry = ncarry + (lo >>> 26) | 0;
                    hncarry += ncarry >>> 26;
                    ncarry &= 0x3ffffff;
                }
                out.words[k] = rword;
                carry = ncarry;
                ncarry = hncarry;
            }
            if (carry !== 0) out.words[k] = carry;
            else out.length--;
            return out._strip();
        }
        function jumboMulTo(self, num, out) {
            return bigMulTo(self, num, out);
        }
        BN.prototype.mulTo = function mulTo(num, out) {
            var res;
            var len = this.length + num.length;
            if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
            else if (len < 63) res = smallMulTo(this, num, out);
            else if (len < 1024) res = bigMulTo(this, num, out);
            else res = jumboMulTo(this, num, out);
            return res;
        };
        function FFTM(x, y) {
            this.x = x;
            this.y = y;
        }
        FFTM.prototype.makeRBT = function makeRBT(N) {
            var t = new Array(N);
            var l = BN.prototype._countBits(N) - 1;
            for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
            return t;
        };
        FFTM.prototype.revBin = function revBin(x, l, N) {
            if (x === 0 || x === N - 1) return x;
            var rb = 0;
            for(var i = 0; i < l; i++){
                rb |= (x & 1) << l - i - 1;
                x >>= 1;
            }
            return rb;
        };
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
            for(var i = 0; i < N; i++){
                rtws[i] = rws[rbt[i]];
                itws[i] = iws[rbt[i]];
            }
        };
        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
            this.permute(rbt, rws, iws, rtws, itws, N);
            for(var s = 1; s < N; s <<= 1){
                var l = s << 1;
                var rtwdf = Math.cos(2 * Math.PI / l);
                var itwdf = Math.sin(2 * Math.PI / l);
                for(var p = 0; p < N; p += l){
                    var rtwdf_ = rtwdf;
                    var itwdf_ = itwdf;
                    for(var j = 0; j < s; j++){
                        var re = rtws[p + j];
                        var ie = itws[p + j];
                        var ro = rtws[p + j + s];
                        var io = itws[p + j + s];
                        var rx = rtwdf_ * ro - itwdf_ * io;
                        io = rtwdf_ * io + itwdf_ * ro;
                        ro = rx;
                        rtws[p + j] = re + ro;
                        itws[p + j] = ie + io;
                        rtws[p + j + s] = re - ro;
                        itws[p + j + s] = ie - io;
                        if (j !== l) {
                            rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                            rtwdf_ = rx;
                        }
                    }
                }
            }
        };
        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
            var N = Math.max(m, n) | 1;
            var odd = N & 1;
            var i = 0;
            for(N = N / 2 | 0; N; N = N >>> 1)i++;
            return 1 << i + 1 + odd;
        };
        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
            if (N <= 1) return;
            for(var i = 0; i < N / 2; i++){
                var t = rws[i];
                rws[i] = rws[N - i - 1];
                rws[N - i - 1] = t;
                t = iws[i];
                iws[i] = -iws[N - i - 1];
                iws[N - i - 1] = -t;
            }
        };
        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
            var carry = 0;
            for(var i = 0; i < N / 2; i++){
                var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
                ws[i] = w & 0x3ffffff;
                if (w < 0x4000000) carry = 0;
                else carry = w / 0x4000000 | 0;
            }
            return ws;
        };
        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
            var carry = 0;
            for(var i = 0; i < len; i++){
                carry = carry + (ws[i] | 0);
                rws[2 * i] = carry & 0x1fff;
                carry = carry >>> 13;
                rws[2 * i + 1] = carry & 0x1fff;
                carry = carry >>> 13;
            }
            for(i = 2 * len; i < N; ++i)rws[i] = 0;
            assert(carry === 0);
            assert((carry & -8192) === 0);
        };
        FFTM.prototype.stub = function stub(N) {
            var ph = new Array(N);
            for(var i = 0; i < N; i++)ph[i] = 0;
            return ph;
        };
        FFTM.prototype.mulp = function mulp(x, y, out) {
            var N = 2 * this.guessLen13b(x.length, y.length);
            var rbt = this.makeRBT(N);
            var _ = this.stub(N);
            var rws = new Array(N);
            var rwst = new Array(N);
            var iwst = new Array(N);
            var nrws = new Array(N);
            var nrwst = new Array(N);
            var niwst = new Array(N);
            var rmws = out.words;
            rmws.length = N;
            this.convert13b(x.words, x.length, rws, N);
            this.convert13b(y.words, y.length, nrws, N);
            this.transform(rws, _, rwst, iwst, N, rbt);
            this.transform(nrws, _, nrwst, niwst, N, rbt);
            for(var i = 0; i < N; i++){
                var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
                iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
                rwst[i] = rx;
            }
            this.conjugate(rwst, iwst, N);
            this.transform(rwst, iwst, rmws, _, N, rbt);
            this.conjugate(rmws, _, N);
            this.normalize13b(rmws, N);
            out.negative = x.negative ^ y.negative;
            out.length = x.length + y.length;
            return out._strip();
        };
        BN.prototype.mul = function mul(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return this.mulTo(num, out);
        };
        BN.prototype.mulf = function mulf(num) {
            var out = new BN(null);
            out.words = new Array(this.length + num.length);
            return jumboMulTo(this, num, out);
        };
        BN.prototype.imul = function imul(num) {
            return this.clone().mulTo(num, this);
        };
        BN.prototype.imuln = function imuln(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = (this.words[i] | 0) * num;
                var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
                carry >>= 26;
                carry += w / 0x4000000 | 0;
                carry += lo >>> 26;
                this.words[i] = lo & 0x3ffffff;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.muln = function muln(num) {
            return this.clone().imuln(num);
        };
        BN.prototype.sqr = function sqr() {
            return this.mul(this);
        };
        BN.prototype.isqr = function isqr() {
            return this.imul(this.clone());
        };
        BN.prototype.pow = function pow(num) {
            var w = toBitArray(num);
            if (w.length === 0) return new BN(1);
            var res = this;
            for(var i = 0; i < w.length; i++, res = res.sqr()){
                if (w[i] !== 0) break;
            }
            if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
                if (w[i] === 0) continue;
                res = res.mul(q);
            }
            return res;
        };
        BN.prototype.iushln = function iushln(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
            var i;
            if (r !== 0) {
                var carry = 0;
                for(i = 0; i < this.length; i++){
                    var newCarry = this.words[i] & carryMask;
                    var c = (this.words[i] | 0) - newCarry << r;
                    this.words[i] = c | carry;
                    carry = newCarry >>> 26 - r;
                }
                if (carry) {
                    this.words[i] = carry;
                    this.length++;
                }
            }
            if (s !== 0) {
                for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
                for(i = 0; i < s; i++)this.words[i] = 0;
                this.length += s;
            }
            return this._strip();
        };
        BN.prototype.ishln = function ishln(bits) {
            assert(this.negative === 0);
            return this.iushln(bits);
        };
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
            assert(typeof bits === 'number' && bits >= 0);
            var h;
            if (hint) h = (hint - hint % 26) / 26;
            else h = 0;
            var r = bits % 26;
            var s = Math.min((bits - r) / 26, this.length);
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            var maskedWords = extended;
            h -= s;
            h = Math.max(0, h);
            if (maskedWords) {
                for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
                maskedWords.length = s;
            }
            if (s === 0) ;
            else if (this.length > s) {
                this.length -= s;
                for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
            } else {
                this.words[0] = 0;
                this.length = 1;
            }
            var carry = 0;
            for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
                var word = this.words[i] | 0;
                this.words[i] = carry << 26 - r | word >>> r;
                carry = word & mask;
            }
            if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
            if (this.length === 0) {
                this.words[0] = 0;
                this.length = 1;
            }
            return this._strip();
        };
        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
            assert(this.negative === 0);
            return this.iushrn(bits, hint, extended);
        };
        BN.prototype.shln = function shln(bits) {
            return this.clone().ishln(bits);
        };
        BN.prototype.ushln = function ushln(bits) {
            return this.clone().iushln(bits);
        };
        BN.prototype.shrn = function shrn(bits) {
            return this.clone().ishrn(bits);
        };
        BN.prototype.ushrn = function ushrn(bits) {
            return this.clone().iushrn(bits);
        };
        BN.prototype.testn = function testn(bit) {
            assert(typeof bit === 'number' && bit >= 0);
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) return false;
            var w = this.words[s];
            return !!(w & q);
        };
        BN.prototype.imaskn = function imaskn(bits) {
            assert(typeof bits === 'number' && bits >= 0);
            var r = bits % 26;
            var s = (bits - r) / 26;
            assert(this.negative === 0, 'imaskn works only with positive numbers');
            if (this.length <= s) return this;
            if (r !== 0) s++;
            this.length = Math.min(s, this.length);
            if (r !== 0) {
                var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
                this.words[this.length - 1] &= mask;
            }
            return this._strip();
        };
        BN.prototype.maskn = function maskn(bits) {
            return this.clone().imaskn(bits);
        };
        BN.prototype.iaddn = function iaddn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.isubn(-num);
            if (this.negative !== 0) {
                if (this.length === 1 && (this.words[0] | 0) <= num) {
                    this.words[0] = num - (this.words[0] | 0);
                    this.negative = 0;
                    return this;
                }
                this.negative = 0;
                this.isubn(num);
                this.negative = 1;
                return this;
            }
            return this._iaddn(num);
        };
        BN.prototype._iaddn = function _iaddn(num) {
            this.words[0] += num;
            for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
                this.words[i] -= 0x4000000;
                if (i === this.length - 1) this.words[i + 1] = 1;
                else this.words[i + 1]++;
            }
            this.length = Math.max(this.length, i + 1);
            return this;
        };
        BN.prototype.isubn = function isubn(num) {
            assert(typeof num === 'number');
            assert(num < 0x4000000);
            if (num < 0) return this.iaddn(-num);
            if (this.negative !== 0) {
                this.negative = 0;
                this.iaddn(num);
                this.negative = 1;
                return this;
            }
            this.words[0] -= num;
            if (this.length === 1 && this.words[0] < 0) {
                this.words[0] = -this.words[0];
                this.negative = 1;
            } else for(var i = 0; i < this.length && this.words[i] < 0; i++){
                this.words[i] += 0x4000000;
                this.words[i + 1] -= 1;
            }
            return this._strip();
        };
        BN.prototype.addn = function addn(num) {
            return this.clone().iaddn(num);
        };
        BN.prototype.subn = function subn(num) {
            return this.clone().isubn(num);
        };
        BN.prototype.iabs = function iabs() {
            this.negative = 0;
            return this;
        };
        BN.prototype.abs = function abs() {
            return this.clone().iabs();
        };
        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
            var len = num.length + shift;
            var i;
            this._expand(len);
            var w;
            var carry = 0;
            for(i = 0; i < num.length; i++){
                w = (this.words[i + shift] | 0) + carry;
                var right = (num.words[i] | 0) * mul;
                w -= right & 0x3ffffff;
                carry = (w >> 26) - (right / 0x4000000 | 0);
                this.words[i + shift] = w & 0x3ffffff;
            }
            for(; i < this.length - shift; i++){
                w = (this.words[i + shift] | 0) + carry;
                carry = w >> 26;
                this.words[i + shift] = w & 0x3ffffff;
            }
            if (carry === 0) return this._strip();
            assert(carry === -1);
            carry = 0;
            for(i = 0; i < this.length; i++){
                w = -(this.words[i] | 0) + carry;
                carry = w >> 26;
                this.words[i] = w & 0x3ffffff;
            }
            this.negative = 1;
            return this._strip();
        };
        BN.prototype._wordDiv = function _wordDiv(num, mode) {
            var shift = this.length - num.length;
            var a = this.clone();
            var b = num;
            var bhi = b.words[b.length - 1] | 0;
            var bhiBits = this._countBits(bhi);
            shift = 26 - bhiBits;
            if (shift !== 0) {
                b = b.ushln(shift);
                a.iushln(shift);
                bhi = b.words[b.length - 1] | 0;
            }
            var m = a.length - b.length;
            var q;
            if (mode !== 'mod') {
                q = new BN(null);
                q.length = m + 1;
                q.words = new Array(q.length);
                for(var i = 0; i < q.length; i++)q.words[i] = 0;
            }
            var diff = a.clone()._ishlnsubmul(b, 1, m);
            if (diff.negative === 0) {
                a = diff;
                if (q) q.words[m] = 1;
            }
            for(var j = m - 1; j >= 0; j--){
                var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
                qj = Math.min(qj / bhi | 0, 0x3ffffff);
                a._ishlnsubmul(b, qj, j);
                while(a.negative !== 0){
                    qj--;
                    a.negative = 0;
                    a._ishlnsubmul(b, 1, j);
                    if (!a.isZero()) a.negative ^= 1;
                }
                if (q) q.words[j] = qj;
            }
            if (q) q._strip();
            a._strip();
            if (mode !== 'div' && shift !== 0) a.iushrn(shift);
            return {
                div: q || null,
                mod: a
            };
        };
        BN.prototype.divmod = function divmod(num, mode, positive) {
            assert(!num.isZero());
            if (this.isZero()) return {
                div: new BN(0),
                mod: new BN(0)
            };
            var div, mod, res;
            if (this.negative !== 0 && num.negative === 0) {
                res = this.neg().divmod(num, mode);
                if (mode !== 'mod') div = res.div.neg();
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.iadd(num);
                }
                return {
                    div: div,
                    mod: mod
                };
            }
            if (this.negative === 0 && num.negative !== 0) {
                res = this.divmod(num.neg(), mode);
                if (mode !== 'mod') div = res.div.neg();
                return {
                    div: div,
                    mod: res.mod
                };
            }
            if ((this.negative & num.negative) !== 0) {
                res = this.neg().divmod(num.neg(), mode);
                if (mode !== 'div') {
                    mod = res.mod.neg();
                    if (positive && mod.negative !== 0) mod.isub(num);
                }
                return {
                    div: res.div,
                    mod: mod
                };
            }
            if (num.length > this.length || this.cmp(num) < 0) return {
                div: new BN(0),
                mod: this
            };
            if (num.length === 1) {
                if (mode === 'div') return {
                    div: this.divn(num.words[0]),
                    mod: null
                };
                if (mode === 'mod') return {
                    div: null,
                    mod: new BN(this.modrn(num.words[0]))
                };
                return {
                    div: this.divn(num.words[0]),
                    mod: new BN(this.modrn(num.words[0]))
                };
            }
            return this._wordDiv(num, mode);
        };
        BN.prototype.div = function div(num) {
            return this.divmod(num, 'div', false).div;
        };
        BN.prototype.mod = function mod(num) {
            return this.divmod(num, 'mod', false).mod;
        };
        BN.prototype.umod = function umod(num) {
            return this.divmod(num, 'mod', true).mod;
        };
        BN.prototype.divRound = function divRound(num) {
            var dm = this.divmod(num);
            if (dm.mod.isZero()) return dm.div;
            var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
            var half = num.ushrn(1);
            var r2 = num.andln(1);
            var cmp = mod.cmp(half);
            if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
            return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };
        BN.prototype.modrn = function modrn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var p = 67108864 % num;
            var acc = 0;
            for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
            return isNegNum ? -acc : acc;
        };
        BN.prototype.modn = function modn(num) {
            return this.modrn(num);
        };
        BN.prototype.idivn = function idivn(num) {
            var isNegNum = num < 0;
            if (isNegNum) num = -num;
            assert(num <= 0x3ffffff);
            var carry = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var w = (this.words[i] | 0) + carry * 0x4000000;
                this.words[i] = w / num | 0;
                carry = w % num;
            }
            this._strip();
            return isNegNum ? this.ineg() : this;
        };
        BN.prototype.divn = function divn(num) {
            return this.clone().idivn(num);
        };
        BN.prototype.egcd = function egcd(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var x = this;
            var y = p.clone();
            if (x.negative !== 0) x = x.umod(p);
            else x = x.clone();
            var A = new BN(1);
            var B = new BN(0);
            var C = new BN(0);
            var D = new BN(1);
            var g = 0;
            while(x.isEven() && y.isEven()){
                x.iushrn(1);
                y.iushrn(1);
                ++g;
            }
            var yp = y.clone();
            var xp = x.clone();
            while(!x.isZero()){
                for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    x.iushrn(i);
                    while(i-- > 0){
                        if (A.isOdd() || B.isOdd()) {
                            A.iadd(yp);
                            B.isub(xp);
                        }
                        A.iushrn(1);
                        B.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    y.iushrn(j);
                    while(j-- > 0){
                        if (C.isOdd() || D.isOdd()) {
                            C.iadd(yp);
                            D.isub(xp);
                        }
                        C.iushrn(1);
                        D.iushrn(1);
                    }
                }
                if (x.cmp(y) >= 0) {
                    x.isub(y);
                    A.isub(C);
                    B.isub(D);
                } else {
                    y.isub(x);
                    C.isub(A);
                    D.isub(B);
                }
            }
            return {
                a: C,
                b: D,
                gcd: y.iushln(g)
            };
        };
        BN.prototype._invmp = function _invmp(p) {
            assert(p.negative === 0);
            assert(!p.isZero());
            var a = this;
            var b = p.clone();
            if (a.negative !== 0) a = a.umod(p);
            else a = a.clone();
            var x1 = new BN(1);
            var x2 = new BN(0);
            var delta = b.clone();
            while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
                for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
                if (i > 0) {
                    a.iushrn(i);
                    while(i-- > 0){
                        if (x1.isOdd()) x1.iadd(delta);
                        x1.iushrn(1);
                    }
                }
                for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
                if (j > 0) {
                    b.iushrn(j);
                    while(j-- > 0){
                        if (x2.isOdd()) x2.iadd(delta);
                        x2.iushrn(1);
                    }
                }
                if (a.cmp(b) >= 0) {
                    a.isub(b);
                    x1.isub(x2);
                } else {
                    b.isub(a);
                    x2.isub(x1);
                }
            }
            var res;
            if (a.cmpn(1) === 0) res = x1;
            else res = x2;
            if (res.cmpn(0) < 0) res.iadd(p);
            return res;
        };
        BN.prototype.gcd = function gcd(num) {
            if (this.isZero()) return num.abs();
            if (num.isZero()) return this.abs();
            var a = this.clone();
            var b = num.clone();
            a.negative = 0;
            b.negative = 0;
            for(var shift = 0; a.isEven() && b.isEven(); shift++){
                a.iushrn(1);
                b.iushrn(1);
            }
            do {
                while(a.isEven())a.iushrn(1);
                while(b.isEven())b.iushrn(1);
                var r = a.cmp(b);
                if (r < 0) {
                    var t = a;
                    a = b;
                    b = t;
                } else if (r === 0 || b.cmpn(1) === 0) break;
                a.isub(b);
            }while (true)
            return b.iushln(shift);
        };
        BN.prototype.invm = function invm(num) {
            return this.egcd(num).a.umod(num);
        };
        BN.prototype.isEven = function isEven() {
            return (this.words[0] & 1) === 0;
        };
        BN.prototype.isOdd = function isOdd() {
            return (this.words[0] & 1) === 1;
        };
        BN.prototype.andln = function andln(num) {
            return this.words[0] & num;
        };
        BN.prototype.bincn = function bincn(bit) {
            assert(typeof bit === 'number');
            var r = bit % 26;
            var s = (bit - r) / 26;
            var q = 1 << r;
            if (this.length <= s) {
                this._expand(s + 1);
                this.words[s] |= q;
                return this;
            }
            var carry = q;
            for(var i = s; carry !== 0 && i < this.length; i++){
                var w = this.words[i] | 0;
                w += carry;
                carry = w >>> 26;
                w &= 0x3ffffff;
                this.words[i] = w;
            }
            if (carry !== 0) {
                this.words[i] = carry;
                this.length++;
            }
            return this;
        };
        BN.prototype.isZero = function isZero() {
            return this.length === 1 && this.words[0] === 0;
        };
        BN.prototype.cmpn = function cmpn(num) {
            var negative = num < 0;
            if (this.negative !== 0 && !negative) return -1;
            if (this.negative === 0 && negative) return 1;
            this._strip();
            var res;
            if (this.length > 1) res = 1;
            else {
                if (negative) num = -num;
                assert(num <= 0x3ffffff, 'Number is too big');
                var w = this.words[0] | 0;
                res = w === num ? 0 : w < num ? -1 : 1;
            }
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.cmp = function cmp(num) {
            if (this.negative !== 0 && num.negative === 0) return -1;
            if (this.negative === 0 && num.negative !== 0) return 1;
            var res = this.ucmp(num);
            if (this.negative !== 0) return -res | 0;
            return res;
        };
        BN.prototype.ucmp = function ucmp(num) {
            if (this.length > num.length) return 1;
            if (this.length < num.length) return -1;
            var res = 0;
            for(var i = this.length - 1; i >= 0; i--){
                var a = this.words[i] | 0;
                var b = num.words[i] | 0;
                if (a === b) continue;
                if (a < b) res = -1;
                else if (a > b) res = 1;
                break;
            }
            return res;
        };
        BN.prototype.gtn = function gtn(num) {
            return this.cmpn(num) === 1;
        };
        BN.prototype.gt = function gt(num) {
            return this.cmp(num) === 1;
        };
        BN.prototype.gten = function gten(num) {
            return this.cmpn(num) >= 0;
        };
        BN.prototype.gte = function gte(num) {
            return this.cmp(num) >= 0;
        };
        BN.prototype.ltn = function ltn(num) {
            return this.cmpn(num) === -1;
        };
        BN.prototype.lt = function lt(num) {
            return this.cmp(num) === -1;
        };
        BN.prototype.lten = function lten(num) {
            return this.cmpn(num) <= 0;
        };
        BN.prototype.lte = function lte(num) {
            return this.cmp(num) <= 0;
        };
        BN.prototype.eqn = function eqn(num) {
            return this.cmpn(num) === 0;
        };
        BN.prototype.eq = function eq(num) {
            return this.cmp(num) === 0;
        };
        BN.red = function red(num) {
            return new Red(num);
        };
        BN.prototype.toRed = function toRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            assert(this.negative === 0, 'red works only with positives');
            return ctx.convertTo(this)._forceRed(ctx);
        };
        BN.prototype.fromRed = function fromRed() {
            assert(this.red, 'fromRed works only with numbers in reduction context');
            return this.red.convertFrom(this);
        };
        BN.prototype._forceRed = function _forceRed(ctx) {
            this.red = ctx;
            return this;
        };
        BN.prototype.forceRed = function forceRed(ctx) {
            assert(!this.red, 'Already a number in reduction context');
            return this._forceRed(ctx);
        };
        BN.prototype.redAdd = function redAdd(num) {
            assert(this.red, 'redAdd works only with red numbers');
            return this.red.add(this, num);
        };
        BN.prototype.redIAdd = function redIAdd(num) {
            assert(this.red, 'redIAdd works only with red numbers');
            return this.red.iadd(this, num);
        };
        BN.prototype.redSub = function redSub(num) {
            assert(this.red, 'redSub works only with red numbers');
            return this.red.sub(this, num);
        };
        BN.prototype.redISub = function redISub(num) {
            assert(this.red, 'redISub works only with red numbers');
            return this.red.isub(this, num);
        };
        BN.prototype.redShl = function redShl(num) {
            assert(this.red, 'redShl works only with red numbers');
            return this.red.shl(this, num);
        };
        BN.prototype.redMul = function redMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.mul(this, num);
        };
        BN.prototype.redIMul = function redIMul(num) {
            assert(this.red, 'redMul works only with red numbers');
            this.red._verify2(this, num);
            return this.red.imul(this, num);
        };
        BN.prototype.redSqr = function redSqr() {
            assert(this.red, 'redSqr works only with red numbers');
            this.red._verify1(this);
            return this.red.sqr(this);
        };
        BN.prototype.redISqr = function redISqr() {
            assert(this.red, 'redISqr works only with red numbers');
            this.red._verify1(this);
            return this.red.isqr(this);
        };
        BN.prototype.redSqrt = function redSqrt() {
            assert(this.red, 'redSqrt works only with red numbers');
            this.red._verify1(this);
            return this.red.sqrt(this);
        };
        BN.prototype.redInvm = function redInvm() {
            assert(this.red, 'redInvm works only with red numbers');
            this.red._verify1(this);
            return this.red.invm(this);
        };
        BN.prototype.redNeg = function redNeg() {
            assert(this.red, 'redNeg works only with red numbers');
            this.red._verify1(this);
            return this.red.neg(this);
        };
        BN.prototype.redPow = function redPow(num) {
            assert(this.red && !num.red, 'redPow(normalNum)');
            this.red._verify1(this);
            return this.red.pow(this, num);
        };
        var primes = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null
        };
        function MPrime(name, p) {
            this.name = name;
            this.p = new BN(p, 16);
            this.n = this.p.bitLength();
            this.k = new BN(1).iushln(this.n).isub(this.p);
            this.tmp = this._tmp();
        }
        MPrime.prototype._tmp = function _tmp() {
            var tmp = new BN(null);
            tmp.words = new Array(Math.ceil(this.n / 13));
            return tmp;
        };
        MPrime.prototype.ireduce = function ireduce(num) {
            var r = num;
            var rlen;
            do {
                this.split(r, this.tmp);
                r = this.imulK(r);
                r = r.iadd(this.tmp);
                rlen = r.bitLength();
            }while (rlen > this.n)
            var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
            if (cmp === 0) {
                r.words[0] = 0;
                r.length = 1;
            } else if (cmp > 0) r.isub(this.p);
            else if (r.strip !== undefined) r.strip();
            else r._strip();
            return r;
        };
        MPrime.prototype.split = function split(input, out) {
            input.iushrn(this.n, 0, out);
        };
        MPrime.prototype.imulK = function imulK(num) {
            return num.imul(this.k);
        };
        function K256() {
            MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);
        K256.prototype.split = function split(input, output) {
            var mask = 0x3fffff;
            var outLen = Math.min(input.length, 9);
            for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
            output.length = outLen;
            if (input.length <= 9) {
                input.words[0] = 0;
                input.length = 1;
                return;
            }
            var prev = input.words[9];
            output.words[output.length++] = prev & mask;
            for(i = 10; i < input.length; i++){
                var next = input.words[i] | 0;
                input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
                prev = next;
            }
            prev >>>= 22;
            input.words[i - 10] = prev;
            if (prev === 0 && input.length > 10) input.length -= 10;
            else input.length -= 9;
        };
        K256.prototype.imulK = function imulK(num) {
            num.words[num.length] = 0;
            num.words[num.length + 1] = 0;
            num.length += 2;
            var lo = 0;
            for(var i = 0; i < num.length; i++){
                var w = num.words[i] | 0;
                lo += w * 0x3d1;
                num.words[i] = lo & 0x3ffffff;
                lo = w * 0x40 + (lo / 0x4000000 | 0);
            }
            if (num.words[num.length - 1] === 0) {
                num.length--;
                if (num.words[num.length - 1] === 0) num.length--;
            }
            return num;
        };
        function P224() {
            MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);
        function P192() {
            MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);
        function P25519() {
            MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);
        P25519.prototype.imulK = function imulK(num) {
            var carry = 0;
            for(var i = 0; i < num.length; i++){
                var hi = (num.words[i] | 0) * 0x13 + carry;
                var lo = hi & 0x3ffffff;
                hi >>>= 26;
                num.words[i] = lo;
                carry = hi;
            }
            if (carry !== 0) num.words[num.length++] = carry;
            return num;
        };
        BN._prime = function prime(name) {
            if (primes[name]) return primes[name];
            var prime;
            if (name === 'k256') prime = new K256();
            else if (name === 'p224') prime = new P224();
            else if (name === 'p192') prime = new P192();
            else if (name === 'p25519') prime = new P25519();
            else throw new Error('Unknown prime ' + name);
            primes[name] = prime;
            return prime;
        };
        function Red(m) {
            if (typeof m === 'string') {
                var prime = BN._prime(m);
                this.m = prime.p;
                this.prime = prime;
            } else {
                assert(m.gtn(1), 'modulus must be greater than 1');
                this.m = m;
                this.prime = null;
            }
        }
        Red.prototype._verify1 = function _verify1(a) {
            assert(a.negative === 0, 'red works only with positives');
            assert(a.red, 'red works only with red numbers');
        };
        Red.prototype._verify2 = function _verify2(a, b) {
            assert((a.negative | b.negative) === 0, 'red works only with positives');
            assert(a.red && a.red === b.red, 'red works only with red numbers');
        };
        Red.prototype.imod = function imod(a) {
            if (this.prime) return this.prime.ireduce(a)._forceRed(this);
            move(a, a.umod(this.m)._forceRed(this));
            return a;
        };
        Red.prototype.neg = function neg(a) {
            if (a.isZero()) return a.clone();
            return this.m.sub(a)._forceRed(this);
        };
        Red.prototype.add = function add(a, b) {
            this._verify2(a, b);
            var res = a.add(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res._forceRed(this);
        };
        Red.prototype.iadd = function iadd(a, b) {
            this._verify2(a, b);
            var res = a.iadd(b);
            if (res.cmp(this.m) >= 0) res.isub(this.m);
            return res;
        };
        Red.prototype.sub = function sub(a, b) {
            this._verify2(a, b);
            var res = a.sub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res._forceRed(this);
        };
        Red.prototype.isub = function isub(a, b) {
            this._verify2(a, b);
            var res = a.isub(b);
            if (res.cmpn(0) < 0) res.iadd(this.m);
            return res;
        };
        Red.prototype.shl = function shl(a, num) {
            this._verify1(a);
            return this.imod(a.ushln(num));
        };
        Red.prototype.imul = function imul(a, b) {
            this._verify2(a, b);
            return this.imod(a.imul(b));
        };
        Red.prototype.mul = function mul(a, b) {
            this._verify2(a, b);
            return this.imod(a.mul(b));
        };
        Red.prototype.isqr = function isqr(a) {
            return this.imul(a, a.clone());
        };
        Red.prototype.sqr = function sqr(a) {
            return this.mul(a, a);
        };
        Red.prototype.sqrt = function sqrt(a) {
            if (a.isZero()) return a.clone();
            var mod3 = this.m.andln(3);
            assert(mod3 % 2 === 1);
            if (mod3 === 3) {
                var pow = this.m.add(new BN(1)).iushrn(2);
                return this.pow(a, pow);
            }
            var q = this.m.subn(1);
            var s = 0;
            while(!q.isZero() && q.andln(1) === 0){
                s++;
                q.iushrn(1);
            }
            assert(!q.isZero());
            var one = new BN(1).toRed(this);
            var nOne = one.redNeg();
            var lpow = this.m.subn(1).iushrn(1);
            var z = this.m.bitLength();
            z = new BN(2 * z * z).toRed(this);
            while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
            var c = this.pow(z, q);
            var r = this.pow(a, q.addn(1).iushrn(1));
            var t = this.pow(a, q);
            var m = s;
            while(t.cmp(one) !== 0){
                var tmp = t;
                for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
                assert(i < m);
                var b = this.pow(c, new BN(1).iushln(m - i - 1));
                r = r.redMul(b);
                c = b.redSqr();
                t = t.redMul(c);
                m = i;
            }
            return r;
        };
        Red.prototype.invm = function invm(a) {
            var inv = a._invmp(this.m);
            if (inv.negative !== 0) {
                inv.negative = 0;
                return this.imod(inv).redNeg();
            } else return this.imod(inv);
        };
        Red.prototype.pow = function pow(a, num) {
            if (num.isZero()) return new BN(1).toRed(this);
            if (num.cmpn(1) === 0) return a.clone();
            var windowSize = 4;
            var wnd = new Array(1 << windowSize);
            wnd[0] = new BN(1).toRed(this);
            wnd[1] = a;
            for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
            var res = wnd[0];
            var current = 0;
            var currentLen = 0;
            var start = num.bitLength() % 26;
            if (start === 0) start = 26;
            for(i = num.length - 1; i >= 0; i--){
                var word = num.words[i];
                for(var j = start - 1; j >= 0; j--){
                    var bit = word >> j & 1;
                    if (res !== wnd[0]) res = this.sqr(res);
                    if (bit === 0 && current === 0) {
                        currentLen = 0;
                        continue;
                    }
                    current <<= 1;
                    current |= bit;
                    currentLen++;
                    if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                    res = this.mul(res, wnd[current]);
                    currentLen = 0;
                    current = 0;
                }
                start = 26;
            }
            return res;
        };
        Red.prototype.convertTo = function convertTo(num) {
            var r = num.umod(this.m);
            return r === num ? r.clone() : r;
        };
        Red.prototype.convertFrom = function convertFrom(num) {
            var res = num.clone();
            res.red = null;
            return res;
        };
        BN.mont = function mont(num) {
            return new Mont(num);
        };
        function Mont(m) {
            Red.call(this, m);
            this.shift = this.m.bitLength();
            if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
            this.r = new BN(1).iushln(this.shift);
            this.r2 = this.imod(this.r.sqr());
            this.rinv = this.r._invmp(this.m);
            this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
            this.minv = this.minv.umod(this.r);
            this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);
        Mont.prototype.convertTo = function convertTo(num) {
            return this.imod(num.ushln(this.shift));
        };
        Mont.prototype.convertFrom = function convertFrom(num) {
            var r = this.imod(num.mul(this.rinv));
            r.red = null;
            return r;
        };
        Mont.prototype.imul = function imul(a, b) {
            if (a.isZero() || b.isZero()) {
                a.words[0] = 0;
                a.length = 1;
                return a;
            }
            var t = a.imul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.mul = function mul(a, b) {
            if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
            var t = a.mul(b);
            var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
            var u = t.isub(c).iushrn(this.shift);
            var res = u;
            if (u.cmp(this.m) >= 0) res = u.isub(this.m);
            else if (u.cmpn(0) < 0) res = u.iadd(this.m);
            return res._forceRed(this);
        };
        Mont.prototype.invm = function invm(a) {
            var res = this.imod(a._invmp(this.m).mul(this.r2));
            return res._forceRed(this);
        };
    })(module, this);
});
parcelRegister("ejFGc", function(module, exports) {
    'use strict';
    var $6SLbO = parcelRequire("6SLbO");
    var $h9FlO = parcelRequire("h9FlO");
    var $gIBLw = parcelRequire("gIBLw");
    var $gcaJj = parcelRequire("gcaJj");
    var $fS6zE = parcelRequire("fS6zE");
    var $Wth4q = parcelRequire("Wth4q");
    var $a6c32bc236201271$require$Buffer = $Wth4q.Buffer;
    function $a6c32bc236201271$var$decrypt(data, password) {
        var salt = data.algorithm.decrypt.kde.kdeparams.salt;
        var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
        var algo = $h9FlO[data.algorithm.decrypt.cipher.algo.join('.')];
        var iv = data.algorithm.decrypt.cipher.iv;
        var cipherText = data.subjectPrivateKey;
        var keylen = parseInt(algo.split('-')[1], 10) / 8;
        var key = $fS6zE.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
        var cipher = $gcaJj.createDecipheriv(algo, key, iv);
        var out = [];
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        return $a6c32bc236201271$require$Buffer.concat(out);
    }
    function $a6c32bc236201271$var$parseKeys(buffer) {
        var password;
        if (typeof buffer === 'object' && !$a6c32bc236201271$require$Buffer.isBuffer(buffer)) {
            password = buffer.passphrase;
            buffer = buffer.key;
        }
        if (typeof buffer === 'string') buffer = $a6c32bc236201271$require$Buffer.from(buffer);
        var stripped = $gIBLw(buffer, password);
        var type = stripped.tag;
        var data = stripped.data;
        var subtype, ndata;
        switch(type){
            case 'CERTIFICATE':
                ndata = $6SLbO.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
            case 'PUBLIC KEY':
                if (!ndata) ndata = $6SLbO.PublicKey.decode(data, 'der');
                subtype = ndata.algorithm.algorithm.join('.');
                switch(subtype){
                    case '1.2.840.113549.1.1.1':
                        return $6SLbO.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                    case '1.2.840.10045.2.1':
                        ndata.subjectPrivateKey = ndata.subjectPublicKey;
                        return {
                            type: 'ec',
                            data: ndata
                        };
                    case '1.2.840.10040.4.1':
                        ndata.algorithm.params.pub_key = $6SLbO.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                        return {
                            type: 'dsa',
                            data: ndata.algorithm.params
                        };
                    default:
                        throw new Error('unknown key id ' + subtype);
                }
            case 'ENCRYPTED PRIVATE KEY':
                data = $6SLbO.EncryptedPrivateKey.decode(data, 'der');
                data = $a6c32bc236201271$var$decrypt(data, password);
            case 'PRIVATE KEY':
                ndata = $6SLbO.PrivateKey.decode(data, 'der');
                subtype = ndata.algorithm.algorithm.join('.');
                switch(subtype){
                    case '1.2.840.113549.1.1.1':
                        return $6SLbO.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                    case '1.2.840.10045.2.1':
                        return {
                            curve: ndata.algorithm.curve,
                            privateKey: $6SLbO.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                        };
                    case '1.2.840.10040.4.1':
                        ndata.algorithm.params.priv_key = $6SLbO.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                        return {
                            type: 'dsa',
                            params: ndata.algorithm.params
                        };
                    default:
                        throw new Error('unknown key id ' + subtype);
                }
            case 'RSA PUBLIC KEY':
                return $6SLbO.RSAPublicKey.decode(data, 'der');
            case 'RSA PRIVATE KEY':
                return $6SLbO.RSAPrivateKey.decode(data, 'der');
            case 'DSA PRIVATE KEY':
                return {
                    type: 'dsa',
                    params: $6SLbO.DSAPrivateKey.decode(data, 'der')
                };
            case 'EC PRIVATE KEY':
                data = $6SLbO.ECPrivateKey.decode(data, 'der');
                return {
                    curve: data.parameters.value,
                    privateKey: data.privateKey
                };
            default:
                throw new Error('unknown key type ' + type);
        }
    }
    $a6c32bc236201271$var$parseKeys.signature = $6SLbO.signature;
    module.exports = $a6c32bc236201271$var$parseKeys;
});
parcelRegister("6SLbO", function(module, exports) {
    $parcel$export(module.exports, "certificate", ()=>$502c641ac9e0adc8$export$c98397a6eb8d0678, (v)=>$502c641ac9e0adc8$export$c98397a6eb8d0678 = v);
    $parcel$export(module.exports, "RSAPrivateKey", ()=>$502c641ac9e0adc8$export$f4aab6816f64fa6b, (v)=>$502c641ac9e0adc8$export$f4aab6816f64fa6b = v);
    $parcel$export(module.exports, "RSAPublicKey", ()=>$502c641ac9e0adc8$export$4471f5c65d097c11, (v)=>$502c641ac9e0adc8$export$4471f5c65d097c11 = v);
    $parcel$export(module.exports, "PublicKey", ()=>$502c641ac9e0adc8$export$ca8b6604d6ce14de, (v)=>$502c641ac9e0adc8$export$ca8b6604d6ce14de = v);
    $parcel$export(module.exports, "PrivateKey", ()=>$502c641ac9e0adc8$export$8f54525b330fd87b, (v)=>$502c641ac9e0adc8$export$8f54525b330fd87b = v);
    $parcel$export(module.exports, "EncryptedPrivateKey", ()=>$502c641ac9e0adc8$export$23cd2842b44ca3e7, (v)=>$502c641ac9e0adc8$export$23cd2842b44ca3e7 = v);
    $parcel$export(module.exports, "DSAPrivateKey", ()=>$502c641ac9e0adc8$export$245c9aaa9f5ce4ce, (v)=>$502c641ac9e0adc8$export$245c9aaa9f5ce4ce = v);
    $parcel$export(module.exports, "DSAparam", ()=>$502c641ac9e0adc8$export$8ad762e3e6399afe, (v)=>$502c641ac9e0adc8$export$8ad762e3e6399afe = v);
    $parcel$export(module.exports, "ECPrivateKey", ()=>$502c641ac9e0adc8$export$32ef6f92e22c6ab0, (v)=>$502c641ac9e0adc8$export$32ef6f92e22c6ab0 = v);
    $parcel$export(module.exports, "signature", ()=>$502c641ac9e0adc8$export$c9cd164b539ebb63, (v)=>$502c641ac9e0adc8$export$c9cd164b539ebb63 = v);
    var $502c641ac9e0adc8$export$c98397a6eb8d0678;
    var $502c641ac9e0adc8$export$f4aab6816f64fa6b;
    var $502c641ac9e0adc8$export$4471f5c65d097c11;
    var $502c641ac9e0adc8$export$ca8b6604d6ce14de;
    var $502c641ac9e0adc8$export$8f54525b330fd87b;
    var $502c641ac9e0adc8$export$23cd2842b44ca3e7;
    var $502c641ac9e0adc8$export$245c9aaa9f5ce4ce;
    var $502c641ac9e0adc8$export$8ad762e3e6399afe;
    var $502c641ac9e0adc8$export$32ef6f92e22c6ab0;
    var $502c641ac9e0adc8$export$c9cd164b539ebb63;
    'use strict';
    var $4YrAW = parcelRequire("4YrAW");
    $502c641ac9e0adc8$export$c98397a6eb8d0678 = (parcelRequire("eqV2A"));
    var $502c641ac9e0adc8$var$RSAPrivateKey = $4YrAW.define('RSAPrivateKey', function() {
        this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
    });
    $502c641ac9e0adc8$export$f4aab6816f64fa6b = $502c641ac9e0adc8$var$RSAPrivateKey;
    var $502c641ac9e0adc8$var$RSAPublicKey = $4YrAW.define('RSAPublicKey', function() {
        this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
    });
    $502c641ac9e0adc8$export$4471f5c65d097c11 = $502c641ac9e0adc8$var$RSAPublicKey;
    var $502c641ac9e0adc8$var$AlgorithmIdentifier = $4YrAW.define('AlgorithmIdentifier', function() {
        this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
    });
    var $502c641ac9e0adc8$var$PublicKey = $4YrAW.define('SubjectPublicKeyInfo', function() {
        this.seq().obj(this.key('algorithm').use($502c641ac9e0adc8$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
    });
    $502c641ac9e0adc8$export$ca8b6604d6ce14de = $502c641ac9e0adc8$var$PublicKey;
    var $502c641ac9e0adc8$var$PrivateKeyInfo = $4YrAW.define('PrivateKeyInfo', function() {
        this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($502c641ac9e0adc8$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
    });
    $502c641ac9e0adc8$export$8f54525b330fd87b = $502c641ac9e0adc8$var$PrivateKeyInfo;
    var $502c641ac9e0adc8$var$EncryptedPrivateKeyInfo = $4YrAW.define('EncryptedPrivateKeyInfo', function() {
        this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
    });
    $502c641ac9e0adc8$export$23cd2842b44ca3e7 = $502c641ac9e0adc8$var$EncryptedPrivateKeyInfo;
    var $502c641ac9e0adc8$var$DSAPrivateKey = $4YrAW.define('DSAPrivateKey', function() {
        this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
    });
    $502c641ac9e0adc8$export$245c9aaa9f5ce4ce = $502c641ac9e0adc8$var$DSAPrivateKey;
    $502c641ac9e0adc8$export$8ad762e3e6399afe = $4YrAW.define('DSAparam', function() {
        this['int']();
    });
    var $502c641ac9e0adc8$var$ECParameters = $4YrAW.define('ECParameters', function() {
        this.choice({
            namedCurve: this.objid()
        });
    });
    var $502c641ac9e0adc8$var$ECPrivateKey = $4YrAW.define('ECPrivateKey', function() {
        this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($502c641ac9e0adc8$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
    });
    $502c641ac9e0adc8$export$32ef6f92e22c6ab0 = $502c641ac9e0adc8$var$ECPrivateKey;
    $502c641ac9e0adc8$export$c9cd164b539ebb63 = $4YrAW.define('signature', function() {
        this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
    });
});
parcelRegister("4YrAW", function(module, exports) {
    var $39f22bc6452e58d0$var$asn1 = module.exports;
    $39f22bc6452e58d0$var$asn1.bignum = (parcelRequire("9pbIC"));
    $39f22bc6452e58d0$var$asn1.define = (parcelRequire("ceLSt")).define;
    $39f22bc6452e58d0$var$asn1.base = (parcelRequire("7pROP"));
    $39f22bc6452e58d0$var$asn1.constants = (parcelRequire("9Gn7M"));
    $39f22bc6452e58d0$var$asn1.decoders = (parcelRequire("jgiMU"));
    $39f22bc6452e58d0$var$asn1.encoders = (parcelRequire("4mVZW"));
});
parcelRegister("ceLSt", function(module, exports) {
    var $4YrAW = parcelRequire("4YrAW");
    var $v3bBu = parcelRequire("v3bBu");
    var $8e8bee50c1965a65$var$api = module.exports;
    $8e8bee50c1965a65$var$api.define = function define(name, body) {
        return new $8e8bee50c1965a65$var$Entity(name, body);
    };
    function $8e8bee50c1965a65$var$Entity(name, body) {
        this.name = name;
        this.body = body;
        this.decoders = {};
        this.encoders = {};
    }
    $8e8bee50c1965a65$var$Entity.prototype._createNamed = function createNamed(base) {
        var named;
        try {
            named = (parcelRequire("203s9")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
        } catch (e) {
            named = function(entity) {
                this._initNamed(entity);
            };
        }
        $v3bBu(named, base);
        named.prototype._initNamed = function initnamed(entity) {
            base.call(this, entity);
        };
        return new named(this);
    };
    $8e8bee50c1965a65$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
        enc = enc || 'der';
        if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($4YrAW.decoders[enc]);
        return this.decoders[enc];
    };
    $8e8bee50c1965a65$var$Entity.prototype.decode = function decode(data, enc, options) {
        return this._getDecoder(enc).decode(data, options);
    };
    $8e8bee50c1965a65$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
        enc = enc || 'der';
        if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($4YrAW.encoders[enc]);
        return this.encoders[enc];
    };
    $8e8bee50c1965a65$var$Entity.prototype.encode = function encode(data, enc, reporter) {
        return this._getEncoder(enc).encode(data, reporter);
    };
});
parcelRegister("203s9", function(module, exports) {
    var indexOf = function(xs, item) {
        if (xs.indexOf) return xs.indexOf(item);
        else for(var i = 0; i < xs.length; i++){
            if (xs[i] === item) return i;
        }
        return -1;
    };
    var Object_keys = function(obj) {
        if (Object.keys) return Object.keys(obj);
        else {
            var res = [];
            for(var key in obj)res.push(key);
            return res;
        }
    };
    var forEach = function(xs, fn) {
        if (xs.forEach) return xs.forEach(fn);
        else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
    };
    var defineProp = function() {
        try {
            Object.defineProperty({}, '_', {});
            return function(obj, name, value) {
                Object.defineProperty(obj, name, {
                    writable: true,
                    enumerable: false,
                    configurable: true,
                    value: value
                });
            };
        } catch (e) {
            return function(obj, name, value) {
                obj[name] = value;
            };
        }
    }();
    var globals = [
        'Array',
        'Boolean',
        'Date',
        'Error',
        'EvalError',
        'Function',
        'Infinity',
        'JSON',
        'Math',
        'NaN',
        'Number',
        'Object',
        'RangeError',
        'ReferenceError',
        'RegExp',
        'String',
        'SyntaxError',
        'TypeError',
        'URIError',
        'decodeURI',
        'decodeURIComponent',
        'encodeURI',
        'encodeURIComponent',
        'escape',
        'eval',
        'isFinite',
        'isNaN',
        'parseFloat',
        'parseInt',
        'undefined',
        'unescape'
    ];
    function Context() {}
    Context.prototype = {};
    var Script = exports.Script = function NodeScript(code) {
        if (!(this instanceof Script)) return new Script(code);
        this.code = code;
    };
    Script.prototype.runInContext = function(context) {
        if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
        var iframe = document.createElement('iframe');
        if (!iframe.style) iframe.style = {};
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        var win = iframe.contentWindow;
        var wEval = win.eval, wExecScript = win.execScript;
        if (!wEval && wExecScript) {
            wExecScript.call(win, 'null');
            wEval = win.eval;
        }
        forEach(Object_keys(context), function(key) {
            win[key] = context[key];
        });
        forEach(globals, function(key) {
            if (context[key]) win[key] = context[key];
        });
        var winKeys = Object_keys(win);
        var res = wEval.call(win, this.code);
        forEach(Object_keys(win), function(key) {
            if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
        });
        forEach(globals, function(key) {
            if (!(key in context)) defineProp(context, key, win[key]);
        });
        document.body.removeChild(iframe);
        return res;
    };
    Script.prototype.runInThisContext = function() {
        return eval(this.code);
    };
    Script.prototype.runInNewContext = function(context) {
        var ctx = Script.createContext(context);
        var res = this.runInContext(ctx);
        if (context) forEach(Object_keys(ctx), function(key) {
            context[key] = ctx[key];
        });
        return res;
    };
    forEach(Object_keys(Script.prototype), function(name) {
        exports[name] = Script[name] = function(code) {
            var s = Script(code);
            return s[name].apply(s, [].slice.call(arguments, 1));
        };
    });
    exports.isContext = function(context) {
        return context instanceof Context;
    };
    exports.createScript = function(code) {
        return exports.Script(code);
    };
    exports.createContext = Script.createContext = function(context) {
        var copy = new Context();
        if (typeof context === 'object') forEach(Object_keys(context), function(key) {
            copy[key] = context[key];
        });
        return copy;
    };
});
parcelRegister("7pROP", function(module, exports) {
    var $56649d7a438b1476$var$base = module.exports;
    $56649d7a438b1476$var$base.Reporter = (parcelRequire("9Mcka")).Reporter;
    $56649d7a438b1476$var$base.DecoderBuffer = (parcelRequire("8BbkO")).DecoderBuffer;
    $56649d7a438b1476$var$base.EncoderBuffer = (parcelRequire("8BbkO")).EncoderBuffer;
    $56649d7a438b1476$var$base.Node = (parcelRequire("8pyk3"));
});
parcelRegister("9Mcka", function(module, exports) {
    $parcel$export(module.exports, "Reporter", ()=>$71e22815ba47f766$export$957313a2f485e5ed, (v)=>$71e22815ba47f766$export$957313a2f485e5ed = v);
    var $71e22815ba47f766$export$957313a2f485e5ed;
    var $v3bBu = parcelRequire("v3bBu");
    function $71e22815ba47f766$var$Reporter(options) {
        this._reporterState = {
            obj: null,
            path: [],
            options: options || {},
            errors: []
        };
    }
    $71e22815ba47f766$export$957313a2f485e5ed = $71e22815ba47f766$var$Reporter;
    $71e22815ba47f766$var$Reporter.prototype.isError = function isError(obj) {
        return obj instanceof $71e22815ba47f766$var$ReporterError;
    };
    $71e22815ba47f766$var$Reporter.prototype.save = function save() {
        var state = this._reporterState;
        return {
            obj: state.obj,
            pathLen: state.path.length
        };
    };
    $71e22815ba47f766$var$Reporter.prototype.restore = function restore(data) {
        var state = this._reporterState;
        state.obj = data.obj;
        state.path = state.path.slice(0, data.pathLen);
    };
    $71e22815ba47f766$var$Reporter.prototype.enterKey = function enterKey(key) {
        return this._reporterState.path.push(key);
    };
    $71e22815ba47f766$var$Reporter.prototype.exitKey = function exitKey(index) {
        var state = this._reporterState;
        state.path = state.path.slice(0, index - 1);
    };
    $71e22815ba47f766$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
        var state = this._reporterState;
        this.exitKey(index);
        if (state.obj !== null) state.obj[key] = value;
    };
    $71e22815ba47f766$var$Reporter.prototype.path = function path() {
        return this._reporterState.path.join('/');
    };
    $71e22815ba47f766$var$Reporter.prototype.enterObject = function enterObject() {
        var state = this._reporterState;
        var prev = state.obj;
        state.obj = {};
        return prev;
    };
    $71e22815ba47f766$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
        var state = this._reporterState;
        var now = state.obj;
        state.obj = prev;
        return now;
    };
    $71e22815ba47f766$var$Reporter.prototype.error = function error(msg) {
        var err;
        var state = this._reporterState;
        var inherited = msg instanceof $71e22815ba47f766$var$ReporterError;
        if (inherited) err = msg;
        else err = new $71e22815ba47f766$var$ReporterError(state.path.map(function(elem) {
            return '[' + JSON.stringify(elem) + ']';
        }).join(''), msg.message || msg, msg.stack);
        if (!state.options.partial) throw err;
        if (!inherited) state.errors.push(err);
        return err;
    };
    $71e22815ba47f766$var$Reporter.prototype.wrapResult = function wrapResult(result) {
        var state = this._reporterState;
        if (!state.options.partial) return result;
        return {
            result: this.isError(result) ? null : result,
            errors: state.errors
        };
    };
    function $71e22815ba47f766$var$ReporterError(path, msg) {
        this.path = path;
        this.rethrow(msg);
    }
    $v3bBu($71e22815ba47f766$var$ReporterError, Error);
    $71e22815ba47f766$var$ReporterError.prototype.rethrow = function rethrow(msg) {
        this.message = msg + ' at: ' + (this.path || '(shallow)');
        if (Error.captureStackTrace) Error.captureStackTrace(this, $71e22815ba47f766$var$ReporterError);
        if (!this.stack) try {
            throw new Error(this.message);
        } catch (e) {
            this.stack = e.stack;
        }
        return this;
    };
});
parcelRegister("8BbkO", function(module, exports) {
    $parcel$export(module.exports, "DecoderBuffer", ()=>$642a923f98967a64$export$bf9f79cdc4a49163, (v)=>$642a923f98967a64$export$bf9f79cdc4a49163 = v);
    $parcel$export(module.exports, "EncoderBuffer", ()=>$642a923f98967a64$export$8ff24f7760c7a78e, (v)=>$642a923f98967a64$export$8ff24f7760c7a78e = v);
    var $642a923f98967a64$export$bf9f79cdc4a49163;
    var $642a923f98967a64$export$8ff24f7760c7a78e;
    var $v3bBu = parcelRequire("v3bBu");
    var $7pROP = parcelRequire("7pROP");
    var $642a923f98967a64$require$Reporter = $7pROP.Reporter;
    var $5k7LC = parcelRequire("5k7LC");
    var $642a923f98967a64$require$Buffer = $5k7LC.Buffer;
    function $642a923f98967a64$var$DecoderBuffer(base, options) {
        $642a923f98967a64$require$Reporter.call(this, options);
        if (!$642a923f98967a64$require$Buffer.isBuffer(base)) {
            this.error('Input not Buffer');
            return;
        }
        this.base = base;
        this.offset = 0;
        this.length = base.length;
    }
    $v3bBu($642a923f98967a64$var$DecoderBuffer, $642a923f98967a64$require$Reporter);
    $642a923f98967a64$export$bf9f79cdc4a49163 = $642a923f98967a64$var$DecoderBuffer;
    $642a923f98967a64$var$DecoderBuffer.prototype.save = function save() {
        return {
            offset: this.offset,
            reporter: $642a923f98967a64$require$Reporter.prototype.save.call(this)
        };
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.restore = function restore(save) {
        var res = new $642a923f98967a64$var$DecoderBuffer(this.base);
        res.offset = save.offset;
        res.length = this.offset;
        this.offset = save.offset;
        $642a923f98967a64$require$Reporter.prototype.restore.call(this, save.reporter);
        return res;
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
        return this.offset === this.length;
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
        if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
        else return this.error(fail || 'DecoderBuffer overrun');
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
        if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
        var res = new $642a923f98967a64$var$DecoderBuffer(this.base);
        res._reporterState = this._reporterState;
        res.offset = this.offset;
        res.length = this.offset + bytes;
        this.offset += bytes;
        return res;
    };
    $642a923f98967a64$var$DecoderBuffer.prototype.raw = function raw(save) {
        return this.base.slice(save ? save.offset : this.offset, this.length);
    };
    function $642a923f98967a64$var$EncoderBuffer(value, reporter) {
        if (Array.isArray(value)) {
            this.length = 0;
            this.value = value.map(function(item) {
                if (!(item instanceof $642a923f98967a64$var$EncoderBuffer)) item = new $642a923f98967a64$var$EncoderBuffer(item, reporter);
                this.length += item.length;
                return item;
            }, this);
        } else if (typeof value === 'number') {
            if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
            this.value = value;
            this.length = 1;
        } else if (typeof value === 'string') {
            this.value = value;
            this.length = $642a923f98967a64$require$Buffer.byteLength(value);
        } else if ($642a923f98967a64$require$Buffer.isBuffer(value)) {
            this.value = value;
            this.length = value.length;
        } else return reporter.error('Unsupported type: ' + typeof value);
    }
    $642a923f98967a64$export$8ff24f7760c7a78e = $642a923f98967a64$var$EncoderBuffer;
    $642a923f98967a64$var$EncoderBuffer.prototype.join = function join(out, offset) {
        if (!out) out = new $642a923f98967a64$require$Buffer(this.length);
        if (!offset) offset = 0;
        if (this.length === 0) return out;
        if (Array.isArray(this.value)) this.value.forEach(function(item) {
            item.join(out, offset);
            offset += item.length;
        });
        else {
            if (typeof this.value === 'number') out[offset] = this.value;
            else if (typeof this.value === 'string') out.write(this.value, offset);
            else if ($642a923f98967a64$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
            offset += this.length;
        }
        return out;
    };
});
parcelRegister("8pyk3", function(module, exports) {
    var $7pROP = parcelRequire("7pROP");
    var $61fb48423d223fb4$require$Reporter = $7pROP.Reporter;
    var $7pROP = parcelRequire("7pROP");
    var $61fb48423d223fb4$require$EncoderBuffer = $7pROP.EncoderBuffer;
    var $7pROP = parcelRequire("7pROP");
    var $61fb48423d223fb4$require$DecoderBuffer = $7pROP.DecoderBuffer;
    var $gxaFy = parcelRequire("gxaFy");
    var $61fb48423d223fb4$var$tags = [
        'seq',
        'seqof',
        'set',
        'setof',
        'objid',
        'bool',
        'gentime',
        'utctime',
        'null_',
        'enum',
        'int',
        'objDesc',
        'bitstr',
        'bmpstr',
        'charstr',
        'genstr',
        'graphstr',
        'ia5str',
        'iso646str',
        'numstr',
        'octstr',
        'printstr',
        't61str',
        'unistr',
        'utf8str',
        'videostr'
    ];
    var $61fb48423d223fb4$var$methods = [
        'key',
        'obj',
        'use',
        'optional',
        'explicit',
        'implicit',
        'def',
        'choice',
        'any',
        'contains'
    ].concat($61fb48423d223fb4$var$tags);
    var $61fb48423d223fb4$var$overrided = [
        '_peekTag',
        '_decodeTag',
        '_use',
        '_decodeStr',
        '_decodeObjid',
        '_decodeTime',
        '_decodeNull',
        '_decodeInt',
        '_decodeBool',
        '_decodeList',
        '_encodeComposite',
        '_encodeStr',
        '_encodeObjid',
        '_encodeTime',
        '_encodeNull',
        '_encodeInt',
        '_encodeBool'
    ];
    function $61fb48423d223fb4$var$Node(enc, parent) {
        var state = {};
        this._baseState = state;
        state.enc = enc;
        state.parent = parent || null;
        state.children = null;
        state.tag = null;
        state.args = null;
        state.reverseArgs = null;
        state.choice = null;
        state.optional = false;
        state.any = false;
        state.obj = false;
        state.use = null;
        state.useDecoder = null;
        state.key = null;
        state['default'] = null;
        state.explicit = null;
        state.implicit = null;
        state.contains = null;
        if (!state.parent) {
            state.children = [];
            this._wrap();
        }
    }
    module.exports = $61fb48423d223fb4$var$Node;
    var $61fb48423d223fb4$var$stateProps = [
        'enc',
        'parent',
        'children',
        'tag',
        'args',
        'reverseArgs',
        'choice',
        'optional',
        'any',
        'obj',
        'use',
        'alteredUse',
        'key',
        'default',
        'explicit',
        'implicit',
        'contains'
    ];
    $61fb48423d223fb4$var$Node.prototype.clone = function clone() {
        var state = this._baseState;
        var cstate = {};
        $61fb48423d223fb4$var$stateProps.forEach(function(prop) {
            cstate[prop] = state[prop];
        });
        var res = new this.constructor(cstate.parent);
        res._baseState = cstate;
        return res;
    };
    $61fb48423d223fb4$var$Node.prototype._wrap = function wrap() {
        var state = this._baseState;
        $61fb48423d223fb4$var$methods.forEach(function(method) {
            this[method] = function _wrappedMethod() {
                var clone = new this.constructor(this);
                state.children.push(clone);
                return clone[method].apply(clone, arguments);
            };
        }, this);
    };
    $61fb48423d223fb4$var$Node.prototype._init = function init(body) {
        var state = this._baseState;
        $gxaFy(state.parent === null);
        body.call(this);
        state.children = state.children.filter(function(child) {
            return child._baseState.parent === this;
        }, this);
        $gxaFy.equal(state.children.length, 1, 'Root node can have only one child');
    };
    $61fb48423d223fb4$var$Node.prototype._useArgs = function useArgs(args) {
        var state = this._baseState;
        var children = args.filter(function(arg) {
            return arg instanceof this.constructor;
        }, this);
        args = args.filter(function(arg) {
            return !(arg instanceof this.constructor);
        }, this);
        if (children.length !== 0) {
            $gxaFy(state.children === null);
            state.children = children;
            children.forEach(function(child) {
                child._baseState.parent = this;
            }, this);
        }
        if (args.length !== 0) {
            $gxaFy(state.args === null);
            state.args = args;
            state.reverseArgs = args.map(function(arg) {
                if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
                var res = {};
                Object.keys(arg).forEach(function(key) {
                    if (key == (key | 0)) key |= 0;
                    var value = arg[key];
                    res[value] = key;
                });
                return res;
            });
        }
    };
    $61fb48423d223fb4$var$overrided.forEach(function(method) {
        $61fb48423d223fb4$var$Node.prototype[method] = function _overrided() {
            var state = this._baseState;
            throw new Error(method + ' not implemented for encoding: ' + state.enc);
        };
    });
    $61fb48423d223fb4$var$tags.forEach(function(tag) {
        $61fb48423d223fb4$var$Node.prototype[tag] = function _tagMethod() {
            var state = this._baseState;
            var args = Array.prototype.slice.call(arguments);
            $gxaFy(state.tag === null);
            state.tag = tag;
            this._useArgs(args);
            return this;
        };
    });
    $61fb48423d223fb4$var$Node.prototype.use = function use(item) {
        $gxaFy(item);
        var state = this._baseState;
        $gxaFy(state.use === null);
        state.use = item;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.optional = function optional() {
        var state = this._baseState;
        state.optional = true;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.def = function def(val) {
        var state = this._baseState;
        $gxaFy(state['default'] === null);
        state['default'] = val;
        state.optional = true;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.explicit = function explicit(num) {
        var state = this._baseState;
        $gxaFy(state.explicit === null && state.implicit === null);
        state.explicit = num;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.implicit = function implicit(num) {
        var state = this._baseState;
        $gxaFy(state.explicit === null && state.implicit === null);
        state.implicit = num;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.obj = function obj() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        state.obj = true;
        if (args.length !== 0) this._useArgs(args);
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.key = function key(newKey) {
        var state = this._baseState;
        $gxaFy(state.key === null);
        state.key = newKey;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.any = function any() {
        var state = this._baseState;
        state.any = true;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.choice = function choice(obj) {
        var state = this._baseState;
        $gxaFy(state.choice === null);
        state.choice = obj;
        this._useArgs(Object.keys(obj).map(function(key) {
            return obj[key];
        }));
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype.contains = function contains(item) {
        var state = this._baseState;
        $gxaFy(state.use === null);
        state.contains = item;
        return this;
    };
    $61fb48423d223fb4$var$Node.prototype._decode = function decode(input, options) {
        var state = this._baseState;
        if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
        var result = state['default'];
        var present = true;
        var prevKey = null;
        if (state.key !== null) prevKey = input.enterKey(state.key);
        if (state.optional) {
            var tag = null;
            if (state.explicit !== null) tag = state.explicit;
            else if (state.implicit !== null) tag = state.implicit;
            else if (state.tag !== null) tag = state.tag;
            if (tag === null && !state.any) {
                var save = input.save();
                try {
                    if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                    else this._decodeChoice(input, options);
                    present = true;
                } catch (e) {
                    present = false;
                }
                input.restore(save);
            } else {
                present = this._peekTag(input, tag, state.any);
                if (input.isError(present)) return present;
            }
        }
        var prevObj;
        if (state.obj && present) prevObj = input.enterObject();
        if (present) {
            if (state.explicit !== null) {
                var explicit = this._decodeTag(input, state.explicit);
                if (input.isError(explicit)) return explicit;
                input = explicit;
            }
            var start = input.offset;
            if (state.use === null && state.choice === null) {
                if (state.any) var save = input.save();
                var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
                if (input.isError(body)) return body;
                if (state.any) result = input.raw(save);
                else input = body;
            }
            if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
            if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
            if (state.any) result;
            else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
            else result = this._decodeChoice(input, options);
            if (input.isError(result)) return result;
            if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
                child._decode(input, options);
            });
            if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
                var data = new $61fb48423d223fb4$require$DecoderBuffer(result);
                result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
            }
        }
        if (state.obj && present) result = input.leaveObject(prevObj);
        if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
        else if (prevKey !== null) input.exitKey(prevKey);
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
        var state = this._baseState;
        if (tag === 'seq' || tag === 'set') return null;
        if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
        else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
        else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
        else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
        else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
        else if (tag === 'null_') return this._decodeNull(input, options);
        else if (tag === 'bool') return this._decodeBool(input, options);
        else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
        else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
        if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
        else return input.error('unknown tag: ' + tag);
    };
    $61fb48423d223fb4$var$Node.prototype._getUse = function _getUse(entity, obj) {
        var state = this._baseState;
        state.useDecoder = this._use(entity, obj);
        $gxaFy(state.useDecoder._baseState.parent === null);
        state.useDecoder = state.useDecoder._baseState.children[0];
        if (state.implicit !== state.useDecoder._baseState.implicit) {
            state.useDecoder = state.useDecoder.clone();
            state.useDecoder._baseState.implicit = state.implicit;
        }
        return state.useDecoder;
    };
    $61fb48423d223fb4$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
        var state = this._baseState;
        var result = null;
        var match = false;
        Object.keys(state.choice).some(function(key) {
            var save = input.save();
            var node = state.choice[key];
            try {
                var value = node._decode(input, options);
                if (input.isError(value)) return false;
                result = {
                    type: key,
                    value: value
                };
                match = true;
            } catch (e) {
                input.restore(save);
                return false;
            }
            return true;
        }, this);
        if (!match) return input.error('Choice not matched');
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
        return new $61fb48423d223fb4$require$EncoderBuffer(data, this.reporter);
    };
    $61fb48423d223fb4$var$Node.prototype._encode = function encode(data, reporter, parent) {
        var state = this._baseState;
        if (state['default'] !== null && state['default'] === data) return;
        var result = this._encodeValue(data, reporter, parent);
        if (result === undefined) return;
        if (this._skipDefault(result, reporter, parent)) return;
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
        var state = this._baseState;
        if (state.parent === null) return state.children[0]._encode(data, reporter || new $61fb48423d223fb4$require$Reporter());
        var result = null;
        this.reporter = reporter;
        if (state.optional && data === undefined) {
            if (state['default'] !== null) data = state['default'];
            else return;
        }
        var content = null;
        var primitive = false;
        if (state.any) result = this._createEncoderBuffer(data);
        else if (state.choice) result = this._encodeChoice(data, reporter);
        else if (state.contains) {
            content = this._getUse(state.contains, parent)._encode(data, reporter);
            primitive = true;
        } else if (state.children) {
            content = state.children.map(function(child) {
                if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
                if (child._baseState.key === null) return reporter.error('Child should have a key');
                var prevKey = reporter.enterKey(child._baseState.key);
                if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
                var res = child._encode(data[child._baseState.key], reporter, data);
                reporter.leaveKey(prevKey);
                return res;
            }, this).filter(function(child) {
                return child;
            });
            content = this._createEncoderBuffer(content);
        } else {
            if (state.tag === 'seqof' || state.tag === 'setof') {
                if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
                if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
                var child = this.clone();
                child._baseState.implicit = null;
                content = this._createEncoderBuffer(data.map(function(item) {
                    var state = this._baseState;
                    return this._getUse(state.args[0], data)._encode(item, reporter);
                }, child));
            } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
            else {
                content = this._encodePrimitive(state.tag, data);
                primitive = true;
            }
        }
        var result;
        if (!state.any && state.choice === null) {
            var tag = state.implicit !== null ? state.implicit : state.tag;
            var cls = state.implicit === null ? 'universal' : 'context';
            if (tag === null) {
                if (state.use === null) reporter.error('Tag could be omitted only for .use()');
            } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
        }
        if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
        return result;
    };
    $61fb48423d223fb4$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
        var state = this._baseState;
        var node = state.choice[data.type];
        if (!node) $gxaFy(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
        return node._encode(data.value, reporter);
    };
    $61fb48423d223fb4$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
        var state = this._baseState;
        if (/str$/.test(tag)) return this._encodeStr(data, tag);
        else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
        else if (tag === 'objid') return this._encodeObjid(data, null, null);
        else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
        else if (tag === 'null_') return this._encodeNull();
        else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
        else if (tag === 'bool') return this._encodeBool(data);
        else if (tag === 'objDesc') return this._encodeStr(data, tag);
        else throw new Error('Unsupported tag: ' + tag);
    };
    $61fb48423d223fb4$var$Node.prototype._isNumstr = function isNumstr(str) {
        return /^[0-9 ]*$/.test(str);
    };
    $61fb48423d223fb4$var$Node.prototype._isPrintstr = function isPrintstr(str) {
        return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
    };
});
parcelRegister("9Gn7M", function(module, exports) {
    var $70c9f95905a88f58$var$constants = module.exports;
    $70c9f95905a88f58$var$constants._reverse = function reverse(map) {
        var res = {};
        Object.keys(map).forEach(function(key) {
            if ((key | 0) == key) key = key | 0;
            var value = map[key];
            res[value] = key;
        });
        return res;
    };
    $70c9f95905a88f58$var$constants.der = (parcelRequire("lpBh5"));
});
parcelRegister("lpBh5", function(module, exports) {
    $parcel$export(module.exports, "tagClass", ()=>$f968d8c070be10cd$export$3584c46ed60baee8, (v)=>$f968d8c070be10cd$export$3584c46ed60baee8 = v);
    $parcel$export(module.exports, "tagClassByName", ()=>$f968d8c070be10cd$export$f18596ef8d632e49, (v)=>$f968d8c070be10cd$export$f18596ef8d632e49 = v);
    $parcel$export(module.exports, "tag", ()=>$f968d8c070be10cd$export$2b067c6666111485, (v)=>$f968d8c070be10cd$export$2b067c6666111485 = v);
    $parcel$export(module.exports, "tagByName", ()=>$f968d8c070be10cd$export$f17df38a421ab9e3, (v)=>$f968d8c070be10cd$export$f17df38a421ab9e3 = v);
    var $f968d8c070be10cd$export$3584c46ed60baee8;
    var $f968d8c070be10cd$export$f18596ef8d632e49;
    var $f968d8c070be10cd$export$2b067c6666111485;
    var $f968d8c070be10cd$export$f17df38a421ab9e3;
    var $9Gn7M = parcelRequire("9Gn7M");
    $f968d8c070be10cd$export$3584c46ed60baee8 = {
        0: 'universal',
        1: 'application',
        2: 'context',
        3: 'private'
    };
    $f968d8c070be10cd$export$f18596ef8d632e49 = $9Gn7M._reverse($f968d8c070be10cd$export$3584c46ed60baee8);
    $f968d8c070be10cd$export$2b067c6666111485 = {
        0x00: 'end',
        0x01: 'bool',
        0x02: 'int',
        0x03: 'bitstr',
        0x04: 'octstr',
        0x05: 'null_',
        0x06: 'objid',
        0x07: 'objDesc',
        0x08: 'external',
        0x09: 'real',
        0x0a: 'enum',
        0x0b: 'embed',
        0x0c: 'utf8str',
        0x0d: 'relativeOid',
        0x10: 'seq',
        0x11: 'set',
        0x12: 'numstr',
        0x13: 'printstr',
        0x14: 't61str',
        0x15: 'videostr',
        0x16: 'ia5str',
        0x17: 'utctime',
        0x18: 'gentime',
        0x19: 'graphstr',
        0x1a: 'iso646str',
        0x1b: 'genstr',
        0x1c: 'unistr',
        0x1d: 'charstr',
        0x1e: 'bmpstr'
    };
    $f968d8c070be10cd$export$f17df38a421ab9e3 = $9Gn7M._reverse($f968d8c070be10cd$export$2b067c6666111485);
});
parcelRegister("jgiMU", function(module, exports) {
    var $e05e15d54de3c556$var$decoders = module.exports;
    $e05e15d54de3c556$var$decoders.der = (parcelRequire("hhhbu"));
    $e05e15d54de3c556$var$decoders.pem = (parcelRequire("bSW3A"));
});
parcelRegister("hhhbu", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $4YrAW = parcelRequire("4YrAW");
    var $c9415aa2b27c8979$var$base = $4YrAW.base;
    var $c9415aa2b27c8979$var$bignum = $4YrAW.bignum;
    var $c9415aa2b27c8979$var$der = $4YrAW.constants.der;
    function $c9415aa2b27c8979$var$DERDecoder(entity) {
        this.enc = 'der';
        this.name = entity.name;
        this.entity = entity;
        this.tree = new $c9415aa2b27c8979$var$DERNode();
        this.tree._init(entity.body);
    }
    module.exports = $c9415aa2b27c8979$var$DERDecoder;
    $c9415aa2b27c8979$var$DERDecoder.prototype.decode = function decode(data, options) {
        if (!(data instanceof $c9415aa2b27c8979$var$base.DecoderBuffer)) data = new $c9415aa2b27c8979$var$base.DecoderBuffer(data, options);
        return this.tree._decode(data, options);
    };
    function $c9415aa2b27c8979$var$DERNode(parent) {
        $c9415aa2b27c8979$var$base.Node.call(this, 'der', parent);
    }
    $v3bBu($c9415aa2b27c8979$var$DERNode, $c9415aa2b27c8979$var$base.Node);
    $c9415aa2b27c8979$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
        if (buffer.isEmpty()) return false;
        var state = buffer.save();
        var decodedTag = $c9415aa2b27c8979$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
        if (buffer.isError(decodedTag)) return decodedTag;
        buffer.restore(state);
        return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
        var decodedTag = $c9415aa2b27c8979$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
        if (buffer.isError(decodedTag)) return decodedTag;
        var len = $c9415aa2b27c8979$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
        if (buffer.isError(len)) return len;
        if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
        if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
        var state = buffer.save();
        var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
        if (buffer.isError(res)) return res;
        len = buffer.offset - state.offset;
        buffer.restore(state);
        return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    };
    $c9415aa2b27c8979$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
        while(true){
            var tag = $c9415aa2b27c8979$var$derDecodeTag(buffer, fail);
            if (buffer.isError(tag)) return tag;
            var len = $c9415aa2b27c8979$var$derDecodeLen(buffer, tag.primitive, fail);
            if (buffer.isError(len)) return len;
            var res;
            if (tag.primitive || len !== null) res = buffer.skip(len);
            else res = this._skipUntilEnd(buffer, fail);
            if (buffer.isError(res)) return res;
            if (tag.tagStr === 'end') break;
        }
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
        var result = [];
        while(!buffer.isEmpty()){
            var possibleEnd = this._peekTag(buffer, 'end');
            if (buffer.isError(possibleEnd)) return possibleEnd;
            var res = decoder.decode(buffer, 'der', options);
            if (buffer.isError(res) && possibleEnd) break;
            result.push(res);
        }
        return result;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
        if (tag === 'bitstr') {
            var unused = buffer.readUInt8();
            if (buffer.isError(unused)) return unused;
            return {
                unused: unused,
                data: buffer.raw()
            };
        } else if (tag === 'bmpstr') {
            var raw = buffer.raw();
            if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
            var str = '';
            for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
            return str;
        } else if (tag === 'numstr') {
            var numstr = buffer.raw().toString('ascii');
            if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
            return numstr;
        } else if (tag === 'octstr') return buffer.raw();
        else if (tag === 'objDesc') return buffer.raw();
        else if (tag === 'printstr') {
            var printstr = buffer.raw().toString('ascii');
            if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
            return printstr;
        } else if (/str$/.test(tag)) return buffer.raw().toString();
        else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
        var result;
        var identifiers = [];
        var ident = 0;
        while(!buffer.isEmpty()){
            var subident = buffer.readUInt8();
            ident <<= 7;
            ident |= subident & 0x7f;
            if ((subident & 0x80) === 0) {
                identifiers.push(ident);
                ident = 0;
            }
        }
        if (subident & 0x80) identifiers.push(ident);
        var first = identifiers[0] / 40 | 0;
        var second = identifiers[0] % 40;
        if (relative) result = identifiers;
        else result = [
            first,
            second
        ].concat(identifiers.slice(1));
        if (values) {
            var tmp = values[result.join(' ')];
            if (tmp === undefined) tmp = values[result.join('.')];
            if (tmp !== undefined) result = tmp;
        }
        return result;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
        var str = buffer.raw().toString();
        if (tag === 'gentime') {
            var year = str.slice(0, 4) | 0;
            var mon = str.slice(4, 6) | 0;
            var day = str.slice(6, 8) | 0;
            var hour = str.slice(8, 10) | 0;
            var min = str.slice(10, 12) | 0;
            var sec = str.slice(12, 14) | 0;
        } else if (tag === 'utctime') {
            var year = str.slice(0, 2) | 0;
            var mon = str.slice(2, 4) | 0;
            var day = str.slice(4, 6) | 0;
            var hour = str.slice(6, 8) | 0;
            var min = str.slice(8, 10) | 0;
            var sec = str.slice(10, 12) | 0;
            if (year < 70) year = 2000 + year;
            else year = 1900 + year;
        } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
        return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
        return null;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
        var res = buffer.readUInt8();
        if (buffer.isError(res)) return res;
        else return res !== 0;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
        var raw = buffer.raw();
        var res = new $c9415aa2b27c8979$var$bignum(raw);
        if (values) res = values[res.toString(10)] || res;
        return res;
    };
    $c9415aa2b27c8979$var$DERNode.prototype._use = function use(entity, obj) {
        if (typeof entity === 'function') entity = entity(obj);
        return entity._getDecoder('der').tree;
    };
    function $c9415aa2b27c8979$var$derDecodeTag(buf, fail) {
        var tag = buf.readUInt8(fail);
        if (buf.isError(tag)) return tag;
        var cls = $c9415aa2b27c8979$var$der.tagClass[tag >> 6];
        var primitive = (tag & 0x20) === 0;
        if ((tag & 0x1f) === 0x1f) {
            var oct = tag;
            tag = 0;
            while((oct & 0x80) === 0x80){
                oct = buf.readUInt8(fail);
                if (buf.isError(oct)) return oct;
                tag <<= 7;
                tag |= oct & 0x7f;
            }
        } else tag &= 0x1f;
        var tagStr = $c9415aa2b27c8979$var$der.tag[tag];
        return {
            cls: cls,
            primitive: primitive,
            tag: tag,
            tagStr: tagStr
        };
    }
    function $c9415aa2b27c8979$var$derDecodeLen(buf, primitive, fail) {
        var len = buf.readUInt8(fail);
        if (buf.isError(len)) return len;
        if (!primitive && len === 0x80) return null;
        if ((len & 0x80) === 0) return len;
        var num = len & 0x7f;
        if (num > 4) return buf.error('length octect is too long');
        len = 0;
        for(var i = 0; i < num; i++){
            len <<= 8;
            var j = buf.readUInt8(fail);
            if (buf.isError(j)) return j;
            len |= j;
        }
        return len;
    }
});
parcelRegister("bSW3A", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $5k7LC = parcelRequire("5k7LC");
    var $8a71c5b853c3ea19$require$Buffer = $5k7LC.Buffer;
    var $hhhbu = parcelRequire("hhhbu");
    function $8a71c5b853c3ea19$var$PEMDecoder(entity) {
        $hhhbu.call(this, entity);
        this.enc = 'pem';
    }
    $v3bBu($8a71c5b853c3ea19$var$PEMDecoder, $hhhbu);
    module.exports = $8a71c5b853c3ea19$var$PEMDecoder;
    $8a71c5b853c3ea19$var$PEMDecoder.prototype.decode = function decode(data, options) {
        var lines = data.toString().split(/[\r\n]+/g);
        var label = options.label.toUpperCase();
        var re = /^-----(BEGIN|END) ([^-]+)-----$/;
        var start = -1;
        var end = -1;
        for(var i = 0; i < lines.length; i++){
            var match = lines[i].match(re);
            if (match === null) continue;
            if (match[2] !== label) continue;
            if (start === -1) {
                if (match[1] !== 'BEGIN') break;
                start = i;
            } else {
                if (match[1] !== 'END') break;
                end = i;
                break;
            }
        }
        if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
        var base64 = lines.slice(start + 1, end).join('');
        base64.replace(/[^a-z0-9\+\/=]+/gi, '');
        var input = new $8a71c5b853c3ea19$require$Buffer(base64, 'base64');
        return $hhhbu.prototype.decode.call(this, input, options);
    };
});
parcelRegister("4mVZW", function(module, exports) {
    var $32e634ba5c9f5903$var$encoders = module.exports;
    $32e634ba5c9f5903$var$encoders.der = (parcelRequire("7TTIj"));
    $32e634ba5c9f5903$var$encoders.pem = (parcelRequire("6IIig"));
});
parcelRegister("7TTIj", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $5k7LC = parcelRequire("5k7LC");
    var $5c08e30abebc6b49$require$Buffer = $5k7LC.Buffer;
    var $4YrAW = parcelRequire("4YrAW");
    var $5c08e30abebc6b49$var$base = $4YrAW.base;
    var $5c08e30abebc6b49$var$der = $4YrAW.constants.der;
    function $5c08e30abebc6b49$var$DEREncoder(entity) {
        this.enc = 'der';
        this.name = entity.name;
        this.entity = entity;
        this.tree = new $5c08e30abebc6b49$var$DERNode();
        this.tree._init(entity.body);
    }
    module.exports = $5c08e30abebc6b49$var$DEREncoder;
    $5c08e30abebc6b49$var$DEREncoder.prototype.encode = function encode(data, reporter) {
        return this.tree._encode(data, reporter).join();
    };
    function $5c08e30abebc6b49$var$DERNode(parent) {
        $5c08e30abebc6b49$var$base.Node.call(this, 'der', parent);
    }
    $v3bBu($5c08e30abebc6b49$var$DERNode, $5c08e30abebc6b49$var$base.Node);
    $5c08e30abebc6b49$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
        var encodedTag = $5c08e30abebc6b49$var$encodeTag(tag, primitive, cls, this.reporter);
        if (content.length < 0x80) {
            var header = new $5c08e30abebc6b49$require$Buffer(2);
            header[0] = encodedTag;
            header[1] = content.length;
            return this._createEncoderBuffer([
                header,
                content
            ]);
        }
        var lenOctets = 1;
        for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
        var header = new $5c08e30abebc6b49$require$Buffer(2 + lenOctets);
        header[0] = encodedTag;
        header[1] = 0x80 | lenOctets;
        for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
        if (tag === 'bitstr') return this._createEncoderBuffer([
            str.unused | 0,
            str.data
        ]);
        else if (tag === 'bmpstr') {
            var buf = new $5c08e30abebc6b49$require$Buffer(str.length * 2);
            for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
            return this._createEncoderBuffer(buf);
        } else if (tag === 'numstr') {
            if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
            return this._createEncoderBuffer(str);
        } else if (tag === 'printstr') {
            if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
            return this._createEncoderBuffer(str);
        } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
        else if (tag === 'objDesc') return this._createEncoderBuffer(str);
        else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
        if (typeof id === 'string') {
            if (!values) return this.reporter.error('string objid given, but no values map found');
            if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
            id = values[id].split(/[\s\.]+/g);
            for(var i = 0; i < id.length; i++)id[i] |= 0;
        } else if (Array.isArray(id)) {
            id = id.slice();
            for(var i = 0; i < id.length; i++)id[i] |= 0;
        }
        if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
        if (!relative) {
            if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
            id.splice(0, 2, id[0] * 40 + id[1]);
        }
        var size = 0;
        for(var i = 0; i < id.length; i++){
            var ident = id[i];
            for(size++; ident >= 0x80; ident >>= 7)size++;
        }
        var objid = new $5c08e30abebc6b49$require$Buffer(size);
        var offset = objid.length - 1;
        for(var i = id.length - 1; i >= 0; i--){
            var ident = id[i];
            objid[offset--] = ident & 0x7f;
            while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
        }
        return this._createEncoderBuffer(objid);
    };
    function $5c08e30abebc6b49$var$two(num) {
        if (num < 10) return '0' + num;
        else return num;
    }
    $5c08e30abebc6b49$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
        var str;
        var date = new Date(time);
        if (tag === 'gentime') str = [
            $5c08e30abebc6b49$var$two(date.getFullYear()),
            $5c08e30abebc6b49$var$two(date.getUTCMonth() + 1),
            $5c08e30abebc6b49$var$two(date.getUTCDate()),
            $5c08e30abebc6b49$var$two(date.getUTCHours()),
            $5c08e30abebc6b49$var$two(date.getUTCMinutes()),
            $5c08e30abebc6b49$var$two(date.getUTCSeconds()),
            'Z'
        ].join('');
        else if (tag === 'utctime') str = [
            $5c08e30abebc6b49$var$two(date.getFullYear() % 100),
            $5c08e30abebc6b49$var$two(date.getUTCMonth() + 1),
            $5c08e30abebc6b49$var$two(date.getUTCDate()),
            $5c08e30abebc6b49$var$two(date.getUTCHours()),
            $5c08e30abebc6b49$var$two(date.getUTCMinutes()),
            $5c08e30abebc6b49$var$two(date.getUTCSeconds()),
            'Z'
        ].join('');
        else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
        return this._encodeStr(str, 'octstr');
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeNull = function encodeNull() {
        return this._createEncoderBuffer('');
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
        if (typeof num === 'string') {
            if (!values) return this.reporter.error('String int or enum given, but no values map');
            if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
            num = values[num];
        }
        if (typeof num !== 'number' && !$5c08e30abebc6b49$require$Buffer.isBuffer(num)) {
            var numArray = num.toArray();
            if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
            num = new $5c08e30abebc6b49$require$Buffer(numArray);
        }
        if ($5c08e30abebc6b49$require$Buffer.isBuffer(num)) {
            var size = num.length;
            if (num.length === 0) size++;
            var out = new $5c08e30abebc6b49$require$Buffer(size);
            num.copy(out);
            if (num.length === 0) out[0] = 0;
            return this._createEncoderBuffer(out);
        }
        if (num < 0x80) return this._createEncoderBuffer(num);
        if (num < 0x100) return this._createEncoderBuffer([
            0,
            num
        ]);
        var size = 1;
        for(var i = num; i >= 0x100; i >>= 8)size++;
        var out = new Array(size);
        for(var i = out.length - 1; i >= 0; i--){
            out[i] = num & 0xff;
            num >>= 8;
        }
        if (out[0] & 0x80) out.unshift(0);
        return this._createEncoderBuffer(new $5c08e30abebc6b49$require$Buffer(out));
    };
    $5c08e30abebc6b49$var$DERNode.prototype._encodeBool = function encodeBool(value) {
        return this._createEncoderBuffer(value ? 0xff : 0);
    };
    $5c08e30abebc6b49$var$DERNode.prototype._use = function use(entity, obj) {
        if (typeof entity === 'function') entity = entity(obj);
        return entity._getEncoder('der').tree;
    };
    $5c08e30abebc6b49$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
        var state = this._baseState;
        var i;
        if (state['default'] === null) return false;
        var data = dataBuffer.join();
        if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
        if (data.length !== state.defaultBuffer.length) return false;
        for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
        return true;
    };
    function $5c08e30abebc6b49$var$encodeTag(tag, primitive, cls, reporter) {
        var res;
        if (tag === 'seqof') tag = 'seq';
        else if (tag === 'setof') tag = 'set';
        if ($5c08e30abebc6b49$var$der.tagByName.hasOwnProperty(tag)) res = $5c08e30abebc6b49$var$der.tagByName[tag];
        else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
        else return reporter.error('Unknown tag: ' + tag);
        if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
        if (!primitive) res |= 0x20;
        res |= $5c08e30abebc6b49$var$der.tagClassByName[cls || 'universal'] << 6;
        return res;
    }
});
parcelRegister("6IIig", function(module, exports) {
    var $v3bBu = parcelRequire("v3bBu");
    var $7TTIj = parcelRequire("7TTIj");
    function $4e4935f09ee49d47$var$PEMEncoder(entity) {
        $7TTIj.call(this, entity);
        this.enc = 'pem';
    }
    $v3bBu($4e4935f09ee49d47$var$PEMEncoder, $7TTIj);
    module.exports = $4e4935f09ee49d47$var$PEMEncoder;
    $4e4935f09ee49d47$var$PEMEncoder.prototype.encode = function encode(data, options) {
        var buf = $7TTIj.prototype.encode.call(this, data);
        var p = buf.toString('base64');
        var out = [
            '-----BEGIN ' + options.label + '-----'
        ];
        for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
        out.push('-----END ' + options.label + '-----');
        return out.join('\n');
    };
});
parcelRegister("eqV2A", function(module, exports) {
    'use strict';
    var $4YrAW = parcelRequire("4YrAW");
    var $a81fbd81d3c72dea$var$Time = $4YrAW.define('Time', function() {
        this.choice({
            utcTime: this.utctime(),
            generalTime: this.gentime()
        });
    });
    var $a81fbd81d3c72dea$var$AttributeTypeValue = $4YrAW.define('AttributeTypeValue', function() {
        this.seq().obj(this.key('type').objid(), this.key('value').any());
    });
    var $a81fbd81d3c72dea$var$AlgorithmIdentifier = $4YrAW.define('AlgorithmIdentifier', function() {
        this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
    });
    var $a81fbd81d3c72dea$var$SubjectPublicKeyInfo = $4YrAW.define('SubjectPublicKeyInfo', function() {
        this.seq().obj(this.key('algorithm').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
    });
    var $a81fbd81d3c72dea$var$RelativeDistinguishedName = $4YrAW.define('RelativeDistinguishedName', function() {
        this.setof($a81fbd81d3c72dea$var$AttributeTypeValue);
    });
    var $a81fbd81d3c72dea$var$RDNSequence = $4YrAW.define('RDNSequence', function() {
        this.seqof($a81fbd81d3c72dea$var$RelativeDistinguishedName);
    });
    var $a81fbd81d3c72dea$var$Name = $4YrAW.define('Name', function() {
        this.choice({
            rdnSequence: this.use($a81fbd81d3c72dea$var$RDNSequence)
        });
    });
    var $a81fbd81d3c72dea$var$Validity = $4YrAW.define('Validity', function() {
        this.seq().obj(this.key('notBefore').use($a81fbd81d3c72dea$var$Time), this.key('notAfter').use($a81fbd81d3c72dea$var$Time));
    });
    var $a81fbd81d3c72dea$var$Extension = $4YrAW.define('Extension', function() {
        this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
    });
    var $a81fbd81d3c72dea$var$TBSCertificate = $4YrAW.define('TBSCertificate', function() {
        this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('issuer').use($a81fbd81d3c72dea$var$Name), this.key('validity').use($a81fbd81d3c72dea$var$Validity), this.key('subject').use($a81fbd81d3c72dea$var$Name), this.key('subjectPublicKeyInfo').use($a81fbd81d3c72dea$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($a81fbd81d3c72dea$var$Extension).optional());
    });
    var $a81fbd81d3c72dea$var$X509Certificate = $4YrAW.define('X509Certificate', function() {
        this.seq().obj(this.key('tbsCertificate').use($a81fbd81d3c72dea$var$TBSCertificate), this.key('signatureAlgorithm').use($a81fbd81d3c72dea$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
    });
    module.exports = $a81fbd81d3c72dea$var$X509Certificate;
});
parcelRegister("h9FlO", function(module, exports) {
    module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");
});
parcelRegister("gIBLw", function(module, exports) {
    'use strict';
    var $c2be0cd28f0ce65b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
    var $c2be0cd28f0ce65b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
    var $c2be0cd28f0ce65b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;
    var $55KiC = parcelRequire("55KiC");
    var $gcaJj = parcelRequire("gcaJj");
    var $Wth4q = parcelRequire("Wth4q");
    var $c2be0cd28f0ce65b$require$Buffer = $Wth4q.Buffer;
    module.exports = function(okey, password) {
        var key = okey.toString();
        var match = key.match($c2be0cd28f0ce65b$var$findProc);
        var decrypted;
        if (!match) {
            var match2 = key.match($c2be0cd28f0ce65b$var$fullRegex);
            decrypted = $c2be0cd28f0ce65b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
        } else {
            var suite = 'aes' + match[1];
            var iv = $c2be0cd28f0ce65b$require$Buffer.from(match[2], 'hex');
            var cipherText = $c2be0cd28f0ce65b$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
            var cipherKey = $55KiC(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
            var out = [];
            var cipher = $gcaJj.createDecipheriv(suite, cipherKey, iv);
            out.push(cipher.update(cipherText));
            out.push(cipher['final']());
            decrypted = $c2be0cd28f0ce65b$require$Buffer.concat(out);
        }
        var tag = key.match($c2be0cd28f0ce65b$var$startRegex)[1];
        return {
            tag: tag,
            data: decrypted
        };
    };
});
parcelRegister("jf5f0", function(module, exports) {
    module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");
});
parcelRegister("1LYL6", function(module, exports) {
    'use strict';
    var $Wth4q = parcelRequire("Wth4q");
    var $14a94faaa2710991$require$Buffer = $Wth4q.Buffer;
    var $bxS53 = parcelRequire("bxS53");
    var $8JoQd = parcelRequire("8JoQd");
    var $14a94faaa2710991$require$EC = $8JoQd.ec;
    var $ejFGc = parcelRequire("ejFGc");
    var $jf5f0 = parcelRequire("jf5f0");
    function $14a94faaa2710991$var$verify(sig, hash, key, signType, tag) {
        var pub = $ejFGc(key);
        if (pub.type === 'ec') {
            if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
            return $14a94faaa2710991$var$ecVerify(sig, hash, pub);
        } else if (pub.type === 'dsa') {
            if (signType !== 'dsa') throw new Error('wrong public key type');
            return $14a94faaa2710991$var$dsaVerify(sig, hash, pub);
        }
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        hash = $14a94faaa2710991$require$Buffer.concat([
            tag,
            hash
        ]);
        var len = pub.modulus.byteLength();
        var pad = [
            1
        ];
        var padNum = 0;
        while(hash.length + pad.length + 2 < len){
            pad.push(0xff);
            padNum += 1;
        }
        pad.push(0x00);
        var i = -1;
        while(++i < hash.length)pad.push(hash[i]);
        pad = $14a94faaa2710991$require$Buffer.from(pad);
        var red = $bxS53.mont(pub.modulus);
        sig = new $bxS53(sig).toRed(red);
        sig = sig.redPow(new $bxS53(pub.publicExponent));
        sig = $14a94faaa2710991$require$Buffer.from(sig.fromRed().toArray());
        var out = padNum < 8 ? 1 : 0;
        len = Math.min(sig.length, pad.length);
        if (sig.length !== pad.length) out = 1;
        i = -1;
        while(++i < len)out |= sig[i] ^ pad[i];
        return out === 0;
    }
    function $14a94faaa2710991$var$ecVerify(sig, hash, pub) {
        var curveId = $jf5f0[pub.data.algorithm.curve.join('.')];
        if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
        var curve = new $14a94faaa2710991$require$EC(curveId);
        var pubkey = pub.data.subjectPrivateKey.data;
        return curve.verify(hash, sig, pubkey);
    }
    function $14a94faaa2710991$var$dsaVerify(sig, hash, pub) {
        var p = pub.data.p;
        var q = pub.data.q;
        var g = pub.data.g;
        var y = pub.data.pub_key;
        var unpacked = $ejFGc.signature.decode(sig, 'der');
        var s = unpacked.s;
        var r = unpacked.r;
        $14a94faaa2710991$var$checkValue(s, q);
        $14a94faaa2710991$var$checkValue(r, q);
        var montp = $bxS53.mont(p);
        var w = s.invm(q);
        var v = g.toRed(montp).redPow(new $bxS53(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
        return v.cmp(r) === 0;
    }
    function $14a94faaa2710991$var$checkValue(b, q) {
        if (b.cmpn(0) <= 0) throw new Error('invalid sig');
        if (b.cmp(q) >= 0) throw new Error('invalid sig');
    }
    module.exports = $14a94faaa2710991$var$verify;
});
parcelRegister("bsZLy", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $859238ac8a186043$require$Buffer = $5k7LC.Buffer;
    var $8JoQd = parcelRequire("8JoQd");
    var $9pbIC = parcelRequire("9pbIC");
    module.exports = function createECDH(curve) {
        return new $859238ac8a186043$var$ECDH(curve);
    };
    var $859238ac8a186043$var$aliases = {
        secp256k1: {
            name: 'secp256k1',
            byteLength: 32
        },
        secp224r1: {
            name: 'p224',
            byteLength: 28
        },
        prime256v1: {
            name: 'p256',
            byteLength: 32
        },
        prime192v1: {
            name: 'p192',
            byteLength: 24
        },
        ed25519: {
            name: 'ed25519',
            byteLength: 32
        },
        secp384r1: {
            name: 'p384',
            byteLength: 48
        },
        secp521r1: {
            name: 'p521',
            byteLength: 66
        }
    };
    $859238ac8a186043$var$aliases.p224 = $859238ac8a186043$var$aliases.secp224r1;
    $859238ac8a186043$var$aliases.p256 = $859238ac8a186043$var$aliases.secp256r1 = $859238ac8a186043$var$aliases.prime256v1;
    $859238ac8a186043$var$aliases.p192 = $859238ac8a186043$var$aliases.secp192r1 = $859238ac8a186043$var$aliases.prime192v1;
    $859238ac8a186043$var$aliases.p384 = $859238ac8a186043$var$aliases.secp384r1;
    $859238ac8a186043$var$aliases.p521 = $859238ac8a186043$var$aliases.secp521r1;
    function $859238ac8a186043$var$ECDH(curve) {
        this.curveType = $859238ac8a186043$var$aliases[curve];
        if (!this.curveType) this.curveType = {
            name: curve
        };
        this.curve = new $8JoQd.ec(this.curveType.name);
        this.keys = void 0;
    }
    $859238ac8a186043$var$ECDH.prototype.generateKeys = function(enc, format) {
        this.keys = this.curve.genKeyPair();
        return this.getPublicKey(enc, format);
    };
    $859238ac8a186043$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
        inenc = inenc || 'utf8';
        if (!$859238ac8a186043$require$Buffer.isBuffer(other)) other = new $859238ac8a186043$require$Buffer(other, inenc);
        var otherPub = this.curve.keyFromPublic(other).getPublic();
        var out = otherPub.mul(this.keys.getPrivate()).getX();
        return $859238ac8a186043$var$formatReturnValue(out, enc, this.curveType.byteLength);
    };
    $859238ac8a186043$var$ECDH.prototype.getPublicKey = function(enc, format) {
        var key = this.keys.getPublic(format === 'compressed', true);
        if (format === 'hybrid') {
            if (key[key.length - 1] % 2) key[0] = 7;
            else key[0] = 6;
        }
        return $859238ac8a186043$var$formatReturnValue(key, enc);
    };
    $859238ac8a186043$var$ECDH.prototype.getPrivateKey = function(enc) {
        return $859238ac8a186043$var$formatReturnValue(this.keys.getPrivate(), enc);
    };
    $859238ac8a186043$var$ECDH.prototype.setPublicKey = function(pub, enc) {
        enc = enc || 'utf8';
        if (!$859238ac8a186043$require$Buffer.isBuffer(pub)) pub = new $859238ac8a186043$require$Buffer(pub, enc);
        this.keys._importPublic(pub);
        return this;
    };
    $859238ac8a186043$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
        enc = enc || 'utf8';
        if (!$859238ac8a186043$require$Buffer.isBuffer(priv)) priv = new $859238ac8a186043$require$Buffer(priv, enc);
        var _priv = new $9pbIC(priv);
        _priv = _priv.toString(16);
        this.keys = this.curve.genKeyPair();
        this.keys._importPrivate(_priv);
        return this;
    };
    function $859238ac8a186043$var$formatReturnValue(bn, enc, len) {
        if (!Array.isArray(bn)) bn = bn.toArray();
        var buf = new $859238ac8a186043$require$Buffer(bn);
        if (len && buf.length < len) {
            var zeros = new $859238ac8a186043$require$Buffer(len - buf.length);
            zeros.fill(0);
            buf = $859238ac8a186043$require$Buffer.concat([
                zeros,
                buf
            ]);
        }
        if (!enc) return buf;
        else return buf.toString(enc);
    }
});
parcelRegister("bIasb", function(module, exports) {
    $parcel$export(module.exports, "publicEncrypt", ()=>$886be99faec3bef9$export$512823e338ddb1b7, (v)=>$886be99faec3bef9$export$512823e338ddb1b7 = v);
    $parcel$export(module.exports, "privateDecrypt", ()=>$886be99faec3bef9$export$7efb24e2fddf99b9, (v)=>$886be99faec3bef9$export$7efb24e2fddf99b9 = v);
    $parcel$export(module.exports, "privateEncrypt", ()=>$886be99faec3bef9$export$9d0e0c0c4a8d30f3, (v)=>$886be99faec3bef9$export$9d0e0c0c4a8d30f3 = v);
    $parcel$export(module.exports, "publicDecrypt", ()=>$886be99faec3bef9$export$b9d55ff329113abd, (v)=>$886be99faec3bef9$export$b9d55ff329113abd = v);
    var $886be99faec3bef9$export$512823e338ddb1b7;
    var $886be99faec3bef9$export$7efb24e2fddf99b9;
    var $886be99faec3bef9$export$9d0e0c0c4a8d30f3;
    var $886be99faec3bef9$export$b9d55ff329113abd;
    $886be99faec3bef9$export$512823e338ddb1b7 = (parcelRequire("fZDr0"));
    $886be99faec3bef9$export$7efb24e2fddf99b9 = (parcelRequire("3p2ND"));
    $886be99faec3bef9$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
        return $886be99faec3bef9$export$512823e338ddb1b7(key, buf, true);
    };
    $886be99faec3bef9$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
        return $886be99faec3bef9$export$7efb24e2fddf99b9(key, buf, true);
    };
});
parcelRegister("fZDr0", function(module, exports) {
    var $ejFGc = parcelRequire("ejFGc");
    var $1DyI6 = parcelRequire("1DyI6");
    var $7K4uY = parcelRequire("7K4uY");
    var $5g0NR = parcelRequire("5g0NR");
    var $ixBc1 = parcelRequire("ixBc1");
    var $9pbIC = parcelRequire("9pbIC");
    var $fr5TT = parcelRequire("fr5TT");
    var $cfrZu;
    var $Wth4q = parcelRequire("Wth4q");
    var $ba4b246a6106fed1$require$Buffer = $Wth4q.Buffer;
    module.exports = function publicEncrypt(publicKey, msg, reverse) {
        var padding;
        if (publicKey.padding) padding = publicKey.padding;
        else if (reverse) padding = 1;
        else padding = 4;
        var key = $ejFGc(publicKey);
        var paddedMsg;
        if (padding === 4) paddedMsg = $ba4b246a6106fed1$var$oaep(key, msg);
        else if (padding === 1) paddedMsg = $ba4b246a6106fed1$var$pkcs1(key, msg, reverse);
        else if (padding === 3) {
            paddedMsg = new $9pbIC(msg);
            if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
        } else throw new Error('unknown padding');
        if (reverse) return (0, parcelRequire("cfrZu"))(paddedMsg, key);
        else return $fr5TT(paddedMsg, key);
    };
    function $ba4b246a6106fed1$var$oaep(key, msg) {
        var k = key.modulus.byteLength();
        var mLen = msg.length;
        var iHash = $7K4uY('sha1').update($ba4b246a6106fed1$require$Buffer.alloc(0)).digest();
        var hLen = iHash.length;
        var hLen2 = 2 * hLen;
        if (mLen > k - hLen2 - 2) throw new Error('message too long');
        var ps = $ba4b246a6106fed1$require$Buffer.alloc(k - mLen - hLen2 - 2);
        var dblen = k - hLen - 1;
        var seed = $1DyI6(hLen);
        var maskedDb = $ixBc1($ba4b246a6106fed1$require$Buffer.concat([
            iHash,
            ps,
            $ba4b246a6106fed1$require$Buffer.alloc(1, 1),
            msg
        ], dblen), $5g0NR(seed, dblen));
        var maskedSeed = $ixBc1(seed, $5g0NR(maskedDb, hLen));
        return new $9pbIC($ba4b246a6106fed1$require$Buffer.concat([
            $ba4b246a6106fed1$require$Buffer.alloc(1),
            maskedSeed,
            maskedDb
        ], k));
    }
    function $ba4b246a6106fed1$var$pkcs1(key, msg, reverse) {
        var mLen = msg.length;
        var k = key.modulus.byteLength();
        if (mLen > k - 11) throw new Error('message too long');
        var ps;
        if (reverse) ps = $ba4b246a6106fed1$require$Buffer.alloc(k - mLen - 3, 0xff);
        else ps = $ba4b246a6106fed1$var$nonZero(k - mLen - 3);
        return new $9pbIC($ba4b246a6106fed1$require$Buffer.concat([
            $ba4b246a6106fed1$require$Buffer.from([
                0,
                reverse ? 1 : 2
            ]),
            ps,
            $ba4b246a6106fed1$require$Buffer.alloc(1),
            msg
        ], k));
    }
    function $ba4b246a6106fed1$var$nonZero(len) {
        var out = $ba4b246a6106fed1$require$Buffer.allocUnsafe(len);
        var i = 0;
        var cache = $1DyI6(len * 2);
        var cur = 0;
        var num;
        while(i < len){
            if (cur === cache.length) {
                cache = $1DyI6(len * 2);
                cur = 0;
            }
            num = cache[cur++];
            if (num) out[i++] = num;
        }
        return out;
    }
});
parcelRegister("5g0NR", function(module, exports) {
    var $7K4uY = parcelRequire("7K4uY");
    var $Wth4q = parcelRequire("Wth4q");
    var $3d3f11d98f131928$require$Buffer = $Wth4q.Buffer;
    module.exports = function(seed, len) {
        var t = $3d3f11d98f131928$require$Buffer.alloc(0);
        var i = 0;
        var c;
        while(t.length < len){
            c = $3d3f11d98f131928$var$i2ops(i++);
            t = $3d3f11d98f131928$require$Buffer.concat([
                t,
                $7K4uY('sha1').update(seed).update(c).digest()
            ]);
        }
        return t.slice(0, len);
    };
    function $3d3f11d98f131928$var$i2ops(c) {
        var out = $3d3f11d98f131928$require$Buffer.allocUnsafe(4);
        out.writeUInt32BE(c, 0);
        return out;
    }
});
parcelRegister("ixBc1", function(module, exports) {
    module.exports = function xor(a, b) {
        var len = a.length;
        var i = -1;
        while(++i < len)a[i] ^= b[i];
        return a;
    };
});
parcelRegister("fr5TT", function(module, exports) {
    var $9pbIC = parcelRequire("9pbIC");
    var $Wth4q = parcelRequire("Wth4q");
    var $b3cdf455bc7e4e8e$require$Buffer = $Wth4q.Buffer;
    function $b3cdf455bc7e4e8e$var$withPublic(paddedMsg, key) {
        return $b3cdf455bc7e4e8e$require$Buffer.from(paddedMsg.toRed($9pbIC.mont(key.modulus)).redPow(new $9pbIC(key.publicExponent)).fromRed().toArray());
    }
    module.exports = $b3cdf455bc7e4e8e$var$withPublic;
});
parcelRegister("3p2ND", function(module, exports) {
    var $ejFGc = parcelRequire("ejFGc");
    var $5g0NR = parcelRequire("5g0NR");
    var $ixBc1 = parcelRequire("ixBc1");
    var $9pbIC = parcelRequire("9pbIC");
    var $cfrZu;
    var $7K4uY = parcelRequire("7K4uY");
    var $fr5TT = parcelRequire("fr5TT");
    var $Wth4q = parcelRequire("Wth4q");
    var $27a5e0d2e6fe9775$require$Buffer = $Wth4q.Buffer;
    module.exports = function privateDecrypt(privateKey, enc, reverse) {
        var padding;
        if (privateKey.padding) padding = privateKey.padding;
        else if (reverse) padding = 1;
        else padding = 4;
        var key = $ejFGc(privateKey);
        var k = key.modulus.byteLength();
        if (enc.length > k || new $9pbIC(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
        var msg;
        if (reverse) msg = $fr5TT(new $9pbIC(enc), key);
        else msg = (0, parcelRequire("cfrZu"))(enc, key);
        var zBuffer = $27a5e0d2e6fe9775$require$Buffer.alloc(k - msg.length);
        msg = $27a5e0d2e6fe9775$require$Buffer.concat([
            zBuffer,
            msg
        ], k);
        if (padding === 4) return $27a5e0d2e6fe9775$var$oaep(key, msg);
        else if (padding === 1) return $27a5e0d2e6fe9775$var$pkcs1(key, msg, reverse);
        else if (padding === 3) return msg;
        else throw new Error('unknown padding');
    };
    function $27a5e0d2e6fe9775$var$oaep(key, msg) {
        var k = key.modulus.byteLength();
        var iHash = $7K4uY('sha1').update($27a5e0d2e6fe9775$require$Buffer.alloc(0)).digest();
        var hLen = iHash.length;
        if (msg[0] !== 0) throw new Error('decryption error');
        var maskedSeed = msg.slice(1, hLen + 1);
        var maskedDb = msg.slice(hLen + 1);
        var seed = $ixBc1(maskedSeed, $5g0NR(maskedDb, hLen));
        var db = $ixBc1(maskedDb, $5g0NR(seed, k - hLen - 1));
        if ($27a5e0d2e6fe9775$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
        var i = hLen;
        while(db[i] === 0)i++;
        if (db[i++] !== 1) throw new Error('decryption error');
        return db.slice(i);
    }
    function $27a5e0d2e6fe9775$var$pkcs1(key, msg, reverse) {
        var p1 = msg.slice(0, 2);
        var i = 2;
        var status = 0;
        while(msg[i++] !== 0)if (i >= msg.length) {
            status++;
            break;
        }
        var ps = msg.slice(2, i - 1);
        if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
        if (ps.length < 8) status++;
        if (status) throw new Error('decryption error');
        return msg.slice(i);
    }
    function $27a5e0d2e6fe9775$var$compare(a, b) {
        a = $27a5e0d2e6fe9775$require$Buffer.from(a);
        b = $27a5e0d2e6fe9775$require$Buffer.from(b);
        var dif = 0;
        var len = a.length;
        if (a.length !== b.length) {
            dif++;
            len = Math.min(a.length, b.length);
        }
        var i = -1;
        while(++i < len)dif += a[i] ^ b[i];
        return dif;
    }
});
parcelRegister("9hQRv", function(module, exports) {
    $parcel$export(module.exports, "randomFill", ()=>$6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8, (v)=>$6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = v);
    $parcel$export(module.exports, "randomFillSync", ()=>$6c2eb4e5b7b6051e$export$2f7171e78e524d5e, (v)=>$6c2eb4e5b7b6051e$export$2f7171e78e524d5e = v);
    var $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8;
    var $6c2eb4e5b7b6051e$export$2f7171e78e524d5e;
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $6c2eb4e5b7b6051e$var$oldBrowser() {
        throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
    }
    var $Wth4q = parcelRequire("Wth4q");
    var $1DyI6 = parcelRequire("1DyI6");
    var $6c2eb4e5b7b6051e$var$Buffer = $Wth4q.Buffer;
    var $6c2eb4e5b7b6051e$var$kBufferMaxLength = $Wth4q.kMaxLength;
    var $6c2eb4e5b7b6051e$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
    var $6c2eb4e5b7b6051e$var$kMaxUint32 = Math.pow(2, 32) - 1;
    function $6c2eb4e5b7b6051e$var$assertOffset(offset, length) {
        if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
        if (offset > $6c2eb4e5b7b6051e$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
        if (offset > $6c2eb4e5b7b6051e$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
    }
    function $6c2eb4e5b7b6051e$var$assertSize(size, offset, length) {
        if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
        if (size > $6c2eb4e5b7b6051e$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
        if (size + offset > length || size > $6c2eb4e5b7b6051e$var$kBufferMaxLength) throw new RangeError('buffer too small');
    }
    if ($6c2eb4e5b7b6051e$var$crypto && $6c2eb4e5b7b6051e$var$crypto.getRandomValues || false) {
        $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = $6c2eb4e5b7b6051e$var$randomFill;
        $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = $6c2eb4e5b7b6051e$var$randomFillSync;
    } else {
        $6c2eb4e5b7b6051e$export$bb1abf2ce84fc7e8 = $6c2eb4e5b7b6051e$var$oldBrowser;
        $6c2eb4e5b7b6051e$export$2f7171e78e524d5e = $6c2eb4e5b7b6051e$var$oldBrowser;
    }
    function $6c2eb4e5b7b6051e$var$randomFill(buf, offset, size, cb) {
        if (!$6c2eb4e5b7b6051e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        if (typeof offset === 'function') {
            cb = offset;
            offset = 0;
            size = buf.length;
        } else if (typeof size === 'function') {
            cb = size;
            size = buf.length - offset;
        } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
        $6c2eb4e5b7b6051e$var$assertOffset(offset, buf.length);
        $6c2eb4e5b7b6051e$var$assertSize(size, offset, buf.length);
        return $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size, cb);
    }
    function $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size, cb) {
        var ourBuf = buf.buffer;
        var uint = new Uint8Array(ourBuf, offset, size);
        $6c2eb4e5b7b6051e$var$crypto.getRandomValues(uint);
        if (cb) {
            $6cAn5.nextTick(function() {
                cb(null, buf);
            });
            return;
        }
        return buf;
        if (cb) {
            $1DyI6(size, function(err, bytes) {
                if (err) return cb(err);
                bytes.copy(buf, offset);
                cb(null, buf);
            });
            return;
        }
        var bytes = $1DyI6(size);
        bytes.copy(buf, offset);
        return buf;
    }
    function $6c2eb4e5b7b6051e$var$randomFillSync(buf, offset, size) {
        if (typeof offset === 'undefined') offset = 0;
        if (!$6c2eb4e5b7b6051e$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
        $6c2eb4e5b7b6051e$var$assertOffset(offset, buf.length);
        if (size === undefined) size = buf.length - offset;
        $6c2eb4e5b7b6051e$var$assertSize(size, offset, buf.length);
        return $6c2eb4e5b7b6051e$var$actualFill(buf, offset, size);
    }
});
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $7GEKO;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("7GEKO")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("biBfP", function(module, exports) {
    $parcel$export(module.exports, "getSafeValue", ()=>$e31cfbdea683954a$export$d05672fd1312a6d);
    $parcel$export(module.exports, "getSafeOptionsForAnalytics", ()=>$e31cfbdea683954a$export$fde3d804891b8254);
    $parcel$export(module.exports, "flattenOptions", ()=>$e31cfbdea683954a$export$7baa7c13b358b002);
    $parcel$export(module.exports, "getOptionValuesLengths", ()=>$e31cfbdea683954a$export$e2e167245697ed4e);
    $parcel$export(module.exports, "filterOptions", ()=>$e31cfbdea683954a$export$60d56ed3961c839c);
    var $chc6P = parcelRequire("chc6P");
    var $db8jg;
    const $e31cfbdea683954a$export$d05672fd1312a6d = (val)=>(0, (0, parcelRequire("db8jg")).memoizedHashString)(val.toString()).toString();
    const $e31cfbdea683954a$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$e31cfbdea683954a$export$d05672fd1312a6d(value));
    const $e31cfbdea683954a$export$7baa7c13b358b002 = (optionGroups)=>(0, ($parcel$interopDefault($chc6P)))(optionGroups.map((group)=>group.options));
    const $e31cfbdea683954a$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
    const $e31cfbdea683954a$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));
});
parcelRegister("l5gEe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef8773284d2f300e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ef8773284d2f300e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        empty: {
            "id": "issue-field-labels.edit.empty",
            "defaultMessage": "No matches found"
        },
        failedFetch: {
            "id": "issue-field-labels.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        placeholder: {
            "id": "issue-field-labels.edit.placeholder",
            "defaultMessage": "Select label"
        },
        createNewItem: {
            "id": "issue-field-labels.edit.create-new-item",
            "defaultMessage": "New label"
        },
        loading: {
            "id": "issue-field-labels.edit.loading",
            "defaultMessage": "Searching..."
        },
        recent: {
            "id": "issue-field-labels.edit.recent",
            "defaultMessage": "Recent labels"
        },
        all: {
            "id": "issue-field-labels.edit.all",
            "defaultMessage": "All labels"
        }
    });
});
parcelRegister("evGBv", function(module, exports) {
    $parcel$export(module.exports, "mapDataToLabelOptions", ()=>$df66270ab3f9af77$export$cd8e373d5b1325b1);
    $parcel$export(module.exports, "mutateLabelsFields", ()=>$df66270ab3f9af77$export$f691a7c5b86be653);
    const $df66270ab3f9af77$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name })=>({
                value: name,
                label: name
            }));
    const $df66270ab3f9af77$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
            fieldId: fieldId,
            labels: selectedLabels.map(({ value: value })=>({
                    name: value
                })),
            mutationGroup: (0, $fbaea1aecc52fe2c$export$31fd86f8f183952c)
        });
});
const $fbaea1aecc52fe2c$export$31fd86f8f183952c = 'labelsFields';
parcelRegister("3ZQGw", function(module, exports) {
    $parcel$export(module.exports, "LabelsFieldTypeConfig", ()=>$0e9a07e22e44fb24$export$e4c3d82c6a697032);
    var $5uXOq = parcelRequire("5uXOq");
    var $lLTtI;
    var $8GQyc;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $0e9a07e22e44fb24$var$LabelsFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8GQyc")).default), props);
    const $0e9a07e22e44fb24$export$e4c3d82c6a697032 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("lLTtI"))))),
        type: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        Component: $0e9a07e22e44fb24$var$LabelsFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).labelsFieldWriter)
    };
});
parcelRegister("kTnsH", function(module, exports) {
    $parcel$export(module.exports, "MultiCheckboxesCustomFieldTypeConfig", ()=>$a666f3e6ce2ead81$export$29399cace92d6d05);
    var $5uXOq = parcelRequire("5uXOq");
    var $aEee1;
    var $aqCUo;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $a666f3e6ce2ead81$var$MultiCheckboxesCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aqCUo")).default), props);
    const $a666f3e6ce2ead81$export$29399cace92d6d05 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("aEee1"))))),
        type: (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        Component: $a666f3e6ce2ead81$var$MultiCheckboxesCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).checkboxSelectFieldWriter)
    };
});
parcelRegister("aqCUo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e0b893bc2fc3f63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $edQZ6;
    var $hx8g7;
    var $lfTZh;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    const $0e0b893bc2fc3f63$var$CheckboxSelectField = (props)=>{
        const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false } = props;
        const options = (0, (0, parcelRequire("hx8g7")).mapDataToOptions)(allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "async-checkbox-select-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("edQZ6")).AsyncCheckboxSelectEdit), {
            ...fieldProps,
            options: options,
            value: value,
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly
        })));
    };
    var $0e0b893bc2fc3f63$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateCheckboxField),
        transformDefaultValue: (0, (0, parcelRequire("hx8g7")).mapDataToOptions)
    })($0e0b893bc2fc3f63$var$CheckboxSelectField);
});
parcelRegister("edQZ6", function(module, exports) {
    $parcel$export(module.exports, "AsyncCheckboxSelectEdit", ()=>$53d0db7977df62c9$export$48ad7b39ee5392c2);
    var $1jUsD;
    const $53d0db7977df62c9$export$48ad7b39ee5392c2 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("4OVMa")).then((module)=>module.CheckboxSelectEdit), {
        moduleId: "./src/packages/issue/fields/checkbox-select/src/index.tsx"
    });
});
parcelRegister("4OVMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gTShp").then(()=>parcelRequire('7p86r'));
});
parcelRegister("g8kqC", function(module, exports) {
    $parcel$export(module.exports, "MultiGroupCustomFieldTypeConfig", ()=>$f461df346d8eee00$export$62823f7adb904a12);
    var $5uXOq = parcelRequire("5uXOq");
    var $3XWBa;
    var $5sz86;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $f461df346d8eee00$var$MultiGroupCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5sz86")).default), props);
    const $f461df346d8eee00$export$62823f7adb904a12 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("3XWBa"))))),
        type: (0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE),
        Component: $f461df346d8eee00$var$MultiGroupCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).multipleGroupPickerFieldWriter)
    };
});
parcelRegister("5sz86", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0e92fcc13435d46$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9EuZf;
    var $5fnvk;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $1IlAr;
    const $b0e92fcc13435d46$var$MultiGroupPickerField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
        const getExtraProps = ()=>{
            if (isDropdownMenuFixedAndLayered) return {
                menuPosition: 'fixed',
                groupPickerStyles: (0, (0, parcelRequire("9EuZf")).defaultUserPickerStyles),
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
            return {
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fnvk")).default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            isMulti: true,
            placeholder: " ",
            ...getExtraProps()
        }));
    };
    var $b0e92fcc13435d46$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateGroupPickerField),
        transformDefaultValue: (0, (0, parcelRequire("1IlAr")).transformGroupDefaultValueToUserOption)
    })($b0e92fcc13435d46$var$MultiGroupPickerField);
});
parcelRegister("1IlAr", function(module, exports) {
    $parcel$export(module.exports, "transformGroupDefaultValueToUserOption", ()=>$d2f2135dd78f2505$export$d9591be6713fcfc8);
    $parcel$export(module.exports, "mutateMultipleGroupPickerField", ()=>$d2f2135dd78f2505$export$8cb86783be488510);
    var $arYvt;
    const $d2f2135dd78f2505$export$d9591be6713fcfc8 = (group)=>{
        if (!group) return null;
        if (Array.isArray(group)) return group.map((groupItem)=>(0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(groupItem));
        return (0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(group);
    };
    const $d2f2135dd78f2505$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
            fieldId: fieldId,
            groups: selectedGroups.map(({ name: name })=>({
                    groupName: name
                })),
            mutationGroup: (0, $795be18a4b521940$export$31fd86f8f183952c)
        });
});
const $795be18a4b521940$export$31fd86f8f183952c = 'multipleGroupPickerFields';
parcelRegister("iHSUu", function(module, exports) {
    $parcel$export(module.exports, "MultiSelectCustomFieldTypeConfig", ()=>$19289b6ae773b2f1$export$1203387d0e5999ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Upkx;
    var $g2djo;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $19289b6ae773b2f1$var$MultiSelectCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g2djo")).default), {
            ...props,
            defaultValue: undefined
        });
    const $19289b6ae773b2f1$export$1203387d0e5999ed = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("6Upkx"))))),
        type: (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        Component: $19289b6ae773b2f1$var$MultiSelectCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).multiSelectFieldWriter)
    };
});
parcelRegister("6Upkx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $507b9f1b894431d4$var$_react = $507b9f1b894431d4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $507b9f1b894431d4$var$_UNSAFE_baseNew = $507b9f1b894431d4$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $507b9f1b894431d4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $507b9f1b894431d4$var$CheckboxUncheckedIcon = (props)=>$507b9f1b894431d4$var$_react.default.createElement($507b9f1b894431d4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<rect width="12.5" height="12.5" x="1.75" y="1.75" stroke="currentcolor" stroke-width="1.5" rx="1.25"/>`
        }, props));
    $507b9f1b894431d4$var$CheckboxUncheckedIcon.displayName = 'CheckboxUncheckedIcon';
    var $507b9f1b894431d4$var$_default = module.exports.default = $507b9f1b894431d4$var$CheckboxUncheckedIcon;
});
parcelRegister("g2djo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$970d61a7c1588270$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d3RWa;
    const $970d61a7c1588270$var$MultiSelectField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3RWa")).default), {
            ...props,
            isMulti: true
        });
    var $970d61a7c1588270$export$2e2bcd8739ae039 = $970d61a7c1588270$var$MultiSelectField;
});
parcelRegister("3owst", function(module, exports) {
    $parcel$export(module.exports, "MultiUserCustomFieldTypeConfig", ()=>$114133be8a191ff4$export$e61985ad3f4b288f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7uWFl;
    var $gARR3;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $114133be8a191ff4$export$e61985ad3f4b288f = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("7uWFl"))))),
        type: (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
        Component: (0, (0, parcelRequire("gARR3")).default),
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).AssigneeFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).multiUserPickerFieldWriter)
    };
});
parcelRegister("gARR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06543e5a7cef326e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzCWA;
    const $06543e5a7cef326e$var$MultiUserPickerField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzCWA")).default), {
            ...props,
            isMulti: true,
            context: "CustomMultiUserField"
        });
    var $06543e5a7cef326e$export$2e2bcd8739ae039 = $06543e5a7cef326e$var$MultiUserPickerField;
});
parcelRegister("lzCWA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a02b9e46792852c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dQLtU;
    var $gLdtQ;
    var $jGVMX;
    var $hpV4g;
    var $7C5S0;
    var $5kDIl;
    const $a02b9e46792852c4$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
            context: context,
            ...projectKey && {
                project: projectKey
            },
            ...fieldId && {
                fieldId: fieldId
            },
            query: ''
        })}`;
    const $a02b9e46792852c4$var$UserPickerField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dQLtU")).default), {
            autoCompleteUrl: $a02b9e46792852c4$var$getAutoCompleteUrl(context, fieldId, selectedProject?.projectKey),
            placeholder: placeholder,
            isDisabled: isReadOnly || isDisabled,
            onChange: onChange,
            value: value,
            appearance: "normal",
            isMulti: isMulti,
            autoFocus: autoFocus,
            fieldId: fieldId,
            fetchSuggestions: onFetchSuggestions,
            isClearable: true,
            width: width,
            inputId: id,
            onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll),
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
        }));
    };
    var $a02b9e46792852c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateUserPickerField),
        transformDefaultValue: (0, (0, parcelRequire("5kDIl")).transformDefaultUserValues)
    })($a02b9e46792852c4$var$UserPickerField);
});
parcelRegister("dQLtU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4d56a824ba419e6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jOrdN;
    var $9EuZf;
    const $e4d56a824ba419e6$var$UserPickerEdit = (props)=>{
        const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
        const extraProps = ()=>{
            if (isDropdownMenuFixedAndLayered) return {
                menuPosition: 'fixed',
                styles: (0, (0, parcelRequire("9EuZf")).defaultUserPickerStyles),
                onCloseMenuOnScroll: onCloseMenuOnScroll
            };
            return {
                onCloseMenuOnScroll: onCloseMenuOnScroll
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jOrdN")).default), {
            ...fieldProps,
            fieldId: fieldId,
            inputId: inputId,
            appearance: appearance,
            width: width,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            placeholder: placeholder,
            isDisabled: isDisabled,
            isMulti: isMulti,
            autoCompleteUrl: autoCompleteUrl,
            fetchSuggestions: fetchSuggestions,
            emptyOption: emptyOption,
            onSelection: onSelection,
            onDataLoaded: onDataLoaded,
            onDataRequest: onDataRequest,
            onCancel: onCancel,
            isDropdownVisibleByDefault: isDropdownVisibleByDefault,
            isClearable: isClearable,
            isBulkEdit: isBulkEdit,
            ...extraProps()
        });
    };
    var $e4d56a824ba419e6$export$2e2bcd8739ae039 = $e4d56a824ba419e6$var$UserPickerEdit;
});
parcelRegister("jOrdN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f3563054ff092b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kEnpg;
    var $eusud;
    var $koVbs;
    var $duvPR;
    var $khYiH;
    const $9f3563054ff092b8$var$stringContains = (str, substr)=>{
        if (str == null) return false;
        if (substr == null || substr === '') return true;
        return str.toLowerCase().includes(substr.toLowerCase());
    };
    const $9f3563054ff092b8$export$251bdbdbce9550ea = 400;
    const $9f3563054ff092b8$var$UserPickerWrapper = (props)=>{
        const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, ($parcel$interopDefault($8Rkzz))), onSelection: onSelection = (0, ($parcel$interopDefault($8Rkzz))), onDataRequest: onDataRequest = (0, ($parcel$interopDefault($8Rkzz))), onDataLoaded: onDataLoaded = (0, ($parcel$interopDefault($8Rkzz))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, menuMinWidth: menuMinWidth, fetchSuggestions: fetchSuggestionsProps, ...fieldProps } = props;
        const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(Boolean(isDropdownVisibleByDefault));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [query, setQueryString] = (0, $5uXOq.useState)(null);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [wasFocused, setWasFocused] = (0, $5uXOq.useState)(false);
        const [wasCleared, setWasCleared] = (0, $5uXOq.useState)(false);
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)([]);
        const [sessionId, setSessionId] = (0, $5uXOq.useState)('');
        const getEmptyValue = ()=>emptyOption ? {
                ...emptyOption,
                id: (0, $768a4f0fe483a263$export$61a0b64dfe00294c)
            } : null;
        const debounceTime = withoutDebounce ? 0 : $9f3563054ff092b8$export$251bdbdbce9550ea;
        const requestSuggestionsDebounced = (0, $5uXOq.useMemo)(()=>{
            const isCurrentValue = (userOptionValue)=>{
                if (!userOptionValue) return value === null;
                if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
                return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
            };
            const fetchSuggestions = async ()=>{
                let users = [];
                if (autoCompleteUrl !== undefined) {
                    const autoCompleteResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                    users = (0, (0, parcelRequire("khYiH")).mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
                }
                return users.map((userData)=>(0, (0, parcelRequire("khYiH")).mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
            };
            const handleSuggestions = (newSuggestions)=>{
                if (!isDropdownVisible || !newSuggestions) return;
                const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
                setIsLoading(false);
                setSuggestions(filteredSuggestions);
                onDataLoaded(!query, filteredSuggestions.length);
            };
            const handleError = ()=>{
                setIsLoading(false);
                setSuggestions([]);
            };
            const requestSuggestions = ()=>{
                onDataRequest(!query);
                if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                    handleSuggestions(results);
                }).catch(handleError);
                return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
            };
            return (0, ($parcel$interopDefault($lFKmC)))(()=>{
                requestSuggestions();
            }, debounceTime);
        }, [
            debounceTime,
            value,
            autoCompleteUrl,
            query,
            isBulkEdit,
            shouldShowEmailInOptions,
            isDropdownVisible,
            wasFocused,
            onDataLoaded,
            onDataRequest,
            fetchSuggestionsProps,
            sessionId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (query === null || !isDropdownVisible) return;
            requestSuggestionsDebounced();
            return ()=>{
                requestSuggestionsDebounced.cancel();
            };
        }, [
            requestSuggestionsDebounced,
            query,
            isDropdownVisible
        ]);
        const onSelectedValueChangeMulti = (userOptionValue)=>{
            if (userOptionValue && userOptionValue.length === 0) onChange(null);
            else onChange(userOptionValue);
        };
        const onSelectedValueChangeSingle = (userOptionValue)=>{
            const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
            if (valueId === (0, $768a4f0fe483a263$export$61a0b64dfe00294c)) onChange(null);
            else onChange(userOptionValue);
        };
        const onSuggestionSelect = (userOptionValue, sId)=>{
            setSessionId(sId || '');
            setWasFocused(false);
            setWasCleared(false);
            setIsLoading(false);
            setSuggestions([]);
            onSelection(sessionId);
            if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
            else onSelectedValueChangeSingle(userOptionValue);
        };
        const onBlur = ()=>{
            setIsDropdownVisible(false);
            setIsLoading(false);
            setWasFocused(false);
            setSuggestions([]);
            if (wasCleared) {
                onSuggestionSelect(getEmptyValue());
                return;
            }
            onCancel();
        };
        const onDropdownOpen = (sId)=>{
            setSessionId(sId || '');
            setQueryString('');
            setIsDropdownVisible(true);
            setIsLoading(true);
            setWasFocused(true);
            setWasCleared(false);
        };
        const onQueryChange = (queryStr, sId)=>{
            setSessionId(sId || '');
            setQueryString(queryStr || '');
            setIsLoading(!!queryStr);
            setWasFocused(false);
            setIsDropdownVisible(!!queryStr);
        };
        const onClear = ()=>{
            setWasCleared(true);
            onSuggestionSelect(null);
        };
        const closeMenuOnScroll = (e)=>{
            if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
        };
        const isMatchingQuery = (suggestion)=>{
            const { displayName: displayName, name: name } = suggestion;
            return !isLoading || $9f3563054ff092b8$var$stringContains(displayName, query) || $9f3563054ff092b8$var$stringContains(name, query);
        };
        const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
        const filteredSuggestions = getSuggestions();
        const pickerValue = value || getEmptyValue();
        const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, (0, parcelRequire("duvPR")).default).emptyQueryMessage) : undefined;
        const controlProps = openMenuOnClick ? {
            openMenuOnClick: openMenuOnClick,
            onOpen: onDropdownOpen
        } : {
            open: isDropdownVisible,
            onFocus: onDropdownOpen
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kEnpg")).UserPicker), {
            value: pickerValue,
            options: filteredSuggestions,
            isMulti: isMulti,
            fieldId: fieldId,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: portalElement,
            width: width,
            appearance: appearance,
            isClearable: isClearable,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            placeholder: placeholder,
            onBlur: onBlur,
            isLoading: isLoading && isDropdownVisible,
            onClear: onClear,
            onInputChange: onQueryChange,
            onChange: onSuggestionSelect,
            noBorder: noBorder,
            styles: styles,
            noOptionsMessage: getNoOptionsMessage,
            allowEmail: allowEmail,
            inputId: inputId,
            required: isRequired,
            ariaLabel: fieldProps['aria-label'],
            ariaLabelledBy: fieldProps['aria-labelledby'],
            closeMenuOnScroll: closeMenuOnScroll,
            menuPosition: menuPosition,
            ...controlProps
        });
    };
    var $9f3563054ff092b8$export$2e2bcd8739ae039 = $9f3563054ff092b8$var$UserPickerWrapper;
});
const $768a4f0fe483a263$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';
parcelRegister("duvPR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7ea6ee4d1ce51e6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyQueryMessage: {
            "id": "base-user-picker.empty-query-message",
            "defaultMessage": "Start typing to get a list of possible matches."
        }
    });
});
parcelRegister("khYiH", function(module, exports) {
    $parcel$export(module.exports, "mapUserObjectToUserOption", ()=>$5eec43efc9e4eafe$export$e11fc32dba4fe919);
    $parcel$export(module.exports, "mapAutoCompleteResponseToUsers", ()=>$5eec43efc9e4eafe$export$ec325826d2bf6655);
    var $jcw0u;
    const $5eec43efc9e4eafe$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
        let userOption = {
            id: userData.accountId || '',
            name: userData.displayName || '',
            avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
        };
        if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) userOption = {
            ...userOption,
            byline: userData.emailAddress
        };
        return userOption;
    };
    const $5eec43efc9e4eafe$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
        try {
            if (isBulkEdit) {
                if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) return autoCompleteResponse.users;
            } else if (Array.isArray(autoCompleteResponse)) return autoCompleteResponse;
            throw Error('autoCompleteResponse is either null or not expected value');
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'mapAutoCompleteResponse',
                    packageName: 'jiraBaseUserPicker',
                    teamName: 'gryffindor'
                },
                error: error
            });
        }
        return [];
    };
});
parcelRegister("dzSVK", function(module, exports) {
    $parcel$export(module.exports, "NumberCustomFieldTypeConfig", ()=>$ba1f787e6f666f7e$export$9263307b5dc5bafe);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSzuZ;
    var $bo14T;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $ba1f787e6f666f7e$var$NumberCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bo14T")).default), props);
    const $ba1f787e6f666f7e$export$9263307b5dc5bafe = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("cSzuZ"))))),
        type: (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
        Component: $ba1f787e6f666f7e$var$NumberCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).TextFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).numberFieldWriter)
    };
});
parcelRegister("cSzuZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $96061082adb54bcc$var$_react = $96061082adb54bcc$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $96061082adb54bcc$var$_UNSAFE_baseNew = $96061082adb54bcc$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $96061082adb54bcc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $96061082adb54bcc$var$HashtagIcon = (props)=>$96061082adb54bcc$var$_react.default.createElement($96061082adb54bcc$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m6.75 1-2.5 14m7.5-14-2.5 14M14 10.25H1m14-4.5H2"/>`
        }, props));
    $96061082adb54bcc$var$HashtagIcon.displayName = 'HashtagIcon';
    var $96061082adb54bcc$var$_default = module.exports.default = $96061082adb54bcc$var$HashtagIcon;
});
parcelRegister("bo14T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dfdc9c56d4f0e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hMKLn;
    var $hpV4g;
    var $jGVMX;
    var $kU4qk;
    const $69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e = (props)=>{
        const { width: width = 350, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMKLn")).InputField), {
            type: "number",
            width: width,
            ...rest
        });
    };
    var $69dfdc9c56d4f0e9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString),
        transformDefaultValue: (0, (0, parcelRequire("kU4qk")).transformAsString)
    })($69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e);
});
parcelRegister("hMKLn", function(module, exports) {
    $parcel$export(module.exports, "InputField", ()=>$c59ad84f24b74144$export$dd2171e2b7d3bc5b);
    $parcel$export(module.exports, "default", ()=>$c59ad84f24b74144$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8mGGj;
    var $jGVMX;
    var $hpV4g;
    var $lrbT7;
    const $c59ad84f24b74144$export$dd2171e2b7d3bc5b = (props)=>{
        const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mGGj")).default), {
            ...rest,
            onChange: onChange,
            value: value,
            type: type,
            width: width,
            step: "any",
            testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            onWheel: (0, (0, parcelRequire("lrbT7")).preventMouseScrollForNumericFieldHandler),
            isDisabled: isReadOnly || rest.isDisabled
        });
    };
    var $c59ad84f24b74144$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($c59ad84f24b74144$export$dd2171e2b7d3bc5b);
});
parcelRegister("8mGGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af711023521e2d75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $9EfCw;
    const $af711023521e2d75$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $af711023521e2d75$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9EfCw")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("9EfCw")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $af711023521e2d75$export$2e2bcd8739ae039 = $af711023521e2d75$var$Textfield;
});
parcelRegister("9EfCw", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$a7502c1f5abf97ed$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$a7502c1f5abf97ed$export$3eeb47dc8e6249d9);
    const $a7502c1f5abf97ed$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $a7502c1f5abf97ed$var$backgroundColor[appearance],
            borderColor: $a7502c1f5abf97ed$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorHover[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorFocus[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$a7502c1f5abf97ed$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $a7502c1f5abf97ed$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $a7502c1f5abf97ed$var$getMaxWidth = (width)=>!width ? `100%` : width in $a7502c1f5abf97ed$var$widthMap ? $a7502c1f5abf97ed$var$widthMap[width] : +width;
    const $a7502c1f5abf97ed$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $a7502c1f5abf97ed$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $a7502c1f5abf97ed$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("lrbT7", function(module, exports) {
    $parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", ()=>$0fe71c1efa633a57$export$3fedcbfe1c53d8f);
    const $0fe71c1efa633a57$export$3fedcbfe1c53d8f = (event)=>{
        if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
    };
});
parcelRegister("kU4qk", function(module, exports) {
    $parcel$export(module.exports, "transformAsNumber", ()=>$2648f8f88d1e9261$export$52c4e7404b9db862);
    $parcel$export(module.exports, "mutateNumberField", ()=>$2648f8f88d1e9261$export$6701d4d68ea6db95);
    $parcel$export(module.exports, "transformAsString", ()=>$2648f8f88d1e9261$export$afe59f8094df7220);
    const $2648f8f88d1e9261$export$52c4e7404b9db862 = (value)=>{
        if (value) return Number(value);
        return undefined;
    };
    const $2648f8f88d1e9261$export$6701d4d68ea6db95 = (value, fieldId)=>({
            fieldId: fieldId,
            value: Number(value),
            mutationGroup: (0, $358fca2fc5354374$export$31fd86f8f183952c)
        });
    const $2648f8f88d1e9261$export$afe59f8094df7220 = (value)=>{
        if (value !== undefined) return String(value);
        return undefined;
    };
});
const $358fca2fc5354374$export$31fd86f8f183952c = 'numberFields';
parcelRegister("2prZd", function(module, exports) {
    $parcel$export(module.exports, "ParentFieldTypeConfig", ()=>$2c89c4ecde62323b$export$dfc79382467975d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $kbh8j;
    var $8mBES;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $2c89c4ecde62323b$var$ParentFieldTypeComponent = (props)=>{
        if (!props.issueTypeId || !props.canUserViewProject) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mBES")).default), {
            ...props,
            selectedProject: {
                value: props.projectId
            },
            selectedIssueType: {
                value: props.issueTypeId
            },
            isFieldResponsive: true
        });
    };
    const $2c89c4ecde62323b$export$dfc79382467975d5 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("kbh8j"))))),
        type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
        Component: $2c89c4ecde62323b$var$ParentFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).selectFieldWriter)
    };
});
parcelRegister("kbh8j", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eb121ffdd78fe280$var$_react = $eb121ffdd78fe280$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eb121ffdd78fe280$var$_UNSAFE_baseNew = $eb121ffdd78fe280$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $eb121ffdd78fe280$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eb121ffdd78fe280$var$FieldIcon = (props)=>$eb121ffdd78fe280$var$_react.default.createElement($eb121ffdd78fe280$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M0 2.75h6m-4 8.5h12c.69 0 1.25-.56 1.25-1.25V7c0-.69-.56-1.25-1.25-1.25H2C1.31 5.75.75 6.31.75 7v3c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $eb121ffdd78fe280$var$FieldIcon.displayName = 'FieldIcon';
    var $eb121ffdd78fe280$var$_default = module.exports.default = $eb121ffdd78fe280$var$FieldIcon;
});
parcelRegister("8mBES", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28698af5fbb25d8a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hnsNR;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $1iKBB;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $bA6nL;
    var $eulr6;
    const $28698af5fbb25d8a$export$96c87c0afbe06b37 = (props)=>{
        const { fieldId: fieldId, fieldName: fieldName, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let issueTypeId;
        if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iKBB")).ParentFieldEdit), {
            fieldId: fieldId,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isExistingIssue: isExistingIssue,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            selectedProjectId: selectedProject ? selectedProject.value : undefined,
            selectedIssueTypeId: issueTypeId,
            fetchSuggestionsOnFocus: true,
            passedInIssueKey: ((0, (0, parcelRequire("4R6GH")).fg)('modern_its_render_flag_migration') ? (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') : (0, (0, parcelRequire("co1wz")).ff)('render-modern-issue-transition_cxt0z')) || (0, (0, parcelRequire("hnsNR")).isFedRamp)() ? issueKey : undefined,
            spacing: "default"
        }), (0, (0, parcelRequire("4R6GH")).fg)('override_parent_field_description_in_frontend') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: formatMessage((0, (0, parcelRequire("bA6nL")).default).description),
            fieldName: fieldName
        }));
    };
    var $28698af5fbb25d8a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("eulr6")).transformDefaultParentValue),
        validator: (0, (0, parcelRequire("eulr6")).validateParentField)
    })($28698af5fbb25d8a$export$96c87c0afbe06b37);
});
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
parcelRegister("1iKBB", function(module, exports) {
    $parcel$export(module.exports, "ParentFieldEdit", ()=>$b89ca9fa2a80ab1b$export$55c2cccecfd24751);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $gN6Vx;
    var $loZC0;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $2gCtH;
    var $3BhEA;
    var $lElIo;
    var $koeKL;
    var $iVcsU;
    var $inRSh;
    var $3orGF;
    var $1sPJ0;
    var $6v0ju;
    const $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
    const $b89ca9fa2a80ab1b$export$55c2cccecfd24751 = (props)=>{
        const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [noOptionsMessage, setNoOptionsMessage] = (0, $5uXOq.useState)('');
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const [excludeDone, setExcludeDone] = (0, $5uXOq.useState)(true);
        const isInitialMount = (0, $5uXOq.useRef)(true);
        const lastQuery = (0, $5uXOq.useRef)('');
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const onCheckboxClickOld = (0, $5uXOq.useCallback)(()=>{
            setExcludeDone(!excludeDone);
        }, [
            excludeDone
        ]);
        const componentPropsOld = (0, $5uXOq.useMemo)(()=>({
                isChecked: !excludeDone,
                onChange: onCheckboxClickOld
            }), [
            excludeDone,
            onCheckboxClickOld
        ]);
        const componentProps = (0, $5uXOq.useMemo)(()=>({
                onChange: (event)=>{
                    setExcludeDone(!event.target.checked);
                }
            }), []);
        const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
            if (context === 'menu') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                content: option.label
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1sPJ0")).default), {
                option: option
            }));
            const label = (0, (0, parcelRequire("co1wz")).ff)('jsm-request-type-layout-supports-parent-field_jiq2s') ? option.label || `${option.key} ${option.fields.summary}` : `${option.key} ${option.fields.summary}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, label);
        }, []);
        const searchParents = (0, $5uXOq.useCallback)(async (query = '')=>{
            setHasLastFetchFailed(false);
            try {
                lastQuery.current = query;
                if (isExistingIssue) {
                    const fetchedOptions = await (0, (0, parcelRequire("6v0ju")).fetchParentsForExisting)({
                        searchTerm: query,
                        issueKey: passedInIssueKey || issueKey,
                        cloudId: cloudId,
                        excludeDone: excludeDone
                    });
                    return fetchedOptions;
                }
                if (selectedProjectId && selectedIssueTypeId) {
                    const fetchedOptions = await (0, (0, parcelRequire("6v0ju")).fetchParentsForNew)({
                        searchTerm: query,
                        selectedProjectId: selectedProjectId,
                        selectedIssueTypeId: selectedIssueTypeId,
                        cloudId: cloudId,
                        excludeDone: excludeDone
                    });
                    return fetchedOptions;
                }
                setHasLastFetchFailed(true);
                return {
                    options: []
                };
            } catch  {
                setHasLastFetchFailed(true);
                return {
                    options: []
                };
            }
        }, [
            isExistingIssue,
            issueKey,
            cloudId,
            excludeDone,
            selectedProjectId,
            selectedIssueTypeId,
            passedInIssueKey
        ]);
        const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            const response = await searchParents(query);
            if (lastQuery.current === query) {
                if (response.options !== undefined) {
                    setSuggestions(response.options);
                    if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                    if (query === '') setDefaultSuggestions(response.options);
                } else {
                    setSuggestions([]);
                    if (query === '') setDefaultSuggestions([]);
                }
                setIsLoading(false);
            }
        }, [
            searchParents
        ]);
        const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(requestSuggestions, $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
            excludeDone
        ]);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedRequestSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                lastQuery.current = query;
                setIsLoading(true);
                debouncedRequestSuggestions(query);
            } else {
                lastQuery.current = '';
                setIsLoading(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedRequestSuggestions,
            defaultSuggestions
        ]);
        const handleFocus = (0, $5uXOq.useCallback)((e)=>{
            if (lastQuery.current === '' && !defaultSuggestions) {
                setIsLoading(true);
                requestSuggestions();
            }
            onFocus && onFocus(e);
        }, [
            defaultSuggestions,
            onFocus,
            requestSuggestions
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
        }, [
            hasLastFetchFailed
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>{
            const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, (0, parcelRequire("3orGF")).default).noMatches);
            return hasLastFetchFailed ? formatMessage((0, (0, parcelRequire("3orGF")).default).failedFetch) : noOptions;
        }, [
            formatMessage,
            hasLastFetchFailed,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, (0, parcelRequire("3orGF")).default).loading), [
            formatMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isInitialMount.current) {
                setIsLoading(true);
                requestSuggestions(lastQuery.current);
            }
            isInitialMount.current = false;
        }, [
            excludeDone,
            requestSuggestions
        ]);
        const spacing = (0, $5uXOq.useMemo)(()=>spacingProps, [
            spacingProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            onKeyDown: (0, (0, parcelRequire("iVcsU")).preventEscKeyPropagationKeyPressHandler),
            inputId: `${fieldId}-field`,
            options: suggestions,
            value: value,
            formatOptionLabel: formatOptionLabel,
            onBlur: onBlur,
            onFocus: handleFocus,
            onChange: onChange,
            menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            closeMenuOnScroll: onCloseMenuOnScroll,
            isMulti: false,
            isLoading: isLoading,
            onInputChange: onQueryChange,
            loadingMessage: getLoadingMessage,
            noOptionsMessage: getNoOptionsMessage,
            placeholder: formatMessage((0, (0, parcelRequire("3orGF")).default).placeholder),
            components: {
                Menu: (0, parcelRequire("inRSh")).default
            },
            componentsProps: (0, (0, parcelRequire("4R6GH")).fg)('fix_show_done_issues_checkbox_in_parent_field') ? componentProps : componentPropsOld,
            autoFocus: autoFocus,
            filterOption: filterOption,
            validationState: isInvalid === true ? 'error' : undefined,
            hideSelectedOptions: true,
            isClearable: isClearable,
            ...isEditing !== undefined && {
                menuIsOpen: isEditing
            },
            isDisabled: isDisabled,
            defaultMenuIsOpen: defaultMenuIsOpen,
            classNamePrefix: classNamePrefix,
            spacing: spacing,
            "aria-label": formatMessage((0, (0, parcelRequire("3orGF")).default).placeholder),
            ...(0, (0, parcelRequire("4R6GH")).fg)('bulk-transitions-fix-a11y-violations') && {
                'aria-labelledby': ariaLabelledBy
            }
        });
    };
});
parcelRegister("iVcsU", function(module, exports) {
    $parcel$export(module.exports, "getOptionColorElem", ()=>$608100d8bb869e55$export$b00899e73680c477);
    $parcel$export(module.exports, "mapDataToOptions", ()=>$608100d8bb869e55$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$608100d8bb869e55$export$fc800909123977f3);
    $parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", ()=>$608100d8bb869e55$export$feb08457bf70a411);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$608100d8bb869e55$export$949dc67535a8ff2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $heWHN;
    var $iHPnC;
    const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color];
    const $608100d8bb869e55$export$b00899e73680c477 = (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
            color: color,
            "data-testid": `issue-field-parent.common.color-patch-${color}`
        });
    const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
        return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
                id: id,
                key: key,
                fields: {
                    issuetype: issueType,
                    summary: summary
                },
                color: color,
                value: id,
                label: `${key} ${summary}`,
                isDone: isDone
            }));
    };
    const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
            id: option.value
        });
    const $608100d8bb869e55$export$9b822862d986dfdf = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
        if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
    };
    const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
    const $608100d8bb869e55$var$ColorPatch = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1nzbko4": (0, (0, parcelRequire("lD23V")).default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("heWHN", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_EPIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
    $parcel$export(module.exports, "MAP_COLORS_TO_VALUE", ()=>$3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    $parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", ()=>$3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
    $parcel$export(module.exports, "MAP_VALUE_TO_COLOR", ()=>$3a4ee6f2b0ce40ab$export$a6cb26e106674600);
    $parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$43264b0781f10167);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
    $parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
    $parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$db17671bf37971e7);
    $parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
    $parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
    $parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$703aca53c431bb88);
    $parcel$export(module.exports, "BASE_COLOR_SCHEMA", ()=>$3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $kFsv3;
    const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
    const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
        [(0, (0, parcelRequire("kFsv3")).GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N200})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
        [(0, $72ba03e317f3d228$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
        [(0, $72ba03e317f3d228$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
        [(0, $72ba03e317f3d228$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
        [(0, $72ba03e317f3d228$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
        [(0, $72ba03e317f3d228$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
        [(0, $72ba03e317f3d228$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
        [(0, $72ba03e317f3d228$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N200})`,
        [(0, $72ba03e317f3d228$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
        [(0, $72ba03e317f3d228$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
        [(0, $72ba03e317f3d228$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
        [(0, $72ba03e317f3d228$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
        [(0, $72ba03e317f3d228$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
        [(0, $72ba03e317f3d228$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
        [(0, $72ba03e317f3d228$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
        [(0, (0, parcelRequire("kFsv3")).SERVER_PURPLE)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_PURPLE)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_BLUE)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_BLUE)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREEN)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREEN)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_TEAL)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_TEAL)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_YELLOW)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_YELLOW)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_ORANGE)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_ORANGE)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREY)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREY)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY)
    };
    const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
    const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)
    };
    const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).GREY)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: {
            primary: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
            secondary: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P500})`,
            text: `var(--ds-text-accent-purple, ${(0, $72ba03e317f3d228$exports).P500})`,
            textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $72ba03e317f3d228$exports).P50})`,
            border: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P400})`,
            line: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $72ba03e317f3d228$exports).P75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: {
            primary: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
            secondary: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B500})`,
            text: `var(--ds-text-accent-blue, ${(0, $72ba03e317f3d228$exports).B500})`,
            textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $72ba03e317f3d228$exports).B50})`,
            border: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B400})`,
            line: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B300})`,
            primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $72ba03e317f3d228$exports).B75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: {
            primary: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
            secondary: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G500})`,
            text: `var(--ds-text-accent-green, ${(0, $72ba03e317f3d228$exports).G500})`,
            textBackground: `var(--ds-background-accent-green-subtler, ${(0, $72ba03e317f3d228$exports).G50})`,
            border: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G400})`,
            line: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $72ba03e317f3d228$exports).G75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: {
            primary: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
            secondary: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T500})`,
            text: `var(--ds-text-accent-teal, ${(0, $72ba03e317f3d228$exports).T500})`,
            textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $72ba03e317f3d228$exports).T50})`,
            border: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T400})`,
            line: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $72ba03e317f3d228$exports).T75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: {
            primary: `var(--ds-background-accent-yellow-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
            secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $72ba03e317f3d228$exports).Y500})`,
            text: `var(--ds-text-accent-yellow, ${(0, $72ba03e317f3d228$exports).Y500})`,
            textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $72ba03e317f3d228$exports).Y50})`,
            border: `var(--ds-border-accent-yellow, ${(0, $72ba03e317f3d228$exports).Y400})`,
            line: `var(--ds-border-accent-yellow, ${(0, $72ba03e317f3d228$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $72ba03e317f3d228$exports).Y75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: {
            primary: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
            secondary: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R500})`,
            text: `var(--ds-text-accent-red, ${(0, $72ba03e317f3d228$exports).R500})`,
            textBackground: `var(--ds-background-accent-red-subtler, ${(0, $72ba03e317f3d228$exports).R50})`,
            border: `var(--ds-border-accent-red, ${(0, $72ba03e317f3d228$exports).R400})`,
            line: `var(--ds-border-accent-red, ${(0, $72ba03e317f3d228$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $72ba03e317f3d228$exports).R75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREY)]: {
            primary: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N200})`,
            secondary: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N500})`,
            text: `var(--ds-text-accent-gray, ${(0, $72ba03e317f3d228$exports).N500})`,
            textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $72ba03e317f3d228$exports).N30})`,
            border: `var(--ds-border-accent-gray, ${(0, $72ba03e317f3d228$exports).N700})`,
            line: `var(--ds-border-accent-gray, ${(0, $72ba03e317f3d228$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $72ba03e317f3d228$exports).N50})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: {
            primary: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
            secondary: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
            border: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P100})`,
            line: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: {
            primary: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
            secondary: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
            border: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B200})`,
            line: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B100})`,
            primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: {
            primary: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
            secondary: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
            border: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G200})`,
            line: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: {
            primary: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
            secondary: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
            border: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T200})`,
            line: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: {
            primary: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
            secondary: `var(--ds-background-accent-orange-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
            border: `var(--ds-background-accent-orange-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
            line: `var(--ds-border-accent-orange, ${(0, $72ba03e317f3d228$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $72ba03e317f3d228$exports).Y100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: {
            primary: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
            secondary: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
            border: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R100})`,
            line: `var(--ds-border-accent-red, ${(0, $72ba03e317f3d228$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: {
            primary: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N700})`,
            secondary: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N300})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N500})`,
            border: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N100})`,
            line: `var(--ds-border-accent-gray, ${(0, $72ba03e317f3d228$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N100})`,
            hasContrastSecondaryGradient: false
        }
    };
});
parcelRegister("kFsv3", function(module, exports) {
    $parcel$export(module.exports, "PURPLE", ()=>$da8a77f13d52b186$export$7ffdeca4b2f927a2);
    $parcel$export(module.exports, "DARK_PURPLE", ()=>$da8a77f13d52b186$export$c815fe495e8174a0);
    $parcel$export(module.exports, "BLUE", ()=>$da8a77f13d52b186$export$738c3b9a44c87ecc);
    $parcel$export(module.exports, "DARK_BLUE", ()=>$da8a77f13d52b186$export$1225f83626261b80);
    $parcel$export(module.exports, "GREEN", ()=>$da8a77f13d52b186$export$48d4b2cd5bc0e88b);
    $parcel$export(module.exports, "DARK_GREEN", ()=>$da8a77f13d52b186$export$c6f4cf2e5768eb78);
    $parcel$export(module.exports, "TEAL", ()=>$da8a77f13d52b186$export$d0446fe88325854e);
    $parcel$export(module.exports, "DARK_TEAL", ()=>$da8a77f13d52b186$export$bb848c92687e69dc);
    $parcel$export(module.exports, "YELLOW", ()=>$da8a77f13d52b186$export$aab610c505c06a8f);
    $parcel$export(module.exports, "DARK_YELLOW", ()=>$da8a77f13d52b186$export$466af87757d343a2);
    $parcel$export(module.exports, "ORANGE", ()=>$da8a77f13d52b186$export$3de5e29ed1757f9b);
    $parcel$export(module.exports, "DARK_ORANGE", ()=>$da8a77f13d52b186$export$da02e4820b6ab753);
    $parcel$export(module.exports, "GREY", ()=>$da8a77f13d52b186$export$7d278ca694634874);
    $parcel$export(module.exports, "DARK_GREY", ()=>$da8a77f13d52b186$export$26453300bfc61cb8);
    $parcel$export(module.exports, "COLORS", ()=>$da8a77f13d52b186$export$56d196d2844d1ca1);
    $parcel$export(module.exports, "SERVER_PURPLE", ()=>$da8a77f13d52b186$export$792af22a0198af8d);
    $parcel$export(module.exports, "SERVER_DARK_PURPLE", ()=>$da8a77f13d52b186$export$588af712afdcb006);
    $parcel$export(module.exports, "SERVER_BLUE", ()=>$da8a77f13d52b186$export$84c4918645391802);
    $parcel$export(module.exports, "SERVER_DARK_BLUE", ()=>$da8a77f13d52b186$export$b8f1f5838352a33a);
    $parcel$export(module.exports, "SERVER_GREEN", ()=>$da8a77f13d52b186$export$9384b7e350ee6542);
    $parcel$export(module.exports, "SERVER_DARK_GREEN", ()=>$da8a77f13d52b186$export$87d3fb8d8656d38b);
    $parcel$export(module.exports, "SERVER_TEAL", ()=>$da8a77f13d52b186$export$b0b4ce3e99e66aae);
    $parcel$export(module.exports, "SERVER_DARK_TEAL", ()=>$da8a77f13d52b186$export$a89b77a449bd223e);
    $parcel$export(module.exports, "SERVER_YELLOW", ()=>$da8a77f13d52b186$export$9a33b5e3cde94885);
    $parcel$export(module.exports, "SERVER_DARK_YELLOW", ()=>$da8a77f13d52b186$export$33253d7862bceb8a);
    $parcel$export(module.exports, "SERVER_ORANGE", ()=>$da8a77f13d52b186$export$6609c2b23fc42f39);
    $parcel$export(module.exports, "SERVER_DARK_ORANGE", ()=>$da8a77f13d52b186$export$cd994662b5911917);
    $parcel$export(module.exports, "SERVER_GREY", ()=>$da8a77f13d52b186$export$1793d43e13e078c5);
    $parcel$export(module.exports, "SERVER_DARK_GREY", ()=>$da8a77f13d52b186$export$487a6e9145526564);
    $parcel$export(module.exports, "GHX_LABEL_1", ()=>$da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
    $parcel$export(module.exports, "GHX_LABEL_2", ()=>$da8a77f13d52b186$export$8f5c1c5512278dc6);
    $parcel$export(module.exports, "GHX_LABEL_3", ()=>$da8a77f13d52b186$export$94ac87c81ed074a7);
    $parcel$export(module.exports, "GHX_LABEL_4", ()=>$da8a77f13d52b186$export$6bc9ab1f489f76f7);
    $parcel$export(module.exports, "GHX_LABEL_5", ()=>$da8a77f13d52b186$export$610a2c132b6fcf96);
    $parcel$export(module.exports, "GHX_LABEL_6", ()=>$da8a77f13d52b186$export$8e4997dba71f1c40);
    $parcel$export(module.exports, "GHX_LABEL_7", ()=>$da8a77f13d52b186$export$18a545b4e69b27b4);
    $parcel$export(module.exports, "GHX_LABEL_8", ()=>$da8a77f13d52b186$export$27fff1a0d295292a);
    $parcel$export(module.exports, "GHX_LABEL_9", ()=>$da8a77f13d52b186$export$e57aa662a56724e1);
    $parcel$export(module.exports, "GHX_LABEL_10", ()=>$da8a77f13d52b186$export$4b0d63e2c3be2072);
    $parcel$export(module.exports, "GHX_LABEL_11", ()=>$da8a77f13d52b186$export$457ecb9560f2bf83);
    $parcel$export(module.exports, "GHX_LABEL_12", ()=>$da8a77f13d52b186$export$a866db37165a696c);
    $parcel$export(module.exports, "GHX_LABEL_13", ()=>$da8a77f13d52b186$export$9b18447c1168a1b6);
    $parcel$export(module.exports, "GHX_LABEL_14", ()=>$da8a77f13d52b186$export$93b9ad4020e271b7);
    $parcel$export(module.exports, "AGILE_COLOR_1", ()=>$da8a77f13d52b186$export$5cd2af17b34de3e3);
    $parcel$export(module.exports, "AGILE_COLOR_2", ()=>$da8a77f13d52b186$export$987671fa69482a7b);
    $parcel$export(module.exports, "AGILE_COLOR_3", ()=>$da8a77f13d52b186$export$70ba8a5b1f4c7446);
    $parcel$export(module.exports, "AGILE_COLOR_4", ()=>$da8a77f13d52b186$export$fcd1c42d8d3ebd36);
    $parcel$export(module.exports, "AGILE_COLOR_5", ()=>$da8a77f13d52b186$export$f80a5bd2fa0ba256);
    $parcel$export(module.exports, "AGILE_COLOR_6", ()=>$da8a77f13d52b186$export$37ad5ce8d2aeaf78);
    $parcel$export(module.exports, "AGILE_COLOR_7", ()=>$da8a77f13d52b186$export$9dc62d5d151cb355);
    $parcel$export(module.exports, "AGILE_COLOR_8", ()=>$da8a77f13d52b186$export$1ed15b30f5663f92);
    $parcel$export(module.exports, "AGILE_COLOR_9", ()=>$da8a77f13d52b186$export$5d23a84d55ac1644);
    $parcel$export(module.exports, "AGILE_COLOR_10", ()=>$da8a77f13d52b186$export$bf08c9a6ed42e349);
    $parcel$export(module.exports, "AGILE_COLOR_11", ()=>$da8a77f13d52b186$export$66c5d8f0b5ff279c);
    $parcel$export(module.exports, "AGILE_COLOR_12", ()=>$da8a77f13d52b186$export$da30755a37c3a597);
    $parcel$export(module.exports, "AGILE_COLOR_13", ()=>$da8a77f13d52b186$export$721cf84faff6bf19);
    $parcel$export(module.exports, "AGILE_COLOR_14", ()=>$da8a77f13d52b186$export$4b8f8666bd7b61dd);
    $parcel$export(module.exports, "Colors", ()=>$da8a77f13d52b186$export$c537fa0d021d010b);
    $parcel$export(module.exports, "ServerColors", ()=>$da8a77f13d52b186$export$d33d39828a18210a);
    $parcel$export(module.exports, "ClassicEpicColors", ()=>$da8a77f13d52b186$export$f476e6e43e0101e7);
    $parcel$export(module.exports, "AgileColors", ()=>$da8a77f13d52b186$export$4b7407b8700035bd);
    const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
    const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
    const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
    const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
    const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
    const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
    const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
    const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
    const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
    const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
    const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
    const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
    const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
    const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
    const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
        $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        $da8a77f13d52b186$export$c815fe495e8174a0,
        $da8a77f13d52b186$export$738c3b9a44c87ecc,
        $da8a77f13d52b186$export$1225f83626261b80,
        $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        $da8a77f13d52b186$export$d0446fe88325854e,
        $da8a77f13d52b186$export$bb848c92687e69dc,
        $da8a77f13d52b186$export$aab610c505c06a8f,
        $da8a77f13d52b186$export$466af87757d343a2,
        $da8a77f13d52b186$export$3de5e29ed1757f9b,
        $da8a77f13d52b186$export$da02e4820b6ab753,
        $da8a77f13d52b186$export$7d278ca694634874,
        $da8a77f13d52b186$export$26453300bfc61cb8
    ];
    const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
    const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
    const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
    const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
    const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
    const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
    const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
    const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
    const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
    const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
    const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
    const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
    const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
    const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
    const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
    const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
    const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
    const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
    const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
    const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
    const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
    const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
    const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
    const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
    const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
    const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
    const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
    const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
    const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
    const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
    const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
    const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
    const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
    const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
    const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
    const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
    const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
    const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
    const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
    const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
    const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
    const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
    const $da8a77f13d52b186$export$c537fa0d021d010b = {
        PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
        BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
        DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
        GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
        DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
        YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
        DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
        ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
        DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
        GREY: $da8a77f13d52b186$export$7d278ca694634874,
        DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
    };
    const $da8a77f13d52b186$export$d33d39828a18210a = {
        SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
        SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
        SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
        SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
        SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
        SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
        SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
        SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
        SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
        SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
        SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
        SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
        SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
        SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
    };
    const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
        GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
        GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
        GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
        GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
        GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
        GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
        GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
        GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
        GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
        GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
        GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
        GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
        GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
        GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
    };
    const $da8a77f13d52b186$export$4b7407b8700035bd = {
        AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
        AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
        AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
        AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
        AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
        AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
        AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
        AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
        AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
        AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
        AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
        AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
        AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
        AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
    };
});
parcelRegister("iHPnC", function(module, exports) {
    $parcel$export(module.exports, "asColor", ()=>$e626bf77f0e696c5$export$b74af6529f09947);
    $parcel$export(module.exports, "asServerColor", ()=>$e626bf77f0e696c5$export$442690a499ee9598);
    $parcel$export(module.exports, "asClassicEpicColor", ()=>$e626bf77f0e696c5$export$eb754032c0b9698c);
    $parcel$export(module.exports, "transformColorToTheme", ()=>$e626bf77f0e696c5$export$37c9bd72afe7f286);
    $parcel$export(module.exports, "getValueFromColor", ()=>$e626bf77f0e696c5$export$a00423580059ae28);
    $parcel$export(module.exports, "getColorFromValue", ()=>$e626bf77f0e696c5$export$6d14528e40cbe34b);
    $parcel$export(module.exports, "toFrontendColor", ()=>$e626bf77f0e696c5$export$574e4dbf3c01f0ad);
    $parcel$export(module.exports, "toBackendColor", ()=>$e626bf77f0e696c5$export$47af25386a01de1);
    $parcel$export(module.exports, "classicToFrontendColor", ()=>$e626bf77f0e696c5$export$8f81207f7ac5fb9a);
    $parcel$export(module.exports, "classicToBackendColor", ()=>$e626bf77f0e696c5$export$28fb68bb1de025d5);
    $parcel$export(module.exports, "getDefaultColorPalette", ()=>$e626bf77f0e696c5$export$f6e067d5c418081a);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$e626bf77f0e696c5$export$949dc67535a8ff2);
    $parcel$export(module.exports, "getRandomColor", ()=>$e626bf77f0e696c5$export$e4369cabd7e84cd9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $heWHN;
    var $ehxiD;
    var $kFsv3;
    const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).Colors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color];
        return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
    };
    const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).ServerColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
    };
    const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).ClassicEpicColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).AgileColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
        const newColorSchema = {
            ...(0, (0, parcelRequire("heWHN")).BASE_COLOR_SCHEMA),
            ...colorSchemaExtension
        };
        const extendedColors = (colorSchemaExtension ? Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, (0, parcelRequire("kFsv3")).Colors)));
        return extendedColors.reduce((obj, color)=>({
                ...obj,
                [color]: transformation(newColorSchema[color])
            }), {});
    };
    const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color] || (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[0, (0, parcelRequire("kFsv3")).PURPLE];
    const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>(0, ($parcel$interopDefault($ggSx2)))((0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE))[value] || (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
    const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
    const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).purpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).blueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).tealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).yellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).orangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREY]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkPurpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkBlueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkTealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkYellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkOrangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]
            }
        ];
    const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR))=>$e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR];
    const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
        const colorKeys = Object.keys((0, (0, parcelRequire("kFsv3")).Colors));
        return colorKeys[Math.floor(Math.random() * colorKeys.length)];
    };
});
parcelRegister("ehxiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b7e3d933c7b9f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        purpleLabel: {
            "id": "issue-epic-color.common.purple-label",
            "defaultMessage": "purple"
        },
        blueLabel: {
            "id": "issue-epic-color.common.blue-label",
            "defaultMessage": "blue"
        },
        greenLabel: {
            "id": "issue-epic-color.common.green-label",
            "defaultMessage": "green"
        },
        tealLabel: {
            "id": "issue-epic-color.common.teal-label",
            "defaultMessage": "teal"
        },
        yellowLabel: {
            "id": "issue-epic-color.common.yellow-label",
            "defaultMessage": "yellow"
        },
        orangeLabel: {
            "id": "issue-epic-color.common.orange-label",
            "defaultMessage": "orange"
        },
        greyLabel: {
            "id": "issue-epic-color.common.grey-label",
            "defaultMessage": "grey"
        },
        darkPurpleLabel: {
            "id": "issue-epic-color.common.dark-purple-label",
            "defaultMessage": "dark purple"
        },
        darkBlueLabel: {
            "id": "issue-epic-color.common.dark-blue-label",
            "defaultMessage": "dark blue"
        },
        darkGreenLabel: {
            "id": "issue-epic-color.common.dark-green-label",
            "defaultMessage": "dark green"
        },
        darkTealLabel: {
            "id": "issue-epic-color.common.dark-teal-label",
            "defaultMessage": "dark teal"
        },
        darkYellowLabel: {
            "id": "issue-epic-color.common.dark-yellow-label",
            "defaultMessage": "dark yellow"
        },
        darkOrangeLabel: {
            "id": "issue-epic-color.common.dark-orange-label",
            "defaultMessage": "dark orange"
        },
        darkGreyLabel: {
            "id": "issue-epic-color.common.dark-grey-label",
            "defaultMessage": "dark grey"
        }
    });
});
parcelRegister("inRSh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f1b6faa7238bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iKImW;
    var $2JKLA;
    var $4R6GH;
    var $koVbs;
    var $drCen;
    const $bc8f1b6faa7238bb$var$Menu = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children, ...restProps } = props;
        const isChecked = props.selectProps?.componentsProps?.isChecked || false;
        const isDefaultChecked = props.selectProps?.componentsProps?.isDefaultChecked || false;
        const label = formatMessage((0, (0, parcelRequire("drCen")).default).checkboxLabel);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === ' ') event.stopPropagation();
        }, []);
        const onChange = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            event.preventDefault();
            props.selectProps?.componentsProps?.onChange?.(event);
        }, [
            props.selectProps?.componentsProps
        ]);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('fix_show_done_issues_checkbox_in_parent_field')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Menu, restProps, (0, ($parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iKImW")).default), {
            onKeyDown: onKeyDown,
            onClick: onChange,
            onChange: (0, ($parcel$interopDefault($8Rkzz))),
            isChecked: isChecked,
            id: "issue-field-parent.ui.edit.menu.checkbox"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxLabel, {
            onClick: onChange,
            htmlFor: "issue-field-parent.ui.edit.menu.checkbox",
            "data-testid": "issue-field-parent.ui.edit.menu.checkbox-label"
        }, label)), children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Menu, restProps, (0, ($parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, {
            onClick: props.selectProps?.componentsProps?.onChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iKImW")).default), {
            defaultChecked: isDefaultChecked,
            onKeyDown: onKeyDown,
            label: label
        })), children);
    };
    var $bc8f1b6faa7238bb$export$2e2bcd8739ae039 = $bc8f1b6faa7238bb$var$Menu;
    const $bc8f1b6faa7238bb$var$CheckboxWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt4lce4 _n7zlpe8f _4cvr1h6o _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $bc8f1b6faa7238bb$var$CheckboxLabel = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iKImW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec5980beae429bf0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $jXXts;
    var $99ZKq;
    var $c8uX8;
    var $8U8U2;
    var $7TKqh;
    const $ec5980beae429bf0$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $ec5980beae429bf0$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("jXXts")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("c8uX8")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $ec5980beae429bf0$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("99ZKq")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8U8U2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7TKqh")).default), null)));
    }));
    $ec5980beae429bf0$var$Checkbox.displayName = 'Checkbox';
    var $ec5980beae429bf0$export$2e2bcd8739ae039 = $ec5980beae429bf0$var$Checkbox;
});
parcelRegister("99ZKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4db890d47c10939a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dqbQ1;
    function $4db890d47c10939a$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $4db890d47c10939a$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$4db890d47c10939a$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dqbQ1")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $4db890d47c10939a$export$2e2bcd8739ae039 = $4db890d47c10939a$var$CheckboxIcon;
});
parcelRegister("c8uX8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9767db9a5c3364bd$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $9767db9a5c3364bd$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $72ba03e317f3d228$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $9767db9a5c3364bd$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $9767db9a5c3364bd$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $72ba03e317f3d228$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $9767db9a5c3364bd$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $72ba03e317f3d228$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $72ba03e317f3d228$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $72ba03e317f3d228$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $72ba03e317f3d228$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $72ba03e317f3d228$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $72ba03e317f3d228$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $72ba03e317f3d228$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $72ba03e317f3d228$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $9767db9a5c3364bd$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $9767db9a5c3364bd$var$baseStyles,
                label && $9767db9a5c3364bd$var$textLabelLayoutStyles,
                isDisabled && $9767db9a5c3364bd$var$disabledStyles,
                $9767db9a5c3364bd$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("8U8U2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e82f3710f559a90a$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $e82f3710f559a90a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e82f3710f559a90a$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $e82f3710f559a90a$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $e82f3710f559a90a$var$labelTextStyles
        }, children);
    }
});
parcelRegister("7TKqh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75f0ce159cbebe91$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $75f0ce159cbebe91$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $72ba03e317f3d228$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $75f0ce159cbebe91$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $75f0ce159cbebe91$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("drCen", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c6a6ed4bb83a84$export$2e2bcd8739ae039);
    var $7VHMR;
    var $90c6a6ed4bb83a84$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        checkboxLabel: {
            "id": "issue-field-parent.edit.menu.checkbox-label",
            "defaultMessage": "Show done issues"
        }
    });
});
parcelRegister("3orGF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f57b6631f3fbd470$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f57b6631f3fbd470$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "issue-field-parent.edit.no-matches",
            "defaultMessage": "No matches"
        },
        failedFetch: {
            "id": "issue-field-parent.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        placeholder: {
            "id": "issue-field-parent.edit.placeholder",
            "defaultMessage": "Select parent"
        },
        loading: {
            "id": "issue-field-parent.edit.loading",
            "defaultMessage": "Searching..."
        }
    });
});
parcelRegister("1sPJ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3aae186893156b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cQ0ub;
    var $koVbs;
    var $iVcsU;
    var $hVITp;
    var $am1jp;
    const $3aae186893156b3c$var$renderOptionDescription = (option)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionDescriptionWrapper, null, option.description != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).Description), null, option.description) : null);
    const $3aae186893156b3c$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionColorTypeKeyWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconColorKeyWrapper, null, option?.color ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("iVcsU")).getOptionColorElem)(option?.color), (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconWithColor, {
            src: option.fields?.issuetype.iconUrl,
            alt: iconAltMessage
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Icon, {
            src: option.fields?.issuetype.iconUrl,
            alt: iconAltMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IssueKey, null, option.key)), option.isDone ? (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$DoneWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cQ0ub"))))), {
            primaryColor: `var(--ds-text-success, ${(0, $72ba03e317f3d228$exports).G500})`,
            label: "done-parent-issue"
        }), doneParentLabel) : null);
    const $3aae186893156b3c$var$CustomOption = ({ option: option })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ('fields' in option) {
            const fields = option?.fields;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).OptionWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).OptionTextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).OptionLabel), null, $3aae186893156b3c$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, (0, parcelRequire("hVITp")).default).doneParentLabel), formatMessage((0, (0, parcelRequire("hVITp")).default).icon, {
                issueType: fields?.issuetype.name || ''
            })), option.fields.summary)));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).OptionWrapper), null, option.elemBefore != null ? option.elemBefore : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).OptionTextContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("am1jp")).OptionLabel), null, option.label), $3aae186893156b3c$var$renderOptionDescription(option)));
    };
    var $3aae186893156b3c$export$2e2bcd8739ae039 = $3aae186893156b3c$var$CustomOption;
    const $3aae186893156b3c$var$IconWithColor = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _p12f7vkz",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f7vkz",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$IconColorKeyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$DoneWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$IssueKey = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionColorTypeKeyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz1rc1 _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionDescriptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cQ0ub", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $958ab7d49d641312$var$_react = $958ab7d49d641312$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $958ab7d49d641312$var$_checkMark = $958ab7d49d641312$var$_interopRequireDefault((parcelRequire("bZUh6")));
    function $958ab7d49d641312$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $958ab7d49d641312$var$EditorDoneIcon = (props)=>$958ab7d49d641312$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $958ab7d49d641312$var$_checkMark.default
        }));
    $958ab7d49d641312$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $958ab7d49d641312$var$_default = module.exports.default = $958ab7d49d641312$var$EditorDoneIcon;
});
parcelRegister("bZUh6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8bc10b3745ba142a$var$_react = $8bc10b3745ba142a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8bc10b3745ba142a$var$_UNSAFE_baseNew = $8bc10b3745ba142a$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $8bc10b3745ba142a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8bc10b3745ba142a$var$CheckMarkIcon = (props)=>$8bc10b3745ba142a$var$_react.default.createElement($8bc10b3745ba142a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $8bc10b3745ba142a$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $8bc10b3745ba142a$var$_default = module.exports.default = $8bc10b3745ba142a$var$CheckMarkIcon;
});
parcelRegister("hVITp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3c6ab058a23c088$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c3c6ab058a23c088$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        icon: {
            "id": "issue-field-parent.edit.option.icon",
            "defaultMessage": "{issueType} icon"
        },
        doneParentLabel: {
            "id": "issue-field-parent.edit.option.done-parent-label",
            "defaultMessage": "Done"
        }
    });
});
parcelRegister("am1jp", function(module, exports) {
    $parcel$export(module.exports, "OptionWrapper", ()=>$ab8f2b72ae03fc69$export$d6f6a072cce04542);
    $parcel$export(module.exports, "OptionTextContainer", ()=>$ab8f2b72ae03fc69$export$c6c33847de6c74ef);
    $parcel$export(module.exports, "Description", ()=>$ab8f2b72ae03fc69$export$393edc798c47379d);
    $parcel$export(module.exports, "OptionLabel", ()=>$ab8f2b72ae03fc69$export$2cf7ef1e2dd6c6b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ab8f2b72ae03fc69$export$d6f6a072cce04542 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $ab8f2b72ae03fc69$export$c6c33847de6c74ef = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $ab8f2b72ae03fc69$export$393edc798c47379d = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
                __cmplp.className
            ])
        });
    });
    const $ab8f2b72ae03fc69$export$2cf7ef1e2dd6c6b1 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6v0ju", function(module, exports) {
    $parcel$export(module.exports, "fetchParentsForNew", ()=>$2703467b5174b086$export$73bed6a0175e413);
    $parcel$export(module.exports, "fetchParentsForExisting", ()=>$2703467b5174b086$export$f995718992ca6c2f);
    var $jcw0u;
    var $cWEsa;
    var $cAZGv;
    var $iVcsU;
    const $2703467b5174b086$export$cfeee2ee86ead336 = 'bento';
    const $2703467b5174b086$export$73bed6a0175e413 = async (props)=>{
        const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
        try {
            const response = await (0, (0, parcelRequire("cAZGv")).fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
            return {
                options: (0, (0, parcelRequire("iVcsU")).mapDataToOptions)(response.candidates),
                message: response.message
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchParentsForNew',
                    packageName: 'jiraIssueFieldParent',
                    teamName: $2703467b5174b086$export$cfeee2ee86ead336
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error(error);
        }
    };
    const $2703467b5174b086$export$f995718992ca6c2f = async (props)=>{
        const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
        try {
            const response = await (0, (0, parcelRequire("cWEsa")).fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
            return {
                options: (0, (0, parcelRequire("iVcsU")).mapDataToOptions)(response.candidates),
                message: response.message
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchParentsForExisting',
                    packageName: 'jiraIssueFieldParent',
                    teamName: $2703467b5174b086$export$cfeee2ee86ead336
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("cWEsa", function(module, exports) {
    $parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", ()=>$96b7190bd204920f$export$59a0f41a1d5dcee0);
    var $jJZqs;
    var $d8JF2;
    var $2t8So;
    var $k90nh;
    var $1aPWY;
    const $96b7190bd204920f$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
        const response = (0, (0, parcelRequire("2t8So")).default)(cloudId, issueKey, searchTerm, excludeDone);
        const { data: data, errors: errors } = await response;
        if (!data || errors) {
            const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
            throw new (0, (0, parcelRequire("k90nh")).default)(new Error(message), (0, (0, parcelRequire("d8JF2")).PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        }
        if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
            if (Array.isArray(errors) && errors.length > 0) {
                const errorMessage = JSON.stringify(errors);
                throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, (0, parcelRequire("d8JF2")).PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
            } else throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, (0, parcelRequire("d8JF2")).PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        }
        const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, (0, parcelRequire("1aPWY")).transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
        return {
            candidates: candidates,
            message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
        };
    };
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("d8JF2", function(module, exports) {
    $parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", ()=>$9b9ac42d3f1a3741$export$c7c7f21787854c5b);
    $parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", ()=>$9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5);
    var $bItI4;
    const $9b9ac42d3f1a3741$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
    const $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$9b9ac42d3f1a3741$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, (0, parcelRequire("bItI4")).parentCandidatesForExistingIssueQuery)()}
    }
`;
});
parcelRegister("bItI4", function(module, exports) {
    $parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", ()=>$a63b2f209c365c28$export$f63a6e3151b9dd82);
    const $a63b2f209c365c28$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
    const $a63b2f209c365c28$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
    const $a63b2f209c365c28$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
    const $a63b2f209c365c28$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
    const $a63b2f209c365c28$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a63b2f209c365c28$var$issueType()}
      ${$a63b2f209c365c28$var$summary()}
      ${$a63b2f209c365c28$var$status()}
    }
  }
}`;
    const $a63b2f209c365c28$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$a63b2f209c365c28$var$color()}
              ${$a63b2f209c365c28$var$fieldsById()}
            }
          }
        }
        message
      }
    }
`;
});
parcelRegister("2t8So", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b07071af5f9e15eb$export$2e2bcd8739ae039);
    var $d8JF2;
    var $iBOrg;
    const $b07071af5f9e15eb$export$83bff8b82e36a9e9 = 20;
    var $b07071af5f9e15eb$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
        const variables = {
            cloudId: cloudId,
            issueKey: issueKey,
            searchTerm: searchTerm,
            excludeDone: excludeDone,
            first: $b07071af5f9e15eb$export$83bff8b82e36a9e9
        };
        const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query({
            query: (0, (0, parcelRequire("d8JF2")).buildParentCandidatesForExistingIssueQuery)(),
            variables: variables
        });
        return response;
    };
});
parcelRegister("k90nh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$602ab0b685964cde$export$2e2bcd8739ae039);
    var $jJZqs;
    class $602ab0b685964cde$export$2e2bcd8739ae039 extends Error {
        constructor(error, endpoint){
            if (error instanceof $602ab0b685964cde$export$2e2bcd8739ae039) return error;
            super(error.message);
            this.error = error;
            this.message = error.message;
            if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
                if (error.traceId != null) this.traceId = error.traceId;
                this.statusCode = error.statusCode;
            }
            this.endpoint = endpoint;
        }
    }
});
parcelRegister("1aPWY", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$9711633f84674efa$export$3ceb62baab058c6b);
    var $gULOk;
    var $jJZqs;
    var $heWHN;
    const $9711633f84674efa$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
            const edgeNode = edge.node;
            const fieldsEdges = edgeNode.fieldsById.edges;
            const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
            const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
            const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
            const colorField = edgeNode.issueColorField;
            if (summaryField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'summary',
                    error: 'Call to gira for parent candidates returned without summary data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            if (issueTypeField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'issueType',
                    error: 'Call to gira for parent candidates returned without issue type data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            if (statusField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'status',
                    error: 'Call to gira for parent candidates returned without status data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            if (issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'Issue Color',
                    error: 'Call to gira for parent candidates returned without color data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            const summaryFieldNode = summaryField.node;
            const issueTypeFieldNode = issueTypeField.node;
            const checkParentIssueIsDone = (statusCategoryId)=>{
                const doneStatusCategoryId = (0, (0, parcelRequire("gULOk"))).StatusCategoryIds[(0, (0, parcelRequire("gULOk"))).StatusCategoryTypes.DONE];
                return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
            };
            const isDone = checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId);
            const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
            const parent = {
                id: edgeNode.issueId,
                key: edgeNode.key,
                summary: summaryFieldNode.text,
                issueType: {
                    id: String(issueTypeFieldNode.issueType.issueTypeId),
                    name: issueTypeFieldNode.issueType.name,
                    iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
                },
                isDone: isDone,
                statusCategoryId: statusCategoryId
            };
            return {
                ...parent,
                color: colorField?.color?.colorKey ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
            };
        });
});
parcelRegister("cAZGv", function(module, exports) {
    $parcel$export(module.exports, "fetchParentCandidatesForNewIssue", ()=>$e563dea4a8edeb6a$export$48a29a1313179c04);
    var $jJZqs;
    var $78P89;
    var $iveGN;
    var $k90nh;
    var $1aPWY;
    const $e563dea4a8edeb6a$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
        const response = (0, (0, parcelRequire("iveGN")).default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
        const { data: data, errors: errors } = await response;
        if (!data || errors) {
            const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
            throw new (0, (0, parcelRequire("k90nh")).default)(new Error(message), (0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        }
        if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
            if (Array.isArray(errors) && errors.length > 0) {
                const errorMessage = JSON.stringify(errors);
                throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
            } else throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        }
        const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, (0, parcelRequire("1aPWY")).transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
        return {
            candidates: candidates,
            message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
        };
    };
});
parcelRegister("78P89", function(module, exports) {
    $parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", ()=>$cf42cbd052db3ab7$export$26f006aaa0389bc0);
    $parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", ()=>$cf42cbd052db3ab7$export$453f3d2e0fac3592);
    var $eVi6b;
    const $cf42cbd052db3ab7$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
    const $cf42cbd052db3ab7$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$cf42cbd052db3ab7$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, (0, parcelRequire("eVi6b")).parentCandidatesForNewIssueQuery)()}
    }
`;
});
parcelRegister("eVi6b", function(module, exports) {
    $parcel$export(module.exports, "parentCandidatesForNewIssueQuery", ()=>$5f9b4891c9749af5$export$1dfd5c8a625d5960);
    const $5f9b4891c9749af5$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
    const $5f9b4891c9749af5$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
    const $5f9b4891c9749af5$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
    const $5f9b4891c9749af5$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
    const $5f9b4891c9749af5$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$5f9b4891c9749af5$var$issueType()}
      ${$5f9b4891c9749af5$var$summary()}
      ${$5f9b4891c9749af5$var$status()}
    }
  }
}`;
    const $5f9b4891c9749af5$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$5f9b4891c9749af5$var$color()}
                ${$5f9b4891c9749af5$var$fieldsById()}
              }
            }
          }
          message
        }
      }
`;
});
parcelRegister("iveGN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b9969b12a843159$export$2e2bcd8739ae039);
    var $78P89;
    var $iBOrg;
    const $4b9969b12a843159$export$1fd3b40492f4ef9f = 20;
    var $4b9969b12a843159$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
        const variables = {
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            searchTerm: searchTerm,
            excludeDone: excludeDone,
            first: $4b9969b12a843159$export$1fd3b40492f4ef9f
        };
        const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query({
            query: (0, (0, parcelRequire("78P89")).buildParentCandidatesForNewIssueQuery)(),
            variables: variables,
            operationName: `jira_parenting_${(0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
        });
        return response;
    };
});
parcelRegister("bA6nL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b53543067399a8c2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b53543067399a8c2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        description: {
            "id": "issue-create-commons.parent-field.description",
            "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
        }
    });
});
parcelRegister("eulr6", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultParentValue", ()=>$ca97e2610eb77570$export$f38bec4d01c88544);
    $parcel$export(module.exports, "validateParentField", ()=>$ca97e2610eb77570$export$656803053e0b9113);
    $parcel$export(module.exports, "mutateParentField", ()=>$ca97e2610eb77570$export$15ec054c85ac7db1);
    var $bGrWH;
    var $heWHN;
    const $ca97e2610eb77570$export$f38bec4d01c88544 = (defaultValue)=>{
        const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
        const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
        const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
        const summary = summaryField?.node.text;
        const label = `${key} ${summary}`;
        return {
            label: label,
            value: issueId,
            key: key,
            color: issueColorField && issueColorField.color !== null ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
            fields: {
                summary: summary,
                issuetype: {
                    name: issueTypeField?.node.issueType.name,
                    iconUrl: issueTypeField?.node.issueType.avatar.xsmall
                }
            }
        };
    };
    const $ca97e2610eb77570$export$656803053e0b9113 = (data, isRequired)=>{
        if (isRequired) {
            if (!data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $ca97e2610eb77570$export$15ec054c85ac7db1 = ({ value: value })=>({
            parentField: {
                issueId: value
            }
        });
});
parcelRegister("eRVlU", function(module, exports) {
    $parcel$export(module.exports, "PeopleCustomFieldType", ()=>$f83100d884a853ed$export$531787d3fa23885);
    var $5uXOq = parcelRequire("5uXOq");
    var $3XWBa;
    var $gARR3;
    var $lfWSN;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $f83100d884a853ed$var$PeopleCustomFieldTypeComponent = (props)=>{
        if (props.schemaConfiguration.isMulti) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gARR3")).default), props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfWSN")).default), props);
    };
    const $f83100d884a853ed$export$531787d3fa23885 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("3XWBa"))))),
        type: (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        Component: $f83100d884a853ed$var$PeopleCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).AssigneeFieldPlaceholder), null),
        writer: (id, value, fields)=>Array.isArray(value) ? (0, (0, parcelRequire("kShoa")).multiUserPickerFieldWriter)(id, value, fields) : (0, (0, parcelRequire("kShoa")).singleUserPickerFieldWriter)(id, value, fields)
    };
});
parcelRegister("lfWSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8dbbb313a8b6153d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzCWA;
    const $8dbbb313a8b6153d$var$SingleUserPickerField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzCWA")).default), {
            ...props,
            isMulti: false,
            context: "CustomUserField"
        });
    var $8dbbb313a8b6153d$export$2e2bcd8739ae039 = $8dbbb313a8b6153d$var$SingleUserPickerField;
});
parcelRegister("cK31e", function(module, exports) {
    $parcel$export(module.exports, "PriorityFieldTypeConfig", ()=>$73ea0385fc1a41bb$export$63f81e33b9847d28);
    var $5uXOq = parcelRequire("5uXOq");
    var $cX3aW;
    var $2QZDj;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $73ea0385fc1a41bb$var$PriorityFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QZDj")).default), props);
    const $73ea0385fc1a41bb$export$63f81e33b9847d28 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("cX3aW"))))),
        type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        Component: $73ea0385fc1a41bb$var$PriorityFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).priorityFieldWriter)
    };
});
parcelRegister("cX3aW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $96dd75500b03de5a$var$_react = $96dd75500b03de5a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $96dd75500b03de5a$var$_UNSAFE_baseNew = $96dd75500b03de5a$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $96dd75500b03de5a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $96dd75500b03de5a$var$PriorityHighestIcon = (props)=>$96dd75500b03de5a$var$_react.default.createElement($96dd75500b03de5a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M2.5 11.875 8 8.25l5.5 3.625m-11-4.5L8 3.75l5.5 3.625"/>`
        }, props));
    $96dd75500b03de5a$var$PriorityHighestIcon.displayName = 'PriorityHighestIcon';
    var $96dd75500b03de5a$var$_default = module.exports.default = $96dd75500b03de5a$var$PriorityHighestIcon;
});
parcelRegister("2QZDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29a3848e499878f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qOqP;
    var $4IxfP;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $hnBts;
    const $b29a3848e499878f$var$PriorityField = (props)=>{
        const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
        const options = (0, (0, parcelRequire("4IxfP")).mapDataToOptions)(allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4qOqP")).default), {
            options: options,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly,
            inputId: id,
            isRequired: isRequired,
            ariaLabelledBy: ariaLabelledBy
        }));
    };
    var $b29a3848e499878f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validatePriorityField),
        transformDefaultValue: (0, parcelRequire("hnBts")).transformDefaultValue
    })($b29a3848e499878f$var$PriorityField);
});
parcelRegister("4qOqP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00acd3f7bdd60a4f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gN6Vx;
    var $9UhzQ;
    var $lElIo;
    const $00acd3f7bdd60a4f$var$PriorityEdit = (props)=>{
        const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            inputId: inputId,
            required: isRequired,
            value: value,
            options: options,
            placeholder: placeholder,
            onChange: onChange,
            onFocus: onFocus,
            onBlur: onBlur,
            autoFocus: autoFocus,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
            isClearable: false,
            hideSelectedOptions: true,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isDisabled,
            classNamePrefix: classNamePrefix,
            openMenuOnFocus: openMenuOnFocus,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $00acd3f7bdd60a4f$export$2e2bcd8739ae039 = $00acd3f7bdd60a4f$var$PriorityEdit;
});
parcelRegister("9UhzQ", function(module, exports) {
    $parcel$export(module.exports, "formatOptionLabel", ()=>$7c6c645af44efe7b$export$322216d90ffb8d0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1IqIJ;
    const $7c6c645af44efe7b$export$b4053b30a2d3983b = (props)=>{
        const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexRow, null, Boolean(iconUrl) && (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$AvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            appearance: "square",
            size: "xsmall",
            src: iconUrl,
            borderColor: "transparent"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexColumn, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
        }, label), optionContext === 'menu' && Boolean(description) && (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$Description, null, description)));
    };
    const $7c6c645af44efe7b$export$322216d90ffb8d0e = (option, { context: context })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$export$b4053b30a2d3983b, {
            option: option,
            optionContext: context
        });
    const $7c6c645af44efe7b$var$FlexRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $7c6c645af44efe7b$var$FlexColumn = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2lx21bp4 _1e0c1txw _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $7c6c645af44efe7b$var$AvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $7c6c645af44efe7b$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wyb1skh _syaz1rc1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hnBts", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultValue", ()=>$f6b5541ab69f5e0c$export$e2f4e5d31db527cc);
    $parcel$export(module.exports, "mutatePriorityField", ()=>$f6b5541ab69f5e0c$export$2c46dd13be598543);
    const $f6b5541ab69f5e0c$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        });
    const $f6b5541ab69f5e0c$export$2c46dd13be598543 = ({ value: value })=>({
            priority: {
                priorityId: value
            }
        });
});
parcelRegister("9HQd3", function(module, exports) {
    $parcel$export(module.exports, "RadioButtonsCustomFieldTypeConfig", ()=>$238501c66641cf61$export$2483417b1f9a587c);
    var $5uXOq = parcelRequire("5uXOq");
    var $7AN3k;
    var $evAhI;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $238501c66641cf61$var$RadioButtonsCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("evAhI")).default), props);
    const $238501c66641cf61$export$2483417b1f9a587c = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("7AN3k"))))),
        type: (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE),
        Component: $238501c66641cf61$var$RadioButtonsCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).radioSelectFieldWriter)
    };
});
parcelRegister("evAhI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfa82702cc29d68e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2wOz;
    var $aSk8p;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $glFZG;
    const $dfa82702cc29d68e$var$RadioSelectField = (props)=>{
        const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false }, isReadOnly: isReadOnly = false, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
        const options = (0, (0, parcelRequire("aSk8p")).mapDataToOptions)(allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g2wOz")).default), {
            options: options,
            isDisabled: isReadOnly || isDisabled,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            ariaLabelledBy: ariaLabelledBy
        }));
    };
    var $dfa82702cc29d68e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateRadioSelectField),
        transformDefaultValue: (0, parcelRequire("glFZG")).transformDefaultValue
    })($dfa82702cc29d68e$var$RadioSelectField);
});
parcelRegister("g2wOz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1767240ecaf9413$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNYo9;
    var $lElIo;
    const $c1767240ecaf9413$var$RadioSelectEdit = (props)=>{
        const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', isDisabled: isDisabled = false, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNYo9")).default), {
            classNamePrefix: classNamePrefix,
            value: value,
            options: options,
            isDisabled: isDisabled,
            placeholder: placeholder,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onChange: onChange,
            onFocus: onFocus,
            closeMenuOnScroll: onCloseMenuOnScroll,
            onBlur: onBlur,
            autoFocus: autoFocus,
            validationState: isInvalid === true ? 'error' : null,
            isClearable: isClearable,
            openMenuOnFocus: openMenuOnFocus,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $c1767240ecaf9413$export$2e2bcd8739ae039 = $c1767240ecaf9413$var$RadioSelectEdit;
});
parcelRegister("bNYo9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e9b2078c855dd6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gN6Vx;
    var $5J9wY;
    const $d1e9b2078c855dd6$var$RadioSelect = (0, ($parcel$interopDefault($5uXOq))).memo(({ components: components, ...props })=>{
        const mergedComponents = (0, $5uXOq.useMemo)(()=>({
                ...components,
                Option: (0, (0, parcelRequire("5J9wY")).RadioOption)
            }), [
            components
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            ...props,
            isMulti: false,
            components: mergedComponents
        });
    });
    var $d1e9b2078c855dd6$export$2e2bcd8739ae039 = $d1e9b2078c855dd6$var$RadioSelect;
});
parcelRegister("5J9wY", function(module, exports) {
    $parcel$export(module.exports, "CheckboxOption", ()=>$79e2fb5697ce2f8b$export$d40cc97ecda916f9);
    $parcel$export(module.exports, "RadioOption", ()=>$79e2fb5697ce2f8b$export$82ab7168879267a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8lPvK;
    var $b54DD;
    function $79e2fb5697ce2f8b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $79e2fb5697ce2f8b$var$getPrimitiveStyles = (props)=>{
        const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
        const baseStyles = {
            alignItems: 'center',
            backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})` : 'transparent',
            color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
            display: 'flex ',
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-050, 4px)",
            boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`}` : 'none',
            ':active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: isFocused ? '2px solid transparent' : ''
            }
        };
        const augmentedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
            ...getStyles('option', props),
            ...baseStyles
        });
        const bemClasses = {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        };
        return [
            augmentedStyles,
            cx(bemClasses, className)
        ];
    };
    const $79e2fb5697ce2f8b$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$8c13c2ee36917869})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$8d43898f60b96a82})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $72ba03e317f3d228$export$8c13c2ee36917869})`;
        else if (isActive) return `var(--ds-background-selected-pressed, ${0, $72ba03e317f3d228$export$8c13c2ee36917869})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $72ba03e317f3d228$export$e62e8919cca44969})`;
        else if (isFocused) return `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        return `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`;
    };
    const $79e2fb5697ce2f8b$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
        else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        else if (!isSelected) return 'transparent';
        return `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`;
    };
    const $79e2fb5697ce2f8b$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        else if (isDisabled) return `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
        else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        else if (isActive) return `var(--ds-background-selected-bold, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        else if (isFocused) return `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
        else if (isSelected) return `var(--ds-background-selected-bold, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
        return `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
    };
    const $79e2fb5697ce2f8b$var$baseIconStyles = {
        name: "35x0q3",
        styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
    };
    const $79e2fb5697ce2f8b$var$baseOptionStyles = {
        name: "16e0ede",
        styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    class $79e2fb5697ce2f8b$var$ControlOption extends (0, $5uXOq.Component) {
        render() {
            const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
            const props = {
                ...innerProps,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            const [styles, classes] = $79e2fb5697ce2f8b$var$getPrimitiveStyles({
                getStyles: getStyles,
                ...rest
            });
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: styles,
                className: classes,
                ref: innerRef,
                ...props
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $79e2fb5697ce2f8b$var$baseIconStyles,
                    {
                        '& svg rect, & svg circle:first-of-type': {
                            stroke: $79e2fb5697ce2f8b$var$getBorderColor({
                                ...this.props,
                                ...this.state
                            })
                        }
                    }
                ]
            }, !!Icon ? (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, {
                label: "",
                primaryColor: $79e2fb5697ce2f8b$var$getPrimaryColor({
                    ...this.props,
                    ...this.state
                }),
                secondaryColor: $79e2fb5697ce2f8b$var$getSecondaryColor({
                    ...this.props,
                    ...this.state
                }),
                isFacadeDisabled: true
            }) : null), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $79e2fb5697ce2f8b$var$baseOptionStyles
            }, children)));
        }
        constructor(...args){
            super(...args);
            this.state = {
                isActive: false
            };
            this.onMouseDown = ()=>this.setState({
                    isActive: true
                });
            this.onMouseUp = ()=>this.setState({
                    isActive: false
                });
            this.onMouseLeave = ()=>this.setState({
                    isActive: false
                });
        }
    }
    const $79e2fb5697ce2f8b$export$d40cc97ecda916f9 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($79e2fb5697ce2f8b$var$ControlOption, {
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("8lPvK"))))),
            ...props
        });
    const $79e2fb5697ce2f8b$export$82ab7168879267a7 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($79e2fb5697ce2f8b$var$ControlOption, {
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("b54DD"))))),
            ...props
        });
});
parcelRegister("8lPvK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $61483decc0e57b68$var$_react = $61483decc0e57b68$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $61483decc0e57b68$var$_checkboxChecked = $61483decc0e57b68$var$_interopRequireDefault((parcelRequire("cB6mQ")));
    function $61483decc0e57b68$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $61483decc0e57b68$var$CheckboxIcon = (props)=>$61483decc0e57b68$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $61483decc0e57b68$var$_checkboxChecked.default
        }));
    $61483decc0e57b68$var$CheckboxIcon.displayName = 'CheckboxIcon';
    var $61483decc0e57b68$var$_default = module.exports.default = $61483decc0e57b68$var$CheckboxIcon;
});
parcelRegister("cB6mQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92bde1349c69e776$var$_react = $92bde1349c69e776$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $92bde1349c69e776$var$_UNSAFE_baseNew = $92bde1349c69e776$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $92bde1349c69e776$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92bde1349c69e776$var$CheckboxCheckedIcon = (props)=>$92bde1349c69e776$var$_react.default.createElement($92bde1349c69e776$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $92bde1349c69e776$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
    var $92bde1349c69e776$var$_default = module.exports.default = $92bde1349c69e776$var$CheckboxCheckedIcon;
});
parcelRegister("b54DD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8113c2653da74710$var$_react = $8113c2653da74710$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $8113c2653da74710$var$_radioChecked = $8113c2653da74710$var$_interopRequireDefault((parcelRequire("3Z46d")));
    function $8113c2653da74710$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8113c2653da74710$var$RadioIcon = (props)=>$8113c2653da74710$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
        }, props, {
            newIcon: $8113c2653da74710$var$_radioChecked.default
        }));
    $8113c2653da74710$var$RadioIcon.displayName = 'RadioIcon';
    var $8113c2653da74710$var$_default = module.exports.default = $8113c2653da74710$var$RadioIcon;
});
parcelRegister("3Z46d", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2e6a3fa09edabe84$var$_react = $2e6a3fa09edabe84$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2e6a3fa09edabe84$var$_UNSAFE_baseNew = $2e6a3fa09edabe84$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $2e6a3fa09edabe84$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2e6a3fa09edabe84$var$RadioCheckedIcon = (props)=>$2e6a3fa09edabe84$var$_react.default.createElement($2e6a3fa09edabe84$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
        }, props));
    $2e6a3fa09edabe84$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
    var $2e6a3fa09edabe84$var$_default = module.exports.default = $2e6a3fa09edabe84$var$RadioCheckedIcon;
});
parcelRegister("glFZG", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultValue", ()=>$bab8deb286f07f08$export$e2f4e5d31db527cc);
    const $bab8deb286f07f08$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
            label: value,
            value: id
        });
});
parcelRegister("7lpSO", function(module, exports) {
    $parcel$export(module.exports, "SelectCustomFieldTypeConfig", ()=>$a425e0c10378516d$export$8ed2c57b191fc5f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Upkx;
    var $k4tyx;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $a425e0c10378516d$var$SelectCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k4tyx")).default), {
            ...props,
            defaultValue: undefined
        });
    const $a425e0c10378516d$export$8ed2c57b191fc5f5 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("6Upkx"))))),
        type: (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        Component: $a425e0c10378516d$var$SelectCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).selectFieldWriter)
    };
});
parcelRegister("chk7J", function(module, exports) {
    $parcel$export(module.exports, "SprintFieldTypeConfig", ()=>$7cbcc31fd938100a$export$da0c478aebabb75b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lvWkV;
    var $5fc53;
    var $9gHYS;
    var $3Xb7y;
    var $kShoa;
    const $7cbcc31fd938100a$var$SprintFieldTypeComponent = (props)=>{
        const { projectKey: projectKey, canUserViewProject: canUserViewProject } = props;
        if (!projectKey || !canUserViewProject) return null;
        const autoCompleteUrl = `/rest/greenhopper/1.0/sprint/picker?projectKey=${projectKey}&query=`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Xb7y")).default), {
            ...props,
            autoCompleteUrl: autoCompleteUrl
        });
    };
    const $7cbcc31fd938100a$export$da0c478aebabb75b = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("lvWkV"))))),
        type: (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        Component: $7cbcc31fd938100a$var$SprintFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).selectFieldWriter)
    };
});
parcelRegister("lvWkV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fa99bea734a9d293$var$_react = $fa99bea734a9d293$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fa99bea734a9d293$var$_UNSAFE_baseNew = $fa99bea734a9d293$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fa99bea734a9d293$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fa99bea734a9d293$var$SprintIcon = (props)=>$fa99bea734a9d293$var$_react.default.createElement($fa99bea734a9d293$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $fa99bea734a9d293$var$SprintIcon.displayName = 'SprintIcon';
    var $fa99bea734a9d293$var$_default = module.exports.default = $fa99bea734a9d293$var$SprintIcon;
});
parcelRegister("3Xb7y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50063478b6346348$export$2e2bcd8739ae039);
    var $hpV4g;
    var $3pqs3;
    var $aqMtW;
    var $6iZh4;
    var $50063478b6346348$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aqMtW")).transformDefaultSprintValue),
        validator: (0, (0, parcelRequire("6iZh4")).validateRequired),
        shouldRenderFieldMessage: false
    })((0, (0, parcelRequire("3pqs3")).SprintField));
});
parcelRegister("3pqs3", function(module, exports) {
    $parcel$export(module.exports, "SprintField", ()=>$83fe5b61920278eb$export$617303ef516d5a01);
    $parcel$export(module.exports, "default", ()=>$83fe5b61920278eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $gT07g;
    var $loZC0;
    var $6s1PB;
    var $koVbs;
    var $io7kF;
    var $3spCR;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $ahEu3;
    var $aqMtW;
    const $83fe5b61920278eb$export$617303ef516d5a01 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
        const renderSprintEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("io7kF")).default), {
                fieldId: fieldId,
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: value,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                fetchSuggestionsOnMount: false,
                autoFocus: autoFocus,
                isInvalid: Boolean(error),
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                isDisabled: isEditable === false,
                getSuggestions: (0, (0, parcelRequire("aqMtW")).getSprintSuggestions),
                ...selectedProject?.projectKey ? {
                    projectKey: selectedProject?.projectKey
                } : {},
                inputId: id,
                isRequired: isRequired
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: nonEditableReason?.message || ''
        }, renderSprintEdit()) : renderSprintEdit(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }), value && value.state === (0, (0, parcelRequire("3spCR")).ACTIVE_SPRINT_STATE) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $83fe5b61920278eb$var$messageContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gT07g")).default), {
            appearance: "warning",
            testId: "issue-create-commons.ui.sprint-field.required-fields-message"
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("ahEu3")).default).activeSprintSelectionWarningMessageIssueTermRefresh : (0, (0, parcelRequire("ahEu3")).default).activeSprintSelectionWarningMessage))) : null);
    };
    var $83fe5b61920278eb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aqMtW")).transformDefaultSprintValue),
        shouldRenderFieldMessage: false
    })($83fe5b61920278eb$export$617303ef516d5a01);
    const $83fe5b61920278eb$var$messageContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.050'
    });
});
parcelRegister("io7kF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e42898dffd6db898$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $4R6GH;
    var $koVbs;
    var $6Vzc4;
    var $3BhEA;
    var $9UhzQ;
    var $lElIo;
    var $gcvId;
    var $5fc53;
    var $249dD;
    var $bW9R0;
    var $egtXp;
    var $gxJKL;
    var $ckVH2;
    const $e42898dffd6db898$export$251bdbdbce9550ea = 300;
    const $e42898dffd6db898$var$SprintEdit = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, (0, parcelRequire("5fc53")).SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus, 'aria-labelledby': ariaLabelledBy } = props;
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const lastQuery = (0, $5uXOq.useRef)('');
        const [restrictSprints, setRestrictSprint] = (0, $5uXOq.useState)((0, (0, parcelRequire("egtXp")).getCheckboxValueFromLocalStorage)((0, (0, parcelRequire("egtXp")).EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
        const isInitialMount = (0, $5uXOq.useRef)(true);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, (0, parcelRequire("bW9R0")).useSprintSuggestions)({
            getSuggestions: getSuggestions
        });
        const onCheckboxClick = (0, $5uXOq.useCallback)(()=>{
            setRestrictSprint(!restrictSprints);
            (0, (0, parcelRequire("egtXp")).setCheckBoxValueInLocalStorage)((0, (0, parcelRequire("egtXp")).EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
        }, [
            restrictSprints
        ]);
        const componentProps = (0, $5uXOq.useMemo)(()=>({
                isChecked: restrictSprints,
                onChange: onCheckboxClick,
                projectKey: projectKey
            }), [
            restrictSprints,
            projectKey,
            onCheckboxClick
        ]);
        const handleSuggestions = (0, $5uXOq.useCallback)((results, query)=>{
            if (lastQuery.current === query) {
                const transformSuggestions = useTransformSuggestions || (0, (0, parcelRequire("249dD")).transformSuggestions);
                const response = transformSuggestions(results, formatMessage);
                if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
                setSuggestions(response);
                if (query === '') setDefaultSuggestions(response);
            }
        }, [
            formatMessage,
            useTransformSuggestions,
            onPostTransformSuggestions
        ]);
        const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).FailedFetchOptionWrapper), null, formatMessage((0, (0, parcelRequire("ckVH2")).default).failedFetch)), [
            formatMessage
        ]);
        const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            try {
                let response;
                if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
                else response = await getSprintSuggestions(autoCompleteUrl, query);
                handleSuggestions(response, query);
            } catch (err) {
                setHasLastFetchFailed(true);
                const failedOption = [
                    {
                        label: getFailedFetchMessage(),
                        value: '',
                        isDisabled: true
                    }
                ];
                setSuggestions(failedOption);
            }
        }, [
            autoCompleteUrl,
            restrictSprints,
            projectKey,
            getFailedFetchMessage,
            getSprintSuggestions,
            handleSuggestions
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                } else if (options && !defaultSuggestions) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                }
            }
        }, []);
        const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(fetchSuggestions, $e42898dffd6db898$export$251bdbdbce9550ea), [
            restrictSprints
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, (0, parcelRequire("ckVH2")).default).empty), [
            formatMessage,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, (0, parcelRequire("ckVH2")).default).loading), [
            formatMessage,
            loadingMessage
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, query || '');
        }, [
            hasLastFetchFailed
        ]);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedFetchSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                lastQuery.current = query;
                setIsLoadingSuggestions(true);
                debouncedFetchSuggestions(query);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedFetchSuggestions,
            defaultSuggestions,
            setIsLoadingSuggestions,
            setSuggestions
        ]);
        const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
            if (!suggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions('');
            }
            onFocus && onFocus(e);
        }, [
            fetchSuggestions,
            onFocus,
            setIsLoadingSuggestions,
            suggestions
        ]);
        const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
            onBlur && onBlur(e);
        }, [
            onBlur
        ]);
        const onValueChange = (0, $5uXOq.useCallback)((newValues)=>{
            onChange && onChange(newValues, suggestions);
        }, [
            onChange,
            suggestions
        ]);
        const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
        (0, $5uXOq.useEffect)(()=>{
            if (!isInitialMount.current) {
                setIsLoadingSuggestions(true);
                debouncedFetchSuggestions(lastQuery.current);
            }
            isInitialMount.current = false;
        }, [
            restrictSprints,
            debouncedFetchSuggestions,
            setIsLoadingSuggestions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gcvId")).default), {
            inputId: inputId,
            isRequired: isRequired,
            isClearable: true,
            hideSelectedOptions: true,
            autoFocus: autoFocus,
            fieldId: fieldId,
            options: suggestions,
            value: value,
            onBlur: onSelectBlur,
            menuPosition: menuPosition,
            componentsProps: projectKey ? componentProps : undefined,
            components: projectKey ? {
                Menu: (0, parcelRequire("gxJKL")).default
            } : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            closeMenuOnScroll: onCloseMenuOnScroll,
            loadingMessage: getLoadingMessage,
            placeholder: formatMessage((0, (0, parcelRequire("ckVH2")).default).placeholder),
            onInputChange: onQueryChange,
            onChange: onValueChange,
            spacing: spacing,
            isLoading: isLoadingSuggestions,
            filterOption: filterOption,
            formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
            validationState: isInvalid === true ? 'error' : null,
            isDisabled: isDisabled,
            openMenuOnFocus: openMenuOnFocus,
            ...(0, (0, parcelRequire("4R6GH")).fg)('bulk-transitions-fix-a11y-violations') && {
                'aria-labelledby': ariaLabelledBy
            }
        });
    };
    var $e42898dffd6db898$export$2e2bcd8739ae039 = $e42898dffd6db898$var$SprintEdit;
});
parcelRegister("gcvId", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2132d0cd1f409256$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $6AKkW;
    var $6RCeq;
    var $co1wz;
    var $koVbs;
    var $db8jg;
    var $2OMDV;
    var $8zOmE;
    var $lwMsT;
    var $8z9w3;
    var $dKKqb;
    const $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
    const $2132d0cd1f409256$var$analyticsProps = {
        onChange: 'valueChanged',
        onInputChange: 'inputChanged',
        onMenuOpen: 'menuOpened',
        onMenuClose: 'menuClosed'
    };
    const $2132d0cd1f409256$export$53574ab050410077 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('select', $2132d0cd1f409256$var$analyticsProps)((0, (0, parcelRequire("6AKkW")).default));
    const $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView = (props)=>{
        const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel = '' } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasSessionStarted = (0, $5uXOq.useRef)(false);
        const sessionId = (0, $5uXOq.useRef)(customSessionId);
        const sessionStartedAt = (0, $5uXOq.useRef)(0);
        const endSessionRef = (0, $5uXOq.useRef)(undefined);
        const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
        const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const flatOptions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("dKKqb")).flattenOptions)(options), [
            options
        ]);
        const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
            const selectedOptions = !(0, ($parcel$interopDefault($hGgHi)))(value) ? value : [];
            let filteredOptions = (0, (0, parcelRequire("dKKqb")).filterOptions)(flatOptions, query);
            const optionsLength = filteredOptions.length;
            filteredOptions = filteredOptions.slice(0, $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
            const safeFilteredOptions = (0, (0, parcelRequire("dKKqb")).getSafeOptionsForAnalytics)(filteredOptions);
            return {
                inputId: inputId,
                required: isRequired,
                fieldId: fieldId,
                isLoading: isLoading,
                optionsLength: optionsLength,
                componentName: 'select',
                packageName: '@atlaskit/select',
                optionValuesSafeForAnalytics: false,
                options: safeFilteredOptions,
                optionsLengths: (0, (0, parcelRequire("dKKqb")).getOptionValuesLengths)(filteredOptions),
                queryLength: query.length,
                queryHash: query === '' ? query : (0, (0, parcelRequire("db8jg")).memoizedHashString)(query),
                selectedOptions: (0, (0, parcelRequire("dKKqb")).getSafeOptionsForAnalytics)(selectedOptions),
                selectedOptionsLengths: (0, (0, parcelRequire("dKKqb")).getOptionValuesLengths)(selectedOptions),
                sessionId: sessionId.current,
                truncationSize: $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
            };
        }, [
            value,
            flatOptions,
            inputId,
            isRequired,
            fieldId,
            isLoading
        ]);
        const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
            const matchedIndexes = [];
            flatOptions.forEach((option, index)=>{
                if (option.value === selectedItem.value) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        }, [
            flatOptions
        ]);
        const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(query),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
        }, [
            getAnalyticsAttributes
        ]);
        const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(savedQuery),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
        }, [
            getAnalyticsAttributes,
            savedQuery
        ]);
        const startSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current === undefined) sessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            sessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const endSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current !== undefined) {
                const currentStartedAt = sessionStartedAt.current;
                const elapsedTime = currentStartedAt === 0 ? (0, (0, parcelRequire("6RCeq")).default).now() - currentStartedAt : 0;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime
                });
            }
            sessionId.current = undefined;
            sessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const restartSession = (0, $5uXOq.useCallback)(()=>{
            endSession();
            startSession();
        }, [
            endSession,
            startSession
        ]);
        const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') setQueryAtSetValue(savedQuery);
            setSavedQuery(query);
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            fireUIAnalyticsEvent(analyticsEvent, query);
        }, [
            fireUIAnalyticsEvent,
            savedQuery,
            setSavedQuery,
            setQueryAtSetValue
        ]);
        const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("dKKqb")).getSafeValue)(option.value),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
                removedItem: option ? (0, (0, parcelRequire("dKKqb")).getSafeValue)(option.value) : undefined
            });
        }, [
            fireUIAnalyticsEvent,
            savedQuery
        ]);
        const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("dKKqb")).getSafeValue)(option.value),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                selectedOrder: getItemOrder(option),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            getItemOrder,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            onChange && onChange(selectedOptionOrOptions, actionMeta);
        }, [
            fireOptionCreatedEvent,
            fireOptionRemovedEvent,
            fireOptionSelectedEvent,
            onChange
        ]);
        const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
            onInputChange && onInputChange(query, sessionId.current);
        }, [
            fireInputChangedEvent,
            onInputChange,
            sessionId
        ]);
        const isValidNewOption = (0, $5uXOq.useCallback)(()=>!!canCreateNewItem, [
            canCreateNewItem
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasSessionStarted.current) {
                startSession();
                fireInputChangedEvent('', {
                    action: 'fake-action'
                }, createAnalyticsEvent({}));
                hasSessionStarted.current = true;
            }
        }, [
            createAnalyticsEvent,
            fireInputChangedEvent,
            startSession
        ]);
        (0, $5uXOq.useEffect)(()=>{
            endSessionRef.current = endSession;
        }, [
            endSession
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                endSessionRef.current && endSessionRef.current();
            }, []);
        const passRequiredProp = (0, (0, parcelRequire("co1wz")).ff)('pass-required-prop-to-createble-select-from-sprint-field_yvnwn', false);
        const { isRequired: required, ...propsWithoutRequired } = props;
        const propsToSpread = passRequiredProp ? propsWithoutRequired : props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2132d0cd1f409256$export$53574ab050410077, {
            ...propsToSpread,
            ...passRequiredProp ? {
                required: isRequired
            } : {},
            onChange: onChangeWithAnalytics,
            onInputChange: onInputChangeWithAnalytics,
            isValidNewOption: isValidNewOption,
            label: ariaLabel || formatMessage((0, (0, parcelRequire("8z9w3")).default).ariaLabelForSelect)
        });
    };
    var $2132d0cd1f409256$export$2e2bcd8739ae039 = $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView;
});
parcelRegister("8z9w3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$283d0de21cddfa94$export$2e2bcd8739ae039);
    var $7VHMR;
    var $283d0de21cddfa94$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ariaLabelForSelect: {
            "id": "issue-field-select-with-analytics.ariaLabel",
            "defaultMessage": "Select Field"
        }
    });
});
parcelRegister("dKKqb", function(module, exports) {
    $parcel$export(module.exports, "getSafeValue", ()=>$52dde5a2f186bbcb$export$d05672fd1312a6d);
    $parcel$export(module.exports, "getSafeOptionsForAnalytics", ()=>$52dde5a2f186bbcb$export$fde3d804891b8254);
    $parcel$export(module.exports, "flattenOptions", ()=>$52dde5a2f186bbcb$export$7baa7c13b358b002);
    $parcel$export(module.exports, "getOptionValuesLengths", ()=>$52dde5a2f186bbcb$export$e2e167245697ed4e);
    $parcel$export(module.exports, "filterOptions", ()=>$52dde5a2f186bbcb$export$60d56ed3961c839c);
    var $chc6P = parcelRequire("chc6P");
    var $db8jg;
    const $52dde5a2f186bbcb$export$d05672fd1312a6d = (val)=>(0, (0, parcelRequire("db8jg")).memoizedHashString)(val.toString()).toString();
    const $52dde5a2f186bbcb$export$fde3d804891b8254 = (items)=>{
        const itemsToFilter = Array.isArray(items) ? items : [
            items
        ];
        return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$52dde5a2f186bbcb$export$d05672fd1312a6d(value));
    };
    const $52dde5a2f186bbcb$export$7baa7c13b358b002 = (optionGroups)=>(0, ($parcel$interopDefault($chc6P)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
                optionOrGroup
            ]));
    const $52dde5a2f186bbcb$export$e2e167245697ed4e = (items)=>{
        const itemsToFilter = Array.isArray(items) ? items : [
            items
        ];
        return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
    };
    const $52dde5a2f186bbcb$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));
});
parcelRegister("249dD", function(module, exports) {
    $parcel$export(module.exports, "hasState", ()=>$cfadc135289d0d3a$export$d2fec4e2fc5f065a);
    $parcel$export(module.exports, "findSprintWithState", ()=>$cfadc135289d0d3a$export$fb6b70a9c996212b);
    $parcel$export(module.exports, "mapSprintOptionToData", ()=>$cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
    $parcel$export(module.exports, "transformSuggestions", ()=>$cfadc135289d0d3a$export$1d0ee4320c26fb60);
    var $3spCR;
    var $e7pk8;
    const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
    const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
    const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
        if (!sprints) return undefined;
        return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
    };
    const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
        if (state !== undefined) {
            const stateKey = state.toUpperCase();
            return (0, (0, parcelRequire("3spCR")).SPRINT_STATES)[stateKey];
        }
        return undefined;
    };
    const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
    const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
            id: Number(option.value),
            name: String(option.label),
            state: option.state,
            boardId: Number(option.data?.boardId) || 0
        });
    const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
    const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
            id: Number(option.value),
            boardName: option.description,
            name: String(option.label),
            stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
            date: String(option.data?.date)
        });
    const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
    const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
            id: sprint.id,
            description: sprint.boardName,
            label: sprint.name,
            state: sprint.stateKey,
            value: sprint.id,
            data: {
                date: sprint.date,
                fromCache: sprint.fromCache
            }
        });
    const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
            id: sprint.id,
            name: sprint.name,
            href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
            endDate: sprint.endDate || ''
        });
    const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
            label: sprint.name,
            value: sprint.id,
            href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
            state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
            data: {
                boardId: sprint.boardId,
                date: sprint.startDate
            }
        });
    const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
    const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
        const serverSuggestions = suggestionsFromServer.suggestions || [];
        const allMatches = suggestionsFromServer.allMatches || [];
        const allItems = serverSuggestions.concat(allMatches);
        const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, (0, parcelRequire("3spCR")).ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
        const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, (0, parcelRequire("3spCR")).FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
        const sprints = [
            {
                label: formatMessage((0, (0, parcelRequire("e7pk8")).default).activeSprints),
                options: activeItems
            },
            {
                label: formatMessage((0, (0, parcelRequire("e7pk8")).default).futureSprints),
                options: futureItems
            }
        ];
        return sprints;
    };
});
parcelRegister("3spCR", function(module, exports) {
    $parcel$export(module.exports, "ACTIVE_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$3ebc9911a79d714f);
    $parcel$export(module.exports, "FUTURE_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$863e42082c6bde5);
    $parcel$export(module.exports, "CLOSED_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$86cdef09a89e8c4b);
    $parcel$export(module.exports, "SPRINT_STATES", ()=>$113c1ed08a0bda4f$export$73a0206a4dc59760);
    const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
    const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
    const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
    const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
        ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
        CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
        FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
    };
});
parcelRegister("e7pk8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f3d56beb10e0cde$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        activeSprints: {
            "id": "issue-field-sprint.common.active-sprints",
            "defaultMessage": "Active"
        },
        futureSprints: {
            "id": "issue-field-sprint.common.future-sprints",
            "defaultMessage": "Future"
        },
        recentSprints: {
            "id": "issue-field-sprint.common.recent-sprints",
            "defaultMessage": "Recent sprints"
        }
    });
});
parcelRegister("bW9R0", function(module, exports) {
    $parcel$export(module.exports, "useSprintSuggestions", ()=>$76a69867a9473261$export$16d0ab78a0b529dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
        maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
        maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
    });
    const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
        let queryString;
        if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
        else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(queryString);
    };
    const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
        const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
        const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
        const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
            try {
                const response = await getSuggestions(autoCompleteUrl, query, projectKey);
                setIsLoadingSuggestions(false);
                return response;
            } catch (error) {
                setIsLoadingSuggestions(false);
                throw error;
            }
        }, [
            getSuggestions,
            setIsLoadingSuggestions
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>({
                getSprintSuggestions: getSprintSuggestions,
                setIsLoadingSuggestions: setIsLoadingSuggestions
            }), [
            getSprintSuggestions,
            setIsLoadingSuggestions
        ]);
        return [
            {
                isLoadingSuggestions: isLoadingSuggestions
            },
            actions
        ];
    };
});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;
parcelRegister("egtXp", function(module, exports) {
    $parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", ()=>$da54a1ad644b3ed6$export$90fd8fcc9388370d);
    $parcel$export(module.exports, "getCheckboxValueFromLocalStorage", ()=>$da54a1ad644b3ed6$export$b6ec857d138d143b);
    $parcel$export(module.exports, "setCheckBoxValueInLocalStorage", ()=>$da54a1ad644b3ed6$export$1750bf12ee05e0ac);
    var $ebyGx = parcelRequire("ebyGx");
    const $da54a1ad644b3ed6$var$getViewMode = ()=>(0, ($parcel$interopDefault($ebyGx))).parse(window.location.search).view || '';
    const $da54a1ad644b3ed6$export$d5e150c1e3186bd1 = ()=>$da54a1ad644b3ed6$var$getViewMode().includes('planning');
    const $da54a1ad644b3ed6$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
    const $da54a1ad644b3ed6$export$b6ec857d138d143b = (key)=>{
        const value = window.localStorage?.getItem(key);
        return value ? JSON.parse(value) : true;
    };
    const $da54a1ad644b3ed6$export$1750bf12ee05e0ac = (key, value)=>{
        try {
            window.localStorage.setItem(key, value);
        } catch  {}
    };
});
parcelRegister("gxJKL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb901ddd959c90f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iKImW;
    var $2JKLA;
    var $koVbs;
    var $ghRU5;
    var $kacDU;
    const $fb901ddd959c90f6$var$Menu = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children, ...restProps } = props;
        const isChecked = props.selectProps?.componentsProps?.isChecked || false;
        const projectKey = props.selectProps?.componentsProps?.projectKey || null;
        const label = formatMessage((0, (0, parcelRequire("ghRU5")).default).checkboxLabel, {
            projectKey: projectKey
        });
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === ' ') event.stopPropagation();
        }, []);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Menu, restProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kacDU")).CheckboxWrapper), {
            onClick: props.selectProps?.componentsProps?.onChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iKImW")).default), {
            onKeyDown: onKeyDown,
            isChecked: isChecked,
            label: label,
            testId: "issue-field-sprint.ui.edit.menu.checkbox"
        })), children)));
    };
    var $fb901ddd959c90f6$export$2e2bcd8739ae039 = $fb901ddd959c90f6$var$Menu;
});
parcelRegister("ghRU5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7044cf08eb2bc7be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7044cf08eb2bc7be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        checkboxLabel: {
            "id": "issue-field-sprint.edit.menu.checkbox-label",
            "defaultMessage": "Only show sprints in this project ({projectKey})"
        }
    });
});
parcelRegister("kacDU", function(module, exports) {
    $parcel$export(module.exports, "CheckboxWrapper", ()=>$38a94e57c20f776f$export$eef12940a6696c78);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $38a94e57c20f776f$export$eef12940a6696c78 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt41bs6 _n7zlpe8f _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ckVH2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fe9503663e56e29$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6fe9503663e56e29$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-field-sprint.edit.placeholder",
            "defaultMessage": "Select sprint"
        },
        empty: {
            "id": "issue-field-sprint.edit.empty",
            "defaultMessage": "No matches found"
        },
        failedFetch: {
            "id": "issue-field-sprint.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        loading: {
            "id": "issue-field-sprint.edit.loading",
            "defaultMessage": "Searching..."
        }
    });
});
parcelRegister("ahEu3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e77c8f330a49e37f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e77c8f330a49e37f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        activeSprintSelectionWarningMessage: {
            "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
            "defaultMessage": "Creating this issue will affect the active sprint's scope"
        },
        activeSprintSelectionWarningMessageIssueTermRefresh: {
            "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh",
            "defaultMessage": "Creating this work item will affect the active sprint's scope"
        }
    });
});
parcelRegister("aqMtW", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultSprintValue", ()=>$02b747729b1ec287$export$94efa001ab93bfd1);
    $parcel$export(module.exports, "mutateJiraSprintField", ()=>$02b747729b1ec287$export$38f8d6ec9f8dd490);
    $parcel$export(module.exports, "getSprintSuggestions", ()=>$02b747729b1ec287$export$a5ccca5b51d5d670);
    var $eusud;
    const $02b747729b1ec287$export$94efa001ab93bfd1 = (selectedSprints)=>{
        const sprint = selectedSprints[0];
        return sprint && {
            label: sprint.name,
            value: sprint.sprintId,
            state: sprint.state
        };
    };
    const $02b747729b1ec287$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
            sprintsField: {
                fieldId: fieldId,
                sprints: [
                    {
                        sprintId: value.toString()
                    }
                ]
            }
        });
    const $02b747729b1ec287$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
        const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
        return queryString;
    };
    const $02b747729b1ec287$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, (0, parcelRequire("eusud")).performGetRequest)($02b747729b1ec287$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));
});
parcelRegister("j85Ze", function(module, exports) {
    $parcel$export(module.exports, "StoryPointEstimateCustomFieldTypeConfig", ()=>$bc3fb5d2c33a6a48$export$8deb8e2b0423b5b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSzuZ;
    var $bo14T;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $bc3fb5d2c33a6a48$var$StoryPointEstimateCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bo14T")).default), props);
    const $bc3fb5d2c33a6a48$export$8deb8e2b0423b5b3 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("cSzuZ"))))),
        type: (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE),
        Component: $bc3fb5d2c33a6a48$var$StoryPointEstimateCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).TextFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).numberFieldWriter)
    };
});
parcelRegister("9TyvL", function(module, exports) {
    $parcel$export(module.exports, "SummaryFieldTypeConfig", ()=>$3f14060b386f603e$export$ac5c271c33c3c6d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nQJF;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $3f14060b386f603e$export$ac5c271c33c3c6d7 = {
        type: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
        Component: (0, (0, parcelRequire("7nQJF")).default),
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).TextFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).textFieldWriter)
    };
});
parcelRegister("7nQJF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e43d0c98a72456c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hMKLn;
    const $7e43d0c98a72456c$var$TextField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMKLn")).default), {
            type: "text",
            ...props
        });
    var $7e43d0c98a72456c$export$2e2bcd8739ae039 = $7e43d0c98a72456c$var$TextField;
});
parcelRegister("j2R7K", function(module, exports) {
    $parcel$export(module.exports, "TeamCustomFieldTypeConfig", ()=>$1b14f3049c72d53c$export$68615ecd9a5b878d);
    var $5uXOq = parcelRequire("5uXOq");
    var $3XWBa;
    var $iPfC3;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $1b14f3049c72d53c$var$TeamCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iPfC3")).default), props);
    const $1b14f3049c72d53c$export$68615ecd9a5b878d = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("3XWBa"))))),
        type: (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE),
        Component: $1b14f3049c72d53c$var$TeamCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).teamFieldWriter)
    };
});
parcelRegister("iPfC3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35cafe98c17438b5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $eb5hX;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $9K1c2;
    const $35cafe98c17438b5$export$c3b8fa1b9560fb7e = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
        const getTeamEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eb5hX")).default), {
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: value,
                fieldId: fieldId,
                isInvalid: Boolean(error),
                isDisabled: !isEditable,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                fetchSuggestionsOnFocus: true,
                ariaLabelledBy: ariaLabelledBy
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: nonEditableReason?.message || ''
        }, getTeamEdit()) : getTeamEdit());
    };
    var $35cafe98c17438b5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateCustomTeamsField),
        transformDefaultValue: (0, (0, parcelRequire("9K1c2")).transformDefaultTeam)
    })($35cafe98c17438b5$export$c3b8fa1b9560fb7e);
});
parcelRegister("eb5hX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$762657ba3faad803$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lHuuV;
    var $koVbs;
    var $lElIo;
    var $FtZX9;
    var $blh8O;
    var $b6swk;
    var $ibWtm;
    var $jv74C;
    const $762657ba3faad803$var$MenuList = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6swk")).default), props);
    const $762657ba3faad803$var$Option = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ibWtm")).default), props);
    const $762657ba3faad803$var$CustomTeamPickerEdit = (props)=>{
        const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
        const handleSearch = (0, (0, parcelRequire("FtZX9")).default)(async (query)=>(0, (0, parcelRequire("jv74C")).fetchTeams)(query || '', autoCompleteUrl), 300);
        const onFocus = async ()=>{
            if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
                shouldFetchDefaultOptions.current = false;
                setIsLoading && setIsLoading(true);
                const options = await handleSearch();
                setDefaultOptions && setDefaultOptions(options);
                setIsLoading && setIsLoading(false);
            }
        };
        const defaultOptionsProps = ()=>{
            if (fetchSuggestionsOnFocus) return {
                onFocus: onFocus,
                isLoading: isLoading,
                defaultOptions: defaultOptions
            };
            return {};
        };
        const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, (0, parcelRequire("blh8O")).default).noMatches), [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lHuuV")).default), {
            fieldId: fieldId,
            ...defaultOptionsProps(),
            loadOptions: handleSearch,
            onChange: onChange,
            autoFocus: autoFocus,
            isClearable: Boolean(value),
            isMulti: false,
            value: value,
            validationState: isInvalid === true ? 'error' : null,
            components: {
                MenuList: $762657ba3faad803$var$MenuList,
                Option: $762657ba3faad803$var$Option
            },
            noOptionsMessage: noOptionsMessage,
            placeholder: placeholder,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            classNamePrefix: classNamePrefix,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $762657ba3faad803$export$2e2bcd8739ae039 = $762657ba3faad803$var$CustomTeamPickerEdit;
});
parcelRegister("blh8O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47204223650b9e34$export$2e2bcd8739ae039);
    var $7VHMR;
    const $47204223650b9e34$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        menuHeader: {
            "id": "issue-field-custom-team.menu-header",
            "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
        },
        noMatches: {
            "id": "issue-field-custom-team.no-matches",
            "defaultMessage": "No Matches"
        },
        menuFooter: {
            "id": "issue-field-custom-team.menu-footer",
            "defaultMessage": "Showing 100 results. To display more results, please refine your search."
        }
    });
    var $47204223650b9e34$export$2e2bcd8739ae039 = $47204223650b9e34$var$messages;
});
parcelRegister("b6swk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7d58b272b039ad0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2JKLA;
    var $koVbs;
    var $blh8O;
    const $b7d58b272b039ad0$var$MenuListComponent = (props)=>{
        const { options: options } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const footer = options.length > 0 && options[0].moreResultsAvailable ? (0, ($parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$MenuFooterText, null, formatMessage((0, (0, parcelRequire("blh8O")).default).menuFooter)) : null;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).MenuList, props, (0, ($parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$Container, null, formatMessage((0, (0, parcelRequire("blh8O")).default).menuHeader)), props.children, footer));
    };
    var $b7d58b272b039ad0$export$2e2bcd8739ae039 = $b7d58b272b039ad0$var$MenuListComponent;
    const $b7d58b272b039ad0$var$MenuFooterText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1ifp _11c81oud _1yt41pyq",
                __cmplp.className
            ])
        });
    });
    const $b7d58b272b039ad0$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41pyq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ibWtm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82bc7e69d2cb0c6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ll2T;
    var $99gde;
    var $2JKLA;
    var $7KPXo;
    const $82bc7e69d2cb0c6a$var$OptionComponent = (props)=>{
        const value = props.data;
        if (value) {
            const { avatarUrl: avatarUrl, label: label } = value;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionWrapper, null, avatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$Icon, {
                src: avatarUrl,
                alt: label
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $82bc7e69d2cb0c6a$var$boxStyle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7KPXo")).default), {
                alt: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionText, null, props.children))));
        }
        return null;
    };
    var $82bc7e69d2cb0c6a$export$2e2bcd8739ae039 = $82bc7e69d2cb0c6a$var$OptionComponent;
    const $82bc7e69d2cb0c6a$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $82bc7e69d2cb0c6a$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bahv2br _1yt4otz2",
                __cmplp.className
            ])
        });
    });
    const $82bc7e69d2cb0c6a$var$OptionText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $82bc7e69d2cb0c6a$var$boxStyle = (0, (0, parcelRequire("99gde")).xcss)({
        height: '16px',
        width: '16px',
        marginRight: 'space.100'
    });
});
parcelRegister("7KPXo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f6eecaecb2670c4$export$2e2bcd8739ae039);
    var $dCLgq;
    var $6oKGV = parcelRequire("6oKGV");
    const $6f6eecaecb2670c4$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($6oKGV)),
        srcDark: ($parcel$interopDefault($6oKGV))
    });
    var $6f6eecaecb2670c4$export$2e2bcd8739ae039 = $6f6eecaecb2670c4$var$Illustration;
    const $6f6eecaecb2670c4$export$a179c88182cb9d56 = [
        0,
        0,
        596,
        596
    ];
});
parcelRegister("6oKGV", function(module, exports) {
    module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();
});
parcelRegister("jv74C", function(module, exports) {
    $parcel$export(module.exports, "transformTeamFieldTypeString", ()=>$dbbd6d0fcad033b6$export$f7d628c77d5447d0);
    $parcel$export(module.exports, "fetchTeams", ()=>$dbbd6d0fcad033b6$export$a789e725ac68b08d);
    var $eusud;
    const $dbbd6d0fcad033b6$export$4accbe1c2fbc55dd = (team)=>({
            label: team.title,
            value: team.id.toString(),
            isShared: team.shareable,
            avatarUrl: team.avatarUrl
        });
    const $dbbd6d0fcad033b6$export$f7d628c77d5447d0 = (team)=>{
        if (team) return team.value.toString();
        return null;
    };
    const $dbbd6d0fcad033b6$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(autoCompleteUrl, {
            body: JSON.stringify({
                excludedIds: [],
                maxResults: 100,
                query: query
            })
        });
        if (response) {
            const teams = response.teams.map($dbbd6d0fcad033b6$export$4accbe1c2fbc55dd);
            return [
                {
                    moreResultsAvailable: response.moreResultsAvailable,
                    options: teams
                }
            ];
        }
        return [];
    };
});
parcelRegister("9K1c2", function(module, exports) {
    $parcel$export(module.exports, "mutateTeamField", ()=>$e945ecd21dcd5234$export$8db32a33b76e5823);
    $parcel$export(module.exports, "transformDefaultTeam", ()=>$e945ecd21dcd5234$export$d2d64eb763c850a1);
    const $e945ecd21dcd5234$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
            fieldId: fieldId,
            mutationGroup: (0, $0a8c3ec56489edc2$export$31fd86f8f183952c),
            team: {
                teamId: selectedTeam.value
            }
        } : null;
    const $e945ecd21dcd5234$export$d2d64eb763c850a1 = (team)=>({
            label: team.name,
            value: team.teamId,
            isShared: true
        });
});
const $0a8c3ec56489edc2$export$31fd86f8f183952c = 'teamFields';
parcelRegister("kfv7e", function(module, exports) {
    $parcel$export(module.exports, "TeamsPlatformCustomFieldTypeConfig", ()=>$5b2998e95da8bc40$export$bd8e1979d863fc93);
    var $5uXOq = parcelRequire("5uXOq");
    var $3XWBa;
    var $5fc53;
    var $9gHYS;
    var $d9PPV;
    var $kShoa;
    const $5b2998e95da8bc40$var$TeamsPlatformCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d9PPV")).TeamField), {
            ...props,
            defaultValue: undefined
        });
    const $5b2998e95da8bc40$export$bd8e1979d863fc93 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("3XWBa"))))),
        type: (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
        Component: $5b2998e95da8bc40$var$TeamsPlatformCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).singleUserPickerFieldWriter)
    };
});
parcelRegister("d9PPV", function(module, exports) {
    $parcel$export(module.exports, "TeamField", ()=>$4d064a61ca9e1968$export$6f6cb44144d37e0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bSSG7;
    var $4kXb0;
    const $4d064a61ca9e1968$var$CLICKED_KEY = 'clicked';
    const $4d064a61ca9e1968$var$ONBOARDING_BANNER_KEY = 'TEAM_FIELD_ONBOARDING_BANNER_DISMISSED';
    const $4d064a61ca9e1968$var$localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('team-field-onboarding');
    const $4d064a61ca9e1968$export$6f6cb44144d37e0d = (props)=>{
        $4d064a61ca9e1968$var$localStorage.set($4d064a61ca9e1968$var$CLICKED_KEY, true);
        $4d064a61ca9e1968$var$localStorage.set($4d064a61ca9e1968$var$ONBOARDING_BANNER_KEY, true);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4kXb0")).default), props);
    };
});
parcelRegister("4kXb0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d376b3496c34d29$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $heNNl;
    var $8vFwj;
    var $4ajjx;
    var $lfTZh;
    var $8zOmE;
    var $lwMsT;
    var $9OXo1;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $icXkU;
    const $2d376b3496c34d29$var$overrideSelectStyles = {
        control: (base)=>({
                ...base,
                padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
            })
    };
    const $2d376b3496c34d29$var$stopFormPropagation = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const $2d376b3496c34d29$export$96c8ee98de63ec5b = (props)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const siteId = tenantContext.cloudId;
        const [hackIsEditable, setHackIsEditable] = (0, $5uXOq.useState)(true);
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
        const onCreate = (0, $5uXOq.useCallback)((team)=>{
            if (team && team?.id !== value?.id) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                    memberCount: team.memberCount
                });
                setHackIsEditable(false);
                setTimeout(()=>{
                    onChange(team);
                    setHackIsEditable(true);
                }, 1000);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            value?.id
        ]);
        const [createTeamDialog, createTeamDialogTrigger] = (0, (0, parcelRequire("8vFwj")).useCreateTeamDialog)({
            onCreate: onCreate
        });
        const getTeamEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "team-picker-edit",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ajjx")).AsyncTeamPickerEdit), {
                ...fieldProps,
                width: width,
                siteId: siteId,
                autoFocus: autoFocus,
                defaultValue: value,
                onChange: onChange,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                isDisabled: isEditable === false || !hackIsEditable,
                styles: $2d376b3496c34d29$var$overrideSelectStyles,
                createTeamDialogTrigger: createTeamDialogTrigger
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: nonEditableReason?.message || ''
        }, getTeamEdit()) : getTeamEdit(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "create-issue-field-team-create-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            name: "gic-create-team-dialog-form",
            onSubmit: $2d376b3496c34d29$var$stopFormPropagation
        }, createTeamDialog)));
    };
    var $2d376b3496c34d29$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("icXkU")).validateAtlassianTeamsField),
        transformDefaultValue: (0, (0, parcelRequire("icXkU")).transformDefaultAtlassianTeam)
    })($2d376b3496c34d29$export$96c8ee98de63ec5b);
});
parcelRegister("8vFwj", function(module, exports) {
    $parcel$export(module.exports, "useCreateTeamDialog", ()=>$e708dcb0d93e7fe3$export$e8b8170429d616be);
    var $5uXOq = parcelRequire("5uXOq");
    var $fB4A6;
    var $pa9q9;
    var $1wpPp;
    var $4ywcn;
    var $8igKv;
    var $koVbs;
    var $lfTZh;
    var $cYlk7;
    var $14XJw;
    var $9OXo1;
    var $5bWaz;
    var $1jUsD;
    const $e708dcb0d93e7fe3$export$75096afde50756fd = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("9xBtf")).then((module)=>module.TeamCreateDialog), {
        moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
    });
    const $e708dcb0d93e7fe3$export$e8b8170429d616be = (props = {})=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [inputTeamName, setInputTeamName] = (0, $5uXOq.useState)('');
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
        const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
            if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ywcn")).default), {
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === 'warning') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8igKv")).default), {
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === 'error') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
                    ...flagProps,
                    ...serviceProps
                }));
        }, [
            showFlag
        ]);
        const { onCancel: onCancel } = {
            onCancel: ()=>null,
            ...props
        };
        const callback = (0, $5uXOq.useCallback)((teamName)=>{
            setInputTeamName(teamName);
            setIsOpen(true);
        }, []);
        const handleOnClose = ()=>{
            setIsOpen(false);
            onCancel();
        };
        const handleOnCreate = (team)=>{
            const formattedTeam = {
                ...team,
                name: team.displayName
            };
            props.onCreate?.(formattedTeam);
        };
        return [
            isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "team-create-dialog"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bWaz")).PeopleAndTeamsConfigurationProvider), {
                product: "jira",
                locale: (0, (0, parcelRequire("fB4A6")).default)(locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($e708dcb0d93e7fe3$export$75096afde50756fd, {
                cloudId: cloudId,
                orgId: orgId,
                product: "jira",
                principalId: atlassianAccountId || user.accountId || '',
                onClose: handleOnClose,
                onCreateTeamSuccess: handleOnCreate,
                extraAnalyticsAttrs: props.analyticsCtx,
                enableMembershipSettingsChoice: true,
                currentUser: user.accountId ? {
                    id: user.accountId,
                    fullName: user.userFullname,
                    avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                    ...user
                } : undefined,
                prepopulatedFields: {
                    teamName: inputTeamName
                },
                addFlag: addFlag
            }))) : null,
            callback
        ];
    };
});
parcelRegister("1wpPp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ebed3b5115fbfc5$export$2e2bcd8739ae039);
    var $3KRpp;
    var $2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).ErrorFlag);
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $1eg3p;
    var $1jUsD;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1eg3p")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("4ywcn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a612b92e24f3853$export$2e2bcd8739ae039);
    var $3KRpp;
    var $1a612b92e24f3853$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).SuccessFlag);
});
parcelRegister("8igKv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b804070d792a00$export$2e2bcd8739ae039);
    var $3KRpp;
    var $87b804070d792a00$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).WarningFlag);
});
parcelRegister("9xBtf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("64JiP")
    ]).then(()=>parcelRequire('cDKpP'));
});
parcelRegister("4ajjx", function(module, exports) {
    $parcel$export(module.exports, "AsyncTeamPickerEdit", ()=>$81014c0bebd525f2$export$7db2ade8dff2be91);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $1jUsD;
    var $9n6Ty;
    const $81014c0bebd525f2$var$EMPTY_OBJECT = {};
    const $81014c0bebd525f2$export$eaed616868423e8a = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("eWvkp")), {
        moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
    });
    const $81014c0bebd525f2$export$7db2ade8dff2be91 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("9n6Ty")).asyncTeamPickerEditEntryPoint), $81014c0bebd525f2$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "async-jira-issue-atlassian-team-picker-edit",
            packageName: "jira-issue-field-team",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                width: "350px",
                height: "40px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("9n6Ty", function(module, exports) {
    $parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", ()=>$306b3712a4b90308$export$80ec8c2b96e9988);
    var $evanD;
    var $7KfpL;
    const $306b3712a4b90308$export$80ec8c2b96e9988 = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("eWvkp")).then((module)=>module.TeamPickerEditEntryPointContent), {
            moduleId: "ce0fa7b5"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eWvkp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eEi3r").then(()=>parcelRequire('hgQ4J'));
});
parcelRegister("icXkU", function(module, exports) {
    $parcel$export(module.exports, "mutateAtlassianTeamField", ()=>$9b9cb321960b72df$export$c8b8a48d1ff67754);
    $parcel$export(module.exports, "transformDefaultAtlassianTeam", ()=>$9b9cb321960b72df$export$3fee94ad0b9e180c);
    $parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", ()=>$9b9cb321960b72df$export$450002773f9da0a4);
    $parcel$export(module.exports, "validateAtlassianTeamsField", ()=>$9b9cb321960b72df$export$8222f94513c7d2e6);
    var $bGrWH;
    const $9b9cb321960b72df$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
            fieldId: fieldId,
            mutationGroup: (0, $9f942793bea6ba7a$export$31fd86f8f183952c),
            team: {
                teamId: selectedTeam.id
            }
        } : null;
    const $9b9cb321960b72df$export$3fee94ad0b9e180c = (team)=>({
            name: team.name,
            id: team.teamId,
            avatarUrl: team?.avatar?.small
        });
    const $9b9cb321960b72df$export$450002773f9da0a4 = (team)=>{
        if (team && team.id) return team.id;
        return null;
    };
    const $9b9cb321960b72df$export$8222f94513c7d2e6 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
const $9f942793bea6ba7a$export$31fd86f8f183952c = 'atlassianTeamFields';
parcelRegister("9uVge", function(module, exports) {
    $parcel$export(module.exports, "TextAreaCustomFieldTypeConfig", ()=>$62cfff7fda2456e7$export$a843cc77cac50059);
    var $5uXOq = parcelRequire("5uXOq");
    var $HDQ7u;
    var $9cNbb;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $62cfff7fda2456e7$var$TextAreaCustomFieldTypeComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cNbb")).default), props);
    const $62cfff7fda2456e7$export$a843cc77cac50059 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("HDQ7u"))))),
        type: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
        Component: $62cfff7fda2456e7$var$TextAreaCustomFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DescriptionFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).textAreaFieldWriter)
    };
});
parcelRegister("9cNbb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9bfbc76c8b6a999d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e7njR;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    const $9bfbc76c8b6a999d$var$TextAreaField = (props)=>{
        const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
        const onTextAreaChange = (e)=>{
            onChange(e.target.value);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e7njR")).default), {
            ...fieldProps,
            value: value,
            onChange: onTextAreaChange,
            onBlur: onBlur,
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            isDisabled: isReadOnly
        }));
    };
    var $9bfbc76c8b6a999d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($9bfbc76c8b6a999d$var$TextAreaField);
});
parcelRegister("e7njR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac310125020056c3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6HBFQ;
    const $ac310125020056c3$var$TextAreaEdit = (props)=>{
        const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6HBFQ")).default), {
            ...fieldProps,
            isRequired: isRequired,
            placeholder: placeholder,
            value: value,
            autoFocus: autoFocus,
            onBlur: onBlur,
            onFocus: onFocus,
            onChange: onChange,
            isInvalid: isInvalid,
            minimumRows: minimumRows,
            isDisabled: isDisabled
        });
    };
    var $ac310125020056c3$export$2e2bcd8739ae039 = $ac310125020056c3$var$TextAreaEdit;
});
parcelRegister("6HBFQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e06e4347ef638a2c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $7zSSp;
    const $e06e4347ef638a2c$var$packageName = "platform-pkg";
    const $e06e4347ef638a2c$var$packageVersion = "0.0.0-use.local";
    const $e06e4347ef638a2c$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $e06e4347ef638a2c$var$packageName,
        packageVersion: $e06e4347ef638a2c$var$packageVersion
    };
    const $e06e4347ef638a2c$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("7zSSp")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $e06e4347ef638a2c$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $e06e4347ef638a2c$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$e06e4347ef638a2c$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$e06e4347ef638a2c$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $e06e4347ef638a2c$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7zSSp")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("7zSSp")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $e06e4347ef638a2c$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($e06e4347ef638a2c$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $e06e4347ef638a2c$var$TextArea.displayName = 'TextArea';
    var $e06e4347ef638a2c$export$2e2bcd8739ae039 = $e06e4347ef638a2c$var$TextArea;
});
parcelRegister("7zSSp", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$349f5d21489b2f74$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$349f5d21489b2f74$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$349f5d21489b2f74$export$98856a888ef36079);
    var $f8Sb3;
    var $1xPSU;
    function $349f5d21489b2f74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $349f5d21489b2f74$var$disabledRules = {
        backgroundColor: (0, parcelRequire("1xPSU")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("1xPSU")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("1xPSU")).disabledBackground,
        borderColor: (0, parcelRequire("1xPSU")).disabledBorder,
        borderColorFocus: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("1xPSU")).disabledTextColor
    };
    const $349f5d21489b2f74$var$invalidRules = {
        borderColor: (0, parcelRequire("1xPSU")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("1xPSU")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("1xPSU")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("1xPSU")).defaultBackgroundColorHover
    };
    const $349f5d21489b2f74$var$backgroundColor = {
        standard: (0, parcelRequire("1xPSU")).defaultBackgroundColor,
        subtle: (0, parcelRequire("1xPSU")).transparent,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$backgroundColorFocus = {
        standard: (0, parcelRequire("1xPSU")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("1xPSU")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$backgroundColorHover = {
        standard: (0, parcelRequire("1xPSU")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("1xPSU")).defaultBackgroundColorHover,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$borderColor = {
        standard: (0, parcelRequire("1xPSU")).defaultBorderColor,
        subtle: (0, parcelRequire("1xPSU")).transparent,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$borderColorFocus = {
        standard: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$borderColorHover = {
        standard: (0, parcelRequire("1xPSU")).defaultBorderColor,
        subtle: (0, parcelRequire("1xPSU")).subtleBorderColorHover,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$lineHeightBase = 20;
    const $349f5d21489b2f74$var$lineHeightCompact = 16;
    const $349f5d21489b2f74$var$compactVerticalPadding = 2;
    const $349f5d21489b2f74$var$verticalPadding = 6;
    const $349f5d21489b2f74$var$horizontalPadding = 8;
    const $349f5d21489b2f74$var$transitionDuration = '0.2s';
    const $349f5d21489b2f74$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $349f5d21489b2f74$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $349f5d21489b2f74$export$12879c7697ed953d = 2;
    const $349f5d21489b2f74$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $349f5d21489b2f74$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $349f5d21489b2f74$var$lineHeightBase * minimumRows;
        return contentHeight + $349f5d21489b2f74$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $349f5d21489b2f74$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $349f5d21489b2f74$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $349f5d21489b2f74$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $349f5d21489b2f74$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $349f5d21489b2f74$var$backgroundColorFocus[appearance],
                borderColor: $349f5d21489b2f74$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $349f5d21489b2f74$var$backgroundColor[appearance],
                borderColor: $349f5d21489b2f74$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $349f5d21489b2f74$var$invalidRules.backgroundColorFocus,
                borderColor: $349f5d21489b2f74$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $349f5d21489b2f74$var$invalidRules.backgroundColor,
                borderColor: $349f5d21489b2f74$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $349f5d21489b2f74$var$disabledRules.backgroundColorFocus,
                    borderColor: $349f5d21489b2f74$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $349f5d21489b2f74$var$disabledRules.backgroundColor,
                    borderColor: $349f5d21489b2f74$var$disabledRules.borderColor
                }
            } : {}
        });
    const $349f5d21489b2f74$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("1xPSU")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $349f5d21489b2f74$var$disabledRules.textColor
        }
    });
    const $349f5d21489b2f74$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $349f5d21489b2f74$var$backgroundColorHover[appearance],
                borderColor: $349f5d21489b2f74$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $349f5d21489b2f74$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $349f5d21489b2f74$var$invalidRules.backgroundColorHover,
                    borderColor: $349f5d21489b2f74$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$invalidRules.borderColor}`
                }
            }
        });
    var $349f5d21489b2f74$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $349f5d21489b2f74$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $349f5d21489b2f74$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $349f5d21489b2f74$var$_ref2;
        return $349f5d21489b2f74$var$_ref;
    };
    const $349f5d21489b2f74$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $349f5d21489b2f74$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $349f5d21489b2f74$var$codeFontFamily : $349f5d21489b2f74$var$fontFamily
        });
    const $349f5d21489b2f74$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $349f5d21489b2f74$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $349f5d21489b2f74$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$349f5d21489b2f74$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $349f5d21489b2f74$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $349f5d21489b2f74$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$349f5d21489b2f74$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $349f5d21489b2f74$var$lineHeightBase / 14
            }
        });
    };
    const $349f5d21489b2f74$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$349f5d21489b2f74$var$transitionDuration} ease-in-out,
               border-color ${$349f5d21489b2f74$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$349f5d21489b2f74$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $349f5d21489b2f74$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($349f5d21489b2f74$var$staticStyles, $349f5d21489b2f74$var$borderPaddingAndHeightStyles(minimumRows, appearance), $349f5d21489b2f74$var$resizeStyle(resize), $349f5d21489b2f74$var$borderStyle(appearance), $349f5d21489b2f74$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $349f5d21489b2f74$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($349f5d21489b2f74$var$bgAndBorderColorStyles(appearance), $349f5d21489b2f74$var$hoverBackgroundAndBorderStyles(appearance), $349f5d21489b2f74$var$placeholderStyles, {
            color: (0, parcelRequire("1xPSU")).textColor,
            '&:disabled': {
                color: $349f5d21489b2f74$var$disabledRules.textColor
            }
        });
});
parcelRegister("1xPSU", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$7d4f8489709fddb4$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$7d4f8489709fddb4$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$7d4f8489709fddb4$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$7d4f8489709fddb4$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$7d4f8489709fddb4$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$7d4f8489709fddb4$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$7d4f8489709fddb4$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$7d4f8489709fddb4$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$7d4f8489709fddb4$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$7d4f8489709fddb4$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$7d4f8489709fddb4$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$7d4f8489709fddb4$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$7d4f8489709fddb4$export$f4d082c200a4b4b8);
    const $7d4f8489709fddb4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $72ba03e317f3d228$export$9fdfb749e33cdf97)})`;
    const $7d4f8489709fddb4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $72ba03e317f3d228$export$1ce2d1575d444ceb)})`;
    const $7d4f8489709fddb4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`;
    const $7d4f8489709fddb4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`;
    const $7d4f8489709fddb4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`;
    const $7d4f8489709fddb4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`;
    const $7d4f8489709fddb4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`;
    const $7d4f8489709fddb4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`;
    const $7d4f8489709fddb4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $7d4f8489709fddb4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$f563ee71e9ee74cd)})`;
    const $7d4f8489709fddb4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $72ba03e317f3d228$export$fbda843f0a27fe96)})`;
    const $7d4f8489709fddb4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $72ba03e317f3d228$export$5f71e19f3a7ad9de)})`;
    const $7d4f8489709fddb4$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("4I0dG", function(module, exports) {
    $parcel$export(module.exports, "TextCustomFieldTypeConfig", ()=>$479801bf04725697$export$c0fb3f2e63d9c457);
    var $5uXOq = parcelRequire("5uXOq");
    var $HDQ7u;
    var $7nQJF;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $479801bf04725697$export$c0fb3f2e63d9c457 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("HDQ7u"))))),
        type: (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
        Component: (0, (0, parcelRequire("7nQJF")).default),
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).TextFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).textFieldWriter)
    };
});
parcelRegister("eFzGt", function(module, exports) {
    $parcel$export(module.exports, "UrlCustomFieldTypeConfig", ()=>$1f67de6720141602$export$ffd29c07a77eba88);
    var $5uXOq = parcelRequire("5uXOq");
    var $lF2mK;
    var $b3x8f;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $1f67de6720141602$export$ffd29c07a77eba88 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("lF2mK"))))),
        type: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
        Component: (0, (0, parcelRequire("b3x8f")).default),
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).TextFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).urlFieldWriter)
    };
});
parcelRegister("b3x8f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097d081b3402af20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hMKLn;
    const $097d081b3402af20$var$UrlField = (props)=>{
        const { width: width = 350, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMKLn")).default), {
            type: "url",
            width: width,
            ...rest
        });
    };
    var $097d081b3402af20$export$2e2bcd8739ae039 = $097d081b3402af20$var$UrlField;
});
parcelRegister("5VWF9", function(module, exports) {
    $parcel$export(module.exports, "UserCustomFieldTypeConfig", ()=>$236772e6b1d3a040$export$e4e5f327b24b40ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $h4hXX;
    var $lfWSN;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    const $236772e6b1d3a040$export$e4e5f327b24b40ce = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("h4hXX"))))),
        type: (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        Component: (0, (0, parcelRequire("lfWSN")).default),
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).AssigneeFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).singleUserPickerFieldWriter)
    };
});
parcelRegister("1avQ5", function(module, exports) {
    $parcel$export(module.exports, "VersionFieldTypeConfig", ()=>$8ec751d67ae1a8ea$export$db147413137ce6f2);
    $parcel$export(module.exports, "MultiVersionsFieldTypeConfig", ()=>$8ec751d67ae1a8ea$export$2b457390d9f3d552);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Hv8i;
    var $k5vQX;
    var $aQNfA;
    var $5fc53;
    var $9gHYS;
    var $kShoa;
    function $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(allowedValuesProp) {
        return allowedValuesProp.map(({ id: id, name: name, released: released, archived: archived })=>{
            let status = 'UNRELEASED';
            if (archived) status = 'ARCHIVED';
            else if (released) status = 'RELEASED';
            return {
                id: id,
                name: name,
                status: status
            };
        });
    }
    const $8ec751d67ae1a8ea$var$VersionFieldTypeComponent = (props)=>{
        const allowedValues = $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(props.allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aQNfA")).default), {
            ...props,
            allowedValues: allowedValues
        });
    };
    const $8ec751d67ae1a8ea$export$db147413137ce6f2 = {
        icon: (0, ($parcel$interopDefault((0, parcelRequire("5Hv8i"))))),
        type: (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
        Component: $8ec751d67ae1a8ea$var$VersionFieldTypeComponent,
        placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
        writer: (0, (0, parcelRequire("kShoa")).selectFieldWriter)
    };
    const $8ec751d67ae1a8ea$var$MultiVersionsFieldTypeComponent = (props)=>{
        const allowedValues = $8ec751d67ae1a8ea$var$mapPropToExternalOptionAllowedValues(props.allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k5vQX")).default), {
            ...props,
            allowedValues: allowedValues
        });
    };
    const $8ec751d67ae1a8ea$export$2b457390d9f3d552 = (type)=>({
            icon: (0, ($parcel$interopDefault((0, parcelRequire("5Hv8i"))))),
            type: type,
            Component: $8ec751d67ae1a8ea$var$MultiVersionsFieldTypeComponent,
            placeholder: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9gHYS")).DropdownFieldPlaceholder), null),
            writer: (0, (0, parcelRequire("kShoa")).multiSelectFieldWriter)
        });
});
parcelRegister("k5vQX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76983af27be6a3ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $koVbs;
    var $hTBEr;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $cBHNh;
    var $34EcD;
    const $76983af27be6a3ff$var$MultiVersionsField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const options = (0, (0, parcelRequire("34EcD")).transformVersionExternalOptionstoVersionOptions)(allowedValues);
        const isDisabled = allowedValues.length === 0;
        const onChangeVersionsEdit = (versionEditValue)=>{
            if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
        };
        const getVersionsEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTBEr")).default), {
                options: options,
                value: value,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                isMulti: true,
                onChange: onChangeVersionsEdit,
                isInvalid: Boolean(error),
                fieldId: fieldId,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                isDisabled: isReadOnly || isDisabled,
                autoFocus: autoFocus,
                placeholder: isDisabled ? formatMessage((0, (0, parcelRequire("cBHNh")).default).none) : '',
                inputId: id,
                isRequired: isRequired
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("cBHNh")).default).tooltip)
        }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }));
    };
    var $76983af27be6a3ff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateMultiVersionsField),
        transformDefaultValue: (0, (0, parcelRequire("34EcD")).transformVersionExternalOptionstoVersionOptions),
        shouldRenderFieldMessage: false
    })($76983af27be6a3ff$var$MultiVersionsField);
});
parcelRegister("hTBEr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87c89427d751fd8d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gN6Vx;
    var $4R6GH;
    var $koVbs;
    var $lElIo;
    var $dTQPF;
    const $87c89427d751fd8d$var$Versions = (props)=>{
        const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, openMenuOnFocus: openMenuOnFocus = (0, (0, parcelRequire("4R6GH")).fg)('bulk-transitions-fix-a11y-violations') ? false : undefined } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getIsClearable = ()=>{
            if (!isClearable) return false;
            return Array.isArray(value) ? value.length > 0 : Boolean(value);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            placeholder: placeholder,
            options: (0, (0, parcelRequire("dTQPF")).getGroupedOptions)((0, (0, parcelRequire("dTQPF")).removeArchivedOptions)(options), formatMessage),
            validationState: isInvalid === true ? 'error' : null,
            value: value,
            fieldId: fieldId,
            isMulti: isMulti,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onChange: onChange,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isClearable: getIsClearable(),
            inputId: inputId,
            required: isRequired,
            classNamePrefix: classNamePrefix,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            ...(0, (0, parcelRequire("4R6GH")).fg)('bulk-transitions-fix-a11y-violations') && {
                openMenuOnFocus: openMenuOnFocus
            }
        });
    };
    var $87c89427d751fd8d$export$2e2bcd8739ae039 = $87c89427d751fd8d$var$Versions;
});
parcelRegister("dTQPF", function(module, exports) {
    $parcel$export(module.exports, "transformVersionExternalToVersion", ()=>$418fd006fc4a31c5$export$c1c38f7974aa8bed);
    $parcel$export(module.exports, "removeArchivedOptions", ()=>$418fd006fc4a31c5$export$6f0b68b6e372a0e6);
    $parcel$export(module.exports, "getGroupedOptions", ()=>$418fd006fc4a31c5$export$721c3d9226425f9c);
    $parcel$export(module.exports, "getVersionsIds", ()=>$418fd006fc4a31c5$export$c96a1607e976ccc6);
    $parcel$export(module.exports, "getVersionId", ()=>$418fd006fc4a31c5$export$d0a84488c5034e2b);
    var $lCBBY;
    const $418fd006fc4a31c5$var$getStatusFromRestOption = (option)=>{
        if (option.released) return 'RELEASED';
        if (option.archived) return 'ARCHIVED';
        return 'UNRELEASED';
    };
    const $418fd006fc4a31c5$export$eb178ff2323a1ab3 = (option)=>({
            label: option.name,
            value: option.id,
            status: $418fd006fc4a31c5$var$getStatusFromRestOption(option)
        });
    const $418fd006fc4a31c5$export$c1c38f7974aa8bed = (option)=>({
            label: option.name,
            value: option.id,
            status: option.status
        });
    const $418fd006fc4a31c5$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
    const $418fd006fc4a31c5$export$721c3d9226425f9c = (options, formatMessage)=>{
        const groupedOptions = [];
        if (options.length) {
            const versionOrder = options.length && options[0].status === 'RELEASED' ? [
                'RELEASED',
                'UNRELEASED'
            ] : [
                'UNRELEASED',
                'RELEASED'
            ];
            versionOrder.forEach((status)=>{
                const statusOptions = options.filter((option)=>option.status === status);
                if (statusOptions.length) groupedOptions.push({
                    options: statusOptions,
                    label: status === 'RELEASED' ? formatMessage((0, (0, parcelRequire("lCBBY")).default).released) : formatMessage((0, (0, parcelRequire("lCBBY")).default).unreleased)
                });
            });
        }
        return groupedOptions;
    };
    const $418fd006fc4a31c5$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
                id: v.value
            }));
    const $418fd006fc4a31c5$export$d0a84488c5034e2b = (selectedVersion)=>({
            id: selectedVersion.value
        });
});
parcelRegister("lCBBY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a958e5bb1549bd80$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a958e5bb1549bd80$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        released: {
            "id": "issue-field-versions.released",
            "defaultMessage": "Released"
        },
        unreleased: {
            "id": "issue-field-versions.unreleased",
            "defaultMessage": "Unreleased"
        }
    });
    var $a958e5bb1549bd80$export$2e2bcd8739ae039 = $a958e5bb1549bd80$var$messages;
});
parcelRegister("cBHNh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b40c0e93e07915fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b40c0e93e07915fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        none: {
            "id": "issue-create-commons.multi-versions-field.none",
            "defaultMessage": "None"
        },
        tooltip: {
            "id": "issue-create-commons.multi-versions-field.tooltip",
            "defaultMessage": "We couldn't find any versions for this project"
        }
    });
});
parcelRegister("34EcD", function(module, exports) {
    $parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", ()=>$f99feaf445ed0ec0$export$11cad9e2f2e9ae55);
    $parcel$export(module.exports, "mutateMultiVersionsField", ()=>$f99feaf445ed0ec0$export$6999207a9642bd09);
    var $dTQPF;
    const $f99feaf445ed0ec0$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, (0, parcelRequire("dTQPF")).transformVersionExternalToVersion)(option));
    const $f99feaf445ed0ec0$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $a7d2b97eb2e0b950$export$31fd86f8f183952c),
            versions: selectedVersions.map(({ value: value })=>({
                    versionId: value
                }))
        });
});
const $a7d2b97eb2e0b950$export$31fd86f8f183952c = 'multipleVersionPickerFields';
parcelRegister("aQNfA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d04647b01be2b83f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $koVbs;
    var $hTBEr;
    var $dTQPF;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $jrGSc;
    var $1AaWN;
    const $d04647b01be2b83f$var$SingleVersionField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, ariaLabelledBy: ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onChangeVersionsEdit = (versionEditValue)=>{
            if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
        };
        const options = (0, (0, parcelRequire("1AaWN")).transformVersionExternalOptionstoVersionOptions)(allowedValues);
        const isDisabled = allowedValues.length === 0;
        const getVersionsEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTBEr")).default), {
                options: options,
                value: value,
                onChange: onChangeVersionsEdit,
                isInvalid: Boolean(error),
                fieldId: fieldId,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                isMulti: false,
                isDisabled: isDisabled,
                placeholder: isDisabled ? formatMessage((0, (0, parcelRequire("jrGSc")).default).none) : '',
                autoFocus: autoFocus,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                ariaLabelledBy: ariaLabelledBy
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("jrGSc")).default).tooltip)
        }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }));
    };
    var $d04647b01be2b83f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateSingleVersionField),
        transformDefaultValue: (0, (0, parcelRequire("dTQPF")).transformVersionExternalToVersion),
        shouldRenderFieldMessage: false
    })($d04647b01be2b83f$var$SingleVersionField);
});
parcelRegister("jrGSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5396ea8e93f1b004$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5396ea8e93f1b004$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        none: {
            "id": "issue-create-commons.single-version-field.none",
            "defaultMessage": "None"
        },
        tooltip: {
            "id": "issue-create-commons.single-version-field.tooltip",
            "defaultMessage": "We couldn't find any versions for this project"
        }
    });
});
parcelRegister("1AaWN", function(module, exports) {
    $parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", ()=>$79dd8b3734a0e456$export$11cad9e2f2e9ae55);
    $parcel$export(module.exports, "mutateSingleVersionField", ()=>$79dd8b3734a0e456$export$57ed62196c76c8b6);
    var $dTQPF;
    const $79dd8b3734a0e456$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, (0, parcelRequire("dTQPF")).transformVersionExternalToVersion)(option));
    const $79dd8b3734a0e456$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $703505cc37235a2c$export$31fd86f8f183952c),
            version: {
                versionId: value
            }
        });
});
const $703505cc37235a2c$export$31fd86f8f183952c = 'singleVersionPickerFields';
parcelRegister("hmRfM", function(module, exports) {
    $parcel$export(module.exports, "FormSubmissionRoot", ()=>$5045058046d328b0$export$4ae1a0970466e244);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7NUKB;
    var $eiOkd;
    var $e21nk;
    var $cm8b5;
    var $8HvEs;
    var $7Wnap;
    var $7yduy;
    var $4R6GH;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $lwMsT;
    var $l2N2a;
    var $l8ruj;
    var $doZTA;
    var $iEEXl;
    var $7wwVP;
    var $j3cMm;
    var $6czoq;
    var $aCsR5;
    var $fOgCm;
    var $b668c;
    var $g2iZ7;
    var $djHla;
    var $7YlSK;
    var $f9uY0;
    var $b8mPJ;
    const $5045058046d328b0$var$FormContent = (0, $5uXOq.memo)(({ formSubmissionLoading: formSubmissionLoading, formSubmissionData: formSubmissionData, formSubmissionError: formSubmissionError })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const canCreateIssues = Boolean(project?.permissions.createIssues) || formSubmissionData?.formWithFieldData?.accessLevel === (0, (0, parcelRequire("7wwVP")).FormAccessLevelTypes).OPEN;
        const hasError = formSubmissionError !== undefined;
        if (!formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData?.formWithFieldData?.issueType && !hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).IssueTypeDeletedView), null);
        if (!formSubmissionLoading && formSubmissionData?.formWithFieldData && !formSubmissionData.fieldMetaData && canCreateIssues && formSubmissionData?.formWithFieldData?.issueType && !hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).IssueTypeNotAssociatedView), {
            issueTypeName: formSubmissionData?.formWithFieldData?.issueType?.name ?? ''
        });
        if (!canCreateIssues) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).NoPermissionView), null);
        if (formSubmissionData?.formSubmissionValidationData?.hasMissingSupportedRequiredFields) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).FormMissingSupportedRequiredFieldsView), null);
        if (formSubmissionData?.formSubmissionValidationData?.hasUnsupportedRequiredFields) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).FormContainsUnsupportedRequiredFieldsView), null);
        const canViewIssues = Boolean(project?.permissions.viewIssues);
        const noPermissionToViewProjectScopedRequiredFields = formSubmissionData?.formSubmissionValidationData?.hasProjectScopedRequiredFields && !canViewIssues;
        if (noPermissionToViewProjectScopedRequiredFields) {
            const projectScopedRequiredFields = formSubmissionData?.formWithFieldData?.fields.filter((f)=>f.isRequiredByForm && (0, (0, parcelRequire("fOgCm")).isProjectScopedFieldType)(f.type)).map((f)=>f.type) ?? [];
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'formUnavailable viewed', {
                error: 'noPermissionToViewProjectScopedRequiredFields',
                projectScopedRequiredFields: projectScopedRequiredFields
            });
            if ((0, (0, parcelRequire("4R6GH")).fg)('forms_project_specific_field_404_page')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).NoProjectAccessView), null);
        }
        if (hasError || formSubmissionData == null || formSubmissionData.formWithFieldData == null || formSubmissionData.fieldMetaData == null || formSubmissionData?.formWithFieldData?.enabled === false || formSubmissionData?.formSubmissionValidationData?.isFormSubmissionValid === false || noPermissionToViewProjectScopedRequiredFields) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).FormUnavailableView), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("djHla")).MediaPermissionsPreloader), {
            projectId: String(formSubmissionData.formWithFieldData.projectId),
            formId: formSubmissionData.formWithFieldData.formId
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9uY0")).FillInView), null));
    });
    const $5045058046d328b0$export$2f8578dc462e47a9 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { featureView: featureView } = (0, (0, parcelRequire("b668c")).useJWMFormsFeatures)();
        const pageHeading = formatMessage((0, (0, parcelRequire("b8mPJ")).default).pageHeading);
        const { data: formSubmissionData, loading: formSubmissionLoading, error: formSubmissionError } = (0, (0, parcelRequire("g2iZ7")).useFormSubmission)();
        const hasError = formSubmissionError !== undefined;
        const loading = formSubmissionLoading;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "form-submission"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "form-submission",
            hold: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).RenderStartMark), {
            view: featureView,
            loading: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e21nk")).BusinessDocumentTitle), {
            pageHeading: pageHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aCsR5")).FormBackground), {
            bannerColor: formSubmissionData?.formWithFieldData?.bannerColor
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j3cMm")).Card), {
            minHeight: (0, $410f34228866ee1a$export$aa78f5e84beba3ce)
        }, !hasError && loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$Placeholder, {
            id: "form-content",
            "data-testid": "business-form.ui.form-submission.place-holder"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$var$FormContent, {
            formSubmissionLoading: formSubmissionLoading,
            formSubmissionData: formSubmissionData,
            formSubmissionError: formSubmissionError
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("iEEXl")).VIEW_FORM_SUBMISSION_EXPERIENCE)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8HvEs")).PerformanceAnalytics), {
            view: featureView,
            loading: loading
        }), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yduy")).JWMSpaStatePageReady), null));
    });
    const $5045058046d328b0$export$4ae1a0970466e244 = (0, $5uXOq.memo)(()=>{
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const canCreateOrModifyForm = Boolean(project?.permissions.administerProject);
        const [{ query: query }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const shouldShowContactAdminBanner = !canCreateOrModifyForm && query[(0, (0, parcelRequire("iEEXl")).URL_PARAMS).FROM] === (0, (0, parcelRequire("iEEXl")).URL_PARAMS).DIRECTORY;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "form-submission-root"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "businessFormSubmission",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, shouldShowContactAdminBanner && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7YlSK")).ContactAdminBanner), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiOkd")).default), {
            shouldAddPadding: false,
            withOverflow: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5045058046d328b0$export$2f8578dc462e47a9, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null))));
    });
    const $5045058046d328b0$var$Placeholder = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ip3fh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eiOkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98d0f47ed36cd9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $6cG4N;
    var $bUSNl;
    var $lLfAu;
    var $aXDiy;
    const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
        const [{ content: sidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const isSidebarOpen = withSidebar && sidebarContent != null;
        let content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, header, children);
        if (withSidebar) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLfAu")).SidebarLayout), {
            theme: sidebarTheme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $b98d0f47ed36cd9a$var$contentWrapperStyles,
                isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
            ]
        }, content));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aXDiy")).ThemedContainer), {
            shouldAddPadding: shouldAddPadding,
            isSidebarOpen: isSidebarOpen,
            withSidebar: withSidebar,
            withDynamicHeight: withDynamicHeight,
            withOverflow: withOverflow,
            id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
            className: className
        }, content);
    };
    const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        color: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: '100%',
        minWidth: '0',
        width: 'auto'
    });
    const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingRight: 'space.300',
        paddingBottom: 'space.300'
    });
    var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';
parcelRegister("bUSNl", function(module, exports) {
    $parcel$export(module.exports, "getSidebarQueryParams", ()=>$39fc2da09b28cabf$export$ddc11e4d41e7cf62);
    $parcel$export(module.exports, "useSidebar", ()=>$39fc2da09b28cabf$export$54c70f22f548bff8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hE5wF;
    var $3hGWp;
    var $dCm1o;
    var $3sQ5x;
    var $iXqE5;
    var $jnA4H;
    const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
    const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
            (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
            (0, (0, parcelRequire("hE5wF")).SELECTED_COMMENT_PARAM)
        ];
    const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
    const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                content: content
            });
        };
    const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
            if (newWidth === state.sidebarWidth) return;
            setState({
                ...state,
                sidebarWidth: newWidth
            });
            (0, (0, parcelRequire("jnA4H")).localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
        };
    const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                onSidebarClose: onSidebarClose
            });
        };
    const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            state.onSidebarClose();
            setState({
                ...state,
                content: null,
                onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
            });
        };
    const $39fc2da09b28cabf$var$actions = {
        setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
        setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
        setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
        closeSidebar: $39fc2da09b28cabf$var$closeSidebar
    };
    const $39fc2da09b28cabf$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            content: null,
            sidebarWidth: (0, (0, parcelRequire("jnA4H")).localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
            onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
        },
        actions: $39fc2da09b28cabf$var$actions,
        name: 'JWMSidebarStore'
    });
    const $39fc2da09b28cabf$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($39fc2da09b28cabf$var$Store);
    const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
        const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
        const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
        const [, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
            const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                    [param]: undefined
                }), {});
            setQueryParams(newQueryParams);
        }, [
            setQueryParams,
            sidebarQueryParams
        ]);
        return [
            state,
            {
                ...hookActions,
                resetSidebarQueryParams: resetSidebarQueryParams
            }
        ];
    };
});
parcelRegister("hE5wF", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", ()=>$bfd6cbe4770149b5$export$8386e51ba415e85d);
    $parcel$export(module.exports, "DEFAULT_AVATAR_RES", ()=>$bfd6cbe4770149b5$export$159fe44438c210e9);
    $parcel$export(module.exports, "FILTER_PARAM", ()=>$bfd6cbe4770149b5$export$d8301e0b33832d94);
    $parcel$export(module.exports, "INLINE_CREATE_PARAM", ()=>$bfd6cbe4770149b5$export$599c163c1570a353);
    $parcel$export(module.exports, "INVITE_OPEN_PARAM", ()=>$bfd6cbe4770149b5$export$3a74d1a195d2f007);
    $parcel$export(module.exports, "SELECTED_ISSUE_PARAM", ()=>$bfd6cbe4770149b5$export$c070acdc9b0f1be5);
    $parcel$export(module.exports, "SELECTED_COMMENT_PARAM", ()=>$bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
    $parcel$export(module.exports, "GROUP_BY_ASSIGNEE", ()=>$bfd6cbe4770149b5$export$dba794af6c0f2afc);
    $parcel$export(module.exports, "GROUP_BY_PRIORITY", ()=>$bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
    $parcel$export(module.exports, "GROUP_BY_CATEGORY", ()=>$bfd6cbe4770149b5$export$22ef551f315f2786);
    $parcel$export(module.exports, "GROUP_BY_STATUS", ()=>$bfd6cbe4770149b5$export$6d69efb296b78a);
    $parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e23e1d1ea45171c2);
    $parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e35c6e217c75dc4b);
    $parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", ()=>$bfd6cbe4770149b5$export$e5eab344feb92af9);
    $parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", ()=>$bfd6cbe4770149b5$export$a311e1b78816c048);
    $parcel$export(module.exports, "CARD_COVERS_TYPE", ()=>$bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$bfd6cbe4770149b5$export$5716e8bcb003888d);
    $parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$1f9fb9f15184100f);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$c72ea455b368cdd9);
    const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
    const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
    const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
    const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
    const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
    const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
    const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
    const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
    const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
    const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
    const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
    const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
    const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
    const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
    const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
    const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
    const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
    const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
    const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
    const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
    const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("jnA4H", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$301038d04a64b539$export$c2ed3351cac403d1);
    var $bSSG7;
    const $301038d04a64b539$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_common');
});
parcelRegister("lLfAu", function(module, exports) {
    $parcel$export(module.exports, "SidebarLayout", ()=>$1dbab6fa0f2d1b51$export$8295a33ab8a36876);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $getxR;
    var $He4jn;
    var $bUSNl;
    var $eHSp3;
    const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $1dbab6fa0f2d1b51$var$sidebarStyles,
                theme === 'business' && $1dbab6fa0f2d1b51$var$businessSidebarStyles
            ],
            style: {
                width: sidebarWidth
            }
        }, children);
    const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
        (0, (0, parcelRequire("getxR")).useSidebarQueryParams)();
        const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, (0, parcelRequire("He4jn")).useResizer)();
        (0, $5uXOq.useEffect)(()=>()=>{
                setSidebarContent(null);
            }, [
            setSidebarContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).Wrapper), {
            isResizing: isResizing,
            "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
        }, children, content && (0, ($parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
            sidebarWidth: sidebarWidth,
            theme: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).ResizeHandle), {
            onMouseDown: onMouseDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).SidebarContent), null, content)));
    };
    const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        backgroundColor: 'elevation.surface',
        flexGrow: 0,
        flexShrink: 0,
        position: 'relative',
        zIndex: 'card',
        maxWidth: '75%'
    });
    const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderTopLeftRadius: 'border.radius.200',
        borderTopRightRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        marginRight: 'space.300',
        marginTop: 'space.300'
    });
});
parcelRegister("getxR", function(module, exports) {
    $parcel$export(module.exports, "useSidebarQueryParams", ()=>$7ddee5a34b903b90$export$34adbeffbeceba68);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $4R6GH;
    var $1XJ20;
    var $8zOmE;
    var $lwMsT;
    var $3hGWp;
    var $bUSNl;
    const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const sidebarQueryParams = (0, (0, parcelRequire("bUSNl")).getSidebarQueryParams)();
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const prevQueryParams = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(queryParams);
        const closeSidebar = (0, $5uXOq.useCallback)(()=>{
            resetSidebarQueryParams();
            setSidebarContent(null);
        }, [
            resetSidebarQueryParams,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            sidebarQueryParams.forEach((queryParam)=>{
                if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                    const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                            [param]: undefined
                        }), {});
                    setQueryParams(newQueryParams);
                }
            });
        }, [
            prevQueryParams,
            queryParams,
            setQueryParams,
            sidebarQueryParams
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleKeydown = (event)=>{
                if (!queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
                if (queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') return;
                if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                    closeSidebar();
                }
            };
            typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
            return ()=>{
                typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
            };
        }, [
            closeSidebar,
            content?.key,
            createAnalyticsEvent,
            queryParams
        ]);
    };
});
parcelRegister("He4jn", function(module, exports) {
    $parcel$export(module.exports, "useResizer", ()=>$80d7a99fb39f1e91$export$faede3f1542958fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $bUSNl;
    const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
    const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
        const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const startRef = (0, $5uXOq.useRef)(0);
        const width = (0, $5uXOq.useRef)(0);
        const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
        const resize = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))((clientX)=>{
            const proposedWidth = width.current + startRef.current - clientX;
            setSidebarWidth(proposedWidth);
        }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
            setSidebarWidth
        ]);
        const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            resize(event.clientX);
        }, [
            resize
        ]);
        const onMouseUp = (0, $5uXOq.useCallback)(()=>{
            startRef.current = 0;
            width.current = 0;
            setIsResizing(false);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            }, [
            onMouseMove,
            onMouseUp
        ]);
        const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
            startRef.current = event.clientX;
            width.current = sidebarWidth;
            setIsResizing(true);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove,
            onMouseUp,
            sidebarWidth
        ]);
        return {
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            isResizing: isResizing
        };
    };
});
parcelRegister("eHSp3", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$71d20039839e60ab$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "SidebarContent", ()=>$71d20039839e60ab$export$49e8f7b58a4df4ea);
    $parcel$export(module.exports, "ResizeHandle", ()=>$71d20039839e60ab$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $71d20039839e60ab$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isResizing: isResizing, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
                __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$49e8f7b58a4df4ea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$33f2411a0ad35be7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aXDiy", function(module, exports) {
    $parcel$export(module.exports, "ThemedContainer", ()=>$0d3cb0cba7f538e9$export$2a4209ec8a7db359);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0d3cb0cba7f538e9$export$2a4209ec8a7db359 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
                !__cmplp.withSidebar && "_syazfrbu",
                __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
                __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
                __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
                __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("e21nk", function(module, exports) {
    $parcel$export(module.exports, "BusinessDocumentTitle", ()=>$aa5670652f17dfc4$export$416064ba09d98e69);
    var $5uXOq = parcelRequire("5uXOq");
    var $ew1Lk;
    var $54qG5;
    const $aa5670652f17dfc4$export$416064ba09d98e69 = (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: documentTitle
        });
    });
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("8HvEs", function(module, exports) {
    $parcel$export(module.exports, "PerformanceAnalytics", ()=>$0eced7986dcab954$export$ec3c3b39c046a620);
    var $5uXOq = parcelRequire("5uXOq");
    var $7NUKB;
    var $2nbdU;
    var $3vR0I;
    var $7Wnap;
    const $0eced7986dcab954$export$ec3c3b39c046a620 = (0, $5uXOq.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
        const loadingRef = (0, $5uXOq.useRef)(loading);
        loadingRef.current = loading;
        if (loading === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "performance-analytics-loading"
        });
        const scrollElement = false ? null : document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597));
        const product = view.startsWith('software') ? 'jsw' : 'jwm';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).PageLoadMetrics), {
            view: view,
            attributes: attributes,
            product: product
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3vR0I")).FirstInteractionMetric), {
            view: view,
            product: product
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nbdU")).default), {
            viewId: `${product}.${view}`,
            scrollElement: scrollElement,
            itemsCount: itemsCount,
            attributes: attributes
        }));
    });
});
parcelRegister("2nbdU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$551da07557368f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $lwMsT;
    const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
    const $551da07557368f71$export$46962be62755f053 = (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const samplingCount = (0, $5uXOq.useRef)(0);
        const frames = (0, $5uXOq.useRef)(0);
        const rafId = (0, $5uXOq.useRef)(null);
        const start = (0, $5uXOq.useRef)(0);
        (0, $5uXOq.useEffect)(()=>{
            const container = scrollElement ?? document;
            const hasScrollCapture = true;
            const tick = ()=>{
                if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                    frames.current += 1;
                    rafId.current = requestAnimationFrame(tick);
                } else {
                    const stopTime = performance.now();
                    const elapsedMs = stopTime - start.current;
                    const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                    const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                    frames.current = 0;
                    const attr = {
                        ...attributes || {},
                        itemsCount: itemsCount,
                        avgFrameDuration: avgFrameDuration,
                        fps: fps
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
                }
            };
            const handleOnScroll = ()=>{
                samplingCount.current += 1;
                if (samplingCount.current !== samplingRate) return;
                samplingCount.current = 0;
                start.current = performance.now();
                tick();
            };
            container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
                if (rafId.current) cancelAnimationFrame(rafId.current);
            };
        }, [
            scrollElement,
            createAnalyticsEvent,
            itemsCount,
            samplingRate,
            viewId,
            attributes
        ]);
        return null;
    });
    var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;
});
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;
parcelRegister("3vR0I", function(module, exports) {
    $parcel$export(module.exports, "FirstInteractionMetric", ()=>$43e497a79074b7d0$export$70b569bf2edd0b7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $lwMsT;
    const $43e497a79074b7d0$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const container = document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597)) ?? document;
            const hasScrollCapture = true;
            const startTime = performance.now();
            const handleFirstClick = ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                    duration: performance.now() - startTime
                });
                container.removeEventListener('click', handleFirstClick);
            };
            const handleFirstScroll = ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                    duration: performance.now() - startTime
                });
                container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
            };
            container.addEventListener('click', handleFirstClick);
            container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('click', handleFirstClick);
                container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
            };
        }, [
            createAnalyticsEvent,
            view,
            product
        ]);
        return null;
    };
});
parcelRegister("7Wnap", function(module, exports) {
    $parcel$export(module.exports, "RenderStartMark", ()=>$4c177752bab6a832$export$2128f295d6adb861);
    $parcel$export(module.exports, "PageLoadMetrics", ()=>$4c177752bab6a832$export$66b33c055cbb625e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    var $gN11a;
    const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
        if (loading === true) return null;
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
        return null;
    };
    const $4c177752bab6a832$export$66b33c055cbb625e = (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
        const metric = (0, (0, parcelRequire("gN11a")).pageLoadMetrics)[view];
        return metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: `${product}.${view}`,
            metric: metric,
            extra: attributes
        });
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $czVoz;
    var $9TpzN;
    var $d7oXH;
    var $co1wz;
    var $2m0sQ;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("czVoz")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TpzN")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("d7oXH")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("9TpzN", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$886eecd9178dd67d$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $d7oXH;
    var $knQnR;
    function $886eecd9178dd67d$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $886eecd9178dd67d$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsv1")).default));
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $886eecd9178dd67d$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("knQnR")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $9efn2;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("9efn2")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $2m0sQ;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $d7oXH;
    var $knQnR;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $d7oXH;
    var $knQnR;
    var $2m0sQ;
    var $h9AzB;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("h9AzB")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $d7oXH;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("7yduy", function(module, exports) {
    $parcel$export(module.exports, "JWMSpaStatePageReady", ()=>$150b436063f0aaae$export$d54524c142a057f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZw8H;
    const $150b436063f0aaae$export$d54524c142a057f = ()=>{
        const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            let id = window.requestAnimationFrame(()=>{
                id = window.requestAnimationFrame(()=>{
                    setIsReady(true);
                });
            });
            return ()=>{
                window.cancelAnimationFrame(id);
            };
        }, []);
        if (!isReady) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null);
    };
});
parcelRegister("j3cMm", function(module, exports) {
    $parcel$export(module.exports, "Card", ()=>$da92e917e9b85f56$export$60332b2344f7fe41);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $da92e917e9b85f56$export$c75a6d3667a4a2e7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7hp5a _2rkoftgi _otyru2gc _1yt41dfa _16qs1bpa",
                __cmplp.className
            ])
        });
    });
    const $da92e917e9b85f56$var$StyledCard = (0, $5uXOq.forwardRef)(({ as: C = $da92e917e9b85f56$export$c75a6d3667a4a2e7, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_brev0o": (0, (0, parcelRequire("lD23V")).default)(__cmplp.minHeight, "px"),
                "--_1upm8ip": (0, (0, parcelRequire("lD23V")).default)(__cmplp.maxHeight, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.minHeight !== null ? "_1tke1rgx" : "_1tke1wug",
                __cmplp.maxHeight !== null ? "_c71l1w9o" : "_c71l1wug",
                __cmplp.className
            ])
        });
    });
    const $da92e917e9b85f56$export$60332b2344f7fe41 = $da92e917e9b85f56$var$StyledCard;
});
parcelRegister("aCsR5", function(module, exports) {
    $parcel$export(module.exports, "FormBackground", ()=>$4c9d8229fbc4b0b5$export$e13fb218ba50bebd);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $3NYLB;
    const $4c9d8229fbc4b0b5$export$e13fb218ba50bebd = (0, $5uXOq.memo)(({ children: children, bannerColor: bannerColor, header: header })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4c9d8229fbc4b0b5$var$Background, {
            bannerColor: (0, (0, parcelRequire("3NYLB")).getDesignTokenBannerColor)(bannerColor)
        }, header, (0, ($parcel$interopDefault($5uXOq))).createElement($4c9d8229fbc4b0b5$var$ContentWrapper, null, children)));
    const $4c9d8229fbc4b0b5$var$Background = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { bannerColor: bannerColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1524em9": (0, (0, parcelRequire("lD23V")).default)(`linear-gradient(to bottom, ${__cmplp.bannerColor || `var(--ds-background-neutral-hovered, ${(0, $72ba03e317f3d228$exports).N40A})`} 30%, transparent 30%)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71c01 _qmxj1n9t _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $4c9d8229fbc4b0b5$var$ContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbufrr _18s8mvv2",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3NYLB", function(module, exports) {
    $parcel$export(module.exports, "getRandomBannerColor", ()=>$8d0eb4c1d86abc14$export$aefdd89adb2344b3);
    $parcel$export(module.exports, "getDesignTokenBannerColor", ()=>$8d0eb4c1d86abc14$export$c3fba1eee1434e93);
    const $8d0eb4c1d86abc14$var$FORM_COLORS = [
        (0, $72ba03e317f3d228$export$60847d42f9da92a6),
        (0, $72ba03e317f3d228$export$5aae31392d72caaa),
        (0, $72ba03e317f3d228$export$747d86715d4175de),
        (0, $72ba03e317f3d228$export$215b7063051591f1),
        (0, $72ba03e317f3d228$export$69cb3ca10c1e330e),
        (0, $72ba03e317f3d228$export$a7175d4e9206bc80)
    ];
    const $8d0eb4c1d86abc14$export$993a5daeae2a3b3d = (index)=>$8d0eb4c1d86abc14$var$FORM_COLORS[index];
    const $8d0eb4c1d86abc14$export$aefdd89adb2344b3 = ()=>$8d0eb4c1d86abc14$var$FORM_COLORS[Math.floor(Math.random() * $8d0eb4c1d86abc14$var$FORM_COLORS.length)];
    const $8d0eb4c1d86abc14$export$c3fba1eee1434e93 = (colorCode)=>{
        switch(colorCode){
            case 0, $72ba03e317f3d228$export$60847d42f9da92a6:
                return `var(--ds-background-accent-red-subtle, ${0, $72ba03e317f3d228$export$60847d42f9da92a6})`;
            case 0, $72ba03e317f3d228$export$5aae31392d72caaa:
                return `var(--ds-background-accent-yellow-subtle, ${0, $72ba03e317f3d228$export$5aae31392d72caaa})`;
            case 0, $72ba03e317f3d228$export$747d86715d4175de:
                return `var(--ds-background-accent-green-subtle, ${0, $72ba03e317f3d228$export$747d86715d4175de})`;
            case 0, $72ba03e317f3d228$export$69cb3ca10c1e330e:
                return `var(--ds-background-accent-teal-subtle, ${0, $72ba03e317f3d228$export$69cb3ca10c1e330e})`;
            case 0, $72ba03e317f3d228$export$a7175d4e9206bc80:
                return `var(--ds-background-accent-purple-subtle, ${0, $72ba03e317f3d228$export$a7175d4e9206bc80})`;
            case 0, $72ba03e317f3d228$export$215b7063051591f1:
            default:
                return `var(--ds-background-accent-blue-subtle, ${0, $72ba03e317f3d228$export$215b7063051591f1})`;
        }
    };
});
parcelRegister("b668c", function(module, exports) {
    $parcel$export(module.exports, "useJWMFormsFeatures", ()=>$16b8c1742dea6da5$export$761e4daa424a5fb7);
    $parcel$export(module.exports, "default", ()=>$16b8c1742dea6da5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $16b8c1742dea6da5$var$defaultFeaturesContext = {
        featureView: 'form-submit',
        shouldHidePoweredBy: false
    };
    const $16b8c1742dea6da5$var$JWMFormsFeaturesContext = (0, $5uXOq.createContext)($16b8c1742dea6da5$var$defaultFeaturesContext);
    const $16b8c1742dea6da5$export$761e4daa424a5fb7 = ()=>(0, $5uXOq.useContext)($16b8c1742dea6da5$var$JWMFormsFeaturesContext);
    var $16b8c1742dea6da5$export$2e2bcd8739ae039 = $16b8c1742dea6da5$var$JWMFormsFeaturesContext;
});
parcelRegister("djHla", function(module, exports) {
    $parcel$export(module.exports, "MediaPermissionsPreloader", ()=>$d53363cdf9dab000$export$1ea28abf1046610e);
    $parcel$export(module.exports, "useMediaPermissions", ()=>$d53363cdf9dab000$export$270452b93e9d2c99);
    var $5uXOq = parcelRequire("5uXOq");
    var $6dxIs;
    var $dJTwj;
    const $d53363cdf9dab000$export$1ea28abf1046610e = ({ projectId: projectId, formId: formId })=>{
        const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, (0, parcelRequire("6dxIs")).useUploadPermissions)();
        const [, { updateStore: updateStore }] = (0, (0, parcelRequire("dJTwj")).useMediaPermissionsStore)();
        (0, $5uXOq.useEffect)(()=>{
            if (projectId) fetchUploadPermissions(projectId, formId);
        }, [
            projectId,
            fetchUploadPermissions,
            formId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateStore({
                mediaUploadPermissions: uploadPermissions,
                mediaUploadPermissionStatus: uploadPermissionStatus
            });
        }, [
            updateStore,
            uploadPermissionStatus,
            uploadPermissions
        ]);
        return null;
    };
    const $d53363cdf9dab000$export$270452b93e9d2c99 = ()=>{
        const [{ mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus }] = (0, (0, parcelRequire("dJTwj")).useMediaPermissionsStore)();
        const isUploadPermissionReady = mediaUploadPermissionStatus === 'COMPLETED' && mediaUploadPermissions !== null;
        return {
            mediaUploadPermissions: mediaUploadPermissions,
            mediaUploadPermissionStatus: mediaUploadPermissionStatus,
            mediaContext: {
                viewContext: isUploadPermissionReady ? mediaUploadPermissions : {},
                uploadContext: isUploadPermissionReady ? mediaUploadPermissions : {},
                userAuth: null
            }
        };
    };
});
parcelRegister("6dxIs", function(module, exports) {
    $parcel$export(module.exports, "useUploadPermissions", ()=>$d55c0017318f0800$export$9fc4bf889c7dbfba);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $8zOmE;
    var $lwMsT;
    var $jpsyn;
    const $d55c0017318f0800$var$QUERY_ID = 'formSubmissionMediaPermissions';
    const $d55c0017318f0800$export$9fc4bf889c7dbfba = (isDescriptionField)=>{
        const [uploadPermissionStatus, setUploadPermissionStatus] = (0, $5uXOq.useState)('NOT_STARTED');
        const [uploadPermissions, setUploadPermissions] = (0, $5uXOq.useState)(null);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const fetchUploadPermissions = (0, $5uXOq.useCallback)(async (projectId, formId)=>{
            setUploadPermissionStatus('LOADING');
            try {
                const url = (0, (0, parcelRequire("jpsyn")).getMediaUploadPermissionUrl)(formId, Boolean(isDescriptionField));
                const uploadResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                setUploadPermissions({
                    clientId: uploadResponse.clientId,
                    serviceHost: uploadResponse.endpointUrl,
                    token: uploadResponse.token,
                    tokenLifespanInMs: uploadResponse.tokenDurationInMins * 60000,
                    collection: uploadResponse.targetCollection,
                    tokenIssueTimestamp: Date.now() - 10000
                });
                setUploadPermissionStatus('COMPLETED');
            } catch (err) {
                setUploadPermissionStatus('COMPLETED');
                if (err.statusCode === 403) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${$d55c0017318f0800$var$QUERY_ID} forbidden`);
                else (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $d55c0017318f0800$var$QUERY_ID,
                        packageName: 'jiraBusinessForm',
                        teamName: 'jira-werewolves'
                    },
                    attributes: {
                        statusCode: err.statusCode
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            createAnalyticsEvent,
            isDescriptionField
        ]);
        return {
            uploadPermissions: uploadPermissions,
            fetchUploadPermissions: fetchUploadPermissions,
            uploadPermissionStatus: uploadPermissionStatus
        };
    };
});
parcelRegister("jpsyn", function(module, exports) {
    $parcel$export(module.exports, "getMediaUploadPermissionUrl", ()=>$d10e4390e86d9aea$export$9f4e6a02a32c7984);
    $parcel$export(module.exports, "getFormAttachmentUploadUrl", ()=>$d10e4390e86d9aea$export$b80950102aaa651d);
    const $d10e4390e86d9aea$export$9f4e6a02a32c7984 = (formId, returnCreateIssueAdf)=>`/rest/api/2/attachment/upload/form/${formId}/credentials?returnCreateIssueAdf=${returnCreateIssueAdf}`;
    const $d10e4390e86d9aea$export$b80950102aaa651d = (formId)=>`/rest/api/2/attachment/upload/form/${formId}`;
});
parcelRegister("dJTwj", function(module, exports) {
    $parcel$export(module.exports, "useMediaPermissionsStore", ()=>$91f5295abbefbb95$export$9c03e2ed7cceacd6);
    var $3sQ5x;
    var $iXqE5;
    const $91f5295abbefbb95$var$actions = {
        updateStore: (newData)=>({ setState: setState })=>{
                setState(newData);
            }
    };
    const $91f5295abbefbb95$var$MediaPermissionsStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            mediaUploadPermissions: null,
            mediaUploadPermissionStatus: 'NOT_STARTED'
        },
        actions: $91f5295abbefbb95$var$actions,
        name: 'JWMMediaPermissions'
    });
    const $91f5295abbefbb95$export$9c03e2ed7cceacd6 = (0, (0, parcelRequire("3sQ5x")).createHook)($91f5295abbefbb95$var$MediaPermissionsStore);
});
const $410f34228866ee1a$export$aa78f5e84beba3ce = 240;
parcelRegister("7YlSK", function(module, exports) {
    $parcel$export(module.exports, "ContactAdminBanner", ()=>$de37af4b546c3e70$export$a50845fcec7cb9ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $hJ0Of;
    var $2APCZ;
    var $i6qxo;
    var $6Ll2T;
    var $99gde;
    var $8Q4sF;
    var $koVbs;
    var $aLvPW;
    const $de37af4b546c3e70$var$ContactYourAdminLink = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: "/jira/contact-administrator"
        }, children);
    const $de37af4b546c3e70$export$a50845fcec7cb9ff = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(true);
        const handleDismissClick = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, [
            setIsOpen
        ]);
        if (!isOpen) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $de37af4b546c3e70$var$bannerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJ0Of")).default), {
            testId: "business-form.ui.form-submission.contact-admin-banner.banner",
            appearance: "announcement"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Q4sF")).FormattedI18nMessage), {
            componentsMapping: {
                link: $de37af4b546c3e70$var$ContactYourAdminLink
            },
            message: formatMessage((0, (0, parcelRequire("aLvPW")).default).needToEdit, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            })
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $de37af4b546c3e70$var$buttonContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            label: "dismiss",
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("i6qxo"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("aLvPW")).default).dismiss),
                primaryColor: "var(--ds-text-inverse, white)"
            }),
            onClick: handleDismissClick
        })));
    };
    const $de37af4b546c3e70$var$bannerContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'relative'
    });
    const $de37af4b546c3e70$var$buttonContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        top: 'space.100',
        right: 'space.100'
    });
});
parcelRegister("aLvPW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fe90aa245dc4244$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8fe90aa245dc4244$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        needToEdit: {
            "id": "business-form.form-submission.contact-admin-banner.need-to-edit",
            "defaultMessage": "{linkStart}Contact your admin{linkEnd} to edit this form."
        },
        dismiss: {
            "id": "business-form.form-submission.contact-admin-banner.dismiss",
            "defaultMessage": "Dismiss"
        }
    });
});
parcelRegister("f9uY0", function(module, exports) {
    $parcel$export(module.exports, "FillInView", ()=>$35a47656ff93b9c5$export$32d78bb31929ae49);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1IqIJ;
    var $4EETE;
    var $lOr6E;
    var $3fqJh;
    var $6Ll2T;
    var $fm763;
    var $ZuPvl;
    var $99gde;
    var $loZC0;
    var $dJl1T;
    var $4R6GH;
    var $467lJ;
    var $LJaTB;
    var $koVbs;
    var $lfTZh;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $lwMsT;
    var $l2N2a;
    var $iEEXl;
    var $co4Oy;
    var $6czoq;
    var $icLsg;
    var $fOgCm;
    var $b668c;
    var $g2iZ7;
    var $djHla;
    var $kMDCx;
    var $6dxIs;
    var $jpsyn;
    var $c4qDm;
    var $icFsv;
    var $6Ti3X;
    var $jfugj;
    const $35a47656ff93b9c5$var$submissionErrorFlag = (errorMessage)=>{
        if (errorMessage === (0, (0, parcelRequire("iEEXl")).FORM_VALIDATION_ERROR).ATTACHMENT_ERROR) return {
            type: 'error',
            title: (0, (0, parcelRequire("icFsv")).default).submissionErrorFlag,
            description: (0, (0, parcelRequire("icFsv")).default).submissionAttachmentErrorContent,
            testId: 'business-form.ui.form-submission.fill-in-view.form-attachment-error-flag'
        };
        return {
            type: 'error',
            title: (0, (0, parcelRequire("icFsv")).default).submissionErrorFlag,
            description: errorMessage,
            testId: 'business-form.ui.form-submission.fill-in-view.error-flag'
        };
    };
    const $35a47656ff93b9c5$var$interactions = [
        'scroll',
        'click',
        'focus',
        'keydown'
    ];
    const $35a47656ff93b9c5$var$hasInitialInteractionCapture = true;
    const $35a47656ff93b9c5$export$32d78bb31929ae49 = ()=>{
        const [uploading, setUploading] = (0, $5uXOq.useState)(false);
        const [shouldRenderExtraFields, setShouldRenderExtraFields] = (0, $5uXOq.useState)(false);
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)(true);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { data: formSubmissionData, formId: formId } = (0, (0, parcelRequire("g2iZ7")).useFormSubmission)();
        const { data: projectData } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { shouldHidePoweredBy: shouldHidePoweredBy } = (0, (0, parcelRequire("b668c")).useJWMFormsFeatures)();
        const { formWithFieldData: formWithFieldData, fieldMetaData: fieldMetaData } = formSubmissionData ?? {};
        const { description: description, projectId: projectId, accessLevel: accessLevel, issueType: issueType } = formWithFieldData ?? {};
        const { uploadPermissions: uploadPermissions, fetchUploadPermissions: fetchUploadPermissions, uploadPermissionStatus: uploadPermissionStatus } = (0, (0, parcelRequire("6dxIs")).useUploadPermissions)(true);
        const { mediaUploadPermissions: mediaUploadPermissions, mediaUploadPermissionStatus: mediaUploadPermissionStatus, mediaContext: mediaContext } = (0, (0, parcelRequire("djHla")).useMediaPermissions)();
        const isUploadPermissionNotReady = uploadPermissionStatus !== 'COMPLETED' || mediaUploadPermissionStatus !== 'COMPLETED';
        const parsedDescription = (0, $5uXOq.useMemo)(()=>{
            if (description === undefined || description === '') return undefined;
            try {
                return JSON.parse(description);
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, (0, parcelRequire("iEEXl")).PACKAGE_NAME), 'failed to parse form description in form submission');
                return undefined;
            }
        }, [
            description
        ]);
        const analyticAttributes = (0, $5uXOq.useMemo)(()=>({
                accessLevel: accessLevel?.toString(),
                isOutsideUser: !projectData || !projectData?.permissions.createIssues,
                formId: formId
            }), [
            accessLevel,
            projectData,
            formId
        ]);
        const handleCreateIssueOnComplete = (0, $5uXOq.useCallback)(()=>{
            setIsVisible(false);
        }, [
            setIsVisible
        ]);
        const handleResetClick = (0, $5uXOq.useCallback)(()=>{
            setIsVisible(true);
        }, [
            setIsVisible
        ]);
        const renderExtraFields = (0, $5uXOq.useCallback)(()=>{
            setShouldRenderExtraFields(true);
            if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
        }, []);
        const setRef = (0, (0, parcelRequire("jfugj")).useIntersectionObserver)(renderExtraFields);
        const setIntersectionRef = (0, $5uXOq.useCallback)((element)=>setRef(element), [
            setRef
        ]);
        const { create: create, data: createIssueData, error: createIssueError, errorMessage: errorMessage, loading: createIssueLoading } = (0, (0, parcelRequire("kMDCx")).useCreateIssue)(formSubmissionData?.formWithFieldData, handleCreateIssueOnComplete, projectData?.type);
        const handleSubmitClick = (0, $5uXOq.useCallback)(async (formData)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'form submitted', 'formSubmission', analyticAttributes);
            await create(formData);
        }, [
            create,
            createAnalyticsEvent,
            analyticAttributes
        ]);
        const renderFields = (0, $5uXOq.useCallback)((fields)=>fields.map((f)=>{
                if (!fieldMetaData || !fieldMetaData[f.fieldId]) return null;
                const fieldConfig = (0, (0, parcelRequire("fOgCm")).getFieldTypeConfig)(f.type, projectData?.type);
                if (!fieldConfig) {
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'field missing', {
                        type: f.type
                    });
                    return null;
                }
                const { autoCompleteUrl: autoCompleteUrl, allowedValues: allowedValues = [], defaultFieldValue: defaultFieldValue, schema: schema } = fieldMetaData[f.fieldId];
                let completeUrl = autoCompleteUrl;
                if (Boolean(undefined) && typeof autoCompleteUrl === 'string') {
                    const url = new URL(autoCompleteUrl);
                    completeUrl = `${url.pathname}${url.search}`;
                }
                const isFieldRequired = f.isRequired || !!f.isRequiredByForm;
                const fieldDescription = f.description;
                const field = (0, ($parcel$interopDefault($5uXOq))).createElement(fieldConfig.Component, {
                    key: f.fieldId,
                    fieldName: typeof f.alias === 'string' && f.alias.length > 0 ? f.alias : f.name,
                    fieldId: f.fieldId,
                    isRequired: isFieldRequired,
                    description: fieldDescription,
                    autoCompleteUrl: completeUrl,
                    allowedValues: allowedValues,
                    mediaUploadContexts: {
                        uploadContext: uploadPermissions,
                        attachmentUploadContext: mediaUploadPermissions
                    },
                    projectId: String(projectId),
                    issueTypeId: issueType?.id,
                    projectKey: projectData?.key,
                    onInProgressChange: setUploading,
                    defaultValue: defaultFieldValue,
                    attachmentCustomUploadURL: (0, (0, parcelRequire("jpsyn")).getFormAttachmentUploadUrl)(formId),
                    canUserViewProject: Boolean(projectData?.permissions?.viewIssues),
                    schemaConfiguration: schema?.configuration
                });
                return f.parentCondition && (0, (0, parcelRequire("4R6GH")).fg)('jira_forms_conditional_field_logic_gate_') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4qDm")).default), {
                    key: `${f.parentCondition.id}:${f.fieldId}`,
                    condition: f.parentCondition
                }, field) : field;
            }), [
            fieldMetaData,
            uploadPermissions,
            mediaUploadPermissions,
            projectId,
            issueType?.id,
            formId,
            projectData?.permissions?.viewIssues,
            projectData?.key,
            projectData?.type,
            createAnalyticsEvent
        ]);
        const getErrorFlag = (0, $5uXOq.useCallback)(()=>errorMessage !== null && typeof errorMessage === 'string' ? $35a47656ff93b9c5$var$submissionErrorFlag(errorMessage) : (0, (0, parcelRequire("467lJ")).default).genericError(), [
            errorMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.addEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
            return ()=>{
                if (typeof document !== 'undefined') $35a47656ff93b9c5$var$interactions.forEach((evt)=>document.removeEventListener(evt, renderExtraFields, $35a47656ff93b9c5$var$hasInitialInteractionCapture));
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (typeof projectId === 'number') fetchUploadPermissions(String(projectId), formId);
        }, [
            fetchUploadPermissions,
            formId,
            projectId
        ]);
        if (createIssueData?.success && !isVisible) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "business-form.ui.form-submission.fill-in-view.success-view"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6czoq")).SuccessView), {
            shouldHidePoweredBy: shouldHidePoweredBy,
            onResetClick: handleResetClick,
            analyticAttributes: analyticAttributes
        }));
        if (!formSubmissionData || !formWithFieldData || !fieldMetaData || isUploadPermissionNotReady) return null;
        const cloneInitialFields = [
            ...formWithFieldData.fields
        ];
        const initialFields = cloneInitialFields.splice(0, 15);
        const shouldRenderAdditionalFields = cloneInitialFields.length > 0 && shouldRenderExtraFields;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            objectType: "form",
            objectId: formId,
            containerType: "project",
            containerId: String(projectId),
            attributes: {
                ...(0, (0, parcelRequire("jfugj")).generateFieldAnalytics)(formWithFieldData.fields),
                ...analyticAttributes
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "formSubmission viewed"
        }), projectData?.name ? (0, ($parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$ProjectNameWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), {
            alignBlock: "center",
            space: "space.100"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            appearance: "square",
            size: "small",
            src: projectData?.avatarUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            as: "span",
            color: "color.text.subtle",
            weight: "semibold"
        }, projectData?.name))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $35a47656ff93b9c5$var$projectNamePlaceholderStyles
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formWithFieldData.title,
            position: "right"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("icLsg")).TitleWrapperTruncated), null, formWithFieldData.title)), (0, ($parcel$interopDefault($5uXOq))).createElement($35a47656ff93b9c5$var$DescriptionWrapper, {
            "data-testid": "business-form.ui.form-submission.fill-in-view.description"
        }, parsedDescription ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "description-view",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("co4Oy")).default), {
            document: parsedDescription,
            mediaContext: mediaContext,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true
            },
            baseUrl: ""
        })) : null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOr6E")).default), {
            isDisabled: createIssueLoading || createIssueData?.success && !isVisible,
            onSubmit: handleSubmitClick
        }, ({ formProps: formProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("form", {
                ...formProps,
                name: "submit form",
                noValidate: true,
                "data-test-id": "business-form.ui.form-submission.fill-in-view.form"
            }, renderFields(initialFields), shouldRenderAdditionalFields && renderFields(cloneInitialFields), !shouldRenderAdditionalFields && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                ref: setIntersectionRef
            }), (shouldRenderAdditionalFields || formWithFieldData.fields.length <= 15) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3fqJh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4EETE")).default), {
                testId: "business-form.ui.form-submission.fill-in-view.loading-button",
                type: "submit",
                appearance: "primary",
                isLoading: createIssueLoading || uploading,
                interactionName: "business-form-submission-submit"
            }, formatMessage((0, (0, parcelRequire("icFsv")).default).submitButton))), (0, (0, parcelRequire("4R6GH")).fg)('jira_forms_conditional_field_logic_gate_') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ti3X")).default), null))), createIssueError && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "business-form.ui.form-submission.fill-in-view.flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("LJaTB")).FlagRenderer), {
            flag: getErrorFlag()
        })));
    };
    const $35a47656ff93b9c5$var$ProjectNameWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _18s8zu5n",
                __cmplp.className
            ])
        });
    });
    const $35a47656ff93b9c5$var$projectNamePlaceholderStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.200'
    });
    const $35a47656ff93b9c5$var$DescriptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pku2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3fqJh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$443778c9cd3bd4a5$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $443778c9cd3bd4a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $443778c9cd3bd4a5$var$formFooterWrapperStyles = {
        name: "1rruhyk",
        styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
    };
    const $443778c9cd3bd4a5$var$justifyContentStyles = {
        name: "11g6mpt",
        styles: "justify-content:flex-start"
    };
    function $443778c9cd3bd4a5$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("footer", {
            css: [
                $443778c9cd3bd4a5$var$formFooterWrapperStyles,
                align === 'start' && $443778c9cd3bd4a5$var$justifyContentStyles
            ]
        }, children);
    }
});
parcelRegister("467lJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc639d9ac2372482$export$2e2bcd8739ae039);
    var $8BkAH;
    var $8hiuq;
    var $l7mS2;
    var $5jDRa;
    var $dc639d9ac2372482$export$2e2bcd8739ae039 = {
        forbidden: (0, parcelRequire("8BkAH")).default,
        genericError: (0, parcelRequire("8hiuq")).default,
        serverError: (0, parcelRequire("l7mS2")).default,
        unauthorized: (0, parcelRequire("5jDRa")).default
    };
});
parcelRegister("8BkAH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47acdb71562a5159$export$2e2bcd8739ae039);
    var $7VHMR;
    const $47acdb71562a5159$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.forbidden.title",
            "defaultMessage": "You don't have permission to do that"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.forbidden.description",
            "defaultMessage": "Ask your Jira admin for help."
        }
    });
    var $47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $47acdb71562a5159$var$messages.title,
            description: $47acdb71562a5159$var$messages.description
        });
});
parcelRegister("8hiuq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffd4533bf12eb3f1$export$2e2bcd8739ae039);
    var $7VHMR;
    const $ffd4533bf12eb3f1$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.generic-error.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.generic-error.description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
    var $ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $ffd4533bf12eb3f1$var$messages.title,
            description: $ffd4533bf12eb3f1$var$messages.description
        });
});
parcelRegister("l7mS2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31a915dd4c1d2142$export$2e2bcd8739ae039);
    var $7VHMR;
    const $31a915dd4c1d2142$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.server-error.title",
            "defaultMessage": "We're having some trouble"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.server-error.description",
            "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
        }
    });
    var $31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $31a915dd4c1d2142$var$messages.title,
            description: $31a915dd4c1d2142$var$messages.description
        });
});
parcelRegister("5jDRa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8754751d720d57d4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $8754751d720d57d4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.flags.flags.errors.unauthorized.title",
            "defaultMessage": "You're logged out"
        },
        description: {
            "id": "platform.ui.flags.flags.errors.unauthorized.description",
            "defaultMessage": "Log back in and try again."
        }
    });
    var $8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $8754751d720d57d4$var$messages.title,
            description: $8754751d720d57d4$var$messages.description
        });
});
parcelRegister("LJaTB", function(module, exports) {
    $parcel$export(module.exports, "FlagRenderer", ()=>$2de6889b93863972$export$7c38ebd1f7ca6a5a);
    var $hkhmi;
    var $34Vv8;
    const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, (0, parcelRequire("34Vv8")).default)((0, (0, parcelRequire("hkhmi")).default));
});
parcelRegister("hkhmi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2971dd786c0add8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHfPB;
    class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { flagService: flagService, flag: flag } = this.props;
            if (flagService) this.flagId = flagService.showFlag(flag);
        }
        componentWillUnmount() {
            const { flagService: flagService } = this.props;
            if (flagService && this.flagId) flagService.dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(this.flagId));
        }
        render() {
            return null;
        }
    }
});
parcelRegister("co4Oy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2436649549ab9cdd$export$2e2bcd8739ae039);
    var $1jUsD;
    const $2436649549ab9cdd$var$AsyncDescriptionReadView = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("iBqjK")), {
        ssr: false,
        moduleId: "./src/packages/business/form/src/common/ui/description-read/main.tsx"
    });
    var $2436649549ab9cdd$export$2e2bcd8739ae039 = $2436649549ab9cdd$var$AsyncDescriptionReadView;
});
parcelRegister("iBqjK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7VuUY").then(()=>parcelRequire('bFrp8'));
});
parcelRegister("icLsg", function(module, exports) {
    $parcel$export(module.exports, "TitleWrapper", ()=>$e2b5765917c57fb2$export$585a3b23e887288b);
    $parcel$export(module.exports, "TitleWrapperTruncated", ()=>$e2b5765917c57fb2$export$179667894b01611b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $e2b5765917c57fb2$export$585a3b23e887288b = (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81p5s _19pkidpf _fh0l1f4h _o8b6idpf _6id51kw7 _1ols1kw7",
                __cmplp.className
            ])
        });
    });
    const $e2b5765917c57fb2$export$179667894b01611b = (0, $5uXOq.forwardRef)(({ as: C = $e2b5765917c57fb2$export$585a3b23e887288b, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _o5721q9c _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kMDCx", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$b6e087ee0849b727$export$8af2d18142c8506c);
    var $5tTFS;
    var $cm8b5;
    var $dJl1T;
    var $jcw0u;
    var $4R6GH;
    var $eCBf9;
    var $8zOmE;
    var $lwMsT;
    var $iEEXl;
    var $kgZWx;
    var $qPGip;
    const $b6e087ee0849b727$var$QUERY_NAME = 'CreateJiraBusinessIssueForm';
    const $b6e087ee0849b727$var$logMissing = (name)=>{
        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, (0, parcelRequire("iEEXl")).PACKAGE_NAME), `"${name}" was unexpectedly null or undefined for form submission`);
    };
    const $b6e087ee0849b727$export$8af2d18142c8506c = (formWithFieldData, onComplete, projectType)=>{
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("iEEXl")).SUBMIT_FORM_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("iEEXl")).SUBMIT_FORM_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("iEEXl")).SUBMIT_FORM_EXPERIENCE));
        const doFireErrorAnalytics = (error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: $b6e087ee0849b727$var$QUERY_NAME,
                    packageName: 'jiraBusinessForm',
                    teamName: 'jira-werewolves'
                },
                error: Array.isArray(error) && error.length > 0 ? error[0] : error,
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [createIssue, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("kgZWx")).FORM_CREATE_ISSUE_MUTATION), {
            onError: (apolloError)=>{
                doFireErrorAnalytics(apolloError);
                markExperienceFailed('create issue service - mutation onError', apolloError);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, (0, parcelRequire("iEEXl")).PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
            },
            onCompleted: (responseData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$b6e087ee0849b727$var$QUERY_NAME} succeeded`, {});
                if (responseData.createJiraBusinessIssueByForm?.errors) {
                    const errors = responseData.createJiraBusinessIssueByForm.errors.map((e)=>new (0, (0, parcelRequire("eCBf9")).MutationError)(e)).filter((e)=>e.message !== (0, (0, parcelRequire("iEEXl")).FORM_VALIDATION_ERROR).ATTACHMENT_ERROR && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$b46f0126077d6b7c) && e.extensions?.errorType !== (0, $b2058fd633cf6c26$export$d65db43b48ab539f));
                    if (errors.length > 0) {
                        doFireErrorAnalytics(errors);
                        const mutationError = errors.find((e)=>e.message);
                        if (mutationError) markExperienceFailed('Create issue service mutation failed', new (0, (0, parcelRequire("eCBf9")).MutationError)(mutationError), {
                            errorType: mutationError.extensions?.errorType || '',
                            statusCode: mutationError.extensions?.statusCode || ''
                        });
                    }
                    return;
                }
                if (responseData.createJiraBusinessIssueByForm?.item?.issueId) {
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(responseData.createJiraBusinessIssueByForm.item.issueId));
                    onComplete?.();
                }
                markExperienceSuccess();
            }
        });
        const create = async (formInputData)=>{
            const projectId = formWithFieldData?.projectId;
            const issueTypeId = formWithFieldData?.issueType?.id;
            const formId = formWithFieldData?.formId;
            startExperience();
            if (typeof formInputData !== 'object') {
                $b6e087ee0849b727$var$logMissing('formInputData');
                return;
            }
            if (typeof formWithFieldData !== 'object') {
                $b6e087ee0849b727$var$logMissing('formWithFieldData');
                return;
            }
            if (typeof projectId !== 'number') {
                $b6e087ee0849b727$var$logMissing('projectId');
                return;
            }
            if (typeof issueTypeId !== 'string') {
                $b6e087ee0849b727$var$logMissing('issueTypeId');
                return;
            }
            if (typeof formId !== 'string') {
                $b6e087ee0849b727$var$logMissing('formId');
                return;
            }
            const fields = (0, (0, parcelRequire("4R6GH")).fg)('jsw_forms_rollout') ? (0, (0, parcelRequire("qPGip")).transformFormData)({
                formInputData: formInputData,
                formWithFieldData: formWithFieldData,
                projectType: projectType
            }) : (0, (0, parcelRequire("qPGip")).transformFormData)({
                formInputData: formInputData,
                formWithFieldData: formWithFieldData
            });
            await createIssue({
                variables: {
                    input: {
                        formId: formId,
                        fields: fields
                    }
                },
                onError: ()=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, (0, parcelRequire("iEEXl")).PACKAGE_NAME), 'ApolloError: Failed to create issue using form');
                }
            });
        };
        const mutationBadRequestError = data?.createJiraBusinessIssueByForm?.errors?.map((e)=>new (0, (0, parcelRequire("eCBf9")).MutationError)(e))?.find((e)=>e.message);
        return {
            error: error || mutationBadRequestError,
            errorMessage: mutationBadRequestError ? (0, (0, parcelRequire("qPGip")).transformErrorMessage)(mutationBadRequestError, formWithFieldData) : null,
            data: (0, (0, parcelRequire("qPGip")).transformResult)(data),
            loading: loading,
            create: create
        };
    };
});
parcelRegister("eCBf9", function(module, exports) {
    $parcel$export(module.exports, "MutationError", ()=>$5fe48c9a5d56428c$export$10c788363424e94e);
    const $5fe48c9a5d56428c$export$bd0568a021288e41 = 'MutationError';
    class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.message = payload.message ?? '';
            this.extensions = payload.extensions;
            this.statusCode = payload.extensions?.statusCode ?? null;
        }
    }
});
const $b2058fd633cf6c26$export$b46f0126077d6b7c = 'REQUIRED_FIELD_MISSING';
const $b2058fd633cf6c26$export$d65db43b48ab539f = 'FIELD_VALIDATION_FAILED';
parcelRegister("kgZWx", function(module, exports) {
    $parcel$export(module.exports, "FORM_CREATE_ISSUE_MUTATION", ()=>$aa968c869903eefe$export$8421abc4fb1c6a51);
    var $5cllN;
    const $aa968c869903eefe$export$8421abc4fb1c6a51 = (0, (0, parcelRequire("5cllN")).default)`
mutation CreateJiraBusinessIssueByForm($input: JwmFormCreateIssueInput!) {
  createJiraBusinessIssueByForm(input: $input) {
    item {
      id
      issueId
    }
    success
    errors {
      message
      extensions {
        ... on FieldValidationMutationErrorExtension {
          statusCode
          errorType
          fieldId
        }
      }
    }
  }
}
`;
});
parcelRegister("qPGip", function(module, exports) {
    $parcel$export(module.exports, "transformResult", ()=>$aa4cd5c41c12e7b8$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "transformFormData", ()=>$aa4cd5c41c12e7b8$export$d1360584b6d92fb7);
    $parcel$export(module.exports, "transformErrorMessage", ()=>$aa4cd5c41c12e7b8$export$d7c77df21c828876);
    var $4Xk2W = parcelRequire("4Xk2W");
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $fOgCm;
    var $kShoa;
    const $aa4cd5c41c12e7b8$export$f13b29f9ed0c5a03 = (data)=>{
        if (!data) return data;
        const issueId = data.createJiraBusinessIssueByForm?.item?.issueId;
        const isIssueIdValid = typeof issueId === 'number';
        const isCreateJiraBusinessIssueSuccessValid = typeof data.createJiraBusinessIssueByForm?.success === 'boolean';
        if (!isIssueIdValid || !isCreateJiraBusinessIssueSuccessValid) (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'transformFormSubmissionResult',
                packageName: 'jiraBusinessForm',
                teamName: 'jira-werewolves'
            },
            attributes: {
                message: 'Some fields from form submission were not returned properly',
                isIssueIdValid: isIssueIdValid,
                isCreateJiraBusinessIssueSuccessValid: isCreateJiraBusinessIssueSuccessValid
            },
            sendToPrivacyUnsafeSplunk: true
        });
        if (typeof data.createJiraBusinessIssueByForm?.success !== 'boolean') return undefined;
        return {
            success: data.createJiraBusinessIssueByForm.success,
            issueId: issueId
        };
    };
    const $aa4cd5c41c12e7b8$export$d1360584b6d92fb7 = ({ formInputData: formInputData, formWithFieldData: formWithFieldData, projectType: projectType })=>{
        const formFieldsById = (0, ($parcel$interopDefault($4Xk2W)))(formWithFieldData.fields, (f)=>f.fieldId);
        const fields = {
            users: [],
            labels: [],
            versions: [],
            stringFields: [],
            adfFields: [],
            multipleSelectFields: [],
            singleGroupPickerFields: [],
            multipleGroupPickerFields: [],
            multipleSelectUserPickerFields: []
        };
        Object.entries(formInputData).forEach(([key, value])=>{
            if (value === undefined || value === null) return;
            const fieldData = formFieldsById[key];
            if (!fieldData) return;
            const { type: type } = fieldData;
            const fieldConfig = (0, (0, parcelRequire("fOgCm")).getFieldTypeConfig)(type, projectType);
            if (!fieldConfig) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'transformFormSubmissionResult',
                        packageName: 'jiraBusinessForm',
                        teamName: 'jira-werewolves'
                    },
                    attributes: {
                        message: `"${type}" was unexpectedly missing in form config in form submission`
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return;
            }
            fieldConfig.writer(key, value, fields);
        });
        const labelsField = fields.labels.find((f)=>f.fieldId === 'labels');
        const formLabelPrefix = (0, (0, parcelRequire("4R6GH")).fg)('jsw_forms_rollout') ? (0, (0, parcelRequire("fOgCm")).getFormLabelPrefix)(projectType) : (0, (0, parcelRequire("fOgCm")).FORM_LABEL);
        const uniqueFormLabel = (0, (0, parcelRequire("fOgCm")).getUniqueFormLabel)(formLabelPrefix, formWithFieldData.formId);
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jwm_business_forms_issue_view');
        if (labelsField) {
            if (!labelsField.values.values.includes(formLabelPrefix)) labelsField.values.values.push(formLabelPrefix);
            if (expConfig.get('isFormsIssueViewEnabled', false)) {
                if (!labelsField.values.values.includes(uniqueFormLabel)) labelsField.values.values.push(uniqueFormLabel);
            }
        } else {
            const labelsToAdd = [
                formLabelPrefix
            ];
            if (expConfig.get('isFormsIssueViewEnabled', false)) labelsToAdd.push(uniqueFormLabel);
            fields.labels.push((0, (0, parcelRequire("kShoa")).toLabelsField)('labels', labelsToAdd));
        }
        return fields;
    };
    const $aa4cd5c41c12e7b8$export$d7c77df21c828876 = (err, formWithFieldData)=>{
        const fieldWithError = formWithFieldData?.fields?.find((field)=>field.fieldId === err?.extensions?.fieldId);
        const errorMessage = fieldWithError?.alias ? err?.message.replace(fieldWithError.name, fieldWithError.alias) : err?.message;
        return errorMessage;
    };
});
parcelRegister("4Xk2W", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
        $1m3dq(result, key, value);
    });
    module.exports = $39bc38f0156cacc0$var$keyBy;
});
parcelRegister("c4qDm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70398421e931218a$export$2e2bcd8739ae039);
    var $9fDOt;
    const $70398421e931218a$var$Condition = ({ condition: condition, children: children })=>{
        const isValid = (0, (0, parcelRequire("9fDOt")).useConditionValidator)(condition);
        return isValid ? children : null;
    };
    var $70398421e931218a$export$2e2bcd8739ae039 = $70398421e931218a$var$Condition;
});
parcelRegister("9fDOt", function(module, exports) {
    $parcel$export(module.exports, "useConditionValidator", ()=>$8cb5eb768c39cd03$export$17591b2856d3d1a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $7PYcZ;
    var $3SFJ0;
    const $8cb5eb768c39cd03$export$be08e95e749ed486 = (condition)=>{
        if (condition.__typename === 'JiraFormSelectCondition') return (0, (0, parcelRequire("3SFJ0")).makeSelectConditionValidator)(condition);
        return null;
    };
    const $8cb5eb768c39cd03$export$17591b2856d3d1a3 = (condition)=>{
        const formState = (0, (0, parcelRequire("7PYcZ")).useFormState)({
            values: true
        });
        const validator = (0, $5uXOq.useMemo)(()=>$8cb5eb768c39cd03$export$be08e95e749ed486(condition), [
            condition
        ]);
        if (!validator || !formState?.values) return true;
        const fieldValue = formState.values[condition.parentField.fieldId];
        if (fieldValue === undefined) return false;
        return validator(fieldValue);
    };
});
parcelRegister("7PYcZ", function(module, exports) {
    $parcel$export(module.exports, "useFormState", ()=>$ad6c72384c8565bc$export$606f11b2eb45ecc6);
    var $5uXOq = parcelRequire("5uXOq");
    var $lOr6E;
    const $ad6c72384c8565bc$var$defaultSubscriptionConfig = {
        values: true
    };
    const $ad6c72384c8565bc$var$getSubscriptionHash = (subscriptionConfig)=>{
        let hash = '';
        for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
        return hash;
    };
    const $ad6c72384c8565bc$export$606f11b2eb45ecc6 = (subscriptionConfig = $ad6c72384c8565bc$var$defaultSubscriptionConfig)=>{
        const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).FormContext));
        const [state, setState] = (0, $5uXOq.useState)();
        const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$ad6c72384c8565bc$var$getSubscriptionHash(subscriptionConfig), [
            subscriptionConfig
        ]);
        const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, [
            subscriptionConfigHash
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subscribe((formState)=>{
                setState(formState);
            }, config);
            return ()=>unsubscribe();
        }, [
            subscribe,
            config
        ]);
        return state;
    };
});
parcelRegister("3SFJ0", function(module, exports) {
    $parcel$export(module.exports, "makeSelectConditionValidator", ()=>$e775093f07257699$export$8c83f6839a9dfd3);
    const $e775093f07257699$export$26db3529e2ea773b = (possibleSelectOption)=>{
        return 'value' in possibleSelectOption && (typeof possibleSelectOption.value === 'undefined' || typeof possibleSelectOption.value === 'string');
    };
    const $e775093f07257699$export$4be42473522c84f6 = (possibleSelectOptionArray)=>{
        if (!Array.isArray(possibleSelectOptionArray)) return false;
        if (possibleSelectOptionArray.length) return possibleSelectOptionArray.every($e775093f07257699$export$26db3529e2ea773b);
        return true;
    };
    const $e775093f07257699$export$8c83f6839a9dfd3 = (condition)=>{
        const { fieldOptionIds: fieldOptionIds, operator: operator } = condition;
        return (fieldValue)=>{
            if (!fieldOptionIds?.length) return true;
            if (fieldValue === null) return false;
            if ($e775093f07257699$export$26db3529e2ea773b(fieldValue)) return fieldOptionIds.includes(fieldValue.value);
            if ($e775093f07257699$export$4be42473522c84f6(fieldValue)) return operator === 'ALL' ? fieldOptionIds.every((id)=>fieldValue.find(({ value: value })=>value === id)) : fieldOptionIds.some((id)=>fieldValue.find(({ value: value })=>value === id));
            return true;
        };
    };
});
parcelRegister("icFsv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f40c930e967a388f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f40c930e967a388f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        submissionErrorFlag: {
            "id": "business-form.form-submission.fill-in-view.submission-error-flag",
            "defaultMessage": "Something's gone wrong"
        },
        submissionAttachmentErrorContent: {
            "id": "business-form.form-submission.fill-in-view.submission-attachment-error-content",
            "defaultMessage": "Attachment upload failed. Make sure the file format and size are correct, and check your internet connection before trying again."
        },
        submitButton: {
            "id": "business-form.form-submission.fill-in-view.submit-button",
            "defaultMessage": "Submit"
        }
    });
});
parcelRegister("6Ti3X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59de8f2d041a296c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $7PYcZ;
    var $fraBZ;
    var $koVbs;
    var $ea1JH;
    const $59de8f2d041a296c$var$useMessageCreator = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, $5uXOq.useCallback)((prevValues, newValues)=>{
            if (!prevValues || !newValues) return '';
            const fieldCountDiff = Object.keys(prevValues).length - Object.keys(newValues).length;
            if (fieldCountDiff === 0) return '';
            return fieldCountDiff < 0 ? formatMessage((0, (0, parcelRequire("ea1JH")).default).fieldsAdded, {
                fieldCount: Math.abs(fieldCountDiff)
            }) : formatMessage((0, (0, parcelRequire("ea1JH")).default).fieldsRemoved, {
                fieldCount: Math.abs(fieldCountDiff)
            });
        }, [
            formatMessage
        ]);
    };
    const $59de8f2d041a296c$var$ScreenreaderAnnouncer = ()=>{
        const formState = (0, (0, parcelRequire("7PYcZ")).useFormState)({
            values: true
        });
        const prevValues = (0, $5uXOq.useRef)();
        const [message, setMessage] = (0, $5uXOq.useState)('');
        const getMessage = $59de8f2d041a296c$var$useMessageCreator();
        const debouncedUpdateMessage = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((newValues)=>{
                const newMessage = getMessage(prevValues.current, newValues);
                prevValues.current = newValues;
                setMessage(newMessage);
            }, 200), [
            getMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            debouncedUpdateMessage(formState?.values);
        }, [
            debouncedUpdateMessage,
            formState?.values
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fraBZ")).AnnouncerV2), {
            message: message
        });
    };
    var $59de8f2d041a296c$export$2e2bcd8739ae039 = $59de8f2d041a296c$var$ScreenreaderAnnouncer;
});
parcelRegister("fraBZ", function(module, exports) {
    $parcel$export(module.exports, "AnnouncerV2", ()=>$f73a83ae5cba96ea$export$a43c8a2f4981e0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dqoiX;
    const $f73a83ae5cba96ea$var$NON_BREAKING_SPACE = '\u00A0';
    const $f73a83ae5cba96ea$export$a43c8a2f4981e0e = (0, $5uXOq.memo)(({ message: originalMessage, liveMode: liveMode = 'polite', shouldAnnounce: shouldAnnounce = true, testId: testId })=>{
        const previousMessage = (0, $5uXOq.useRef)('');
        const setAlternatePolite = (0, $5uXOq.useRef)(false);
        const addSuffix = (0, $5uXOq.useRef)(false);
        const [oldMessage, setOldMessage] = (0, $5uXOq.useState)('');
        const [newMessage, setNewMessage] = (0, $5uXOq.useState)('');
        (0, $5uXOq.useEffect)(()=>{
            let message = shouldAnnounce ? originalMessage : $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
            if (previousMessage.current === message) {
                addSuffix.current = !addSuffix.current;
                if (addSuffix.current) message += $f73a83ae5cba96ea$var$NON_BREAKING_SPACE;
            }
            setOldMessage(setAlternatePolite.current ? '' : message);
            setNewMessage(setAlternatePolite.current ? message : '');
            if (shouldAnnounce) setAlternatePolite.current = !setAlternatePolite.current;
            previousMessage.current = originalMessage;
        }, [
            originalMessage,
            shouldAnnounce
        ]);
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-live": liveMode,
            "aria-relevant": "additions text",
            "aria-atomic": "true"
        }, oldMessage), $5uXOq.createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-live": liveMode,
            "aria-relevant": "additions text",
            "aria-atomic": "true"
        }, newMessage));
    });
    const $f73a83ae5cba96ea$var$positionRelative = null;
});
parcelRegister("dqoiX", function(module, exports) {
    $parcel$export(module.exports, "visuallyHiddenStyles", ()=>$11827e0613b04108$export$8dd524ceb40e3d16);
    $parcel$export(module.exports, "ScreenReaderText", ()=>$11827e0613b04108$export$88fad6aa294f111c);
    $parcel$export(module.exports, "ScreenReaderCaption", ()=>$11827e0613b04108$export$200c8e5d652aa9af);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $11827e0613b04108$export$8dd524ceb40e3d16 = {
        clip: 'rect(1px, 1px, 1px, 1px)',
        clipPath: 'inset(50%)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute'
    };
    const $11827e0613b04108$export$88fad6aa294f111c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
    const $11827e0613b04108$export$200c8e5d652aa9af = (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ea1JH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38c1ce986f69f095$export$2e2bcd8739ae039);
    var $7VHMR;
    var $38c1ce986f69f095$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fieldsRemoved: {
            "id": "business-form.form-submission.fill-in-view.screenreader-announcer.fields-removed",
            "defaultMessage": "{fieldCount, plural,\n\t\t\tone {# form field has been removed below}\n\t\t\tother {# form fields have been removed below}\n\t\t}"
        },
        fieldsAdded: {
            "id": "business-form.form-submission.fill-in-view.screenreader-announcer.fields-added",
            "defaultMessage": "{fieldCount, plural,\n\t\t\tone {# form field has been added below}\n\t\t\tother {# form fields have been added below}\n\t\t}"
        }
    });
});
parcelRegister("jfugj", function(module, exports) {
    $parcel$export(module.exports, "generateFieldAnalytics", ()=>$f80bb0d21b4f5357$export$9c1a0599c1937c10);
    $parcel$export(module.exports, "useIntersectionObserver", ()=>$f80bb0d21b4f5357$export$a7395f9832c00176);
    var $5uXOq = parcelRequire("5uXOq");
    var $kGsr8 = parcelRequire("kGsr8");
    const $f80bb0d21b4f5357$export$9c1a0599c1937c10 = (fields)=>{
        const fieldIds = (0, ($parcel$interopDefault($kGsr8)))(fields.map((field)=>field.type.replace('com.atlassian.jira.plugin.system.customfieldtypes:', '')));
        const customFieldCount = fields.filter((field)=>field.fieldId.startsWith('customfield_')).length;
        const fieldCount = fields.length;
        return {
            fieldIds: fieldIds,
            customFieldCount: customFieldCount,
            fieldCount: fieldCount
        };
    };
    const $f80bb0d21b4f5357$export$a7395f9832c00176 = (onIntersection)=>{
        const [ref, setRef] = (0, $5uXOq.useState)(null);
        const handleObserver = (0, $5uXOq.useCallback)((entries)=>{
            entries.forEach(({ isIntersecting: isIntersecting })=>{
                if (isIntersecting) onIntersection();
            });
        }, [
            onIntersection
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!ref || typeof window === 'undefined' || typeof window !== 'undefined' && !window.IntersectionObserver) return undefined;
            const observer = new IntersectionObserver(handleObserver, {
                root: null,
                rootMargin: '20px',
                threshold: 0
            });
            if (ref) observer.observe(ref);
            return ()=>{
                observer.disconnect();
            };
        }, [
            ref,
            onIntersection,
            handleObserver
        ]);
        return setRef;
    };
});
parcelRegister("b8mPJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d009e2d1a73fd0a0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d009e2d1a73fd0a0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pageHeading: {
            "id": "business-form.form-submission.page-heading",
            "defaultMessage": "Form submission"
        }
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
